webpackJsonp([0],{

/***/ "+++F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_dashboardNotification__ = __webpack_require__("Qoh4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__ = __webpack_require__("a0yF");


/*
  Generic component used to display notifications coming from
  notifications API endpoint. It's also used by notification-items.js
  to display those generic components in top right corner of the app
  if user has notifications turned on.
 */







var NOTIFICATION_CLASS_SETTLED = 'settled';
var NOTIFICATION_CLASS_PRICE_UP = 'price-up';
var NOTIFICATION_CLASS_PRICE_DOWN = 'price-down';
var NOTIFICATION_CLASS_MATCHED = 'matched';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_dashboardNotification__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  props: {
    showTimeElapsed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: {
    iconTargetClass: function iconTargetClass() {
      switch (this.data.notificationType) {
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["k" /* NOTIFICATION_MATCHED */]:
          return NOTIFICATION_CLASS_MATCHED;
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["l" /* NOTIFICATION_SETTLED */]:
          return NOTIFICATION_CLASS_SETTLED;
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["m" /* NOTIFICATION_PRICE_CHANGE */]:
          return this.data.contentJson.PriceDelta > 0 ? NOTIFICATION_CLASS_PRICE_UP : NOTIFICATION_CLASS_PRICE_DOWN;
        default:
          return NOTIFICATION_CLASS_SETTLED;
      }
    },
    classModifiers: function classModifiers() {
      var _ref;

      var isUnread = this.theme !== 'notifications' && this.data && typeof this.data.isRead !== 'undefined' && !this.data.isRead;
      return _ref = {
        'notification-item-dashboard': true,
        'notification-item-dashboard--unread': isUnread
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'notification-item-dashboard--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'notification-item-dashboard--clickable', this.marketId), _ref;
    },
    marketId: function marketId() {
      return this.data.contentJson ? this.data.contentJson.MarketId : null;
    },
    iconClassModifiers: function iconClassModifiers() {
      return {
        'notification-item-dashboard__icon': true
      };
    },
    iconStyleModifiers: function iconStyleModifiers() {
      return {
        'background-image': 'url(' + this.data.contentJson.ImageUrl + ')'
      };
    },
    showContractName: function showContractName() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["m" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showPayout: function showPayout() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["l" /* NOTIFICATION_SETTLED */];
    },
    showSellInfo: function showSellInfo() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["k" /* NOTIFICATION_MATCHED */];
    },
    showSharesOwned: function showSharesOwned() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["m" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showPriceChange: function showPriceChange() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["m" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showLevelChanged: function showLevelChanged() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["n" /* NOTIFICATION_LEVEL */];
    },
    showNextLevelInfo: function showNextLevelInfo() {
      return this.data.contentJson.NewTraderLevel < 7;
    },
    quantity: function quantity() {
      return this.data.contentJson.Quantity;
    },
    sharesOwned: function sharesOwned() {
      return this.data.contentJson.SharesOwned;
    },
    isYes: function isYes() {
      var tradeType = this.data.contentJson.TradeType;
      return tradeType === 1 || tradeType === 3;
    },
    yesNoText: function yesNoText() {
      return this.isYes ? 'YES' : 'NO';
    },
    pricePerShare: function pricePerShare() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["g" /* toCents */])(this.data.contentJson.PricePerShare);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* isMarketSingle */])(this.data.contentJson);
    },
    tradeTypeShare: function tradeTypeShare() {
      return typeof this.data.contentJson.MarketType === 'undefined' || this.isMarketSingle ? '' : this.data.contentJson.ContractName || '';
    },
    tradeTypeOperation: function tradeTypeOperation() {
      return this.data.contentJson.TradeType <= 1 ? 'Bought' : 'Sold';
    },
    lastTradePriceAsCents: function lastTradePriceAsCents() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["g" /* toCents */])(this.data.contentJson.LastTradePrice);
    },
    routeTo: function routeTo() {
      if (this.marketId) {
        return {
          name: 'market-details',
          params: {
            marketId: this.marketId
          }
        };
      }
      return {};
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['closeNotificationsWidget']), {
    onInteract: function onInteract() {
      this.closeNotificationsWidget();
    }
  })
});

/***/ }),

/***/ "+11a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+1tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_research_widget_research_widget_vue__ = __webpack_require__("/yTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_widget_insight_widget_vue__ = __webpack_require__("w0Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_biggest_gains_market_biggest_gains_vue__ = __webpack_require__("XqpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_money_widget_market_money_widget_vue__ = __webpack_require__("JVxM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_currently_predicting_market_currently_predicting_vue__ = __webpack_require__("Dksu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_key_stats_market_key_stats_vue__ = __webpack_require__("aHny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_top_comments_market_top_comments_vue__ = __webpack_require__("KvDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_insight_insight_news_insight_news_vue__ = __webpack_require__("rjQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_cms_preview_carousel_preview_carousel_vue__ = __webpack_require__("7WHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_daily_markets_daily_markets_vue__ = __webpack_require__("B/8G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pages_page_markets_page_markets_vue__ = __webpack_require__("CIck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__in_the_news_in_the_news_vue__ = __webpack_require__("y1jZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__podcasts_podcasts_vue__ = __webpack_require__("QrTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hero_unit_slider_hero_unit_slider_vue__ = __webpack_require__("RQ5D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__quotes_quotes_vue__ = __webpack_require__("PElc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__how_it_works_how_it_works_vue__ = __webpack_require__("Z05w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__most_predicted_most_predicted_vue__ = __webpack_require__("UqqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__most_predicted_list_most_predicted_list_vue__ = __webpack_require__("4p0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__home_videos__ = __webpack_require__("CPvM");




























/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_loader__["a" /* default */]],
  components: {
    electionMap: __WEBPACK_IMPORTED_MODULE_15__components_pages_page_election_map_new_election_map_election_map_vue__["f" /* default */],
    heroUnitSlider: __WEBPACK_IMPORTED_MODULE_21__hero_unit_slider_hero_unit_slider_vue__["a" /* default */],
    quotes: __WEBPACK_IMPORTED_MODULE_22__quotes_quotes_vue__["a" /* default */],
    howItWorks: __WEBPACK_IMPORTED_MODULE_23__how_it_works_how_it_works_vue__["a" /* default */],
    mostPredicted: __WEBPACK_IMPORTED_MODULE_24__most_predicted_most_predicted_vue__["a" /* default */],
    podcasts: __WEBPACK_IMPORTED_MODULE_20__podcasts_podcasts_vue__["a" /* default */],
    researchWidget: __WEBPACK_IMPORTED_MODULE_2__components_research_widget_research_widget_vue__["a" /* default */],
    inTheNews: __WEBPACK_IMPORTED_MODULE_19__in_the_news_in_the_news_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    newsFeed: __WEBPACK_IMPORTED_MODULE_18__news_feed_news_feed_vue__["a" /* default */],
    mostPredictedList: __WEBPACK_IMPORTED_MODULE_25__most_predicted_list_most_predicted_list_vue__["a" /* default */],
    insightWidget: __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_widget_insight_widget_vue__["a" /* default */],
    marketBiggestGains: __WEBPACK_IMPORTED_MODULE_5__components_market_market_biggest_gains_market_biggest_gains_vue__["a" /* default */],
    marketMoneyWidget: __WEBPACK_IMPORTED_MODULE_6__components_market_market_money_widget_market_money_widget_vue__["a" /* default */],
    marketCurrentlyPredicting: __WEBPACK_IMPORTED_MODULE_7__components_market_market_currently_predicting_market_currently_predicting_vue__["a" /* default */],
    marketKeyStats: __WEBPACK_IMPORTED_MODULE_8__components_market_market_key_stats_market_key_stats_vue__["a" /* default */],
    marketTopComments: __WEBPACK_IMPORTED_MODULE_9__components_market_market_top_comments_market_top_comments_vue__["a" /* default */],
    homeVideos: __WEBPACK_IMPORTED_MODULE_26__home_videos__["a" /* default */],
    insightNews: __WEBPACK_IMPORTED_MODULE_10__components_insight_insight_news_insight_news_vue__["a" /* default */],
    dailyMarkets: __WEBPACK_IMPORTED_MODULE_16__components_daily_markets_daily_markets_vue__["a" /* default */],
    pageMarkets: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_markets_page_markets_vue__["a" /* default */],
    previewCarousel: __WEBPACK_IMPORTED_MODULE_11__components_cms_preview_carousel_preview_carousel_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'PredictIt'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted', 'isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup']), {
    classModifiers: function classModifiers() {
      return {
        'home-old': true,
        'home-old--shutdown': this.isShutdownModeOn
      };
    },
    showMap: function showMap() {
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    showHomepageInitialLoader: function showHomepageInitialLoader() {
      if (this.homepageInitialLoaderVisible) {
        return;
      }
      this.loaderAdd(document.body);
      this.homepageInitialLoaderVisible = true;
    },
    hideHomepageInitialLoader: function hideHomepageInitialLoader() {
      if (!this.homepageInitialLoaderVisible) {
        return;
      }
      this.loaderRemove(document.body);
      this.homepageInitialLoaderVisible = false;
    },
    onEmbeddedInitialLoadStateChange: function onEmbeddedInitialLoadStateChange(isLoading) {
      if (this.initialHomepageMarketLoadComplete) {
        return;
      }
      if (isLoading) {
        this.showHomepageInitialLoader();
      } else {
        this.hideHomepageInitialLoader();
        this.initialHomepageMarketLoadComplete = true;
      }
    }
  }),
  data: function data() {
    return {
      initialHomepageMarketLoadComplete: false,
      homepageInitialLoaderVisible: false
    };
  },
  mounted: function mounted() {
    if (!this.initialHomepageMarketLoadComplete) {
      this.showHomepageInitialLoader();
    }
    if (this.isUserRestricted && !this.currentPopup) {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.hideHomepageInitialLoader();
  }
});

/***/ }),

/***/ "+6DW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractInfoLoader_vue__ = __webpack_require__("Zdfa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_781a0632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractInfoLoader_vue__ = __webpack_require__("egIo");
function injectStyle (ssrContext) {
  __webpack_require__("Ng05")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractInfoLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_781a0632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractInfoLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+88x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


function setLargeNumber(el, binding) {
  el.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["u" /* largeNumberDisplay */])(binding.value || 0);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setLargeNumber(el, binding);
  },
  update: function update(el, binding) {
    setLargeNumber(el, binding);
  }
});

/***/ }),

/***/ "+8GN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+8fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  validations: {
    fields: {
      newPassword: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].password,
      newPasswordConfirmation: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].passwordConfirmation('newPassword')
    }
  },
  data: function data() {
    return {
      fields: {
        newPassword: '',
        newPasswordConfirmation: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotificationWithTimeoutCallback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['setPassword']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          newPassword: this.fields.newPassword
        };
        this.setPassword(payload).then(this.formEnable).then(function () {
          _this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Password Set.',
            callback: function callback() {
              return _this.$router.go(-1);
            }
          });
        }).catch(this.formHandleErrors);
      }
    }
  })
});

/***/ }),

/***/ "+8hI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-profile-widget"},[_c('div',{staticClass:"public-profile-widget__title"},[_c('span',{staticClass:"public-profile-widget__title-text"},[_vm._v("Public Profile")]),_vm._v(" "),_c('div',{staticClass:"public-profile-widget__title-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]),_vm._v(" "),_c('div',{staticClass:"public-profile-widget__section"},[_c('div',{staticClass:"public-profile-widget__section-title"},[_c('div',{staticClass:"public-profile-widget__section-title-prefix"},[_vm._v("\n        College Affiliation\n      ")]),_vm._v(" "),(_vm.isUCAffilSet === false)?_c('div',{staticClass:"public-profile-widget__info"},[_vm._v("\n        Not Affiliated\n      ")]):(_vm.userAffiliations.length === 0)?_c('div',{staticClass:"public-profile-widget__info"},[_vm._v("\n        No Affiliations Specified\n      ")]):_vm._e()]),_vm._v(" "),(_vm.userAffiliations.length > 0)?_c('div',{staticClass:"public-profile-widget__items"},_vm._l((_vm.userAffiliations),function(item){return _c('div',[_vm._v("\n        "+_vm._s(item.name)),(item.isPendingApproval)?_c('span',[_vm._v(" (Pending)")]):_vm._e(),(!item.isPublic)?_c('span',[_vm._v(" *")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"public-profile-widget__note"},[_c('span',{staticClass:"public-profile-widget__link",on:{"click":_vm.showAffiliationsPopup}},[_vm._v("Edit")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+COC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+CQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_small_js__ = __webpack_require__("S1Yq");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c04a95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_small_vue__ = __webpack_require__("B3yl");
function injectStyle (ssrContext) {
  __webpack_require__("+COC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_small_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c04a95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+Cz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_alert_box_js__ = __webpack_require__("qYhg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdf3861e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_box_vue__ = __webpack_require__("n5Uq");
function injectStyle (ssrContext) {
  __webpack_require__("OCEH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_alert_box_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdf3861e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+MUC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+ZRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");

/* eslint-disable no-unused-vars */




var searchMixin = {
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar', 'getSearch', 'resetSearchResults']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['closeMobileMenu']), {
    onSearchResults: function onSearchResults(data) {
      this.closeMobileMenu();
    },
    formatQuery: function formatQuery(query) {
      return query.trim();
    },
    doSearch: function doSearch(query) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { reset: true };

      if (this.isLoading) return;
      this.loaderAddLegacy(document.body);
      if (options.reset) {
        this.resetSearchResults(query);
      }

      this.getSearch(this.formatQuery(query)).then(function (data) {
        _this.loaderRemoveLegacy(document.body);
        _this.$gtm.trackEvent({
          event: 'Search',
          SearchNumTotalMarketsFound: data.totalMarkets
        });
        _this.onSearchResults(data);

        if (_this.$router.currentRoute.query.query !== query) {
          _this.$router.push({
            name: 'market-search',
            query: {
              query: query
            }
          });
        }
      }).catch(function () {
        return _this.loaderRemoveLegacy(document.body);
      });
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (searchMixin);

/***/ }),

/***/ "+i1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    },
    back: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    hasTitle: function hasTitle() {
      return !!this.$slots.title;
    },
    hasSecondary: function hasSecondary() {
      return !!this.$slots.secondary;
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'static-page-header': true,
        'static-page-header--secondary': this.hasSecondary
      }, 'static-page-header--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "+j07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processing-transaction"},[(_vm.showTimeout)?[_c('div',{staticClass:"processing-transaction__headline"},[_c('h5',{staticClass:"processing-transaction__title processing-transaction__title--warn"},[_vm._v("\n        Processing Timeout\n      ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width processing-transaction__button",on:{"click":_vm.openDepositHistory}},[_vm._v("\n        Open Deposit History\n      ")])])]:[_c('div',{staticClass:"processing-transaction__loader"}),_vm._v(" "),_c('div',{staticClass:"processing-transaction__processing"},[_vm._v("\n      Processing Transaction...\n    ")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n          It looks like we are having some communication issues. Don't worry, we will keep trying to complete your deposit. Please check your Deposit History as usually these issues resolve within a few minutes.\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+jU6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_validators__ = __webpack_require__("SVQh");





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AccountPhoneUpdate',
    mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
    validations: {
        phoneNumber: __WEBPACK_IMPORTED_MODULE_3__helpers_validators__["a" /* default */].phone
    },
    data: function data() {
        return {
            phoneNumber: '',
            verificationCode: '',
            step: 'input', // 'input', 'verify'
            isSending: false,
            isVerifying: false,
            error: null,
            secondsUntilResend: 0,
            resendTimer: null
        };
    },

    computed: {
        canSendCode: function canSendCode() {
            return !this.$v.phoneNumber.$invalid && !this.isSending && this.secondsUntilResend === 0;
        },
        canVerify: function canVerify() {
            return this.verificationCode.length >= 6 && !this.isVerifying;
        },
        phoneError: function phoneError() {
            if (this.$v.phoneNumber.$error) {
                return 'Enter a valid phone number';
            }
            return '';
        }
    },
    methods: {
        sendCode: function sendCode() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.canSendCode) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:

                                _this.isSending = true;
                                _this.error = null;

                                _context.prev = 4;
                                _context.next = 7;
                                return _this.$store.dispatch('user/phoneUpdate', {
                                    phoneNumber: _this.phoneNumber
                                });

                            case 7:
                                response = _context.sent;

                                _this.step = 'verify';
                                _this.secondsUntilResend = response.seconds_til_resend_available || 60;
                                _this.startResendTimer();
                                _context.next = 16;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](4);

                                _this.error = _this.extractErrorMessage(_context.t0, 'Failed to send verification code.');

                            case 16:
                                _context.prev = 16;

                                _this.isSending = false;
                                return _context.finish(16);

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[4, 13, 16, 19]]);
            }))();
        },
        verifyCode: function verifyCode() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.canVerify) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:

                                _this2.isVerifying = true;
                                _this2.error = null;

                                _context2.prev = 4;
                                _context2.next = 7;
                                return _this2.$store.dispatch('user/phoneVerify', {
                                    phoneNumber: _this2.phoneNumber,
                                    code: _this2.verificationCode
                                });

                            case 7:
                                _context2.next = 9;
                                return _this2.$store.dispatch('user/getAccountDetail');

                            case 9:
                                _this2.$emit('close');
                                _context2.next = 16;
                                break;

                            case 12:
                                _context2.prev = 12;
                                _context2.t0 = _context2['catch'](4);

                                _this2.error = _this2.extractErrorMessage(_context2.t0, 'Incorrect code. Please try again.');
                                _this2.verificationCode = '';

                            case 16:
                                _context2.prev = 16;

                                _this2.isVerifying = false;
                                return _context2.finish(16);

                            case 19:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[4, 12, 16, 19]]);
            }))();
        },
        startResendTimer: function startResendTimer() {
            var _this3 = this;

            this.clearResendTimer();
            this.resendTimer = setInterval(function () {
                if (_this3.secondsUntilResend > 0) {
                    _this3.secondsUntilResend -= 1;
                } else {
                    _this3.clearResendTimer();
                }
            }, 1000);
        },
        clearResendTimer: function clearResendTimer() {
            if (this.resendTimer) {
                clearInterval(this.resendTimer);
                this.resendTimer = null;
            }
        },
        extractErrorMessage: function extractErrorMessage(error, defaultMessage) {
            if (error.response && error.response.data) {
                var data = error.response.data;
                if (Array.isArray(data) && data.length > 0 && data[0].message) {
                    return data[0].message;
                }
                if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                    return data.errors[0].message;
                }
                if (data.message) {
                    return data.message;
                }
            }
            return defaultMessage;
        },
        onCancel: function onCancel() {
            this.$emit('close');
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.clearResendTimer();
    }
});

/***/ }),

/***/ "+kDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__ = __webpack_require__("Q+EN");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    chartData: {
      type: Array,
      required: true,
      default: null
    },
    chartDataLoaded: {
      type: Boolean,
      default: false
    },
    chartOptions: {
      type: Object,
      default: null
    },
    market: {
      type: Object,
      required: true
    },
    timeline: {
      type: String,
      required: false
    },
    chartType: {
      type: String,
      required: false
    },
    chartSystemOptions: {
      type: Object,
      default: function _default() {}
    },
    showVolume: {
      type: Boolean,
      default: false
    },
    showPriceAxisZoom: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },

  computed: {
    containerStyleModifiers: function containerStyleModifiers() {
      var height = '390px';
      if (this.chartOptions && this.chartOptions.maxHeight) {
        height = this.chartOptions.maxHeight;
      }
      if (this.chartSystemOptions && this.chartSystemOptions.maxHeight) {
        height = this.chartSystemOptions.maxHeight;
      }
      return {
        height: height
      };
    }
  },
  watch: {
    showVolume: function showVolume() {
      this.renderChart();
    },
    showPriceAxisZoom: function showPriceAxisZoom() {
      this.renderChart();
    },
    chartType: function chartType() {
      this.renderChart();
    },
    chartData: function chartData(value) {
      this.createChart(value);
    }
  },
  methods: {
    createChart: function createChart(data) {
      var _this = this;

      if (data && data.length > 0) {
        setTimeout(function () {
          _this.renderChart();
        }, __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["a" /* ContractChartGroup */].renderTimeout());
      } else if (this.$refs.chart) {
        this.$refs.chart.innerHTML = '';
      }
    },
    renderChart: function renderChart() {
      if (!this.$refs.chart) return;
      if (this.chart !== null) {
        this.chart.destroy();
      }
      var ClassName = this.chartType === 'candle' ? __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["b" /* ContractChartGroupStock */] : __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["a" /* ContractChartGroup */];
      var options = this.chartOptions || {};
      options.showVolume = this.showVolume;
      options.showPriceAxisZoom = this.showPriceAxisZoom;
      var group = new ClassName({
        market: this.market,
        timeline: this.timeline,
        data: this.chartData,
        chartOptions: options
      });
      this.chart = group.draw(this.$refs.chart);
    }
  }
});

/***/ }),

/***/ "+oQ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+poj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_recaptcha__ = __webpack_require__("dSZ5");











var CAPTCHA_FIELD = 'g-recaptcha-response';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_userAgent__["a" /* default */]],
  props: {
    email: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      // login attempt counter (for v2 fallback rerenders)
      attempt: 1,
      fieldTypePassword: 'password',
      fields: {
        email: this.email,
        password: '',
        rememberMe: true
      },
      timeout: null,
      // Pending payload for v2 fallback retry
      pendingPayload: null
    };
  },

  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].emailNoMessage,
      password: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].requiredNoMessage
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('popup', ['currentPopupOptions']), {
    loginButtonDisabled: function loginButtonDisabled() {
      return this.invalidOrDisabled;
    }
  }),
  mounted: function mounted() {
    // Check if we were redirected here with a login error (e.g., from registration flow)
    if (this.currentPopupOptions && this.currentPopupOptions.loginError) {
      this.formHandleErrors(this.currentPopupOptions.loginError);
      // Clear the error from options so it doesn't show again on re-render
      this.setCurrentPopupOptions({});
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['login', 'setUseDisqus', 'loginDisqus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {
    showPassword: function showPassword() {
      this.fieldTypePassword = this.fieldTypePassword === 'password' ? 'text' : 'password';
    },
    onForgotten: function onForgotten() {
      if (this.isPage) {
        this.$router.push({ name: 'account-password-forgotten' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].FORGOTTEN);
      }
    },
    getRedirectPath: function getRedirectPath() {
      if (this.$router.currentRoute.query.redirect) return this.$router.currentRoute.query.redirect;
      if (this.$router.currentRoute.name === 'home' || this.isPage) return { name: 'portfolio' };
      return null;
    },
    triggerRedirect: function triggerRedirect(redirect) {
      this.$router.push(redirect);
      if (this.isIos) {
        this.$nextTick(function () {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 100);
        });
      }
    },
    onLogin: function onLogin() {
      var _this = this;

      this.setProfileStatus({ event: 'login' });
      if (this.$route && this.$route.name === 'disqus-auth') {
        this.loginDisqus().then(function () {
          _this.setUseDisqus(true);
          window.close();
        });
      } else {
        var redirect = this.getRedirectPath();
        this.setCurrentPopup();
        if (redirect) {
          this.triggerRedirect(redirect);
        }
      }
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _payload, v3Token, payload;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.formIsValid() && _this2.formDisable())) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__services_recaptcha__["a" /* default */].executeV3('login');

              case 4:
                v3Token = _context.sent;
                payload = (_payload = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, CAPTCHA_FIELD, v3Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'recaptcha-version', 'v3'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'email', _this2.fields.email), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'password', _this2.fields.password), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'grant_type', 'password'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'rememberMe', _this2.fields.rememberMe), _payload);


                _this2.login(payload).then(function (result) {
                  _this2.formEnable();

                  // Check if 2FA challenge is required
                  if (result.requiresTwoFactor) {
                    // Switch to 2FA verification modal
                    _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].TWO_FACTOR);
                    return;
                  }

                  _this2.onLogin();
                }).catch(function (error) {
                  // Step 2: Check if v3 failed and v2 challenge is needed
                  if (__WEBPACK_IMPORTED_MODULE_9__services_recaptcha__["a" /* default */].isV3ScoreFailure(error)) {
                    _this2.pendingPayload = payload;
                    _this2.attempt += 1;
                    _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].RECAPTCHA_CHALLENGE);
                    _this2.setCurrentPopupOptions({
                      attempt: _this2.attempt,
                      onVerified: _this2.onRecaptchaV2Verified
                    });
                    _this2.formEnable();
                    return;
                  }

                  _this2.attempt += 1;
                  _this2.formHandleErrors(error);
                });
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                // Error getting v3 token - fall back to showing error
                _this2.formEnable();
                _this2.formHandleErrors(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 9]]);
      }))();
    },
    onRecaptchaV2Verified: function onRecaptchaV2Verified(v2Token) {
      var _extends2,
          _this3 = this;

      // Called when user completes v2 challenge in modal
      // Don't switch to login modal yet - keep reCAPTCHA visible during API call
      // to avoid "flash" of login form before 2FA or success transition

      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.pendingPayload, (_extends2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, CAPTCHA_FIELD, v2Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'recaptcha-version', 'v2'), _extends2));

      this.login(payload).then(function (result) {
        _this3.formEnable();

        if (result.requiresTwoFactor) {
          _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].TWO_FACTOR);
          return;
        }

        // Success - close modal and proceed
        _this3.onLogin();
      }).catch(function (error) {
        // On error, pass error via popup options so new login modal can display it
        // (calling formHandleErrors here won't work as this component is destroyed)
        _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
        _this3.setCurrentPopupOptions({ loginError: error });
      });
    }
  })
});

/***/ }),

/***/ "+sDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_app__ = __webpack_require__("WSTi");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    currentStepIndexFlow1: 1,
    optionSecondStepSelectedFlow1: __WEBPACK_IMPORTED_MODULE_0__store_modules_app__["a" /* APP_COLOR_PALETTE */].GREEN_RED,
    optionThirdStepSelectedFlow1: __WEBPACK_IMPORTED_MODULE_0__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED
  },
  mutations: {
    nextStepFlow1: function nextStepFlow1(state) {
      state.currentStepIndexFlow1 += 1;
    },
    prevStepFlow1: function prevStepFlow1(state) {
      state.currentStepIndexFlow1 -= 1;
    },
    selectOptionThirdStepFlow1: function selectOptionThirdStepFlow1(state, value) {
      state.optionThirdStepSelectedFlow1 = value;
    },
    selectOptionSecondStepFlow1: function selectOptionSecondStepFlow1(state, value) {
      state.optionSecondStepSelectedFlow1 = value;
    }
  },
  actions: {
    nextStepFlow1: function nextStepFlow1(_ref) {
      var commit = _ref.commit;

      commit('nextStepFlow1');
    },
    prevStepFlow1: function prevStepFlow1(_ref2) {
      var commit = _ref2.commit;

      commit('prevStepFlow1');
    },
    selectOptionSecondStepFlow1: function selectOptionSecondStepFlow1(_ref3, value) {
      var commit = _ref3.commit;

      commit('selectOptionSecondStepFlow1', value);
    },
    selectOptionThirdStepFlow1: function selectOptionThirdStepFlow1(_ref4, value) {
      var commit = _ref4.commit;

      commit('selectOptionThirdStepFlow1', value);
    }
  }
});

/***/ }),

/***/ "+vs+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/3CK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader--dashboard-notifications"},[_c('notification-loader'),_vm._v(" "),_c('notification-loader'),_vm._v(" "),_c('notification-loader')],1):[_c('div',{staticClass:"notifications-list__content"},[_vm._l((_vm.items),function(notification,index){return _c('notification-item-dashboard',{key:notification.notificationId,staticClass:"notifications-list__item",attrs:{"theme":_vm.theme,"showTimeElapsed":true,"index":index,"data":notification}})}),_vm._v(" "),(_vm.isScrollMore)?_c('div',{staticClass:"notifications-list__scroll-down"},[_vm._v("Scroll down for more notifications")]):_vm._e(),_vm._v(" "),(_vm.showInfiniteLoading)?_c('infinite-loading',{attrs:{"distance":150},on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"notifications-list__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()],2),_vm._v(" "),(_vm.notificationsCount === 0)?_c('div',{staticClass:"notifications-list__footer-no-notifications"},[_vm._v("\n      There are no notifications to display\n    ")]):_vm._e(),_vm._v(" "),(_vm.limit !== null && _vm.notificationsCount > 0)?_c('div',{staticClass:"notifications-list__link",on:{"click":_vm.onSeeAllClick}},[_vm._v("\n      See All Notifications\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/7LY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTQgOCI+CiAgICA8cGF0aCBmaWxsPSIjMjYzQjNGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMy42NjcuOTAybC0uNjczLS42MDRBMS4yMjQgMS4yMjQgMCAwIDAgMTIuMTc2IDBjLS4zMTggMC0uNTg3LjEtLjgwOS4yOThMNyA0LjIxMiAyLjYzMy4yOThBMS4xNjkgMS4xNjkgMCAwIDAgMS44MjQgMGMtLjMxMSAwLS41ODQuMS0uODE4LjI5OEwuMzQxLjkwMkEuOTUxLjk1MSAwIDAgMCAwIDEuNjM1YzAgLjI5LjExNC41MzIuMzQxLjcyNWw1Ljg1IDUuMjQzYy4yMTYuMjA0LjQ4NS4zMDYuODA5LjMwNi4zMTggMCAuNTktLjEwMi44MTgtLjMwNmw1Ljg1LTUuMjQzQS45MzguOTM4IDAgMCAwIDE0IDEuNjM1YzAtLjI4LS4xMS0uNTIzLS4zMzMtLjczM3oiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "/BTu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_settings_settings__ = __webpack_require__("8p/V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin__ = __webpack_require__("Q9xH");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('whatisnew', ['optionSecondStepSelectedFlow1', 'optionThirdStepSelectedFlow1']), {
    optionsSecondStep: function optionsSecondStep() {
      return __WEBPACK_IMPORTED_MODULE_3__components_account_settings_settings__["a" /* UX_OPTIONS_BUTTON_COLOR_SCHEME */].options;
    },
    optionsThirdStep: function optionsThirdStep() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__components_account_settings_settings__["b" /* UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT */].options)).reverse();
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('whatisnew', ['selectOptionSecondStepFlow1', 'selectOptionThirdStepFlow1']))
});

/***/ }),

/***/ "/Em5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel preview-carousel--standalone"},[_c('div',{ref:"content",class:_vm.contentClassModifiers,style:(_vm.contentStyleModifiers)},[(_vm.storyHtml)?_c('div',{staticClass:"preview-carousel__cutoff-guide",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-carousel__story"},[_c('div',{staticClass:"preview-carousel__story-html",domProps:{"innerHTML":_vm._s(_vm.storyHtml)}})])]),_vm._v(" "),(_vm.showExpandControl)?_c('div',{class:_vm.expandClassModifiers,on:{"click":_vm.toggleExpand}},[(!_vm.isExpanded)?_c('span',[_vm._v("Read More ▾")]):_c('span',[_vm._v("Show Less ▴")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Fc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[_c('div',{staticClass:"check-option__box"},[_c('form-checkbox',{staticClass:"checkbox--settings-option",attrs:{"label":_vm.obj.info,"name":_vm.checkboxName,"disabled":_vm.disabled},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1),_vm._v(" "),(_vm.withValue)?_c('div',{staticClass:"check-option__input"},[_c('currency-input',{attrs:{"initial":_vm.obj.currencyInitial,"disabled":_vm.disabled,"validate":_vm.obj.validate},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/JWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_depositWarningMixin__ = __webpack_require__("Scap");













var AMOUNT_STEP_ONE = 10;
var AMOUNT_STEP_THREE = 50;
var AMOUNT_STEP_FOUR = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_depositWarningMixin__["a" /* default */]],
  data: function data() {
    return {
      error: null,
      canDeposit: false,
      isReady: false,
      disclaimer: '',
      fields: {
        amount: ''
      },
      depositAmounts: [AMOUNT_STEP_ONE, AMOUNT_STEP_THREE, AMOUNT_STEP_FOUR]
    };
  },
  validations: function validations() {
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getDepositUSDCoin']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), {
    handleAmountBlur: function handleAmountBlur() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      });
    },
    onUpdateAmount: function onUpdateAmount(amount) {
      if (this.fields.amount === '') {
        this.fields.amount = amount;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["D" /* isNumber */])(this.fields.amount)) {
        this.fields.amount = Number(this.fields.amount) + amount;
      }
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + amount + ' Button'
      });
    },
    onSubmit: function onSubmit() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      });
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].COINBASE);
      this.setCurrentPopupOptions({ depositPayload: this.depositPayload });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['depositMethods']), {
    minimumDepositAmount: function minimumDepositAmount() {
      return this.depositMethods.minimumDepositAmount || 10.0;
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    depositPayload: function depositPayload() {
      return {
        amount: this.fields.amount,
        depositPromoCode: '',
        marketingSource: '',
        marketingProgram: ''
      };
    },
    amountHasError: function amountHasError() {
      return this.$v.fields.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_getValidationMessage__["a" /* default */])(this.$v.fields.amount);
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getDepositUSDCoin().then(function (data) {
      _this.checkDocumentUploadFlags(data);
      _this.loaderRemove(document.body);
      _this.promoCodeDetail = data.promoCodeDetail || {};
      _this.canDeposit = data.canDeposit;
      _this.disclaimer = data.disclaimer;
      _this.isReady = true;
    }).catch(function (error) {
      _this.isReady = true;
      _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
      _this.loaderRemove(document.body);
      _this.checkDocumentUploadFlags(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data', {}));
    });
  }
});

/***/ }),

/***/ "/KY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contracts_history_sold_bought_at_sold_bought_at_vue__ = __webpack_require__("2N1A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showMarketName: {
      type: Boolean,
      default: true
    },
    data: Object,
    desktop: {
      type: Boolean,
      default: false
    },
    compactMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    soldBoughtAt: __WEBPACK_IMPORTED_MODULE_0__components_contracts_history_sold_bought_at_sold_bought_at_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return {
        'contract-tile': true,
        'contract-tile--compact': this.compactMode
      };
    },
    accountHistoryRoute: function accountHistoryRoute() {
      if (this.$route.fullPath === '/account/history') {
        return {
          name: 'account-history',
          params: { marketId: this.data.marketId }
        };
      }
      return {
        name: 'account-history',
        params: { marketId: this.data.marketId },
        query: { contractId: this.data.contractId }
      };
    },
    profit: function profit() {
      switch (this.data.tradeType) {
        case 0: // Buy No
        case 1:
          // Buy Yes
          return ' –';
        default:
          {
            var fee = this.data.tradingFees !== 0 ? this.data.tradingFeesString : '';
            var gainLoss = this.data.tradeGainLossString;
            return this.data.tradeGainLoss ? gainLoss + ' ' + fee : gainLoss;
          }
      }
    },
    profitClass: function profitClass() {
      return {
        'contract-tile__profit-desk': true,
        'contract-tile__profit-desk--plus': this.data.tradeGainLoss > 0
      };
    },
    profitDesk: function profitDesk() {
      return this.data.tradeType > 1 ? this.data.tradeGainLossString : '-';
    },
    fee: function fee() {
      return this.data.tradingFees < 0 ? this.data.tradingFeesString : '';
    },
    date: function date() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["k" /* dateToString */])(this.data.dateExecuted);
    },
    market: function market() {
      return this.data.marketName ? this.data.marketName : 'null';
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* isMarketSingle */])(this.data);
    },
    contractName: function contractName() {
      if (this.data.marketType !== 0) {
        return this.data.contractName;
      }
      var type = this.data.tradeType;
      return type === 0 || type === 2 ? 'No' : 'Yes';
    },
    shortProfit: function shortProfit() {
      var tradeType = this.data.tradeType;
      return {
        'contract-tile__profit--short': tradeType === 0 || tradeType === 1
      };
    },
    longName: function longName() {
      var tradeType = this.data.tradeType;
      return {
        'contract-tile__name--long': tradeType === 0 || tradeType === 1
      };
    }
  }
});

/***/ }),

/***/ "/Tgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      isCategoriesLabelVisible: false,
      swiperOption: {
        roundLengths: true, // Fixes blurry text
        slidesPerView: 8,
        breakpoints: {
          320: { // iPhone 5
            slidesPerView: 3.5
          },
          640: {
            slidesPerView: 4.5
          },
          1024: {
            slidesPerView: 6.5
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('browse', ['userBrowseHeaders']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), {
    externalBrowseHeaders: function externalBrowseHeaders() {
      return this.userBrowseHeaders.filter(function (item) {
        return item.external;
      });
    },
    categoryBrowseHeaders: function categoryBrowseHeaders() {
      return this.userBrowseHeaders.filter(function (item) {
        return !item.external;
      });
    },
    categoriesIcon: function categoriesIcon() {
      // if (this.isLayoutDesktop) {
      //   return this.iconClassModifiers({ icon: 'globe' });
      // }
      return this.iconClassModifiers({ icon: 'categories' });
    },
    isAllMarketsLinkActive: function isAllMarketsLinkActive() {
      return this.$route.name === 'market-list' && !this.$route.params.headerId;
    },
    classModifiers: function classModifiers() {
      return {
        'nav-browse': true,
        'nav-browse--desktop': !this.isLayoutMobile,
        'nav-browse--mobile': this.isLayoutMobile
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['toggleNavBrowseCategoriesOverlay']), {
    toggleCategoriesLabel: function toggleCategoriesLabel() {
      if (this.isLayoutMobile) {
        this.toggleNavBrowseCategoriesOverlay();
      }
    },
    iconClassModifiers: function iconClassModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'nav-browse__link-icon': true
      }, 'nav-browse__link-icon--' + item.icon, item.icon);
    }
  }),
  mounted: function mounted() {
    if (this.isLayoutDesktop) {
      this.isCategoriesLabelVisible = true;
    }
  }
});

/***/ }),

/***/ "/afu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/awr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMC41IDQuNSA3LjEyNSA5bDMuMzAyIDQuNSIgc3Ryb2tlPSIjNTU1NzVBIiBzdHJva2Utd2lkdGg9IjIuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "/b9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contentLoader__ = __webpack_require__("P71F");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_externalLinks__["a" /* default */]],
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    availableSocials: function availableSocials() {
      var availableSocials = [];
      if (this.facebookLink) {
        availableSocials.push('Facebook');
      }
      if (this.googleLink) {
        availableSocials.push('Google');
      }
      if (this.twitterLink) {
        availableSocials.push('X');
      }

      if (availableSocials.length === 0) {
        return '';
      }

      if (availableSocials.length === 1) {
        return availableSocials[0];
      }

      if (availableSocials.length === 2) {
        return availableSocials.join(' or ');
      }

      if (availableSocials.length === 3) {
        return availableSocials[0] + ', ' + availableSocials[1] + ' or ' + availableSocials[2];
      }
    }
  },
  created: function created() {
    var _this = this;

    this.getExternalLogins({}).then(function (response) {
      _this.links = response.data;
      _this.isComponentReady = true;
    });
  }
});

/***/ }),

/***/ "/gSw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/gt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"captcha",staticClass:"captcha",style:(_vm.styleModifiers)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/gy2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showSwitchButton: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      altModeOn: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlay', ['visible']), {
    isAltViewModifier: function isAltViewModifier() {
      return {
        'modal-switch--isAltView': this.altModeOn
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', ['show', 'hide']), {
    close: function close() {
      this.hide();
      this.$emit('modalClose');
    },
    toggle: function toggle() {
      this.altModeOn = !this.altModeOn;
      this.$emit('modalToggle');
    }
  }),
  watch: {
    visible: function visible() {
      if (!this.visible) {
        this.close();
      }
    }
  },
  created: function created() {
    this.show();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["l" /* lockModal */])();
  },
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["m" /* unLockModal */])();
  }
});

/***/ }),

/***/ "/nzw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-page"},[_c('profile')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/s1U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/sWl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/sbu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/u+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-horizontal-sushi-orders"},[(_vm.hasOffers)?[_c('div',{staticClass:"market-contract-horizontal-sushi-orders__values"},[_c('span',{class:_vm.buyValueClass,attrs:{"data-tooltip":("Buy: " + _vm.buyQuantityFormatted)}},[_vm._v(_vm._s(_vm.buyQuantityDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-contract-horizontal-sushi-orders__sep"},[_vm._v("/")]),_vm._v(" "),_c('span',{class:_vm.sellValueClass,attrs:{"data-tooltip":("Sell: " + _vm.sellQuantityFormatted)}},[_vm._v(_vm._s(_vm.sellQuantityDisplay))])])]:_c('span',{staticClass:"market-dash-symbol"},[_vm._v("-")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/v52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_desktop_header_js__ = __webpack_require__("U91k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20bb80a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_desktop_header_vue__ = __webpack_require__("1KQ7");
function injectStyle (ssrContext) {
  __webpack_require__("bXzy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_desktop_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20bb80a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_desktop_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/x/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mySharesCount > 0 )?_c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-dashboard__menu-order"},[_c('menu-button',{attrs:{"theme":_vm.theme,"type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-dashboard__menu-timespan"},[_c('menu-button',{attrs:{"type":"timespan","theme":_vm.theme,"name":_vm.selectedTimespan.name,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e()]),_vm._v(" "),(_vm.ordersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-dashboard__order"},_vm._l((_vm.orderList('dashboard')),function(order){return _c('menu-button',{key:order.sort,attrs:{"theme":_vm.theme,"type":order.sort,"name":order.fullName,"selected":_vm.dashOrderSelected(order.sort)},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e(),_vm._v(" "),(_vm.timespansOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-dashboard__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"theme":_vm.theme,"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/xcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.currentPopupOptions.icon)?_c('div',{staticClass:"popup-generic-small__icon"},[(_vm.currentPopupOptions.icon === 'error')?_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.icon === 'success')?_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-generic-small__content"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/yMG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_widget_js__ = __webpack_require__("5RCZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1016bcda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_widget_vue__ = __webpack_require__("MWul");
function injectStyle (ssrContext) {
  __webpack_require__("I1/e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1016bcda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/z+u":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDYgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjc1IDAuODMzMjUyTDQuODMyOTcgNC44MDM2MkM0Ljg1OTUgNC44MjkzOSA0Ljg4MDU1IDQuODU5OTkgNC44OTQ5MSA0Ljg5MzY3QzQuOTA5MjcgNC45MjczNSA0LjkxNjY3IDQuOTYzNDYgNC45MTY2NyA0Ljk5OTkyQzQuOTE2NjcgNS4wMzYzOCA0LjkwOTI3IDUuMDcyNDkgNC44OTQ5MSA1LjEwNjE3QzQuODgwNTUgNS4xMzk4NSA0Ljg1OTUgNS4xNzA0NSA0LjgzMjk3IDUuMTk2MjJMMC43NSA5LjE2NjU5IiBzdHJva2U9IiMwQzBDMEMiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "/zTd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiM0Mjg1ZjQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEyLjI0IDEwLjI4NVYxNC40aDYuODA2Yy0uMjc1IDEuNzY1LTIuMDU2IDUuMTc0LTYuODA2IDUuMTc0LTQuMDk1IDAtNy40MzktMy4zODktNy40MzktNy41NzRzMy4zNDUtNy41NzQgNy40MzktNy41NzRjMi4zMyAwIDMuODkxLjk4OSA0Ljc4NSAxLjg0OWwzLjI1NC0zLjEzOEMxOC4xODkgMS4xODYgMTUuNDc5IDAgMTIuMjQgMGMtNi42MzUgMC0xMiA1LjM2NS0xMiAxMnM1LjM2NSAxMiAxMiAxMmM2LjkyNiAwIDExLjUyLTQuODY5IDExLjUyLTExLjcyNiAwLS43ODgtLjA4NS0xLjM5LS4xODktMS45ODlIMTIuMjR6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "06uq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "06wT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.chartData.length > 0)?_c('div',{ref:"chart",staticClass:"charts-container",style:(_vm.containerStyleModifiers)}):(_vm.chartDataLoaded)?_c('div',{staticClass:"charts-container__no-data"},[_vm._v("\n    No data to display\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "09V6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    disabled: Boolean,
    name: {
      type: String,
      required: true
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    value: String,
    validator: String
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    textAreaModifiers: function textAreaModifiers() {
      return {
        'textarea--has-value': this.value,
        'textarea--is-focused': this.focus
      };
    }
  },
  methods: {
    handleBlur: function handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
    },
    handleFocus: function handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);
    },
    updateValue: function updateValue(e) {
      this.$emit('input', e.target.value);
    }
  }
});

/***/ }),

/***/ "09fK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_special_js__ = __webpack_require__("OprK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db37b2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_special_vue__ = __webpack_require__("hmLK");
function injectStyle (ssrContext) {
  __webpack_require__("e69X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_special_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db37b2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_special_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0AWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-notification"},[_c('div',{class:_vm.iconModifiers}),_vm._v(" "),_c('div',{class:_vm.contentModifiers,domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('div',{staticClass:"side-notification__close-wrapper",on:{"click":_vm.onClose}},[(true)?_c('div',{staticClass:"side-notification__loader",style:({ '--close-timeout': (_vm.closeTimeout + "ms") })},[_c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32"}},[_c('circle',{staticClass:"side-notification__loader-ring",attrs:{"cx":"16","cy":"16","r":"13"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"side-notification__close"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0FJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    restrictionPreamble: {
      type: String
    },
    restrictions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),

/***/ "0HU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

var STATE_TEXT_MAP = {
  'pending approval': 'pending',
  'not approved': 'rejected'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    state: {
      type: String,
      default: 'pending'
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    transformedStatus: function transformedStatus() {
      var statelowerCased = this.state.toLowerCase();
      if (statelowerCased in STATE_TEXT_MAP) {
        return STATE_TEXT_MAP[statelowerCased];
      }
      return statelowerCased;
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'state-icon': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'state-icon--' + this.transformedStatus, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'state-icon--' + this.theme, this.theme), _ref;
    }
  }
});

/***/ }),

/***/ "0IZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CANCEL_ORDER_MODE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORDER_BOOK_OFFER_DISPLAY_MODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_loader__ = __webpack_require__("39kf");



/* eslint-disable no-restricted-syntax, arrow-body-style */









var CANCEL_ORDER_MODE = {
  ALL: 'all',
  SINGLE: 'single',
  NONE: 'none'
};

var ORDER_BOOK_OFFER_DISPLAY_MODE = {
  BUY: 'buy',
  SELL: 'sell',
  TOGGLE: 'toggle'
};

/* harmony default export */ __webpack_exports__["b"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_loader__["a" /* default */]],
  components: {
    smallModal: __WEBPACK_IMPORTED_MODULE_8__components_generics_modal_small_small_vue__["default"]
  },
  props: {
    scrollable: {
      type: Boolean,
      default: false
    },
    minimumRows: {
      type: Number,
      default: 0
    },
    contract: {
      type: Object,
      required: true
    },
    market: {
      type: Object,
      required: true
    },
    buyOffers: {
      type: Array,
      required: true,
      default: []
    },
    sellOffers: {
      type: Array,
      required: true,
      default: []
    },
    displayMode: {
      type: String,
      required: false,
      default: ORDER_BOOK_OFFER_DISPLAY_MODE.TOGGLE
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    cardLayout: {
      type: Boolean,
      default: false
    },
    compactCardLayout: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      CANCEL_ORDER_MODE: CANCEL_ORDER_MODE,
      ORDER_BOOK_OFFER_DISPLAY_MODE: ORDER_BOOK_OFFER_DISPLAY_MODE,
      showAll: this.scrollable,
      showAllCut: 5,
      deleteAllMode: false,
      deleteOfferId: null,
      showMenu: false,
      cancelModalMode: CANCEL_ORDER_MODE.NONE, // 'all', 'single'
      activeTab: null
    };
  },

  watch: {
    'contract.contractId': {
      handler: function handler() {
        this.updateShowAll();
        this.updateActiveTab();
      }
    },
    activeTab: function activeTab(newTab) {
      if (newTab) {
        __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('order_book_active_tab_' + this.contract.contractId, newTab);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isCancelOrdersEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    imageUrl: function imageUrl() {
      return this.contract.contractImageSmallUrl || this.contract.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    offersToDelete: function offersToDelete() {
      var _this = this;

      if (this.deleteAllMode) {
        return this.offers;
      }
      return this.offers.filter(function (o) {
        return o.offerId === _this.deleteOfferId;
      });
    },
    activeOfferSide: function activeOfferSide() {
      if (this.displayMode === ORDER_BOOK_OFFER_DISPLAY_MODE.SELL) return 'sell';
      if (this.displayMode === ORDER_BOOK_OFFER_DISPLAY_MODE.TOGGLE) return this.activeTab;
      return 'buy';
    },
    emptyOrdersText: function emptyOrdersText() {
      return 'You have no ' + this.activeOfferSide + ' orders.';
    },
    showCancelModal: function showCancelModal() {
      return this.cancelModalMode !== CANCEL_ORDER_MODE.NONE;
    },
    classModifiers: function classModifiers() {
      return {
        'order-book-offers-sushi': true,
        'order-book-offers-sushi--card-layout': this.cardLayout,
        'order-book-offers-sushi--compact-card': this.cardLayout && this.compactCardLayout,
        'order-book-offers-sushi--card-empty': this.isCardEmpty,
        'order-book-offers-sushi--delete-all': this.deleteAllMode
      };
    },
    tableModifiers: function tableModifiers() {
      return {
        'order-book-sushi__table': true,
        'order-book-sushi__table--scrollable': this.scrollable
      };
    },
    offers: function offers() {
      var buyOffersMapped = this.buyOffers.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, o, {
          pricePerShare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(o.pricePerShare)
        });
      });
      var sellOffersMapped = this.sellOffers.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, o, {
          pricePerShare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(o.pricePerShare)
        });
      });
      buyOffersMapped.sort(function (prev, next) {
        if (prev.pricePerShare === next.pricePerShare) {
          return 0;
        }
        var result = 1;
        if (prev.pricePerShare < next.pricePerShare) result = -1;

        return -result;
      });
      sellOffersMapped.sort(function (prev, next) {
        if (prev.pricePerShare === next.pricePerShare) {
          return 0;
        }
        var result = 1;
        if (prev.pricePerShare < next.pricePerShare) result = -1;

        return result;
      });

      if (this.displayMode === ORDER_BOOK_OFFER_DISPLAY_MODE.BUY) {
        return buyOffersMapped;
      }
      if (this.displayMode === ORDER_BOOK_OFFER_DISPLAY_MODE.SELL) {
        return sellOffersMapped;
      }
      if (this.displayMode === ORDER_BOOK_OFFER_DISPLAY_MODE.TOGGLE) {
        return this.activeTab === ORDER_BOOK_OFFER_DISPLAY_MODE.BUY ? buyOffersMapped : sellOffersMapped;
      }

      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(buyOffersMapped), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(sellOffersMapped));
    },
    showAllItemsNotice: function showAllItemsNotice() {
      if (this.scrollable) return false;
      return this.offers.length > this.showAllCut;
    },
    itemsToDisplay: function itemsToDisplay() {
      return this.showAll ? this.offers : this.offers.slice(0, this.showAllCut);
    },
    displayRows: function displayRows() {
      var displayRows = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.itemsToDisplay));
      var minimumRows = this.minimumRows;
      if (this.cardLayout && this.compactCardLayout) {
        minimumRows = this.isCardEmpty ? 1 : 0;
      }
      var rowCount = Math.max(displayRows.length, minimumRows);

      while (displayRows.length < rowCount) {
        displayRows.push(null);
      }

      return displayRows;
    },
    isCardEmpty: function isCardEmpty() {
      return this.cardLayout && this.offers.length === 0;
    },
    showProcessedNotice: function showProcessedNotice() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.offers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (!item.isProcessed) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getMarket']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['cancelOffer', 'cancelAllOffers', 'getContractOffers', 'getOrderBook', 'setTradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    getDate: function getDate(item) {
      var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["k" /* dateToString */])(item.dateCreated).split(' ');
      return v[0];
    },
    getDateFull: function getDateFull(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["k" /* dateToString */])(item.dateCreated);
    },
    onClickInner: function onClickInner() {},
    onClickOutside: function onClickOutside() {
      this.showMenu = false;
    },
    rowModifiers: function rowModifiers(item) {
      return {
        'order-book-sushi__row': true,
        'order-book-sushi__row--striped': true,
        'order-book-offers-sushi__row--to-cancel': item.offerId === this.deleteOfferId || this.deleteAllMode
      };
    },
    rowTitle: function rowTitle(item) {
      return 'Created ' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(item.dateCreated).format('MM/DD/YYYY h:mm a') + ' ET - Original Quantity: ' + item.quantity;
    },
    loginClicked: function loginClicked() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    },
    rowClicked: function rowClicked(item) {
      if (!this.isLayoutMobile) return;
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_OFFER_INFO);
      this.setCurrentPopupOptions({
        title: this.rowTitle(item)
      });
    },
    offerInfoDisplay: function offerInfoDisplay(item) {
      switch (item.tradeType) {
        case 0:
          return 'Buy NO';
        case 1:
          return 'Buy YES';
        case 2:
          return 'Sell NO';
        case 3:
          return 'Sell YES';
        default:
          return '';
      }
    },
    offerFullInfoDisplay: function offerFullInfoDisplay(item) {
      var quantity = item.remainingQuantity.toLocaleString();
      var price = item.pricePerShare + '&cent;';
      switch (item.tradeType) {
        case 0:
          return 'Buy ' + quantity + ' NO at Max ' + price;
        case 1:
          return 'Buy ' + quantity + ' YES at Max ' + price;
        case 2:
          return 'Sell ' + quantity + ' NO at Min ' + price;
        case 3:
          return 'Sell ' + quantity + ' YES at Min ' + price;
        default:
          return '';
      }
    },
    deleteClicked: function deleteClicked(offerId) {
      this.cancelClicked();
      this.deleteOfferId = offerId;
      this.cancelModalMode = CANCEL_ORDER_MODE.SINGLE;
    },
    confirmDeleteClicked: function confirmDeleteClicked(offerId) {
      var _this2 = this;

      if (!this.isCancelOrdersEnabled) {
        // this.setCurrentSmallPopup(MODALS.SMALL_PROCESS_ERROR);
        this.setCurrentPopupOptions({ message: 'The site is in Maintenance so we are unable to cancel your order at this time. Please try again later.' });
      } else {
        this.loaderAdd(document.body);
        this.cancelOffer(offerId).then(function () {
          _this2.setSuccessSideNotification('Your order has been removed.');
          _this2.getContractOffers(_this2.contract.contractId);
          _this2.cancelClicked();
          _this2.$emit('offerCanceled');
        }).catch(function () {
          return _this2.cancelClicked();
        });
      }
    },
    deleteAllClicked: function deleteAllClicked() {
      this.cancelClicked();
      this.deleteAllMode = true;
      this.showMenu = false;
      this.cancelModalMode = CANCEL_ORDER_MODE.ALL;
    },
    confirmDeleteAllClicked: function confirmDeleteAllClicked() {
      var _this3 = this;

      if (!this.isCancelOrdersEnabled) {
        // this.setCurrentSmallPopup(MODALS.SMALL_PROCESS_ERROR);
        this.setCurrentPopupOptions({ message: 'The site is in Maintenance so we are unable to cancel your order at this time. Please try again later.' });
      } else {
        var payload = {
          contractId: this.contract.contractId
          // offerType: this.operationType,
        };
        this.loaderAdd(document.body);
        this.cancelAllOffers(payload).then(function () {
          _this3.setSuccessSideNotification('Your orders have been removed.');
          _this3.getContractOffers(_this3.contract.contractId);
          _this3.cancelClicked();
          _this3.$emit('offerCanceled');
        }).catch(function () {
          return _this3.cancelClicked();
        });
      }
    },
    cancelClicked: function cancelClicked() {
      this.cancelModalMode = CANCEL_ORDER_MODE.NONE;
      this.showMenu = false;
      this.deleteAllMode = false;
      this.deleteOfferId = null;
      this.loaderRemove(document.body);
    },
    toggleShowAll: function toggleShowAll() {
      this.showAll = !this.showAll;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('order_book_all_offers_show_all_' + this.contract.contractId, this.showAll);
    },
    updateShowAll: function updateShowAll() {
      if (this.scrollable) return;
      this.showAll = __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('order_book_all_offers_show_all_' + this.contract.contractId, false);
    },
    updateActiveTab: function updateActiveTab() {
      this.activeTab = __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('order_book_active_tab_' + this.contract.contractId, ORDER_BOOK_OFFER_DISPLAY_MODE.BUY);
    }
  }),
  created: function created() {
    this.cancelClicked();
    this.updateShowAll();
    this.updateActiveTab();
  }
});

/***/ }),

/***/ "0IxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_dashboard_page_dashboard_sushi_page_dashboard_sushi_vue__ = __webpack_require__("9/FY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_dashboard_page_dashboard_sushi_pages_sushi_invite_friends_sushi_invite_friends_vue__ = __webpack_require__("IlLP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_dashboard_page_dashboard_sushi_pages_sushi_leaderboard_info_sushi_leaderboard_info_vue__ = __webpack_require__("l+Fm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_dashboard_page_dashboard_sushi_pages_sushi_my_markets_sushi_my_markets_vue__ = __webpack_require__("Nd9h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_dashboard_page_dashboard_sushi_pages_sushi_notifications_sushi_notifications_vue__ = __webpack_require__("Z+nZ");
/* eslint-disable max-len */






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/dashboard',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages_dashboard_page_dashboard_sushi_page_dashboard_sushi_vue__["a" /* default */],
  props: true,
  meta: {
    requiresAuth: true,
    appContentFullWidth: true
  },
  children: [{
    path: '',
    name: 'portfolio',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_dashboard_page_dashboard_sushi_pages_sushi_my_markets_sushi_my_markets_vue__["a" /* default */],
    meta: {
      appContentFullWidth: true
    }
  }, {
    path: 'leaderboard-info',
    name: 'dashboard-leaderboard-info',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_dashboard_page_dashboard_sushi_pages_sushi_leaderboard_info_sushi_leaderboard_info_vue__["a" /* default */],
    meta: {
      appContentFullWidth: true
    }
  }, {
    path: 'invite-friends',
    name: 'dashboard-invite-friends',
    component: __WEBPACK_IMPORTED_MODULE_1__components_pages_dashboard_page_dashboard_sushi_pages_sushi_invite_friends_sushi_invite_friends_vue__["a" /* default */],
    meta: {
      appContentFullWidth: true
    }
  }, {
    path: 'notifications',
    name: 'dashboard-notifications',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_dashboard_page_dashboard_sushi_pages_sushi_notifications_sushi_notifications_vue__["a" /* default */],
    meta: {
      appContentFullWidth: true
    }
  }]
}]);

/***/ }),

/***/ "0Jvk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-image",style:(_vm.imageStyleModifiers)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0KBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without__ = __webpack_require__("yI9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isString__ = __webpack_require__("JDN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_intersection__ = __webpack_require__("Aemx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters_consts__ = __webpack_require__("OJH0");












 /* eslint-disable */







var DEFAULT_FILTERED_MARKETS = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

var TWENTY_FOUR_GAINS = 'Biggest 24 hour Gains';
var TWENTY_FOUR_LOSS = 'Biggest 24 hour Losses';
var WEEK_GAINS = 'Biggest 7 day Gains';
var WEEK_LOSS = 'Biggest 7 day Losses';

var prepareBiggestGains = function prepareBiggestGains(items, sectionTitle) {
  var isGain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  items.forEach(function (el) {
    el.sectionTitle = sectionTitle;
    el.isGain = isGain;
  });
  return items;
};

var TITLE_PREDICTED = 'Most Predicted';
var TITLE_TRENDING = 'Top Trending';
var TITLE_MOVERS = 'Biggest Movers';
var TITLE_NEW_ARRIVALS = 'New Arrivals';

var prepareMostPredicted = function prepareMostPredicted(markets, sectionTitle) {
  markets.forEach(function (el) {
    el.sectionTitle = sectionTitle;
  });
  return markets;
};

var THROTTLE_TIME = 1750;

var getCachedStoriesByIndexes = function getCachedStoriesByIndexes(storyMap, indexes) {
  return indexes.map(function (index) {
    return storyMap[index];
  }).filter(function (story) {
    return typeof story !== 'undefined';
  });
};

var getMissingStoryIndexes = function getMissingStoryIndexes(storyMap, indexes) {
  return indexes.filter(function (index) {
    return typeof storyMap[index] === 'undefined';
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    headers: [],
    headersReady: false,
    filters: null,
    orders: __WEBPACK_IMPORTED_MODULE_16__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_16__filters_consts__["b" /* TIMESPANS */],
    filteredMarkets: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_FILTERED_MARKETS),
    selectedFilters: [],
    selectedOrder: __WEBPACK_IMPORTED_MODULE_16__filters_consts__["a" /* ORDERS */][0],
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_16__filters_consts__["c" /* AVAILABLE_TIMESPANS */].TODAY,
    shouldShowTimespanFilter: true,
    twentyFourGains: [],
    twentyFourLoss: [],
    weekGains: [],
    weekLoss: [],
    newArrivalMarkets: [],
    mostPredictedMarkets: [],
    trendingMarkets: [],
    biggestMoverMarkets: [],
    widgets: {},
    latestHeaderId: null,
    storiesNav: [],
    currentStory: null,
    currentStoryIndex: null,
    currentStoryDetail: null,
    storyDetailMap: {},
    storyMap: {},
    storiesList: [],
    storiesUseLegacyPreload: false,
    showNavBrowseOverlay: false,
    marketsPageInitialLoadDone: false
  },
  getters: {
    areUserBrowseHeadersEmpty: function areUserBrowseHeadersEmpty(state, getters) {
      return state.headersReady && getters.userBrowseHeaders.length === 0;
    },
    userBrowseHeaders: function userBrowseHeaders(state, getters, rootState, rootGetters) {
      var baseHeaders = [];

      if (false) {
        baseHeaders.push({
          headerId: -2,
          external: true,
          href: process.env.TOURNAMENT_LINK,
          title: 'Tournament',
          icon: 'star'
        });
      }

      if (rootGetters['user/isLoggedIn']) {
        baseHeaders.push({
          headerId: -1,
          external: true,
          name: 'market-watchlist',
          title: 'Watchlist',
          icon: 'watch'
        });
      }

      return [].concat(baseHeaders, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(state.headers));
    }
  },
  mutations: {
    clearCurrentStoryDetail: function clearCurrentStoryDetail(state) {
      state.currentStoryDetail = null;
    },
    setCurrentStoryDetail: function setCurrentStoryDetail(state, data) {
      state.currentStoryDetail = data;
    },
    clearCurrentStory: function clearCurrentStory(state) {
      state.currentStory = null;
    },
    setCurrentStory: function setCurrentStory(state, data) {
      state.currentStory = data;
    },
    setCurrentStoryIndex: function setCurrentStoryIndex(state, data) {
      state.currentStoryIndex = data;
    },
    setStoriesNav: function setStoriesNav(state, data) {
      state.storiesNav = data;
    },
    updateStoryDetailMap: function updateStoryDetailMap(state, data) {
      var index = data.index,
          obj = data.obj;

      state.storyDetailMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.storyDetailMap, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, index, obj));
    },
    updateStoryMap: function updateStoryMap(state, data) {
      var index = data.index,
          obj = data.obj;

      state.storyMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.storyMap, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, index, obj));
    },
    updateStoriesList: function updateStoriesList(state, data) {
      state.storiesList = data;
    },
    setLatestHeaderId: function setLatestHeaderId(state, data) {
      state.latestHeaderId = data;
    },
    setMarketsPageInitialLoadDone: function setMarketsPageInitialLoadDone(state, data) {
      state.marketsPageInitialLoadDone = data;
    },
    setHeaders: function setHeaders(state, payload) {
      state.headers = payload;
      state.headersReady = true;
    },
    setFilters: function setFilters(state, payload) {
      state.filters = payload;
      if (payload) {
        // check if we have selected filters available
        var filterIds = payload.reduce(function (c, filters) {
          return c.concat(filters.filters.map(function (f) {
            return f.filterId;
          }));
        }, []);
        var selectedFilters = __WEBPACK_IMPORTED_MODULE_12_lodash_intersection___default()(state.selectedFilters, filterIds);
        if (state.selectedFilters.length !== selectedFilters.length) {
          state.selectedFilters = [];
        }
      } else {
        state.selectedFilters = [];
      }
    },
    updateFilteredMarkets: function updateFilteredMarkets(state, payload) {
      var data = state.filteredMarkets.data.concat(payload.markets || []);
      var page = payload.page;
      var totalCount = payload.totalMarkets;
      var canLoadMore = totalCount > data.length;

      state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    resetFilteredMarkets: function resetFilteredMarkets(state) {
      state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_FILTERED_MARKETS);
    },
    updateGainsLossMarketFromNotification: function updateGainsLossMarketFromNotification(state, data) {
      if (state.twentyFourGains.length > 0) {
        var markets = state.twentyFourGains.slice();
        state.twentyFourGains = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.twentyFourLoss.length > 0) {
        var _markets = state.twentyFourLoss.slice();
        state.twentyFourLoss = _markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.weekGains.length > 0) {
        var _markets2 = state.weekGains.slice();
        state.weekGains = _markets2.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.weekLoss.length > 0) {
        var _markets3 = state.weekLoss.slice();
        state.weekLoss = _markets3.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updateGainsLossContractFromNotification: function updateGainsLossContractFromNotification(state, data) {
      if (state.twentyFourGains.length > 0) {
        var markets = state.twentyFourGains.slice();
        state.twentyFourGains = markets.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.twentyFourLoss.length > 0) {
        var _markets4 = state.twentyFourLoss.slice();
        state.twentyFourLoss = _markets4.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.weekGains.length > 0) {
        var _markets5 = state.weekGains.slice();
        state.weekGains = _markets5.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.weekLoss.length > 0) {
        var _markets6 = state.weekLoss.slice();
        state.weekLoss = _markets6.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
    },
    updatePredictedTrendingMarketFromNotification: function updatePredictedTrendingMarketFromNotification(state, data) {
      if (state.mostPredictedMarkets.length > 0) {
        var markets = state.mostPredictedMarkets.slice();
        state.mostPredictedMarkets = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.trendingMarkets.length > 0) {
        var _markets7 = state.trendingMarkets.slice();
        state.trendingMarkets = _markets7.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.biggestMoverMarkets.length > 0) {
        var _markets8 = state.biggestMoverMarkets.slice();
        state.biggestMoverMarkets = _markets8.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.newArrivalMarkets.length > 0) {
        var _markets9 = state.newArrivalMarkets.slice();
        state.newArrivalMarkets = _markets9.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updatePredictedTrendingContractsFromNotification: function updatePredictedTrendingContractsFromNotification(state, data) {
      if (state.mostPredictedMarkets.length > 0) {
        var markets = state.mostPredictedMarkets.slice();
        state.mostPredictedMarkets = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.trendingMarkets.length > 0) {
        var _markets10 = state.trendingMarkets.slice();
        state.trendingMarkets = _markets10.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.biggestMoverMarkets.length > 0) {
        var _markets11 = state.biggestMoverMarkets.slice();
        state.biggestMoverMarkets = _markets11.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.newArrivalMarkets.length > 0) {
        var _markets12 = state.newArrivalMarkets.slice();
        state.newArrivalMarkets = _markets12.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
    },
    updateMarketWidgetsContractsFromNotification: function updateMarketWidgetsContractsFromNotification(state, data) {
      if (state.widgets.most) {
        state.widgets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.widgets, {
          most: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(state.widgets.most, data)
        });
      }

      if (state.widgets.smart) {
        state.widgets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.widgets, {
          smart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(state.widgets.smart, data)
        });
      }
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      if (state.filteredMarkets.data) {
        state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
          data: state.filteredMarkets.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.filteredMarkets.data) {
        state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
          data: state.filteredMarkets.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    updateStoryMapFromMarketNotification: function updateStoryMapFromMarketNotification(state, data) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.storyMap).forEach(function (key) {
        var story = state.storyMap[key];
        var desktopContent = story.desktopContent;
        var mobileContent = story.mobileContent;

        if (desktopContent && desktopContent.cmsContent) {
          if (desktopContent.cmsContent.marketTileMarkets) {
            desktopContent.cmsContent.marketTileMarkets = desktopContent.cmsContent.marketTileMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
            });
          }
          if (desktopContent.cmsContent.contractListMarkets) {
            desktopContent.cmsContent.contractListMarkets = desktopContent.cmsContent.contractListMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
            });
          }
        }

        if (mobileContent && mobileContent.cmsContent) {
          if (mobileContent.cmsContent.marketTileMarkets) {
            mobileContent.cmsContent.marketTileMarkets = mobileContent.cmsContent.marketTileMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
            });
          }
          if (mobileContent.cmsContent.contractListMarkets) {
            mobileContent.cmsContent.contractListMarkets = mobileContent.cmsContent.contractListMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
            });
          }
        }
      });

      if (state.currentStoryDetail && state.currentStoryDetail.cmsContentObject) {
        var cms = state.currentStoryDetail.cmsContentObject;
        if (cms.marketTileMarkets) {
          cms.marketTileMarkets = cms.marketTileMarkets.map(function (m) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(m, data);
          });
        }
        if (cms.contractListMarkets) {
          cms.contractListMarkets = cms.contractListMarkets.map(function (m) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(m, data);
          });
        }
      }
    },
    updateStoryMapFromContractNotification: function updateStoryMapFromContractNotification(state, data) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.storyMap).forEach(function (key) {
        var story = state.storyMap[key];
        var desktopContent = story.desktopContent;
        var mobileContent = story.mobileContent;

        if (desktopContent && desktopContent.cmsContent) {
          if (desktopContent.cmsContent.marketTileMarkets) {
            desktopContent.cmsContent.marketTileMarkets = desktopContent.cmsContent.marketTileMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
            });
          }
          if (desktopContent.cmsContent.contractListMarkets) {
            desktopContent.cmsContent.contractListMarkets = desktopContent.cmsContent.contractListMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
            });
          }
        }

        if (mobileContent && mobileContent.cmsContent) {
          if (mobileContent.cmsContent.marketTileMarkets) {
            mobileContent.cmsContent.marketTileMarkets = mobileContent.cmsContent.marketTileMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
            });
          }
          if (mobileContent.cmsContent.contractListMarkets) {
            mobileContent.cmsContent.contractListMarkets = mobileContent.cmsContent.contractListMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
            });
          }
        }
      });

      if (state.currentStoryDetail && state.currentStoryDetail.cmsContentObject) {
        var cms = state.currentStoryDetail.cmsContentObject;
        if (cms.marketTileMarkets) {
          cms.marketTileMarkets = cms.marketTileMarkets.map(function (m) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(m, data);
          });
        }
        if (cms.contractListMarkets) {
          cms.contractListMarkets = cms.contractListMarkets.map(function (m) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(m, data);
          });
        }
      }
    },
    addFilter: function addFilter(state, filterId) {
      if (!state.selectedFilters.includes(filterId)) {
        state.selectedFilters.push(filterId);
      }
    },
    clearFilters: function clearFilters(state) {
      state.selectedFilters = [];
    },
    clearOrder: function clearOrder(state) {
      state.selectedOrder = __WEBPACK_IMPORTED_MODULE_16__filters_consts__["a" /* ORDERS */][0];
    },
    setOrderFromQuery: function setOrderFromQuery(state, order) {
      var found = __WEBPACK_IMPORTED_MODULE_16__filters_consts__["a" /* ORDERS */].find(function (i) {
        return i.sort === order;
      });
      if (found) {
        state.selectedOrder = __WEBPACK_IMPORTED_MODULE_16__filters_consts__["a" /* ORDERS */].find(function (i) {
          return i.sort === order;
        });
        state.shouldShowTimespanFilter = __WEBPACK_IMPORTED_MODULE_16__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(order) !== -1;
      }
    },
    clearTimespan: function clearTimespan(state) {
      state.selectedTimespan = __WEBPACK_IMPORTED_MODULE_16__filters_consts__["c" /* AVAILABLE_TIMESPANS */].TODAY;
      state.shouldShowTimespanFilter = true;
    },
    setTimespanFromQuery: function setTimespanFromQuery(state, timespan) {
      var found = __WEBPACK_IMPORTED_MODULE_16__filters_consts__["c" /* AVAILABLE_TIMESPANS */][timespan];
      if (found) {
        state.selectedTimespan = found;
      }
    },
    removeFilter: function removeFilter(state, filterId) {
      state.selectedFilters = __WEBPACK_IMPORTED_MODULE_10_lodash_without___default()(state.selectedFilters, filterId);
    },

    selectOrder: __WEBPACK_IMPORTED_MODULE_16__filters_consts__["f" /* selectOrder */],
    selectTimespan: __WEBPACK_IMPORTED_MODULE_16__filters_consts__["g" /* selectTimespan */],
    setWidgets: function setWidgets(state, payload) {
      var mapping = {
        currentlyPredictingWidget: 'currently',
        smartMoneyWidget: 'smart',
        todaysMostPredictedWidget: 'most',
        keyStatsWidget: 'key',
        topCommentsWidget: 'comments'
      };
      var widgets = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
        var value = payload[key];
        var name = mapping[key];
        if (name) {
          widgets[name] = value;
        }
      });
      state.widgets = widgets;
    },
    setTwentyFourGains: function setTwentyFourGains(state, data) {
      state.twentyFourGains = prepareBiggestGains(data, TWENTY_FOUR_GAINS, true);
    },
    setTwentyFourLoss: function setTwentyFourLoss(state, data) {
      state.twentyFourLoss = prepareBiggestGains(data, TWENTY_FOUR_LOSS, false);
    },
    setWeekGains: function setWeekGains(state, data) {
      state.weekGains = prepareBiggestGains(data, WEEK_GAINS, true);
    },
    setWeekLoss: function setWeekLoss(state, data) {
      state.weekLoss = prepareBiggestGains(data, WEEK_LOSS, false);
    },
    setNewArrivalMarkets: function setNewArrivalMarkets(state, data) {
      state.newArrivalMarkets = prepareMostPredicted(data.markets, TITLE_NEW_ARRIVALS);
    },
    setMostPredictedMarkets: function setMostPredictedMarkets(state, data) {
      state.mostPredictedMarkets = prepareMostPredicted(data.markets, TITLE_PREDICTED);
    },
    setTrendingMarkets: function setTrendingMarkets(state, data) {
      state.trendingMarkets = prepareMostPredicted(data.markets, TITLE_TRENDING);
    },
    setBiggestMoverMarkets: function setBiggestMoverMarkets(state, data) {
      state.biggestMoverMarkets = prepareMostPredicted(data.markets, TITLE_MOVERS);
    },
    toggleNavBrowseCategoriesOverlay: function toggleNavBrowseCategoriesOverlay(state) {
      state.showNavBrowseOverlay = !state.showNavBrowseOverlay;
    }
  },
  actions: {
    getHeaders: function getHeaders(_ref) {
      var commit = _ref.commit;

      var cached = __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get('browseHeaders');
      var prom = cached ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ data: cached }) : __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHeaders();
      return prom.then(function (response) {
        if (!__WEBPACK_IMPORTED_MODULE_11_lodash_isString___default()(response.data)) {
          var sorted = __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default()(response.data, ['sortOrder']);
          __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set('browseHeaders', response.data, "3600");
          commit('setHeaders', sorted);
        }
        return response;
      });
    },
    getFilters: function getFilters(_ref2, headerId) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getFilters(headerId).then(function (response) {
        var sorted = __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default()(response.data, ['sortOrder']);
        sorted.map(function (item) {
          item.filters = __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default()(item.filters, ['sortOrder']);
          return item;
        });
        commit('setFilters', sorted);
        return response;
      });
    },

    getFilteredMarkets: __WEBPACK_IMPORTED_MODULE_8_lodash_throttle___default()(function (_ref3, _ref4) {
      var state = _ref3.state,
          commit = _ref3.commit;
      var headerId = _ref4.headerId,
          _ref4$reset = _ref4.reset,
          reset = _ref4$reset === undefined ? false : _ref4$reset;

      var filterIds = state.selectedFilters.join(',');
      var sort = state.selectedOrder.sort;
      var sortParameter = state.selectedTimespan.parameter;
      var page = reset ? 1 : state.filteredMarkets.page + 1;
      var canLoadMore = reset ? true : state.filteredMarkets.canLoadMore;
      if (canLoadMore) {
        return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getFilteredMarkets(headerId, 20, page, filterIds, sort, sortParameter).then(function (response) {
          // resetting takes place here so markets are 'swapped'
          if (reset) commit('resetFilteredMarkets');
          commit('updateFilteredMarkets', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(response.data, { page: page }));
          return response;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(1);
    }, THROTTLE_TIME),
    resetFilteredMarkets: function resetFilteredMarkets(_ref5) {
      var commit = _ref5.commit;

      commit('resetFilteredMarkets');
    },
    getNewArrivalMarkets: function getNewArrivalMarkets(_ref6, _ref7) {
      var commit = _ref6.commit;
      var limit = _ref7.limit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getNewArrivalMarkets(limit).then(function (response) {
        commit('setNewArrivalMarkets', response.data);
        return response.data;
      });
    },
    getMostPredictedMarkets: function getMostPredictedMarkets(_ref8, _ref9) {
      var commit = _ref8.commit;
      var limit = _ref9.limit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getMostPredictedMarkets(limit).then(function (response) {
        commit('setMostPredictedMarkets', response.data);
        return response.data;
      });
    },
    getTrendingMarkets: function getTrendingMarkets(_ref10, _ref11) {
      var commit = _ref10.commit;
      var limit = _ref11.limit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getTrendingMarkets(limit).then(function (response) {
        commit('setTrendingMarkets', response.data);
        return response.data;
      });
    },
    getBiggestMoverMarkets: function getBiggestMoverMarkets(_ref12, _ref13) {
      var commit = _ref12.commit;
      var limit = _ref13.limit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getBiggestMoverMarkets(limit).then(function (response) {
        commit('setBiggestMoverMarkets', response.data);
        return response.data;
      });
    },
    addFilter: function addFilter(_ref14, filterId) {
      var commit = _ref14.commit;

      commit('addFilter', filterId);
    },
    removeFilter: function removeFilter(_ref15, filterId) {
      var commit = _ref15.commit;

      commit('removeFilter', filterId);
    },
    selectOrder: function selectOrder(_ref16, sort) {
      var commit = _ref16.commit;

      commit('selectOrder', sort);
    },
    selectTimespan: function selectTimespan(_ref17, parameter) {
      var commit = _ref17.commit;

      commit('selectTimespan', parameter);
    },
    getCarousel: function getCarousel() {
      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getCarousel().then(function (response) {
        return response.data;
      });
    },
    getTwentyFourGains: function getTwentyFourGains(_ref18, _ref19) {
      var commit = _ref18.commit;
      var _ref19$isLoss = _ref19.isLoss,
          isLoss = _ref19$isLoss === undefined ? false : _ref19$isLoss,
          _ref19$days = _ref19.days,
          days = _ref19$days === undefined ? 1 : _ref19$days,
          _ref19$contracts = _ref19.contracts,
          contracts = _ref19$contracts === undefined ? 2 : _ref19$contracts;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setTwentyFourGains', response.data);
        return response.data;
      });
    },
    getTwentyFourLoss: function getTwentyFourLoss(_ref20, _ref21) {
      var commit = _ref20.commit;
      var _ref21$isLoss = _ref21.isLoss,
          isLoss = _ref21$isLoss === undefined ? true : _ref21$isLoss,
          _ref21$days = _ref21.days,
          days = _ref21$days === undefined ? 1 : _ref21$days,
          _ref21$contracts = _ref21.contracts,
          contracts = _ref21$contracts === undefined ? 2 : _ref21$contracts;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setTwentyFourLoss', response.data);
        return response.data;
      });
    },
    getWeekGains: function getWeekGains(_ref22, _ref23) {
      var commit = _ref22.commit;
      var _ref23$isLoss = _ref23.isLoss,
          isLoss = _ref23$isLoss === undefined ? false : _ref23$isLoss,
          _ref23$days = _ref23.days,
          days = _ref23$days === undefined ? 7 : _ref23$days,
          _ref23$contracts = _ref23.contracts,
          contracts = _ref23$contracts === undefined ? 2 : _ref23$contracts;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setWeekGains', response.data);
        return response.data;
      });
    },
    getWeekLoss: function getWeekLoss(_ref24, _ref25) {
      var commit = _ref24.commit;
      var _ref25$isLoss = _ref25.isLoss,
          isLoss = _ref25$isLoss === undefined ? true : _ref25$isLoss,
          _ref25$days = _ref25.days,
          days = _ref25$days === undefined ? 7 : _ref25$days,
          _ref25$contracts = _ref25.contracts,
          contracts = _ref25$contracts === undefined ? 2 : _ref25$contracts;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setWeekLoss', response.data);
        return response.data;
      });
    },
    clearFilters: function clearFilters(_ref26) {
      var commit = _ref26.commit;

      commit('clearFilters');
    },
    clearTimespan: function clearTimespan(_ref27) {
      var commit = _ref27.commit;

      commit('clearTimespan');
    },
    setTimespanFromQuery: function setTimespanFromQuery(_ref28, payload) {
      var commit = _ref28.commit;

      commit('setTimespanFromQuery', payload);
    },
    clearOrder: function clearOrder(_ref29) {
      var commit = _ref29.commit;

      commit('clearOrder');
    },
    setOrderFromQuery: function setOrderFromQuery(_ref30, payload) {
      var commit = _ref30.commit;

      commit('setOrderFromQuery', payload);
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref31, payload) {
      var commit = _ref31.commit;

      commit('updateMarketFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref32, payload) {
      var commit = _ref32.commit;

      commit('updateContractFromNotification', payload);
    },
    updateGainsLossMarketFromNotification: function updateGainsLossMarketFromNotification(_ref33, payload) {
      var commit = _ref33.commit;

      commit('updateGainsLossMarketFromNotification', payload);
    },
    updateGainsLossContractFromNotification: function updateGainsLossContractFromNotification(_ref34, payload) {
      var commit = _ref34.commit;

      commit('updateGainsLossContractFromNotification', payload);
    },
    updatePredictedTrendingMarketFromNotification: function updatePredictedTrendingMarketFromNotification(_ref35, payload) {
      var commit = _ref35.commit;

      commit('updatePredictedTrendingMarketFromNotification', payload);
    },
    updatePredictedTrendingContractsFromNotification: function updatePredictedTrendingContractsFromNotification(_ref36, payload) {
      var commit = _ref36.commit;

      commit('updatePredictedTrendingContractsFromNotification', payload);
    },
    updateMarketWidgetsContractsFromNotification: function updateMarketWidgetsContractsFromNotification(_ref37, payload) {
      var commit = _ref37.commit;

      commit('updateMarketWidgetsContractsFromNotification', payload);
    },
    updateStoryMapFromMarketNotification: function updateStoryMapFromMarketNotification(_ref38, payload) {
      var commit = _ref38.commit;

      commit('updateStoryMapFromMarketNotification', payload);
    },
    updateStoryMapFromContractNotification: function updateStoryMapFromContractNotification(_ref39, payload) {
      var commit = _ref39.commit;

      commit('updateStoryMapFromContractNotification', payload);
    },
    getWidgets: function getWidgets(_ref40) {
      var commit = _ref40.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getWidgets().then(function (response) {
        commit('setWidgets', response.data);
        return response;
      });
    },
    setLatestHeaderId: function setLatestHeaderId(_ref41, data) {
      var commit = _ref41.commit;

      commit('setLatestHeaderId', data);
    },
    setMarketsPageInitialLoadDone: function setMarketsPageInitialLoadDone(_ref42, data) {
      var commit = _ref42.commit;

      commit('setMarketsPageInitialLoadDone', data);
    },
    getStoriesList: function getStoriesList(_ref43, _ref44) {
      var commit = _ref43.commit,
          state = _ref43.state;
      var indexes = _ref44.indexes,
          _ref44$cache = _ref44.cache,
          cache = _ref44$cache === undefined ? false : _ref44$cache;

      if (!Array.isArray(indexes) || indexes.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      var missingIndexes = cache ? getMissingStoryIndexes(state.storyMap, indexes) : indexes;

      if (cache && missingIndexes.length === 0) {
        var cachedStories = getCachedStoriesByIndexes(state.storyMap, indexes);
        commit('updateStoriesList', cachedStories);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(cachedStories);
      }

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStoriesList(missingIndexes).then(function (response) {
        var stories = [];
        if (Array.isArray(response.data)) {
          stories = response.data;
        } else {
          stories = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(response, 'data.stories', []);
        }

        stories.forEach(function (obj, position) {
          commit('updateStoryMap', {
            index: missingIndexes[position],
            obj: obj
          });
        });

        var orderedStories = getCachedStoriesByIndexes(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.storyMap, missingIndexes.reduce(function (accumulator, index, position) {
          accumulator[index] = stories[position];
          return accumulator;
        }, {})), indexes);

        commit('updateStoriesList', orderedStories);
        return orderedStories;
      });
    },
    getStoriesNav: function getStoriesNav(_ref45) {
      var commit = _ref45.commit,
          state = _ref45.state;

      var _ref46 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref46$cache = _ref46.cache,
          cache = _ref46$cache === undefined ? true : _ref46$cache;

      if (cache && state.storiesNav.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.storiesNav);
      }
      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStoriesNav().then(function (response) {
        commit('setStoriesNav', response.data);
        return response.data;
      });
    },
    getStory: function getStory(_ref47, _ref48) {
      var commit = _ref47.commit,
          state = _ref47.state;
      var index = _ref48.index,
          _ref48$cache = _ref48.cache,
          cache = _ref48$cache === undefined ? true : _ref48$cache;

      commit('clearCurrentStory');
      if (cache && typeof state.storyMap[index] !== 'undefined') {
        var obj = state.storyMap[index];
        commit('setCurrentStory', obj);
        commit('setCurrentStoryIndex', index);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(obj);
      }
      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStory(index).then(function (response) {
        var obj = response.data;
        commit('updateStoryMap', {
          index: index,
          obj: obj
        });
        commit('setCurrentStory', obj);
        commit('setCurrentStoryIndex', index);
        return obj;
      });
    },
    getStoryDetail: function getStoryDetail(_ref49, _ref50) {
      var commit = _ref49.commit,
          state = _ref49.state;
      var index = _ref50.index,
          _ref50$cache = _ref50.cache,
          cache = _ref50$cache === undefined ? true : _ref50$cache;

      commit('clearCurrentStoryDetail');
      if (cache && typeof state.storyDetailMap[index] !== 'undefined') {
        var obj = state.storyDetailMap[index];
        commit('setCurrentStoryDetail', obj);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(obj);
      }
      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStoryDetail(index).then(function (response) {
        var obj = response.data;
        commit('updateStoryDetailMap', {
          index: index,
          obj: obj
        });
        commit('setCurrentStoryDetail', obj);
        return obj;
      });
    },
    getStaticPageFull: function getStaticPageFull(_ref51, key) {
      var commit = _ref51.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStaticPageDetail(key).then(function (response) {
        return response.data;
      });
    },
    getStaticPagePreview: function getStaticPagePreview(_ref52, id) {
      var commit = _ref52.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStaticPagePreview(id).then(function (response) {
        return response.data;
      });
    },
    getStoryFullPreview: function getStoryFullPreview(_ref53, id) {
      var commit = _ref53.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStoryFullPreview(id).then(function (response) {
        return response.data;
      });
    },
    clearCurrentStoryDetail: function clearCurrentStoryDetail(_ref54) {
      var commit = _ref54.commit;

      commit('clearCurrentStoryDetail');
    },
    toggleNavBrowseCategoriesOverlay: function toggleNavBrowseCategoriesOverlay(_ref55) {
      var commit = _ref55.commit;

      commit('toggleNavBrowseCategoriesOverlay');
    }
  }
});

/***/ }),

/***/ "0O9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onLogin: function onLogin() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'click',
        label: 'Login to My Account'
      });
      if (this.isPage) {
        this.$router.push({ name: 'account-page-login' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
      }
    }
  })
});

/***/ }),

/***/ "0OLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isDark: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "0RmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_report_js__ = __webpack_require__("CcaY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8e325a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_report_vue__ = __webpack_require__("KR/I");
function injectStyle (ssrContext) {
  __webpack_require__("5Xc3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_report_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8e325a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0S3t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-odds-toggle-popup"},[_c('div',{staticClass:"price-odds-toggle-popup__options"},[_c('div',{staticClass:"price-odds-toggle-popup__option",class:!_vm.settingShowOdds ? 'price-odds-toggle-popup__option--active' : '',on:{"click":_vm.onDontShowOdds}},[_vm._v("Last Trade Price")]),_vm._v(" "),_c('div',{staticClass:"price-odds-toggle-popup__option",class:_vm.settingShowOdds ? 'price-odds-toggle-popup__option--active' : '',on:{"click":_vm.onShowOdds}},[_c('brand-name'),_vm._v(" Odds")],1)]),_vm._v(" "),(!_vm.settingShowOdds)?_c('div',{staticClass:"price-odds-toggle-popup__disclaimer"},[_vm._v("\n    The Last Trade Price for a YES contract.\n  ")]):_vm._e(),_vm._v(" "),(_vm.settingShowOdds)?_c('div',{staticClass:"price-odds-toggle-popup__disclaimer"},[_vm._v("\n    The implied odds of the event occurring based on the wisdom of the crowd. These odds are approximated using the Last Trade Price of the YES side of the contract.\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0W9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-rules-content"},[_c('div',{staticClass:"market-rules-content__section"},[_c('div',{staticClass:"market-rules-content__section-header"},[_c('img',{staticClass:"market-rules-content__icon",attrs:{"src":_vm.criteriaIcon,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"market-rules-content__section-title"},[_vm._v("Criteria for Payout")])]),_vm._v(" "),_c('div',{staticClass:"market-rules-content__section-body"},[(_vm.clarificationDisclaimer)?_c('i',{staticClass:"market-rules-content__clarifications-disclaimer"},[_vm._v("Please Note: PredictIt added a supplementary comment at the bottom of the Rules on "+_vm._s(_vm.dateToString(_vm.clarificationDisclaimer.date, 'MM/DD/YYYY'))+".")]):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.rulesModel.baseRule)}}),_vm._v(" "),(_vm.clarificationsSection.length > 0)?_c('div',[_c('h5',{staticClass:"market-rules-content__clarifications-header"},[_vm._v("Supplementary Comment"+_vm._s(_vm.clarificationsSection.length > 1 ? 's' : ''))]),_vm._v(" "),_vm._l((_vm.clarificationsSection),function(clarification){return _c('div',{key:clarification.clarification,staticClass:"market-rules-content__clarification"},[_c('div',[_c('u',[_vm._v("Created On: "+_vm._s(_vm.dateToString(clarification.date)))])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(clarification.clarification)}})])})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"market-rules-content__divider"}),_vm._v(" "),_c('div',{staticClass:"market-rules-content__section"},[_c('div',{staticClass:"market-rules-content__section-header"},[_c('img',{staticClass:"market-rules-content__icon",attrs:{"src":_vm.datesIcon,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"market-rules-content__section-title"},[_vm._v("Dates")])]),_vm._v(" "),_c('div',{staticClass:"market-rules-content__section-body"},[(_vm.startDate)?_c('p',{staticClass:"market-rules-content__date"},[_c('span',{staticClass:"market-rules-content__date-label"},[_vm._v("Start Date")]),_vm._v(": "+_vm._s(_vm.startDate)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.endDate)?_c('p',{staticClass:"market-rules-content__date"},[_c('span',{staticClass:"market-rules-content__date-label"},[_vm._v("End Date")]),_vm._v(": "+_vm._s(_vm.endDate)+"\n      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"market-rules-content__divider"}),_vm._v(" "),_c('div',{staticClass:"market-rules-content__section"},[_c('div',{staticClass:"market-rules-content__section-header"},[_c('img',{staticClass:"market-rules-content__icon",attrs:{"src":_vm.marketTypeIcon,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"market-rules-content__section-title"},[_vm._v("Market Type")])]),_vm._v(" "),(_vm.isMarketSingle)?_c('div',{staticClass:"market-rules-content__section-body"},[_vm._v("\n      This is a market with a single outcome of either YES or NO. In a single-contract market, the calculation of risk (required collateral) is equal to the amount you paid for your shares.\n    ")]):_c('div',{staticClass:"market-rules-content__section-body"},[_vm._v("\n      This market offers several possible outcomes (contracts) but only one outcome that can resolve to YES. It is sometimes possible, however, for all contracts in a market to resolve to NO, depending on circumstances.  In a multiple-contract market of this type, the calculation of risk (required collateral) is equal to the amount necessary to cover your maximum potential loss (or smallest profit) when considering every possible market outcome.\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0X7F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getForumUrl: function getForumUrl() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/ForumURL');
  },
  getTicketsTypes: function getTicketsTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Support/Tickets/Types');
  },
  postTicket: function postTicket(payload) {
    var options = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Support/Ticket', payload, options);
  },
  getReportUser: function getReportUser() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Support/ReportUser');
  },
  postReportUser: function postReportUser(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Support/ReportUser', payload);
  },
  getAnnouncements: function getAnnouncements() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/Announcements');
  }
});

/***/ }),

/***/ "0fv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_support_js__ = __webpack_require__("tGWZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_559468ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_support_vue__ = __webpack_require__("LU/L");
function injectStyle (ssrContext) {
  __webpack_require__("aGiD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_support_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_559468ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0fyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0syx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-loader"},[_c('div',{staticClass:"market-loader__data"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0tSq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0yMi41OSAwSDEuNDExQzEuMDM3LjAwMS42OC4xNS40MTUuNDE1LjE1LjY3OSAwIDEuMDM3IDAgMS40MXYyMS4xOGMuMDAyLjM3My4xNS43MzEuNDE1Ljk5NXMuNjIzLjQxMy45OTYuNDE0aDIxLjE4Yy4zNzMtLjAwMi43My0uMTUuOTk0LS40MTRzLjQxMy0uNjIyLjQxNS0uOTk1VjEuNDFjLS4wMDEtLjM3NC0uMTUtLjczMi0uNDE0LS45OTZTMjIuOTY0LjAwMSAyMi41OSAwem0tNy42MzYgOC4wNzVoLTEuNDNjLS4yNzkgMC0uNTY3LjI5Ny0uNTY3LjUxN3YxLjQ4aDEuOTk0Yy0uMDggMS4xMzQtLjI0NCAyLjE3MS0uMjQ0IDIuMTcxaC0xLjc2djUuOTM3aC0yLjYyM3YtNS45MzdIOS4wNDdWMTAuMDhoMS4yNzdWOC4zMWMwLS4zMjMtLjA2NS0yLjQ5IDIuNjg3LTIuNDloMS45NDN2Mi4yNTZ6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "1/Lc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contracts_history_contract_tile_contract_tile_vue__ = __webpack_require__("34gu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_plus_minus_sign_plus_minus_sign_vue__ = __webpack_require__("T2le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");








var NO_CONTRACTS_MESSAGE = 'No trades in the past 30 days';
var NO_MORE_CONTRACTS_MESSAGE = 'No further trades in the past 30 days';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */]],
  props: {
    lightHeader: {
      type: Boolean,
      default: false
    },
    showMarketNames: {
      type: Boolean,
      default: true
    },
    contracts: {
      type: Array
    },
    canLoadMore: {
      type: Boolean,
      default: true
    },
    compactMode: { // keep mobile size on desktop
      type: Boolean,
      default: false
    },
    hasFilter: {
      type: Boolean,
      default: false
    },
    marketId: Number // indicates "see more" routing
  },
  components: {
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a,
    contractTile: __WEBPACK_IMPORTED_MODULE_4__components_contracts_history_contract_tile_contract_tile_vue__["a" /* default */],
    plusMinusSign: __WEBPACK_IMPORTED_MODULE_5__components_generics_plus_minus_sign_plus_minus_sign_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loadedInfo: this.getLoadedInfo(),
      infiniteLoader: null
    };
  },

  watch: {
    contracts: {
      handler: 'contractsHandler',
      immediate: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    showLoader: function showLoader() {
      return !this.isComponentReady && !this.compactMode && !this.$route.params.marketId;
    },
    loaderNum: function loaderNum() {
      return this.isLayoutMobile ? 2 : 5;
    },
    showHeader: function showHeader() {
      return this.lightHeader ? this.contracts.length > 0 : true;
    },
    headModifiers: function headModifiers() {
      return {
        'contracts-history__head': true,
        'contracts-history__head--with-filter': this.hasFilter,
        'contracts-history--light': this.lightHeader
      };
    },
    classModifiers: function classModifiers() {
      return {
        'contracts-history--compact': this.compactMode
      };
    },
    stickyOptions: function stickyOptions() {
      if (this.$router.currentRoute.name === 'market-details') {
        return this.isLayoutMobile ? __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile : __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].desktop;
      }
      return this.isLayoutMobile ? __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile : __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].desktop;
    },
    desktopColumns: function desktopColumns() {
      return !(this.isLayoutMobile || this.compactMode);
    }
  }),
  methods: {
    contractsHandler: function contractsHandler(newValue, oldValue) {
      if (newValue.length > 0) {
        this.isComponentReady = true;
        if (this.infiniteLoader) {
          this.infiniteLoader.loaded();
          if (!this.canLoadMore) {
            this.infiniteLoader.complete();
          }
        }
        this.loadedInfo = this.getLoadedInfo();
      } else if (typeof oldValue === 'undefined') {
        this.loadedInfo = this.getLoadedInfo();
        this.isComponentReady = true;
      }
    },
    getLoadedInfo: function getLoadedInfo() {
      return this.contracts.length > 0 ? NO_MORE_CONTRACTS_MESSAGE : NO_CONTRACTS_MESSAGE;
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;
      this.$emit('loading', infi);
    }
  }
});

/***/ }),

/***/ "1/XJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");








var TOTAL_COLUMNS = 12;
var COLUMN_OPTIONS = [{ label: '0%', value: 0 }, { label: '8.3%', value: 1 }, { label: '16.6%', value: 2 }, { label: '25%', value: 3 }, { label: '33.3%', value: 4 }, { label: '41.6%', value: 5 }, { label: '50%', value: 6 }, { label: '58.3%', value: 7 }, { label: '66.6%', value: 8 }, { label: '75%', value: 9 }, { label: '83%', value: 10 }, { label: '91.6%', value: 11 }];
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    previewId: {}
  },
  data: function data() {
    return {
      COLUMN_OPTIONS: COLUMN_OPTIONS,
      columnChoice: {
        left: COLUMN_OPTIONS[0],
        middle: COLUMN_OPTIONS[7],
        right: COLUMN_OPTIONS[0]
      }
    };
  },

  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  computed: {
    isColumnCountExceeding: function isColumnCountExceeding() {
      return this.columnChoice.left.value + this.columnChoice.right.value >= TOTAL_COLUMNS;
    },
    middleOption: function middleOption() {
      var sumColumns = this.columnChoice.left.value + this.columnChoice.right.value;
      return TOTAL_COLUMNS - sumColumns;
    },
    leftColumnClasses: function leftColumnClasses() {
      var option = this.columnChoice.left.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + option, !!option);
    },
    middleColumnClasses: function middleColumnClasses() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + this.middleOption, !!this.middleOption);
    },
    rightColumnClasses: function rightColumnClasses() {
      var option = this.columnChoice.right.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, option, !!option);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPagePreview(this.previewId).then(function (data) {
      _this.loaderRemove(document.body);
      _this.installDynamicControls({ data: data });
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPagePreview']))
});

/***/ }),

/***/ "1/qb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__ = __webpack_require__("GZXJ");
/* eslint-disable no-bitwise */


var listenAction = void 0;
var stickyTop = void 0;
var zIndex = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var elStyle = el.style;
    var params = binding.value || {};
    stickyTop = params.stickyTop || 0;
    zIndex = params.zIndex || 1000;
    // uncomment this line and import in case disabling on ios is necessary
    // if (isIos) return;

    if (__WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__["h" /* isWindows */]) return;
    elStyle.position = '-webkit-sticky';
    elStyle.position = 'sticky';

    // if the browser support css sticky（Currently Safari, Firefox and Chrome Canary）
    if (~elStyle.position.indexOf('sticky')) {
      elStyle.top = stickyTop + 'px';
      elStyle.zIndex = zIndex;
      return;
    }

    elStyle.position = 'relative';

    var childStyle = el.firstElementChild.style;
    childStyle.cssText = 'left: 0; right: 0; top: ' + stickyTop + 'px; z-index: ' + zIndex + '; ' + childStyle.cssText;

    var active = false;

    var sticky = function sticky() {
      if (active) {
        return;
      }
      if (!elStyle.height) {
        elStyle.height = el.offsetHeight + 'px';
      }
      childStyle.willChange = 'transform';
      childStyle.position = 'fixed';
      active = true;
    };

    var reset = function reset() {
      if (!active) {
        return;
      }
      childStyle.position = 'absolute';
      active = false;
    };

    var check = function check() {
      var offsetTop = el.getBoundingClientRect().top;
      if (offsetTop <= stickyTop) {
        sticky();
        return;
      }
      reset();
    };

    listenAction = function listenAction() {
      if (!window.requestAnimationFrame) {
        return setTimeout(check, 16);
      }

      window.requestAnimationFrame(check);
      return null;
    };

    window.addEventListener('scroll', listenAction);
  },
  unbind: function unbind() {
    window.removeEventListener('scroll', listenAction);
  },
  update: function update(el, binding) {
    var params = binding.value || {};
    stickyTop = params.stickyTop || 0;
    zIndex = params.zIndex || 1000;

    var childStyle = el.firstElementChild.style;
    el.style.top = stickyTop + 'px';
    el.style.zIndex = zIndex;
    childStyle.top = el.style.top;
    childStyle.zIndex = el.style.zIndex;
  }
});

/***/ }),

/***/ "12bX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_payout_sushi_js__ = __webpack_require__("OoyY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32695aca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_payout_sushi_vue__ = __webpack_require__("SuF/");
function injectStyle (ssrContext) {
  __webpack_require__("13lc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_payout_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32695aca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_payout_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "13lc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1EIf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1F6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("UKic");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4f95c66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("fI94");
function injectStyle (ssrContext) {
  __webpack_require__("APZR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4f95c66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1FJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_rules_content_market_rules_content_vue__ = __webpack_require__("a7S9");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketRulesContent: __WEBPACK_IMPORTED_MODULE_4__components_market_market_rules_content_market_rules_content_vue__["a" /* default */]
  },
  props: {
    rules: String,
    dateEnd: String,
    market: {
      type: Object,
      required: true
    },
    emphasize: {
      type: Boolean,
      default: false
    },
    showExpanded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      expanded: this.showExpanded
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['isRulesOpen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    wrapperClass: function wrapperClass() {
      return {
        'market-rules__wrapper': true,
        'market-rules__wrapper--single': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* isMarketSingle */])(this.market)
      };
    },
    marginBoxClass: function marginBoxClass() {
      return {
        'market-rules__box': true,
        'market-rules__box--margin': true
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setGenericSmallPopup']), {
    showRulesPopup: function showRulesPopup() {
      this.setGenericSmallPopup({
        name: __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MARKET_RULES,
        options: {
          title: 'The Rules',
          market: this.market
        }
      });
    }
  }),
  mounted: function mounted() {
    if (this.emphasize) this.showRulesPopup();
  }
});

/***/ }),

/***/ "1KQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-list-desktop-header"},[_c('div',{staticClass:"market-list-desktop-header__title"},[_c('div',{staticClass:"market-list-desktop-header__text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c('span',{staticClass:"market-list-desktop-header__text--small"},[_vm._v("\n        "+_vm._s(_vm.count)+" Market"),(_vm.count !== 1)?[_vm._v("s")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"market-list-desktop-header__filters"},[(_vm.layout == 'grid')?_c('market-filters-desktop-grid',{attrs:{"embedded":_vm.embedded}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Lmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__ = __webpack_require__("Q+EN");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('chart', ['getContractChartData']), {
    createChart: function createChart(data) {
      var _this = this;

      if (data) {
        setTimeout(function () {
          _this.renderChart(data);
        }, __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__["f" /* PriceChangeChart */].renderTimeout());
      }
    },
    renderChart: function renderChart(data) {
      if (!this.$refs.chart) return;
      var chart = new __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__["f" /* PriceChangeChart */](this.contract, data);
      chart.draw(this.$refs.chart);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      contractId: this.contract.contractId
    };
    this.getContractChartData(payload).then(function (data) {
      return _this2.createChart(data);
    });
  }
});

/***/ }),

/***/ "1MKN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      require: false,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 0
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['keyboardDoubleSelected']), {
    text: function text() {
      return String(isNaN(this.value) || this.value === null ? '' : this.value);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['updateKeyboardDoubleSelected']), {
    buttonClick: function buttonClick(numberChar) {
      if (this.keyboardDoubleSelected) {
        this.updateKeyboardDoubleSelected(false);
        this.$emit('input', Number(numberChar));
        return;
      }
      if (numberChar === '0' && this.text === '') {
        return;
      }
      if (this.maxLength && this.maxLength <= this.text.length) {
        return;
      }
      var text = this.text + numberChar;
      this.$emit('input', Number(text));
    },
    backspaceClick: function backspaceClick() {
      if (this.keyboardDoubleSelected) {
        this.updateKeyboardDoubleSelected(false);
        this.$emit('input', null);
        return;
      }
      if (this.text.length > 0) {
        var text = this.text.substring(0, this.text.length - 1);
        if (text.length > 0) {
          this.$emit('input', Number(text));
        } else {
          this.$emit('input', null);
        }
      }
    },
    outsideClick: function outsideClick() {
      this.$emit('outsideClick');
    }
  })
});

/***/ }),

/***/ "1OjE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1P9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_detail_charts_js__ = __webpack_require__("1pzP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a068177_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_detail_charts_vue__ = __webpack_require__("H2VB");
function injectStyle (ssrContext) {
  __webpack_require__("o9eX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_detail_charts_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a068177_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_detail_charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Qpe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-table"},[_c('div',{staticClass:"leaderboards-table__row leaderboards-table__row--header"},[_c('div',{staticClass:"leaderboards-table__row-position"},[_vm._v("\n      Rank\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-change"},[_vm._v("\n      Change\n    ")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-profitable-predictions"},[_c('div',[_vm._v("Wins")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__info-icon",on:{"click":_vm.onWinsInfoClick}})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-roi"},[_c('div',[_vm._v("ROI")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__info-icon",on:{"click":_vm.onRoiInfoClick}})])]),_vm._v(" "),(_vm.showNoDataMessage)?_c('div',{staticClass:"leaderboards-table__no-data"},[_vm._v("\n    No data is available for this selection.\n  ")]):_vm._l((_vm.rows),function(item){return _c('div',{key:item.id,class:_vm.rowClassModifiers(item)},[_c('div',{staticClass:"leaderboards-table__row-position"},[_vm._v("\n        "+_vm._s(item.rank)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-trader",on:{"click":function($event){return _vm.onAvatarClick(item)}}},[_c('div',{staticClass:"leaderboards-table__row-trader-avatar"},[_c('account-social-avatar',{attrs:{"avatar":item.avatarImage,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.traderLevelColor(item),"showEdit":false,"theme":"leaderboards"}})],1),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-trader-info"},[_c('div',{staticClass:"leaderboards-table__row-trader-username"},[(_vm.isLayoutDesktop)?_c('span',[_vm._v(_vm._s(_vm._f("usernameDisplayLong")(item.userName)))]):_c('span',[_vm._v(_vm._s(_vm._f("usernameDisplay")(item.userName)))])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-trader-level"},[_vm._v("\n            "+_vm._s(_vm.traderLevelDisplay(item))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-change"},[(_vm.showRankChange(item))?_c('div',{staticClass:"leaderboards-table__row-change-wrap"},[_c('div',{staticClass:"leaderboards-table__row-change-number"},[_vm._v(_vm._s(Math.abs(item.rankChange)))]),_vm._v(" "),_c('div',{class:_vm.arrowChangeClassModifiers(item)})]):(item.rankChange === 0)?_c('div',{staticClass:"leaderboards-table__row-change-empty-value"},[_vm._v("\n          NC\n        ")]):_c('div',{staticClass:"leaderboards-table__row-change-empty-value"},[_vm._v("\n          New!\n        ")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-profitable-predictions"},[(item.wins)?[(_vm.isLayoutDesktop)?_vm._l((_vm.range(item.wins)),function(i){return _c('div',{key:i,staticClass:"leaderboards-table__trophy"})}):[_c('strong',[_vm._v(_vm._s(item.wins))]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__trophy"})]]:_c('hr',{staticClass:"leaderboards-table__dash"})],2),_vm._v(" "),_c('div',{class:_vm.roiModifiers(item)},[(item.roi >0)?[_vm._v("+")]:(item.roi <0)?[_vm._v("-")]:_vm._e(),_vm._v(_vm._s(_vm.traderRoiDisplay(item))+"\n      ")],2)])}),_vm._v(" "),(_vm.selectedLeaderboard)?[(_vm.leaderboardsResults.canLoadMore)?_c('infinite-loading',{key:_vm.infiniteLoadingKey,on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"leaderboards-table__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-table__row-trader"},[_c('div',{staticClass:"leaderboards-table__row-trader-menu"},[_vm._v("Trader")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1b1z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1gOo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDMwIDI1Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTI5Ljc4IDIuODY1YTEyLjE5IDEyLjE5IDAgMCAxLTMuNTEuOTYxIDYuMTI2IDYuMTI2IDAgMCAwIDIuNjg4LTMuMzhjLTEuMTguNy0yLjQ4OSAxLjIwOS0zLjg4IDEuNDgzQTYuMTA0IDYuMTA0IDAgMCAwIDIwLjYxOCAwYTYuMTEgNi4xMSAwIDAgMC01Ljk1MiA3LjUwMkExNy4zNDQgMTcuMzQ0IDAgMCAxIDIuMDczIDEuMTE4YTYuMDg0IDYuMDg0IDAgMCAwLS44MjggMy4wNzIgNi4xMSA2LjExIDAgMCAwIDIuNzE4IDUuMDg1IDYuMDY3IDYuMDY3IDAgMCAxLTIuNzY3LS43NjV2LjA3OGMwIDIuOTYgMi4xMDcgNS40MyA0LjkwMSA1Ljk5YTYuMDg4IDYuMDg4IDAgMCAxLTIuNzU5LjEwNiA2LjExNiA2LjExNiAwIDAgMCA1LjcwOCA0LjI0MyAxMi4yNTkgMTIuMjU5IDAgMCAxLTcuNTkgMi42MTVjLS40OTEgMC0uOTc5LS4wMjktMS40NTYtLjA4NmExNy4yODIgMTcuMjgyIDAgMCAwIDkuMzY1IDIuNzQ2YzExLjIzOCAwIDE3LjM4NC05LjMxIDE3LjM4NC0xNy4zODUgMC0uMjY0LS4wMDYtLjUyOC0uMDE4LS43OWExMi4zOSAxMi4zOSAwIDAgMCAzLjA1LTMuMTYyeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "1gXZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1l9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",class:_vm.classObject,on:{"click":_vm.hide}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hovered: false
    };
  },

  props: {
    text: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    layout: {
      type: String,
      default: ''
    },
    win: {
      default: null
    },
    sell: {
      default: null
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'button-price': true,
        'button-price--hovered': this.hovered
      }, 'button-price--' + this.layout, this.layout);
    },
    isWin: function isWin() {
      return this.win !== null;
    },
    isSell: function isSell() {
      return this.sell !== null && this.sell > 0;
    },
    showWinOrSell: function showWinOrSell() {
      return this.isLayoutDesktop && (this.isWin || this.isSell);
    },
    multiple: function multiple() {
      var result = 100 / this.price;
      var rounded = Math.round(result * 100) / 100;
      return rounded % 1 === 0 ? Math.round(rounded) : rounded;
    }
  }),
  methods: {
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    }
  }
});

/***/ }),

/***/ "1pzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INITIAL_MAX_CONTRACTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_market_market_detail_charts_container_container_vue__ = __webpack_require__("M8zO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_market_detail_charts_header_header_vue__ = __webpack_require__("4pyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_market_market_detail_charts_table_table_vue__ = __webpack_require__("ZJhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_market_detail_charts_timeline_timeline_vue__ = __webpack_require__("GebD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_market_contracts_stats_market_contracts_stats_vue__ = __webpack_require__("Y/q+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__("jPoG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_contentLoader__ = __webpack_require__("P71F");








 /* eslint-disable */














// const YES_CONTRACT_TYPE = 'Yes';
// const NO_CONTRACT_TYPE = 'No';
// const NO_CONTRACT_LINE_COLOR = '#F27130';
var MARKET_SINGLE_CONTRACT_NAME = 'Closing Price';
var INITIAL_SHOW_CONTRACTS = 3;
var INITIAL_MAX_CONTRACTS = 6;

var CHART_TYPES = {
  LINE: 'line',
  CANDLE: 'candle'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__mixins_contentLoader__["a" /* default */]],
  props: {
    market: {
      type: Object,
      required: false
    },
    chartOptions: {
      type: Object,
      default: null
    },
    theme: {
      type: String,
      default: ''
    },
    cache: {
      type: Boolean,
      default: false
    },
    chartSystemOptions: {
      type: Object,
      default: function _default() {}
    },
    suppressGlobalLoader: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var contractIds = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'contractIds', []) || [];

    return {
      hasMarketHiddenContracts: __WEBPACK_IMPORTED_MODULE_16__utils_helpers__["q" /* hasMarketHiddenContracts */],
      initialised: false,
      chartType: CHART_TYPES.LINE,
      preparedContractIds: null,
      toggled: false,
      disabledContracts: new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(),
      availableContractIds: contractIds,
      chartShowContractsInitial: contractIds.length > 0 ? contractIds.length : INITIAL_SHOW_CONTRACTS,
      chartMaxContracts: contractIds.length > 0 ? null : INITIAL_MAX_CONTRACTS,
      chartTimeline: null,
      chartDataLoaded: false,
      chartData: [],
      originalChartData: [],
      showStats: false,
      showVolume: false,
      showPriceAxisZoom: true
    };
  },

  components: {
    chartsContainer: __WEBPACK_IMPORTED_MODULE_10__components_market_market_detail_charts_container_container_vue__["a" /* default */],
    chartsHeader: __WEBPACK_IMPORTED_MODULE_11__components_market_market_detail_charts_header_header_vue__["a" /* default */],
    chartsTable: __WEBPACK_IMPORTED_MODULE_12__components_market_market_detail_charts_table_table_vue__["a" /* default */],
    chartsTimeline: __WEBPACK_IMPORTED_MODULE_13__components_market_market_detail_charts_timeline_timeline_vue__["a" /* default */],
    marketContractsStats: __WEBPACK_IMPORTED_MODULE_14__components_market_market_contracts_stats_market_contracts_stats_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('market', ['marketContractsStats']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
        'market-detail-charts': true
      }, 'market-detail-charts--' + this.theme, this.theme);
    },
    title: function title() {
      return __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'chartTitle', null);
    },
    caption: function caption() {
      return __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'chartCaption', null);
    },
    chartContracts: function chartContracts() {
      var results = [];
      var contractIdDataGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["r" /* groupByKeepOrder */])(this.chartData, 'contractId');

      // show contracts that represent selected point on time on the chart
      contractIdDataGroup.forEach(function (data) {
        results.push(data[data.length - 1]);
      });

      var marketContracts = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.market.contracts || this.market.marketContracts);
      return results.map(function (item) {
        var contract = marketContracts.find(function (i) {
          return i.contractId === item.contractId;
        }) || {};
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
          contractImageUrl: contract.contractImageUrl,
          contractImageSmallUrl: contract.contractImageSmallUrl
        });
      });
    },
    showChartsTable: function showChartsTable() {
      var noChartOptionOrLegendOn = this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'includeLegend', false);
      return this.chartContracts.length > 1 && noChartOptionOrLegendOn;
    },
    filteredChartData: function filteredChartData() {
      return this.chartData.filter(function (el) {
        return el.checked;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('chart', ['getMarketChartData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('market', ['getMarketContractsStats', 'clearMarketContractsStats']), {
    prepareDisabledContracts: function prepareDisabledContracts(data) {
      var _this = this;

      if (this.availableContractIds.length > 0) {
        this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(data, function (el) {
          return el.contractId;
        }).map(function (el) {
          return el.contractId;
        }).filter(function (i) {
          return !_this.availableContractIds.includes(i);
        }));
      } else {
        var results = [];
        var contractIdDataGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["r" /* groupByKeepOrder */])(data, 'contractId');
        // show contracts that represent selected point on time on the art
        contractIdDataGroup.forEach(function (groupData) {
          results.push(groupData[groupData.length - 1]);
        });

        results.forEach(function (el, index) {
          if (index >= _this.chartShowContractsInitial) {
            _this.disabledContracts.add(el.contractId);
          }
        });
      }
    },
    prepareChartData: function prepareChartData(source) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(source);
      var contractIds = this.availableContractIds.length > 0 ? this.availableContractIds : __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(data, function (el) {
        return el.contractId;
      }).map(function (el) {
        return el.contractId;
      });

      var isYesNoMarket = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["j" /* isMarketSingle */])(this.market);
      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default()(contractIds, this.preparedContractIds)) {
        this.prepareDisabledContracts(data);
        this.preparedContractIds = contractIds;
      }

      data.forEach(function (el) {
        el.additional = false;
        el.checked = _this2.checkIsContractEnabled(el);
        el.chartPrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* regularContractPrice */])(el);

        if (isYesNoMarket) {
          el.contractName = MARKET_SINGLE_CONTRACT_NAME;
        }
      });

      return data;
    },
    checkIsContractEnabled: function checkIsContractEnabled(el) {
      return !this.disabledContracts.has(el.contractId);
    },
    getChartLoaderTarget: function getChartLoaderTarget() {
      return this.$refs.chartLoadingScope || this.$el;
    },
    beginChartRequestLoad: function beginChartRequestLoad() {
      if (this.suppressGlobalLoader) {
        this.loaderAddLegacy(this.getChartLoaderTarget());
        return;
      }
      this.loaderAdd();
    },
    endChartRequestLoad: function endChartRequestLoad() {
      if (this.suppressGlobalLoader) {
        this.loaderRemoveLegacy(this.getChartLoaderTarget());
        return;
      }
      this.loaderRemove();
    },
    loadStats: function loadStats() {
      var _this3 = this;

      this.beginChartRequestLoad();
      this.getMarketContractsStats(this.market.marketId).then(function () {
        return _this3.endChartRequestLoad();
      }).catch(function () {
        return _this3.endChartRequestLoad();
      });
    },
    loadChartData: function loadChartData(_ref2) {
      var _this4 = this;

      var _ref2$useOriginalData = _ref2.useOriginalData,
          useOriginalData = _ref2$useOriginalData === undefined ? false : _ref2$useOriginalData;

      if (useOriginalData) {
        this.chartData = this.prepareChartData(this.originalChartData);
      } else {
        var params = {
          marketId: this.market.marketId,
          maxContracts: this.chartMaxContracts,
          timespan: this.chartTimeline
        };
        var storyId = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'cmsStoryId', null);
        if (storyId) {
          params.storyId = storyId;
          params.chartStoryVersionId = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'cmsVersionId', null);
          params.regionUUID = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'regionUUID', null);
          params.sectionType = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'sectionType', null);
        }
        this.beginChartRequestLoad();
        this.getMarketChartData({ params: params, cache: this.cache }).then(function (data) {
          _this4.originalChartData = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
          _this4.chartData = _this4.prepareChartData(_this4.originalChartData);
          _this4.endChartRequestLoad();
          if (_this4.chartData.length === 0 && !_this4.initialised) {
            _this4.$emit('no-data');
          }
          _this4.chartDataLoaded = true;
          _this4.isComponentReady = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["s" /* isHighChartsReady */])();
          _this4.initialised = true;
        }).catch(function (e) {
          console.error('Chart error', e);
          _this4.initialised = true;
          _this4.endChartRequestLoad();
        });
      }
    },
    onShowKey: function onShowKey() {
      this.toggled = true;
    },
    volumeChartToggle: function volumeChartToggle(value) {
      this.showVolume = value;
    },
    priceAxisZoomToggle: function priceAxisZoomToggle(value) {
      this.showPriceAxisZoom = value;
    },
    onTimelineChange: function onTimelineChange(timeline) {
      if (timeline === 'stats') {
        this.showStats = true;
        this.loadStats();
      } else {
        this.showStats = false;
        this.chartTimeline = timeline;
        this.loadChartData({});
      }
    },
    onTypeChange: function onTypeChange(type) {
      var _this5 = this;

      this.chartType = type;

      if (type === CHART_TYPES.CANDLE && this.chartData) {
        var contracts = __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(this.chartData, function (el) {
          return el.contractId;
        });
        var enabled = contracts.find(function (i) {
          return _this5.checkIsContractEnabled(i);
        }) || contracts[0];
        var contractIds = contracts.map(function (i) {
          return i.contractId;
        }).filter(function (i) {
          return i !== enabled.contractId;
        });
        this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(contractIds);
        this.loadChartData({ useOriginalData: true });
      }
    },
    onContractToggle: function onContractToggle(item, checked) {
      var contractId = item.contractId;
      // const contractsNum = Math.min(this.market.contracts.length, INITIAL_MAX_CONTRACTS);
      // const disabledContractsMaxSize = contractsNum;

      if (this.chartType === CHART_TYPES.CANDLE) {
        if (!checked) {
          this.disabledContracts.add(contractId);
        } else {
          var contractIds = __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(this.chartData, function (el) {
            return el.contractId;
          }).map(function (i) {
            return i.contractId;
          }).filter(function (i) {
            return i !== contractId;
          });
          this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(contractIds);
        }
      } else {
        if (!checked) {
          this.disabledContracts.add(contractId);
        } else {
          this.disabledContracts.delete(contractId);
        }
      }

      this.loadChartData({ useOriginalData: true });
    }
  }),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_18__logger__["a" /* default */].info('[CHART] Rendering chart: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.chartOptions || {}) + ' for ' + this.market.marketId);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearMarketContractsStats();
  }
});

/***/ }),

/***/ "1ri1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_withdraw_js__ = __webpack_require__("eWdu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec1211e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_withdraw_vue__ = __webpack_require__("UGnQ");
function injectStyle (ssrContext) {
  __webpack_require__("8a1C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_withdraw_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec1211e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_withdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1vcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contracts_history_contracts_history_vue__ = __webpack_require__("uath");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_export_history_export_history_vue__ = __webpack_require__("cgtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_history_trades_history_filters_history_filters_vue__ = __webpack_require__("aoNs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_loader__ = __webpack_require__("39kf");












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_loader__["a" /* default */]],
  props: {
    showExport: Boolean
  },
  components: {
    contractsHistory: __WEBPACK_IMPORTED_MODULE_4__components_contracts_history_contracts_history_vue__["a" /* default */],
    exportHistory: __WEBPACK_IMPORTED_MODULE_5__components_export_history_export_history_vue__["a" /* default */],
    historyFilters: __WEBPACK_IMPORTED_MODULE_6__components_account_history_trades_history_filters_history_filters_vue__["a" /* default */]
  },
  data: function data() {
    return {
      activeFilter: null,
      marketId: undefined,
      recent: true,
      isOpen: false,
      loading: null,
      ready: false
    };
  },
  created: function created() {
    this.debouncedDoLoading = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(this.doLoading, 300);
  },

  watch: {
    activeFilter: function activeFilter(val) {
      if (val) {
        this.debouncedDoLoading(val.marketId);
      }
    },

    $route: {
      handler: 'routeHandler',
      immediate: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['market']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('profile', ['tradeHistory', 'marketHistory', 'tradedMarkets']), {
    showMessage: function showMessage() {
      return !this.isLoading && this.$route.params.marketId && this.$route.params.marketId !== 'all' && this.market.marketId && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    filteredContracts: function filteredContracts() {
      if (this.activeFilter) {
        // to not show old data while loading new
        return this.activeFilter.marketId !== this.marketHistory.marketId ? [] : this.marketHistory.data;
      }
      // whole trade history
      return this.tradeHistory.data;
    },
    canLoadMore: function canLoadMore() {
      return this.activeFilter ? this.marketHistory.canLoadMore : this.tradeHistory.canLoadMore;
    },
    showMarketNames: function showMarketNames() {
      return this.activeFilter === null;
    },
    isExportAvailable: function isExportAvailable() {
      return this.showExport;
      // this.tradeHistory &&
      // this.tradeHistory.data &&
      // this.tradeHistory.data.length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('profile', ['getTradeHistory', 'getTradedMarkets']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getMarket', 'clearMarket']), {
    routeHandler: function routeHandler(route) {
      var _this = this;

      var marketId = route.params.marketId;
      var isAll = marketId === 'all';
      var isEmpty = !marketId;
      this.loaderAdd(document.body);

      if (marketId && !isAll) {
        this.marketId = Number(marketId);
      } else if (isAll) {
        this.marketId = 'all';
      } else {
        this.marketId = undefined;
      }

      this.getTradedMarkets({ cache: true }).then(function (val) {
        if (_this.marketId) {
          var marketFilter = val.find(function (o) {
            return o.marketId === _this.marketId;
          });
          if (marketFilter) {
            _this.activeFilter = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, marketFilter);
          }
        }
      }).then(function () {
        if (marketId && !isAll) {
          _this.clearMarket();
          return _this.getMarket({ marketId: _this.marketId });
        } else if (isAll) {
          _this.clearMarket();
          return _this.getTradeHistory();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});
      }).then(function () {
        _this.loaderRemove(document.body);
        _this.isOpen = isAll;
        _this.recent = isEmpty;
        if (isEmpty || isAll) {
          _this.activeFilter = null;
        }
        _this.ready = true;
      });
    },
    loadHistory: function loadHistory() {
      var _this2 = this;

      if (this.activeFilter) {
        if (this.loading !== this.activeFilter.marketId) {
          this.debouncedDoLoading(this.activeFilter.marketId);
        }
      } else if (this.canLoadMore) {
        if (this.isLayoutMobile) {
          this.loaderAdd(document.body);
        }
        this.getTradeHistory().then(function () {
          if (_this2.isLayoutMobile) {
            _this2.loaderRemove(document.body);
          }
        }).catch(function () {
          if (_this2.isLayoutMobile) {
            _this2.loaderRemove(document.body);
          }
        });
      }
    },
    modalExport: function modalExport() {
      this.$emit('export', 'trades');
    },
    doLoading: function doLoading(marketId) {
      var _this3 = this;

      if (this.loading !== marketId) {
        this.loading = marketId;
        var contractId = (this.$route.query || {}).contractId;
        var payload = { marketId: marketId };
        if (contractId) {
          payload.contractId = contractId;
        }
        if (this.isLayoutMobile) {
          this.loaderAdd(document.body);
        }
        return this.getTradeHistory(payload).then(function () {
          _this3.loading = null;
          if (_this3.isLayoutMobile) {
            _this3.loaderRemove(document.body);
          }
        }).catch(function () {
          if (_this3.isLayoutMobile) {
            _this3.loaderRemove(document.body);
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.clearMarket();
    if (this.debouncedDoLoading) {
      this.debouncedDoLoading.cancel();
    }
  }
});

/***/ }),

/***/ "1wil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-leaderboards"},[(_vm.isLayoutDesktop)?[_c('div',{staticClass:"page-leaderboards__no-scroll"}),_vm._v(" "),_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-4 page-leaderboards__sticky"},[_c('leaderboards-levels',[_c('leaderboards-toolbar')],1),_vm._v(" "),_c('div',{staticClass:"page-leaderboards__note"},[_vm._v("\n          Leaderboards are updated nightly.\n        ")]),_vm._v(" "),(_vm.isLoggedIn && _vm.isUserVerified)?_c('share-invite-widget',{staticClass:"page-leaderboards__share"}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column small-12 large-8"},[_c('leaderboards-table')],1)])]:[(!_vm.selectedLeaderboard)?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12"},[_c('leaderboards-levels'),_vm._v(" "),_c('div',{staticClass:"page-leaderboards__note"},[_vm._v("\n          Leaderboards are updated nightly\n        ")]),_vm._v(" "),(_vm.isLoggedIn && _vm.isUserVerified)?_c('share-invite-widget',{staticClass:"page-leaderboards__share"}):_vm._e()],1)]):[_c('div',{staticClass:"page-leaderboards__toolbar"},[_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12"},[_c('leaderboards-toolbar',{attrs:{"backButton":true},on:{"back":_vm.onBackClick}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('leaderboards-table')],1)])])]]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1zuO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', 'button--large', 'button--submit', 'button--full-width', { 'button--loading': _vm.loading } ],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.label))]):_c('span',{staticClass:"button__spinner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2+il":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__market_key_stats_element_market_key_stats_element_vue__ = __webpack_require__("GVWc");





function getOrderMobile(arr) {
  var odd = [];
  var even = arr.reduce(function (prev, curr, idx) {
    if (idx % 2) {
      odd.push(curr);
      return prev;
    }
    prev.push(curr);
    return prev;
  }, []);
  return even.concat(odd);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  props: {
    widget: Object
  },
  components: {
    marketKeyStatsElement: __WEBPACK_IMPORTED_MODULE_3__market_key_stats_element_market_key_stats_element_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    items: function items() {
      if (!this.widget) {
        return [];
      }
      return this.isLayoutMobile ? getOrderMobile(this.widget.widgetKeyStats) : this.widget.widgetKeyStats;
    }
  }),
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  methods: {},
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "2/KR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "21Oa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.isColumnCountExceeding)?_c('alert-box',{staticClass:"page-story-preview__box",attrs:{"level":"warning"}},[_vm._v("\n    Column setup appears to be invalid (either exceeds 100% or content column broke to next row).\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row row-xy page-story-preview__controls-row"},[_c('div',{staticClass:"column small-12 medium-4"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Left Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.left),callback:function ($$v) {_vm.$set(_vm.columnChoice, "left", $$v)},expression:"columnChoice.left"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Preview","options":_vm.TYPE_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.typeChoice),callback:function ($$v) {_vm.typeChoice=$$v},expression:"typeChoice"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Right Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.right),callback:function ($$v) {_vm.$set(_vm.columnChoice, "right", $$v)},expression:"columnChoice.right"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row page-story-preview__content-row"},[_c('div',{class:[_vm.leftColumnClasses, 'page-story-preview__content-column']},[_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{class:[_vm.middleColumnClasses, 'page-story-preview__content-column']},[(!_vm.isDetailMode && _vm.selectedHomepageSection)?_c('story-preview-homepage-surface',{key:_vm.homepageSurfaceKey,attrs:{"story-section":_vm.selectedHomepageSection,"preview-mode":_vm.typeChoice.value}}):(_vm.isDetailMode && _vm.selectedDetailData)?_c('story-preview-detail-surface',{key:_vm.detailSurfaceKey,attrs:{"detail-data":_vm.selectedDetailData}}):_vm._e()],1),_vm._v(" "),_c('div',{class:[_vm.rightColumnClasses, 'page-story-preview__content-column']},[_vm._v("\n       \n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "21pt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_animated_number_js__ = __webpack_require__("DsFz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d7163a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_animated_number_vue__ = __webpack_require__("yoSF");
function injectStyle (ssrContext) {
  __webpack_require__("XyfZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_animated_number_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d7163a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_animated_number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "220P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_story_preview_js__ = __webpack_require__("81Xy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394cd820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_story_preview_vue__ = __webpack_require__("21Oa");
function injectStyle (ssrContext) {
  __webpack_require__("oiU4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_story_preview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394cd820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_story_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "22Ot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    email: {
      type: String,
      required: false
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), {
    onLogin: function onLogin() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
      this.setCurrentPopupOptions({ email: this.email });
    }
  })
});

/***/ }),

/***/ "283W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"research",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "28Cy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNhKSI+CiAgICAgICAgPHBhdGggZD0iTTkuNTMzIDguMTJhLjE2Ny4xNjcgMCAwIDEgMC0uMjM2bDYuMTc2LTYuMTc1QTEgMSAwIDEgMCAxNC4yOTMuMjk1TDguMTE4IDYuNDY3YS4xNjcuMTY3IDAgMCAxLS4yMzYgMEwxLjcwNy4yOTVBMSAxIDAgMCAwIC4yOTMgMS43MWw2LjE3NCA2LjE3NWEuMTY3LjE2NyAwIDAgMSAwIC4yMzZMLjI5MyAxNC4yOTVhMSAxIDAgMCAwIDEuNDE0IDEuNDE0bDYuMTc1LTYuMTc1YS4xNjcuMTY3IDAgMCAxIC4yMzYgMGw2LjE3NSA2LjE3NWExIDEgMCAwIDAgMS40MTQtMS40MTRMOS41MzMgOC4xMnoiIGZpbGw9IiM1NTU3NUEiLz4KICAgIDwvZz4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iYSI+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTZ2MTZIMHoiLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgo8L3N2Zz4K"

/***/ }),

/***/ "2A6V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {},
    market: {},
    handleJourneyOpened: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'hasMaintenance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    classModifiers: function classModifiers() {
      var isPurchaseJourneyOpened = this.handleJourneyOpened && this.tradeOptions.contractId === this.contract.contractId;

      return {
        'market-disabled-outcome-v2': true,
        'market-disabled-outcome-v2--settled': this.isMarketSettled,
        'market-disabled-outcome-v2--journey-opened': isPurchaseJourneyOpened,
        'market-disabled-outcome-v2--journey-opened--yes': isPurchaseJourneyOpened && this.tradeOptions.operationValue === 'yes',
        'market-disabled-outcome-v2--journey-opened--no': isPurchaseJourneyOpened && this.tradeOptions.operationValue === 'no'
      };
    },
    iconClassModifiers: function iconClassModifiers() {
      return {
        'market-disabled-outcome-v2__icon': true,
        'market-disabled-outcome-v2__icon--yes': this.isMarketSettled && this.isWinnerYes,
        'market-disabled-outcome-v2__icon--no': this.isMarketSettled && this.isWinnerNo
      };
    },
    buttonText: function buttonText() {
      if (this.isMarketSettled) {
        if (this.contract.settledStatus === 1) {
          return 'Yes';
          // this.contract.payoutType === 0
        } else if (this.contract.settledStatus === 2) {
          return 'No';
        }
        return 'N/A';
      }
      if (this.hasMaintenance) {
        return 'Trading Paused';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["z" /* isMarketExpired */])(this.market)) {
        return this.isLayoutMobile ? 'Pending' : 'Pending Settlement';
      }

      return this.market.status;
    },
    isWinnerYes: function isWinnerYes() {
      // this.contract.payoutType === 1
      return this.contract.settledStatus === 1;
    },
    isWinnerNo: function isWinnerNo() {
      // this.contract.payoutType === 0
      return this.isMarketSingle && this.contract.settledStatus === 2;
    }
  })
});

/***/ }),

/***/ "2Fyx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2HMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposited"},[_c('div',{staticClass:"row"},[(_vm.currentDeposit.account && _vm.currentDeposit.matched > 0)?[_c('div',{class:_vm.leftColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Transferred")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.amountFormatted)}})]),_vm._v(" "),(_vm.hasPromotionalCredit)?_c('div',{staticClass:"small-4 column deposited__divider"},[_c('div',{staticClass:"deposited__title deposited__title--small"},[(_vm.isLayoutDesktop)?[_vm._v("\n            Promotional Credit\n          ")]:[_vm._v("\n            Credit\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.matchedFormatted)}})]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.rightColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Available")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small"},[_vm._v(_vm._s(_vm.balance.accountBalance))])])]:[_c('div',{class:_vm.leftColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Deposited")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.amountFormatted)}})]),_vm._v(" "),(_vm.hasPromotionalCredit)?_c('div',{staticClass:"small-4 column deposited__divider"},[_c('div',{staticClass:"deposited__title deposited__title--small"},[(_vm.isLayoutDesktop)?[_vm._v("\n            Promotional Credit\n          ")]:[_vm._v("\n            Credit\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.promoAmountFormatted)}})]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.rightColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Available")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small"},[_vm._v(_vm._s(_vm.balance.accountBalance))])])],_vm._v(" "),_c('div',{staticClass:"column small-12"},[(_vm.currentDeposit.account)?_c('div',{staticClass:"deposited__confirmation-number",domProps:{"innerHTML":_vm._s(_vm.currentDeposit.messageForUser)}}):_c('div',{staticClass:"deposited__confirmation-number"},[_vm._v("\n        Your confirmation number for this transaction is "+_vm._s(_vm.currentDeposit.confirmationNumber)+".\n      ")])]),_vm._v(" "),(_vm.currentDeposit.account)?_c('div',{staticClass:"column small-12"},[_c('bank-account',{staticClass:"deposited__account",attrs:{"preview":true,"account":_vm.currentDeposit.account}})],1):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Kdh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2KqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:_vm.classModifiers,on:{"click":_vm.handleSecretTap}},[_c('transition',{attrs:{"name":"footer-expand"},on:{"enter":_vm.onFooterExpandEnter,"after-enter":_vm.onFooterExpandStopFrame,"enter-cancelled":_vm.onFooterExpandStopFrame}},[(_vm.isLayoutMobile || _vm.expanded)?_c('div',{staticClass:"footer__top"},[_c('div',{staticClass:"footer__top-content"},[_c('div',{staticClass:"row row-y footer__row"},[_c('div',{staticClass:"column small-12 medium-12 large-4"},[_c('router-link',{staticClass:"footer__logo",attrs:{"to":{name: 'home'},"tag":"div"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-12 large-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12 medium-4"},[_c('div',{class:_vm.sectionClassModifiers('engage'),on:{"click":function($event){return _vm.toggleSection('engage')}}},[_vm._v("\n                  Engage\n                ")]),_vm._v(" "),_c('div',{staticClass:"footer__section-divider"}),_vm._v(" "),(_vm.isSectionVisible('engage'))?[_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'market-list' }}},[_vm._v("\n                    Markets\n                  ")]),_vm._v(" "),_c('a',{staticClass:"footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleSearchBar($event)}}},[_vm._v("Search")]),_vm._v(" "),(_vm.leaderboardsEnabled)?_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'leaderboards' }}},[_vm._v("\n                    Leaderboards\n                  ")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('div',{class:_vm.sectionClassModifiers('learn'),on:{"click":function($event){return _vm.toggleSection('learn')}}},[_vm._v("\n                  Support\n                ")]),_vm._v(" "),_c('div',{staticClass:"footer__section-divider"}),_vm._v(" "),(_vm.isSectionVisible('learn'))?[_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'WhatIsPredictIt' }}},[_vm._v("\n                    About\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'sitemap' }}},[_vm._v("\n                    Site Map\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'HelpAndSupport' }}},[_vm._v("\n                    Support\n                  ")])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('div',{class:_vm.sectionClassModifiers('legal'),on:{"click":function($event){return _vm.toggleSection('legal')}}},[_vm._v("\n                  Legal\n                ")]),_vm._v(" "),_c('div',{staticClass:"footer__section-divider"}),_vm._v(" "),(_vm.isSectionVisible('legal'))?[_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'terms-and-conditions' }}},[_vm._v("\n                    Terms And Conditions\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v("\n                    Privacy\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'accessibility-statement' }}},[_vm._v("\n                    Accessibility Statement\n                  ")])]:_vm._e()],2)])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"footer__bottom"},[(_vm.isLayoutDesktop)?_c('div',{staticClass:"footer__bottom-content"},[_c('div',{staticClass:"footer__bottom-details",on:{"click":_vm.onDetailsToggle}},[_c('div',[_vm._v("\n          Details\n        ")]),_vm._v(" "),_c('div',{class:_vm.footerBottomChevronModifiers})]),_vm._v(" "),_c('div',{staticClass:"footer__links"},[_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'market-list' }}},[_vm._v("\n          Markets\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'news-stories' }}},[_vm._v("\n          News\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'HelpAndSupport' }}},[_vm._v("\n          Support\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'platform-announcements' }}},[_vm._v("\n          Announcements\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"footer__bottom-side-nav"},[_c('div',{staticClass:"footer__bottom-copy"},[_vm._v("\n          The Truth Machine © "+_vm._s((new Date()).getFullYear())+" "),_c('brand-name'),_vm._v(". All rights reserved.\n        ")],1),_vm._v(" "),_c('div',{staticClass:"footer__logos"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"footer__logo-item"},[_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":item.href,"title":item.title}},[_c('img',{attrs:{"src":item.icon}})])])}),0)])]):_c('div',{staticClass:"footer__bottom-content"},[_c('div',{staticClass:"footer__links"},[_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'market-list' }}},[_vm._v("\n          Markets\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'news-stories' }}},[_vm._v("\n          News\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'HelpAndSupport' }}},[_vm._v("\n          Support\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'platform-announcements' }}},[_vm._v("\n          Announcements\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"footer__logos"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"footer__logo-item"},[_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":item.href,"title":item.title}},[_c('img',{attrs:{"src":item.icon}})])])}),0),_vm._v(" "),_c('div',{staticClass:"footer__bottom-copy"},[_vm._v("\n        The Truth Machine\n      ")]),_vm._v(" "),_c('div',{staticClass:"footer__bottom-copy"},[_vm._v("\n         © "+_vm._s((new Date()).getFullYear())+" "),_c('brand-name'),_vm._v(". All rights reserved.\n      ")],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2LR/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2N1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sold_bought_at_js__ = __webpack_require__("cbPA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3f5a31_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sold_bought_at_vue__ = __webpack_require__("7Nf+");
function injectStyle (ssrContext) {
  __webpack_require__("776K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sold_bought_at_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3f5a31_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sold_bought_at_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Pqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connect; });
/* unused harmony export addListener */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addOrderBookListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearOrderBookListeners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setupMessaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cleanupMessaging; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__ = __webpack_require__("GZXJ");

/* eslint-disable */






var MESSAGING_TOKEN_FLAG_NAME = 'firebase-token-sent';
var MESSAGING_TOKEN_EXPIRES_AT = 31536000;
var REF_ORDER_BOOK = 'contractOrderBook';
var REF_MARKETS = 'marketStats';
var REF_CONTRACTS = 'contractStats';

var EVENT_ADDED = 'child_added';
var EVENT_CHANGED = 'child_changed';
var EVENT_INIT = 'value';

var DATA_METHOD = 'update';
var DATA_MARKETS = 'market_data';
var DATA_CONTRACTS = 'contract_data';

var setSentTokenFlag = function setSentTokenFlag(flag) {
  return __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set(MESSAGING_TOKEN_FLAG_NAME, flag, MESSAGING_TOKEN_EXPIRES_AT);
};
var sendTokenToServer = function sendTokenToServer(token) {
  if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn']) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'sendTokenToServer skipped', 'User is not logged in');
    return;
  }

  var isTokenSent = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get(MESSAGING_TOKEN_FLAG_NAME, false);
  if (isTokenSent) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'sendTokenToServer skipped', 'Token was already sent');
    return;
  }

  __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.putMessagingToken(token).then(function () {
    return setSentTokenFlag(true);
  }).catch(function () {
    return setSentTokenFlag(false);
  });
};

var connect = function connect() {
  var apiToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var listenerOptions = arguments[1];

  var isAnonymous = apiToken === null;
  var config = {
    apiKey: "AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA",
    authDomain: "predictit-f497e.firebaseapp.com",
    databaseURL: "https://predictit-f497e.firebaseio.com",
    projectId: "predictit-f497e",
    messagingSenderId: "76708845910",
    appId: "1:76708845910:web:a2746a4abbe584b1911ef7"
  };
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'init', 'anonymous mode: ' + isAnonymous, config);
  if (window.firebase.apps.length > 0) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'reinitializing app');
    window.firebase.app().delete().then(function () {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'reinitialized app succesfully');
      try {
        window.firebase.initializeApp(config);
      } catch (e) {}
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setFirebaseInitialized', true);
      addListener(listenerOptions);
    });
  } else {
    try {
      window.firebase.initializeApp(config);
    } catch (e) {}
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setFirebaseInitialized', true);
    addListener(listenerOptions);
  }
};

var triggerUpdate = function triggerUpdate(_ref) {
  var _ref$loaded = _ref.loaded,
      loaded = _ref$loaded === undefined ? false : _ref$loaded,
      callback = _ref.callback,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? DATA_METHOD : _ref$method,
      name = _ref.name,
      data = _ref.data;

  if (loaded) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', method + ' of ' + name + ' with ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    callback(method, name, data);
  } else {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'skipping ' + method + ' of ' + name);
  }
};

var addOrderBookListener = function addOrderBookListener(contractId, listener) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  /* so initial snapshot is ignored -it should come from API */
  var loaded = false;
  var orderBook = window.firebase.database().ref(REF_ORDER_BOOK + '/' + contractId);
  orderBook.on(EVENT_INIT, function (snapshot) {
    var data = snapshot.val();
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn'] && !loaded) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'skipping initial order book update ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    } else if (data) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'update order book ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      listener(data);
    } else if (defaultValue !== null) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'update order book with default value');
      listener(defaultValue);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'order book is empty');
    }
    loaded = true;
  });
};

var clearOrderBookListeners = function clearOrderBookListeners(contractId) {
  try {
    window.firebase.database().ref(REF_ORDER_BOOK + '/' + contractId).off();
  } catch (e) {}
};

var addListener = function addListener(options) {
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'adding listener');
  var _options$onUpdate = options.onUpdate,
      onUpdate = _options$onUpdate === undefined ? function () {
    return null;
  } : _options$onUpdate;

  var marketDataLoaded = false;
  var contractDataLoaded = false;

  var markets = window.firebase.database().ref(REF_MARKETS).orderByChild('TimeStamp').startAt((+new Date() / 1000).toFixed(5).toString());
  markets.on(EVENT_ADDED, function (data) {
    triggerUpdate({
      loaded: marketDataLoaded,
      callback: onUpdate,
      name: DATA_MARKETS,
      data: data.val()
    });
  });
  markets.on(EVENT_CHANGED, function (data) {
    triggerUpdate({
      loaded: marketDataLoaded,
      callback: onUpdate,
      name: DATA_MARKETS,
      data: data.val()
    });
  });
  markets.once(EVENT_INIT, function () {
    marketDataLoaded = true;
  });

  var contracts = window.firebase.database().ref(REF_CONTRACTS).orderByChild('TimeStamp').startAt((+new Date() / 1000).toFixed(5).toString());

  contracts.on(EVENT_ADDED, function (data) {
    triggerUpdate({
      loaded: contractDataLoaded,
      callback: onUpdate,
      name: DATA_CONTRACTS,
      data: data.val()
    });
  });
  contracts.on(EVENT_CHANGED, function (data) {
    triggerUpdate({
      loaded: contractDataLoaded,
      callback: onUpdate,
      name: DATA_CONTRACTS,
      data: data.val()
    });
  });
  contracts.once(EVENT_INIT, function () {
    contractDataLoaded = true;
  });
};

var setupMessaging = function setupMessaging() {
  if (__WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["c" /* isAndroid */] || __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["b" /* isIos */] || __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["e" /* isIE */]) return;

  var messaging = window.firebase.messaging();
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'setting up messaging');
  messaging.requestPermission().then(function (data) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'permission granted', data);
    messaging.getToken().then(function (token) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'messaging token received');
      if (token) {
        sendTokenToServer(token);
      } else {
        setSentTokenFlag(false);
      }
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting token', error);
      setSentTokenFlag(false);
    });
    messaging.onTokenRefresh(function () {
      messaging.getToken().then(function (token) {
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'messaging token refreshed');
        if (token) {
          setSentTokenFlag(false);
          sendTokenToServer(token);
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting refresh token', error);
        setSentTokenFlag(false);
      });
    });
  }).catch(function (error) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting permission', error);
  });
};

var cleanupMessaging = function cleanupMessaging() {
  return __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del(MESSAGING_TOKEN_FLAG_NAME);
};



/***/ }),

/***/ "2Q+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-invite-friends"},[_c('div',{staticClass:"sushi-invite-friends__content"},[_c('share-invite-widget')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2SRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_search__ = __webpack_require__("+ZRi");





var SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_search__["a" /* default */]],
  props: {
    theme: {
      type: String,
      default: 'default'
    }
  },
  data: function data() {
    return {
      focused: false,
      searchQuery: '',
      searchFor: '',
      searchTotal: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('search', ['searchBarVisible']), {
    show: function show() {
      return this.theme === 'default' && this.searchBarVisible || this.theme !== 'default';
    },
    showSummary: function showSummary() {
      return this.searchTotal === 0;
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'search-bar': true
      }, 'search-bar--' + this.theme, this.theme);
    },
    summaryClassModifiers: function summaryClassModifiers() {
      return {
        'search-bar__summary': true,
        'search-bar__summary--no-results': !this.searchTotal
      };
    },
    inputClassModifiers: function inputClassModifiers() {
      return {
        'search-bar__input': true,
        'search-bar__input--focused': this.focused
      };
    }
  }),
  watch: {
    $route: function $route() {
      if (this.show) {
        this.onClose();
      }
    },
    show: function show(value) {
      var _this = this;

      if (value) {
        setTimeout(function () {
          _this.$refs.searchInput.focus();
        }, SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('app', ['toggleMobileMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('search', ['toggleSearchBar']), {
    handleFocus: function handleFocus() {
      this.focused = true;
    },
    handleBlur: function handleBlur() {
      this.focused = false;
    },
    onSearchResults: function onSearchResults(data) {
      if (data.totalMarkets > 0) {
        // close when there are results
        this.onClose();
      } else if (this.theme === 'menu') {
        this.toggleMobileMenu();
      }
      this.searchTotal = data.totalMarkets;
    },
    onClose: function onClose() {
      if (this.theme === 'default') {
        this.toggleSearchBar();
      } else if (this.theme === 'menu') {
        this.toggleMobileMenu();
      }
      this.searchFor = '';
      this.searchQuery = '';
      this.searchTotal = null;
    },
    onSubmit: function onSubmit() {
      this.searchTotal = null;
      if (this.searchQuery === '') return;
      this.searchFor = this.searchQuery;
      this.doSearch(this.searchQuery);
    }
  })
});

/***/ }),

/***/ "2YJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-table-view"},[_c('table',{staticClass:"document-table-view__table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.documentData.displayDocuments),function(document,index){return _c('tr',{key:index,class:_vm.rowClassModifiers(document, index),on:{"click":function($event){return _vm.onOpen(document, index)}}},[_c('td',[_vm._v("\n          "+_vm._s(document.displayDocumentTitle)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(document.displayDocumentDescription)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.parseDate(document))+"\n        ")])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Date")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ZYw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2evg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-trophy-pyramid"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("1 to 99")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("100 to 999")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("1,000 to 9,999")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("10,000 to 99,999")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("100,000 and over")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2gZh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2iQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bottom_market_links_widget_js__ = __webpack_require__("Ju06");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd29611_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_market_links_widget_vue__ = __webpack_require__("4b+g");
function injectStyle (ssrContext) {
  __webpack_require__("cwNw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bottom_market_links_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd29611_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_market_links_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2uhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderboardsInfoLoader_vue__ = __webpack_require__("OIwd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46dc6efc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderboardsInfoLoader_vue__ = __webpack_require__("Uepp");
function injectStyle (ssrContext) {
  __webpack_require__("PQLn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderboardsInfoLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46dc6efc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderboardsInfoLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2uxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-requirements"},[_c('p',{staticClass:"password-requirements__label"},[_vm._v("Minimum password requirements")]),_vm._v(" "),_c('div',{staticClass:"password-requirements__req"},[_c('form-checkbox',{staticClass:"password-requirements__6plus",attrs:{"name":"password-requirements-min-length","label":"6+characters","disabled":true,"checked":this.validation.minLength,"small":true}}),_vm._v(" "),_c('form-checkbox',{staticClass:"password-requirements__letter",attrs:{"name":"password-requirements-lower","label":"Upper & Lower Case","disabled":true,"checked":_vm.hasOneUpperLower,"small":true}}),_vm._v(" "),_c('form-checkbox',{staticClass:"password-requirements__digit",attrs:{"name":"password-requirements-digit","label":"Number","disabled":true,"checked":this.validation.hasOneDigit,"small":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2wse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "2zfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_side_notification_js__ = __webpack_require__("4RVP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0906cade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_notification_vue__ = __webpack_require__("0AWQ");
function injectStyle (ssrContext) {
  __webpack_require__("CfET")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_side_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0906cade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "32Fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    layout: {
      type: String,
      default: ''
    },
    marketId: {
      type: Number
    },
    isWatched: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true,
      isOn: this.isWatched
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-watch--' + this.layout, this.layout), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-watch--on', this.isOn), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-watch--off', !this.isOn), _ref;
    },
    title: function title() {
      return this.isOn ? 'Remove from Watchlist' : 'Add to Watchlist';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['addMarketToWatchList', 'removeMarketFromWatchList']), {
    onWatchToggle: function onWatchToggle() {
      var _this = this;

      if (!this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
        return;
      }
      this.show = false;
      if (!this.isOn) {
        this.addMarketToWatchList(this.marketId).then(function () {
          _this.$emit('watch-toggle', true);
        });
      } else {
        this.removeMarketFromWatchList(this.marketId).then(function () {
          _this.$emit('watch-toggle', false);
        });
      }
      this.isOn = !this.isOn;
      setTimeout(function () {
        _this.show = true;
      }, 0);
    }
  })
});

/***/ }),

/***/ "33FX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_support_videos_videos_vue__ = __webpack_require__("HSd1");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    videos: __WEBPACK_IMPORTED_MODULE_2__components_support_videos_videos_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    showVideos: function showVideos() {
      return !this.isLayoutMobile && !this.isLoggedIn;
    },
    mainColumnModifiers: function mainColumnModifiers() {
      return {
        column: true,
        'small-12': true,
        'large-8': this.showVideos
      };
    },
    mainRowModifiers: function mainRowModifiers() {
      return {
        row: !this.showVideos,
        'row-x': this.showVideos
      };
    }
  })
});

/***/ }),

/***/ "34gu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_contract_tile_js__ = __webpack_require__("/KY/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31485ec2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contract_tile_vue__ = __webpack_require__("fftE");
function injectStyle (ssrContext) {
  __webpack_require__("ESWA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_contract_tile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31485ec2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contract_tile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "39kf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var CLASS_IS_LOADING = 'is-loading';

var loaderMixin = {
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['newLoaderIsLoading', 'isLayoutMobile', 'isLayoutDesktop'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['incrNewLoaderCounter', 'decrNewLoaderCounter']), {
    loaderAddLegacy: function loaderAddLegacy() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var target = el || this.$el;
      if (target) {
        target.classList.add(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = true;
      }
    },
    loaderRemoveLegacy: function loaderRemoveLegacy() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var target = el || this.$el;
      if (target) {
        target.classList.remove(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = false;
      }
    },
    loaderAdd: function loaderAdd() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (this.isLayoutMobile) {
        this.incrNewLoaderCounter();
        if (changeFlag) {
          this.isLoading = true;
        }
      } else {
        this.loaderAddLegacy(el, loadingClass, changeFlag);
      }
    },
    loaderRemove: function loaderRemove() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (this.isLayoutMobile) {
        this.decrNewLoaderCounter();
        if (changeFlag) {
          this.isLoading = false;
        }
      } else {
        this.loaderRemoveLegacy(el, loadingClass, changeFlag);
      }
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (loaderMixin);

/***/ }),

/***/ "3GDC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_filter_button_js__ = __webpack_require__("JSIy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e28373_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_button_vue__ = __webpack_require__("OqUx");
function injectStyle (ssrContext) {
  __webpack_require__("QgYw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_filter_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e28373_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3PHu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3PvP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_available_balance_js__ = __webpack_require__("AsO2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da22d6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_available_balance_vue__ = __webpack_require__("thf6");
function injectStyle (ssrContext) {
  __webpack_require__("n3iy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_available_balance_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da22d6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_available_balance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3USW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_document_js__ = __webpack_require__("MluJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067b0f8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_document_vue__ = __webpack_require__("7JgB");
function injectStyle (ssrContext) {
  __webpack_require__("S2j1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_document_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067b0f8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_document_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Uxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_old_js__ = __webpack_require__("+1tr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ca103a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_old_vue__ = __webpack_require__("nJds");
function injectStyle (ssrContext) {
  __webpack_require__("GR9s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_old_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ca103a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_old_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3VsP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"notification-item-trade-confirmed__content"},[_c('div',{staticClass:"notification-item-trade-confirmed__container"},[_c('div',{staticClass:"notification-item-trade-confirmed__icon"},[(_vm.isProcessedOrMatched)?_c('img',{attrs:{"src":__webpack_require__("uDSN")}}):_c('img',{attrs:{"src":__webpack_require__("U+El")}})]),_vm._v(" "),_c('h4',{staticClass:"notification-item-trade-confirmed__title"},[_vm._v(_vm._s(_vm.offerStatusLongText))]),_vm._v(" "),(_vm.showAutoCloseLoader)?_c('div',{staticClass:"notification-item-trade-confirmed__loader",style:({ '--close-timeout': (_vm.closeTimeout + "ms") })},[_c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32"}},[_c('circle',{staticClass:"notification-item-trade-confirmed__loader-ring",attrs:{"cx":"16","cy":"16","r":"13"}})])]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-trade-confirmed__close",on:{"click":_vm.onClose}})]),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"},[_c('div',{staticClass:"notification-item-trade-confirmed__market"},[_vm._v("\n        "+_vm._s(_vm.marketName)+"\n      ")])]),_vm._v(" "),(_vm.showHistory)?_c('div',_vm._l((_vm.history),function(stock){return _c('div',{staticClass:"row notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"},[_c('div',{staticClass:"notification-item-trade-confirmed__info"},[_c('div',[_vm._v("\n            "+_vm._s(_vm.soldOrBoughtText(stock.TradeType))+"\n            "),_c('span',[_vm._v(_vm._s(stock.Quantity)+" "+_vm._s(_vm.yesNoText(stock.TradeType)))]),_vm._v(" "),(!_vm.isMarketSingle)?_c('span',{staticClass:"notification-item-trade-confirmed__contract"},[_vm._v("\n              in "),_c('span',{directives:[{name:"contract-name",rawName:"v-contract-name"}]},[_vm._v(_vm._s(_vm.contractName))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notification-item-trade-confirmed__min-price"},[_vm._v("\n              at "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(stock.PricePerShare),expression:"stock.PricePerShare",modifiers:{"cents":true}}]})])])])])}),0):_vm._e(),_vm._v(" "),(_vm.showCashFooter)?_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 text-left"},[(_vm.showProfitLoss)?_c('div',[_vm._v("\n            "+_vm._s(_vm.profitOrLossText)+": "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.profit),expression:"profit",modifiers:{"fixed3":true}}]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[(_vm.showFees)?_c('div',[_vm._v("\n            Fees: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.fee),expression:"fee",modifiers:{"fixed3":true}}]})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.offerId && _vm.dateCreated)?[_c('div',{staticClass:"column small-12"},[_c('div',[_vm._v("\n              Date: "+_vm._s(_vm.dateCreated)+"\n            ")])])]:_vm._e(),_vm._v(" "),(_vm.offerId)?[_c('div',{staticClass:"column small-6 text-left"},[_c('div',[_vm._v("\n              Confirmation: "+_vm._s(_vm._f("base32")(_vm.offerId))+"\n            ")])]),_vm._v(" "),_vm._m(0)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-6 text-left"},[(_vm.showRisk)?_c('div',[_vm._v("\n            Risk Adj.: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.risk),expression:"risk",modifiers:{"fixed3":true}}]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[_c('div',[_c('strong',[_c('plus-minus-sign'),_vm._v(" Cash: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.cost),expression:"cost",modifiers:{"fixed3":true}}]})],1)])])],2)]):(_vm.showOpenOfferRecordedFooter && _vm.offerId)?_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--footer"},[_c('div',{staticClass:"row"},[(_vm.dateCreated)?[_c('div',{staticClass:"column small-12"},[_c('div',[_vm._v("\n              Date: "+_vm._s(_vm.dateCreated)+"\n            ")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-6 text-left"},[_c('div',[_vm._v("\n            Confirmation: "+_vm._s(_vm._f("base32")(_vm.offerId))+"\n          ")])]),_vm._v(" "),_vm._m(1)],2)]):_vm._e(),_vm._v(" "),(_vm.remainingQuantity > 0)?_c('div',{class:_vm.bottomContainerClassModifiers},[(false)?_c('div',{staticClass:"notification-item-trade-confirmed__icon"},[_c('img',{attrs:{"src":require("assets/icons/pending-large.svg")}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__info"},[_c('div',[_vm._v("\n          "+_vm._s(_vm.soldOrBoughtTextOffer())+"\n          "),_c('span',[_vm._v(_vm._s(_vm.remainingQuantity)+" "+_vm._s(_vm.yesNoText(_vm.offerType)))]),_vm._v(" "),(!_vm.isMarketSingle)?_c('span',{staticClass:"notification-item-trade-confirmed__contract"},[_vm._v("\n            in "),_c('span',{directives:[{name:"contract-name",rawName:"v-contract-name"}]},[_vm._v(_vm._s(_vm.contractName))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notification-item-trade-confirmed__min-price"},[_vm._v("\n            at "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.minPrice),expression:"minPrice",modifiers:{"cents":true}}]})])])])]):_vm._e(),_vm._v(" "),(_vm.showFooter)?_c('div',{staticClass:"notification-item-trade-confirmed__footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[(_vm.showToggle)?_c('div',{staticClass:"notification-item-trade-confirmed__toggle",on:{"click":_vm.onToggle}},[(_vm.advanced)?[_vm._v("Hide")]:[_vm._v("Details")]],2):_c('div',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right notification-item-trade-confirmed__share"},[_c('div',{staticClass:"notification-item-trade-confirmed__share-buttons"},[_c('a',{staticClass:"notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--x",on:{"click":function($event){$event.preventDefault();return _vm.onTwitterShare($event)}}}),_vm._v(" "),_c('a',{staticClass:"notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--facebook",on:{"click":function($event){$event.preventDefault();return _vm.onFacebookShare($event)}}}),_vm._v(" "),_c('a',{staticClass:"notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--email",attrs:{"href":_vm.mailto},on:{"click":_vm.onEmailShare}})])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-6 text-right"},[_c('div',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-6 text-right"},[_c('div',[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3cKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_main_nav_js__ = __webpack_require__("ASm9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e792242_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_main_nav_vue__ = __webpack_require__("XLAI");
function injectStyle (ssrContext) {
  __webpack_require__("e1V1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_main_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e792242_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_main_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ggI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_textarea_js__ = __webpack_require__("09V6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a39100_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textarea_vue__ = __webpack_require__("DJt/");
function injectStyle (ssrContext) {
  __webpack_require__("q/wu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_textarea_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a39100_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3iU4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['clearRefreshToken', 'setUseDisqus', 'loginDisqus', 'logoutDisqus'])),
  created: function created() {
    var _this = this;

    document.body.classList.remove('splash');
    if (this.$route.name === 'disqus-logout') {
      this.logoutDisqus().then(function () {
        _this.setUseDisqus(false);
        _this.$router.push({
          name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["Q" /* smartatob */])(_this.$route.params.routeName),
          params: JSON.parse(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["Q" /* smartatob */])(_this.$route.params.routeParams))
        });
      });
    } else if (this.isLoggedIn) {
      // remember that from now onwards we should login with disqus
      this.loginDisqus().then(function () {
        _this.setUseDisqus(true);
        setTimeout(function () {
          window.close();
        }, 1000);
      });
    } else {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    }
  }
});

/***/ }),

/***/ "3kQE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3kul":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "3lN5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3mSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_transfer_js__ = __webpack_require__("NPa3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c360e49_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_transfer_vue__ = __webpack_require__("v0IF");
function injectStyle (ssrContext) {
  __webpack_require__("BEn0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_transfer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c360e49_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3po1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,style:(_vm.styleVariables)},[(_vm.isLoading)?_c('div',{staticClass:"order-book-sushi__loading"}):_vm._e(),_vm._v(" "),(_vm.initialised)?[(_vm.showTitle && !_vm.showCardLayout)?_c('div',{staticClass:"order-book-sushi__title"},[_vm._v("\n      Orderbook\n    ")]):_vm._e(),_vm._v(" "),(_vm.displayMode === _vm.ORDER_BOOK_DISPLAY_MODES.MOBILE)?_c('div',{staticClass:"order-book-sushi__tabs-header"},[_c('div',{staticClass:"order-book-sushi__tabs"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.name,staticClass:"order-book-sushi__tab",class:{'order-book-sushi__tab--active': _vm.activeTab === tab.name},on:{"click":function($event){return _vm.tabChange(tab.name)}}},[_c('span',{staticClass:"order-book-sushi__tab-text"},[_vm._v("\n            "+_vm._s(tab.title)+"\n          ")])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__content",class:_vm.contentModifiers},[(_vm.showCardLayout)?[(_vm.showPricesCard)?_c('div',{staticClass:"order-book-sushi__card order-book-sushi__card--prices"},[(_vm.showCompactCardTitles)?_c('div',{staticClass:"order-book-sushi__card-title order-book-sushi__card-title--compact-orderbook"},[_c('span',{class:_vm.cardTitleSideModifiers('yes'),on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onCompactOrderBookTitleClick('yes')}}},[_vm._v("\n              YES Orderbook\n            ")]),_vm._v(" "),_c('span',{class:_vm.cardTitleSideModifiers('no'),on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onCompactOrderBookTitleClick('no')}}},[_vm._v("\n              NO Orderbook\n            ")])]):_c('div',{staticClass:"order-book-sushi__card-title"},[_vm._v("\n            Orderbook\n          ")]),_vm._v(" "),_c('order-book-prices-sushi',{attrs:{"contract":_vm.contract,"buyOffers":_vm.buyOffers,"sellOffers":_vm.sellOffers,"operationType":_vm.operationType,"operationValue":_vm.operationValue,"orderBook":_vm.orderBook,"showHeader":true,"scrollable":false,"minimumRows":_vm.minimumRowsForCurrentDisplayMode,"card-layout":true,"compact-card-layout":_vm.compactCards},on:{"click":function($event){return _vm.$emit('updatePriceAndQuantity', $event)}}})],1):_vm._e(),_vm._v(" "),(_vm.showOrdersCard)?_c('div',{staticClass:"order-book-sushi__card order-book-sushi__card--orders"},[_c('order-book-offers-sushi',{attrs:{"showHeader":true,"scrollable":false,"minimumRows":_vm.minimumRowsForCurrentDisplayMode,"market":_vm.market,"contract":_vm.contract,"buyOffers":_vm.buyOffers,"sellOffers":_vm.sellOffers,"card-layout":true,"compact-card-layout":_vm.compactCards},on:{"offerCanceled":_vm.offerCanceled}})],1):_vm._e(),_vm._v(" "),(_vm.showSharesCard)?_c('div',{staticClass:"order-book-sushi__card order-book-sushi__card--shares"},[_c('order-book-shares-sushi',{attrs:{"showHeader":true,"scrollable":false,"minimumRows":_vm.minimumRowsForCurrentDisplayMode,"contract":_vm.contract,"items":_vm.contractShares,"card-layout":true,"compact-card-layout":_vm.compactCards}})],1):_vm._e()]:[(_vm.tabVisible(_vm.TABS.PRICES))?_c('order-book-prices-sushi',{attrs:{"contract":_vm.contract,"buyOffers":_vm.buyOffers,"sellOffers":_vm.sellOffers,"operationType":_vm.operationType,"operationValue":_vm.operationValue,"orderBook":_vm.orderBook,"showHeader":true,"scrollable":_vm.displayMode === _vm.ORDER_BOOK_DISPLAY_MODES.MOBILE,"minimumRows":_vm.minimumRowsForCurrentDisplayMode},on:{"click":function($event){return _vm.$emit('updatePriceAndQuantity', $event)}}}):_vm._e(),_vm._v(" "),(_vm.tabVisible(_vm.TABS.ALL_OFFERS))?_c('order-book-offers-sushi',{attrs:{"showHeader":_vm.displayMode === _vm.ORDER_BOOK_DISPLAY_MODES.DEFAULT,"scrollable":_vm.displayMode === _vm.ORDER_BOOK_DISPLAY_MODES.MOBILE,"minimumRows":_vm.minimumRowsForCurrentDisplayMode,"market":_vm.market,"contract":_vm.contract,"buyOffers":_vm.buyOffers,"sellOffers":_vm.sellOffers},on:{"offerCanceled":_vm.offerCanceled}}):_vm._e(),_vm._v(" "),(_vm.tabVisible(_vm.TABS.MY_ORDERS))?_c('order-book-my-orders-sushi',{attrs:{"showHeader":_vm.displayMode === _vm.ORDER_BOOK_DISPLAY_MODES.MOBILE,"scrollable":_vm.displayMode === _vm.ORDER_BOOK_DISPLAY_MODES.MOBILE,"minimumRows":_vm.minimumRowsForCurrentDisplayMode,"market":_vm.market,"contract":_vm.contract,"buyOffers":_vm.buyOffers,"sellOffers":_vm.sellOffers,"operationType":_vm.operationType},on:{"offerCanceled":_vm.offerCanceled}}):_vm._e(),_vm._v(" "),(_vm.tabVisible(_vm.TABS.MY_SHARES))?_c('order-book-shares-sushi',{attrs:{"showHeader":_vm.displayMode === _vm.ORDER_BOOK_DISPLAY_MODES.DEFAULT,"scrollable":_vm.displayMode === _vm.ORDER_BOOK_DISPLAY_MODES.MOBILE,"minimumRows":_vm.minimumRowsForCurrentDisplayMode,"contract":_vm.contract,"items":_vm.contractShares}}):(_vm.isLayoutMobile)?_c('div',{staticClass:"order-book-shares-sushi order-book-shares-sushi--empty"}):_vm._e()]],2)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3uJM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yLjI0MyAyMC4zMDJjLS43ODMuOTYxLjQ5NSAyLjIzOSAxLjQ1MiAxLjQ1NGw0Ljc0OC0zLjg4OC0yLjMxNy0yLjMyMS0zLjg4MyA0Ljc1NXptMTkuMzEtMTEuMDgxTDE0Ljc0IDIuNDQ1YTEuNTM2IDEuNTM2IDAgMCAwLTIuMTY0IDBBMS41MiAxLjUyIDAgMCAwIDEyLjU4IDQuNmwuODguODc1TDkuNjcgOS4yMjNjLS45OS0uMDU3LTMuNDg0LS4xNy00LjQ1LjA1Ny0xLjAyNC4yNDItMS4zODcgMS41MDQtLjY0MSAyLjI0Mmw3Ljk3NyA3Ljg5MmMuNzQuNzM1IDIuMDIxLjM4MyAyLjI2Ni0uNjM0LjA1Mi0uMjE1LjI0My0xLjI2Ni4wNTctNC40MDJsMy43NzUtMy43MzQuNzM1LjczMmMuNjA3LjYgMS41Ny41ODUgMi4xNjQtLjAwMWExLjUyMyAxLjUyMyAwIDAgMC0uMDAxLTIuMTU0eiIgZmlsbD0iIzk0OTQ5NCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "3wpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_loader__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('profile', ['userAffiliations', 'isUCAffilSet'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('profile', ['getUserAffiliations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopup', 'setCurrentPopupOptions']), {
    showAffiliationsPopup: function showAffiliationsPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
      this.setCurrentPopupOptions({ allowClose: true });
    },
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PUBLIC_PROFILE_INFO);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd();
    this.getUserAffiliations().then(function () {
      return _this.loaderRemove();
    }).catch(function () {
      return _this.loaderRemove();
    });
  }
});

/***/ }),

/***/ "3yfD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");





var PROGRESS_LEFT_RIGHT_THRESHOLD = 15;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_socialLevel__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    avatarTheme: function avatarTheme() {
      return this.isLayoutDesktop ? 'large' : '';
    },
    username: function username() {
      return this.userData && this.userData.userName ? '' + this.userData.userName : '';
    },
    backgroundModifiers: function backgroundModifiers() {
      var num = this.level.num;
      return {
        'account-social-badge': true
        // [`account-social-badge--level-${num}`]: num,
      };
    },
    progressBarStyleModifiers: function progressBarStyleModifiers() {
      return {
        width: this.progressPercentage + '%'
      };
    },
    progressBarClassModifiers: function progressBarClassModifiers() {
      return {
        'account-social-badge__progress-num': true,
        'account-social-badge__progress-num--right  ': true
      };
    },
    levelColor: function levelColor() {
      return '#55575A';
    },
    progressColor: function progressColor() {
      return '#259EBB';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    showBadgesPopup: function showBadgesPopup() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_BADGES);
    }
  })
});

/***/ }),

/***/ "4/49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__ = __webpack_require__("GZXJ");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__["a" /* default */]]
});

/***/ }),

/***/ "4/Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String
    },
    reversed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('showPopup');
    }
  }
});

/***/ }),

/***/ "44Nf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiselect",class:{ 'multiselect--active': _vm.isOpen, 'multiselect--disabled': _vm.disabled, 'multiselect--above': _vm.isAbove },attrs:{"tabindex":_vm.searchable ? -1 : _vm.tabindex},on:{"focus":function($event){return _vm.activate()},"blur":function($event){_vm.searchable ? false : _vm.deactivate()},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.pointerForward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.pointerBackward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.addPointerElement($event)}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.deactivate()}}},[_vm._t("caret",[_c('div',{staticClass:"multiselect__select",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggle()}}})],{"toggle":_vm.toggle}),_vm._v(" "),_vm._t("clear",null,{"search":_vm.search}),_vm._v(" "),_c('div',{ref:"tags",staticClass:"multiselect__tags"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visibleValue.length > 0),expression:"visibleValue.length > 0"}],staticClass:"multiselect__tags-wrap"},[_vm._l((_vm.visibleValue),function(option){return [_vm._t("tag",[_c('span',{staticClass:"multiselect__tag"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}}),_vm._v(" "),_c('i',{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true","tabindex":"1"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.removeElement(option)},"mousedown":function($event){$event.preventDefault();return _vm.removeElement(option)}}})])],{"option":option,"search":_vm.search,"remove":_vm.removeElement})]})],2),_vm._v(" "),(_vm.internalValue && _vm.internalValue.length > _vm.limit)?[_c('strong',{staticClass:"multiselect__strong",domProps:{"textContent":_vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))}})]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"multiselect__loading"}},[_vm._t("loading",[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"multiselect__spinner"})])],2),_vm._v(" "),(_vm.searchable)?_c('input',{ref:"search",staticClass:"multiselect__input",style:(_vm.inputStyle),attrs:{"name":_vm.name,"id":_vm.id,"type":"text","autocomplete":"off","placeholder":_vm.placeholder,"disabled":_vm.disabled,"tabindex":_vm.tabindex},domProps:{"value":_vm.isOpen ? _vm.search : _vm.currentOptionLabel},on:{"input":function($event){return _vm.updateSearch($event.target.value)},"focus":function($event){$event.preventDefault();return _vm.activate()},"blur":function($event){$event.preventDefault();return _vm.deactivate()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.deactivate()},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.pointerForward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.pointerBackward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.addPointerElement($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }$event.stopPropagation();return _vm.removeLastElement()}]}}):_vm._e(),_vm._v(" "),(!_vm.searchable)?_c('span',{staticClass:"multiselect__single",domProps:{"innerHTML":_vm._s(_vm.currentOptionLabel)},on:{"mousedown":function($event){$event.preventDefault();return _vm.toggle($event)}}}):_vm._e()],2),_vm._v(" "),_c('transition',{attrs:{"name":"multiselect"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:({ maxHeight: _vm.optimizedHeight + 'px' }),on:{"focus":_vm.activate,"mousedown":function($event){$event.preventDefault();}}},[_c('ul',{staticClass:"multiselect__content",style:(_vm.contentStyle)},[_vm._t("beforeList"),_vm._v(" "),(_vm.multiple && _vm.max === _vm.internalValue.length)?_c('li',[_c('span',{staticClass:"multiselect__option"},[_vm._t("maxElements",[_vm._v("Maximum of "+_vm._s(_vm.max)+" options selected. First remove a selected option to select another.")])],2)]):_vm._e(),_vm._v(" "),(!_vm.max || _vm.internalValue.length < _vm.max)?_vm._l((_vm.filteredOptions),function(option,index){return _c('li',{key:index,staticClass:"multiselect__element"},[(!(option && (option.$isLabel || option.$isDisabled)))?_c('span',{staticClass:"multiselect__option",class:_vm.optionHighlight(index, option),attrs:{"data-select":option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,"data-selected":_vm.selectedLabelText,"data-deselect":_vm.deselectLabelText},on:{"click":function($event){$event.stopPropagation();return _vm.select(option)},"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.pointerSet(index, option)}}},[_vm._t("option",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}})],{"option":option,"search":_vm.search})],2):_vm._e(),_vm._v(" "),(option && (option.$isLabel || option.$isDisabled))?_c('span',{staticClass:"multiselect__option multiselect__option--disabled",class:_vm.optionHighlight(index, option)},[_vm._t("option",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}})],{"option":option,"search":_vm.search})],2):_vm._e()])}):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNoResults && (_vm.filteredOptions.length === 0 && _vm.search && !_vm.loading)),expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[_c('span',{staticClass:"multiselect__option"},[_vm._t("noResult",[_vm._v("No elements found. Consider changing the search query.")])],2)]),_vm._v(" "),_vm._t("afterList")],2)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4DPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-page-loader"},[_c('div',{staticClass:"static-page-loader__content"},[_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-2"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-3"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4EoQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_disqus_js__ = __webpack_require__("cz2j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae9a6f92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_disqus_vue__ = __webpack_require__("h21F");
function injectStyle (ssrContext) {
  __webpack_require__("iNbR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_disqus_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae9a6f92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_disqus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Hqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-tax-detail"},[_c('div',{staticClass:"page-tax-detail__content"},[_c('div',{staticClass:"page-tax-detail__title"},[_vm._v("Tax Information")]),_vm._v(" "),_c('div',{staticClass:"page-tax-detail__content-wrap"},[_c('tax-info-notification')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Iyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNewsFeed)?_c('div',{class:_vm.classModifiers},[(!_vm.collapsible)?[(_vm.showTitle)?_c('div',{staticClass:"news-feed__header"},[_c('div',{staticClass:"news-feed__header-title"},[_vm._v("\n        News Feed\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"news-feed__line"}),_vm._v(" "),_c('div',{class:_vm.contentClassModifiers},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"news-feed__item"},[_c('news-feed-item',{attrs:{"data":item}})],1)}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMoreButton),expression:"showMoreButton"}],staticClass:"news-feed__more-button",on:{"click":_vm.loadMore}},[_vm._v("\n      More News\n    ")])]:[_c('collapsible-panel',{key:_vm.isOpen,attrs:{"noPadding":true,"darkHeader":true,"canClose":false,"isOpen":_vm.isOpen,"theme":"small-header"},on:{"toggle":function($event){return _vm.$emit('toggle-news')}}},[_c('div',{staticClass:"news-feed__collapsible-title",attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"news-feed__collapsible-title-text"},[_vm._v("News Feed")])]),_vm._v(" "),_c('div',{staticClass:"news-feed__collapsible-content"},[_c('div',{class:_vm.contentClassModifiers},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"news-feed__item"},[_c('news-feed-item',{attrs:{"data":item}})],1)}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMoreButton),expression:"showMoreButton"}],staticClass:"news-feed__more-button",on:{"click":_vm.loadMore}},[_vm._v("\n          More News\n        ")])])])]],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Ny/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4OEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_cash_js__ = __webpack_require__("9rUd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190527dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_cash_vue__ = __webpack_require__("PBWK");
function injectStyle (ssrContext) {
  __webpack_require__("Ttr+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_cash_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190527dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_cash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4RI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_collapsible_panel_components_collapsible_panel_simple_collapsible_panel_simple_vue__ = __webpack_require__("gYkw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_support_faq_search_input_faq_search_input_vue__ = __webpack_require__("ZvSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_support__ = __webpack_require__("33FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_contentLoader__ = __webpack_require__("P71F");














/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_support__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_contentLoader__["a" /* default */]],
  props: {
    title: {
      type: String,
      default: 'FAQs'
    },
    minLength: {
      type: Number,
      default: 2
    },
    triggerNavigateToHelpAndSupport: {
      type: Boolean,
      default: true
    }
  },
  components: {
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__["a" /* default */],
    collapsiblePanelSimple: __WEBPACK_IMPORTED_MODULE_4__components_collapsible_panel_components_collapsible_panel_simple_collapsible_panel_simple_vue__["a" /* default */],
    faqSearchInput: __WEBPACK_IMPORTED_MODULE_5__components_support_faq_search_input_faq_search_input_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_6__components_generics_content_header_content_header_vue__["a" /* default */],
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_10__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  data: function data() {
    return {
      searchTerm: '',
      noResultFound: false,
      reg: [],
      expanded: false,
      accordion: null,
      accordionQA: null
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },

  // watch: {
  //   isLayoutMobile(value) {
  //     if (!value && this.triggerNavigateToHelpAndSupport) {
  //       this.$router.push({ name: 'HelpAndSupport' });
  //     }
  //   },
  // },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('about', ['faqs']), {
    filteredFAQs: function filteredFAQs() {
      this.expanded = false;
      if (this.$route.params.faqid === 666) {
        this.expanded = true;
        this.searchTerm = 'how do you calculate risk in multi';
      }
      var formatTitle = function formatTitle(title, count) {
        return title + ' [' + count + ']';
      };
      if (this.faqs === null) {
        return [];
      }
      if (this.searchTerm === '') {
        this.noResultFound = this.faqs.length === 0;
        // just mapping category names to add [items.count] to name
        return this.faqs.map(function (category) {
          return {
            name: formatTitle(category.name, category.faqs.length),
            faqs: category.faqs,
            id: category.id
          };
        });
      }
      var reg = this.getRegexp(this.searchTerm);
      // reducing categories depending on filtered QA in them
      var newCategories = this.faqs.reduce(function (previouse, category) {
        var filteredQA = category.faqs.filter(function (qa) {
          return reg.test(qa.title) || reg.test(qa.description_text);
        });
        if (filteredQA.length > 0) {
          previouse.push({
            name: formatTitle(category.name, filteredQA.length),
            faqs: filteredQA,
            id: category.id
          });
        }
        return previouse;
      }, []);
      this.noResultFound = newCategories.length === 0;
      return newCategories;
    },
    isEmpty: function isEmpty() {
      return this.noResultFound;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('about', ['getFaqs']), {
    updateSearch: function updateSearch(term) {
      this.searchTerm = term.length >= this.minLength ? term.toLowerCase() : '';
    },
    initializeComponentWithSearchTerm: function initializeComponentWithSearchTerm(term) {
      var _this = this;

      this.updateSearch(term);
      this.$nextTick(function () {
        _this.expanded = true;
        _this.accordion = 'faq-0';
        _this.accordionQA = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_this.filteredFAQs, '[0].faqs[0].id');
      });
    },
    getRegexp: function getRegexp(term) {
      if (!this.reg[term]) {
        this.reg[term] = new RegExp(term, 'im');
      }
      return this.reg[term];
    },
    accordionOpen: function accordionOpen(e) {
      this.accordion = e;

      if (e !== null) {
        setTimeout(function () {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_scrollTo__["a" /* default */])(document.getElementById(e), 0);
        }, 50);
      }
    },
    accordionOpenQA: function accordionOpenQA(e) {
      this.accordionQA = e;
    }
  }),
  created: function created() {
    var _this2 = this;

    // if (store.state.app.layout === 'desktop' && this.triggerNavigateToHelpAndSupport) {
    //   this.$router.push({ name: 'HelpAndSupport' });
    // }
    this.loaderAdd(document.body);
    this.getFaqs().then(function () {
      _this2.isComponentReady = true;
      _this2.loaderRemove(document.body);
    }).catch(function () {
      return _this2.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "4RVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("G/BR");






var levels = ['success', 'danger', 'warning', 'info'];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    level: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        return levels.indexOf(value) !== -1;
      }
    },
    autoClose: {
      type: Boolean,
      required: false,
      default: true
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    onCloseCallback: {
      default: null
    },
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      interacted: false
    };
  },

  computed: {
    contentModifiers: function contentModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'side-notification__content': true
      }, 'side-notification__content--' + this.level, this.level);
    },
    iconModifiers: function iconModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'side-notification__icon': true
      }, 'side-notification__icon--' + this.level, this.level);
    },
    isDebug: function isDebug() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__logger__["b" /* isDebugOn */])();
    },
    showAutoCloseLoader: function showAutoCloseLoader() {
      return this.autoClose && this.closeTimeout > 0 && !this.interacted && !this.isDebug;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['clearSideNotification']), {
    onClose: function onClose() {
      this.clearSideNotification();
      if (typeof this.onCloseCallback !== 'undefined' && this.onCloseCallback !== null) {
        this.onCloseCallback.apply(this);
      }
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !this.isDebug) {
      this.timeout = setTimeout(function () {
        if (!_this.interacted) _this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
});

/***/ }),

/***/ "4Sf7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4b+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-market-links-widget"},[(_vm.opened === null)?_c('div',{staticClass:"bottom-market-links-widget__bar"},[_c('div',{staticClass:"bottom-market-links-widget__sections"},_vm._l((_vm.sections),function(section){return _c('div',{key:section.name,staticClass:"bottom-market-links-widget__section",on:{"click":function($event){return _vm.openSection(section)}}},[_c('div',{staticClass:"bottom-market-links-widget__section-icon",class:("bottom-market-links-widget__section-icon--" + (section.name))}),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-widget__section-title"},[_vm._v("\n            "+_vm._s(section.title)+"\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-widget__toggle",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('toggle')}}})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened && _vm.opened.name === _vm.SECTIONS.PRODUCT_HISTORY),expression:"opened && opened.name === SECTIONS.PRODUCT_HISTORY"}],staticClass:"bottom-market-links-widget__opened"},[_c('div',{staticClass:"bottom-market-links-widget__opened-content"},[_c('div',{staticClass:"bottom-market-links-widget__opened-title"},[_vm._v("\n          Product History\n          "),_c('div',{staticClass:"bottom-market-links-widget__opened-title-close",on:{"click":_vm.closeSection}})]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-widget__opened-widget"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened && _vm.opened.name === _vm.SECTIONS.SESSION_HISTORY),expression:"opened && opened.name === SECTIONS.SESSION_HISTORY"}],staticClass:"bottom-market-links-widget__opened"},[_c('div',{staticClass:"bottom-market-links-widget__opened-content"},[_c('div',{staticClass:"bottom-market-links-widget__opened-title"},[_vm._v("\n          Session History\n          "),_c('div',{staticClass:"bottom-market-links-widget__opened-title-close",on:{"click":_vm.closeSection}})]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-widget__opened-widget"},[_c('session-history-sushi',{attrs:{"type":"widget"}})],1)])]),_vm._v(" "),(_vm.opened && _vm.opened.name === _vm.SECTIONS.WATCHLIST)?_c('div',{staticClass:"bottom-market-links-widget__opened"},[_c('div',{staticClass:"bottom-market-links-widget__opened-content"},[_c('div',{staticClass:"bottom-market-links-widget__opened-title"},[_vm._v("\n          Watchlist\n          "),_c('div',{staticClass:"bottom-market-links-widget__opened-title-close",on:{"click":_vm.closeSection}})]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-widget__opened-widget"},[(_vm.isLoggedIn)?_c('watchlist-sushi',{attrs:{"type":"widget"}}):_vm._e()],1)])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened && _vm.opened.name === _vm.SECTIONS.DISCUSSION),expression:"opened && opened.name === SECTIONS.DISCUSSION"}],staticClass:"bottom-market-links-widget__opened"},[_c('div',{staticClass:"bottom-market-links-widget__opened-content"},[_c('div',{staticClass:"bottom-market-links-widget__opened-title"},[_vm._v("\n          Discussion\n          "),_c('div',{staticClass:"bottom-market-links-widget__opened-title-close",on:{"click":_vm.closeSection}})]),_vm._v(" "),(_vm.market.disqus_Identifier)?_c('div',{staticClass:"bottom-market-links-widget__opened-widget"},[_c('disqus',{attrs:{"disqusId":_vm.market.disqus_Identifier,"title":_vm.market.disqus_Title,"auth":_vm.market.disqus_UserAuth,"url":_vm.market.disqus_Url,"previous":_vm.market.disqus_PrevThreadID,"next":_vm.market.disqus_NextThreadID,"total":_vm.market.disqus_ArchivedCommentsTotal,"marketId":_vm.market.marketId}})],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4blE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_catchHtmlClickMixin__ = __webpack_require__("xO2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__ = __webpack_require__("ZIhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_support__ = __webpack_require__("33FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_brand_name_brand_name_js__ = __webpack_require__("9IfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__ = __webpack_require__("P71F");














var DEFAULT_TITLE = 'What is ' + __WEBPACK_IMPORTED_MODULE_10__components_brand_name_brand_name_js__["a" /* BRAND */] + '?';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__helpers_catchHtmlClickMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_support__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__["a" /* default */]],
  props: {
    title: {
      type: String,
      default: DEFAULT_TITLE
    }
  },
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__["a" /* default */],
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_9__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },
  data: function data() {
    return {
      topBasics: [{
        name: DEFAULT_TITLE,
        text: ''
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    topics: function topics() {
      return this.isLayoutMobile ? [] : [this.topBasics[0]];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    openResearch: function openResearch() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__["a" /* MODALS */].RESEARCH);
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* STATIC_PAGES */].WHAT_IS).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "4eDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_settings_button_js__ = __webpack_require__("WF/p");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc282c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_settings_button_vue__ = __webpack_require__("HQPR");
function injectStyle (ssrContext) {
  __webpack_require__("na9c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_settings_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc282c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_settings_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4f6F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","appear":""},on:{"after-enter":_vm.afterEnter}},[_c('div',{class:_vm.overlayClassModifiers},[_c('div',{staticClass:"modal__wrapper"},[_c('div',{staticClass:"modal__body",class:_vm.bodyClass},[(_vm.hasHeader)?_c('div',{staticClass:"modal__header",class:_vm.headerClass},[_vm._t("header"),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"modal__close",on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}})],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"modal__content",class:_vm.classModifier},[_vm._t("content")],2),_vm._v(" "),(_vm.hasFooter)?_c('div',{staticClass:"modal__footer"},[_vm._t("footer")],2):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4gzO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_product_history_sushi_js__ = __webpack_require__("Gcrh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5925c20c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_history_sushi_vue__ = __webpack_require__("gL3B");
function injectStyle (ssrContext) {
  __webpack_require__("o68p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_product_history_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5925c20c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_history_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4kpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_not_found_js__ = __webpack_require__("urbP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17877986_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_not_found_vue__ = __webpack_require__("QgQ6");
function injectStyle (ssrContext) {
  __webpack_require__("hECP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_not_found_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17877986_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_not_found_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4p0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_list_js__ = __webpack_require__("Zi8f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2763bc03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_list_vue__ = __webpack_require__("id0j");
function injectStyle (ssrContext) {
  __webpack_require__("pPYv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2763bc03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4pyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_js__ = __webpack_require__("Ufge");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a97db65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("emeG");
function injectStyle (ssrContext) {
  __webpack_require__("7aYA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a97db65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4v//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4v/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "4vD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_element_js__ = __webpack_require__("OLUT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064052a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_element_vue__ = __webpack_require__("8vMm");
function injectStyle (ssrContext) {
  __webpack_require__("Y8LD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_element_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064052a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_element_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4xwA":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDE4IDE5Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjY0LjA2MUwuNzI3IDEwLjIwOHMyLjQyOCAxLjI4MyA0Ljk5OCAyLjI4N0wxNi4wNDEgMS43MDFsLTguNTA4IDExLjkxdjUuMTA1bDIuMTU1LTQuNDY3IDYuMzUzIDIuNzY2TDE3Ljc0MiAwbC0uMDM0LjAyYS4xMDQuMTA0IDAgMCAxLS4wNjguMDQxeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "52iG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('preview-carousel-loader'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}],class:_vm.tabsClassModifiers},[(_vm.showNavigationArrows)?_c('button',{staticClass:"preview-carousel__arrow preview-carousel__arrow--left",attrs:{"disabled":!_vm.canScrollLeft,"aria-label":"Scroll left"},on:{"click":_vm.scrollLeft}}):_vm._e(),_vm._v(" "),_c('div',{ref:"tabsList",staticClass:"preview-carousel__nav-container"},[_c('tabs',{attrs:{"items":_vm.navigationTabs,"theme":"carousel","activeTab":_vm.activeTab},on:{"tabChange":_vm.navigationTabChange},nativeOn:{"click":function($event){return _vm.tabsClicked($event)}}})],1),_vm._v(" "),(_vm.showNavigationArrows)?_c('button',{staticClass:"preview-carousel__arrow preview-carousel__arrow--right",attrs:{"disabled":!_vm.canScrollRight,"aria-label":"Scroll right"},on:{"click":_vm.scrollRight}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isComponentReady),expression:"isComponentReady"}],ref:"content",class:_vm.contentClassModifiers,style:(_vm.contentStyleModifiers)},_vm._l((_vm.storyMap),function(data,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(parseInt(index, 10) === _vm.currentStoryIndex),expression:"parseInt(index, 10) === currentStoryIndex"}],key:(_vm.refreshIndex + "-" + index),staticClass:"preview-carousel__story"},[_c('div',{staticClass:"preview-carousel__story-html",domProps:{"innerHTML":_vm._s(_vm.storyContentMap[index])}})])}),0),_vm._v(" "),(_vm.showExpandControl)?_c('div',{class:_vm.expandClassModifiers,on:{"click":_vm.toggleExpand}},[(!_vm.isExpanded)?_c('span',[_vm._v("Read More ▾")]):_c('span',[_vm._v("Show Less ▴")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "53+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.tableModifiers},[(_vm.showHeader && !_vm.showColumnHeader && !_vm.showCardColumnHeader)?_c('div',{staticClass:"order-book-sushi__header order-book-shares-sushi__header"},[_c('div',{staticClass:"order-book-sushi__header-cell order-book-sushi__header-cell--active"},[_vm._v("Holdings")])]):_vm._e(),_vm._v(" "),(_vm.cardLayout)?[(_vm.showHeader)?_c('div',{staticClass:"order-book-shares-sushi__card-title"},[_vm._v("\n        Holdings\n      ")]):_vm._e(),_vm._v(" "),(_vm.showCardColumnHeader)?_c('div',{staticClass:"order-book-shares-sushi__card-columns"},[_c('div',{staticClass:"order-book-shares-sushi__card-columns-cell order-book-shares-sushi__card-columns-cell--price"},[_vm._v("Price")]),_vm._v(" "),_c('div',{staticClass:"order-book-shares-sushi__card-columns-cell order-book-shares-sushi__card-columns-cell--quantity"},[_vm._v("Qty")]),_vm._v(" "),_c('div',{staticClass:"order-book-shares-sushi__card-columns-cell order-book-shares-sushi__card-columns-cell--date"},[_vm._v("Date")])]):_vm._e()]:(_vm.showColumnHeader)?_c('div',{staticClass:"order-book-sushi__header order-book-sushi__header--striped order-book-shares-sushi__columns"},[_c('div',{staticClass:"order-book-shares-sushi__columns-price"},[_vm._v("Price")]),_vm._v(" "),_c('div',{staticClass:"order-book-shares-sushi__columns-quantity"},[_vm._v("Qty")]),_vm._v(" "),_c('div',{staticClass:"order-book-shares-sushi__columns-date"},[_vm._v("Date")])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.bodyModifiers},[_vm._l((_vm.displayRows),function(item,index){return _c('div',{key:("order-book-shares-" + index),staticClass:"order-book-sushi__row order-book-sushi__row--striped order-book-shares-sushi__row"},[(item)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--highlight order-book-shares-sushi__cell order-book-shares-sushi__cell--price"},[_vm._v("\n            "+_vm._s(item.pricePerShare)+"¢\n          ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-shares-sushi__cell order-book-shares-sushi__cell--quantity"},[_vm._v("\n            "+_vm._s(item.sharesOwned.toLocaleString())+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-shares-sushi__cell order-book-shares-sushi__cell--action"},[(item.isNo)?[_vm._v("NO")]:[_vm._v("YES")]],2),_vm._v(" "),_c('span',{staticClass:"order-book-shares-sushi__date"},[_vm._v("\n            "+_vm._s(_vm.getDate(item.dateExecuted))+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"order-book-shares-sushi__icon",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onInfoClick(item)}}})]:(index === 0 && !_vm.cardLayout && !_vm.isScrollableEmpty)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable order-book-shares-sushi__cell order-book-shares-sushi__cell--full"},[_vm._v("\n            "+_vm._s(_vm.emptyStateText)+"\n          ")])]:[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-shares-sushi__cell order-book-shares-sushi__cell--price"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-shares-sushi__cell order-book-shares-sushi__cell--quantity"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-shares-sushi__cell order-book-shares-sushi__cell--action"},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticClass:"order-book-shares-sushi__date order-book-shares-sushi__date--placeholder"},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticClass:"order-book-shares-sushi__icon order-book-shares-sushi__icon--placeholder"})]],2)}),_vm._v(" "),(_vm.isCardEmpty)?_c('div',{staticClass:"order-book-shares-sushi__empty-card-message"},[(_vm.isLoggedIn)?[_vm._v("\n          You have no holdings.\n        ")]:[_c('button',{staticClass:"order-book-sushi__empty-card-link",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.loginClicked($event)}}},[_vm._v("Login")]),_vm._v(" to see your holdings.\n        ")]],2):(_vm.isScrollableEmpty)?_c('div',{staticClass:"order-book-shares-sushi__empty-card-message"},[(_vm.isLoggedIn)?[_vm._v("\n          You have no holdings.\n        ")]:[_c('button',{staticClass:"order-book-sushi__empty-card-link",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.loginClicked($event)}}},[_vm._v("Login")]),_vm._v(" to see your holdings.\n        ")]],2):_vm._e()],2)],2),_vm._v(" "),(_vm.showAllItemsNotice)?_c('div',{staticClass:"order-book-sushi__footer"},[_c('div',{staticClass:"order-book-sushi__footer-cell order-book-sushi__footer-cell--show-all",on:{"click":_vm.toggleShowAll}},[(!_vm.showAll)?[_vm._v("Show All")]:[_vm._v("Show Less")]],2)]):_vm._e(),_vm._v(" "),(_vm.cardLayout && !_vm.isCardEmpty)?_c('div',{staticClass:"order-book-sushi__footer order-book-shares-sushi__notice"},[_c('div',{staticClass:"order-book-sushi__footer-cell order-book-sushi__footer-cell--price-links"},[_vm._v("\n      Positions sold in order of purchase.\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "54E+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: 'sushi'
    }
  },
  data: function data() {
    return {
      isOn: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('dashboard', ['mySharesCount']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'dashboard-markets-toggle': true
      }, 'dashboard-markets-toggle--' + this.theme, this.theme);
    },
    buttonText: function buttonText() {
      return this.isOn ? 'Close All' : 'Open All';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('dashboard', ['setMarketsToggle']), {
    onClick: function onClick() {
      this.isOn = !this.isOn;
      this.setMarketsToggle(this.isOn);
    }
  })
});

/***/ }),

/***/ "5CwS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "5IfR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5MMF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_balance_history_balance_history_item_balance_history_item_vue__ = __webpack_require__("FSWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");








var NO_ITEMS_MESSAGE = 'No transactions to display';
var NO_MORE_ITEMS_MESSAGE = 'No further transactions';

var BASIC_COLUMN_SET = ['DEPOSITS', 'PROMOTIONS'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__["a" /* default */]],
  props: {
    type: {
      type: String
    },
    items: {
      type: Array
    },
    canLoadMore: {
      type: Boolean,
      default: true
    }
  },
  components: {
    balanceHistoryItem: __WEBPACK_IMPORTED_MODULE_4__components_balance_history_balance_history_item_balance_history_item_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      loadedInfo: NO_ITEMS_MESSAGE,
      infiniteLoader: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    loaderNum: function loaderNum() {
      return this.isLayoutMobile ? 2 : 5;
    },
    stickyOptions: function stickyOptions() {
      return this.isLayoutMobile ? __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile : __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].desktop;
    },
    showAdditionalColumns: function showAdditionalColumns() {
      return !BASIC_COLUMN_SET.includes(this.type) && this.isLayoutDesktop;
    },
    amountColumnModifiers: function amountColumnModifiers() {
      return {
        column: true,
        'text-center': true,
        'small-4': !this.showAdditionalColumns,
        'small-2': this.showAdditionalColumns
      };
    },
    typeColumnModifiers: function typeColumnModifiers() {
      return {
        column: true,
        'text-left': true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns
      };
    },
    statusColumnModifiers: function statusColumnModifiers() {
      return {
        column: true,
        'text-right': true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns
      };
    }
  }),
  watch: {
    items: {
      handler: 'itemsHandler',
      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onFeeInfoClick: function onFeeInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_FEE_INFO);
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;
      this.$emit('loading', infi);
    },
    itemsHandler: function itemsHandler(newValue, oldValue) {
      if (newValue.length > 0) {
        this.isComponentReady = true;
        if (this.infiniteLoader) {
          this.infiniteLoader.loaded();
          if (!this.canLoadMore) {
            this.infiniteLoader.complete();
          }
        }
        this.loadedInfo = NO_MORE_ITEMS_MESSAGE;
      } else if (typeof oldValue === 'undefined') {
        this.loadedInfo = NO_ITEMS_MESSAGE;
        this.isComponentReady = true;
      }
    }
  })
});

/***/ }),

/***/ "5QOt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5RCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    shutdown: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.shutdown) {
        window.location.href = 'https://twitter.com/PredictIt';
      } else {
        this.$router.push({ name: 'research' });
      }
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'research-widget': true
      }, 'research-widget--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "5WGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_history_js__ = __webpack_require__("RdAN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cac48068_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_history_vue__ = __webpack_require__("VYlq");
function injectStyle (ssrContext) {
  __webpack_require__("jSv/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cac48068_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5X5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":_vm.name}},[_c('div',{staticClass:"radio__input"},[_c('input',{attrs:{"type":"radio","name":_vm.name,"required":_vm.required,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked === _vm.value},on:{"change":_vm.onChange}})]),_vm._v(" "),_c('div',{staticClass:"radio__label",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Xc3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5XgW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials-loader"},[_c('div',{staticClass:"socials-loader__item"}),_vm._v(" "),_c('div',{staticClass:"socials-loader__item"}),_vm._v(" "),_c('div',{staticClass:"socials-loader__item"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5aqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationLoader_vue__ = __webpack_require__("U7LV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738afbd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationLoader_vue__ = __webpack_require__("J6HH");
function injectStyle (ssrContext) {
  __webpack_require__("lPAh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738afbd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5c7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-markets"},[(_vm.isLayoutDesktop)?[_c('div',{staticClass:"page-markets__desktop-header"},[(_vm.showInitialSpinner)?_c('div',{staticClass:"page-markets__desktop-header-skeleton"},[_c('div',{staticClass:"page-markets__desktop-header-line page-markets__desktop-header-line--title"}),_vm._v(" "),_vm._m(0)]):[_c('market-list-desktop-header',{ref:"desktopHeader",attrs:{"title":_vm.currentHeaderName,"count":_vm.filteredMarkets.totalCount,"layout":_vm.marketDisplay,"embedded":_vm.embedded},on:{"toggle":_vm.onLayoutToggle}})]],2)]:_c('div',{staticClass:"page-markets__mobile-header-wrapper"},[_c('div',{staticClass:"page-markets__mobile-header-container"},[(_vm.showInitialSpinner)?_c('div',{staticClass:"page-markets__mobile-header-skeleton"},[_c('div',{staticClass:"page-markets__mobile-header-line page-markets__mobile-header-line--title"}),_vm._v(" "),_c('div',{staticClass:"page-markets__mobile-header-line"})]):[_c('market-section-header',{ref:"mobileHeader",staticClass:"page-markets__mobile-header",attrs:{"title":_vm.currentHeaderName,"count":_vm.filteredMarkets.totalCount}}),_vm._v(" "),_c('market-filters-mobile',{staticClass:"page-markets__mobile-filters",attrs:{"embedded":_vm.embedded}})]],2)]),_vm._v(" "),(_vm.showInitialSpinner)?_c('div',{staticClass:"page-markets__grid page-markets__grid--loading"},_vm._l((_vm.marketSkeletonCount),function(index){return _c('div',{key:index,staticClass:"page-markets__grid-item"},[_vm._m(1,true)])}),0):(_vm.items.length > 0)?_c('div',{staticClass:"page-markets__grid"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"page-markets__grid-item"},[_c('market-list-item',{key:item.marketId,attrs:{"layout":_vm.marketDisplay,"market":item}})],1)}),0):_vm._e(),_vm._v(" "),(_vm.filteredMarkets.canLoadMore && _vm.marketsPageInitialLoadDone)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[(_vm.showSpinner)?_c('div',{staticClass:"page-markets__spinner"}):_vm._e()]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e(),_vm._v(" "),(_vm.showNoMarketsMessage)?_c('div',{staticClass:"page-markets__no-markets-found"},[_vm._v("\n  No Markets Found. "),_c('br'),_vm._v("\n  Please Adjust Filters\n")]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-markets__desktop-header-filters"},[_c('div',{staticClass:"page-markets__desktop-header-line page-markets__desktop-header-line--label"}),_vm._v(" "),_c('div',{staticClass:"page-markets__desktop-header-chip"}),_vm._v(" "),_c('div',{staticClass:"page-markets__desktop-header-chip"}),_vm._v(" "),_c('div',{staticClass:"page-markets__desktop-header-chip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-markets__skeleton-card"},[_c('div',{staticClass:"page-markets__skeleton-card-inner"},[_c('div',{staticClass:"page-markets__skeleton-image"}),_vm._v(" "),_c('div',{staticClass:"page-markets__skeleton-main"},[_c('div',{staticClass:"page-markets__skeleton-title"}),_vm._v(" "),_c('div',{staticClass:"page-markets__skeleton-contract page-markets__skeleton-contract--primary"}),_vm._v(" "),_c('div',{staticClass:"page-markets__skeleton-contract"}),_vm._v(" "),_c('div',{staticClass:"page-markets__skeleton-meta"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5f2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_catchHtmlClickMixin__ = __webpack_require__("xO2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_instant_credit__ = __webpack_require__("zAJv");











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__helpers_catchHtmlClickMixin__["a" /* default */]],
  props: {
    formType: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].FORM_TYPE_IDV.INITIAL
    },
    trigger: {
      type: String,
      required: false,
      default: ''
    }
  },
  validations: function validations() {
    if (this.isSsn4) {
      return {
        fields: {
          street: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
          city: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].onlyCharacters,
          zipCode: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateUSZipCode('country'),
          country: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
          nscbStatus: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validatenNscbStatus('country'),
          taxId: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateSSN('country')
        }
      };
    }
    return {
      fields: {
        firstName: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].onlyCharacters,
        lastName: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].onlyCharacters,
        dateOfBirthDay: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
        dateOfBirthMonth: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
        dateOfBirthYear: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateIsAdult('dateOfBirthMonth', 'dateOfBirthDay'),
        street: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
        city: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].onlyCharacters,
        zipCode: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateUSZipCode('country'),
        country: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
        nscbStatus: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validatenNscbStatus('country'),
        taxId: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateSSN('country')
      }
    };
  },
  data: function data() {
    return {
      ready: false,
      years: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].birthYears,
      months: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].months,
      days: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].days,
      countryID: null,
      disclaimer: '',
      countries: [],
      showNscbStatusExplanation: false,
      fields: {
        nscbStatus: false,
        firstName: '',
        lastName: '',
        dateOfBirthDay: '',
        dateOfBirthMonth: '',
        dateOfBirthYear: '',
        street: '',
        city: '',
        zipCode: '',
        country: '',
        taxId: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    this.getVerifyID().then(function (response) {
      var data = response.data;
      _this.disclaimer = data.disclaimer;
      _this.countryID = data.countryID;
      _this.countries = data.countryList.map(function (el) {
        return {
          required: el.validatePostalCode,
          label: el.countryName,
          value: el.countryCode
        };
      });
      if (_this.countryID) {
        _this.fields.country = _this.countries.find(function (i) {
          return i.value === _this.countryID;
        }) || '';
      } else if (_this.countries.length === 1) {
        _this.fields.country = _this.countries[0];
      }

      if (_this.isSsn4) {
        _this.fields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.fields, {
          street: _this.userData.address,
          city: _this.userData.city,
          zipCode: _this.userData.postalCode
        });
      } else if (_this.formDataCache !== null) {
        _this.fields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.fields, _this.formDataCache);
      }

      _this.ready = true;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['formDataCache']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData', 'registrationFlowActive']), {
    title: function title() {
      return this.isSsn4 ? 'Identity Verification' : 'Personal Details';
    },
    submitLabel: function submitLabel() {
      return this.isSsn4 ? 'Continue' : 'Next';
    },
    showNoSolicitingNotice: function showNoSolicitingNotice() {
      return this.isNotUnitedStates;
    },
    isNotUnitedStates: function isNotUnitedStates() {
      return this.fields.country && this.fields.country.value && this.fields.country.value !== 'US';
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      return this.invalidOrDisabled;
    },
    errorNotAdult: function errorNotAdult() {
      var field = this.$v.fields.dateOfBirthYear;
      return field.$error ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_getValidationMessage__["a" /* default */])(field) : '';
    },
    zipCodeModifier: function zipCodeModifier() {
      return {
        column: true,
        'small-6': this.countries.length > 0,
        'small-12': this.countries.length === 0
      };
    },
    countriesModifier: function countriesModifier() {
      return {
        column: true,
        'small-6': this.countries.length > 0
      };
    },
    isSsn4: function isSsn4() {
      return this.formType === __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].FORM_TYPE_IDV.SSN4IDV;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getVerifyID', 'verifyID', 'getAccountDetail', 'logout', 'setSsnInfoVerified', 'endRegistrationFlow']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopupWithDelay', 'cacheFormData', 'setCurrentPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getBalance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    onCloseClick: function onCloseClick() {
      this.setCurrentPopup();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'ID Verification',
        action: 'submit',
        label: 'ID Verify Next'
      });
      if (this.formIsValid() && this.formDisable()) {
        var payload = {};
        if (this.isSsn4) {
          payload = {
            address1: this.fields.street,
            city: this.fields.city,
            postalCode: this.fields.zipCode,
            countryID: this.fields.country.value,
            taxId: this.fields.taxId,
            formType: this.formType
          };
        } else {
          payload = {
            firstName: this.fields.firstName,
            lastName: this.fields.lastName,
            birthDay: this.fields.dateOfBirthDay.value,
            birthMonth: this.fields.dateOfBirthMonth.value,
            birthYear: this.fields.dateOfBirthYear.value,
            address1: this.fields.street,
            city: this.fields.city,
            postalCode: this.fields.zipCode,
            countryID: this.fields.country.value,
            taxId: this.fields.taxId,
            formType: this.formType
          };
        }
        if (this.showNoSolicitingNotice) {
          payload.nscbStatus = this.fields.nscbStatus ? 1 : 0;
        } else {
          payload.nscbStatus = -1;
        }
        this.verifyID(payload).then(function (data) {
          if (_this2.isNotUnitedStates) {
            window.location.href = data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('');
          }
          return _this2.formEnable();
        }).then(this.getAccountDetail).then(function () {
          _this2.$gtm.trackEvent({ event: 'PassIDV' });
          _this2.cacheFormData({});
          if (_this2.isSsn4) {
            _this2.setSsnInfoVerified();

            if (_this2.trigger === __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].FORM_TYPE_TRIGGERS.MODAL) {
              _this2.setCurrentPopupWithDelay({
                name: __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS,
                options: {
                  checkInstantCredit: __WEBPACK_IMPORTED_MODULE_9__services_instant_credit__["a" /* default */].checkIfCanRunAfterVerification()
                }
              });
            } else {
              _this2.setCurrentPopup();
            }
          } else {
            _this2.setCurrentPopupWithDelay({
              name: __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS,
              options: {
                checkInstantCredit: __WEBPACK_IMPORTED_MODULE_9__services_instant_credit__["a" /* default */].checkIfCanRunAfterVerification()
              }
            });
          }
          _this2.getBalance();
        }).catch(function (error) {
          _this2.$gtm.trackEvent({ event: 'FailIDV' });
          _this2.formHandleErrors(error);
        });
      }
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.cacheFormData(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.fields));
  }
});

/***/ }),

/***/ "5g2X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_withdraw_confirm_withdraw_confirm_vue__ = __webpack_require__("waMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_available_balance_available_balance_vue__ = __webpack_require__("3PvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");















var DEFAULT_ACCOUNT_TYPE = '1';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["b" /* formMixin */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__["a" /* default */],
    availableBalance: __WEBPACK_IMPORTED_MODULE_6__components_wallet_available_balance_available_balance_vue__["a" /* default */],
    notificationIcon: __WEBPACK_IMPORTED_MODULE_7__components_notification_icon_notification_icon_vue__["a" /* default */],
    withdrawConfirm: __WEBPACK_IMPORTED_MODULE_4__components_wallet_withdraw_confirm_withdraw_confirm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      newAccountMode: true,
      showConfirmation: false,
      error: '',
      fields: {
        amount: '',
        routingNumber: '',
        accountNumber: '',
        accountType: DEFAULT_ACCOUNT_TYPE
      }
    };
  },
  validations: function validations() {
    if (this.newAccountMode) {
      return {
        fields: {
          accountNumber: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].accountNumber,
          routingNumber: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].routingNumber,
          amount: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].withdrawalAmount(this.minWithdrawal, this.maxWithdrawal)
        }
      };
    }
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].withdrawalAmount(this.minWithdrawal, this.maxWithdrawal)
      }
    };
  },
  created: function created() {
    this.checkWithdrawAch();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('wallet', ['ach']), {
    accountTypes: function accountTypes() {
      var _this = this;

      var results = [];
      if (!this.ach || !this.ach.bankAccountTypes) return results;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.ach.bankAccountTypes).forEach(function (index) {
        var label = _this.ach.bankAccountTypes[index];
        if (label !== 'Unknown') {
          results.push({ index: index, label: label });
        }
      });
      return results;
    },
    accountDetails: function accountDetails() {
      var data = {
        routingNumber: this.fields.routingNumber,
        accountNumber: this.fields.accountNumber,
        accountType: this.fields.accountType,
        accountTypeLabel: this.accountTypeLabel
      };
      if (!this.newAccountMode) {
        data.accountId = this.ach.accountAchDetailId;
        data.accountLastFourDigits = this.ach.achAccountNumberLastFour;
      }

      return data;
    },
    accountTypeLabel: function accountTypeLabel() {
      var _this2 = this;

      if (this.accountTypes.length === 0) return '';
      return this.accountTypes.filter(function (item) {
        return item.index === _this2.fields.accountType;
      })[0].label;
    },
    availableBalance: function availableBalance() {
      return this.ach && this.ach.availableFundsString ? this.ach.availableFundsString : '$0.00';
    },
    restrictedFunds: function restrictedFunds() {
      return this.ach && this.ach.restrictedFundsString ? this.ach.restrictedFundsString : '';
    },
    minWithdrawal: function minWithdrawal() {
      return this.maxWithdrawal > 0 ? 1 : 0;
    },
    maxWithdrawal: function maxWithdrawal() {
      return this.ach ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["G" /* roundDown */])(this.ach.availableFunds) : 0;
    },
    isAmountFieldDisabled: function isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    errorMessage: function errorMessage() {
      return this.error || this.ach.errorMessage;
    },
    hasErrorMessage: function hasErrorMessage() {
      return this.error || !!this.ach.errorMessage;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getWithdrawAch']), {
    onSubmit: function onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess: function onSuccess() {
      this.fields.amount = '';
      this.fields.routingNumber = '';
      this.fields.accountNumber = '';
      this.fields.accountType = DEFAULT_ACCOUNT_TYPE;
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawAch();
      this.$emit('success');
    },
    onEdit: function onEdit() {
      this.showConfirmation = false;
    },
    onChangeAccount: function onChangeAccount() {
      this.newAccountMode = true;
    },
    showRoutingNumberModal: function showRoutingNumberModal() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_ROUTING_NUMBER);
    },
    checkWithdrawAch: function checkWithdrawAch() {
      var _this3 = this;

      this.getWithdrawAch().then(function (data) {
        _this3.checkDocumentUploadFlags(data);
        _this3.newAccountMode = !data.hasSavedAccount;
        _this3.isComponentReady = true;
      }).catch(function (error) {
        _this3.isComponentReady = true;
        _this3.error = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.message', '');
      });
    }
  })
});

/***/ }),

/***/ "5jEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_video_view_js__ = __webpack_require__("8ofP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3307b4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_view_vue__ = __webpack_require__("a+EO");
function injectStyle (ssrContext) {
  __webpack_require__("z/s/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_video_view_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3307b4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5n65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_settings_modal_js__ = __webpack_require__("Vgn4");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09488ef8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_settings_modal_vue__ = __webpack_require__("f+P6");
function injectStyle (ssrContext) {
  __webpack_require__("pfo7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_settings_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09488ef8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_settings_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5r1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_account_js__ = __webpack_require__("h/F2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78366694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_account_vue__ = __webpack_require__("wLE9");
function injectStyle (ssrContext) {
  __webpack_require__("XaR5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_account_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78366694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5v01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-withdrawal-loader"},[_c('div',{staticClass:"account-withdrawal-loader__row account-withdrawal-loader__row--first"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5y3J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    colorDisabled: {
      type: String,
      default: '#263b1e'
    },
    color: {
      type: String,
      default: '#000000'
    },
    name: {
      type: String,
      required: true
    },
    checked: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'charts-checkbox': true,
        'charts-checkbox--checked': this.checked
      };
    },
    tickClassModifiers: function tickClassModifiers() {
      return {
        'charts-checkbox__tick': true,
        'charts-checkbox__tick--checked': this.checked
      };
    },
    styleModifiers: function styleModifiers() {
      var color = this.checked ? this.color : this.colorDisabled;
      return {
        border: 'solid 2px ' + color
      };
    }
  },
  methods: {
    onChange: function onChange(e) {
      var _this = this;

      this.show = false;
      this.$emit('change', e.target.checked);
      setTimeout(function () {
        _this.show = true;
      }, 0);
    }
  }
});

/***/ }),

/***/ "5yVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_vue__ = __webpack_require__("PUmN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_contract_horizontal_sushi_common_betslip_market_contract_horizontal_sushi_common_betslip_vue__ = __webpack_require__("M+zr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_contracts_list_header_sushi_market_contracts_list_header_sushi_vue__ = __webpack_require__("uN8r");






var NARROW_CONTAINER_WIDTH = 900;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    market: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isNarrowContainer: false,
      containerResizeObserver: null
    };
  },

  components: {
    marketContractHorizontalSushi: __WEBPACK_IMPORTED_MODULE_2__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_vue__["a" /* default */],
    marketContractHorizontalSushiMobile: __WEBPACK_IMPORTED_MODULE_3__components_market_market_contract_horizontal_sushi_common_betslip_market_contract_horizontal_sushi_common_betslip_vue__["a" /* default */],
    marketContractsListHeaderSushi: __WEBPACK_IMPORTED_MODULE_4__components_market_market_contracts_list_header_sushi_market_contracts_list_header_sushi_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('onboarding', ['showOnboardingStep']), {
    updateContainerLayoutMode: function updateContainerLayoutMode() {
      var containerWidth = this.$el ? this.$el.clientWidth : 0;
      this.isNarrowContainer = containerWidth > 0 && containerWidth < NARROW_CONTAINER_WIDTH;
    },
    teardownResizeObserver: function teardownResizeObserver() {
      if (this.containerResizeObserver) {
        this.containerResizeObserver.disconnect();
        this.containerResizeObserver = null;
      }
    },
    setupResizeObserver: function setupResizeObserver() {
      var _this = this;

      this.teardownResizeObserver();
      this.updateContainerLayoutMode();
      if (typeof ResizeObserver === 'undefined' || !this.$el) {
        return;
      }
      this.containerResizeObserver = new ResizeObserver(function () {
        _this.updateContainerLayoutMode();
      });
      this.containerResizeObserver.observe(this.$el);
    },
    onContractClick: function onContractClick(data) {
      var contractId = data.contractId,
          operationValue = data.operationValue;

      var no = operationValue === 'no' ? true : undefined;
      var route = {
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl
        },
        query: {
          contractId: contractId,
          no: no
        }
      };
      if (!this.openNewTab) {
        this.$router.push(route);
      } else {
        var resolved = this.$router.resolve(route);
        window.open(resolved.href, "_blank");
      }
    }
  }),
  mounted: function mounted() {
    this.setupResizeObserver();
  },
  beforeDestroy: function beforeDestroy() {
    this.teardownResizeObserver();
  }
});

/***/ }),

/***/ "5ywO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5zJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-links"},[_c('div',{staticClass:"sushi-market-links__title"},[_c('div',{staticClass:"sushi-market-links__title-text"},[_vm._v("\n      Market Lists\n    ")]),_vm._v(" "),(_vm.isPinningEnabled)?_c('sushi-market-links-toggle'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"sushi-market-links__content"},[_c('div',{staticClass:"sushi-market-links__header"},[_c('div',{staticClass:"sushi-market-links__header-1"},[_vm._v("Watchlist")]),_vm._v(" "),(!_vm.isWatchlistEmpty && !_vm.isWatchlistLoading)?[_c('div',{staticClass:"sushi-market-links__header-2"},[_vm._v("Top Contracts")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-links__header-3"},[_vm._v("Volume")])]:_vm._e()],2),_vm._v(" "),(_vm.showWatchlist)?_c('watchlist-sushi',{attrs:{"type":"standalone"},on:{"loading":function($event){_vm.isWatchlistLoading = true},"loaded":function($event){_vm.isWatchlistLoading = false}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sushi-market-links__line"}),_vm._v(" "),_c('div',{staticClass:"sushi-market-links__header"},[_c('div',{staticClass:"sushi-market-links__header-1"},[_vm._v("Session List")]),_vm._v(" "),(!_vm.isSessionHistoryEmpty)?_c('div',{staticClass:"sushi-market-links__header-2"},[_vm._v("Contracts Visited")]):_vm._e()]),_vm._v(" "),_c('session-history-sushi',{attrs:{"type":"standalone"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "61DT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_js__ = __webpack_require__("NSIw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63450543_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_vue__ = __webpack_require__("6JIL");
function injectStyle (ssrContext) {
  __webpack_require__("SOQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63450543_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "62Q9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"wallet"},[(_vm.isLayoutMobile)?_c('content-header',{staticClass:"content-header--account",attrs:{"title":_vm.capitalizeFirstLetter(_vm.activeTab),"returnRoute":"profile"}}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.gridRowModifier},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 wallet__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[(!_vm.hasMaintenance)?[(_vm.isLayoutMobile && !_vm.isShutdownModeOn)?_c('div',{staticClass:"wallet__tabs"},[_c('tabs',{attrs:{"activeTab":_vm.activeTab,"items":_vm.tabs},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),(!_vm.isLayoutMobile)?_c('account-desktop-header',{attrs:{"title":_vm.capitalizeFirstLetter(_vm.activeTab),"activeTab":_vm.activeTab,"tabs":_vm.tabs},on:{"tabChange":_vm.tabChange}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wallet__content"},[(_vm.showDepositTab)?_c('deposit'):_vm._e(),_vm._v(" "),(_vm.showWithdrawTab)?_c('withdraw'):_vm._e()],1)]:[_c('div',{staticClass:"wallet__content-maintenance"},[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n            Due to site maintenance, it is not possible to deposit or withdraw funds at this time. Please try again later.\n          ")])],1)]],2)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "62Vb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_watchlist_sushi_js__ = __webpack_require__("JvIk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9128ff4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_watchlist_sushi_vue__ = __webpack_require__("Z+l7");
function injectStyle (ssrContext) {
  __webpack_require__("DtY3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_watchlist_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9128ff4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_watchlist_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "63Fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function set(key, value) {
  var data = {
    value: value
  };
  sessionStorage.setItem(key.toString(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function get(key, defaultValue) {
  try {
    var data = JSON.parse(sessionStorage.getItem(key.toString()));
    if (data !== null) {
      return data.value;
    }
  } catch (e) {
    sessionStorage.removeItem(key.toString());
  }
  return defaultValue || null;
}

function del(key) {
  sessionStorage.removeItem(key.toString());
}

/* harmony default export */ __webpack_exports__["a"] = ({
  set: set,
  get: get,
  del: del
});

/***/ }),

/***/ "63o8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "65ef":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6636":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "67/Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "680R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_session_history_sushi_session_history_sushi_vue__ = __webpack_require__("84WW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_history_sushi_product_history_sushi_vue__ = __webpack_require__("4gzO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchlist_sushi_watchlist_sushi_vue__ = __webpack_require__("62Vb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sushi_market_links_toggle_sushi_market_links_toggle_vue__ = __webpack_require__("S77G");







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showWatchlist: false,
      isWatchlistLoading: false
    };
  },

  components: {
    sessionHistorySushi: __WEBPACK_IMPORTED_MODULE_2__components_session_history_sushi_session_history_sushi_vue__["a" /* default */],
    productHistorySushi: __WEBPACK_IMPORTED_MODULE_3__components_product_history_sushi_product_history_sushi_vue__["a" /* default */],
    watchlistSushi: __WEBPACK_IMPORTED_MODULE_4__components_watchlist_sushi_watchlist_sushi_vue__["a" /* default */],
    sushiMarketLinksToggle: __WEBPACK_IMPORTED_MODULE_5__components_sushi_market_links_toggle_sushi_market_links_toggle_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isPinningEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['market', 'sessionHistory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['watchlist']), {
    isWatchlistEmpty: function isWatchlistEmpty() {
      return this.watchlist.data === null ? true : this.watchlist.data.length === 0;
    },
    isSessionHistoryEmpty: function isSessionHistoryEmpty() {
      return this.sessionHistory.length === 0;
    }
  }),
  watch: {
    isActive: {
      handler: function handler(isActive) {
        if (isActive && !this.showWatchlist) {
          this.showWatchlist = true;
        } else {
          this.showWatchlist = false; // necessary show it reloads when coming back
        }
      },

      immediate: true
    }
  }
});

/***/ }),

/***/ "6ALX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Aew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messaging-journey-info"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"messaging-journey-info__buttons"},[_c('div',{staticClass:"button button--primary button--medium messaging-journey-info__button",on:{"click":_vm.onOptIn}},[_vm._v("\n      Opt In (tries to show native window)\n    ")]),_vm._v(" "),_c('div',{staticClass:"button button--primary button--medium",on:{"click":_vm.onOptOut}},[_vm._v("\n      Opt Out (info stored in browser)\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messaging-journey-info__note"},[_vm._v("\n    Copy for user whether or not he'd like to receive notifications.\n    "),_c('br'),_vm._v("\n    API Call required on opt in\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Bn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


function setSrc(el, binding) {
  el.setAttribute('src', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["C" /* getAssetPath */])(binding.value));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setSrc(el, binding);
  }
});

/***/ }),

/***/ "6DHL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIzMSIgdmlld0JveD0iMCAwIDE0IDMxIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEzLjQzNiAxNS4xNTRIOS4yODR2MTUuMjEzSDIuOTkyVjE1LjE1NEgwVjkuODA4aDIuOTkydi0zLjQ2QzIuOTkyIDMuODc0IDQuMTY3IDAgOS4zNCAwTDE0IC4wMnY1LjE5aC0zLjM4MWMtLjU1NSAwLTEuMzM1LjI3Ni0xLjMzNSAxLjQ1NnYzLjE0N2g0LjcwMmwtLjU1IDUuMzQxeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "6Fjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_table_js__ = __webpack_require__("AZoq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8121c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_table_vue__ = __webpack_require__("OFlW");
function injectStyle (ssrContext) {
  __webpack_require__("+oQ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_table_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8121c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6JIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register"},[_c('div',{staticClass:"account-register__socials"},[_c('form-socials',{attrs:{"title":"Sign Up with"}})],1),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12 row-y"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":1,"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"validation":_vm.$v.fields.email,"autocomplete":"off","gtm":"Registration,Email","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":2,"disabled":_vm.isFormDisabled,"name":"emailConfirmation","type":"email","required":true,"validation":_vm.$v.fields.emailConfirmation,"autocomplete":"off","gtm":"Registration,Confirm Email","placeholder":"Confirm Email"},on:{"input":_vm.$v.fields.emailConfirmation.$touch},model:{value:(_vm.fields.emailConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "emailConfirmation", $$v)},expression:"fields.emailConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{ref:"password",attrs:{"hideIconOnValue":false,"tabindex":3,"disabled":_vm.isFormDisabled,"name":"password","type":_vm.fieldTypePassword,"required":true,"validation":_vm.$v.fields.password,"autocomplete":"new-password","gtm":"Registration,Password","placeholder":"Password"},on:{"input":_vm.$v.fields.password.$touch},model:{value:(_vm.fields.password),callback:function ($$v) {_vm.$set(_vm.fields, "password", $$v)},expression:"fields.password"}},[(!_vm.isIE)?_c('show-password-icon',{attrs:{"slot":"icon"},on:{"showPassword":_vm.showPassword},slot:"icon"}):_vm._e()],1)],1),_vm._v(" "),(_vm.showUsername)?[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"account-register__username-wraper"},[_c('form-input',{attrs:{"tabindex":4,"disabled":_vm.isFormDisabled,"name":"nickname","type":"text","required":true,"validation":_vm.$v.fields.username,"autocomplete":"off","gtm":"Registration,User Name","placeholder":"Username"},on:{"input":_vm.$v.fields.username.$touch},model:{value:(_vm.fields.username),callback:function ($$v) {_vm.$set(_vm.fields, "username", $$v)},expression:"fields.username"}})],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('p',{staticClass:"account-register__disclaimer"},[_vm._v("\n          By clicking \"Create Account\", you confirm that you are at least 18 years of age and have read the "),_c('router-link',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"to":{ name: 'terms-and-conditions' }}},[_vm._v("Terms and Conditions")]),_vm._v(". One account per person.\n        ")],1)])]),_vm._v(" "),_c('form-submit',{attrs:{"disabled":_vm.registerButtonDisabled,"loading":_vm.isFormDisabled,"label":"Create Account"}}),_vm._v(" "),_vm._m(1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v("Sign Up using your email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recaptcha-terms"},[_vm._v("\n          Protected by reCAPTCHA ·\n          "),_c('a',{attrs:{"href":"https://policies.google.com/privacy","target":"_blank"}},[_vm._v("Privacy")]),_vm._v("\n          ·\n          "),_c('a',{attrs:{"href":"https://policies.google.com/terms","target":"_blank"}},[_vm._v("Terms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6JQ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw"},[(_vm.showTabs)?_c('div',{staticClass:"withdraw__tabs"},[_c('tabs',{attrs:{"activeTab":_vm.activeTab,"items":_vm.tabs,"theme":"add-funds"},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"withdraw__content"},[(_vm.showAchTab)?_c('ach',{on:{"success":_vm.onSuccessWithdraw}}):_vm._e(),_vm._v(" "),(_vm.showCheckTab)?_c('check',{on:{"success":_vm.onSuccessWithdraw}}):_vm._e(),_vm._v(" "),(_vm.showCryptoTab)?_c('coinbase-withdraw',{on:{"success":_vm.onSuccessWithdraw}}):_vm._e(),_vm._v(" "),(_vm.showBankTransferTab)?_c('bank-transfer',{on:{"success":_vm.onSuccessWithdraw}}):_vm._e(),_vm._v(" "),(_vm.showPendingTab)?_c('pending-requests'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6M/o":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/7gAmQWRvYmUAZMAAAAABAwAVBAMGCg0AAAbMAAAP0wAAFuIAACBd/9sAhAABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgICAgICAgICAgIDAwMDAwMDAwMDAQEBAQEBAQIBAQICAgECAgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwP/wgARCABjAJsDAREAAhEBAxEB/8QBDwABAAEFAQEBAAAAAAAAAAAAAAECBAUGBwMICQEBAAIDAQEAAAAAAAAAAAAAAAECAwQFBgcQAAEDAwQBAwMEAgMAAAAAAAABAgMSBAUREwYXFRBAITAxFCBgMwdQIkEkFhEAAQMCAgMMBAkFEQAAAAAAAgEDBAAFERIhMdTwQVGBIhMUlDWVBjZhMiMVQHGRobFCM3QW4fFSkkMQIDBQwdGCorLC4nOzNERVBxIAAQICBgYIBAQHAAAAAAAAAQARIQIxUaESMgMQQWFxEwQgQGCBkcHRIrFCUiMw8OGS8WJygjM0BRMBAAECBQMEAgMBAQEAAAAAAREAIfAxQVFhcZGhEIHR8UCxMMHhIGBQ/9oADAMBAAIRAxEAAAH9xslbJAAAAAAAAFZlon86trX8kAAAAAAAACo+HM+K3QAAAAAAAAKzulMngAAAAAADXsPQ1bB1Oh7nnveaVn63+Z34rMAElvMe0SBJSSSaBbvZXTruWfj8jx+p3/Y81lY1sZ8+6FOC0kGg7+LEZo4V3dbsnGz7Jr36Dzcuv7NLazaNW8Hyx7TqZDied9U9kplxU+o6NyPPzmrThshre1TBZ45L19fqfKzWd1xVdVnMYLbZqX85Vnzl7Dr5Diedqh1m2TV6+n6TyvP5/wCxciAYGzWJr0WlgAAAOJa/ZymHd3LLo6Nr9rqm/wCSur4q5QAAAAAAcxti0la8w7/eMmmIKiAAAAAAAAAJiYmAAAAAAAAACsoAAAAAAAAB6oysWwwAAAEwABARKR6zGz47f//aAAgBAQABBQKaZ8jtVNVNVNVNVNVNVNVNVNVNVNVNVNVNVNVNVEc5F/Mfo/8Auudr+7Zzu2c7tnO7Zzu2c7tnO7Zzu2c7tnO7Zzu2c7tnO7Zzu2c7tnO7Zzu2c7tnO7ZyX+X2cn9cc0WTrfmp1vzU635qdb81Ot+anW/NTrfmp1vzU635qdb81Ot+anW/NTrfmp1vzUvuG8ixgzEX8jov685hPH1vzU635qbjNd1pusN1pusNxpLdQQRbzDejN1husN5hvMN1plsjePusbhcNiFluGTsvMOuJLLI2uQtN1g776KafP/F/lrlbuPMyYi4zWfyOXyVjc+CgxPIPK3KqX+Tx+MZirq/u4dRU1MDy+OLil3ynkGKnZynOyXnE8zNl8bhokscloo/7/B9jL3/i8bYxWvHsSuGzHIeUX3GLDIZSfh+Guoo+H8ft2f8Al8SpaYTE41yFS66GC4tj0xUnCry8G8NvGScbwkeIsMDN+fc/H6Mnj4spY2+Bkfc/R5jc2mLMdzbC3scmd43C25v7rlLLe3htYPr8p40zldne8JvcpeYjg8WLzH+LcmjvZUuLzTc9izTU/9oACAECAAEFAvaUFBQUFBQUFBQUFBQUFBQUFBQUFHtakKkKkKkKkKkKkKkKkKkKkKkKkKkKkHTRsPy7dStqlSFSC5C1RfI2h5G0PI2h5G0PIWol/bKvkLU8jaHkLU8jaHkbU8hankbUS7ZKNurJh+fZqMmiVVyFsh5G1JP5PWOJtOykrYbeOKN7d9ZbfbaRxSSrK1jF9GwURNhiemxFSn/Wur1iNmJP5PSKPckerriXeitrVl0+OJt5M1VvLhx+VKPmmk/RHM+WH8lrT8hujNbm5u31ymiGiGiHwh8GiGiGiGiGiGiGiGiGiD4qhJWm5CfMwjWomifXRdD4VKI0/an/2gAIAQMAAQUC9pUVlZWVlZWVlZWVlZWVlZWVlZWV+1pUpUpUpUpUpUpUpUpUpUpUpUpUpUpUhs7q5HYbJtR0b2LSpSpQ423G2423G2423FDihxtuNtxtuNtxtuNtxaWsdFxeXU43dYsdwl4kttLDJtuE+3qqlWg5yqqf6iO19FVEE19b6TbtVe5pW7Vq1svF3YRPt6OXRE/1SlXPViKtDVKGlCCNRP0XkaSWe2qm2oiUNvk2m/XtLxluSY2VyNx985WRw4we98j/AK7m1Ddxjlurx37U/9oACAECAgY/AuxfuKxJwdLEx3FYrCqbCsVhWKwrFYUwJfcVTYVisKpsKxWFU2FYrCqbCmyKfgsTzVsVE2FGbljRSExMdxWKwqbf0OLmwy7Tu9UJuWBpYilHMMwcY21CoGs0FcY3cvJ1foNaE7vKd4+OhpArshvV1Ps0nJlxGcSP3xQzJb3D9z1+0PVrsXGjwrrtrpaltlSF2iHgdJ36RJWmkEKANn5pRyckvnmkj1q1LggS3HeIRmhxDraI3VL3EHeAfJQu/tl9E08xazoGeX/KJr3hSrskv24wf6g38Fcu/Zuszxpelq9iGoeQT9KH4TyQnCu5guzKkJpIZdfomA6ixEFCUdlP/9oACAEDAgY/Auxf2JJpk5yjYfgVdnBE3UZub5v/AFpNX1TfT6q5gyNUssB+ver0riZDlv8Ao0/Lma5TtrG9HKnxSnpMKV7k3grtJTaIqOnl8v5eDxO+Z/RXS16FquQvP5OorI5k4pstj/aWfouoq8cKva1s0a/EqHQyM75BJwjsajxBTk+6Fid/e7+SZZXK/Nl5cd80SOoHJ5gXuUzMWyojaFxeTPG5f+WnvlpBTDKzP2lcXmCJ+dGGQREprm3VI5k8ZyeoNqQnkmInFUE0+bmGX+o9lP/aAAgBAQEGPwJdK5cdCVrXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1rXdx1ihKnHXp5vDUnr5vW/Voh/DrWglTtI95fuVeXWu8z2KvLrXeZ7FXl1rvM9iry613mexV5da7zPYq8utd5nsVeXWu8z2KvLrXeZ7FXl1rvM9iry613mexV5da7zPYq8utd5nsVeXWu8z2KvLrXeZ7FXl1rvM9iry613mexV5da7zPYq8utd5nsVeXWdX/Znw/cqc/zD/tL8D4v71GqWN3BTJf8Ad2/h+912G71u3bXXYbvW7dtddhu9bt2112G71u3bXXYbvW7dtddhu9bt2112G71u3bXXYbvW7dtddhu9bt2112G71u3bXXYbvW7dtddhu9bt2112G71u3bXXYbvW7dtdJ0+C3FVUxEXrjbBcJOEGumc4afElZBbaRccPaS4bQ/ruvgGHHQus2dXmjTEHGp1tNs04RMZiiSV2G71u3bXXYbvW7fw/e61761v1r9Fb/wAi/ub9G884LTLQqbjrhIDbYj6xGZaBRK169Va/TX5K361r8i1rrf8AkqLY7Ll96zxJ0pDg5mbZABcr094dRKi8lsV0KXyLzjTKT7kq5pF4uCdKmvO4YE4BO5ujgvAOCYcOuiakNsyWTTKbLzDbrZCu8QKOCotO3nwqBNc1i9c/DyKSw5zCLi67BbVV6LMbDUgpguGCJvExNjnmYkto4Crr06xJMdBgWhU4UrXvY8WNYY75LvbtVfn+jBK0pw79YcW/h8+Ne6bQw1JuOQXJLsgjSHbGD9R2arS84br/AOyZHAiTSqiOmpMPxJMgtgEXp8O5A2UCPJYExZlMKy9JlZZMZ5wNAkXOC4OCY41GgBbJLbM8C/DTEvKDc6YLjWF1ukRzF7oENs1eZAwQVUMVQtQhZmDn+Jrw0iyLi4r4+wcd5ZuzZcp5I0Flf2TWZTy6hXStSoixDjPw22HXVCTDmxiR/NzY9KhuuIL2A45CyllVF1V+T+ZFSucmSmmVLQ2GKk88S6EbjR2kJ+Q4q/VEVKnZE2J0EXHlWHFPRLGIgjzZzkTQ3IdLEsieoKoi6ca3vSuPD6SpNS8CpvfOqV4l/wDRH2MxT2iSFEDQTca22B++txOfLNgshhEFxcMOcTHDeSVZbgNnk3lz8LrbZUSPNj24C8TXeTZjGZFeuEuQ77rdik5iDzfSBVEwaWvw4K2gfEAeIJVnfuawprlq6JG8PRPESTW7WlzGVzrzFwaZ5rpnJPMWdURBWHcnwaZkpInw5bbGZWOlWu5S7TMVlXPacy69DJQx0oKpjXiW0Np7CFd+kRxHkoyxc2AljHFE0I02pLhXqrwb3q4avW10uPDu0crTXD830Vr0Lo14J+eps5G+dJhlVaZ1c7ILBuMzm0favmI+jGjfuEhOcxKZdpzi6ZM53DnTRE5ZYng20CIq5UEUSoF6vEPmLFBAnbfb5jjJEOLJI2UmKJGozHJGV0kLQACgriuoLy7IuTNwCKMRt2JK6OjcdOezg1yFMFe55cy45uDCo8Q0ltwGVMztzMt1mNNdcLMr9wIMsqZIxT1icVaUYsSRFDMq5YN0usQceHLGuDKY1y1uzvALviG/uB+qVyIVpXodujMPb8hAQ5R46FzyXEOSejhKkypw473y7+NaE9GPKX5tVcPxaE+PTXib/wA8kERwkjLJtapyZBW2dbHbLINsuUhOwoxI3my+vp+KTMul7CVezGwJAuEe1dFYgfhu4u3W3ksEpsrpRvzZBrJ9qCOAuUEbwoboF4Y/EnvuRe3bkVqJy2uuSLQ1Yjh+6feYvjCG2xmkBOl84jjaFnXFRWJbEeKRzDkiTJluijfPPzJb9xuElRTkso9KkmWXUOOFX6+D9ldbq50RcNDkGCAw473Lyr7VG1X0V/hHVu4v3kiA8Rtg+I4OtYI6y42YusvN4oQ52Xm0JMUVNFMTLzcXLw9EXNCaKO1EgxXcMOlJEaU0dmYanDIsn1EH+Ctd2KYlpnxn3xhXV4C93DkiuynYN2cH7KJNZjkIqv19CcokQo3vVHvDtwkMR3+j3KO8zHeCQiKD7D5tpzbRY6edQFFcUXUtKbniGy5URS9jOYkHgn6LTJEZL6E00VuszUmDYXuTcL3IbKPIuDGPKi2tkkRxGnx0E4SJoxTD9JqNHbFthhsWmmx1CAJlFOFdCfAGbVLmOx7Sr/PXKNHFRkTuaAigthMR0ViDFn5JC4ASmTQpoHNjaLndL8Eu4WOPCZgF7pEIJmponiB6db1nuBL9/wAURby5hSLlQgxKnLwsxiScspyzoZWxoIKIb4HafdLHPmNnK2RxVs1DP0vMpnysFT+K1RdaKqfA8fRm4s2T6a/Z46NWbPq+t9T4Fpy/08+H9TTX/H+x/l/0K//aAAgBAQMBPyG28UGwQZLlK1gmmCaYJpgmmCaYJpgmmCaYJpgmmCaYJpgmmCaYJpgmmCaDlRqIf3XC6Ayf88pqUTe86Qnrj8MyZMmTJkyZMmTJkyZMmTJmx1HYfiaGlUekJzRaPt/n69evXr169evXr169QFe0SCXGQZpRtFuSvkpysrQnCLn2XD6dbXFTsw2HZuZ6Vm7M4JjtUETCWE2vtdzrquRDvcqDVzjLXasjdlahn4qylKH3ViKlhLBK0dbbsUh7NE2ytGdX4l4u/wBrk3RDMTtnV+IHZB9y1qFkLjMjvG8VLESnKFgKtZK0XpWQ7A3ShP2OBoGIyZMrtVnEVjQbRrSqN4pYkmKhRXvG8Agtijm+hCreFYnPehLSnKSYmxcfZenNulpFyzwrdKhCCXJs6XkjVimWIdzK4RBe+VRBB0TJInDLOSE8hrEJoFO5Awq7QOIuRgkJm5FYwdSTNvGLkGMimY2a5cVPOzimVSixkhLKylpkDmhzrNuPLfHCqCTbKqEQT1mNNJCQK8yRM10T+6BqwKWZquuY4ob7h1UdY7UpLUUFrcqUifeRGJiA1ZjB/HkfAK0M90+sssx7tkxSW49xQUZ4HkKucur/AGL2pJEEnDIe2Z7YmrrTdDF1PJCYNZph/wB0A0ibqnZBhuMsv1xNErgKknKd/DhGYHL6oqcqd4kcKURqjNBYIBhGSd8i2KYOXUrizm7TgUmfsDFLi7egFpW6eM3vQNOz46dtuzbVLqdAs8EtqbVszUTf/SoaTqZBOyVua9ycRGObfMu8UXMpptit+LohpAbKrhTCYnaFIaJTnsh+LDZyYlgxGVKPjo1UjYfZjOM9f2pCWxm6VBt4qDbxUvDAuXsZUQbhKAsE7hAcaS5DJWYNvFQbeKg2PFQbeKg28VBt4qDbxUG3ioNvFLr5rOnux46XoAkanRdwLqLheqUf5KYZkdmwK0KGkmTwpmsJJpooOxVLNDMoZjdbtQbGfG1Ob1f5rZPU30Q68uMSvUgdS2KqV1kiQAAqGznuJ9c+f6pzer+H8/1Tm9X8P5/qkLQgOR/DtWW3zmRM1uNjhoe9trH4XB/6OPKtPlp//9oACAECAwE/Icvw4qO9ddddddddddddddddddddddddddddddddddddQ3oy/E5a5a5a5a5a5a5a5a5a5a5a5a5a5a5ayrKFQHsn9UCgJXLXLSJsHBauRg4rk4OK5FHIwcVzsHFDmnofBXPwcVyMHFc/BxXIwcVy8HFc7BxXLwcUDPL1RAat6XlUt5C+8fqkkLGDSpcTdCkm5OvT7TlgwZVysHFPuf21rU+lx2SAM3bo1VjlpaW5jIcxkCyTmEI0zA92a5ttQGSYEzbLqsYzjQCVuxHNRVIoWS3Ay5JJ9JAHfY5VsdWh8kF2Ahvr09ClSwk4MMNqhRCwo7AgM0XHqpCTKiRcuORmmeBFXBsFeyMPs3pUFvTzf79b3wK7savahbuxDL5W8rV9kwJ302CeSrapoDkJJbZ9It5oMz1AQ20DoUpLuGlVxrxXFkNvwy8enX0yBZHdU/KPaiBBz1Jbi8EQGi2bNKSqxxF3ImTshiKL0XSeDDPgIneiUZY/qPTgK4CuAoEkCtgArgK4CuArgK4CuArgK4CuApox5Lnh4or7py9nKkiXulLbt3JJt8qBEgrjP58xrTaRVZoL0P8AwBl+J//aAAgBAwMBPyH8SY5VLbHapbY7VLbHapbY7VLbHapbY7VLbHapbY7VLbHapbY7VLbHapbY7VLbHapbY7VLbHapbY7VLbHapbY7VLanP8Tg/nAAAAByOVCx1cj3al1nC3ZGlpRmNk9n0OCtvKsOGsOGsOGsOGsOGkruVcdYcNYcNYcNYcNYcNYcNXQyRBu2QdN1odwODDsk2g8pe1Aqg1GHuVHFO1vaD13PMZzqF/ERxs5nHo5H/Czn+BWizLPKrD2e7l4pQhNM12emaqaJEevttd5V+hApZlZETF0Xvp54ofgcxbJKJ5jOrhmue4p/VPrTm603Lr6ZHrJ0BOr61DDZkVIU2Uki+GtB5Ee7WF8lZEv/AMEq7eRO/wB0dKZkrIYjNJad8/6qD3hFsrInKI1qw7v7X/ak/IdLdpJ/y3IqHW/8UhQIGqM3p2HJ0q6dZOTOn6o1c98ge6kHvFK6yFsClpzB4Z1HTUld1q/88Sh5VUZdWTrV5OzFTiy/f/lP/9oADAMBAAIRAxEAABCf/wD/AP8A/wD/AP2BJJJJJJJJIJ//AP8A/wD/AP8A/wDzbbbbbbagKCFJmgoBOPbaErV7LQmxQmtxSMohpPfG2K22221AXP8A/wD/AP8A/wDdf/8A/wD/AP8A/wD/AP8A+f8A/wD/AP8A/wD/AP8Ar/8A/wD/AP8A/wD/APoJJJJJhPcI/wD/2gAIAQEDAT8QhJKvyYYwxKu9oLH3lH3lH3lH3lH3lH3lH3lH3lH3lH3lH3lH3lH3lH3lH3lH3lH3lDoaENE6XnGVZ6dB7C5nPdwRai0Mxno9J1Im3P4f/wD/AP8A/wD/AP8A/wD/AP8A/wD/AP8A/wD/AP8A+Y/QuROmdfxe8S4GR2eEpKy/nYsWLFixYsWLFixYsSoamrxEYohDmlEjACRSTyeYN6AyCe4g7RElCfFMcjdt77xqMpJAImYsyyrOtZKU5UqWQkoXm/FJkmQEngkhtE0KwNoZAlixmhMhtTMWETZwCbokE5e9DiFQndN8w/Vr31igdsPU/VMAloFMgASKZlxUMF40oSVwsRMhkhNi3J9tRIOVBAiyDpYxFsFiRBEBmISGGTxUJaM2oC0oIWi2dKXRZbgbRMMQ1JMaxFF1ZmxwaqSWM1CozrBUjwsbgxqxnAaVS/GLLpERoaogKTC3BkImkZinMRih0Fz2TGqy7A48tSClOGL57Lm+V9qPFS4LYiSlhgLe34igy+Ua0RiNmupqLC0mJipIGFwuiUiNFxFJIOReaEEMjumbJBZOOpTkoaxgmQInHj0yp0BLL+jInhreNP1UYTf2BaAkRKkBb7oHA+hDgBQ/KhOM8ysE3hlY3FvwdHB/tkNFmDCCn9kVUck6QNGKXEiVSAJTZEaBUHNDvy2Yt2TMnR33KCVkLl7ZfS7m9JYyiZVjo/bjnyRIrXZhMT0AhySRME1BuklMPsKHkFWuBZHDeSz/AKU4HYQUS2IkOSJs4ypVUrBIohmCUyuLESZMLYxsAEhbt18lPamcXZT9BMhwgbeKMuMCVzOElDooI0R+Rm7dVrfjSEgpYjiYVhILqdK/JBFqs1GRKCjjpSZjr2FATlY2LUT0ZQTuLoXqG3TYCA9WIVTBq0i2EgrNRJEFKVETo6GcDAMgy3u6U2zjJKZRN2wXJAEWCo7ZUUxJg7AtZAmcnUAmAztNVxYQKnANZIqJmoUpSrFlnHyrRcVnqLVCrbn1IcQhEXyNCzE6nL+JWmnjwN643ZXG7KOTLHx/aDpYyiND6OLOcnyzhTjdlcbsr6ynG7K43ZXG7K43ZXG7K43ZQmmSPa9i1qTacsXLkTpuER0idyIvH+GDoz0iQwZeSjZBSMHjKNV/2nD3GIJZnIqrc/U4YyrGN3+Zv4pGcXuYg9lEsbpTBvd5MMBUuJ86Ia+JhCn6nWnGN38PWjGN38PXDbTaEyIRQ5xmn4fc3ue8LJETF4i9fQ4XbqdjNo/hc/Yz6f8AeNfSy0LyJjOvExOSZvFWoz//2gAIAQIDAT8QAHP4cNtca0IT+tQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lQ+lYpWR0/EI+jmuN5rjea43muN5rjea43muN5rjea43muN5rjea43muN5rjeaDHg3N6Gb27VcAci7oMaaE0HJLj0SuN5rGKKjUJqD/YtXSKGZGOw1/VYg/ox4wNhhis/RwYf3TokATVcgBK8E1pXzH5fqnIuUJmKxsSUBcqhfjAYfNYcw70KahEoL2BKGVonObFMcwgkuKLJtkjfOpNDzljzDHaOuJoJ7iCB1aCGVEuYgbHZHuKbVhLDnL91BidTHipLrTjGfaKlGeWPPSoub+3++e9DvdCkLOSwWXiMAkU1STkuG6M2QTSiQSk14qLJmgQBEGgnsnjssFXG0nJYHMwAzcZYi3BkBG5CTrfGMqUDyVZBu0RqgGuZWRKV3GR5ignmFCyQSJnXTG/3WSeP1jS/SuJQwAUAyVynQTJKvbxgAJSKIhKXk1moyh335Q1FLBVJLA2sDa4Wm3C0ykWi0elDaJkOyHtUm5v7/HnWpbfz4qGPfEeOu2wSxrt9tWvFmwkx3yK5ae9JnZVlll7FpZaUIlqycwgMBS0MERkCCFWs7cFsZINiCJytDNAAEFMCzfZCdMqtHHNZND/ADf2od2E9wJUJf3oOhg+wqGL5RiKIiMOxbSsgWzPPv7+9Aub/BoRneICVE0SztE5ZJDbBFyRI1nJDJCAUb5K3kAQQ0hFA2IJWcOSJhandma92x9mdWn/AHGO1W9bofFY4+Kxx8VeAHB8bVBuRnumzbKscfFY4+Kxx8Vjj4rHHxWOPiscfFY4+Kxx8VLpOVFg5gRKy3M95hyPMIKNbqOZPeGbe8vZewSt9hf0zjmzyW0QN8lAZ2oQAgLaHtjOvoj4/nRQJhbHOWLTGaIYemYxHmi0diEJ5uE38fj++MfWv/yI+Nalu8VfnxV+fFX58VfnxV+fFX58VfnxV+fHqe//ACTzTnV57ZYx3rvnj3r/2gAIAQMDAT8QVX8Of1TGQtz/AJjmsBpgNMBpgNMBpgNMBpgNMBpgNMBpgNMBpgNMBpgNMBpgNMJ/zG1ZnX8RVXdx8/1XE+PmuJ8fNcT4+a4nx81xPj5rifHzXE+PmuJ8fNcT4+a4nx81xPj5rifHzXE+PmuJ8fNR3gw3Vst6IsHFO45mOmL14CdppKCwNRswIxpFcT4+awo+cb0MSCzj5rhPFOE8U4TxThPFOE8UCgAGqfNYyfNcJ4pwninCeKcJ4pwninCeKECBDEMk7JFlDk60W8hCifkTEjNkTMQsNXWSGO4gjyRSMK7LoQXfVC4owUl7UISJMkZJCEglDXD5PnG9eAfr/iwpDLORzGroa8F6E3XBCCZJCtxjVkShwYFjFxoZwzBsxLORDoMlvlO62DYzjRo4RGGol+RYeHr6FSB+3oZvtVlArBrHPLnGnWfVSiHILLBnkpkiSXRglqt4C7tKbyZEgxdlBMCnJYahyghlZZQhWOBqRlKE4mROlTE32lXBG6INJrwD11RQsbuh7sFJN0W65/ARlBTDFeTpqbze+QRUnAYSMQX/AHNGHAsoKC76l6tCww4D9NbksGqpOQN2vfPHf1VRijr4lOaJCwnUK2E0QEmYTKcxJYMwMiLqzUnULEM8ky3EZxleq1YDdLBlW3bkkuWlspM39JalqWgosmrkuzj/AGpalqWpalqWpalqWgiqBi4KllXOqOSCaAyk8mVBmARCpMBScsWM8F1EL0KusAiLuZFxVdRSzlTZoldi+hYyIKn+cBpSVwzdryRDD7UKCAUh1g2RqQk8MsNEWJaAkILOe7K343vr+Jf8SfinPSrceatx5q3Hmrceatx5q3Hmrceatx5rpjrPprxRl6X5xj4rX2+fQnEU6Tt8YtWmmGv/2Q=="

/***/ }),

/***/ "6Ngg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    content: String,
    isOpen: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    darkHeader: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    },
    accordion: {
      default: null
    },
    id: {
      default: null
    },
    canClose: {
      type: Boolean,
      default: true
    },
    showChevron: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isOpenState: this.isOpen
    };
  },

  computed: {
    hasSlotTitle: function hasSlotTitle() {
      return !!this.$slots.title;
    },
    hasSlotContent: function hasSlotContent() {
      return !!this.$slots.default;
    },
    wrapperModifier: function wrapperModifier() {
      if (this.id !== null) {
        this.isOpenState = this.accordion === this.id;
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'collapsible-panel--no-chevron': !this.showChevron,
        'collapsible-panel--is-open': this.isOpenState
      }, 'collapsible-panel--theme-' + this.theme, true);
    },
    noPaddingModifier: function noPaddingModifier() {
      return {
        'collapsible-panel--no-padding': this.noPadding
      };
    },
    darkHeaderModifier: function darkHeaderModifier() {
      return {
        'collapsible-panel--dark-header': this.darkHeader
      };
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.isOpenState === true && !this.canClose) return;

      this.isOpenState = !this.isOpenState;
      if (this.id !== null) {
        this.$emit('open', this.isOpenState ? this.id : null);
      } else {
        this.$emit('toggle', this.isOpenState);
      }
    }
  }
});

/***/ }),

/***/ "6QL+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6V5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_privacy_policy_js__ = __webpack_require__("umUo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18771f61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_privacy_policy_vue__ = __webpack_require__("uvRM");
function injectStyle (ssrContext) {
  __webpack_require__("kIHN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_privacy_policy_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18771f61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_privacy_policy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6WA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-comment",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.showUserDetails(_vm.comment)}}},[_c('div',{staticClass:"top-comment__avatar"},[_c('account-social-avatar',{attrs:{"avatar":_vm.comment.avatarImage,"showProgress":false,"percentage":100,"showEdit":false,"theme":"markets"}})],1),_vm._v(" "),_c('div',{staticClass:"top-comment__info"},[_c('div',{staticClass:"top-comment__name"},[_vm._v("\n        "+_vm._s(_vm.comment.userName)+"\n      ")]),_vm._v(" "),(_vm.comment.profitablePredictions)?_c('div',{staticClass:"top-comment__active"},[_vm._v("\n        "+_vm._s(_vm.traderLevelDisplay(_vm.comment))+"\n      ")]):_vm._e()])]),_vm._v(" "),(_vm.comment.marketTitle)?_c('div',{staticClass:"top-comment__market",domProps:{"innerHTML":_vm._s(_vm.comment.marketTitle)}}):_vm._e(),_vm._v(" "),_c('div',{ref:"text",staticClass:"top-comment__comment",domProps:{"innerHTML":_vm._s(_vm.comment.comment)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6X+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"close-button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[(!_vm.isDark)?_c('img',{attrs:{"src":__webpack_require__("srjS"),"alt":"Close"}}):_vm._e(),_vm._v(" "),(_vm.isDark)?_c('img',{attrs:{"src":__webpack_require__("gJ7L"),"alt":"Close"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Zmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BRAND */
var BRAND = 'PredictIt';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      brand: BRAND
    };
  }
});

/***/ }),

/***/ "6b0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logos_old_bloomberg_png__ = __webpack_require__("MuFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logos_old_bloomberg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_logos_old_bloomberg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logos_old_cnn_png__ = __webpack_require__("HpV6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logos_old_cnn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logos_old_cnn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logos_old_economist_png__ = __webpack_require__("Q+Dx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logos_old_economist_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_logos_old_economist_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logos_old_hbr_png__ = __webpack_require__("e/7H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logos_old_hbr_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_logos_old_hbr_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logos_old_nbc_png__ = __webpack_require__("r7L0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logos_old_nbc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_logos_old_nbc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logos_old_newyorktimes_png__ = __webpack_require__("n8WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logos_old_newyorktimes_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_logos_old_newyorktimes_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_logos_old_politico_png__ = __webpack_require__("AYS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_logos_old_politico_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_logos_old_politico_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_logos_old_thejournal_png__ = __webpack_require__("FlLb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_logos_old_thejournal_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_logos_old_thejournal_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logos_old_theringer_png__ = __webpack_require__("xyij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logos_old_theringer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_logos_old_theringer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logos_old_vox_png__ = __webpack_require__("ttZ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logos_old_vox_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_logos_old_vox_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_logos_old_yahoo_png__ = __webpack_require__("fpwF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_logos_old_yahoo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_logos_old_yahoo_png__);
















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      items: [{
        href: 'https://www.cnn.com/videos/tv/2019/10/05/do-gambling-odds-forecase-elections-better-than-polls.cnn',
        src: __WEBPACK_IMPORTED_MODULE_5__assets_images_logos_old_cnn_png___default.a,
        class: ''
      }, {
        href: 'https://www.cnbc.com/2018/01/30/these-online-traders-bet-on-the-chaos-of-the-trump-administration.html',
        src: __WEBPACK_IMPORTED_MODULE_8__assets_images_logos_old_nbc_png___default.a,
        class: ''
      }, {
        href: 'https://www.nytimes.com/2019/03/20/technology/andrew-yang-internet-democratic-primary.html?searchResultPosition=1',
        src: __WEBPACK_IMPORTED_MODULE_9__assets_images_logos_old_newyorktimes_png___default.a,
        class: ''
      }, {
        href: 'https://finance.yahoo.com/news/politics-not-trade-will-drive-markets-in-2020-goldman-sachs-152608855.html',
        src: __WEBPACK_IMPORTED_MODULE_14__assets_images_logos_old_yahoo_png___default.a,
        class: ''
      }, {
        href: 'https://www.theringer.com/2018/3/21/17130490/predictit-politics-elections-gambling',
        src: __WEBPACK_IMPORTED_MODULE_12__assets_images_logos_old_theringer_png___default.a,
        class: ''
      }, {
        href: 'https://www.politico.com/story/2018/07/05/supreme-court-justice-contenders-gambling-odds-694906',
        src: __WEBPACK_IMPORTED_MODULE_10__assets_images_logos_old_politico_png___default.a,
        class: ''
      }, {
        href: 'https://hbr.org/2018/07/if-you-say-something-is-likely-how-likely-do-people-think-it-is',
        src: __WEBPACK_IMPORTED_MODULE_7__assets_images_logos_old_hbr_png___default.a,
        class: ''
      }, {
        href: 'https://www.wsj.com/articles/wanna-bet-the-market-has-a-view-on-the-2020-election-11578679896',
        src: __WEBPACK_IMPORTED_MODULE_11__assets_images_logos_old_thejournal_png___default.a,
        class: ''
      }, {
        href: 'https://www.vox.com/future-perfect/2019/4/5/18290870/forecasting-tetlock-prediction-markets-betting',
        src: __WEBPACK_IMPORTED_MODULE_13__assets_images_logos_old_vox_png___default.a,
        class: ''
      }, {
        href: 'https://www.bloomberg.com/news/articles/2019-08-01/predictit-owns-the-market-for-2020-presidential-election-betting',
        src: __WEBPACK_IMPORTED_MODULE_4__assets_images_logos_old_bloomberg_png___default.a,
        class: ''
      }, {
        href: 'https://www.economist.com/graphic-detail/2020/01/04/what-markets-and-models-expect-in-2020',
        src: __WEBPACK_IMPORTED_MODULE_6__assets_images_logos_old_economist_png___default.a,
        class: ''
      }],
      swiperOptions: {
        autoplay: 3000,
        loop: true,
        direction: 'horizontal',
        pagination: '.in-the-news__pagination'
      },
      chunkSize: 4
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    itemsPaged: function itemsPaged() {
      var items = this.items;
      var chunk = this.chunkSize;
      var pages = [];
      for (var a = 0, end = items.length; a < end; a += chunk) {
        pages.push({
          key: a,
          items: items.slice(a, a + chunk)
        });
      }
      return pages;
    }
  }),
  methods: {
    getImgModifiers: function getImgModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'in-the-news-old__img': true
      }, 'in-the-news-old__img--' + item.class, item.class);
    }
  }
});

/***/ }),

/***/ "6b6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6gnH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6iuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "6vwd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "73/K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "74Z8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "776K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7BYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-sitemap"},[_c('static-page-header',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      Site Map\n    ")])]),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"page-sitemap__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_c('div',{staticClass:"page-sitemap__content"},[_c('div',{staticClass:"page-sitemap__row"},_vm._l((_vm.enabledGroups),function(group){return _c('div',{staticClass:"page-sitemap__column"},[_c('router-link',{staticClass:"page-sitemap__group-title",attrs:{"to":group.url,"tag":"div"}},[_vm._v("\n          "+_vm._s(group.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"page-sitemap__group-links"},_vm._l((_vm.enabledGroupItems(group.items)),function(item){return _c('a',{staticClass:"page-sitemap__group-link",attrs:{"href":item.url}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0)],1)}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7DQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_js__ = __webpack_require__("mThu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5169a6d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_vue__ = __webpack_require__("8rDO");
function injectStyle (ssrContext) {
  __webpack_require__("Ivs/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5169a6d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Ez+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "7GI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_combined_login_js__ = __webpack_require__("nlkt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fdc7702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_combined_login_vue__ = __webpack_require__("FUh1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_combined_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fdc7702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_combined_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7JgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_vm._m(0),_vm._v(" "),(_vm.isPending)?[(_vm.isCard)?[_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identity has been confirmed.\n      ")]),_vm._v(" "),(false)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Don’t want to wait? Try Online Banking instead. No document upload required. Start trading now!\n      ")]):_vm._e()]:(_vm.isPopup)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n    ")]):_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n    ")])]:[(_vm.isCard)?[_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        To use a credit card, PredictIt requires all traders to upload a proof of identity document. We will then review the document as quickly as possible so that you can start trading.\n      ")]),_vm._v(" "),(false)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Don’t want to wait? Try Online Banking instead. No document upload required. Start trading now!\n      ")]):_vm._e()]:(_vm.isPopup)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      We are required to collect further documentation in order to process your transaction. Please click to upload an identity document.\n    ")]):_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      We are required to collect documentation in order to process further deposits or withdrawals. Please click to upload an identity document.\n    ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick($event)}}},[_vm._v("\n      Upload Document\n    ")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-upload-document__icon"},[_c('img',{attrs:{"src":__webpack_require__("xgaP")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7NdF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Nf+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sold-bought-at"},[_c('span',{staticClass:"sold-bought-at__type"},[_vm._v(_vm._s(_vm.typeToString))]),_vm._v(" "),(_vm.closedText)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.closedText)}})]:[_c('span',{staticClass:"sold-bought-at__quantity",class:_vm.negativeModifier},[_vm._v(_vm._s(_vm.quantity))]),_vm._v(" at "+_vm._s(_vm.priceToString)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7P0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.brand))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7P8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.hasServerMessage)?[(_vm.maintenance.suspendedMessage)?_c('div',{staticClass:"app-header-notification app-header-notification--with-close app-header-notification--not-clickable"},[_c('div',{staticClass:"app-header-notification__content",domProps:{"innerHTML":_vm._s(_vm.maintenanceMessageText)}})]):(_vm.maintenance.systemMessage)?_c('div',{staticClass:"app-header-notification app-header-notification--with-close app-header-notification--system",on:{"click":function($event){$event.stopPropagation();return _vm.onSystemMessageClick($event)}}},[_c('div',{staticClass:"app-header-notification__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.maintenanceMessageText)}}),_vm._v(" "),_c('div',{staticClass:"app-header-notification__close",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onCloseMaintenanceMessage($event)}}},[_c('div',{staticClass:"app-header-notification__close-icon"})])])]):_vm._e()]:(_vm.liveUpdatesDisabled)?_c('div',{staticClass:"app-header-notification app-header-notification--system",on:{"click":function($event){$event.stopPropagation();return _vm.onErrorClick($event)}}},[_c('div',{staticClass:"app-header-notification__content"},[_vm._v("\n      Due to page inactivity, live updates, including account balance, have been disabled on this page. To re-enable live updates please refresh the page.\n    ")])]):(_vm.showErrorNotification)?_c('div',{staticClass:"app-header-notification",on:{"click":function($event){$event.stopPropagation();return _vm.onErrorClick($event)}}},[_vm._m(0)]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header-notification__content"},[_vm._v("\n      An error has occurred.\n      Click "),_c('a',{staticClass:"app-header-notification__link",attrs:{"href":"#"}},[_vm._v("here")]),_vm._v(" to reload the page.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Q1h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7RdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.loading)?_c('div',{staticClass:"twittertimeline__spinner"}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.contentClassModifiers},[_c('div',{ref:"init",class:_vm.initClassModifiers})]),_vm._v(" "),(_vm.showFooter)?_c('div',{staticClass:"twittertimeline__footer"},[_c('div',{staticClass:"twittertimeline__more-button",on:{"click":_vm.onFooterMoreButtonClick}},[_vm._v("\n      "+_vm._s(_vm.getMoreTweetsLabel)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{ref:"more",staticClass:"twittertimeline__content"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7WHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_preview_carousel_js__ = __webpack_require__("oV6X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41091ed2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_carousel_vue__ = __webpack_require__("52iG");
function injectStyle (ssrContext) {
  __webpack_require__("KAwH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_preview_carousel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41091ed2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Wq7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__top_comment_top_comment_vue__ = __webpack_require__("bFAx");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    widget: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_loader__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"],
    topComment: __WEBPACK_IMPORTED_MODULE_2__top_comment_top_comment_vue__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      rightDis: false,
      leftDis: true,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: function onTransitionStart(swp) {
          var ax = swp.activeIndex % _this.lastIndex;
          _this.leftDis = ax === 1;
          _this.rightDis = ax === 0;
        }
      }
    };
  },

  computed: {
    obj: function obj() {
      return !this.widget ? {} : this.widget;
    },
    items: function items() {
      return this.widget.widgetTopComments || [];
    },
    lastIndex: function lastIndex() {
      return this.items.length;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--left': true
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--right': true
      };
    }
  },
  methods: {
    prevSlide: function prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "7Ymm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-widget-loader': true
      }, 'market-widget-loader--' + this.theme, this.theme);
    }
  })
});

/***/ }),

/***/ "7aYA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7fpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    hideDelay: {
      type: Number,
      default: 300
    }
  },
  data: function data() {
    return {
      isVisible: false,
      hideTimeout: null,
      watchdogTimeout: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['newLoaderCounter']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['newLoaderIsLoading'])),
  watch: {
    newLoaderIsLoading: {
      handler: 'newLoaderIsLoadingHandler',
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isVisible) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["E" /* unlockScroll */])();
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    if (this.watchdogTimeout) {
      clearTimeout(this.watchdogTimeout);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['resetLoaderCounter']), {
    newLoaderIsLoadingHandler: function newLoaderIsLoadingHandler(value) {
      if (value) {
        this.showLoader();
      } else {
        this.hideLoader();
      }
    },
    showLoader: function showLoader() {
      var _this = this;

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      if (this.watchdogTimeout) {
        clearTimeout(this.watchdogTimeout);
      }
      this.watchdogTimeout = setTimeout(function () {
        _this.resetLoaderCounter();
      }, 5000);

      if (!this.isVisible) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["F" /* lockScroll */])();
      }

      this.isVisible = true;
    },
    hideLoader: function hideLoader() {
      var _this2 = this;

      if (this.watchdogTimeout) {
        clearTimeout(this.watchdogTimeout);
      }
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      this.hideTimeout = setTimeout(function () {
        if (_this2.isVisible) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["E" /* unlockScroll */])();
        }
        _this2.isVisible = false;
        _this2.hideTimeout = null;
      }, this.hideDelay);
    }
  })
});

/***/ }),

/***/ "7iEX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7lSu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7okt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_js__ = __webpack_require__("DFsO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3635d095_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_vue__ = __webpack_require__("LkCa");
function injectStyle (ssrContext) {
  __webpack_require__("ZBib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3635d095_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7pd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['market']))
});

/***/ }),

/***/ "7trC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_onboarding_document_to_review_document_to_review_vue__ = __webpack_require__("e0++");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    documentData: {
      type: Object,
      required: true
    }
  },
  components: {
    documentToReview: __WEBPACK_IMPORTED_MODULE_0__components_onboarding_document_to_review_document_to_review_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "7uEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTopComments || _vm.showSkeleton)?_c('div',{staticClass:"sushi-market-top-comments",class:_vm.rootModifiers},[_c('div',{staticClass:"sushi-market-top-comments__header"},[_c('div',{staticClass:"sushi-market-top-comments__title"},[_vm._v(_vm._s(_vm.topComments.title))]),_vm._v(" "),_c('a',{staticClass:"sushi-market-top-comments__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onOpenDiscussion($event)}}},[_vm._v("\n      View Discussion\n    ")])]),_vm._v(" "),(_vm.showSkeleton)?_c('div',{staticClass:"sushi-market-top-comments__list"},_vm._l((_vm.skeletonCount),function(index){return _c('div',{key:index,staticClass:"sushi-market-top-comments__item sushi-market-top-comments__item--skeleton",attrs:{"aria-hidden":"true"}},[_vm._m(0,true),_vm._v(" "),_vm._m(1,true)])}),0):_c('div',{staticClass:"sushi-market-top-comments__list"},_vm._l((_vm.previewComments),function(comment,index){return _c('div',{key:comment.commentId,staticClass:"sushi-market-top-comments__item",attrs:{"data-tooltip":"Click to view in discussion","role":"button","tabindex":"0"},on:{"!click":function($event){return _vm.onCommentClick($event, comment)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onOpenComment(comment)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onOpenComment(comment)}]}},[_c('div',{staticClass:"sushi-market-top-comments__avatar"},[_c('account-social-avatar',{attrs:{"avatar":comment.avatarImage,"showProgress":false,"showEdit":false,"percentage":100,"theme":"markets"}}),_vm._v(" "),_c('div',{staticClass:"sushi-market-top-comments__rank-overlay",attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"sushi-market-top-comments__rank"},[_vm._v("\n            "+_vm._s(index + 1)+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"sushi-market-top-comments__content"},[_c('div',{staticClass:"sushi-market-top-comments__meta"},[_c('div',{staticClass:"sushi-market-top-comments__name"},[_vm._v("\n            "+_vm._s(comment.userName)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-top-comments__date"},[_vm._v("\n            "+_vm._s(_vm.formatDate(comment.createdAt))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"sushi-market-top-comments__comment",domProps:{"innerHTML":_vm._s(comment.previewHtml)}})])])}),0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-top-comments__avatar"},[_c('div',{staticClass:"sushi-market-top-comments__avatar-skeleton"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-top-comments__content"},[_c('div',{staticClass:"sushi-market-top-comments__meta"},[_c('div',{staticClass:"sushi-market-top-comments__skeleton sushi-market-top-comments__skeleton--name"}),_vm._v(" "),_c('div',{staticClass:"sushi-market-top-comments__skeleton sushi-market-top-comments__skeleton--date"})]),_vm._v(" "),_c('div',{staticClass:"sushi-market-top-comments__skeleton sushi-market-top-comments__skeleton--comment"}),_vm._v(" "),_c('div',{staticClass:"sushi-market-top-comments__skeleton sushi-market-top-comments__skeleton--comment-short"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7vAe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7wmZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTEuMTYgOC44NjNoMy4xMzl2Ni42MDFIMS4xNnpNMTQuNjkxIDEyLjI3NGgzLjEzOXYzLjE5MWgtMy4xMzl6Ii8+CiAgICAgICAgPHRleHQgZmlsbD0iIzY3OTk5RiIgZm9udC1mYW1pbHk9IlJvYm90by1Cb2xkLCBSb2JvdG8iIGZvbnQtc2l6ZT0iMTIiIGZvbnQtd2VpZ2h0PSJib2xkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIj4KICAgICAgICAgICAgPHRzcGFuIHg9IjE0LjA4IiB5PSIxNCI+wqI8L3RzcGFuPgogICAgICAgIDwvdGV4dD4KICAgICAgICA8cGF0aCBmaWxsPSIjNjc5OTlGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xOC40MSAxOEguNThjLS4zMiAwLS41OC4yNjQtLjU4LjU5IDAgLjMyNS4yNi41OS41OC41OWgxNy44M2MuMzIgMCAuNTgtLjI2NS41OC0uNTkgMC0uMzI2LS4yNi0uNTktLjU4LS41OXoiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiM2Nzk5OUYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik0xIDE0bDUtNyA1IDQgNi41MTMtOS41MTMiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "7ws2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending-requests-list-withdrawal"},[(!_vm.isComponentReady)?[_c('account-withdrawal-loader'),_vm._v(" "),_c('account-withdrawal-loader'),_vm._v(" "),_c('account-withdrawal-loader')]:[_vm._l((_vm.pendingRequests),function(request,index){return (_vm.pendingRequests.length > 0)?_c('pending-request',{key:index,staticClass:"pending-requests-list-withdrawal__item",attrs:{"request":request},on:{"complete":_vm.onComplete}}):_vm._e()}),_vm._v(" "),(_vm.pendingRequests.length === 0)?_c('alert-box',{staticClass:"pending-requests-list-withdrawal__alert-box",attrs:{"level":"info"}},[_vm._v("\n      You have no withdrawals pending.\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7wxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    asWidget: {
      type: Boolean,
      default: false
    }
  },
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_4__components_generics_content_header_content_header_vue__["a" /* default */],
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__["a" /* default */],
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_6__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  data: function data() {
    return {
      expanded: false,
      accordion: 'video-0',
      videos: [{ title: 'Buying and Selling Shares', video: 'https://www.youtube.com/watch?v=h57BM4abHJ4', id: 'video-0' }, { title: 'Navigating the Site', video: 'https://www.youtube.com/watch?v=muJmhHeVJ_w', id: 'video-1' }, { title: 'Opening an Account', video: 'https://www.youtube.com/watch?v=NfWU0Wiixuo', id: 'video-2' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn'])),
  methods: {
    getYoutubeIdFromUrl: function getYoutubeIdFromUrl(url) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vue_youtube_embed__["b" /* getIdFromURL */])(url);
    },
    accordionOpen: function accordionOpen(e) {
      this.accordion = e;

      if (e !== null) {
        setTimeout(function () {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_scrollTo__["a" /* default */])(document.getElementById(e), 0);
        }, 50);
      }
    }
  }
});

/***/ }),

/***/ "8/3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = checkResponseForMaintenance;
/* harmony export (immutable) */ __webpack_exports__["c"] = checkResponseForTaxInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = checkResponseForDocumentUpload;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkResponseForApiGoingOffline;
/* harmony export (immutable) */ __webpack_exports__["e"] = checkResponseVersion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__("JDN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






var TAX_INFO_STATUS_CODE = 403;
var TAX_INFO_MESSAGE_CODE = 'requireTax1099Redirect';

var DOCUMENT_UPLOAD_SKIP_POPUP_URLS = ['Wallet/DepositCard', 'Wallet/ConfirmDepositCard', 'Wallet/SubmitDepositCard', 'Wallet/WithdrawAch', 'Wallet/WithdrawCheck', 'Wallet/DepositUSDCoin', 'Wallet/WithdrawWire', 'Wallet/WithdrawUSDC', 'Wallet/DepositPWMB'];

function checkResponseForMaintenance(response) {
  var maintenanceMessage = response.headers['pi-maintenancemessage'];
  var suspendedMessage = response.headers['pi-tradingsuspendedmessage'];
  var systemMessage = response.headers['pi-systemmessages'];

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setMaintenance', {
    isMaintenanceEnabled: typeof maintenanceMessage !== 'undefined',
    isTradingEnabled: typeof maintenanceMessage === 'undefined',
    maintenanceMessage: maintenanceMessage || '',
    suspendedMessage: suspendedMessage || '',
    systemMessage: systemMessage || ''
  });
}

function checkResponseForTaxInfo(response) {
  if (!(response.status === TAX_INFO_STATUS_CODE && response.data.code && response.data.code === TAX_INFO_MESSAGE_CODE)) return;
  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].TAX_INFO);
  }, 1000);
}

function checkResponseForDocumentUpload(response) {
  var dontAct = response.config.method.toLowerCase() === 'get' && __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(DOCUMENT_UPLOAD_SKIP_POPUP_URLS, function (x) {
    return response.config.url.includes(x);
  });

  if (!(response.data.duRequired || response.data.duPending) || dontAct) return;

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].UPLOAD_DOCUMENT);
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopupOptions', {
    isPending: !!response.data.duPending,
    source: response.data.duSource
  });
}

function checkResponseForApiGoingOffline(response) {
  if (!(response.data && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(response.data) && response.data.includes('MaintenanceMessage'))) return;
  // When error response includes MaintenanceMessage redirect to home
  // This situation means API is offline
  window.location.href = "/";
}

function checkResponseVersion(response) {
  var version = response.headers['x-version'];
  if (!version) return;
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.app.initialVersion === null) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setInitialVersion', version);
  }
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setServerVersion', version);
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  checkResponseForMaintenance: checkResponseForMaintenance,
  checkResponseForTaxInfo: checkResponseForTaxInfo,
  checkResponseForApiGoingOffline: checkResponseForApiGoingOffline,
  checkResponseVersion: checkResponseVersion
});

/***/ }),

/***/ "81Xy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__story_preview_homepage_surface_vue__ = __webpack_require__("Cg4w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__story_preview_detail_surface_vue__ = __webpack_require__("Caoy");









var TOTAL_COLUMNS = 12;
var COLUMN_OPTIONS = [{ label: '0%', value: 0 }, { label: '8.3%', value: 1 }, { label: '16.6%', value: 2 }, { label: '25%', value: 3 }, { label: '33.3%', value: 4 }, { label: '41.6%', value: 5 }, { label: '50%', value: 6 }, { label: '58.3%', value: 7 }, { label: '66.6%', value: 8 }, { label: '75%', value: 9 }, { label: '83%', value: 10 }, { label: '91.6%', value: 11 }];
var TYPE_OPTIONS = [{ label: 'Desktop', value: 'desktop' }, { label: 'Mobile', value: 'mobile' }, { label: 'Detail', value: 'detail' }];
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    previewId: {}
  },
  data: function data() {
    return {
      COLUMN_OPTIONS: COLUMN_OPTIONS,
      TYPE_OPTIONS: TYPE_OPTIONS,
      typeChoice: TYPE_OPTIONS[0],
      columnChoice: {
        left: COLUMN_OPTIONS[0],
        middle: COLUMN_OPTIONS[7],
        right: COLUMN_OPTIONS[0]
      },
      fullPreviewData: null,
      previewDataVersion: 0
    };
  },

  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__["a" /* default */],
    storyPreviewHomepageSurface: __WEBPACK_IMPORTED_MODULE_6__story_preview_homepage_surface_vue__["a" /* default */],
    storyPreviewDetailSurface: __WEBPACK_IMPORTED_MODULE_7__story_preview_detail_surface_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'page-story-preview': true
      }, 'page-story-preview--' + this.typeChoice.value, true);
    },
    isColumnCountExceeding: function isColumnCountExceeding() {
      return this.columnChoice.left.value + this.columnChoice.right.value >= TOTAL_COLUMNS;
    },
    middleOption: function middleOption() {
      var sumColumns = this.columnChoice.left.value + this.columnChoice.right.value;
      return TOTAL_COLUMNS - sumColumns;
    },
    leftColumnClasses: function leftColumnClasses() {
      var option = this.columnChoice.left.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + option, !!option);
    },
    middleColumnClasses: function middleColumnClasses() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + this.middleOption, !!this.middleOption);
    },
    rightColumnClasses: function rightColumnClasses() {
      var option = this.columnChoice.right.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + option, !!option);
    },
    isDetailMode: function isDetailMode() {
      return this.typeChoice.value === 'detail';
    },
    selectedHomepageSection: function selectedHomepageSection() {
      if (!this.fullPreviewData || this.isDetailMode) {
        return null;
      }
      var homePreviewData = this.fullPreviewData.homePagePreviewViewModel || {};
      if (this.typeChoice.value === 'mobile') {
        return homePreviewData.mobileContent || null;
      }
      return homePreviewData.desktopContent || null;
    },
    selectedDetailData: function selectedDetailData() {
      if (!this.fullPreviewData || !this.isDetailMode) {
        return null;
      }
      return this.fullPreviewData.detailPageViewModel || null;
    },
    homepageSurfaceKey: function homepageSurfaceKey() {
      return this.typeChoice.value + '-' + this.previewDataVersion;
    },
    detailSurfaceKey: function detailSurfaceKey() {
      return 'detail-' + this.previewDataVersion;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStoryFullPreview']), {
    setDefaultColumnsByMode: function setDefaultColumnsByMode(mode) {
      switch (mode) {
        case 'mobile':
          this.columnChoice.left = COLUMN_OPTIONS[4];
          this.columnChoice.right = COLUMN_OPTIONS[4];
          return;
        case 'desktop':
          this.columnChoice.left = COLUMN_OPTIONS[0];
          this.columnChoice.right = COLUMN_OPTIONS[0];
          return;
        case 'detail':
          this.columnChoice.left = COLUMN_OPTIONS[0];
          this.columnChoice.right = COLUMN_OPTIONS[0];
          return;
        default:
          break;
      }
    },
    typeChoiceHandler: function typeChoiceHandler(option) {
      this.setDefaultColumnsByMode(option.value);
    },
    loadPreviewData: function loadPreviewData() {
      var _this = this;

      this.loaderAdd(document.body);
      return this.getStoryFullPreview(this.previewId).then(function (responseData) {
        _this.fullPreviewData = responseData;
        _this.previewDataVersion += 1;
        return responseData;
      }).catch(function () {
        _this.fullPreviewData = null;
      }).finally(function () {
        _this.loaderRemove(document.body);
      });
    }
  }),
  watch: {
    typeChoice: {
      handler: 'typeChoiceHandler',
      immediate: true
    },
    previewId: {
      handler: 'loadPreviewData',
      immediate: true
    }
  }
});

/***/ }),

/***/ "84WW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_session_history_sushi_js__ = __webpack_require__("rm4l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d119082_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_session_history_sushi_vue__ = __webpack_require__("UgWA");
function injectStyle (ssrContext) {
  __webpack_require__("MW9B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_session_history_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d119082_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_session_history_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "85+t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "88wj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_requests_list_withdrawal_js__ = __webpack_require__("uCH6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a66952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_requests_list_withdrawal_vue__ = __webpack_require__("7ws2");
function injectStyle (ssrContext) {
  __webpack_require__("hmLA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_requests_list_withdrawal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a66952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_requests_list_withdrawal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8EqH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8G+U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_login_js__ = __webpack_require__("lFoL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498fee32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_login_vue__ = __webpack_require__("YGiH");
function injectStyle (ssrContext) {
  __webpack_require__("ayND")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498fee32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8HXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-news-archive-stories"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-news-archive-stories__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-news-archive-stories__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8I/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_amount_info_amount_info_vue__ = __webpack_require__("Jm7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");






var RECEIVED_MESSAGE = 'Your withdrawal request has been received.';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  components: {
    amountInfo: __WEBPACK_IMPORTED_MODULE_2__components_wallet_amount_info_amount_info_vue__["a" /* default */]
  },
  props: {
    amendAvailable: {
      type: Boolean,
      required: false,
      default: false
    },
    kind: {
      type: String,
      required: false
    },
    amount: {
      type: Number,
      required: false
    },
    bankWithdrawAmounts: {
      type: Object
    },
    fee: {
      type: Number,
      required: false,
      default: 5.0
    },
    beneficiaryInfo: {
      type: Object,
      required: false
    },
    accountDetails: {
      type: Object,
      required: false
    },
    addressLine1: {
      type: String,
      required: false
    },
    addressLine2: {
      type: String,
      required: false
    },
    addressLine3: {
      type: String,
      required: false
    },
    country: {
      required: false
    },
    recipient: {
      required: false
    }
  },
  data: function data() {
    return {
      hasFailed: false
    };
  },

  computed: {
    isAch: function isAch() {
      return this.kind === 'ach';
    },
    isCheck: function isCheck() {
      return this.kind === 'check';
    },
    isCoinbase: function isCoinbase() {
      return this.kind === 'coinbase-withdraw';
    },
    isBankTransfer: function isBankTransfer() {
      return this.kind === 'bank-transfer';
    },
    netTotal: function netTotal() {
      return this.amount - this.fee;
    },
    backText: function backText() {
      return this.hasFailed ? 'Back' : 'Cancel';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['postWithdrawCheck', 'postWithdrawAch', 'postWithdrawCoinbase', 'postWithdrawWireSubmit']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    inspectWithrawConfirmResponse: function inspectWithrawConfirmResponse(data) {
      if (data.isTLEvent) {
        this.$gtm.trackEvent({
          event: 'FullWithdraw'
        });
      }
    },
    onEdit: function onEdit() {
      this.$emit('edit');
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.formReset();
      this.loaderAdd(document.body);
      if (this.isCheck) {
        var payload = {
          amount: this.amount
        };
        this.postWithdrawCheck(payload).then(function (data) {
          _this.loaderRemove(document.body);
          _this.inspectWithrawConfirmResponse(data);
          _this.setSuccessSideNotification(RECEIVED_MESSAGE);
          _this.$gtm.trackEvent({ event: 'Withdraw' });
          _this.$emit('success');
        }).catch(function (error) {
          _this.hasFailed = true;
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
          _this.$gtm.trackEvent({ event: 'FailWithdraw' });
        });
      } else if (this.isAch) {
        var _payload = {
          amount: this.amount,
          savedAchAccountId: this.accountDetails.accountId,
          achRoutingNumber: this.accountDetails.routingNumber,
          achAccountNumber: this.accountDetails.accountNumber,
          achAccountType: this.accountDetails.accountType
        };
        this.postWithdrawAch(_payload).then(function (data) {
          _this.loaderRemove(document.body);
          _this.inspectWithrawConfirmResponse(data);
          _this.setSuccessSideNotification(RECEIVED_MESSAGE);
          _this.$gtm.trackEvent({ event: 'Withdraw' });
          _this.$emit('success');
        }).catch(function (error) {
          _this.hasFailed = true;
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
          _this.$gtm.trackEvent({ event: 'FailWithdraw' });
        });
      } else if (this.isCoinbase) {
        var _payload2 = {
          amount: this.amount
        };
        this.postWithdrawCoinbase(_payload2).then(function (data) {
          _this.loaderRemove(document.body);
          _this.inspectWithrawConfirmResponse(data);
          _this.setSuccessSideNotification(RECEIVED_MESSAGE);
          _this.$gtm.trackEvent({ event: 'Withdraw' });
          _this.$emit('success');
        }).catch(function (error) {
          _this.hasFailed = true;
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
          _this.$gtm.trackEvent({ event: 'FailWithdraw' });
        });
      } else if (this.isBankTransfer) {
        var _payload3 = {
          amount: this.amount,
          accountWireBeneficiaryId: this.beneficiaryInfo.accountWireBeneficiaryId
        };
        this.postWithdrawWireSubmit(_payload3).then(function (data) {
          _this.loaderRemove(document.body);
          _this.inspectWithrawConfirmResponse(data);
          _this.setSuccessSideNotification(RECEIVED_MESSAGE);
          _this.$gtm.trackEvent({ event: 'Withdraw' });
          _this.$emit('success');
        }).catch(function (error) {
          _this.hasFailed = true;
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
          _this.$gtm.trackEvent({ event: 'FailWithdraw' });
        });
      }
    }
  })
});

/***/ }),

/***/ "8KPi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8KbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg__ = __webpack_require__("K0uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg__ = __webpack_require__("LmU5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg__ = __webpack_require__("htEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg__);






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), {
    items: function items() {
      if (this.isShutdownModeOn) {
        return [{
          title: 'Browsing Questions',
          description: 'Markets offer a range of questions for traders to test their skills.',
          icon: __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default.a
        }, {
          title: 'Making Predictions',
          description: 'Traders make predictions by buying and selling shares in potential outcomes.',
          icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default.a
        }, {
          title: 'Trading Shares',
          description: 'Prices will rise and fall with political events, giving traders the opportunity to cash in shares for a profit.',
          icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default.a
        }];
      }
      return [{
        title: 'Browse Markets',
        description: 'Check out the range of available markets on which you can try and predict the outcome.',
        icon: __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default.a
      }, {
        title: 'Make A Prediction',
        description: 'Think everyone’s got it wrong? Put your money where your mouth is and buy shares for or against an event taking place.',
        icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default.a
      }, {
        title: 'Trade Your Shares',
        description: 'Buy your shares low and sell them high once the crowd figures out you were right.',
        icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default.a
      }];
    }
  })
});

/***/ }),

/***/ "8O0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_share_info_popup_js__ = __webpack_require__("lMNy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f4023e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_info_popup_vue__ = __webpack_require__("zUFh");
function injectStyle (ssrContext) {
  __webpack_require__("Tr7g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_share_info_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f4023e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_info_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8RtG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8TeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_forgotten_js__ = __webpack_require__("QM9i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40528853_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_forgotten_vue__ = __webpack_require__("ZNt6");
function injectStyle (ssrContext) {
  __webpack_require__("jeTY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_forgotten_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40528853_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_forgotten_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8V4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8YSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountFormLoader_vue__ = __webpack_require__("h1Ye");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4c8682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountFormLoader_vue__ = __webpack_require__("bBr+");
function injectStyle (ssrContext) {
  __webpack_require__("U2mR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountFormLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4c8682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountFormLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8a1C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8hek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_js__ = __webpack_require__("bYWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d067a66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__("dSDn");
function injectStyle (ssrContext) {
  __webpack_require__("4v//")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d067a66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8mrx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TIME_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");






var DEFAULT_LOAD_LEADERBOARD = {
  data: [],
  trader: null,
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

var TIME_OPTIONS = {
  PAST_WEEK: { label: 'Past Week', value: 7 },
  PAST_MONTH: { label: 'Past Month', value: 30 },
  PAST_YEAR: { label: 'Past Year', value: 365 }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  state: {
    selectedLeaderboardId: null,
    playerLeaderboards: [],
    leaderboards: [],
    leaderboardsResults: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_LOAD_LEADERBOARD),
    leaderboardsDateRange: TIME_OPTIONS.PAST_WEEK.value
  },
  getters: {
    selectedLeaderboard: function selectedLeaderboard(state) {
      return state.leaderboards.find(function (i) {
        return i.leaderBoardId === state.selectedLeaderboardId;
      });
    }
  },
  mutations: {
    setSelectedLeaderboardId: function setSelectedLeaderboardId(state, data) {
      state.selectedLeaderboardId = data;
    },
    setPlayerLeaderboards: function setPlayerLeaderboards(state, data) {
      state.playerLeaderboards = data;
    },
    setLeaderboards: function setLeaderboards(state, data) {
      state.leaderboards = data;
    },
    clearSelectedLeaderboardId: function clearSelectedLeaderboardId(state) {
      state.selectedLeaderboardId = null;
    },
    resetLeaderboardsResults: function resetLeaderboardsResults(state) {
      state.leaderboardsResults = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_LOAD_LEADERBOARD);
    },
    setLeaderboardsResults: function setLeaderboardsResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.leaderboardsResults.data));
      var data = sourceData.concat(payload.data.traders || []);
      var page = payload.data.page;
      var totalCount = payload.data.totalTraders;
      var canLoadMore = totalCount > data.length;

      state.leaderboardsResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.leaderboardsResults, {
        trader: payload.data.trader,
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setLeaderboardsDateRange: function setLeaderboardsDateRange(state, data) {
      state.leaderboardsDateRange = data;
    },
    resetLeaderboardsDateRange: function resetLeaderboardsDateRange(state) {
      state.leaderboardsDateRange = TIME_OPTIONS.PAST_WEEK.value;
    }
  },
  actions: {
    getLeaderboardsResults: function getLeaderboardsResults(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      if (state.selectedLeaderboardId !== null && state.leaderboardsResults.canLoadMore) {
        var page = state.leaderboardsResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getLeaderboard({
          dateRange: state.leaderboardsDateRange,
          id: state.selectedLeaderboardId,
          page: page
        }).then(function (response) {
          commit('setLeaderboardsResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    getLeaderboards: function getLeaderboards(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$cache = _ref3.cache,
          cache = _ref3$cache === undefined ? true : _ref3$cache;

      if (cache && state.leaderboards.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.leaderboards);
      }
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getLeaderboards().then(function (response) {
        commit('setLeaderboards', response.data);
        return response.data;
      });
    },
    getPlayerLeaderboards: function getPlayerLeaderboards(_ref4) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getPlayerLeaderboards().then(function (response) {
        commit('setPlayerLeaderboards', response.data);
        return response.data;
      });
    },
    setSelectedLeaderboardId: function setSelectedLeaderboardId(_ref5, data) {
      var commit = _ref5.commit;

      commit('setSelectedLeaderboardId', data);
    },
    clearSelectedLeaderboardId: function clearSelectedLeaderboardId(_ref6) {
      var commit = _ref6.commit;

      commit('clearSelectedLeaderboardId');
    },
    resetLeaderboardsResults: function resetLeaderboardsResults(_ref7) {
      var commit = _ref7.commit;

      commit('resetLeaderboardsResults');
    },
    setLeaderboardsDateRange: function setLeaderboardsDateRange(_ref8, data) {
      var commit = _ref8.commit;

      commit('setLeaderboardsDateRange', data);
    },
    resetLeaderboardsDateRange: function resetLeaderboardsDateRange(_ref9) {
      var commit = _ref9.commit;

      commit('resetLeaderboardsDateRange');
    }
  }
});

/***/ }),

/***/ "8nLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_page_js__ = __webpack_require__("M5iw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7360fc94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_page_vue__ = __webpack_require__("/nzw");
function injectStyle (ssrContext) {
  __webpack_require__("f1Rs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7360fc94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8ofP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString__ = __webpack_require__("JDN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__ = __webpack_require__("5/be");




var SOURCES = {
  YOUTUBE: 1,
  VIMEO: 2
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    autoPlay: {},
    loop: {},
    mute: {},
    source: {},
    startTime: {},
    videoUrl: {},
    maxHeight: {}
  },
  computed: {
    classModifiers: function classModifiers() {
      return {
        'video-view': true,
        'video-view--responsive': !this.playerHeight
      };
    },
    isYoutube: function isYoutube() {
      return this.source === SOURCES.YOUTUBE;
    },
    isVimeo: function isVimeo() {
      return this.source === SOURCES.VIMEO;
    },
    youtubeVideoId: function youtubeVideoId() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__["b" /* getIdFromURL */])(this.videoUrl);
    },
    youtubePlayerVars: function youtubePlayerVars() {
      return {
        rel: 0,
        start: this.startTime,
        autoplay: this.autoPlay ? 1 : 0
      };
    },
    playerHeight: function playerHeight() {
      if (this.maxHeight) {
        return this.maxHeight;
      }
      return undefined;
    },
    playerWidth: function playerWidth() {
      if (!this.playerHeight) {
        return '100%';
      }
      var height = __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default()(this.playerHeight) && this.playerHeight.endsWith('px') ? Number(this.playerHeight.replace('px', '').trim()) : this.playerHeight;
      var ratio = this.isVimeo ? 2 : 1.78;
      return height * ratio;
    },
    vimeoVideoId: function vimeoVideoId() {
      return (/(vimeo(pro)?\.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/.exec(this.videoUrl)[3]
      );
    },
    vimeoPlayerVars: function vimeoPlayerVars() {
      var params = {
        responsive: !this.playerHeight,
        muted: this.mute,
        start_time: this.startTime
      };
      return params;
    }
  },
  methods: {
    youtubeEnded: function youtubeEnded() {
      if (this.loop && this.$refs.youtubePlayer) {
        this.$refs.youtubePlayer.player.seekTo(0);
      }
    }
  }
});

/***/ }),

/***/ "8p/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UX_OPTIONS_BUTTON_COLOR_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT; });
/* unused harmony export UX_OPTIONS_PRICE_DISPLAY */
/* unused harmony export UX_OPTIONS_MOBILE_ORDERBOOK_DISPLAY */
/* unused harmony export UX_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__settings_option_settings_option_vue__ = __webpack_require__("7DQ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__settings_option_switch_settings_option_switch_vue__ = __webpack_require__("OdBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__check_option_check_option_vue__ = __webpack_require__("9zdy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__security_settings_security_settings_vue__ = __webpack_require__("lyr+");


/* eslint-disable no-console */


















var PROVIDER_FACEBOOK = 'Facebook';
var PROVIDER_TWITTER = 'Twitter';
var PROVIDER_GOOGLE = 'Google';

var optionPush = {
  key: 'AllowPushNotifications',
  info: 'Push Notifications'
};

var sectionNotifications = [{
  key: 'OpenOfferMatched',
  info: 'One of my orders has been matched'
}, {
  key: 'MarketClosed',
  info: 'One of my markets has closed'
}];

if (false) {
  sectionNotifications.push({
    key: 'ContractPriceChange',
    info: 'One of my contracts changes in price by:',
    withValue: 'ContractPriceChangeAmount',
    validate: function validate(x) {
      return x >= 5 && x < 100;
    },
    currencyInitial: 5
  });
}

var sectionGeneral = [
  // {
  //   key: 'ShowBalanceHeader',
  //   info: 'Show my available balances in header',
  // },
];

var UX_OPTIONS_BUTTON_COLOR_SCHEME = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme,
  info: 'Buy Button Color Scheme',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["a" /* APP_COLOR_PALETTE */].GREEN_RED,
    info: 'Green/Red'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["a" /* APP_COLOR_PALETTE */].BLUE_GREY,
    info: 'Blue/Grey'
  }]
};

var UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout,
  info: 'Mobile Contract Layout',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].STANDARD,
    info: 'Tile'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].SIMPLIFIED,
    info: 'Simplified'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED,
    info: 'Condensed'
  }]
};

var UX_OPTIONS_PRICE_DISPLAY = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay,
  info: 'Price Display',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["d" /* APP_PRICE_DISPLAY */].TRADE_PRICES,
    info: 'Trade Prices'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS,
    info: 'Odds'
  }]
};

var UX_OPTIONS_MOBILE_ORDERBOOK_DISPLAY = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS,
  info: 'Orderbook Layout (Mobile Only)',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED,
    info: 'Collapsed'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].EXPANDED,
    info: 'Expanded'
  }]
};

var UX_OPTIONS = [UX_OPTIONS_BUTTON_COLOR_SCHEME, UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT, UX_OPTIONS_PRICE_DISPLAY];

var UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(UX_OPTIONS.filter(function (option) {
  return option.key !== __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS;
})));

/* unused harmony default export */ var _unused_webpack_default_export = ({
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_12__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    alertBox: __WEBPACK_IMPORTED_MODULE_7__components_generics_alert_box_alert_box_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    formCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_forms_checkbox_checkbox_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__["a" /* default */],
    switchButton: __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__["a" /* default */],
    settingsOption: __WEBPACK_IMPORTED_MODULE_15__settings_option_settings_option_vue__["a" /* default */],
    checkOption: __WEBPACK_IMPORTED_MODULE_17__check_option_check_option_vue__["a" /* default */],
    securitySettings: __WEBPACK_IMPORTED_MODULE_18__security_settings_security_settings_vue__["a" /* default */],
    settingsOptionSwitch: __WEBPACK_IMPORTED_MODULE_16__settings_option_switch_settings_option_switch_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_externalLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      manageInfoLoaded: false,
      correspondence: false,
      logins: [],
      hasLocalPassword: false,
      sectionGeneral: sectionGeneral,
      sectionNotifications: sectionNotifications,
      optionPush: optionPush,
      sectionPushEnabled: false,
      categories: {
        privacy: 'privacy',
        general: 'display',
        push: 'PushNotifications',
        inApp: 'InAppNotifications',
        ux: 'ux'
      },
      sectionUX: UX_OPTIONS
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Settings'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'leaderboardsEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('profile', ['settingsReady']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['settings']), {
    sectionPrivacy: function sectionPrivacy() {
      var results = [{
        key: 'ShowTradeHistory',
        info: "Show my trade activity in 'Currently Predicting'"
      }];
      if (this.leaderboardsEnabled) {
        results.push({
          key: 'AllowLeaderboard',
          info: 'Show my ranking in the Leaderboards'
        });
      }
      return results;
    },
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    },
    isFacebookDisabled: function isFacebookDisabled() {
      return !this.hasLocalPassword;
    },
    isTwitterDisabled: function isTwitterDisabled() {
      return !this.hasLocalPassword;
    },
    isGoogleDisabled: function isGoogleDisabled() {
      return !this.hasLocalPassword;
    },
    hasFacebook: function hasFacebook() {
      return this.checkLogin(PROVIDER_FACEBOOK);
    },
    hasTwitter: function hasTwitter() {
      return this.checkLogin(PROVIDER_TWITTER);
    },
    hasGoogle: function hasGoogle() {
      return this.checkLogin(PROVIDER_GOOGLE);
    },
    hasGeneral: function hasGeneral() {
      if (this.settings.display && typeof this.settings.display.ShowBalanceHeader !== 'undefined') {
        return true;
      }
      return false;
    },
    hasPrivacy: function hasPrivacy() {
      if (this.settings.privacy && typeof this.settings.privacy.ShowTradeHistory !== 'undefined' && typeof this.settings.privacy.AllowLeaderboard !== 'undefined') {
        return true;
      }
      return false;
    },
    hasUX: function hasUX() {
      return this.settings.ux && typeof this.settings.ux.UXSettingBuyColorScheme !== 'undefined' && typeof this.settings.ux.UXSettingMobileContractLayout !== 'undefined' && typeof this.settings.ux.UXSettingPriceDisplay !== 'undefined';
    },
    hasPush: function hasPush() {
      if (this.settings.PushNotifications && typeof this.settings.PushNotifications.AllowPushNotifications !== 'undefined') {
        this.sectionPushEnabled = this.settings.PushNotifications.AllowPushNotifications;
        return true;
      }
      return false;
    },
    isPushDisabled: function isPushDisabled() {
      return !this.sectionPushEnabled;
    },
    haveSettingsLoaded: function haveSettingsLoaded() {
      return this.hasGeneral || this.hasPrivacy || this.hasPush;
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.clearSettings();
    this.getAllSettings().then(this.checkManageInfo).then(function () {
      _this.manageInfoLoaded = true;
    }).then(function () {
      return _this.getExternalLogins({
        type: __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* default */].SOCIAL_LOGIN_ADD
      });
    }).then(function (response) {
      _this.links = response.data;
    }).then(function () {
      _this.loaderRemove(document.body);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getManageInfo', 'removeExternal', 'logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getAllSettings', 'clearSettings']), {
    checkProvider: function checkProvider(x, target) {
      return x.loginProvider.toLowerCase() === target.toLowerCase();
    },
    checkLogin: function checkLogin(target) {
      var _this2 = this;

      return this.logins && this.logins.length > 0 && this.logins.filter(function (x) {
        return _this2.checkProvider(x, target);
      }).length === 1;
    },
    getProviderKey: function getProviderKey(target) {
      var _this3 = this;

      if (this.logins && this.logins.length > 0) {
        var login = this.logins.filter(function (x) {
          return _this3.checkProvider(x, target);
        })[0];
        return login ? login.providerKey : {};
      }
      return {};
    },
    checkManageInfo: function checkManageInfo() {
      var _this4 = this;

      return this.getManageInfo().then(function (data) {
        _this4.hasLocalPassword = data.hasLocalPassword;
        _this4.logins = data.logins;
      });
    },
    onToggleProvider: function onToggleProvider(provider, value) {
      var _this5 = this;

      if (value) {
        if (!this.isWrapperApp) {
          this.loaderAdd(document.body);
        }
        try {
          if (provider === PROVIDER_FACEBOOK) this.facebookLinkClick();
          if (provider === PROVIDER_TWITTER) this.twitterLinkClick();
          if (provider === PROVIDER_GOOGLE) this.googleLinkClick();
        } catch (err) {
          this.loaderRemove(document.body);
          console.error(err);
        }
      } else {
        var payload = {
          loginProvider: provider,
          providerKey: this.getProviderKey(provider)
        };
        this.removeExternal(payload).then(function () {
          return _this5.setSuccessSideNotification('Settings updated successfully.');
        }).then(this.getAllSettings).then(this.checkManageInfo).catch(function () {
          return _this5.setErrorSideNotification('Error has occured.');
        });
      }
    },
    onToggleSetting: function onToggleSetting(item) {
      if (item.key === 'AllowLeaderboard') {
        this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_LEADERBOARDS_UPDATE_INFO);
      }
    },
    onSetPassword: function onSetPassword() {
      this.$router.push({ name: 'password-set' });
    },
    doError: function doError(e) {
      this.setErrorSideNotification(e);
    },
    togglePush: function togglePush(e) {
      this.sectionPushEnabled = e;
    }
  })
});

/***/ }),

/***/ "8rDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-option"},[_c('div',{staticClass:"settings-option__left"},[_c('div',{staticClass:"settings-option__wrap"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"settings-option__right"},[_c('switch-button',{attrs:{"black":""},on:{"toggle":_vm.toggle},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8sRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__("H/Zg");



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    ticketTypes: null,
    reportReasons: []
  },
  mutations: {
    updateTicketTypes: function updateTicketTypes(state, payload) {
      state.ticketTypes = payload;
    },
    setReportReasons: function setReportReasons(state, data) {
      state.reportReasons = data.reasons || [];
    }
  },
  actions: {
    getForumUrl: function getForumUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getForumUrl().then(function (response) {
        return response.data;
      });
    },
    getTicketsTypes: function getTicketsTypes(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getTicketsTypes().then(function (response) {
        return commit('updateTicketTypes', response.data.map(function (o) {
          return { label: o, value: o };
        }));
      });
    },
    postTicket: function postTicket(_ref2, payload) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.postTicket(payload);
    },
    getReportUserReasons: function getReportUserReasons(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$cache = _ref4.cache,
          cache = _ref4$cache === undefined ? true : _ref4$cache;

      if (cache && state.reportReasons.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.reportReasons);
      }
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getReportUser().then(function (response) {
        commit('setReportReasons', response.data);
        return response.data;
      });
    },
    reportUser: function reportUser(_ref5, payload) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.postReportUser(payload).then(function (response) {
        return response.data;
      });
    },
    getAnnouncements: function getAnnouncements() {
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getAnnouncements().then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "8uve":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik01LjYyNSA5aDYuNzVNOSAxNS43NWE2Ljc1IDYuNzUgMCAxIDAgMC0xMy41IDYuNzUgNi43NSAwIDAgMCAwIDEzLjV6IiBzdHJva2U9IiNEMTQzM0YiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "8vMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"market-biggest-gains-element",attrs:{"tag":"div","to":{name: 'market-details', params: {marketId: _vm.promo.marketId, marketUrl: _vm.promo.marketUrl}}}},[(_vm.header)?_c('div',{staticClass:"market-biggest-gains-element__header"},[_vm._v("\n    "+_vm._s(_vm.promo.sectionTitle)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-biggest-gains-element__content"},[_c('div',{staticClass:"market-biggest-gains-element__market"},[_vm._v("\n      "+_vm._s(_vm.promo.marketName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-biggest-gains-element__wrapper"},[_c('div',{staticClass:"market-biggest-gains-element__contract"},[_vm._v("\n        "+_vm._s(_vm.promo.contractName)+"\n      ")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"market-biggest-gains-element__current-price"},[(_vm.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.contract.lastTradePriceAsCents}})]:[_vm._v("\n            -"),_c('span',{domProps:{"innerHTML":_vm._s('&cent;')}})]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contract.changePriceAsCents,"lastClosePrice":_vm.contract.lastClosePrice}})],1),_vm._v(" "),(_vm.hasLastTradePrice)?_c('div',{class:_vm.iconModifiers}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8zAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMapLoader_vue__ = __webpack_require__("sCGU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267a84b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapLoader_vue__ = __webpack_require__("WxRi");
function injectStyle (ssrContext) {
  __webpack_require__("iHgG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMapLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267a84b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9/FY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_dashboard_sushi_js__ = __webpack_require__("NFT2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d45902_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dashboard_sushi_vue__ = __webpack_require__("U23d");
function injectStyle (ssrContext) {
  __webpack_require__("WDky")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_dashboard_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d45902_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dashboard_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "94vp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_request_withdrawal_js__ = __webpack_require__("cLlV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cc6c9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_request_withdrawal_vue__ = __webpack_require__("xOSv");
function injectStyle (ssrContext) {
  __webpack_require__("U/rp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_request_withdrawal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cc6c9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_request_withdrawal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "95mA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    announcement: {
      type: Object,
      required: true
    }
  }
});

/***/ }),

/***/ "95qB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_insight_insight_panel_insight_panel_vue__ = __webpack_require__("QgOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_link_insight_link_vue__ = __webpack_require__("DXdo");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    insightPanel: __WEBPACK_IMPORTED_MODULE_2__components_insight_insight_panel_insight_panel_vue__["a" /* default */],
    insightLink: __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_link_insight_link_vue__["a" /* default */]
  },
  props: {
    numArticles: {
      type: Number,
      default: 4
    }
  },
  data: function data() {
    return {
      linkBack: {
        name: 'insight'
      },
      createLink: function createLink(url) {
        return {
          path: '/insight/' + btoa(encodeURI(url))
        };
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('insight', ['analysis']), {
    allArticlesAway: function allArticlesAway() {
      return !this.isLayoutMobile;
    },
    allArticlesLink: function allArticlesLink() {
      if (!this.isLayoutMobile) {
        return 'https://analysis.predictit.org/';
      }
      return {
        path: '/insight/' + btoa(encodeURI('//analysis.predictit.org/'))
      };
    },
    tumblr: function tumblr() {
      return this.analysis === null ? [] : this.analysis;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('insight', ['getMostPopular', 'getAnalysis'])),
  mounted: function mounted() {
    this.getAnalysis({
      limit: this.numArticles
    });
  }
});

/***/ }),

/***/ "9B+r":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "9H7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index1"},[_c('section',{staticClass:"index__banner"},[_c('div',{staticClass:"row row-x "},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4"},[_c('div',{staticClass:"index1__sign-up"},[_c('div',{staticClass:"index1__modal__header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register',{attrs:{"mode":"page"}}),_vm._v(" "),_c('account-register-footer')],1)])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"index__quote"},[_c('div',{staticClass:"index__quote--quote-container"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"index__quote--quote-logo-img"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/60739962-605f-4bac-912f-6d9353a9c1b5.png"),expression:"`/images/60739962-605f-4bac-912f-6d9353a9c1b5.png`"}],staticClass:"img-responsive"})])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('section',{staticClass:"index__properties"},[_c('div',{staticClass:" "},[_c('div',{staticClass:"index__properties-container"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/4300778c-1f81-48dd-bc0f-34c7b1390ac8.png"),expression:"`/images/4300778c-1f81-48dd-bc0f-34c7b1390ac8.png`"}]})]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/010db909-3592-4dd7-8fe9-53d40fba2b8f.png"),expression:"`/images/010db909-3592-4dd7-8fe9-53d40fba2b8f.png`"}]})]),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/33cc985e-910b-41a6-93b8-bdad5cd60908.png"),expression:"`/images/33cc985e-910b-41a6-93b8-bdad5cd60908.png`"}]})]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/262950df-75d5-4d67-ae63-eb12878c3a0a.png"),expression:"`/images/262950df-75d5-4d67-ae63-eb12878c3a0a.png`"}]})]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/ce63ef48-3790-471d-88cd-dec2880845c1.png"),expression:"`/images/ce63ef48-3790-471d-88cd-dec2880845c1.png`"}]})]),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"})])])]),_vm._v(" "),_vm._m(11)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12 large-8 index__hero-container"},[_c('h1',[_vm._v("Think You Know Politics?")]),_vm._v(" "),_c('h2',[_vm._v("Put your money "),_c('br'),_vm._v(" where your "),_c('br'),_vm._v(" mouth is")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index__prediction"},[_c('div',{staticClass:"row row-x "},[_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8100/Will-Congress-confirm-a-Supreme-Court-justice-in-2025","target":"_blank"}},[_c('div',{staticClass:"index__prediction-img index__prediction-img--left"},[_c('p',{staticClass:"index__prediction--prediction-text"},[_vm._v("New justice "),_c('br'),_vm._v(" confirmed?")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8142/How-many-vetoes-will-Trump-issue-in-2025","target":"_blank"}},[_c('div',{staticClass:"index__prediction-img index__prediction-img--middle"},[_c('p',{staticClass:"index__prediction--prediction-text"},[_vm._v("Number of "),_c('br'),_vm._v(" vetoes?")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8099/Which-party-will-win-the-2025-gubernatorial-election-in-Virginia","target":"_blank"}},[_c('div',{staticClass:"index__prediction-img index__prediction-img--right"},[_c('p',{staticClass:"index__prediction--prediction-text"},[_vm._v("Next Virginia "),_c('br'),_vm._v(" Governor?")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"index__quote--quote-text"},[_c('p',[_vm._v("\"This is probably one of the most exciting engines I've come across in terms of political opinion.\"")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"index__quote--quote-author"},[_c('p',{staticClass:"index__quote--author-name"}),_c('hr',{staticClass:"index__quote--hyphen"}),_vm._v(" James Carville"),_c('p'),_vm._v(" "),_c('p',{staticClass:"index__quote--author-position"},[_vm._v("Political Pundit")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index__video"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"index__video--video-container"},[_c('div',{staticClass:"column small-12 index__video--videowrapper"},[_c('iframe',{attrs:{"height":"608","width":"100%","src":"https://www.youtube.com/embed/XxHBRkqT5YQ?rel=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12 large-12"},[_c('div',{staticClass:"index__process-heading"},[_c('h2',[_vm._v("Start Now")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Shares priced 1¢ - 99¢. Winning shares pay $1.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Think your shares hit the roof? Sell them to other buyers.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Safe and Secure: Operated by the Prediction Market Research Consortium.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Trade on over 300 political futures markets.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Join the prediction market for politics.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index__work"},[_c('div',{staticClass:"row row-x index__work-container "},[_c('div',{staticClass:"col-sm-12 index__process-heading"},[_c('h2',[_vm._v("How Does It Work")])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index__work--work-info"},[_c('div',{staticClass:"index__work--work-icon"},[_vm._v("\n\t\t\t\t\t1\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index__process-text"},[_c('h3',[_vm._v("Browse Markets")]),_vm._v(" "),_c('p',[_vm._v("Look for opportunities on market prices.")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index__work--work-info"},[_c('div',{staticClass:"index__work--work-icon"},[_vm._v("\n\t\t\t\t\t2\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index__process-text"},[_c('h3',[_vm._v("Make a Prediction")]),_vm._v(" "),_c('p',[_vm._v("Think everyone's got it wrong? Buy shares for or against an event taking place. ")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index__work--work-info"},[_c('div',{staticClass:"index__work--work-icon"},[_vm._v("\n\t\t\t\t\t3\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index__process-text"},[_c('h3',[_vm._v("Trade your shares")]),_vm._v(" "),_c('p',[_vm._v("Buy your shares low and sell them high once the crowd figures out you were right.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9IBX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9IfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BRAND; });
var BRAND = 'PredictIt';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  data: function data() {
    return {
      brand: BRAND
    };
  }
});

/***/ }),

/***/ "9MQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-links-toggle",on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_c('transition',{attrs:{"name":"sushi-market-links-toggle"}},[(_vm.showMenu)?_c('div',{staticClass:"sushi-market-links-toggle__menu"},[_c('div',{staticClass:"sushi-market-links-toggle__menu-label"},[_vm._v("\n        Links Widget\n      ")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-links-toggle__menu-inner"},[_c('div',{class:_vm.itemWatchlistModifiers,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleWatchlistPin($event)}}},[_c('div',{staticClass:"sushi-market-links-toggle__menu-inner-icon"}),_vm._v(" "),_c('div',[_vm._v("\n            Watchlist\n          ")])]),_vm._v(" "),_c('div',{class:_vm.itemSessionHistoryModifiers,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleSessionHistoryPin($event)}}},[_c('div',{staticClass:"sushi-market-links-toggle__menu-inner-icon"}),_vm._v(" "),_c('div',[_vm._v("\n            Session List\n          ")])]),_vm._v(" "),(false)?_c('div',{class:_vm.itemMarketHistoryModifiers,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleMarketHistoryPin($event)}}},[_c('div',{staticClass:"sushi-market-links-toggle__menu-inner-icon"}),_vm._v(" "),_c('div',[_vm._v("\n            Product History\n          ")])]):_vm._e()])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9QTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_desktop_sushi_common_betslip_js__ = __webpack_require__("TiAK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_442faf91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_desktop_sushi_common_betslip_vue__ = __webpack_require__("zBTg");
function injectStyle (ssrContext) {
  __webpack_require__("6636")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_desktop_sushi_common_betslip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_442faf91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_desktop_sushi_common_betslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9RvI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9V7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-search"},[(!_vm.isLoading && _vm.items.length === 0)?_c('div',{staticClass:"page-search__disclaimer"},[_vm._v("\n    No results found. Please try again.\n  ")]):_c('div',[_c('div',{staticClass:"page-search__header"},[_c('div',{staticClass:"page-search__header-text"},[_vm._v("\n        Search Results:\n        "),_c('span',{staticClass:"page-search__header-text--small"},[_vm._v("\n          "+_vm._s(_vm.searchQuery)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"page-search__header-text page-search__header-text--right"},[_vm._v("\n         "+_vm._s(_vm.searchResults.totalCount)+" Market"),(_vm.searchResults.totalCount !== 1)?_c('span',[_vm._v("s")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"page-search__grid"},[_vm._l((_vm.items),function(item){return _c('div',{staticClass:"page-search__grid-item"},[_c('market-list-item',{key:item.marketId,attrs:{"market":item}})],1)}),_vm._v(" "),(_vm.searchResults.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"page-search__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Z8S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.checkboxModifiers},[_c('label',{attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"checkbox__tick",class:_vm.classIsChecked}),_vm._v(" "),_c('div',{staticClass:"checkbox__label"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9cGE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onLogin: function onLogin() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'click',
        label: 'Login to My Account'
      });
      if (this.isPage) {
        this.$router.push({ name: 'account-page-login' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
      }
    }
  })
});

/***/ }),

/***/ "9eDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landing_pages_hero_unit_slider_hero_unit_slider_vue__ = __webpack_require__("eLuk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_home_old_quotes_quotes_vue__ = __webpack_require__("PElc");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountRegister: __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__["a" /* default */],
    heroUnitSlider: __WEBPACK_IMPORTED_MODULE_2__components_landing_pages_hero_unit_slider_hero_unit_slider_vue__["a" /* default */],
    quotes: __WEBPACK_IMPORTED_MODULE_3__components_home_home_old_quotes_quotes_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "9ewn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "9hG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__ = __webpack_require__("DECz");



/* harmony default export */ __webpack_exports__["a"] = ({
  getBalance: function getBalance() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/Balance');
  },
  getDepositCard: function getDepositCard() {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositCard?' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositCard');
  },
  postConfirmDepositCard: function postConfirmDepositCard(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/ConfirmDepositCard', marketingPayload);
  },
  postSubmitDepositCard: function postSubmitDepositCard(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/SubmitDepositCard', marketingPayload);
  },
  getPayNearMe: function getPayNearMe(page) {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PayNearMe?page=' + page + '&' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PayNearMe?page=' + page);
  },
  getDepositUSDCoin: function getDepositUSDCoin() {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositUSDCoin?' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositUSDCoin');
  },
  postSubmitDepositUSDCoin: function postSubmitDepositUSDCoin(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/DepositUSDCoin', marketingPayload);
  },
  getWithdrawAch: function getWithdrawAch() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawAch');
  },
  getWithdrawCheck: function getWithdrawCheck() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawCheck');
  },
  getWithdrawUSDC: function getWithdrawUSDC() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawUSDC');
  },
  postWithdrawAch: function postWithdrawAch(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawAch', payload);
  },
  postWithdrawCheck: function postWithdrawCheck(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawCheck', payload);
  },
  postWithdrawUSDC: function postWithdrawUSDC(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawUSDC', payload);
  },
  getPendingWithdrawals: function getPendingWithdrawals() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PendingWithdrawals');
  },
  getPendingDeposits: function getPendingDeposits() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PendingDeposits');
  },
  postCancelWithdrawal: function postCancelWithdrawal(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/CancelWithdrawal', payload);
  },
  getDepositMethods: function getDepositMethods() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositMethods');
  },
  getWithdrawalMethods: function getWithdrawalMethods() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawalMethods');
  },
  getWithdrawWire: function getWithdrawWire() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawWire');
  },
  getWithdrawWireBankSearch: function getWithdrawWireBankSearch(page, query) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawWireBankSearch?page=' + page + '&query=' + encodeURIComponent(query));
  },
  postWithdrawWireBankInfo: function postWithdrawWireBankInfo(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireBankInfo', payload);
  },
  postWithdrawWireConfirm: function postWithdrawWireConfirm(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireConfirm', payload);
  },
  postWithdrawWireSubmit: function postWithdrawWireSubmit(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireSubmit', payload);
  },
  getDepositPWMB: function getDepositPWMB(_ref) {
    var authorizationId = _ref.authorizationId,
        returnUrl = _ref.returnUrl,
        cancelUrl = _ref.cancelUrl;

    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositPWMB?AuthorizationIdToRefresh=' + authorizationId + '&requestedReturnUrl=' + returnUrl + '&requestedCancelUrl=' + cancelUrl + '&' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositPWMB?AuthorizationIdToRefresh=' + authorizationId + '&requestedReturnUrl=' + returnUrl + '&requestedCancelUrl=' + cancelUrl);
  },
  deletePWMBAuthorization: function deletePWMBAuthorization(authorizationId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].delete('api/User/Wallet/PWMBAuthorization/' + authorizationId);
  },
  postConfirmDepositPWMB: function postConfirmDepositPWMB(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/ConfirmDepositPWMB', marketingPayload);
  },
  postSubmitDepositPWMB: function postSubmitDepositPWMB(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/DepositPWMB', marketingPayload);
  },
  getPWMBAuthorization: function getPWMBAuthorization() {
    var queryPart = decodeURIComponent(window.location.search.replace('?pwmbDeposit=success&', '').replace('?pwmbDeposit=cancel&', ''));
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PWMBAuthorization?redirectQueryStringPWMBPart=' + queryPart);
  },
  postInstantCredit: function postInstantCredit(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/InstantCredit', payload);
  }
});

/***/ }),

/***/ "9ozv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_expandable_sushi_js__ = __webpack_require__("z8T8");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_expandable_sushi_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fce65e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_expandable_sushi_vue__ = __webpack_require__("gXJu");
function injectStyle (ssrContext) {
  __webpack_require__("PzZj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_expandable_sushi_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fce65e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_expandable_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9poZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9pxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");
/* eslint-disable max-len */


var DEFAULT_TIMELINE = '30d';

/* harmony default export */ __webpack_exports__["a"] = ({
  getMarketChartData: function getMarketChartData(_ref) {
    var marketId = _ref.marketId,
        _ref$timespan = _ref.timespan,
        timespan = _ref$timespan === undefined ? DEFAULT_TIMELINE : _ref$timespan,
        _ref$maxContracts = _ref.maxContracts,
        maxContracts = _ref$maxContracts === undefined ? 4 : _ref$maxContracts,
        _ref$storyId = _ref.storyId,
        storyId = _ref$storyId === undefined ? null : _ref$storyId,
        _ref$regionUUID = _ref.regionUUID,
        regionUUID = _ref$regionUUID === undefined ? null : _ref$regionUUID,
        _ref$sectionType = _ref.sectionType,
        sectionType = _ref$sectionType === undefined ? null : _ref$sectionType,
        _ref$chartStoryVersio = _ref.chartStoryVersionId,
        chartStoryVersionId = _ref$chartStoryVersio === undefined ? null : _ref$chartStoryVersio;

    var isTimespanInHours = timespan.includes('h');
    var finalTimespan = timespan.replace('h', '').replace('d', '');
    if (finalTimespan === '0') {
      finalTimespan = '';
    }
    if (storyId) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetMarketChartData/' + marketId + '?timespan=' + finalTimespan + '&maxContracts=' + maxContracts + '&isTimespanInHours=' + isTimespanInHours + '&chartUUID=' + regionUUID + '&chartStoryId=' + storyId + '&sectionType=' + (sectionType || '') + '&chartStoryVersionId=' + (chartStoryVersionId || ''));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetMarketChartData/' + marketId + '?timespan=' + finalTimespan + '&maxContracts=' + maxContracts + '&isTimespanInHours=' + isTimespanInHours);
  },
  getContractChartData: function getContractChartData(contractId) {
    var timespan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TIMELINE;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetContractChartData/' + contractId + '?timespan=' + timespan);
  }
});

/***/ }),

/***/ "9rUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_depositWarningMixin__ = __webpack_require__("Scap");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_depositWarningMixin__["a" /* default */]],
  data: function data() {
    return {
      disclaimer: '',
      buttonDisabled: false,
      url: null,
      error: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd();
    this.getPayNearMe('').then(function (data) {
      _this.loaderRemove();
      _this.url = data.url;
      _this.promoCodeDetail = data.promoCodeDetail || {};
      _this.disclaimer = data.disclaimer;
    }).catch(function (error) {
      _this.loaderRemove();
      _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', 'Your authorization to deposit by cash has been disabled.');
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getPayNearMe']), {
    onDeposit: function onDeposit() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Cash Deposit'
      });
      this.buttonDisabled = true;
      window.location.href = this.url;
    }
  })
});

/***/ }),

/***/ "9rb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_requests_list_deposit_js__ = __webpack_require__("G+wi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792ee7ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_requests_list_deposit_vue__ = __webpack_require__("OCkA");
function injectStyle (ssrContext) {
  __webpack_require__("fFb1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_requests_list_deposit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792ee7ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_requests_list_deposit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9sCE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info"},[_c('div',{staticClass:"amount-info__sections"},[_c('div',{staticClass:"amount-info__section"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"amount-info__amount"},[_vm._v("\n        $"+_vm._s(_vm.amount.toFixed(2))+"\n      ")])]),_vm._v(" "),(!_vm.isBankTransfer)?[_c('div',{staticClass:"amount-info__section"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"amount-info__confirmation-number"},[_vm._v("($"+_vm._s(_vm.feeRounded.toFixed(2))+")")])])]:[_c('div',{staticClass:"amount-info__section"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"amount-info__confirmation-number"},[_vm._v("($"+_vm._s(_vm.flatFeeAmountRounded.toFixed(2))+")")])]),_vm._v(" "),_c('div',{staticClass:"amount-info__section"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"amount-info__confirmation-number"},[_vm._v("($"+_vm._s(_vm.percentageFeeAmountRounded.toFixed(2))+")")])])],_vm._v(" "),_c('div',{staticClass:"amount-info__section"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"amount-info__amount"},[_vm._v("$"+_vm._s(_vm.totalRounded.toFixed(2)))])]),_vm._v(" "),(_vm.plaidAccount !== null)?[_c('div',{staticClass:"amount-info__section"},[_vm._m(5),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.plaidAccount.institution_name))])]),_vm._v(" "),_c('div',{staticClass:"amount-info__section"},[_vm._m(6),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.plaidAccount.mask))])])]:_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info__section--left"},[_c('span',[_vm._v("\n          Requested Amount\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info__section--left"},[_c('span',[_vm._v("\n            Fees\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info__section--left"},[_c('span',[_vm._v("\n            Bank Transfer Fee\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info__section--left"},[_c('span',[_vm._v("\n            Processing Fee\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info__section--left"},[_c('span',[_vm._v("\n          Net Withdrawal\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info__section--left"},[_c('span',[_vm._v("\n          Institution Name\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info__section--left"},[_c('span',[_vm._v("\n         Account Number\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9sg1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9xQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_upload_document_account_upload_document_vue__ = __webpack_require__("3USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_ssn_info_upload_account_ssn_info_upload_vue__ = __webpack_require__("FHMi");



var documentUploadMixin = {
  data: function data() {
    return {
      documentUploadSource: 4,
      documentUploadInfoVisible: false,
      documentUploadInfoPending: false,
      collectSsnInfo: false
    };
  },

  components: {
    accountUploadDocument: __WEBPACK_IMPORTED_MODULE_0__components_account_account_upload_document_account_upload_document_vue__["a" /* default */],
    accountSsnInfoUpload: __WEBPACK_IMPORTED_MODULE_1__components_account_account_ssn_info_upload_account_ssn_info_upload_vue__["a" /* default */]
  },
  methods: {
    checkDocumentUploadFlags: function checkDocumentUploadFlags(data) {
      this.documentUploadInfoVisible = data.duRequired || data.duPending;
      this.documentUploadInfoPending = data.duPending;
      this.documentUploadSource = data.duSource || this.documentUploadSource;
      this.collectSsnInfo = data.requireSSN4;
      return data.duRequired || data.duPending;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (documentUploadMixin);

/***/ }),

/***/ "9zdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_option_js__ = __webpack_require__("BEGL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15472aee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_option_vue__ = __webpack_require__("/Fc2");
function injectStyle (ssrContext) {
  __webpack_require__("bzSr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_option_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15472aee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A3QY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A3lz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A6L0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"charts-checkbox"}},[(_vm.show)?_c('div',{class:_vm.classModifiers},[_c('label',{staticClass:"charts-checkbox__label-container",attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{class:_vm.tickClassModifiers,style:(_vm.styleModifiers)}),_vm._v(" "),_c('div',{staticClass:"charts-checkbox__label"},[_vm._t("default")],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A7mH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orientation-info"},[_c('img',{staticClass:"orientation-info__image",attrs:{"src":__webpack_require__("RuPo")}}),_vm._v(" "),_c('div',[_c('span',{staticClass:"orientation-info__emphasize"},[_vm._v("You're making me dizzy!")]),_vm._v(" "),_c('br'),_vm._v("\n    Rotate your device back to portrait mode\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AJVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"plus-minus-sign"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AM9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getPlayerLeaderboards: function getPlayerLeaderboards() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/leaderboards');
  },
  getLeaderboards: function getLeaderboards() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Leaderboards' : 'api/Leaderboards';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getLeaderboard: function getLeaderboard(_ref) {
    var id = _ref.id,
        _ref$dateRange = _ref.dateRange,
        dateRange = _ref$dateRange === undefined ? 7 : _ref$dateRange,
        _ref$page = _ref.page,
        page = _ref$page === undefined ? 1 : _ref$page,
        _ref$itemsPerPage = _ref.itemsPerPage,
        itemsPerPage = _ref$itemsPerPage === undefined ? 30 : _ref$itemsPerPage;

    var encoded = encodeURIComponent('?daterange=' + dateRange + '&page=' + page + '&itemsPerPage=' + itemsPerPage);
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Leaderboards/' + id + encoded : 'api/Leaderboards/' + id + '?daterange=' + dateRange + '&page=' + page + '&itemsPerPage=' + itemsPerPage;
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  }
});

/***/ }),

/***/ "AORQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_phone_update_js__ = __webpack_require__("+jU6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a582e8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_phone_update_vue__ = __webpack_require__("AxPX");
function injectStyle (ssrContext) {
  __webpack_require__("s6Yu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_phone_update_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a582e8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_phone_update_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "APZR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ASm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  props: {
    showIcons: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'leaderboardsEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    enabledLinks: function enabledLinks() {
      return this.links.filter(function (i) {
        return i.enabled;
      });
    },
    links: function links() {
      if (this.isLoggedIn) {
        return [{
          title: 'Markets',
          name: 'markets',
          href: { name: 'market-list' },
          enabled: true
        }, {
          title: 'News',
          name: 'news',
          href: '/news',
          enabled: true
        }, {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          enabled: this.leaderboardsEnabled
        }, {
          title: 'Account',
          name: 'account',
          href: this.accountLink,
          enabled: true
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard',
          enabled: true
        }];
      }

      return [{
        title: 'Markets',
        name: 'markets',
        href: { name: 'market-list' },
        enabled: true
      }, {
        title: 'News',
        name: 'news',
        href: '/news',
        enabled: true
      }, {
        title: 'Leaderboards',
        name: 'leaderboards',
        href: '/leaderboards',
        enabled: this.leaderboardsEnabled
      }];
    }
  }),
  methods: {
    classModifier: function classModifier(name) {
      var _ref;

      var routes = ['market-details'];
      var dontHighlight = routes.includes(this.$route.name);
      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav__link-with-icon main-nav__link-with-icon--' + name, this.showIcons), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav__link--no-highlight', dontHighlight), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav__link', true), _ref;
    },
    showSocialAvatarOnMobile: function showSocialAvatarOnMobile(item) {
      return this.isLayoutMobile && item.name === 'dashboard' && this.isLoggedIn;
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLinkClick: function onLinkClick(href) {
      // scroll page to top if link is clicked again
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
    }
  }
});

/***/ }),

/***/ "AXUH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AYS5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "AZoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ready: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['mapStateData']), {
    meStyleModifiers: function meStyleModifiers() {
      return this.getContractInfo('ME');
    },
    me1StyleModifiers: function me1StyleModifiers() {
      return this.getContractInfo('ME-01');
    },
    me2StyleModifiers: function me2StyleModifiers() {
      return this.getContractInfo('ME-02');
    },
    me3StyleModifiers: function me3StyleModifiers() {
      return this.getContractInfo('ME-03');
    },
    neStyleModifiers: function neStyleModifiers() {
      return this.getContractInfo('NE');
    },
    ne1StyleModifiers: function ne1StyleModifiers() {
      return this.getContractInfo('NE-01');
    },
    ne2StyleModifiers: function ne2StyleModifiers() {
      return this.getContractInfo('NE-02');
    },
    ne3StyleModifiers: function ne3StyleModifiers() {
      return this.getContractInfo('NE-03');
    }
  }),
  watch: {
    mapStateData: {
      handler: 'mapStateDataHandler',
      immediate: true
    }
  },
  methods: {
    getContractInfo: function getContractInfo(key) {
      var data = this.mapStateData[key] || null;
      if (data === null) {
        return {
          background: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY[__WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color
        };
      }
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getLeadingTradedContract */])(data.contracts || []);
      if (!targetContract) {
        return {
          background: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY[__WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color
        };
      }
      var colorMap = targetContract.contractName === __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["d" /* CONTRACTS */].DEMOCRATIC ? __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE : __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED;
      var index = null;
      if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].LOW) {
        index = __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].LOW;
      } else if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].MEDIUM) {
        index = __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM;
      } else if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].HIGH) {
        index = __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH;
      }
      return {
        color: '#fff',
        background: colorMap[index].color
      };
    },
    mapStateDataHandler: function mapStateDataHandler(value) {
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(value)) {
        this.ready = true;
      }
    }
  }
});

/***/ }),

/***/ "AkE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    step: {
      type: Number,
      default: 1
    },
    value: {}
  },
  data: function data() {
    return {
      sliderValue: this.value
    };
  },

  methods: {
    setSliderValue: function setSliderValue(event) {
      this.sliderValue = parseFloat(event.target.value);
    },
    getProgress: function getProgress(value, min, max) {
      return (value - min) / (max - min) * 100;
    },
    setCSSProgress: function setCSSProgress(progress) {
      if (!this.$refs.slider) return;
      this.$refs.slider.style.setProperty('--ProgressPercent', progress + '%');
    }
  },
  watch: {
    value: function value(_value) {
      this.sliderValue = _value !== null ? parseFloat(_value, 10) : 0;
    },
    sliderValue: function sliderValue(value) {
      if (value) {
        this.$emit('input', value);
      }
      var progress = this.getProgress(value, this.min, this.max);
      var extraWidth = (100 - progress) / 10;
      this.setCSSProgress(progress + extraWidth);
    }
  }
});

/***/ }),

/***/ "AkHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi__ = __webpack_require__("HC9X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_extended_betslip_contract_info_purchase_extended_betslip_contract_info_vue__ = __webpack_require__("uY0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_order_book_sushi_order_book_sushi_vue__ = __webpack_require__("kIgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_ownership_and_orders_bar_market_ownership_and_orders_bar_vue__ = __webpack_require__("Pf5Y");










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi__["a" /* default */]],
  components: {
    smallModal: __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_small_small_vue__["default"],
    purchaseExtendedBetslipContractInfo: __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_extended_betslip_contract_info_purchase_extended_betslip_contract_info_vue__["a" /* default */],
    orderBookSushi: __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_order_book_sushi_order_book_sushi_vue__["a" /* default */],
    marketOwnershipAndOrdersBar: __WEBPACK_IMPORTED_MODULE_8__components_market_market_ownership_and_orders_bar_market_ownership_and_orders_bar_vue__["a" /* default */]
  },
  props: {
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ORDER_BOOK_DISPLAY_MODES: __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_order_book_sushi_order_book_sushi_vue__["b" /* ORDER_BOOK_DISPLAY_MODES */],
      isThrottled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['currentPriceSymbol']), {
    dontShowMultiples: function dontShowMultiples() {
      return !this.isYesType && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["f" /* hasNoPositionInAMarketBesidesLoadedContract */])({ market: this.market, contract: this.contract });
    },
    showOwnershipAndOrdersSummary: function showOwnershipAndOrdersSummary() {
      return this.showOwnershipAndOrdersBar && this.showOrderSlip && !this.isMarketSettled && (this.contractModel.userQuantity > 0 || this.contractModel.userOpenOrders > 0);
    },
    extendedOrderBookKey: function extendedOrderBookKey() {
      var timestamp = this.contractModel.timestamp || '-';
      return this.contractModel.contractId + '-' + timestamp + '-' + this.tradeSuccess.toString() + '-' + this.contractModel.mode + '-' + this.contractModel.userOpenOrders + '-' + this.contractModel.userQuantity;
    },
    nextButtonDisabledExtended: function nextButtonDisabledExtended() {
      return this.$options.mixins[0].computed.nextButtonDisabled.call(this) || this.isThrottled;
    },
    nextButtonClassModifiers: function nextButtonClassModifiers() {
      return {
        'purchase-extended-betslip__button': true,
        'purchase-extended-betslip__button--yes': this.isYesType && !this.nextButtonDisabledExtended,
        'purchase-extended-betslip__button--no': !this.isYesType && !this.nextButtonDisabledExtended,
        'purchase-extended-betslip__button--disabled': this.nextButtonDisabledExtended,
        'purchase-extended-betslip__button--throttled': this.isThrottled
      };
    },
    skipConfirmationToggleClassModifiers: function skipConfirmationToggleClassModifiers() {
      return {
        'purchase-extended-betslip__skip-confirmation-toggle': true,
        'purchase-extended-betslip__skip-confirmation-toggle--active': this.skipConfirmation
      };
    },
    buyPrice: function buyPrice() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["h" /* roundToTwo */])(this.quantity * this.pricePerShare / 100).toFixed(2);
    },
    multiple: function multiple() {
      var result = 100 / this.pricePerShare;
      var rounded = Math.round(result * 100) / 100;
      return rounded % 1 === 0 ? Math.round(rounded) : rounded;
    },
    payoutDisplay: function payoutDisplay() {
      if (!this.quantity) {
        return '$-';
      }
      if (this.showSellWarning) {
        return '$-';
      }
      if (this.tradeOptions.operationType === 'sell') {
        var price = this.quantity * this.pricePerShare;
        if (price < 100) {
          return price + '\xA2+';
        }
        return '$' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["h" /* roundToTwo */])(this.quantity * this.pricePerShare / 100).toFixed(2) + '+';
      }
      return '$' + this.quantity;
    },
    payoutDisplayTitle: function payoutDisplayTitle() {
      if (this.tradeOptions.operationType === 'sell') {
        return 'This is the estimated payout if your order is matched at the minimum sell price. Actual figures may differ if your order is matched at more favorable prices';
      }

      return '';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onClickNext: function onClickNext() {
      var _this = this;

      // necessary as we use pointerdown events
      if (this.submitDisabledBecauseOfSwitch) return;
      if (this.skipConfirmation) {
        this.isThrottled = true;
        setTimeout(function () {
          _this.isThrottled = false;
        }, 3000);
      }
      this.$emit('submit');
    },
    payoutClick: function payoutClick() {
      if (this.tradeOptions.operationType === 'sell') {
        this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PAYOUT_INFO);
      }
    },
    onQuantityInputBlur: function onQuantityInputBlur(v) {
      if (v === null || v === '') {
        this.setDefaultQuantity();
      }
    },
    onPriceInputBlur: function onPriceInputBlur(v) {
      if (!v) {
        this.setDefaultPrice();
      }
    },
    onClickOutside: function onClickOutside() {
      this.inputSelected = null;
    }
  })
});

/***/ }),

/***/ "ApBL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ApH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"potential-payouts"},[_c('switch-modal',{staticClass:"modal-switch--payouts",on:{"modalClose":_vm.close,"modalToggle":_vm.toggle}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Potential Payouts")]),_vm._v(" "),_c('div',{key:_vm.toggleIndex,staticClass:"potential-payouts__content",class:_vm.classModifier,attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"potential-payouts__market-name"},[_vm._v(_vm._s(_vm.market.marketName))]),_vm._v(" "),_c('table',{staticClass:"potential-payouts__table"},[_c('thead',{staticClass:"potential-payouts__thead"},[_c('th',[_vm._v("Market Outcome")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("\n            You Own\n          ")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("\n            Shares\n          ")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("\n            Average Price\n          ")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("\n            Value\n          ")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("Risk")]),_vm._v(" "),_c('th',{staticClass:"potential-payouts--last"},[_vm._v("Payout")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.payouts),function(item,index){return _c('tr',{key:index},[_c('td',{staticClass:"potential-payouts--highlight"},[_vm._v(_vm._s(item.contractName))]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"potential-payouts--middle"},[(item.sharesOwned > 0)?_c('span',[(_vm.isNo(item))?[_vm._v("No")]:[_vm._v("Yes")]],2):_c('span',[_vm._v("\n                --\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"potential-payouts--middle"},[(item.sharesOwned > 0)?_c('span',{class:_vm.yourOwnModifiers(item)},[_vm._v("\n                "+_vm._s(item.sharesOwned)+"\n              ")]):_c('span',[_vm._v("\n                --\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"potential-payouts--middle"},[(item.averagePrice !== 0)?_c('span',[_vm._v("\n                "+_vm._s(item.averagePriceString)+"\n              ")]):_c('span',[_vm._v("\n                --\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"potential-payouts--middle"},[(item.investment !== 0)?_c('span',[_vm._v("\n                "+_vm._s(item.investmentString)+"\n              ")]):_c('span',[_vm._v("\n                --\n              ")])]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"potential-payouts--middle",class:_vm.isWithGreatestRisk(item) ? 'potential-payouts--greatest' : ''},[_vm._v(_vm._s(item.riskAmountString))]),_vm._v(" "),_c('td',{staticClass:"potential-payouts--last"},[_vm._v(_vm._s(item.payoutAmountString))])])}),0)]),_vm._v(" "),(_vm.showSpinner)?_c('div',{staticClass:"potential-payouts__spinner"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"potential-payouts__description"},[_c('p',{staticClass:"potential-payouts__risk-calculated"},[_vm._v("Risk is calculated to the tenth of a cent, but rounded for display purposes.")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('a',{ref:"export",on:{"click":_vm.onExport}},[_c('span',{staticClass:"potential-payouts__button"},[_vm._v("Export Full Calculations")])]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"slot":"altheader"},slot:"altheader"},[_vm._v("How are Risk and Potential Payouts calculated?")]),_vm._v(" "),_c('div',{key:_vm.toggleIndex,staticClass:"potential-payouts__content",attrs:{"slot":"altcontent"},slot:"altcontent"},[_c('div',{staticClass:"potential-payouts__altcontent"},[_c('p',[_vm._v("Your Risk in any contract is the sum of your profits and losses, across all contracts, should that contract resolve to \"Yes\".")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('p',[_vm._v("Your Investment in the market as a whole is equal to your greatest Risk in any one contract. This is the amount PredictIt debits from your account to cover your position.")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Your Potential Payout is the amount you will be credited if the contract resolves to \"Yes\". It is the difference between your total Investment (greatest Risk in any contract) and the Risk in the winning contract.\n        ")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('p',[_vm._v("Share Value corresponds to the face value of your position in each contract (shares multiplied by average purchase price).")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('p',[_vm._v("For a full table of these calculations, export the data by clicking the button at the bottom of the table.")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{staticClass:"potential-payouts__description potential-payouts__description--alt"},[_c('a',{ref:"export",on:{"click":_vm.onExport}},[_c('span',{staticClass:"potential-payouts__button"},[_vm._v("Export Full Calculations")])])]):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Aq5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_trades_js__ = __webpack_require__("1vcp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fde476d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trades_vue__ = __webpack_require__("QxNN");
function injectStyle (ssrContext) {
  __webpack_require__("+vs+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_trades_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fde476d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trades_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Aqlg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_update_image_js__ = __webpack_require__("Ug2n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cff97fac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_update_image_vue__ = __webpack_require__("tp7G");
function injectStyle (ssrContext) {
  __webpack_require__("YWtT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_update_image_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cff97fac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_update_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AsO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    balance: {
      type: String
    },
    restricted: {
      type: String,
      default: ''
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_RESTRICTED_FUNDS_INFO);
    }
  })
});

/***/ }),

/***/ "AxKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_avatar_account_social_avatar_vue__ = __webpack_require__("ROsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_userDetails__ = __webpack_require__("jtWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_userDetails__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_socialLevel__["a" /* default */]],
  components: {
    accountSocialAvatar: __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_avatar_account_social_avatar_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      infiniteLoader: null,
      isLoading: false
    };
  },

  watch: {
    isLoggedIn: {
      handler: 'leaderboardsParamChangeHandler'
    },
    leaderboardsDateRange: {
      handler: 'leaderboardsParamChangeHandler'
    },
    selectedLeaderboard: {
      handler: 'leaderboardsParamChangeHandler',
      immediate: true
    },
    rows: function rows() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.leaderboardsResults.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('leaderboards', ['selectedLeaderboard']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('leaderboards', ['leaderboardsDateRange', 'leaderboardsResults']), {
    rows: function rows() {
      var _this = this;

      var items = this.leaderboardsResults.data === null ? [] : this.leaderboardsResults.data;
      if (this.leaderboardsResults.trader) {
        return [this.leaderboardsResults.trader].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(items.filter(function (i) {
          return i.userName !== _this.leaderboardsResults.trader.userName;
        })));
      }
      return items;
    },
    infiniteLoadingKey: function infiniteLoadingKey() {
      return this.selectedLeaderboard.leaderBoardId + '-' + this.leaderboardsDateRange + '-' + this.isLoggedIn.toString();
    },
    showNoDataMessage: function showNoDataMessage() {
      return !this.isLoading && this.rows.length === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('leaderboards', ['resetLeaderboardsResults', 'getLeaderboardsResults']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    range: function range(limit) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, limit);
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.leaderboardsResults.canLoadMore) {
        this.loadLeaderboardRows();
      }
    },
    loadLeaderboardRows: function loadLeaderboardRows() {
      var _this2 = this;

      this.isLoading = true;
      this.getLeaderboardsResults().then(function () {
        _this2.isLoading = false;
      }).catch(function () {
        _this2.isLoading = false;
        _this2.infiniteLoader.complete();
        _this2.infiniteLoader = null;
      });
    },
    leaderboardsParamChangeHandler: function leaderboardsParamChangeHandler(newValue) {
      if (newValue) {
        this.resetLeaderboardsResults();
        this.infiniteLoader = null;
      }
    },
    traderLevelColor: function traderLevelColor(item) {
      return this.getLevelByNumber(item.traderLevel).currentColor;
    },
    traderLevelDisplay: function traderLevelDisplay(item) {
      var level = this.getLevelByNumber(item.traderLevel);
      return 'Level ' + level.num + ' (' + level.text + ')';
    },
    traderRoiDisplay: function traderRoiDisplay(item) {
      var value = Math.abs(item.roi * 100);
      var fractionDigits = value >= 1000 ? 0 : 1;
      var roi = value.toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      });
      return roi + '%';
    },
    isItemCurrentUser: function isItemCurrentUser(item) {
      return this.leaderboardsResults.trader && this.leaderboardsResults.trader.userName === item.userName;
    },
    rowClassModifiers: function rowClassModifiers(item) {
      return {
        'leaderboards-table__row': true,
        'leaderboards-table__row--me': this.isItemCurrentUser(item)
      };
    },
    roiModifiers: function roiModifiers(item) {
      return {
        'leaderboards-table__row-roi': true,
        'leaderboards-table__row-roi--gain': item.roi > 0,
        'leaderboards-table__row-roi--loss': item.roi < 0
      };
    },
    arrowChangeClassModifiers: function arrowChangeClassModifiers(item) {
      return {
        'leaderboards-table__row-change-arrow': true,
        'leaderboards-table__row-change-arrow--up': item.rankChange > 0,
        'leaderboards-table__row-change-arrow--down': item.rankChange < 0
      };
    },
    showRankChange: function showRankChange(item) {
      return item.rankChange !== null && item.rankChange !== 0;
    },
    onAvatarClick: function onAvatarClick(item) {
      if (this.isItemCurrentUser(item)) return;
      this.showUserDetails(item);
    },
    onRoiInfoClick: function onRoiInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_ROI_INFO);
    },
    onWinsInfoClick: function onWinsInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_WINS_INFO);
    }
  })
});

/***/ }),

/***/ "AxPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-phone-update"},[(_vm.error)?_c('div',{staticClass:"account-phone-update__error"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.step === 'input')?_c('div',{staticClass:"account-phone-update__step"},[_c('p',{staticClass:"account-phone-update__description"},[_vm._v("\n      Verify your phone number via SMS code.\n    ")]),_vm._v(" "),_c('div',{staticClass:"account-phone-update__field"},[_c('label',{staticClass:"account-phone-update__label"},[_vm._v("Phone Number")]),_vm._v(" "),_c('div',{staticClass:"account-phone-update__input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"account-phone-update__input",attrs:{"type":"tel","placeholder":"+1 (555) 555-5555","autocomplete":"tel"},domProps:{"value":(_vm.phoneNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value},function($event){return _vm.$v.phoneNumber.$touch()}],"blur":function($event){return _vm.$v.phoneNumber.$touch()}}}),_vm._v(" "),(_vm.phoneError)?_c('div',{staticClass:"account-phone-update__field-error"},[_vm._v("\n          "+_vm._s(_vm.phoneError)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":!_vm.canSendCode},on:{"click":_vm.sendCode}},[_vm._v("\n      "+_vm._s(_vm.isSending ? "Sending..." : "Send Verification Code")+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.step === 'verify')?_c('div',{staticClass:"account-phone-update__step"},[_c('p',{staticClass:"account-phone-update__description"},[_vm._v("\n      Enter the 6-digit code sent to "+_vm._s(_vm.phoneNumber)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"account-phone-update__field"},[_c('label',{staticClass:"account-phone-update__label"},[_vm._v("Verification Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verificationCode),expression:"verificationCode"}],staticClass:"account-phone-update__input",attrs:{"type":"text","placeholder":"000000","maxlength":"6","inputmode":"numeric","autocomplete":"one-time-code"},domProps:{"value":(_vm.verificationCode)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.verifyCode($event)},"input":function($event){if($event.target.composing){ return; }_vm.verificationCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"account-phone-update__resend"},[_c('button',{staticClass:"account-phone-update__resend-btn",attrs:{"disabled":_vm.secondsUntilResend > 0},on:{"click":_vm.sendCode}},[_vm._v("\n        "+_vm._s(_vm.secondsUntilResend > 0
            ? ("Resend code in " + _vm.secondsUntilResend + "s")
            : "Resend code")+"\n      ")])]),_vm._v(" "),_c('button',{staticClass:"button button--primary button--full-width",attrs:{"disabled":!_vm.canVerify},on:{"click":_vm.verifyCode}},[_vm._v("\n      "+_vm._s(_vm.isVerifying ? "Verifying..." : "Verify & Update")+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-phone-update__footer"},[_c('button',{staticClass:"account-phone-update__cancel-btn",on:{"click":_vm.onCancel}},[_vm._v("\n      Cancel\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Axs9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"coinbase-process-overview",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 1\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       We initiate a "+_vm._s(_vm.amountDisplay)+" USDC transaction with Coinbase, a leader in digital payment solutions.\n    ")])]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 2\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       You are automatically redirected to the Coinbase payment details website where you can see all of the necessary details about your future "+_vm._s(_vm.amountDisplay)+" USDC transaction. "),_c('strong',[_vm._v("Only send USD Coin (USDC), sending any other digital asset, including Ethereum (ETH) will result in permanent loss.")])])]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 3\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       Using Coinbase, or your preferred digital payment wallet, you send us the payment using the unique payment details from Step 2."),_c('strong',[_vm._v(" Please Note: While you are technically able to send more or less than the amount you entered on the previous screen ($"+_vm._s(_vm.amountDisplay)+") using your wallet, doing so will result in significant delays in your payment processing.")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"column small-1"},[_c('form-checkbox',{staticClass:"checkbox--no-margin",attrs:{"name":"Afree","label":""},model:{value:(_vm.fields.agreed),callback:function ($$v) {_vm.$set(_vm.fields, "agreed", $$v)},expression:"fields.agreed"}})],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"add-funds-coinbase__submit"},[_c('form-submit',{attrs:{"label":"Continue to Coinbase","disabled":_vm.isConfirmDisabled}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 4\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n      While your deposit is being processed by the crypto processing network it will not appear in your PredictIt account balance. Once the payment has been verified by Coinbase your PredictIt account balance will automatically be updated. Depending on network traffic this can take up to 24hrs.\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-11"},[_c('div',{staticClass:"coinbase-process-overview__note"},[_vm._v("\n          I understand the risks of using crypto currencies and that any over-payments can only be 'refunded' via the standard PredictIt Withdrawal process and are subject to standard processing fees.\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AyQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VERSION_SETTINGS_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VERSION_TO_MIGRATE_TO; });
/* unused harmony export getCurrentVersionNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shouldShowWhatsIsNewPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_app__ = __webpack_require__("WSTi");
 /* eslint-disable */




/*
  When new version is introduced to migrate to (e.g)
  change VERSION_TO_MIGRATE_TO to 2 and update what-is-new-popup and what-is-new-popup-footer
   to use different flow for instance whatIsNewFlowVersion2
*/

var VERSION_SETTINGS_LOADING = -1;
var VERSION_TO_MIGRATE_TO = 1;

var getCurrentVersionNumber = function getCurrentVersionNumber() {
  var version = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.profile.settings.ux, __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingAnnouncementCurState, VERSION_SETTINGS_LOADING.toString());
  return parseInt(version, 10);
};

var shouldShowWhatsIsNewPopup = function shouldShowWhatsIsNewPopup() {
  var versionNumber = getCurrentVersionNumber();
  return !!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/isLoggedIn'] && versionNumber !== VERSION_SETTINGS_LOADING && versionNumber < VERSION_TO_MIGRATE_TO;
};

/***/ }),

/***/ "AyUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_platform_announcements_js__ = __webpack_require__("dLt5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40220df4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_platform_announcements_vue__ = __webpack_require__("teEc");
function injectStyle (ssrContext) {
  __webpack_require__("hKjy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_platform_announcements_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40220df4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_platform_announcements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AzCe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B/8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_daily_markets_js__ = __webpack_require__("nGgz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e2f3713_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_markets_vue__ = __webpack_require__("CyJB");
function injectStyle (ssrContext) {
  __webpack_require__("p8N8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_daily_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e2f3713_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B3yl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-small",class:_vm.classModifier},[(_vm.overlay)?_c('div',{staticClass:"modal-small__overlay",on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-small__wrap"},[_c('div',{staticClass:"modal-small__header"},[_vm._t("header"),_vm._v(" "),(_vm.closeButton)?_c('button',{staticClass:"modal-small__close",on:{"click":_vm.close}}):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"modal-small__content"},[_vm._t("content")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B8JL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "BC2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");








var DATE_FORMAT = 'MM/DD/YYYY hh:mm a';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    scrollable: {
      type: Boolean,
      default: false
    },
    minimumRows: {
      type: Number,
      default: 0
    },
    contract: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true,
      default: []
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    cardLayout: {
      type: Boolean,
      default: false
    },
    compactCardLayout: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAll: this.scrollable,
      showAllCut: 5
    };
  },
  created: function created() {
    this.updateShowAll();
  },

  watch: {
    'contract.contractId': {
      handler: function handler() {
        this.updateShowAll();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    classModifiers: function classModifiers() {
      return {
        'order-book-shares-sushi': true,
        'order-book-shares-sushi--card-layout': this.cardLayout,
        'order-book-shares-sushi--compact-card': this.cardLayout && this.compactCardLayout,
        'order-book-shares-sushi--card-empty': this.isCardEmpty,
        'order-book-shares-sushi--scrollable': this.scrollable,
        'order-book-shares-sushi--scrollable-empty': this.isScrollableEmpty
      };
    },
    tableModifiers: function tableModifiers() {
      return {
        'order-book-sushi__table': true,
        'order-book-sushi__table--scrollable': this.scrollable
      };
    },
    bodyModifiers: function bodyModifiers() {
      return {
        'order-book-sushi__body': true,
        'order-book-sushi__body--scrollable': this.scrollable
      };
    },
    showColumnHeader: function showColumnHeader() {
      return this.scrollable;
    },
    showCardColumnHeader: function showCardColumnHeader() {
      return this.cardLayout;
    },
    shares: function shares() {
      return this.items.map(function (s) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, s, {
          pricePerShare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["g" /* toCents */])(s.pricePerShare),
          dateExecuted: __WEBPACK_IMPORTED_MODULE_4_moment___default()(s.dateExecuted).format(DATE_FORMAT) + ' ET',
          isNo: s.predictionType === 0 || s.predictionType === 2
        });
      });
    },
    showAllItemsNotice: function showAllItemsNotice() {
      if (this.scrollable) return false;
      return this.shares.length > this.showAllCut;
    },
    itemsToDisplay: function itemsToDisplay() {
      return this.showAll ? this.shares : this.shares.slice(0, this.showAllCut);
    },
    displayRows: function displayRows() {
      var minimumRows = Math.max(this.minimumRows, this.scrollable ? 0 : 1);
      if (this.cardLayout && this.compactCardLayout) {
        minimumRows = this.isCardEmpty ? 1 : 0;
      }
      var displayRows = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemsToDisplay));
      var rowCount = Math.max(displayRows.length, minimumRows);

      while (displayRows.length < rowCount) {
        displayRows.push(null);
      }

      return displayRows;
    },
    emptyStateText: function emptyStateText() {
      return this.isLoggedIn ? '(No Holdings)' : '(Not Logged In)';
    },
    isCardEmpty: function isCardEmpty() {
      return this.cardLayout && this.shares.length === 0;
    },
    isScrollableEmpty: function isScrollableEmpty() {
      return this.scrollable && this.shares.length === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), {
    getDate: function getDate(dateExecuted) {
      if (!dateExecuted) return '';
      var v = dateExecuted.split(' ');
      return v[0];
    },
    loginClicked: function loginClicked() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    },
    onInfoClick: function onInfoClick(item) {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_SHARE_INFO);
      this.setCurrentPopupOptions({ item: item });
    },
    toggleShowAll: function toggleShowAll() {
      this.showAll = !this.showAll;
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set('order_book_shares_show_all_' + this.contract.contractId, this.showAll);
    },
    updateShowAll: function updateShowAll() {
      if (this.scrollable) return;
      this.showAll = __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('order_book_shares_show_all_' + this.contract.contractId, false);
    }
  })
});

/***/ }),

/***/ "BCWs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_currency_input_currency_input_vue__ = __webpack_require__("xMYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");










var DEBOUNCE_TIME = 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_forms_checkbox_checkbox_vue__["a" /* default */],
    currencyInput: __WEBPACK_IMPORTED_MODULE_6__components_forms_currency_input_currency_input_vue__["a" /* default */]
  },
  props: {
    category: {
      type: String,
      required: true
    },
    obj: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      checked: false,
      errorChecked: null,
      value: this.initialValue,
      errorValue: null,
      debounceUpdate: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('profile', ['settings']), {
    name: function name() {
      return this.obj.key;
    },
    checkboxName: function checkboxName() {
      return '' + this.category + this.name;
    },
    withValue: function withValue() {
      return this.obj.withValue;
    },
    getSettingsChecked: function getSettingsChecked() {
      return this.settings[this.category][this.name];
    },
    getSettingsValue: function getSettingsValue() {
      return this.withValue ? this.settings[this.category][this.withValue] : 0;
    },
    classObject: function classObject() {
      return {
        'check-option': true,
        'check-option--with-value': this.withValue,
        'check-option--disabled': this.disabled
      };
    },
    initialValue: function initialValue() {
      return 10;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('profile', ['updateSettings'])),
  created: function created() {
    var _this = this;

    this.checked = this.getSettingsChecked;
    var parsed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(this.getSettingsValue, 10);
    this.value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(parsed) ? this.initialValue : parsed;

    this.$watch('checked', function (val, old) {
      if (_this.errorChecked !== val) {
        _this.loaderAddLegacy();
        _this.updateSettings({
          category: _this.category,
          key: _this.name,
          value: val
        }).then(function () {
          return _this.loaderRemoveLegacy();
        }).catch(function () {
          _this.loaderRemoveLegacy();
          _this.errorChecked = old;
          _this.checked = _this.errorChecked;
          _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
        });
      } else {
        _this.errorChecked = null;
      }
    });

    this.debounceUpdate = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function (val) {
      _this.updateSettings({
        category: _this.category,
        key: _this.withValue,
        value: val
      }).catch(function () {
        _this.errorValue = _this.getSettingsValue;
        _this.value = _this.errorValue;
        _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
      });
    }, DEBOUNCE_TIME, { trailing: true });

    if (this.withValue) {
      this.$watch('value', function (val) {
        // prevents watch endless loop
        if (_this.errorValue !== val) {
          _this.debounceUpdate(val);
        } else {
          _this.errorValue = null;
        }
      });
    }
  }
});

/***/ }),

/***/ "BEn0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BGev":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTQgOCI+CiAgICA8cGF0aCBmaWxsPSIjQjhDNUM2IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0uMzMzIDcuMDA3bC42NzMuNjA0Yy4yMzQuMTk5LjUwNy4yOTguODE4LjI5OC4zMTggMCAuNTg3LS4xLjgwOS0uMjk4TDcgMy42OTdsNC4zNjcgMy45MTRjLjIyMi4xOTkuNDkxLjI5OC44MDkuMjk4LjMxMSAwIC41ODQtLjEuODE4LS4yOThsLjY2NS0uNjA0QS45NTEuOTUxIDAgMCAwIDE0IDYuMjc0YS45MTIuOTEyIDAgMCAwLS4zNDEtLjcyNUw3LjgwOS4zMDZBMS4xMzEgMS4xMzEgMCAwIDAgNyAwYy0uMzE4IDAtLjU5LjEwMi0uODE4LjMwNkwuMzMyIDUuNTQ5QS45MzguOTM4IDAgMCAwIDAgNi4yNzRjMCAuMjguMTEuNTIzLjMzMy43MzN6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "BL43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



// const ROUTES_TO_HIDE_COUNT = [
//   'portfolio',
// ];

var unreadNotificationMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userUnreadNotificationsCount']), {
    userUnreadNotificationsCountHeader: function userUnreadNotificationsCountHeader() {
      // if (this.$route && ROUTES_TO_HIDE_COUNT.includes(this.$route.name)) return 0;
      return this.userUnreadNotificationsCount;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('dashboard', ['markNotificationsAsRead']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['setUserUnreadNotificationsCount']), {
    clearAllNotifications: function clearAllNotifications() {
      this.markNotificationsAsRead();
      this.setUserUnreadNotificationsCount(0);
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (unreadNotificationMixin);

/***/ }),

/***/ "BPuv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BRRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_offers_sushi_js__ = __webpack_require__("0IZu");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_offers_sushi_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3366790a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_offers_sushi_vue__ = __webpack_require__("Phpc");
function injectStyle (ssrContext) {
  __webpack_require__("AXUH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_offers_sushi_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3366790a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_offers_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BSVH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BYVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BiGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_table_view_js__ = __webpack_require__("N2Hf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6a1163_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_table_view_vue__ = __webpack_require__("2YJ6");
function injectStyle (ssrContext) {
  __webpack_require__("zeud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_table_view_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6a1163_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_table_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BmES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_appNotification__ = __webpack_require__("qtti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_plus_minus_sign_plus_minus_sign_vue__ = __webpack_require__("T2le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_notifications__ = __webpack_require__("t45u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);










var DATE_FORMAT = 'MM/DD/YYYY hh:mm a';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_appNotification__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["b" /* formMixin */]],
  components: {
    plusMinusSign: __WEBPACK_IMPORTED_MODULE_3__components_generics_plus_minus_sign_plus_minus_sign_vue__["a" /* default */]
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      dontShowAgain: false,
      advanced: false
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'notification-item-trade-confirmed': true,
        'notification-item-trade-confirmed--processing': this.isProcessedOrMatched
      };
    },
    showFooter: function showFooter() {
      return !false;
    },
    minPrice: function minPrice() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["g" /* toCents */])(this.data.Offer.PricePerShare);
    },
    minPriceDisplay: function minPriceDisplay() {
      var suffix = this.minPrice === 1 ? 'cent' : 'cents';
      return this.minPrice + ' ' + suffix;
    },
    profit: function profit() {
      return this.data.TotalProfit;
    },
    fee: function fee() {
      return this.data.TotalFees;
    },
    cost: function cost() {
      return this.data.TotalCost;
    },
    risk: function risk() {
      return this.data.TotalRiskChange;
    },
    showRisk: function showRisk() {
      return this.data.ShowRisk;
    },
    contractName: function contractName() {
      return this.data.Name || this.data.LongName;
    },
    marketName: function marketName() {
      return this.data.MarketName;
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["j" /* isMarketSingle */])(this.data);
    },
    history: function history() {
      var source = this.data.History ? this.data.History.map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, i);
      }) : [];
      return source.map(function (h) {
        h.PricePerShare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["g" /* toCents */])(h.PricePerShare);
        return h;
      }) || [];
    },
    dateCreated: function dateCreated() {
      var v = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.data, 'Offer.DateCreated', null);
      return v !== null ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(v).format(DATE_FORMAT) + ' ET' : null;
    },
    defaultTradeType: function defaultTradeType() {
      return parseInt(this.data.Offer.TradeType, 10) || 0;
    },
    offerType: function offerType() {
      return this.data.Offer.TradeType;
    },
    offerId: function offerId() {
      return this.data.Offer.OfferId;
    },
    remainingQuantity: function remainingQuantity() {
      return this.data.Offer.RemainingQuantity;
    },
    isOfferProcessed: function isOfferProcessed() {
      return this.data.History !== null && this.data.History.length > 0 && this.data.Offer.RemainingQuantity !== 0;
    },
    isOfferMatched: function isOfferMatched() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__store_modules_notifications__["a" /* isOfferMatched */])(this.data);
    },
    isOpenOfferRecorded: function isOpenOfferRecorded() {
      return this.data.Offer.RemainingQuantity !== 0;
    },
    isProcessedOrMatched: function isProcessedOrMatched() {
      return this.isOfferProcessed || this.isOfferMatched;
    },
    offerStatusLongText: function offerStatusLongText() {
      if (this.isOfferProcessed) return 'Order Matched!';
      if (this.isOfferMatched) return 'Order Matched!';
      if (this.isOpenOfferRecorded) return 'Order Recorded';
      return null;
    },
    showHistory: function showHistory() {
      return this.isProcessedOrMatched && this.history && this.history.length > 0;
    },
    showCashFooter: function showCashFooter() {
      return this.isProcessedOrMatched && this.advanced;
    },
    showOpenOfferRecordedFooter: function showOpenOfferRecordedFooter() {
      return this.isOpenOfferRecorded && this.advanced;
    },
    showToggle: function showToggle() {
      return true;
      // return this.isProcessedOrMatched;
    },
    showProfitLoss: function showProfitLoss() {
      return this.defaultTradeType > 1;
    },
    showFees: function showFees() {
      return this.defaultTradeType > 1 && this.fee !== 0;
    },
    shareText: function shareText() {
      if (this.history.length > 0) {
        if (this.defaultTradeType <= 1) {
          // show max price when user buy shares
          var _h = this.history.reduce(function (prev, current) {
            return prev.PricePerShare > current.PricePerShare ? prev : current;
          });
          return this.getShareText('buy', _h.Quantity, _h.PricePerShare);
        }
        // show min price when user sell shares
        var h = this.history.reduce(function (prev, current) {
          return prev.PricePerShare < current.PricePerShare ? prev : current;
        });
        return this.getShareText('sell', h.Quantity, h.PricePerShare);
      }
      if (this.defaultTradeType <= 1) {
        return this.getShareText('buy-offer', this.remainingQuantity, this.minPrice);
      }
      return this.getShareText('sell-offer', this.remainingQuantity, this.minPrice);
    },
    shareUrl: function shareUrl() {
      var resolved = this.$router.resolve({
        name: 'market-details',
        params: {
          marketId: this.data.MarketId,
          marketUrl: this.data.MarketUrl
        }
      });
      return '' + window.location.origin + resolved.href;
    },
    facebookShareUrl: function facebookShareUrl() {
      var pictureUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["C" /* getAssetPath */])('/images/Contracts/' + this.data.ImageName);
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl) + '&picture=' + encodeURIComponent(pictureUrl) + '&quote=' + encodeURIComponent(this.shareText);
    },
    twitterShareUrl: function twitterShareUrl() {
      return 'http://twitter.com/share?text=' + encodeURIComponent(this.shareText) + '&url=' + encodeURIComponent(this.shareUrl);
    },
    toggleButtonModifiers: function toggleButtonModifiers() {
      return {
        'notification-item-trade-confirmed__toggle': true,
        'notification-item-trade-confirmed__toggle--on': this.advanced
      };
    },
    profitOrLossText: function profitOrLossText() {
      return this.data.TotalProfit > 0 ? 'Profit' : 'Loss';
    },
    bottomContainerClassModifiers: function bottomContainerClassModifiers() {
      return {
        'notification-item-trade-confirmed__container': true,
        'notification-item-trade-confirmed__container--simple': !this.isProcessedOrMatched,
        'notification-item-trade-confirmed__container--border': this.isProcessedOrMatched
      };
    },
    mailto: function mailto() {
      var text = this.shareText;
      var newShareText = text.replace(' @PredictIt', '');
      return 'mailto:?body=' + newShareText + escape('\r\n') + escape('\r\n') + escape('\r\n') + this.shareUrl + '&subject=I just traded on PredictIt.org!';
    }
  },
  methods: {
    soldOrBoughtTextOffer: function soldOrBoughtTextOffer() {
      return this.defaultTradeType <= 1 ? 'Buy Order' : 'Sell Order';
    },
    soldOrBoughtText: function soldOrBoughtText() {
      var tradeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var isHistoryPresent = !!this.data.History;
      if (tradeType === null) return this.soldOrBoughtText(this.defaultTradeType);
      if (tradeType <= 1) return isHistoryPresent ? 'Bought' : 'Buy';
      return isHistoryPresent ? 'Sold' : 'Sell';
    },
    isYes: function isYes(tradeType) {
      return tradeType === 1 || tradeType === 3;
    },
    yesNoText: function yesNoText(tradeType) {
      return this.isYes(tradeType) ? 'YES' : 'NO';
    },
    tradeTypeClassModifier: function tradeTypeClassModifier(tradeType) {
      return {
        'notification-item-trade-confirmed__num-shares': true,
        'notification-item-trade-confirmed__num-shares--yes': this.isYes(tradeType),
        'notification-item-trade-confirmed__num-shares--no': !this.isYes(tradeType)
      };
    },
    onToggle: function onToggle() {
      this.advanced = !this.advanced;
    },
    openShareDialog: function openShareDialog(url) {
      window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
    },
    onEmailShare: function onEmailShare() {
      this.$gtm.trackEvent({ event: 'Share-Email' });
    },
    onFacebookShare: function onFacebookShare() {
      this.$gtm.trackEvent({ event: 'Share-Facebook' });
      this.openShareDialog(this.facebookShareUrl);
    },
    onTwitterShare: function onTwitterShare() {
      this.$gtm.trackEvent({ event: 'Share-Twitter' });
      this.openShareDialog(this.twitterShareUrl);
    },
    getShareText: function getShareText(type, quantity, pricePerShare) {
      var soldOrBoughtShareText = 'I just bought';
      switch (type) {
        default:
        case 'buy':
          break;
        case 'sell':
          soldOrBoughtShareText = 'I just sold';
          break;
        case 'buy-offer':
          soldOrBoughtShareText = "I'm placing an order to buy";
          break;
        case 'sell-offer':
          soldOrBoughtShareText = "I'm placing an order to sell";
          break;
      }

      var suffix = quantity > 1 ? 'shares' : 'share';
      var tradeTypeText = this.defaultTradeType === 0 || this.defaultTradeType === 2 ? 'No' : 'Yes';
      var contractSuffix = this.isMarketSingle ? '' : ' in \'' + this.contractName + '\'';
      var shares = quantity + ' ' + tradeTypeText + ' ' + suffix + contractSuffix;

      return soldOrBoughtShareText + ' ' + shares + ' for ' + pricePerShare + '\xA2 in this market. @PredictIt';
    }
  }
});

/***/ }),

/***/ "Bmi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-key-stats"},[_c('div',{staticClass:"market-key-stats__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('div',{staticClass:"market-key-stats__content"},_vm._l((_vm.items),function(elem,index){return _c('market-key-stats-element',{key:index,attrs:{"widget":elem}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bo+i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C5mt":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMwN2EwYmIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjM0IDEwLjczMmwtNy42MDggNC4zNFY2LjM0bDcuNjA4IDQuMzkyem01LjQ2NCA2LjUzNlY0LjE5NkgyLjE5NnYxMy4wNzJoMTkuNjA4em0wLTE1LjI2OGMuNTc5IDAgMS4wOS4yMTMgMS41MzIuNjM4LjQ0My40MjYuNjY0Ljk0NS42NjQgMS41NThsLS4wNTEgMTMuMDcyYzAgLjU3OS0uMjEzIDEuMDgtLjYzOCAxLjUwNi0uNDI2LjQyNi0uOTI4LjYzOS0xLjUwNy42MzlIMTYuMzR2Mi4xOTZINy42NnYtMi4xOTZIMi4xOTZhMi4xMiAyLjEyIDAgMCAxLTEuNTU4LS42MzlDLjIxMyAxOC4zNSAwIDE3Ljg0NyAwIDE3LjI2OFY0LjE5NmMwLS42MTMuMjEzLTEuMTMyLjYzOC0xLjU1OEEyLjExOSAyLjExOSAwIDAgMSAyLjE5NiAyaDE5LjYwOHoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "CAq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");

/* eslint-disable no-restricted-syntax,consistent-return */






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    stateCode: {
      type: String
    },
    stateName: {
      type: String
    },
    marketData: {
      type: Object
    },
    type: {}
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  data: function data() {
    return {
      capitalizeFirstLetter: __WEBPACK_IMPORTED_MODULE_5__utils_helpers__["B" /* capitalizeFirstLetter */],
      toCents: __WEBPACK_IMPORTED_MODULE_5__utils_helpers__["g" /* toCents */]
    };
  },

  computed: {
    isSenate: function isSenate() {
      return this.type === 'senate';
    },
    color: function color() {
      return this.pallette.color;
    },
    showNote: function showNote() {
      var statesForNote = ['ME', 'NE'];
      return statesForNote.includes(this.stateCode) && !this.isSenate;
    },
    winnerMode: function winnerMode() {
      return this.targetContract !== null;
      // return get(this.marketData, 'status', 'Open') === constants.MARKET_CLOSED;
    },
    winnerBgColorStyleModifiers: function winnerBgColorStyleModifiers() {
      return {
        'background-color': this.color
      };
    },
    targetContract: function targetContract() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["v" /* getLeadingTradedContract */])(this.marketData.contracts || []);
    },
    targetContractInstance: function targetContractInstance() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.targetContract || {});
    },
    classModifiers: function classModifiers() {
      return {
        'market-state-tooltip': true
      };
    },
    styleModifiers: function styleModifiers() {
      return {
        border: '4px solid ' + this.color
      };
    },
    titleClassModifiers: function titleClassModifiers() {
      // const lightPallettes = [
      //   COLOR_MAP.GRAY[0],
      //   COLOR_MAP.BLUE[0],
      //   COLOR_MAP.RED[0],
      // ];
      return {
        'market-state-tooltip__state-name': true
        // 'market-state-tooltip__state-name--light': lightPallettes.includes(this.pallette),
      };
    },
    titleStyleModifiers: function titleStyleModifiers() {
      return {
        background: this.color
      };
    },
    pallette: function pallette() {
      if (!this.targetContract) {
        return __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY[1];
      }

      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(this.targetContract.contractName);
      var factor = pallette[0].from + this.targetContract.lastTradePrice;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pallette), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (factor <= item.to) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return pallette[pallette.length - 1];
    },
    contracts: function contracts() {
      return (this.marketData.contracts || []).map(function (i) {
        return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](i);
      });
    }
  },
  methods: {
    getNameDisplay: function getNameDisplay(contract) {
      var parts = (contract.contractName || '').split(' ');
      return parts.length > 1 ? parts[1] : contract.contractName;
    },
    contractClassModifiers: function contractClassModifiers(contract, index) {
      return {
        'market-state-tooltip__contract': true,
        'market-state-tooltip__contract--with-border': index === 0
      };
    },
    imageStyleModifiers: function imageStyleModifiers(contract) {
      return {
        'background-image': 'url(' + contract.contractImageUrl + ')'
      };
    },
    onTooltipClick: function onTooltipClick() {
      if (this.marketData.marketId) {
        window.location.href = 'https://www.predictit.org/markets/detail/' + this.marketData.marketId;
      }
    }
  },
  created: function created() {
    if (this.stateCode !== 'GA2') {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('market/setMarketMapTooltipVisible', true);
    }
  }
});

/***/ }),

/***/ "CAth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONTRACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COLOR_INDEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRICE_FACTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLOR_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColorForPalletteCandidate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_page_election_map_new_election_map_toolbar_election_map_toolbar_vue__ = __webpack_require__("yhSh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_table_election_map_table_vue__ = __webpack_require__("6Fjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_special_election_map_special_vue__ = __webpack_require__("09fK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__ = __webpack_require__("Q+EN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_overview_map_overview_map_vue__ = __webpack_require__("Shp1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");










var CONTRACTS = {
  REPUBLICAN: 'Republican',
  DEMOCRATIC: 'Democratic',
  TRUMP: 'Trump'
};

var COLOR_INDEXES = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2
};

var PRICE_FACTORS = {
  DELTA: 0.01,
  LOW: 0.64,
  MEDIUM: 0.79,
  HIGH: 1
};

var COLOR_MAP = {
  GRAY: [{ from: 0, to: PRICE_FACTORS.LOW, color: '#dddddd' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.MEDIUM, color: '#bbbbbb' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.HIGH, color: '#888888' }],
  BLUE: [{ from: 30, to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(30 + PRICE_FACTORS.LOW), color: '#8aafff' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(30 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(30 + PRICE_FACTORS.MEDIUM), color: '#5c80dc' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(30 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(30 + PRICE_FACTORS.HIGH), color: '#244999' }],
  RED: [{ from: 40, to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(40 + PRICE_FACTORS.LOW), color: '#ff8b98' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(40 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(40 + PRICE_FACTORS.MEDIUM), color: '#ff5865' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(40 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["h" /* roundToTwo */])(40 + PRICE_FACTORS.HIGH), color: '#d22532' }]
};

var getColorForPalletteCandidate = function getColorForPalletteCandidate(contractName) {
  var name = (contractName || '').toLowerCase();
  var isRepublican = name.includes(CONTRACTS.REPUBLICAN.toLowerCase()) || name.includes(CONTRACTS.TRUMP.toLowerCase());

  if (isRepublican) {
    return COLOR_MAP.RED;
  }
  return COLOR_MAP.BLUE;
};

/* harmony default export */ __webpack_exports__["c"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  components: {
    electionMapToolbar: __WEBPACK_IMPORTED_MODULE_2__components_pages_page_election_map_new_election_map_toolbar_election_map_toolbar_vue__["a" /* default */],
    electionMapTable: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_table_election_map_table_vue__["a" /* default */],
    electionMapSpecial: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_special_election_map_special_vue__["a" /* default */],
    overviewMap: __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_overview_map_overview_map_vue__["a" /* default */]
  },
  data: function data() {
    return {
      type: 'senate'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['mapStateData', 'mapOverviewData', 'mapStateDataSenate', 'mapOverviewDataSenate']), {
    ChartClass: function ChartClass() {
      if (this.type === 'electoral') {
        return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["c" /* ElectionMapChartParty */];
      }
      if (this.type === 'senate') {
        return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["d" /* ElectionMapChartSenate */];
      }
      return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["e" /* ElectionMapChartOverall */];
    }
  }),
  watch: {
    type: {
      handler: 'typeHandler',
      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['getMapStateData', 'getMapOverviewData', 'getMapOverviewDataSenate', 'getMapStateDataSenate']), {
    typeHandler: function typeHandler() {
      var _this = this;

      this.loaderAdd();
      if (this.type === 'electoral') {
        this.getMapOverviewData().then(function () {
          return _this.getMapStateData();
        }).then(function (data) {
          return _this.createChart(data);
        }).then(function () {
          return _this.loaderRemove();
        }).catch(function () {
          return _this.loaderRemove();
        });
      } else if (this.type === 'senate') {
        this.getMapOverviewDataSenate().then(function () {
          return _this.getMapStateDataSenate();
        }).then(function (data) {
          return _this.createChart(data);
        }).then(function () {
          return _this.loaderRemove();
        }).catch(function () {
          return _this.loaderRemove();
        });
      }
    },
    createChart: function createChart(data) {
      var _this2 = this;

      setTimeout(function () {
        _this2.renderChart(data);
      }, this.ChartClass.renderTimeout());
    },
    renderChart: function renderChart(data) {
      if (!this.$refs.chart) return;
      var group = new this.ChartClass(data);
      group.draw(this.$refs.chart);
    },
    onToggle: function onToggle() {
      this.type = this.type === 'electoral' ? 'senate' : 'electoral';
    }
  }),
  created: function created() {
    if (this.$route.query.map) {
      this.type = this.$route.query.map;
    }
  }
});

/***/ }),

/***/ "CAzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__ = __webpack_require__("Y+KT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2d8483e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("4f6F");
function injectStyle (ssrContext) {
  __webpack_require__("xQ7R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2d8483e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CCA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_what_is_predictit_js__ = __webpack_require__("4blE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dcf9984_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_predictit_vue__ = __webpack_require__("mnsD");
function injectStyle (ssrContext) {
  __webpack_require__("6gnH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_what_is_predictit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dcf9984_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_predictit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CG+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      requited: true
    }
  },
  computed: {
    selectedModifier: function selectedModifier() {
      return {
        'state-button--selected': this.selected
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click', this);
    }
  }
});

/***/ }),

/***/ "CIck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_markets_js__ = __webpack_require__("i3z8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36aaa7b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_markets_vue__ = __webpack_require__("5c7z");
function injectStyle (ssrContext) {
  __webpack_require__("vuRz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36aaa7b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CLCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classModifiers,attrs:{"to":_vm.routeTo}},[_c('div',{class:_vm.iconClassModifiers,style:(_vm.iconStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"notification-item-dashboard__content"},[_c('div',{staticClass:"notification-item-dashboard__title"},[_c('div',{staticClass:"notification-item-dashboard__title-left"},[_vm._v("\n        "+_vm._s(_vm.data.contentJson.Title)+"\n      ")]),_vm._v(" "),(_vm.showPriceChange && !_vm.showTimeElapsed)?[_c('div',{staticClass:"notification-item-dashboard__title-right"},[_vm._v("\n          "+_vm._s(_vm.lastTradePriceAsCents)+"¢\n          "),_c('market-change-price',{attrs:{"price":_vm.data.contentJson.PriceDelta}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.showContractName)?_c('h5',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"notification-item-dashboard__contract-name"},[_vm._v("\n      "+_vm._s(_vm.data.contentJson.ContractName)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.showLevelChanged)?[_c('h5',{staticClass:"notification-item-dashboard__market-name"},[_vm._v("\n        "+_vm._s(_vm.data.contentJson.Body)+"\n      ")]),_vm._v(" "),(_vm.showNextLevelInfo)?_c('h5',{staticClass:"notification-item-dashboard__level-changed-info"},[_vm._v("\n        "+_vm._s(_vm.getProgressInfoTextForLevel(_vm.data.contentJson.NewTraderLevel, _vm.data.contentJson.ProfitablePredictions))+"\n      ")]):_vm._e()]:_c('h5',{staticClass:"notification-item-dashboard__market-name"},[_vm._v("\n      "+_vm._s(_vm.data.contentJson.MarketName)+"\n    ")]),_vm._v(" "),(_vm.showPayout)?[_c('div',{staticClass:"notification-item-dashboard__payout"},[_vm._v("\n        Payout: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixed",value:(_vm.data.contentJson.Cash),expression:"data.contentJson.Cash",modifiers:{"round2":true,"fixed":true}}]})])]:_vm._e(),_vm._v(" "),(_vm.showSellInfo)?[_c('div',{staticClass:"notification-item-dashboard__sell-info"},[_vm._v("\n        "+_vm._s(_vm.tradeTypeOperation)+" "+_vm._s(_vm.quantity)+" "+_vm._s(_vm.yesNoText)+"\n        "),(_vm.tradeTypeShare)?_c('span',{staticClass:"notification-item-dashboard__sell-info-contract"},[_vm._v("\n          in "+_vm._s(_vm.tradeTypeShare)+"\n        ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notification-item-dashboard__sell-info-price"},[_vm._v("\n          @ "+_vm._s(_vm.pricePerShare)+"¢\n        ")])])]:_vm._e(),_vm._v(" "),(_vm.showSharesOwned)?[_c('div',{staticClass:"notification-item-dashboard__shares"},[_vm._v("\n        "+_vm._s(_vm.sharesOwned)+" "+_vm._s(_vm.yesNoText)+" Share"),(_vm.sharesOwned >1)?[_vm._v("s")]:_vm._e(),_vm._v(" Owned\n      ")],2)]:_vm._e(),_vm._v(" "),(_vm.showTimeElapsed)?_c('div',{staticClass:"notification-item-dashboard__time-elapsed"},[_vm._v("\n      "+_vm._s(_vm.timeElapsed)+"\n    ")]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-dashboard__close",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClose($event)}}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CP5y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CPTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("wU6a");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_526c5450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("GH+k");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_526c5450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CPcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__("H/Zg");

 /* eslint-disable max-len */



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    chartData: [],
    latestChartParams: {}
  },
  mutations: {
    setLatestChartParams: function setLatestChartParams(state, value) {
      state.latestChartParams = value;
    },
    setChartData: function setChartData(state, value) {
      state.chartData = value;
    }
  },
  actions: {
    getMarketChartData: function getMarketChartData(_ref, _ref2) {
      var commit = _ref.commit,
          state = _ref.state;
      var params = _ref2.params,
          _ref2$cache = _ref2.cache,
          cache = _ref2$cache === undefined ? false : _ref2$cache;

      if (cache && state.latestChartParams && __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(params, state.latestChartParams)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.chartData);
      }
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].chart.getMarketChartData(params).then(function (response) {
        var data = response.data;
        commit('setLatestChartParams', params);
        commit('setChartData', data);
        return data;
      });
    },
    getContractChartData: function getContractChartData(_ref3, _ref4) {
      var commit = _ref3.commit;
      var contractId = _ref4.contractId,
          timeline = _ref4.timeline;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].chart.getContractChartData(contractId, timeline).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "CPvM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_videos_vue__ = __webpack_require__("w1pb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c18a26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_videos_vue__ = __webpack_require__("JdRn");
function injectStyle (ssrContext) {
  __webpack_require__("hbUY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_videos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c18a26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_videos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CRTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"insight-widget__header"},[_vm._v("\n    Insights\n  ")]),_vm._v(" "),_c('div',{staticClass:"insight-widget__line"}),_vm._v(" "),_c('div',{staticClass:"insight-widget__content"},[_c('insight-panel',{attrs:{"text":"All Articles","href":_vm.allArticlesLink,"away":_vm.allArticlesAway}},[_c('div',{staticClass:"insight-widget__articles"},_vm._l((_vm.tumblr),function(link){return _c('insight-link',{key:link.title,attrs:{"title":link.title,"href":_vm.createLink(link.url),"url":link.url}})}),1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CRil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"market-contract-info-v2",attrs:{"to":_vm.detailsLink}},[(_vm.isCompactLayout)?_c('div',{staticClass:"market-contract-info-v2__compact"},[(_vm.imageUrl)?_c('div',{staticClass:"market-contract-info-v2__image",style:(_vm.imageStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__main"},[(!!_vm.$slots.title || _vm.title)?_c('div',{staticClass:"market-contract-info-v2__title"},[(!!_vm.$slots.title)?_vm._t("title"):(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()],2):_vm._e(),_vm._v(" "),(!!_vm.$slots.subtitle)?_c('div',{staticClass:"market-contract-info-v2__subtitle"},[_vm._t("subtitle")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__content"},[_vm._t("preContent"),_vm._v(" "),(_vm.layout === _vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK)?[_vm._t("content")]:_vm._e(),_vm._v(" "),(_vm.layout === _vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY)?_vm._l((_vm.marketContracts),function(item){return _c('div',{key:_vm.contractKey(item),staticClass:"market-contract-info-v2__row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__value-light"},[_vm._v("\n                "+_vm._s(_vm.contractTitle (item))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[(_vm.contractChanePrice (item))?_c('market-change-price',{attrs:{"price":_vm.contractChanePrice (item),"lastClosePrice":_vm.contractLastClosePrice (item),"symbol":_vm.priceSymbol}}):_vm._e(),_vm._v(" "),(_vm.contractHasLastTradePrice(item))?[_c('animated-number',{attrs:{"value":_vm.contractPrice(item),"symbol":_vm.priceSymbol}})]:[_vm._v("\n                  NEW\n                ")]],2)])}):_vm._e(),_vm._v(" "),_vm._t("afterContent")],2)])]):(_vm.isDetailedLayout)?_c('div',{staticClass:"market-contract-info-v2__detailed"},[(_vm.imageUrl)?_c('div',{staticClass:"market-contract-info-v2__detailed-image",style:(_vm.imageStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__detailed-main"},[(!!_vm.$slots.title || _vm.title)?_c('div',{staticClass:"market-contract-info-v2__detailed-title"},[(!!_vm.$slots.title)?_vm._t("title"):(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__detailed-content"},[_vm._t("preContent"),_vm._v(" "),(_vm.layout === _vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED)?[_vm._t("content")]:_vm._e(),_vm._v(" "),_vm._t("afterContent")],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CTE/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Caoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_story_preview_detail_surface_js__ = __webpack_require__("e9Yj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f9a00f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_story_preview_detail_surface_vue__ = __webpack_require__("YjXZ");
function injectStyle (ssrContext) {
  __webpack_require__("xPXF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_story_preview_detail_surface_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f9a00f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_story_preview_detail_surface_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CcaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");



/* eslint-disable arrow-body-style */




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      fields: {
        reason: null,
        message: ''
      },
      files: []
    };
  },

  validations: {
    fields: {
      reason: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      message: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].message
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('support', ['reportReasons']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['watchedUserDetails']), {
    isUploadEnabled: function isUploadEnabled() {
      // return !(this.isIos && this.isStandalone);
      return false;
    },
    messagePlaceholder: function messagePlaceholder() {
      return this.fields.message ? '' : 'Message';
    },
    messageRequired: function messageRequired() {
      return !this.fields.message;
    },
    reasonOptions: function reasonOptions() {
      return this.reportReasons.map(function (item) {
        return {
          label: item.reason,
          value: item.reasonId
        };
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('support', ['getReportUserReasons', 'reportUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd(document.body);
        // const formData = new FormData();
        // formData.append('subject', this.fields.subject.value);
        // formData.append('description', this.fields.message);
        //
        //
        // this.files.forEach((file) => {
        //   formData.append('uploadedFile', file);
        // });
        var payload = {
          userName: this.watchedUserDetails.userName,
          description: this.fields.message,
          reasonId: this.fields.reason.value,
          pageUrl: window.location.href
        };
        this.reportUser(payload).then(function () {
          _this.loaderRemove(document.body);
          _this.setSuccessSideNotification('Report received.<br> Thank you.');
          _this.setCurrentSmallPopup();
        }).catch(function (error) {
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
        });
      }
    },
    onUpload: function onUpload() {
      this.$refs.fileinput.click();
    },
    fileToBase64: function fileToBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve({
            name: file.name,
            file: reader.result
          });
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    onChange: function onChange() {
      var files = this.$refs.fileinput.files;
      if (files.length) {
        this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files));
      }
    },
    fileRemove: function fileRemove(index) {
      this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(0, index)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(index + 1)));
    }
  }),
  created: function created() {
    this.getReportUserReasons();
  }
});

/***/ }),

/***/ "Cel6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-tile",class:_vm.darkModifier},[_c('router-link',{staticClass:"link-tile__link",attrs:{"to":_vm.href}},[_c('div',{staticClass:"link-tile__icon"},[_c('img',{staticClass:"link-tile__icon-image",attrs:{"src":_vm.icon,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"link-tile__content"},[_c('h2',{staticClass:"link-tile__content-title",class:_vm.titleModifier},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('h3',{staticClass:"link-tile__content-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"link-tile__arrow"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CfET":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cg4w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_story_preview_homepage_surface_js__ = __webpack_require__("ceFQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71956d3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_story_preview_homepage_surface_vue__ = __webpack_require__("/Em5");
function injectStyle (ssrContext) {
  __webpack_require__("JnoZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_story_preview_homepage_surface_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71956d3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_story_preview_homepage_surface_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cwec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-login-footer"},[_c('div',{staticClass:"account-login-footer__title"},[_vm._v("\n        Don't have an account?\n      ")]),_vm._v(" "),_c('span',{staticClass:"account-login-footer__link",on:{"click":function($event){$event.preventDefault();return _vm.onCreateAccount($event)}}},[_vm._v("\n        Create an Account\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CyJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-markets"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"daily-markets__info"},[_vm._v("\n    Access the Market Focus and Daily Markets newsletters to receive comprehensive market insights, news, data analysis, and key indicators at the intersection of politics and prediction markets.\n  ")]),_vm._v(" "),_c('div',{staticClass:"daily-markets__line"}),_vm._v(" "),_c('div',{staticClass:"daily-markets__articles"},_vm._l((_vm.items),function(item){return _c('div',{key:item.link},[_c('router-link',{staticClass:"daily-markets__link",attrs:{"to":_vm.dailyMarketPageLink(item)}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])],1)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-markets__header"},[_c('div',{staticClass:"daily-markets__header-title"},[_vm._v("\n      Newsletters\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Czyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('h2',{staticClass:"purchase-offer-value-sushi__header",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"purchase-offer-value-sushi__wrap"},[_c('button',{staticClass:"purchase-offer-value-sushi__button purchase-offer-value-sushi__button--left",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.subtract($event)}}},[_vm._v("-1¢")]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-value-sushi__box",on:{"click":_vm.onBoxClick}},[(_vm.kind === 'modal')?_c('keyboard-numeric-input-sushi',{attrs:{"value":_vm.cents,"selected":_vm.selected,"symbol":true},on:{"click":_vm.click},model:{value:(_vm.cents),callback:function ($$v) {_vm.cents=$$v},expression:"cents"}}):[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cents),expression:"cents"}],ref:"input",staticClass:"purchase-offer-value-sushi__input",attrs:{"tabindex":_vm.tabindex,"maxlength":"2","placeholder":""},domProps:{"value":(_vm.cents)},on:{"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')},"input":function($event){if($event.target.composing){ return; }_vm.cents=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"purchase-offer-value-sushi__symbol"},[_vm._v("¢")])]],2),_vm._v(" "),_c('button',{staticClass:"purchase-offer-value-sushi__button purchase-offer-value-sushi__button--right",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.add($event)}}},[_vm._v("+1¢")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D+Yn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: {
    mainClassName: function mainClassName() {
      return 'market-filters-desktop-grid';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-desktop-grid__menu': true,
        'market-filters-desktop-grid__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    },
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.fullName;
    }
  }
});

/***/ }),

/***/ "D3WX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D5rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_v2_js__ = __webpack_require__("iYpn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570cd222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_v2_vue__ = __webpack_require__("tLhP");
function injectStyle (ssrContext) {
  __webpack_require__("FvKT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570cd222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DECz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__ = __webpack_require__("63Fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");





// maps url parameters to endpoint parameter names
var VARIABLES = {
  PIReferral: 'piReferral',
  utm_campaign: 'marketingProgram',
  utm_source: 'marketingSource',
  utm_code: 'depositPromoCode',
  instant_credit: ''
};

function getStorage(name) {
  var localStorageVariables = ['utm_code'];
  if (localStorageVariables.includes(name)) {
    return __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */];
  }
  return __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */];
}

function check(route) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(VARIABLES).forEach(function (key) {
    var value = route.query[key];
    if (value) {
      var storage = getStorage(key);
      storage.set(key, value);
    }
  });
}

function get(name) {
  var storage = getStorage(name);
  var value = storage.get(name, null);
  if (value !== null) {
    return {
      name: VARIABLES[name],
      value: value
    };
  }
  return null;
}

function payload(oldPayload) {
  var data = {};

  for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    names[_key - 1] = arguments[_key];
  }

  names.forEach(function (name) {
    var storage = getStorage(name);
    var value = storage.get(name, null);
    if (value !== null) {
      data[VARIABLES[name]] = value;
    }
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, oldPayload, data);
}

function clear() {
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('PIReferral');
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('utm_campaign');
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('utm_source');
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('utm_code');
  __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('utm_code');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  check: check,
  get: get,
  payload: payload,
  clear: clear
});

/***/ }),

/***/ "DEr/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DFsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopupOptions']))
});

/***/ }),

/***/ "DIeW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DJ46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learn-the-basics"},[_c('div',{class:_vm.mainRowModifiers},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"learn-the-basics__static-page-header"},[_c('static-page-header',{attrs:{"back":{ name: 'HelpAndSupport' }}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n            Help and Support\n          ")])])],1)]),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{class:_vm.mainColumnModifiers},[_c('div',{staticClass:"learn-the-basics__content"},[_c('static-page-loader',{staticClass:"static-page-loader--padding"})],1)]):_c('div',{class:_vm.mainColumnModifiers},[_c('div',{staticClass:"learn-the-basics__header"},[_vm._v("\n        How to Trade on PredictIt\n      ")]),_vm._v(" "),_c('div',{staticClass:"learn-the-basics__content",domProps:{"innerHTML":_vm._s(_vm.content)}})]),_vm._v(" "),(_vm.showVideos)?_c('div',{staticClass:"column large-4"},[_c('videos',{attrs:{"asWidget":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DJt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea",class:_vm.textAreaModifiers},[_c('label',{staticClass:"textarea__label",attrs:{"for":_vm.name}},[_c('div',{staticClass:"textarea__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('textarea',{staticClass:"textarea__value",attrs:{"disabled":_vm.disabled,"name":_vm.name,"id":_vm.name,"maxlenght":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DXdo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_link_js__ = __webpack_require__("w70/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7c35b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_link_vue__ = __webpack_require__("mXH+");
function injectStyle (ssrContext) {
  __webpack_require__("1OjE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_link_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7c35b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DZRR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DZwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_search__ = __webpack_require__("+ZRi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_brand_name_brand_name_js__ = __webpack_require__("9IfM");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_search__["a" /* default */]],
  components: {
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a,
    marketListItem: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_5__components_brand_name_brand_name_js__["a" /* BRAND */] + ': Search Results'
    };
  },
  data: function data() {
    return {
      infiniteLoader: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('search', ['hasSearched', 'searchResults', 'searchQuery']), {
    items: function items() {
      return this.searchResults.data === null ? [] : this.searchResults.data;
    }
  }),
  watch: {
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.searchResults.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    }
  },
  methods: {
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.searchResults.canLoadMore) {
        var query = this.$router.currentRoute.query.query;
        this.doSearch(query, { reset: false });
      }
    }
  },
  created: function created() {
    var query = this.$router.currentRoute.query.query;
    // no search results in store and query provided
    // so user must have navigated here manually, trying searching
    if (!this.hasSearched && query) {
      this.doSearch(query);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.resetSearchResults('');
  }
});

/***/ }),

/***/ "DbLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_js__ = __webpack_require__("Zdym");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad696aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_vue__ = __webpack_require__("yMVe");
function injectStyle (ssrContext) {
  __webpack_require__("IdEn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad696aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DkRA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_top_comments_js__ = __webpack_require__("TdGO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb477bf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_top_comments_vue__ = __webpack_require__("7uEV");
function injectStyle (ssrContext) {
  __webpack_require__("3lN5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_top_comments_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb477bf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_top_comments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dksu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_currently_predicting_js__ = __webpack_require__("u9HT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ada9a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_currently_predicting_vue__ = __webpack_require__("Wx+w");
function injectStyle (ssrContext) {
  __webpack_require__("LDV9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_currently_predicting_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ada9a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_currently_predicting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dlcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"app-mobile-menu"}},[(_vm.mobileMenuOpened)?_c('div',{staticClass:"app-mobile-menu"},[_c('div',{staticClass:"app-mobile-menu__content-wrap"},[_c('div',{staticClass:"app-mobile-menu__content"},[_c('search-bar',{attrs:{"theme":"menu"}}),_vm._v(" "),(_vm.isLoggedIn && _vm.showBalanceHeader)?[_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--investment",attrs:{"id":"menu-investment"},on:{"click":function($event){$event.preventDefault();return _vm.onInvestmentClick($event)}}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Investment")]),_vm._v(" "),_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.portfolioBalanceDecimal),expression:"balance.portfolioBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],staticClass:"app-mobile-menu__menu-item-value"})]),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--cash",attrs:{"id":"menu-cash"},on:{"click":function($event){$event.preventDefault();return _vm.onCashClick($event)}}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Cash")]),_vm._v(" "),_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.accountBalanceDecimal),expression:"balance.accountBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],staticClass:"app-mobile-menu__menu-item-value"})]),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--deposit",attrs:{"id":"menu-deposit"},on:{"click":function($event){$event.preventDefault();return _vm.openDepositPopup($event)}}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Deposit")]),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__menu-item-icon app-mobile-menu__menu-item-icon--deposit"})])]:(!_vm.isLoggedIn)?[(!_vm.isUserRestricted)?_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--register",attrs:{"id":"menu-signup"},on:{"click":_vm.onSignUp}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Sign Up")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--login",attrs:{"id":"menu-login"},on:{"click":_vm.onLogin}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Login")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__nav"},[_vm._l((_vm.enabledLinks),function(item){return _c('router-link',{key:("menu-nav-" + (item.name)),class:_vm.itemClassModifiers(item),attrs:{"tag":"div","id":("menu-nav-" + (item.name)),"to":item.href},nativeOn:{"click":function($event){return _vm.onLinkClick(item.href)}}},[_c('div',{staticClass:"app-mobile-menu__nav-item-text"},[_vm._v("\n              "+_vm._s(item.title.toString())+"\n            ")]),_vm._v(" "),(item.name === 'dashboard')?_c('account-social-avatar',{attrs:{"theme":"mobile-menu","avatar":_vm.userAvatar,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.levelColorWithRespectToNav,"showEdit":false}}):_c('div',{class:_vm.itemIconClassModifiers(item)})],1)}),_vm._v(" "),(_vm.isLoggedIn)?_c('div',{staticClass:"app-mobile-menu__nav-item",on:{"click":_vm.logoutButton}},[_c('div',{staticClass:"app-mobile-menu__nav-item-text"},[_vm._v("LOGOUT")]),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__nav-item-icon app-mobile-menu__nav-item-icon--logout"})]):_vm._e()],2)],2),_vm._v(" "),(false)?_c('div',{staticClass:"app-mobile-menu__classic-exchange"},[_c('div',{staticClass:"app-mobile-menu__classic-exchange__content"},[_c('div',{staticClass:"app-mobile-menu__classic-exchange__mask",on:{"click":_vm.showLeavingPopup}}),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__classic-exchange__bar"})])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DsFz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Number
    },
    symbol: {
      type: String,
      default: '&cent;'
    }
  },
  data: function data() {
    return {
      isNewValueGreater: false
    };
  },

  watch: {
    value: {
      handler: function handler(newValue, oldValue) {
        this.isNewValueGreater = newValue > oldValue;
      },

      deep: false
    }
  },
  computed: {
    transitionName: function transitionName() {
      return this.isNewValueGreater ? 'animated-number--high' : 'animated-number--low';
    }
  }
});

/***/ }),

/***/ "DtY3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dthr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-enable-classic-predictit-footer"},[_c('h4',{staticClass:"account-enable-classic-predictit-footer__title"},[_vm._v("\n        Already have an account\n      ")]),_vm._v(" "),_c('a',{staticClass:"account-enable-classic-predictit-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onLogin($event)}}},[_vm._v("\n        Login to My Account\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DvJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_bottom_nav_js__ = __webpack_require__("uo5Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b1c0876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_bottom_nav_vue__ = __webpack_require__("fHHP");
function injectStyle (ssrContext) {
  __webpack_require__("8EqH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_bottom_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b1c0876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_bottom_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DvL7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEyLjI0IDEwLjI4NVYxNC40aDYuODA2Yy0uMjc1IDEuNzY1LTIuMDU2IDUuMTc0LTYuODA2IDUuMTc0LTQuMDk1IDAtNy40MzktMy4zODktNy40MzktNy41NzRzMy4zNDUtNy41NzQgNy40MzktNy41NzRjMi4zMyAwIDMuODkxLjk4OSA0Ljc4NSAxLjg0OWwzLjI1NC0zLjEzOEMxOC4xODkgMS4xODYgMTUuNDc5IDAgMTIuMjQgMGMtNi42MzUgMC0xMiA1LjM2NS0xMiAxMnM1LjM2NSAxMiAxMiAxMmM2LjkyNiAwIDExLjUyLTQuODY5IDExLjUyLTExLjcyNiAwLS43ODgtLjA4NS0xLjM5LS4xODktMS45ODlIMTIuMjR6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "Dwlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_notifications__ = __webpack_require__("tjp7");


/* eslint-disable */



var DEFAULT_TOP_POSITION = 0;
var DEFAULT_RESET_POSITION_TIMEOUT = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    lastTopPosition: DEFAULT_TOP_POSITION,
    currentPopup: null,
    currentSmallPopup: null,
    tradePopupOptions: {},
    currentPopupOptions: {},
    formDataCache: null,
    remember: {}
  },
  mutations: {
    setCurrentPopup: function setCurrentPopup(state, popupName) {
      if (popupName) {
        state.lastTopPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
      }
      state.currentPopup = popupName;
      state.currentPopupOptions = {};
    },
    setCurrentSmallPopup: function setCurrentSmallPopup(state, popupName) {
      if (popupName) {
        state.lastTopPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
      }
      state.currentSmallPopup = popupName;
    },
    setTradePopupOptions: function setTradePopupOptions(state, options) {
      state.tradePopupOptions = options;
    },
    setCurrentPopupOptions: function setCurrentPopupOptions(state, options) {
      state.currentPopupOptions = options;
    },
    cacheFormData: function cacheFormData(state, payload) {
      state.formDataCache = payload;
    },
    rememberPopup: function rememberPopup(state, _ref) {
      var route = _ref.route,
          popup = _ref.popup;

      state.remember = {
        route: route,
        popup: popup
      };
    },
    restorePopup: function restorePopup(state, payload) {
      if (state.remember.route === payload) {
        state.currentPopup = state.remember.popup;
      }
      state.remember = {};
    },
    resetLastTopPosition: function resetLastTopPosition(state) {
      state.lastTopPosition = DEFAULT_TOP_POSITION;
    },
    updateTradePopupOptionsMarketFromNotification: function updateTradePopupOptionsMarketFromNotification(state, data) {
      if (state.tradePopupOptions && state.tradePopupOptions.market) {
        state.tradePopupOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.tradePopupOptions, {
          market: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_notifications__["a" /* updateMarket */])(state.tradePopupOptions.market, data)
        });
      }
    },
    updateTradePopupOptionsContractsFromNotification: function updateTradePopupOptionsContractsFromNotification(state, data) {
      if (state.tradePopupOptions && state.tradePopupOptions.market) {
        state.tradePopupOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.tradePopupOptions, {
          market: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_notifications__["b" /* updateMarketContracts */])(state.tradePopupOptions.market, data)
        });
      }
    }
  },
  actions: {
    setCurrentPopupWithDelay: function setCurrentPopupWithDelay(_ref2, _ref3) {
      var commit = _ref2.commit;
      var name = _ref3.name,
          _ref3$options = _ref3.options,
          options = _ref3$options === undefined ? {} : _ref3$options;

      commit('setCurrentPopup', null);
      setTimeout(function () {
        commit('setCurrentPopup', name);
        commit('setCurrentPopupOptions', options);
      }, 1000);
    },
    setTradePopup: function setTradePopup(_ref4, _ref5) {
      var commit = _ref4.commit;
      var name = _ref5.name,
          options = _ref5.options;

      commit('setCurrentPopup', name);
      commit('setTradePopupOptions', options);
    },
    setCurrentPopup: function setCurrentPopup(_ref6) {
      var commit = _ref6.commit,
          state = _ref6.state;
      var popupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('setCurrentPopup', popupName);
        if (!popupName && state.lastTopPosition !== DEFAULT_TOP_POSITION) {
          resolve();
        } else {
          resolve();
        }
      });
    },
    setCurrentSmallPopup: function setCurrentSmallPopup(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;
      var popupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      commit('setCurrentSmallPopup', popupName);
    },
    setTradePopupOptions: function setTradePopupOptions(_ref8, options) {
      var commit = _ref8.commit;

      commit('setTradePopupOptions', options);
    },
    setCurrentPopupOptions: function setCurrentPopupOptions(_ref9, options) {
      var commit = _ref9.commit;

      commit('setCurrentPopupOptions', options);
    },
    setGenericPopup: function setGenericPopup(_ref10, popup) {
      var commit = _ref10.commit;

      commit('setCurrentPopup', popup.name);
      commit('setCurrentPopupOptions', popup.options);
    },
    setGenericSmallPopup: function setGenericSmallPopup(_ref11, popup) {
      var commit = _ref11.commit;

      commit('setCurrentSmallPopup', popup.name);
      commit('setCurrentPopupOptions', popup.options);
    },
    setErrorPopup: function setErrorPopup(_ref12) {
      var commit = _ref12.commit;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Error',
        icon: 'error',
        iconTitle: 'Error!',
        content: content
      });
    },
    setSuccessPopup: function setSuccessPopup(_ref13) {
      var commit = _ref13.commit;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Operation successful.';

      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Success',
        icon: 'success',
        iconTitle: 'Success!',
        content: content
      });
    },
    setSuccessPopupWithTimeoutCallback: function setSuccessPopupWithTimeoutCallback(_ref14, _ref15) {
      var _this = this;

      var commit = _ref14.commit;
      var _ref15$content = _ref15.content,
          content = _ref15$content === undefined ? 'Operation successful.' : _ref15$content,
          _ref15$callback = _ref15.callback,
          callback = _ref15$callback === undefined ? function () {} : _ref15$callback;

      var callBackApplied = false;
      var timeout = setTimeout(function () {
        callBackApplied = true;
        callback.apply(_this);
      }, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT);
      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Success',
        icon: 'success',
        iconTitle: 'Success!',
        onClose: function onClose() {
          if (!callBackApplied) {
            clearTimeout(timeout);
            callback.apply(_this);
          }
        },
        content: content
      });
    },
    cacheFormData: function cacheFormData(_ref16, payload) {
      var commit = _ref16.commit;

      commit('cacheFormData', payload);
    },
    rememberPopup: function rememberPopup(_ref17, route) {
      var commit = _ref17.commit,
          state = _ref17.state;

      commit('rememberPopup', route);
    },
    restorePopup: function restorePopup(_ref18, route) {
      var commit = _ref18.commit;

      commit('restorePopup', route);
    },
    updateTradePopupOptionsMarketFromNotification: function updateTradePopupOptionsMarketFromNotification(_ref19, data) {
      var commit = _ref19.commit;

      commit('updateTradePopupOptionsMarketFromNotification', data);
    },
    updateTradePopupOptionsContractsFromNotification: function updateTradePopupOptionsContractsFromNotification(_ref20, data) {
      var commit = _ref20.commit;

      commit('updateTradePopupOptionsContractsFromNotification', data);
    }
  }
});

/***/ }),

/***/ "Dz7g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E0tW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "E2Y7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* STATIC_PAGES */].RESEARCH).then(function (data) {
      _this.installDynamicControls({ data: data });
    });
  }
});

/***/ }),

/***/ "E3zi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODALS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_modal_modal_vue__ = __webpack_require__("CAzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_layouts_generic_vue__ = __webpack_require__("7okt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_small_vue__ = __webpack_require__("WRh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_account_forgotten_account_forgotten_vue__ = __webpack_require__("8TeC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_account_forgotten_footer_footer_vue__ = __webpack_require__("koWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_account_account_register_external_account_register_external_vue__ = __webpack_require__("E9c5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_account_details_modal_account_details_verify_vue__ = __webpack_require__("EKqI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_account_account_upload_id_account_upload_id_vue__ = __webpack_require__("flEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_account_account_upload_document_account_upload_document_vue__ = __webpack_require__("3USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_account_account_details_modal_account_details_update_modal_vue__ = __webpack_require__("IUvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_account_account_update_image_account_update_image_vue__ = __webpack_require__("Aqlg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_wallet_add_funds_combined_add_funds_combined_vue__ = __webpack_require__("l9wN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_wallet_add_funds_combined_footer_footer_vue__ = __webpack_require__("1F6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_wallet_deposited_deposited_vue__ = __webpack_require__("WXHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_potential_payouts_potential_payouts_vue__ = __webpack_require__("gTQM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_export_history_export_history_vue__ = __webpack_require__("cgtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_insight_insight_modal_insight_modal_vue__ = __webpack_require__("TJ+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_research_research_vue__ = __webpack_require__("eNmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_tax_info_notification_tax_info_notification_vue__ = __webpack_require__("wQDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_home_home_old_news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_attach_to_home_attach_to_home_vue__ = __webpack_require__("r6f4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_offers_indicator_popup_offers_indicator_popup_vue__ = __webpack_require__("zyut");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_market_market_contracts_stats_popup_market_contracts_stats_popup_vue__ = __webpack_require__("ETXZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_account_account_reset_password_account_reset_password_vue__ = __webpack_require__("TMp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_orientation_info_orientation_info_vue__ = __webpack_require__("v0Cj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_account_account_badges_list_account_badges_list_vue__ = __webpack_require__("yeq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_social_user_profile_overview_user_profile_overview_vue__ = __webpack_require__("M6xY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_social_user_profile_overview_header_user_profile_overview_header_vue__ = __webpack_require__("nNeU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_social_user_report_user_report_vue__ = __webpack_require__("0RmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_leaderboards_leaderboards_trophy_pyramid_leaderboards_trophy_pyramid_vue__ = __webpack_require__("mgKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_messaging_journey_info_messaging_journey_info_vue__ = __webpack_require__("sIse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_wallet_coinbase_process_overview_coinbase_process_overview_vue__ = __webpack_require__("MbhW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_profile_affiliations_popup_affiliations_popup_vue__ = __webpack_require__("jI1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_announcement_announcement_vue__ = __webpack_require__("Mz4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_market_market_rules_market_rules_vue__ = __webpack_require__("bynG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_account_account_already_exists_account_already_exists_vue__ = __webpack_require__("QSM8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_account_account_already_exists_footer_footer_vue__ = __webpack_require__("Z/tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_account_account_enable_classic_predictit_account_enable_classic_predictit_vue__ = __webpack_require__("Y6Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_account_account_enable_classic_predictit_footer_footer_vue__ = __webpack_require__("nBxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_market_market_ownership_conflict_modal_market_ownership_conflict_modal_vue__ = __webpack_require__("nEDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_account_account_two_factor_verify_account_two_factor_verify_vue__ = __webpack_require__("b8Ry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_account_account_two_factor_prompt_account_two_factor_prompt_vue__ = __webpack_require__("aUi2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_account_account_phone_update_account_phone_update_vue__ = __webpack_require__("AORQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_purchase_sushi_purchase_review_and_confirm_sushi_purchase_review_and_confirm_sushi_vue__ = __webpack_require__("rJdw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_market_price_odds_toggle_popup_price_odds_toggle_popup_vue__ = __webpack_require__("QHOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_purchase_sushi_share_info_popup_share_info_popup_vue__ = __webpack_require__("8O0X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_what_is_new_popup_what_is_new_popup_vue__ = __webpack_require__("NwTj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_what_is_new_popup_what_is_new_popup_footer_vue__ = __webpack_require__("mHXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_forms_captcha_captcha_vue__ = __webpack_require__("aDe5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_what_is_new_popup_helpers__ = __webpack_require__("AyQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__mixins_loader__ = __webpack_require__("39kf");

/* eslint-disable import/extensions */




























































var MODALS = {
  LOGIN: 'login',
  FORGOTTEN: 'forgotten',
  RESET_PASSWORD: 'reset-password',
  REGISTER: 'register',
  REGISTER_EXTERNAL: 'register-external',
  ACCOUNT_VERIFY: 'account-verify',
  UPLOAD_ID: 'upload-id',
  TAX_INFO: 'tax-info',
  ATTACH_TO_HOME: 'attach-to-home',
  ACCOUNT_DETAIL_UPDATE: 'account-detail-update',
  ACCOUNT_DETAIL_PASSWORD: 'account-detail-password',
  ACCOUNT_DETAIL_PASSWORD_SET: 'account-detail-password-set',
  ACCOUNT_ADDRESS_UPDATE: 'account-address-update',
  ADD_FUNDS: 'add-funds',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_ERROR: 'payment-error',
  POTENTIAL_PAYOUTS: 'potential-payouts',
  MARKET_CONTRACT_STATS: 'market-contracts-stats',
  RESEARCH: 'research',
  TWITTER: 'twitter',
  NEWS_FEED: 'news-feed',
  PURCHASE: 'purchase-modal',
  PURCHASE_SUSHI: 'purchase-modal-sushi',
  PURCHASE_SUSHI_REVIEW: 'purchase-modal-review-sushi',
  INSIGHT: 'insight-modal',
  GENERIC: 'generic',
  EXPORT_TRADE_HISTORY: 'export-trade-history',
  EXPORT_TRANSACTION_HISTORY: 'export-transaction-history',
  COINBASE: 'coinbase',
  SMALL_CVV: 'cvv',
  SMALL_SWIFT: 'swift',
  SMALL_ROUTING_NUMBER: 'routing-number',
  SMALL_EDIT_IMAGE: 'edit-image',
  SMALL_MARKET_RULES: 'market-rules',
  SMALL_GENERIC: 'generic-small',
  SMALL_USERNAME: 'username',
  SMALL_TRADE_INFO: 'account-trade-info',
  SMALL_OFFERS_INDICATOR: 'offers-indicator',
  SMALL_VERIFICATION_INFO: 'verfication-info',
  SMALL_BADGES: 'badges',
  SMALL_USER_PROFILE: 'user-profile',
  SMALL_REPORT_USER: 'report-user',
  SMALL_ROI_INFO: 'roi-info',
  SMALL_FEE_INFO: 'fee-info',
  SMALL_WINS_INFO: 'wins-info',
  SMALL_LEADERBOARDS_UPDATE_INFO: 'leaderboards-update-info',
  SMALL_SHARE_INVITE_INFO: 'share-invite-info',
  SMALL_PUBLIC_PROFILE_INFO: 'public-profile-info',
  SMALL_RESTRICTED_FUNDS_INFO: 'restricted-funds-info',
  SMALL_ANNOUNCEMENT: 'announcement',
  UPLOAD_DOCUMENT: 'upload-document',
  ORIENTATION: 'orientation',
  SMALL_MESSAGING_JOURNEY: 'messaging-journey',
  SMALL_PWMB_ACCOUNT_CONFIRM_DELETE: 'pwmb-account-confirm-delete',
  AFFILIATIONS: 'affiliations',
  VIDEO: 'video',
  ACCOUNT_ALREADY_EXISTS: 'account-already-exists',
  ACCOUNT_ENABLE_CLASSIC: 'account-enable-classic',
  MARKET_OWNERSHIP_CONFLICT: 'market-ownership-conflict',
  TWO_FACTOR: 'two-factor',
  TWO_FACTOR_PROMPT: 'two-factor-prompt',
  PHONE_UPDATE: 'phone-update',
  SMALL_PRICE_ODDS: 'small-price-odds',
  SMALL_PREDICTIT_INDEX: 'small-predictit-index',
  SMALL_OWNERSHIP_INFO: 'ownership-info',
  SMALL_SHARE_INFO: 'small-share-info',
  SMALL_DEPOSIT_NUMBER_INFORMATION: 'small-deposit-number-information',
  SMALL_OFFER_INFO: 'small-offer-info',
  RECAPTCHA_CHALLENGE: 'recaptcha-challenge',
  SMALL_PAYOUT_INFO: 'payout-info',
  CUSTOMIZE_YOUR_PREDICTIT: 'customize-your-predictit'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_59__mixins_loader__["a" /* default */]],
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_2__components_generics_modal_modal_vue__["a" /* default */],
    announcement: __WEBPACK_IMPORTED_MODULE_41__components_announcement_announcement_vue__["a" /* default */],
    affiliationsPopup: __WEBPACK_IMPORTED_MODULE_40__components_profile_affiliations_popup_affiliations_popup_vue__["a" /* default */],
    addFundsCombined: __WEBPACK_IMPORTED_MODULE_17__components_wallet_add_funds_combined_add_funds_combined_vue__["a" /* default */],
    addFundsCombinedFooter: __WEBPACK_IMPORTED_MODULE_18__components_wallet_add_funds_combined_footer_footer_vue__["a" /* default */],
    accountDetailsVerify: __WEBPACK_IMPORTED_MODULE_12__components_account_account_details_modal_account_details_verify_vue__["a" /* default */],
    accountUploadId: __WEBPACK_IMPORTED_MODULE_13__components_account_account_upload_id_account_upload_id_vue__["a" /* default */],
    accountUploadDocument: __WEBPACK_IMPORTED_MODULE_14__components_account_account_upload_document_account_upload_document_vue__["a" /* default */],
    accountDetailsUpdateModal: __WEBPACK_IMPORTED_MODULE_15__components_account_account_details_modal_account_details_update_modal_vue__["a" /* default */],
    accountLogin: __WEBPACK_IMPORTED_MODULE_5__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_6__components_account_account_login_footer_footer_vue__["a" /* default */],
    accountForgotten: __WEBPACK_IMPORTED_MODULE_7__components_account_account_forgotten_account_forgotten_vue__["a" /* default */],
    accountForgottenFooter: __WEBPACK_IMPORTED_MODULE_8__components_account_account_forgotten_footer_footer_vue__["a" /* default */],
    accountRegister: __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__["a" /* default */],
    accountRegisterExternal: __WEBPACK_IMPORTED_MODULE_11__components_account_account_register_external_account_register_external_vue__["a" /* default */],
    accountUpdateImage: __WEBPACK_IMPORTED_MODULE_16__components_account_account_update_image_account_update_image_vue__["a" /* default */],
    attachToHome: __WEBPACK_IMPORTED_MODULE_28__components_attach_to_home_attach_to_home_vue__["a" /* default */],
    deposited: __WEBPACK_IMPORTED_MODULE_19__components_wallet_deposited_deposited_vue__["a" /* default */],
    genericPopup: __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_layouts_generic_vue__["a" /* default */],
    genericSmallPopup: __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_small_vue__["a" /* default */],
    offersIndicatorPopup: __WEBPACK_IMPORTED_MODULE_29__components_offers_indicator_popup_offers_indicator_popup_vue__["a" /* default */],
    potentialPayouts: __WEBPACK_IMPORTED_MODULE_20__components_potential_payouts_potential_payouts_vue__["a" /* default */],
    smallModal: __WEBPACK_IMPORTED_MODULE_21__components_generics_modal_small_small_vue__["default"],
    exportHistory: __WEBPACK_IMPORTED_MODULE_22__components_export_history_export_history_vue__["a" /* default */],
    insightModal: __WEBPACK_IMPORTED_MODULE_23__components_insight_insight_modal_insight_modal_vue__["a" /* default */],
    research: __WEBPACK_IMPORTED_MODULE_24__components_research_research_vue__["a" /* default */],
    taxInfoNotification: __WEBPACK_IMPORTED_MODULE_25__components_tax_info_notification_tax_info_notification_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_26__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    newsFeed: __WEBPACK_IMPORTED_MODULE_27__components_home_home_old_news_feed_news_feed_vue__["a" /* default */],
    marketContractsStatsPopup: __WEBPACK_IMPORTED_MODULE_30__components_market_market_contracts_stats_popup_market_contracts_stats_popup_vue__["a" /* default */],
    accountResetPassword: __WEBPACK_IMPORTED_MODULE_31__components_account_account_reset_password_account_reset_password_vue__["a" /* default */],
    orientationInfo: __WEBPACK_IMPORTED_MODULE_32__components_orientation_info_orientation_info_vue__["a" /* default */],
    accountBadgesList: __WEBPACK_IMPORTED_MODULE_33__components_account_account_badges_list_account_badges_list_vue__["a" /* default */],
    userProfileOverview: __WEBPACK_IMPORTED_MODULE_34__components_social_user_profile_overview_user_profile_overview_vue__["a" /* default */],
    userProfileOverviewHeader: __WEBPACK_IMPORTED_MODULE_35__components_social_user_profile_overview_header_user_profile_overview_header_vue__["a" /* default */],
    userReport: __WEBPACK_IMPORTED_MODULE_36__components_social_user_report_user_report_vue__["a" /* default */],
    leaderboardsTrophyPyramid: __WEBPACK_IMPORTED_MODULE_37__components_leaderboards_leaderboards_trophy_pyramid_leaderboards_trophy_pyramid_vue__["a" /* default */],
    messagingJourneyInfo: __WEBPACK_IMPORTED_MODULE_38__components_messaging_journey_info_messaging_journey_info_vue__["a" /* default */],
    coinbaseProcessOverview: __WEBPACK_IMPORTED_MODULE_39__components_wallet_coinbase_process_overview_coinbase_process_overview_vue__["a" /* default */],
    accountAlreadyExists: __WEBPACK_IMPORTED_MODULE_43__components_account_account_already_exists_account_already_exists_vue__["a" /* default */],
    accountAlreadyExistsFooter: __WEBPACK_IMPORTED_MODULE_44__components_account_account_already_exists_footer_footer_vue__["a" /* default */],
    accountEnableClassicPredictit: __WEBPACK_IMPORTED_MODULE_45__components_account_account_enable_classic_predictit_account_enable_classic_predictit_vue__["a" /* default */],
    accountEnableClassicPredictitFooter: __WEBPACK_IMPORTED_MODULE_46__components_account_account_enable_classic_predictit_footer_footer_vue__["a" /* default */],
    marketOwnershipConflictModal: __WEBPACK_IMPORTED_MODULE_47__components_market_market_ownership_conflict_modal_market_ownership_conflict_modal_vue__["a" /* default */],
    accountTwoFactorVerify: __WEBPACK_IMPORTED_MODULE_48__components_account_account_two_factor_verify_account_two_factor_verify_vue__["a" /* default */],
    accountTwoFactorPrompt: __WEBPACK_IMPORTED_MODULE_49__components_account_account_two_factor_prompt_account_two_factor_prompt_vue__["a" /* default */],
    accountPhoneUpdate: __WEBPACK_IMPORTED_MODULE_50__components_account_account_phone_update_account_phone_update_vue__["a" /* default */],
    marketRules: __WEBPACK_IMPORTED_MODULE_42__components_market_market_rules_market_rules_vue__["a" /* default */],
    purchaseReviewAndConfirmSushi: __WEBPACK_IMPORTED_MODULE_51__components_purchase_sushi_purchase_review_and_confirm_sushi_purchase_review_and_confirm_sushi_vue__["a" /* default */],
    shareInfoPopup: __WEBPACK_IMPORTED_MODULE_53__components_purchase_sushi_share_info_popup_share_info_popup_vue__["a" /* default */],
    captcha: __WEBPACK_IMPORTED_MODULE_56__components_forms_captcha_captcha_vue__["a" /* default */],
    priceOddsTogglePopup: __WEBPACK_IMPORTED_MODULE_52__components_market_price_odds_toggle_popup_price_odds_toggle_popup_vue__["a" /* default */],
    whatIsNewPopup: __WEBPACK_IMPORTED_MODULE_54__components_what_is_new_popup_what_is_new_popup_vue__["a" /* default */],
    whatIsNewPopupFooter: __WEBPACK_IMPORTED_MODULE_55__components_what_is_new_popup_what_is_new_popup_footer_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['isTaxNotificationMandatory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup', 'currentPopupOptions', 'lastTopPosition', 'tradePopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['status', 'registrationFlowActive', 'twoFactorEnabled']), {
    canCloseAuth: function canCloseAuth() {
      return this.$route.name !== 'disqus-auth';
    },
    footerHideBodyClass: function footerHideBodyClass() {
      return this.currentPopupOptions.hideFooter ? 'modal__body--medium modal__footer--hide' : 'modal__body--medium';
    }
  }),
  watch: {
    // Reset loading state when reCAPTCHA modal closes
    currentPopup: function currentPopup(newVal) {
      if (newVal !== MODALS.RECAPTCHA_CHALLENGE) {
        this.recaptchaVerifying = false;
      }
    },

    // Reset loading state when popup options change (new v2 challenge)
    currentPopupOptions: function currentPopupOptions() {
      // Always reset verifying state when options change - this handles the case
      // where we show a new v2 challenge while the modal is already showing
      if (this.currentPopup === MODALS.RECAPTCHA_CHALLENGE) {
        this.recaptchaVerifying = false;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingsAnnouncementCurState']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupWithDelay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['setCurrentDeposit', 'markFirstDepositDone']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout', 'endRegistrationFlow']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', { hideOverlay: 'hide' }), {
    isCurrentModal: function isCurrentModal(name) {
      return this.currentPopup === name;
    },
    isCurrentSmallModal: function isCurrentSmallModal(name) {
      return this.currentSmallPopup === name;
    },
    closeModal: function closeModal() {
      this.setCurrentPopup();
      this.onClose();
    },
    closeSmallModal: function closeSmallModal() {
      this.setCurrentSmallPopup();
      this.onClose();
    },
    closeModalWithLogout: function closeModalWithLogout() {
      this.logout();
      this.setCurrentPopup();
      this.onClose();
    },
    closePaymentSuccessModal: function closePaymentSuccessModal() {
      this.markFirstDepositDone();
      this.setCurrentPopup();
      this.setCurrentDeposit(null);
      this.onClose();
    },
    closeModalHideOverlay: function closeModalHideOverlay() {
      this.setCurrentPopup();
      this.hideOverlay();
      this.onClose();
    },
    closeUserReportModal: function closeUserReportModal() {
      this.setCurrentSmallPopup(MODALS.SMALL_USER_PROFILE);
    },
    closeWhatIsNewPopup: function closeWhatIsNewPopup() {
      var _this = this;

      this.loaderAdd(document.body);
      this.setSettingsAnnouncementCurState(__WEBPACK_IMPORTED_MODULE_58__components_what_is_new_popup_helpers__["b" /* VERSION_TO_MIGRATE_TO */]).then(function () {
        _this.loaderRemove(document.body);
        _this.closeModal();
      }).catch(function () {
        _this.closeModal();
        _this.loaderRemove(document.body);
      });
    },
    onClose: function onClose() {
      if (this.currentPopupOptions && typeof this.currentPopupOptions.onClose !== 'undefined') {
        this.currentPopupOptions.onClose.apply(this);
      }
    },
    onRecaptchaChallengeComplete: function onRecaptchaChallengeComplete(token) {
      // When v2 captcha is completed, show loading state while API processes
      if (token && this.currentPopupOptions && typeof this.currentPopupOptions.onVerified === 'function') {
        this.recaptchaVerifying = true;
        this.currentPopupOptions.onVerified(token);
      }
    },
    addFundsClose: function addFundsClose() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Closing/Cancel Deposit Modal'
      });
      // Chain to next modal in priority order: AFFILIATIONS → TWO_FACTOR_PROMPT
      if (this.status && this.status.isUCAffilSet === null) {
        this.setCurrentPopup(MODALS.AFFILIATIONS);
      } else if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when ACCOUNT_VERIFY (Personal Details) modal is closed during registration
    closeAccountVerifyModal: function closeAccountVerifyModal() {
      // Closed without completion - check 2FA as final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },
    paymentSuccessDone: function paymentSuccessDone() {
      // Chain to next modal in priority order: AFFILIATIONS → TWO_FACTOR_PROMPT
      if (this.status && this.status.isUCAffilSet === null) {
        this.setCurrentPopupWithDelay({ name: MODALS.AFFILIATIONS });
      } else if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when AFFILIATIONS (College Affiliation) modal is closed during registration
    closeAffiliationsModal: function closeAffiliationsModal() {
      // Affiliations is second-to-last - 2FA prompt is final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when affiliations form is submitted successfully
    onAffiliationsSubmitted: function onAffiliationsSubmitted() {
      // Same as close - 2FA prompt is final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    }
  }),
  data: function data() {
    return {
      MODALS: MODALS,
      constants: __WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */],
      recaptchaVerifying: false,
      gtmAddFunds: {
        virtualPage: '/Account/_DptFrmUsSgnUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Deposit',
          action: 'click',
          label: 'Closing Deposit Modal'
        }
      },
      gtmAccountVerify: {
        virtualPage: '_SgnUpDptIDV',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'ID Verification',
          action: 'click',
          label: 'Closing ID Verification Modal'
        }
      },
      gtmLogin: {
        name: 'login',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Login',
          action: 'click',
          label: 'Closing Login Modal'
        }
      },
      gtmSignUp: {
        virtualPage: '/Account/SignUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Registration',
          action: 'click',
          label: 'Closing Registration Modal'
        }
      }
    };
  }
});

/***/ }),

/***/ "E5wa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'overview-map-contract': true
      }, 'overview-map-contract--' + this.type, this.type);
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.item);
    },
    color: function color() {
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(this.item.shortName);
      return pallette[__WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color;
    },
    bgColorStyleModifiers: function bgColorStyleModifiers() {
      return {
        'background-color': this.color
      };
    },
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'background-image': 'url(\'' + this.item.contractImageUrl + '\')'
      };
    },
    marketDetailUrl: function marketDetailUrl() {
      if (!__WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["g" /* isStandalone */]) {
        return this.type === 'senate' ? 'https://www.predictit.org/markets/detail/6874' : 'https://www.predictit.org/markets/detail/3698';
      }
      return '#';
    }
  })
});

/***/ }),

/***/ "E9c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_external_js__ = __webpack_require__("RSTw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96e5e6ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_external_vue__ = __webpack_require__("NWOx");
function injectStyle (ssrContext) {
  __webpack_require__("JM8M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_external_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96e5e6ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_external_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E9yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-modals"},[(_vm.isCurrentModal(_vm.MODALS.LOGIN))?_c('modal',{attrs:{"gtm":_vm.gtmLogin,"bodyClass":_vm.footerHideBodyClass,"closeButton":!_vm.isUserRestricted && _vm.canCloseAuth},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Login")]),_vm._v(" "),_c('account-login',{attrs:{"slot":"content","email":_vm.currentPopupOptions.email},slot:"content"}),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn)?_c('account-login-footer',{attrs:{"slot":"footer"},slot:"footer"}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.FORGOTTEN))?_c('modal',{attrs:{"gtm":"forgotten","bodyClass":"modal__body--medium","closeButton":_vm.canCloseAuth},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Forgotten Password")]),_vm._v(" "),_c('account-forgotten',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('account-forgotten-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_ALREADY_EXISTS))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Account Already Exists")]),_vm._v(" "),_c('account-already-exists',{attrs:{"slot":"content","email":_vm.currentPopupOptions.email},slot:"content"}),_vm._v(" "),_c('account-already-exists-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_ENABLE_CLASSIC))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Enable PredictIt Classic")]),_vm._v(" "),_c('account-enable-classic-predictit',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.RESET_PASSWORD))?_c('modal',{attrs:{"gtm":"reset-password","bodyClass":"modal__body--medium","closeButton":_vm.canCloseAuth},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Reset Your Password")]),_vm._v(" "),_c('account-reset-password',{attrs:{"slot":"content","token":_vm.currentPopupOptions.token},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.REGISTER))?_c('modal',{attrs:{"gtm":_vm.gtmSignUp,"bodyClass":_vm.footerHideBodyClass,"closeButton":_vm.canCloseAuth},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('account-register-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.REGISTER_EXTERNAL))?_c('modal',{attrs:{"gtm":"SignUp-external","bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModalWithLogout()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register-external',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_VERIFY))?_c('modal',{attrs:{"gtm":_vm.gtmAccountVerify,"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeAccountVerifyModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.currentPopupOptions && _vm.currentPopupOptions.formType === _vm.constants.FORM_TYPE_IDV.SSN4IDV)?[_vm._v("\n          Identity Verification\n        ")]:[_vm._v("\n          Personal Details\n        ")]],2),_vm._v(" "),_c('account-details-verify',{attrs:{"slot":"content","formType":_vm.currentPopupOptions.formType || undefined,"trigger":_vm.currentPopupOptions.trigger || undefined},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.UPLOAD_ID))?_c('modal',{attrs:{"gtm":"upload-id","bodyClass":"modal__body--medium","headerClass":"modal__header--small modal__header--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("We are unable to verfiy your identity")]),_vm._v(" "),_c('account-upload-id',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.UPLOAD_DOCUMENT))?_c('modal',{attrs:{"gtm":"upload-document","bodyClass":"modal__body--medium","headerClass":"modal__header--small modal__header--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_vm._v("\n    >\n      "),_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.currentPopupOptions.isPending)?[_vm._v("Identity Verification Pending ")]:[_vm._v("Document Upload Required ")]],2),_vm._v(" "),_c('account-upload-document',{attrs:{"slot":"content","source":_vm.currentPopupOptions.source,"isPending":_vm.currentPopupOptions.isPending,"isPopup":true},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TAX_INFO))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Tax Information")]),_vm._v(" "),_c('tax-info-notification',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ATTACH_TO_HOME))?_c('small-modal',{attrs:{"type":"top-alt","padding":false},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Add to Home Screen")]),_vm._v(" "),_c('attach-to-home',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ORIENTATION))?_c('modal',{attrs:{"bodyClass":"modal__body--full","closeButton":false,"fullScreen":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('orientation-info',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_UPDATE) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_PASSWORD) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_PASSWORD_SET) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_ADDRESS_UPDATE))?_c('account-details-update-modal',{attrs:{"what":_vm.currentPopup}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ADD_FUNDS))?_c('modal',{attrs:{"bodyClass":"modal__body--medium modal__body--show-ready","closeButtonClass":"modal__close--quick-deposit","gtm":_vm.gtmAddFunds},on:{"modalClose":function($event){return _vm.addFundsClose()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Quick Deposit")]),_vm._v(" "),_c('add-funds-combined',{attrs:{"slot":"content","checkInstantCredit":_vm.currentPopupOptions.checkInstantCredit},slot:"content"}),_vm._v(" "),_c('add-funds-combined-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PAYMENT_SUCCESS))?_c('modal',{attrs:{"closeButton":!_vm.currentPopupOptions.noClose,"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closePaymentSuccessModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('deposited'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width",on:{"click":_vm.paymentSuccessDone}},[_c('span',[_vm._v("\n              Done\n            ")])]),_vm._v(" "),_c('div',{staticClass:"app-modals__payment-success-get-in-actions"},[_vm._v("\n            Get in the action: "),_c('router-link',{attrs:{"to":{ name: 'market-list' }},nativeOn:{"click":function($event){return _vm.closePaymentSuccessModal($event)}}},[_vm._v("View All Markets")])],1)],1)])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PAYMENT_ERROR))?_c('modal',{attrs:{"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.error)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentPopupOptions.error)}}):_c('p',[_vm._v("Unfortunately, we could not process your payment.")])])])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.POTENTIAL_PAYOUTS))?_c('potential-payouts',{attrs:{"market":_vm.currentPopupOptions.market},on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.MARKET_CONTRACT_STATS))?_c('market-contracts-stats-popup',{attrs:{"stats":_vm.currentPopupOptions.stats,"isFixed":_vm.currentPopupOptions.isFixed},on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_OFFERS_INDICATOR))?_c('offers-indicator-popup',{attrs:{"items":_vm.currentPopupOptions.items,"operationType":_vm.currentPopupOptions.operationType,"price":_vm.currentPopupOptions.price},on:{"modalClose":function($event){return _vm.closeSmallModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.RESEARCH))?_c('modal',{attrs:{"bodyClass":"modal__body--gray modal__body--medium","noPadding":true,"gtm":"research"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Research Opportunities")]),_vm._v(" "),_c('research',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TWITTER))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","noPadding":true,"clickOutsideEnabled":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Latest Tweets")]),_vm._v(" "),_c('twitter-timeline',{attrs:{"slot":"content","inOverlay":true},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.NEWS_FEED))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","noPadding":true,"clickOutsideEnabled":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Latest News")]),_vm._v(" "),_c('news-feed',{attrs:{"slot":"content","inOverlay":true,"marketId":_vm.currentPopupOptions.marketId},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PURCHASE_SUSHI_REVIEW))?_c('modal',{attrs:{"bodyClass":"modal__body--slim","noPadding":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Review and Confirm Order")]),_vm._v(" "),_c('purchase-review-and-confirm-sushi',{attrs:{"slot":"content","market":_vm.tradePopupOptions.market},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_SWIFT))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n        Text\n      ")])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_CVV))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Where is my CVV?")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("6M/o")}})])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_VERIFICATION_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 0)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          You need to have your identity verified in order to make a deposit. Click \"Verify\" to provide the necessary information.\n        ")]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 1)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Some deposits and withdrawals will require us to perform an enhanced verification check. Click on \"Upgrade\" to prevent a delay in processing your transactions.\n        ")]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 2)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ROUTING_NUMBER))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Sample Check")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/check.96fa935.jpg"),expression:"`/static/img/check.96fa935.jpg`"}]})])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_EDIT_IMAGE))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Change Profile Image")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('account-update-image')],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.INSIGHT))?_c('insight-modal',{on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.GENERIC))?_c('modal',{attrs:{"bodyClass":"modal__body--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.currentPopupOptions.content)+"\n        ")]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_MARKET_RULES))?_c('modal',{attrs:{"autoClose":false,"overlayTheme":"z-index-plus-one"},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('div',{staticClass:"app-modals__rules",attrs:{"slot":"content"},slot:"content"},[_c('market-rules',{attrs:{"market":_vm.currentPopupOptions.market,"showExpanded":true,"dateEnd":_vm.currentPopupOptions.market.dateEndString,"rules":_vm.currentPopupOptions.market.rule}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_GENERIC))?_c('small-modal',{attrs:{"autoClose":true},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-small-popup',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.currentPopupOptions.content)+"\n        ")]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.EXPORT_TRADE_HISTORY))?_c('small-modal',{attrs:{"padding":false},on:{"modalClose":function($event){return _vm.closeModalHideOverlay()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.$route.query && _vm.$route.query.contractId)?[_vm._v("\n          Export Contract History\n        ")]:(_vm.$route.params.marketId && _vm.$route.params.marketId !== 'all')?[_vm._v("\n          Export Market History\n        ")]:[_vm._v("\n          Export Trade History\n        ")]],2),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('export-history',{attrs:{"kind":"trade"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.EXPORT_TRANSACTION_HISTORY))?_c('small-modal',{attrs:{"padding":false},on:{"modalClose":function($event){return _vm.closeModalHideOverlay()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Export Transaction History")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('export-history',{attrs:{"kind":"transaction"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_USERNAME))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Username")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/avatar.9ff8844.svg"),expression:"`/static/img/avatar.9ff8844.svg`"}]}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n         A username is required to preserve your anominity when using third-party services.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_TRADE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[(_vm.currentPopupOptions.completeInfo)?[_vm._v("\n          \"Net P/L\" is the sum of your profit/loss"),_c('br'),_vm._v(" and any trading fees. "),_c('br'),_c('br')]:_vm._e(),_vm._v("\n          Figures are calculated to the tenth of a cent, but rounded for display purposes.\n        ")],2)])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_OWNERSHIP_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Minimum Ownership")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Traders are required to purchase and maintain a minimum ownership of "+_vm._s(_vm.currentPopupOptions.shares)+" share"),(_vm.currentPopupOptions.shares > 1)?[_vm._v("s")]:_vm._e(),_vm._v(" in this contract.\n        ")],2)])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ROI_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\nReturn on Investment (ROI) is calculated as the % gain or loss in the value of your portfolio over the time period. Deposits and withdrawals during that period are not included in this calculation. You must have a minimum portfolio value of $10 at both the beginning and end of the period to appear on the leaderboard.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_FEE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\nThe fees listed here are the fees that PredictIt charges and do not include fees charged by any bank, crypto-network, or other 3rd party involved in transferring money.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_WINS_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          You are credited with a win whenever you sell a share at a profit.\n        ")]),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Trophies for Wins are awarded as follows:\n        ")]),_vm._v(" "),_c('leaderboards-trophy-pyramid')],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_LEADERBOARDS_UPDATE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Leaderboards are updated nightly. Your preference will be reflected in the next update.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ANNOUNCEMENT))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Announcement")]),_vm._v(" "),_c('announcement',{attrs:{"slot":"content","announcement":_vm.currentPopupOptions.announcement},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PUBLIC_PROFILE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("About Your Profile")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          To make PredictIt more fun and social in the future we will allow traders to share information from their profiles. If there is anything you would rather keep private you can always mark it as hidden. On your profile pages hidden items are still shown but include an asterisk (*) to let you know they are hidden from other users.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_RESTRICTED_FUNDS_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Funds awarded as part of promotional offer cannot be withdrawn until traded.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_SHARE_INVITE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Separate multiple email addresses with a semi-colon.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_MESSAGING_JOURNEY))?_c('small-modal',{attrs:{"closeButton":false}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('messaging-journey-info',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PWMB_ACCOUNT_CONFIRM_DELETE))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirmation")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("\n          Are you sure you want to remove this bank authorization?\n        ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__buttons"},[_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.stopPropagation();return _vm.currentPopupOptions.onConfirm($event)}}},[_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width button--focused",attrs:{"autofocus":""},on:{"click":function($event){$event.stopPropagation();return _vm.closeSmallModal()}}},[_vm._v("\n            No\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_BADGES))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Badges")]),_vm._v(" "),_c('account-badges-list',{staticClass:"modal__content--badges",attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_USER_PROFILE))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('user-profile-overview-header',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('user-profile-overview',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_REPORT_USER))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeUserReportModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Report User")]),_vm._v(" "),_c('user-report',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.COINBASE))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Process Overview\n      ")]),_vm._v(" "),_c('coinbase-process-overview',{attrs:{"slot":"content","depositPayload":_vm.currentPopupOptions.depositPayload},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.AFFILIATIONS))?_c('modal',{attrs:{"closeButton":!!_vm.currentPopupOptions.allowClose,"noPadding":true,"bodyClass":"modal__body--slim modal__body--show-ready modal__body--no-overflow"},on:{"modalClose":_vm.closeAffiliationsModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("College Affiliation")]),_vm._v(" "),_c('affiliations-popup',{attrs:{"slot":"content"},on:{"affiliationsSubmitted":_vm.onAffiliationsSubmitted},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.VIDEO))?_c('modal',{on:{"modalClose":_vm.closeModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('br'),_vm._v(" "),_c('youtube',{attrs:{"player-width":"100%","player-height":400,"video-id":_vm.currentPopupOptions.id}}),_vm._v(" "),_c('div',{staticClass:"app-modals__note"},[_vm._v("\n        For more information on how to trade on PredictIt, visit our "),_c('router-link',{staticClass:"app-modals__note-link",attrs:{"to":{name: 'HelpAndSupport'}}},[_vm._v("Support")]),_vm._v(" page.\n        ")],1)],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.MARKET_OWNERSHIP_CONFLICT))?_c('modal',{attrs:{"bodyClass":"modal__body--large","noPadding":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Market Ownership Conflict")]),_vm._v(" "),_c('market-ownership-conflict-modal',{attrs:{"slot":"content","restrictions":_vm.currentPopupOptions.restrictions,"restrictionPreamble":_vm.currentPopupOptions.restrictionPreamble},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_SHARE_INFO))?_c('small-modal',{attrs:{"wide":true,"padding":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('share-info-popup',{attrs:{"slot":"content","item":_vm.currentPopupOptions.item},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PAYOUT_INFO))?_c('small-modal',{attrs:{"wide":true,"padding":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          This is the estimated payout if your order is matched at the minimum sell price. Actual figures may differ if your order is matched at more favorable prices.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TWO_FACTOR))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":false},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Two-Factor Authentication")]),_vm._v(" "),_c('account-two-factor-verify',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TWO_FACTOR_PROMPT))?_c('modal',{attrs:{"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Security Recommendation")]),_vm._v(" "),_c('account-two-factor-prompt',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PHONE_UPDATE))?_c('modal',{attrs:{"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Update Phone Number")]),_vm._v(" "),_c('account-phone-update',{attrs:{"slot":"content"},on:{"close":function($event){return _vm.closeModal()}},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.RECAPTCHA_CHALLENGE))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":false}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Additional Verification Required")]),_vm._v(" "),_c('div',{staticClass:"recaptcha-challenge-modal",attrs:{"slot":"content"},slot:"content"},[(_vm.recaptchaVerifying)?[_c('div',{staticClass:"recaptcha-challenge-modal__loading"},[_c('div',{staticClass:"recaptcha-challenge-modal__spinner"}),_vm._v(" "),_c('p',{staticClass:"recaptcha-challenge-modal__message"},[_vm._v("\n              Verification successful! Processing your request...\n            ")])])]:[_c('p',{staticClass:"recaptcha-challenge-modal__message"},[_vm._v("\n            Please verify that you are not a robot to continue.\n          ")]),_vm._v(" "),_c('captcha',{key:_vm.currentPopupOptions.attempt || 1,on:{"input":_vm.onRecaptchaChallengeComplete}})]],2)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PRICE_ODDS))?_c('small-modal',{attrs:{"info":true,"closeButton":true},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('price-odds-toggle-popup'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button button--large button--black button--full-width",on:{"click":_vm.closeSmallModal}},[_c('span',[_vm._v("\n              Close\n            ")])])],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.CUSTOMIZE_YOUR_PREDICTIT))?_c('modal',{attrs:{"bodyClass":"modal__body--xlarge","noPadding":true},on:{"modalClose":function($event){return _vm.closeWhatIsNewPopup()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Customize Your PredictIt")]),_vm._v(" "),_c('what-is-new-popup',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('what-is-new-popup-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ECMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-market-links-overlay"},[_c('div',{staticClass:"bottom-market-links-overlay__content",on:{"click":_vm.closeOverlay}},[(_vm.isLoggedIn)?_c('div',{staticClass:"bottom-market-links-overlay__shortcuts"},[_c('div',{staticClass:"bottom-market-links-overlay__title"},[_vm._v("Account Shortcuts")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-deposit",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToDeposit($event)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("Deposit")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-dashboard",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToDashboard($event)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("Dashboard")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})])]):_c('div',{staticClass:"bottom-market-links-overlay__shortcuts"},[_c('div',{staticClass:"bottom-market-links-overlay__title"},[_vm._v("Account Shortcuts")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-dashboard",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToLogin($event)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("Login")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-dashboard",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToSignUp($event)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("Sign up")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})])]),_vm._v(" "),(_vm.showMarketShortcuts)?_c('div',{staticClass:"bottom-market-links-overlay__shortcuts"},[_c('div',{staticClass:"bottom-market-links-overlay__title"},[_vm._v("Market Sections")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-contracts",class:{'bottom-market-links-overlay__option--selected': _vm.selectedSection === _vm.NAVIGATION_TABS.CONTRACTS},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToMarketTab(_vm.NAVIGATION_TABS.CONTRACTS)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("Contracts")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-discussion",class:{'bottom-market-links-overlay__option--selected': _vm.selectedSection === _vm.NAVIGATION_TABS.DISCUSSION},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToMarketTab(_vm.NAVIGATION_TABS.DISCUSSION)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("Discussion")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-rules",class:{'bottom-market-links-overlay__option--selected': _vm.selectedSection === _vm.NAVIGATION_TABS.RULES},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToMarketTab(_vm.NAVIGATION_TABS.RULES)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("Rules")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})]),_vm._v(" "),(_vm.isLoggedIn)?_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-history",class:{'bottom-market-links-overlay__option--selected': _vm.selectedSection === _vm.NAVIGATION_TABS.HISTORY},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToMarketTab(_vm.NAVIGATION_TABS.HISTORY)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("History")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})]):_vm._e(),_vm._v(" "),(_vm.isLoggedIn)?_c('div',{staticClass:"bottom-market-links-overlay__option bottom-market-links-overlay__option--slim bottom-market-links-overlay__option--slim-lists",class:{'bottom-market-links-overlay__option--selected': _vm.selectedSection === _vm.NAVIGATION_TABS.LINKS},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goToMarketTab(_vm.NAVIGATION_TABS.LINKS)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_vm._v("Lists")]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__title"},[_vm._v("Action Bar Modes")]),_vm._v(" "),_vm._l((_vm.options),function(option){return _c('div',{key:option.mode,class:_vm.optionClassModifiers(option),on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.switchTo(option.mode)}}},[_c('div',{staticClass:"bottom-market-links-overlay__option-title"},[_c('div',{staticClass:"bottom-market-links-overlay__option-title-text"},[_vm._v("\n          "+_vm._s(option.title)+"\n        ")]),_vm._v(" "),(_vm.showContractsOnlyWarning(option.mode))?_c('div',{staticClass:"bottom-market-links-overlay__option-title-info"},[_vm._v("\n          Contracts Section Only\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bottom-market-links-overlay__option-icon"})])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EGLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");




/*
  Use this component as <captcha :key="parentVar"></captcha>
  and update var on error, so it rerenders properly.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      key: ''
    };
  },

  computed: {
    styleModifiers: function styleModifiers() {
      return {
        transform: 'scale(0.95)'
      };
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getCaptchaSiteKey']), {
    onSuccess: function onSuccess(value) {
      this.$emit('input', value);
    },
    onExpired: function onExpired() {
      this.$emit('input', null);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var url = 'https://www.google.com/recaptcha/api.js';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["b" /* loadScript */])(url, 'grecaptcha').then(function (grecaptcha) {
      _this.getCaptchaSiteKey().then(function (data) {
        _this.key = data;
        grecaptcha.ready(function () {
          grecaptcha.render(_this.$refs.captcha, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
            sitekey: _this.key,
            callback: _this.onSuccess
          }, 'expired-callback', _this.onExpired));
        });
      });
    });
  }
});

/***/ }),

/***/ "EIVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_loader_js__ = __webpack_require__("7fpX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_448d5fde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_loader_vue__ = __webpack_require__("xpMb");
function injectStyle (ssrContext) {
  __webpack_require__("Fokc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_loader_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_448d5fde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EKqI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_verify_js__ = __webpack_require__("5f2b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49ee4ab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_verify_vue__ = __webpack_require__("xYxR");
function injectStyle (ssrContext) {
  __webpack_require__("Pxah")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_verify_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49ee4ab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_verify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ENdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setToken */
/* unused harmony export addListener */
/* unused harmony export connect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return forceReconnect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createConnection; });
/* unused harmony export isConnected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return forceDisconnect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* global $ */
/* eslint-disable */



var STATES = ['connecting', 'connected', 'reconnecting', '', 'disconnected'];
var reconnectTimeout = 5 * 1000;
var channelMarketHub = null;
var connection = null;
var reconnectDisabled = false;

function createConnection(_ref) {
  var apiToken = _ref.apiToken,
      onUpdate = _ref.onUpdate;

  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'createConnection::', apiToken);
  if (typeof $ !== 'undefined' && typeof $.hubConnection !== 'undefined') {
    connection = $.hubConnection("https://hub.predictit.org/signalr", {
      useDefaultPath: false
    });
    channelMarketHub = connection.createHubProxy('marketHub');
    if (apiToken) {
      setToken({ apiToken: apiToken });
    }
    if (isConnected()) {
      addListener({ onUpdate: onUpdate });
      connect();
    }
    return true;
  }
  return false;
}

var isConnected = function isConnected() {
  return connection !== null;
};

var connect = function connect() {
  if (!isConnected()) return;
  channelMarketHub.on('update', function (objectType, object) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'marketHub::', 'update::', objectType, object);
  });
  connection.start().done(function (state) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'connection::', 'connected::', state.id, state);
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('app/setSignalrInitialized', true);
  }).fail(function (error) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'connection::', 'errored::', error);
    if (reconnectDisabled) {
      __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect-disabled::');
    } else {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect::');
        connection.start();
      }, reconnectTimeout);
    }
  });
  connection.starting(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: starting::');
  });
  connection.received(function (data) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'received::', data);
  });
  connection.connectionSlow(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: connectionSlow::');
  });
  connection.reconnecting(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnecting::');
  });
  connection.reconnected(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnected::');
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('app/setSignalrInitialized', true);
  });
  connection.stateChanged(function (change) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: stateChanged::', STATES[change.oldState], ' => ', STATES[change.newState]);
  });
  connection.disconnected(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: disconnected::', connection.lastError);
    if (reconnectDisabled) {
      __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect-disabled::');
    } else {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect::');
        connection.start();
      }, reconnectTimeout);
    }
  });
  window.onbeforeunload = function () {
    if (connection !== null) {
      connection.stop();
    }
  };
};

var addListener = function addListener(options) {
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'adding listener');
  var _options$onUpdate = options.onUpdate,
      onUpdate = _options$onUpdate === undefined ? function () {
    return null;
  } : _options$onUpdate;

  channelMarketHub.on('update', function (objectType, object) {
    onUpdate('update', objectType, object);
  });
};

var setToken = function setToken(options) {
  var _options$apiToken = options.apiToken,
      apiToken = _options$apiToken === undefined ? null : _options$apiToken;

  if (apiToken !== null && connection !== null) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: token present, add bearer');
    connection.qs = { bearer: apiToken };
  }
};

var forceReconnect = function forceReconnect(_ref2) {
  var apiToken = _ref2.apiToken,
      onUpdate = _ref2.onUpdate;

  if (document.readyState !== 'complete') return;
  if (!isConnected()) return;
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'forceReconnect::');
  reconnectDisabled = true;
  connection.stop();
  connection = null;
  channelMarketHub = null;
  if (!apiToken) return;
  var created = createConnection({ apiToken: apiToken, onUpdate: onUpdate });
  if (created) {
    reconnectDisabled = false;
  }
};

var forceDisconnect = function forceDisconnect() {
  if (!isConnected()) return;
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: forceDisconnect::');
  reconnectDisabled = true;
  connection.stop();
  connection = null;
  channelMarketHub = null;
};



/***/ }),

/***/ "EOu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return waitForFirebaseInitialized; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return waitForStatusReady; });
/* unused harmony export waitForSignalrInitialized */
/* unused harmony export waitForHighCharts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");

/* eslint-disable */



var waitForFirebaseInitialized = function waitForFirebaseInitialized() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.app.firebaseInitialized) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

var waitForStatusReady = function waitForStatusReady() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (typeof __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.status.hasBeenFunded !== 'undefined') {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

var waitForSignalrInitialized = function waitForSignalrInitialized() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.app.signalrInitialized || !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/isLoggedIn']) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

var waitForHighCharts = function waitForHighCharts() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["s" /* isHighChartsReady */])()) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

/***/ }),

/***/ "ERhj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ESWA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ETXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_popup_js__ = __webpack_require__("eFE/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b364405_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_popup_vue__ = __webpack_require__("X0hB");
function injectStyle (ssrContext) {
  __webpack_require__("wuuS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b364405_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EZP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_simple_js__ = __webpack_require__("OHuv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427d1980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_simple_vue__ = __webpack_require__("UV+D");
function injectStyle (ssrContext) {
  __webpack_require__("o5X3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_simple_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427d1980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_simple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EbKL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EcaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notification_items_notification_item_simple_notification_item_simple_vue__ = __webpack_require__("EZP0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notification_items_notification_item_trade_confirmed_notification_item_trade_confirmed_vue__ = __webpack_require__("uVqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__ = __webpack_require__("MJqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__ = __webpack_require__("a0yF");

/* eslint-disable no-unused-vars */
/*
  Display List of notifications in top right side of the page, reuses many components.
  One of used components is dashboard notification which for now is used to display:
  - NOTIFICATION_SHARES_TRADED
 */






var ROUTE_PORTFOLIO = 'portfolio';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    notificationItemDashboard: __WEBPACK_IMPORTED_MODULE_4__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__["a" /* default */],
    notificationItemSimple: __WEBPACK_IMPORTED_MODULE_2__components_notification_items_notification_item_simple_notification_item_simple_vue__["a" /* default */],
    notificationItemTradeConfirmed: __WEBPACK_IMPORTED_MODULE_3__components_notification_items_notification_item_trade_confirmed_notification_item_trade_confirmed_vue__["a" /* default */]
  },
  data: function data() {
    return {
      NOTIFICATION_SHARES_TRADED_CLOSE_DELAY: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["c" /* NOTIFICATION_SHARES_TRADED_CLOSE_DELAY */],
      NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["d" /* NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY */],
      activeNotification: null,
      currentRoute: this.$router.currentRoute
    };
  },

  watch: {
    notificationList: function notificationList(value) {
      this.activeNotification = value[value.length - 1];
    },
    $route: function $route(to, from) {
      this.currentRoute = to;
      if (from.name !== to.name) {
        this.clear();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['notificationList']), {
    mockNotifications: function mockNotifications() {
      return [{
        index: 1,
        method: 'asd',
        type: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["e" /* NOTIFICATION_SIMPLE */],
        data: {
          closeTimeout: 3500,
          icon: 'pending',
          text: 'You will be notified when processing is complete.',
          title: 'Order Received'
        }
      }, {
        index: 2,
        method: 'asd',
        type: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["f" /* NOTIFICATION_TRADE_CONFIRMED */],
        data: { "ContractId": 18492, "Name": "test1", "MarketId": 7458, "MarketName": "Placeholder Test Market Multi Outcome", "MarketUrl": "Placeholder-Test-Market-Multi-Outcome", "MarketType": 3, "ImageName": "default.jpg", "TotalProfit": 0, "TotalFees": 0, "ShowRisk": false, "TotalRiskChange": 0, "TotalCost": 0, "Offer": { "OfferId": 285028, "ContractId": 18492, "Quantity": 1, "RemainingQuantity": 1, "DateCreated": "2023-05-17T11:27:42.14", "TradeType": 1, "PricePerShare": 0.99 }, "History": [], "TimeStamp": "1684322862.08828", "Guid": "460c5426-b273-461b-a067-3a7256202edc", "UpdateType": "tradeConfirmed_data" }
      }, {
        index: 3,
        method: 'asd',
        type: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["e" /* NOTIFICATION_SIMPLE */],
        data: {
          closeTimeout: 3500,
          title: 'Error Occurred',
          icon: 'cancel',
          text: 'Order Received. You will be notified when processing is complete.'
        }
      }, {
        index: 4,
        method: 'asd',
        type: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["f" /* NOTIFICATION_TRADE_CONFIRMED */],
        data: { "ContractId": 18492, "Name": "test1", "MarketId": 7458, "MarketName": "Placeholder Test Market Multi Outcome", "MarketUrl": "Placeholder-Test-Market-Multi-Outcome", "MarketType": 3, "ImageName": "default.jpg", "TotalProfit": 0, "TotalFees": 0, "ShowRisk": false, "TotalRiskChange": 0, "TotalCost": 0, "Offer": { "OfferId": 285028, "ContractId": 18492, "Quantity": 1, "RemainingQuantity": 0, "DateCreated": "2023-05-17T11:27:42.14", "TradeType": 1, "PricePerShare": 0.99 }, "History": [{}], "TimeStamp": "1684322862.08828", "Guid": "460c5426-b273-461b-a067-3a7256202edc", "UpdateType": "tradeConfirmed_data" }
      }];
    },
    notificationsToDisplay: function notificationsToDisplay() {
      // TODO
      // return this.mockNotifications
      return this.notificationList.filter(this.isNotificationDisplayable);
    },
    shouldDisplayNotifications: function shouldDisplayNotifications() {
      return this.notificationsToDisplay.length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['clear']), {
    onClose: function onClose() {
      // TODO
      this.clear();
    },
    isNotificationDisplayable: function isNotificationDisplayable(notification) {
      return this.shouldDisplayNotificationSimple(notification) || this.shouldDisplayNotificationTradeConfirmed(notification) || this.shouldDisplayDashboardNotification(notification);
    },
    shouldDisplayNotificationSimple: function shouldDisplayNotificationSimple(notification) {
      return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["e" /* NOTIFICATION_SIMPLE */];
    },
    shouldDisplayNotificationTradeConfirmed: function shouldDisplayNotificationTradeConfirmed(notification) {
      // TODO
      // return true;
      var displayRouteNames = ['market-details', 'market-details-sushi', 'market-detail-contracts', 'market-detail-rules', 'market-detail-charts', 'market-detail-history', 'market-detail-discussion', 'market-details-legacy'];
      if (displayRouteNames.includes(this.currentRoute.name)) {
        return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["f" /* NOTIFICATION_TRADE_CONFIRMED */] && notification.data.MarketId.toString() === this.currentRoute.params.marketId.toString();
      } else if (this.currentRoute.name === ROUTE_PORTFOLIO) {
        return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["f" /* NOTIFICATION_TRADE_CONFIRMED */];
      }
      return false;
    },
    shouldDisplayDashboardNotification: function shouldDisplayDashboardNotification(notification) {
      var types = [__WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["g" /* NOTIFICATION_SHARES_TRADED */], __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["h" /* NOTIFICATION_TRADER_LEVEL_CHANGED */]];
      return types.includes(notification.type);
    }
  })
});

/***/ }),

/***/ "Eckv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ed2X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EeD/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Efhk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_insights__ = __webpack_require__("95qB");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_insights__["a" /* default */]],
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'insight-widget': true
      }, 'insight-widget--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "EhAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processing-transaction"},[(_vm.showTimeout)?[_c('div',{staticClass:"processing-transaction__content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"processing-transaction__message"},[_vm._v("\n        It looks like we are having some communication issues. Don't worry, we will keep trying to complete your request. Please check your Withdrawal History as usually these issues resolve within a few minutes.\n      ")]),_vm._v(" "),_c('button',{staticClass:"button button--primary button--full-width processing-transaction__button",on:{"click":_vm.openWithdrawalHistory}},[_vm._v("\n        Open Withdrawal History\n      ")])])]:[_c('div',{staticClass:"processing-transaction__loader"}),_vm._v(" "),_c('div',{staticClass:"processing-transaction__processing"},[_vm._v("\n      Processing Request...\n    ")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processing-transaction__icon-wrapper"},[_c('div',{staticClass:"processing-transaction__icon"}),_vm._v(" "),_c('p',{staticClass:"processing-transaction__label"},[_vm._v("Processing Timeout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EjHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_password_requirements_js__ = __webpack_require__("LHdv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a84d262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_requirements_vue__ = __webpack_require__("2uxq");
function injectStyle (ssrContext) {
  __webpack_require__("/sWl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_password_requirements_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a84d262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_requirements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ellf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_validators__ = __webpack_require__("SVQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_code_input_code_input_vue__ = __webpack_require__("l8Or");









/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
    components: {
        switchButton: __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__["a" /* default */],
        CodeInput: __WEBPACK_IMPORTED_MODULE_7__components_generics_code_input_code_input_vue__["a" /* default */]
    },
    validations: {
        phoneNumber: __WEBPACK_IMPORTED_MODULE_5__helpers_validators__["a" /* default */].phone
    },
    data: function data() {
        return {
            loading: true,
            error: null,
            status: null,

            // Setup states
            setupMode: null, // 'email', 'phone', 'authenticator'
            setupStep: 'select', // 'select', 'send', 'verify', 'phone-input'

            // Email/Phone setup
            verificationCode: '',
            isSendingCode: false,
            isVerifying: false,
            codeSent: false,
            secondsUntilResend: 0,
            resendTimer: null,

            // Phone number input (for adding new phone)
            phoneNumber: '',
            pendingPhoneNumber: '',

            // Authenticator setup
            authenticatorData: null,
            codeCopied: false,

            // Confirmation modal for disabling 2FA
            showDisableConfirmation: false,
            isDisabling: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['userData']), {
        is2FAEnabled: function is2FAEnabled() {
            return this.status && this.status.is_two_factor_enabled || false;
        },
        isEmailVerified: function isEmailVerified() {
            return this.status && this.status.is_email_verified || false;
        },
        isPhoneVerified: function isPhoneVerified() {
            return this.status && this.status.is_phone_verified || false;
        },
        isAuthenticatorEnabled: function isAuthenticatorEnabled() {
            return this.status && this.status.is_authenticator_enabled || false;
        },
        emailHint: function emailHint() {
            return this.status && this.status.email_hint || '';
        },
        phoneHint: function phoneHint() {
            return this.status && this.status.phone_hint || '';
        },
        hasPhone: function hasPhone() {
            return !!this.phoneHint;
        },
        canEnable2FA: function canEnable2FA() {
            return this.status && this.status.can_enable_two_factor || false;
        },
        hasAnyMethod: function hasAnyMethod() {
            return this.isEmailVerified || this.isPhoneVerified || this.isAuthenticatorEnabled;
        },
        canSendCode: function canSendCode() {
            return !this.isSendingCode && this.secondsUntilResend === 0;
        },
        canVerify: function canVerify() {
            return this.verificationCode.length >= 6 && !this.isVerifying;
        },
        phoneError: function phoneError() {
            if (this.$v.phoneNumber.$error) {
                return 'Enter a valid phone number';
            }
            return '';
        },
        canSubmitPhone: function canSubmitPhone() {
            return !this.$v.phoneNumber.$invalid && !this.isSendingCode;
        },
        hasCodeError: function hasCodeError() {
            return this.error !== null && this.verificationCode === '';
        },
        currentStep: function currentStep() {
            // Returns step number for stepper indicator
            if (!this.setupMode) return 0;
            if (this.setupStep === 'phone-input') return 1;
            if (this.setupStep === 'send') return 1;
            if (this.setupStep === 'verify') return 2;
            return 1;
        },
        totalSteps: function totalSteps() {
            // Email/Phone: Send -> Verify (2 steps)
            // Authenticator: Scan -> Verify (2 steps)
            // Phone with input: Input -> Send -> Verify (3 steps, but we show 2)
            return 2;
        }
    }),
    mounted: function mounted() {
        this.loadStatus();

        // Clear the navigation flag now that we've arrived
        this.setNavigatingToTwoFactorSetup(false);
    },
    beforeDestroy: function beforeDestroy() {
        this.clearResendTimer();
    },

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('user', ['getTwoFactorStatus', 'twoFactorSetupEmailSendCode', 'twoFactorSetupEmailVerify', 'twoFactorSetupPhoneSendCode', 'twoFactorSetupPhoneVerify', 'getTwoFactorSetupAuthenticator', 'twoFactorSetupAuthenticatorVerify', 'twoFactorEnable', 'twoFactorDisable', 'phoneUpdate', 'phoneVerify', 'setNavigatingToTwoFactorSetup']), {
        loadStatus: function loadStatus() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                _this.error = null;
                                _context.prev = 2;
                                _context.next = 5;
                                return _this.getTwoFactorStatus();

                            case 5:
                                _this.status = _context.sent;
                                _context.next = 11;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](2);

                                _this.error = 'Failed to load security settings.';

                            case 11:
                                _context.prev = 11;

                                _this.loading = false;
                                return _context.finish(11);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[2, 8, 11, 14]]);
            }))();
        },
        startSetup: function startSetup(method) {
            this.setupMode = method;
            this.verificationCode = '';
            this.codeSent = false;
            this.error = null;
            this.phoneNumber = '';
            this.pendingPhoneNumber = '';
            this.secondsUntilResend = 0;
            this.clearResendTimer();

            if (method === 'authenticator') {
                this.setupStep = 'send';
                this.loadAuthenticatorSetup();
            } else if (method === 'phone' && !this.hasPhone) {
                // User needs to enter a phone number first
                this.setupStep = 'phone-input';
            } else {
                // Auto-send code for email/phone methods (if phone exists)
                // Set both states synchronously to show spinner immediately (avoids button flash)
                this.isSendingCode = true;
                this.setupStep = 'send';
                this.doSendCode();
            }
        },


        // Internal method that skips the canSendCode guard (for initial auto-send)
        doSendCode: function doSendCode() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.isSendingCode = true;
                                _this2.error = null;

                                _context2.prev = 2;
                                response = void 0;

                                if (!(_this2.setupMode === 'email')) {
                                    _context2.next = 10;
                                    break;
                                }

                                _context2.next = 7;
                                return _this2.twoFactorSetupEmailSendCode();

                            case 7:
                                response = _context2.sent;
                                _context2.next = 20;
                                break;

                            case 10:
                                if (!(_this2.setupMode === 'phone')) {
                                    _context2.next = 20;
                                    break;
                                }

                                if (!_this2.pendingPhoneNumber) {
                                    _context2.next = 17;
                                    break;
                                }

                                _context2.next = 14;
                                return _this2.phoneUpdate({ phoneNumber: _this2.pendingPhoneNumber });

                            case 14:
                                response = _context2.sent;
                                _context2.next = 20;
                                break;

                            case 17:
                                _context2.next = 19;
                                return _this2.twoFactorSetupPhoneSendCode();

                            case 19:
                                response = _context2.sent;

                            case 20:

                                _this2.codeSent = true;
                                _this2.setupStep = 'verify';
                                _this2.secondsUntilResend = response && response.seconds_til_resend_available || 60;
                                _this2.startResendTimer();

                                // Focus the code input after it appears
                                _this2.$nextTick(function () {
                                    if (_this2.$refs.codeInput) {
                                        _this2.$refs.codeInput.focusFirst();
                                    }
                                });
                                _context2.next = 30;
                                break;

                            case 27:
                                _context2.prev = 27;
                                _context2.t0 = _context2['catch'](2);

                                _this2.error = _this2.extractErrorMessage(_context2.t0, 'Failed to send verification code.');

                            case 30:
                                _context2.prev = 30;

                                _this2.isSendingCode = false;
                                return _context2.finish(30);

                            case 33:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 27, 30, 33]]);
            }))();
        },
        cancelSetup: function cancelSetup() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.setupMode = null;
                                _this3.setupStep = 'select';
                                _this3.verificationCode = '';
                                _this3.codeSent = false;
                                _this3.authenticatorData = null;
                                _this3.secondsUntilResend = 0;
                                _this3.clearResendTimer();
                                _this3.codeCopied = false;
                                _context3.next = 10;
                                return _this3.loadStatus();

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        loadAuthenticatorSetup: function loadAuthenticatorSetup() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.loading = true;
                                _this4.codeCopied = false;
                                _context4.prev = 2;
                                _context4.next = 5;
                                return _this4.getTwoFactorSetupAuthenticator();

                            case 5:
                                _this4.authenticatorData = _context4.sent;

                                _this4.setupStep = 'verify';
                                _context4.next = 12;
                                break;

                            case 9:
                                _context4.prev = 9;
                                _context4.t0 = _context4['catch'](2);

                                _this4.error = _this4.extractErrorMessage(_context4.t0, 'Failed to load authenticator setup.');

                            case 12:
                                _context4.prev = 12;

                                _this4.loading = false;
                                return _context4.finish(12);

                            case 15:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[2, 9, 12, 15]]);
            }))();
        },
        copyManualCode: function copyManualCode() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var textArea;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(!_this5.authenticatorData || !_this5.authenticatorData.manual_code)) {
                                    _context5.next = 2;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 2:
                                _context5.prev = 2;
                                _context5.next = 5;
                                return navigator.clipboard.writeText(_this5.authenticatorData.manual_code);

                            case 5:
                                _this5.codeCopied = true;

                                // Reset copied state after 2 seconds
                                setTimeout(function () {
                                    _this5.codeCopied = false;
                                }, 2000);
                                _context5.next = 19;
                                break;

                            case 9:
                                _context5.prev = 9;
                                _context5.t0 = _context5['catch'](2);

                                // Fallback for older browsers
                                textArea = document.createElement('textarea');

                                textArea.value = _this5.authenticatorData.manual_code;
                                document.body.appendChild(textArea);
                                textArea.select();
                                document.execCommand('copy');
                                document.body.removeChild(textArea);
                                _this5.codeCopied = true;

                                setTimeout(function () {
                                    _this5.codeCopied = false;
                                }, 2000);

                            case 19:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5, [[2, 9]]);
            }))();
        },
        sendCode: function sendCode() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (_this6.canSendCode) {
                                    _context6.next = 2;
                                    break;
                                }

                                return _context6.abrupt('return');

                            case 2:
                                _context6.next = 4;
                                return _this6.doSendCode();

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        submitPhoneNumber: function submitPhoneNumber() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _this7.$v.phoneNumber.$touch();

                                if (!_this7.$v.phoneNumber.$invalid) {
                                    _context7.next = 4;
                                    break;
                                }

                                _this7.error = 'Please enter a valid phone number.';
                                return _context7.abrupt('return');

                            case 4:

                                _this7.isSendingCode = true;
                                _this7.error = null;

                                _context7.prev = 6;
                                _context7.next = 9;
                                return _this7.phoneUpdate({ phoneNumber: _this7.phoneNumber });

                            case 9:
                                response = _context7.sent;

                                _this7.pendingPhoneNumber = _this7.phoneNumber;
                                _this7.codeSent = true;
                                _this7.setupStep = 'verify';
                                _this7.secondsUntilResend = response && response.seconds_til_resend_available || 60;
                                _this7.startResendTimer();
                                _context7.next = 20;
                                break;

                            case 17:
                                _context7.prev = 17;
                                _context7.t0 = _context7['catch'](6);

                                _this7.error = _this7.extractErrorMessage(_context7.t0, 'Failed to send verification code.');

                            case 20:
                                _context7.prev = 20;

                                _this7.isSendingCode = false;
                                return _context7.finish(20);

                            case 23:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7, [[6, 17, 20, 23]]);
            }))();
        },
        onCodeComplete: function onCodeComplete(code) {
            // Auto-submit when 6 digits are entered
            if (code && code.length === 6 && !this.isVerifying) {
                this.verifyCode();
            }
        },
        verifyCode: function verifyCode() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (_this8.canVerify) {
                                    _context8.next = 2;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 2:

                                _this8.isVerifying = true;
                                _this8.error = null;

                                _context8.prev = 4;

                                if (!(_this8.setupMode === 'email')) {
                                    _context8.next = 10;
                                    break;
                                }

                                _context8.next = 8;
                                return _this8.twoFactorSetupEmailVerify({ code: _this8.verificationCode });

                            case 8:
                                _context8.next = 23;
                                break;

                            case 10:
                                if (!(_this8.setupMode === 'phone')) {
                                    _context8.next = 20;
                                    break;
                                }

                                if (!_this8.pendingPhoneNumber) {
                                    _context8.next = 16;
                                    break;
                                }

                                _context8.next = 14;
                                return _this8.phoneVerify({ phoneNumber: _this8.pendingPhoneNumber, code: _this8.verificationCode });

                            case 14:
                                _context8.next = 18;
                                break;

                            case 16:
                                _context8.next = 18;
                                return _this8.twoFactorSetupPhoneVerify({ code: _this8.verificationCode });

                            case 18:
                                _context8.next = 23;
                                break;

                            case 20:
                                if (!(_this8.setupMode === 'authenticator')) {
                                    _context8.next = 23;
                                    break;
                                }

                                _context8.next = 23;
                                return _this8.twoFactorSetupAuthenticatorVerify({
                                    code: _this8.verificationCode,
                                    encryptedSecret: _this8.authenticatorData.encrypted_secret
                                });

                            case 23:
                                _context8.next = 25;
                                return _this8.loadStatus();

                            case 25:
                                _this8.cancelSetup();
                                _context8.next = 32;
                                break;

                            case 28:
                                _context8.prev = 28;
                                _context8.t0 = _context8['catch'](4);

                                _this8.error = _this8.extractErrorMessage(_context8.t0, 'Incorrect code. Please try again.');
                                _this8.verificationCode = '';

                            case 32:
                                _context8.prev = 32;

                                _this8.isVerifying = false;
                                return _context8.finish(32);

                            case 35:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8, [[4, 28, 32, 35]]);
            }))();
        },
        toggleTwoFactor: function toggleTwoFactor(enabled) {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(enabled && !_this9.is2FAEnabled)) {
                                    _context9.next = 13;
                                    break;
                                }

                                _context9.prev = 1;
                                _context9.next = 4;
                                return _this9.twoFactorEnable();

                            case 4:
                                _context9.next = 6;
                                return _this9.loadStatus();

                            case 6:
                                _context9.next = 11;
                                break;

                            case 8:
                                _context9.prev = 8;
                                _context9.t0 = _context9['catch'](1);

                                _this9.error = _this9.extractErrorMessage(_context9.t0, 'Failed to enable 2FA.');

                            case 11:
                                _context9.next = 14;
                                break;

                            case 13:
                                if (!enabled && _this9.is2FAEnabled) {
                                    // Show confirmation modal before disabling
                                    _this9.showDisableConfirmation = true;
                                }

                            case 14:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this9, [[1, 8]]);
            }))();
        },
        cancelDisable: function cancelDisable() {
            this.showDisableConfirmation = false;
            // Force the toggle-button back to the correct "enabled" state
            // since is2FAEnabled didn't change, the watcher won't fire automatically
            if (this.$refs.twoFactorToggle) {
                this.$refs.twoFactorToggle.isChecked = this.is2FAEnabled;
            }
        },
        confirmDisable: function confirmDisable() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _this10.isDisabling = true;
                                _this10.error = null;
                                _context10.prev = 2;
                                _context10.next = 5;
                                return _this10.twoFactorDisable();

                            case 5:
                                _context10.next = 7;
                                return _this10.loadStatus();

                            case 7:
                                _this10.showDisableConfirmation = false;
                                _context10.next = 13;
                                break;

                            case 10:
                                _context10.prev = 10;
                                _context10.t0 = _context10['catch'](2);

                                _this10.error = _this10.extractErrorMessage(_context10.t0, 'Failed to disable 2FA.');

                            case 13:
                                _context10.prev = 13;

                                _this10.isDisabling = false;
                                return _context10.finish(13);

                            case 16:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this10, [[2, 10, 13, 16]]);
            }))();
        },
        startResendTimer: function startResendTimer() {
            var _this11 = this;

            this.clearResendTimer();
            this.resendTimer = setInterval(function () {
                if (_this11.secondsUntilResend > 0) {
                    _this11.secondsUntilResend -= 1;
                } else {
                    _this11.clearResendTimer();
                }
            }, 1000);
        },
        clearResendTimer: function clearResendTimer() {
            if (this.resendTimer) {
                clearInterval(this.resendTimer);
                this.resendTimer = null;
            }
        },
        extractErrorMessage: function extractErrorMessage(error, defaultMessage) {
            // API returns errors as a direct array: response.data = [{ code, message, ... }]
            if (error.response && error.response.data) {
                var data = error.response.data;

                // Handle direct array of errors (API format)
                if (Array.isArray(data) && data.length > 0 && data[0].message) {
                    return data[0].message;
                }

                // Handle nested errors array
                if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                    return data.errors[0].message;
                }

                // Handle direct message property
                if (data.message) {
                    return data.message;
                }
            }
            return defaultMessage;
        },
        getMethodStatusText: function getMethodStatusText(isVerified) {
            return isVerified ? 'Verified' : 'Not Set Up';
        },
        getMethodStatusClass: function getMethodStatusClass(isVerified) {
            return isVerified ? 'security-settings__status--verified' : 'security-settings__status--not-verified';
        }
    })
});

/***/ }),

/***/ "EoBZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgIDxnIGZpbGw9IiM2Nzk5OUYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTTEwLjUgMEM0LjcxIDAgMCA0LjcxIDAgMTAuNVM0LjcxIDIxIDEwLjUgMjEgMjEgMTYuMjkgMjEgMTAuNSAxNi4yOSAwIDEwLjUgMHptMCAxOS4yYy00Ljc5NyAwLTguNy0zLjkwMy04LjctOC43IDAtNC43OTcgMy45MDMtOC43IDguNy04LjcgNC43OTcgMCA4LjcgMy45MDMgOC43IDguNyAwIDQuNzk3LTMuOTAzIDguNy04LjcgOC43eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMC42NyA4LjQ5NWMuNjgyLjAwNiAxLjI0My0uNTcgMS4yNS0xLjI3NGExLjI2NiAxLjI2NiAwIDAgMC0xLjI0My0xLjI5M2MtLjY5NSAwLTEuMjY0LjU2Mi0xLjI3IDEuMjczIDAgLjcwNC41NjEgMS4yODcgMS4yNjMgMS4yOTR6TTEyLjE3NCAxNC4yNzJjLS4xMi4wNDctLjIzNC4xMzUtLjM1NC4xODJhMS45NDIgMS45NDIgMCAwIDEtLjQ2OC4xMzZjLS4xOTQuMDItLjMzNC0uMDgxLS4zODEtLjI3MWExLjQwNiAxLjQwNiAwIDAgMS0uMDQtLjQ0Yy4wMzMtLjMwNS4wOTMtLjYwMy4xNDctLjkwOC4xNi0uOTA3LjMzNC0xLjgxNS40ODgtMi43MjkuMDQtLjI0NC4wODctLjQ5NC4wOC0uNzQ1LS4wMDctLjI5OC0uMTgtLjQ0LS40NzUtLjQ0SDguNzkyYTIuMDUgMi4wNSAwIDAgMC0uMjg4LjAyYy0uMTguMDM0LS4yNjcuMTIyLS4yOC4yNjQtLjAxNC4xMjkuMDUzLjI1OC4yMi4zMTkuMTM0LjA0Ny4yNzQuMDYuNDE1LjA4LjMyLjA0OC40MjguMTYzLjQyOC40OTUgMCAuMDU0LS4wMDcuMTAyLS4wMTQuMTU2LS4xMzQuOC0uMjggMS41OTEtLjQxNCAyLjM5LS4wNzQuNDYxLS4xNDcuOTE1LS4yMDcgMS4zNzUtLjA5NC42Ny41NDggMS4zMDggMS4wNDkgMS4zNzUuMy4wNC42MDguMDU0LjkxNi4wNDguNjU1LS4wMDcgMS4yMDMtLjI5MiAxLjY2NC0uNzU5YS42OTYuNjk2IDAgMCAwIC4xNzQtLjMwNWMuMDUzLS4xOS0uMDk0LS4zMTgtLjI4MS0uMjQzeiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "Eu+w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eu6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[(_vm.showDetails)?_c('small-modal',{on:{"modalClose":function($event){_vm.showDetails = false}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n      PredictIt is currently undergoing maintenance."),_c('br'),_c('br'),_vm._v(" You can login and access your account, but cannot create new orders.\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-site-alert-v2__title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-site-alert-v2__text"},[(_vm.isLayoutMobile)?_c('span',{staticClass:"market-site-alert-v2__details-link",on:{"click":function($event){_vm.showDetails = true}}},[_vm._v("\n        View Details\n      ")]):[_vm._v("\n        PredictIt is currently undergoing maintenance. You can login and access your account, but cannot create new orders.\n      ")]],2)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EvJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EvOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_js__ = __webpack_require__("tE+S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f80081c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_vue__ = __webpack_require__("bFdm");
function injectStyle (ssrContext) {
  __webpack_require__("2ZYw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f80081c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ExM7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EyLR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_header_app_header_vue__ = __webpack_require__("8hek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_secondary_nav_app_secondary_nav_vue__ = __webpack_require__("O8vu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_main_nav_app_main_nav_vue__ = __webpack_require__("3cKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_bottom_nav_app_bottom_nav_vue__ = __webpack_require__("DvJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_mobile_menu_app_mobile_menu_vue__ = __webpack_require__("IKgY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_footer_app_footer_vue__ = __webpack_require__("bkfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_notification_items_notification_items_vue__ = __webpack_require__("rEDR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_header_notification_app_header_notification_vue__ = __webpack_require__("dMVO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_maintenance_notification_maintenance_notification_vue__ = __webpack_require__("T7ic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_header_search_bar_search_bar_vue__ = __webpack_require__("OL8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generics_side_notification_side_notification_vue__ = __webpack_require__("2zfn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_app_secondary_nav_nav_browse_categories_overlay_nav_browse_categories_overlay_vue__ = __webpack_require__("w4vL");
















var SIMPLE_LAYOUT_ROUTES = ['disqus-auth', 'disqus-logout'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appHeader: __WEBPACK_IMPORTED_MODULE_2__components_app_app_header_app_header_vue__["a" /* default */],
    appHeaderNotification: __WEBPACK_IMPORTED_MODULE_9__components_app_app_header_notification_app_header_notification_vue__["b" /* default */],
    appSecondaryNav: __WEBPACK_IMPORTED_MODULE_3__components_app_app_secondary_nav_app_secondary_nav_vue__["a" /* default */],
    appMainNav: __WEBPACK_IMPORTED_MODULE_4__components_app_app_main_nav_app_main_nav_vue__["a" /* default */],
    appBottomNav: __WEBPACK_IMPORTED_MODULE_5__components_app_app_bottom_nav_app_bottom_nav_vue__["a" /* default */],
    appFooter: __WEBPACK_IMPORTED_MODULE_7__components_app_app_footer_app_footer_vue__["a" /* default */],
    appMobileMenu: __WEBPACK_IMPORTED_MODULE_6__components_app_app_mobile_menu_app_mobile_menu_vue__["a" /* default */],
    maintenanceNotification: __WEBPACK_IMPORTED_MODULE_10__components_maintenance_notification_maintenance_notification_vue__["a" /* default */],
    notificationItems: __WEBPACK_IMPORTED_MODULE_8__components_notification_items_notification_items_vue__["a" /* default */],
    searchBar: __WEBPACK_IMPORTED_MODULE_11__components_app_app_header_search_bar_search_bar_vue__["a" /* default */],
    sideNotification: __WEBPACK_IMPORTED_MODULE_12__components_generics_side_notification_side_notification_vue__["a" /* default */],
    navBrowseCategoriesOverlay: __WEBPACK_IMPORTED_MODULE_15__components_app_app_secondary_nav_nav_browse_categories_overlay_nav_browse_categories_overlay_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isStandalone: __WEBPACK_IMPORTED_MODULE_14__mixins_userAgent__["g" /* isStandalone */],
      isTransitioning: false
    };
  },

  watch: {
    $route: function $route() {
      var _this = this;

      setTimeout(function () {
        _this.isTransitioning = false;
      }, 1000);
    }
  },
  methods: {
    onBeforeLeave: function onBeforeLeave() {
      this.isTransitioning = true;
    },
    onAfterEnter: function onAfterEnter() {
      this.isTransitioning = false;
      window.scrollTo(0, 0);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasBanner', 'hasMaintenanceMessage', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred', 'liveUpdatesDisabled', 'mobileMenuOpened']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['sideNotificationLevel', 'sideNotificationText', 'sideNotificationOnCloseCallback', 'showNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('search', ['searchBarVisible']), {
    isSimpleLayout: function isSimpleLayout() {
      return SIMPLE_LAYOUT_ROUTES.includes(this.$route.name);
    },
    appModifiers: function appModifiers() {
      return {
        'app-layout': true,
        'app-layout--with-overflow': (this.currentPopup !== null || this.currentSmallPopup !== null) && this.isTransitioning,
        'app-layout--full-width': this.$route.meta.appContentFullWidth,
        'app-layout--bg-white': true
      };
    },
    headerModifiers: function headerModifiers() {
      return {
        'app-layout__header': true,
        'app-layout__header--secondary': true,
        'app-layout__header--error': !__WEBPACK_IMPORTED_MODULE_14__mixins_userAgent__["g" /* isStandalone */] && (this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled),
        'app-layout__header--notifications-widget-open': this.showNotificationsWidget
      };
    },
    contentModifiers: function contentModifiers() {
      return {
        'app-layout__content': true,
        'app-layout__content--secondary': !this.isSimpleLayout,
        'app-layout__content--simple': this.isSimpleLayout,
        'app-layout__content--error': !__WEBPACK_IMPORTED_MODULE_14__mixins_userAgent__["g" /* isStandalone */] && (this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled),
        'app-layout__content--with-overflow': this.$route.meta.appContentOverflowed,
        'app-layout__content--full-width': this.$route.meta.appContentFullWidth
      };
    },
    sideNotificationShouldDisplay: function sideNotificationShouldDisplay() {
      return this.sideNotificationLevel && this.sideNotificationText;
    }
  })
});

/***/ }),

/***/ "EyqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters_consts__ = __webpack_require__("OJH0");




 /* eslint-disable arrow-body-style, max-len */








var KEY_SHOULD_SHOW_TIMESPAN = 'should-show-timespan';
var KEY_SELECTED_ORDER = 'selected-order';
var KEY_SELECTED_TIMESPAN = 'selected-timespan';

var DEFAULT_NOTIFICATIONS = {
  data: [],
  page: 0,
  totalCount: -1,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    markReadIsBeingCalled: false,
    marketsToggle: null,
    myShares: null,
    mySharesReady: false,
    notifications: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_NOTIFICATIONS),
    notificationsToggle: false,
    orders: __WEBPACK_IMPORTED_MODULE_9__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_9__filters_consts__["b" /* TIMESPANS */],
    selectedOrder: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_ORDER, __WEBPACK_IMPORTED_MODULE_9__filters_consts__["a" /* ORDERS */][0]),
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_TIMESPAN, __WEBPACK_IMPORTED_MODULE_9__filters_consts__["c" /* AVAILABLE_TIMESPANS */].ALL),
    shouldShowTimespanFilter: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SHOULD_SHOW_TIMESPAN, true)
  },
  getters: {
    mySharesCount: function mySharesCount(state) {
      return state.myShares ? state.myShares.markets.length : 0;
    },
    mySharesTotalGainLoss: function mySharesTotalGainLoss(state) {
      if (state.myShares && state.myShares.markets) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default()(state.myShares.markets, __WEBPACK_IMPORTED_MODULE_7__utils_helpers__["J" /* marketUserGainLoss */]);
      }
      return 0;
    }
  },
  mutations: {
    setMarketsToggle: function setMarketsToggle(state, flag) {
      state.marketsToggle = flag;
    },
    setMyShares: function setMyShares(state, payload) {
      state.myShares = payload;
      state.mySharesReady = true;
    },
    setSummaryChartData: function setSummaryChartData(state, payload) {
      state.summaryChart = payload;
    },
    updateNotifications: function updateNotifications(state, payload) {
      var sourceNotifications = payload.data.notificationItems || [];
      sourceNotifications.forEach(function (el) {
        el.contentJson = typeof el.contentJson === 'string' ? JSON.parse(el.contentJson) : el.contentJson;
      });
      var data = state.notifications.data.concat(sourceNotifications);
      var page = payload.data.page;
      var totalCount = payload.data.totalItems;
      var canLoadMore = totalCount > data.length;

      state.notifications = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.notifications, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    resetNotifications: function resetNotifications(state) {
      state.notifications = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_NOTIFICATIONS);
    },
    updateMySharesFromNotification: function updateMySharesFromNotification(state, data) {
      if (state.myShares && state.myShares.markets) {
        state.myShares = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.myShares, {
          markets: state.myShares.markets.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["c" /* updateMySharesMarket */])(market, data);
          })
        });
      }
    },
    updateMySharesContractFromNotification: function updateMySharesContractFromNotification(state, data) {
      if (state.myShares && state.myShares.markets) {
        state.myShares = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.myShares, {
          markets: state.myShares.markets.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    toggleNotifications: function toggleNotifications(state) {
      state.notificationsToggle = !state.notificationsToggle;
    },
    selectOrder: function selectOrder(state, sort) {
      var selectedOrder = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(state.orders, { sort: sort });
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_9__filters_consts__["d" /* DEFAULT_TIMESPANS */][sort] || __WEBPACK_IMPORTED_MODULE_9__filters_consts__["c" /* AVAILABLE_TIMESPANS */].EMPTY;
      var shouldShowTimespan = __WEBPACK_IMPORTED_MODULE_9__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(selectedOrder.sort) !== -1;
      state.selectedOrder = selectedOrder;
      state.selectedTimespan = selectedTimespan;
      state.shouldShowTimespanFilter = shouldShowTimespan;
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SHOULD_SHOW_TIMESPAN, shouldShowTimespan);
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_ORDER, selectedOrder);
    },
    selectTimespan: function selectTimespan(state, parameter) {
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(state.timespans, { parameter: parameter });
      state.selectedTimespan = selectedTimespan;
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
    },
    setMarkReadBeingCalled: function setMarkReadBeingCalled(state, value) {
      state.markReadIsBeingCalled = value;
    }
  },
  actions: {
    getMyShares: function getMyShares(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getMyShares(state.selectedOrder.sort, state.selectedTimespan.parameter).then(function (response) {
        commit('setMyShares', response.data);
        return response.data;
      });
    },
    resetNotifications: function resetNotifications(_ref2) {
      var commit = _ref2.commit;

      commit('resetNotifications');
    },
    getNotifications: function getNotifications(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.notifications.canLoadMore) {
        var page = state.notifications.page + 1;
        return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getNotifications(page).then(function (response) {
          commit('updateNotifications', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
    },
    markNotificationsAsRead: function markNotificationsAsRead(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state;

      if (state.markReadIsBeingCalled) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});

      commit('setMarkReadBeingCalled', true);
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.putNotifications().then(function (response) {
        commit('setMarkReadBeingCalled', false);
        return response.data;
      }).catch(function (error) {
        commit('setMarkReadBeingCalled', false);
        throw error;
      });
    },
    updateMySharesFromNotification: function updateMySharesFromNotification(_ref5, payload) {
      var commit = _ref5.commit;

      commit('updateMySharesFromNotification', payload);
    },
    updateMySharesContractFromNotification: function updateMySharesContractFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateMySharesContractFromNotification', payload);
    },
    selectOrder: function selectOrder(_ref7, sort) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('selectOrder', sort);
      return dispatch('getMyShares');
    },
    selectTimespan: function selectTimespan(_ref8, timespan) {
      var state = _ref8.state,
          dispatch = _ref8.dispatch,
          commit = _ref8.commit;

      commit('selectTimespan', timespan);
      return dispatch('getMyShares');
    },
    toggleNotifications: function toggleNotifications(_ref9) {
      var commit = _ref9.commit;

      commit('toggleNotifications');
    },
    setMarketsToggle: function setMarketsToggle(_ref10, flag) {
      var commit = _ref10.commit;

      commit('setMarketsToggle', flag);
    }
  }
});

/***/ }),

/***/ "F+2w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-tile-view"},_vm._l((_vm.documentData.displayDocuments),function(document,index){return _c('document-to-review',{key:index,attrs:{"title":document.displayDocumentDescription,"link":document.displayDocumentPath,"num":0,"markOpened":false,"showLabel":_vm.documentData.settingsShowOpenStatus === 1}},[_c('span',{attrs:{"slot":"suffix"},slot:"suffix"},[_vm._v("\n      "+_vm._s(document.displayDocumentTitle)+"\n    ")])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F/Vy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.title)?_c('div',{staticClass:"podcasts__header"},[_c('div',{staticClass:"podcasts__header-title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(_vm.showArrows)?_c('div',{staticClass:"podcasts__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"podcasts__content",on:{"mouseenter":_vm.stopSwiper,"mouseleave":_vm.startSwiper}},[_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.tracks),function(track,index){return _c('swiper-slide',{key:index,staticClass:"podcasts__slide"},[(track.type === _vm.PODCAST.POLITICAN_TRADER)?_c('iframe',{style:(_vm.getTrackFrameStyle(track, index)),attrs:{"width":"100%","height":_vm.getTrackHeight(track, index),"scrolling":"no","frameborder":"no","allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":"","oallowfullscreen":"","msallowfullscreen":"","src":_vm.getPoliticanTraderUrl()},on:{"load":_vm.onTrackFrameLoad}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.SOUNDCLOUD)?_c('iframe',{style:(_vm.getTrackFrameStyle(track, index)),attrs:{"width":"100%","height":_vm.getTrackHeight(track, index),"scrolling":"no","frameborder":"no","src":_vm.getSoundCloudUrl(track.id)},on:{"load":_vm.onTrackFrameLoad}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.APPLE)?_c('iframe',{style:(_vm.getTrackFrameStyle(track, index)),attrs:{"width":"100%","height":_vm.getTrackHeight(track, index),"scrolling":"no","frameborder":"no","src":_vm.getAppleUrl(track.id)},on:{"load":_vm.onTrackFrameLoad}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.STITCHER)?_c('iframe',{style:(_vm.getTrackFrameStyle(track, index)),attrs:{"width":"100%","height":_vm.getTrackHeight(track, index),"scrolling":"no","frameborder":"no","src":_vm.getStitcherUrl(track.id)},on:{"load":_vm.onTrackFrameLoad}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.ITUNES)?_c('div',{staticClass:"podcasts__iframe podcasts__iframe--itunes"},[_c('iframe',{style:(_vm.styleItunesIframe),attrs:{"scrolling":"no","frameborder":"no","src":_vm.getItunesUrl(track.id)},on:{"load":_vm.onTrackFrameLoad}})]):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.BACKTRACKS)?_c('div',{staticClass:"podcasts__backtrack",attrs:{"data-bt-embed":_vm.getBacktracksUrl(track.id),"data-bt-theme":"dark","data-bt-show-description":"false","data-bt-show-comments":"false","data-bt-show-art-cover":"false"}}):_vm._e()])}),1),_vm._v(" "),(false)?_c('div',{staticClass:"podcasts__link-wrapper"},[_c('strong',[_vm._v("Special Offer:")]),_vm._v(" "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"podcasts__link",attrs:{"href":"https://lp.stratfor.com/predictitoffer"}},[_vm._v("\n      Access Stratfor Worldview - Geopolitical Insights on What Moves Political Markets")])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F06B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F76i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maintenance.isMaintenanceEnabled)?_c('div',{staticClass:"maintenance-notification"},[_c('img',{staticClass:"maintenance-notification__logo",attrs:{"src":__webpack_require__("Kcew")}}),_vm._v(" "),_c('p',{staticClass:"maintenance-notification__info"},[(_vm.maintenance.maintenanceMessage)?[_vm._v("\n      "+_vm._s(_vm.maintenance.maintenanceMessage)+"\n    ")]:[_vm._v("\n      We are currently undergoing scheduled maintenance.\n    ")]],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FBEZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FBuH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-empty-state",class:{ 'market-empty-state--small': _vm.small }},[_c('div',{staticClass:"market-empty-state__icon-circle"},[_c('img',{staticClass:"market-empty-state__icon",attrs:{"src":_vm.iconSrc,"alt":_vm.icon}})]),_vm._v(" "),_c('div',{staticClass:"market-empty-state__content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FEAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tradeOptions.contractId)?_c('div',{class:_vm.classModifiers},[_c('purchase-journey-sushi',_vm._b({attrs:{"closeJourneyAfterSuccess":_vm.closeJourneyAfterSuccess,"market":_vm.market,"kind":_vm.layoutKind,"showContractCharts":_vm.showContractCharts,"showRelatedContracts":_vm.showRelatedContracts,"showOrderSlip":_vm.showOrderSlip,"showOwnershipAndOrdersBar":_vm.showOwnershipAndOrdersBar,"disablePurchaseOfferWatchers":_vm.disablePurchaseOfferWatchers}},'purchase-journey-sushi',_vm.tradeOptions,false))],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FGQd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQ3MF8zODk4KSI+CjxwYXRoIGQ9Ik0yMi41ODk4IDBDMjIuOTYzOCAwLjAwMSAyMy4zMjE5IDAuMTUwMDYzIDIzLjU4NTkgMC40MTQwNjJDMjMuODQ5OSAwLjY3ODA2MiAyMy45OTkgMS4wMzYxNiAyNCAxLjQxMDE2VjIyLjU4OThDMjMuOTk4IDIyLjk2MjggMjMuODQ5IDIzLjMyMSAyMy41ODUgMjMuNTg1QzIzLjMyMSAyMy44NDkgMjIuOTYzOCAyMy45OTcgMjIuNTkwOCAyMy45OTlIMS40MTExM0MxLjAzODEzIDIzLjk5OCAwLjY4MDAzOSAyMy44NDkgMC40MTUwMzkgMjMuNTg1QzAuMTUwMDM5IDIzLjMyMSAwLjAwMiAyMi45NjI4IDAgMjIuNTg5OFYxLjQxMDE2QzAgMS4wMzcxNiAwLjE1MDAzOSAwLjY3OTAzOSAwLjQxNTAzOSAwLjQxNTAzOUMwLjY4MDAzOSAwLjE1MDAzOSAxLjAzNzEzIDAuMDAxIDEuNDExMTMgMEgyMi41ODk4Wk00IDRMMTAuMDQ3OSAxMi4yMDQxTDQuMzE2NDEgMTlINi43Njk1M0wxMS4xOTYzIDEzLjc1NjhMMTUuMDYxNSAxOUgyMEwxMy42OTYzIDEwLjM1MzVMMTkuMDU0NyA0SDE2LjYwMDZMMTIuNTU4NiA4Ljc5Mzk1TDkuMDYzNDggNEg0Wk04LjMyMzI0IDUuNDQ1MzFMMTcuMDk4NiAxNy40Nzc1SDE1Ljc0MDJMNi44NjYyMSA1LjQ0NTMxSDguMzIzMjRaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzQ3MF8zODk4Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ "FGdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  multipleEmails: 'Invalid email',
  email: 'Enter a valid email',
  sameAs: 'Doesn’t Match',
  minLength: 'At least %v characters',
  maxLength: '%v characters maximum',
  exactLength: 'Exactly %v digits required',
  required: 'Is required',
  alphaNum: 'Only letters and numbers are allowed',
  hasOneLower: 'At least one lowercase letter',
  hasOneUpper: 'At least one uppercase letter',
  hasOneDigit: 'At least one number',
  validateIsAdult: 'You must be at least 18 years old',
  alpha: 'Only letters are allowed',
  onlyCharacters: 'Only letters are allowed',
  validateUSZipCode: 'Enter a valid code',
  validateCardNumber: '',
  validateSSN: '4 digits are required',
  numeric: 'Numbers only',
  price: 'Invalid amount',
  between: 'Amount must be between $%v1 and $%v2',
  minValue: 'Minimum amount is $%v',
  minLengthDigit: 'Min. %v digits',
  maxLengthDigit: 'Max. %v digits',
  minValueDeposit: 'Minimum amount is $%v',
  maxValueDeposit: 'Invalid amount',
  usernameIsValid: 'Enter a valid username',
  greaterThan: 'Value must be greater than %v',
  noSpaces: 'No spaces',
  phone: 'Enter a valid phone number',
  phoneOptional: 'Enter a valid phone number'
});

/***/ }),

/***/ "FHMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_ssn_info_upload_js__ = __webpack_require__("MeDD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05703b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_ssn_info_upload_vue__ = __webpack_require__("X6LQ");
function injectStyle (ssrContext) {
  __webpack_require__("1b1z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_ssn_info_upload_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05703b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_ssn_info_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FITW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{
        id: 1,
        text: 'The most exciting engine in terms of political opinion',
        author: 'James Carville, Political Pundit'
      }],
      swiperOptions: {
        autoplay: 3000,
        direction: 'horizontal'
      }
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  }
});

/***/ }),

/***/ "FM5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_twitter_timeline_js__ = __webpack_require__("tumW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d85e700_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twitter_timeline_vue__ = __webpack_require__("7RdL");
function injectStyle (ssrContext) {
  __webpack_require__("OFB4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_twitter_timeline_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d85e700_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twitter_timeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FMYX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('transition',{attrs:{"name":"slide"}},[_c('nav-browse',{key:(_vm.rotationIndex + "-" + _vm.isLayoutMobile)})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FOkx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "FP0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getOrderBook: function getOrderBook(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Trade/' + contractId + '/OrderBook');
  },
  postConfirmTrade: function postConfirmTrade(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/ConfirmTrade', payload); // Confirm trade create order for confirmation
  },
  postSubmitTrade: function postSubmitTrade(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/SubmitTrade', payload); // Submit trade create order without confirmation
  },
  postCancelAllOffers: function postCancelAllOffers(contractId, payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/CancelAllOffers/' + contractId, payload);
  },
  postCancelOffer: function postCancelOffer(offerId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/CancelOffer/' + offerId);
  },
  getOrderBookTradeInfo: function getOrderBookTradeInfo(contractId, tradeType, price) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Trade/' + contractId + '/OrderBook/' + tradeType + '/' + price);
  }
});

/***/ }),

/***/ "FQlF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FSWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_balance_history_item_js__ = __webpack_require__("TNLE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c677b91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_balance_history_item_vue__ = __webpack_require__("vRZU");
function injectStyle (ssrContext) {
  __webpack_require__("LujD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_balance_history_item_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c677b91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_balance_history_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FUh1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-combined-login"},[_c('account-login'),_vm._v(" "),_c('account-login-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FV5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FaNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notifications_list_notifications_list_vue__ = __webpack_require__("R/N+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    notificationsList: __WEBPACK_IMPORTED_MODULE_4__components_notifications_list_notifications_list_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Notifications'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile'])),
  beforeDestroy: function beforeDestroy() {
    this.clearAllNotifications();
  }
});

/***/ }),

/***/ "FcIm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "FezS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_forgotten_password_js__ = __webpack_require__("wfyV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32690f28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_forgotten_password_vue__ = __webpack_require__("YQaP");
function injectStyle (ssrContext) {
  __webpack_require__("Eu+w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_forgotten_password_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32690f28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_forgotten_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ffa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['maintenance']))
});

/***/ }),

/***/ "FlLb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Fm43":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkwMjVfMTk4MDUpIj4KPHBhdGggZD0iTTEgM0gxNSIgc3Ryb2tlPSIjNTU1NzVBIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuNSAxSDYuNUM2LjIzNDc4IDEgNS45ODA0MyAxLjEwNTM2IDUuNzkyODkgMS4yOTI4OUM1LjYwNTM2IDEuNDgwNDMgNS41IDEuNzM0NzggNS41IDJWM0gxMC41VjJDMTAuNSAxLjczNDc4IDEwLjM5NDYgMS40ODA0MyAxMC4yMDcxIDEuMjkyODlDMTAuMDE5NiAxLjEwNTM2IDkuNzY1MjIgMSA5LjUgMVoiIHN0cm9rZT0iIzU1NTc1QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjUgMTEuNVY2LjUiIHN0cm9rZT0iIzU1NTc1QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05LjUgMTEuNVY2LjUiIHN0cm9rZT0iIzU1NTc1QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi41NzY3IDE0LjA4MjdDMTIuNTU1OSAxNC4zMzI3IDEyLjQ0MTkgMTQuNTY1OSAxMi4yNTczIDE0LjczNThDMTIuMDcyNyAxNC45MDU3IDExLjgzMDkgMTUgMTEuNTggMTVINC40MjA2N0M0LjE2OTc1IDE1IDMuOTI3OTggMTQuOTA1NyAzLjc0MzM2IDE0LjczNThDMy41NTg3NCAxNC41NjU5IDMuNDQ0NzQgMTQuMzMyNyAzLjQyNCAxNC4wODI3TDIuNSAzSDEzLjVMMTIuNTc2NyAxNC4wODI3WiIgc3Ryb2tlPSIjNTU1NzVBIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MDI1XzE5ODA1Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ "FmzU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fn63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'submit'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "Fokc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FvKT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FwJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-my-markets"},[_c('div',{staticClass:"sushi-my-markets__toolbar"},[_c('dashboard-market-filters',{staticClass:"sushi-my-markets__toolbar-filters"}),_vm._v(" "),_c('dashboard-markets-toggle',{staticClass:"sushi-my-markets__toolbar-toggle"})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('portfolio-my-markets',{attrs:{"sushi":true}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G+2P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_site_alert_v2_js__ = __webpack_require__("Kj7L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c3a799_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_site_alert_v2_vue__ = __webpack_require__("Eu6+");
function injectStyle (ssrContext) {
  __webpack_require__("J0X6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_site_alert_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c3a799_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_site_alert_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G+wi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_pending_request_deposit_pending_request_deposit_vue__ = __webpack_require__("o/Tx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__["a" /* default */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__["a" /* default */],
    pendingRequestDeposit: __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_pending_request_deposit_pending_request_deposit_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.getPendingDeposits().then(function () {
      _this.isComponentReady = true;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['pendingDepositsRequests'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getPendingDeposits']), {
    onComplete: function onComplete() {
      this.getPendingDeposits();
    }
  })
});

/***/ }),

/***/ "G/7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_orders_js__ = __webpack_require__("U9Lo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4360c9c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_orders_vue__ = __webpack_require__("/u+B");
function injectStyle (ssrContext) {
  __webpack_require__("ZKfp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_orders_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4360c9c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G/BR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isDebugOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_hasIn__ = __webpack_require__("RfZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_hasIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_hasIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__("YaEn");




function isDebugOn() {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_hasIn___default()(__WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */], ['currentRoute', 'query', 'console']) || "production" === 'development';
}

function info() {
  if (isDebugOn()) {
    var _console;

    (_console = console).info.apply(_console, arguments); // eslint-disable-line no-console
  }
}

function warn() {
  if (isDebugOn()) {
    var _console2;

    (_console2 = console).warn.apply(_console2, arguments); // eslint-disable-line no-console
  }
}

function error() {
  if (isDebugOn()) {
    var _console3;

    (_console3 = console).error.apply(_console3, arguments); // eslint-disable-line no-console
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  info: info,
  warn: warn,
  error: error
});

/***/ }),

/***/ "G/gM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G1f8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_common_betslip_js__ = __webpack_require__("n4JO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b04c414_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_common_betslip_vue__ = __webpack_require__("e8xD");
function injectStyle (ssrContext) {
  __webpack_require__("7iEX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_common_betslip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b04c414_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_common_betslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G3f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"header-search",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('label',{staticClass:"header-search__label"},[_c('span',{staticClass:"header-search__visually-hidden"},[_vm._v("Search")]),_vm._v(" "),_c('button',{staticClass:"header-search__icon",attrs:{"type":"submit","aria-label":"Search"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"header-search__input",attrs:{"id":"search-query","name":"search-query","type":"search","placeholder":"Search"},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G8ry":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GB5W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GH+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GHbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headerHeight: 0,
      headerHeightInterval: null,
      debouncedUpdateHeaderHeight: null
    };
  },

  methods: {
    updateHeaderHeight: function updateHeaderHeight() {
      var header = document.querySelector('.app-layout__header');
      if (header) {
        this.headerHeight = header.offsetHeight;
      }
    }
  },
  mounted: function mounted() {
    this.debouncedUpdateHeaderHeight = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this.updateHeaderHeight, 200);
    this.debouncedUpdateHeaderHeight();
    window.addEventListener('resize', this.debouncedUpdateHeaderHeight);
    this.headerHeightInterval = setInterval(this.debouncedUpdateHeaderHeight, 5000);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.debouncedUpdateHeaderHeight);
    if (this.headerHeightInterval) {
      clearInterval(this.headerHeightInterval);
    }
  }
});

/***/ }),

/***/ "GMue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String,
      required: true
    },
    more: {
      type: Boolean,
      default: false
    },
    href: {
      type: [Object, String]
    },
    showBottom: {
      type: Boolean,
      default: true
    },
    away: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      open: false
    };
  },

  computed: {
    moreModifier: function moreModifier() {
      return { 'insight-panel__link--more': this.more };
    },
    openModifier: function openModifier() {
      return { 'insight-panel--open': this.open };
    }
  },
  methods: {
    onClick: function onClick() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.href) === 'object') {
        this.$router.push(this.href);
      } else if (this.away) {
        window.open(this.href, '_blank');
      }
    }
  }
});

/***/ }),

/***/ "GOBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_account_social_avatar_account_social_avatar_vue__ = __webpack_require__("ROsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png__ = __webpack_require__("FcIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png__);

/* eslint-disable no-unused-vars */






var LEVEL_BRONZE_THRESHOLD = 10;
var LEVEL_SILVER_THRESHOLD = 135;
var LEVEL_GOLD_THRESHOLD = 915;
var LEVEL_PLATINUM_THRESHOLD = 4950;
var LEVEL_DIAMOND_THRESHOLD = 30000;
var LEVEL_BLACK_THRESHOLD = 375000;

var LEVEL_MAP = {
  LEVEL_LOADING: { num: 100, text: '', progressColor: 'transparent', currentColor: 'transparent' },
  LEVEL_BLUE_THRESHOLD: { num: 1, text: 'Novice', next: LEVEL_BRONZE_THRESHOLD, progressColor: '#e2a779', currentColor: '#0c96ae' },
  LEVEL_BRONZE_THRESHOLD: { num: 2, text: 'Prognosticator', next: LEVEL_SILVER_THRESHOLD, progressColor: '#cdcdcd', currentColor: '#e2a779' },
  LEVEL_SILVER_THRESHOLD: { num: 3, text: 'Diviner', next: LEVEL_GOLD_THRESHOLD, progressColor: '#fadf7c', currentColor: '#cdcdcd' },
  LEVEL_GOLD_THRESHOLD: { num: 4, text: 'Soothsayer', next: LEVEL_PLATINUM_THRESHOLD, progressColor: '#4f4e4e', currentColor: '#fadf7c' },
  LEVEL_PLATINUM_THRESHOLD: { num: 5, text: 'Fortune Teller', next: LEVEL_DIAMOND_THRESHOLD, progressColor: '#88b9ce', currentColor: '#4f4e4e' },
  LEVEL_DIAMOND_THRESHOLD: { num: 6, text: 'Prophet', next: LEVEL_BLACK_THRESHOLD, progressColor: '#000000', currentColor: '#88b9ce' },
  LEVEL_BLACK_THRESHOLD: { num: 7, text: 'Oracle', next: null, currentColor: '#000000' }
};

var ACTIVE_COLOR = '#07a0bb';
var ACTIVE_ROUTES = ['portfolio'];

var socialLevelMixin = {
  components: {
    accountSocialAvatar: __WEBPACK_IMPORTED_MODULE_3__components_account_account_social_avatar_account_social_avatar_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['profileDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData']), {
    // computed properties are in user context
    level: function level() {
      if (this.isSocialReady) {
        return this.getLevelByPredictions(this.profileDetail.profitablePredictions);
      }
      return LEVEL_MAP.LEVEL_LOADING;
    },
    activeFor: function activeFor() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.userData.dateRegistered).fromNow(true);
    },
    toNextLevel: function toNextLevel() {
      var next = this.level.next;
      if (next !== null) return (next - this.profileDetail.profitablePredictions).toLocaleString();
      return null;
    },
    progressPercentage: function progressPercentage() {
      var next = this.level.next;
      var predictionsNormalized = 100 * this.profileDetail.profitablePredictions;
      if (next !== null) return Math.floor(predictionsNormalized / next);
      return 0;
    },
    progressColor: function progressColor() {
      return this.level.progressColor ? this.level.progressColor : null;
    },
    progressInfoText: function progressInfoText() {
      return 'You are ' + this.progressPercentage + '% of the way to Level ' + (this.level.num + 1);
    },
    levelColor: function levelColor() {
      return this.level.currentColor;
    },
    levelColorWithRespectToNav: function levelColorWithRespectToNav() {
      if (this.$route && ACTIVE_ROUTES.includes(this.$route.name)) {
        return ACTIVE_COLOR;
      }
      return this.levelColor;
    },
    isTopLevelTrader: function isTopLevelTrader() {
      return this.toNextLevel === null;
    },
    userAvatar: function userAvatar() {
      if (this.isSocialReady && this.userData.avatarImage) {
        return this.userData.avatarImage;
      }
      return __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png___default.a;
    },
    isSocialReady: function isSocialReady() {
      return this.userData && this.userData.userName !== undefined && this.profileDetail && this.profileDetail.userGuid !== undefined;
    }
  }),
  methods: {
    getProgressInfoTextForLevel: function getProgressInfoTextForLevel(num, profitablePredictions) {
      var nextLevel = this.getLevelByNumber(num);
      var predictionsNormalized = 100 * profitablePredictions;
      if (num === LEVEL_MAP.LEVEL_BLACK_THRESHOLD.num) {
        return "You've reached Top Level.";
      }

      var progressPercentage = Math.floor(predictionsNormalized / nextLevel.next);
      return 'You are ' + progressPercentage + '% of the way to Level ' + (num + 1);
    },
    getThresholdByNumber: function getThresholdByNumber(num) {
      if (num === LEVEL_MAP.LEVEL_BLACK_THRESHOLD) return '-';
      var previousLevel = this.getLevelByNumber(num - 1);
      var currentLevel = this.getLevelByNumber(num);

      return currentLevel.next - previousLevel.next;
    },
    getLevelByNumber: function getLevelByNumber(num) {
      if (num === LEVEL_MAP.LEVEL_BLUE_THRESHOLD.num) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_BRONZE_THRESHOLD.num) return LEVEL_MAP.LEVEL_BRONZE_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_SILVER_THRESHOLD.num) return LEVEL_MAP.LEVEL_SILVER_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_GOLD_THRESHOLD.num) return LEVEL_MAP.LEVEL_GOLD_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD.num) return LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD.num) return LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD;
      return LEVEL_MAP.LEVEL_BLACK_THRESHOLD;
    },
    getLevelByPredictions: function getLevelByPredictions(threshold) {
      if (!threshold) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (threshold < LEVEL_BRONZE_THRESHOLD) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (threshold < LEVEL_SILVER_THRESHOLD) return LEVEL_MAP.LEVEL_BRONZE_THRESHOLD;
      if (threshold < LEVEL_GOLD_THRESHOLD) return LEVEL_MAP.LEVEL_SILVER_THRESHOLD;
      if (threshold < LEVEL_PLATINUM_THRESHOLD) return LEVEL_MAP.LEVEL_GOLD_THRESHOLD;
      if (threshold < LEVEL_DIAMOND_THRESHOLD) return LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD;
      if (threshold < LEVEL_BLACK_THRESHOLD) return LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD;
      return LEVEL_MAP.LEVEL_BLACK_THRESHOLD;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (socialLevelMixin);

/***/ }),

/***/ "GPEM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-discussion-widget"},[_c('div',{staticClass:"sushi-market-discussion-widget__title"},[_c('div',{staticClass:"sushi-market-discussion-widget__title-text"},[_vm._v("Discussion")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-discussion-widget__title-icon",on:{"click":_vm.toggleDiscussionPin}})]),_vm._v(" "),(!_vm.showInfoOnly)?_c('div',{staticClass:"sushi-market-discussion-widget__comments"},[_c('disqus',{attrs:{"disqusId":_vm.market.disqus_Identifier,"title":_vm.market.disqus_Title,"auth":_vm.market.disqus_UserAuth,"url":_vm.market.disqus_Url,"previous":_vm.market.disqus_PrevThreadID,"next":_vm.market.disqus_NextThreadID,"total":_vm.market.disqus_ArchivedCommentsTotal,"marketId":_vm.market.marketId}})],1):_c('div',{staticClass:"sushi-market-discussion-widget__info"},[_vm._v("\n    The Discussion Widget lets you keep the conversation going while you browse the market.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GR9s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GSOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_v2_button_price_button_price_vue__ = __webpack_require__("al65");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { buttonPrice: __WEBPACK_IMPORTED_MODULE_1__components_market_v2_button_price_button_price_vue__["a" /* default */] },

  props: {
    // button-price content
    price: { type: Number, default: 0 },
    text: { type: String, required: true },
    win: { default: null },
    sell: { default: null },

    // visual variant: 'buy-yes' | 'sell-yes' | 'buy-no' | 'sell-no'
    variant: { type: String, required: true },

    // active / selection state
    isActive: { type: Boolean, default: false },
    isOn: { type: Boolean, default: false },
    operationValue: { type: String, default: null },

    // sell-disabled guard
    saleDisabled: { type: Boolean, default: false },
    disabledTooltip: { type: String, default: "You don't have any shares available to sell." }
  },

  computed: {
    buttonClass: function buttonClass() {
      var _ref;

      return _ref = {
        'market-button-direction': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--' + this.variant, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--active', this.isActive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--on', this.isOn), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--off', !this.isOn), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--off-yes', this.operationValue === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--off-no', this.operationValue === 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--sale-disabled', this.saleDisabled), _ref;
    }
  },

  methods: {
    onClick: function onClick() {
      if (!this.saleDisabled) {
        this.$emit('click');
      }
    }
  }
});

/***/ }),

/***/ "GVWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_element_js__ = __webpack_require__("wWzM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52307cf3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_element_vue__ = __webpack_require__("iuvl");
function injectStyle (ssrContext) {
  __webpack_require__("rreX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_element_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52307cf3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_element_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GY5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GZXJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _isStandalone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _isIos; });
/* unused harmony export isMacOs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _isWindows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _isAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _isIE; });
/* unused harmony export isEdge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _iOSWrapper; });
/* unused harmony export androidWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _isTablet; });
/* unused harmony export getOrientation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js__ = __webpack_require__("GCDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ua_parser_js__);


var uaParsed = __WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default()(window.navigator.userAgent);
var _isStandalone = !!window.navigator.standalone;

var _isIos = uaParsed && uaParsed.os && uaParsed.os.name === 'iOS';

var _isMacOs = uaParsed && uaParsed.os && uaParsed.os.name === 'Mac OS';

var _isWindows = uaParsed && uaParsed.os && uaParsed.os.name.includes('Windows');

var _isAndroid = uaParsed && uaParsed.os && uaParsed.os.name === 'Android';

var _isIE = uaParsed && uaParsed.browser && (uaParsed.browser.name === 'IE' || uaParsed.browser.name === 'IEMobile');

var _isEdge = uaParsed && uaParsed.browser && uaParsed.browser.name === 'Edge';

var _iOSWrapper = window.navigator.userAgent && window.navigator.userAgent.includes('iOSWrapper');

var _androidWrapper = window.navigator.userAgent && window.navigator.userAgent.includes('AndroidWrapper');


var _isTablet = uaParsed && uaParsed.device && uaParsed.device.type === 'tablet';


var _getOrientation = function _getOrientation() {
  if (window.screen.orientation) {
    if (window.screen.orientation.type.includes('portrait')) return 'portrait';
    return 'landscape';
  }
  if (Math.abs(window.orientation) === 90) return 'landscape';
  return 'portrait';
};


var userAgentMixin = {
  computed: {
    isTablet: function isTablet() {
      return _isTablet;
    },
    isWindows: function isWindows() {
      return _isWindows;
    },
    isIos: function isIos() {
      return _isIos;
    },
    isMacOs: function isMacOs() {
      return _isMacOs;
    },
    isStandalone: function isStandalone() {
      return _isStandalone;
    },
    isAndroid: function isAndroid() {
      return _isAndroid;
    },
    isIE: function isIE() {
      return _isIE;
    },
    iOSWrapper: function iOSWrapper() {
      return _iOSWrapper;
    },
    isEdge: function isEdge() {
      return _isEdge;
    },
    androidWrapper: function androidWrapper() {
      return _androidWrapper;
    },
    isWrapperApp: function isWrapperApp() {
      return this.androidWrapper || this.iOSWrapper;
    },
    version: function version() {
      return '1.0.67';
    }
  },
  methods: {
    getWindowSize: function getWindowSize() {
      return [Math.min(document.documentElement.clientWidth, window.innerWidth || 0), Math.min(document.documentElement.clientHeight, window.innerHeight || 0)];
    },
    getOrientation: function getOrientation() {
      return _getOrientation();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userAgentMixin);

/***/ }),

/***/ "Gcrh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__ = __webpack_require__("dDJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_winner_v2_market_winner_v2_vue__ = __webpack_require__("q1K7");









var MAX_CONTRACTS_NUM = 10;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'standalone'
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketContractInfoV2: __WEBPACK_IMPORTED_MODULE_6__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["a" /* default */],
    marketWinnerV2: __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_winner_v2_market_winner_v2_vue__["a" /* default */]
  },
  data: function data() {
    return {
      ready: false,
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: __WEBPACK_IMPORTED_MODULE_6__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["b" /* MARKET_CONTRACT_INFO_VALUES_LAYOUT */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['market', 'relatedProducts', 'reloadHistoryToggle']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'product-history-sushi': true
      }, 'product-history-sushi--' + this.type, this.type);
    }
  }),
  watch: {
    market: {
      handler: 'marketHandler',
      immediate: true
    },
    reloadHistoryToggle: function reloadHistoryToggle(val) {
      this.reloadHistory();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getRelatedProducts']), {
    itemLink: function itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      };
    },
    getContracts: function getContracts(item) {
      if (item.contractWinner) {
        return [item.contractWinner].map(function (i) {
          return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](i);
        });
      }
      return (item.contracts || []).slice(0, 2).map(function (i) {
        return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](i);
      });
    },
    contractName: function contractName(item) {
      if (item.marketType !== 0) {
        return item.contractName;
      }
      var type = item.tradeType;
      return type === 0 || type === 2 ? 'No' : 'Yes';
    },
    marketHandler: function marketHandler(value) {
      var _this = this;

      if (value) {
        this.loaderAdd(document.body);
        this.getRelatedProducts(this.market.marketId).then(function () {
          _this.ready = true;
          _this.loaderRemove(document.body);
        }).catch(function () {
          _this.ready = true;
          _this.loaderRemove(document.body);
        });
      }
    },
    reloadHistory: function reloadHistory() {
      var _this2 = this;

      this.loaderAdd(document.body);
      this.getRelatedProducts(this.market.marketId).then(function () {
        _this2.ready = true;
        _this2.loaderRemove(document.body);
      }).catch(function () {
        _this2.ready = true;
        _this2.loaderRemove(document.body);
      });
    },
    imageStyleModifiers: function imageStyleModifiers(item) {
      return {
        'background-image': 'url(\'' + item.marketImageUrl + '\')'
      };
    }
  })
});

/***/ }),

/***/ "Ge07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[_c('fieldset',{staticClass:"settings-option-switch__fieldset"},[_c('div',{staticClass:"settings-option-switch__legend-wrapper"},[_c('legend',{staticClass:"settings-option-switch__legend"},[_vm._v(_vm._s(_vm.obj.info))])]),_vm._v(" "),_c('div',{staticClass:"settings-option-switch__options"},_vm._l((_vm.obj.options),function(value){return _c('label',{key:value.key,staticClass:"settings-option-switch__option",class:{ 'settings-option-switch__option--disabled': _vm.isOptionDisabled(value) }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelValue),expression:"modelValue"}],attrs:{"type":"radio","name":_vm.obj.key,"disabled":_vm.isOptionDisabled(value)},domProps:{"value":value.key,"checked":value.key === _vm.modelValue,"checked":_vm._q(_vm.modelValue,value.key)},on:{"change":[function($event){_vm.modelValue=value.key},function($event){return _vm.change(value.key)}]}}),_vm._v(" "),_c('span',{staticClass:"settings-option-switch__label-text"},[_vm._v(_vm._s(value.info))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GeN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-numeric-sushi",on:{"click":function($event){$event.stopPropagation();return _vm.outsideClick($event)}}},[_c('div',{staticClass:"keyboard-numeric-sushi__content"},[_c('div',{staticClass:"keyboard-numeric-sushi__numbers"},[_c('div',{staticClass:"keyboard-numeric-sushi__row"},[_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('1')}}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('2')}}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('3')}}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('4')}}},[_vm._v("4")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('5')}}},[_vm._v("5")])]),_vm._v(" "),_c('div',{staticClass:"keyboard-numeric-sushi__row"},[_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('6')}}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('7')}}},[_vm._v("7")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('8')}}},[_vm._v("8")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('9')}}},[_vm._v("9")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric-sushi__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('0')}}},[_vm._v("0")])])]),_vm._v(" "),_c('div',{staticClass:"keyboard-numeric-sushi__options"},[_c('button',{staticClass:"keyboard-numeric-sushi__key keyboard-numeric-sushi__key--backspace",on:{"click":function($event){$event.stopPropagation();return _vm.backspaceClick($event)}}},[_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-numeric-sushi__key--backspace-image"},[_c('span',{staticClass:"keyboard-numeric-sushi__key--backspace-text"},[_vm._v("x")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GeXy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xMC41NzkgMTQuMjNsMy42MzctMi4wNjctMy42MzctMi4wNzN2NC4xNHpNMjIuNTkgMEgxLjQxMUMxLjAzNy4wMDEuNjguMTUuNDE1LjQxNS4xNS42NzkgMCAxLjAzNyAwIDEuNDF2MjEuMThjLjAwMi4zNzMuMTUuNzMxLjQxNS45OTVzLjYyMy40MTMuOTk2LjQxNGgyMS4xOGMuMzczLS4wMDIuNzMtLjE1Ljk5NC0uNDE0cy40MTMtLjYyMi40MTUtLjk5NVYxLjQxYy0uMDAxLS4zNzQtLjE1LS43MzItLjQxNC0uOTk2UzIyLjk2NC4wMDEgMjIuNTkgMHptLTMuOTE4IDE1LjUzNGMtLjA3OS4yOTYtLjIzNC41NjYtLjQ1Ljc4NC0uMjE2LjIxNy0uNDg2LjM3NC0uNzgxLjQ1NS0xLjA4Ni4yOTMtNS40NC4yOTMtNS40NC4yOTNzLTQuMzU1IDAtNS40NC0uMjkzYy0uMjk2LS4wOC0uNTY1LS4yMzgtLjc4MS0uNDU1LS4yMTYtLjIxOC0uMzcxLS40ODgtLjQ1LS43ODQtLjI5LTEuMDkzLS4yOS0zLjM3My0uMjktMy4zNzNzMC0yLjI4LjI5LTMuMzczYy4wNzktLjI5Ni4yMzQtLjU2Ny40NS0uNzg0LjIxNi0uMjE3LjQ4NS0uMzc0Ljc4LS40NTRDNy42NDcgNy4yNTYgMTIgNy4yNTYgMTIgNy4yNTZzNC4zNTUgMCA1LjQ0LjI5NGMuMjk3LjA4LjU2Ni4yMzcuNzgyLjQ1NC4yMTYuMjE4LjM3MS40ODguNDUuNzg1LjI5IDEuMDkuMjkgMy4zNzQuMjkgMy4zNzRzMCAyLjI3OC0uMjkgMy4zN3oiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "GebD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeline_js__ = __webpack_require__("ucfx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeline_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df18bb8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeline_vue__ = __webpack_require__("cRkn");
function injectStyle (ssrContext) {
  __webpack_require__("OOZ5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeline_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df18bb8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GgQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_submit_js__ = __webpack_require__("Fn63");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f060936e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submit_vue__ = __webpack_require__("1zuO");
function injectStyle (ssrContext) {
  __webpack_require__("DZRR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_submit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f060936e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GkVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_social_share_invite_widget_share_invite_widget_vue__ = __webpack_require__("dDcj");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    shareInviteWidget: __WEBPACK_IMPORTED_MODULE_0__components_social_share_invite_widget_share_invite_widget_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Gumd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Gz6C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/Zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_about__ = __webpack_require__("L3N8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_account__ = __webpack_require__("cW54");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_browse__ = __webpack_require__("R6p5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_chart__ = __webpack_require__("9pxA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_insight__ = __webpack_require__("gatU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_market__ = __webpack_require__("d3y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api_profile__ = __webpack_require__("aeoD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_support__ = __webpack_require__("0X7F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_trade__ = __webpack_require__("FP0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_api_wallet__ = __webpack_require__("9hG0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api_dashboard__ = __webpack_require__("OfZf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_api_leaderboards__ = __webpack_require__("AM9x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_api_map__ = __webpack_require__("JoM+");














/* harmony default export */ __webpack_exports__["a"] = ({
  about: __WEBPACK_IMPORTED_MODULE_0__services_api_about__["a" /* default */],
  account: __WEBPACK_IMPORTED_MODULE_1__services_api_account__["a" /* default */],
  browse: __WEBPACK_IMPORTED_MODULE_2__services_api_browse__["a" /* default */],
  chart: __WEBPACK_IMPORTED_MODULE_3__services_api_chart__["a" /* default */],
  insight: __WEBPACK_IMPORTED_MODULE_4__services_api_insight__["a" /* default */],
  market: __WEBPACK_IMPORTED_MODULE_5__services_api_market__["a" /* default */],
  profile: __WEBPACK_IMPORTED_MODULE_6__services_api_profile__["a" /* default */],
  support: __WEBPACK_IMPORTED_MODULE_7__services_api_support__["a" /* default */],
  trade: __WEBPACK_IMPORTED_MODULE_8__services_api_trade__["a" /* default */],
  wallet: __WEBPACK_IMPORTED_MODULE_9__services_api_wallet__["a" /* default */],
  dashboard: __WEBPACK_IMPORTED_MODULE_10__services_api_dashboard__["a" /* default */],
  leaderboards: __WEBPACK_IMPORTED_MODULE_11__services_api_leaderboards__["a" /* default */],
  map: __WEBPACK_IMPORTED_MODULE_12__services_api_map__["a" /* default */]
});

/***/ }),

/***/ "H1Lz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "H1pb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_code_input_code_input_vue__ = __webpack_require__("l8Or");








/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */]],
    components: {
        CodeInput: __WEBPACK_IMPORTED_MODULE_6__components_generics_code_input_code_input_vue__["a" /* default */]
    },
    data: function data() {
        return {
            selectedMethod: null,
            code: '',
            codeSent: false,
            isVerifying: false,
            isSendingCode: false,
            secondsUntilResend: 0,
            secondsUntilExpiry: 0,
            resendTimer: null,
            expiryTimer: null,
            errorMessage: '',
            targetExpirationTime: null,
            targetResendTime: null,
            handleVisibilityChange: null,
            sendingStartTime: null,
            canShowSentState: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('user', ['twoFactorRequired', 'twoFactorToken', 'twoFactorMethods', 'twoFactorEmailHint', 'twoFactorPhoneHint', 'twoFactorSecondsUntilExpiry']), {
        hasEmail: function hasEmail() {
            return this.twoFactorMethods.includes('email');
        },
        hasPhone: function hasPhone() {
            return this.twoFactorMethods.includes('phone');
        },
        hasAuthenticator: function hasAuthenticator() {
            return this.twoFactorMethods.includes('authenticator');
        },
        canSendCode: function canSendCode() {
            return !this.isSendingCode && this.secondsUntilResend === 0;
        },
        canVerify: function canVerify() {
            return this.code.length >= 6 && !this.isVerifying;
        },
        methodRequiresSendCode: function methodRequiresSendCode() {
            return this.selectedMethod === 'email' || this.selectedMethod === 'phone';
        },
        formattedExpiryTime: function formattedExpiryTime() {
            var minutes = Math.floor(this.secondsUntilExpiry / 60);
            var seconds = this.secondsUntilExpiry % 60;
            return minutes + ':' + seconds.toString().padStart(2, '0');
        },
        hasCodeError: function hasCodeError() {
            return this.errorMessage !== '' && this.code === '';
        }
    }),
    mounted: function mounted() {
        this.secondsUntilExpiry = this.twoFactorSecondsUntilExpiry;
        this.startExpiryTimer();

        // Set up visibility change listener to sync timers when tab regains focus
        this.handleVisibilityChange = this.onVisibilityChange.bind(this);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        // Auto-select if only one method available
        if (this.twoFactorMethods.length === 1) {
            this.selectMethod(this.twoFactorMethods[0]);
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.clearTimers();
        if (this.handleVisibilityChange) {
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
            this.handleVisibilityChange = null;
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['twoFactorSendCode', 'twoFactorVerify', 'clearTwoFactorChallenge']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {

        // Handle visibility change - recalculate timers when tab becomes visible
        // This fixes the browser throttling issue where setInterval slows down / stops in background tabs
        onVisibilityChange: function onVisibilityChange() {
            if (document.visibilityState === 'visible') {
                this.updateTimersFromTargets();
            }
        },


        // Recalculate remaining seconds from stored target timestamps
        updateTimersFromTargets: function updateTimersFromTargets() {
            var now = Date.now();

            // Update expiry timer if active
            if (this.targetExpirationTime !== null) {
                var remaining = Math.max(0, Math.ceil((this.targetExpirationTime - now) / 1000));
                this.secondsUntilExpiry = remaining;
                if (remaining <= 0) {
                    this.clearExpiryTimer();
                    this.onSessionExpired();
                }
            }

            // Update resend timer if active
            if (this.targetResendTime !== null) {
                var _remaining = Math.max(0, Math.ceil((this.targetResendTime - now) / 1000));
                this.secondsUntilResend = _remaining;
                if (_remaining <= 0) {
                    this.clearResendTimer();
                }
            }
        },
        selectMethod: function selectMethod(method) {
            var _this = this;

            this.selectedMethod = method;
            this.code = '';
            this.codeSent = false;
            this.errorMessage = '';
            this.secondsUntilResend = 0;
            this.targetResendTime = null;
            this.sendingStartTime = null;
            this.canShowSentState = false;

            if (method === 'authenticator') {
                // Authenticator doesn't require sending code
                this.codeSent = true;
                this.$nextTick(function () {
                    if (_this.$refs.codeInput) {
                        _this.$refs.codeInput.focusFirst();
                    }
                });
            } else {
                // Auto-send code for email/phone methods
                this.sendCode();
            }
        },
        onCodeComplete: function onCodeComplete(code) {
            // Auto-submit when 6 digits are entered
            if (code && code.length === 6 && !this.isVerifying) {
                this.verifyCode();
            }
            // For now, just ensure focus is maintained
        },
        sendCode: function sendCode() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var minimumDisplayPromise, response, resendSeconds;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(!_this2.canSendCode || !_this2.methodRequiresSendCode)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:

                                _this2.isSendingCode = true;
                                _this2.canShowSentState = false;
                                _this2.sendingStartTime = Date.now();
                                _this2.errorMessage = '';

                                // Set up minimum display duration (500ms)
                                minimumDisplayPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                                    setTimeout(function () {
                                        _this2.canShowSentState = true;
                                        resolve();
                                    }, 500);
                                });
                                _context.prev = 7;
                                _context.next = 10;
                                return _this2.twoFactorSendCode({ method: _this2.selectedMethod });

                            case 10:
                                response = _context.sent;
                                _context.next = 13;
                                return minimumDisplayPromise;

                            case 13:

                                _this2.codeSent = true;
                                resendSeconds = response.seconds_til_resend_available || 60;

                                _this2.secondsUntilResend = resendSeconds;
                                _this2.startResendTimer(resendSeconds);

                                // Focus the code input after it appears
                                _this2.$nextTick(function () {
                                    if (_this2.$refs.codeInput) {
                                        _this2.$refs.codeInput.focusFirst();
                                    }
                                });
                                _context.next = 24;
                                break;

                            case 20:
                                _context.prev = 20;
                                _context.t0 = _context['catch'](7);

                                _this2.errorMessage = _this2.extractErrorMessage(_context.t0, 'Failed to send code. Please try again.');
                                _this2.canShowSentState = true;

                            case 24:
                                _context.prev = 24;

                                _this2.isSendingCode = false;
                                return _context.finish(24);

                            case 27:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[7, 20, 24, 27]]);
            }))();
        },
        verifyCode: function verifyCode() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this3.canVerify) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:

                                _this3.isVerifying = true;
                                _this3.errorMessage = '';

                                _context2.prev = 4;
                                _context2.next = 7;
                                return _this3.twoFactorVerify({ method: _this3.selectedMethod, code: _this3.code });

                            case 7:
                                _this3.clearTimers();
                                _this3.setProfileStatus({ event: 'login' });
                                _this3.onLoginSuccess();
                                _context2.next = 16;
                                break;

                            case 12:
                                _context2.prev = 12;
                                _context2.t0 = _context2['catch'](4);

                                _this3.errorMessage = _this3.extractErrorMessage(_context2.t0, 'Incorrect code. Please try again.');
                                _this3.code = '';

                            case 16:
                                _context2.prev = 16;

                                _this3.isVerifying = false;
                                return _context2.finish(16);

                            case 19:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[4, 12, 16, 19]]);
            }))();
        },
        getRedirectPath: function getRedirectPath() {
            if (this.$router.currentRoute.query.redirect) return this.$router.currentRoute.query.redirect;
            if (this.$router.currentRoute.name === 'home') return { name: 'portfolio' };
            return null;
        },
        onLoginSuccess: function onLoginSuccess() {
            this.setCurrentPopup(null);
            var redirect = this.getRedirectPath();
            if (redirect) {
                this.$router.push(redirect);
            }
        },
        onCancel: function onCancel() {
            this.clearTimers();
            this.clearTwoFactorChallenge();
            this.setCurrentPopup(null);
        },
        startResendTimer: function startResendTimer(durationSeconds) {
            var _this4 = this;

            this.clearResendTimer();
            // Store absolute target time
            this.targetResendTime = Date.now() + durationSeconds * 1000;

            this.resendTimer = setInterval(function () {
                var now = Date.now();
                var remaining = Math.max(0, Math.ceil((_this4.targetResendTime - now) / 1000));
                _this4.secondsUntilResend = remaining;

                if (remaining <= 0) {
                    _this4.clearResendTimer();
                }
            }, 1000);
        },
        startExpiryTimer: function startExpiryTimer() {
            var _this5 = this;

            this.clearExpiryTimer();
            // Store absolute target time
            this.targetExpirationTime = Date.now() + this.secondsUntilExpiry * 1000;

            this.expiryTimer = setInterval(function () {
                var now = Date.now();
                var remaining = Math.max(0, Math.ceil((_this5.targetExpirationTime - now) / 1000));
                _this5.secondsUntilExpiry = remaining;

                if (remaining <= 0) {
                    _this5.clearExpiryTimer();
                    _this5.onSessionExpired();
                }
            }, 1000);
        },
        onSessionExpired: function onSessionExpired() {
            var _this6 = this;

            this.errorMessage = 'Session expired. Please log in again.';
            setTimeout(function () {
                _this6.onCancel();
            }, 2000);
        },
        clearResendTimer: function clearResendTimer() {
            if (this.resendTimer) {
                clearInterval(this.resendTimer);
                this.resendTimer = null;
            }
            this.targetResendTime = null;
        },
        clearExpiryTimer: function clearExpiryTimer() {
            if (this.expiryTimer) {
                clearInterval(this.expiryTimer);
                this.expiryTimer = null;
            }
            this.targetExpirationTime = null;
        },
        clearTimers: function clearTimers() {
            this.clearResendTimer();
            this.clearExpiryTimer();
        },
        extractErrorMessage: function extractErrorMessage(error, defaultMessage) {
            // API returns errors as a direct array: response.data = [{ code, message, ... }]
            if (error.response && error.response.data) {
                var data = error.response.data;

                // Handle direct array of errors (API format)
                if (Array.isArray(data) && data.length > 0 && data[0].message) {
                    return data[0].message;
                }

                // Handle nested errors array
                if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                    return data.errors[0].message;
                }

                // Handle direct message property
                if (data.message) {
                    return data.message;
                }

                // Handle OAuth error_description
                if (data.error_description) {
                    return data.error_description;
                }
            }
            return defaultMessage;
        },
        getMethodIcon: function getMethodIcon(method) {
            switch (method) {
                case 'email':
                    return 'icon-email';
                case 'phone':
                    return 'icon-phone';
                case 'authenticator':
                    return 'icon-lock';
                default:
                    return 'icon-lock';
            }
        },
        getMethodLabel: function getMethodLabel(method) {
            switch (method) {
                case 'email':
                    return 'Email ' + this.twoFactorEmailHint;
                case 'phone':
                    return 'Phone (SMS) ' + this.twoFactorPhoneHint;
                case 'authenticator':
                    return 'Authenticator App';
                default:
                    return method;
            }
        },
        getMethodLabelDescriptive: function getMethodLabelDescriptive(method) {
            if (method === 'authenticator') {
                return 'Open your authenticator app';
            }

            // Show sending state while code is being sent
            if (this.isSendingCode) {
                var target = method === 'email' ? this.twoFactorEmailHint : this.twoFactorPhoneHint;
                return method === 'email' ? 'Sending code to ' + target : 'Sending code to ' + target;
            }

            // Show sent state after code has been sent
            if (this.codeSent) {
                var _target = method === 'email' ? this.twoFactorEmailHint : this.twoFactorPhoneHint;
                return method === 'email' ? 'Code sent to ' + _target : 'Code sent to ' + _target;
            }

            return method;
        },
        getCodeInputLabel: function getCodeInputLabel() {
            switch (this.selectedMethod) {
                case 'email':
                    return 'Enter the 6-digit code from your email';
                case 'phone':
                    return 'Enter the 6-digit code from your phone';
                case 'authenticator':
                    return 'Enter the 6-digit code from your authenticator app';
                default:
                    return 'Enter the 6-digit code';
            }
        }
    })
});

/***/ }),

/***/ "H2VB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isComponentReady),expression:"!isComponentReady"}],staticClass:"market-detail-charts__content-loader"},[_c('market-chart-loader')],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isComponentReady),expression:"isComponentReady"}]},[_c('div',{staticClass:"market-detail-charts__timeline"},[_c('charts-timeline',{attrs:{"market":_vm.market,"chartOptions":_vm.chartOptions,"isChartLoading":_vm.isLoading,"showVolume":_vm.showVolume,"showPriceAxisZoom":_vm.showPriceAxisZoom},on:{"timelineChange":_vm.onTimelineChange,"typeChange":_vm.onTypeChange,"volumeChartToggle":_vm.volumeChartToggle,"priceAxisZoomToggle":_vm.priceAxisZoomToggle}})],1),_vm._v(" "),_c('div',{ref:"chartLoadingScope",staticClass:"market-detail-charts__body"},[(!_vm.showStats)?[(_vm.title)?_c('div',{staticClass:"market-detail-charts__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('charts-container',{attrs:{"market":_vm.market,"timeline":_vm.chartTimeline,"chartOptions":_vm.chartOptions,"showVolume":_vm.showVolume,"showPriceAxisZoom":_vm.showPriceAxisZoom,"chartType":_vm.chartType,"chartData":_vm.filteredChartData,"chartDataLoaded":_vm.chartDataLoaded,"chartSystemOptions":_vm.chartSystemOptions}}),_vm._v(" "),(_vm.showChartsTable)?_c('charts-table',{staticClass:"market-detail-charts__table",attrs:{"chartOptions":_vm.chartOptions,"contracts":_vm.chartContracts},on:{"toggleItem":_vm.onContractToggle}}):_vm._e(),_vm._v(" "),(_vm.caption)?_c('div',{staticClass:"market-detail-charts__caption",domProps:{"innerHTML":_vm._s(_vm.caption)}}):_vm._e()]:[_c('div',{staticClass:"market-detail-charts__stats-container"},[(_vm.marketContractsStats.length > 0)?_c('market-contracts-stats',{attrs:{"isFixed":_vm.hasMarketHiddenContracts(_vm.market),"stats":_vm.marketContractsStats}}):(!_vm.isLoading)?_c('div',{staticClass:"market-detail-charts__stats-no-data"},[_vm._v("\n            No data to display\n          ")]):_vm._e()],1)]],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H2eu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");

/* eslint-disable object-shorthand */






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */]],
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */]
  },
  validations: {
    fields: {
      newUserName: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].username
    }
  },
  data: function data() {
    return {
      initialised: false,
      fields: {
        username: '',
        newUserName: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData', 'usernameTries']), {
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      return this.invalidOrDisabled || this.usernameTries === 0;
    },
    isUsernameInputDisabled: function isUsernameInputDisabled() {
      return this.isFormDisabled || this.usernameTries === 0;
    }
  }),
  watch: {
    isLoading: function isLoading(value) {
      var el = document.querySelector('.modal__body--show-ready');
      if (!el) return;
      if (value) {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    },

    userData: {
      handler: 'userDataChanged',
      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotificationWithTimeoutCallback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['changeUserName', 'getAccountDetail', 'getUserNameTries']), {
    userDataChanged: function userDataChanged(value) {
      if (value) {
        this.fields.username = value.userName;
      }
    },
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        this.changeUserName(this.fields.newUserName).then(function () {
          _this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Username Updated.',
            callback: function callback() {
              return _this.$router.go(-1);
            }
          });
        }).then(this.formEnable).then(this.getAccountDetail).catch(function (e) {
          _this.formHandleErrors(e);
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.loaderAdd(document.body);
    this.getUserNameTries().then(function (data) {
      _this2.loaderRemove(document.body);
      _this2.initialised = true;
      _this2.$nextTick(function () {
        if (data > 0) {
          var newUsernameInput = _this2.$refs.newUsername.$el.querySelector('.input__value');
          newUsernameInput.focus();
        }
      });
    });
  }
});

/***/ }),

/***/ "H4Kq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-filters",class:_vm.openModifier},[(_vm.value)?_c('div',{staticClass:"history-filters__selected"},[_c('div',{staticClass:"history-filters__selected-back",on:{"click":_vm.onRecent}}),_vm._v(" "),_c('div',{staticClass:"history-filters__selected-wrap"},[_c('span',{staticClass:"history-filters__selected-title"},[_c('router-link',{attrs:{"to":{ name: 'market-details', params: { marketId: _vm.value.marketId } }}},[_vm._v(_vm._s(_vm.value.marketTitle))])],1)])]):_vm._e(),_vm._v(" "),(!_vm.value)?_c('div',[_c('div',{staticClass:"history-filters__recent"},[_c('button-with-info',{attrs:{"text":"Most Recent","selected":_vm.recent},on:{"click":_vm.onRecent,"infoClick":_vm.onInfoClick}})],1),_vm._v(" "),_c('div',{staticClass:"history-filters__markets"},[_c('button-with-info',{attrs:{"text":"Markets","selected":!_vm.recent,"infoOnLeft":false},on:{"click":_vm.onMarkets,"infoClick":_vm.onInfoClick}})],1),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"column small-12"},[_c('refine-history',{attrs:{"list":_vm.markets},on:{"input":_vm.onRefineHistoryInput}})],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H7Lx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HC9X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_order_book_sushi_order_book_sushi_vue__ = __webpack_require__("kIgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_keyboard_numeric_sushi_keyboard_numeric_sushi_vue__ = __webpack_require__("m1D1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_keyboard_numeric_input_sushi_keyboard_numeric_input_sushi_vue__ = __webpack_require__("JLAi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_purchase_offer_value_sushi_purchase_offer_value_sushi_vue__ = __webpack_require__("W6JW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_purchase_sushi_purchase_quantity_value_sushi_purchase_quantity_value_sushi_vue__ = __webpack_require__("S2nZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__ = __webpack_require__("yzoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_related_contracts_sushi_related_contracts_sushi_vue__ = __webpack_require__("P4uE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_purchase_sushi_purchase_offer_value_picker_mobile_sushi_purchase_offer_value_picker_mobile_sushi_vue__ = __webpack_require__("ziKg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_purchase_sushi_purchase_quantity_picker_mobile_sushi_purchase_quantity_picker_mobile_sushi_vue__ = __webpack_require__("v5l1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__ = __webpack_require__("azKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__("IcnI");


 /* eslint-disable */






















var getDefaultBuyQuantity = function getDefaultBuyQuantity() {
  return __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */].getters['user/isLoggedIn'] ? 1 : 10;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_loader__["a" /* default */]],
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    keyboardNumericSushi: __WEBPACK_IMPORTED_MODULE_7__components_keyboard_numeric_sushi_keyboard_numeric_sushi_vue__["a" /* default */],
    keyboardNumericInputSushi: __WEBPACK_IMPORTED_MODULE_8__components_keyboard_numeric_input_sushi_keyboard_numeric_input_sushi_vue__["a" /* default */],
    orderBookSushi: __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_order_book_sushi_order_book_sushi_vue__["a" /* default */],
    purchaseOfferValueSushi: __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_purchase_offer_value_sushi_purchase_offer_value_sushi_vue__["a" /* default */],
    purchaseQuantityValueSushi: __WEBPACK_IMPORTED_MODULE_10__components_purchase_sushi_purchase_quantity_value_sushi_purchase_quantity_value_sushi_vue__["a" /* default */],
    marketCharts: __WEBPACK_IMPORTED_MODULE_15__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */],
    purchaseTradeTypeSwitcherSushi: __WEBPACK_IMPORTED_MODULE_16__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__["a" /* default */],
    relatedContractsSushi: __WEBPACK_IMPORTED_MODULE_17__components_related_contracts_sushi_related_contracts_sushi_vue__["a" /* default */],
    purchaseOfferValuePickerMobileSushi: __WEBPACK_IMPORTED_MODULE_18__components_purchase_sushi_purchase_offer_value_picker_mobile_sushi_purchase_offer_value_picker_mobile_sushi_vue__["a" /* default */],
    purchaseQuantityPickerMobileSushi: __WEBPACK_IMPORTED_MODULE_19__components_purchase_sushi_purchase_quantity_picker_mobile_sushi_purchase_quantity_picker_mobile_sushi_vue__["a" /* default */],
    marketTradingUnavailableV2: __WEBPACK_IMPORTED_MODULE_20__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__["a" /* default */]
  },
  props: {
    market: {},
    contract: {},
    showRelatedContracts: {
      type: Boolean,
      default: false
    },
    showContractCharts: {
      type: Boolean,
      default: false
    },
    showOrderSlip: {
      type: Boolean,
      default: true
    },
    disablePurchaseOfferWatchers: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      pricePerShareUpdateCount: 0,
      pricePerShare: null,
      quantity: getDefaultBuyQuantity(),
      skipConfirmation: false,
      quantityError: null,
      inputSelected: null,
      submitDisabledBecauseOfSwitch: false,
      directionalOrderState: {
        yes: null,
        no: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isTradingEnabled', 'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'cancelToggle', 'tradeSuccess', 'masterTradeOptions']), {
    componentName: function componentName() {
      return this.$options.name || this.$vnode && this.$vnode.componentOptions.tag || "Unknown Component";
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    isMarketClosed: function isMarketClosed() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["M" /* isMarketClosed */])(this.market);
    },
    minimumOwnership: function minimumOwnership() {
      return Math.max(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.contract, 'minimumClipSize', 1), 1);
    },
    showThresholdInfo: function showThresholdInfo() {
      return this.minimumOwnership > 1;
    },
    minQuantityValue: function minQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return this.contractModel.userQuantity >= this.minimumOwnership ? 1 : Math.min(this.minimumOwnership, this.minimumOwnership - this.contractModel.userQuantity);
      } else {
        return this.contractModel.userQuantity === 0 ? 1 : this.contractModel.userQuantity > this.minimumOwnership ? 1 : this.contractModel.userQuantity;
      }
    },
    maxQuantityValue: function maxQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return 9999;
      } else {
        return this.contractModel.userQuantity === 0 ? 1 : this.contractModel.userQuantity;
      }
    },
    chartOptions: function chartOptions() {
      return {
        include24hr: true,
        include7day: true,
        include30day: true,
        include90day: true,
        includeCandle: true,
        includeLine: true,
        includeLegend: false,
        contractIds: [this.tradeOptions.contractId]
      };
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'purchase-offer-sushi': true,
        'purchase-offer-sushi--maintenance': !this.isTradingEnabled,
        'purchase-offer-sushi--yes': this.tradeOptions.operationValue === 'yes',
        'purchase-offer-sushi--no': this.tradeOptions.operationValue === 'no',
        'purchase-offer-sushi--mobile-inline': true
      }, 'purchase-offer-sushi--' + this.$router.currentRoute.name, true);
    },
    contractModel: function contractModel() {
      return this.contract ? new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.contract) : {};
    },
    contractName: function contractName() {
      if (!this.market || !this.contract) return '';
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["j" /* isMarketSingle */])(this.market)) {
        return this.market.marketShortName || this.market.marketName;
      }
      return this.contract.contractName;
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    mainClassName: function mainClassName() {
      return 'purchase-offer-sushi';
    },
    quantityErrorText: function quantityErrorText() {
      var _getReducedQuantity = this.getReducedQuantity(),
          reduced = _getReducedQuantity.reduced,
          min = _getReducedQuantity.min,
          max = _getReducedQuantity.max;

      if (this.tradeOptions.operationType === 'buy' && this.quantity && this.contractModel.userQuantity + this.quantity < min) {
        var suffix = min === 1 ? 'share' : 'shares';
        return 'You must own at least ' + min + ' ' + suffix + ' in this contract';
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity > this.contractModel.userQuantity) {
        if (this.contractModel.userQuantity === 1) {
          return 'You have only 1 share to sell';
        }
        if (this.contractModel.userQuantity === 0) {
          return "You don't have any shares to sell";
        }
        var _suffix = this.contractModel.userQuantity === 1 ? 'share' : 'shares';
        return 'You only have ' + this.contractModel.userQuantity + ' ' + _suffix + ' to sell';
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity && this.quantity < reduced) {
        var _suffix2 = min === 1 ? 'share' : 'shares';
        return 'You must maintain ownership of at least ' + min + ' ' + _suffix2;
      }
      // CR
      if (this.tradeOptions.operationType === 'sell' && this.quantity && max && this.quantity > max && this.quantity !== this.contractModel.userQuantity) {
        var _suffix3 = min === 1 ? 'share' : 'shares';
        return 'You must maintain ownership of at least ' + min + ' ' + _suffix3;
      }
      return null;
    },
    isPriceValid: function isPriceValid() {
      if (this.pricePerShare === null || isNaN(this.pricePerShare) || this.pricePerShare === 0) {
        return false;
      }
      return true;
    },
    isQuantityValid: function isQuantityValid() {
      if (this.quantity === null || this.quantity === '') return false;
      if (this.tradeOptions.operationType === 'sell') {
        if (this.quantity > this.contractModel.userQuantity) return false;
      }
      return !this.quantityErrorText;
    },
    nextButtonTitle: function nextButtonTitle() {
      if (this.tradeOptions && this.tradeOptions.skipConfirmation) {
        return 'Submit Order';
      }
      if (this.isLayoutDesktop) {
        return 'Next';
      }
      return this.tradeTypeText;
    },
    nextButtonDisabled: function nextButtonDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["M" /* isMarketClosed */])(this.market) || !this.isTradingEnabled || !this.isQuantityValid || !this.isPriceValid || !this.isAvailableForTrade || this.isLoading;
    },
    purchaseOfferKey: function purchaseOfferKey() {
      var timestamp = this.contractModel.timestamp || '-';
      return this.contractModel.contractId + '-' + timestamp + '-' + this.tradeSuccess.toString() + '-' + this.contractModel.mode + '-' + this.contractModel.userOpenOrders + '-' + this.contractModel.userQuantity + '-' + this.tradeOptions.operationType + '-' + this.tradeOptions.operationValue;
    },
    orderBookKey: function orderBookKey() {
      return this.purchaseOfferKey;
    },
    isContractOpen: function isContractOpen() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["A" /* isContractOpen */])(this.contract);
    },
    pricePerShareSuffix: function pricePerShareSuffix() {
      return this.tradeType <= 1 ? 'Max' : 'Min';
    },
    pricePerShareSuffixFull: function pricePerShareSuffixFull() {
      return this.tradeType <= 1 ? 'Maximum' : 'Minimum';
    },
    tradeType: function tradeType() {
      switch (this.tradeOptions.operationType + '_' + this.tradeOptions.operationValue) {
        case 'buy_no':
          return 0;
        case 'buy_yes':
          return 1;
        case 'sell_no':
          return 2;
        case 'sell_yes':
          return 3;
        default:
          return -1;
      }
    },
    tradeTypeText: function tradeTypeText() {
      return this.tradeType <= 1 ? 'Buy' : 'Sell';
    },
    isYesType: function isYesType() {
      return this.tradeType === 1 || this.tradeType === 3;
    },
    yesNoText: function yesNoText() {
      return this.isYesType ? 'YES' : 'NO';
    },
    tradeOperationAndValue: function tradeOperationAndValue() {
      return {
        type: this.tradeOptions.operationType,
        value: this.tradeOptions.operationValue
      };
    },
    isAvailableForTrade: function isAvailableForTrade() {
      if (!this.contractModel.mode) return true;
      return this.contractModel.mode === this.tradeOptions.operationValue;
    },
    showSellWarning: function showSellWarning() {
      return this.contractModel.userQuantity === 0 && this.tradeOptions.operationType === 'sell';
    },
    tradingUnavailableTheme: function tradingUnavailableTheme() {
      if (this.isAfterHours) {
        return 'after-hours';
      }
      return 'maintenance';
    },
    tradingUnavailableText: function tradingUnavailableText() {
      if (this.isAfterHours) {
        return 'Trading is not available during After-hours';
      }
      return 'Trading is not available during Maintenance mode.';
    }
  }),
  watch: {
    'tradeOptions.operationType': function watchOperationType(val, oldVal) {
      var _this = this;

      this.submitDisabledBecauseOfSwitch = true;
      this.pricePerShareUpdateCount += 1;
      if (oldVal && oldVal !== val) {
        this.clearDirectionalOrderState();
      }
      this.setDefaultPrice();
      this.setDefaultQuantity();
      setTimeout(function () {
        _this.submitDisabledBecauseOfSwitch = false;
      }, 500);
    },
    'tradeOptions.operationValue': function watchOperationValue(val, oldVal) {
      var _this2 = this;

      this.submitDisabledBecauseOfSwitch = true;
      this.pricePerShareUpdateCount += 1;
      if (oldVal && oldVal !== val) {
        this.saveDirectionalOrderState(oldVal);
      }
      this.restoreDirectionalOrderState(val);
      setTimeout(function () {
        _this2.submitDisabledBecauseOfSwitch = false;
      }, 500);
    },
    contractModel: function contractModel(value, oldValue) {
      if (oldValue && value && oldValue.contractId !== value.contractId) {
        this.clearDirectionalOrderState();
      }
      if (this.cancelToggle) {
        this.setCancelToggle(false);
      }
    },
    pricePerShare: function pricePerShare(newVal, oldVal) {
      if (!this.disablePurchaseOfferWatchers) {
        this.setTradePrice(newVal);
      }
    },
    quantity: function quantity(newValue, oldValue) {
      if (!this.disablePurchaseOfferWatchers) {
        this.setTradeQuantity(newValue);
      }
    },
    skipConfirmation: function skipConfirmation(value) {
      this.setTradeSkipConfirmation(value);
      this.skipConfirmation = this.tradeOptions.skipConfirmation;
    },
    isQuantityValid: function isQuantityValid(value) {
      if (value === true) this.quantityError = null;
    },
    masterTradeOptions: function masterTradeOptions(value) {
      var quantity = value.quantity,
          pricePerShare = value.pricePerShare;

      this.setQuantityConsolidatingTradeOptions(quantity);
      this.setPriceConsolidatingTradeOptions(pricePerShare);
    },
    tradeSuccess: function tradeSuccess(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.clearDirectionalOrderState();
        this.setDefaultPrice();
        this.setDefaultQuantity();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getMarketRules']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeQuantity', 'setTradePrice', 'setTradeSkipConfirmation', 'setCancelToggle', 'setMasterTradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setGenericSmallPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), {
    shouldPreserveDirectionalOrderState: function shouldPreserveDirectionalOrderState() {
      return !this.isLayoutDesktop;
    },
    saveDirectionalOrderState: function saveDirectionalOrderState() {
      var operationValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tradeOptions.operationValue;

      if (!this.shouldPreserveDirectionalOrderState() || !operationValue) return;

      this.directionalOrderState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.directionalOrderState, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, operationValue, {
        pricePerShare: this.pricePerShare,
        quantity: this.quantity
      }));
    },
    restoreDirectionalOrderState: function restoreDirectionalOrderState() {
      var operationValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tradeOptions.operationValue;

      if (!this.shouldPreserveDirectionalOrderState()) {
        this.setDefaultPrice();
        this.setDefaultQuantity();
        return;
      }

      var savedState = this.directionalOrderState[operationValue];
      if (savedState) {
        this.setPriceConsolidatingTradeOptions(savedState.pricePerShare);
        this.setQuantityConsolidatingTradeOptions(savedState.quantity);
        return;
      }

      this.setDefaultPrice();
      this.setDefaultQuantity();
    },
    clearDirectionalOrderState: function clearDirectionalOrderState() {
      this.directionalOrderState = {
        yes: null,
        no: null
      };
    },
    setDefaultQuantity: function setDefaultQuantity() {
      var _getReducedQuantity2 = this.getReducedQuantity(),
          reduced = _getReducedQuantity2.reduced;

      this.setQuantityConsolidatingTradeOptions(reduced);
    },
    setQuantityConsolidatingTradeOptions: function setQuantityConsolidatingTradeOptions(value) {
      var currentQuantity = this.quantity;
      this.quantity = value;
      if (value !== null && this.tradeOptions.quantity === null) {
        this.setTradeQuantity(value);
      }
    },
    setDefaultPrice: function setDefaultPrice() {
      this.setPriceConsolidatingTradeOptions(this.getDefaultPricePerShare());
    },
    setPriceConsolidatingTradeOptions: function setPriceConsolidatingTradeOptions(value) {
      var currentPrice = this.pricePerShare;
      this.pricePerShare = value;
      if (value !== null && this.tradeOptions.pricePerShare === null) {
        this.setTradePrice(value);
      }
    },
    getDefaultPricePerShare: function getDefaultPricePerShare() {
      var initialPrice = 0;
      // buy
      if (this.tradeOptions.operationType === 'buy') {
        if (this.tradeOptions.operationValue === 'yes') {
          initialPrice = this.contractModel.buyYesCostAsCents;
        } else {
          initialPrice = this.contractModel.buyNoCostAsCents;
        }
      } else if (this.tradeOptions.operationValue === 'yes') {
        // sell
        initialPrice = this.contractModel.sellYesCostAsCents;
      } else {
        initialPrice = this.contractModel.sellNoCostAsCents;
      }

      if (initialPrice === 0) {
        initialPrice = this.contractModel.lastTradePriceAsCents;
        if (initialPrice > 0 && this.tradeOptions.operationValue === 'no') {
          initialPrice = 100 - initialPrice;
        }
      }

      if (initialPrice === 0) {
        initialPrice = 50;
      }

      return initialPrice;
    },
    getReducedQuantity: function getReducedQuantity() {
      if (this.tradeOptions.operationType === 'sell') {
        return this.contractModel.userQuantity === 0 ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: null
        } : this.contractModel.userQuantity > this.minimumOwnership ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: this.contractModel.userQuantity - this.minimumOwnership
        } : {
          reduced: this.contractModel.userQuantity,
          min: this.minimumOwnership,
          max: null
        };
      } else if (this.tradeOptions.operationType === 'buy') {
        return this.contractModel.userQuantity >= this.minimumOwnership ? {
          reduced: getDefaultBuyQuantity(),
          min: this.minimumOwnership,
          max: null
        } : {
          reduced: Math.max(this.minimumOwnership, getDefaultBuyQuantity()),
          min: this.minimumOwnership,
          max: null
        };
      }
    },
    onUpdatePriceAndQuantity: function onUpdatePriceAndQuantity(data) {
      this.setMasterTradeOptions({
        quantity: Math.min(data.quantity, 9999),
        pricePerShare: data.price
      });
    },
    openThresholdInfoPopup: function openThresholdInfoPopup() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_14__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_OWNERSHIP_INFO);
      this.setCurrentPopupOptions({ shares: this.minimumOwnership });
    },
    onClickNext: function onClickNext() {
      if (this.isQuantityValid && !this.isLoading) {
        this.$emit('submit');
      } else {
        this.quantityError = true;
      }
    },
    onClickNextButWithSkipDisabled: function onClickNextButWithSkipDisabled() {
      if (this.isQuantityValid && !this.isLoading) {
        this.$emit('submit-no-skip');
      } else {
        this.quantityError = true;
      }
    }
  }),
  created: function created() {
    if (this.tradeOptions.pricePerShare !== null) {
      this.setQuantityConsolidatingTradeOptions(this.tradeOptions.quantity);
    } else {
      this.setDefaultPrice();
      this.setDefaultQuantity();
    }

    this.pricePerShare = this.tradeOptions.pricePerShare;
    this.skipConfirmation = this.tradeOptions.skipConfirmation;
  }
});

/***/ }),

/***/ "HK72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_search_js__ = __webpack_require__("DZwU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcb2e98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_search_vue__ = __webpack_require__("9V7m");
function injectStyle (ssrContext) {
  __webpack_require__("dEOY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_search_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcb2e98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HLCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_research_js__ = __webpack_require__("iHjQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca1c5dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_research_vue__ = __webpack_require__("RPGB");
function injectStyle (ssrContext) {
  __webpack_require__("XzS6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_research_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca1c5dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_research_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HOak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_history_trades_trades_vue__ = __webpack_require__("Aq5e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_history_transactions_transactions_vue__ = __webpack_require__("eMds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");










var TAB_TRADES = 'trades';
var TAB_DEPOSIT_WITHDRAWALS = 'deposit-withdrawals';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    marketId: {}
  },
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_2__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_4__components_account_profile_profile_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_5__components_generics_tabs_tabs_vue__["a" /* default */],
    trades: __WEBPACK_IMPORTED_MODULE_6__components_account_history_trades_trades_vue__["a" /* default */],
    transactions: __WEBPACK_IMPORTED_MODULE_7__components_account_history_transactions_transactions_vue__["a" /* default */]
  },
  data: function data() {
    return {
      ready: false,
      activeTab: '',
      tabs: [{ name: TAB_TRADES, title: 'Trades' }, { name: TAB_DEPOSIT_WITHDRAWALS, title: 'Deposits/Withdrawals' }]
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'History'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    tradesKey: function tradesKey() {
      return 'trades-' + this.isLayoutMobile.toString();
    },
    transactionsKey: function transactionsKey() {
      return 'transactions-' + this.isLayoutMobile.toString();
    },
    showTradesTab: function showTradesTab() {
      return this.activeTab === TAB_TRADES;
    },
    showTransactionsTab: function showTransactionsTab() {
      return this.activeTab === TAB_DEPOSIT_WITHDRAWALS;
    },
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', {
    showOverlay: 'show'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['resetTradeHistory', 'resetTransactionHistory']), {
    onExport: function onExport(what) {
      this.showOverlay();
      if (what === TAB_TRADES) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].EXPORT_TRADE_HISTORY);
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].EXPORT_TRANSACTION_HISTORY);
      }
    },
    tabChange: function tabChange(name) {
      var _this = this;

      if (name === TAB_DEPOSIT_WITHDRAWALS) {
        this.resetTransactionHistory();
      } else if (name === TAB_TRADES) {
        this.resetTradeHistory();
      }

      setTimeout(function () {
        if (_this.activeTab && _this.$route && _this.$route.path) {
          _this.$gtm.trackEvent({
            event: 'pageviewTrackerEvent',
            virtualPage: _this.$route.path + '/' + name,
            virtualPageTitle: _this.$route.name + ' - ' + name
          });
        }

        _this.activeTab = name;
        if (name && _this.$router.currentRoute.query.tabId !== name) {
          _this.$router.push({
            name: 'account-history',
            query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$route.query, {
              tabId: _this.activeTab
            })
          });
        }
      }, 0);
    }
  }),
  watch: {
    '$route.query': function $routeQuery(value) {
      if (value.tabId && value.tabId !== this.activeTab) {
        this.resetTransactionHistory();
        this.resetTradeHistory();
        this.activeTab = value.tabId;
      }
    }
  },
  created: function created() {
    if (this.$route.query.tabId) {
      this.activeTab = this.$route.query.tabId;
    } else {
      this.activeTab = 'trades';
      this.$router.push({ name: 'account-history', query: { tabId: 'trades' } });
    }
    this.ready = true;
  },
  beforeDestroy: function beforeDestroy() {
    this.resetTransactionHistory();
    this.resetTradeHistory();
  }
});

/***/ }),

/***/ "HP6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MODALS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_modal_modal_vue__ = __webpack_require__("CAzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_layouts_generic_vue__ = __webpack_require__("7okt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_small_vue__ = __webpack_require__("WRh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_account_forgotten_account_forgotten_vue__ = __webpack_require__("8TeC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_account_forgotten_footer_footer_vue__ = __webpack_require__("koWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_account_account_register_external_account_register_external_vue__ = __webpack_require__("E9c5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_account_details_modal_account_details_verify_vue__ = __webpack_require__("EKqI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_account_account_upload_id_account_upload_id_vue__ = __webpack_require__("flEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_account_account_upload_document_account_upload_document_vue__ = __webpack_require__("3USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_account_account_details_modal_account_details_update_modal_vue__ = __webpack_require__("IUvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_account_account_update_image_account_update_image_vue__ = __webpack_require__("Aqlg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_wallet_add_funds_combined_add_funds_combined_vue__ = __webpack_require__("l9wN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_wallet_add_funds_combined_footer_footer_vue__ = __webpack_require__("1F6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_wallet_deposited_deposited_vue__ = __webpack_require__("WXHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_potential_payouts_potential_payouts_vue__ = __webpack_require__("gTQM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_export_history_export_history_vue__ = __webpack_require__("cgtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_insight_insight_modal_insight_modal_vue__ = __webpack_require__("TJ+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_research_research_vue__ = __webpack_require__("eNmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_tax_info_notification_tax_info_notification_vue__ = __webpack_require__("wQDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_home_home_old_news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_attach_to_home_attach_to_home_vue__ = __webpack_require__("r6f4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_offers_indicator_popup_offers_indicator_popup_vue__ = __webpack_require__("zyut");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_market_market_contracts_stats_popup_market_contracts_stats_popup_vue__ = __webpack_require__("ETXZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_account_account_reset_password_account_reset_password_vue__ = __webpack_require__("TMp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_orientation_info_orientation_info_vue__ = __webpack_require__("v0Cj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_account_account_badges_list_account_badges_list_vue__ = __webpack_require__("yeq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_social_user_profile_overview_user_profile_overview_vue__ = __webpack_require__("M6xY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_social_user_profile_overview_header_user_profile_overview_header_vue__ = __webpack_require__("nNeU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_social_user_report_user_report_vue__ = __webpack_require__("0RmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_leaderboards_leaderboards_trophy_pyramid_leaderboards_trophy_pyramid_vue__ = __webpack_require__("mgKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_messaging_journey_info_messaging_journey_info_vue__ = __webpack_require__("sIse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_wallet_coinbase_process_overview_coinbase_process_overview_vue__ = __webpack_require__("MbhW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_profile_affiliations_popup_affiliations_popup_vue__ = __webpack_require__("jI1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_announcement_announcement_vue__ = __webpack_require__("Mz4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_market_market_rules_market_rules_vue__ = __webpack_require__("bynG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_account_account_already_exists_account_already_exists_vue__ = __webpack_require__("QSM8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_account_account_already_exists_footer_footer_vue__ = __webpack_require__("Z/tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_account_account_enable_classic_predictit_account_enable_classic_predictit_vue__ = __webpack_require__("Y6Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_account_account_enable_classic_predictit_footer_footer_vue__ = __webpack_require__("nBxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_market_market_ownership_conflict_modal_market_ownership_conflict_modal_vue__ = __webpack_require__("nEDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_account_account_two_factor_verify_account_two_factor_verify_vue__ = __webpack_require__("b8Ry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_account_account_two_factor_prompt_account_two_factor_prompt_vue__ = __webpack_require__("aUi2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_account_account_phone_update_account_phone_update_vue__ = __webpack_require__("AORQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_purchase_sushi_purchase_review_and_confirm_sushi_purchase_review_and_confirm_sushi_vue__ = __webpack_require__("rJdw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_market_price_odds_toggle_popup_price_odds_toggle_popup_vue__ = __webpack_require__("QHOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_purchase_sushi_share_info_popup_share_info_popup_vue__ = __webpack_require__("8O0X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_what_is_new_popup_what_is_new_popup_vue__ = __webpack_require__("NwTj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_what_is_new_popup_what_is_new_popup_footer_vue__ = __webpack_require__("mHXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_forms_captcha_captcha_vue__ = __webpack_require__("aDe5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_what_is_new_popup_helpers__ = __webpack_require__("AyQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__mixins_loader__ = __webpack_require__("39kf");

/* eslint-disable import/extensions */




























































var MODALS = {
  LOGIN: 'login',
  FORGOTTEN: 'forgotten',
  RESET_PASSWORD: 'reset-password',
  REGISTER: 'register',
  REGISTER_EXTERNAL: 'register-external',
  ACCOUNT_VERIFY: 'account-verify',
  UPLOAD_ID: 'upload-id',
  TAX_INFO: 'tax-info',
  ATTACH_TO_HOME: 'attach-to-home',
  ACCOUNT_DETAIL_UPDATE: 'account-detail-update',
  ACCOUNT_DETAIL_PASSWORD: 'account-detail-password',
  ACCOUNT_DETAIL_PASSWORD_SET: 'account-detail-password-set',
  ACCOUNT_ADDRESS_UPDATE: 'account-address-update',
  ADD_FUNDS: 'add-funds',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_ERROR: 'payment-error',
  POTENTIAL_PAYOUTS: 'potential-payouts',
  MARKET_CONTRACT_STATS: 'market-contracts-stats',
  RESEARCH: 'research',
  TWITTER: 'twitter',
  NEWS_FEED: 'news-feed',
  PURCHASE: 'purchase-modal',
  PURCHASE_SUSHI: 'purchase-modal-sushi',
  PURCHASE_SUSHI_REVIEW: 'purchase-modal-review-sushi',
  INSIGHT: 'insight-modal',
  GENERIC: 'generic',
  EXPORT_TRADE_HISTORY: 'export-trade-history',
  EXPORT_TRANSACTION_HISTORY: 'export-transaction-history',
  COINBASE: 'coinbase',
  SMALL_CVV: 'cvv',
  SMALL_SWIFT: 'swift',
  SMALL_ROUTING_NUMBER: 'routing-number',
  SMALL_EDIT_IMAGE: 'edit-image',
  SMALL_MARKET_RULES: 'market-rules',
  SMALL_GENERIC: 'generic-small',
  SMALL_USERNAME: 'username',
  SMALL_TRADE_INFO: 'account-trade-info',
  SMALL_OFFERS_INDICATOR: 'offers-indicator',
  SMALL_VERIFICATION_INFO: 'verfication-info',
  SMALL_BADGES: 'badges',
  SMALL_USER_PROFILE: 'user-profile',
  SMALL_REPORT_USER: 'report-user',
  SMALL_ROI_INFO: 'roi-info',
  SMALL_FEE_INFO: 'fee-info',
  SMALL_WINS_INFO: 'wins-info',
  SMALL_LEADERBOARDS_UPDATE_INFO: 'leaderboards-update-info',
  SMALL_SHARE_INVITE_INFO: 'share-invite-info',
  SMALL_PUBLIC_PROFILE_INFO: 'public-profile-info',
  SMALL_RESTRICTED_FUNDS_INFO: 'restricted-funds-info',
  SMALL_ANNOUNCEMENT: 'announcement',
  UPLOAD_DOCUMENT: 'upload-document',
  ORIENTATION: 'orientation',
  SMALL_MESSAGING_JOURNEY: 'messaging-journey',
  SMALL_PWMB_ACCOUNT_CONFIRM_DELETE: 'pwmb-account-confirm-delete',
  AFFILIATIONS: 'affiliations',
  VIDEO: 'video',
  ACCOUNT_ALREADY_EXISTS: 'account-already-exists',
  ACCOUNT_ENABLE_CLASSIC: 'account-enable-classic',
  MARKET_OWNERSHIP_CONFLICT: 'market-ownership-conflict',
  TWO_FACTOR: 'two-factor',
  TWO_FACTOR_PROMPT: 'two-factor-prompt',
  PHONE_UPDATE: 'phone-update',
  SMALL_PRICE_ODDS: 'small-price-odds',
  SMALL_PREDICTIT_INDEX: 'small-predictit-index',
  SMALL_OWNERSHIP_INFO: 'ownership-info',
  SMALL_SHARE_INFO: 'small-share-info',
  SMALL_DEPOSIT_NUMBER_INFORMATION: 'small-deposit-number-information',
  SMALL_OFFER_INFO: 'small-offer-info',
  RECAPTCHA_CHALLENGE: 'recaptcha-challenge',
  SMALL_PAYOUT_INFO: 'payout-info',
  CUSTOMIZE_YOUR_PREDICTIT: 'customize-your-predictit'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_59__mixins_loader__["a" /* default */]],
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_2__components_generics_modal_modal_vue__["a" /* default */],
    announcement: __WEBPACK_IMPORTED_MODULE_41__components_announcement_announcement_vue__["a" /* default */],
    affiliationsPopup: __WEBPACK_IMPORTED_MODULE_40__components_profile_affiliations_popup_affiliations_popup_vue__["a" /* default */],
    addFundsCombined: __WEBPACK_IMPORTED_MODULE_17__components_wallet_add_funds_combined_add_funds_combined_vue__["a" /* default */],
    addFundsCombinedFooter: __WEBPACK_IMPORTED_MODULE_18__components_wallet_add_funds_combined_footer_footer_vue__["a" /* default */],
    accountDetailsVerify: __WEBPACK_IMPORTED_MODULE_12__components_account_account_details_modal_account_details_verify_vue__["a" /* default */],
    accountUploadId: __WEBPACK_IMPORTED_MODULE_13__components_account_account_upload_id_account_upload_id_vue__["a" /* default */],
    accountUploadDocument: __WEBPACK_IMPORTED_MODULE_14__components_account_account_upload_document_account_upload_document_vue__["a" /* default */],
    accountDetailsUpdateModal: __WEBPACK_IMPORTED_MODULE_15__components_account_account_details_modal_account_details_update_modal_vue__["a" /* default */],
    accountLogin: __WEBPACK_IMPORTED_MODULE_5__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_6__components_account_account_login_footer_footer_vue__["a" /* default */],
    accountForgotten: __WEBPACK_IMPORTED_MODULE_7__components_account_account_forgotten_account_forgotten_vue__["a" /* default */],
    accountForgottenFooter: __WEBPACK_IMPORTED_MODULE_8__components_account_account_forgotten_footer_footer_vue__["a" /* default */],
    accountRegister: __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__["a" /* default */],
    accountRegisterExternal: __WEBPACK_IMPORTED_MODULE_11__components_account_account_register_external_account_register_external_vue__["a" /* default */],
    accountUpdateImage: __WEBPACK_IMPORTED_MODULE_16__components_account_account_update_image_account_update_image_vue__["a" /* default */],
    attachToHome: __WEBPACK_IMPORTED_MODULE_28__components_attach_to_home_attach_to_home_vue__["a" /* default */],
    deposited: __WEBPACK_IMPORTED_MODULE_19__components_wallet_deposited_deposited_vue__["a" /* default */],
    genericPopup: __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_layouts_generic_vue__["a" /* default */],
    genericSmallPopup: __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_small_vue__["a" /* default */],
    offersIndicatorPopup: __WEBPACK_IMPORTED_MODULE_29__components_offers_indicator_popup_offers_indicator_popup_vue__["a" /* default */],
    potentialPayouts: __WEBPACK_IMPORTED_MODULE_20__components_potential_payouts_potential_payouts_vue__["a" /* default */],
    smallModal: __WEBPACK_IMPORTED_MODULE_21__components_generics_modal_small_small_vue__["default"],
    exportHistory: __WEBPACK_IMPORTED_MODULE_22__components_export_history_export_history_vue__["a" /* default */],
    insightModal: __WEBPACK_IMPORTED_MODULE_23__components_insight_insight_modal_insight_modal_vue__["a" /* default */],
    research: __WEBPACK_IMPORTED_MODULE_24__components_research_research_vue__["a" /* default */],
    taxInfoNotification: __WEBPACK_IMPORTED_MODULE_25__components_tax_info_notification_tax_info_notification_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_26__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    newsFeed: __WEBPACK_IMPORTED_MODULE_27__components_home_home_old_news_feed_news_feed_vue__["a" /* default */],
    marketContractsStatsPopup: __WEBPACK_IMPORTED_MODULE_30__components_market_market_contracts_stats_popup_market_contracts_stats_popup_vue__["a" /* default */],
    accountResetPassword: __WEBPACK_IMPORTED_MODULE_31__components_account_account_reset_password_account_reset_password_vue__["a" /* default */],
    orientationInfo: __WEBPACK_IMPORTED_MODULE_32__components_orientation_info_orientation_info_vue__["a" /* default */],
    accountBadgesList: __WEBPACK_IMPORTED_MODULE_33__components_account_account_badges_list_account_badges_list_vue__["a" /* default */],
    userProfileOverview: __WEBPACK_IMPORTED_MODULE_34__components_social_user_profile_overview_user_profile_overview_vue__["a" /* default */],
    userProfileOverviewHeader: __WEBPACK_IMPORTED_MODULE_35__components_social_user_profile_overview_header_user_profile_overview_header_vue__["a" /* default */],
    userReport: __WEBPACK_IMPORTED_MODULE_36__components_social_user_report_user_report_vue__["a" /* default */],
    leaderboardsTrophyPyramid: __WEBPACK_IMPORTED_MODULE_37__components_leaderboards_leaderboards_trophy_pyramid_leaderboards_trophy_pyramid_vue__["a" /* default */],
    messagingJourneyInfo: __WEBPACK_IMPORTED_MODULE_38__components_messaging_journey_info_messaging_journey_info_vue__["a" /* default */],
    coinbaseProcessOverview: __WEBPACK_IMPORTED_MODULE_39__components_wallet_coinbase_process_overview_coinbase_process_overview_vue__["a" /* default */],
    accountAlreadyExists: __WEBPACK_IMPORTED_MODULE_43__components_account_account_already_exists_account_already_exists_vue__["a" /* default */],
    accountAlreadyExistsFooter: __WEBPACK_IMPORTED_MODULE_44__components_account_account_already_exists_footer_footer_vue__["a" /* default */],
    accountEnableClassicPredictit: __WEBPACK_IMPORTED_MODULE_45__components_account_account_enable_classic_predictit_account_enable_classic_predictit_vue__["a" /* default */],
    accountEnableClassicPredictitFooter: __WEBPACK_IMPORTED_MODULE_46__components_account_account_enable_classic_predictit_footer_footer_vue__["a" /* default */],
    marketOwnershipConflictModal: __WEBPACK_IMPORTED_MODULE_47__components_market_market_ownership_conflict_modal_market_ownership_conflict_modal_vue__["a" /* default */],
    accountTwoFactorVerify: __WEBPACK_IMPORTED_MODULE_48__components_account_account_two_factor_verify_account_two_factor_verify_vue__["a" /* default */],
    accountTwoFactorPrompt: __WEBPACK_IMPORTED_MODULE_49__components_account_account_two_factor_prompt_account_two_factor_prompt_vue__["a" /* default */],
    accountPhoneUpdate: __WEBPACK_IMPORTED_MODULE_50__components_account_account_phone_update_account_phone_update_vue__["a" /* default */],
    marketRules: __WEBPACK_IMPORTED_MODULE_42__components_market_market_rules_market_rules_vue__["a" /* default */],
    purchaseReviewAndConfirmSushi: __WEBPACK_IMPORTED_MODULE_51__components_purchase_sushi_purchase_review_and_confirm_sushi_purchase_review_and_confirm_sushi_vue__["a" /* default */],
    shareInfoPopup: __WEBPACK_IMPORTED_MODULE_53__components_purchase_sushi_share_info_popup_share_info_popup_vue__["a" /* default */],
    captcha: __WEBPACK_IMPORTED_MODULE_56__components_forms_captcha_captcha_vue__["a" /* default */],
    priceOddsTogglePopup: __WEBPACK_IMPORTED_MODULE_52__components_market_price_odds_toggle_popup_price_odds_toggle_popup_vue__["a" /* default */],
    whatIsNewPopup: __WEBPACK_IMPORTED_MODULE_54__components_what_is_new_popup_what_is_new_popup_vue__["a" /* default */],
    whatIsNewPopupFooter: __WEBPACK_IMPORTED_MODULE_55__components_what_is_new_popup_what_is_new_popup_footer_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['isTaxNotificationMandatory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup', 'currentPopupOptions', 'lastTopPosition', 'tradePopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['status', 'registrationFlowActive', 'twoFactorEnabled']), {
    canCloseAuth: function canCloseAuth() {
      return this.$route.name !== 'disqus-auth';
    },
    footerHideBodyClass: function footerHideBodyClass() {
      return this.currentPopupOptions.hideFooter ? 'modal__body--medium modal__footer--hide' : 'modal__body--medium';
    }
  }),
  watch: {
    // Reset loading state when reCAPTCHA modal closes
    currentPopup: function currentPopup(newVal) {
      if (newVal !== MODALS.RECAPTCHA_CHALLENGE) {
        this.recaptchaVerifying = false;
      }
    },

    // Reset loading state when popup options change (new v2 challenge)
    currentPopupOptions: function currentPopupOptions() {
      // Always reset verifying state when options change - this handles the case
      // where we show a new v2 challenge while the modal is already showing
      if (this.currentPopup === MODALS.RECAPTCHA_CHALLENGE) {
        this.recaptchaVerifying = false;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingsAnnouncementCurState']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupWithDelay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['setCurrentDeposit', 'markFirstDepositDone']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout', 'endRegistrationFlow']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', { hideOverlay: 'hide' }), {
    isCurrentModal: function isCurrentModal(name) {
      return this.currentPopup === name;
    },
    isCurrentSmallModal: function isCurrentSmallModal(name) {
      return this.currentSmallPopup === name;
    },
    closeModal: function closeModal() {
      this.setCurrentPopup();
      this.onClose();
    },
    closeSmallModal: function closeSmallModal() {
      this.setCurrentSmallPopup();
      this.onClose();
    },
    closeModalWithLogout: function closeModalWithLogout() {
      this.logout();
      this.setCurrentPopup();
      this.onClose();
    },
    closePaymentSuccessModal: function closePaymentSuccessModal() {
      this.markFirstDepositDone();
      this.setCurrentPopup();
      this.setCurrentDeposit(null);
      this.onClose();
    },
    closeModalHideOverlay: function closeModalHideOverlay() {
      this.setCurrentPopup();
      this.hideOverlay();
      this.onClose();
    },
    closeUserReportModal: function closeUserReportModal() {
      this.setCurrentSmallPopup(MODALS.SMALL_USER_PROFILE);
    },
    closeWhatIsNewPopup: function closeWhatIsNewPopup() {
      var _this = this;

      this.loaderAdd(document.body);
      this.setSettingsAnnouncementCurState(__WEBPACK_IMPORTED_MODULE_58__components_what_is_new_popup_helpers__["b" /* VERSION_TO_MIGRATE_TO */]).then(function () {
        _this.loaderRemove(document.body);
        _this.closeModal();
      }).catch(function () {
        _this.closeModal();
        _this.loaderRemove(document.body);
      });
    },
    onClose: function onClose() {
      if (this.currentPopupOptions && typeof this.currentPopupOptions.onClose !== 'undefined') {
        this.currentPopupOptions.onClose.apply(this);
      }
    },
    onRecaptchaChallengeComplete: function onRecaptchaChallengeComplete(token) {
      // When v2 captcha is completed, show loading state while API processes
      if (token && this.currentPopupOptions && typeof this.currentPopupOptions.onVerified === 'function') {
        this.recaptchaVerifying = true;
        this.currentPopupOptions.onVerified(token);
      }
    },
    addFundsClose: function addFundsClose() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Closing/Cancel Deposit Modal'
      });
      // Chain to next modal in priority order: AFFILIATIONS → TWO_FACTOR_PROMPT
      if (this.status && this.status.isUCAffilSet === null) {
        this.setCurrentPopup(MODALS.AFFILIATIONS);
      } else if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when ACCOUNT_VERIFY (Personal Details) modal is closed during registration
    closeAccountVerifyModal: function closeAccountVerifyModal() {
      // Closed without completion - check 2FA as final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },
    paymentSuccessDone: function paymentSuccessDone() {
      // Chain to next modal in priority order: AFFILIATIONS → TWO_FACTOR_PROMPT
      if (this.status && this.status.isUCAffilSet === null) {
        this.setCurrentPopupWithDelay({ name: MODALS.AFFILIATIONS });
      } else if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when AFFILIATIONS (College Affiliation) modal is closed during registration
    closeAffiliationsModal: function closeAffiliationsModal() {
      // Affiliations is second-to-last - 2FA prompt is final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when affiliations form is submitted successfully
    onAffiliationsSubmitted: function onAffiliationsSubmitted() {
      // Same as close - 2FA prompt is final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(MODALS.TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    }
  }),
  data: function data() {
    return {
      MODALS: MODALS,
      constants: __WEBPACK_IMPORTED_MODULE_57__constants__["a" /* default */],
      recaptchaVerifying: false,
      gtmAddFunds: {
        virtualPage: '/Account/_DptFrmUsSgnUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Deposit',
          action: 'click',
          label: 'Closing Deposit Modal'
        }
      },
      gtmAccountVerify: {
        virtualPage: '_SgnUpDptIDV',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'ID Verification',
          action: 'click',
          label: 'Closing ID Verification Modal'
        }
      },
      gtmLogin: {
        name: 'login',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Login',
          action: 'click',
          label: 'Closing Login Modal'
        }
      },
      gtmSignUp: {
        virtualPage: '/Account/SignUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Registration',
          action: 'click',
          label: 'Closing Registration Modal'
        }
      }
    };
  }
});

/***/ }),

/***/ "HPJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "HQPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"market-settings-button",class:{
    'market-settings-button--disabled': _vm.disabled,
    'market-settings-button--theme-details': _vm.theme === 'details',
  },attrs:{"aria-label":"Open Trade Experience Settings"},on:{"click":_vm.onToggle}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HSd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_videos_js__ = __webpack_require__("7wxw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2858168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videos_vue__ = __webpack_require__("m/0L");
function injectStyle (ssrContext) {
  __webpack_require__("iJBb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_videos_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2858168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hi7N":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyMyIgaGVpZ2h0PSIxNSIgcng9IjcuNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuMSIvPgo8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNiIgZmlsbD0iI0NFRDJEQiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "HkCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_info_js__ = __webpack_require__("TONy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578ce4fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_info_vue__ = __webpack_require__("RO1L");
function injectStyle (ssrContext) {
  __webpack_require__("5ywO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578ce4fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HpV6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "HqNE":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAuMzg0IiBoZWlnaHQ9IjQyLjU0MSIgdmlld0JveD0iMCAwIDMwLjM4NCA0Mi41NDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUuMTkyIDRWMzguNTQxTTMuNSAyNi44NDlMMTUuMTkyIDM4LjU0MUwyNi44ODQgMjYuODQ5IiBzdHJva2U9IiNEOTUzNEYiIHN0cm9rZS13aWR0aD0iNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "HvTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_bar_js__ = __webpack_require__("Paoj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2fa3c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_bar_vue__ = __webpack_require__("IvC7");
function injectStyle (ssrContext) {
  __webpack_require__("BYVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2fa3c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hxoi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_my_orders_sushi_js__ = __webpack_require__("xw4J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122be1f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_my_orders_sushi_vue__ = __webpack_require__("WcTM");
function injectStyle (ssrContext) {
  __webpack_require__("nLQ2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_my_orders_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122be1f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_my_orders_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HzXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_biggest_gains_element_market_biggest_gains_element_vue__ = __webpack_require__("4vD6");










var REFRSEH_ENABLED = true;
var REFRESH_INTERVAL = 10 * 60 * 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiperSlide"],
    marketBiggestGainsElement: __WEBPACK_IMPORTED_MODULE_7__components_market_market_biggest_gains_element_market_biggest_gains_element_vue__["a" /* default */]
  },
  props: {
    headerId: {
      type: Number,
      default: 0
    },
    extended: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    return {
      activeIndex: 0,
      interval: null,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('browse', ['getTwentyFourGains', 'getTwentyFourLoss', 'getWeekGains', 'getWeekLoss']), {
    prevSlide: function prevSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slideNext();
    },
    fetchData: function fetchData() {
      var _this2 = this;

      var promises = [this.getTwentyFourGains({}), this.getTwentyFourLoss({}), this.getWeekGains({}), this.getWeekLoss({})];

      this.loaderAdd();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this2.isComponentReady = true;
        _this2.loaderRemove();
      }).catch(function () {
        return _this2.loaderRemove();
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('browse', ['twentyFourGains', 'twentyFourLoss', 'weekGains', 'weekLoss']), {
    classModifiers: function classModifiers() {
      return {
        'market-biggest-gains': true,
        'market-biggest-gains--extended': this.extended
      };
    },
    dummyComponents: function dummyComponents() {
      if (this.isLayoutMobile) return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, 1);
      var num = this.extended ? 4 : 2;
      return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, num);
    },
    items: function items() {
      var results = [];
      if (this.isLayoutDesktop) {
        if (this.twentyFourGains.length) results.push(this.twentyFourGains[0]);
        if (this.twentyFourLoss.length) results.push(this.twentyFourLoss[0]);
        if (this.extended) {
          if (this.weekGains.length) results.push(this.weekGains[0]);
          if (this.weekLoss.length) results.push(this.weekLoss[0]);
        }
      } else {
        if (this.twentyFourGains.length) results.push(this.twentyFourGains);
        if (this.twentyFourLoss.length) results.push(this.twentyFourLoss);
        if (this.extended) {
          if (this.weekGains.length) results.push(this.weekGains);
          if (this.weekLoss.length) results.push(this.weekLoss);
        }
      }
      return results;
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === 3;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--left': true
        // 'market-biggest-gains__swiper-arrows__arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--right': true
        // 'market-biggest-gains__swiper-arrows__arrow--disabled': this.isNextArrowDisabled,
      };
    },
    shouldShowMobileSlider: function shouldShowMobileSlider() {
      return this.items.length > 0 && !this.isLayoutDesktop;
    },
    shouldShowDesktopList: function shouldShowDesktopList() {
      return this.items.length > 0 && this.isLayoutDesktop;
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.fetchData();
    if (REFRSEH_ENABLED) {
      this.interval = setInterval(function () {
        _this3.fetchData();
      }, REFRESH_INTERVAL);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
});

/***/ }),

/***/ "I+d5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I+ky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_v2_button_price_button_price_vue__ = __webpack_require__("al65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__ = __webpack_require__("tRmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__ = __webpack_require__("azKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__ = __webpack_require__("X4WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_market_ownership_and_orders_bar_market_ownership_and_orders_bar_vue__ = __webpack_require__("Pf5Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_modules_app__ = __webpack_require__("WSTi");


/* eslint-disable */














var firstNonEmptyString = function firstNonEmptyString() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value === 'string' && value.trim() !== '';
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__["a" /* default */]],
  components: {
    buttonPrice: __WEBPACK_IMPORTED_MODULE_6__components_market_v2_button_price_button_price_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_5__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */],
    marketDisabledOutcomeV2: __WEBPACK_IMPORTED_MODULE_9__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__["a" /* default */],
    marketTradingUnavailableV2: __WEBPACK_IMPORTED_MODULE_10__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__["a" /* default */],
    marketOwnershipAndOrdersBar: __WEBPACK_IMPORTED_MODULE_13__components_market_market_ownership_and_orders_bar_market_ownership_and_orders_bar_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    },
    dashboardMode: {
      type: Boolean,
      default: false
    },
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false
    },
    mobileLayout: {
      type: Number,
      default: null
    },
    showSharesOwnedIconOnImage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      BUTTONS: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */],
      OPERATIONS: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */],
      VALUES: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */],
      isWaiting: false,
      activeButton: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES.id,
      chart: null,
      sellDisabledTooltipText: "You don't have any shares available to sell."
    };
  },
  mounted: function mounted() {
    this.initializePurchaseButtons();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'currentPriceSymbol']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode', 'hidePurchaseForContractId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['settingShowOdds', 'settingMobileLayout']), {
    hasExplicitMobileLayout: function hasExplicitMobileLayout() {
      return this.mobileLayout !== null;
    },
    effectiveMobileLayout: function effectiveMobileLayout() {
      if (this.hasExplicitMobileLayout) {
        return this.mobileLayout;
      }

      return this.settingMobileLayout;
    },
    isSimplifiedMobileLayout: function isSimplifiedMobileLayout() {
      return this.isLayoutMobile && this.effectiveMobileLayout === __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].SIMPLIFIED;
    },
    isStandardMobileLayout: function isStandardMobileLayout() {
      if (this.forCmsWidget) {
        return true;
      }
      return this.isLayoutMobile && this.effectiveMobileLayout === __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].STANDARD;
    },
    isCondensedMobileLayout: function isCondensedMobileLayout() {
      return this.isLayoutMobile && this.effectiveMobileLayout === __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED && !this.forCmsWidget;
    },
    hideButtons: function hideButtons() {
      if (this.forCmsWidget && this.isMarketDisabled) {
        return true;
      }
      if (this.isLayoutMobile && this.isMarketDisabled) {
        return true;
      }

      return this.isSimplifiedMobileLayout && !this.isMarketDisabled && (!this.isContractActive || this.hidePurchaseForContractId === this.contract.contractId);
    },
    isContractActive: function isContractActive() {
      return this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId;
    },
    isButtonPriceActive: function isButtonPriceActive() {
      return this.isContractActive;
    },
    showActiveButtonSecondaryPrice: function showActiveButtonSecondaryPrice() {
      return this.isButtonPriceActive && !this.isCondensedMobileLayout;
    },
    tradeOperationAndValue: function tradeOperationAndValue() {
      return {
        type: this.tradeOptions.operationType,
        value: this.tradeOptions.operationValue
      };
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    singleMarketTitle: function singleMarketTitle() {
      return firstNonEmptyString(this.market && this.market.marketShortName, this.contractModel.contractName, this.contractModel.name);
    },
    title: function title() {
      return this.isMarketSingle ? this.singleMarketTitle : this.contractModel.contractName || this.contractModel.name;
    },
    classModifiers: function classModifiers() {
      return {
        'market-contract-horizontal-sushi-common-betslip': true,
        'market-contract-horizontal-sushi-common-betslip--show-shares-owned-on-image': this.showSharesOwnedIconOnImage,
        'market-contract-horizontal-sushi-common-betslip--disabled': this.isMarketDisabled,
        'market-contract-horizontal-sushi-common-betslip--hovered': this.hovered,
        'market-contract-horizontal-sushi-common-betslip--settled': this.isMarketSettled,
        'market-contract-horizontal-sushi-common-betslip--settled-yes': this.isMarketSettled && this.isWinnerYes,
        'market-contract-horizontal-sushi-common-betslip--settled-no': this.isMarketSettled && this.isWinnerNo,
        'market-contract-horizontal-sushi-common-betslip--should-close': this.isContractActive,
        'market-contract-horizontal-sushi-common-betslip--with-ownership-and-orders': this.showOwnershipAndOrdersSummary,
        'market-contract-horizontal-sushi-common-betslip--dashboard': this.dashboardMode,
        'market-contract-horizontal-sushi-common-betslip--cms-widget': this.forCmsWidget,
        'market-contract-horizontal-sushi-common-betslip--standard': this.hasExplicitMobileLayout && this.isStandardMobileLayout,
        'market-contract-horizontal-sushi-common-betslip--simplified': this.hasExplicitMobileLayout && this.isSimplifiedMobileLayout,
        'market-contract-horizontal-sushi-common-betslip--condensed': this.isCondensedMobileLayout
      };
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    sharesOwnedStyleModifiers: function sharesOwnedStyleModifiers() {
      return {
        'market-contract-horizontal-sushi-common-betslip__image-shares-owned': true,
        'market-contract-horizontal-sushi-common-betslip__image-shares-owned--no': this.contractModel.mode === 'no'
      };
    },
    showOpenOffers: function showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar: function showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    showSharesBarBottom: function showSharesBarBottom() {
      return this.showSharesBar && this.isMarketDisabled;
    },
    showOwnershipAndOrdersSummary: function showOwnershipAndOrdersSummary() {
      return this.showOwnershipAndOrdersBar && !this.isMarketSettled && (this.showSharesBar || this.showOpenOffers);
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    isMarketJourneyDisabled: function isMarketJourneyDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["y" /* isMarketJourneyDisabled */])(this.market);
    },
    currentPrice: function currentPrice() {
      if (!this.contractModel.hasLastTradePrice) {
        return 0;
      }

      if (this.dashboardMode && this.contractModel.mode === 'no') {
        return 100 - this.contractModel.lastTradePriceAsCents;
      }
      return this.contractModel.lastTradePriceAsCents;
    },
    isWinnerYes: function isWinnerYes() {
      return this.contract.settledStatus === 1;
    },
    isWinnerNo: function isWinnerNo() {
      return this.isMarketSingle && this.contract.settledStatus === 2;
    },
    isContractSaleDisabled: function isContractSaleDisabled() {
      return this.contractModel.userQuantity === 0;
    },
    showNoPriceHintTitle: function showNoPriceHintTitle() {
      return this.dashboardMode && this.isLayoutMobile && this.contractModel.mode === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO && this.currentPrice > 0;
    },
    noPriceHintTitle: function noPriceHintTitle() {
      return this.settingShowOdds ? 'NO Odds' : 'NO Price';
    }
  }),
  watch: {
    // isContractActive(value) {
    //   if (this.isLayoutDesktop) {
    //     if (!value) {
    //       this.activeButton = BUTTONS.BUY_YES.id;
    //     }
    //   }
    // },
    'tradeOperationAndValue': function tradeOperationAndValue(v) {
      if (this.contract.contractId !== this.tradeOptions.contractId) {
        return;
      }
      var type = v.type,
          value = v.value;

      if (type && value) {
        if (type === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */].SELL) {
          this.activeButton = value === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES ? __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].SELL_YES.id : __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].SELL_NO.id;
        } else {
          this.activeButton = value === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES ? __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES.id : __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_NO.id;
        }
      }
    },
    tradeOperationToggle: function tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      var button = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["d" /* getActiveButtonAfterSwitch */])(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation', 'toggleHidePurchaseForContractId', 'setBottomBetSlipExtendedMode', 'setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    getDefaultButtonForContract: function getDefaultButtonForContract() {
      return this.contractModel.mode === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO ? __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_NO : __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES;
    },
    getButtonForTradeOptions: function getButtonForTradeOptions() {
      var _this = this;

      if (!this.tradeOptions || !this.tradeOptions.operationType || !this.tradeOptions.operationValue) {
        return this.getDefaultButtonForContract();
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */]).find(function (button) {
        return button.type === _this.tradeOptions.operationType && button.value === _this.tradeOptions.operationValue;
      }) || this.getDefaultButtonForContract();
    },
    findActiveButton: function findActiveButton() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */]).find(function (i) {
        return i.id === _this2.activeButton;
      });
    },
    getTypeAndValueIfButtonActiveOrDefaults: function getTypeAndValueIfButtonActiveOrDefaults() {
      var type = this.tradeOptions.operationType;
      var value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        var button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type: type, value: value };
    },
    onClickOpenOffers: function onClickOpenOffers() {
      var _getTypeAndValueIfBut = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut.type,
          value = _getTypeAndValueIfBut.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    initializePurchaseButtons: function initializePurchaseButtons() {
      var button = this.getDefaultButtonForContract();
      this.activeButton = button.id;

      if ((!this.isMarketSingle || this.isLayoutMobile) && this.tradeOptions && this.contract.contractId === this.tradeOptions.contractId && (button.type !== this.tradeOptions.operationType || button.value !== this.tradeOptions.operationValue)) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
      }
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    },
    onContractClick: function onContractClick() {
      if (this.isCondensedMobileLayout) {
        var _getTypeAndValueIfBut2 = this.getTypeAndValueIfButtonActiveOrDefaults(),
            type = _getTypeAndValueIfBut2.type,
            value = _getTypeAndValueIfBut2.value;

        this.openPurchaseJourney(this.contractModel.contractId, type, value);
        return;
      }

      if (this.isContractActive && this.isLayoutMobile) {
        if (this.dashboardMode) {
          this.setTradeOptions(null);
          return;
        }
      }

      if (this.tradeOptions.contractId !== this.contract.contractId) {
        var button = this.getDefaultButtonForContract();
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, true);
      } else {
        this.toggleHidePurchaseForContractId(this.contractModel.contractId);
      }
    },
    isButtonActiveClassModifiers: function isButtonActiveClassModifiers(index) {
      var selectedButton = this.isContractActive ? this.getButtonForTradeOptions() : null;
      var isOn = !!selectedButton && selectedButton.id === index;

      return {
        'market-contract-horizontal-sushi-common-betslip__button-single--active': this.isContractActive,
        'market-contract-horizontal-sushi-common-betslip__button-single--on': isOn,
        'market-contract-horizontal-sushi-common-betslip__button-single--off': !isOn,
        'market-contract-horizontal-sushi-common-betslip__button-single--off-yes': this.tradeOptions.operationValue === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES,
        'market-contract-horizontal-sushi-common-betslip__button-single--off-no': this.tradeOptions.operationValue === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var dontExtendMobileBetslip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (this.isWaiting) {
        return;
      }

      // this.isWaiting = true;
      // waitForFirebaseInitialized()
      //   .then(() => {
      //   if (this.isLoggedIn) {
      //     return waitForStatusReady();
      //   }
      //   return Promise.resolve(1);
      // })
      //   .then(() => {
      //
      //   });

      this.isWaiting = false;
      // contract does not modify tradeOptions, is simply used as a widget somewhere
      if (this.forCmsWidget) {
        this.$emit('contractClicked', { contractId: contractId });
        return;
      }
      // if (this.isLoggedIn && !this.isUserVerified) {
      //   this.showAccountVerifyPopup();
      //   return;
      // }
      // if (this.isLoggedIn && !this.status.hasBeenFunded) {
      //   this.showAddFundsPopup({ delay: false });
      //   return;
      // }
      if (this.isMarketJourneyDisabled || this.isMarketDisabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["w" /* contractOwnershipNum */])(this.contractModel) === 0) return;

      this.pushSessionHistoryContract({
        value: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.contract, {
          marketName: this.market.marketShortName || this.market.marketName
        })
      });
      this.setTradeOptions({
        contractId: contractId,
        operationType: operationType,
        operationValue: operationValue !== null ? operationValue : this.contractModel.mode || __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES
      });
      if (!dontExtendMobileBetslip) {
        this.setBottomWidgetFooterMode(__WEBPACK_IMPORTED_MODULE_12__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP);
        if (this.isLayoutMobile) {
          this.setBottomWidgetFooterModeContractsSection(__WEBPACK_IMPORTED_MODULE_12__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP);
        }
        this.setBottomBetSlipExtendedMode(true);
      }
    }
  })
});

/***/ }),

/***/ "I1/e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I4Gm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I4ul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fields: {
        newPassword: null,
        newPasswordConfirmation: null
      },
      error: null,
      isAddingExternal: false // Guard against duplicate API calls from race condition
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasMaintenance']), {
    searchQuery: function searchQuery() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["I" /* parseQuery */])(window.location.search);
    },
    hashQuery: function hashQuery() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["I" /* parseQuery */])(window.location.hash);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['addExternal', 'setToken', 'setRefreshToken', 'getUserInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {
    handleAdd: function handleAdd() {
      var _this = this;

      // Prevent duplicate calls caused by both app.js and this component calling getUserInfo()
      if (this.isAddingExternal) return;
      this.isAddingExternal = true;

      var payload = {
        externalAccessToken: this.hashQuery.access_token
      };
      this.addExternal(payload).then(function () {
        return _this.goToTarget();
      }).catch(function () {
        return _this.handleError();
      });
    },
    handleRegister: function handleRegister() {
      this.$router.push({ name: 'home' });
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER_EXTERNAL);
    },
    handleLogin: function handleLogin() {
      this.setProfileStatus({ event: 'login' });
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('externalToken');
      if (this.hashQuery.refresh_token) {
        this.setRefreshToken(this.hashQuery.refresh_token);
      }
      this.setToken(this.hashQuery.access_token);
      this.goToTarget();
    },
    handleError: function handleError() {
      var _this2 = this;

      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Login Cancelled or Failed.';

      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('externalToken');
      this.setErrorSideNotification(message);
      setTimeout(function () {
        return _this2.$router.push({ name: 'home' });
      }, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT);
    },
    goToTarget: function goToTarget() {
      if (this.searchQuery.redirect) {
        this.$router.push(this.searchQuery.redirect);
      } else {
        this.$router.push({ name: 'home' });
      }
    }
  }),
  watch: {
    userInfo: function userInfo(data) {
      if (this.searchQuery.type === __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].SOCIAL_LOGIN_ADD) {
        this.handleAdd();
      } else if (!this.hasMaintenance && data && data.hasRegistered === false) {
        this.handleRegister();
      } else if (data && data.hasRegistered === true) {
        this.handleLogin();
      } else {
        this.handleError();
      }
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.hashQuery.access_token) {
      if (this.searchQuery.type === __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].SOCIAL_LOGIN_OR_REGISTER) {
        __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('externalToken', this.hashQuery.access_token);
      }
      this.getUserInfo().catch(function () {
        return _this3.handleError();
      });
    } else if (this.hashQuery.error) {
      this.handleError();
    }
  }
});

/***/ }),

/***/ "I7Sp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1-footer"},[(!_vm.isFirstStep)?_c('div',{staticClass:"what-is-new-flow-version-1-footer__button what-is-new-flow-version-1-footer__button--prev",class:{'what-is-new-flow-version-1-footer__button--disabled': _vm.isLoading},on:{"click":_vm.onPreviousStep}},[_vm._v("\n    Back\n  ")]):_c('div',{staticClass:"what-is-new-flow-version-1-footer__empty"},[_vm._v(" ")]),_vm._v(" "),(!(_vm.isLayoutMobile && _vm.isLastStep))?_c('div',{staticClass:"what-is-new-flow-version-1-footer__dots"},_vm._l((Object.values(_vm.STEPS)),function(step){return _c('div',{key:step,staticClass:"what-is-new-flow-version-1-footer__dot",class:{'what-is-new-flow-version-1-footer__dot--current': _vm.currentStepIndexFlow1 === step}})}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1-footer__button what-is-new-flow-version-1-footer__button--next",class:{'what-is-new-flow-version-1-footer__button--disabled': _vm.isLoading},on:{"click":_vm.onNextStep}},[(_vm.isLastStep)?[_vm._v("\n      Start Predicting\n    ")]:[_vm._v("\n      Next\n    ")]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I7u4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transactions"},[_c('div',{staticClass:"row row-xy"},[_c('div',{staticClass:"column small-8"},[_c('form-select',{attrs:{"searchable":false,"placeholder":"Type","options":_vm.transactionFilters.typeOptions,"track-by":"value","label":"label"},model:{value:(_vm.filter.type),callback:function ($$v) {_vm.$set(_vm.filter, "type", $$v)},expression:"filter.type"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('form-select',{attrs:{"searchable":false,"maxHeight":300,"placeholder":"Year","options":_vm.transactionFilters.yearOptions,"track-by":"value","label":"label"},model:{value:(_vm.filter.year),callback:function ($$v) {_vm.$set(_vm.filter, "year", $$v)},expression:"filter.year"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('balance-history',{key:("cancelCounter--" + _vm.cancelCounter),attrs:{"type":_vm.filter.type.value,"items":_vm.items,"canLoadMore":_vm.canLoadMore},on:{"itemCancelled":_vm.onItemCancelled,"loading":_vm.loadHistory}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I88n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "II89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_with_info_js__ = __webpack_require__("pgVC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb70a184_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_with_info_vue__ = __webpack_require__("rZUg");
function injectStyle (ssrContext) {
  __webpack_require__("ZQ/I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_with_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb70a184_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_with_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IK/8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lp-1.688eb28.png";

/***/ }),

/***/ "IKgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_mobile_menu_js__ = __webpack_require__("hPGJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f93c9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_mobile_menu_vue__ = __webpack_require__("Dlcl");
function injectStyle (ssrContext) {
  __webpack_require__("erdd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_mobile_menu_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f93c9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_mobile_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IQKx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_plus_minus_sign_plus_minus_sign_vue__ = __webpack_require__("T2le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_empty_state_market_empty_state_vue__ = __webpack_require__("tGGA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__ = __webpack_require__("dDJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");











var MAX_CONTRACTS_NUM = 10;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'standalone'
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    plusMinusSign: __WEBPACK_IMPORTED_MODULE_5__components_generics_plus_minus_sign_plus_minus_sign_vue__["a" /* default */],
    marketContractInfoV2: __WEBPACK_IMPORTED_MODULE_8__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["a" /* default */],
    marketEmptyState: __WEBPACK_IMPORTED_MODULE_6__components_market_market_empty_state_market_empty_state_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isMarketSingle: __WEBPACK_IMPORTED_MODULE_7__utils_helpers__["j" /* isMarketSingle */],
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: __WEBPACK_IMPORTED_MODULE_8__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["b" /* MARKET_CONTRACT_INFO_VALUES_LAYOUT */],
      MAX_CONTRACTS_NUM: MAX_CONTRACTS_NUM,
      dateToString: __WEBPACK_IMPORTED_MODULE_7__utils_helpers__["k" /* dateToString */],
      ready: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['market', 'history', 'reloadHistoryToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('market', ['historyData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'trade-history-sushi': true
      }, 'trade-history-sushi--' + this.type, this.type);
    },
    historyContracts: function historyContracts() {
      return this.historyData.slice(0, MAX_CONTRACTS_NUM);
    }
  }),
  watch: {
    market: {
      handler: 'marketHandler'
    },
    reloadHistoryToggle: function reloadHistoryToggle() {
      this.reloadHistory();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getMarketHistory', 'resetHistory']), {
    showNetPLInfo: function showNetPLInfo() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_TRADE_INFO);
    },
    reformatStringValue: function reformatStringValue(val) {
      if (val.includes('(')) {
        return val.replace('($', '-$').replace(')', '');
      }
      return val;
    },
    itemMainDate: function itemMainDate(item) {
      var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["k" /* dateToString */])(item.dateExecuted).split(' ');
      return v[0];
    },
    itemSecondaryDate: function itemSecondaryDate(item) {
      var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["k" /* dateToString */])(item.dateExecuted).split(' ');
      return v.slice(1, v.length).join(' ');
    },
    itemPriceInCents: function itemPriceInCents(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["h" /* roundToTwo */])(item.pricePerShare * 100);
    },
    tradeActionToString: function tradeActionToString(item) {
      var type = item.tradeType;
      return type === 0 || type === 2 ? 'NO' : 'YES';
    },
    typeToString: function typeToString(item) {
      switch (item.tradeType) {
        case 0: // Buy No
        case 1:
          // Buy Yes
          return 'Bought';
        case 2: // Sell No
        case 3:
          // Sell Yes
          return 'Sold';
        default:
          return 'Closed'; // 4 - Closed
      }
    },
    contractName: function contractName(item) {
      if (item.marketType !== 0) {
        return item.contractName;
      }
      var type = item.tradeType;
      return type === 0 || type === 2 ? 'NO' : 'YES';
    },
    marketHandler: function marketHandler(value) {
      var _this = this;

      if (value) {
        this.loaderAdd();
        this.getMarketHistory({ marketId: this.market.marketId, reload: true }).then(function () {
          _this.ready = true;
          _this.loaderRemove();
        }).catch(function () {
          _this.ready = true;
          _this.loaderRemove();
        });
      }
    },
    reloadHistory: function reloadHistory() {
      var _this2 = this;

      this.loaderAdd();
      this.getMarketHistory({ marketId: this.market.marketId, reload: true }).then(function () {
        _this2.ready = true;
        _this2.loaderRemove();
      }).catch(function () {
        _this2.ready = true;
        _this2.loaderRemove();
      });
    },
    imageStyleModifiers: function imageStyleModifiers(item) {
      return {
        'background-image': 'url(\'' + item.contractImageSmallUrl + '\')'
      };
    }
  }),
  mounted: function mounted() {
    this.marketHandler(this.market);
  }
});

/***/ }),

/***/ "IQRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-levels"},[_c('div',{staticClass:"leaderboards-levels__header"},[_vm._v("\n    Leaderboards\n  ")]),_vm._v(" "),_vm._t("default"),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.loaderItems(7)),function(item){return _c('div',{staticClass:"content-loader-item"},[_c('leaderboards-info-loader')],1)}),0):[(_vm.leaderboards.length > 0)?_c('div',{staticClass:"leaderboards-levels__items"},_vm._l((_vm.leaderboards),function(item){return _c('div',{key:item.leaderBoardId,class:_vm.itemClassModifiers(item),on:{"click":function($event){return _vm.onItemClick(item)}}},[_vm._v("\n        "+_vm._s(_vm._f("pluralize")(item.leaderBoardName))+"\n      ")])}),0):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IS7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"how-it-works-old"},[_c('h2',{staticClass:"how-it-works-old__title"},[(_vm.isUserRestricted)?[_vm._v("\n      Coming Soon\n    ")]:(_vm.isShutdownModeOn)?[_vm._v("\n      How Prediction Markets Work\n    ")]:[_vm._v("\n      How It Works\n    ")]],2),_vm._v(" "),_c('div',{staticClass:"how-it-works-old__items row"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"how-it-works-old__item column small-12 large-4"},[_c('div',{staticClass:"how-it-works-old__item-image-container"},[_c('img',{staticClass:"how-it-works-old__item-image",attrs:{"src":item.icon}})]),_vm._v(" "),_c('h4',{staticClass:"how-it-works-old__item-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"how-it-works-old__item-description"},[_vm._v("\n        "+_vm._s(item.description)+"\n      ")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IUvR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_update_modal_js__ = __webpack_require__("g1ej");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5fba248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_update_modal_vue__ = __webpack_require__("hUJ1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_update_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5fba248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_update_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IW6G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IXeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_range_slider_range_slider_vue__ = __webpack_require__("OKKy");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    rangeSlider: __WEBPACK_IMPORTED_MODULE_3__components_range_slider_range_slider_vue__["a" /* default */]
  },
  props: {
    value: {
      type: Number,
      default: 50
    },
    tabindex: Number,
    selected: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      val: this.value !== null ? parseInt(this.value, 10) : 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    minimumCentValue: function minimumCentValue() {
      return 1;
    },
    maximumCentValue: function maximumCentValue() {
      return 99;
    }
  }),
  watch: {
    val: 'updateOffer',
    value: function value(_value) {
      this.val = _value !== null ? parseInt(_value, 10) : 0;
    }
  },
  methods: {
    add: function add() {
      if (isNaN(this.val) || this.val === null) this.val = this.minimumCentValue;
      this.val += 1;
    },
    subtract: function subtract() {
      if (isNaN(this.val) || this.val === null) this.val = this.minimumCentValue;
      if (this.val === this.minimumCentValue) return;
      this.val -= 1;
    },
    updateOffer: function updateOffer() {
      this.val = parseInt(this.val, 10);
      if (isNaN(this.val) || this.val < 1) this.val = null;else if (this.val > 99) this.val = 99;

      if (this.val !== null) {
        this.$emit('input', Number(this.val));
      } else {
        this.$emit('input', this.val);
      }
    },
    click: function click() {
      this.$emit('click');
    },
    onFocus: function onFocus() {
      var _this = this;

      if (this.isLayoutMobile) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["F" /* lockScroll */])();
      }
      this.$emit('focus');
      var focusAndSelect = function focusAndSelect() {
        var el = _this.$refs && _this.$refs.input;
        if (el && typeof el.select === 'function') {
          el.focus();
          el.select();
          el.setSelectionRange(0, 99);
        }
      };
      this.$nextTick(focusAndSelect);
      setTimeout(focusAndSelect, 50);
    },
    onBlur: function onBlur() {
      this.$emit('blur', this.val);
      if (this.isLayoutMobile) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["E" /* unlockScroll */])();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isLayoutMobile) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["E" /* unlockScroll */])();
    }
  }
});

/***/ }),

/***/ "IYz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__("b4Ty");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a11af04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("TD6b");
function injectStyle (ssrContext) {
  __webpack_require__("Vngw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a11af04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_about__ = __webpack_require__("Ke/w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_browse__ = __webpack_require__("0KBQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_chart__ = __webpack_require__("CPcE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_market__ = __webpack_require__("L09H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_overlay__ = __webpack_require__("X/Fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_popup__ = __webpack_require__("Dwlj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_search__ = __webpack_require__("dI8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_support__ = __webpack_require__("8sRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_wallet__ = __webpack_require__("XWIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_profile__ = __webpack_require__("PMOm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_notifications__ = __webpack_require__("t45u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_insight__ = __webpack_require__("bwq/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_dashboard__ = __webpack_require__("EyqK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_leaderboards__ = __webpack_require__("8mrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_watchlist__ = __webpack_require__("UtW7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_onboarding__ = __webpack_require__("PQ7o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_whatisnew__ = __webpack_require__("+sDo");























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: {
    about: __WEBPACK_IMPORTED_MODULE_2__modules_about__["a" /* default */],
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["f" /* default */],
    browse: __WEBPACK_IMPORTED_MODULE_4__modules_browse__["a" /* default */],
    chart: __WEBPACK_IMPORTED_MODULE_5__modules_chart__["a" /* default */],
    market: __WEBPACK_IMPORTED_MODULE_6__modules_market__["a" /* default */],
    overlay: __WEBPACK_IMPORTED_MODULE_7__modules_overlay__["a" /* default */],
    popup: __WEBPACK_IMPORTED_MODULE_8__modules_popup__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_9__modules_search__["a" /* default */],
    support: __WEBPACK_IMPORTED_MODULE_10__modules_support__["a" /* default */],
    trade: __WEBPACK_IMPORTED_MODULE_11__modules_trade__["b" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_12__modules_user__["a" /* default */],
    wallet: __WEBPACK_IMPORTED_MODULE_13__modules_wallet__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_14__modules_profile__["c" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_15__modules_notifications__["b" /* default */],
    insight: __WEBPACK_IMPORTED_MODULE_16__modules_insight__["a" /* default */],
    dashboard: __WEBPACK_IMPORTED_MODULE_17__modules_dashboard__["a" /* default */],
    leaderboards: __WEBPACK_IMPORTED_MODULE_18__modules_leaderboards__["b" /* default */],
    watchlist: __WEBPACK_IMPORTED_MODULE_19__modules_watchlist__["a" /* default */],
    onboarding: __WEBPACK_IMPORTED_MODULE_20__modules_onboarding__["a" /* default */],
    whatisnew: __WEBPACK_IMPORTED_MODULE_21__modules_whatisnew__["a" /* default */]
  },
  strict: "production" !== 'production'
}));

/***/ }),

/***/ "IdEn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Igwv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  props: {
    token: {
      type: String
    }
  },
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].email,
      newPassword: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].password,
      newPasswordConfirmation: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].passwordConfirmation('newPassword')
    }
  },
  data: function data() {
    return {
      fields: {
        email: '',
        newPassword: null,
        newPasswordConfirmation: null
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['resetPassword']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        this.resetPassword({
          email: this.fields.email,
          password: this.fields.newPassword,
          token: this.token
        }).then(function () {
          _this.setCurrentPopup();
          _this.$router.push({ name: 'home' });
          _this.setSuccessSideNotification('Your password has been changed');
        }).catch(function (errors) {
          _this.formEnable();
          _this.setErrorSideNotification(errors.response.data.message);
        });
      }
    }
  })
});

/***/ }),

/***/ "Ijuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"row news-feed-item",class:_vm.containerModifier,attrs:{"href":_vm.url,"target":_vm.target}},[(_vm.shouldShowImage)?_c('div',{staticClass:"column small-4 news-feed-item__image"},[_c('img',{attrs:{"src":_vm.getItemImage(_vm.data)},on:{"error":_vm.onImageLoadError}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column news-feed-item__content",class:_vm.contentModifier},[_c('h4',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),(_vm.showSubtitle)?_c('h5',{staticClass:"news-feed-item__subtitle"},[_vm._v("\n      "+_vm._s(_vm.data.origin.title)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.data.summary)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.summary.content)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IlLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_invite_friends_js__ = __webpack_require__("GkVD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e49873_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_invite_friends_vue__ = __webpack_require__("2Q+L");
function injectStyle (ssrContext) {
  __webpack_require__("06uq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_invite_friends_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e49873_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_invite_friends_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ilzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_what_is_new_flow_version_1_footer_js__ = __webpack_require__("XcjC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd9b9f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_new_flow_version_1_footer_vue__ = __webpack_require__("I7Sp");
function injectStyle (ssrContext) {
  __webpack_require__("UWaV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_what_is_new_flow_version_1_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd9b9f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_new_flow_version_1_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IpFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"range-slider"},[_c('input',{ref:"slider",staticClass:"slider",attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.sliderValue},on:{"input":function($event){return _vm.setSliderValue($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iuoh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IvC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onClickNumber($event)}}},[_c('span',{staticClass:"market-shares-bar__number"},[_vm._v(_vm._s(_vm.number.toLocaleString()))]),_vm._v(" "),_c('span',{staticClass:"market-shares-bar__mode"},[_vm._v(_vm._s(_vm.mode))])]),_vm._v(" "),_c('div',{staticClass:"market-shares-bar__bottom"},[_c('span',{staticClass:"market-shares-bar__info"},[_vm._v("\n      at "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.average),expression:"average",modifiers:{"cents":true}}]}),_vm._v(" avg.\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-shares-bar__change-price-wrap"},[_c('market-change-price',{attrs:{"price":_vm.difference}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ivan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('account-social-badge'),_vm._v(" "),_c('div',{staticClass:"profile__menu"},_vm._l((_vm.enabledLinks),function(link){return _c('div',{key:link.name},[(link.type === 'header' && _vm.isLinkAvailable(link))?_c('div',{staticClass:"profile__menu-header"},[_vm._v("\n        "+_vm._s(link.name)+"\n      ")]):(link.type === 'line' && _vm.isLinkAvailable(link))?_c('div',{staticClass:"profile__menu-line"}):(link.type === 'logout')?_c('div',{staticClass:"profile__menu-logout",on:{"click":_vm.logoutButton}},[_c('div',{staticClass:"profile__menu-logout-icon"}),_vm._v(" "),_c('div',{staticClass:"profile__menu-logout-text"},[_vm._v("\n          "+_vm._s(link.name)+"\n        ")])]):(link.type === 'link' && _vm.isLinkAvailable(link))?_c('router-link',{class:_vm.profileButtonClass(link),attrs:{"to":link.to,"tag":"div"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-11"},[_c('div',{staticClass:"profile__button-link-name"},[_vm._v("\n              "+_vm._s(link.name)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column small-1"},[_c('div',{staticClass:"profile__button-nav-icon  profile__button-arrow-right"})])])]):_vm._e()],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ivs/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IwtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_disqus_js__ = __webpack_require__("3iU4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed6e6ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_disqus_vue__ = __webpack_require__("eveM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_disqus_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed6e6ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_disqus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J+13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {
      type: Object,
      required: true
    },
    color: {}
  },
  computed: {
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'border-color': this.color,
        'background-image': 'url(' + this.contract.contractImageSmallUrl + ')'
      };
    }
  }
});

/***/ }),

/***/ "J0X6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J1hJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_processing_transaction_js__ = __webpack_require__("qg25");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef3d8632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processing_transaction_vue__ = __webpack_require__("EhAj");
function injectStyle (ssrContext) {
  __webpack_require__("A3lz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_processing_transaction_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef3d8632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processing_transaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J2kF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_item2_js__ = __webpack_require__("eFwA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b304d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_item2_vue__ = __webpack_require__("bAqS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_item2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b304d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_item2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J6HH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-loader"},[_c('div',{staticClass:"notification-loader__avatar"},[_c('div',{staticClass:"notification-loader__avatar-circle"})]),_vm._v(" "),_c('div',{staticClass:"notification-loader__content"},[_c('div',{staticClass:"notification-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"notification-loader__text-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J8fB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-offer-sushi-mobile-bar",class:( _obj = { 'purchase-offer-sushi-mobile-bar--hidden': _vm.isHidden

}, _obj[("purchase-offer-sushi-mobile-bar--" + _vm.bottomWidgetFooterMode)] = _vm.bottomWidgetFooterMode, _obj )},[(_vm.bottomWidgetFooterMode === _vm.BOTTOM_WIDGET_FOOTER_MODES.BETSLIP)?[_c('div',{staticClass:"purchase-offer-sushi-mobile-bar__extended-toggle",on:{"click":_vm.toggleBottomBetslipMode}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(_vm.bottomBetslipExtended)?_c('div',{key:"extended",staticClass:"purchase-offer-sushi-mobile-bar__extended"},[_c('purchase-extended-betslip',{attrs:{"market":_vm.market,"contract":_vm.contract,"showOrderSlip":true,"showOwnershipAndOrdersBar":_vm.showOwnershipAndOrdersBar},on:{"submit":function($event){return _vm.$emit('submit')},"contractInfoClick":_vm.toggleBottomBetslipMode},scopedSlots:_vm._u([{key:"right-side-footer",fn:function(){return [_c('div',{staticClass:"purchase-offer-sushi-mobile-bar__betslip-toggle purchase-offer-sushi-mobile-bar__betslip-toggle--embedded",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.switchTo(_vm.BOTTOM_WIDGET_FOOTER_MODES.TOGGlE)}}})]},proxy:true}],null,false,2691584513)}),_vm._v(" "),_c('div',{staticClass:"purchase-offer-sushi-mobile-bar__extended-close",on:{"click":_vm.toggleBottomBetslipMode}})],1):_c('div',{key:"preview",staticClass:"purchase-offer-sushi-mobile-bar__preview",on:{"click":_vm.toggleBottomBetslipMode}},[_c('div',{staticClass:"purchase-offer-sushi-mobile-bar__preview-contract-image",style:(_vm.contractImageStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"purchase-offer-sushi-mobile-bar__preview-contract"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"purchase-offer-sushi-mobile-bar__preview-contract-name"},[_vm._v("\n            "+_vm._s(_vm.contractName)+"\n          ")]),_vm._v(" "),_c('div',[(_vm.isAvailableForTrade)?_c('span',{staticClass:"purchase-offer-sushi-mobile-bar__preview-contract-submit"},[_vm._v("\n              "+_vm._s((_vm.quantity || '').toLocaleString())+" "+_vm._s(_vm.yesNoText.toUpperCase())+" "),_c('span',[_vm._v("at "+_vm._s(_vm.pricePerShare)+"¢ "+_vm._s(_vm.pricePerShareSuffix))])]):_c('span',{staticClass:"purchase-offer-sushi-mobile-bar__preview-contract-warning"},[_vm._v("\n              "+_vm._s(_vm.tradeOptions.operationValue.toUpperCase())+" blocked by "+_vm._s(_vm.contractModel.mode.toUpperCase())+" positions\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-sushi-mobile-bar__preview-side"},[_c('button',{class:_vm.nextButtonClassModifiers,attrs:{"disabled":_vm.nextButtonDisabled},domProps:{"innerHTML":_vm._s(_vm.nextButtonTitle)},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClickNextButWithSkipDisabled($event)}}}),_vm._v(" "),_c('div',{staticClass:"purchase-offer-sushi-mobile-bar__betslip-toggle",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.switchTo(_vm.BOTTOM_WIDGET_FOOTER_MODES.TOGGlE)}}})])])])]:(_vm.bottomWidgetFooterMode === _vm.BOTTOM_WIDGET_FOOTER_MODES.PINNED)?_c('bottom-market-links-widget',{attrs:{"market":_vm.market},on:{"toggle":function($event){return _vm.switchTo(_vm.BOTTOM_WIDGET_FOOTER_MODES.TOGGlE)}}}):(_vm.bottomWidgetFooterMode === _vm.BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH)?_c('bottom-betslip-shortcut-widget',{on:{"toggle":function($event){return _vm.switchTo(_vm.BOTTOM_WIDGET_FOOTER_MODES.TOGGlE)}}}):(_vm.bottomWidgetFooterMode === _vm.BOTTOM_WIDGET_FOOTER_MODES.TOGGlE)?_c('bottom-market-links-overlay',{attrs:{"navigatedFromContractsSection":_vm.navigatedFromContractsSection,"selectedSection":_vm.selectedSection}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JD5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length > 0)?_c('div',{staticClass:"form-errors"},_vm._l((_vm.errors),function(error,index){return _c('p',{key:index,staticClass:"form-errors__entry",domProps:{"innerHTML":_vm._s(error)}})}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JLAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_keyboard_numeric_input_sushi_js__ = __webpack_require__("RuzB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390081e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_numeric_input_sushi_vue__ = __webpack_require__("RKVE");
function injectStyle (ssrContext) {
  __webpack_require__("EvJc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_keyboard_numeric_input_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390081e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_numeric_input_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JM8M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JNgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"election-map"},[(_vm.type === 'electoral')?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-9"},[_c('div',{staticClass:"election-map__content"},[_c('div',{staticClass:"election-map__title"},[_vm._v("\n          Which party will win the Electoral College?\n        ")]),_vm._v(" "),_c('div',{staticClass:"election-map__toolbar"},[_c('election-map-toolbar',{attrs:{"mapStateData":_vm.mapStateData,"type":"electoral"}})],1),_vm._v(" "),_c('div',{ref:"chart",staticClass:"election-map__chart"})])]),_vm._v(" "),_c('div',{staticClass:"column small-12 large-3"},[_c('overview-map',{attrs:{"mapOverviewData":_vm.mapOverviewData,"type":"electoral"}})],1)]):_vm._e(),_vm._v(" "),(_vm.type === 'senate')?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-9"},[_c('div',{staticClass:"election-map__content"},[_c('div',{staticClass:"election-map__title"},[_vm._v("\n          Which party will win the Senate?\n        ")]),_vm._v(" "),_c('div',{staticClass:"election-map__toolbar"},[_c('election-map-toolbar',{attrs:{"mapStateData":_vm.mapStateDataSenate,"type":"senate"}})],1),_vm._v(" "),_c('div',{ref:"chart",staticClass:"election-map__chart"}),_vm._v(" "),(false)?_c('div',{staticClass:"election-map__special"},[_c('election-map-special')],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column small-12 large-3"},[_c('overview-map',{attrs:{"mapOverviewData":_vm.mapOverviewDataSenate,"type":"senate"}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JOj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_state_button_js__ = __webpack_require__("CG+G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bff113bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_state_button_vue__ = __webpack_require__("nfMg");
function injectStyle (ssrContext) {
  __webpack_require__("iWSG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_state_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bff113bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_state_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JOjr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JSIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'sushi'
    }
  },
  data: function data() {
    return {
      isSelected: this.selected
    };
  },

  computed: {
    buttonModifier: function buttonModifier() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'filter-button--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'filter-button--selected', this.isSelected), _ref;
    }
  },
  methods: {
    toggleFilter: function toggleFilter(e) {
      e.stopPropagation();
      this.isSelected = !this.isSelected;
      if (this.isSelected) {
        this.$emit('addFilter', this.id);
      } else {
        this.$emit('removeFilter', this.id);
      }
    }
  }
});

/***/ }),

/***/ "JSpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_embed_js__ = __webpack_require__("WhZX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b018425_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_embed_vue__ = __webpack_require__("KHbp");
function injectStyle (ssrContext) {
  __webpack_require__("2Kdh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_embed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b018425_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JVxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_money_widget_js__ = __webpack_require__("qXT1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b3e446_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_money_widget_vue__ = __webpack_require__("Zn+p");
function injectStyle (ssrContext) {
  __webpack_require__("itDa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_money_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b3e446_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_money_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JcLu":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCA1MCAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjA4MzAxIDE3LjVDNS4zNTM4NCA4LjkwNjQ5IDE2LjM1MzggMi4wNTg4NCAyNS4wNDEzIDIuMDU4ODRDMzMuNzI4OCAyLjA1ODg0IDQ0LjU0MTMgOS4yMTk0MyA0Ny45MTYzIDE3LjcxNDFNMi4wODMwMSAxNy41QzUuMzUzODQgMjYuMDkzNSAxNi4zNTM4IDMyLjk0MTIgMjUuMDQxMyAzMi45NDEyQzMzLjcyODggMzIuOTQxMiA0NC41NDEzIDI2LjIwODggNDcuOTE2MyAxNy43MTQxIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMi4wODMwMSAxNy41QzUuMzUzODQgOC45MDY0OSAxNi4zNTM4IDIuMDU4ODQgMjUuMDQxMyAyLjA1ODg0QzMzLjcyODggMi4wNTg4NCA0NC41NDEzIDkuMjE5NDMgNDcuOTE2MyAxNy43MTQxQzQ0LjU0MTMgMjYuMjA4OCAzMy43Mjg4IDMyLjk0MTIgMjUuMDQxMyAzMi45NDEyQzE2LjM1MzggMzIuOTQxMiA1LjM1Mzg0IDI2LjA5MzUgMi4wODMwMSAxNy41WiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMwLjQ1NTUgMTcuNUMzMC40NTU1IDIwLjU0NyAyOC4wMTE3IDIzLjAxNTYgMjQuOTk5MiAyMy4wMTU2QzIxLjk4NjcgMjMuMDE1NiAxOS41NDMgMjAuNTQ1IDE5LjU0MyAxNy41QzE5LjU0MyAxNC40NTI5IDIxLjk4NjcgMTEuOTg0NCAyNC45OTkyIDExLjk4NDRDMjguMDExNyAxMS45ODQ0IDMwLjQ1NTUgMTQuNDU1IDMwLjQ1NTUgMTcuNVoiIGZpbGw9IiNEREREREQiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "JdRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-videos"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"home-videos__line"}),_vm._v(" "),_c('div',{staticClass:"home-videos__content"},[_c('youtube',{staticClass:"home-videos__player",attrs:{"player-width":"100%","player-height":240,"video-id":_vm.getYoutubeUrl}}),_vm._v(" "),_c('div',{staticClass:"home-videos__note"},[_vm._v("\n      For more information on how to trade on PredictIt, visit our "),_c('router-link',{staticClass:"home-videos__note-link",attrs:{"to":{name: 'HelpAndSupport'}}},[_vm._v("Support")]),_vm._v(" page.\n    ")],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-videos__header"},[_c('div',{staticClass:"home-videos__header-title"},[_vm._v("\n      How to Open an Account\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jjcr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_cards_americanexpress_jpg__ = __webpack_require__("ZFw9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_cards_americanexpress_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_cards_americanexpress_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_cards_discover_jpg__ = __webpack_require__("OGIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_cards_discover_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_cards_discover_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_mastercard_jpg__ = __webpack_require__("MzT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_mastercard_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_cards_mastercard_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_visa_jpg__ = __webpack_require__("XiJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_visa_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_cards_visa_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_blank_png__ = __webpack_require__("owqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_blank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_cards_blank_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_depositWarningMixin__ = __webpack_require__("Scap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");























var AMOUNT_STEP_ONE = 10;
var AMOUNT_STEP_THREE = 50;
var AMOUNT_STEP_FOUR = 100;
var DEPOSIT_INITIAL = 20;
var DEPOSIT_NON_ZERO_BALANCE = 50;

var STEP_INITIAL = 1;
var STEP_CONFIRM = 2;
var STEP_TRY_AGAIN = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_depositWarningMixin__["a" /* default */]],
  validations: function validations() {
    var rules = {
      fields: {
        name: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required,
        number: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].cardNumber,
        expiryDateMonth: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required,
        expiryDateYear: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required,
        cvv: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].cvv,
        amount: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
      }
    };

    if (this.avsFlag) {
      rules.fields.address = __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required;
      rules.fields.city = __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required;
      rules.fields.zipCode = __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].validateUSZipCode('country');
    }
    return rules;
  },

  components: {
    notificationIcon: __WEBPACK_IMPORTED_MODULE_3__components_notification_icon_notification_icon_vue__["a" /* default */]
  },
  props: {
    instantCreditData: {}
  },
  data: function data() {
    return {
      ready: false,
      canDeposit: false,
      balanceChecked: false,
      step: STEP_INITIAL,
      years: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].expiryYears,
      months: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].months,
      days: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].days,
      depositAmounts: [AMOUNT_STEP_ONE, AMOUNT_STEP_THREE, AMOUNT_STEP_FOUR],
      disclaimer: '',
      errorMessage: '',
      errorMessageDepositFail: '',
      avsMessage: false,
      avsFlag: false,
      fields: {
        country: '',
        name: '',
        amount: '',
        number: '',
        expiryDateMonth: '',
        expiryDateYear: '',
        cvv: '',
        address: '',
        city: '',
        zipCode: ''
      },
      instantCreditDetail: this.instantCreditData
    };
  },
  created: function created() {
    this.initialize();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['balance', 'firstDepositDone', 'depositMethods']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['status', 'userData', 'ssnInfoVerified']), {
    classModifiers: function classModifiers() {
      return {
        'add-funds': true,
        'add-funds--popup': this.isPopup,
        'add-funds--regular': !this.isPopup
      };
    },
    availableCardTypes: function availableCardTypes() {
      return (this.depositMethods.creditCardTypes || []).map(function (i) {
        return i.toLowerCase();
      });
    },
    minimumDepositAmount: function minimumDepositAmount() {
      return this.depositMethods.minimumDepositAmount || 10.0;
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    accountUploadDocumentTheme: function accountUploadDocumentTheme() {
      return this.isPage ? 'page-padded' : '';
    },
    minDeposit: function minDeposit() {
      return AMOUNT_STEP_ONE;
    },
    amountHasError: function amountHasError() {
      return this.$v.fields.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_getValidationMessage__["a" /* default */])(this.$v.fields.amount);
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit || this.cardTypeHasError;
    },
    isStepInitial: function isStepInitial() {
      return this.step === STEP_INITIAL;
    },
    isStepConfirm: function isStepConfirm() {
      return this.step === STEP_CONFIRM;
    },
    isStepTryAgain: function isStepTryAgain() {
      return this.step === STEP_TRY_AGAIN;
    },
    cardNumber: function cardNumber() {
      return (this.fields.number || '').replace(/ /g, '');
    },
    cardTypeHasError: function cardTypeHasError() {
      return this.cardType !== __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.BLANK && !this.availableCardTypes.includes(this.cardType);
    },
    cardTypeValidationMessage: function cardTypeValidationMessage() {
      return 'This card is not supported';
    },
    cardType: function cardType() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["c" /* getCardTypeForNumber */])(this.cardNumber);
    },
    cardTypeImage: function cardTypeImage() {
      var img = __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_blank_png___default.a;
      switch (this.cardType) {
        case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.AMERICAN_EXPRESS:
          img = __WEBPACK_IMPORTED_MODULE_6__assets_images_cards_americanexpress_jpg___default.a;
          break;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.DISCOVER:
          img = __WEBPACK_IMPORTED_MODULE_7__assets_images_cards_discover_jpg___default.a;
          break;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.MASTERCARD:
          img = __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_mastercard_jpg___default.a;
          break;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.VISA:
          img = __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_visa_jpg___default.a;
          break;
        default:
          break;
      }
      return img;
    },
    depositPayload: function depositPayload() {
      var payload = {
        cardHoldersName: this.fields.name,
        amount: this.fields.amount,
        cardNumber: this.cardNumber,
        securityCode: this.fields.cvv,
        expirationMonth: this.fields.expiryDateMonth.value,
        expirationYear: this.fields.expiryDateYear.value,
        depositPromoCode: '',
        marketingSource: '',
        marketingProgram: '',
        cardType: this.cardType
      };
      if (this.avsFlag) {
        payload.address1 = this.fields.address;
        payload.city = this.fields.city;
        payload.postalCode = this.fields.zipCode;
      }
      return payload;
    },
    infoAmount: function infoAmount() {
      var number = Number(this.depositPayload.amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + number;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getDepositCard', 'confirmDepositCard', 'submitDepositCard', 'setCurrentDeposit', 'getBalance', 'getDepositMethods']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericPopup', 'setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), {
    initialize: function initialize() {
      var _this = this;

      this.loaderAdd();
      this.getBalance().then(this.getDepositCard).then(function (data) {
        _this.loaderRemove();
        _this.isComponentReady = true;
        _this.checkDocumentUploadFlags(data);
        _this.canDeposit = data.canDeposit;
        _this.errorMessage = data.errorMessage;
        _this.promoCodeDetail = data.promoCodeDetail || {};
        _this.disclaimer = data.disclaimer;
        _this.fields.name = data.cardHoldersName;
        _this.avsFlag = data.avsFlag;
        _this.fields.city = data.city || '';
        _this.fields.address = data.address1 || '';
        _this.fields.zipCode = data.postalCode || '';
        _this.fields.country = {
          value: _this.userData.countryCode
        };
      }).catch(function (error) {
        _this.isComponentReady = true;
        _this.errorMessage = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
        _this.loaderRemove();
        _this.checkDocumentUploadFlags(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data', {}));
      });

      if (!this.isPopup) {
        this.getDepositMethods();
      }
    },
    tabChange: function tabChange(name) {
      this.activeTab = name;
    },
    scrollToTopIfPage: function scrollToTopIfPage() {
      if (this.isLayoutMobile && this.isPage) {
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, 100);
      }
    },
    getInitialAmount: function getInitialAmount() {
      return this.balance && this.balance.accountBalanceDecimal > 0 ? DEPOSIT_NON_ZERO_BALANCE : DEPOSIT_INITIAL;
    },
    handleDepositFail: function handleDepositFail(error) {
      this.errorMessageDepositFail = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '');
      if (this.isPage) {
        this.step = STEP_INITIAL;
        this.setGenericPopup({
          name: __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].PAYMENT_ERROR,
          options: {
            title: 'Payment Failed',
            icon: 'error',
            error: this.errorMessageDepositFail
          }
        });
      } else {
        this.step = STEP_TRY_AGAIN;
      }
    },
    onUpdateAmount: function onUpdateAmount(amount) {
      if (this.fields.amount === '') {
        this.fields.amount = amount;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["D" /* isNumber */])(this.fields.amount)) {
        this.fields.amount = Number(this.fields.amount) + amount;
      }
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + amount + ' Button'
      });
    },
    onConfirmDeposit: function onConfirmDeposit() {
      var _this2 = this;

      this.avsMessage = false;
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'submit',
        label: 'Submit Deposit'
      });
      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd();
        this.confirmDepositCard(this.depositPayload).then(function (data) {
          _this2.loaderRemove();
          _this2.formEnable();
          if (_this2.checkDocumentUploadFlags(data)) return;
          if (data.dapFlag) {
            _this2.step = STEP_INITIAL;
            _this2.canDeposit = false;
            _this2.errorMessage = data.dapMessage;
          } else if (data.avsFlag) {
            _this2.step = STEP_INITIAL;
            _this2.avsFlag = true;
            _this2.avsMessage = true;
            _this2.getDepositCard().then(function (depositData) {
              _this2.checkDocumentUploadFlags(depositData);
              _this2.fields.city = depositData.city || '';
              _this2.fields.address = depositData.address1 || '';
              _this2.fields.zipCode = depositData.postalCode || '';
              _this2.fields.country = {
                value: _this2.userData.countryCode
              };
            }).catch(function (error) {
              _this2.errorMessage = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
            });
          } else {
            _this2.step = STEP_CONFIRM;
            _this2.scrollToTopIfPage();
          }
        }).catch(function (error) {
          _this2.loaderRemove();
          if (_this2.checkDocumentUploadFlags(error.response.data)) return;
          _this2.formEnable();
          _this2.handleDepositFail(error);
        });
      }
    },
    onSubmitDeposit: function onSubmitDeposit() {
      var _this3 = this;

      this.formDisable();
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      });
      this.loaderAdd();
      this.submitDepositCard(this.depositPayload).then(function (data) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(data)) return;
        _this3.setCurrentDeposit(data);
        _this3.balanceChecked = false;
        _this3.$gtm.trackEvent({ event: _this3.status.hasBeenFunded ? 'MultiDeposit' : 'Deposit' });
        var popupOptions = {
          name: __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].PAYMENT_SUCCESS,
          options: {
            title: 'Payment Confirmed',
            icon: 'success',
            iconTitle: 'Success!'
          }
        };
        if (!_this3.status.hasBeenFunded) {
          popupOptions.options.noClose = true;
        }
        _this3.setGenericPopup(popupOptions);
        _this3.formEnable();
        _this3.$emit('success');
      }).then(this.getBalance).catch(function (error) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(error.response.data)) return;
        _this3.formEnable();
        _this3.handleDepositFail(error);
      });
    },
    onTryAgain: function onTryAgain() {
      this.step = STEP_INITIAL;
    },
    showCVVModal: function showCVVModal() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_CVV);
    },
    fieldName: function fieldName(name) {
      return this.mode + '-' + name;
    },
    handleAmountBlur: function handleAmountBlur() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      });
    }
  }),
  watch: {
    ssnInfoVerified: function ssnInfoVerified() {
      this.initialize();
    }
  }
});

/***/ }),

/***/ "Jm7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_amount_info_js__ = __webpack_require__("gCuu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29fde05a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_amount_info_vue__ = __webpack_require__("9sCE");
function injectStyle (ssrContext) {
  __webpack_require__("2Fyx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_amount_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29fde05a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_amount_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmi9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgOEMwIDMuNTgxNzIgMy41ODE3MiAwIDggMEgxNkMyMC40MTgzIDAgMjQgMy41ODE3MiAyNCA4QzI0IDEyLjQxODMgMjAuNDE4MyAxNiAxNiAxNkg4QzMuNTgxNzIgMTYgMCAxMi40MTgzIDAgOFoiIGZpbGw9IiNFNEU0RTQiLz4KPHBhdGggZD0iTTggMC41SDE2QzIwLjE0MjEgMC41IDIzLjUgMy44NTc4NiAyMy41IDhDMjMuNSAxMi4xNDIxIDIwLjE0MjEgMTUuNSAxNiAxNS41SDhDMy44NTc4NiAxNS41IDAuNSAxMi4xNDIxIDAuNSA4QzAuNSAzLjg1Nzg2IDMuODU3ODYgMC41IDggMC41WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuMSIvPgo8Y2lyY2xlIGN4PSIxNiIgY3k9IjgiIHI9IjYiIGZpbGw9IiMwMDAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4xNzEgNi40OTMxTDE1LjMyODMgMTAuNDIwOUMxNS4yNzAyIDEwLjQ4MDkgMTUuMjAwNyAxMC41Mjg2IDE1LjEyMzggMTAuNTYxMkMxNS4wNDY5IDEwLjU5MzggMTQuOTY0MiAxMC42MTA2IDE0Ljg4MDcgMTAuNjEwNkMxNC43OTcyIDEwLjYxMDYgMTQuNzE0NSAxMC41OTM4IDE0LjYzNzYgMTAuNTYxMkMxNC41NjA3IDEwLjUyODYgMTQuNDkxMiAxMC40ODA5IDE0LjQzMzEgMTAuNDIwOUwxMi44Mjc3IDguNzgwNzVDMTIuNzA5IDguNjU3OTggMTIuNjQyNiA4LjQ5Mzg3IDEyLjY0MjYgOC4zMjMwN0MxMi42NDI2IDguMTUyMjggMTIuNzA5IDcuOTg4MTcgMTIuODI3NyA3Ljg2NTM5QzEyLjg4NTggNy44MDU0NyAxMi45NTU0IDcuNzU3ODQgMTMuMDMyMyA3LjcyNTMxQzEzLjEwOTIgNy42OTI3OCAxMy4xOTE4IDcuNjc2MDIgMTMuMjc1MyA3LjY3NjAyQzEzLjM1ODggNy42NzYwMiAxMy40NDE0IDcuNjkyNzggMTMuNTE4MyA3LjcyNTMxQzEzLjU5NTIgNy43NTc4NCAxMy42NjQ4IDcuODA1NDcgMTMuNzIyOSA3Ljg2NTM5TDE0Ljg4MDcgOS4wNDg1N0wxOC4yNzYyIDUuNTc4ODZDMTguMzM0MyA1LjUxODg1IDE4LjQwMzggNS40NzExMyAxOC40ODA3IDUuNDM4NTRDMTguNTU3NiA1LjQwNTk1IDE4LjY0MDMgNS4zODkxNiAxOC43MjM4IDUuMzg5MTZDMTguODA3MyA1LjM4OTE2IDE4Ljg5IDUuNDA1OTUgMTguOTY2OSA1LjQzODU0QzE5LjA0MzggNS40NzExMyAxOS4xMTMzIDUuNTE4ODUgMTkuMTcxNCA1LjU3ODg2QzE5LjI5MDQgNS43MDEzOCAxOS4zNTY5IDUuODY1NDEgMTkuMzU2OSA2LjAzNjE3QzE5LjM1NjkgNi4yMDY5MyAxOS4yOTA0IDYuMzcwOTYgMTkuMTcxNCA2LjQ5MzQ4IiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "JnoZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JoM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getContracts: function getContracts() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Public/MapDataLegend/EC' : 'api/Public/MapDataLegend/EC';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getStateData: function getStateData() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Public/MapData/EC' : 'api/Public/MapData/EC';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getContractsSenate: function getContractsSenate() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Public/MapDataLegend/SEN' : 'api/Public/MapDataLegend/SEN';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getStateDataSenate: function getStateDataSenate() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Public/MapData/SEN' : 'api/Public/MapData/SEN';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  }
});

/***/ }),

/***/ "JqZZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ju06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_session_history_sushi_session_history_sushi_vue__ = __webpack_require__("84WW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_history_sushi_product_history_sushi_vue__ = __webpack_require__("4gzO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_watchlist_sushi_watchlist_sushi_vue__ = __webpack_require__("62Vb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_disqus__ = __webpack_require__("oeb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");









var SECTIONS = {
  DISCUSSION: 'discussion',
  WATCHLIST: 'watchlist',
  SESSION_HISTORY: 'session-history',
  PRODUCT_HISTORY: 'product-history'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_disqus__["a" /* default */]],
  props: {
    market: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      opened: null,
      SECTIONS: SECTIONS
    };
  },

  components: {
    sessionHistorySushi: __WEBPACK_IMPORTED_MODULE_3__components_session_history_sushi_session_history_sushi_vue__["a" /* default */],
    productHistorySushi: __WEBPACK_IMPORTED_MODULE_4__components_product_history_sushi_product_history_sushi_vue__["a" /* default */],
    watchlistSushi: __WEBPACK_IMPORTED_MODULE_5__components_watchlist_sushi_watchlist_sushi_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    sections: function sections() {
      var results = [];
      if (this.market.disqus_Identifier) {
        results.push({ name: SECTIONS.DISCUSSION, title: 'Discussion' });
      }
      if (this.isLoggedIn) {
        return [].concat(results, [{ name: SECTIONS.WATCHLIST, title: 'Watchlist' }, { name: SECTIONS.SESSION_HISTORY, title: 'Session' }]);
      }
      return [].concat(results, [{ name: SECTIONS.SESSION_HISTORY, title: 'Session' }]);
    }
  }),
  methods: {
    openSection: function openSection(section) {
      this.opened = section;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["l" /* lockModal */])();
    },
    closeSection: function closeSection() {
      this.opened = null;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["m" /* unLockModal */])();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["m" /* unLockModal */])();
  }
});

/***/ }),

/***/ "JvIk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__ = __webpack_require__("dDJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_empty_state_market_empty_state_vue__ = __webpack_require__("tGGA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_contract__ = __webpack_require__("YZ+m");










var WATCHLIST_SIZE = 10;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'standalone'
    }
  },
  data: function data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["b" /* MARKET_CONTRACT_INFO_VALUES_LAYOUT */]
    };
  },

  components: {
    marketContractInfoV2: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketEmptyState: __WEBPACK_IMPORTED_MODULE_6__components_market_market_empty_state_market_empty_state_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('watchlist', ['watchlist']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['market']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'watchlist-sushi': true
      }, 'watchlist-sushi--' + this.type, this.type);
    },
    items: function items() {
      var results = this.watchlist.data === null ? [] : this.watchlist.data;
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(results.slice(0, WATCHLIST_SIZE)));
    },
    itemClassModifiers: function itemClassModifiers() {
      return {
        'market-contract-info-v2__widget-item': true,
        'market-contract-info-v2__widget-item--border-bottom': this.layout !== 'widget' && !this.isLayoutMobile
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('watchlist', ['getWatchList', 'resetWatchlist']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('profile', ['removeMarketFromWatchList']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['markCurrentMarketNotWatched']), {
    loadWatchlist: function loadWatchlist() {
      var _this = this;

      this.loaderAdd();
      this.$emit('loading');
      this.getWatchList().then(function () {
        _this.$emit('loaded');
        _this.loaderRemove();
      }).catch(function () {
        _this.$emit('loaded');
        _this.loaderRemove();
      });
    },
    itemLink: function itemLink(item) {
      var contractId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var query = {};
      if (contractId) {
        query.contractId = contractId;
      }
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: query
      };
    },
    getContracts: function getContracts(item) {
      return (item.contracts || []).slice(0, 2).map(function (i) {
        return new __WEBPACK_IMPORTED_MODULE_8__models_contract__["a" /* default */](i);
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.resetWatchlist().then(function () {
      return _this2.loadWatchlist();
    });
  }
});

/***/ }),

/***/ "JwZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.showProgress)?_c('div',{staticClass:"account-social-avatar__progress-container",on:{"click":_vm.onShowEditPopup}},[_c('svg',{staticClass:"account-social-avatar__progress",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 120 120"}},[(_vm.percentage < 100)?_c('circle',{staticClass:"account-social-avatar__progress-meter",attrs:{"cx":"60","cy":"60","r":_vm.radius,"stroke-width":_vm.strokeWidth,"stroke":_vm.backgroundStrokeColor}}):_vm._e(),_vm._v(" "),_c('circle',{staticClass:"account-social-avatar__progress-value",style:(_vm.styleModifiers),attrs:{"cx":"60","cy":"60","r":_vm.radius,"stroke-width":_vm.strokeWidth}})])]):_vm._e(),_vm._v(" "),(_vm.avatar)?_c('div',{class:_vm.imageClassModifiers,style:(_vm.imageStyleModifiers),on:{"click":_vm.onShowEditPopup}}):_vm._e(),_vm._v(" "),(_vm.showNotificationsCount)?_c('div',{staticClass:"account-social-avatar__notifications-count"},[_vm._v("\n    "+_vm._s(_vm.notificationsCount)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.hasLabel)?_c('div',{class:_vm.labelClassModifiers},[_vm._t("label"),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.isEditEnabled)?_c('span',{staticClass:"account-social-avatar__edit-photo"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K0uo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDQiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCAxMDQgNTIiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBmaWxsPSIjMjYzQjNGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik05NS4wMSA0MC4xMzJhMi4zMyAyLjMzIDAgMCAwLTEuOTE0LS42NjRsLTEuMTA2LTEuMWMzLjY5NS00LjE3NiA1LjczNC05LjQ2MSA1LjczNC0xNS4wNzMgMC02LjEwMS0yLjM4Ni0xMS44NC02LjcyMS0xNi4xNTZDODYuNjYgMi44MTQgODAuODk0LjQ0MiA3NC43NTMuNDQyYy02LjEzIDAtMTEuODk2IDIuMzc1LTE2LjIzNiA2LjY5Ny00LjM0NSA0LjMxNi02LjczNCAxMC4wNTUtNi43MzQgMTYuMTU2IDAgNi4xMDIgMi4zOTQgMTEuODQzIDYuNzM0IDE2LjE1OSA0LjM0IDQuMzIgMTAuMTA2IDYuNjkyIDE2LjIzNyA2LjY5MmEyMi44MTkgMjIuODE5IDAgMCAwIDE1LjE1LTUuNzA3bDEuMTExIDEuMDk3YTIuMzEgMi4zMSAwIDAgMCAuNjY4IDEuOTFsNy45MTMgNy44NzNjLjQ2MS40NTggMS4wNjIuNjggMS42NjguNjguNTk4IDAgMS4yMDQtLjIyNSAxLjY2Ny0uNjhhMi4zMzcgMi4zMzcgMCAwIDAgMC0zLjMxbC03LjkyLTcuODc3em0tNy4zNC0zLjk5OWExOC4xOTUgMTguMTk1IDAgMCAxLTEyLjkxNiA1LjMzIDE4LjE4IDE4LjE4IDAgMCAxLTEyLjkwNy01LjMyNWMtMy40NDYtMy40MjgtNS4zNS03Ljk5My01LjM1LTEyLjg0NSAwLTQuODUgMS45LTkuNDEyIDUuMzUtMTIuODQzYTE4LjE4OSAxOC4xODkgMCAwIDEgMTIuOTA3LTUuMzI1YzQuODggMCA5LjQ2OCAxLjg5IDEyLjkxNiA1LjMyNSAzLjQ0NCAzLjQzIDUuMzQ1IDcuOTkzIDUuMzQ1IDEyLjg0MyAwIDQuODUyLTEuOTAxIDkuNDEtNS4zNDUgMTIuODR6Ii8+CiAgICAgICAgPGcgc3Ryb2tlPSIjMjYzQjNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMSA0OGExIDEgMCAwIDEtMSAxSDNhMSAxIDAgMCAxLTEtMVYyM2ExIDEgMCAwIDEgMS0xaDdhMSAxIDAgMCAxIDEgMXYyNXpNNDUgNDhhMSAxIDAgMCAxLTEgMWgtN2ExIDEgMCAwIDEtMS0xVjMzYTEgMSAwIDAgMSAxLTFoN2ExIDEgMCAwIDEgMSAxdjE1ek0yOCA0OGExIDEgMCAwIDEtMSAxaC03YTEgMSAwIDAgMS0xLTFWOGExIDEgMCAwIDEgMS0xaDdhMSAxIDAgMCAxIDEgMXY0MHoiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "K1rd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K2V5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi"},[_c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi__box"},[_c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi__label",on:{"click":_vm.onFocus}},[(!_vm.$slots.label)?[_vm._v("\n        Price\n      ")]:_vm._t("label")],2),_vm._v(" "),_c('div',[_c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi__input-wrap",on:{"click":_vm.onFocus}},[_c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi__input-suffix"},[_vm._v("¢")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"input",staticClass:"purchase-offer-value-picker-mobile-sushi__input",attrs:{"tabindex":_vm.tabindex,"inputmode":"numeric","pattern":"[0-9]*","type":"text","maxlength":"4","placeholder":""},domProps:{"value":(_vm.val)},on:{"click":_vm.onFocus,"focus":_vm.onFocus,"blur":_vm.onBlur,"input":function($event){if($event.target.composing){ return; }_vm.val=$event.target.value}}})])])]),_vm._v(" "),(_vm.selected)?_c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi__picker"},[_c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi__option purchase-offer-value-picker-mobile-sushi__option--subtract",class:{
      'purchase-offer-value-picker-mobile-sushi__option--disabled': _vm.val === _vm.minimumCentValue
    },on:{"pointerdown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.subtract($event)},"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.subtract($event)}}},[_vm._v("\n      -1¢\n    ")]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi__slider"},[_c('range-slider',{attrs:{"min":_vm.minimumCentValue,"max":_vm.maximumCentValue},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1),_vm._v(" "),_c('div',{staticClass:"purchase-offer-value-picker-mobile-sushi__option purchase-offer-value-picker-mobile-sushi__option--add",class:{
      'purchase-offer-value-picker-mobile-sushi__option--disabled': _vm.val === _vm.maximumCentValue
    },on:{"pointerdown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.add($event)},"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.add($event)}}},[_vm._v("\n      +1¢\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K2ud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_radio_js__ = __webpack_require__("joAC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db4207cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__ = __webpack_require__("5X5i");
function injectStyle (ssrContext) {
  __webpack_require__("zKe2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_radio_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db4207cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KA7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAVIGATION_TABS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_disqus_disqus_vue__ = __webpack_require__("4EoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_payout_sushi_market_payout_sushi_vue__ = __webpack_require__("12bX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_headerTags__ = __webpack_require__("cgm0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_headerHeight__ = __webpack_require__("GHbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_mutex__ = __webpack_require__("EOu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_sushi_market_discussion_widget_sushi_market_discussion_widget_vue__ = __webpack_require__("LrHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_sushi_market_links_widget_sushi_market_links_widget_vue__ = __webpack_require__("wQqh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_market_market_watch_market_watch_vue__ = __webpack_require__("lkXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_brand_name_brand_name_js__ = __webpack_require__("9IfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_page_market_detail_sushi_pages_sushi_market_charts_sushi_market_charts_vue__ = __webpack_require__("kOSc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pages_page_market_detail_sushi_pages_sushi_market_discussion_sushi_market_discussion_vue__ = __webpack_require__("TtE0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_page_market_detail_sushi_pages_sushi_market_history_sushi_market_history_vue__ = __webpack_require__("5WGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_page_market_detail_sushi_pages_sushi_market_rules_sushi_market_rules_vue__ = __webpack_require__("wFR7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_page_market_detail_sushi_pages_sushi_market_contracts_sushi_market_contracts_vue__ = __webpack_require__("vSY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_pages_page_market_detail_sushi_pages_sushi_market_links_sushi_market_links_vue__ = __webpack_require__("uf7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_pages_page_market_detail_sushi_pages_sushi_market_research_sushi_market_research_vue__ = __webpack_require__("uAZ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pages_page_market_detail_sushi_pages_sushi_market_methodology_sushi_market_methodology_vue__ = __webpack_require__("NHsJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_market_v2_market_alert_v2_market_alert_v2_vue__ = __webpack_require__("eLZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_market_v2_market_site_alert_v2_market_site_alert_v2_vue__ = __webpack_require__("G+2P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__ = __webpack_require__("X4WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_purchase_sushi_purchase_offer_sushi_mobile_bar_purchase_offer_sushi_mobile_bar_vue__ = __webpack_require__("otBS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__store_modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__store__ = __webpack_require__("IcnI");






/* eslint-disable */






































var DEFAULT_PAGE_TITLE = __WEBPACK_IMPORTED_MODULE_21__components_brand_name_brand_name_js__["a" /* BRAND */];

var NAVIGATION_TABS = {
  CONTRACTS: 'contracts',
  RESEARCH: 'research',
  METHODOLOGY: 'methodology',
  RULES: 'rules',
  CHARTS: 'charts',
  HISTORY: 'history',
  DISCUSSION: 'discussion',
  LINKS: 'links'
};

var ROUTE_DRIVEN_TABS = [NAVIGATION_TABS.CONTRACTS, NAVIGATION_TABS.RESEARCH, NAVIGATION_TABS.METHODOLOGY, NAVIGATION_TABS.RULES, NAVIGATION_TABS.CHARTS, NAVIGATION_TABS.HISTORY, NAVIGATION_TABS.DISCUSSION, NAVIGATION_TABS.LINKS];

var AUTH_REQUIRING_TABS = [NAVIGATION_TABS.HISTORY, NAVIGATION_TABS.LINKS];

function resolveActiveTab(tab) {
  if (!ROUTE_DRIVEN_TABS.includes(tab)) {
    return NAVIGATION_TABS.CONTRACTS;
  }
  if (AUTH_REQUIRING_TABS.includes(tab) && !__WEBPACK_IMPORTED_MODULE_41__store__["a" /* default */].getters['user/isLoggedIn']) {
    return NAVIGATION_TABS.CONTRACTS;
  }
  return ROUTE_DRIVEN_TABS.includes(tab) ? tab : NAVIGATION_TABS.CONTRACTS;
}

function buildDiscussionQuery(query) {
  var commentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var commentThreadId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var nextQuery = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, query, {
    tab: NAVIGATION_TABS.DISCUSSION
  });

  if (Number(commentThreadId) > 0) {
    nextQuery.commentThreadId = Number(commentThreadId);
  } else {
    delete nextQuery.commentThreadId;
  }

  if (commentId) {
    nextQuery.commentId = commentId;
  } else {
    delete nextQuery.commentId;
  }

  return nextQuery;
}

function buildTabQuery(query, tab) {
  var nextQuery = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, query);

  delete nextQuery.commentThreadId;
  delete nextQuery.commentId;

  if (tab && tab !== NAVIGATION_TABS.CONTRACTS) {
    nextQuery.tab = tab;
  } else {
    delete nextQuery.tab;
  }

  return nextQuery;
}

function buildCommentHash() {
  var commentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return commentId ? '#comment-' + commentId : '';
}

function normalizeCommentThreadId(commentThreadId) {
  var normalized = Number(commentThreadId);

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite___default()(normalized) && normalized > 0 ? normalized : 0;
}

function resolveRouteMarketId(route) {
  return Number(route && route.params ? route.params.marketId : 0);
}

function resolveDiscussionCommentId(route) {
  if (route && route.query && route.query.commentId) {
    return route.query.commentId;
  }

  if (route && route.hash && route.hash.indexOf('#comment-') === 0) {
    return route.hash.replace('#comment-', '');
  }

  return '';
}

function getCurrentLocationQuery() {
  var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["I" /* parseQuery */])(window.location.search || '');

  delete query[''];

  return query;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_headerTags__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_headerHeight__["a" /* default */], __WEBPACK_IMPORTED_MODULE_32__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_33__mixins_contentLoader__["a" /* default */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_9__components_generics_alert_box_alert_box_vue__["a" /* default */],
    disqus: __WEBPACK_IMPORTED_MODULE_7__components_disqus_disqus_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__["a" /* default */],
    sushiMarketDiscussionWidget: __WEBPACK_IMPORTED_MODULE_17__components_sushi_market_discussion_widget_sushi_market_discussion_widget_vue__["a" /* default */],
    sushiMarketLinksWidget: __WEBPACK_IMPORTED_MODULE_18__components_sushi_market_links_widget_sushi_market_links_widget_vue__["a" /* default */],
    marketPayoutSushi: __WEBPACK_IMPORTED_MODULE_8__components_market_market_payout_sushi_market_payout_sushi_vue__["a" /* default */],
    marketWatch: __WEBPACK_IMPORTED_MODULE_19__components_market_market_watch_market_watch_vue__["a" /* default */],
    pageSushiMarketCharts: __WEBPACK_IMPORTED_MODULE_22__components_pages_page_market_detail_sushi_pages_sushi_market_charts_sushi_market_charts_vue__["a" /* default */],
    pageSushiMarketDiscussion: __WEBPACK_IMPORTED_MODULE_23__components_pages_page_market_detail_sushi_pages_sushi_market_discussion_sushi_market_discussion_vue__["a" /* default */],
    pageSushiMarketHistory: __WEBPACK_IMPORTED_MODULE_24__components_pages_page_market_detail_sushi_pages_sushi_market_history_sushi_market_history_vue__["a" /* default */],
    pageSushiMarketRules: __WEBPACK_IMPORTED_MODULE_25__components_pages_page_market_detail_sushi_pages_sushi_market_rules_sushi_market_rules_vue__["a" /* default */],
    pageSushiMarketContracts: __WEBPACK_IMPORTED_MODULE_26__components_pages_page_market_detail_sushi_pages_sushi_market_contracts_sushi_market_contracts_vue__["a" /* default */],
    pageSushiMarketLinks: __WEBPACK_IMPORTED_MODULE_27__components_pages_page_market_detail_sushi_pages_sushi_market_links_sushi_market_links_vue__["a" /* default */],
    pageSushiMarketResearch: __WEBPACK_IMPORTED_MODULE_28__components_pages_page_market_detail_sushi_pages_sushi_market_research_sushi_market_research_vue__["a" /* default */],
    pageSushiMarketMethodology: __WEBPACK_IMPORTED_MODULE_29__components_pages_page_market_detail_sushi_pages_sushi_market_methodology_sushi_market_methodology_vue__["a" /* default */],
    marketAlertV2: __WEBPACK_IMPORTED_MODULE_30__components_market_v2_market_alert_v2_market_alert_v2_vue__["a" /* default */],
    marketSiteAlertV2: __WEBPACK_IMPORTED_MODULE_31__components_market_v2_market_site_alert_v2_market_site_alert_v2_vue__["a" /* default */],
    marketCharts: __WEBPACK_IMPORTED_MODULE_34__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */],
    purchaseOfferSushiMobileBar: __WEBPACK_IMPORTED_MODULE_38__components_purchase_sushi_purchase_offer_sushi_mobile_bar_purchase_offer_sushi_mobile_bar_vue__["a" /* default */]
  },
  props: {
    showRules: {
      type: Boolean,
      default: false
    },
    marketId: {
      type: Number,
      required: true
    },
    prerendered: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      NAVIGATION_TABS: NAVIGATION_TABS,
      titleHovered: false,
      stickyObserver: null,
      onScroll: null,
      stickyScrollAnimationFrame: null,
      contentResizeObserver: null,
      desktopStickyTitleHeight: 0,
      desktopContentMinHeight: 0,
      mobileContentMinHeight: 0,
      mobileContentHeightReleaseTimer: null,
      mobileContentHeightReleaseAnimationFrame: null,
      discussionWidgetRouteSwap: 1,
      isResetting: false,
      showAllContracts: false,
      activeTab: resolveActiveTab(this.$route.query.tab),
      requestedDiscussionCommentId: resolveDiscussionCommentId(this.$route),
      requestedDiscussionCommentThreadId: normalizeCommentThreadId(this.$route.query.commentThreadId),
      showHistory: false,
      toolbarTabsCanScrollLeft: false,
      toolbarTabsCanScrollRight: false,
      toolbarTabsResizeObserver: null,
      hideMainChart: false,
      isTitleSticky: false,
      initialised: false,
      reloading: false,
      tabScrollPositions: {}
    };
  },
  metaInfo: function metaInfo() {
    if (this.market && this.market.marketId) {
      return {
        title: this.market.seoTitle,
        link: [{ rel: 'canonical', href: '' + window.location.href }],
        meta: [{ name: 'description', content: this.market.seoDescription }, { itemprop: 'name', content: this.market.seoTitle }, { itemprop: 'description', content: this.market.seoDescription }, { itemprop: 'image', content: this.market.imageName }, { property: 'og:title', content: this.market.seoTitle }, { property: 'og:type', content: 'article' }, { property: 'og:image', content: this.market.imageName }, { property: 'og:description', content: this.market.seoDescription }, { property: 'og:site_name', content: __WEBPACK_IMPORTED_MODULE_21__components_brand_name_brand_name_js__["a" /* BRAND */] }, { property: 'og:url', content: '' + window.location.href }]
      };
    }
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'isCommentEnabled', 'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance', 'isPinningEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['previousRoute', 'settingShowOdds']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('market', ['market', 'contracts', 'marketLoadError', 'marketIsEngineBusy', 'marketIsEngineBusyMessage', 'isDiscussionPinned']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'bottomBetslipExtended', 'bottomWidgetFooterMode', 'bottomWidgetFooterModeContractsSection', 'hasStoredBottomWidgetFooterModePreference']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('notifications', ['lastConfirmedContractData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('user', ['status']), {
    isShortcutWidgetVisible: function isShortcutWidgetVisible() {
      return this.market !== null && !!this.market.marketId && !this.isMarketDisabled && this.initialised && !this.isResetting && this.isLayoutMobile && this.activeTab !== NAVIGATION_TABS.CONTRACTS;
    },
    displayedMarketName: function displayedMarketName() {
      if (!this.market) {
        return '';
      }

      return this.isTitleSticky ? this.pinnedMarketName : this.market.marketName;
    },
    pinnedMarketName: function pinnedMarketName() {
      if (!this.market) {
        return '';
      }

      return this.market.marketShortName || this.market.marketName;
    },
    desktopStickyTitleOffset: function desktopStickyTitleOffset() {
      if (!this.isLayoutDesktop || !this.isTitleSticky) {
        return 0;
      }

      // Desktop stacks the sticky short title above the tabs, so the toolbar
      // always needs the final rendered title height and not just the header.
      if (this.desktopStickyTitleHeight > 0) {
        return this.desktopStickyTitleHeight;
      }

      var $stickyTitle = document.querySelector('.page-market-detail-sushi__title--is-sticky');

      return $stickyTitle ? $stickyTitle.offsetHeight : 0;
    },
    toolbarStyleModifiers: function toolbarStyleModifiers() {
      return {
        top: this.headerHeight + this.desktopStickyTitleOffset + 'px'
      };
    },
    contentStyleModifiers: function contentStyleModifiers() {
      var contentMinHeight = this.isLayoutDesktop ? this.desktopContentMinHeight : this.mobileContentMinHeight;

      if (!contentMinHeight) {
        return {};
      }

      return {
        minHeight: contentMinHeight + 'px'
      };
    },
    titleStyleModifiers: function titleStyleModifiers() {
      if (this.isLayoutMobile && !this.isMarketDisabled) {
        return {
          top: this.headerHeight + 'px'
        };
      }

      if (!this.isTitleSticky) {
        return {};
      }
      return {
        top: this.headerHeight + 'px'
      };
    },
    showStickyTitleSummary: function showStickyTitleSummary() {
      return this.isTitleSticky && this.isPayoutAvailable;
    },
    isExpandedMobileBetslipActive: function isExpandedMobileBetslipActive() {
      return this.isLayoutMobile && this.bottomWidgetFooterMode === __WEBPACK_IMPORTED_MODULE_39__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP && this.bottomBetslipExtended;
    },
    stickyUserGainLoss: function stickyUserGainLoss() {
      if (!this.market) {
        return 0;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["J" /* marketUserGainLoss */])(this.market);
    },
    stickyUserGainLossNormalized: function stickyUserGainLossNormalized() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["h" /* roundToTwo */])(this.stickyUserGainLoss) === 0 ? 0 : this.stickyUserGainLoss;
    },
    stickyUserGainLossLabel: function stickyUserGainLossLabel() {
      if (this.stickyUserGainLossNormalized > 0) {
        return 'Gain';
      }

      return this.stickyUserGainLossNormalized < 0 ? 'Loss' : 'Gain/Loss';
    },
    showDesktopTitlePayout: function showDesktopTitlePayout() {
      return this.isPayoutAvailable && this.isLayoutDesktop && !this.isTitleSticky;
    },
    showDesktopTitleWatch: function showDesktopTitleWatch() {
      return this.isLayoutDesktop && this.watchIconVisible;
    },
    showMobileTitleWatch: function showMobileTitleWatch() {
      return this.isLayoutMobile && this.watchIconVisible;
    },
    newMarketBarDescription: function newMarketBarDescription() {
      return this.isLayoutDesktop ? 'Orderbooks and features may be limited.' : 'Features may be limited.';
    },
    watchIconVisible: function watchIconVisible() {
      var statuses = [__WEBPACK_IMPORTED_MODULE_20__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* default */].MARKET_SETTLED];
      return this.isLoggedIn && !statuses.includes(this.market.status);
    },
    discussionWidgetKey: function discussionWidgetKey() {
      return 'market--' + this.discussionWidgetRouteSwap.toString();
    },
    navigationTabs: function navigationTabs() {
      var results = [{
        name: NAVIGATION_TABS.CONTRACTS,
        title: 'Contracts'
      }];

      // results = [
      //   ...results,
      //   {
      //     name: NAVIGATION_TABS.CHARTS,
      //     title: 'Charts',
      //   },
      // ]

      results = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(results), [{
        name: NAVIGATION_TABS.DISCUSSION,
        title: 'Discussion'
      }, {
        name: NAVIGATION_TABS.RULES,
        title: 'Rules',
        meta: {
          numRuleComments: this.market ? this.market.numRuleComments : 0
        }
      }]);

      if (this.isLoggedIn) {
        results = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(results), [{
          name: NAVIGATION_TABS.HISTORY,
          title: 'History'
        }, {
          name: NAVIGATION_TABS.LINKS,
          title: 'Lists'
        }]);
      }

      return results;
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    isPayoutAvailable: function isPayoutAvailable() {
      return this.isLoggedIn && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["K" /* hasMarketPayout */])(this.market) && !this.isMarketSettled;
    },
    isAllPayoutsAvailable: function isAllPayoutsAvailable() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    title: function title() {
      return 'Market details for ' + this.market.symbol + '--' + this.market.marketId;
    },
    showEngineBusyNotification: function showEngineBusyNotification() {
      return this.market.isEngineBusy && this.market.isEngineBusyMessage || this.marketIsEngineBusy && this.marketIsEngineBusyMessage;
    },
    engineBusyNotificationContent: function engineBusyNotificationContent() {
      return this.market.isEngineBusyMessage || this.marketIsEngineBusyMessage;
    },
    ogImageSrc: function ogImageSrc() {
      return this.prerendered !== '' && this.market && this.market.imageName;
    },
    showEconomicIndicator: function showEconomicIndicator() {
      return [2, 3, 4].includes(this.market.econIndicatorTradeStatus);
    },
    showDiscussionWidget: function showDiscussionWidget() {
      return this.isPinningEnabled && this.isLoggedIn && this.isDiscussionPinned && this.isCommentEnabled;
    },
    showMarketLinksWidget: function showMarketLinksWidget() {
      return this.isPinningEnabled && this.isLoggedIn;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('insight', ['getMarketFeeds']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('market', ['getMarket', 'clearMarket', 'clearMarketEngineBusyMessage', 'getMarketContractsStats']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setTradePopup', 'setGenericPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'setTradePrice', 'setTradeQuantity', 'clearOrderBook', 'setBottomBetSlipExtendedMode', 'toggleHidePurchaseForContractId', 'setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection']), {
    isMarketDetailPath: function isMarketDetailPath() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return typeof path === 'string' && path.indexOf('/markets/detail/') === 0;
    },
    shouldPreserveMobileFooterMode: function shouldPreserveMobileFooterMode() {
      var fromRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (fromRoute && fromRoute.name === 'market-details') {
        return true;
      }

      return this.isMarketDetailPath(this.previousRoute);
    },
    applyDefaultMobileFooterMode: function applyDefaultMobileFooterMode() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$fromRoute = _ref.fromRoute,
          fromRoute = _ref$fromRoute === undefined ? null : _ref$fromRoute;

      if (!this.isLayoutMobile) {
        return;
      }

      this.setBottomBetSlipExtendedMode(false);

      if (!this.hasStoredBottomWidgetFooterModePreference && !this.shouldPreserveMobileFooterMode(fromRoute)) {
        this.setBottomWidgetFooterModeContractsSection(__WEBPACK_IMPORTED_MODULE_39__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH);
      }

      if (this.activeTab === NAVIGATION_TABS.CONTRACTS) {
        this.setBottomWidgetFooterMode(this.bottomWidgetFooterModeContractsSection);
        return;
      }

      this.setBottomWidgetFooterMode(__WEBPACK_IMPORTED_MODULE_39__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH);
    },
    destroyStickyTracking: function destroyStickyTracking() {
      if (this.stickyObserver) {
        this.stickyObserver.disconnect();
        this.stickyObserver = null;
      }

      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        this.onScroll = null;
      }

      if (this.stickyScrollAnimationFrame && window.cancelAnimationFrame) {
        window.cancelAnimationFrame(this.stickyScrollAnimationFrame);
        this.stickyScrollAnimationFrame = null;
      }

      this.desktopStickyTitleHeight = 0;
    },
    destroyDesktopContentHeightTracking: function destroyDesktopContentHeightTracking() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$resetHeight = _ref2.resetHeight,
          resetHeight = _ref2$resetHeight === undefined ? false : _ref2$resetHeight;

      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }

      if (resetHeight) {
        this.desktopContentMinHeight = 0;
      }
    },
    cancelMobileContentHeightRelease: function cancelMobileContentHeightRelease() {
      if (this.mobileContentHeightReleaseTimer) {
        window.clearTimeout(this.mobileContentHeightReleaseTimer);
        this.mobileContentHeightReleaseTimer = null;
      }

      if (this.mobileContentHeightReleaseAnimationFrame) {
        window.cancelAnimationFrame(this.mobileContentHeightReleaseAnimationFrame);
        this.mobileContentHeightReleaseAnimationFrame = null;
      }
    },
    destroyMobileContentHeightLock: function destroyMobileContentHeightLock() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$resetHeight = _ref3.resetHeight,
          resetHeight = _ref3$resetHeight === undefined ? false : _ref3$resetHeight;

      this.cancelMobileContentHeightRelease();

      if (resetHeight) {
        this.mobileContentMinHeight = 0;
      }
    },
    getToolbarTabsScroller: function getToolbarTabsScroller() {
      if (!this.$refs.toolbarTabs) {
        return null;
      }

      return this.$refs.toolbarTabs.querySelector('.tabs');
    },
    initToolbarTabsScrollTracking: function initToolbarTabsScrollTracking() {
      var _this = this;

      this.destroyToolbarTabsScrollTracking();
      this.$nextTick(function () {
        var $tabs = _this.getToolbarTabsScroller();

        if (!$tabs) {
          _this.refreshToolbarTabsScrollState();
          return;
        }

        $tabs.addEventListener('scroll', _this.refreshToolbarTabsScrollState, { passive: true });

        if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
          _this.toolbarTabsResizeObserver = new ResizeObserver(_this.refreshToolbarTabsScrollState);
          _this.toolbarTabsResizeObserver.observe($tabs);
        }

        _this.refreshToolbarTabsScrollState();
        _this.scheduleToolbarTabIntoView(_this.activeTab);
      });
    },
    destroyToolbarTabsScrollTracking: function destroyToolbarTabsScrollTracking() {
      var $tabs = this.getToolbarTabsScroller();

      if ($tabs) {
        $tabs.removeEventListener('scroll', this.refreshToolbarTabsScrollState);
      }

      if (this.toolbarTabsResizeObserver) {
        this.toolbarTabsResizeObserver.disconnect();
        this.toolbarTabsResizeObserver = null;
      }
    },
    refreshToolbarTabsScrollState: function refreshToolbarTabsScrollState() {
      var $tabs = this.getToolbarTabsScroller();

      if (!this.isLayoutMobile || !$tabs) {
        this.toolbarTabsCanScrollLeft = false;
        this.toolbarTabsCanScrollRight = false;
        return;
      }

      var maxScrollLeft = Math.max(0, $tabs.scrollWidth - $tabs.clientWidth);
      var $firstTab = $tabs.querySelector('.tabs__item:first-child');
      var $lastTab = $tabs.querySelector('.tabs__item:last-of-type');
      var tabsRect = $tabs.getBoundingClientRect();
      var firstTabRect = $firstTab ? $firstTab.getBoundingClientRect() : null;
      var lastTabRect = $lastTab ? $lastTab.getBoundingClientRect() : null;

      this.toolbarTabsCanScrollLeft = maxScrollLeft > 1 && firstTabRect && firstTabRect.left < tabsRect.left - 1;
      this.toolbarTabsCanScrollRight = maxScrollLeft > 1 && lastTabRect && lastTabRect.right > tabsRect.right + 1;
    },
    scrollToolbarTabs: function scrollToolbarTabs(direction) {
      var $tabs = this.getToolbarTabsScroller();

      if (!$tabs) {
        return;
      }

      var distance = Math.max(120, Math.floor($tabs.clientWidth * 0.8));
      var left = $tabs.scrollLeft + distance * direction;

      if (typeof $tabs.scrollTo === 'function') {
        $tabs.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        $tabs.scrollLeft = left;
      }

      window.setTimeout(this.refreshToolbarTabsScrollState, 250);
    },
    scheduleToolbarTabIntoView: function scheduleToolbarTabIntoView() {
      var _this2 = this;

      var tabName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.activeTab;

      if (!this.isLayoutMobile || !tabName) {
        return;
      }

      this.$nextTick(function () {
        _this2.scrollToolbarTabIntoView(tabName);

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            _this2.scrollToolbarTabIntoView(tabName);
          });
        }

        window.setTimeout(function () {
          _this2.scrollToolbarTabIntoView(tabName);
        }, 150);
      });
    },
    scrollToolbarTabIntoView: function scrollToolbarTabIntoView(tabName) {
      if (!this.isLayoutMobile || !tabName) {
        return;
      }

      var $tabs = this.getToolbarTabsScroller();

      if (!$tabs) {
        return;
      }

      var $tab = $tabs.querySelector('.tabs__link-name-' + tabName);

      if (!$tab) {
        return;
      }

      var tabsRect = $tabs.getBoundingClientRect();
      var tabRect = $tab.getBoundingClientRect();
      var maxScrollLeft = Math.max(0, $tabs.scrollWidth - $tabs.clientWidth);
      var scrollButtonWidth = 28;
      var scrollButtonBuffer = 8;
      var overlaySafeWidth = scrollButtonWidth + scrollButtonBuffer;
      var visibleLeft = tabsRect.left + ($tabs.scrollLeft > 1 ? overlaySafeWidth : 0);
      var visibleRight = tabsRect.right - ($tabs.scrollLeft < maxScrollLeft - 1 ? overlaySafeWidth : 0);
      var leftOverflow = tabRect.left - visibleLeft;
      var rightOverflow = tabRect.right - visibleRight;
      var nextScrollLeft = $tabs.scrollLeft;

      if (leftOverflow < 0) {
        nextScrollLeft += leftOverflow;
      } else if (rightOverflow > 0) {
        nextScrollLeft += rightOverflow;
      } else {
        this.refreshToolbarTabsScrollState();
        return;
      }

      nextScrollLeft = Math.max(0, Math.min(nextScrollLeft, maxScrollLeft));

      if (typeof $tabs.scrollTo === 'function') {
        $tabs.scrollTo({ left: nextScrollLeft, behavior: 'smooth' });
      } else {
        $tabs.scrollLeft = nextScrollLeft;
      }

      window.setTimeout(this.refreshToolbarTabsScrollState, 250);
    },
    captureDesktopContentHeight: function captureDesktopContentHeight() {
      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      this.desktopContentMinHeight = this.$refs.marketContent.offsetHeight;
    },
    captureMobileContentHeight: function captureMobileContentHeight() {
      if (!this.isLayoutMobile || !this.$refs.marketContent) {
        return;
      }

      this.cancelMobileContentHeightRelease();

      var currentHeight = this.$refs.marketContent.offsetHeight;
      var minHeightToPreventClamp = this.resolveContentMinHeight();

      this.mobileContentMinHeight = Math.ceil(Math.max(currentHeight, minHeightToPreventClamp));
    },
    getNaturalContentHeight: function getNaturalContentHeight() {
      if (!this.$refs.marketContent || !this.$refs.marketContentInner) {
        return 0;
      }

      var styles = window.getComputedStyle(this.$refs.marketContent);
      var verticalChrome = parseFloat(styles.paddingTop || 0) + parseFloat(styles.paddingBottom || 0) + parseFloat(styles.borderTopWidth || 0) + parseFloat(styles.borderBottomWidth || 0);

      return Math.ceil(this.$refs.marketContentInner.offsetHeight + verticalChrome);
    },
    resolveContentMinHeight: function resolveContentMinHeight() {
      if (!this.$refs.marketContent) {
        return 0;
      }

      var naturalHeight = this.getNaturalContentHeight();
      var scrollTop = window.pageYOffset || window.scrollY || 0;
      var contentTop = this.$refs.marketContent.getBoundingClientRect().top + scrollTop;
      var currentHeight = this.$refs.marketContent.offsetHeight;
      var documentHeight = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
      var chromeBelowContent = Math.max(0, documentHeight - contentTop - currentHeight);
      var viewportBottom = scrollTop + window.innerHeight;
      // The page shell needs this temporary min-height so tab swaps do not clamp the document
      // while the next panel is mounting and the scroll position is being restored.
      var minHeightToPreventClamp = Math.max(0, viewportBottom - contentTop - chromeBelowContent);

      return Math.ceil(Math.max(naturalHeight, minHeightToPreventClamp));
    },
    syncDesktopContentMinHeight: function syncDesktopContentMinHeight() {
      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      var nextHeight = this.resolveContentMinHeight();

      if (nextHeight > 0 && nextHeight !== this.desktopContentMinHeight) {
        this.desktopContentMinHeight = nextHeight;
      }
    },
    refreshDesktopContentHeightTracking: function refreshDesktopContentHeightTracking() {
      var _this3 = this;

      if (this.isResetting) {
        return;
      }

      this.$nextTick(function () {
        if (!_this3.isLayoutDesktop || !_this3.$refs.marketContent || !_this3.$refs.marketContentInner) {
          _this3.destroyDesktopContentHeightTracking({ resetHeight: true });
          return;
        }

        _this3.syncDesktopContentMinHeight();

        if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
          _this3.destroyDesktopContentHeightTracking();
          _this3.contentResizeObserver = new ResizeObserver(function () {
            _this3.syncDesktopContentMinHeight();
          });
          _this3.contentResizeObserver.observe(_this3.$refs.marketContentInner);
        }

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            _this3.syncDesktopContentMinHeight();
          });
        }
      });
    },
    isDesktopToolbarPinned: function isDesktopToolbarPinned() {
      if (!this.isLayoutDesktop) {
        return false;
      }

      var $toolbar = this.$el ? this.$el.querySelector('.page-market-detail-sushi__toolbar') : null;
      if (!$toolbar) {
        return false;
      }

      var stickyTop = this.headerHeight + this.desktopStickyTitleOffset;
      var toolbarTop = $toolbar.getBoundingClientRect().top;

      return toolbarTop <= stickyTop + 1;
    },
    resetDesktopTabContentScroll: function resetDesktopTabContentScroll() {
      var _this4 = this;

      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      var $toolbar = this.$el ? this.$el.querySelector('.page-market-detail-sushi__toolbar') : null;
      if (!$toolbar) {
        return;
      }

      var toolbarBottom = $toolbar.getBoundingClientRect().bottom;
      var scrollTop = window.pageYOffset || window.scrollY || 0;
      var contentTop = this.$refs.marketContent.getBoundingClientRect().top + scrollTop;
      var nextScrollTop = Math.max(0, Math.ceil(contentTop - toolbarBottom));

      // Once the desktop tabs are pinned, reset the new tab back to its own top instead of inheriting a deep scroll from the last tab.
      window.scrollTo(0, nextScrollTop);

      if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
        window.requestAnimationFrame(function () {
          _this4.syncDesktopContentMinHeight();
        });
        return;
      }

      this.syncDesktopContentMinHeight();
    },
    isMobileToolbarVisible: function isMobileToolbarVisible() {
      if (!this.isLayoutMobile || !this.$el) {
        return false;
      }

      var $toolbar = this.$el.querySelector('.page-market-detail-sushi__toolbar');
      if (!$toolbar) {
        return false;
      }

      var toolbarRect = $toolbar.getBoundingClientRect();

      return toolbarRect.bottom > this.headerHeight && toolbarRect.top < window.innerHeight;
    },
    scheduleMobileContentHeightRelease: function scheduleMobileContentHeightRelease() {
      var _this5 = this;

      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$delay = _ref4.delay,
          delay = _ref4$delay === undefined ? 0 : _ref4$delay;

      var release = function release() {
        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          _this5.mobileContentHeightReleaseAnimationFrame = window.requestAnimationFrame(function () {
            _this5.mobileContentHeightReleaseAnimationFrame = window.requestAnimationFrame(function () {
              _this5.mobileContentHeightReleaseAnimationFrame = null;
              _this5.mobileContentMinHeight = 0;
            });
          });
          return;
        }

        _this5.mobileContentMinHeight = 0;
      };

      this.cancelMobileContentHeightRelease();

      if (delay > 0) {
        this.mobileContentHeightReleaseTimer = window.setTimeout(function () {
          _this5.mobileContentHeightReleaseTimer = null;
          release();
        }, delay);
        return;
      }

      release();
    },
    restoreMobileTabContentScroll: function restoreMobileTabContentScroll(tab) {
      var _this6 = this;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$preserveToolbar = _ref5.preserveToolbarPosition,
          preserveToolbarPosition = _ref5$preserveToolbar === undefined ? false : _ref5$preserveToolbar;

      if (!this.isLayoutMobile || !this.$refs.marketContent) {
        this.destroyMobileContentHeightLock({ resetHeight: true });
        return;
      }

      if (preserveToolbarPosition) {
        this.scheduleMobileContentHeightRelease({ delay: 400 });
        return;
      }

      var topOffset = this.headerHeight;

      if (this.$refs.marketTitle) {
        topOffset += this.$refs.marketTitle.offsetHeight;
      }

      if (this.tabScrollPositions[tab] !== undefined) {
        __WEBPACK_IMPORTED_MODULE_40__logger__["a" /* default */].info('Scrolling to last position for ' + tab);
        window.scrollTo(0, this.tabScrollPositions[tab]);
        this.scheduleMobileContentHeightRelease();
        return;
      }

      this.scheduleMobileContentHeightRelease({ delay: 400 });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_scrollTo__["a" /* default */])(this.$refs.marketContent, 250, 'linear', null, topOffset, function () {
        _this6.scheduleMobileContentHeightRelease();
      });
    },
    syncDesktopStickyTitleHeight: function syncDesktopStickyTitleHeight() {
      if (!this.isLayoutDesktop || !this.isTitleSticky || !this.$refs.marketTitle) {
        this.desktopStickyTitleHeight = 0;
        return;
      }

      this.desktopStickyTitleHeight = this.$refs.marketTitle.offsetHeight;
    },
    getPageScrollTop: function getPageScrollTop() {
      var scrollTop = window.pageYOffset || window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

      if (this.isLayoutMobile && this.bottomBetslipExtended && document.body.style.position === 'fixed' && document.body.style.top) {
        var lockedScrollTop = parseInt(document.body.style.top, 10);

        if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(lockedScrollTop)) {
          scrollTop = Math.abs(lockedScrollTop);
        }
      }

      return scrollTop;
    },
    isAtPageTop: function isAtPageTop() {
      var scrollTop = this.getPageScrollTop();

      return scrollTop <= 1;
    },
    scheduleStickyTitleStateUpdate: function scheduleStickyTitleStateUpdate() {
      var _this7 = this;

      this.$nextTick(function () {
        var update = function update() {
          _this7.updateTitleStickyState();
        };

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(update);
          return;
        }

        update();
      });
    },
    updateTitleStickyState: function updateTitleStickyState() {
      var stickySentinelTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.isLayoutMobile && this.isAtPageTop()) {
        this.isTitleSticky = false;
        return;
      }

      if (stickySentinelTop === null) {
        if (!this.$refs.stickySentinel) {
          this.isTitleSticky = false;
          return;
        }

        stickySentinelTop = this.$refs.stickySentinel.getBoundingClientRect().top;
      }

      this.isTitleSticky = !this.isMarketDisabled && stickySentinelTop <= this.headerHeight;
    },
    refreshStickyObserver: function refreshStickyObserver() {
      var _this8 = this;

      if (this.isResetting) {
        return;
      }

      this.$nextTick(function () {
        _this8.initStickyObserver();
      });
    },
    initStickyObserver: function initStickyObserver() {
      var _this9 = this;

      this.destroyStickyTracking();

      if (!this.$refs.stickySentinel) {
        this.isTitleSticky = false;
        return;
      }

      var useScrollFallback = this.isLayoutMobile || !('IntersectionObserver' in window);
      if (useScrollFallback) {
        this.initScrollFallback();
      }

      if (!('IntersectionObserver' in window)) {
        this.updateTitleStickyState();
        return;
      }

      this.stickyObserver = new IntersectionObserver(function (_ref6) {
        var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref6, 1),
            entry = _ref7[0];

        _this9.updateTitleStickyState(entry.boundingClientRect.top);
      }, {
        rootMargin: '-' + this.headerHeight + 'px 0px 0px 0px',
        threshold: [0]
      });

      this.stickyObserver.observe(this.$refs.stickySentinel);
      this.updateTitleStickyState();
    },
    initScrollFallback: function initScrollFallback() {
      var _this10 = this;

      this.onScroll = function () {
        if (_this10.stickyScrollAnimationFrame) {
          return;
        }

        if (!window.requestAnimationFrame) {
          _this10.updateTitleStickyState();
          return;
        }

        _this10.stickyScrollAnimationFrame = window.requestAnimationFrame(function () {
          _this10.stickyScrollAnimationFrame = null;
          _this10.updateTitleStickyState();
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
    },
    onWatchToggle: function onWatchToggle() {
      this.retrieveMarketData({ marketId: this.marketId, clearOrderBook: false, clearMarket: true, loader: false });
    },
    onTitleMouseOver: function onTitleMouseOver() {
      this.titleHovered = true;
    },
    onTitleMouseLeave: function onTitleMouseLeave() {
      this.titleHovered = false;
    },
    openNewMarketStats: function openNewMarketStats() {
      var _this11 = this;

      this.loaderAdd(document.body);
      this.getMarketContractsStats(this.market.marketId).then(function (data) {
        _this11.loaderRemove(document.body);
        if (!data) {
          return;
        }
        _this11.setGenericPopup({
          name: __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].MARKET_CONTRACT_STATS,
          options: {
            stats: data,
            isFixed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["q" /* hasMarketHiddenContracts */])(_this11.market)
          }
        });
      }).catch(function () {
        return _this11.loaderRemove(document.body);
      });
    },
    openPotentialPayouts: function openPotentialPayouts() {
      this.setGenericPopup({
        name: __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].POTENTIAL_PAYOUTS,
        options: {
          market: this.market
        }
      });
    },
    syncDiscussionLocation: function syncDiscussionLocation() {
      var commentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var commentThreadId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var currentQuery = getCurrentLocationQuery();
      var resolvedRoute = this.$router.resolve({
        name: this.$route.name,
        params: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.$route.params, {
          dontReload: true
        }),
        query: buildDiscussionQuery(currentQuery, commentId, commentThreadId),
        hash: buildCommentHash(commentId)
      });

      // Keep Disqus-only state out of Vue Router so the routed page shell does not remount.
      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
    },
    syncTabLocation: function syncTabLocation(tab) {
      var currentQuery = getCurrentLocationQuery();
      var resolvedRoute = this.$router.resolve({
        name: this.$route.name,
        params: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.$route.params, {
          dontReload: true
        }),
        query: buildTabQuery(currentQuery, tab),
        hash: ''
      });

      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
    },
    resolveActiveTabForCurrentUser: function resolveActiveTabForCurrentUser(tab) {
      if (!ROUTE_DRIVEN_TABS.includes(tab)) {
        return NAVIGATION_TABS.CONTRACTS;
      }

      if (AUTH_REQUIRING_TABS.includes(tab) && !this.isLoggedIn) {
        return NAVIGATION_TABS.CONTRACTS;
      }

      return tab;
    },
    syncActiveTabFromRoute: function syncActiveTabFromRoute() {
      var currentQuery = getCurrentLocationQuery();
      var activeTab = this.resolveActiveTabForCurrentUser(this.$route.query.tab || currentQuery.tab);

      if (activeTab !== this.activeTab) {
        this.activeTab = activeTab;
      }

      this.scheduleToolbarTabIntoView(activeTab);
    },
    updateDiscussionRequest: function updateDiscussionRequest() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$commentId = _ref8.commentId,
          commentId = _ref8$commentId === undefined ? '' : _ref8$commentId,
          _ref8$commentThreadId = _ref8.commentThreadId,
          commentThreadId = _ref8$commentThreadId === undefined ? 0 : _ref8$commentThreadId;

      this.requestedDiscussionCommentId = commentId;
      this.requestedDiscussionCommentThreadId = normalizeCommentThreadId(commentThreadId);
      this.syncDiscussionLocation(this.requestedDiscussionCommentId, this.requestedDiscussionCommentThreadId);
    },
    onOpenDiscussion: function onOpenDiscussion() {
      this.activeTab = NAVIGATION_TABS.DISCUSSION;
      this.updateDiscussionRequest();
    },
    onOpenDiscussionComment: function onOpenDiscussionComment(comment) {
      var commentId = comment && comment.commentId ? comment.commentId : '';
      var commentThreadId = comment && comment.commentThreadId ? Number(comment.commentThreadId) : 0;

      this.activeTab = NAVIGATION_TABS.DISCUSSION;
      this.updateDiscussionRequest({
        commentId: commentId,
        commentThreadId: commentThreadId
      });
    },
    onDiscussionRequestChange: function onDiscussionRequestChange() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.updateDiscussionRequest(payload);
    },
    navigationTabChange: function navigationTabChange(name) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_40__logger__["a" /* default */].info('[TABS] Change to: ' + name + ' from ' + this.activeTab);
      var isTheSameTab = this.activeTab === name;

      if (isTheSameTab) {
        return;
      }

      if (this.activeTab === NAVIGATION_TABS.DISCUSSION) {
        this.discussionWidgetRouteSwap += 1;
      }

      // Only do the desktop reset when the tabs are already pinned, otherwise we bring the old toolbar jump back in the non-sticky state.
      var shouldResetDesktopTabContentScroll = this.isLayoutDesktop && this.isDesktopToolbarPinned();
      var shouldPreserveMobileToolbarPosition = this.isLayoutMobile && this.isMobileToolbarVisible();

      if (this.isLayoutDesktop) {
        this.captureDesktopContentHeight();
      } else {
        // Mobile needs the outgoing panel height held through the swap so the page does not
        // shrink and yank the midpage tabs around before the new panel finishes mounting.
        this.captureMobileContentHeight();
        this.tabScrollPositions[this.activeTab] = window.scrollY || window.pageYOffset;
      }

      this.activeTab = name;
      if (this.activeTab === NAVIGATION_TABS.DISCUSSION) {
        this.updateDiscussionRequest();
      } else {
        this.requestedDiscussionCommentId = '';
        this.requestedDiscussionCommentThreadId = 0;
        this.syncTabLocation(this.activeTab);
      }
      if (this.activeTab === NAVIGATION_TABS.CONTRACTS) {
        this.setBottomWidgetFooterMode(this.bottomWidgetFooterModeContractsSection);
      }
      this.$nextTick(function () {
        _this12.scheduleToolbarTabIntoView(name);

        if (_this12.isLayoutDesktop) {
          _this12.refreshDesktopContentHeightTracking();

          if (shouldResetDesktopTabContentScroll) {
            if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
              window.requestAnimationFrame(function () {
                _this12.resetDesktopTabContentScroll();
              });
            } else {
              _this12.resetDesktopTabContentScroll();
            }
          }
          return;
        }

        _this12.restoreMobileTabContentScroll(name, { preserveToolbarPosition: shouldPreserveMobileToolbarPosition });
      });
    },
    retrieveMarketData: function retrieveMarketData(_ref9) {
      var _this13 = this;

      var marketId = _ref9.marketId,
          _ref9$clearMarket = _ref9.clearMarket,
          clearMarket = _ref9$clearMarket === undefined ? true : _ref9$clearMarket,
          _ref9$clearOrderBook = _ref9.clearOrderBook,
          clearOrderBook = _ref9$clearOrderBook === undefined ? true : _ref9$clearOrderBook,
          _ref9$loader = _ref9.loader,
          loader = _ref9$loader === undefined ? true : _ref9$loader;

      if (clearOrderBook) {
        this.clearOrderBook();
      }
      if (marketId) {
        if (loader) {
          this.loaderAdd(document.body);
        }
        var commentThreadId = this.$route.query.commentThreadId;
        return this.getMarket({ marketId: marketId, commentThreadId: commentThreadId, skipCache: clearMarket }).then(function (data) {
          if (loader) {
            _this13.loaderRemove(document.body);
          }
          if (data.econIndicatorTradeStatus === 3) {
            _this13.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
          }
        }).catch(function () {
          if (loader) {
            _this13.loaderRemove(document.body);
          }
          _this13.$router.push({ name: 'not-found' });
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
    },
    addBoxLoading: function addBoxLoading() {
      var $el = document.querySelector('.purchase-offer-desktop-sushi-common-betslip__box');
      if ($el) {
        $el.classList.add('purchase-offer-desktop-sushi-common-betslip__box--loading');
      }

      var $el2 = document.querySelector('.purchase-offer-sushi-mobile-bar');
      if ($el2) {
        $el2.classList.add('purchase-offer-sushi-mobile-bar--loading');
      }
    },
    removeBoxLoading: function removeBoxLoading() {
      var $el = document.querySelector('.purchase-offer-desktop-sushi-common-betslip__box');
      if ($el) {
        $el.classList.remove('purchase-offer-desktop-sushi-common-betslip__box--loading');
      }

      var $el2 = document.querySelector('.purchase-offer-sushi-mobile-bar');
      if ($el2) {
        $el2.classList.remove('purchase-offer-sushi-mobile-bar--loading');
      }
    },
    loadHandler: function loadHandler(value) {
      var _this14 = this;

      if (!this.initialised) {
        this.applyDefaultMobileFooterMode();
        this.startPageSetup();
      }

      this.addBoxLoading();
      this.reloading = true;

      if (value) {
        this.retrieveMarketData({
          marketId: this.marketId, clearOrderBook: false, clearMarket: true
        }).then(__WEBPACK_IMPORTED_MODULE_16__utils_mutex__["b" /* waitForStatusReady */]).then(function () {
          if (!_this14.initialised) {
            _this14.setupPage();
          } else {
            _this14.switchContractSideIfNecessaryBecauseOfOwnership();
          }
          _this14.syncActiveTabFromRoute();
          _this14.removeBoxLoading();
          _this14.initialised = true;
          _this14.reloading = false;
        });
      } else {
        this.retrieveMarketData({
          marketId: this.marketId, clearOrderBook: true, clearMarket: true
        }).then(function () {
          if (!_this14.initialised) {
            _this14.setupPage();
          }
          _this14.syncActiveTabFromRoute();
          _this14.removeBoxLoading();
          _this14.initialised = true;
          _this14.reloading = false;
        });
      }
    },
    switchContractSideIfNecessaryBecauseOfOwnership: function switchContractSideIfNecessaryBecauseOfOwnership() {
      var _this15 = this;

      if (this.isMarketDisabled) {
        return;
      }

      if (!this.tradeOptions.contractId) {
        return;
      }

      var contract = this.contracts.find(function (c) {
        return c.contractId === _this15.tradeOptions.contractId;
      });
      if (!contract) {
        return;
      }

      var contractModel = new __WEBPACK_IMPORTED_MODULE_36__models_contract__["a" /* default */](contract);
      if (!contractModel.mode || contractModel.mode === this.tradeOptions.operationValue) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_40__logger__["a" /* default */].info('[PURCHASE] switching sides after signin');
      this.setTradeOptions({
        contractId: contract.contractId,
        operationType: __WEBPACK_IMPORTED_MODULE_37__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__["b" /* OPERATIONS */].BUY,
        operationValue: contractModel.mode
      });
      this.setTradePrice(contractModel.mode === __WEBPACK_IMPORTED_MODULE_37__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__["c" /* VALUES */].YES ? contractModel.buyYesCostAsCents : contractModel.buyNoCostAsCents);
    },
    startPageSetup: function startPageSetup() {
      this.isResetting = true;
      this.isTitleSticky = false;
      this.hideMainChart = false;
      this.destroyStickyTracking();
      this.destroyDesktopContentHeightTracking({ resetHeight: true });
      this.destroyMobileContentHeightLock({ resetHeight: true });
    },
    setupPage: function setupPage() {
      this.isResetting = false;
      this.reorganizeTags();
      this.refreshStickyObserver();
      this.refreshDesktopContentHeightTracking();
      this.initToolbarTabsScrollTracking();
    }
  }),
  watch: {
    lastConfirmedContractData: function lastConfirmedContractData(data) {
      var contractIds = (this.contracts || []).map(function (i) {
        return i.contractId;
      });
      if (data && data.matched && contractIds.includes(data.id)) {
        this.showHistory = true;
      }
    },

    isLoggedIn: {
      handler: 'loadHandler',
      immediate: true
    },
    headerHeight: function headerHeight(value, oldValue) {
      if (!value || value === oldValue) {
        return;
      }

      this.syncDesktopStickyTitleHeight();
      this.refreshStickyObserver();
    },
    isLayoutMobile: function isLayoutMobile(value, oldValue) {
      if (value === oldValue) {
        return;
      }

      this.destroyMobileContentHeightLock({ resetHeight: true });
      this.initToolbarTabsScrollTracking();

      if (value) {
        this.destroyDesktopContentHeightTracking({ resetHeight: true });
      } else {
        this.refreshDesktopContentHeightTracking();
      }

      this.syncDesktopStickyTitleHeight();
      this.refreshStickyObserver();
    },
    bottomBetslipExtended: function bottomBetslipExtended(value, oldValue) {
      if (value === oldValue || !this.isLayoutMobile) {
        return;
      }

      this.scheduleStickyTitleStateUpdate();
    },
    isTitleSticky: function isTitleSticky(value, oldValue) {
      var _this16 = this;

      if (value === oldValue) {
        return;
      }

      this.$nextTick(function () {
        _this16.syncDesktopStickyTitleHeight();

        if (value && typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            _this16.syncDesktopStickyTitleHeight();
          });
        }
      });
    },
    showStickyTitleSummary: function showStickyTitleSummary(value, oldValue) {
      var _this17 = this;

      if (value === oldValue) {
        return;
      }

      this.$nextTick(function () {
        _this17.syncDesktopStickyTitleHeight();

        if (_this17.isLayoutDesktop && typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            _this17.syncDesktopStickyTitleHeight();
          });
        }
      });
    },
    $route: function $route(to, from) {
      var _this18 = this;

      if (from && to) {
        this.activeTab = this.resolveActiveTabForCurrentUser(to.query.tab);
        this.requestedDiscussionCommentId = resolveDiscussionCommentId(to);
        this.requestedDiscussionCommentThreadId = normalizeCommentThreadId(to.query.commentThreadId);
        this.scheduleToolbarTabIntoView(this.activeTab);

        if (resolveRouteMarketId(to) === resolveRouteMarketId(from)) {
          return;
        }

        this.applyDefaultMobileFooterMode({ fromRoute: from });
        this.setBottomBetSlipExtendedMode(false);
        this.startPageSetup();
        this.retrieveMarketData({
          marketId: to.params.marketId,
          clearOrderBook: true,
          clearMarket: true
        }).then(function () {
          _this18.setupPage();
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyStickyTracking();
    this.destroyDesktopContentHeightTracking({ resetHeight: true });
    this.destroyMobileContentHeightLock({ resetHeight: true });
    this.destroyToolbarTabsScrollTracking();
    this.clearMarketEngineBusyMessage();
    this.setTradeOptions(null);
    this.toggleHidePurchaseForContractId(null);
    this.clearMarket();
    this.clearOrderBook();
    this.setBottomBetSlipExtendedMode(false);
    document.title = DEFAULT_PAGE_TITLE;
  }
});

/***/ }),

/***/ "KAwH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KFNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_user_status_js__ = __webpack_require__("4/49");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76665e99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_user_status_vue__ = __webpack_require__("ZSKQ");
function injectStyle (ssrContext) {
  __webpack_require__("jHoo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_user_status_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76665e99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_user_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KHbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-list-item-v2-embed",class:{ 'market-list-item-v2-embed--vertical': _vm.isVerticalList }},[(_vm.showTitle)?_c('div',{staticClass:"market-list-item-v2-embed__header"},[_c('div',{staticClass:"market-list-item-v2-embed__header-text"},[_vm._v("\n      Related Markets:\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2-embed__header-text--small"},[_vm._v("\n      "+_vm._s(_vm.markets.length)+" Market"),(_vm.markets.length !== 1)?[_vm._v("s")]:_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2-embed__grid",style:(_vm.gridStyleModifiers)},_vm._l((_vm.markets),function(market){return _c('div',{staticClass:"market-list-item-v2-embed__grid-item"},[_c('market-list-item',{key:market.marketId,attrs:{"market":market}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KJ3Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KNAh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CodeInput',

    props: {
        value: {
            type: String,
            default: ''
        },
        error: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        length: {
            type: Number,
            default: 6
        }
    },

    data: function data() {
        return {
            digits: Array(this.length).fill('')
        };
    },


    computed: {
        isComplete: function isComplete() {
            return this.digits.every(function (d) {
                return d !== '';
            });
        },
        codeValue: function codeValue() {
            return this.digits.join('');
        }
    },

    watch: {
        value: {
            immediate: true,
            handler: function handler(newVal) {
                if (newVal !== this.codeValue) {
                    this.setCodeFromValue(newVal);
                }
            }
        }
    },

    methods: {
        /**
         * Handle input event - auto-advance to next input and distribute autofill content
         */
        handleInput: function handleInput(event, index) {
            var _this = this;

            var numericValue = this.getNumericValue(event.target.value);

            if (numericValue.length > 1) {
                // iOS one-time-code autofill injects the full code into the focused field.
                var startIndex = numericValue.length >= this.length ? 0 : index;
                this.applyCode(numericValue, startIndex);
                return;
            }

            if (numericValue.length > 0) {
                this.$set(this.digits, index, numericValue);

                // Auto-advance to next input
                if (index < this.length - 1) {
                    this.$nextTick(function () {
                        _this.focusInput(index + 1);
                    });
                }
            } else {
                this.$set(this.digits, index, '');
            }

            this.emitUpdate();
        },


        /**
         * Handle keydown events - backspace navigation and arrow keys
         */
        handleKeydown: function handleKeydown(event, index) {
            var key = event.key;

            if (key === 'Backspace') {
                if (this.digits[index] === '' && index > 0) {
                    // If current input is empty, go to previous and clear it
                    event.preventDefault();
                    this.$set(this.digits, index - 1, '');
                    this.focusInput(index - 1);
                    this.emitUpdate();
                } else if (this.digits[index] !== '') {
                    // Clear current input
                    this.$set(this.digits, index, '');
                    this.emitUpdate();
                }
            } else if (key === 'ArrowLeft' && index > 0) {
                event.preventDefault();
                this.focusInput(index - 1);
            } else if (key === 'ArrowRight' && index < this.length - 1) {
                event.preventDefault();
                this.focusInput(index + 1);
            } else if (key === 'Enter' && this.isComplete) {
                this.$emit('submit');
            }
        },


        /**
         * Handle paste event - fill all inputs from pasted content
         */
        handlePaste: function handlePaste(event) {
            event.preventDefault();

            var pastedData = (event.clipboardData || window.clipboardData).getData('text');
            this.applyCode(pastedData);
        },


        /**
         * Select content on focus for easy replacement
         */
        handleFocus: function handleFocus(event) {
            event.target.select();
        },
        getNumericValue: function getNumericValue(value) {
            return (value || '').replace(/\D/g, '');
        },
        applyCode: function applyCode(value) {
            var _this2 = this;

            var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var numericValue = this.getNumericValue(value).slice(0, this.length - startIndex);

            if (numericValue.length === 0) {
                return;
            }

            for (var offset = 0; offset < numericValue.length; offset++) {
                this.$set(this.digits, startIndex + offset, numericValue[offset]);
            }

            if (startIndex === 0) {
                for (var i = numericValue.length; i < this.length; i++) {
                    this.$set(this.digits, i, '');
                }
            }

            this.$nextTick(function () {
                _this2.focusNextAvailableInput(startIndex);
            });

            this.emitUpdate();
        },
        focusNextAvailableInput: function focusNextAvailableInput() {
            var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            var nextEmptyIndex = this.digits.findIndex(function (digit, index) {
                return index >= startIndex && digit === '';
            });

            if (nextEmptyIndex !== -1) {
                this.focusInput(nextEmptyIndex);
                return;
            }

            this.focusInput(this.length - 1);
        },


        /**
         * Focus a specific input by index
         */
        focusInput: function focusInput(index) {
            var inputs = this.$refs.inputs;
            if (inputs && inputs[index]) {
                inputs[index].focus();
            }
        },


        /**
         * Public method: focus the first input
         */
        focusFirst: function focusFirst() {
            this.focusInput(0);
        },


        /**
         * Public method: clear all inputs
         */
        clear: function clear() {
            var _this3 = this;

            this.digits = Array(this.length).fill('');
            this.emitUpdate();
            this.$nextTick(function () {
                _this3.focusFirst();
            });
        },


        /**
         * Set digits from external value
         */
        setCodeFromValue: function setCodeFromValue(value) {
            var chars = (value || '').split('');
            for (var i = 0; i < this.length; i++) {
                this.$set(this.digits, i, chars[i] || '');
            }
        },


        /**
         * Emit update events
         */
        emitUpdate: function emitUpdate() {
            var code = this.codeValue;
            this.$emit('input', code);
            this.$emit('update:value', code);

            if (this.isComplete) {
                this.$emit('complete', code);
            }
        }
    }
});

/***/ }),

/***/ "KR/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-report"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{ref:"fileuploadform",attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form-select',{staticClass:"user-report__subject",attrs:{"searchable":false,"maxHeight":300,"adjust":false,"disabled":_vm.isFormDisabled,"options":_vm.reasonOptions,"required":true,"label":"label","placeholder":"Reason","track-by":"value"},on:{"input":_vm.$v.fields.reason.$touch},model:{value:(_vm.fields.reason),callback:function ($$v) {_vm.$set(_vm.fields, "reason", $$v)},expression:"fields.reason"}}),_vm._v(" "),_c('form-textarea',{staticClass:"user-report__message",attrs:{"required":_vm.messageRequired,"name":"help-message","placeholder":_vm.messagePlaceholder},model:{value:(_vm.fields.message),callback:function ($$v) {_vm.$set(_vm.fields, "message", $$v)},expression:"fields.message"}}),_vm._v(" "),_c('input',{ref:"fileinput",staticClass:"user-report__file",attrs:{"type":"file","multiple":"multiple"},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"user-report__footer"},[(_vm.isUploadEnabled)?_c('button',{staticClass:"user-report__button user-report__upload",attrs:{"disabled":_vm.isFormDisabled,"name":"upload-button","type":"button"},on:{"click":_vm.onUpload}},[_vm._v("\n        Upload\n      ")]):_vm._e()]),_vm._v(" "),(_vm.files.length > 0)?_c('ul',{staticClass:"user-report__files"},[_vm._l((_vm.files),function(file,index){return [_c('li',[_vm._v(_vm._s(file.name)+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.fileRemove(index)}}},[_vm._v("(Remove)")])])]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"user-report__footer"},[_c('button',{staticClass:"user-report__button user-report__submit",attrs:{"type":"submit","disabled":_vm.invalidOrDisabled,"name":"help-button"}},[_vm._v("Send")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KRSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mySharesCount > 0)?_c('div',{class:_vm.classModifiers},[(_vm.theme === 'sushi')?_c('div',{staticClass:"dashboard-markets-toggle__anchor",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")]):_c('button',{staticClass:"button button--primary dashboard-markets-toggle__button",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.buttonText))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KRkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("jLJc");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_001c5ad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("6b6f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_001c5ad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KUSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__ = __webpack_require__("MJqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_unreadNotification__ = __webpack_require__("BL43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__ = __webpack_require__("P71F");


 /*
                                       Display List of notifications in dashboard/account pages.
                                      */







var NOTIFICATION_COUNT_LIMIT = 99;
var NO_ITEMS_MESSAGE = 'There are no notifications';
var NO_MORE_ITEMS_MESSAGE = 'No more notifications to display';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_unreadNotification__["a" /* default */]],
  props: {
    limit: {
      type: Number,
      default: null
    },
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    notificationItemDashboard: __WEBPACK_IMPORTED_MODULE_5__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      loadedInfo: NO_ITEMS_MESSAGE,
      infiniteLoader: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('dashboard', ['notifications', 'notificationsToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['userData']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'notifications-list': true
      }, 'notifications-list--' + this.theme, this.theme);
    },
    items: function items() {
      var data = this.notifications.data;

      if (this.limit) {
        data = this.notifications.data.slice(0, this.limit);
      }
      return __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(data, function (el) {
        return el.notificationId;
      });
    },
    notificationsCount: function notificationsCount() {
      var total = this.notifications.totalCount;
      return total > NOTIFICATION_COUNT_LIMIT ? NOTIFICATION_COUNT_LIMIT : total;
    },
    showInfiniteLoading: function showInfiniteLoading() {
      return this.notifications.canLoadMore && !this.limit;
    },
    isScrollMore: function isScrollMore() {
      return this.infiniteLoader && this.notifications.canLoadMore && this.items.length > 0;
    }
  }),
  watch: {
    notificationsToggle: function notificationsToggle() {
      this.infiniteLoader = null;
      this.resetNotifications();
      this.loadNotifications();
    },
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.notifications.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
      this.loadedInfo = this.items.length > 0 ? NO_MORE_ITEMS_MESSAGE : NO_ITEMS_MESSAGE;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('dashboard', ['resetNotifications', 'getNotifications']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['toggleNotificationsWidget']), {
    onSeeAllClick: function onSeeAllClick() {
      this.toggleNotificationsWidget();
      this.$router.push({ name: 'dashboard-notifications' });
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.notifications.canLoadMore) {
        this.loadNotifications();
      }
    },
    loadNotifications: function loadNotifications() {
      var _this = this;

      if (this.loading) return;

      this.loading = true;
      this.getNotifications().then(function () {
        _this.loading = false;
        _this.isComponentReady = true;
      });
    }
  }),
  created: function created() {
    this.resetNotifications();
    this.loadNotifications();
  }
});

/***/ }),

/***/ "KVSF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KWv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_home_old_home_old_vue__ = __webpack_require__("3Uxo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_trends_trends_vue__ = __webpack_require__("dywA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_page_markets_page_markets_vue__ = __webpack_require__("CIck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_story_detail_page_story_detail_vue__ = __webpack_require__("p+/I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_search_page_search_vue__ = __webpack_require__("HK72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_watchlist_page_watchlist_vue__ = __webpack_require__("UwQr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_page_privacy_policy_page_privacy_policy_vue__ = __webpack_require__("6V5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_page_terms_and_conditions_page_terms_and_conditions_vue__ = __webpack_require__("v+Mv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_page_platform_announcements_page_platform_announcements_vue__ = __webpack_require__("AyUZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_debug_debug_vue__ = __webpack_require__("V/Y1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_page_sitemap_page_sitemap_vue__ = __webpack_require__("PVzo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_page_research_page_research_vue__ = __webpack_require__("HLCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_page_leaderboards_page_leaderboards_vue__ = __webpack_require__("LnYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_page_not_found_page_not_found_vue__ = __webpack_require__("4kpQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_page_static_preview_page_static_preview_vue__ = __webpack_require__("n58p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_page_story_preview_page_story_preview_vue__ = __webpack_require__("220P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__ = __webpack_require__("Ykf8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_page_accessibility_statement_page_accessibility_statement_vue__ = __webpack_require__("aK6m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_pages_page_market_detail_sushi_page_market_detail_sushi_vue__ = __webpack_require__("rjLX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_pages_page_user_status_page_user_status_vue__ = __webpack_require__("KFNs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_pages_page_news_stories_page_news_stories_vue__ = __webpack_require__("jqqL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_page_news_archive_stories_page_news_archive_stories_vue__ = __webpack_require__("jcwD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__account__ = __webpack_require__("Rlrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__support__ = __webpack_require__("u0d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__dashboard__ = __webpack_require__("0IxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__static__ = __webpack_require__("gQ0Z");






























var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_25__account__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_26__support__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_27__dashboard__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_28__static__["a" /* default */]), [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components_home_home_old_home_old_vue__["a" /* default */],
  name: 'home',
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/setMarketsPageInitialLoadDone', false);
    next();
  }
}, {
  path: '/trends',
  component: __WEBPACK_IMPORTED_MODULE_2__components_home_trends_trends_vue__["a" /* default */],
  name: 'trends',
  meta: {
    requiresAuth: true
  }
}, {
  path: '/research',
  component: __WEBPACK_IMPORTED_MODULE_12__components_pages_page_research_page_research_vue__["a" /* default */],
  name: 'research'
}, {
  path: '/privacy-policy',
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_page_privacy_policy_page_privacy_policy_vue__["a" /* default */],
  name: 'privacy-policy'
}, {
  path: '/accessibility-statement',
  name: 'accessibility-statement',
  component: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_accessibility_statement_page_accessibility_statement_vue__["a" /* default */]
}, {
  path: '/terms-and-conditions',
  component: __WEBPACK_IMPORTED_MODULE_8__components_pages_page_terms_and_conditions_page_terms_and_conditions_vue__["a" /* default */],
  name: 'terms-and-conditions'
}, {
  path: '/platform-announcements',
  component: __WEBPACK_IMPORTED_MODULE_9__components_pages_page_platform_announcements_page_platform_announcements_vue__["a" /* default */],
  name: 'platform-announcements'
}, {
  path: '/markets/search',
  name: 'market-search',
  component: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_search_page_search_vue__["a" /* default */]
}, {
  path: '/markets/watchlist',
  name: 'market-watchlist',
  component: __WEBPACK_IMPORTED_MODULE_6__components_pages_page_watchlist_page_watchlist_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    // browse.selectedOrder etc i shared by watchlist and markets page
    __WEBPACK_IMPORTED_MODULE_24__logger__["a" /* default */].info('[WATCHLIST] Before enter setup');
    if (to.query.sortParameter) {
      __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', to.query.sortParameter);
    } else {
      __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', 'ALL');
    }
    if (to.query.sort) {
      __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/setOrderFromQuery', to.query.sort);
    } else {
      __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/setOrderFromQuery', 'traded');
    }
    next();
  }
}, {
  path: '/markets/detail/:marketId/:marketUrl?',
  name: 'market-details',
  component: __WEBPACK_IMPORTED_MODULE_19__components_pages_page_market_detail_sushi_page_market_detail_sushi_vue__["a" /* default */],
  meta: {
    appContentFullWidth: true
  },
  props: function props(route) {
    return {
      marketId: parseInt(route.params.marketId, 10),
      showRules: !!route.params.showRules,
      prerendered: route.query.prerendered
    };
  }
}, {
  path: '/markets/:headerId?/:headerUrl?',
  name: 'market-list',
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_markets_page_markets_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_24__logger__["a" /* default */].info('[MARKETS] Before enter setup');
    if (from.name !== 'market-list' && from.name !== 'payment-success' && from.name !== 'payment-fail') {
      __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/setMarketsPageInitialLoadDone', false);
    }
    if (to.query.filterIds) {
      to.query.filterIds.split(',').forEach(function (i) {
        var filterId = parseInt(i, 10);
        __WEBPACK_IMPORTED_MODULE_24__logger__["a" /* default */].info('[MARKETS] filterId passed: ' + filterId);
        if (filterId) __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/addFilter', filterId);
      });
    }
    if (to.query.sortParameter) {
      __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', to.query.sortParameter);
    }
    if (to.query.sort) {
      __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('browse/setOrderFromQuery', to.query.sort);
    }
    next();
  },
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl
    };
  }
}, {
  path: '/stories/detail/:storyId/:storyUrl?',
  name: 'story-details',
  component: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_story_detail_page_story_detail_vue__["a" /* default */],
  props: function props(route) {
    return {
      storyId: parseInt(route.params.storyId, 10)
    };
  }
}, {
  path: '/payment/success',
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_markets_page_markets_vue__["a" /* default */],
  name: 'payment-success',
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
      notificationText: 'Bitcoin Deposit Received',
      notificationLevel: 'success'
    };
  }
}, {
  path: '/payment/fail',
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_markets_page_markets_vue__["a" /* default */],
  name: 'payment-fail',
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl
    };
  }
}, {
  path: '/static-page-preview',
  component: __WEBPACK_IMPORTED_MODULE_15__components_pages_page_static_preview_page_static_preview_vue__["a" /* default */],
  name: 'static-page-preview',
  beforeEnter: function beforeEnter(to, from, next) {
    if (!to.query.previewId) {
      next({
        name: 'home'
      });
    } else {
      next();
    }
  },
  props: function props(route) {
    return {
      previewId: route.query.previewId
    };
  }
}, {
  path: '/story-full-preview',
  component: __WEBPACK_IMPORTED_MODULE_16__components_pages_page_story_preview_page_story_preview_vue__["a" /* default */],
  name: 'story-full-preview',
  beforeEnter: function beforeEnter(to, from, next) {
    if (!to.query.previewId) {
      next({
        name: 'home'
      });
    } else {
      next();
    }
  },
  props: function props(route) {
    return {
      previewId: route.query.previewId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.path,
  component: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["b" /* default */],
  name: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.path,
  component: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["b" /* default */],
  name: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].WEDNESDAY.path,
  component: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["b" /* default */],
  name: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].WEDNESDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].WEDNESDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].THURSDAY.path,
  component: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["b" /* default */],
  name: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].THURSDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].THURSDAY.pageId
    };
  }
}, {
  path: '/sitemap',
  component: __WEBPACK_IMPORTED_MODULE_11__components_pages_page_sitemap_page_sitemap_vue__["a" /* default */],
  name: 'sitemap'
}, {
  path: '/user-status',
  component: __WEBPACK_IMPORTED_MODULE_20__components_pages_page_user_status_page_user_status_vue__["a" /* default */],
  name: 'user-status'
}, {
  path: '/news',
  component: __WEBPACK_IMPORTED_MODULE_21__components_pages_page_news_stories_page_news_stories_vue__["a" /* default */],
  name: 'news-stories'
}, {
  path: '/news/archive',
  component: __WEBPACK_IMPORTED_MODULE_22__components_pages_page_news_archive_stories_page_news_archive_stories_vue__["a" /* default */],
  name: 'news-archive-stories'
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_14__components_pages_page_not_found_page_not_found_vue__["a" /* default */],
  name: 'not-found'
}]);

if (false) {
  routes.push({
    path: '/debug',
    component: pageDebug,
    name: 'debug'
  });
}

if (false) {
  routes.push({
    path: '/leaderboards',
    component: pageLeaderboards,
    name: 'leaderboards',
    beforeEnter: function beforeEnter(to, from, next) {
      log.info('[LEADERBOARDS] Before enter setup');
      if (typeof to.query.leaderboardId !== 'undefined') {
        log.info('[LEADERBOARDS] settings leaderboardId: ' + to.query.leaderboardId);
        store.dispatch('leaderboards/setSelectedLeaderboardId', parseInt(to.query.leaderboardId, 10));
      }
      if (to.query.dateRange) {
        log.info('[LEADERBOARDS] settings dateRange: ' + to.query.dateRange);
        store.dispatch('leaderboards/setLeaderboardsDateRange', parseInt(to.query.dateRange, 10));
      }
      next();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "KXaR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KaRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-upload-id"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"account-upload-id__note"},[_vm._v("\n    Save New Password\n  ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick($event)}}},[_vm._v("\n    Upload File\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-upload-id__icon"},[_c('img',{attrs:{"src":__webpack_require__("z6fO")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kbcc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDEwIDE2Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTcuMjA3LjQzOWwuMDAzLjAwNEExLjY1MyAxLjY1MyAwIDAgMSA4LjMzMyAwQzkuMjUzIDAgMTAgLjc0NyAxMCAxLjY2N2MwIC40ODYtLjIxMS45Mi0uNTQzIDEuMjI0bC4wMDMuMDA1LTUuMzI3IDQuODgyTDkuNDYgMTIuNjZsLS4wMDMuMDA1Yy4zMzIuMzAzLjU0My43MzYuNTQzIDEuMjIzIDAgLjkyLS43NDcgMS42NjctMS42NjcgMS42NjctLjQzNCAwLS44MjUtLjE3LTEuMTIzLS40NDNsLS4wMDMuMDA1TC41NCA5LjAwN2ExLjY3MSAxLjY3MSAwIDAgMSAwLTIuNDU4TDcuMjA3LjQzOXoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Kcew":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iUHJlZGljdEl0X01haW5fMjAyNiIgZGF0YS1uYW1lPSJQcmVkaWN0SXQgTWFpbiAyMDI2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMzEuNDEgOTQuMDgiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICMwMEE1RDc7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJJdCI+CiAgICA8cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjc5LjIgNS4xMSAyNzkuMiAyMy4xIDI3OS4yIDI0LjU2IDI3OS4yIDcwLjMzIDI5Mi4xNyA3MC4zMyAyOTIuMTcgMjQuNTYgMjkyLjE3IDIzLjEgMjkyLjE3IDUuMTEgMjc5LjIgNS4xMSIvPgogICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzI0LjMyLDIzdjguNjhoLTkuNXYyMy4zOWMwLDIuMTkuMzcsMy42NiwxLjEsNC4zOXMyLjE5LDEuMSw0LjM5LDEuMWMuNzMsMCwxLjQzLS4wMywyLjEtLjA5LjY3LS4wNiwxLjMxLS4xNSwxLjkyLS4yN3YxMC4wNWMtMS4xLjE4LTIuMzIuMy0zLjY2LjM3LTEuMzQuMDYtMi42NS4wOS0zLjkzLjA5LTIuMDEsMC0zLjkyLS4xNC01LjcxLS40MS0xLjgtLjI3LTMuMzgtLjgxLTQuNzUtMS42LTEuMzctLjc5LTIuNDUtMS45Mi0zLjI0LTMuMzgtLjc5LTEuNDYtMS4xOS0zLjM4LTEuMTktNS43NnYtMjcuODdoLTcuODZ2LTguNjhoNy44NnYtOS4zNGwxMi45OC00LjgzdjE0LjE2aDkuNVoiLz4KICA8L2c+CiAgPGcgaWQ9IlByZWRpY3QiPgogICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjcxLjc2LDIzLjF2OC42OGgtOS41djIzLjM5YzAsMi4xOS4zNywzLjY1LDEuMSw0LjM4LjczLjczLDIuMTksMS4xLDQuMzgsMS4xLjczLDAsMS40My0uMDMsMi4xLS4wOS42Ny0uMDYsMS4zMS0uMTUsMS45Mi0uMjd2MTAuMDVjLTEuMS4xOC0yLjMyLjMtMy42NS4zNy0xLjM0LjA2LTIuNjUuMDktMy45My4wOS0yLjAxLDAtMy45MS0uMTQtNS43MS0uNDEtMS44LS4yNy0zLjM4LS44MS00Ljc1LTEuNi0xLjM3LS43OS0yLjQ1LTEuOTItMy4yNC0zLjM4LS43OS0xLjQ2LTEuMTktMy4zOC0xLjE5LTUuNzZ2LTI3Ljg2aC03Ljg2di04LjY4aDcuODZ2LTkuNDRsMTIuOTctNC43MnYxNC4xNmg5LjVaIi8+CiAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMjIuNTcsMzEuNmMtMi4wNywwLTMuODEuNDctNS4yMSwxLjQyLTEuNC45NC0yLjU0LDIuMTYtMy40MywzLjY1LS44OCwxLjQ5LTEuNTEsMy4xNC0xLjg3LDQuOTMtLjM3LDEuOC0uNTUsMy41OC0uNTUsNS4zNHMuMTgsMy40NC41NSw1LjIxYy4zNywxLjc3Ljk2LDMuMzcsMS43OCw0Ljc5LjgyLDEuNDMsMS45MywyLjYxLDMuMzMsMy41MiwxLjQuOTEsMy4xMSwxLjM3LDUuMTIsMS4zNywzLjExLDAsNS40OS0uODcsNy4xNy0yLjYsMS42Ny0xLjc0LDIuNzItNC4wNywzLjE1LTYuOTloMTIuNTJjLS44NSw2LjI3LTMuMjksMTEuMDUtNy4zMSwxNC4zNC00LjAyLDMuMjktOS4xNyw0LjkzLTE1LjQ0LDQuOTMtMy41MywwLTYuNzgtLjU5LTkuNzMtMS43OC0yLjk2LTEuMTktNS40Ny0yLjg1LTcuNTQtNC45OC0yLjA3LTIuMTMtMy42OC00LjY3LTQuODQtNy42My0xLjE2LTIuOTUtMS43NC02LjItMS43NC05Ljczcy41My03LjA1LDEuNi0xMC4xOGMxLjA2LTMuMTQsMi42My01Ljg1LDQuNy04LjEzLDIuMDctMi4yOCw0LjYtNC4wNyw3LjU4LTUuMzQsMi45OC0xLjI4LDYuMzktMS45MiwxMC4yMy0xLjkyLDIuOCwwLDUuNS4zNyw4LjA5LDEuMSwyLjU5LjczLDQuOSwxLjg0LDYuOTQsMy4zMywyLjA0LDEuNDksMy43LDMuMzUsNC45OCw1LjU3LDEuMjgsMi4yMiwyLjAxLDQuODYsMi4xOSw3LjloLTEyLjdjLS44NS01LjQyLTQuMDUtOC4xMy05LjU5LTguMTMiLz4KICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE4Ni41OSw1LjExaDEyLjk3djEwLjY5aC0xMi45N1Y1LjExWk0xOTkuNTYsNzAuMzNoLTEyLjk3VjIzLjFoMTIuOTd2NDcuMjNaIi8+CiAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNzIuMzQsNjQuM2MtMS41MiwyLjU2LTMuNTIsNC40LTUuOTgsNS41My0yLjQ3LDEuMTMtNS4yNSwxLjY5LTguMzYsMS42OS0zLjUzLDAtNi42NC0uNjgtOS4zMi0yLjA2LTIuNjgtMS4zNy00Ljg5LTMuMjMtNi42Mi01LjU3LTEuNzQtMi4zNS0zLjA1LTUuMDQtMy45My04LjA5LS44OC0zLjA0LTEuMzItNi4yMS0xLjMyLTkuNXMuNDQtNi4yMywxLjMyLTkuMThjLjg4LTIuOTUsMi4xOS01LjU2LDMuOTMtNy44MSwxLjc0LTIuMjUsMy45MS00LjA2LDYuNTMtNS40NCwyLjYyLTEuMzcsNS42Ni0yLjA1LDkuMTMtMi4wNSwyLjgsMCw1LjQ3LjU5LDcuOTksMS43OCwyLjUzLDEuMTksNC41MiwyLjk0LDUuOTgsNS4yNWguMThWNS4xMWgxMi45N3Y2NS4yMmgtMTIuMzN2LTYuMDNoLS4xOFpNMTcxLjc5LDQwLjk2Yy0uMzctMS44LS45OS0zLjM4LTEuODctNC43NS0uODgtMS4zNy0yLjAzLTIuNDgtMy40My0zLjMzLTEuNC0uODUtMy4xNy0xLjI4LTUuMy0xLjI4cy0zLjkzLjQzLTUuMzksMS4yOGMtMS40Ni44NS0yLjYzLDEuOTgtMy41MiwzLjM4LS44OCwxLjQtMS41MiwzLTEuOTIsNC44LS40LDEuOC0uNTksMy42Ny0uNTksNS42MiwwLDEuODMuMjEsMy42NS42NCw1LjQ4LjQyLDEuODMsMS4xMSwzLjQ2LDIuMDYsNC44OS45NCwxLjQzLDIuMTMsMi41OSwzLjU2LDMuNDcsMS40My44OCwzLjE1LDEuMzIsNS4xNiwxLjMyLDIuMTMsMCwzLjkxLS40Myw1LjM0LTEuMjgsMS40My0uODUsMi41Ny0xLjk5LDMuNDItMy40My44NS0xLjQzLDEuNDYtMy4wNiwxLjgzLTQuODkuMzctMS44My41NS0zLjcxLjU1LTUuNjZzLS4xOC0zLjgyLS41NS01LjYyIi8+CiAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMTAuMzgsNjAuNjFjMi40OCwxLjA5LDUuNDQsMSw4Ljg2LS4yNywyLjQ1LS45MSw0LjM0LTIuMzEsNS42NS00LjIsMS4zMS0xLjg4LDEuOTItMy41OSwxLjgxLTUuMTFsMTAuNy0zLjk4Yy4yNiw1Ljk1LS45NSwxMC43Mi0zLjY0LDE0LjMyLTIuNjksMy42LTYuNTUsNi4zMy0xMS41Nyw4LjItMy40OCwxLjI5LTYuODMsMS45LTEwLjA0LDEuODMtMy4yMS0uMDctNi4xNy0uNzgtOC44Ny0yLjExLTIuNy0xLjMzLTUuMTItMy4yMy03LjIzLTUuNjktMi4xMi0yLjQ2LTMuODEtNS40LTUuMDktOC44My0xLjIzLTMuMzEtMS44My02LjU5LTEuODEtOS44NS4wMi0zLjI2LjY1LTYuMywxLjg3LTkuMTMsMS4yMi0yLjgyLDMtNS4zNSw1LjMyLTcuNTgsMi4zMi0yLjIzLDUuMTctMy45Nyw4LjU0LTUuMjIsMy43Ny0xLjQsNy4zMi0xLjg5LDEwLjY2LTEuNDgsMy4zNC40Miw2LjM2LDEuNTIsOS4wNywzLjMsMi43MSwxLjc5LDUuMDUsNC4xLDcuMDIsNi45NCwxLjk3LDIuODQsMy40Nyw2LjAyLDQuNTIsOS41M2wtMzEuOTQsMTEuODdjMS42NCwzLjg4LDMuNjksNi4zNiw2LjE4LDcuNDVNMTE1LjQ2LDMyLjIxYy0yLjA1LTEuMDYtNC41Ni0xLjAzLTcuNTMuMDctMS45NC43Mi0zLjQzLDEuNjUtNC40NywyLjc4LTEuMDQsMS4xMy0xLjc3LDIuMzMtMi4xOCwzLjU5LS40MSwxLjI2LS41NywyLjQ5LS40OCwzLjY5LjA5LDEuMi4yNiwyLjI0LjUzLDMuMTJsMTkuNzgtNy4zNWMtMS43Mi0yLjg3LTMuNi00LjgzLTUuNjUtNS44OSIvPgogICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNzUuMTIsMjMuMXY4Ljc3aC4xOGMuNjEtMS40NiwxLjQzLTIuODIsMi40Ny00LjA3LDEuMDQtMS4yNSwyLjIyLTIuMzEsMy41Ni0zLjIsMS4zNC0uODgsMi43Ny0xLjU3LDQuMjktMi4wNiwxLjUyLS40OSwzLjExLS43Myw0Ljc1LS43My44NSwwLDEuOC4xNSwyLjgzLjQ2djEyLjA2Yy0uNjEtLjEyLTEuMzQtLjIzLTIuMTktLjMyLS44NS0uMDktMS42OC0uMTQtMi40Ny0uMTQtMi4zOCwwLTQuMzguNC02LjAzLDEuMTktMS42NC43OS0yLjk3LDEuODctMy45NywzLjI0LTEsMS4zNy0xLjcyLDIuOTctMi4xNSw0LjgtLjQzLDEuODMtLjY0LDMuODEtLjY0LDUuOTR2MjEuMjloLTEyLjk3VjIzLjFoMTIuMzNaIi8+CiAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02Mi4wNSwxOC4yNmMtLjgyLTIuNS0yLjEzLTQuNzItMy45My02LjY3LTEuOC0xLjk1LTQuMTMtMy41Mi02Ljk5LTQuNzEtMi44Ni0xLjE5LTYuMzQtMS43OC0xMC40Mi0xLjc4SDExLjMxdjY1LjIzaC4xMXYuMDdoLTcuMjRsMTQuMDQsMTguNTcsMTQuNTEtMTguNTdoLTcuMjR2LS4wN2guMTZ2LTIzLjM4aDB2LTE3LjI3aC02LjgzbDEzLjY2LTE3LjQ5LDEzLjIyLDE3LjQ5aC02LjgydjE3LjI2aDEuODRjNC4wOCwwLDcuNTUtLjU5LDEwLjQyLTEuNzgsMi44Ni0xLjE5LDUuMTktMi43NSw2Ljk5LTQuNywxLjc5LTEuOTUsMy4xMS00LjE5LDMuOTMtNi43Mi44Mi0yLjUzLDEuMjMtNS4xLDEuMjMtNy43MnMtLjQxLTUuMjctMS4yMy03Ljc2Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "Ke/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__("H/Zg");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    faqs: null,
    sitemap: null
  },
  mutations: {
    setFaqs: function setFaqs(state, payload) {
      state.faqs = payload;
    },
    setSitemap: function setSitemap(state, payload) {
      state.sitemap = payload;
    }
  },
  actions: {
    getFaqs: function getFaqs(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].about.getFaqs().then(function (response) {
        commit('setFaqs', response.data);
        return response.data;
      });
    },
    getSitemap: function getSitemap(_ref2) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].about.getSitemap().then(function (response) {
        commit('setSitemap', response.data);
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "Kf7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.showCloseButton)?_c('div',{staticClass:"content-header__close",on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"content-header__title",on:{"click":_vm.closeTitle}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.subTitle)?_c('span',{staticClass:"content-header__sub-title"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KfAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAILY_PAGES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");





var DAILY_PAGES = {
  MONDAY: {
    id: 'market-focus',
    path: '/market-focus',
    pageId: 'DailyMarketsMonday',
    title: 'Market Focus'
  },
  TUESDAY: {
    id: 'daily-market-updates',
    path: '/daily-market-updates',
    pageId: 'DailyMarketsTuesday',
    title: 'Daily Market Updates'
  },
  WEDNESDAY: {
    id: 'daily-markets-wednesday',
    path: '/daily-markets-wednesday',
    pageId: 'DailyMarketsWednesday',
    title: 'Daily Markets Wednesday'
  },
  THURSDAY: {
    id: 'daily-markets-thursday',
    path: '/daily-markets-thursday',
    pageId: 'DailyMarketsThursday',
    title: 'Daily Markets Thursday'
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */]],
  props: {
    pageId: {
      type: String,
      required: true
    }
  },
  metaInfo: function metaInfo() {
    var _this = this;

    var info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(DAILY_PAGES);
    var pageData = info.find(function (i) {
      return i.pageId === _this.pageId;
    });

    return {
      title: (pageData || {}).title || 'Daily Markets'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this2 = this;

    this.getStaticPageFull(this.pageId).then(function (data) {
      _this2.installDynamicControls({ data: data });
    });
  }
});

/***/ }),

/***/ "KfPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"security-settings",attrs:{"id":"security"}},[(_vm.loading)?_c('div',{staticClass:"security-settings__loading-overlay"},[_c('div',{staticClass:"security-settings__spinner"}),_vm._v(" "),_c('span',[_vm._v("Loading security settings...")])]):(_vm.error && !_vm.setupMode)?_c('div',{staticClass:"security-settings__error"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n    "),_c('button',{staticClass:"security-settings__retry-btn",on:{"click":_vm.loadStatus}},[_vm._v("Retry")])]):[_c('div',{staticClass:"security-settings__status-header"},[_c('div',{staticClass:"security-settings__status-info"},[_c('span',{staticClass:"security-settings__status-label"},[_vm._v("Two-Factor Authentication")]),_vm._v(" "),_c('span',{class:['security-settings__status-badge', _vm.is2FAEnabled ? 'security-settings__status-badge--active' : '']},[_vm._v("\n          "+_vm._s(_vm.is2FAEnabled ? 'Enabled' : 'Disabled')+"\n        ")])]),_vm._v(" "),(_vm.hasAnyMethod)?_c('switch-button',{ref:"twoFactorToggle",attrs:{"black":"","checked":_vm.is2FAEnabled,"disabled":!_vm.canEnable2FA},on:{"toggle":_vm.toggleTwoFactor}}):_vm._e()],1),_vm._v(" "),_c('p',{staticClass:"security-settings__description"},[_vm._v("\n      Add an extra layer of security to your account by requiring a verification code in addition to your password when you sign in.\n    ")]),_vm._v(" "),(_vm.setupMode)?_c('div',{staticClass:"security-settings__setup"},[_c('div',{staticClass:"security-settings__setup-header"},[_c('button',{staticClass:"security-settings__back-btn",on:{"click":_vm.cancelSetup}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polyline',{attrs:{"points":"15 18 9 12 15 6"}})]),_vm._v("\n          BACK\n        ")]),_vm._v(" "),_c('h5',{staticClass:"security-settings__setup-title"},[_vm._v("\n          Set Up "+_vm._s(_vm.setupMode === 'email' ? 'Email' : (_vm.setupMode === 'phone' ? 'Phone (SMS)' : 'Authenticator'))+" Verification\n        ")])]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"security-settings__error"},[_vm._v("\n        "+_vm._s(_vm.error)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.setupStep === 'phone-input' && _vm.setupMode === 'phone')?_c('div',{staticClass:"security-settings__step"},[_c('p',{staticClass:"security-settings__step-text"},[_vm._v("\n          Enter your phone number to receive a verification code via SMS.\n        ")]),_vm._v(" "),_c('div',{staticClass:"security-settings__input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"security-settings__input",attrs:{"type":"tel","placeholder":"+1 555-555-5555"},domProps:{"value":(_vm.phoneNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value},function($event){return _vm.$v.phoneNumber.$touch()}],"blur":function($event){return _vm.$v.phoneNumber.$touch()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitPhoneNumber($event)}}}),_vm._v(" "),(_vm.phoneError)?_c('div',{staticClass:"security-settings__field-error"},[_vm._v("\n            "+_vm._s(_vm.phoneError)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",class:{ 'button--loading': _vm.isSendingCode },attrs:{"disabled":!_vm.canSubmitPhone},on:{"click":_vm.submitPhoneNumber}},[(_vm.isSendingCode)?_c('span',{staticClass:"button__spinner"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"button__text"},[_vm._v(_vm._s(_vm.isSendingCode ? 'Sending...' : 'Send Verification Code'))])])]):_vm._e(),_vm._v(" "),(_vm.setupStep === 'send' && (_vm.setupMode === 'email' || _vm.setupMode === 'phone'))?_c('div',{staticClass:"security-settings__step"},[(_vm.isSendingCode)?_c('div',{staticClass:"security-settings__sending"},[_c('div',{staticClass:"security-settings__spinner"}),_vm._v(" "),_c('span',[_vm._v("Sending verification code...")])]):[_c('p',{staticClass:"security-settings__step-text"},[_vm._v("\n            We'll send a verification code to your "+_vm._s(_vm.setupMode === 'email' ? 'email address' : 'phone number')+".\n          ")]),_vm._v(" "),_c('button',{staticClass:"button button--primary button--full-width",attrs:{"disabled":!_vm.canSendCode},on:{"click":_vm.sendCode}},[_vm._v("\n            Send Code\n          ")])]],2):_vm._e(),_vm._v(" "),(_vm.setupMode === 'authenticator' && _vm.authenticatorData)?_c('div',{staticClass:"security-settings__authenticator"},[_c('p',{staticClass:"security-settings__step-text"},[_vm._v("\n          Scan the QR code with your authenticator app (Google Authenticator, Authy, etc.)\n        ")]),_vm._v(" "),_c('div',{staticClass:"security-settings__qr-container"},[_c('img',{staticClass:"security-settings__qr-code",attrs:{"src":_vm.authenticatorData.qr_code_url,"alt":"QR Code"}})]),_vm._v(" "),_c('p',{staticClass:"security-settings__manual-hint"},[_vm._v("Can't scan? Enter this code manually:")]),_vm._v(" "),_c('div',{staticClass:"security-settings__code-wrapper"},[_c('code',{staticClass:"security-settings__manual-code-value"},[_vm._v(_vm._s(_vm.authenticatorData.manual_code))]),_vm._v(" "),_c('button',{staticClass:"security-settings__copy-btn",class:{ 'security-settings__copy-btn--copied': _vm.codeCopied },on:{"click":_vm.copyManualCode}},[_vm._v("\n            "+_vm._s(_vm.codeCopied ? '✓ Copied' : 'Copy')+"\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.setupStep === 'verify')?_c('div',{staticClass:"security-settings__verify"},[_c('label',{staticClass:"security-settings__label security-settings__label--centered"},[_vm._v("Enter verification code")]),_vm._v(" "),_c('code-input',{ref:"codeInput",attrs:{"error":_vm.hasCodeError,"disabled":_vm.isVerifying,"loading":_vm.isVerifying},on:{"submit":_vm.verifyCode,"complete":_vm.onCodeComplete},model:{value:(_vm.verificationCode),callback:function ($$v) {_vm.verificationCode=$$v},expression:"verificationCode"}}),_vm._v(" "),(_vm.setupMode !== 'authenticator')?_c('div',{staticClass:"security-settings__resend"},[_c('button',{staticClass:"security-settings__resend-btn",attrs:{"disabled":_vm.secondsUntilResend > 0},on:{"click":_vm.sendCode}},[(_vm.secondsUntilResend > 0)?[_c('span',{staticClass:"security-settings__resend-icon"},[_vm._v("⏱")]),_vm._v("\n              Resend in "+_vm._s(_vm.secondsUntilResend)+"s\n            ")]:[_vm._v(" Resend code ")]],2)]):_vm._e()],1):_vm._e()]):_c('div',{staticClass:"security-settings__methods"},[_c('div',{staticClass:"security-settings__method"},[_c('div',{staticClass:"security-settings__method-info"},[_c('span',{staticClass:"security-settings__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"}}),_vm._v(" "),_c('polyline',{attrs:{"points":"22,6 12,13 2,6"}})])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method-details"},[_c('span',{staticClass:"security-settings__method-name"},[_vm._v("Email")]),_vm._v(" "),_c('span',{class:['security-settings__method-status', _vm.getMethodStatusClass(_vm.isEmailVerified)]},[_vm._v("\n              "+_vm._s(_vm.getMethodStatusText(_vm.isEmailVerified))+"\n              "),(_vm.isEmailVerified && _vm.emailHint)?[_vm._v(" - "+_vm._s(_vm.emailHint))]:_vm._e()],2)])]),_vm._v(" "),(!_vm.isEmailVerified)?_c('button',{staticClass:"security-settings__setup-btn",on:{"click":function($event){return _vm.startSetup('email')}}},[_vm._v("\n          Set Up\n        ")]):_c('span',{staticClass:"security-settings__check"},[_vm._v("✓")])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method"},[_c('div',{staticClass:"security-settings__method-info"},[_c('span',{staticClass:"security-settings__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"5","y":"2","width":"14","height":"20","rx":"2","ry":"2"}}),_vm._v(" "),_c('line',{attrs:{"x1":"12","y1":"18","x2":"12.01","y2":"18"}})])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method-details"},[_c('span',{staticClass:"security-settings__method-name"},[_vm._v("Phone (SMS)")]),_vm._v(" "),_c('span',{class:['security-settings__method-status', _vm.getMethodStatusClass(_vm.isPhoneVerified)]},[_vm._v("\n              "+_vm._s(_vm.getMethodStatusText(_vm.isPhoneVerified))+"\n              "),(_vm.isPhoneVerified && _vm.phoneHint)?[_vm._v(" - "+_vm._s(_vm.phoneHint))]:_vm._e()],2)])]),_vm._v(" "),(!_vm.isPhoneVerified)?_c('button',{staticClass:"security-settings__setup-btn",on:{"click":function($event){return _vm.startSetup('phone')}}},[_vm._v("\n          Set Up\n        ")]):_c('span',{staticClass:"security-settings__check"},[_vm._v("✓")])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method"},[_c('div',{staticClass:"security-settings__method-info"},[_c('span',{staticClass:"security-settings__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 12l2 2 4-4"}})])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method-details"},[_c('span',{staticClass:"security-settings__method-name"},[_vm._v("Authenticator App")]),_vm._v(" "),_c('span',{class:['security-settings__method-status', _vm.getMethodStatusClass(_vm.isAuthenticatorEnabled)]},[_vm._v("\n              "+_vm._s(_vm.getMethodStatusText(_vm.isAuthenticatorEnabled))+"\n            ")])])]),_vm._v(" "),(!_vm.isAuthenticatorEnabled)?_c('button',{staticClass:"security-settings__setup-btn",on:{"click":function($event){return _vm.startSetup('authenticator')}}},[_vm._v("\n          Set Up\n        ")]):_c('span',{staticClass:"security-settings__check"},[_vm._v("✓")])])]),_vm._v(" "),(_vm.showDisableConfirmation)?_c('div',{staticClass:"security-settings__modal-overlay"},[_c('div',{staticClass:"security-settings__modal"},[_c('h4',{staticClass:"security-settings__modal-title"},[_vm._v("Disable Two-Factor Authentication?")]),_vm._v(" "),_c('p',{staticClass:"security-settings__modal-text"},[_vm._v("\n          Disabling 2FA will make your account less secure. Are you sure you want to continue?\n        ")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"security-settings__error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"security-settings__modal-actions"},[_c('button',{staticClass:"button button--secondary",attrs:{"disabled":_vm.isDisabling},on:{"click":_vm.cancelDisable}},[_vm._v("\n            Cancel\n          ")]),_vm._v(" "),_c('button',{staticClass:"button button--danger",attrs:{"disabled":_vm.isDisabling},on:{"click":_vm.confirmDisable}},[_vm._v("\n            "+_vm._s(_vm.isDisabling ? 'Disabling...' : 'Yes, Disable 2FA')+"\n          ")])])])]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kj7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    market: {
      type: Object,
      required: true
    }
  },
  components: {
    smallModal: __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_small_small_vue__["default"]
  },
  data: function data() {
    return {
      showDetails: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'isCommentEnabled', 'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance', 'isPinningEnabled', 'hasMaintenance', 'hasMaintenanceSuspended']), {
    show: function show() {
      return !!this.theme;
    },
    theme: function theme() {
      if (this.hasMaintenance) {
        return 'maintenance';
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["N" /* isMarketMaintenance */])(this.market)) {
        return 'maintenance';
      }
      return '';
    },
    title: function title() {
      if (this.hasMaintenanceSuspended) {
        return 'Trading Paused';
      }
      return 'In Maintenance';
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-site-alert-v2': true
      }, 'market-site-alert-v2--' + this.theme, this.theme);
    }
  })
});

/***/ }),

/***/ "KkzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq"},[_c('div',{class:_vm.mainRowModifiers},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"faq__static-page-header"},[_c('static-page-header',{attrs:{"back":{ name: 'HelpAndSupport' }}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n              Help and Support\n            ")])])],1)]),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{class:_vm.mainColumnModifiers},[_c('div',{staticClass:"faq__content"},[_c('static-page-loader',{staticClass:"static-page-loader--padding"})],1)]):_c('div',{class:_vm.mainColumnModifiers},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"faq__header"},[_vm._v("Frequently Asked Questions")]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"faq__content"},[_c('faq-search-input',{staticClass:"faq__search",attrs:{"initial":_vm.$route.query.query},on:{"init":_vm.initializeComponentWithSearchTerm,"search":_vm.updateSearch}}),_vm._v(" "),_vm._l((_vm.filteredFAQs),function(item,index){return _c('div',{attrs:{"id":("faq-" + index)}},[_c('collapsible-panel',{key:item.id,attrs:{"isOpen":_vm.expanded,"title":item.name,"accordion":_vm.accordion,"id":("faq-" + index)},on:{"open":_vm.accordionOpen}},_vm._l((item.faqs),function(qa){return _c('collapsible-panel-simple',{key:qa.id,staticClass:"faq__qa",attrs:{"isOpen":_vm.expanded,"title":qa.title,"accordion":_vm.accordionQA,"id":qa.id},on:{"open":_vm.accordionOpenQA}},[_c('div',{domProps:{"innerHTML":_vm._s(qa.description)}})])}),1)],1)}),_vm._v(" "),(_vm.isEmpty)?_c('p',{staticClass:"faq__no-result"},[_vm._v("\n          No results found for \""+_vm._s(_vm.searchTerm)+"\"\n        ")]):_vm._e()],2):_vm._e()]),_vm._v(" "),(_vm.showVideos)?_c('div',{staticClass:"column large-4"},[_c('videos',{attrs:{"asWidget":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KmT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_session_list_history_svg__ = __webpack_require__("poum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_session_list_history_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_session_list_history_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_trade_history_svg__ = __webpack_require__("eHZI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_trade_history_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_trade_history_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_watchlist_history_svg__ = __webpack_require__("JcLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_watchlist_history_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_watchlist_history_svg__);






var ICONS = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
  'session-history': __WEBPACK_IMPORTED_MODULE_2__assets_icons_session_list_history_svg___default.a,
  'trade-history': __WEBPACK_IMPORTED_MODULE_3__assets_icons_trade_history_svg___default.a,
  'watchlist-history': __WEBPACK_IMPORTED_MODULE_4__assets_icons_watchlist_history_svg___default.a
});

var AVAILABLE_ICONS = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ICONS);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    icon: {
      type: String,
      required: true,
      validator: function validator(value) {
        return AVAILABLE_ICONS.includes(value);
      }
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconSrc: function iconSrc() {
      return ICONS[this.icon];
    }
  }
});

/***/ }),

/***/ "Kon3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('h2',{staticClass:"purchase-quantity-value-sushi__header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"purchase-quantity-value-sushi__wrap"},[_c('button',{staticClass:"purchase-quantity-value-sushi__button purchase-quantity-value-sushi__button--left",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.subtract($event)}}},[_vm._v("-"+_vm._s(_vm.threshold))]),_vm._v(" "),_c('div',{staticClass:"purchase-quantity-value-sushi__box"},[(_vm.kind === 'modal')?_c('keyboard-numeric-input-sushi',{attrs:{"value":_vm.val,"selected":_vm.selected},on:{"click":_vm.click},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],staticClass:"purchase-quantity-value-sushi__input",attrs:{"tabindex":_vm.tabindex,"maxlength":"4","placeholder":""},domProps:{"value":(_vm.val)},on:{"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')},"input":function($event){if($event.target.composing){ return; }_vm.val=$event.target.value}}})],1),_vm._v(" "),_c('button',{staticClass:"purchase-quantity-value-sushi__button purchase-quantity-value-sushi__button--right",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.add($event)}}},[_vm._v("+"+_vm._s(_vm.threshold))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KsCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_js__ = __webpack_require__("5yVZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58f2c46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_vue__ = __webpack_require__("iocs");
function injectStyle (ssrContext) {
  __webpack_require__("K1rd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58f2c46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KvDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_top_comments_js__ = __webpack_require__("7Wq7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_788c80ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_top_comments_vue__ = __webpack_require__("zhst");
function injectStyle (ssrContext) {
  __webpack_require__("GY5o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_top_comments_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_788c80ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_top_comments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KyYK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L09H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_sessionHistory__ = __webpack_require__("zckU");










 /* eslint-disable max-len,no-unused-vars,arrow-body-style,no-restricted-syntax */








var PIN_KEY_DISCUSSION = 'discussion-pin-key';
var PIN_KEY_SESSION_HISTORY = 'session-history-pin-key';
var PIN_KEY_WATCHLIST = 'watchlist-pin-key';
var PIN_KEY_MARKET_HISTORY = 'market-history-pin-key';
var PIN_KEY_OPENED = 'pin-opened-key';

var MAX_RELATED_MARKETS = 3;
var MARKET_DEBOUNCE_INTERVAL = 750;
var debounceGetMarket = __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default()(function (dispatch, marketId) {
  dispatch('getMarket', { marketId: marketId, skipCache: true });
}, MARKET_DEBOUNCE_INTERVAL);

var ITEMS_PER_HISTORY_PAGE = 10;
var DEFAULT_HISTORY = {
  data: null,
  marketId: -1,
  totalCount: -1,
  canLoadMore: true
};
var DEFAULT_MARKET_SUMMARY_DATA = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};
var createDefaultTopComments = function createDefaultTopComments() {
  return {
    title: 'Top Recent Comments',
    comments: []
  };
};
var SUMMARY_DATA_THROTTLE_TIME = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    marketIsEngineBusy: false,
    marketIsEngineBusyMessage: null,
    marketLoadError: false,
    market: null,
    contracts: [],
    contract: null,
    history: DEFAULT_HISTORY,
    marketSummaryData: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_MARKET_SUMMARY_DATA),
    marketSummaryDataDate: '',
    marketSummaryLimitExceededMessage: '',
    isRulesOpen: false,
    related: [],
    chartTimeline: null,
    chartType: null,
    marketContractsStats: [],
    mapStateData: {},
    mapStateDataSenate: {},
    mapOverviewData: [],
    mapOverviewDataSenate: [],
    marketMapTooltipVisible: false,
    isDiscussionPinned: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_DISCUSSION, false),
    isWatchlistPinned: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_WATCHLIST, false),
    isSessionHistoryPinned: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_SESSION_HISTORY, false),
    isMarketHistoryPinned: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_MARKET_HISTORY, false),
    pinnedOpened: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_OPENED, []),
    relatedContracts: [],
    relatedProducts: {
      active: [],
      closed: []
    },
    marketTopComments: createDefaultTopComments(),
    marketTopCommentsMarketId: null,
    marketTopCommentsLoaded: false,
    marketTopCommentsLoading: false,
    reloadHistoryToggle: 0,
    sessionHistory: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_16__helpers_sessionHistory__["a" /* SESSION_HISTORY_KEY */], [])
  },
  getters: {
    historyData: function historyData(state) {
      var historyData = state.history.data;
      return historyData === null ? [] : historyData;
    }
  },
  mutations: {
    setMarket: function setMarket(state, payload) {
      state.market = payload;
    },
    markCurrentMarketNotWatched: function markCurrentMarketNotWatched(state) {
      state.market = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.market, {
        isMarketWatched: false
      });
    },
    setContract: function setContract(state, payload) {
      state.contract = payload;
    },
    setContracts: function setContracts(state, payload) {
      state.contracts = payload;
    },
    setMarketLoadError: function setMarketLoadError(state, payload) {
      state.marketLoadError = payload;
    },
    setMarketEngineBusyMessage: function setMarketEngineBusyMessage(state, _ref) {
      var isEngineBusy = _ref.isEngineBusy,
          isEngineBusyMessage = _ref.isEngineBusyMessage;

      state.marketIsEngineBusy = isEngineBusy;
      state.marketIsEngineBusyMessage = isEngineBusyMessage;
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      state.market = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["a" /* updateMarket */])(state.market, data);
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.market !== null && typeof state.market.contracts !== 'undefined') {
        // CONTRACTS SORT
        // contracts.sort((prev, next) => {
        //   if (prev.lastTradePrice < next.lastTradePrice) {
        //     return 1;
        //   } else if (prev.lastTradePrice > next.lastTradePrice) {
        //     return -1;
        //   }
        //   return 0;
        // });
        state.market = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["b" /* updateMarketContracts */])(state.market, data);
      }
      if (state.contracts !== null) {
        // CONTRACTS SORT
        // state.contracts.sort((prev, next) => {
        //   if (prev.lastTradePrice < next.lastTradePrice) {
        //     return 1;
        //   } else if (prev.lastTradePrice > next.lastTradePrice) {
        //     return -1;
        //   }
        //   return 0;
        // });
        var contracts = state.contracts.slice();
        state.contracts = contracts.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.contract !== null) {
        state.contract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["d" /* updateContract */])(state.contract, data);
      }
    },
    updateMapOverviewDataFromNotification: function updateMapOverviewDataFromNotification(state, data) {
      if (state.mapOverviewData.length > 0) {
        var mapOverviewData = state.mapOverviewData.slice();
        state.mapOverviewData = mapOverviewData.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }

      var mapStateData = __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(state.mapStateData);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(mapStateData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stateCode = _step.value;

          mapStateData[stateCode] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["b" /* updateMarketContracts */])(mapStateData[stateCode], data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.mapStateData = mapStateData;
    },
    updateMapOverviewDataSenateFromNotification: function updateMapOverviewDataSenateFromNotification(state, data) {
      if (state.mapOverviewDataSenate.length > 0) {
        var mapOverviewData = state.mapOverviewDataSenate.slice();
        state.mapOverviewDataSenate = mapOverviewData.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }

      var mapStateData = __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(state.mapStateDataSenate);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(mapStateData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var stateCode = _step2.value;

          mapStateData[stateCode] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["b" /* updateMarketContracts */])(mapStateData[stateCode], data);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      state.mapStateDataSenate = mapStateData;
    },
    resetHistory: function resetHistory(state) {
      state.history = DEFAULT_HISTORY;
    },
    updateHistory: function updateHistory(state, payload) {
      state.history = {
        data: payload.data.historyList,
        marketId: payload.marketId,
        totalCount: payload.data.totalCount,
        canLoadMore: payload.data.totalCount > payload.data.historyList.length
      };
    },
    setMarketSummaryLimitExceeded: function setMarketSummaryLimitExceeded(state, message) {
      state.marketSummaryLimitExceededMessage = message;
    },
    updateMarketSummaryData: function updateMarketSummaryData(state, payload) {
      var data = __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default()(state.marketSummaryData.data.concat(payload.SummaryContractData || []), function (i) {
        return i.MarketSummaryDataId;
      });
      var page = payload.Page;
      var totalCount = payload.TotalItems;
      var canLoadMore = totalCount > data.length;

      state.marketSummaryData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.marketSummaryData, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    resetMarketSummaryData: function resetMarketSummaryData(state) {
      state.marketSummaryData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_MARKET_SUMMARY_DATA);
      state.marketSummaryLimitExceededMessage = '';
    },
    setOpenRules: function setOpenRules(state, payload) {
      state.isRulesOpen = payload;
    },
    setRelatedMarkets: function setRelatedMarkets(state, payload) {
      state.related = payload;
    },
    clearRelatedMarkets: function clearRelatedMarkets(state) {
      state.related = [];
    },
    updateRelatedMarketFromNotification: function updateRelatedMarketFromNotification(state, data) {
      if (state.related.length > 0) {
        state.related = state.related.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updateRelatedContractFromNotification: function updateRelatedContractFromNotification(state, data) {
      if (state.related.length > 0) {
        state.related = state.related.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
    },
    setChartTimeline: function setChartTimeline(state, data) {
      state.chartTimeline = data;
    },
    setChartType: function setChartType(state, data) {
      state.chartType = data;
    },
    setMarketContractsStats: function setMarketContractsStats(state, data) {
      state.marketContractsStats = data;
    },
    clearMarketContractsStats: function clearMarketContractsStats(state) {
      state.marketContractsStats = [];
    },
    setMapOverviewData: function setMapOverviewData(state, data) {
      state.mapOverviewData = data;
    },
    setMapOverviewDataSenate: function setMapOverviewDataSenate(state, data) {
      state.mapOverviewDataSenate = data;
    },
    setMapStateData: function setMapStateData(state, data) {
      state.mapStateData = data;
    },
    setMapStateDataSenate: function setMapStateDataSenate(state, data) {
      state.mapStateDataSenate = data;
    },
    setMarketMapTooltipVisible: function setMarketMapTooltipVisible(state, flag) {
      state.marketMapTooltipVisible = flag;
    },
    setMarketSummaryDataDate: function setMarketSummaryDataDate(state, value) {
      state.marketSummaryDataDate = value;
    },
    toggleDiscussionPin: function toggleDiscussionPin(state) {
      if (state.isDiscussionPinned) {
        state.isDiscussionPinned = false;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_DISCUSSION, false);
      } else {
        state.isDiscussionPinned = true;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_DISCUSSION, true);
      }
    },
    toggleWatchlistPin: function toggleWatchlistPin(state) {
      if (state.isWatchlistPinned) {
        state.isWatchlistPinned = false;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_WATCHLIST, false);
      } else {
        state.isWatchlistPinned = true;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_WATCHLIST, true);
      }
    },
    toggleSessionHistoryPin: function toggleSessionHistoryPin(state) {
      if (state.isSessionHistoryPinned) {
        state.isSessionHistoryPinned = false;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_SESSION_HISTORY, false);
      } else {
        state.isSessionHistoryPinned = true;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_SESSION_HISTORY, true);
      }
    },
    toggleMarketHistoryPin: function toggleMarketHistoryPin(state) {
      if (state.isMarketHistoryPinned) {
        state.isMarketHistoryPinned = false;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_MARKET_HISTORY, false);
      } else {
        state.isMarketHistoryPinned = true;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_MARKET_HISTORY, true);
      }
    },
    clearRelatedContracts: function clearRelatedContracts(state) {
      state.relatedContracts = [];
    },
    setRelatedContracts: function setRelatedContracts(state, data) {
      state.relatedContracts = data;
    },
    setRelatedProducts: function setRelatedProducts(state, data) {
      state.relatedProducts = {
        active: data.activeMarkets || [],
        closed: data.closedMarkets || []
      };
    },
    setMarketTopComments: function setMarketTopComments(state, _ref2) {
      var marketId = _ref2.marketId,
          data = _ref2.data;

      state.marketTopCommentsMarketId = marketId;
      state.marketTopCommentsLoaded = true;
      state.marketTopCommentsLoading = false;
      state.marketTopComments = data || createDefaultTopComments();
    },
    setMarketTopCommentsLoading: function setMarketTopCommentsLoading(state, payload) {
      state.marketTopCommentsLoading = payload;
    },
    clearMarketTopComments: function clearMarketTopComments(state) {
      state.marketTopComments = createDefaultTopComments();
      state.marketTopCommentsMarketId = null;
      state.marketTopCommentsLoaded = false;
      state.marketTopCommentsLoading = false;
    },
    incrReloadHistoryToggle: function incrReloadHistoryToggle(state) {
      state.reloadHistoryToggle += 1;
    },
    toggleOpenPinSection: function toggleOpenPinSection(state, name) {
      var opened = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.pinnedOpened));
      if (opened.includes(name)) {
        state.pinnedOpened = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(opened.filter(function (i) {
          return i !== name;
        })));
      } else {
        state.pinnedOpened = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(opened), [name]);
      }
    },
    pushSessionHistoryContract: function pushSessionHistoryContract(state, data) {
      state.sessionHistory = __WEBPACK_IMPORTED_MODULE_16__helpers_sessionHistory__["b" /* default */].pushContract(data);
    }
  },
  actions: {
    updateHeaderHeightclearMarket: function updateHeaderHeightclearMarket(_ref3) {
      var commit = _ref3.commit;

      commit('setMarket', {});
      commit('setContracts', []);
    },
    clearMarketEngineBusyMessage: function clearMarketEngineBusyMessage(_ref4) {
      var commit = _ref4.commit;

      commit('setMarketEngineBusyMessage', {
        isEngineBusy: false,
        isEngineBusyMessage: null
      });
    },
    getMarket: function getMarket(_ref5, _ref6) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          state = _ref5.state;
      var marketId = _ref6.marketId,
          _ref6$commentThreadId = _ref6.commentThreadId,
          commentThreadId = _ref6$commentThreadId === undefined ? '' : _ref6$commentThreadId,
          _ref6$skipCache = _ref6.skipCache,
          skipCache = _ref6$skipCache === undefined ? false : _ref6$skipCache,
          _ref6$modifyState = _ref6.modifyState,
          modifyState = _ref6$modifyState === undefined ? true : _ref6$modifyState;

      commit('setMarketLoadError', false);
      if (!skipCache && state.market !== null && state.market.marketId === marketId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.market);
      }
      var marketData = {};
      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarket(marketId, commentThreadId).then(function (response) {
        marketData = response.data;
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketContracts(marketId);
      }).then(function (response) {
        marketData.contracts = response.data;
        if (modifyState) {
          commit('setContracts', marketData.contracts);
          commit('setMarket', marketData);
        }
        return marketData;
      }).catch(function () {
        if (modifyState) {
          commit('setMarketLoadError', true);
          dispatch('clearMarket');
        }
      });
    },
    getMarketContracts: function getMarketContracts(_ref7, marketId) {
      var commit = _ref7.commit,
          state = _ref7.state;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketContracts(marketId).then(function (response) {
        commit('setContracts', response.data);
        commit('setMarket', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.market, {
          contracts: response.data
        }));
        return response.data;
      });
    },
    getMarketRules: function getMarketRules(_ref8, marketId) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketRules(marketId).then(function (response) {
        return response.data;
      });
    },
    getContract: function getContract(_ref9, contractId) {
      var commit = _ref9.commit,
          state = _ref9.state;

      if (state.contract !== null && state.contract.contractId === contractId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.contract);
      }
      if (state.contracts !== null) {
        var contract = state.contracts.find(function (c) {
          return c.contractId === contractId;
        });
        if (typeof contract !== 'undefined') {
          commit('setContract', contract);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(contract);
        }
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    },
    getMarketContractsStats: function getMarketContractsStats(_ref10, marketId) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketContractsStats(marketId).then(function (response) {
        commit('setMarketContractsStats', response.data);
        return response.data;
      }).catch(function () {
        dispatch('clearMarketContractsStats');
      });
    },
    clearMarketContractsStats: function clearMarketContractsStats(_ref11) {
      var commit = _ref11.commit;

      commit('clearMarketContractsStats');
    },
    resetHistory: function resetHistory(_ref12) {
      var commit = _ref12.commit;

      commit('resetHistory');
    },
    getMarketHistory: function getMarketHistory(_ref13, _ref14) {
      var state = _ref13.state,
          commit = _ref13.commit;
      var marketId = _ref14.marketId,
          _ref14$reload = _ref14.reload,
          reload = _ref14$reload === undefined ? false : _ref14$reload;

      var history = state.history;
      if (history !== null && history.marketId === marketId && !reload) {
        return history.data;
      }
      // on new market but in history old data
      commit('resetHistory');
      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].profile.getTradeHistory(ITEMS_PER_HISTORY_PAGE, 1, marketId).then(function (response) {
        commit('updateHistory', {
          data: response.data,
          marketId: marketId
        });
        return response.data;
      });
    },
    getRelatedMarkets: function getRelatedMarkets(_ref15, marketId) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketRelated(marketId).then(function (response) {
        var data = response.data.slice(0, MAX_RELATED_MARKETS);
        commit('setRelatedMarkets', data);
        return data;
      });
    },
    clearRelatedMarkets: function clearRelatedMarkets(_ref16) {
      var commit = _ref16.commit;

      commit('clearRelatedMarkets');
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref17, payload) {
      var commit = _ref17.commit,
          dispatch = _ref17.dispatch,
          state = _ref17.state;

      var marketId = payload.MarketId;
      if (state.market !== null && state.market.marketId === marketId) {
        commit('updateMarketFromNotification', payload);
        // debounceGetMarket(dispatch, marketId);
      }
    },
    setMarketEngineBusyMessage: function setMarketEngineBusyMessage(_ref18, payload) {
      var commit = _ref18.commit;

      commit('setMarketEngineBusyMessage', payload);
    },
    updateRelatedMarketFromNotification: function updateRelatedMarketFromNotification(_ref19, payload) {
      var commit = _ref19.commit;

      commit('updateRelatedMarketFromNotification', payload);
    },
    updateRelatedContractFromNotification: function updateRelatedContractFromNotification(_ref20, payload) {
      var commit = _ref20.commit;

      commit('updateRelatedContractFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref21, payload) {
      var commit = _ref21.commit;

      commit('updateContractFromNotification', payload);
    },
    updateMapOverviewDataFromNotification: function updateMapOverviewDataFromNotification(_ref22, payload) {
      var commit = _ref22.commit;

      commit('updateMapOverviewDataFromNotification', payload);
    },
    updateMapOverviewDataSenateFromNotification: function updateMapOverviewDataSenateFromNotification(_ref23, payload) {
      var commit = _ref23.commit;

      commit('updateMapOverviewDataSenateFromNotification', payload);
    },
    openRules: function openRules(_ref24) {
      var commit = _ref24.commit;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      commit('setOpenRules', payload);
    },
    setMarket: function setMarket(_ref25, market) {
      var commit = _ref25.commit;

      commit('setMarket', market);
    },
    setContracts: function setContracts(_ref26, contracts) {
      var commit = _ref26.commit;

      commit('setContracts', contracts);
    },
    setMarketLoadError: function setMarketLoadError(_ref27, flag) {
      var commit = _ref27.commit;

      commit('setMarketLoadError', flag);
    },
    setChartTimeline: function setChartTimeline(_ref28, payload) {
      var commit = _ref28.commit;

      commit('setChartTimeline', payload);
    },
    setChartType: function setChartType(_ref29, payload) {
      var commit = _ref29.commit;

      commit('setChartType', payload);
    },
    getMapOverviewData: function getMapOverviewData(_ref30) {
      var commit = _ref30.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].map.getContracts().then(function (response) {
        commit('setMapOverviewData', response.data);
        return response.data;
      });
    },
    getMapStateData: function getMapStateData(_ref31) {
      var commit = _ref31.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].map.getStateData().then(function (response) {
        var data = (response.data || []).reduce(function (obj, item) {
          var stateCode = item.marketName.split(' ')[4];
          var stateName = __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].statesCodeToNameMap[stateCode];
          var stateVotes = __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];
          obj[stateCode] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item, {
            stateVotes: stateVotes,
            stateCode: stateCode,
            stateName: stateName
          });
          return obj;
        }, {});
        commit('setMapStateData', data);
        return data;
      });
    },
    getMapOverviewDataSenate: function getMapOverviewDataSenate(_ref32) {
      var commit = _ref32.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].map.getContractsSenate().then(function (response) {
        commit('setMapOverviewDataSenate', response.data);
        return response.data;
      });
    },
    getMapStateDataSenate: function getMapStateDataSenate(_ref33) {
      var commit = _ref33.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].map.getStateDataSenate().then(function (response) {
        var data = (response.data || []).reduce(function (obj, item) {
          var stateCode = item.marketName.match(/\b[A-Z]{2}\b/)[0];
          var stateName = __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].statesCodeToNameMap[stateCode];
          var stateVotes = __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];
          var result = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item, {
            stateVotes: stateVotes,
            stateCode: stateCode,
            stateName: stateName
          });
          if (stateCode === 'GA') {
            if (item.marketId === 6651) {
              obj[stateCode] = result;
            } else {
              obj.GA2 = result;
            }
          }
          obj[stateCode] = result;
          return obj;
        }, {});
        commit('setMapStateDataSenate', data);
        return data;
      });
    },
    setMarketMapTooltipVisible: function setMarketMapTooltipVisible(_ref34, flag) {
      var commit = _ref34.commit;

      commit('setMarketMapTooltipVisible', flag);
    },
    getCommentThread: function getCommentThread(_ref35, _ref36) {
      var commit = _ref35.commit;
      var marketId = _ref36.marketId,
          threadId = _ref36.threadId;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getCommentThread({ marketId: marketId, threadId: threadId }).then(function (response) {
        return response.data;
      });
    },
    getMarketTopComments: function getMarketTopComments(_ref37, marketId) {
      var commit = _ref37.commit;

      if (!marketId) {
        commit('clearMarketTopComments');
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(createDefaultTopComments());
      }

      commit('setMarketTopCommentsLoading', true);

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketTopComments(marketId).then(function (response) {
        var data = response.data || createDefaultTopComments();
        commit('setMarketTopComments', {
          marketId: marketId,
          data: data
        });
        return data;
      }).catch(function () {
        commit('clearMarketTopComments');
        return createDefaultTopComments();
      });
    },

    getMarketSummaryData: __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (_ref38) {
      var state = _ref38.state,
          commit = _ref38.commit;

      var _ref39 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref39$reset = _ref39.reset,
          reset = _ref39$reset === undefined ? false : _ref39$reset;

      var page = reset ? 1 : state.marketSummaryData.page + 1;
      var canLoadMore = reset ? true : state.marketSummaryData.canLoadMore;
      if (canLoadMore) {
        return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].browse.getMarketSummaryData(page, state.marketSummaryDataDate).then(function (response) {
          var data = response.data;
          if (reset) commit('resetMarketSummaryData');
          commit('setMarketSummaryLimitExceeded', '');
          commit('updateMarketSummaryData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, { page: page }));
          return data;
        }).catch(function (error) {
          var response = error.response;
          if (response && response.data) {
            var data = Array.isArray(response.data) ? response.data[0] : response.data;
            var showLimitExceeded = data.code && data.code === 'LIMIT_EXCEEDED';
            var message = showLimitExceeded ? data.message : '';
            commit('setMarketSummaryLimitExceeded', message);
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(1);
    }, SUMMARY_DATA_THROTTLE_TIME),
    resetMarketSummaryData: function resetMarketSummaryData(_ref40) {
      var commit = _ref40.commit;

      commit('resetMarketSummaryData');
    },
    clearMarketTopComments: function clearMarketTopComments(_ref41) {
      var commit = _ref41.commit;

      commit('clearMarketTopComments');
    },
    setMarketSummaryDataDate: function setMarketSummaryDataDate(_ref42, value) {
      var commit = _ref42.commit;

      commit('setMarketSummaryDataDate', value);
    },
    markCurrentMarketNotWatched: function markCurrentMarketNotWatched(_ref43) {
      var commit = _ref43.commit;

      commit('markCurrentMarketNotWatched');
    },
    toggleDiscussionPin: function toggleDiscussionPin(_ref44) {
      var commit = _ref44.commit;

      commit('toggleDiscussionPin');
    },
    toggleWatchlistPin: function toggleWatchlistPin(_ref45) {
      var commit = _ref45.commit;

      commit('toggleWatchlistPin');
    },
    toggleSessionHistoryPin: function toggleSessionHistoryPin(_ref46) {
      var commit = _ref46.commit;

      commit('toggleSessionHistoryPin');
    },
    toggleMarketHistoryPin: function toggleMarketHistoryPin(_ref47) {
      var commit = _ref47.commit;

      commit('toggleMarketHistoryPin');
    },
    clearRelatedContracts: function clearRelatedContracts(_ref48) {
      var commit = _ref48.commit;

      commit('clearRelatedContracts');
    },
    getRelatedContracts: function getRelatedContracts(_ref49, contractId) {
      var commit = _ref49.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getRelatedContracts(contractId).then(function (response) {
        var data = response.data;
        commit('setRelatedContracts', data);
        return data;
      });
    },
    getRelatedProducts: function getRelatedProducts(_ref50, marketId) {
      var commit = _ref50.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketRelatedProducts(marketId).then(function (response) {
        var data = response.data;
        commit('setRelatedProducts', data);
        return data;
      });
    },
    incrReloadHistoryToggle: function incrReloadHistoryToggle(_ref51) {
      var commit = _ref51.commit;

      commit('incrReloadHistoryToggle');
    },
    toggleOpenPinSection: function toggleOpenPinSection(_ref52, name) {
      var commit = _ref52.commit;

      commit('toggleOpenPinSection', name);
    },
    pushSessionHistoryContract: function pushSessionHistoryContract(_ref53, data) {
      var commit = _ref53.commit;

      commit('pushSessionHistoryContract', data);
    },
    clearMarket: function clearMarket(_ref54) {
      var commit = _ref54.commit;

      commit('setMarket', {});
      commit('setContracts', []);
      commit('clearMarketTopComments');
    }
  }
});

/***/ }),

/***/ "L0UG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L3N8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getFaqs: function getFaqs() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/about/faqs');
  },
  getSitemap: function getSitemap() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/sitemap');
  }
});

/***/ }),

/***/ "L6pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "L8Dv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__ = __webpack_require__("P71F");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      items: [],
      swiperOptions: {
        loop: false,
        autoplay: 5000,
        direction: 'horizontal',
        pagination: '.hero-unit-slider__pagination',
        paginationClickable: true
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), {
    classModifiers: function classModifiers() {
      return {
        'hero-unit-slider': true,
        'hero-unit-slider--shutdown': this.isShutdownModeOn
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getCarousel']), {
    getBannerUrl: function getBannerUrl(banner) {
      if (banner.carouselData.carouselItemButton.url) {
        return banner.carouselData.carouselItemButton.url;
      } else if (banner.carouselData.marketId) {
        return { name: 'market-details', params: { marketId: banner.carouselData.marketId } };
      }
      return {};
    },
    isUrlExternal: function isUrlExternal(banner) {
      var url = banner.carouselData.carouselItemButton.url || '';
      return url.startsWith('http');
    },
    bannerImageStyleModifiers: function bannerImageStyleModifiers(url) {
      if (!url) return {};
      return {
        'background-image': 'url(\'' + url + '\')'
      };
    },
    buttonStyleModifiers: function buttonStyleModifiers(button) {
      var styles = {};
      if (button.backgroundColor) {
        styles.backgroundColor = button.backgroundColor;
        styles.borderColor = button.backgroundColor;
      }
      return styles;
    }
  }),
  created: function created() {
    var _this = this;

    this.getCarousel().then(function (data) {
      _this.items = data;
      _this.isComponentReady = _this.items.length > 0;
    });
  }
});

/***/ }),

/***/ "LDV9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LHdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    validation: {
      type: Object,
      required: true
    }
  },
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_0__components_forms_checkbox_checkbox_vue__["a" /* default */]
  },
  computed: {
    hasOneUpperLower: function hasOneUpperLower() {
      return this.validation.hasOneLower && this.validation.hasOneUpper;
    }
  }
});

/***/ }),

/***/ "LMIZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.objClass},[_c('span',{staticClass:"market-change-price__value",domProps:{"innerHTML":_vm._s(_vm.changeValue)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LPOY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LQ9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"biggest-gains-loader"},[_c('div',{staticClass:"biggest-gains-loader__header"},[_c('div',{staticClass:"biggest-gains-loader__header-text"})]),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader__content"},[_c('div',{staticClass:"biggest-gains-loader-text-1"}),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader-text-2"}),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader-text-3"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LT3w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LTL3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_brand_name_js__ = __webpack_require__("6Zmy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0f6b6b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_name_vue__ = __webpack_require__("7P0N");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_brand_name_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0f6b6b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_name_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LU/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support",class:{'support--logged-in': _vm.isLoggedIn}},[_c('div',{class:_vm.gridRowModifier},[(_vm.isLoggedIn)?[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 support__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('div',{staticClass:"column large-8 small-12"},[(!_vm.isLayoutMobile)?_c('account-desktop-header',{attrs:{"title":"Help and Support"}}):_c('content-header',{staticClass:"content-header--account",attrs:{"title":"Help and Support","returnRoute":"profile"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[_c('div',{staticClass:"support__content"},[_c('router-view')],1)])]:[(_vm.showHeader)?_c('div',{staticClass:"column small-12"},[_c('static-page-header',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n            Help and Support\n          ")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('router-view')],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LWRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    earned: function earned() {
      return [{ title: 'Badge 1' }, { title: 'Badge 2' }];
    },
    current: function current() {
      return [{ title: 'Badge 3' }, { title: 'Badge 4' }];
    },
    toDiscover: function toDiscover() {
      return [{ title: 'Badge 5' }, { title: 'Badge 6' }];
    }
  }
});

/***/ }),

/***/ "Ld4z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");




var DATE_DISPLAY_FORMAT = 'MM/DD/YYYY hh:mm A';
var TITLE_DATE_FORMAT = 'ddd MMM Do, YYYY';
var EMPTY_DISPLAY = '-';

var hasValue = function hasValue(value) {
  return value !== null && typeof value !== 'undefined' && value !== '';
};
var hasNumber = function hasNumber(value) {
  return hasValue(value) && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(Number(value));
};
var formatCurrency = function formatCurrency(value) {
  if (!hasNumber(value)) return EMPTY_DISPLAY;

  var amount = Number(value);
  return '$' + amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  computed: {
    requestDateValue: function requestDateValue() {
      if (!this.request) return null;

      return this.request.dateCreated || this.request.date || null;
    },
    paymentMethod: function paymentMethod() {
      return this.request && this.request.paymentMethod ? this.request.paymentMethod : EMPTY_DISPLAY;
    },
    requestTypeLabel: function requestTypeLabel() {
      if (this.request && this.request.paymentMethod) {
        return this.request.paymentMethod + ' Deposit';
      }

      return 'Pending Deposit';
    },
    requestTitle: function requestTitle() {
      if (!this.requestDateValue || !__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.requestDateValue).isValid()) {
        return this.requestTypeLabel;
      }

      return this.requestTypeLabel + ' on ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.requestDateValue).format(TITLE_DATE_FORMAT);
    },
    formattedAmount: function formattedAmount() {
      return formatCurrency(this.request && this.request.amount);
    },
    formattedAmountReceived: function formattedAmountReceived() {
      return formatCurrency(this.request && this.request.amountReceived);
    },
    formattedDate: function formattedDate() {
      if (!this.requestDateValue || !__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.requestDateValue).isValid()) return EMPTY_DISPLAY;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["k" /* dateToString */])(this.requestDateValue, DATE_DISPLAY_FORMAT);
    },
    showAmountReceived: function showAmountReceived() {
      if (!this.request || !hasNumber(this.request.amountReceived)) return false;

      var amountReceived = Number(this.request.amountReceived);
      if (amountReceived <= 0) return false;

      if (!hasNumber(this.request.amount)) return true;

      return amountReceived !== Number(this.request.amount);
    }
  }
});

/***/ }),

/***/ "LdRG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LiRf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    smallModal: __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_small_small_vue__["default"]
  },
  props: {
    market: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isMarketSettled: __WEBPACK_IMPORTED_MODULE_3__utils_helpers__["n" /* isMarketSettled */],
      isMarketExpired: __WEBPACK_IMPORTED_MODULE_3__utils_helpers__["z" /* isMarketExpired */],
      isMarketSuspended: __WEBPACK_IMPORTED_MODULE_3__utils_helpers__["L" /* isMarketSuspended */],
      isMarketStatusClosed: __WEBPACK_IMPORTED_MODULE_3__utils_helpers__["O" /* isMarketStatusClosed */],
      isMarketSingle: __WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* isMarketSingle */],
      showDetails: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'isCommentEnabled', 'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance', 'isPinningEnabled', 'hasMaintenanceSuspended']), {
    settledOutcome: function settledOutcome() {
      if (this.market.contracts.length === 0) {
        return 'Please check the outcome.';
      }
      if (this.isMarketSingle(this.market)) {
        var isWinnerYes = this.market.contracts[0].settledStatus === 1;
        return (isWinnerYes ? 'YES' : 'NO') + ' is the outcome.';
      }

      var contract = this.market.contracts.find(function (i) {
        return i.settledStatus === 1;
      });
      if (contract) {
        return contract.contractName + ' is the outcome.';
      }
      return 'Please check the outcome.';
    },
    show: function show() {
      return !!this.theme;
    },
    theme: function theme() {
      if (this.hasMaintenanceSuspended && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["L" /* isMarketSuspended */])(this.market)) {
        return '';
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["n" /* isMarketSettled */])(this.market)) {
        return 'settled';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["z" /* isMarketExpired */])(this.market)) {
        return 'expired';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["L" /* isMarketSuspended */])(this.market)) {
        return 'expired';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["O" /* isMarketStatusClosed */])(this.market)) {
        return 'expired';
      }

      return '';
    },
    title: function title() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["n" /* isMarketSettled */])(this.market)) {
        return 'Settled';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["z" /* isMarketExpired */])(this.market)) {
        return 'Pending Settlement';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["L" /* isMarketSuspended */])(this.market)) {
        return 'Suspended';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["O" /* isMarketStatusClosed */])(this.market)) {
        return 'Closed';
      }

      return '';
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-alert-v2': true
      }, 'market-alert-v2--' + this.theme, this.theme);
    }
  })
});

/***/ }),

/***/ "LkCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-generic"},[(_vm.currentPopupOptions.icon)?_c('div',{staticClass:"popup-generic__icon"},[(_vm.currentPopupOptions.icon === 'error')?_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.icon === 'success')?_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.iconTitle)?_c('h5',{staticClass:"popup-generic__icon-title",class:("popup-generic__icon-title--" + (_vm.currentPopupOptions.icon))},[_vm._v("\n    "+_vm._s(_vm.currentPopupOptions.iconTitle)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-generic__content"},[_vm._t("content")],2),_vm._v(" "),(_vm.currentPopupOptions.actionCallback)?_c('div',{staticClass:"popup-generic__button-wrapper"},[_c('button',{staticClass:"popup-generic__button button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.currentPopupOptions.actionCallback()}}},[_vm._v("\n      "+_vm._s(_vm.currentPopupOptions.actionTitle)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LmU5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI3OCIgdmlld0JveD0iMCAwIDgwIDc4Ij4KICAgIDxnIGZpbGw9IiMyNjNCM0YiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTTQwLjg0MiAwQTEuODM5IDEuODM5IDAgMCAwIDM5IDEuODV2MzYuNjQ1YzAgMS4wMjguODE5IDEuODUgMS44NDIgMS44NWgzNi40OTZhMS44MzkgMS44MzkgMCAwIDAgMS44NDMtMS44NWMwLTkuNC0zLjQwNi0xOC40NDQtOS42MDMtMjUuNDg5QzYyLjMgNC43NDYgNTEuODIzIDAgNDAuODQyIDB6bTEuODQzIDM2LjY0NVYzLjc1NmEzNC43MiAzNC43MiAwIDAgMSAyNC4xMzggMTEuNzE3YzUuMTkzIDUuODg2IDguMjA4IDEzLjM2IDguNjM2IDIxLjE3Mkg0Mi42ODV6Ii8+CiAgICAgICAgPHBhdGggZD0iTTY0LjAwNiA0NS43ODZjMC0uNzk2LS42MzQtMS40MzMtMS40MjctMS40MzNIMzMuNDUzdi0yOS4yNmMwLS43OTYtLjYzNS0xLjQzMy0xLjQyOC0xLjQzM0MxNC4zNzYgMTMuNjYuMDI5IDI4LjA2Ni4wMjkgNDUuNzg2YzAgMTcuNzA3IDE0LjM0NyAzMi4xMjcgMzEuOTk2IDMyLjEyN3MzMS45ODEtMTQuNDIgMzEuOTgxLTMyLjEyN3ptLTMxLjk4MSAyOS4yNmMtMTYuMDYzIDAtMjkuMTQtMTMuMTMxLTI5LjE0LTI5LjI2IDAtMTUuNjUgMTIuMjk5LTI4LjQ3NyAyNy43MTMtMjkuMjN2MjkuMjE2YzAgLjc5Ni42MzQgMS40MzMgMS40MjcgMS40MzNoMjkuMDk4Yy0uNzUgMTUuNDc3LTEzLjUxMSAyNy44NDEtMjkuMDk4IDI3Ljg0MXoiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "LnAU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "LnM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trends"},[_c('div',{staticClass:"row row-x"},[(!_vm.isUserRestricted)?_c('div',{staticClass:"row row-x trends__three-elements-row"},[_c('div',{staticClass:"column small-12 large-8 trends__element"},[_c('hero-unit-slider')],1),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4 trends__biggest-gains"},[_c('most-predicted-list',{attrs:{"isNewArrival":true,"num":2}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"trends__markets"},[_c('div',{staticClass:"row row-x"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4 large-push-8"},[_c('market-biggest-gains',{attrs:{"extended":_vm.shouldShowKeyStatsWidgets}}),_vm._v(" "),(!_vm.shouldShowKeyStatsWidgets)?[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"comments"}})],1):[(_vm.widgets.comments && _vm.widgets.comments.widgetTopComments.length > 0)?_c('market-top-comments',{staticClass:"trends__widget-comments",attrs:{"widget":_vm.widgets.comments}}):_vm._e()]]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column small-12 large-8 large-pull-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"currently"}})],1):[(_vm.widgets.currently)?_c('market-currently-predicting',{attrs:{"widget":_vm.widgets.currently}}):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"column small-12 large-6 trends--left"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"money"}})],1):[(_vm.widgets.smart)?_c('market-money-widget',{attrs:{"widget":_vm.widgets.smart,"theme":"margin"}}):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"column small-12 large-6 trends--right"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"money"}})],1):[(_vm.widgets.most)?_c('market-money-widget',{attrs:{"widget":_vm.widgets.most}}):_vm._e()]],2)])]),_vm._v(" "),(_vm.shouldShowKeyStatsWidgets)?_c('div',{staticClass:"column small-12 trends__markets--top-distance"},[_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"column small-12 large-8"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"stats"}})],1):[_c('market-key-stats',{attrs:{"widget":_vm.widgets.key}})]],2),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"comments"}})],1):[(_vm.widgets.comments && _vm.widgets.comments.widgetTopComments.length > 0)?_c('market-top-comments',{attrs:{"widget":_vm.widgets.comments}}):_vm._e()]],2)])]):_vm._e()])]),_vm._v(" "),(_vm.disqusReady)?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 trends__element"},[_c('div',{staticClass:"trends__comments-title"},[_vm._v("\n        Comments\n      ")]),_vm._v(" "),_c('disqus',{attrs:{"showTitle":false,"disqusId":_vm.disqusId,"title":"","auth":_vm.disqusAuth,"url":_vm.disqusUrl}})],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"trends__desktop-header"},[_c('span',{staticClass:"trends__desktop-title"},[_vm._v("Latest Trends")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LnYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_leaderboards_js__ = __webpack_require__("RaQB");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0978288c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_leaderboards_vue__ = __webpack_require__("1wil");
function injectStyle (ssrContext) {
  __webpack_require__("7NdF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_leaderboards_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0978288c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_leaderboards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "LrHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_discussion_widget_js__ = __webpack_require__("UEti");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66571bc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_discussion_widget_vue__ = __webpack_require__("GPEM");
function injectStyle (ssrContext) {
  __webpack_require__("3PHu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_discussion_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66571bc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_discussion_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LujD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LulR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_close_button_close_button_vue__ = __webpack_require__("mjGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_journey_sushi_purchase_journey_sushi_vue__ = __webpack_require__("zyXH");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    market: {},
    closeJourneyAfterSuccess: {
      type: Boolean,
      default: true
    },
    showRelatedContracts: {
      type: Boolean,
      default: false
    },
    showContractCharts: {
      type: Boolean,
      default: false
    },
    disablePurchaseOfferWatchers: {
      type: Boolean,
      default: false
    },
    showOrderSlip: {
      type: Boolean,
      default: true
    },
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false
    },
    layoutKind: {
      type: String,
      default: ''
    }
  },
  components: {
    closeButton: __WEBPACK_IMPORTED_MODULE_3__components_generics_close_button_close_button_vue__["a" /* default */],
    purchaseJourneySushi: __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_journey_sushi_purchase_journey_sushi_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'clearOrderBook']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('onboarding', ['showOnboardingStep'])),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'purchase-inline-sushi': true,
        'purchase-inline-sushi--with-orderslip': this.showOrderSlip
      }, 'purchase-inline-sushi--' + this.kind, this.kind);
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.clearOrderBook();
  }
});

/***/ }),

/***/ "LyDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: null
    };
  },
  created: function created() {
    var _this = this;

    this.getIdUploadUrl().then(function (data) {
      _this.url = data;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getIdUploadUrl']), {
    onButtonClick: function onButtonClick() {
      window.location.href = this.url;
    }
  })
});

/***/ }),

/***/ "M+zr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_common_betslip_js__ = __webpack_require__("I+ky");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72628c02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_common_betslip_vue__ = __webpack_require__("NnrL");
function injectStyle (ssrContext) {
  __webpack_require__("ZJN1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_common_betslip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72628c02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_common_betslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M0+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    isOpen: {
      type: Boolean,
      default: false
    },
    accordion: null,
    id: null
  },
  data: function data() {
    return {
      isOpenState: this.isOpen
    };
  },

  computed: {
    isOpenModifier: function isOpenModifier() {
      if (this.id) {
        this.isOpenState = this.accordion === this.id;
      }
      return {
        'collapsible-panel--is-open': this.isOpenState
      };
    }
  },
  methods: {
    toggle: function toggle() {
      this.isOpenState = !this.isOpenState;
      if (this.id) {
        this.$emit('open', this.isOpenState ? this.id : null);
      }
    }
  }
});

/***/ }),

/***/ "M32j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'multiselect',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__["multiselectMixin"], __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__["pointerMixin"], __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["a" /* default */]],
  props: {
    name: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: 'Press enter to select'
    },
    selectedLabel: {
      type: String,
      default: 'Selected'
    },
    deselectLabel: {
      type: String,
      default: 'Press enter to remove'
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 99999
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    limitText: {
      type: Function,
      default: function _default(count) {
        return 'and ' + count + ' more';
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openDirection: {
      type: String,
      default: ''
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    adjust: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    activate: function activate() {
      var _this = this;

      if (this.isOpen || this.disabled) return;
      if (this.adjust) {
        this.adjustPosition();
      }
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }

      this.isOpen = true;
      if (this.searchable) {
        if (!this.preserveSearch) this.search = '';
        this.$nextTick(function () {
          return _this.$refs.search.focus();
        });
      } else {
        this.$el.focus();
      }
      this.$emit('open', this.id);
    },
    addPointerElement: function addPointerElement() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter',
          key = _ref.key;

      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerSet: function pointerSet(index, option) {
      this.pointer = index;
      this.pointerDirty = true;
      if (this.isIos) {
        this.select(option);
      }
    }
  },
  computed: {
    visibleValue: function visibleValue() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    deselectLabelText: function deselectLabelText() {
      return this.showLabels ? this.deselectLabel : '';
    },
    selectLabelText: function selectLabelText() {
      return this.showLabels ? this.selectLabel : '';
    },
    selectedLabelText: function selectedLabelText() {
      return this.showLabels ? this.selectedLabel : '';
    },
    inputStyle: function inputStyle() {
      if (this.multiple && this.value && this.value.length) {
        // Hide input by setting the width to 0 allowing it to receive focus
        return this.isOpen ? { width: 'auto' } : { width: '0', position: 'absolute' };
      }
      return {};
    },
    contentStyle: function contentStyle() {
      return this.options.length ? { display: 'inline-block' } : { display: 'block' };
    },
    isAbove: function isAbove() {
      if (this.openDirection === 'above' || this.openDirection === 'top') {
        return true;
      } else if (this.openDirection === 'below' || this.openDirection === 'bottom') {
        return false;
      }
      return this.prefferedOpenDirection === 'above';
    }
  }
});

/***/ }),

/***/ "M5iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__ = __webpack_require__("yZQa");






function getDefaultRedirectRouteName(isWalletAvailable) {
  return isWalletAvailable ? 'wallet' : 'account-history';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__["a" /* default */]],
  components: {
    profile: __WEBPACK_IMPORTED_MODULE_2__components_account_profile_profile_vue__["a" /* default */]
  },
  watch: {
    isLayoutMobile: function isLayoutMobile(value) {
      if (!value) {
        this.$router.push({ name: getDefaultRedirectRouteName(this.isWalletEnabled) });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasMaintenanceMessage'])),
  beforeCreate: function beforeCreate() {
    // because router.beforeEnter() fires before app.resizeHandler() can check client width
    // also this.isLayoutMobile === undefined here
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.app.layout === 'desktop') {
      var idVerified = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user.status.idVerified;
      var isUserVerified = typeof idVerified !== 'undefined' ? idVerified : true;
      this.$router.push({ name: getDefaultRedirectRouteName(isUserVerified) });
    }
  }
});

/***/ }),

/***/ "M6K4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M6xY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_profile_overview_js__ = __webpack_require__("p8bb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c9bd28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_profile_overview_vue__ = __webpack_require__("SAZR");
function injectStyle (ssrContext) {
  __webpack_require__("SZB3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_profile_overview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c9bd28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_profile_overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M8zO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_container_js__ = __webpack_require__("+kDG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bea2e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_container_vue__ = __webpack_require__("06wT");
function injectStyle (ssrContext) {
  __webpack_require__("rgkE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_container_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bea2e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_container_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MEHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['mobileMenuOpened']), {
    classModifiers: function classModifiers() {
      return {
        'hamburger-icon': true,
        'hamburger-icon--opened': this.mobileMenuOpened
      };
    },
    text: function text() {
      return this.mobileMenuOpened ? 'Close' : 'Menu';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['toggleMobileMenu']))
});

/***/ }),

/***/ "MFJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attach-to-home"},[(_vm.items)?_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(item,index){return _c('swiper-slide',{key:index,staticClass:"attach-to-home__slide"},[(item.textTop)?_c('p',{staticClass:"attach-to-home__slide-text attach-to-home__slide-text--top"},[_vm._v("\n        "+_vm._s(item.textTop)+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"attach-to-home__slide-image",class:("attach-to-home__slide-image--" + (item.image))}),_vm._v(" "),(item.textBottom)?_c('p',{staticClass:"attach-to-home__slide-text attach-to-home__slide-text--bottom"},[_vm._v("\n        "+_vm._s(item.textBottom)+"\n      ")]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"attach-to-home__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"attach-to-home__footer"},[_c('form-checkbox',{staticClass:"checkbox--attach-to-home checkbox--no-margin",attrs:{"label":"Don’t show this message again","name":"dont-show-again","small":true},model:{value:(_vm.dontShowAgain),callback:function ($$v) {_vm.dontShowAgain=$$v},expression:"dontShowAgain"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MGrt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Number,
      default: 0
    },
    validate: Function,
    initial: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      lastCorrect: this.value,
      min: 5,
      max: 94, // coz 99 - 5
      invalid: false,
      val: 0,
      focused: false
    };
  },

  computed: {
    valueWithCent: function valueWithCent() {
      return this.focused ? this.val : this.val + '\xA2';
    }
  },
  created: function created() {
    this.val = this.value;
  },

  methods: {
    updateValue: function updateValue(value) {
      if (value === '') {
        return;
      }

      var parsed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(value, 10);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(parsed)) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if ('' + parsed !== value) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if (value > this.max) {
        this.lastCorrect = this.max;
        this.$refs.input.value = this.max;
        return;
      }

      this.lastCorrect = parsed;
    },
    onFocus: function onFocus() {
      this.focused = true;
    },
    onBlur: function onBlur() {
      this.focused = false;
      this.val = this.lastCorrect;

      if (this.$refs.input.value === '') {
        this.val = this.min;
      }
      if (this.lastCorrect < this.min) {
        this.val = this.min;
      }

      if (this.lastCorrect > this.max) {
        this.val = this.max;
      }

      this.$refs.input.value = this.val + '\xA2';
      this.$emit('input', this.val);
    }
  }
});

/***/ }),

/***/ "MH7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    mainClassName: function mainClassName() {
      return 'market-filters-desktop-grid-watchlist';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-desktop-grid-watchlist__menu': true,
        'market-filters-desktop-grid-watchlist__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    },
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.fullName;
    }
  }),
  created: function created() {
    this.isWatchlistOpen = true;
  }
});

/***/ }),

/***/ "MI6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.symbolClassModifiers}),_vm._v(" "),_c('div',{staticClass:"document-to-review__info"},[_c('div',{staticClass:"document-to-review__label-wrapper"},[(_vm.showLabel)?_c('div',{staticClass:"document-to-review__label"},[(_vm.opened)?[_vm._v("Reviewed")]:[_vm._v("Unopened")]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"document-to-review__label-suffix"},[(_vm.hasSlotSuffix)?[_vm._t("suffix")]:[_vm._v("\n          Doc #"+_vm._s(_vm.num)+"\n        ")]],2)]),_vm._v(" "),(_vm.title)?_c('div',{staticClass:"document-to-review__title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"document-to-review__description"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"document-to-review__button",attrs:{"href":_vm.link},on:{"click":_vm.onOpen}},[(_vm.markOpened && _vm.opened)?_c('div',{staticClass:"document-to-review__button-tick"}):[_vm._v("Open")]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MIwN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MJqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_dashboard_js__ = __webpack_require__("+++F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a760ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_dashboard_vue__ = __webpack_require__("CLCK");
function injectStyle (ssrContext) {
  __webpack_require__("Gz6C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_dashboard_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a760ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MRVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_hamburger_icon_js__ = __webpack_require__("MEHD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70d1d0bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hamburger_icon_vue__ = __webpack_require__("e76B");
function injectStyle (ssrContext) {
  __webpack_require__("dB88")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_hamburger_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70d1d0bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hamburger_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MRk1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-panel",class:_vm.openModifier},[_c('div',{staticClass:"insight-panel__wrap"},[_vm._t("default")],2),_vm._v(" "),(_vm.showBottom)?_c('div',{staticClass:"insight-panel__bottom"},[_c('span',{staticClass:"insight-panel__link",class:_vm.moreModifier,on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MSkT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"withdraw"}}):[(!_vm.showConfirmation)?_c('div',[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending}}):[(!_vm.hasErrorMessage)?[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n          Withdrawing funds may cause some or all of your open orders to be cancelled.\n        ")]),_vm._v(" "),_c('form',{staticClass:"form ach__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('available-balance',{attrs:{"restricted":_vm.restrictedFunds,"balance":_vm.availableBalance}}),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.amount,"theme":"amount","name":"amount","disabled":_vm.isAmountFieldDisabled,"autocomplete":"","placeholder":"Withdrawal Amount (Minimum $1 USD)"},on:{"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1)]),_vm._v(" "),_c('h4',{staticClass:"check__section-title"},[_vm._v("\n            Recipient\n          ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"check__address"},[_vm._v("\n                "+_vm._s(_vm.check.payeeName)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.fields.street)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.fields.city)+", "+_vm._s(_vm.fields.zipCode)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Review Request"}})],1)])],1)]:_vm._e(),_vm._v(" "),(_vm.hasErrorMessage)?_c('alert-box',{attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.hasErrorMessage)?[_c('p',{staticClass:"check__disclaimer"},[_vm._v("\n          "+_vm._s(_vm.check.disclaimer)+"\n        ")])]:_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.showConfirmation)?_c('withdraw-confirm',{staticClass:"withdraw-confirm--with-margin",attrs:{"kind":"check","amendAvailable":true,"amount":Number(_vm.fields.amount),"fee":Number(_vm.fields.amount) * Number(_vm.check.feePercent),"recipient":_vm.check.payeeName,"addressLine1":_vm.fields.street,"addressLine2":_vm.fields.city,"addressLine3":_vm.fields.zipCode,"country":_vm.fields.country},on:{"edit":_vm.onEdit,"success":_vm.onSuccess}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MSvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketDetailPageLoader_vue__ = __webpack_require__("2wse");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665277e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketDetailPageLoader_vue__ = __webpack_require__("tvXx");
function injectStyle (ssrContext) {
  __webpack_require__("Ed2X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketDetailPageLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665277e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketDetailPageLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MW9B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MWul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('h2',{staticClass:"research-widget__title"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"research-widget__content"},[(_vm.shutdown)?[_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        PredictIt started as a project of Victoria University of Wellington, to facilitate research into the way markets forecast events. Now through our application as a federally regulated Event Market platform we are expanding into markets beyond politics.\n      ")]),_vm._v(" "),_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        We are excited for this transition and hope you follow us on Twitter to learn more about future market launches.\n      ")]),_vm._v(" "),_c('button',{staticClass:"button button--medium button--submit",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Learn More")])]:[_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        A project of the Prediction Market Research Consortium, PredictIt has been established to facilitate research into the way markets forecast events.\n      ")]),_vm._v(" "),_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        In order to enable researchers to take advantage of the opportunities presented by prediction markets, we make our data available to the academic community at no cost.\n      ")]),_vm._v(" "),_c('div',{staticClass:"research-widget__button"},[_c('button',{staticClass:"button button--medium button--submit",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Learn More")])])]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MYxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"app-privacy-statement"},[_c('div',{staticClass:"app-privacy-statement__inner"},[_c('div',{staticClass:"app-privacy-statement__close",on:{"click":_vm.onHide}}),_vm._v(" "),_c('div',{staticClass:"app-privacy-statement__info"},[_vm._v("\n      By using our site, you acknowledge that you have read and understand our "),_c('router-link',{staticClass:"app-privacy-statement__link",attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v("Privacy Policy")]),_vm._v(".\n    ")],1),_vm._v(" "),_c('div',{staticClass:"app-privacy-statement__agree"},[_c('button',{staticClass:"button button--primary",on:{"click":_vm.onAgree}},[_vm._v("\n        I Agree\n      ")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MbhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_process_overview_js__ = __webpack_require__("b47U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd60b24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_process_overview_vue__ = __webpack_require__("Axs9");
function injectStyle (ssrContext) {
  __webpack_require__("U8Te")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_process_overview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd60b24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_process_overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MeDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'account-ssn-info-upload': true,
        'account-ssn-info-upload--modal': this.isPopup,
        'account-ssn-info-upload--embedded': !this.isPopup
      }, 'account-ssn-info-upload--' + this.theme, this.theme);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopupOptions', 'setCurrentPopup']), {
    onButtonClick: function onButtonClick() {
      var trigger = this.isPopup ? __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* FORM_TYPE_TRIGGERS */].MODAL : __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* FORM_TYPE_TRIGGERS */].STANDALONE;
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
      this.setCurrentPopupOptions({ formType: __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* FORM_TYPE_IDV */].SSN4IDV, trigger: trigger });
    }
  })
});

/***/ }),

/***/ "MluJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    source: {
      type: Number,
      default: 4
    },
    isPending: {
      type: Boolean,
      default: false
    },
    isPopup: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    isCard: function isCard() {
      return this.type === 'card';
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'account-upload-document': true,
        'account-upload-document--modal': this.isPopup,
        'account-upload-document--embedded': !this.isPopup
      }, 'account-upload-document--' + this.theme, this.theme);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getDocumentUploadLink']), {
    onButtonClick: function onButtonClick() {
      this.getDocumentUploadLink(this.source).then(function (link) {
        window.location.href = link;
      });
    }
  })
});

/***/ }),

/***/ "Mo7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Moaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* eslint-disable no-console */

function set(key, value) {
  var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var data = {
    value: value,
    expires_at: ttl !== null ? (new Date().getTime() + ttl * 1000) / 1 : null
  };

  try {
    localStorage.setItem(key.toString(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  } catch (e) {
    console.error(e);
  }
}

function del(key) {
  try {
    localStorage.removeItem(key.toString());
  } catch (e) {
    console.error(e);
  }
}

function get(key, defaultValue) {
  try {
    var data = JSON.parse(localStorage.getItem(key.toString()));
    if (data !== null) {
      if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
        localStorage.removeItem(key.toString());
      } else {
        return data.value;
      }
    }
  } catch (e) {
    console.error(e);
    del(key);
  }
  return defaultValue || null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  set: set,
  get: get,
  del: del
});

/***/ }),

/***/ "MptW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['dismissTwoFactorPrompt', 'setNavigatingToTwoFactorSetup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
        onSetupNow: function onSetupNow() {
            this.dismissTwoFactorPrompt();
            this.setCurrentPopup(null);
            // Set flag to prevent ADD_FUNDS from showing during navigation
            this.setNavigatingToTwoFactorSetup(true);
            this.$router.push({ name: 'account-settings' });
        },
        onNotNow: function onNotNow() {
            this.dismissTwoFactorPrompt();
            this.setCurrentPopup(null);
        }
    })
});

/***/ }),

/***/ "Mq7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_bank_transfer_components_bank_account_bank_account_vue__ = __webpack_require__("5r1F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    bankAccount: __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_bank_transfer_components_bank_account_bank_account_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['currentDeposit', 'balance']), {
    amountFormatted: function amountFormatted() {
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["d" /* priceDisplay */])(this.currentDeposit.amount || 0);
    },
    matchedFormatted: function matchedFormatted() {
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["d" /* priceDisplay */])(this.currentDeposit.matched || 0);
    },
    promoAmountFormatted: function promoAmountFormatted() {
      var value = this.currentDeposit.promoAmount || 0;
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["d" /* priceDisplay */])(value);
    },
    hasPromotionalCredit: function hasPromotionalCredit() {
      var value = this.currentDeposit.matched || this.currentDeposit.promoAmount || 0;
      return value !== 0;
    },
    leftColClassModifiers: function leftColClassModifiers() {
      return {
        column: true,
        'small-4': this.hasPromotionalCredit,
        'small-6': !this.hasPromotionalCredit,
        deposited__divider: true
      };
    },
    rightColClassModifiers: function rightColClassModifiers() {
      return {
        column: true,
        'small-4': this.hasPromotionalCredit,
        'small-6': !this.hasPromotionalCredit
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getStatus'])),
  created: function created() {
    this.getStatus(); // reload hasBeenFunded flag when showing Summary
  }
});

/***/ }),

/***/ "MuFU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "MvkI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mz4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_announcement_js__ = __webpack_require__("95mA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6864cc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_announcement_vue__ = __webpack_require__("ci9y");
function injectStyle (ssrContext) {
  __webpack_require__("9RvI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_announcement_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6864cc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_announcement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MzT2":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "N1G7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"myshares",staticClass:"portfolio-my-markets"},[_c('div',{staticClass:"portfolio-my-markets__wrapper"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.loaderItems(5)),function(item){return _c('div',{staticClass:"content-loader-item"},[_c('market-shares-item-loader')],1)}),0):[(_vm.showMarketsList)?_vm._l((_vm.filteredMarkets),function(market){return _c('div',{key:market.marketId,staticClass:"portfolio-my-markets__item"},[_c('market-list-item-expandable-sushi',{attrs:{"expandingAll":_vm.isExpandingAllTriggered(market.marketId),"expanded":_vm.isItemExpanded(market.marketId),"market":market},on:{"toggle":_vm.onMarketListItemToggle}})],1)}):_vm._e(),_vm._v(" "),(_vm.showNoSharesPlaceholder)?[_c('div',{staticClass:"portfolio-my-markets__info"},[_vm._v("\n            You do not have any positions.\n          ")])]:_vm._e()]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N2Hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    documentData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      openedIndexes: []
    };
  },

  methods: {
    parseDate: function parseDate(document) {
      if (document.displayDocumentCreatedDate) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(document.displayDocumentCreatedDate).format(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["p" /* DEFAULT_DATE_FORMAT */]);
      }
      return "-";
    },
    onOpen: function onOpen(document, index) {
      this.openedIndexes.push(index);
      window.open(document.displayDocumentPath);
    },
    rowClassModifiers: function rowClassModifiers(document, index) {
      return {
        'document-table-view__row': true,
        'document-table-view__row--clickable': true,
        'document-table-view__row--opened': this.openedIndexes.includes(index)
      };
    }
  }
});

/***/ }),

/***/ "N4a4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-news"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"insight-news__line"}),_vm._v(" "),_c('insight-panel',{attrs:{"text":"See All","href":_vm.allArticlesLink,"away":_vm.allArticlesAway}},[_c('div',{staticClass:"insight-news__articles"},_vm._l((_vm.analysis),function(link){return _c('insight-link',{key:link.title,attrs:{"title":link.title,"href":_vm.createLink(link.url),"date":_vm.createDate(link.date),"url":link.url}})}),1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-news__header"},[_c('div',{staticClass:"insight-news__header-title"},[_vm._v("\n      Insights\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N8e0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N9YZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-discussion"},[_c('div',{staticClass:"sushi-market-discussion__title"},[_c('div',{staticClass:"sushi-market-discussion__title-text"},[_vm._v("\n      Comments "),(_vm.market.disqus_ArchivedCommentsTotal)?[_vm._v("("+_vm._s(_vm.market.disqus_ArchivedCommentsTotal.toLocaleString('en-US'))+" Archived)")]:_vm._e()],2),_vm._v(" "),(_vm.isPinningEnabled && !_vm.isDiscussionPinned && _vm.isLoggedIn)?_c('div',{staticClass:"sushi-market-discussion__title-icon",on:{"click":_vm.toggleDiscussionPin}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sushi-market-discussion__comments"},[_c('disqus',{attrs:{"disqusId":_vm.market.disqus_Identifier,"title":_vm.market.disqus_Title,"auth":_vm.market.disqus_UserAuth,"url":_vm.market.disqus_Url,"previous":_vm.market.disqus_PrevThreadID,"next":_vm.market.disqus_NextThreadID,"total":_vm.market.disqus_ArchivedCommentsTotal,"marketId":_vm.market.marketId,"isActive":_vm.isActive,"focusCommentId":_vm.focusCommentId,"requestedCommentThreadId":_vm.requestedCommentThreadId,"showTitle":false},on:{"discussion-request-change":function($event){return _vm.$emit('discussion-request-change', $event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N9iO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NEEm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.back)?_c('router-link',{staticClass:"static-page-header__back",attrs:{"tag":"div","to":_vm.back}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"static-page-header__text-wrap"},[_c('div',{staticClass:"static-page-header__text"},[_vm._t("title")],2),_vm._v(" "),(_vm.hasSecondary)?_c('div',{staticClass:"static-page-header__text"},[_vm._t("secondary")],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"static-page-header__chevron"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NFT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dashboard_portfolio_my_markets_portfolio_my_markets_vue__ = __webpack_require__("UIPs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_account_social_badge_account_social_badge_vue__ = __webpack_require__("gdGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_filters_market_filters_dashboard_market_filters_dashboard_vue__ = __webpack_require__("of0E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dashboard_dashboard_markets_toggle_dashboard_markets_toggle_vue__ = __webpack_require__("zkja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_social_share_invite_widget_share_invite_widget_vue__ = __webpack_require__("dDcj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_leaderboards_leaderboards_info_leaderboards_info_vue__ = __webpack_require__("HkCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_notifications_list_notifications_list_vue__ = __webpack_require__("R/N+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_profile_public_profile_widget_public_profile_widget_vue__ = __webpack_require__("dlHv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_socialLevel__ = __webpack_require__("GOBe");





var _NAVIGATION_TABS_ROUT;

















var NAVIGATION_TABS = {
  MY_MARKETS: 'my-markets',
  LEADERBOARD_INFO: 'leaderboard-info',
  INVITE_FRIENDS: 'invite-friends',
  NOTIFICATIONS: 'notifications'
};

var NAVIGATION_TABS_ROUTES = (_NAVIGATION_TABS_ROUT = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_NAVIGATION_TABS_ROUT, NAVIGATION_TABS.MY_MARKETS, 'portfolio'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_NAVIGATION_TABS_ROUT, NAVIGATION_TABS.LEADERBOARD_INFO, 'dashboard-leaderboard-info'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_NAVIGATION_TABS_ROUT, NAVIGATION_TABS.INVITE_FRIENDS, 'dashboard-invite-friends'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_NAVIGATION_TABS_ROUT, NAVIGATION_TABS.NOTIFICATIONS, 'dashboard-notifications'), _NAVIGATION_TABS_ROUT);

var NAVIGATION_ROUTES_TABS = Object.fromEntries(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(NAVIGATION_TABS_ROUTES).map(function (_ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];

  return [v, k];
}));

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_17__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_loader__["a" /* default */]],
  components: {
    publicProfileWidget: __WEBPACK_IMPORTED_MODULE_15__components_profile_public_profile_widget_public_profile_widget_vue__["a" /* default */],
    leaderboardsInfo: __WEBPACK_IMPORTED_MODULE_13__components_leaderboards_leaderboards_info_leaderboards_info_vue__["a" /* default */],
    shareInviteWidget: __WEBPACK_IMPORTED_MODULE_12__components_social_share_invite_widget_share_invite_widget_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a,
    tabs: __WEBPACK_IMPORTED_MODULE_6__components_generics_tabs_tabs_vue__["a" /* default */],
    portfolioMyMarkets: __WEBPACK_IMPORTED_MODULE_7__components_dashboard_portfolio_my_markets_portfolio_my_markets_vue__["a" /* default */],
    accountSocialBadge: __WEBPACK_IMPORTED_MODULE_8__components_account_account_social_badge_account_social_badge_vue__["a" /* default */],
    dashboardMarketFilters: __WEBPACK_IMPORTED_MODULE_9__components_market_market_filters_market_filters_dashboard_market_filters_dashboard_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_11__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    dashboardMarketsToggle: __WEBPACK_IMPORTED_MODULE_10__components_dashboard_dashboard_markets_toggle_dashboard_markets_toggle_vue__["a" /* default */],
    notificationsList: __WEBPACK_IMPORTED_MODULE_14__components_notifications_list_notifications_list_vue__["a" /* default */]
  },
  data: function data() {
    return {
      activeNavigationTab: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('dashboard', ['mySharesTotalGainLoss']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('wallet', ['portfolioValueDecimal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('dashboard', ['mySharesReady']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('wallet', ['balance']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
        'page-dashboard-sushi': true
      }, 'page-dashboard-sushi--' + this.$route.name, this.$route.name);
    },
    navigationTabs: function navigationTabs() {
      return [{
        name: NAVIGATION_TABS.MY_MARKETS,
        title: 'My Markets'
      },
      // {
      //   name: NAVIGATION_TABS.LEADERBOARD_INFO,
      //   title: 'Profile',
      // },
      {
        name: NAVIGATION_TABS.INVITE_FRIENDS,
        title: this.isLayoutMobile ? 'Invite' : 'Invite Friends'
      }, {
        name: NAVIGATION_TABS.NOTIFICATIONS,
        title: 'Notifications'
      }];
    },
    portfolioValueReady: function portfolioValueReady() {
      return true;
      // return !this.balance.isDefault && this.mySharesReady;
    },
    gainLossClassModifiers: function gainLossClassModifiers() {
      var value = this.mySharesTotalGainLoss;
      return {
        'page-dashboard-sushi__gain-loss': true,
        'page-dashboard-sushi__gain-loss--plus': value > 0,
        'page-dashboard-sushi__gain-loss--minus': value < 0
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('dashboard', ['setMarketsToggle']), {
    navigationTabChange: function navigationTabChange(name) {
      this.activeNavigationTab = name;
      var routeName = NAVIGATION_TABS_ROUTES[name];
      if (routeName !== this.$route.name) {
        this.$router.push({ name: NAVIGATION_TABS_ROUTES[name] });
      }
      if (name !== NAVIGATION_TABS.MY_MARKETS) {
        this.setMarketsToggle(false);
      }
    }
  }),
  watch: {
    $route: function $route(to, from) {
      this.activeNavigationTab = NAVIGATION_ROUTES_TABS[to.name];
    }
  },
  created: function created() {
    this.activeNavigationTab = NAVIGATION_ROUTES_TABS[this.$route.name];
  }
});

/***/ }),

/***/ "NGyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_facebook_svg__ = __webpack_require__("0tSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_facebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_instagram_svg__ = __webpack_require__("ifvC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_instagram_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_instagram_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_footer_x_svg__ = __webpack_require__("FGQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_footer_x_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_icons_footer_x_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_footer_youtube_svg__ = __webpack_require__("GeXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_footer_youtube_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_footer_youtube_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      debugClickCount: 0,
      debugClickThreshold: 7,
      debugClickTimer: null,
      footerExpandRafId: null,
      screenWidth: 1024,
      visibleSections: ['legal'],
      expanded: true,
      items: [{ title: 'Instagram', href: "https://www.instagram.com/PredictIt/", icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_instagram_svg___default.a }, { title: 'Youtube', href: "https://www.youtube.com/c/predictitofficial", icon: __WEBPACK_IMPORTED_MODULE_6__assets_icons_footer_youtube_svg___default.a }, { title: 'Twitter', href: "https://twitter.com/PredictIt", icon: __WEBPACK_IMPORTED_MODULE_5__assets_icons_footer_x_svg___default.a }, { title: 'Facebook', href: "https://www.facebook.com/PredictIt/", icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_facebook_svg___default.a }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'leaderboardsEnabled']), {
    classModifiers: function classModifiers() {
      return {
        footer: true,
        'footer--expanded': this.expanded
      };
    },
    isLayoutPhone: function isLayoutPhone() {
      return this.screenWidth < 640;
    },
    footerBottomChevronModifiers: function footerBottomChevronModifiers() {
      return {
        'footer__bottom-chevron': true,
        'footer__bottom-chevron--opened': this.expanded
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('search', ['toggleSearchBar']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('onboarding', ['showOnboardingStep']), {
    handleSecretTap: function handleSecretTap() {
      var _this = this;

      this.debugClickCount += 1;
      clearTimeout(this.debugClickTimer);
      this.debugClickTimer = setTimeout(function () {
        _this.debugClickCount = 0;
      }, 2000);
      if (this.debugClickCount >= this.debugClickThreshold) {
        this.debugClickCount = 0;
        this.$router.push({ name: 'user-status' });
      }
    },
    onDetailsToggle: function onDetailsToggle() {
      this.expanded = !this.expanded;
    },
    onFrame: function onFrame() {
      window.scrollTo(0, document.body.scrollHeight);
      this.footerExpandRafId = window.requestAnimationFrame(this.onFrame);
    },
    onFooterExpandStopFrame: function onFooterExpandStopFrame() {
      if (this.footerExpandRafId !== null) {
        window.cancelAnimationFrame(this.footerExpandRafId);
        this.footerExpandRafId = null;
      }
    },
    onFooterExpandEnter: function onFooterExpandEnter() {
      this.footerExpandRafId = window.requestAnimationFrame(this.onFrame);
    },
    resizeHandler: function resizeHandler() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
    },
    sectionClassModifiers: function sectionClassModifiers(name) {
      return {
        'footer__section-title': true,
        'footer__section-title--opened': this.visibleSections.includes(name)
      };
    },
    toggleSection: function toggleSection(name) {
      if (!this.isLayoutPhone) return;
      if (this.visibleSections.includes(name)) {
        this.visibleSections = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.visibleSections.filter(function (i) {
          return i !== name;
        })));
      } else {
        this.visibleSections = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.visibleSections), [name]);
      }
    },
    isSectionVisible: function isSectionVisible(name) {
      return !this.isLayoutPhone || this.isLayoutPhone && this.visibleSections.includes(name);
    },
    onLogin: function onLogin() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    },
    onSignUp: function onSignUp() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
    }
  }),
  created: function created() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    this.onFooterExpandStopFrame();
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_polyfill__ = __webpack_require__("SRJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_custom_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm__ = __webpack_require__("Sl4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_vue__ = __webpack_require__("IYz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_animated_number_animated_number_vue__ = __webpack_require__("21pt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_market_market_state_tooltip_market_state_tooltip_vue__ = __webpack_require__("Vnj/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_click_outside__ = __webpack_require__("oKYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_outer_link__ = __webpack_require__("dK2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_price_display__ = __webpack_require__("P3fZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_large_number__ = __webpack_require__("+88x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_sticky__ = __webpack_require__("1/qb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_asset_cdn_src__ = __webpack_require__("6Bn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__directives_contract_name__ = __webpack_require__("tmS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_brand_name_brand_name_vue__ = __webpack_require__("LTL3");
/* global Sentry */
/* eslint-disable no-confusing-arrow */






















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_youtube_embed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('click-outside', __WEBPACK_IMPORTED_MODULE_13__directives_click_outside__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('outer-link', __WEBPACK_IMPORTED_MODULE_14__directives_outer_link__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('price-display', __WEBPACK_IMPORTED_MODULE_15__directives_price_display__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('large-number', __WEBPACK_IMPORTED_MODULE_16__directives_large_number__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('sticky', __WEBPACK_IMPORTED_MODULE_17__directives_sticky__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('asset-cdn-src', __WEBPACK_IMPORTED_MODULE_18__directives_asset_cdn_src__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('contract-name', __WEBPACK_IMPORTED_MODULE_19__directives_contract_name__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('base32', function (value) {
  return value.toString(32).toUpperCase();
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('pluralize', function (value) {
  return value.charAt(value.length - 1) === 's' ? value : value + 's';
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('usernameDisplay', function (value) {
  var limit = 14;
  var username = value || '';
  if (username.length >= limit) {
    return username.substr(0, limit) + '...';
  }
  return username;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('usernameDisplayLong', function (value) {
  var limit = 20;
  var username = value || '';
  if (username.length >= limit) {
    return username.substr(0, limit) + '...';
  }
  return username;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('ordinal', function (value) {
  var symbols = ['th', 'st', 'nd', 'rd'];
  var v = value % 100;
  var suffix = symbols[(v - 20) % 10] || symbols[v] || symbols[0];
  return '' + value + suffix;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('brand-name', __WEBPACK_IMPORTED_MODULE_20__components_brand_name_brand_name_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('animated-number', __WEBPACK_IMPORTED_MODULE_11__components_animated_number_animated_number_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('market-state-tooltip', __WEBPACK_IMPORTED_MODULE_12__components_market_market_state_tooltip_market_state_tooltip_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_gtm___default.a, {
  debug: "production" === 'development'
});

if (typeof Sentry !== 'undefined' && "production" !== 'development' && __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).SENTRY_DSN) {
  Sentry.init({
    dsn: __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).SENTRY_DSN,
    environment: "production"
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_10__components_app_app_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ "NHsJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_methodology_js__ = __webpack_require__("7pd9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f23cf980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_methodology_vue__ = __webpack_require__("WMwr");
function injectStyle (ssrContext) {
  __webpack_require__("LPOY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_methodology_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f23cf980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_methodology_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NKIR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NMl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_js__ = __webpack_require__("6Ngg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3bc0e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_vue__ = __webpack_require__("SXEJ");
function injectStyle (ssrContext) {
  __webpack_require__("VYD9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3bc0e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NMmg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NN0H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NNk1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-extended-betslip-contract-info"},[_c('div',{staticClass:"purchase-extended-betslip-contract-info__image",style:(_vm.contractImageStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"purchase-extended-betslip-contract-info__info"},[(_vm.isMarketSingle)?[_c('div',{staticClass:"purchase-extended-betslip-contract-info__info-contract"},[_vm._v(_vm._s(_vm.market.marketShortName))])]:[_c('div',{staticClass:"purchase-extended-betslip-contract-info__info-contract"},[_vm._v(_vm._s(_vm.contract.contractName))]),_vm._v(" "),_c('div',{staticClass:"purchase-extended-betslip-contract-info__info-market"},[_vm._v("\n          "+_vm._s(_vm.market.marketShortName)+"\n        ")])]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NOsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORDER_BOOK_DISPLAY_MODES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_order_book_sushi_order_book_offers_sushi_order_book_offers_sushi_vue__ = __webpack_require__("BRRs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_order_book_sushi_order_book_my_orders_sushi_order_book_my_orders_sushi_vue__ = __webpack_require__("Hxoi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_purchase_sushi_order_book_sushi_order_book_prices_sushi_order_book_prices_sushi_vue__ = __webpack_require__("YZhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_order_book_sushi_order_book_shares_sushi_order_book_shares_sushi_vue__ = __webpack_require__("srEx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_mutex__ = __webpack_require__("EOu+");

















var ORDER_BOOK_LS_KEY = 'order-book-contract-id';

var TABS = {
  PRICES: 'prices',
  MY_ORDERS: 'my-orders',
  MY_SHARES: 'my-shares',
  ALL_OFFERS: 'all-offers'
};

var ORDER_BOOK_DEBOUNCE_INTERVAL = 500;
var isPricesDisabled = function isPricesDisabled(market) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["z" /* isMarketExpired */])(market) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["L" /* isMarketSuspended */])(market);
};

var ORDER_BOOK_DISPLAY_MODES = {
  DEFAULT: 'default', //  all visible, buy/sell offers tabs
  MOBILE: 'mobile' // only one section visible
};

/* harmony default export */ __webpack_exports__["b"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_loader__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_5__components_generics_tabs_tabs_vue__["a" /* default */],
    orderBookOffersSushi: __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_order_book_sushi_order_book_offers_sushi_order_book_offers_sushi_vue__["a" /* default */],
    orderBookMyOrdersSushi: __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_order_book_sushi_order_book_my_orders_sushi_order_book_my_orders_sushi_vue__["a" /* default */],
    orderBookPricesSushi: __WEBPACK_IMPORTED_MODULE_8__components_purchase_sushi_order_book_sushi_order_book_prices_sushi_order_book_prices_sushi_vue__["a" /* default */],
    orderBookSharesSushi: __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_order_book_sushi_order_book_shares_sushi_order_book_shares_sushi_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    operationValue: {
      type: String,
      default: 'yes',
      validator: function validator(value) {
        return ['no', 'yes'].indexOf(value) >= 0;
      }
    },
    operationType: {
      type: String,
      default: 'buy'
    },
    displayMode: {
      type: String,
      default: ORDER_BOOK_DISPLAY_MODES.DEFAULT
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    defaultMinimumRows: {
      type: Number,
      default: 0
    },
    compactCards: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var isInitialised = !isPricesDisabled(this.market);
    return {
      ORDER_BOOK_DISPLAY_MODES: ORDER_BOOK_DISPLAY_MODES,
      ORDER_BOOK_OFFER_DISPLAY_MODE: __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_order_book_sushi_order_book_offers_sushi_order_book_offers_sushi_vue__["b" /* ORDER_BOOK_OFFER_DISPLAY_MODE */],
      initialised: isInitialised,
      activeTab: TABS.PRICES,
      hasScrollableContent: false,
      showScrollableFade: false,
      TABS: TABS,
      viewportHeight: typeof window !== 'undefined' ? window.visualViewport ? Math.floor(window.visualViewport.height) : window.innerHeight : 0
    };
  },

  watch: {
    initialised: function initialised(value) {
      var _this = this;

      if (!value) return;
      if (this.tabs.find(function (tab) {
        return tab.name === _this.activeTab;
      }) === undefined) {
        if (this.tabs.find(function (tab) {
          return tab.name === TABS.PRICES;
        }) !== undefined) {
          this.tabChange(TABS.PRICES);
        } else if (this.tabs.length > 0) {
          this.tabChange(this.tabs[0].name);
        }
      }
      this.$emit('initialised');
      this.$nextTick(this.refreshScrollableTableState);
    },
    activeTab: function activeTab() {
      this.$nextTick(this.refreshScrollableTableState);
    },
    orderBook: function orderBook() {
      this.$nextTick(this.refreshScrollableTableState);
    },
    buyOffers: function buyOffers() {
      this.$nextTick(this.refreshScrollableTableState);
    },
    sellOffers: function sellOffers() {
      this.$nextTick(this.refreshScrollableTableState);
    },
    contractShares: function contractShares() {
      this.$nextTick(this.refreshScrollableTableState);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('trade', ['orderBook', 'contractShares', 'contractOffers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'order-book-sushi': true
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'order-book-sushi--' + this.displayMode, this.displayMode), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'order-book-sushi--with-title', this.showTitle), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'order-book-sushi--card-layout', this.showCardLayout), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'order-book-sushi--compact-cards', this.showCardLayout && this.compactCards), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'order-book-sushi--scrollable-active', this.hasScrollableContent), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'order-book-sushi--scroll-fade', this.showScrollableFade), _ref;
    },
    contentModifiers: function contentModifiers() {
      return {
        'order-book-sushi__content--cards': this.showCardLayout
      };
    },
    isMobileDisplayMode: function isMobileDisplayMode() {
      return this.displayMode === ORDER_BOOK_DISPLAY_MODES.MOBILE;
    },
    styleVariables: function styleVariables() {
      if (this.displayMode !== ORDER_BOOK_DISPLAY_MODES.MOBILE) return {};
      return {
        '--order-book-scrollable-visible-rows': this.minimumScrollableRows
      };
    },
    minimumScrollableRows: function minimumScrollableRows() {
      if (this.displayMode !== ORDER_BOOK_DISPLAY_MODES.MOBILE) return 0;
      if (this.viewportHeight > 0 && this.viewportHeight <= 700) return 3;
      return 5;
    },
    minimumRowsForCurrentDisplayMode: function minimumRowsForCurrentDisplayMode() {
      if (this.displayMode === ORDER_BOOK_DISPLAY_MODES.MOBILE) {
        return this.minimumScrollableRows;
      }
      if (this.compactCards) {
        return 0;
      }
      return this.defaultMinimumRows;
    },
    isDefaultDisplayMode: function isDefaultDisplayMode() {
      return this.displayMode === ORDER_BOOK_DISPLAY_MODES.DEFAULT;
    },
    showCardLayout: function showCardLayout() {
      return this.isDefaultDisplayMode;
    },
    showCompactCardTitles: function showCompactCardTitles() {
      return this.showCardLayout && this.compactCards && this.isLayoutMobile;
    },
    showUserCards: function showUserCards() {
      return !this.isLayoutMobile || this.isLoggedIn;
    },
    showPricesCard: function showPricesCard() {
      return this.tabVisible(TABS.PRICES);
    },
    showOrdersCard: function showOrdersCard() {
      return this.tabVisible(TABS.ALL_OFFERS) && this.showUserCards;
    },
    showSharesCard: function showSharesCard() {
      return this.tabVisible(TABS.MY_SHARES) && this.showUserCards;
    },
    buyOffers: function buyOffers() {
      if (this.contract.userOpenOrdersBuyQuantity === 0) return [];
      return this.contractOffers ? this.contractOffers.filter(function (c) {
        return c.tradeType <= 1;
      }) : [];
    },
    sellOffers: function sellOffers() {
      if (this.contract.userOpenOrdersSellQuantity === 0) return [];
      return this.contractOffers ? this.contractOffers.filter(function (c) {
        return c.tradeType > 1;
      }) : [];
    },
    tabs: function tabs() {
      var tabsAvailable = [];
      if (this.displayMode === ORDER_BOOK_DISPLAY_MODES.MOBILE) {
        if (!isPricesDisabled(this.market)) {
          tabsAvailable.push({ name: TABS.PRICES, title: 'Orderbook' });
        }
        tabsAvailable.push({ name: TABS.MY_ORDERS, title: 'My Orders' });
        tabsAvailable.push({ name: TABS.MY_SHARES, title: 'Ownership' });
      } else {
        if (!isPricesDisabled(this.market)) {
          tabsAvailable.push({ name: TABS.PRICES, title: 'Orderbook' });
        }
        tabsAvailable.push({ name: TABS.MY_SHARES, title: 'Holdings' });
        tabsAvailable.push({ name: TABS.ALL_OFFERS, title: 'Orders' });
      }
      return tabsAvailable;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('market', ['getMarketContracts']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('trade', ['getContractShares', 'getContractOffers', 'updateOrderBookPeriodically', 'clearOrderBookUpdates', 'getOrderBook', 'setTradeOptions']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;
    },
    updateViewportHeight: function updateViewportHeight() {
      this.viewportHeight = window.visualViewport ? Math.floor(window.visualViewport.height) : window.innerHeight;
      this.$nextTick(this.refreshScrollableTableState);
    },
    cardTitleSideModifiers: function cardTitleSideModifiers(value) {
      return {
        'order-book-sushi__card-title-side': true,
        'order-book-sushi__card-title-side--active': value === this.operationValue
      };
    },
    onCompactOrderBookTitleClick: function onCompactOrderBookTitleClick(operationValue) {
      if (!this.showCompactCardTitles || operationValue === this.operationValue) return;
      this.setTradeOptions({
        contractId: this.contract.contractId,
        operationType: this.operationType,
        operationValue: operationValue
      });
    },
    onScrollableBodyScroll: function onScrollableBodyScroll() {
      this.refreshScrollableTableState();
    },
    refreshScrollableTableState: function refreshScrollableTableState() {
      if (!this.$el) return;

      var scrollableBody = this.$el.querySelector('.order-book-sushi__body--scrollable');
      if (this._scrollableBodyNode !== scrollableBody) {
        if (this._scrollableBodyNode) {
          this._scrollableBodyNode.removeEventListener('scroll', this.onScrollableBodyScroll);
        }
        this._scrollableBodyNode = scrollableBody;
        if (this._scrollableBodyNode) {
          this._scrollableBodyNode.addEventListener('scroll', this.onScrollableBodyScroll, { passive: true });
        }
      }

      if (!this._scrollableBodyNode || !this.isMobileDisplayMode) {
        this.hasScrollableContent = false;
        this.showScrollableFade = false;
        return;
      }

      var canScroll = this._scrollableBodyNode.scrollHeight > this._scrollableBodyNode.clientHeight + 1;
      var atBottom = this._scrollableBodyNode.scrollTop + this._scrollableBodyNode.clientHeight >= this._scrollableBodyNode.scrollHeight - 1;
      var tableNode = this._scrollableBodyNode.closest('.order-book-sushi__table--scrollable');
      var helperNode = this.$el.querySelector('.order-book-sushi__footer-cell--price-links, .order-book-offers-sushi__processed-notice, .order-book-my-orders-sushi__processed-notice');
      var helperBleedsBelow = tableNode && helperNode ? helperNode.getBoundingClientRect().bottom > tableNode.getBoundingClientRect().bottom + 1 : false;
      this.hasScrollableContent = canScroll || helperBleedsBelow;
      this.showScrollableFade = canScroll && !atBottom || helperBleedsBelow;
    },
    tabVisible: function tabVisible(name) {
      if (this.displayMode === ORDER_BOOK_DISPLAY_MODES.MOBILE) {
        return this.activeTab === name;
      }
      var names = this.tabs.map(function (i) {
        return i.name;
      });
      return !!this.orderBook && names.includes(name);
    },
    refreshOrderBook: function refreshOrderBook() {
      if (!this.isLoggedIn) {
        this.isLoading = false;
        return;
      }
      this.debouncedRefreshOrderBook();
    },
    offerCanceled: function offerCanceled() {
      this.isLoading = true;
      this.refreshOrderBook();
      this.getMarketContracts(this.market.marketId);
    }
  }),
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK]: reinit');
    this.debouncedRefreshOrderBook = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      if (!_this2.isLoggedIn) {
        __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK]: api - load contracts and shares (not logged in)');
        _this2.isLoading = false;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK]: api - load contracts and shares (logged in)');
      var currentContractId = _this2.contract.contractId;

      var promises = [];

      if (_this2.contract.userOpenOrdersBuyQuantity > 0 || _this2.contract.userOpenOrdersSellQuantity > 0) {
        __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK] will fetch offers');
        promises.push(_this2.getContractOffers(_this2.contract.contractId));
      } else {
        __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK] should clear offers');
        _this2.getContractOffers(null);
      }

      if (_this2.contract.userQuantity > 0) {
        __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK] will fetch shares');
        promises.push(_this2.getContractShares(_this2.contract.contractId));
      } else {
        __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK] should clear shares');
        _this2.getContractShares(null);
      }

      __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK]: calling api - ' + promises.length + ' promises.');
      if (promises.length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
          __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(ORDER_BOOK_LS_KEY, currentContractId);
          _this2.initialised = true;
          _this2.isLoading = false;
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(ORDER_BOOK_LS_KEY, null);
          _this2.initialised = true;
          _this2.isLoading = false;
        });
      } else {
        _this2.isLoading = false;
        __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(ORDER_BOOK_LS_KEY, currentContractId);
        _this2.initialised = true;
      }
    }, ORDER_BOOK_DEBOUNCE_INTERVAL);

    this.debouncedGetOrderBook = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[ORDER BOOK]: api - load order book');
      _this2.getOrderBook(_this2.contract.contractId);
    }, ORDER_BOOK_DEBOUNCE_INTERVAL);
  },
  mounted: function mounted() {
    var _this3 = this;

    this.isLoading = true;
    window.addEventListener('resize', this.updateViewportHeight);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.updateViewportHeight);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_mutex__["a" /* waitForFirebaseInitialized */])().then(function () {
      if (_this3.isLoggedIn) {
        _this3.debouncedGetOrderBook();
      }
      _this3.updateOrderBookPeriodically(_this3.contract.contractId);
      _this3.refreshOrderBook();
      _this3.$nextTick(_this3.refreshScrollableTableState);
    });
  },
  updated: function updated() {
    this.refreshScrollableTableState();
  },
  beforeDestroy: function beforeDestroy() {
    this.debouncedRefreshOrderBook.cancel();
    this.debouncedGetOrderBook.cancel();
    this.clearOrderBookUpdates(this.contract.contractId);
    window.removeEventListener('resize', this.updateViewportHeight);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.updateViewportHeight);
    }
    if (this._scrollableBodyNode) {
      this._scrollableBodyNode.removeEventListener('scroll', this.onScrollableBodyScroll);
    }
  }
});

/***/ }),

/***/ "NP+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentStoryDetail !== null)?_c('div',{staticClass:"page-story-detail"},[_c('div',{staticClass:"page-story-detail__content"},[_c('div',{key:_vm.refreshIndex,staticClass:"page-story-detail__story"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.storyContent)}}),_vm._v(" "),(_vm.currentStoryDetail.ctaText)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentStoryDetail.ctaText)}}):_vm._e()]),_vm._v(" "),_c('disqus',{attrs:{"disqusId":_vm.currentStoryDetail.disqus_Identifier,"title":_vm.currentStoryDetail.disqus_Title,"auth":_vm.currentStoryDetail.disqus_UserAuth,"url":_vm.currentStoryDetail.disqus_Url,"previous":_vm.currentStoryDetail.disqus_PrevThreadID,"next":_vm.currentStoryDetail.disqus_NextThreadID,"total":_vm.currentStoryDetail.disqus_ArchivedCommentsTotal}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NPa3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_withdraw_confirm_withdraw_confirm_vue__ = __webpack_require__("waMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_available_balance_available_balance_vue__ = __webpack_require__("3PvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_infinite_loading__);


 /* eslint-disable arrow-body-style */














var TOO_MANY_RESULTS = 50;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_loader__["a" /* default */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__["a" /* default */],
    availableBalance: __WEBPACK_IMPORTED_MODULE_6__components_wallet_available_balance_available_balance_vue__["a" /* default */],
    notificationIcon: __WEBPACK_IMPORTED_MODULE_11__components_notification_icon_notification_icon_vue__["a" /* default */],
    withdrawConfirm: __WEBPACK_IMPORTED_MODULE_4__components_wallet_withdraw_confirm_withdraw_confirm_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_14_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      TOO_MANY_RESULTS: TOO_MANY_RESULTS,
      showConfirmation: false,
      showBankInfoForm: false,
      showWithdrawalAmountForm: false,
      showAddressSearch: false,
      isSearching: false,
      hasSearched: false,
      hasSavedAccount: false,
      showIbanValidationInfo: false,
      showIbanValidationForm: false,
      infiniteLoader: null,
      pickedSuggestion: null,
      accountId: null,
      beneficiaryInfo: {},
      error: '',
      query: '',
      disclaimer: '',
      beneficiaryFields: [],
      bankWithdrawAmounts: {
        grossWithdrawalAmount: 0,
        flatFeeAmount: 0,
        percentageFeeAmount: 0,
        totalFees: 0,
        netWithdrawalAmount: 0
      },
      fieldsBankInfoForm: {
        searchBankName: '',
        searchCity: '',
        searchAddress: '',
        bankName: '',
        streetAddress: '',
        city: '',
        zipCode: '',
        region: ''
      },
      fieldsWithdrawalAmountForm: {
        amount: ''
      }
    };
  },
  validations: function validations() {
    if (this.showBankInfoForm) {
      var rules = {};
      this.beneficiaryFields.forEach(function (field) {
        rules = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rules, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field.id, __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["a" /* validators */].customPattern(field.regEx, field.errorMessage)));
      });
      return {
        fieldsBankInfoForm: rules
      };
    }
    return {
      fieldsWithdrawalAmountForm: {
        amount: __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["a" /* validators */].withdrawalAmount(this.minWithdrawal, this.maxWithdrawal)
      }
    };
  },

  watch: {
    suggestions: function suggestions() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.wireSearchResults.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('wallet', ['wire', 'wireSearchResults']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['userData']), {
    beneficiaryFieldsJustFirst: function beneficiaryFieldsJustFirst() {
      return this.beneficiaryFields.slice(0, 1);
    },
    beneficiaryFieldsWithoutFirst: function beneficiaryFieldsWithoutFirst() {
      return this.beneficiaryFields.slice(1, this.beneficiaryFields.length);
    },
    suggestions: function suggestions() {
      return this.wireSearchResults.data === null ? [] : this.wireSearchResults.data;
    },
    suggestionsTotal: function suggestionsTotal() {
      return this.wireSearchResults.data === null ? 0 : this.wireSearchResults.totalCount;
    },
    amountPlaceholder: function amountPlaceholder() {
      return 'Withdrawal Amount (Minimum $' + this.minWithdrawal + ' USD)';
    },
    minWithdrawal: function minWithdrawal() {
      return this.wire ? this.wire.minimumWithdrawalAmount : 0;
    },
    maxWithdrawal: function maxWithdrawal() {
      return this.wire ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["G" /* roundDown */])(this.wire.availableFunds) : 0;
    },
    isAmountFieldDisabled: function isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    availableBalance: function availableBalance() {
      return this.wire && this.wire.availableFundsString ? this.wire.availableFundsString : '$0.00';
    },
    restrictedFunds: function restrictedFunds() {
      return this.wire && this.wire.restrictedFundsString ? this.wire.restrictedFundsString : '';
    },
    errorMessage: function errorMessage() {
      return this.error;
    },
    hasErrorMessage: function hasErrorMessage() {
      return this.error;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getWithdrawWire', 'getWithdrawWireBankSearch', 'postWithdrawWireBankInfo', 'postWithdrawWireConfirm', 'resetWireSearchResults']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.wireSearchResults.canLoadMore) {
        this.loadWireSearch();
      }
    },
    loadWireSearch: function loadWireSearch() {
      var _this = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$reset = _ref.reset,
          reset = _ref$reset === undefined ? false : _ref$reset;

      this.isSearching = true;
      if (reset) {
        this.hasSearched = false;
      }
      this.getWithdrawWireBankSearch({ query: this.query }).then(function (data) {
        if (data.totalResults > TOO_MANY_RESULTS) {
          _this.showAddressSearch = true;
        }
        _this.hasSearched = true;
        _this.isSearching = false;
      }).catch(function () {
        _this.isSearching = false;
        _this.infiniteLoader.complete();
        _this.infiniteLoader = null;
      });
    },
    reviewRequest: function reviewRequest() {
      var _this2 = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          amount: this.fieldsWithdrawalAmountForm.amount,
          accountWireBeneficiaryId: this.beneficiaryInfo.accountWireBeneficiaryId
        };
        this.postWithdrawWireConfirm(payload).then(function (data) {
          _this2.bankWithdrawAmounts = data;
          _this2.showConfirmation = true;
          _this2.loaderRemove(document.body);
          _this2.formEnable();
        }).catch(function (error) {
          _this2.loaderRemove(document.body);
          _this2.formHandleErrors(error);
          _this2.formEnable();
        });
      }
    },
    confirmAccountInfo: function confirmAccountInfo() {
      var _this3 = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {};
        this.beneficiaryFields.forEach(function (field) {
          payload[field.id] = _this3.fieldsBankInfoForm[field.id];
        });
        this.postWithdrawWireBankInfo(payload).then(function (data) {
          _this3.beneficiaryInfo = data.beneficiaryInfo;
          if (data.canWithdraw) {
            _this3.showWithdrawalAmountForm = true;
            _this3.showBankInfoForm = false;
          } else {
            _this3.showIbanValidationInfo = true;
            _this3.showIbanValidationForm = false;
            _this3.showAddressSearch = true;
          }
          _this3.loaderRemove(document.body);
          _this3.formEnable();
        }).catch(function (error) {
          _this3.loaderRemove(document.body);
          _this3.formHandleErrors(error);
          _this3.formEnable();
        });
      }
    },
    confirmBankInfo: function confirmBankInfo() {
      var _this4 = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          bankId: this.pickedSuggestion.id
        };
        this.beneficiaryFields.forEach(function (field) {
          payload[field.id] = _this4.fieldsBankInfoForm[field.id];
        });
        this.postWithdrawWireBankInfo(payload).then(function (data) {
          _this4.beneficiaryInfo = data.beneficiaryInfo;
          _this4.showWithdrawalAmountForm = true;
          _this4.showBankInfoForm = false;
          _this4.loaderRemove(document.body);
          _this4.formEnable();
        }).catch(function (error) {
          _this4.loaderRemove(document.body);
          _this4.formHandleErrors(error);
          _this4.formEnable();
        });
      }
    },
    showSwiftModal: function showSwiftModal() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_SWIFT);
    },
    customFieldsClassModifiers: function customFieldsClassModifiers(field) {
      return {
        column: true,
        'small-6': true,
        'bank-transfer--hidden-column': field.hidden
      };
    },
    suggestionClassModifiers: function suggestionClassModifiers(suggestion) {
      return {
        'bank-transfer__suggestion': true,
        'bank-transfer__suggestion--not-valid': !suggestion.isValid
      };
    },
    onSuggestionPick: function onSuggestionPick(suggestion) {
      if (!suggestion.isValid) return;

      this.hasSearched = false;
      this.fieldsBankInfoForm.bankName = suggestion.name;
      this.fieldsBankInfoForm.streetAddress = suggestion.address1 + ' ' + suggestion.address2;
      this.fieldsBankInfoForm.city = suggestion.city;
      this.fieldsBankInfoForm.region = suggestion.region;
      this.fieldsBankInfoForm.zipCode = suggestion.postalCode;
      this.fieldsBankInfoForm.swiftBicCode = suggestion.swiftCode;
      this.pickedSuggestion = suggestion;
      this.resetWireSearchResults();
    },
    onFieldInput: function onFieldInput(fieldId) {
      var f = this.beneficiaryFields.find(function (i) {
        return i.id === fieldId;
      });
      var vField = this.$v.fieldsBankInfoForm[fieldId];
      vField.errorMessage = (f || {}).errorMessage || '';
      vField.$touch();
    },
    onSearch: function onSearch() {
      var query = this.fieldsBankInfoForm.searchCity + ' ' + this.fieldsBankInfoForm.searchBankName;
      if (this.showAddressSearch) {
        query += ' ' + this.fieldsBankInfoForm.searchAddress;
      }
      if (query && !this.isSearching) {
        this.resetWireSearchResults();
        this.query = query;
        this.loadWireSearch({ reset: true });
      }
    },
    onSuccess: function onSuccess() {
      this.showConfirmation = false;
      this.checkWithdrawBankTransfer();
      this.$emit('success');
    },
    onEdit: function onEdit() {
      this.showConfirmation = false;
    },
    changeBankInformation: function changeBankInformation() {
      this.resetWireSearchResults();
      this.showWithdrawalAmountForm = false;
      this.showBankInfoForm = true;
    },
    onCancel: function onCancel() {
      this.showWithdrawalAmountForm = true;
      this.showBankInfoForm = false;
    },
    checkWithdrawBankTransfer: function checkWithdrawBankTransfer() {
      var _this5 = this;

      this.getWithdrawWire().then(function (data) {
        _this5.checkDocumentUploadFlags(data);
        _this5.disclaimer = data.disclaimer;
        _this5.beneficiaryInfo = data.beneficiaryInfo;
        _this5.beneficiaryFields = (data.beneficiaryFields || []).map(function (field) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, field, {
            value: ''
          });
        });
        _this5.beneficiaryFields.forEach(function (field) {
          _this5.fieldsBankInfoForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this5.fieldsBankInfoForm, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field.id, field.defaultValue || ''));
        });

        _this5.error = data.errorMessage;
        _this5.isComponentReady = true;
        _this5.hasSavedAccount = data.hasSavedAccount;
        _this5.showIbanValidationForm = data.isIbanEnabled && !data.hasSavedAccount;
        _this5.$nextTick(function () {
          if (data.hasSavedAccount) {
            _this5.showWithdrawalAmountForm = true;
          } else {
            _this5.showBankInfoForm = true;
          }
        });
      }).catch(function (error) {
        _this5.isComponentReady = true;
        _this5.error = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.message', '') || __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.errorMessage', '');
      });
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.resetWireSearchResults();
  },
  mounted: function mounted() {
    this.checkWithdrawBankTransfer();
  }
});

/***/ }),

/***/ "NQZ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");


/* eslint-disable arrow-body-style */







var PRICE_LINKS_NOTICE = 'Tap price links for order priority';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  props: {
    scrollable: {
      type: Boolean,
      default: false
    },
    minimumRows: {
      type: Number,
      default: 0
    },
    contract: {
      type: Object,
      required: true
    },
    orderBook: {
      type: Object
    },
    buyOffers: {
      type: Array,
      default: []
    },
    sellOffers: {
      type: Array,
      default: []
    },
    operationValue: {
      type: String,
      default: 'yes',
      validator: function validator(value) {
        return ['no', 'yes'].indexOf(value) >= 0;
      }
    },
    operationType: {
      type: String,
      default: 'buy'
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    cardLayout: {
      type: Boolean,
      default: false
    },
    compactCardLayout: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAll: this.scrollable,
      showAllCut: 5,
      hoveredIndex: null,
      leftPricesUnavailable: true,
      rightPricesUnavailable: true,
      sideActive: 'left'
    };
  },
  created: function created() {
    this.updateShowAll();
  },

  watch: {
    'contract.contractId': {
      handler: function handler() {
        this.updateShowAll();
      }
    },
    orderBook: function orderBook() {
      this.leftPricesUnavailable = true;
      this.rightPricesUnavailable = true;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    isHoverable: function isHoverable() {
      if (!this.contractModel.mode) return true;
      if (this.contractModel.mode === this.tradeOptions.operationValue) return true;
      return this.contractModel.userOpenOrders === 0 && this.contractModel.userQuantity === 0;
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_6__models_contract__["a" /* default */](this.contract);
    },
    classModifiers: function classModifiers() {
      return {
        'order-book-prices-sushi': true,
        'order-book-prices-sushi--card-layout': this.cardLayout,
        'order-book-prices-sushi--compact-card': this.cardLayout && this.compactCardLayout,
        'order-book-prices-sushi--card-empty': this.isCardEmpty,
        'order-book-prices-sushi--scrollable-empty': this.isScrollableEmpty
      };
    },
    tableModifiers: function tableModifiers() {
      return {
        'order-book-sushi__table': true,
        'order-book-sushi__table--scrollable': this.scrollable
      };
    },
    usesStructuredRows: function usesStructuredRows() {
      return this.cardLayout || this.scrollable || this.minimumRows > 0;
    },
    bodyModifiers: function bodyModifiers() {
      return {
        'order-book-sushi__body': true,
        'order-book-sushi__body--scrollable': this.scrollable
      };
    },
    showInlineUnavailableSides: function showInlineUnavailableSides() {
      return this.isLayoutMobile && !this.scrollable && !this.usesStructuredRows;
    },
    leftSideNoOffersModifiers: function leftSideNoOffersModifiers() {
      return {
        'order-book-sushi__side': true,
        'order-book-sushi__unavailable': true,
        'order-book-sushi__unavailable--active': this.sideActive === 'left'
      };
    },
    rightSideNoOffersModifiers: function rightSideNoOffersModifiers() {
      return {
        'order-book-sushi__side': true,
        'order-book-sushi__unavailable': true,
        'order-book-sushi__unavailable--right': true,
        'order-book-sushi__unavailable--active': this.sideActive === 'right'
      };
    },
    leftSideHeaderModifiers: function leftSideHeaderModifiers() {
      return {
        'order-book-sushi__side': !this.usesStructuredRows,
        'order-book-sushi__header-cell': true,
        'order-book-sushi__header-cell--with-avail-matches': true,
        'order-book-sushi__header-cell--active': this.sideActive === 'left'
      };
    },
    rightSideHeaderModifiers: function rightSideHeaderModifiers() {
      return {
        'order-book-sushi__side': !this.usesStructuredRows,
        'order-book-sushi__header-cell': true,
        'order-book-sushi__header-cell--with-avail-matches': true,
        'order-book-sushi__header-cell--active': this.sideActive === 'right'
      };
    },
    isSharesOwned: function isSharesOwned() {
      return this.contract.userQuantity > 0 || this.buyOffers.length > 0;
    },
    operationValueText: function operationValueText() {
      return this.operationValue.charAt(0).toUpperCase() + this.operationValue.slice(1);
    },
    operationTypeLeftText: function operationTypeLeftText() {
      return 'Buy';
    },
    operationTypeRightText: function operationTypeRightText() {
      return 'Sell';
    },
    operationValueRightText: function operationValueRightText() {
      // const opposite = this.operationValue === 'yes' ? 'No' : 'Yes';
      return this.operationValueText;
    },
    pricesGrouped: function pricesGrouped() {
      var _this = this;

      var prices = [];
      var yesOrders = this.orderBook ? this.orderBook.yesOrders || [] : [];
      var noOrders = this.orderBook ? this.orderBook.noOrders || [] : [];

      var leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
      var rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(noOrders));
      var leftField = 'pricePerShare';
      var rightField = 'costPerShareYes';
      var leftOffers = this.sellOffers;
      var rightOffers = this.buyOffers;
      this.sideActive = 'left';

      if (this.isSharesOwned) {
        if (this.operationValue === 'yes' && this.operationType === 'buy' || this.operationType === 'sell' && this.operationValue === 'no') {
          leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
          rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(noOrders));
          leftField = 'pricePerShare';
          rightField = 'costPerShareYes';
          leftOffers = this.sellOffers;
          rightOffers = this.buyOffers;
          if (this.operationType === 'sell') {
            this.sideActive = 'right';
            leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(noOrders));
            rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
            leftOffers = this.sellOffers;
            rightOffers = this.buyOffers;
            leftField = 'pricePerShare';
            rightField = 'costPerShareNo';
          }
        } else {
          leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(noOrders));
          rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
          leftField = 'pricePerShare';
          rightField = 'costPerShareNo';
          leftOffers = this.sellOffers;
          rightOffers = this.buyOffers;
          if (this.operationType === 'sell') {
            this.sideActive = 'right';
            leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
            rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(noOrders));
            leftField = 'pricePerShare';
            rightField = 'costPerShareYes';
            leftOffers = this.sellOffers;
            rightOffers = this.buyOffers;
          }
        }
      } else if (this.operationValue === 'no') {
        rightField = 'costPerShareNo';
        leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(noOrders));
        rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
      }

      var leftOffersField = leftField;
      var rightOffersField = rightField;

      var max = leftPrices.length > rightPrices.length ? leftPrices.length : rightPrices.length;

      var _loop = function _loop(i) {
        if (leftPrices[i]) {
          _this.leftPricesUnavailable = false;
        }
        if (rightPrices[i]) {
          _this.rightPricesUnavailable = false;
        }

        prices.push({
          index: i,
          buyPrice: leftPrices[i] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(leftPrices[i][leftField]) : null,
          buyQuantity: leftPrices[i] ? leftPrices[i].quantity : null,
          buyOwned: leftPrices[i] ? leftOffers.find(function (s) {
            return s.pricePerShare === leftPrices[i][leftOffersField];
          }) !== undefined : false,
          sellPrice: rightPrices[i] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(rightPrices[i][rightField]) : null,
          sellQuantity: rightPrices[i] ? rightPrices[i].quantity : null,
          sellOwned: rightPrices[i] ? rightOffers.find(function (s) {
            return s.pricePerShare === rightPrices[i][rightOffersField];
          }) !== undefined : false
        });
      };

      for (var i = 0; i < max; i += 1) {
        _loop(i);
      }
      return prices;
    },
    pricesOwned: function pricesOwned() {
      return this.pricesGrouped.find(function (item) {
        return item.buyOwned || item.sellOwned;
      });
    },
    showOwnedIndicators: function showOwnedIndicators() {
      return !!this.pricesOwned;
    },
    showOwnedTrayNotice: function showOwnedTrayNotice() {
      return this.scrollable && this.showOwnedIndicators;
    },
    showPriceLinksNotice: function showPriceLinksNotice() {
      return !!this.pricesOwned && !this.scrollable;
    },
    firstItemForActiveSideOwned: function firstItemForActiveSideOwned() {
      var _this2 = this;

      return this.pricesGrouped.find(function (item) {
        return _this2.sideActive === 'right' ? item.sellOwned : item.buyOwned;
      });
    },
    showAllItemsNotice: function showAllItemsNotice() {
      if (this.scrollable) return false;
      return this.pricesGrouped.length > this.showAllCut;
    },
    itemsToDisplay: function itemsToDisplay() {
      return this.showAll ? this.pricesGrouped : this.pricesGrouped.slice(0, this.showAllCut);
    },
    defaultDisplayRows: function defaultDisplayRows() {
      if (this.usesStructuredRows) return [];

      var displayRows = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemsToDisplay));
      if (this.showInlineUnavailableSides && displayRows.length === 0 && (this.leftPricesUnavailable || this.rightPricesUnavailable)) {
        displayRows.push({
          index: 0,
          buyPrice: null,
          buyQuantity: null,
          buyOwned: false,
          sellPrice: null,
          sellQuantity: null,
          sellOwned: false
        });
      }
      return displayRows;
    },
    displayRows: function displayRows() {
      var minimumRows = this.minimumRows;
      if (this.cardLayout && this.compactCardLayout) {
        minimumRows = this.isCardEmpty ? 1 : 0;
      }
      var displayRows = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemsToDisplay));
      var rowCount = Math.max(displayRows.length, minimumRows);

      while (displayRows.length < rowCount) {
        displayRows.push({
          index: displayRows.length,
          buyPrice: null,
          buyQuantity: null,
          buyOwned: false,
          sellPrice: null,
          sellQuantity: null,
          sellOwned: false
        });
      }

      return displayRows;
    },
    isCardEmpty: function isCardEmpty() {
      return this.cardLayout && this.pricesGrouped.length === 0;
    },
    isScrollableEmpty: function isScrollableEmpty() {
      return this.scrollable && this.pricesGrouped.length === 0;
    },
    emptyOverlayText: function emptyOverlayText() {
      return 'New Orderbook.';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['getOrderBookTradeInfo', 'toggleTradeOperation']), {
    getTradeType: function getTradeType(operationType, operationValue) {
      if (operationType === 'buy' && operationValue === 'no') return 0;
      if (operationType === 'buy' && operationValue === 'yes') return 1;
      if (operationType === 'sell' && operationValue === 'no') return 2;
      if (operationType === 'sell' && operationValue === 'yes') return 3;
      return 1;
    },
    onMouseOver: function onMouseOver(index, side) {
      if (!(this.sideActive === side)) return;
      this.hoveredIndex = index;
    },
    onMouseLeave: function onMouseLeave(side) {
      if (!(this.sideActive === side)) return;
      this.hoveredIndex = null;
    },
    sideClassModifiers: function sideClassModifiers(side) {
      return {
        'order-book-sushi__side': true,
        'order-book-sushi__side--active': this.sideActive === side,
        'order-book-sushi__side--inactive': this.sideActive !== side
      };
    },
    shouldShowEmptyState: function shouldShowEmptyState(item, side, index) {
      if (this.isCardEmpty || this.isScrollableEmpty) return false;
      var isUnavailable = side === 'left' ? this.leftPricesUnavailable : this.rightPricesUnavailable;
      var priceKey = side === 'left' ? 'buyPrice' : 'sellPrice';
      return this.usesStructuredRows && index === 0 && isUnavailable && !item[priceKey];
    },
    shouldShowDefaultUnavailableState: function shouldShowDefaultUnavailableState(side, index) {
      if (!this.showInlineUnavailableSides || index !== 0) return false;
      return side === 'left' ? this.leftPricesUnavailable : this.rightPricesUnavailable;
    },
    ownedTooltipText: function ownedTooltipText(owned) {
      return owned && this.showOwnedIndicators ? PRICE_LINKS_NOTICE : null;
    },
    hoverQuantityClassModifier: function hoverQuantityClassModifier(owned, index, side) {
      var isSideActive = this.sideActive === side && this.isHoverable;
      return {
        'order-book-sushi__body-cell--owned': owned,
        'order-book-sushi__body-cell--hovered': isSideActive && this.hoveredIndex === index,
        'order-book-sushi__body-cell--clickable': isSideActive,
        'order-book-sushi__body-cell--inactive': !isSideActive,
        'order-book-prices-sushi__owned-tooltip': owned && this.showOwnedIndicators
      };
    },
    hoverPriceClassModifier: function hoverPriceClassModifier(owned, index, side) {
      var isSideActive = this.sideActive === side && this.isHoverable;
      return {
        'order-book-sushi__body-cell--price': true,
        'order-book-sushi__body-cell--hovered': isSideActive && this.hoveredIndex === index,
        'order-book-sushi__body-cell--clickable': isSideActive,
        'order-book-sushi__body-cell--inactive': !isSideActive
      };
    },
    showTradeInfo: function showTradeInfo(item, operationType, operationValue, side) {
      var _this3 = this;

      var price = side === 'right' ? item.sellPrice : item.buyPrice;
      var payload = {
        tradeType: this.getTradeType(operationType, operationValue),
        contractId: this.contract.contractId,
        price: price
      };
      this.loaderAdd(document.body);
      this.getOrderBookTradeInfo(payload).then(function (data) {
        setTimeout(function () {
          _this3.loaderRemove(document.body);
          _this3.setGenericSmallPopup({
            name: __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_OFFERS_INDICATOR,
            options: {
              items: data,
              operationType: operationType,
              price: price
            }
          });
        }, 400);
      }).catch(function () {
        return _this3.loaderRemove(document.body);
      });
    },
    handleClick: function handleClick(item, isMine, operationType, operationValue, side) {
      if (!isMine && this.firstItemForActiveSideOwned && item.index > this.firstItemForActiveSideOwned.index) {
        return;
      }
      if (isMine) {
        this.showTradeInfo(item, operationType, operationValue, side);
        return;
      }
      var quantity = this.pricesGrouped.slice(0, item.index + 1).reduce(function (prev, curr) {
        return prev + curr.buyQuantity;
      }, 0);
      var price = this.pricesGrouped[item.index].buyPrice;

      if (side === 'right') {
        quantity = this.pricesGrouped.slice(0, item.index + 1).reduce(function (prev, curr) {
          return prev + curr.sellQuantity;
        }, 0);
        price = this.pricesGrouped[item.index].sellPrice;
      }
      if (price === null) return;
      if (operationType === 'sell' && quantity > this.contract.userQuantity) {
        quantity = this.contract.userQuantity;
      }
      this.$emit('click', {
        quantity: quantity,
        price: price
      });
    },
    onClick: function onClick(item, isMine, side) {
      if (this.sideActive === side) {
        this.handleClick(item, isMine, this.operationType, this.operationValue, this.sideActive);
      } else if (isMine) {
        if (side === 'left') {
          this.showTradeInfo(item, this.operationTypeLeftText.toLowerCase(), this.operationValueText.toLowerCase(), side);
        } else {
          this.showTradeInfo(item, this.operationTypeRightText.toLowerCase(), this.operationValueRightText.toLowerCase(), side);
        }
      }
    },
    toggleShowAll: function toggleShowAll() {
      this.showAll = !this.showAll;
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('order_book_prices_show_all_' + this.contract.contractId, this.showAll);
    },
    updateShowAll: function updateShowAll() {
      if (this.scrollable) return;
      this.showAll = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('order_book_prices_show_all_' + this.contract.contractId, false);
    }
  })
});

/***/ }),

/***/ "NSIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_snakeCase__ = __webpack_require__("OAqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_snakeCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_snakeCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__("KgVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_recaptcha__ = __webpack_require__("dSZ5");






 /* eslint-disable no-mixed-operators,object-shorthand,max-len */








var CAPTCHA_FIELD = 'g-recaptcha-response';
var CACHE_NAME = 'register';
var MAX_CHARACTERS_USERNAME_PART = 5;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_9__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      // attempt counter for v2 fallback rerenders
      attempt: 1,
      usernameShowed: false,
      usernameSource: '',
      fieldTypePassword: 'password',
      latestEmail: '',
      fields: {
        email: '',
        emailConfirmation: '',
        password: '',
        username: ''
      },
      timeout: null,
      // Pending payload for v2 fallback retry
      pendingPayload: null
    };
  },

  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].email,
      emailConfirmation: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].emailConfirmation('email'),
      password: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].password,
      username: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].username
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])('popup', ['formDataCache']), {
    showUsername: function showUsername() {
      if (this.usernameShowed) return true;
      var show = !this.$v.fields.email.$invalid && !this.$v.fields.emailConfirmation.$invalid;
      if (show) {
        if (this.fields.username === '') {
          var email = this.fields.email;
          this.usernameSource = __WEBPACK_IMPORTED_MODULE_4_lodash_snakeCase___default()(email.substr(0, email.indexOf('@')));
          this.fields.username = this.suggestUserName();
          this.$v.fields.username.$touch();
          this.tabTo('_', 'password');
          this.usernameShowed = true;
        }
      } else {
        this.fields.username = '';
      }
      return show;
    },
    registerButtonDisabled: function registerButtonDisabled() {
      return this.invalidOrDisabled;
    }
  }),
  watch: {
    'fields.email': function fieldsEmail(value) {
      if (this.latestEmail && value && value !== this.latestEmail && this.formIsValid() && this.errors.length > 0) {
        this.formReset();
      }
    },
    'fields.emailConfirmation': function fieldsEmailConfirmation(value) {
      if (this.latestEmail && value && value !== this.latestEmail && this.formIsValid() && this.errors.length > 0) {
        this.formReset();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('user', ['login', 'register', 'startRegistrationFlow']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'cacheFormData', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {
    showPassword: function showPassword() {
      this.fieldTypePassword = this.fieldTypePassword === 'password' ? 'text' : 'password';
    },
    onLoginFail: function onLoginFail() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    },


    // ========== LOGIN AFTER REGISTRATION ==========
    loginAfterRegistration: function loginAfterRegistration() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _payload, loginV3Token, payload;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Set registration flow flag - 2FA prompt will appear at end of registration flow
                _this.startRegistrationFlow();

                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12__services_recaptcha__["a" /* default */].executeV3('login');

              case 4:
                loginV3Token = _context.sent;
                payload = (_payload = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, CAPTCHA_FIELD, loginV3Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'recaptcha-version', 'v3'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'email', _this.fields.email), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'password', _this.fields.password), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'grant_type', 'password'), _payload);


                _this.login(payload).then(function () {
                  // Close registration modal - app.js will handle showing ACCOUNT_VERIFY/Personal Details
                  _this.setCurrentPopup(null);
                  if (_this.isPage) {
                    _this.$router.push({ name: 'home' });
                  }
                }).catch(function (error) {
                  // Check if v3 failed and v2 challenge is needed
                  if (__WEBPACK_IMPORTED_MODULE_12__services_recaptcha__["a" /* default */].isV3ScoreFailure(error)) {
                    _this.pendingPayload = payload;
                    _this.attempt += 1;
                    _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].RECAPTCHA_CHALLENGE);
                    _this.setCurrentPopupOptions({
                      attempt: _this.attempt,
                      onVerified: _this.onRecaptchaV2VerifiedForLogin
                    });
                    return;
                  }
                  // Other login error - show login modal
                  _this.onLoginFail();
                });
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                // Error getting v3 token for login - fall back to login modal
                _this.formEnable();
                _this.onLoginFail();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    },


    // Called when user completes v2 challenge for login phase
    onRecaptchaV2VerifiedForLogin: function onRecaptchaV2VerifiedForLogin(v2Token) {
      var _extends2,
          _this2 = this;

      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.pendingPayload, (_extends2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, CAPTCHA_FIELD, v2Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'recaptcha-version', 'v2'), _extends2));

      this.login(payload).then(function () {
        _this2.setCurrentPopup(null);
        if (_this2.isPage) {
          _this2.$router.push({ name: 'home' });
        }
      }).catch(function (error) {
        // v2 login failed - redirect to login modal with error
        // Use setCurrentPopupOptions to pass the error to display
        _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
        _this2.setCurrentPopupOptions({
          loginError: error
        });
      });
    },


    // ========== REGISTRATION SUBMIT ==========
    onSubmit: function onSubmit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var v3Token, payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$gtm.trackEvent({
                  event: 'eventTrackerTrigger',
                  category: 'Registration',
                  action: 'submit',
                  label: 'Create Account'
                });

                if (!(_this3.formIsValid() && _this3.formDisable())) {
                  _context2.next = 14;
                  break;
                }

                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__services_recaptcha__["a" /* default */].executeV3('register');

              case 5:
                v3Token = _context2.sent;
                payload = {
                  recaptchaToken: v3Token,
                  recaptchaVersion: 'v3',
                  email: _this3.fields.email,
                  password: _this3.fields.password,
                  username: _this3.fields.username
                };


                _this3.register(payload).then(function () {
                  return _this3.setProfileStatus({ event: 'registered' });
                }).then(function () {
                  return _this3.loginAfterRegistration();
                }).catch(function (e) {
                  // Check if v3 failed and v2 challenge is needed
                  if (__WEBPACK_IMPORTED_MODULE_12__services_recaptcha__["a" /* default */].isV3ScoreFailure(e)) {
                    _this3.pendingPayload = payload;
                    _this3.attempt += 1;
                    _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].RECAPTCHA_CHALLENGE);
                    _this3.setCurrentPopupOptions({
                      attempt: _this3.attempt,
                      onVerified: _this3.onRecaptchaV2VerifiedForRegistration
                    });
                    _this3.formEnable();
                    return;
                  }

                  // Handle other registration errors
                  var data = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(e, 'response.data', []);
                  var errorCodesEmailExist = ['emailAlreadyInUse'];
                  var emailExistsIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(data, function (i) {
                    return i.code && errorCodesEmailExist.includes(i.code);
                  });

                  if (emailExistsIndex !== -1) {
                    _this3.latestEmail = _this3.fields.email;
                    _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ALREADY_EXISTS);
                    _this3.setCurrentPopupOptions({ email: _this3.fields.email });
                  } else {
                    _this3.latestEmail = '';
                  }

                  _this3.attempt += 1;
                  var errorCodesToSuggestUsername = ['restrictedTextInUsername', 'usernameAlreadyInUse'];
                  var isUsernameTakenIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(data, function (i) {
                    return i.code && errorCodesToSuggestUsername.includes(i.code);
                  });

                  if (isUsernameTakenIndex !== -1) {
                    _this3.fields.username = _this3.suggestUserName();
                  }

                  _this3.formEnable();
                  _this3.formHandleErrors(e);
                });
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](2);

                _this3.formEnable();
                _this3.formHandleErrors(_context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 10]]);
      }))();
    },


    // Called when user completes v2 challenge for registration phase
    onRecaptchaV2VerifiedForRegistration: function onRecaptchaV2VerifiedForRegistration(v2Token) {
      var _this4 = this;

      this.formDisable();

      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.pendingPayload, {
        recaptchaToken: v2Token,
        recaptchaVersion: 'v2'
      });

      this.register(payload).then(function () {
        return _this4.setProfileStatus({ event: 'registered' });
      }).then(function () {
        return _this4.loginAfterRegistration();
      }).catch(function (e) {
        // v2 registration failed - show error on registration form
        _this4.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
        _this4.formEnable();
        _this4.formHandleErrors(e);
      });
    },
    showUsernameInfo: function showUsernameInfo() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_USERNAME);
    },
    suggestUserName: function suggestUserName() {
      return '' + this.usernameSource.slice(0, MAX_CHARACTERS_USERNAME_PART) + this.randomNumber();
    },
    randomNumber: function randomNumber() {
      var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;

      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    onTermsAndConditions: function onTermsAndConditions() {
      var termsAndConditionsRoute = 'terms-and-conditions';
      if (this.$router.currentRoute.name === termsAndConditionsRoute) {
        this.setCurrentPopup();
      } else {
        this.$router.push({ name: termsAndConditionsRoute });
      }
    }
  }),
  created: function created() {
    if (this.formDataCache !== null && CACHE_NAME === this.formDataCache.route) {
      this.fields = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fields, this.formDataCache);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cacheFormData(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fields, { route: CACHE_NAME }));
  }
});

/***/ }),

/***/ "NVO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_js__ = __webpack_require__("Wspo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e905900_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_vue__ = __webpack_require__("Npl3");
function injectStyle (ssrContext) {
  __webpack_require__("rF1e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e905900_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NWOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.email,"disabled":_vm.isFormDisabled,"name":"email","type":"email","required":true,"maxLength":50,"validator":"email","autocomplete":"off","gtm":"Registration,Email","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.emailConfirmation,"disabled":_vm.isFormDisabled,"name":"emailConfirmation","type":"email","required":true,"maxLength":50,"validator":"equalTo","equalTo":_vm.fields.email,"autocomplete":"off","gtm":"Registration,Email Confirmation","placeholder":"Confirm Email"},on:{"input":_vm.$v.fields.emailConfirmation.$touch},model:{value:(_vm.fields.emailConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "emailConfirmation", $$v)},expression:"fields.emailConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"account-register__username-wraper"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"name":"nickname","type":"text","required":true,"maxLength":14,"validation":_vm.$v.fields.username,"autocomplete":"off","placeholder":"Username","gtm":"Registration,Username"},on:{"input":_vm.$v.fields.username.$touch},model:{value:(_vm.fields.username),callback:function ($$v) {_vm.$set(_vm.fields, "username", $$v)},expression:"fields.username"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('p',{staticClass:"account-register__disclaimer"},[_vm._v("\n          By clicking \"Create Account\",\n          you confirm that you are at least 18 years of age and have read the "),_c('router-link',{attrs:{"to":{ name: 'terms-and-conditions' }}},[_vm._v("Terms and Conditions")]),_vm._v(".\n        ")],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"label":"Create Account","disabled":_vm.invalidOrDisabled}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new ext_reg_form__title",staticStyle:{"margin-top":"0.5rem"}},[_vm._v("Complete registration with your email")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NXsH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-desktop-grid__menu-filters"},[_c('menu-button',{attrs:{"theme":"sushi-pill","type":"filters","name":_vm.filterMenuName,"active":_vm.filtersOpen,"filtersSelected":_vm.selectedFilters.length > 0},on:{"click":_vm.toggleFilters}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-desktop-grid__menu-timespan"},[_c('menu-button',{attrs:{"type":"timespan","theme":"sushi-pill","name":_vm.selectedTimespan.name,"active":_vm.timespansOpen},on:{"click":_vm.toggleTimespans}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-filters-desktop-grid__menu-order"},[_c('menu-button',{attrs:{"theme":"sushi-pill","type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),_c('div',{staticClass:"market-filters-desktop-grid__menu-title"},[_vm._v("\n      Sort By:\n    ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.ordersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"theme":_vm.theme,"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort)},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.filtersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__filters"},[_c('a',{staticClass:"market-filters-desktop-grid__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-desktop-grid__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"theme":_vm.theme,"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.timespansOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"theme":_vm.theme,"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nd9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_my_markets_js__ = __webpack_require__("S1q9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c38ed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_my_markets_vue__ = __webpack_require__("FwJv");
function injectStyle (ssrContext) {
  __webpack_require__("65ef")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_my_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c38ed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_my_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ng05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NnrL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onContractClick,"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__header"},[_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__image-title",class:{
        'market-contract-horizontal-sushi-common-betslip__image-title--disabled-desktop-market-page': _vm.isLayoutDesktop && _vm.isMarketDisabled && !_vm.forCmsWidget && !_vm.dashboardMode
      }},[(!_vm.isCondensedMobileLayout)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__image",style:(_vm.contractImageStyleModifiers)},[(_vm.showSharesBar)?_c('div',{class:_vm.sharesOwnedStyleModifiers}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__title"},[_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__title-text"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])]),_vm._v(" "),(_vm.isLayoutDesktop || (_vm.isLayoutMobile && !_vm.isMarketDisabled))?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade"},[(_vm.showNoPriceHintTitle)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade-price-title"},[_vm._v("\n          "+_vm._s(_vm.noPriceHintTitle)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade-price",class:{ 'market-contract-horizontal-sushi-common-betslip__last-trade-price--align-right': (_vm.isStandardMobileLayout || _vm.isSimplifiedMobileLayout) }},[(_vm.currentPrice > 0)?[(_vm.contractModel.changePriceAsCents && _vm.isStandardMobileLayout)?_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e(),_vm._v(" "),_c('animated-number',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade-price-value",attrs:{"value":_vm.currentPrice,"symbol":_vm.currentPriceSymbol}}),_vm._v(" "),(_vm.contractModel.changePriceAsCents && !_vm.isStandardMobileLayout)?_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e()]:[(_vm.forCmsWidget)?_c('span',[_vm._v(" ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade-price-new"},[_vm._v("NEW")])]],2)]):_vm._e(),_vm._v(" "),(_vm.isLayoutMobile && _vm.isMarketDisabled && !_vm.forCmsWidget)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__outcome"},[_c('market-disabled-outcome-v2',{attrs:{"market":_vm.market,"contract":_vm.contract}})],1):_vm._e()]),_vm._v(" "),(!_vm.hideButtons)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__ownership-buttons",class:{
        'market-contract-horizontal-sushi-common-betslip__ownership-buttons--disabled': _vm.isMarketDisabled
      }},[(_vm.showSharesBarBottom || (_vm.isLayoutDesktop && _vm.isMarketDisabled))?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__ownership"},[_vm._v("\n          ")]):(_vm.isLayoutMobile && !_vm.isCondensedMobileLayout)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__empty-space"}):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop && _vm.isMarketDisabled)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__outcome"},[_c('market-disabled-outcome-v2',{attrs:{"market":_vm.market,"contract":_vm.contract}})],1):_vm._e(),_vm._v(" "),(!_vm.isMarketDisabled)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__buttons"},[_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__buttons--left"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-no",class:_vm.isButtonActiveClassModifiers(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value)}}},[_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"win":_vm.contractModel.sellYesCostAsCents,"text":"NO"}})],1)]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-yes",class:_vm.isButtonActiveClassModifiers(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value)}}},[_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"win":_vm.contractModel.sellNoCostAsCents,"text":"YES"}})],1)]:[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-yes",class:_vm.isButtonActiveClassModifiers(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value)}}},[_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"win":_vm.contractModel.sellNoCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"text":"YES"}})],1)]],2),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__buttons--right"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--sell-no",class:[_vm.isButtonActiveClassModifiers(_vm.BUTTONS.SELL_NO.id), { 'market-contract-horizontal-sushi-common-betslip__button-single--sell-disabled': _vm.isContractSaleDisabled }],attrs:{"data-tooltip":_vm.isContractSaleDisabled ? _vm.sellDisabledTooltipText : null},on:{"click":function($event){$event.stopPropagation();!_vm.isContractSaleDisabled && _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.SELL_NO.type, _vm.BUTTONS.SELL_NO.value)}}},[_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.sellNoCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"text":"Sell"}})],1)]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--sell-yes",class:[_vm.isButtonActiveClassModifiers(_vm.BUTTONS.SELL_YES.id), { 'market-contract-horizontal-sushi-common-betslip__button-single--sell-disabled': _vm.isContractSaleDisabled }],attrs:{"data-tooltip":_vm.isContractSaleDisabled ? _vm.sellDisabledTooltipText : null},on:{"click":function($event){$event.stopPropagation();!_vm.isContractSaleDisabled && _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.SELL_YES.type, _vm.BUTTONS.SELL_YES.value)}}},[_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.sellYesCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"text":"Sell"}})],1)]:[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-no",class:_vm.isButtonActiveClassModifiers(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value)}}},[_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"win":_vm.contractModel.sellYesCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"text":"NO"}})],1)]],2)]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.showOwnershipAndOrdersSummary)?_c('market-ownership-and-orders-bar',{staticClass:"market-contract-horizontal-sushi-common-betslip__ownership-and-orders",class:{
      'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--condensed': _vm.isCondensedMobileLayout,
      'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--dashboard': _vm.dashboardMode,
      'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--disabled-market-mobile': (_vm.isMarketDisabled && !_vm.dashboardMode && _vm.isLayoutMobile),
      'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--disabled-market-mobile-dashboard': (_vm.isMarketDisabled && _vm.dashboardMode && _vm.isLayoutMobile)

    },attrs:{"contract":_vm.contract,"symbol":_vm.currentPriceSymbol}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Npl3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit"},[(_vm.showTabs)?_c('div',{staticClass:"deposit__tabs"},[_c('tabs',{attrs:{"items":_vm.tabs,"theme":"add-funds"},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"deposit__content"},[(_vm.showCreditCardTab)?_c('add-funds-card',{key:_vm.cardDepositAttempt,attrs:{"mode":"page"},on:{"success":_vm.onAddFundsCardSuccess}}):_vm._e(),_vm._v(" "),(_vm.showCashTab)?_c('add-funds-cash'):_vm._e(),_vm._v(" "),(_vm.showCoinBaseTab)?_c('add-funds-coinbase'):_vm._e(),_vm._v(" "),(_vm.showBankingTab)?_c('add-funds-bank-transfer'):_vm._e(),_vm._v(" "),(_vm.showPendingTab)?_c('pending-requests'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NqVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_socials_js__ = __webpack_require__("/b9a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6a819e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_socials_vue__ = __webpack_require__("iSNB");
function injectStyle (ssrContext) {
  __webpack_require__("irZi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_socials_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6a819e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_socials_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nqth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_extended_betslip_js__ = __webpack_require__("AkHH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc5f15e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_extended_betslip_vue__ = __webpack_require__("XO3j");
function injectStyle (ssrContext) {
  __webpack_require__("I88n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_extended_betslip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc5f15e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_extended_betslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nu5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_content_header_js__ = __webpack_require__("n2FT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7c9832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_header_vue__ = __webpack_require__("Kf7o");
function injectStyle (ssrContext) {
  __webpack_require__("tvM0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_content_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7c9832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NwTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_what_is_new_popup_vue__ = __webpack_require__("g2Bo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3626f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_new_popup_vue__ = __webpack_require__("f084");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_what_is_new_popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3626f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_new_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O43h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_js__ = __webpack_require__("QxUi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cf1014_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__ = __webpack_require__("Mo7C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cf1014_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O4V+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    contract: {
      type: Object,
      required: true
    },
    hideOrdersLabel: {
      type: Boolean,
      default: false
    },
    symbol: {
      type: String,
      default: '&cent;'
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](this.contract);
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'market-ownership-and-orders-bar': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--yes', this.contractModel.mode === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--no', this.contractModel.mode === 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--mobile', this.isLayoutMobile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--without-orders', !this.hasOrders), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--without-ownership', !this.hasOwnership), _ref;
    },
    ownershipClassModifiers: function ownershipClassModifiers() {
      return {
        'market-ownership-and-orders-bar__ownership--yes': this.contractModel.mode === 'yes',
        'market-ownership-and-orders-bar__ownership--no': this.contractModel.mode === 'no'
      };
    },
    hasOwnership: function hasOwnership() {
      return this.contractModel.userQuantity > 0;
    },
    hasOrders: function hasOrders() {
      return this.contractModel.userOpenOrders > 0;
    },
    showOrdersSummary: function showOrdersSummary() {
      return this.hasOrders || this.hasOwnership;
    },
    shouldRender: function shouldRender() {
      return this.hasOwnership || this.hasOrders;
    },
    showOwnershipIcon: function showOwnershipIcon() {
      return this.hasOwnership;
    },
    ownershipQuantityDisplay: function ownershipQuantityDisplay() {
      return Number(this.contractModel.userQuantity || 0).toLocaleString('en-US');
    },
    ownershipModeDisplay: function ownershipModeDisplay() {
      return this.contractModel.mode.toUpperCase();
    },
    ownershipAverage: function ownershipAverage() {
      return this.contractModel.userAveragePricePerShareAsCents;
    },
    ownershipDifference: function ownershipDifference() {
      return this.contractModel.userChangePriceAsCents;
    },
    buyOrdersDisplay: function buyOrdersDisplay() {
      return Number(this.contractModel.userOpenOrdersBuyQuantity || 0).toLocaleString('en-US');
    },
    sellOrdersDisplay: function sellOrdersDisplay() {
      return Number(this.contractModel.userOpenOrdersSellQuantity || 0).toLocaleString('en-US');
    }
  })
});

/***/ }),

/***/ "O4q7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O8vu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_secondary_nav_js__ = __webpack_require__("zV2+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315b2671_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_secondary_nav_vue__ = __webpack_require__("FMYX");
function injectStyle (ssrContext) {
  __webpack_require__("e7+2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_secondary_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315b2671_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_secondary_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OCEH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OCkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending-requests-list-deposit"},[(!_vm.isComponentReady)?[_c('account-withdrawal-loader'),_vm._v(" "),_c('account-withdrawal-loader'),_vm._v(" "),_c('account-withdrawal-loader')]:[_vm._l((_vm.pendingDepositsRequests),function(request,index){return (_vm.pendingDepositsRequests.length > 0)?_c('pending-request-deposit',{key:index,staticClass:"pending-requests-list-deposit__item",attrs:{"request":request}}):_vm._e()}),_vm._v(" "),(_vm.pendingDepositsRequests.length === 0)?_c('alert-box',{staticClass:"pending-requests-list-deposit__alert-box",attrs:{"level":"info"}},[_vm._v("\n      You have no deposits pending.\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OFB4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OFlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"election-map-table"},[_c('div',{staticClass:"election-map-table__title"},[_vm._v("\n    Split Electoral Votes\n  ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"election-map-table__row"},[_c('div',{staticClass:"election-map-table__row-legend"},[_vm._v("\n      NE\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-state",style:(_vm.neStyleModifiers)},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district"},[_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne1StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne2StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne3StyleModifiers)},[_vm._v("1")])])]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row"},[_c('div',{staticClass:"election-map-table__row-legend"},[_vm._v("\n      ME\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-state",style:(_vm.meStyleModifiers)},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district"},[_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me1StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me2StyleModifiers)},[_vm._v("1")]),_vm._v(" "),(false)?_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me3StyleModifiers)},[_vm._v("x")]):_vm._e()])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"election-map-table__header"},[_c('div',{staticClass:"election-map-table__header-state"},[_c('div',[_vm._v("\n        State\n      ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-table__header-district"},[_c('div',{staticClass:"election-map-table__header-district-header"},[_vm._v("\n        District\n      ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__header-district-num"},[_c('div',[_vm._v("1")]),_vm._v(" "),_c('div',[_vm._v("2")]),_vm._v(" "),_c('div',[_vm._v("3")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OGIm":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "OHuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_appNotification__ = __webpack_require__("qtti");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_appNotification__["a" /* default */]],
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']))
});

/***/ }),

/***/ "OIiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_show_password_icon_js__ = __webpack_require__("UKGl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6993cd77_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_password_icon_vue__ = __webpack_require__("P764");
function injectStyle (ssrContext) {
  __webpack_require__("6ALX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_show_password_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6993cd77_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_password_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OIwd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "OJH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AVAILABLE_TIMESPANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_TIMESPANS; });
/* unused harmony export DEFAULT_TIMESPANS_MARKETS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORDERS_WITH_TIMESPAN_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIMESPANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectTimespan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);




var AVAILABLE_TIMESPANS = {
  TODAY: {
    parameter: 'TODAY',
    name: 'Today'
  },
  '3DAY': {
    parameter: '3DAY',
    name: '3 Days'
  },
  WEEK: {
    parameter: 'WEEK',
    name: 'Week'
  },
  MONTH: {
    parameter: 'MONTH',
    name: 'Month'
  },
  ALL: {
    parameter: 'ALL',
    name: 'All Time'
  },
  EMPTY: {
    parameter: '',
    name: ''
  }
};

var DEFAULT_TIMESPANS = {
  movers: AVAILABLE_TIMESPANS.TODAY,
  traded: AVAILABLE_TIMESPANS.ALL
};

var DEFAULT_TIMESPANS_MARKETS = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_TIMESPANS, {
  traded: AVAILABLE_TIMESPANS.TODAY
});

var ORDERS = [{
  name: 'Volume',
  fullName: 'Trade Volume',
  sort: 'traded'
}, {
  name: 'Price',
  fullName: 'Price Change',
  sort: 'movers'
}, {
  name: 'New Arrivals',
  fullName: 'New Arrivals',
  sort: 'newest'
}, {
  name: 'Expiring',
  fullName: 'Expiring',
  sort: 'closing'
}, {
  name: 'Investment',
  fullName: 'Investment',
  sort: 'investment'
}, {
  name: 'Gain',
  fullName: 'Gain',
  sort: 'gain'
}, {
  name: 'Loss',
  fullName: 'Loss',
  sort: 'loss'
}];

var ORDERS_WITH_TIMESPAN_FILTER = ['movers', 'traded'];

var TIMESPANS = [AVAILABLE_TIMESPANS.TODAY, AVAILABLE_TIMESPANS['3DAY'], AVAILABLE_TIMESPANS.WEEK, AVAILABLE_TIMESPANS.MONTH, AVAILABLE_TIMESPANS.ALL];

var selectTimespan = function selectTimespan(state, parameter) {
  state.selectedTimespan = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(state.timespans, { parameter: parameter });
};

var selectOrder = function selectOrder(state, sort) {
  state.selectedOrder = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(state.orders, { sort: sort });
  state.selectedTimespan = DEFAULT_TIMESPANS_MARKETS[sort] || AVAILABLE_TIMESPANS.EMPTY;
  state.shouldShowTimespanFilter = ORDERS_WITH_TIMESPAN_FILTER.indexOf(state.selectedOrder.sort) !== -1;
};

/***/ }),

/***/ "OKKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_range_slider_js__ = __webpack_require__("AkE8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f24406ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_slider_vue__ = __webpack_require__("IpFs");
function injectStyle (ssrContext) {
  __webpack_require__("ZrIF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_range_slider_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f24406ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OL8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_bar_js__ = __webpack_require__("2SRW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d09dc47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_bar_vue__ = __webpack_require__("mTzD");
function injectStyle (ssrContext) {
  __webpack_require__("QM0A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d09dc47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OLUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_price_change_chart_market_price_change_chart_vue__ = __webpack_require__("ptZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketPriceChangeChart: __WEBPACK_IMPORTED_MODULE_2__components_market_market_price_change_chart_market_price_change_chart_vue__["a" /* default */]
  },
  props: {
    promo: {
      type: Object
    },
    header: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    contract: function contract() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.promo);
    },
    hasLastTradePrice: function hasLastTradePrice() {
      return this.contract.hasLastTradePrice;
    },
    iconModifiers: function iconModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-biggest-gains-element__icon': true
      }, 'market-biggest-gains-element__icon--' + this.iconTargetClass, this.iconTargetClass);
    },
    iconTargetClass: function iconTargetClass() {
      return this.promo.isGain ? 'price-up' : 'price-down';
    }
  }
});

/***/ }),

/***/ "OMZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input",class:_vm.inputModifiers,attrs:{"title":_vm.errorMessage}},[_c('label',{staticClass:"input__label",attrs:{"for":_vm.name}},[(_vm.placeholder)?_c('div',{staticClass:"input__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasIcon)?_c('div',{staticClass:"input__icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('input',{staticClass:"input__value",style:(_vm.inputStyleModifiers),attrs:{"tabindex":_vm.tabindex,"type":_vm.type,"autocomplete":_vm.autocomplete,"disabled":_vm.disabled,"name":_vm.name,"id":_vm.name,"required":_vm.required,"maxlength":_vm.maxLength,"max":_vm.max,"min":_vm.min},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})]),_vm._v(" "),(_vm.showValidationWithin)?[(_vm.error)?_c('div',{staticClass:"input__validation-message"},[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.successTick)?_c('div',{staticClass:"input__success-tick"}):_vm._e()]:_vm._e()],2),_vm._v(" "),(!_vm.showValidationWithin)?[(_vm.error)?_c('div',{staticClass:"input__validation-message input__validation-message--outer"},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OOZ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ORlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notifications_list_notifications_list_vue__ = __webpack_require__("R/N+");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    notificationsList: __WEBPACK_IMPORTED_MODULE_2__components_notifications_list_notifications_list_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['closeNotificationsWidget']), {
    onClickOutside: function onClickOutside() {
      this.closeNotificationsWidget();
    }
  })
});

/***/ }),

/***/ "OSiv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OUji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__ = __webpack_require__("5y3J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ceac93e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("A6L0");
function injectStyle (ssrContext) {
  __webpack_require__("b34n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ceac93e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OZE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"affiliations-popup",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"affiliations-popup__note"},[_vm._v("\n    We are adding new social features to PredictIt and would like to know a little more about you. Are you a student, teacher, staff or alumnus/alumna at an accredited college or university?\n  ")]),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__form"},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-6"},[_c('form-radio',{staticClass:"affiliations-popup__radio",attrs:{"name":"accountType","label":"Yes","checked":_vm.fields.agreed === 'yes',"value":"yes"},model:{value:(_vm.fields.agreed),callback:function ($$v) {_vm.$set(_vm.fields, "agreed", $$v)},expression:"fields.agreed"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-radio',{staticClass:"affiliations-popup__radio",attrs:{"name":"accountType","label":"No","checked":_vm.fields.agreed === 'no',"value":"no"},model:{value:(_vm.fields.agreed),callback:function ($$v) {_vm.$set(_vm.fields, "agreed", $$v)},expression:"fields.agreed"}})],1),_vm._v(" "),(_vm.fields.agreed === 'yes')?[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"affiliations-popup__autosuggest"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("\n              (Optional) Please tell us your university or college affiliation\n            ")]),_vm._v(" "),_c('vue-autosuggest',{ref:"autosuggest",attrs:{"suggestions":_vm.suggestions,"input-props":{id:'autosuggest__input', placeholder:'Search...'}},on:{"input":_vm.onInputChange,"selected":_vm.onSelected},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var suggestion = ref.suggestion;
return _c('div',{staticClass:"affiliations-popup__result-item",on:{"mousedown":function($event){return _vm.onMouseDown(suggestion)},"click":function($event){return _vm.onClick(suggestion)}}},[_c('span',{staticClass:"my-suggestion-item"},[_vm._v("\n                "+_vm._s(suggestion.item.name)+"\n              ")])])}}],null,false,3223706583),model:{value:(_vm.fields.query),callback:function ($$v) {_vm.$set(_vm.fields, "query", $$v)},expression:"fields.query"}})],1)])]:_vm._e()],2)]),_vm._v(" "),(_vm.fields.agreed === 'yes')?_c('div',{staticClass:"affiliations-popup__universities-container"},[(_vm.universities.length > 0)?_c('div',{staticClass:"affiliations-popup__universities"},_vm._l((_vm.universities),function(item){return _c('div',{key:item.key,staticClass:"affiliations-popup__university"},[_c('div',{staticClass:"affiliations-popup__university-name"},[(item.id === -1)?[_c('form-input',{attrs:{"maxLength":100,"theme":"affiliation","type":"text","name":"text","label":""},model:{value:(item.name),callback:function ($$v) {_vm.$set(item, "name", $$v)},expression:"item.name"}})]:[_vm._v("\n            "+_vm._s(item.name)+"\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__university-option",attrs:{"title":"This will keep it in your profile and still allow you to participate in markets, but not allow other users to view it."}},[_c('form-checkbox',{staticClass:"checkbox--no-margin",attrs:{"small":true,"name":_vm.getKey(),"label":"Hidden"},model:{value:(item.isHidden),callback:function ($$v) {_vm.$set(item, "isHidden", $$v)},expression:"item.isHidden"}})],1),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__university-icon",on:{"click":function($event){return _vm.onRemove(item)}}})])}),0):_vm._e(),_vm._v(" "),(_vm.showOtherSchoolNote)?_c('div',{staticClass:"affiliations-popup__note affiliations-popup__note--other"},[_vm._v("\n      We will save your school as Pending Approval and we periodically review and add schools. If you have questions about the process please contact PredictIt Support.\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__note affiliations-popup__note--bottom"},[_c('span',{staticClass:"affiliations-popup__note-title",on:{"click":function($event){_vm.showExplanation = !_vm.showExplanation}}},[_vm._v("\n        About Your Profile\n      ")]),_vm._v(" "),_c('transition',{attrs:{"name":"affiliations-popup"}},[(_vm.showExplanation)?_c('div',[_vm._v("\n          To make PredictIt more fun and social in the future we will allow traders to share information from their profiles. If there is anything you would rather keep private you can always mark it as hidden. On your profile pages hidden items are still shown but include an asterisk (*) to let you know they are hidden from other users.\n        ")]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__submit"},[_c('form-submit',{attrs:{"label":_vm.buttonText,"disabled":_vm.isConfirmDisabled}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OdBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_switch_js__ = __webpack_require__("n0gu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb58763_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_switch_vue__ = __webpack_require__("Ge07");
function injectStyle (ssrContext) {
  __webpack_require__("ZdYx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_switch_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb58763_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OeKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['settingShowOdds']), {
    buttonText: function buttonText() {
      return this.settingShowOdds ? 'Show Last Trade Price' : 'Show Implied Odds of Winning';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingShowOdds']), {
    onShowOdds: function onShowOdds() {
      this.setSettingShowOdds(true);
    },
    onDontShowOdds: function onDontShowOdds() {
      this.setSettingShowOdds(false);
    },
    onToggle: function onToggle() {
      if (this.settingShowOdds) {
        this.setSettingShowOdds(false);
      } else {
        this.setSettingShowOdds(true);
      }
    }
  })
});

/***/ }),

/***/ "OfZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMarkets: function getMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=' + page + '&filterIds=&sort=newest');
  }
});

/***/ }),

/***/ "OmlY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-social-auth"},[_c('div',{staticClass:"account-social-auth__spinner"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oota":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlay', ['visible']), {
    classObject: function classObject() {
      return { 'overlay--visible': this.visible };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', ['hide']))
});

/***/ }),

/***/ "OoyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    market: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: ''
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    showMarketLink: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    userGainLoss: function userGainLoss() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["J" /* marketUserGainLoss */])(this.market);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["h" /* roundToTwo */])(value) === 0 ? 0 : value;
    },
    isAllPayoutsAvailable: function isAllPayoutsAvailable() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    gainIndicatorClassModifier: function gainIndicatorClassModifier() {
      return {
        'market-payout-sushi__gain': true,
        'market-payout-sushi__going-down': !this.userGainLoss
      };
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-payout-sushi': true
      }, 'market-payout-sushi--' + this.theme, this.theme);
    },
    gainLossLabel: function gainLossLabel() {
      if (this.userGainLoss > 0) {
        return 'Gain';
      }

      return this.userGainLoss < 0 ? 'Loss' : 'Gain/Loss';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericPopup']), {
    allPayouts: function allPayouts() {
      // because there is no routing for modals
      this.setGenericPopup({
        name: __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].POTENTIAL_PAYOUTS,
        options: {
          market: this.market
        }
      });
    }
  })
});

/***/ }),

/***/ "OprK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");


 /* eslint-disable no-restricted-syntax,consistent-return */






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ready: false,
      showTooltip: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['mapStateDataSenate', 'marketMapTooltipVisible']), {
    ga2MarketData: function ga2MarketData() {
      return this.mapStateDataSenate.GA2 || {};
    },
    classModifiers: function classModifiers() {
      return {
        'election-map-special': true,
        'election-map-special--tooltip-visible': this.marketMapTooltipVisible
      };
    },
    legendStyleModifiers: function legendStyleModifiers() {
      return {
        background: this.color
      };
    },
    color: function color() {
      return this.pallette.color;
    },
    targetContract: function targetContract() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getLeadingTradedContract */])(this.ga2MarketData.contracts || []);
    },
    targetContractInstance: function targetContractInstance() {
      return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](this.targetContract || {});
    },
    pallette: function pallette() {
      if (!this.targetContract) {
        return __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY[1];
      }

      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(this.targetContract.contractName);
      var factor = pallette[0].from + this.targetContract.lastTradePrice;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pallette), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (factor <= item.to) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return pallette[pallette.length - 1];
    }
  }),
  watch: {
    mapStateDataSenate: {
      handler: 'mapStateDataHandler',
      immediate: true
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.isLayoutMobile) {
        var marketId = this.ga2MarketData.marketId;
        if (marketId) {
          window.location.href = 'https://www.predictit.org/markets/detail/' + marketId;
        }
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.showTooltip = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.showTooltip = false;
    },
    mapStateDataHandler: function mapStateDataHandler(value) {
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(value)) {
        this.ready = true;
      }
    }
  }
});

/***/ }),

/***/ "OqUx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"filter-button",class:_vm.buttonModifier,on:{"click":_vm.toggleFilter}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oz+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_detail_charts_checkbox_checkbox_vue__ = __webpack_require__("OUji");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_market_market_detail_charts_checkbox_checkbox_vue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  props: {
    contracts: {
      type: Array,
      required: true
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      showNavigationArrows: false,
      canScrollLeft: false,
      canScrollRight: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['chartType']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    swiperOption: function swiperOption() {
      var self = this;
      return {
        slidesPerView: this.isLayoutDesktop ? 6 : 2.5,
        freeMode: true,
        watchOverflow: true,
        spaceBetween: 10,
        roundLengths: true,
        onInit: function onInit(swiper) {
          self.updateNavigationState(swiper);
        },
        onTransitionEnd: function onTransitionEnd(swiper) {
          self.updateNavigationState(swiper);
        },
        onReachBeginning: function onReachBeginning() {
          self.canScrollLeft = false;
        },
        onReachEnd: function onReachEnd() {
          self.canScrollRight = false;
        }
      };
    },
    showImage: function showImage() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'showContractImagesOnLegend', false);
    }
  }),
  methods: {
    updateNavigationState: function updateNavigationState(swiperInst) {
      var inst = swiperInst || this.$refs.swiper && this.$refs.swiper.swiper;
      if (inst) {
        // In older versions, isLocked might not be available; we check if container is scrollable
        this.showNavigationArrows = inst.slides.length > inst.params.slidesPerView;
        this.canScrollLeft = !inst.isBeginning;
        this.canScrollRight = !inst.isEnd;
      }
    },
    scrollLeft: function scrollLeft() {
      this.$refs.swiper.swiper.slidePrev();
    },
    scrollRight: function scrollRight() {
      this.$refs.swiper.swiper.slideNext();
    },
    contractName: function contractName(item) {
      var regionUUID = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'regionUUID', null);
      if (regionUUID !== null) {
        return 'checkbox-' + regionUUID + '-' + item.contractName + '-' + item.marketId + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["t" /* uuidv4 */])();
      }
      return 'checkbox-' + item.contractName + '-' + item.marketId + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["t" /* uuidv4 */])();
    },
    imageStyleModifiers: function imageStyleModifiers(item) {
      return {
        'border-color': item.lineColor,
        'background-image': 'url(' + item.contractImageSmallUrl + ')'
      };
    },
    onChange: function onChange(item, checked) {
      this.$emit('toggleItem', item, checked);
    },
    checkboxColor: function checkboxColor(item) {
      return item.additional ? item.additionalLineColor : item.lineColor;
    }
  }
});

/***/ }),

/***/ "P0TV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onContractClick,"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_c('div',{staticClass:"market-contract-horizontal-sushi__header"},[_c('div',{staticClass:"market-contract-horizontal-sushi__image-title"},[_c('div',{staticClass:"market-contract-horizontal-sushi__image",style:(_vm.contractImageStyleModifiers)},[(_vm.showSharesBar)?_c('div',{class:_vm.sharesOwnedStyleModifiers}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__title"},[_c('div',{staticClass:"market-contract-horizontal-sushi__title-text"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__ownership-buttons"},[(_vm.dashboardMode && _vm.useDesktopLayout)?_c('div',{staticClass:"market-contract-horizontal-sushi__middle-columns"},[(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contract-horizontal-sushi__type"},[_vm._v("\n            "+_vm._s(_vm.contractModel.mode === 'no' ? 'NO' : 'YES')+"\n          ")])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade"},[_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price"},[(_vm.currentPriceDashboard > 0)?[_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value-col"},[_c('animated-number',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value",attrs:{"value":_vm.currentPriceDashboard,"symbol":_vm.currentPriceSymbol}})],1),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-change-col"},[(_vm.contractModel.changePriceAsCents && _vm.useDesktopLayout)?_c('market-change-price',{attrs:{"price":_vm.contractModel.mode === 'no' ? -_vm.contractModel.changePriceAsCents : _vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e()],1)]:_c('span',{staticClass:"market-contract-horizontal-sushi__last-trade-price-new"},[_vm._v("NEW")])],2)]),_vm._v(" "),(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contract-horizontal-sushi__volume"},[_c('div',{staticClass:"market-contract-horizontal-sushi__volume-value"},[(_vm.contract.userQuantity > 0)?_c('div',[_vm._v(_vm._s(_vm.volumeDisplay))]):_c('div',{staticClass:"market-dash-symbol"},[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__avg-paid"},[(_vm.contract.userQuantity === 0)?_c('div',{staticClass:"market-dash-symbol"},[_vm._v("-")]):[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.userAveragePricePerShareAsCents),expression:"contractModel.userAveragePricePerShareAsCents",modifiers:{"cents":true}}]}),_vm._v(" "),(_vm.contractModel.userChangePriceAsCents)?_c('market-change-price',{attrs:{"price":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}}):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__buy-orders\n            market-contract-horizontal-sushi__tooltip",attrs:{"data-tooltip":_vm.buyOrdersTooltip}},[(_vm.contractModel.userOpenOrdersBuyQuantity > 0)?_c('div',[_vm._v(_vm._s(_vm.buyOrdersDisplay))]):_c('div',{staticClass:"market-dash-symbol"},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__sell-orders\n            market-contract-horizontal-sushi__tooltip",attrs:{"data-tooltip":_vm.sellOrdersTooltip}},[(_vm.contractModel.userOpenOrdersSellQuantity > 0)?_c('div',[_vm._v(_vm._s(_vm.sellOrdersDisplay))]):_c('div',{staticClass:"market-dash-symbol"},[_vm._v("-")])])]:_vm._e()],2):[_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade"},[_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price"},[(_vm.currentPrice > 0)?[(_vm.contractModel.changePriceAsCents && _vm.isLayoutMobile)?_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value-col"},[_c('animated-number',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value",attrs:{"value":_vm.currentPrice,"symbol":_vm.currentPriceSymbol}})],1),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-change-col"},[(_vm.contractModel.changePriceAsCents && _vm.useDesktopLayout)?_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e()],1)]:[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-change-col"},[_vm._v("\n                 \n              ")])]],2)]),_vm._v(" "),(_vm.showSharesBar)?_c('div',{staticClass:"market-contract-horizontal-sushi__ownership"},[_c('market-shares-ownership',{attrs:{"mode":_vm.contractModel.mode,"number":_vm.contract.userQuantity},on:{"click":_vm.onClickSharesBar}})],1):(_vm.useDesktopLayout && !_vm.forCmsWidget)?_c('div',{staticClass:"market-contract-horizontal-sushi__volume"},[_vm._m(1)]):(_vm.useMobileLayout && _vm.isTradingEnabled)?_c('div',{staticClass:"market-contract-horizontal-sushi__empty-space"}):_vm._e(),_vm._v(" "),(_vm.useDesktopLayout && !_vm.forCmsWidget)?_c('div',{staticClass:"market-contract-horizontal-sushi__avg-paid"},[(_vm.contract.userQuantity === 0)?_c('span',{staticClass:"market-dash-symbol"},[_vm._v("-")]):[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.userAveragePricePerShareAsCents),expression:"contractModel.userAveragePricePerShareAsCents",modifiers:{"cents":true}}]}),_vm._v(" "),(_vm.contractModel.userChangePriceAsCents)?_c('market-change-price',{attrs:{"price":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.useDesktopLayout && !_vm.forCmsWidget)?_c('div',{staticClass:"market-contract-horizontal-sushi__orders"},[_c('market-contract-horizontal-sushi-orders',{attrs:{"buyQuantity":_vm.contractModel.userOpenOrdersBuyQuantity,"sellQuantity":_vm.contractModel.userOpenOrdersSellQuantity,"mode":_vm.contractModel.mode}})],1):_vm._e()],_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__buttons"},[(_vm.isMarketDisabled && !_vm.forCmsWidget)?[_c('market-disabled-outcome-v2',{attrs:{"market":_vm.market,"contract":_vm.contract}})]:[_c('div',{staticClass:"market-contract-horizontal-sushi__buttons--left"},[(_vm.forCmsWidget)?_c('market-button-direction',{attrs:{"variant":"buy-yes","price":_vm.contractModel.buyYesCostAsCents,"text":"YES","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_YES.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value, _vm.BUTTONS.BUY_YES.id)}}}):(_vm.contractModel.mode === _vm.VALUES.NO)?_c('market-button-direction',{attrs:{"variant":"buy-no","price":_vm.contractModel.buyNoCostAsCents,"text":"NO","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_NO.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, _vm.BUTTONS.BUY_NO.id)}}}):_c('market-button-direction',{attrs:{"variant":"buy-yes","price":_vm.contractModel.buyYesCostAsCents,"text":"YES","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_YES.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value, _vm.BUTTONS.BUY_YES.id)}}})],1),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__buttons--right"},[(_vm.forCmsWidget)?_c('market-button-direction',{attrs:{"variant":"buy-no","price":_vm.contractModel.buyNoCostAsCents,"text":"NO","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_NO.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, _vm.BUTTONS.BUY_NO.id)}}}):(_vm.contractModel.mode === _vm.VALUES.NO)?_c('market-button-direction',{attrs:{"variant":"sell-no","price":_vm.contractModel.sellNoCostAsCents,"text":"Sell","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.SELL_NO.id,"operationValue":_vm.tradeOptions.operationValue,"saleDisabled":_vm.contractModel.userQuantity === 0},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.SELL_NO.type, _vm.BUTTONS.SELL_NO.value, _vm.BUTTONS.SELL_NO.id)}}}):(_vm.contractModel.mode === _vm.VALUES.YES)?_c('market-button-direction',{attrs:{"variant":"sell-yes","price":_vm.contractModel.sellYesCostAsCents,"text":"Sell","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.SELL_YES.id,"operationValue":_vm.tradeOptions.operationValue,"saleDisabled":_vm.contractModel.userQuantity === 0},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.SELL_YES.type, _vm.BUTTONS.SELL_YES.value, _vm.BUTTONS.SELL_YES.id)}}}):_c('market-button-direction',{attrs:{"variant":"buy-no","price":_vm.contractModel.buyNoCostAsCents,"text":"NO","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_NO.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, _vm.BUTTONS.BUY_NO.id)}}})],1)]],2)],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value-col"},[_c('span',{staticClass:"market-contract-horizontal-sushi__last-trade-price-new"},[_vm._v("NEW")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-horizontal-sushi__volume-value"},[_c('span',{staticClass:"market-dash-symbol"},[_vm._v("-")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P26B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-chart-loader"},[_c('div',{staticClass:"market-chart-loader__sine-wave"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__content"},[_c('div',{staticClass:"market-chart-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-2"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-3"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-4"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-5"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-6"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-7"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-8"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-9"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-10"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P3fZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


var CURRENCY_CENTS = '&cent;';
var CURRENCY_DOLLARS = '$';

function setPrice(el, binding) {
  var sourcePrice = binding.value || 0;
  var absolutePrice = Math.abs(sourcePrice);
  if (binding.modifiers.round2) {
    absolutePrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["h" /* roundToTwo */])(absolutePrice);
  }
  var currency = binding.modifiers.cents ? CURRENCY_CENTS : CURRENCY_DOLLARS;
  // Display 100cents as $1
  if (absolutePrice === 100 && currency === CURRENCY_CENTS) {
    currency = CURRENCY_DOLLARS;
    absolutePrice = 1;
  }
  var formattedPrice = absolutePrice;
  if (binding.modifiers.floor) {
    absolutePrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["G" /* roundDown */])(absolutePrice);
  }
  if (binding.modifiers.fixed) {
    formattedPrice = absolutePrice.toFixed(2);
  }
  if (binding.modifiers.fixed3) {
    formattedPrice = absolutePrice.toFixed(3);
  }
  if (binding.modifiers.fixedflex) {
    formattedPrice = absolutePrice > 1000 ? absolutePrice.toFixed(0) : absolutePrice.toFixed(2);
  }
  var p = formattedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  var text = currency === CURRENCY_CENTS ? '' + p + currency : '' + currency + p;
  el.innerHTML = sourcePrice >= 0 ? text : '(' + text + ')';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setPrice(el, binding);
  },
  update: function update(el, binding) {
    setPrice(el, binding);
  }
});

/***/ }),

/***/ "P3oX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("8/3H");

/* eslint-disable no-console */







var ERROR_STATUS_CODES = [500, 501, 502, 503, 504];
var UNAUTHORIZED_STATUS_CODE = 401;

var refreshSubscribers = [];
var isRefreshing = false;

function tokenRefreshSubscribe(cb) {
  refreshSubscribers.push(cb);
}

function tokenRefreshComplete(token) {
  refreshSubscribers.map(function (cb) {
    return cb(token);
  });
  refreshSubscribers = [];
}

/* harmony default export */ __webpack_exports__["a"] = (function (error) {
  if (!error.response) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  var config = error.config,
      status = error.response.status;

  var originalRequest = config;

  // Skip token refresh for 2FA login endpoints - they use a different token mechanism
  var isTwoFactorLoginEndpoint = config.url && (config.url.includes('TwoFactor/SendCode') || config.url.includes('TwoFactor/Verify'));
  var hasRefreshToken = !!__WEBPACK_IMPORTED_MODULE_4__helpers_localStorage__["a" /* default */].get('refreshToken', null);

  if (status === UNAUTHORIZED_STATUS_CODE && !isTwoFactorLoginEndpoint && hasRefreshToken) {
    __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[TOKEN] Unauthorized');
    if (!isRefreshing) {
      isRefreshing = true;
      var payload = {
        grant_type: 'refresh_token',
        refresh_token: __WEBPACK_IMPORTED_MODULE_4__helpers_localStorage__["a" /* default */].get('refreshToken')
      };
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('user/login', payload).then(function () {
        isRefreshing = false;
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[TOKEN] REFRESHED');
        tokenRefreshComplete(__WEBPACK_IMPORTED_MODULE_4__helpers_localStorage__["a" /* default */].get('token'));
      }).catch(function () {
        isRefreshing = false;
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[TOKEN] CANNOT REFRESH');
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('user/clearAuthSession');
        tokenRefreshComplete(null);
      });
    }

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      tokenRefreshSubscribe(function (token) {
        if (!token) {
          reject(error);
          return;
        }
        originalRequest.headers.Authorization = 'Bearer ' + token;
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[TOKEN] Retry');
        resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(originalRequest));
      });
    });
  }

  if (error.response) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* checkResponseForApiGoingOffline */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* checkResponseForMaintenance */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* checkResponseForTaxInfo */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* checkResponseForDocumentUpload */])(error.response);
    __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error('API - ERROR', error.response.status, error.response.config.url);
    if (ERROR_STATUS_CODES.indexOf(error.response.status) !== -1) {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('app/setServerError', true);
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error('The request was made but no response was received');
  } else {
    __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error('Something happened in setting up the request that triggered an error');
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ }),

/***/ "P4uE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_related_contracts_sushi_js__ = __webpack_require__("Wva1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da0ecdea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_related_contracts_sushi_vue__ = __webpack_require__("qUrc");
function injectStyle (ssrContext) {
  __webpack_require__("jcOa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_related_contracts_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da0ecdea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_related_contracts_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P71F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_loader__ = __webpack_require__("SHAV");




var contentLoaderMixin = {
  components: {
    AccountFormLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["a" /* AccountFormLoader */],
    AccountWithdrawalLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["b" /* AccountWithdrawalLoader */],
    LeaderboardsInfoLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["c" /* LeaderboardsInfoLoader */],
    MarketLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["d" /* MarketLoader */],
    MarketSharesItemLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["e" /* MarketSharesItemLoader */],
    MarketWidgetLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["f" /* MarketWidgetLoader */],
    NotificationLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["g" /* NotificationLoader */],
    BiggestGainsLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["h" /* BiggestGainsLoader */],
    TableRowsLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["i" /* TableRowsLoader */],
    OverviewMapLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["j" /* OverviewMapLoader */],
    MarketChartLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["k" /* MarketChartLoader */],
    PreviewCarouselLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["l" /* PreviewCarouselLoader */],
    StaticPageLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["m" /* StaticPageLoader */],
    MarketDetailPageLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["n" /* MarketDetailPageLoader */],
    SocialsLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["o" /* SocialsLoader */],
    ContractInfoLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["p" /* ContractInfoLoader */]
  },
  data: function data() {
    return {
      isComponentReady: false
    };
  },

  methods: {
    loaderItems: function loaderItems(number) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, number);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (contentLoaderMixin);

/***/ }),

/***/ "P764":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"show-password"}},[(_vm.show)?_c('button',{staticClass:"show-password",class:_vm.classModifiers,attrs:{"type":"button","tabindex":"-1","title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.onPasswordToggle($event)}}},[_vm._v("\n     \n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P9Cr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PBWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-cash"},[(_vm.showPromoNotification)?_c('alert-box',{attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-funds-cash__logo"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/paynearme.18d924a.jpg"),expression:"`/static/img/paynearme.18d924a.jpg`"}]})]),_vm._v(" "),(_vm.url)?_c('div',{staticClass:"add-funds-cash__button"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.buttonDisabled},on:{"click":_vm.onDeposit}},[_vm._v("\n      Deposit\n    ")])]):_vm._e(),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"add-funds-cash__error"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.url)?[_c('p',{staticClass:"add-funds-cash__note"},[_vm._v("\n      After clicking on the Deposit button above, you will be taken to a third-party site to complete your transaction.\n    ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-cash__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "+_vm._s(_vm.disclaimer)+"\n    ")])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PBe4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.backgroundModifiers},[_c('div',{staticClass:"row row-xy row-100"},[_c('div',{staticClass:"column small-4 large-12 column-100 account-social-badge__avatar"},[_c('account-social-avatar',{attrs:{"avatar":_vm.userAvatar,"showProgress":!_vm.isTopLevelTrader,"percentage":_vm.progressPercentage,"progressStrokeColor":_vm.progressColor,"backgroundStrokeColor":_vm.levelColor,"theme":_vm.avatarTheme}})],1),_vm._v(" "),_c('div',{staticClass:"column small-8 large-12 large-text-center column-100 account-social-badge__text"},[(_vm.isSocialReady)?[_c('div',{staticClass:"account-social-badge__headline"},[_vm._v("\n          "+_vm._s(_vm.username)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__level"},[_c('span',{staticClass:"account-social-badge__level-text"},[_vm._v(_vm._s(_vm.level.text))]),_vm._v(" "),_c('span',{staticClass:"account-social-badge__level-num"},[_vm._v("Level "+_vm._s(_vm.level.num))])]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__progress"},[_c('div',{class:_vm.progressBarClassModifiers},[_vm._v(_vm._s(_vm.progressPercentage)+"%")]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__progress-fill",style:(_vm.progressBarStyleModifiers)})]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__footer"},[(_vm.isTopLevelTrader)?[_vm._v("\n            You are a top-level trader!\n          ")]:[_vm._v("\n            "+_vm._s(_vm.progressInfoText)+"\n          ")]],2),_vm._v(" "),(false)?_c('span',{staticClass:"account-social-badge__link",on:{"click":_vm.showBadgesPopup}},[_vm._v(" Your Badges »\n        ")]):_vm._e()]:_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PCac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi__ = __webpack_require__("HC9X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__ = __webpack_require__("yzoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_extended_betslip_purchase_extended_betslip_vue__ = __webpack_require__("Nqth");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi__["a" /* default */]],
  components: {
    marketCharts: __WEBPACK_IMPORTED_MODULE_2__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */],
    purchaseTradeTypeSwitcherSushi: __WEBPACK_IMPORTED_MODULE_3__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__["a" /* default */],
    purchaseExtendedBetslip: __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_extended_betslip_purchase_extended_betslip_vue__["a" /* default */]
  },
  computed: {
    chartOptions: function chartOptions() {
      return {
        include24hr: true,
        include7day: true,
        include30day: true,
        include90day: true,
        includeCandle: true,
        includeLine: true,
        includeLegend: false,
        contractIds: [this.tradeOptions.contractId]
      };
    },
    mainClassName: function mainClassName() {
      return 'purchase-offer-desktop-sushi';
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--maintenance', !this.isTradingEnabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--yes', this.tradeOptions.operationValue === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--no', this.tradeOptions.operationValue === 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--' + this.$router.currentRoute.name, true), _ref;
    }
  }
});

/***/ }),

/***/ "PElc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_quotes_js__ = __webpack_require__("FITW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5433cd98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quotes_vue__ = __webpack_require__("mI5N");
function injectStyle (ssrContext) {
  __webpack_require__("8V4D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_quotes_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5433cd98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PFd9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PMOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_TYPES_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_YEARS_OPTION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_app__ = __webpack_require__("WSTi");
















var ITEMS_PER_HISTORY_PAGE = 10;
var DEFAULT_HISTORY = {
  data: [],
  page: 0,
  totalCount: -1,
  canLoadMore: true,
  marketId: -1
};
var DEFAULT_PRICE_CHANGE = 10;

var ALL_TYPES_OPTION = { label: 'All Transactions', value: 'ALL' };
var ALL_YEARS_OPTION = { label: 'All', value: '' };
var GUEST_LOGIN_MERGE_SETTING_KEYS = [__WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme, __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout, __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay];

var TYPE_OPTIONS = [ALL_TYPES_OPTION, { label: 'Deposits', value: 'DEPOSITS' }, { label: 'Withdrawals', value: 'WITHDRAWALS' }, { label: 'Promotions', value: 'PROMOTIONS' }];

function makeYearsOptions(obj) {
  var years = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(obj.keys())).sort().reduceRight(function (filter, year) {
    filter.push({ label: year, value: year.toString() });
    return filter;
  }, []);
  years.unshift(ALL_YEARS_OPTION);
  return years;
}

function getResolvedGuestSettingValue(rootState, keyName) {
  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
    return rootState.app.settingColorPalette;
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
    return rootState.app.settingShowOdds ? __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS : __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["d" /* APP_PRICE_DISPLAY */].TRADE_PRICES;
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
    return rootState.app.settingMobileLayout;
  }

  return null;
}

function isGuestSettingDirty(rootState, keyName) {
  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
    return rootState.app.guestSettingColorPaletteDirty;
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
    return rootState.app.guestSettingPriceDisplayDirty;
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
    return rootState.app.guestSettingMobileLayoutDirty;
  }

  return false;
}

function applyResolvedUxSetting(dispatch, keyName, value) {
  var numValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(value, 10);

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
    return dispatch('app/applySettingColorPalette', numValue, { root: true });
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
    return dispatch('app/applySettingMobileLayout', numValue, { root: true });
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
    return dispatch('app/applySettingShowOdds', numValue === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS, { root: true });
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS) {
    return dispatch('app/applySettingOrderbookCollapsed', numValue === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED, { root: true });
  }

  return null;
}

function clearGuestSettingDirty(dispatch, keyName) {
  return dispatch('app/setGuestSettingDirty', { keyName: keyName, value: false }, { root: true });
}

function resolveFetchedSettings(settings, rootState) {
  var dirtySettingsToClear = [];
  var settingsToPersist = [];

  var resolvedSettings = settings.map(function (setting) {
    if (setting.category !== 'ux' || !GUEST_LOGIN_MERGE_SETTING_KEYS.includes(setting.keyName)) {
      return setting;
    }

    var backendValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(setting.value, 10);

    if (setting.hasAccountOverride) {
      dirtySettingsToClear.push(setting.keyName);
      return setting;
    }

    if (!isGuestSettingDirty(rootState, setting.keyName)) {
      return setting;
    }

    var guestValue = getResolvedGuestSettingValue(rootState, setting.keyName);
    if (guestValue === null || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan___default()(backendValue)) {
      return setting;
    }

    settingsToPersist.push({
      category: setting.category,
      keyName: setting.keyName,
      value: guestValue
    });

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, setting, {
      value: guestValue.toString(),
      hasAccountOverride: true
    });
  });

  return {
    resolvedSettings: resolvedSettings,
    dirtySettingsToClear: dirtySettingsToClear,
    settingsToPersist: settingsToPersist
  };
}

/* harmony default export */ __webpack_exports__["c"] = ({
  namespaced: true,
  state: {
    portfolioChart: {
      history: []
    },
    userAffiliations: [],
    profileStatus: {},
    profileDetail: {},
    tradeHistory: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    transactionHistory: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    marketHistory: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    pendingHistory: [],
    marketPayouts: null,
    tradedMarkets: [],
    tradedMarketsLoaded: false,
    isUCAffilSet: false,
    settings: {
      display: {},
      privacy: {},
      InAppNotifications: {},
      PushNotifications: {},
      ux: {}
    }
  },
  mutations: {
    resetTransactionHistory: function resetTransactionHistory(state) {
      state.transactionHistory = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
      state.pendingHistory = [];
    },
    resetTradeHistory: function resetTradeHistory(state) {
      state.tradeHistory = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
    },
    resetMarketHistory: function resetMarketHistory(state) {
      state.marketHistory = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
    },
    updateTransactionHistory: function updateTransactionHistory(state, payload) {
      var data = state.transactionHistory.data.concat(payload.data.fundsHistoryViewModel);
      state.pendingHistory = payload.data.fundsPendingViewModel;
      var page = payload.page;
      var totalCount = payload.data.totalItems;
      var canLoadMore = totalCount > data.length;

      state.transactionHistory = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.transactionHistory, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    updateTradeHistory: function updateTradeHistory(state, payload) {
      var current = state[payload.what];
      var history = void 0;

      if (current.marketId !== payload.marketId || payload.contractId !== current.contractId) {
        history = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
      } else {
        history = current;
      }
      var data = history.data.concat(payload.data.historyList);
      var page = payload.page;
      var marketId = payload.marketId;
      var contractId = payload.contractId;
      var totalCount = payload.data.totalCount;
      var canLoadMore = totalCount > data.length;

      state[payload.what] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state[payload.what], {
        data: data,
        page: page,
        marketId: marketId,
        contractId: contractId,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    updateMarketPayouts: function updateMarketPayouts(state, payload) {
      state.marketPayouts = payload;
    },
    setProfileDetail: function setProfileDetail(state, data) {
      state.profileDetail = data;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        gtmUserID: data.userGuid,
        otmUserID: data.otmUserId
      });
    },
    setProfileStatus: function setProfileStatus(state, data) {
      state.profileStatus = data;
    },
    updateTradedMarkets: function updateTradedMarkets(state, payload) {
      state.tradedMarkets = payload;
      state.tradedMarketsLoaded = true;
    },
    clearTradedMarkets: function clearTradedMarkets(state) {
      state.tradedMarkets = [];
      state.tradedMarketsLoaded = false;
    },
    updateTransactionFilters: function updateTransactionFilters(state, payload) {
      state.transactionFilters = payload;
    },
    setPortfolioChart: function setPortfolioChart(state, data) {
      state.portfolioChart = data;
    },
    clearSettings: function clearSettings(state) {
      state.settings = {
        display: {},
        privacy: {},
        InAppNotifications: {},
        PushNotifications: {},
        ux: {}
      };
    },
    updateSettingsCategory: function updateSettingsCategory(state, payload) {
      var categories = payload.reduce(function (acc, _ref) {
        var category = _ref.category,
            keyName = _ref.keyName,
            value = _ref.value;

        if (acc[category] === undefined) {
          acc[category] = {};
        }
        // converting to boolean if true/false
        var boolValue = null;
        if (value === 'true') {
          boolValue = true;
        }
        if (value === 'false') {
          boolValue = false;
        }
        var parsed = value;
        if (keyName === 'ContractPriceChangeAmount') {
          parsed = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(value, 10);
          if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan___default()(parsed)) {
            parsed = DEFAULT_PRICE_CHANGE;
          }
        }
        acc[category][keyName] = boolValue !== null ? boolValue : parsed;
        return acc;
      }, {});
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(categories).forEach(function (k) {
        state.settings[k] = categories[k];
      });
    },
    updateSettings: function updateSettings(state, _ref2) {
      var category = _ref2.category,
          key = _ref2.key,
          value = _ref2.value;

      state.settings[category][key] = value;
    },
    updateProfileFromNotification: function updateProfileFromNotification(state, data) {
      state.profileDetail = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["R" /* updateObjectValues */])(state.profileDetail, data, __WEBPACK_IMPORTED_MODULE_12__services_notifications_proxy__["o" /* ACCOUNT_FUNDS_MAP */]);
    },
    setUserAffiliations: function setUserAffiliations(state, data) {
      state.userAffiliations = data;
    },
    setIsUCAffilSet: function setIsUCAffilSet(state, data) {
      state.isUCAffilSet = data;
    }
  },
  getters: {
    transactionFilters: function transactionFilters(state) {
      if (state.transactionHistory.data) {
        var registrationYear = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(state.profileDetail.dateRegistered).year();
        var currentYear = new Date().getFullYear();
        var yearPairs = __WEBPACK_IMPORTED_MODULE_8_lodash_range___default()(registrationYear, currentYear + 1).map(function (i) {
          return [i, i];
        });
        var yearsMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(yearPairs);
        var yearOptions = makeYearsOptions(yearsMap);
        return { yearOptions: yearOptions, typeOptions: TYPE_OPTIONS };
      }
      return { yearOptions: [], typeOptions: TYPE_OPTIONS };
    },
    showBidAsk: function showBidAsk(state) {
      return state.settings.display.ShowBidAsk;
    },
    settingsReady: function settingsReady(state) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.privacy).length > 0 && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.InAppNotifications).length > 0 && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.PushNotifications).length > 0;
    }
  },
  actions: {
    getTradeHistory: function getTradeHistory(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$marketId = _ref4.marketId,
          marketId = _ref4$marketId === undefined ? '' : _ref4$marketId,
          _ref4$contractId = _ref4.contractId,
          contractId = _ref4$contractId === undefined ? '' : _ref4$contractId;

      var what = marketId === '' ? 'tradeHistory' : 'marketHistory';
      var history = state[what];
      var force = history.marketId !== marketId || contractId !== history.contractId;

      if (force || history.canLoadMore) {
        var page = force ? 1 : history.page + 1;
        return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTradeHistory(ITEMS_PER_HISTORY_PAGE, page, marketId, contractId).then(function (response) {
          commit('updateTradeHistory', {
            page: page,
            data: response.data,
            marketId: marketId,
            contractId: contractId,
            what: what
          });
        });
      }
      return null;
    },
    getTransactionHistory: function getTransactionHistory(_ref5, _ref6) {
      var state = _ref5.state,
          commit = _ref5.commit;
      var _ref6$type = _ref6.type,
          type = _ref6$type === undefined ? 'ALL' : _ref6$type,
          _ref6$year = _ref6.year,
          year = _ref6$year === undefined ? '' : _ref6$year;

      if (state.transactionHistory.canLoadMore) {
        var page = state.transactionHistory.page + 1;
        return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTransactionHistory(ITEMS_PER_HISTORY_PAGE, page, type, year).then(function (response) {
          commit('updateTransactionHistory', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    clearMarketPayouts: function clearMarketPayouts(_ref7) {
      var commit = _ref7.commit;

      commit('updateMarketPayouts', null);
    },
    getMarketPayouts: function getMarketPayouts(_ref8, marketId) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getMarketPayouts(marketId).then(function (response) {
        commit('updateMarketPayouts', response.data);
      });
    },
    getProfileDetail: function getProfileDetail(_ref9) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getProfileDetail().then(function (response) {
        commit('setProfileDetail', response.data);
        return response.data;
      });
    },
    getTradedMarkets: function getTradedMarkets(_ref10, _ref11) {
      var commit = _ref10.commit,
          state = _ref10.state;
      var _ref11$cache = _ref11.cache,
          cache = _ref11$cache === undefined ? false : _ref11$cache;

      if (cache && state.tradedMarketsLoaded) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.tradedMarkets);
      }
      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTradeHistoryMarkets().then(function (response) {
        commit('updateTradedMarkets', response.data);
        return response.data;
      });
    },
    resetTransactionHistory: function resetTransactionHistory(_ref12) {
      var commit = _ref12.commit;

      commit('resetTransactionHistory');
    },
    resetTradeHistory: function resetTradeHistory(_ref13) {
      var commit = _ref13.commit;

      commit('resetTradeHistory');
    },
    resetMarketHistory: function resetMarketHistory(_ref14) {
      var commit = _ref14.commit;

      commit('resetMarketHistory');
    },
    addMarketToWatchList: function addMarketToWatchList(_ref15, marketId) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.putMarketWatch(marketId).then(function (response) {
        return response.data;
      });
    },
    removeMarketFromWatchList: function removeMarketFromWatchList(_ref16, marketId) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.deleteMarketWatch(marketId).then(function (response) {
        return response.data;
      });
    },
    getPortfolioChart: function getPortfolioChart(_ref17, _ref18) {
      var commit = _ref17.commit;
      var timespan = _ref18.timespan;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getPortfolioChart(timespan).then(function (response) {
        commit('setPortfolioChart', response.data);
        return response.data;
      });
    },
    updateSettings: function updateSettings(_ref19, payload) {
      var commit = _ref19.commit,
          dispatch = _ref19.dispatch;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.putSettings(payload.category, payload.key, payload.value).then(function (response) {
        commit('updateSettings', payload);
        if (payload.category === 'ux') {
          var numValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(payload.value, 10);
          if (payload.key === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
            dispatch('app/applySettingColorPalette', numValue, { root: true });
            clearGuestSettingDirty(dispatch, payload.key);
          } else if (payload.key === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
            dispatch('app/applySettingMobileLayout', numValue, { root: true });
            clearGuestSettingDirty(dispatch, payload.key);
          } else if (payload.key === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
            dispatch('app/applySettingShowOdds', numValue === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS, { root: true });
            clearGuestSettingDirty(dispatch, payload.key);
          } else if (payload.key === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS) {
            dispatch('app/applySettingOrderbookCollapsed', numValue === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED, { root: true });
          }
        }
        return response.data;
      });
    },
    clearSettings: function clearSettings(_ref20) {
      var commit = _ref20.commit;

      commit('clearSettings');
    },
    getAllSettings: function getAllSettings(_ref21) {
      var commit = _ref21.commit,
          dispatch = _ref21.dispatch,
          rootState = _ref21.rootState;

      var categories = ['Display', 'InAppNotifications', 'PushNotifications', 'Privacy', 'ux'].map(function (i) {
        return i.toLowerCase();
      }).join();
      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getAllSettings(categories).then(function (response) {
        var _resolveFetchedSettin = resolveFetchedSettings(response.data, rootState),
            resolvedSettings = _resolveFetchedSettin.resolvedSettings,
            dirtySettingsToClear = _resolveFetchedSettin.dirtySettingsToClear,
            settingsToPersist = _resolveFetchedSettin.settingsToPersist;

        commit('updateSettingsCategory', resolvedSettings);

        var uxSettings = resolvedSettings.filter(function (item) {
          return item.category === 'ux';
        });
        uxSettings.forEach(function (_ref22) {
          var keyName = _ref22.keyName,
              value = _ref22.value;

          applyResolvedUxSetting(dispatch, keyName, value);
        });

        dirtySettingsToClear.forEach(function (keyName) {
          clearGuestSettingDirty(dispatch, keyName);
        });

        if (!settingsToPersist.length) {
          return resolvedSettings;
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(settingsToPersist.map(function (_ref23) {
          var category = _ref23.category,
              keyName = _ref23.keyName,
              value = _ref23.value;
          return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.putSettings(category, keyName, value).then(function () {
            clearGuestSettingDirty(dispatch, keyName);
          }).catch(function () {
            return null;
          });
        })).then(function () {
          return resolvedSettings;
        });
      });
    },
    updateProfileFromNotification: function updateProfileFromNotification(_ref24, payload) {
      var commit = _ref24.commit;

      commit('updateProfileFromNotification', payload);
    },
    clearTradedMarkets: function clearTradedMarkets(_ref25) {
      var commit = _ref25.commit;

      commit('clearTradedMarkets');
    },
    setProfileStatus: function setProfileStatus(_ref26, data) {
      var commit = _ref26.commit;

      commit('setProfileStatus', data);
    },
    sendInviteEmail: function sendInviteEmail(_ref27, email) {
      var commit = _ref27.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.postSendInviteEmail(email).then(function (response) {
        return response.data;
      });
    },
    getUserAffiliations: function getUserAffiliations(_ref28) {
      var commit = _ref28.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getUserAffiliations().then(function (response) {
        var data = response.data;
        commit('setIsUCAffilSet', data.isUCAffilSet);
        commit('setUserAffiliations', data.affiliateEntities || []);
        return response.data;
      });
    },
    setUserAffiliations: function setUserAffiliations(_ref29, payload) {
      var commit = _ref29.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.setUserAffiliations(payload).then(function (response) {
        return response.data;
      });
    },
    removeUserAffiliations: function removeUserAffiliations(_ref30, payload) {
      var commit = _ref30.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.removeUserAffiliations(payload).then(function (response) {
        return response.data;
      });
    },
    getAffiliations: function getAffiliations(_ref31, search) {
      var _ = _ref31._;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getAffiliations(search).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "PQ7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__ = __webpack_require__("yUpF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    editModeOn: false,
    currentStep: __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].REGISTER
  },
  mutations: {
    setCurrentStep: function setCurrentStep(state, step) {
      state.currentStep = step;
    },
    setOnboardingEditMode: function setOnboardingEditMode(state, flag) {
      state.editModeOn = flag;
    }
  },
  actions: {
    showOnboardingStepByCode: function showOnboardingStepByCode(_ref, _ref2) {
      var dispatch = _ref.dispatch,
          rootGetters = _ref.rootGetters;
      var stepCode = _ref2.stepCode;

      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[ONBOARDING] showOnboardingStepByCode ' + stepCode);
      if (stepCode === __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["b" /* ONBOARDING_STEP_NAME_CODE_MAP */].ADD_FUNDS_OR_PENDING) {
        var step = rootGetters['user/showComplianceReviewBanner'] ? __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].PENDING_APPROVAL : __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].QUICK_DEPOSIT;
        dispatch('showOnboardingStep', { step: step });
      } else {
        dispatch('showOnboardingStep', { step: __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["c" /* ONBOARDING_STEP_CODE_NAME_MAP */][stepCode] });
      }
    },
    showOnboardingStep: function showOnboardingStep(_ref3, _ref4) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          rootGetters = _ref3.rootGetters;
      var step = _ref4.step;

      if (step === __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].LOGIN) {
        dispatch('popup/setCurrentPopup', null, { root: true });
        if (rootGetters['app/isLoginEnabled']) {
          alert('login');
        } else {
          dispatch('popup/setCurrentSmallPopup', __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PROCESS_ERROR, { root: true });
          dispatch('popup/setCurrentPopupOptions', { message: 'Due to site maintenance, it\'s not possible to log in at this time. Please try again later.' }, { root: true });
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      } else if (step === __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].REGISTER) {
        dispatch('popup/setCurrentPopup', null, { root: true });
        if (rootGetters['app/isSignUpEnabled']) {
          alert('logout');
        } else {
          dispatch('popup/setCurrentSmallPopup', __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PROCESS_ERROR, { root: true });
          dispatch('popup/setCurrentPopupOptions', { message: 'Due to site maintenance, it\'s not possible to sign up at this time. Please try again later.' }, { root: true });
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[ONBOARDING] showOnboardingStep ' + step);
      commit('setCurrentStep', step);
      return dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_app_modals__["a" /* MODALS */].ONBOARDING, { root: true });
    },
    setCurrentStep: function setCurrentStep(_ref5, _ref6) {
      var commit = _ref5.commit;
      var step = _ref6.step;

      commit('setCurrentStep', step);
    },
    setOnboardingEditMode: function setOnboardingEditMode(_ref7, flag) {
      var commit = _ref7.commit;

      commit('setOnboardingEditMode', flag);
    }
  }
});

/***/ }),

/***/ "PQLn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PUmN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_js__ = __webpack_require__("d/V8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc991b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_vue__ = __webpack_require__("P0TV");
function injectStyle (ssrContext) {
  __webpack_require__("kQhA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc991b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PUuo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_modals_js__ = __webpack_require__("HP6i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9b9903_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_modals_vue__ = __webpack_require__("E9yO");
function injectStyle (ssrContext) {
  __webpack_require__("QgNJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_modals_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9b9903_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_modals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PVzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_sitemap_js__ = __webpack_require__("sof5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7467fb62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_sitemap_vue__ = __webpack_require__("7BYG");
function injectStyle (ssrContext) {
  __webpack_require__("ERhj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_sitemap_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7467fb62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_sitemap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Paoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      required: true
    },
    average: {
      type: Number,
      required: true
    },
    difference: {
      type: Number,
      required: true
    },
    lastClosePrice: {},
    numberOnly: {
      type: Boolean,
      default: false
    },
    avgPriceOnly: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    changePriceTheme: {
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: '&cent;'
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'market-shares-bar': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--yes', this.mode === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--no', this.mode === 'no'), _ref;
    }
  },
  methods: {
    onClickNumber: function onClickNumber() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "PbZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PbpQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PeCr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-market-detail-sushi"},[(_vm.market && _vm.market.marketId && !_vm.isResetting)?[(_vm.isShortcutWidgetVisible)?_c('purchase-offer-sushi-mobile-bar',{attrs:{"market":_vm.market,"navigatedFromContractsSection":true,"selectedSection":_vm.activeTab}}):_vm._e(),_vm._v(" "),(_vm.ogImageSrc)?_c('img',{staticClass:"page-market-detail-sushi__og-image",attrs:{"src":_vm.ogImageSrc,"alt":""}}):_vm._e(),_vm._v(" "),_c('market-site-alert-v2',{staticClass:"page-market-detail-sushi__max-width-container page-market-detail-sushi__site-alert",attrs:{"market":_vm.market}}),_vm._v(" "),_c('div',{staticClass:"page-market-detail-sushi__container"},[_c('div',{staticClass:"page-market-detail-sushi__left"},[(_vm.showMarketLinksWidget)?_c('sushi-market-links-widget',{attrs:{"market":_vm.market}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"page-market-detail-sushi__main"},[_c('div',{ref:"marketTitle",staticClass:"page-market-detail-sushi__title",class:{
          'page-market-detail-sushi__title--is-stickable': !_vm.isMarketDisabled,
          'page-market-detail-sushi__title--is-sticky': _vm.isTitleSticky,
          'page-market-detail-sushi__title--mobile-betslip-expanded': _vm.isExpandedMobileBetslipActive && _vm.isTitleSticky,
          'page-market-detail-sushi__title--payout': _vm.isPayoutAvailable,
          'page-market-detail-sushi__title--with-sticky-summary': _vm.showStickyTitleSummary,
          'page-market-detail-sushi__title--with-watch': _vm.watchIconVisible
        },style:(_vm.titleStyleModifiers),on:{"mouseover":_vm.onTitleMouseOver,"mouseleave":_vm.onTitleMouseLeave}},[_c('div',{staticClass:"page-market-detail-sushi__title-text"},[_vm._v("\n            "+_vm._s(_vm.displayedMarketName)+"\n          ")]),_vm._v(" "),(_vm.showStickyTitleSummary)?_c('div',{staticClass:"page-market-detail-sushi__title-sticky-summary"},[_c('div',{staticClass:"page-market-detail-sushi__title-sticky-summary-item"},[_c('div',{staticClass:"page-market-detail-sushi__title-sticky-summary-label"},[_vm._v("\n                Investment\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixedflex",value:(_vm.market.userInvestment),expression:"market.userInvestment",modifiers:{"round2":true,"fixedflex":true}}],staticClass:"page-market-detail-sushi__title-sticky-summary-value"})]),_vm._v(" "),_c('div',{staticClass:"page-market-detail-sushi__title-sticky-summary-item",class:{
                'page-market-detail-sushi__title-sticky-summary-item--gain': _vm.stickyUserGainLossNormalized > 0,
                'page-market-detail-sushi__title-sticky-summary-item--loss': _vm.stickyUserGainLossNormalized < 0
              }},[_c('div',{staticClass:"page-market-detail-sushi__title-sticky-summary-label"},[_vm._v("\n                "+_vm._s(_vm.stickyUserGainLossLabel)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixedflex",value:(_vm.stickyUserGainLossNormalized),expression:"stickyUserGainLossNormalized",modifiers:{"round2":true,"fixedflex":true}}],staticClass:"page-market-detail-sushi__title-sticky-summary-value"})]),_vm._v(" "),_c('div',{staticClass:"page-market-detail-sushi__title-sticky-summary-item"},[_c('div',{staticClass:"page-market-detail-sushi__title-sticky-summary-label"},[(_vm.isAllPayoutsAvailable)?[_c('a',{staticClass:"page-market-detail-sushi__title-sticky-summary-link",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.openPotentialPayouts($event)}}},[_vm._v("\n                    Max. Payout\n                  ")])]:[_vm._v("\n                  Max. Payout\n                ")]],2),_vm._v(" "),_c('div',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixedflex",value:(_vm.market.userMaxPayout),expression:"market.userMaxPayout",modifiers:{"round2":true,"fixedflex":true}}],staticClass:"page-market-detail-sushi__title-sticky-summary-value"})])]):_vm._e(),_vm._v(" "),(_vm.showDesktopTitlePayout)?_c('div',{staticClass:"page-market-detail-sushi__title-payout"},[_c('market-payout-sushi',{attrs:{"showMarketLink":false,"market":_vm.market}})],1):_vm._e(),_vm._v(" "),(_vm.showMobileTitleWatch)?_c('div',{staticClass:"page-market-detail-sushi__title-watch"},[(!_vm.reloading)?_c('market-watch',{attrs:{"layout":"bright","marketId":_vm.market.marketId,"isWatched":_vm.market.isMarketWatched},on:{"watch-toggle":_vm.onWatchToggle}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showDesktopTitleWatch)?_c('transition',{attrs:{"name":"page-market-detail-sushi__title-watch-desktop"}},[_c('div',{staticClass:"page-market-detail-sushi__title-watch-desktop",class:{'page-market-detail-sushi__title-watch-desktop--no-payout': !_vm.isPayoutAvailable}},[(!_vm.reloading)?_c('market-watch',{ref:"marketWatch",attrs:{"layout":"bright","marketId":_vm.market.marketId,"isWatched":_vm.market.isMarketWatched},on:{"watch-toggle":_vm.onWatchToggle}}):_vm._e()],1)]):_vm._e()],1),_vm._v(" "),_c('div',{ref:"stickySentinel",staticClass:"page-market-detail-sushi__sticky-sentinel"}),_vm._v(" "),(_vm.hideMainChart)?_c('div',{staticClass:"page-market-detail-sushi__new-market-bar market-alert-v2"},[_c('div',{staticClass:"market-alert-v2__title"},[_vm._v("\n            New Market\n          ")]),_vm._v(" "),_c('div',{staticClass:"market-alert-v2__text"},[_c('span',[_vm._v(_vm._s(_vm.newMarketBarDescription))]),_vm._v(" "),_c('a',{staticClass:"page-market-detail-sushi__new-market-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.openNewMarketStats($event)}}},[_vm._v("\n              Open Stats\n            ")])])]):_vm._e(),_vm._v(" "),_c('market-alert-v2',{staticClass:"page-market-detail-sushi__market-alert",attrs:{"market":_vm.market}}),_vm._v(" "),(_vm.showEconomicIndicator)?_c('alert-box',{staticClass:"page-market-detail-sushi__message",attrs:{"level":"affiliation"}},[_c('div',[_vm._v("\n            Economic Indicator markets like this one require you to be affiliated with a school in order to buy or sell shares\n          ")])]):_vm._e(),_vm._v(" "),(_vm.showEngineBusyNotification)?_c('alert-box',{staticClass:"page-market-detail-sushi__message",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.engineBusyNotificationContent)}})]):_vm._e(),_vm._v(" "),(_vm.isPayoutAvailable && !_vm.isLayoutDesktop && !_vm.showStickyTitleSummary)?_c('div',{staticClass:"page-market-detail-sushi__mobile-payout"},[_c('market-payout-sushi',{attrs:{"showMarketLink":false,"market":_vm.market}})],1):_vm._e(),_vm._v(" "),(!_vm.hideMainChart)?_c('div',{staticClass:"page-market-detail-sushi__main-chart"},[_c('market-charts',{key:("chart-main-" + (_vm.isLayoutDesktop.toString())),attrs:{"chartSystemOptions":_vm.isLayoutDesktop ? {'maxHeight': '250px'} : {'maxHeight': '230px'},"market":_vm.market},on:{"no-data":function($event){_vm.hideMainChart = true}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-market-detail-sushi__toolbar",style:(_vm.toolbarStyleModifiers)},[_c('div',{ref:"toolbarTabs",staticClass:"page-market-detail-sushi__toolbar-tabs"},[_c('tabs',{attrs:{"items":_vm.navigationTabs,"theme":"dashboard-nav-no-border","activeTab":_vm.activeTab},on:{"tabChange":_vm.navigationTabChange}}),_vm._v(" "),(_vm.toolbarTabsCanScrollLeft)?_c('button',{staticClass:"page-market-detail-sushi__toolbar-tabs-scroll-button page-market-detail-sushi__toolbar-tabs-scroll-button--left",attrs:{"type":"button","aria-label":"Scroll tabs left"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.scrollToolbarTabs(-1)}}}):_vm._e(),_vm._v(" "),(_vm.toolbarTabsCanScrollRight)?_c('button',{staticClass:"page-market-detail-sushi__toolbar-tabs-scroll-button page-market-detail-sushi__toolbar-tabs-scroll-button--right",attrs:{"type":"button","aria-label":"Scroll tabs right"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.scrollToolbarTabs(1)}}}):_vm._e()],1)]),_vm._v(" "),_c('div',{ref:"marketContent",staticClass:"page-market-detail-sushi__content",class:("page-market-detail-sushi__content--" + _vm.activeTab),style:(_vm.contentStyleModifiers)},[_c('div',{ref:"marketContentInner",staticClass:"page-market-detail-sushi__content-inner"},[(_vm.activeTab === _vm.NAVIGATION_TABS.CHARTS )?_c('page-sushi-market-charts'):_vm._e(),_vm._v(" "),_c('page-sushi-market-contracts',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === _vm.NAVIGATION_TABS.CONTRACTS),expression:"activeTab === NAVIGATION_TABS.CONTRACTS"}],attrs:{"isActive":_vm.activeTab === _vm.NAVIGATION_TABS.CONTRACTS,"isPageTitleSticky":_vm.isTitleSticky},on:{"open-discussion":_vm.onOpenDiscussion,"open-comment":_vm.onOpenDiscussionComment}}),_vm._v(" "),_c('page-sushi-market-rules',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === _vm.NAVIGATION_TABS.RULES),expression:"activeTab === NAVIGATION_TABS.RULES"}]}),_vm._v(" "),_c('page-sushi-market-methodology',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === _vm.NAVIGATION_TABS.METHODOLOGY),expression:"activeTab === NAVIGATION_TABS.METHODOLOGY"}]}),_vm._v(" "),_c('page-sushi-market-research',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === _vm.NAVIGATION_TABS.RESEARCH),expression:"activeTab === NAVIGATION_TABS.RESEARCH"}]}),_vm._v(" "),(_vm.isPinningEnabled)?[(_vm.activeTab === _vm.NAVIGATION_TABS.DISCUSSION)?_c('page-sushi-market-discussion',{attrs:{"isActive":_vm.activeTab === _vm.NAVIGATION_TABS.DISCUSSION,"focusCommentId":_vm.requestedDiscussionCommentId,"requestedCommentThreadId":_vm.requestedDiscussionCommentThreadId},on:{"discussion-request-change":_vm.onDiscussionRequestChange}}):_vm._e()]:[_c('page-sushi-market-discussion',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === _vm.NAVIGATION_TABS.DISCUSSION),expression:"activeTab === NAVIGATION_TABS.DISCUSSION"}],attrs:{"isActive":_vm.activeTab === _vm.NAVIGATION_TABS.DISCUSSION,"focusCommentId":_vm.requestedDiscussionCommentId,"requestedCommentThreadId":_vm.requestedDiscussionCommentThreadId},on:{"discussion-request-change":_vm.onDiscussionRequestChange}})],_vm._v(" "),(_vm.isLoggedIn)?[_c('page-sushi-market-links',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === _vm.NAVIGATION_TABS.LINKS),expression:"activeTab === NAVIGATION_TABS.LINKS"}],attrs:{"isActive":_vm.activeTab === _vm.NAVIGATION_TABS.LINKS}}),_vm._v(" "),(_vm.activeTab === _vm.NAVIGATION_TABS.HISTORY)?_c('page-sushi-market-history'):_vm._e()]:_vm._e()],2)])],1),_vm._v(" "),_c('div',{staticClass:"page-market-detail-sushi__right"},[(_vm.showDiscussionWidget)?_c('sushi-market-discussion-widget',{key:_vm.discussionWidgetKey,attrs:{"showInfoOnly":_vm.activeTab === 'discussion',"market":_vm.market}}):_vm._e()],1)])]:_c('div',{staticClass:"page-market-detail-sushi__loader"},[_c('market-detail-page-loader')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pf5Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_ownership_and_orders_bar_js__ = __webpack_require__("O4V+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382ec28f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_ownership_and_orders_bar_vue__ = __webpack_require__("mt5D");
function injectStyle (ssrContext) {
  __webpack_require__("1EIf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_ownership_and_orders_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382ec28f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_ownership_and_orders_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Phpc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.tableModifiers},[(_vm.showHeader)?_c('div',{staticClass:"order-book-sushi__header"},[_c('div',{staticClass:"order-book-sushi__header-cell order-book-sushi__header-cell--active order-book-offers-sushi__header-flex"},[(_vm.displayMode === _vm.ORDER_BOOK_OFFER_DISPLAY_MODE.TOGGLE)?[_c('div',{staticClass:"order-book-offers-sushi__tab",class:{'order-book-offers-sushi__tab--active': _vm.activeTab === _vm.ORDER_BOOK_OFFER_DISPLAY_MODE.BUY},on:{"click":function($event){_vm.activeTab = _vm.ORDER_BOOK_OFFER_DISPLAY_MODE.BUY}}},[_vm._v("\n          Buy Orders\n        ")]),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__tab",class:{'order-book-offers-sushi__tab--active': _vm.activeTab === _vm.ORDER_BOOK_OFFER_DISPLAY_MODE.SELL},on:{"click":function($event){_vm.activeTab = _vm.ORDER_BOOK_OFFER_DISPLAY_MODE.SELL}}},[_vm._v("\n          Sell Orders\n        ")])]:(_vm.displayMode === _vm.ORDER_BOOK_OFFER_DISPLAY_MODE.BUY)?_c('div',[_vm._v("\n        Buy Orders\n      ")]):(_vm.displayMode === _vm.ORDER_BOOK_OFFER_DISPLAY_MODE.SELL)?_c('div',[_vm._v("\n        Sell Orders\n      ")]):_c('div',[_vm._v("\n        Orders\n      ")])],2),_vm._v(" "),(!_vm.cardLayout)?_c('div',{staticClass:"order-book-offers-sushi__delete-all-wrapper"},[(_vm.offers.length > 0 && !_vm.deleteAllMode)?_c('button',{staticClass:"order-book-offers-sushi__button order-book-offers-sushi__button--delete-all",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showMenu = !_vm.showMenu}}},[_vm._v("\n          •••\n          "),_c('transition',{attrs:{"name":"order-book-offers-sushi"}},[(_vm.showMenu)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"order-book-offers-sushi__menu",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClickInner($event)}}},[_c('div',{staticClass:"order-book-offers-sushi__menu-inner",on:{"click":_vm.deleteAllClicked}},[_vm._v("\n                Cancel All\n              ")])]):_vm._e()])],1):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.cardLayout)?_c('div',{staticClass:"order-book-offers-sushi__columns"},[_c('div',{staticClass:"order-book-offers-sushi__columns-cell order-book-offers-sushi__columns-cell--price"},[_vm._v("Price")]),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__columns-cell order-book-offers-sushi__columns-cell--quantity"},[_vm._v("Qty")]),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__columns-cell order-book-offers-sushi__columns-cell--operation"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__columns-cell order-book-offers-sushi__columns-cell--action"},[(_vm.offers.length > 0 && !_vm.deleteAllMode)?_c('button',{staticClass:"order-book-offers-sushi__button order-book-offers-sushi__button--delete-all",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showMenu = !_vm.showMenu}}},[_vm._v("\n          •••\n          "),_c('transition',{attrs:{"name":"order-book-offers-sushi"}},[(_vm.showMenu)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"order-book-offers-sushi__menu",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClickInner($event)}}},[_c('div',{staticClass:"order-book-offers-sushi__menu-inner",on:{"click":_vm.deleteAllClicked}},[_vm._v("\n                Cancel All\n              ")])]):_vm._e()])],1):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body order-book-offers-sushi__body"},[(_vm.displayRows.length === 0)?[_c('div',{staticClass:"order-book-sushi__row"},[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable"},[(_vm.isLoggedIn)?[_vm._v("\n              (No Orders)\n            ")]:[_vm._v("\n              (Not Logged In)\n            ")]],2)])]:[_vm._l((_vm.displayRows),function(item,index){return [(item)?_c('div',{key:("order-book-offer-" + (item.offerId)),class:['order-book-offers-sushi__row', _vm.rowModifiers(item)],attrs:{"title":_vm.rowTitle(item)},on:{"click":function($event){return _vm.rowClicked(item)}}},[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--highlight order-book-offers-sushi__cell order-book-offers-sushi__cell--price"},[_c('span',{class:{'order-book-sushi__not-processed': !item.isProcessed}},[_vm._v("\n                "+_vm._s(item.pricePerShare)+"¢\n              ")])]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-offers-sushi__cell order-book-offers-sushi__cell--quantity"},[_c('span',{staticClass:"order-book-offers-sushi__quantity"},[_vm._v("\n                "+_vm._s(item.remainingQuantity.toLocaleString())+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-offers-sushi__cell order-book-offers-sushi__cell--operation"},[_c('span',{staticClass:"order-book-offers-sushi__operation"},[_vm._v(_vm._s(_vm.offerInfoDisplay(item)))])]),_vm._v(" "),_c('span',{staticClass:"order-book-offers-sushi__date"},[_vm._v("\n              "+_vm._s(_vm.getDate(item))+"\n            ")]),_vm._v(" "),((item.offerId !== _vm.deleteOfferId) && !_vm.deleteAllMode)?_c('div',{staticClass:"order-book-sushi__body-cell order-book-offers-sushi__cell order-book-offers-sushi__cell--action"},[_c('button',{staticClass:"order-book-offers-sushi__button order-book-offers-sushi__button--delete",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.deleteClicked(item.offerId)}}},[_c('div',{staticClass:"order-book-offers-sushi__button-icon"})])]):_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-offers-sushi__cell order-book-offers-sushi__cell--action"},[_vm._v(" ")])]):_c('div',{key:("order-book-offer-placeholder-" + index),staticClass:"order-book-sushi__row order-book-sushi__row--striped order-book-offers-sushi__row"},[(_vm.offers.length === 0 && index === 0 && !_vm.cardLayout)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable order-book-offers-sushi__cell order-book-offers-sushi__cell--full"},[(_vm.isLoggedIn)?[_vm._v("\n                  (No Orders)\n                ")]:[_vm._v("\n                  (Not Logged In)\n                ")]],2)]:[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-offers-sushi__cell order-book-offers-sushi__cell--price"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-offers-sushi__cell order-book-offers-sushi__cell--quantity"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-offers-sushi__cell order-book-offers-sushi__cell--operation"},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticClass:"order-book-offers-sushi__date order-book-offers-sushi__date--placeholder"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-offers-sushi__cell order-book-offers-sushi__cell--action"},[_vm._v(" ")])]],2)]})],_vm._v(" "),(_vm.isCardEmpty)?_c('div',{staticClass:"order-book-offers-sushi__empty-card-message"},[(_vm.isLoggedIn)?[_vm._v("\n          "+_vm._s(_vm.emptyOrdersText)+"\n        ")]:[_c('button',{staticClass:"order-book-sushi__empty-card-link",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.loginClicked($event)}}},[_vm._v("Login")]),_vm._v(" to see your orders.\n        ")]],2):_vm._e()],2)]),_vm._v(" "),(_vm.showProcessedNotice || _vm.showAllItemsNotice)?_c('div',{staticClass:"order-book-sushi__footer order-book-offers-sushi__footer"},[(_vm.showAllItemsNotice)?_c('div',{staticClass:"order-book-sushi__footer-cell order-book-sushi__footer-cell--show-all",on:{"click":_vm.toggleShowAll}},[(!_vm.showAll)?[_vm._v("Show All")]:[_vm._v("Show Less")]],2):_vm._e(),_vm._v(" "),(_vm.showProcessedNotice)?_c('div',{staticClass:"order-book-sushi__footer-cell order-book-sushi__footer-cell--price-links order-book-offers-sushi__processed-notice"},[_vm._v("\n      * Order is currently in process.\n    ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showCancelModal)?_c('small-modal',{on:{"modalClose":_vm.cancelClicked},scopedSlots:_vm._u([{key:"header",fn:function(){return [(_vm.cancelModalMode === _vm.CANCEL_ORDER_MODE.ALL)?[_vm._v("\n        Confirm Cancel Order"),(_vm.offers.length > 1)?[_vm._v("s")]:_vm._e()]:[_vm._v("\n        Confirm Cancel Order\n      ")]]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-content"},[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-title"},[(_vm.cancelModalMode === _vm.CANCEL_ORDER_MODE.ALL)?[_vm._v("\n            Are you sure you want to cancel the following order"),(_vm.offers.length > 1)?[_vm._v("s")]:_vm._e(),_vm._v("?\n          ")]:[_vm._v("\n            Are you sure you want to cancel the following order?\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers"},[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-contract-info"},[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-contract-image",style:(_vm.contractImageStyleModifiers)}),_vm._v(" "),(_vm.isMarketSingle)?[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-contract"},[_vm._v("\n                "+_vm._s(_vm.market.marketShortName || _vm.market.marketName)+"\n              ")])]:[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-contract"},[_vm._v("\n                "+_vm._s(_vm.contract.contractName)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-market"},[_vm._v("\n                "+_vm._s(_vm.market.marketShortName || _vm.market.marketName)+"\n              ")])]],2),_vm._v(" "),_vm._l((_vm.offersToDelete),function(offer){return _c('div',{key:("cancel-" + (offer.offerId)),staticClass:"order-book-offers-sushi__cancel-modal-offer"},[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offer-info",domProps:{"innerHTML":_vm._s(_vm.offerFullInfoDisplay(offer))}}),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offer-date"},[_vm._v(_vm._s(_vm.getDateFull(offer)))])])})],2),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.cancelModalMode === _vm.CANCEL_ORDER_MODE.ALL)?_c('button',{staticClass:"button button--large button--black button--full-width",on:{"click":_vm.confirmDeleteAllClicked}},[_vm._v("\n          Cancel Order"),(_vm.offers.length > 1)?[_vm._v("s")]:_vm._e()],2):_c('button',{staticClass:"button button--large button--black button--full-width",on:{"click":function($event){return _vm.confirmDeleteClicked(_vm.deleteOfferId)}}},[_vm._v("\n          Cancel Order\n        ")])])]},proxy:true}],null,false,412832234)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PmrE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pxah":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PzFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flows_what_is_new_flow_version_1_what_is_new_flow_version_1_footer_vue__ = __webpack_require__("Ilzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__("AyQu");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    whatIsNewFlowVersion1Footer: __WEBPACK_IMPORTED_MODULE_2__flows_what_is_new_flow_version_1_what_is_new_flow_version_1_footer_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    currentFlow: function currentFlow() {
      if (__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* VERSION_TO_MIGRATE_TO */] === 1) {
        return 'whatIsNewFlowVersion1Footer';
      }
      return null;
    }
  })
});

/***/ }),

/***/ "PzZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q+Dx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Q+EN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContractChartGroupStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContractChartGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PriceChangeChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ElectionMapChartOverall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ElectionMapChartParty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ElectionMapChartSenate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_market_market_state_tooltip_market_state_tooltip_vue__ = __webpack_require__("Vnj/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_market_market_contract_image_market_contract_image_vue__ = __webpack_require__("nygi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_market_market_detail_charts_timeline_timeline_vue__ = __webpack_require__("GebD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__models_contract__ = __webpack_require__("YZ+m");















 /* global Highcharts:false */
/* eslint-disable */












var DATE_MONTHLY_FORMAT = 'DD MMM';
var DATE_YEARLY_FORMAT = 'DD MMM YYYY';
var CONTRACT_BAR_CHART_GRADIENT = '#c6ebf2';
var CONTRACT_BAR_CHART_GRADIENT_STOCK = '#c6ebf2';
var CONTRACT_LINE_CHART_MARKER_FILL_COLOR = '#fff';
var CONTRACT_SELECTION_COLOR = '#c97575';
var CONTRACT_SELECTION_COLOR_ALT = '#fff';

var MarketStateTooltipComponent = __WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_20__components_market_market_state_tooltip_market_state_tooltip_vue__["a" /* default */]);
var MarketContractImageComponent = __WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_21__components_market_market_contract_image_market_contract_image_vue__["a" /* default */]);

function splitArray(arr, size) {
  var result = [];
  var noOfChunks = Math.ceil(arr.length / size);
  for (var i = 0; i < noOfChunks; i += 1) {
    result.push(arr.slice(i * size, (i + 1) * size));
  }
  return result;
}

function volumeRoundUp(num, base) {
  return num % base !== 0 ? num - num % base + base : num;
}

function volumeGetBase(num) {
  if (num >= 10000) return 10000;
  if (num >= 5000) return 5000;
  if (num >= 2500) return 2500;
  if (num >= 1000) return 1000;
  if (num >= 500) return 500;
  if (num >= 250) return 250;
  if (num >= 100) return 100;
  if (num >= 10) return 10;
  return 1;
}

function volumeNormalize(num, base, parts) {
  var result = num;
  if (result % parts === 0) return result;
  do {
    result = result + base;
  } while (result % parts !== 0);
  return result;
}

function volumeGetRange(num) {
  var parts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var base = volumeGetBase(num);
  var max = volumeRoundUp(num, base);
  var normalizedMax = volumeNormalize(max, base, parts);
  var diff = normalizedMax / parts;
  return __WEBPACK_IMPORTED_MODULE_14_lodash_range___default()(0, normalizedMax + diff, diff);
}

function getTradeVolumeTickPositions(_ref) {
  var data = _ref.data,
      _ref$parts = _ref.parts,
      parts = _ref$parts === undefined ? 5 : _ref$parts,
      _ref$show = _ref.show,
      show = _ref$show === undefined ? false : _ref$show;

  var defaults = [0, 2, 4, 6, 8, 10];
  if (!show) {
    return defaults;
  }
  var max = Math.max.apply(null, data);
  if (!max) {
    return defaults;
  }
  return volumeGetRange(max, parts);
}

if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["s" /* isHighChartsReady */])()) {
  Highcharts.SVGRenderer.prototype.symbols.download = function (x, y, w, h) {
    return [
    // Arrow stem
    'M', x + w * 0.5, y, 'L', x + w * 0.5, y + h * 0.7,
    // Arrow head
    'M', x + w * 0.3, y + h * 0.5, 'L', x + w * 0.5, y + h * 0.7, 'L', x + w * 0.7, y + h * 0.5,
    // Box
    'M', x, y + h * 0.9, 'L', x, y + h, 'L', x + w, y + h, 'L', x + w, y + h * 0.9];
  };
}

function getExporting() {
  if (__WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutMobile']) {
    return {
      enabled: false
    };
  }
  return {
    enabled: false
  };
}

var ContractChartGroupStock = function () {
  function ContractChartGroupStock(_ref2) {
    var market = _ref2.market,
        timeline = _ref2.timeline,
        data = _ref2.data,
        _ref2$chartOptions = _ref2.chartOptions,
        chartOptions = _ref2$chartOptions === undefined ? {} : _ref2$chartOptions,
        _ref2$prepare = _ref2.prepare,
        prepare = _ref2$prepare === undefined ? true : _ref2$prepare;

    __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default()(this, ContractChartGroupStock);

    this.market = market;
    this.contracts = market.contracts;
    this.timeline = timeline;
    this.data = data;
    this.contractXaxis = [];
    this.volume = [];
    this.stock = [];
    this.lastXaxisLabelIndex = 0;
    this.contractXaxis = [];
    this.chartOptions = chartOptions;
    if (prepare) this.prepareChartGroupData();
  }

  __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default()(ContractChartGroupStock, [{
    key: 'isTimelineDaily',
    value: function isTimelineDaily() {
      return this.timeline.includes('h');
    }
  }, {
    key: 'prepareDateString',
    value: function prepareDateString(contractData, index, total) {
      var label = void 0;
      if (this.isTimelineDaily()) {
        var value = -(total - index);
        label = value + 'h';
      } else {
        label = __WEBPACK_IMPORTED_MODULE_16_moment___default()(contractData.date).format(DATE_MONTHLY_FORMAT);
      }
      this.contractXaxis[index] = label;
    }
  }, {
    key: 'prepareChartGroupData',
    value: function prepareChartGroupData() {
      var _this = this;

      this.data.forEach(function (item, index) {
        _this.prepareDateString(item, index, _this.data.length);
        _this.prepareSeries(index, item);
      });
    }
  }, {
    key: 'getCandleStickChartData',
    value: function getCandleStickChartData() {
      var name = this.data.length > 0 ? this.data[0].contractName : '';
      var that = this;
      return {
        id: 'candle',
        type: 'candlestick',
        showInLegend: false,
        data: this.stock,
        name: name,
        yAxis: 0,
        tooltip: {
          valueSuffix: '¢',
          pointFormatter: function volumeTooltipFormatter(i) {
            var point = {
              open: this.open,
              low: this.low,
              high: this.high,
              close: this.close,
              date: that.contractXaxis[this.index]
            };
            return '<small>' + point.date + '</small><br><b>Open</b>: ' + point.open + '\xA2<br/><b>High</b>: ' + point.high + '\xA2<br/><b>Low</b>: ' + point.low + '\xA2<br/><b>Close</b>: ' + point.close + '\xA2';
          }
        }
      };
    }
  }, {
    key: 'getVolumeChartData',
    value: function getVolumeChartData() {
      var that = this;
      return {
        id: 'volume',
        yAxis: 1,
        color: {
          linearGradient: [0, 0, 0, 92],
          stops: [[0, CONTRACT_BAR_CHART_GRADIENT_STOCK], [1, CONTRACT_BAR_CHART_GRADIENT_STOCK]]
        },
        data: this.volume,
        showInLegend: false,
        name: 'Total Volume',
        borderRadius: 2,
        type: 'column',
        tooltip: {
          pointFormatter: function volumeTooltipFormatter() {
            return '<small>' + that.contractXaxis[this.index] + '</small><br>Total Volume: <strong>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["u" /* largeNumberDisplay */])(this.y, false) + '</strong><br>';
          }
        }
      };
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries(index, item) {
      var timestamp = +__WEBPACK_IMPORTED_MODULE_16_moment___default()(item.date);
      this.volume[index] = [timestamp, Number((item.tradeVolume || 0).toFixed(1))];
      this.stock[index] = [timestamp, Number((100 * (item.openSharePrice || 0)).toFixed(2)), Number((100 * (item.highSharePrice || 0)).toFixed(2)), Number((100 * (item.lowSharePrice || 0)).toFixed(2)), Number((100 * (item.closeSharePrice || 0)).toFixed(2))];
    }
  }, {
    key: 'getXaxisLabel',
    value: function getXaxisLabel() {
      var label = this.contractXaxis[this.lastXaxisLabelIndex];
      this.lastXaxisLabelIndex += 1;
      return label;
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var showVolume = __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(this.chartOptions, 'showVolume', false);
      var showPriceAxisZoom = __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(this.chartOptions, 'showPriceAxisZoom', true);
      var volume = this.getVolumeChartData();
      var series = [];
      var upColor = this.data.length > 0 ? this.data[0].lineColor : '#07a0bb';

      series.push(this.getCandleStickChartData());

      if (showVolume) {
        series.push(volume);
      }

      var max = undefined;
      var tickPositions = undefined;
      var values = [];

      if (series.length) {
        series[0].data.forEach(function (i) {
          values.push(i[1]);
        });
      }
      if (!showPriceAxisZoom || values.length && values.every(function (v) {
        return v === values[0];
      })) {
        max = 100;
        tickPositions = [0, 20, 40, 60, 80, 100, 120];
      }

      return {
        navigator: {
          enabled: false
        },
        scrollbar: {
          enabled: false
        },
        rangeSelector: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        xAxis: [{
          tickLength: 0,
          lineWidth: 0,
          labels: {
            formatter: function xAxisLabelFormatter() {
              return '';
            }
          }
        }],
        yAxis: [{
          height: showVolume ? '55%' : '100%',
          max: max,
          tickPositions: tickPositions,
          allowDecimals: false,
          labels: {
            formatter: function yAxisLabelFormatter() {
              if (this.value >= 0) {
                return this.value + '\xA2';
              }
            }
          },
          title: {
            text: ''
          },
          resize: {
            enabled: true
          },
          opposite: true
        }, {
          visible: showVolume,
          top: '60%',
          height: '40%',
          offset: 0,
          tickPositions: getTradeVolumeTickPositions({
            data: volume.data.map(function (i) {
              return i[1];
            }),
            parts: 2,
            show: showVolume
          }),
          allowDecimals: false,
          labels: {
            formatter: function yAxisOppositeLabelFormatter() {
              if (this.value >= 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["u" /* largeNumberDisplay */])(this.value, false);
              }
            }
          },
          title: {
            text: ''
          },
          opposite: false
        }],
        plotOptions: {
          candlestick: {
            color: '#fff',
            upColor: upColor
          }
        },
        tooltip: {
          split: true,
          shared: false,
          headerFormat: ''
        },
        series: series,
        exporting: {
          enabled: false
        }
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      return Highcharts.stockChart(container, options);
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ContractChartGroupStock;
}();

var ContractChartGroup = function () {
  function ContractChartGroup(_ref3) {
    var market = _ref3.market,
        timeline = _ref3.timeline,
        data = _ref3.data,
        _ref3$chartOptions = _ref3.chartOptions,
        chartOptions = _ref3$chartOptions === undefined ? {} : _ref3$chartOptions,
        _ref3$prepare = _ref3.prepare,
        prepare = _ref3$prepare === undefined ? true : _ref3$prepare;

    __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default()(this, ContractChartGroup);

    this.market = market;
    this.contracts = market.contracts;
    this.timeline = timeline;
    this.data = data;
    this.contractSeries = {};
    this.contractSeriesNameId = {};
    this.volume = {};
    this.contractXaxis = [];
    this.priceLineType = 'line';
    this.volumeLineType = 'column';
    this.chartOptions = chartOptions;
    if (prepare) this.prepareChartGroupData();
  }

  __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default()(ContractChartGroup, [{
    key: 'getVolumeChartData',
    value: function getVolumeChartData() {
      return {
        yAxis: 1,
        color: {
          linearGradient: [0, 0, 0, 92],
          stops: [[0, CONTRACT_BAR_CHART_GRADIENT], [1, CONTRACT_BAR_CHART_GRADIENT]]
        },
        data: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default()(this.volume).map(function (el) {
          return Number(el.toFixed(1));
        }),
        showInLegend: false,
        name: 'Total Volume',
        borderRadius: 2,
        type: this.volumeLineType,
        tooltip: {
          pointFormatter: function volumeTooltipFormatter() {
            return 'Total Volume: <strong>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["u" /* largeNumberDisplay */])(this.y, false) + '</strong><br>';
          }
        }
      };
    }
  }, {
    key: 'isTimelineDaily',
    value: function isTimelineDaily() {
      return this.timeline.includes('h');
    }
  }, {
    key: 'isMarkerEnabledForTimeline',
    value: function isMarkerEnabledForTimeline(seriesSize) {
      if (__WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutMobile']) {
        return this.timeline === __WEBPACK_IMPORTED_MODULE_23__components_market_market_detail_charts_timeline_timeline_vue__["b" /* TAB_SEVEN_DAYS */];
      }
      return seriesSize <= 30;
    }
  }, {
    key: 'prepareLabels',
    value: function prepareLabels(item) {
      if (!(item.contractId in this.contractSeries)) {
        var color = item.additional ? item.additionalLineColor : item.lineColor;
        this.contractSeriesNameId[item.contractName] = item.contractId;
        this.contractSeries[item.contractId] = {
          color: color,
          lineWidth: 2,
          marker: {
            enabled: false,
            symbol: 'circle',
            fillColor: CONTRACT_LINE_CHART_MARKER_FILL_COLOR,
            lineWidth: 1,
            lineColor: null,
            radius: 5
          },
          data: [],
          yAxis: 0,
          showInLegend: false,
          name: item.contractName,
          contractId: item.contractId,
          type: this.priceLineType,
          tooltip: {
            valueSuffix: '¢'
          }
        };
      }
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries(index, item) {
      this.contractSeries[item.contractId].data.push(item.chartPrice);
      // volume is build as sum of contracts
      // on particular points in time
      if (!(index in this.volume)) {
        this.volume[index] = 0;
      }
      if (item.tradeVolume) {
        this.volume[index] += item.tradeVolume;
      }
    }
  }, {
    key: 'prepareDateString',
    value: function prepareDateString(contractData, index) {
      if (this.isTimelineDaily()) {
        var value = -(index + 1);
        return value + 'h';
      }
      var dt = __WEBPACK_IMPORTED_MODULE_16_moment___default()(contractData.date);
      var dateYear = dt.year();
      var currentYear = __WEBPACK_IMPORTED_MODULE_16_moment___default()().year();
      var format = dateYear === currentYear ? DATE_MONTHLY_FORMAT : DATE_YEARLY_FORMAT;
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(contractData.date).format(format);
    }
  }, {
    key: 'prepareChartGroupData',
    value: function prepareChartGroupData() {
      var _this2 = this;

      var lastContractId = null;
      var lastContractIndex = 0;
      var dateStrings = new __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_set___default.a();

      this.data.forEach(function (item, index) {
        if (index === 0 || item.contractId !== lastContractId) {
          lastContractIndex = 0;
        }
        dateStrings.add(_this2.prepareDateString(item, lastContractIndex));
        _this2.prepareLabels(item);
        _this2.prepareSeries(lastContractIndex, item);
        lastContractIndex += 1;
        lastContractId = item.contractId;
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(this.contractSeries)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref4 = _step.value;

          var _ref5 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray___default()(_ref4, 2);

          var key = _ref5[0];
          var value = _ref5[1];

          this.contractSeries[key].marker.enabled = this.isMarkerEnabledForTimeline(this.contractSeries[key].data.length);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.contractXaxis = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from___default()(dateStrings);
      // we relate to 24h hour format so respacting prepareDateString method
      // we have to reverse
      if (this.isTimelineDaily()) {
        this.contractXaxis = this.contractXaxis.reverse();
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var showVolume = __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(this.chartOptions, 'showVolume', false);
      var showPriceAxisZoom = __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(this.chartOptions, 'showPriceAxisZoom', true);
      var volume = this.getVolumeChartData();
      var series = [];
      var isMobile = __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutMobile'];
      var totalContractSeries = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.contractSeries).length;

      if (showVolume) {
        series.push(volume);
      }

      __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default()(this.contractSeries).forEach(function (contractSeries) {
        series.push(contractSeries);
      });

      var max = undefined;
      var tickPositions = undefined;
      var endOnTick = false;
      var maxes = [];
      var sliceIndex = showVolume ? 1 : 0;

      series.slice(sliceIndex).forEach(function (i) {
        maxes.push(Math.max.apply(null, i.data));
      });
      var totalMax = Math.max.apply(null, maxes);

      if (totalMax < 80) {
        endOnTick = true;
      }
      if (!showPriceAxisZoom || totalContractSeries === 1 && series[sliceIndex].data.every(function (v) {
        return v === series[sliceIndex].data[0];
      })) {
        max = 100;
        tickPositions = [0, 20, 40, 60, 80, 100];
      }

      return {
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        tooltip: {
          shared: true,
          outside: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutDesktop'],
          formatter: function tooltipFormatter() {
            var points = this.points;
            var pricePoints = points.filter(function (p) {
              return p.series.name !== 'Total Volume';
            });
            var volumePoint = points.find(function (p) {
              return p.series.name === 'Total Volume';
            });

            pricePoints.sort(function (a, b) {
              return b.y - a.y;
            });

            var s = '<b>' + points[0].key + '</b><br/>';
            if (volumePoint) {
              s += 'Total Volume: <strong>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["u" /* largeNumberDisplay */])(volumePoint.y, false) + '</strong><br>';
            }
            pricePoints.forEach(function (p) {
              s += '<span style="color:' + p.color + '">\u25CF</span> ' + p.series.name + ': <b>' + p.y + '\xA2</b><br/>';
            });

            return s;
          }
        },
        credits: {
          enabled: false
        },
        yAxis: [{
          tickPositions: tickPositions,
          max: max,
          endOnTick: endOnTick,
          allowDecimals: false,
          title: { text: '' },
          gridLineWidth: 0,
          labels: {
            formatter: function yAxisLabelFormatter() {
              if (this.value >= 0) {
                return this.value + '\xA2';
              }
            }
          },
          opposite: true
        }, {
          allowDecimals: false,
          tickPositions: getTradeVolumeTickPositions({
            data: volume.data,
            parts: 5,
            show: showVolume
          }),
          title: {
            text: ''
          },
          gridLineWidth: 0,
          tickInterval: 5,
          labels: {
            style: {
              opacity: showVolume ? 1 : 0.15
            },
            formatter: function yAxisOppositeLabelFormatter() {
              if (this.value >= 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["u" /* largeNumberDisplay */])(this.value, false);
              }
            }
          }
        }],
        xAxis: [{
          categories: this.contractXaxis,
          crosshair: true,
          tickLength: 0,
          lineWidth: 0,
          tickPositioner: function tickPositioner() {
            var desktopBreak = 10;
            if (isMobile && this.categories && this.categories.length > 2) {
              return [0, Math.floor(this.categories.length / 2), this.categories.length - 1];
            }
            if (!isMobile && this.categories && this.categories.length > desktopBreak) {
              var length = this.categories.length;
              var step = Math.ceil(length / desktopBreak);
              var positions = [];
              for (var i = 0; i < length; i += step) {
                positions.push(i);
              }
              // Always include the last position
              if (positions[positions.length - 1] !== length - 1) {
                positions.push(length - 1);
              }
              return positions;
            }
            return this.tickPositions;
          }
        }],
        series: series,
        plotOptions: {
          series: {
            cursor: 'pointer',
            stickyTracking: false
          },
          line: {
            allowPointSelect: false
          },
          column: {
            allowPointSelect: false,
            pointPadding: 0,
            groupPadding: 0
          }
        },
        exporting: getExporting.bind(this)()
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var _this3 = this;

      var options = this.getOptions();
      return Highcharts.chart(container, options, function (chart) {
        var xAxis = chart.xAxis[0];
        var yAxis = chart.yAxis[0];

        if (__WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(_this3.chartOptions, 'showContractImagesOnChart', false)) {
          chart.series.forEach(function (s) {
            if (s.type === 'line') {
              var lastPoint = s.data[s.data.length - 1];
              var lastX = xAxis.toPixels(lastPoint.x);
              var lastY = yAxis.toPixels(lastPoint.y);
              var contractId = _this3.contractSeriesNameId[lastPoint.series.name];
              var contract = _this3.market.contracts.find(function (i) {
                return i.contractId === contractId;
              });
              if (contract) {
                var instance = new MarketContractImageComponent({
                  propsData: {
                    contract: contract,
                    color: lastPoint.series.color
                  }
                });
                instance.$mount();
                chart.renderer.text(instance.$el.outerHTML, lastX + 7, lastY - 5, true).add();
              }
            }
          });
        }
      });
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ContractChartGroup;
}();

var PriceChangeChart = function () {
  function PriceChangeChart(contract, data) {
    __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default()(this, PriceChangeChart);

    this.contract = contract;
    this.data = data;
    this.colorPositive = '#7dc671';
    this.colorNegative = '#c63540';
    this.colorGrid = '#fff';
    this.lineWidth = 1;
    this.lineType = 'line';
  }

  __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default()(PriceChangeChart, [{
    key: 'getSeries',
    value: function getSeries() {
      var seriesData = this.data.map(function (el) {
        return 50 - (el.closeSharePrice || 0.5) * 100;
      });
      return [{
        data: seriesData,
        lineWidth: this.lineWidth,
        type: this.lineType,
        color: this.colorPositive,
        negativeColor: this.colorNegative,
        marker: { enabled: false, states: { hover: { enabled: false } } },
        states: { hover: { enabled: false } }
      }];
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      return {
        chart: {
          margin: [0, 0, 0, 0],
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0
        },
        plotOptions: {},
        legend: { enabled: false },
        credits: { enabled: false },
        tooltip: { enabled: false },
        series: this.getSeries(),
        title: { text: '', style: { display: 'none' }, margin: 0 },
        yAxis: { labels: { enabled: false }, gridLineColor: this.colorGrid },
        xAxis: { labels: { enabled: false }, gridLineColor: this.colorGrid },
        exporting: {
          enabled: false
        }
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      Highcharts.chart(container, options);
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return PriceChangeChart;
}();

var ElectionMapChartOverall = function () {
  function ElectionMapChartOverall(data) {
    __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartOverall);

    this.data = data;
  }

  __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default()(ElectionMapChartOverall, [{
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      Highcharts.mapChart(container, options);
    }
  }, {
    key: 'getColorValue',
    value: function getColorValue(_ref6) {
      var marketData = _ref6.marketData,
          stateCode = _ref6.stateCode,
          stateName = _ref6.stateName,
          stateVotes = _ref6.stateVotes;

      if (!marketData.contracts) return 0;
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["v" /* getLeadingTradedContract */])(marketData.contracts);
      if (!targetContract || targetContract.lastTradePrice === 0.5) return 0;
      return targetContract.name === 'Democratic' ? 1 : 2;
    }
  }, {
    key: 'formatTooltip',
    value: function formatTooltip() {
      var index = this.point.index;
      var data = this.point.series.userOptions.data[index];
      var marketData = data.marketData;

      if (!marketData.contracts) return false;
      var instance = new MarketStateTooltipComponent({
        propsData: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, data)
      });
      instance.$mount();
      return instance.$el.outerHTML;
    }
  }, {
    key: 'formatDataLabel',
    value: function formatDataLabel() {
      if (this.point.stateCode === 'HI') return '';
      var contracts = this.point.marketData.contracts || [];
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["v" /* getLeadingTradedContract */])(contracts);
      var stateCode = this.point.properties['hc-a2'];
      var showStates = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];
      if (!targetContract) {
        if (contracts.length > 0) {
          return '-';
        }
        return showStates.includes(stateCode) ? stateCode : '';
      }
      var contract = new __WEBPACK_IMPORTED_MODULE_25__models_contract__["a" /* default */](targetContract);
      return contract.lastTradePriceAsCents + '\xA2';
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries() {
      var _this4 = this;

      var mapData = Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small']);
      var statesData = [];

      mapData.forEach(function (value, index) {
        var path = value.geometry.coordinates;
        var copy = {
          path: path
        };

        if (path[0][1] === 9727) {
          Highcharts.seriesTypes.map.prototype.getBox.call({}, [copy]);
          value.middleX = ((path[0][1] + path[1][1]) / 2 - copy._minX) / (copy._maxX - copy._minX);
          value.middleY = ((path[0][2] + path[2][2]) / 2 - copy._minY) / (copy._maxY - copy._minY);
        }

        var stateCode = value.properties['hc-a2'];
        var stateName = value.name.toUpperCase();
        var marketData = _this4.data[stateCode] || {};
        value.stateName = stateName;
        var stateVotes = __WEBPACK_IMPORTED_MODULE_24__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];

        statesData[index] = {
          stateCode: stateCode,
          stateName: stateName,
          stateVotes: stateVotes,
          marketData: marketData,
          value: _this4.getColorValue({ marketData: marketData, stateCode: stateCode, stateName: stateName, stateVotes: stateVotes })
        };
      });

      return { mapData: mapData, statesData: statesData };
    }
  }, {
    key: 'getBaseOptions',
    value: function getBaseOptions(_ref7) {
      var mapData = _ref7.mapData,
          statesData = _ref7.statesData;

      return {
        plotOptions: {
          series: {
            cursor: 'pointer',
            dataLabels: {
              style: {
                textOutline: 0
              }
            }
          }
        },
        exporting: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        mapNavigation: {
          enabled: false,
          enableButtons: false
        },
        xAxis: {
          labels: {
            enabled: false
          }
        },
        title: {
          text: ''
        },
        chart: {
          margin: [0, 0, 0, 0],
          spacing: [0, 0, 0, 0]
        },
        colorAxis: {
          dataClasses: [, {
            from: 0,
            to: 0,
            color: '#c8c8c8',
            name: 'N/A'
          }, {
            from: 1,
            to: 1,
            color: '#2f88dc',
            name: 'Clinton'
          }, {
            from: 2,
            to: 2,
            color: '#bc1500',
            name: 'Trump'
          }]
        },
        tooltip: {
          enabled: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutDesktop'],
          formatter: this.formatTooltip,
          hideDelay: 200,
          useHTML: true,
          borderRadius: 0,
          borderWidth: 0,
          backgroundColor: 'white',
          padding: 0,
          shadow: false,
          followPointer: true
        },
        series: [{
          mapData: mapData,
          data: statesData,
          joinBy: 'stateName',
          name: 'States',
          events: {
            mouseOut: function mouseOut(e) {
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].dispatch('market/setMarketMapTooltipVisible', false);
            },
            click: function click(e) {
              var marketId = __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(e, 'point.marketData.marketId', null);
              if (marketId) {
                window.location.href = 'https://www.predictit.org/markets/detail/' + marketId;
                // router.push({
                //   name: 'market-details',
                //   params: {
                //     marketId,
                //   }
                // });
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: this.formatDataLabel,
            style: {
              fontSize: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutMobile'] ? '10px' : '12px',
              color: 'white'
            }
          }
        }, {
          name: 'Separators',
          type: 'mapline',
          data: Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small'], 'mapline'),
          color: 'silver',
          showInLegend: false,
          enableMouseTracking: false
        }]
      };
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries = this.prepareSeries(),
          mapData = _prepareSeries.mapData,
          statesData = _prepareSeries.statesData;

      return this.getBaseOptions({ mapData: mapData, statesData: statesData });
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ElectionMapChartOverall;
}();

var ElectionMapChartParty = function (_ElectionMapChartOver) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ElectionMapChartParty, _ElectionMapChartOver);

  function ElectionMapChartParty() {
    __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartParty);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ElectionMapChartParty.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ElectionMapChartParty)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default()(ElectionMapChartParty, [{
    key: 'getColorValue',
    value: function getColorValue(_ref8) {
      var marketData = _ref8.marketData,
          stateCode = _ref8.stateCode,
          stateName = _ref8.stateName,
          stateVotes = _ref8.stateVotes;

      if (!marketData.contracts) return 0;
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["v" /* getLeadingTradedContract */])(marketData.contracts);
      if (!targetContract) return 0;
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(targetContract.contractName);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["h" /* roundToTwo */])(targetContract.lastTradePrice + pallette[0].from);
    }
  }, {
    key: 'getColorAxisStops',
    value: function getColorAxisStops() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED));
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries2 = this.prepareSeries(),
          mapData = _prepareSeries2.mapData,
          statesData = _prepareSeries2.statesData;

      var options = this.getBaseOptions({ mapData: mapData, statesData: statesData });
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, options, {
        title: {
          text: ''
        },
        colorAxis: {
          min: 0,
          dataClasses: this.getColorAxisStops()
        }
      });
    }
  }]);

  return ElectionMapChartParty;
}(ElectionMapChartOverall);

var ElectionMapChartSenate = function (_ElectionMapChartOver2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ElectionMapChartSenate, _ElectionMapChartOver2);

  function ElectionMapChartSenate() {
    __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartSenate);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ElectionMapChartSenate.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ElectionMapChartSenate)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default()(ElectionMapChartSenate, [{
    key: 'getColorValue',
    value: function getColorValue(_ref9) {
      var marketData = _ref9.marketData,
          stateCode = _ref9.stateCode,
          stateName = _ref9.stateName,
          stateVotes = _ref9.stateVotes;

      var hardcodedDemocrats = ['CA', 'CT', 'HI', 'IL', 'MD', 'NY', 'OR', 'VT', 'WA'];
      var hardcodedRepublicans = ['AK', 'AL', 'AR', 'IA', 'ID', 'IN', 'KS', 'KY', 'LA', 'MO', 'ND', 'OK', 'SC', 'SD', 'UT'];
      if (hardcodedDemocrats.includes(stateCode)) {
        return __WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[2].to;
      }
      if (hardcodedRepublicans.includes(stateCode)) {
        return __WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[2].to;
      }
      if (!marketData.contracts) return 0;
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["v" /* getLeadingTradedContract */])(marketData.contracts);
      if (!targetContract) return 0;
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(targetContract.contractName);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["h" /* roundToTwo */])(targetContract.lastTradePrice + pallette[0].from);
    }
  }, {
    key: 'formatDataLabel',
    value: function formatDataLabel() {
      // if (this.point.stateCode === 'HI') return '';
      var contracts = this.point.marketData.contracts || [];
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["v" /* getLeadingTradedContract */])(contracts);
      var stateCode = this.point.properties['hc-a2'];
      var showStates = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];
      var markWhenRepublicansAhead = ['DE', 'IL', 'MA', 'NH', 'NJ', 'OR', 'RI', 'VA', 'MN', 'NM', 'MI', 'AL'];
      var markWhenDemocratsAhead = ['AZ', 'CO', 'ME', 'MT', 'NC', 'GA', 'IA', 'KS', 'AK', 'KY', 'SC', 'TX', 'AR', 'ID', 'LA', 'MS', 'NE', 'OK', 'SD', 'TN', 'WV', 'WY'];
      if (!targetContract) {
        if (contracts.length > 0) {
          return '-';
        }
        return showStates.includes(stateCode) ? stateCode : '';
        // return stateCode;
      }
      var contract = new __WEBPACK_IMPORTED_MODULE_25__models_contract__["a" /* default */](targetContract);

      var markPrice = targetContract.contractName === 'Republican' && markWhenRepublicansAhead.includes(stateCode) || targetContract.contractName === 'Democratic' && markWhenDemocratsAhead.includes(stateCode);
      if (markPrice) {
        return '<div>' + contract.lastTradePriceAsCents + '\xA2</div>';
      }

      return contract.lastTradePriceAsCents + '\xA2';
    }
  }, {
    key: 'formatTooltip',
    value: function formatTooltip() {
      var index = this.point.index;
      var data = this.point.series.userOptions.data[index];
      var marketData = data.marketData;

      if (!marketData.contracts) return false;
      var instance = new MarketStateTooltipComponent({
        propsData: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, data, {
          type: 'senate'
        })
      });
      instance.$mount();
      return instance.$el.outerHTML;
    }
  }, {
    key: 'getColorAxisStops',
    value: function getColorAxisStops() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED));
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries3 = this.prepareSeries(),
          mapData = _prepareSeries3.mapData,
          statesData = _prepareSeries3.statesData;

      var options = this.getBaseOptions({ mapData: mapData, statesData: statesData });
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, options, {
        title: {
          text: ''
        },
        colorAxis: {
          min: 0,
          dataClasses: this.getColorAxisStops()
        }
      });
    }
  }]);

  return ElectionMapChartSenate;
}(ElectionMapChartOverall);

/***/ }),

/***/ "Q/ey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_menu_button_js__ = __webpack_require__("R1ks");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe4bf8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_button_vue__ = __webpack_require__("rW2y");
function injectStyle (ssrContext) {
  __webpack_require__("UBij")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_menu_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe4bf8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q334":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_multiselect_js__ = __webpack_require__("M32j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ec894f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__ = __webpack_require__("44Nf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_multiselect_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ec894f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q6AZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-unit-slider"},[(_vm.items)?_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(banner){return _c('swiper-slide',{key:banner.carouselId,staticClass:"hero-unit-slider__slide"},[_c('div',{staticClass:"hero-unit-slider__image",style:(_vm.bannerImageStyleModifiers(banner.carouselData.image))}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__content"},[(banner.carouselData.carouselItemHeader.secondLine)?_c('p',{staticClass:"hero-unit-slider__para",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.secondLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemHeader.firstLine)?_c('h2',{staticClass:"hero-unit-slider__headline",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.firstLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemButton)?_c('button',{staticClass:"button button--medium button--submit hero-unit-slider__button",style:(_vm.buttonStyleModifiers(banner.carouselData.carouselItemButton)),domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemButton.text)},on:{"click":function($event){$event.stopPropagation();return _vm.onNavigate(banner)}}}):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q9xH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__("AyQu");





var STEPS = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
  FOURTH: 4
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      STEPS: STEPS
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('whatisnew', ['currentStepIndexFlow1', 'optionSecondStepSelectedFlow1', 'optionThirdStepSelectedFlow1']), {
    isFirstStep: function isFirstStep() {
      return this.currentStepIndexFlow1 === STEPS.FIRST;
    },
    isLastStep: function isLastStep() {
      return this.currentStepIndexFlow1 === STEPS.FOURTH;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingColorPalette', 'setSettingMobileLayout', 'setSettingsAnnouncementCurState']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('whatisnew', ['nextStepFlow1', 'prevStepFlow1']), {
    onPreviousStep: function onPreviousStep() {
      this.prevStepFlow1();
    },
    onNextStep: function onNextStep() {
      var _this = this;

      if (this.currentStepIndexFlow1 === this.STEPS.FIRST) {
        this.nextStepFlow1();
      } else if (this.currentStepIndexFlow1 === this.STEPS.SECOND) {
        this.loaderAdd(document.body);
        this.setSettingColorPalette(this.optionSecondStepSelectedFlow1).then(function () {
          _this.loaderRemove(document.body);
          _this.nextStepFlow1();
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      } else if (this.currentStepIndexFlow1 === this.STEPS.THIRD) {
        this.loaderAdd(document.body);
        this.setSettingMobileLayout(this.optionThirdStepSelectedFlow1).then(function () {
          _this.loaderRemove(document.body);
          _this.nextStepFlow1();
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      } else if (this.currentStepIndexFlow1 === this.STEPS.FOURTH) {
        this.loaderAdd(document.body);
        this.setSettingsAnnouncementCurState(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* VERSION_TO_MIGRATE_TO */]).then(function () {
          _this.loaderRemove(document.body);
          _this.setCurrentPopup();
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      }
    }
  })
});

/***/ }),

/***/ "QA2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_balance_history_balance_history_vue__ = __webpack_require__("aTrv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_export_history_export_history_vue__ = __webpack_require__("cgtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_select_select_vue__ = __webpack_require__("x+uv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__ = __webpack_require__("PMOm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  props: {
    showExport: Boolean
  },
  components: {
    balanceHistory: __WEBPACK_IMPORTED_MODULE_3__components_balance_history_balance_history_vue__["a" /* default */],
    exportHistory: __WEBPACK_IMPORTED_MODULE_4__components_export_history_export_history_vue__["a" /* default */],
    formSelect: __WEBPACK_IMPORTED_MODULE_5__components_forms_select_select_vue__["a" /* default */]
  },
  data: function data() {
    return {
      cancelCounter: 0,
      isResetting: false,
      typeOptions: [],
      yearsOptions: [],
      filter: {
        type: __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__["a" /* ALL_TYPES_OPTION */],
        year: __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__["b" /* ALL_YEARS_OPTION */]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['pendingHistory', 'transactionHistory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('profile', ['transactionFilters']), {
    items: function items() {
      return this.transactionHistory.data === null ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pendingHistory), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.transactionHistory.data));
    },
    canLoadMore: function canLoadMore() {
      return this.transactionHistory.canLoadMore;
    },
    isExportAvailable: function isExportAvailable() {
      return this.showExport && this.transactionHistory && this.transactionHistory.data && this.transactionHistory.data.length > 0;
    }
  }),
  watch: {
    'filter.type': function watchType() {
      if (this.isResetting) return;
      this.handleFilters();
    },
    'filter.year': function watchYear() {
      if (this.isResetting) return;
      this.handleFilters();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getTransactionHistory', 'resetTransactionHistory']), {
    resetFilters: function resetFilters() {
      var _this = this;

      this.isResetting = true;
      this.filter.type = __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__["a" /* ALL_TYPES_OPTION */];
      this.filter.year = __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__["b" /* ALL_YEARS_OPTION */];
      setTimeout(function () {
        _this.isResetting = false;
      }, 100);
    },
    handleFilters: function handleFilters() {
      var canLoadMore = this.transactionHistory.canLoadMore;
      this.resetTransactionHistory();
      if (canLoadMore) this.loadHistory();
    },
    loadHistory: function loadHistory() {
      var _this2 = this;

      if (this.transactionHistory.canLoadMore) {
        var payload = {
          type: this.filter.type.value,
          year: this.filter.year.value
        };
        if (this.isLayoutMobile) {
          this.loaderAdd(document.body);
        }
        this.getTransactionHistory(payload).then(function () {
          if (_this2.isLayoutMobile) {
            _this2.loaderRemove(document.body);
          }
        }).catch(function () {
          if (_this2.isLayoutMobile) {
            _this2.loaderRemove(document.body);
          }
        });
      }
    },
    modalExport: function modalExport() {
      this.$emit('export', 'deposit-withdrawals');
    },
    onItemCancelled: function onItemCancelled() {
      this.resetFilters();
      this.resetTransactionHistory();
      this.cancelCounter += 1;
    }
  })
});

/***/ }),

/***/ "QHOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_price_odds_toggle_popup_js__ = __webpack_require__("OeKd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31cc3cb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_price_odds_toggle_popup_vue__ = __webpack_require__("0S3t");
function injectStyle (ssrContext) {
  __webpack_require__("HUIz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_price_odds_toggle_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31cc3cb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_price_odds_toggle_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QM0A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QM9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_recaptcha__ = __webpack_require__("dSZ5");









var CAPTCHA_FIELD = 'g-recaptcha-response';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */]],
  data: function data() {
    return {
      // attempt counter for v2 fallback rerenders
      attempt: 1,
      fields: {
        email: null
      },
      // Pending payload for v2 fallback retry
      pendingPayload: null
    };
  },

  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].email
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['systemEmails']), {
    resetUrl: function resetUrl() {
      return window.location.protocol + '//' + window.location.host + '/account/password/reset/';
    },
    resetButtonDisabled: function resetButtonDisabled() {
      return this.invalidOrDisabled;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['forgotPassword']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _payload, v3Token, payload;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.formIsValid() && _this.formDisable())) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_recaptcha__["a" /* default */].executeV3('forgot_password');

              case 4:
                v3Token = _context.sent;
                payload = (_payload = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, CAPTCHA_FIELD, v3Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'recaptcha-version', 'v3'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'email', _this.fields.email), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'url', _this.resetUrl), _payload);


                _this.forgotPassword(payload).then(function (data) {
                  _this.formEnable();
                  _this.setSuccessSideNotification(data);
                  _this.setCurrentPopup();
                }).catch(function (error) {
                  // Step 2: Check if v3 failed and v2 challenge is needed
                  if (__WEBPACK_IMPORTED_MODULE_7__services_recaptcha__["a" /* default */].isV3ScoreFailure(error)) {
                    _this.pendingPayload = payload;
                    _this.attempt += 1;
                    _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].RECAPTCHA_CHALLENGE);
                    _this.setCurrentPopupOptions({
                      attempt: _this.attempt,
                      onVerified: _this.onRecaptchaV2Verified
                    });
                    _this.formEnable();
                    return;
                  }

                  _this.attempt += 1;
                  _this.formHandleErrors(error);
                });
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                _this.formEnable();
                _this.formHandleErrors(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    },
    onRecaptchaV2Verified: function onRecaptchaV2Verified(v2Token) {
      var _extends2,
          _this2 = this;

      // Called when user completes v2 challenge in modal
      // Don't switch to forgotten modal yet - keep reCAPTCHA visible during API call

      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.pendingPayload, (_extends2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, CAPTCHA_FIELD, v2Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'recaptcha-version', 'v2'), _extends2));

      this.forgotPassword(payload).then(function (data) {
        _this2.formEnable();
        _this2.setSuccessSideNotification(data);
        _this2.setCurrentPopup();
      }).catch(function (error) {
        // On error, switch back to forgotten modal to show error
        _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].FORGOTTEN);
        _this2.attempt += 1;
        _this2.formHandleErrors(error);
      });
    }
  })
});

/***/ }),

/***/ "QSM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_already_exists_js__ = __webpack_require__("22Ot");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c91ca67c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_already_exists_vue__ = __webpack_require__("hy1J");
function injectStyle (ssrContext) {
  __webpack_require__("R2yQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_already_exists_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c91ca67c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_already_exists_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QV+F":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "QVL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QWrq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    num: {
      type: Number,
      default: 1
    }
  },
  computed: {
    dummyComponents: function dummyComponents() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, this.num);
    }
  }
});

/***/ }),

/***/ "QaeY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_order_book_sushi_order_book_sushi_vue__ = __webpack_require__("kIgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_keyboard_numeric_sushi_keyboard_numeric_sushi_vue__ = __webpack_require__("m1D1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_keyboard_numeric_input_sushi_keyboard_numeric_input_sushi_vue__ = __webpack_require__("JLAi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_purchase_offer_value_sushi_purchase_offer_value_sushi_vue__ = __webpack_require__("W6JW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_purchase_sushi_purchase_quantity_value_sushi_purchase_quantity_value_sushi_vue__ = __webpack_require__("S2nZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__ = __webpack_require__("yzoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_related_contracts_sushi_related_contracts_sushi_vue__ = __webpack_require__("P4uE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_purchase_sushi_purchase_offer_value_picker_mobile_sushi_purchase_offer_value_picker_mobile_sushi_vue__ = __webpack_require__("ziKg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_purchase_sushi_purchase_quantity_picker_mobile_sushi_purchase_quantity_picker_mobile_sushi_vue__ = __webpack_require__("v5l1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__ = __webpack_require__("azKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__("IcnI");


 /* eslint-disable */






















var getDefaultBuyQuantity = function getDefaultBuyQuantity() {
  return __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */].getters['user/isLoggedIn'] ? 1 : 10;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_loader__["a" /* default */]],
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    keyboardNumericSushi: __WEBPACK_IMPORTED_MODULE_7__components_keyboard_numeric_sushi_keyboard_numeric_sushi_vue__["a" /* default */],
    keyboardNumericInputSushi: __WEBPACK_IMPORTED_MODULE_8__components_keyboard_numeric_input_sushi_keyboard_numeric_input_sushi_vue__["a" /* default */],
    orderBookSushi: __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_order_book_sushi_order_book_sushi_vue__["a" /* default */],
    purchaseOfferValueSushi: __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_purchase_offer_value_sushi_purchase_offer_value_sushi_vue__["a" /* default */],
    purchaseQuantityValueSushi: __WEBPACK_IMPORTED_MODULE_10__components_purchase_sushi_purchase_quantity_value_sushi_purchase_quantity_value_sushi_vue__["a" /* default */],
    marketCharts: __WEBPACK_IMPORTED_MODULE_15__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */],
    purchaseTradeTypeSwitcherSushi: __WEBPACK_IMPORTED_MODULE_16__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__["a" /* default */],
    relatedContractsSushi: __WEBPACK_IMPORTED_MODULE_17__components_related_contracts_sushi_related_contracts_sushi_vue__["a" /* default */],
    purchaseOfferValuePickerMobileSushi: __WEBPACK_IMPORTED_MODULE_18__components_purchase_sushi_purchase_offer_value_picker_mobile_sushi_purchase_offer_value_picker_mobile_sushi_vue__["a" /* default */],
    purchaseQuantityPickerMobileSushi: __WEBPACK_IMPORTED_MODULE_19__components_purchase_sushi_purchase_quantity_picker_mobile_sushi_purchase_quantity_picker_mobile_sushi_vue__["a" /* default */],
    marketTradingUnavailableV2: __WEBPACK_IMPORTED_MODULE_20__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__["a" /* default */]
  },
  props: {
    market: {},
    contract: {},
    showRelatedContracts: {
      type: Boolean,
      default: false
    },
    showContractCharts: {
      type: Boolean,
      default: false
    },
    showOrderSlip: {
      type: Boolean,
      default: true
    },
    disablePurchaseOfferWatchers: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      pricePerShareUpdateCount: 0,
      pricePerShare: null,
      quantity: getDefaultBuyQuantity(),
      skipConfirmation: false,
      quantityError: null,
      inputSelected: null,
      submitDisabledBecauseOfSwitch: false,
      directionalOrderState: {
        yes: null,
        no: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isTradingEnabled', 'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'cancelToggle', 'tradeSuccess', 'masterTradeOptions']), {
    componentName: function componentName() {
      return this.$options.name || this.$vnode && this.$vnode.componentOptions.tag || "Unknown Component";
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    isMarketClosed: function isMarketClosed() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["M" /* isMarketClosed */])(this.market);
    },
    minimumOwnership: function minimumOwnership() {
      return Math.max(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.contract, 'minimumClipSize', 1), 1);
    },
    showThresholdInfo: function showThresholdInfo() {
      return this.minimumOwnership > 1;
    },
    minQuantityValue: function minQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return this.contractModel.userQuantity >= this.minimumOwnership ? 1 : Math.min(this.minimumOwnership, this.minimumOwnership - this.contractModel.userQuantity);
      } else {
        return this.contractModel.userQuantity === 0 ? 1 : this.contractModel.userQuantity > this.minimumOwnership ? 1 : this.contractModel.userQuantity;
      }
    },
    maxQuantityValue: function maxQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return 9999;
      } else {
        return this.contractModel.userQuantity === 0 ? 1 : this.contractModel.userQuantity;
      }
    },
    chartOptions: function chartOptions() {
      return {
        include24hr: true,
        include7day: true,
        include30day: true,
        include90day: true,
        includeCandle: true,
        includeLine: true,
        includeLegend: false,
        contractIds: [this.tradeOptions.contractId]
      };
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'purchase-offer-sushi': true,
        'purchase-offer-sushi--maintenance': !this.isTradingEnabled,
        'purchase-offer-sushi--yes': this.tradeOptions.operationValue === 'yes',
        'purchase-offer-sushi--no': this.tradeOptions.operationValue === 'no',
        'purchase-offer-sushi--mobile-inline': true
      }, 'purchase-offer-sushi--' + this.$router.currentRoute.name, true);
    },
    contractModel: function contractModel() {
      return this.contract ? new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.contract) : {};
    },
    contractName: function contractName() {
      if (!this.market || !this.contract) return '';
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["j" /* isMarketSingle */])(this.market)) {
        return this.market.marketShortName || this.market.marketName;
      }
      return this.contract.contractName;
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    mainClassName: function mainClassName() {
      return 'purchase-offer-sushi';
    },
    quantityErrorText: function quantityErrorText() {
      var _getReducedQuantity = this.getReducedQuantity(),
          reduced = _getReducedQuantity.reduced,
          min = _getReducedQuantity.min,
          max = _getReducedQuantity.max;

      if (this.tradeOptions.operationType === 'buy' && this.quantity && this.contractModel.userQuantity + this.quantity < min) {
        var suffix = min === 1 ? 'share' : 'shares';
        return 'You must own at least ' + min + ' ' + suffix + ' in this contract';
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity > this.contractModel.userQuantity) {
        if (this.contractModel.userQuantity === 1) {
          return 'You have only 1 share to sell';
        }
        if (this.contractModel.userQuantity === 0) {
          return "You don't have any shares to sell";
        }
        var _suffix = this.contractModel.userQuantity === 1 ? 'share' : 'shares';
        return 'You only have ' + this.contractModel.userQuantity + ' ' + _suffix + ' to sell';
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity && this.quantity < reduced) {
        var _suffix2 = min === 1 ? 'share' : 'shares';
        return 'You must maintain ownership of at least ' + min + ' ' + _suffix2;
      }
      // CR
      if (this.tradeOptions.operationType === 'sell' && this.quantity && max && this.quantity > max && this.quantity !== this.contractModel.userQuantity) {
        var _suffix3 = min === 1 ? 'share' : 'shares';
        return 'You must maintain ownership of at least ' + min + ' ' + _suffix3;
      }
      return null;
    },
    isPriceValid: function isPriceValid() {
      if (this.pricePerShare === null || isNaN(this.pricePerShare) || this.pricePerShare === 0) {
        return false;
      }
      return true;
    },
    isQuantityValid: function isQuantityValid() {
      if (this.quantity === null || this.quantity === '') return false;
      if (this.tradeOptions.operationType === 'sell') {
        if (this.quantity > this.contractModel.userQuantity) return false;
      }
      return !this.quantityErrorText;
    },
    nextButtonTitle: function nextButtonTitle() {
      if (this.tradeOptions && this.tradeOptions.skipConfirmation) {
        return 'Submit Order';
      }
      if (this.isLayoutDesktop) {
        return 'Next';
      }
      return this.tradeTypeText;
    },
    nextButtonDisabled: function nextButtonDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["M" /* isMarketClosed */])(this.market) || !this.isTradingEnabled || !this.isQuantityValid || !this.isPriceValid || !this.isAvailableForTrade || this.isLoading;
    },
    purchaseOfferKey: function purchaseOfferKey() {
      var timestamp = this.contractModel.timestamp || '-';
      return this.contractModel.contractId + '-' + timestamp + '-' + this.tradeSuccess.toString() + '-' + this.contractModel.mode + '-' + this.contractModel.userOpenOrders + '-' + this.contractModel.userQuantity + '-' + this.tradeOptions.operationType + '-' + this.tradeOptions.operationValue;
    },
    orderBookKey: function orderBookKey() {
      return this.purchaseOfferKey;
    },
    isContractOpen: function isContractOpen() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["A" /* isContractOpen */])(this.contract);
    },
    pricePerShareSuffix: function pricePerShareSuffix() {
      return this.tradeType <= 1 ? 'Max' : 'Min';
    },
    pricePerShareSuffixFull: function pricePerShareSuffixFull() {
      return this.tradeType <= 1 ? 'Maximum' : 'Minimum';
    },
    tradeType: function tradeType() {
      switch (this.tradeOptions.operationType + '_' + this.tradeOptions.operationValue) {
        case 'buy_no':
          return 0;
        case 'buy_yes':
          return 1;
        case 'sell_no':
          return 2;
        case 'sell_yes':
          return 3;
        default:
          return -1;
      }
    },
    tradeTypeText: function tradeTypeText() {
      return this.tradeType <= 1 ? 'Buy' : 'Sell';
    },
    isYesType: function isYesType() {
      return this.tradeType === 1 || this.tradeType === 3;
    },
    yesNoText: function yesNoText() {
      return this.isYesType ? 'YES' : 'NO';
    },
    tradeOperationAndValue: function tradeOperationAndValue() {
      return {
        type: this.tradeOptions.operationType,
        value: this.tradeOptions.operationValue
      };
    },
    isAvailableForTrade: function isAvailableForTrade() {
      if (!this.contractModel.mode) return true;
      return this.contractModel.mode === this.tradeOptions.operationValue;
    },
    showSellWarning: function showSellWarning() {
      return this.contractModel.userQuantity === 0 && this.tradeOptions.operationType === 'sell';
    },
    tradingUnavailableTheme: function tradingUnavailableTheme() {
      if (this.isAfterHours) {
        return 'after-hours';
      }
      return 'maintenance';
    },
    tradingUnavailableText: function tradingUnavailableText() {
      if (this.isAfterHours) {
        return 'Trading is not available during After-hours';
      }
      return 'Trading is not available during Maintenance mode.';
    }
  }),
  watch: {
    'tradeOptions.operationType': function watchOperationType(val, oldVal) {
      var _this = this;

      this.submitDisabledBecauseOfSwitch = true;
      this.pricePerShareUpdateCount += 1;
      if (oldVal && oldVal !== val) {
        this.clearDirectionalOrderState();
      }
      this.setDefaultPrice();
      this.setDefaultQuantity();
      setTimeout(function () {
        _this.submitDisabledBecauseOfSwitch = false;
      }, 500);
    },
    'tradeOptions.operationValue': function watchOperationValue(val, oldVal) {
      var _this2 = this;

      this.submitDisabledBecauseOfSwitch = true;
      this.pricePerShareUpdateCount += 1;
      if (oldVal && oldVal !== val) {
        this.saveDirectionalOrderState(oldVal);
      }
      this.restoreDirectionalOrderState(val);
      setTimeout(function () {
        _this2.submitDisabledBecauseOfSwitch = false;
      }, 500);
    },
    contractModel: function contractModel(value, oldValue) {
      if (oldValue && value && oldValue.contractId !== value.contractId) {
        this.clearDirectionalOrderState();
      }
      if (this.cancelToggle) {
        this.setCancelToggle(false);
      }
    },
    pricePerShare: function pricePerShare(newVal, oldVal) {
      if (!this.disablePurchaseOfferWatchers) {
        this.setTradePrice(newVal);
      }
    },
    quantity: function quantity(newValue, oldValue) {
      if (!this.disablePurchaseOfferWatchers) {
        this.setTradeQuantity(newValue);
      }
    },
    skipConfirmation: function skipConfirmation(value) {
      this.setTradeSkipConfirmation(value);
      this.skipConfirmation = this.tradeOptions.skipConfirmation;
    },
    isQuantityValid: function isQuantityValid(value) {
      if (value === true) this.quantityError = null;
    },
    masterTradeOptions: function masterTradeOptions(value) {
      var quantity = value.quantity,
          pricePerShare = value.pricePerShare;

      this.setQuantityConsolidatingTradeOptions(quantity);
      this.setPriceConsolidatingTradeOptions(pricePerShare);
    },
    tradeSuccess: function tradeSuccess(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.clearDirectionalOrderState();
        this.setDefaultPrice();
        this.setDefaultQuantity();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getMarketRules']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeQuantity', 'setTradePrice', 'setTradeSkipConfirmation', 'setCancelToggle', 'setMasterTradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setGenericSmallPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), {
    shouldPreserveDirectionalOrderState: function shouldPreserveDirectionalOrderState() {
      return !this.isLayoutDesktop;
    },
    saveDirectionalOrderState: function saveDirectionalOrderState() {
      var operationValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tradeOptions.operationValue;

      if (!this.shouldPreserveDirectionalOrderState() || !operationValue) return;

      this.directionalOrderState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.directionalOrderState, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, operationValue, {
        pricePerShare: this.pricePerShare,
        quantity: this.quantity
      }));
    },
    restoreDirectionalOrderState: function restoreDirectionalOrderState() {
      var operationValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tradeOptions.operationValue;

      if (!this.shouldPreserveDirectionalOrderState()) {
        this.setDefaultPrice();
        this.setDefaultQuantity();
        return;
      }

      var savedState = this.directionalOrderState[operationValue];
      if (savedState) {
        this.setPriceConsolidatingTradeOptions(savedState.pricePerShare);
        this.setQuantityConsolidatingTradeOptions(savedState.quantity);
        return;
      }

      this.setDefaultPrice();
      this.setDefaultQuantity();
    },
    clearDirectionalOrderState: function clearDirectionalOrderState() {
      this.directionalOrderState = {
        yes: null,
        no: null
      };
    },
    setDefaultQuantity: function setDefaultQuantity() {
      var _getReducedQuantity2 = this.getReducedQuantity(),
          reduced = _getReducedQuantity2.reduced;

      this.setQuantityConsolidatingTradeOptions(reduced);
    },
    setQuantityConsolidatingTradeOptions: function setQuantityConsolidatingTradeOptions(value) {
      var currentQuantity = this.quantity;
      this.quantity = value;
      if (value !== null && this.tradeOptions.quantity === null) {
        this.setTradeQuantity(value);
      }
    },
    setDefaultPrice: function setDefaultPrice() {
      this.setPriceConsolidatingTradeOptions(this.getDefaultPricePerShare());
    },
    setPriceConsolidatingTradeOptions: function setPriceConsolidatingTradeOptions(value) {
      var currentPrice = this.pricePerShare;
      this.pricePerShare = value;
      if (value !== null && this.tradeOptions.pricePerShare === null) {
        this.setTradePrice(value);
      }
    },
    getDefaultPricePerShare: function getDefaultPricePerShare() {
      var initialPrice = 0;
      // buy
      if (this.tradeOptions.operationType === 'buy') {
        if (this.tradeOptions.operationValue === 'yes') {
          initialPrice = this.contractModel.buyYesCostAsCents;
        } else {
          initialPrice = this.contractModel.buyNoCostAsCents;
        }
      } else if (this.tradeOptions.operationValue === 'yes') {
        // sell
        initialPrice = this.contractModel.sellYesCostAsCents;
      } else {
        initialPrice = this.contractModel.sellNoCostAsCents;
      }

      if (initialPrice === 0) {
        initialPrice = this.contractModel.lastTradePriceAsCents;
        if (initialPrice > 0 && this.tradeOptions.operationValue === 'no') {
          initialPrice = 100 - initialPrice;
        }
      }

      if (initialPrice === 0) {
        initialPrice = 50;
      }

      return initialPrice;
    },
    getReducedQuantity: function getReducedQuantity() {
      if (this.tradeOptions.operationType === 'sell') {
        return this.contractModel.userQuantity === 0 ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: null
        } : this.contractModel.userQuantity > this.minimumOwnership ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: this.contractModel.userQuantity - this.minimumOwnership
        } : {
          reduced: this.contractModel.userQuantity,
          min: this.minimumOwnership,
          max: null
        };
      } else if (this.tradeOptions.operationType === 'buy') {
        return this.contractModel.userQuantity >= this.minimumOwnership ? {
          reduced: getDefaultBuyQuantity(),
          min: this.minimumOwnership,
          max: null
        } : {
          reduced: Math.max(this.minimumOwnership, getDefaultBuyQuantity()),
          min: this.minimumOwnership,
          max: null
        };
      }
    },
    onUpdatePriceAndQuantity: function onUpdatePriceAndQuantity(data) {
      this.setMasterTradeOptions({
        quantity: Math.min(data.quantity, 9999),
        pricePerShare: data.price
      });
    },
    openThresholdInfoPopup: function openThresholdInfoPopup() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_14__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_OWNERSHIP_INFO);
      this.setCurrentPopupOptions({ shares: this.minimumOwnership });
    },
    onClickNext: function onClickNext() {
      if (this.isQuantityValid && !this.isLoading) {
        this.$emit('submit');
      } else {
        this.quantityError = true;
      }
    },
    onClickNextButWithSkipDisabled: function onClickNextButWithSkipDisabled() {
      if (this.isQuantityValid && !this.isLoading) {
        this.$emit('submit-no-skip');
      } else {
        this.quantityError = true;
      }
    }
  }),
  created: function created() {
    if (this.tradeOptions.pricePerShare !== null) {
      this.setQuantityConsolidatingTradeOptions(this.tradeOptions.quantity);
    } else {
      this.setDefaultPrice();
      this.setDefaultQuantity();
    }

    this.pricePerShare = this.tradeOptions.pricePerShare;
    this.skipConfirmation = this.tradeOptions.skipConfirmation;
  }
});

/***/ }),

/***/ "Qbbn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qe7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__ = __webpack_require__("8mrx");


/* eslint-disable object-shorthand */





var A = { label: 'All Players', value: 'ALL' };

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    backButton: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */]],
  data: function data() {
    return {
      filter: {
        type: A,
        time: null
      },
      typeOptions: [A],
      timeOptions: [__WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__["a" /* TIME_OPTIONS */].PAST_WEEK, __WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__["a" /* TIME_OPTIONS */].PAST_MONTH, __WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__["a" /* TIME_OPTIONS */].PAST_YEAR]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('leaderboards', ['selectedLeaderboard']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('leaderboards', ['leaderboardsDateRange']), {
    title: function title() {
      var leaderboardName = this.selectedLeaderboard.leaderBoardName;
      if (leaderboardName === 'All Predictors') {
        return leaderboardName;
      }
      return 'Top ' + leaderboardName;
    }
  }),
  watch: {
    'filter.time': function filterTime(option) {
      this.setLeaderboardsDateRange(option.value);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('leaderboards', ['setLeaderboardsDateRange']), {
    setDefaultTimeFilter: function setDefaultTimeFilter() {
      var _this = this;

      this.filter.time = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__["a" /* TIME_OPTIONS */]).find(function (i) {
        return i.value === _this.leaderboardsDateRange;
      });
    }
  }),
  created: function created() {
    this.setDefaultTimeFilter();
  }
});

/***/ }),

/***/ "QgNJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QgOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_panel_js__ = __webpack_require__("GMue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60aa162c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_panel_vue__ = __webpack_require__("MRk1");
function injectStyle (ssrContext) {
  __webpack_require__("PbpQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_panel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60aa162c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QgQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('static-page-header',{attrs:{"theme":"dark"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      Page Not Found\n    ")])]),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found__content"},[_c('h1',{staticClass:"page-not-found__header-main"},[_vm._v("\n      Error 404\n    ")]),_vm._v(" "),_c('h3',{staticClass:"page-not-found__header-secondary"},[_vm._v("\n      Whoops. It looks as if this page doesn't exist.\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QgYw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qo/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qoh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("G/BR");






var dashboardNotificationMixin = {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: false
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      timeout: null,
      interacted: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['remove']), {
    onClose: function onClose() {
      this.remove(this.index);
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__logger__["b" /* isDebugOn */])()) {
      this.timeout = setTimeout(function () {
        if (!_this.interacted) _this.onClose();
      }, this.closeTimeout);
    }
  },

  computed: {
    timeElapsed: function timeElapsed() {
      var elapsed = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.data.dateCreated).fromNow(true);
      return elapsed + ' ago';
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (dashboardNotificationMixin);

/***/ }),

/***/ "QrTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__ = __webpack_require__("Rx49");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8581273e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podcasts_vue__ = __webpack_require__("F/Vy");
function injectStyle (ssrContext) {
  __webpack_require__("MIwN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8581273e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podcasts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QxNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"trades"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('history-filters',{attrs:{"recent":_vm.recent,"isOpen":_vm.isOpen,"markets":_vm.tradedMarkets},model:{value:(_vm.activeFilter),callback:function ($$v) {_vm.activeFilter=$$v},expression:"activeFilter"}})],1),_vm._v(" "),(_vm.showMessage)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"trades__message"},[(_vm.$route.query.contractId)?[_vm._v("\n          Click "),_c('strong',[_c('router-link',{attrs:{"to":{ name: 'account-history', params: { marketId: _vm.market.marketId } }}},[_vm._v("here")])],1),_vm._v(" to see your History in all Contracts.\n        ")]:[_vm._v("\n          To see your History in an individual Contract, click on the Contract name.\n        ")]],2)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isOpen),expression:"!isOpen"}],staticClass:"column small-12"},[_c('contracts-history',{attrs:{"hasFilter":_vm.activeFilter !== null,"contracts":_vm.filteredContracts,"showMarketNames":_vm.showMarketNames,"canLoadMore":_vm.canLoadMore},on:{"loading":_vm.loadHistory}})],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QxUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "R/N+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_list_js__ = __webpack_require__("KUSN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fceef74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_list_vue__ = __webpack_require__("/3CK");
function injectStyle (ssrContext) {
  __webpack_require__("/s1U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fceef74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R1ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'sushi'
    },
    selected: {
      type: Boolean,
      default: false
    },
    filtersSelected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {
        'market-filters-menu-button': true,
        'market-filters-menu-button--active': this.active,
        'market-filters-menu-button--arrow': this.arrow,
        'market-filters-menu-button--selected': this.selected,
        'market-filters-menu-button--filters-selected': this.filtersSelected
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-filters-menu-button--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-filters-menu-button--' + this.type, this.type), _ref;
    }
  },
  methods: {
    click: function click(e) {
      e.stopPropagation();
      this.$emit('click', this.type);
    }
  }
});

/***/ }),

/***/ "R2yQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R6p5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__ = __webpack_require__("DECz");




/* harmony default export */ __webpack_exports__["a"] = ({
  getHeaders: function getHeaders() {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Headers');
  },
  getFilters: function getFilters(headerId) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Filters/' + headerId);
  },
  getFilteredMarkets: function getFilteredMarkets(headerId, itemsPerPage, page, filterIds, sort, sortParameter) {
    var query = __WEBPACK_IMPORTED_MODULE_0_querystring___default.a.stringify({
      itemsPerPage: itemsPerPage,
      page: page,
      filterIds: filterIds,
      sort: sort,
      sortParameter: sortParameter
    });
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/' + headerId + '?' + query);
  },
  getNewArrivalMarkets: function getNewArrivalMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=newest&excludeMarketsOutsidePriceLimit=true&sortParameter=');
  },
  getMostPredictedMarkets: function getMostPredictedMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=traded&excludeMarketsOutsidePriceLimit=true&sortParameter=ALL');
  },
  getTrendingMarkets: function getTrendingMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=traded&excludeMarketsOutsidePriceLimit=true&sortParameter=TODAY');
  },
  getBiggestMoverMarkets: function getBiggestMoverMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=movers&excludeMarketsOutsidePriceLimit=true&sortParameter=TODAY');
  },
  getCarousel: function getCarousel() {
    var utmSource = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].get('utm_source');
    if (utmSource) {
      utmSource = utmSource.value;
    }
    var utmCampaign = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].get('utm_campaign');
    if (utmCampaign) {
      utmCampaign = utmCampaign.value;
    }
    var utmCode = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCode) {
      utmCode = utmCode.value;
    }
    var PIReferral = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].get('PIReferral');
    if (PIReferral) {
      PIReferral = PIReferral.value;
    }
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Carousel?promoCode=' + utmCode + '&marketingProgram=' + utmCampaign + '&marketingSource=' + utmSource + '&piReferral=' + PIReferral);
  },
  getSearch: function getSearch(query) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var itemsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Search/' + query + '?page=' + page + '&itemsPerPage=' + itemsPerPage);
  },
  getHomePageGainModule: function getHomePageGainModule() {
    var isLoss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var contracts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Browse/HomePage/GainModule?isLoss=' + isLoss + '&days=' + days + '&contracts=' + contracts : 'api/Browse/HomePage/GainModule?isLoss=' + isLoss + '&days=' + days + '&contracts=' + contracts;
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get(url);
  },
  getWidgets: function getWidgets() {
    // const url = process.env.USE_API_WRAPPER ?
    //   'api/Public/GetLiveData?url=/api/Browse/Widgets' :
    //   'api/Browse/Widgets';
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('/api/Browse/Widgets');
  },
  getStoriesNav: function getStoriesNav() {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Stories/Nav');
  },
  getStoriesList: function getStoriesList(indexes) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Stories/List?indexes=' + indexes.join(','));
  },
  getStory: function getStory(index) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Stories/' + index);
  },
  getStoryDetail: function getStoryDetail(index) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Stories/' + index + '/Detail');
  },
  getStaticPageDetail: function getStaticPageDetail(key) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/StaticPage/' + key);
  },
  getStaticPagePreview: function getStaticPagePreview(id) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/StaticPagePreview/' + id);
  },
  getStoryFullPreview: function getStoryFullPreview(id) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/StoryFullPreview/' + id);
  }
});

/***/ }),

/***/ "R7qn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RDmN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RGPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    market: {},
    contract: {},
    hideSharesBar: {
      type: Boolean,
      default: false
    }
  },
  components: {
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_4__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['currentPriceSymbol', 'isLayoutMobile']), {
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    contractModel: function contractModel() {
      return this.contract ? new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](this.contract) : {};
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    }
  })
});

/***/ }),

/***/ "RIFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-rules"},[_c('div',{staticClass:"sushi-market-rules__title"},[_vm._v("\n    Rules\n  ")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-rules__content"},[_c('market-rules',{attrs:{"market":_vm.market,"showExpanded":true,"dateEnd":_vm.market.dateEndString,"rules":_vm.market.rule}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RJiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");



/* eslint-disable max-len */




var WIDTH_PERCENTAGE_THRESHOLD = 5;

var getWidth = function getWidth(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["h" /* roundToTwo */])(value) * 100;
};
var checkThreshold = function checkThreshold(obj) {
  var value = parseInt(obj.width.replace('%', ''), 10);
  return value >= WIDTH_PERCENTAGE_THRESHOLD;
};

var updateCounters = function updateCounters(_ref) {
  var price = _ref.price,
      counter = _ref.counter,
      stateVotes = _ref.stateVotes;

  if (price <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].LOW) {
    counter.low += stateVotes;
  } else if (price <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].MEDIUM) {
    counter.medium += stateVotes;
  } else if (price <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].HIGH) {
    counter.high += stateVotes;
  }
  counter.total += stateVotes;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mapStateData: {},
    type: {}
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    isSenate: function isSenate() {
      return this.type === 'senate';
    },
    show: function show() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.mapStateData).length > 0;
    },
    barStyleModifiers: function barStyleModifiers() {
      // to right pad in case width does not equal 100
      var color = __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color;
      if (this.republican.high === 0) {
        color = __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color;
      }
      return {
        background: color
      };
    },
    democratLabelStyleModifiers: function democratLabelStyleModifiers() {
      return {
        color: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanLabelStyleModifiers: function republicanLabelStyleModifiers() {
      return {
        color: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democratic: function democratic() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.mapStateData).filter(function (i) {
        var targetContract = _this.getTargetContract(i);
        return targetContract && targetContract.contractName === __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["d" /* CONTRACTS */].DEMOCRATIC;
      });
    },
    democraticCounters: function democraticCounters() {
      var _this2 = this;

      var counter = {
        total: 5,
        low: 0,
        medium: 0,
        high: 5,
        predefinedReal: 0
      };
      if (this.isSenate) {
        counter.predefined = 14; // wont be displayed, used to reserve width
        counter.predefinedReal = 36;
        // 5 demo
        // 12 repub
      }
      this.democratic.forEach(function (i) {
        var targetContract = _this2.getTargetContract(i);
        if (!targetContract) {
          return;
        }
        var stateVotes = _this2.isSenate ? 1 : i.stateVotes;
        updateCounters({
          counter: counter,
          price: targetContract.lastTradePrice,
          stateVotes: stateVotes
        });
      });
      return counter;
    },
    republican: function republican() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.mapStateData).filter(function (i) {
        var targetContract = _this3.getTargetContract(i);
        return targetContract && targetContract.contractName === __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["d" /* CONTRACTS */].REPUBLICAN;
      });
    },
    republicanCounters: function republicanCounters() {
      var _this4 = this;

      var counter = {
        total: 12,
        low: 0,
        medium: 0,
        high: 12,
        predefinedReal: 0
      };
      if (this.isSenate) {
        counter.predefined = 8; // wont be displayed, used to reserve width
        counter.predefinedReal = 29;
      }
      this.republican.forEach(function (i) {
        var targetContract = _this4.getTargetContract(i);
        if (!targetContract) {
          return;
        }
        var stateVotes = _this4.isSenate ? 1 : i.stateVotes;
        updateCounters({
          counter: counter,
          price: targetContract.lastTradePrice,
          stateVotes: stateVotes
        });
      });
      return counter;
    },
    totalVotes: function totalVotes() {
      return this.republicanCounters.total + this.democraticCounters.total;
    },
    democraticPredefinedBarSectionStyleModifiers: function democraticPredefinedBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.predefined / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democraticHighBarSectionStyleModifiers: function democraticHighBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.high / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democraticMediumBarSectionStyleModifiers: function democraticMediumBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.medium / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color
      };
    },
    democraticLowBarSectionStyleModifiers: function democraticLowBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.low / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].LOW].color
      };
    },
    republicanPredefinedBarSectionStyleModifiers: function republicanPredefinedBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.predefined / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanHighBarSectionStyleModifiers: function republicanHighBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.high / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanMediumBarSectionStyleModifiers: function republicanMediumBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.medium / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color
      };
    },
    republicanLowBarSectionStyleModifiers: function republicanLowBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.low / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].LOW].color
      };
    },
    showDemocraticHighText: function showDemocraticHighText() {
      return this.democraticCounters.high > 0 && checkThreshold(this.democraticHighBarSectionStyleModifiers);
    },
    showDemocraticMediumText: function showDemocraticMediumText() {
      return this.democraticCounters.medium > 0 && checkThreshold(this.democraticMediumBarSectionStyleModifiers);
    },
    showDemocraticLowText: function showDemocraticLowText() {
      return this.democraticCounters.low > 0 && checkThreshold(this.democraticLowBarSectionStyleModifiers);
    },
    showRepublicanHighText: function showRepublicanHighText() {
      return this.republicanCounters.high > 0 && checkThreshold(this.republicanHighBarSectionStyleModifiers);
    },
    showRepublicanMediumText: function showRepublicanMediumText() {
      return this.republicanCounters.medium > 0 && checkThreshold(this.republicanMediumBarSectionStyleModifiers);
    },
    showRepublicanLowText: function showRepublicanLowText() {
      return this.republicanCounters.low > 0 && checkThreshold(this.republicanLowBarSectionStyleModifiers);
    },
    showDemocraticPredefinedText: function showDemocraticPredefinedText() {
      return true;
    },
    showRepublicanPredefinedText: function showRepublicanPredefinedText() {
      return true;
    },
    majorityText: function majorityText() {
      if (this.isSenate) {
        return this.isLayoutDesktop ? '50 Seats' : '50';
      }
      return 'Majority';
    }
  }),
  methods: {
    getTargetContract: function getTargetContract(data) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["v" /* getLeadingTradedContract */])(data && data.contracts || []);
    }
  }
});

/***/ }),

/***/ "RKVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-numeric-input-sushi-wrap",on:{"click":function($event){$event.stopPropagation();return _vm.click($event)}}},[_c('div',{staticClass:"keyboard-numeric-input-sushi",class:_vm.selectedModifier,domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),(_vm.symbol)?[_c('span',{staticClass:"keyboard-numeric-input-sushi__symbol"},[_vm._v("\n      ¢\n    ")])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RMkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debug"},[_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RO1L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-info"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.loaderItems(2)),function(item){return _c('div',{staticClass:"content-loader-item"},[_c('leaderboards-info-loader')],1)}),0):[(!_vm.showLeaderboards)?_c('div',{staticClass:"leaderboards-info__message"},[_vm._v("\n      Go to "),_c('router-link',{staticClass:"leaderboards-info__link",attrs:{"to":{ name: 'account-settings'}}},[_vm._v("Settings")]),_vm._v(" to opt to have your rank shown on the Leaderboards.\n    ")],1):[_vm._l((_vm.items),function(item){return _c('div',{key:item.leaderBoardId,class:_vm.sectionClassModifiers(item),on:{"click":function($event){return _vm.onSectionClick(item)}}},[_c('div',{staticClass:"leaderboards-info-section-title"},[_vm._v("\n          "+_vm._s(_vm._f("pluralize")(item.leaderBoardName))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-info-section-position"},[(item.predefined)?_c('div',{staticClass:"leaderboards-info__number leaderboards-info__number--no-margin"},[_vm._v("\n            Not Ranked\n          ")]):_c('div',{staticClass:"leaderboards-info__number"},[_vm._v("\n            "+_vm._s(item.leaderBoardPosition)+"\n            "),_c('div',{staticClass:"leaderboards-info__number-suffix"},[_vm._v("\n              "+_vm._s(_vm.getOrdinalSuffix(item.leaderBoardPosition))+"\n            ")])])])])}),_vm._v(" "),_c('div',{staticClass:"leaderboards-info__note"},[_vm._v("\n        Leaderboards are updated nightly.\n      ")])]]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ROsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_avatar_js__ = __webpack_require__("dOsu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b58ade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_avatar_vue__ = __webpack_require__("JwZy");
function injectStyle (ssrContext) {
  __webpack_require__("sl5T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_avatar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b58ade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RPGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-research"},[_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"showCloseButton":true,"title":"Research Opportunities"}}):_c('div',{staticClass:"page-research__desktop-header"},[_c('router-link',{staticClass:"page-research__back",attrs:{"to":{name: 'home'},"tag":"span"}},[_vm._v("\n        Research Opportunities\n      ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('research')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RQ5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__ = __webpack_require__("L8Dv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_566a5c2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__ = __webpack_require__("kGUT");
function injectStyle (ssrContext) {
  __webpack_require__("7lSu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_566a5c2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RSTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase__ = __webpack_require__("OAqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");









var PROVIDER_FACEBOOK = 'Facebook';
var PROVIDER_TWITTER = 'Twitter';
var PROVIDER_GOOGLE = 'Google';
var CACHE_NAME = 'register-external';
var MAX_USERNAME_LENGTH = 14;
var MAX_EMAIL_LENGTH = 50;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_externalLinks__["a" /* default */]],
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].email, {
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(MAX_EMAIL_LENGTH)
      }),
      emailConfirmation: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].emailConfirmation('email'), {
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(MAX_EMAIL_LENGTH)
      }),
      username: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].username
    }
  },
  data: function data() {
    return {
      fields: {
        email: '',
        emailConfirmation: '',
        username: ''
      },
      error: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['formDataCache'])),
  mounted: function mounted() {
    if (this.userInfo && this.userInfo.userName) {
      this.fields.username = this.getNormalizedSuggestedUserName(this.userInfo.userName);
      this.$v.fields.username.$touch();
    }
    if (this.formDataCache !== null && CACHE_NAME === this.formDataCache.route) {
      this.fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.fields, this.formDataCache);
    }
    if (this.fields.email) {
      this.$v.fields.email.$touch();
    }
    if (this.fields.emailConfirmation) {
      this.$v.fields.emailConfirmation.$touch();
    }
  },

  watch: {
    userInfo: function userInfo() {
      this.fields.username = this.getNormalizedSuggestedUserName(this.userInfo.userName);
      this.$v.fields.username.$touch();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['registerExternal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'cacheFormData']), {
    closePopupAndRedirect: function closePopupAndRedirect() {
      var _this = this;

      this.setCurrentPopup();
      this.getExternalLogins({}).then(function (response) {
        _this.links = response.data;
        var provider = _this.userInfo.loginProvider;
        switch (provider) {
          case PROVIDER_FACEBOOK:
            _this.facebookLinkClick();
            break;
          case PROVIDER_TWITTER:
            _this.twitterLinkClick();
            break;
          case PROVIDER_GOOGLE:
            _this.googleLinkClick();
            break;
          default:
            break;
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: 'Create Account'
      });
      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          email: this.fields.email,
          userName: this.fields.username
        };
        this.registerExternal(payload).then(this.formEnable).then(function () {
          __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('registeredExternal', true);
          _this2.closePopupAndRedirect();
        }).catch(function (error) {
          return _this2.formHandleErrors(error);
        });
      }
    },

    // Normalize only provider-suggested defaults (and cap at backend max length).
    // We intentionally do not re-normalize at submit time so the validated input value
    // the user sees is exactly what gets posted.
    getNormalizedSuggestedUserName: function getNormalizedSuggestedUserName(value) {
      if (!value) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase___default()(value).slice(0, MAX_USERNAME_LENGTH);
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.cacheFormData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.fields, { route: CACHE_NAME }));
  }
});

/***/ }),

/***/ "RU3U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_item_js__ = __webpack_require__("ygM9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be52743_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_item_vue__ = __webpack_require__("Ijuz");
function injectStyle (ssrContext) {
  __webpack_require__("X/wz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_item_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be52743_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RZEf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RZj3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RaQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_social_share_invite_widget_share_invite_widget_vue__ = __webpack_require__("dDcj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_leaderboards_leaderboards_levels_leaderboards_levels_vue__ = __webpack_require__("qvFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_leaderboards_leaderboards_table_leaderboards_table_vue__ = __webpack_require__("hQjR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_leaderboards_leaderboards_toolbar_leaderboards_toolbar_vue__ = __webpack_require__("YfnU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_headerTags__ = __webpack_require__("cgm0");











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_headerTags__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  components: {
    leaderboardsLevels: __WEBPACK_IMPORTED_MODULE_5__components_leaderboards_leaderboards_levels_leaderboards_levels_vue__["a" /* default */],
    leaderboardsTable: __WEBPACK_IMPORTED_MODULE_6__components_leaderboards_leaderboards_table_leaderboards_table_vue__["a" /* default */],
    leaderboardsToolbar: __WEBPACK_IMPORTED_MODULE_7__components_leaderboards_leaderboards_toolbar_leaderboards_toolbar_vue__["a" /* default */],
    shareInviteWidget: __WEBPACK_IMPORTED_MODULE_4__components_social_share_invite_widget_share_invite_widget_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Leaderboards',
      link: [{ rel: 'canonical', href: '' + window.location.href }],
      meta: [{ itemprop: 'image', content: window.location.origin + '/static/logo.png' }, { property: 'og:title', content: 'Leaderboards' }, { property: 'og:type', content: 'article' }, { property: 'og:image', content: window.location.origin + '/static/logo.png' }, { property: 'og:site_name', content: 'Predictit' }, { property: 'og:url', content: '' + window.location.href }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('leaderboards', ['selectedLeaderboard']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('leaderboards', ['selectedLeaderboardId', 'leaderboardsDateRange'])),
  watch: {
    selectedLeaderboardId: function selectedLeaderboardId(value) {
      if (value === null || this.leaderboardsDateRange === null) return;

      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: value,
          dateRange: this.leaderboardsDateRange
        }
      });
    },
    leaderboardsDateRange: function leaderboardsDateRange(value) {
      if (value === null || this.selectedLeaderboardId === null) return;

      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: this.selectedLeaderboardId,
          dateRange: value
        }
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('leaderboards', ['clearSelectedLeaderboardId', 'resetLeaderboardsDateRange']), {
    onBackClick: function onBackClick() {
      this.clearSelectedLeaderboardId();
      this.resetLeaderboardsDateRange();
      this.$router.push({ name: 'leaderboards' });
    }
  }),
  created: function created() {
    this.reorganizeTags();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearSelectedLeaderboardId();
    this.resetLeaderboardsDateRange();
  }
});

/***/ }),

/***/ "RbF8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_plus_minus_sign_plus_minus_sign_vue__ = __webpack_require__("T2le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_purchase_sushi_purchase_extended_betslip_contract_info_purchase_extended_betslip_contract_info_vue__ = __webpack_require__("uY0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api__ = __webpack_require__("H/Zg");












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_loader__["a" /* default */]],
  props: {
    market: {}
  },
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_2__components_generics_alert_box_alert_box_vue__["a" /* default */],
    plusMinusSign: __WEBPACK_IMPORTED_MODULE_3__components_generics_plus_minus_sign_plus_minus_sign_vue__["a" /* default */],
    purchaseExtendedBetslipContractInfo: __WEBPACK_IMPORTED_MODULE_8__components_purchase_sushi_purchase_extended_betslip_contract_info_purchase_extended_betslip_contract_info_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MODALS: __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__["a" /* MODALS */],
      isExpanded: false,
      isEnabled: false,
      timeout: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'confirmationData']), {
    dontShowMultiples: function dontShowMultiples() {
      return !this.isYesType && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["f" /* hasNoPositionInAMarketBesidesLoadedContract */])({ market: this.market, contract: this.contract });
    },
    contract: function contract() {
      var _this = this;

      if (!this.tradeOptions.contractId) return null;
      var contracts = this.market.contracts || this.market.marketContracts;
      return contracts.find(function (c) {
        return c.contractId === _this.tradeOptions.contractId;
      });
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_6__models_contract__["a" /* default */](this.contract);
    },
    outsideOfPriceBoundsWarningText: function outsideOfPriceBoundsWarningText() {
      var value = null;
      var threshold = 10;
      if (this.isBuyTradeType) {
        value = this.isYesType ? this.contractModel.buyYesCostAsCents : this.contractModel.buyNoCostAsCents;
      } else {
        value = this.isYesType ? this.contractModel.sellYesCostAsCents : this.contractModel.sellNoCostAsCents;
      }

      if (!value) {
        return '';
      }

      if (this.isBuyTradeType && this.pricePerShare > value + threshold) {
        return 'This order is more than 10¢ above the current market price. Please verify order before submitting.';
      }

      if (!this.isBuyTradeType && this.pricePerShare < value - threshold) {
        return 'This order is more than 10¢ below the current market price. Please verify order before submitting.';
      }
      return '';
    },
    pricePerShare: function pricePerShare() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(this.confirmationData.pricePerShare);
    },
    pricePerShareDisplay: function pricePerShareDisplay() {
      return this.pricePerShare + '\xA2';
    },
    pricePerSharePrefix: function pricePerSharePrefix() {
      return this.confirmationData.tradeType <= 1 ? 'Max' : 'Min';
    },
    tradeTypeText: function tradeTypeText() {
      return this.isBuyTradeType ? 'Buy' : 'Sell';
    },
    isBuyTradeType: function isBuyTradeType() {
      return this.confirmationData.tradeType <= 1;
    },
    isYesType: function isYesType() {
      return this.confirmationData.tradeType === 1 || this.confirmationData.tradeType === 3;
    },
    isNoType: function isNoType() {
      return this.confirmationData.tradeType === 0 || this.confirmationData.tradeType === 2;
    },
    yesNoText: function yesNoText() {
      return this.isYesType ? 'YES' : 'NO';
    },
    classModifiers: function classModifiers() {
      return {
        'purchase-review-and-confirm-sushi': true,
        'purchase-review-and-confirm-sushi--yes': this.isYesType,
        'purchase-review-and-confirm-sushi--no': this.isNoType
      };
    },
    profits: function profits() {
      return this.confirmationData.tradeProfit || 0;
    },
    fees: function fees() {
      return this.confirmationData.fee || null;
    },
    riskAdjustment: function riskAdjustment() {
      return this.confirmationData.estimatedRisk || null;
    },
    orderTotal: function orderTotal() {
      return this.confirmationData.orderTotal;
    },
    showProfitOrLoss: function showProfitOrLoss() {
      var types = [2, 3];
      var tradeType = this.confirmationData.tradeType;
      return this.profits !== 0 || types.includes(tradeType);
    },
    profitOrLoss: function profitOrLoss() {
      var profit = this.profits || 0;
      return profit > 0 ? 'Profit' : 'Loss';
    },
    payoutDisplay: function payoutDisplay() {
      if (this.tradeOptions.operationType === 'sell') {
        var price = this.tradeOptions.quantity * this.tradeOptions.pricePerShare;
        if (price < 100) {
          return price + '\xA2+';
        }
        return '$' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* roundToTwo */])(this.tradeOptions.quantity * this.tradeOptions.pricePerShare / 100).toFixed(2) + '+';
      }
      return '$' + this.tradeOptions.quantity;
    },
    tradeType: function tradeType() {
      switch (this.tradeOptions.operationType + '_' + this.tradeOptions.operationValue) {
        case 'buy_no':
          return 0;
        case 'buy_yes':
          return 1;
        case 'sell_no':
          return 2;
        case 'sell_yes':
          return 3;
        default:
          return -1;
      }
    },
    nextButtonDisabled: function nextButtonDisabled() {
      var isSufficientFundsWarning = this.confirmationData.isTradeWarningMessage && this.confirmationData.isTradeWarningMessage.toLowerCase().includes('you do not have sufficient funds to place this order');

      return !this.confirmationData.showSubmitTradeButton || !this.isEnabled || isSufficientFundsWarning;
    },
    nextButtonClassModifiers: function nextButtonClassModifiers() {
      return {
        'purchase-review-and-confirm-sushi__footer-next-button': true,
        'purchase-review-and-confirm-sushi__footer-next-button--yes': this.isYesType && !this.nextButtonDisabled,
        'purchase-review-and-confirm-sushi__footer-next-button--no': !this.isYesType && !this.nextButtonDisabled,
        'purchase-review-and-confirm-sushi__footer-next-button--disabled': this.nextButtonDisabled
      };
    },
    buyPrice: function buyPrice() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* roundToTwo */])(this.tradeOptions.quantity * this.pricePerShare / 100).toFixed(2);
    },
    multiple: function multiple() {
      var result = 100 / this.pricePerShare;
      var rounded = Math.round(result * 100) / 100;
      return rounded % 1 === 0 ? Math.round(rounded) : rounded;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setGenericSmallPopup', 'setCurrentPopupOptions', 'setCurrentPopup', 'setTradePopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['clearTradedMarkets']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'clearOrderBook', 'setConfirmationData', 'setConfirmationDoneData', 'setIsInConfirmationMode', 'submitTrade', 'setTradeSuccess', 'setBottomBetSlipExtendedMode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['addSimple']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['setMarketEngineBusyMessage']), {
    onReadRules: function onReadRules() {
      var _this2 = this;

      this.loaderAdd();
      __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].market.getMarket(this.market.marketId).then(function (response) {
        var data = response.data;

        _this2.setGenericSmallPopup({
          name: __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MARKET_RULES,
          options: {
            title: 'The Rules',
            market: data
          }
        });
        _this2.loaderRemove();
      }).catch(function () {
        return _this2.loaderRemove();
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    getErrorFromResponse: function getErrorFromResponse(response) {
      if (!response) return '';
      if (typeof response.data === 'string') {
        return response.data;
      }
      return response.data ? response.data.message : '';
    },
    onClose: function onClose() {
      this.setCurrentPopup();
      this.setTradePopupOptions({});
      // this.setTradeOptions(null);
    },
    onClickAmend: function onClickAmend() {
      this.setConfirmationData(null);
      this.setConfirmationDoneData(null);
      this.setIsInConfirmationMode(false);
      this.onClose();
    },
    onClickSubmit: function onClickSubmit() {
      var _this3 = this;

      this.loaderAdd();
      var payload = {
        quantity: this.tradeOptions.quantity,
        pricePerShare: this.tradeOptions.pricePerShare,
        contractId: this.tradeOptions.contractId,
        tradeType: this.tradeType
      };

      this.submitTrade(payload).then(function (response) {
        var data = response.data;
        _this3.$gtm.trackEvent({ event: 'Trade' });
        _this3.loaderRemove();
        _this3.setConfirmationData(null);
        _this3.setConfirmationDoneData(data);
        _this3.addSimple({
          externalId: data.offer ? data.offer.offerId : null,
          closeTimeout: 3500,
          icon: 'pending',
          text: 'You will be notified when processing is complete.',
          title: 'Order Received'
        });
        _this3.setMarketEngineBusyMessage({
          isEngineBusy: data.isEngineBusy,
          isEngineBusyMessage: data.isEngineBusyMessage
        });
        _this3.setTradeSuccess(true);
        _this3.setBottomBetSlipExtendedMode(false);
        _this3.clearTradedMarkets();
        var isBuyTradeType = [0, 1].includes(_this3.tradeType);
        __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["a" /* default */].showMessagingJourney(isBuyTradeType);
      }).catch(function (error) {
        _this3.setTradeSuccess(false);
        _this3.loaderRemove();
        var message = _this3.getErrorFromResponse(error.response);
        if (message) {
          _this3.addSimple({
            title: 'Error Occurred',
            icon: 'cancel',
            text: message
          });
        }
      });
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.setIsInConfirmationMode(false);
    if (this.timeout !== null) {
      clearTimeout(this.timeout);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.timeout = setTimeout(function () {
      _this4.isEnabled = true;
    }, 0);
  }
});

/***/ }),

/***/ "RdAN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_history_sushi_product_history_sushi_vue__ = __webpack_require__("4gzO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_trade_history_sushi_trade_history_sushi_vue__ = __webpack_require__("Xkgz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sushi_market_links_toggle_sushi_market_links_toggle_vue__ = __webpack_require__("S77G");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    productHistorySushi: __WEBPACK_IMPORTED_MODULE_2__components_product_history_sushi_product_history_sushi_vue__["a" /* default */],
    tradeHistorySushi: __WEBPACK_IMPORTED_MODULE_3__components_trade_history_sushi_trade_history_sushi_vue__["a" /* default */],
    sushiMarketLinksToggle: __WEBPACK_IMPORTED_MODULE_4__components_sushi_market_links_toggle_sushi_market_links_toggle_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']))
});

/***/ }),

/***/ "Rl7k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"nav-browse__container"},[_c('div',{staticClass:"nav-browse__slide nav-browse__slide--categories"},[_c('div',{staticClass:"nav-browse__item"},[_c('span',{staticClass:"nav-browse__link nav-browse__link--categories",on:{"click":_vm.toggleCategoriesLabel}},[_c('span',{class:_vm.categoriesIcon}),_vm._v(" "),_c('transition',{attrs:{"name":"nav-browse"}},[(_vm.isCategoriesLabelVisible)?_c('span',{staticClass:"nav-browse__link-text nav-browse__link-text--categories"},[_vm._v("Categories:")]):_vm._e()])],1)])]),_vm._v(" "),_vm._l((_vm.externalBrowseHeaders),function(item){return _c('div',{key:item.headerId,staticClass:"nav-browse__slide"},[_c('div',{staticClass:"nav-browse__item"},[(item.name)?_c('router-link',{staticClass:"nav-browse__link",attrs:{"to":{name: item.name}}},[(item.icon)?_c('span',{class:_vm.iconClassModifiers(item)}):_vm._e(),_vm._v(" "+_vm._s(item.title)+"\n        ")]):(item.href)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"nav-browse__link",attrs:{"href":item.href}},[(item.icon)?_c('span',{class:_vm.iconClassModifiers(item)}):_vm._e(),_vm._v(" "+_vm._s(item.title)+"\n        ")]):_vm._e()],1)])}),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"nav-browse__slide"},[_c('div',{staticClass:"nav-browse__item"},[_c('router-link',{staticClass:"nav-browse__link",class:{'router-link-active': _vm.isAllMarketsLinkActive},attrs:{"to":{name: 'market-list', params: {headerId: 'all'}}}},[_vm._v("\n          All\n        ")])],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.categoryBrowseHeaders),function(item){return _c('div',{key:item.headerId,staticClass:"nav-browse__slide"},[_c('div',{staticClass:"nav-browse__item"},[_c('router-link',{staticClass:"nav-browse__link",attrs:{"to":{name: 'market-list', params: {headerId: item.headerId, headerUrl: item.headerUrl}}}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])],1)])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rlrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_vue__ = __webpack_require__("O43h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__ = __webpack_require__("DbLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_auth_account_social_auth_vue__ = __webpack_require__("cEur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_history_history_vue__ = __webpack_require__("kNWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_settings_settings_vue__ = __webpack_require__("YCiF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_profile_page_profile_page_vue__ = __webpack_require__("8nLW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_login_page_login_vue__ = __webpack_require__("8G+U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_page_forgotten_password_page_forgotten_password_vue__ = __webpack_require__("FezS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_page_register_page_register_vue__ = __webpack_require__("gVgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_page_tax_detail_page_tax_detail_vue__ = __webpack_require__("xth1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_account_account_disqus_account_disqus_vue__ = __webpack_require__("IwtE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_wallet_wallet_vue__ = __webpack_require__("sBpB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_home_home_old_home_old_vue__ = __webpack_require__("3Uxo");
















/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/account',
  component: __WEBPACK_IMPORTED_MODULE_0__components_account_account_vue__["a" /* default */],
  props: true,
  meta: {
    requiresAuth: true
  },
  children: [{
    path: 'wallet',
    name: 'wallet',
    component: __WEBPACK_IMPORTED_MODULE_11__components_wallet_wallet_vue__["a" /* default */]
  }, {
    path: '',
    name: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_5__components_account_profile_page_profile_page_vue__["a" /* default */],
    props: true
  }, {
    path: 'details',
    name: 'account-details',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'details/update',
    name: 'details-update',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'address/update',
    name: 'address-update',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'password/update',
    name: 'password-update',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'password/set',
    name: 'password-set',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'history/:marketId?',
    name: 'account-history',
    component: __WEBPACK_IMPORTED_MODULE_3__components_account_history_history_vue__["a" /* default */],
    props: true
  }, {
    path: 'settings',
    name: 'account-settings',
    component: __WEBPACK_IMPORTED_MODULE_4__components_account_settings_settings_vue__["a" /* default */]
  }]
}, {
  path: '/account/password/reset',
  name: 'reset-password',
  component: __WEBPACK_IMPORTED_MODULE_14__components_home_home_old_home_old_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_app_modals__["a" /* MODALS */].RESET_PASSWORD);
    __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('popup/setCurrentPopupOptions', {
      token: to.query.token
    });
    next();
  },
  meta: {
    appContentOverflowed: true
  }
}, {
  path: '/account/social/auth',
  name: 'social-auth',
  component: __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_auth_account_social_auth_vue__["a" /* default */]
}, {
  path: '/account/disqus',
  name: 'disqus-auth',
  component: __WEBPACK_IMPORTED_MODULE_10__components_account_account_disqus_account_disqus_vue__["a" /* default */],
  props: true
}, {
  path: '/account/disqus/logout/:routeName/:routeParams?',
  name: 'disqus-logout',
  component: __WEBPACK_IMPORTED_MODULE_10__components_account_account_disqus_account_disqus_vue__["a" /* default */],
  props: true
}, {
  path: '/account/login',
  name: 'account-page-login',
  component: __WEBPACK_IMPORTED_MODULE_6__components_pages_page_login_page_login_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/sign-up',
  name: 'account-page-register',
  component: __WEBPACK_IMPORTED_MODULE_8__components_pages_page_register_page_register_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/password/forgotten',
  name: 'account-password-forgotten',
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_page_forgotten_password_page_forgotten_password_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/taxdetail',
  name: 'account-page-tax-detail',
  component: __WEBPACK_IMPORTED_MODULE_9__components_pages_page_tax_detail_page_tax_detail_vue__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}]);

/***/ }),

/***/ "RqM3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RuD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overlay_js__ = __webpack_require__("Oota");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fcfaf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overlay_vue__ = __webpack_require__("1l9m");
function injectStyle (ssrContext) {
  __webpack_require__("nBFw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overlay_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fcfaf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RuPo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Rutn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjI3MSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIDxwYXRoIGQ9Im0yMzYgMGg0NmwtMTAxIDExNSAxMTggMTU2aC05Mi42bC03Mi41LTk0LjgtODMgOTQuOGgtNDZsMTA3LTEyMy0xMTMtMTQ4aDk0LjlsNjUuNSA4Ni42em0tMTYuMSAyNDRoMjUuNWwtMTY1LTIxOGgtMjcuNHoiLz4KPC9zdmc+"

/***/ }),

/***/ "RuzB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    placeholder: {
      type: String,
      default: '&nbsp;'
    },
    value: {
      default: null
    },
    selected: Boolean,
    symbol: Boolean
  },
  data: function data() {
    return {
      double: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['keyboardDoubleSelected']), {
    number: function number() {
      return parseInt(this.value, 10);
    },
    text: function text() {
      return this.number > 0 ? this.number : this.placeholder;
    },
    selectedModifier: function selectedModifier() {
      return {
        'keyboard-numeric-input-sushi--double': this.selected && this.keyboardDoubleSelected && this.value !== null,
        'keyboard-numeric-input-sushi--selected': this.selected,
        'keyboard-numeric-input-sushi--empty': this.value === null
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['updateKeyboardDoubleSelected']), {
    click: function click() {
      this.updateKeyboardDoubleSelected(!this.selected || !this.keyboardDoubleSelected);
      this.$emit('click');
    }
  })
});

/***/ }),

/***/ "Rx49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PODCAST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__ = __webpack_require__("yG5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__("IcnI");






 /* eslint-disable max-len */





var TRACK_RESIZE_MIN_HEIGHT = 120;
var SWIPER_LAYOUT_REFRESH_DELAYS = [0, 120, 400];
var PODCAST_RESIZE_EVENT = 'cms:podcast-resize';
var PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';
var STORY_COLLAPSED_HEIGHTS = {
  appleShow: { desktop: 450, mobile: 450 },
  appleEpisode: { desktop: 175, mobile: 175 },
  default: { desktop: 450, mobile: 450 }
};

var PODCAST = {
  ITUNES: 'itunes',
  SOUNDCLOUD: 'soundcloud',
  BACKTRACKS: 'backtracks',
  POLITICAN_TRADER: 'politicantrader',
  APPLE: 'apple',
  STITCHER: 'stitcher'
};

/* harmony default export */ __webpack_exports__["b"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__["swiperSlide"]
  },
  props: {
    title: {
      type: String,
      default: 'Featured Podcasts'
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    theme: {
      type: String,
      default: 'default'
    },
    forceLayoutMode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this = this;

    var isLayoutMobile = this.forceLayoutMode === 'mobile' ? true : this.forceLayoutMode === 'desktop' ? false : __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['app/isLayoutMobile'];
    var defaultTracks = __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()([{ id: 'id1437934639', type: PODCAST.APPLE }, { id: 'id1496616116', type: PODCAST.APPLE }, { id: 'id1510570053', type: PODCAST.APPLE }, { id: 'id1136826256', type: PODCAST.APPLE }]
    // { id: '505391', type: PODCAST.STITCHER },
    // { id: '', type: PODCAST.POLITICAN_TRADER },
    // { id: 'https://soundcloud.com/stratfortalks', type: PODCAST.SOUNDCLOUD },
    // { id: 'stratfor/stratfor-quick-take/m/a-second-u-s-north-korea-summit', type: PODCAST.BACKTRACKS },
    // { id: '1437934639', type: PODCAST.ITUNES },
    );
    return {
      PODCAST: PODCAST,
      activeIndex: 0,
      isPlaying: true,
      providerTrackHeights: {},
      resizeObserver: null,
      layoutRefreshTimeouts: [],
      tracks: this.items.length > 0 ? this.items : this.theme === 'story' ? [] : defaultTracks,
      swiperOptions: {
        loop: false,
        autoHeight: true,
        autoplay: this.theme === 'story' || isLayoutMobile ? false : 5000,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          var nextIndex = swp.activeIndex;
          var didSlideChange = nextIndex !== _this.activeIndex;
          _this.activeIndex = nextIndex;
          if (didSlideChange) {
            _this.queueSwiperLayoutRefresh({ speed: 0 });
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    isLayoutMobileView: function isLayoutMobileView() {
      if (this.forceLayoutMode === 'mobile') {
        return true;
      }
      if (this.forceLayoutMode === 'desktop') {
        return false;
      }
      return this.isLayoutMobile;
    },
    isStoryTheme: function isStoryTheme() {
      return this.theme === 'story';
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({
        podcasts: true
      }, 'podcasts--' + this.theme, this.theme);
    },
    activeTrack: function activeTrack() {
      return this.tracks[this.activeIndex] || this.tracks[0] || null;
    },
    height: function height() {
      if (this.isStoryTheme) {
        return 450;
      }
      return this.isLayoutMobileView ? 450 : 400;
    },
    styleItunesIframe: function styleItunesIframe() {
      if (this.isLayoutMobileView) {
        return 'overflow-x:hidden;overflow-y:hidden;height:300px;border:0px';
      }
      return 'overflow-x:hidden;overflow-y:hidden;height:300px;border:0px;width:100%';
    },
    showArrows: function showArrows() {
      return this.tracks.length > 1;
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.activeIndex === this.tracks.length - 1;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'podcasts__header-arrow': true,
        'podcasts__header-arrow--left': true,
        'podcasts__header-arrow--disabled': this.isPrevArrowDisabled
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'podcasts__header-arrow': true,
        'podcasts__header-arrow--right': true,
        'podcasts__header-arrow--disabled': this.isNextArrowDisabled
      };
    }
  }),
  methods: {
    getResponsiveHeight: function getResponsiveHeight(heightMap) {
      return this.isLayoutMobileView ? heightMap.mobile : heightMap.desktop;
    },
    getSwiperInstance: function getSwiperInstance() {
      return this.$refs.swiper && this.$refs.swiper.swiper ? this.$refs.swiper.swiper : null;
    },
    clearPendingLayoutRefreshes: function clearPendingLayoutRefreshes() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.layoutRefreshTimeouts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeoutId = _step.value;

          clearTimeout(timeoutId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.layoutRefreshTimeouts = [];
    },
    queueSwiperLayoutRefresh: function queueSwiperLayoutRefresh() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$speed = _ref2.speed,
          speed = _ref2$speed === undefined ? 0 : _ref2$speed;

      this.clearPendingLayoutRefreshes();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(SWIPER_LAYOUT_REFRESH_DELAYS), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var delay = _step2.value;

          var timeoutId = setTimeout(function () {
            _this2.$nextTick(function () {
              _this2.updateSwiperLayout(speed);
            });
          }, delay);
          this.layoutRefreshTimeouts.push(timeoutId);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    emitResizeSignal: function emitResizeSignal() {
      window.dispatchEvent(new Event(PODCAST_RESIZE_EVENT));
    },
    isVisibleInLayout: function isVisibleInLayout() {
      return !!(this.$el && this.$el.offsetParent !== null);
    },
    isTrackEpisode: function isTrackEpisode() {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return track.type === PODCAST.APPLE && track.id && track.id.includes('?i=');
    },
    getTrackKey: function getTrackKey() {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return (track.type || 'unknown') + ':' + (track.id || index);
    },
    getMeasuredTrackHeight: function getMeasuredTrackHeight(track, index) {
      var key = this.getTrackKey(track, index);
      var measured = this.providerTrackHeights[key];
      if (typeof measured !== 'number' || measured < TRACK_RESIZE_MIN_HEIGHT) {
        return null;
      }
      return measured;
    },
    getCollapsedStoryHeight: function getCollapsedStoryHeight(track) {
      if (track && track.type === PODCAST.APPLE) {
        return this.getResponsiveHeight(this.isTrackEpisode(track) ? STORY_COLLAPSED_HEIGHTS.appleEpisode : STORY_COLLAPSED_HEIGHTS.appleShow);
      }
      return this.getResponsiveHeight(STORY_COLLAPSED_HEIGHTS.default);
    },
    getTrackHeight: function getTrackHeight(track, index) {
      if (!this.isStoryTheme) {
        return this.height;
      }
      var collapsedHeight = this.getCollapsedStoryHeight(track);
      var measuredHeight = this.getMeasuredTrackHeight(track, index);
      return measuredHeight ? Math.max(collapsedHeight, measuredHeight) : collapsedHeight;
    },
    getTrackFrameStyle: function getTrackFrameStyle(track, index) {
      return {
        width: '100%',
        minHeight: this.getTrackHeight(track, index) + 'px',
        height: this.getTrackHeight(track, index) + 'px'
      };
    },
    getActiveTrackHeight: function getActiveTrackHeight() {
      if (!this.isStoryTheme || !this.activeTrack) {
        return null;
      }
      return this.getTrackHeight(this.activeTrack, this.activeIndex);
    },
    syncStoryThemeFrameHeights: function syncStoryThemeFrameHeights() {
      if (!this.isStoryTheme || !this.$el) {
        return;
      }
      var activeHeight = this.getActiveTrackHeight();
      if (!activeHeight) {
        return;
      }
      var activeHeightPx = activeHeight + 'px';
      var container = this.$el.querySelector('.swiper-container');
      var wrapper = this.$el.querySelector('.swiper-wrapper');
      var slides = this.$el.querySelectorAll('.swiper-slide');

      if (container) {
        container.style.setProperty('height', activeHeightPx, 'important');
      }
      if (wrapper) {
        wrapper.style.setProperty('height', activeHeightPx, 'important');
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(slides).entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref3 = _step3.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var index = _ref4[0];
          var slide = _ref4[1];

          if (index === this.activeIndex) {
            slide.style.setProperty('height', activeHeightPx, 'important');
            var iframe = slide.querySelector('iframe');
            if (iframe) {
              iframe.style.setProperty('height', activeHeightPx, 'important');
            }
          } else {
            slide.style.removeProperty('height');
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    updateSwiperLayout: function updateSwiperLayout() {
      var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var swiperInstance = this.getSwiperInstance();
      if (!swiperInstance) {
        return;
      }
      if (typeof swiperInstance.update === 'function') {
        swiperInstance.update();
      }
      if (typeof swiperInstance.updateSize === 'function') {
        swiperInstance.updateSize();
      }
      if (typeof swiperInstance.updateSlides === 'function') {
        swiperInstance.updateSlides();
      }
      if (typeof swiperInstance.updateAutoHeight === 'function') {
        swiperInstance.updateAutoHeight(speed);
      }
      this.syncStoryThemeFrameHeights();
    },
    onTrackFrameLoad: function onTrackFrameLoad() {
      var _this3 = this;

      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this3.syncStoryThemeFrameHeights();
      });
      this.emitResizeSignal();
    },
    handleExternalLayoutRefresh: function handleExternalLayoutRefresh() {
      var _this4 = this;

      if (!this.isVisibleInLayout()) {
        return;
      }
      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this4.syncStoryThemeFrameHeights();
        _this4.emitResizeSignal();
      });
    },
    extractHeightFromMessage: function extractHeightFromMessage(data) {
      if (typeof data === 'number' && data >= TRACK_RESIZE_MIN_HEIGHT) {
        return data;
      }
      if (typeof data === 'string') {
        try {
          return this.extractHeightFromMessage(JSON.parse(data));
        } catch (e) {
          var match = data.match(/height\s*[:=]\s*"?(\d{2,4})"?/i);
          if (match) {
            return parseInt(match[1], 10);
          }
          return null;
        }
      }
      if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) !== 'object' || data === null) {
        return null;
      }
      var candidateKeys = ['height', 'frameHeight', 'playerHeight'];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(candidateKeys), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var key = _step4.value;

          if (typeof data[key] === 'number' && data[key] >= TRACK_RESIZE_MIN_HEIGHT) {
            return data[key];
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (typeof data.data !== 'undefined') {
        return this.extractHeightFromMessage(data.data);
      }
      return null;
    },
    handleProviderMessage: function handleProviderMessage(event) {
      var _this5 = this;

      if (!this.isStoryTheme || !event || !event.origin || event.origin.indexOf('podcasts.apple.com') === -1) {
        return;
      }
      var activeTrack = this.activeTrack;
      if (!activeTrack || activeTrack.type !== PODCAST.APPLE) {
        return;
      }
      var nextHeight = this.extractHeightFromMessage(event.data);
      if (!nextHeight || nextHeight < TRACK_RESIZE_MIN_HEIGHT) {
        return;
      }
      var key = this.getTrackKey(activeTrack, this.activeIndex);
      this.$set(this.providerTrackHeights, key, Math.ceil(nextHeight));
      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this5.syncStoryThemeFrameHeights();
      });
      this.emitResizeSignal();
    },
    stopSwiper: function stopSwiper() {
      this.isPlaying = false;
      if (this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.stopAutoplay();
      }
    },
    startSwiper: function startSwiper() {
      this.isPlaying = true;
      if (this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.startAutoplay();
      }
    },
    getPoliticanTraderUrl: function getPoliticanTraderUrl() {
      return '//html5-player.libsyn.com/embed/destination/id/1822847/height/300/theme/custom/thumbnail/yes/direction/backward/no-cache/true/render-playlist/yes/custom-color/2607ab/';
    },
    getBacktracksUrl: function getBacktracksUrl(id) {
      return 'https://player.backtracks.fm/' + id;
    },
    getSoundCloudUrl: function getSoundCloudUrl(track) {
      return 'https://w.soundcloud.com/player/?url=' + track + '&auto_play=false&show_artwork=false';
    },
    getItunesUrl: function getItunesUrl(ids) {
      var width = this.isLayoutMobileView ? '290' : '476';
      var query = '?c=us&d=Test&t=Test&m=podcast&e=podcast&w=' + width + '&h=300&ids=' + ids + '&wt=playlist';
      return '//widgets.itunes.apple.com/widget.html' + query;
    },
    getAppleUrl: function getAppleUrl(id) {
      var separator = id.includes('?') ? '&' : '?';
      return 'https://embed.podcasts.apple.com/us/podcast/star-spangled-gamblers/' + id + separator + 'itsct=podcast_box&amp;itscg=30200';
    },
    getStitcherUrl: function getStitcherUrl(id) {
      return 'https://www.stitcher.com/embed/' + id;
    },
    prevSlide: function prevSlide() {
      if (!this.isPrevArrowDisabled && this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.slidePrev();
      }
    },
    nextSlide: function nextSlide() {
      if (!this.isNextArrowDisabled && this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.slideNext();
      }
    }
  },
  watch: {
    isLayoutMobileView: function isLayoutMobileView() {
      var _this6 = this;

      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this6.syncStoryThemeFrameHeights();
      });
      this.emitResizeSignal();
    },
    tracks: function tracks() {
      var _this7 = this;

      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this7.syncStoryThemeFrameHeights();
      });
      this.emitResizeSignal();
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    window.addEventListener('message', this.handleProviderMessage);
    window.addEventListener('resize', this.onTrackFrameLoad);
    window.addEventListener(PODCAST_LAYOUT_REFRESH_EVENT, this.handleExternalLayoutRefresh);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(function () {
        _this8.queueSwiperLayoutRefresh({ speed: 0 });
      });
      this.resizeObserver.observe(this.$el);
    }

    this.queueSwiperLayoutRefresh({ speed: 0 });
    this.$nextTick(function () {
      _this8.syncStoryThemeFrameHeights();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.handleProviderMessage);
    window.removeEventListener('resize', this.onTrackFrameLoad);
    window.removeEventListener(PODCAST_LAYOUT_REFRESH_EVENT, this.handleExternalLayoutRefresh);
    this.clearPendingLayoutRefreshes();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }
});

/***/ }),

/***/ "S1Yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      required: false,
      default: 'top'
    },
    padding: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-small--' + this.type, this.type), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-small--no-padding', !this.padding), _ref;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.autoClose && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__logger__["b" /* isDebugOn */])()) {
      setTimeout(function () {
        return _this.close();
      }, this.closeTimeout);
    }
  },

  methods: {
    close: function close() {
      this.$emit('modalClose');
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["l" /* lockModal */])();
  },
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["m" /* unLockModal */])();
  }
});

/***/ }),

/***/ "S1q9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard_portfolio_my_markets_portfolio_my_markets_vue__ = __webpack_require__("UIPs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_filters_market_filters_dashboard_market_filters_dashboard_vue__ = __webpack_require__("of0E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dashboard_dashboard_markets_toggle_dashboard_markets_toggle_vue__ = __webpack_require__("zkja");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    portfolioMyMarkets: __WEBPACK_IMPORTED_MODULE_0__components_dashboard_portfolio_my_markets_portfolio_my_markets_vue__["a" /* default */],
    dashboardMarketFilters: __WEBPACK_IMPORTED_MODULE_1__components_market_market_filters_market_filters_dashboard_market_filters_dashboard_vue__["a" /* default */],
    dashboardMarketsToggle: __WEBPACK_IMPORTED_MODULE_2__components_dashboard_dashboard_markets_toggle_dashboard_markets_toggle_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "S2j1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S2nZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_quantity_value_sushi_js__ = __webpack_require__("iit4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5166f464_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_quantity_value_sushi_vue__ = __webpack_require__("Kon3");
function injectStyle (ssrContext) {
  __webpack_require__("RDmN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_quantity_value_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5166f464_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_quantity_value_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S77G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_links_toggle_js__ = __webpack_require__("ybBz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c5aa41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_links_toggle_vue__ = __webpack_require__("9MQs");
function injectStyle (ssrContext) {
  __webpack_require__("chIw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_links_toggle_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c5aa41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_links_toggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S9O8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__("gGqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
 /* eslint-disable no-console */
/* global MobileApp:false */




/* harmony default export */ __webpack_exports__["a"] = ({
  userLoggedIn: function userLoggedIn(token) {
    if (__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["f" /* iOSWrapper */]) {
      window.location.href = 'pred://userLoggedIn?token=' + token;
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(MobileApp.userLoggedIn)) return;
      try {
        MobileApp.userLoggedIn.bind(MobileApp)(token);
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error(err);
      }
    }
  },
  userLoggedOut: function userLoggedOut() {
    if (__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["f" /* iOSWrapper */]) {
      window.location.href = 'pred://userLoggedOut';
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(MobileApp.userLoggedOut)) return;
      try {
        MobileApp.userLoggedOut.bind(MobileApp)();
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error(err);
      }
    }
  }
});

/***/ }),

/***/ "SA4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-static-preview"},[(_vm.isColumnCountExceeding)?_c('alert-box',{staticClass:"page-static-preview__box",attrs:{"level":"warning"}},[_vm._v("\n    Column setup appears to be invalid (either exceeds 100% or content column broke to next row).\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row row-xy"},[_c('div',{staticClass:"column small-12 medium-6"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Left Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.left),callback:function ($$v) {_vm.$set(_vm.columnChoice, "left", $$v)},expression:"columnChoice.left"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-6"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Right Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.right),callback:function ($$v) {_vm.$set(_vm.columnChoice, "right", $$v)},expression:"columnChoice.right"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:_vm.leftColumnClasses},[_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{class:_vm.middleColumnClasses,domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('div',{class:_vm.rightColumnClasses},[_vm._v("\n       \n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SAZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-profile-overview"},[_c('div',{staticClass:"user-profile-overview__avatar"},[_c('account-social-avatar',{attrs:{"avatar":_vm.watchedUserDetails.avatarImage,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.userLevel.currentColor,"showEdit":false,"theme":"user-profile"}})],1),_vm._v(" "),_c('div',{staticClass:"user-profile-overview__name"},[_vm._v("\n    "+_vm._s(_vm.watchedUserDetails.userName)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"user-profile-overview__level"},[_vm._v("\n    "+_vm._s(_vm.userLevel.text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SBPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketChartLoader_vue__ = __webpack_require__("r5bH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5902708_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketChartLoader_vue__ = __webpack_require__("P26B");
function injectStyle (ssrContext) {
  __webpack_require__("ckGe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketChartLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5902708_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketChartLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SHAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationLoader_vue__ = __webpack_require__("5aqh");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__NotificationLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarketLoader_vue__ = __webpack_require__("fzCn");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__MarketLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarketSharesItemLoader_vue__ = __webpack_require__("W9Re");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__MarketSharesItemLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarketWidgetLoader_vue__ = __webpack_require__("ucfo");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__MarketWidgetLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BiggestGainsLoader_vue__ = __webpack_require__("ZC+n");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__BiggestGainsLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableRowsLoader_vue__ = __webpack_require__("XMP4");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__TableRowsLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountWithdrawalLoader_vue__ = __webpack_require__("d2fJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__AccountWithdrawalLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountFormLoader_vue__ = __webpack_require__("8YSH");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__AccountFormLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LeaderboardsInfoLoader_vue__ = __webpack_require__("2uhI");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__LeaderboardsInfoLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OverviewMapLoader_vue__ = __webpack_require__("8zAU");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__OverviewMapLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MarketChartLoader_vue__ = __webpack_require__("SBPi");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__MarketChartLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StaticPageLoader_vue__ = __webpack_require__("hk1B");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__StaticPageLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PreviewCarouselLoader_vue__ = __webpack_require__("hE3l");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__PreviewCarouselLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MarketDetailPageLoader_vue__ = __webpack_require__("MSvJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__MarketDetailPageLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SocialsLoader_vue__ = __webpack_require__("tel1");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__SocialsLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ContractInfoLoader_vue__ = __webpack_require__("+6DW");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__ContractInfoLoader_vue__["a"]; });
/* eslint-disable */


















/***/ }),

/***/ "SHkF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_tile_js__ = __webpack_require__("Y4EP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e591aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_tile_vue__ = __webpack_require__("Cel6");
function injectStyle (ssrContext) {
  __webpack_require__("DEr/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_tile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e591aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_tile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SMhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_watchlist_js__ = __webpack_require__("tQ/B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc45ffb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_watchlist_vue__ = __webpack_require__("sNPb");
function injectStyle (ssrContext) {
  __webpack_require__("8KPi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_watchlist_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc45ffb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_watchlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SOQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SRJW":
/***/ (function(module, exports) {

/* eslint-disable */

try {
  new MouseEvent('test');
} catch (e) {
  var MouseEvent = function MouseEvent(eventType, params) {
    params = params || { bubbles: false, cancelable: false };
    var mouseEvent = document.createEvent('MouseEvent');
    mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

    return mouseEvent;
  };

  MouseEvent.prototype = Event.prototype;

  window.MouseEvent = MouseEvent;
}

/***/ }),

/***/ "SVQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__ = __webpack_require__("URu4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__ = __webpack_require__("qkwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
 /* eslint-disable no-unused-vars */








var COUNTRY_CODE_US = 'US';

var hasOneDigit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneDigit' }, function (value) {
  return (/\d/.test(value)
  );
});
var hasOneUpper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneUpper' }, function (value) {
  return (/[A-Z]/.test(value)
  );
});
var hasOneLower = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneLower' }, function (value) {
  return (/[a-z]/.test(value)
  );
});
var usernameIsValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'usernameIsValid' }, function (value) {
  return (/^[a-zA-Z0-9_]+$/.test(value)
  );
});
var noSpaces = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'noSpaces' }, function (value) {
  return value.indexOf(' ') === -1;
});
var minLength = function minLength(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minLength', min: min }, function (value) {
    return value.length >= min;
  });
};
var maxLength = function maxLength(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxLength', max: max }, function (value) {
    return value.length <= max;
  });
};
var minLengthDigit = function minLengthDigit(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minLengthDigit', min: min }, function (value) {
    return value.length >= min;
  });
};
var maxLengthDigit = function maxLengthDigit(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxLengthDigit', max: max }, function (value) {
    return value.length <= max;
  });
};
var exactLength = function exactLength(target) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'exactLength', target: target }, function (value) {
    return value.length === target;
  });
};
var notEmptyMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'notEmptyMessage' }, function (value) {
  return (/\S\w*/.test(value)
  );
});
var onlyCharacters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'onlyCharacters' }, function (value) {
  return (/^[A-Za-záéíóú\s'`’.,\-()/]*$/.test(value)
  );
});
var requiredNoMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'requiredNoMessage' }, __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"]);
var emailNoMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'emailNoMessage' }, __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]);
var price = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'price' }, function (value) {
  if (value && value.length > 1 && value.startsWith('0')) return false;
  return (/^\d+\.?\d{0,2}$/.test(value)
  );
});

var priceAllowZero = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'price' }, function (value) {
  if (value && value.length > 1 && value.startsWith('.')) return (/^\d+$/.test(value.slice(1))
  );
  return (/^\d+\.?\d{0,2}$/.test(value)
  );
});

var multipleEmails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'multipleEmails' }, function (value) {
  var emails = value.split(';').map(function (i) {
    return i.replace(' ', '');
  });
  var isValid = true;
  emails.forEach(function (val) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"])(val)) {
      isValid = false;
    }
  });
  return isValid;
});

var minValue = function minValue(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minValue', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

var greaterThan = function greaterThan(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'greaterThan', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value > +min;
  });
};

var minValueDeposit = function minValueDeposit(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minValueDeposit', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

var maxValueDeposit = function maxValueDeposit(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxValueDeposit', max: max }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

// this one should work with "fields.email" built in does not
var sameAs = function sameAs(param) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'sameAs' }, function (value, parentVm) {
    var targetParam = parentVm[param];
    return value.toLowerCase() === targetParam.toLowerCase();
  });
};

var _validateIsAdult = function _validateIsAdult(parMonth, parDay) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateIsAdult' }, function (value, parentVm) {
    var yearSelect = value || {};
    var monthSelect = parentVm[parMonth] || {};
    var daySelect = parentVm[parDay] || {};
    if (yearSelect.value && monthSelect.value && daySelect.value) {
      var dateOfBirth = new Date(yearSelect.value, monthSelect.value - 1, daySelect.value);
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(dateOfBirth), 'years') >= 18;
    }
    return true;
  });
};

var _customPattern = function _customPattern(parPattern, parMessage) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: '' }, function (value) {
    return new RegExp(parPattern).test(value);
  });
};

var _validatenNscbStatus = function _validatenNscbStatus(parCountry) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validatenNscbStatus' }, function (value, parentVm) {
    var countrySelect = parentVm[parCountry];
    if (countrySelect.value !== COUNTRY_CODE_US && !value) {
      return false;
    }
    return true;
  });
};

var _validateSSN = function _validateSSN(parCountry) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateSSN' }, function (value, parentVm) {
    var countrySelect = parentVm[parCountry];
    if (countrySelect.value === COUNTRY_CODE_US) {
      return (/^\d{4}$/.test(value)
      );
    }
    return true;
  });
};

var _validateUSZipCode = function _validateUSZipCode(parCountry) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateUSZipCode' }, function (value, parentVm) {
    var countrySelect = parentVm[parCountry];
    var isFieldRequired = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(countrySelect, 'required', true);

    if (!countrySelect || !countrySelect.value) {
      return true;
    }

    if (isFieldRequired && countrySelect.value === COUNTRY_CODE_US) {
      return (/^[0-9\s]*$/.test(value) && value.length === 5
      );
    }

    if (isFieldRequired && value.length === 0) {
      return false;
    }

    return true;
  });
};

var validateCardNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateCardNumber' }, function (value, parentVm) {
  var trimmedValue = (value || '').replace(/ /g, '');
  var cardType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["c" /* getCardTypeForNumber */])(trimmedValue);
  return cardType !== __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].CARDS.BLANK;
});

// Phone validator - required field, defaults to US if no country code prefix
var phone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'phone' }, function (value) {
  if (!value) return false;
  // If starts with +, validate as international; otherwise default to US
  if (value.startsWith('+')) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__["a" /* isValidPhoneNumber */])(value);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__["a" /* isValidPhoneNumber */])(value, 'US');
});

// Phone validator - optional field, validates only if not empty
var phoneOptional = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'phoneOptional' }, function (value) {
  if (!value || value.trim() === '') return true; // Allow empty
  // If starts with +, validate as international; otherwise default to US
  if (value.startsWith('+')) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__["a" /* isValidPhoneNumber */])(value);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__["a" /* isValidPhoneNumber */])(value, 'US');
});

/* harmony default export */ __webpack_exports__["a"] = ({
  withdrawalAmount: function withdrawalAmount(parFrom, parTo) {
    return {
      price: price,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(parFrom, parTo)
    };
  },
  depositAmount: function depositAmount(parFrom, parTo) {
    return {
      price: price,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      minValueDeposit: minValueDeposit(parFrom),
      maxValueDeposit: maxValueDeposit(parTo)
    };
  },
  depositAmountCoinbase: function depositAmountCoinbase(parFrom, parTo) {
    return {
      price: priceAllowZero,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      minValueDeposit: minValueDeposit(parFrom),
      maxValueDeposit: maxValueDeposit(parTo)
    };
  },
  onlyCharacters: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    onlyCharacters: onlyCharacters
  },
  cardNumber: {
    validateCardNumber: validateCardNumber
  },
  taxId: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    exactLength: exactLength(9)
  },
  required: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
  },
  email: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
  },
  emailConfirmation: function emailConfirmation(par) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      sameAs: sameAs(par)
    };
  },
  validateIsAdult: function validateIsAdult(parMonth, parDay) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      validateIsAdult: _validateIsAdult(parMonth, parDay)
    };
  },
  validateUSZipCode: function validateUSZipCode(parCountry) {
    return {
      validateUSZipCode: _validateUSZipCode(parCountry)
    };
  },
  validatenNscbStatus: function validatenNscbStatus(parCountry) {
    return {
      validatenNscbStatus: _validatenNscbStatus(parCountry)
    };
  },
  validateSSN: function validateSSN(parCountry) {
    return {
      validateSSN: _validateSSN(parCountry)
    };
  },
  password: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    minLength: minLength(6),
    hasOneDigit: hasOneDigit,
    hasOneLower: hasOneLower,
    hasOneUpper: hasOneUpper
  },
  passwordConfirmation: function passwordConfirmation(par) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      // minLength: minLength(6),
      // hasOneDigit,
      // hasOneLower,
      // hasOneUpper,
      sameAs: sameAs(par)
    };
  },
  username: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    noSpaces: noSpaces,
    usernameIsValid: usernameIsValid,
    minLength: minLength(3),
    maxLength: maxLength(14)
  },
  message: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    notEmptyMessage: notEmptyMessage
  },
  requiredNoMessage: { // not mapped in validatorsMessages so error does not display
    requiredNoMessage: requiredNoMessage
  },
  emailNoMessage: { // not mapped in validatorsMessages so error does not display
    emailNoMessage: emailNoMessage
  },
  cvv: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    minLengthDigit: minLengthDigit(3),
    maxLengthDigit: maxLengthDigit(4)
  },
  accountNumber: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    minValue: greaterThan(0)
  },
  routingNumber: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    exactLength: exactLength(9)
  },
  multipleEmails: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    multipleEmails: multipleEmails
  },
  customPattern: function customPattern(parPattern, parMessage) {
    return {
      customPattern: _customPattern(parPattern, parMessage)
    };
  },
  captcha: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
  },
  phone: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    phone: phone
  },
  phoneOptional: {
    phoneOptional: phoneOptional
  }
});

/***/ }),

/***/ "SWC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-terms-and-conditions"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-terms-and-conditions__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-terms-and-conditions__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SXEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-panel",class:_vm.wrapperModifier},[_c('div',{staticClass:"collapsible-panel__header",class:_vm.darkHeaderModifier,on:{"click":_vm.toggle}},[(_vm.hasSlotTitle)?_c('div',{staticClass:"collapsible-panel__header-text"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),(!_vm.hasSlotTitle)?_c('div',{staticClass:"collapsible-panel__header-text",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()]),_vm._v(" "),(_vm.isOpenState)?_c('div',{staticClass:"collapsible-panel__content",class:_vm.noPaddingModifier},[(_vm.hasSlotContent)?[_vm._t("default")]:[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SZB3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sa5U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Scap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_1__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  data: function data() {
    return {
      depositWarning: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* STATIC_PAGES */].DEPOSIT_WARNING).then(function (data) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["e" /* isEmptyHtml */])(data.renderedHTML)) {
        _this.depositWarning = data.renderedHTML;
      }
    }).catch(function () {
      _this.depositWarning = '';
    });
  }
});

/***/ }),

/***/ "SdQH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjI3MSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIDxwYXRoIGQ9Im0yMzYgMGg0NmwtMTAxIDExNSAxMTggMTU2aC05Mi42bC03Mi41LTk0LjgtODMgOTQuOGgtNDZsMTA3LTEyMy0xMTMtMTQ4aDk0LjlsNjUuNSA4Ni42em0tMTYuMSAyNDRoMjUuNWwtMTY1LTIxOGgtMjcuNHoiLz4KPC9zdmc+"

/***/ }),

/***/ "SfXH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Shp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_js__ = __webpack_require__("dcEQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e4316a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_vue__ = __webpack_require__("Tzaz");
function injectStyle (ssrContext) {
  __webpack_require__("R7qn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e4316a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SngK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"deposit"}}):(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":_vm.accountUploadDocumentTheme,"type":"card"}}):(_vm.collectSsnInfo)?_c('account-ssn-info-upload',{attrs:{"isPopup":_vm.isPopup,"theme":_vm.accountUploadDocumentTheme}}):[(_vm.isStepInitial)?_c('form',{class:_vm.classModifiers,on:{"submit":function($event){$event.preventDefault();return _vm.onConfirmDeposit($event)}}},[(_vm.errorMessage)?_c('alert-box',{staticClass:"add-funds__alert-box",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(_vm.avsMessage)?_c('alert-box',{staticClass:"add-funds__alert-box",attrs:{"level":"warning"}},[_vm._v("\n        Please provide a billing address.\n      ")]):_vm._e(),_vm._v(" "),(_vm.showPromoNotification)?_c('alert-box',{staticClass:"add-funds__alert-box",attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification)?_c('alert-box',{staticClass:"add-funds__alert-box",attrs:{"level":_vm.instantCreditBoxLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instantCreditBoxMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.errorMessage)?[_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Deposit Amount ($"+_vm._s(_vm.minimumDepositAmount.toFixed(2))+" Minimum)")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[(_vm.amountHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds__error"},[_vm._v("\n              "+_vm._s(_vm.amountValidationMessage)+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"input-group input-group--large"},[_c('span',{staticClass:"input-group__addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fields.amount),expression:"fields.amount"}],staticClass:"input-group__input",attrs:{"tabindex":"1","validation":_vm.$v.fields.amount},domProps:{"value":(_vm.fields.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.fields, "amount", $event.target.value)},_vm.$v.fields.amount.$touch],"blur":_vm.handleAmountBlur}})])]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},_vm._l((_vm.depositAmounts),function(amount){return _c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"button button--primary add-funds__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onUpdateAmount(amount)}}},[_c('span',{staticClass:"add-funds__button-plus"},[_vm._v("+")]),_vm._v(" $"+_vm._s(amount)+"\n                  ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"tabindex":2,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.name,"name":_vm.fieldName('name'),"autocomplete":"name","type":"text","required":true,"gtm":"Deposit,Credit Card Name","placeholder":"Name on Card"},on:{"input":_vm.$v.fields.name.$touch},model:{value:(_vm.fields.name),callback:function ($$v) {_vm.$set(_vm.fields, "name", $$v)},expression:"fields.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[(_vm.cardTypeHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds__error add-funds__error--no-margin-bottom"},[_vm._v("\n              "+_vm._s(_vm.cardTypeValidationMessage)+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{ref:"cnumber",attrs:{"theme":"card-type","tabindex":4,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.number,"name":_vm.fieldName('number'),"autocomplete":"off","type":"text","gtm":"Deposit,Credit Card Number","hideIconOnValue":false,"required":true},on:{"input":_vm.$v.fields.number.$touch},model:{value:(_vm.fields.number),callback:function ($$v) {_vm.$set(_vm.fields, "number", $$v)},expression:"fields.number"}},[_c('img',{staticClass:"add-funds__card-type",attrs:{"slot":"icon","src":_vm.cardTypeImage},slot:"icon"})])],1)]),_vm._v(" "),_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Expiry Date")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-4 column"},[_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":5,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.expiryDateMonth,"placeholder":"MM","options":_vm.months,"track-by":"value","label":"label","gtm":"Deposit,Credit Card Expiry Month","required":true},on:{"select":function (e) { return _vm.tabTo(e, 'year'); },"input":_vm.$v.fields.expiryDateMonth.$touch},model:{value:(_vm.fields.expiryDateMonth),callback:function ($$v) {_vm.$set(_vm.fields, "expiryDateMonth", $$v)},expression:"fields.expiryDateMonth"}})],1),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('form-select',{ref:"year",attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":6,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.expiryDateYear,"placeholder":"YYYY","options":_vm.years,"track-by":"value","label":"label","gtm":"Deposit,Credit Card Expiry Year","required":true},on:{"select":function (e) { return _vm.tabTo(e, 'cvv'); },"input":_vm.$v.fields.expiryDateYear.$touch},model:{value:(_vm.fields.expiryDateYear),callback:function ($$v) {_vm.$set(_vm.fields, "expiryDateYear", $$v)},expression:"fields.expiryDateYear"}})],1),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('form-input',{ref:"cvv",attrs:{"tabindex":7,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.cvv,"name":_vm.fieldName('cvv'),"autocomplete":"cvv","type":"text","required":true,"gtm":"Deposit,Security Code","placeholder":"CVV"},on:{"input":_vm.$v.fields.cvv.$touch},model:{value:(_vm.fields.cvv),callback:function ($$v) {_vm.$set(_vm.fields, "cvv", $$v)},expression:"fields.cvv"}},[_c('notification-icon',{attrs:{"slot":"icon","reversed":true},on:{"showPopup":_vm.showCVVModal},slot:"icon"})],1)],1)]),_vm._v(" "),(_vm.avsFlag)?[_c('h5',{staticClass:"form__title form__title--left form__title--margin-alt"},[_vm._v("Billing Address")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.address,"disabled":_vm.isFormDisabled,"name":"street","type":"text","required":true,"autocomplete":"street-address","placeholder":"Street Address"},on:{"input":_vm.$v.fields.address.$touch},model:{value:(_vm.fields.address),callback:function ($$v) {_vm.$set(_vm.fields, "address", $$v)},expression:"fields.address"}})],1),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.city,"disabled":_vm.isFormDisabled,"name":"city","type":"text","required":true,"autocomplete":"address-line1","placeholder":"City"},on:{"input":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.zipCode,"disabled":_vm.isFormDisabled,"name":"zipCode","type":"text","required":true,"autocomplete":"postal-code","placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-funds__submit"},[_c('form-submit',{attrs:{"label":"Review And Confirm","disabled":_vm.isConfirmDisabled}})],1),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e()]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isStepConfirm)?_c('div',{staticClass:"add-funds__info"},[_c('div',{staticClass:"add-funds__info-content"},[(_vm.mode === 'page')?_c('span',{staticClass:"add-funds__info-cancel-button",on:{"click":function($event){$event.preventDefault();return _vm.onTryAgain($event)}}},[_vm._v("\n            Cancel\n          ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"add-funds__info-large-para"},[_vm._v("\n            Are you sure you want to deposit\n          ")]),_vm._v(" "),_c('p',{staticClass:"add-funds__info-amount"},[_vm._v("\n            "+_vm._s(_vm.infoAmount)+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"add-funds__info-large-para"},[_vm._v("\n            on your credit card?\n          ")])]),_vm._v(" "),_c('div',{staticClass:"add-funds__info-button-wrapper"},[_c('div',{staticClass:"row row-xy"},[_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitDeposit($event)}}},[_vm._v("\n              Confirm & Deposit\n            ")])])])])]):_vm._e(),_vm._v(" "),(_vm.isStepTryAgain)?_c('div',{staticClass:"add-funds__info"},[_c('div',{staticClass:"add-funds__info-icon"},[_c('img',{attrs:{"src":__webpack_require__("z6fO")}})]),_vm._v(" "),_c('div',{staticClass:"add-funds__info-content"},[(_vm.errorMessageDepositFail)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMessageDepositFail)}}):_c('p',[_vm._v("\n            Unfortunately, your payment was not processed. Please try again.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"add-funds__info-button-wrapper"},[_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onTryAgain($event)}}},[_vm._v("\n          Please Try Again\n        ")])])]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SqAp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SqSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCreateAccount: function onCreateAccount() {
      if (this.isPage) {
        this.$router.push({ name: 'account-page-register' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
      }
    }
  })
});

/***/ }),

/***/ "SuF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-payout-sushi__col-1"},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixedflex",value:(_vm.market.userInvestment),expression:"market.userInvestment",modifiers:{"round2":true,"fixedflex":true}}],staticClass:"market-payout-sushi__price"}),_vm._v(" "),(_vm.showLabels)?_c('div',[_vm._v("\n      Investment\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-payout-sushi__col-2"},[_c('div',{staticClass:"market-payout-sushi__price"},[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixedflex",value:(_vm.userGainLoss),expression:"userGainLoss",modifiers:{"round2":true,"fixedflex":true}}]})]),_vm._v(" "),(_vm.showLabels)?_c('div',[_vm._v("\n      "+_vm._s(_vm.gainLossLabel)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-payout-sushi__col-3"},[_c('div',{staticClass:"market-payout-sushi__price"},[(!_vm.showLabels && _vm.isAllPayoutsAvailable)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixedflex",value:(_vm.market.userMaxPayout),expression:"market.userMaxPayout",modifiers:{"round2":true,"fixedflex":true}}],staticClass:"market-payout-sushi__payout-link-raw",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.allPayouts($event)}}}):_c('span',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixedflex",value:(_vm.market.userMaxPayout),expression:"market.userMaxPayout",modifiers:{"round2":true,"fixedflex":true}}]})]),_vm._v(" "),(_vm.showLabels)?[(_vm.isAllPayoutsAvailable)?[_c('a',{staticClass:"market-payout-sushi__payout-link",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.allPayouts($event)}}},[_vm._v("Max. Payout")])]:[_vm._v("\n        Max. Payout\n      ")]]:_vm._e()],2),_vm._v(" "),(_vm.showMarketLink)?_c('div',{staticClass:"market-payout-sushi__col-4"},[_c('router-link',{staticClass:"market-payout-sushi__payout-link-market",attrs:{"to":{ name: 'market-details', params: { marketId: _vm.market.marketId, marketUrl: _vm.market.marketUrl } }},nativeOn:{"click":function($event){return $event.stopPropagation()}}},[_vm._v("\n      View "),_c('br'),_vm._v("\n      Market\n    ")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T+Fj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T2le":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_plus_minus_sign_js__ = __webpack_require__("0fyw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac417b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plus_minus_sign_vue__ = __webpack_require__("AJVw");
function injectStyle (ssrContext) {
  __webpack_require__("SqAp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_plus_minus_sign_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac417b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plus_minus_sign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T5QV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T6JC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-rows-loader"},[_c('div',{staticClass:"table-rows-loader__header"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"table-rows-loader__content-item"},[_c('div',{staticClass:"table-rows-loader__content-item-text-1"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content-item-text-2"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content-item-text-3"})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T7ic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_maintenance_notification_js__ = __webpack_require__("Ffa9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338f23ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_maintenance_notification_vue__ = __webpack_require__("F76i");
function injectStyle (ssrContext) {
  __webpack_require__("PbZj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_maintenance_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338f23ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_maintenance_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T8v5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_inline_sushi_js__ = __webpack_require__("LulR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96b4892a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_inline_sushi_vue__ = __webpack_require__("FEAx");
function injectStyle (ssrContext) {
  __webpack_require__("kiaR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_inline_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96b4892a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_inline_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T9qA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('dashboard', ['mySharesCount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('dashboard', ['selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    mainClassName: function mainClassName() {
      return 'market-filters-dashboard';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-dashboard__menu': true,
        'market-filters-dashboard__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    },
    orderMenuName: function orderMenuName() {
      return this.isLayoutMobile ? this.selectedOrder.name : this.selectedOrder.fullName;
    }
  }),
  methods: {
    dashOrderSelected: function dashOrderSelected(sort) {
      return this.selectedOrder.sort === sort;
    }
  },
  created: function created() {
    this.isDashboardOpen = true;
  }
});

/***/ }),

/***/ "TA6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_preview_carousel_embed_js__ = __webpack_require__("sFos");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d59a392_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_carousel_embed_vue__ = __webpack_require__("edJ+");
function injectStyle (ssrContext) {
  __webpack_require__("5IfR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_preview_carousel_embed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d59a392_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_carousel_embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TD6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c(_vm.layoutComponent,{tag:"component"}),_vm._v(" "),_c('app-loader'),_vm._v(" "),_c('app-modals'),_vm._v(" "),_c('app-privacy-statement')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "THQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TJ+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_modal_js__ = __webpack_require__("pqmg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e33c59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_modal_vue__ = __webpack_require__("cole");
function injectStyle (ssrContext) {
  __webpack_require__("4Sf7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e33c59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TLs8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MODE_POPUP = 'popup';
var MODE_PAGE = 'page';

var popupPageModeMixin = {
  props: {
    mode: {
      type: String,
      default: MODE_POPUP
    }
  },
  computed: {
    isPage: function isPage() {
      return this.mode === MODE_PAGE;
    },
    isPopup: function isPopup() {
      return this.mode === MODE_POPUP;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (popupPageModeMixin);

/***/ }),

/***/ "TMp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_reset_password_js__ = __webpack_require__("Igwv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b3162e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_reset_password_vue__ = __webpack_require__("eKbQ");
function injectStyle (ssrContext) {
  __webpack_require__("JOjr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_reset_password_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b3162e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_reset_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TNLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_state_icon_state_icon_vue__ = __webpack_require__("uvwz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");






var STATUS_CANCELLABLE = 'Pending Approval';
var BASIC_COLUMN_SET = ['DEPOSITS', 'PROMOTIONS'];

var DIMMED_STATUS_LIST = ['Cancelled', 'Rejected', 'Returned', 'Not Approved'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  components: {
    stateIcon: __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_state_icon_state_icon_vue__["a" /* default */]
  },
  props: {
    type: {
      type: String
    },
    item: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    itemDate: function itemDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["k" /* dateToString */])(this.item.date);
    },
    classModifier: function classModifier() {
      return {
        'balance-history-item--dimmed': DIMMED_STATUS_LIST.includes(this.item.status)
      };
    },
    showAdditionalColumns: function showAdditionalColumns() {
      return !BASIC_COLUMN_SET.includes(this.type) && this.isLayoutDesktop;
    },
    amountColumnModifiers: function amountColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-2': this.showAdditionalColumns
      };
    },
    typeColumnModifiers: function typeColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns
      };
    },
    statusColumnModifiers: function statusColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['cancelWithdrawal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    showCancelRequestButton: function showCancelRequestButton(item) {
      return item.status === STATUS_CANCELLABLE && item.withdrawalId;
    },
    onCancelRequest: function onCancelRequest(item) {
      var _this = this;

      var payload = {
        withdrawalId: item.withdrawalId
      };
      this.loaderAdd();
      this.cancelWithdrawal(payload).then(function () {
        return _this.loaderRemove();
      }).then(function () {
        return _this.setSuccessSideNotification('Your withdrawal has been cancelled.');
      }).then(function () {
        return _this.$emit('itemCancelled', item);
      }).catch(function () {
        _this.loaderRemove();
        _this.setErrorSideNotification('Operation failed.');
      });
    }
  })
});

/***/ }),

/***/ "TONy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('leaderboards', ['playerLeaderboards']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    items: function items() {
      if (this.playerLeaderboards.length === 0 && this.isSocialReady) {
        var items = [{
          leaderBoardId: 0,
          leaderBoardName: 'All Predictors',
          leaderBoardPosition: 100,
          predefined: true
        }];
        if (this.level.num > 1) {
          items.push({
            leaderBoardId: this.level.num,
            leaderBoardName: this.level.text,
            leaderBoardPosition: 100,
            predefined: true
          });
        }
        return items;
      }
      return this.playerLeaderboards;
    },
    showLeaderboards: function showLeaderboards() {
      return this.settings.privacy ? this.settings.privacy.AllowLeaderboard : true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('leaderboards', ['getPlayerLeaderboards']), {
    getOrdinalSuffix: __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["P" /* getOrdinalSuffix */],
    sectionClassModifiers: function sectionClassModifiers() {
      return {
        'leaderboards-info-section': true,
        'leaderboards-info-section--clickable': true
      };
    },
    onSectionClick: function onSectionClick(item) {
      // if (item.predefined) return;
      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: item.leaderBoardId
        }
      });
    }
  }),
  created: function created() {
    var _this = this;

    this.getPlayerLeaderboards().then(function () {
      _this.isComponentReady = true;
    });
  }
});

/***/ }),

/***/ "TYUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__ = __webpack_require__("dDJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    contracts: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketContractInfoV2: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["b" /* MARKET_CONTRACT_INFO_VALUES_LAYOUT */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    items: function items() {
      return this.contracts.map(function (i) {
        var instance = new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](i);
        return {
          id: i.contractId,
          marketName: i.marketName,
          marketId: i.marketId,
          contractName: i.contractName,
          image: i.contractImageSmallUrl || i.contractImageUrl,
          price: instance.changePriceAsCents,
          priceAsCents: instance.lastTradePriceAsCents,
          hasLastTradePrice: instance.hasLastTradePrice,
          lastClosePrice: instance.lastClosePrice
        };
      });
    }
  }),
  methods: {
    itemLink: function itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      };
    }
  }
});

/***/ }),

/***/ "TZdP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TZdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  validations: {
    fields: {
      currentPassword: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      newPassword: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].password,
      newPasswordConfirmation: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].passwordConfirmation('newPassword')
    }
  },
  data: function data() {
    return {
      fields: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotificationWithTimeoutCallback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['changePassword']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          oldPassword: this.fields.currentPassword,
          newPassword: this.fields.newPassword,
          confirmPassword: this.fields.newPasswordConfirmation
        };
        this.changePassword(payload).then(this.formEnable).then(function () {
          _this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Password Updated.',
            callback: function callback() {
              return _this.$router.go(-1);
            }
          });
        }).catch(this.formHandleErrors);
      }
    }
  })
});

/***/ }),

/***/ "TdGO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_avatar_account_social_avatar_vue__ = __webpack_require__("ROsZ");







var TOP_RECENT_COMMENTS_SKELETON_COUNT = 3;
var COMMENT_LINK_CLASS = 'sushi-market-top-comments__comment-link';
var COMMENT_MENTION_CLASS = 'sushi-market-top-comments__comment-mention';
var COMMENT_CODE_CLASS = 'sushi-market-top-comments__comment-code';
var COMMENT_QUOTE_CLASS = 'sushi-market-top-comments__comment-quote';
var COMMENT_SPOILER_CLASS = 'sushi-market-top-comments__comment-spoiler';

var createPreviewSpan = function createPreviewSpan(className, textContent) {
  var span = document.createElement('span');
  span.className = className;
  span.textContent = (textContent || '').trim();
  return span;
};

var replaceNodeWithNode = function replaceNodeWithNode(node, replacementNode) {
  if (!node || !node.parentNode || !replacementNode) {
    return;
  }

  node.parentNode.replaceChild(replacementNode, node);
};

var replaceBlockquoteWithPreviewQuote = function replaceBlockquoteWithPreviewQuote(blockquote) {
  if (!blockquote || !blockquote.parentNode) {
    return;
  }

  var fragment = document.createDocumentFragment();
  var quoteText = (blockquote.textContent || '').trim();

  if (blockquote.previousSibling) {
    fragment.appendChild(document.createElement('br'));
  }

  fragment.appendChild(createPreviewSpan(COMMENT_QUOTE_CLASS, quoteText));
  fragment.appendChild(document.createElement('br'));
  blockquote.parentNode.replaceChild(fragment, blockquote);
};

var normalizeMentionText = function normalizeMentionText(textContent) {
  var text = (textContent || '').trim();

  if (!text) {
    return '';
  }

  return text.charAt(0) === '@' ? text : '@' + text;
};

var normalizeCommentPreviewHtml = function normalizeCommentPreviewHtml(commentHtml) {
  if (!commentHtml || typeof document === 'undefined') {
    return commentHtml || '';
  }

  var container = document.createElement('div');
  container.innerHTML = commentHtml;

  // Normalize the preview into inert markup so the widget behaves as a single click target.
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(container.querySelectorAll('span[spoiler]')).forEach(function (spoiler) {
    spoiler.removeAttribute('spoiler');
    spoiler.classList.add(COMMENT_SPOILER_CLASS);
  });

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(container.querySelectorAll('a[mention], a[data-dsq-mention]')).forEach(function (mentionLink) {
    replaceNodeWithNode(mentionLink, createPreviewSpan(COMMENT_MENTION_CLASS, normalizeMentionText(mentionLink.textContent)));
  });

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(container.querySelectorAll('a')).forEach(function (anchor) {
    var linkText = (anchor.textContent || anchor.getAttribute('href') || '').trim();
    replaceNodeWithNode(anchor, createPreviewSpan(COMMENT_LINK_CLASS, linkText));
  });

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(container.querySelectorAll('pre, code, kbd')).forEach(function (codeElement) {
    replaceNodeWithNode(codeElement, createPreviewSpan(COMMENT_CODE_CLASS, codeElement.textContent));
  });

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(container.querySelectorAll('blockquote')).forEach(replaceBlockquoteWithPreviewQuote);

  return container.innerHTML;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountSocialAvatar: __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_avatar_account_social_avatar_vue__["a" /* default */]
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    hasDesktopRightRail: {
      type: Boolean,
      default: false
    },
    market: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isCommentEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('market', ['marketTopComments', 'marketTopCommentsLoaded', 'marketTopCommentsLoading', 'marketTopCommentsMarketId']), {
    marketId: function marketId() {
      return this.market && this.market.marketId ? this.market.marketId : null;
    },
    activeMarketId: function activeMarketId() {
      return this.isActive ? this.marketId : null;
    },
    topComments: function topComments() {
      return this.marketTopComments || {
        title: 'Top Recent Comments',
        comments: []
      };
    },
    comments: function comments() {
      return this.topComments.comments || [];
    },
    previewComments: function previewComments() {
      return this.comments.map(function (comment) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, comment, {
          previewHtml: normalizeCommentPreviewHtml(comment.commentHtml)
        });
      });
    },
    isLoadedForMarket: function isLoadedForMarket() {
      return this.marketTopCommentsLoaded && this.marketTopCommentsMarketId === this.marketId;
    },
    showTopComments: function showTopComments() {
      return this.isActive && this.isCommentEnabled && this.isLoadedForMarket && this.comments.length > 0;
    },
    showSkeleton: function showSkeleton() {
      return this.isActive && this.isCommentEnabled && this.marketTopCommentsLoading && !this.isLoadedForMarket;
    },
    rootModifiers: function rootModifiers() {
      return {
        'sushi-market-top-comments--with-right-rail': this.hasDesktopRightRail
      };
    },
    skeletonCount: function skeletonCount() {
      return TOP_RECENT_COMMENTS_SKELETON_COUNT;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('market', ['getMarketTopComments']), {
    loadTopComments: function loadTopComments(marketId) {
      if (!marketId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this.getMarketTopComments(marketId);
    },
    formatDate: function formatDate(value) {
      if (!value) {
        return '';
      }

      var date = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(value, __WEBPACK_IMPORTED_MODULE_3_moment___default.a.ISO_8601, true);
      var now = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc();

      if (!date.isValid()) {
        return '';
      }

      var secondsDiff = now.diff(date, 'seconds');

      if (secondsDiff < 0) {
        return date.local().toDate().toLocaleDateString('en-US');
      }

      if (secondsDiff < 60) {
        var elapsed = Math.max(secondsDiff, 1);
        return elapsed === 1 ? '1 second ago' : elapsed + ' seconds ago';
      }

      var minutesDiff = now.diff(date, 'minutes');

      if (minutesDiff < 60) {
        return minutesDiff === 1 ? '1 minute ago' : minutesDiff + ' minutes ago';
      }

      var hoursDiff = now.diff(date, 'hours');

      if (hoursDiff < 24) {
        return hoursDiff === 1 ? '1 hour ago' : hoursDiff + ' hours ago';
      }

      if (hoursDiff < 48) {
        return 'Yesterday';
      }

      return date.local().toDate().toLocaleDateString('en-US');
    },
    onOpenDiscussion: function onOpenDiscussion() {
      this.$emit('open-discussion');
    },
    onCommentClick: function onCommentClick(event, comment) {
      if (event) {
        event.preventDefault();
      }

      this.onOpenComment(comment);
    },
    onOpenComment: function onOpenComment(comment) {
      this.$emit('open-comment', comment);
    }
  }),
  watch: {
    activeMarketId: {
      handler: 'loadTopComments',
      immediate: true
    }
  }
});

/***/ }),

/***/ "TiAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi__ = __webpack_require__("HC9X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__ = __webpack_require__("yzoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_v2_button_price_button_price_vue__ = __webpack_require__("al65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__ = __webpack_require__("tRmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__ = __webpack_require__("X4WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_purchase_extended_betslip_purchase_extended_betslip_vue__ = __webpack_require__("Nqth");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_scrollTo__ = __webpack_require__("rrO7");













/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi__["a" /* default */]],
  components: {
    marketDisabledOutcomeV2: __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__["a" /* default */],
    buttonPrice: __WEBPACK_IMPORTED_MODULE_6__components_market_v2_button_price_button_price_vue__["a" /* default */],
    marketCharts: __WEBPACK_IMPORTED_MODULE_4__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */],
    purchaseTradeTypeSwitcherSushi: __WEBPACK_IMPORTED_MODULE_5__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__["a" /* default */],
    purchaseExtendedBetslip: __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_purchase_extended_betslip_purchase_extended_betslip_vue__["a" /* default */]
  },
  data: function data() {
    return {
      activeButton: __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES.id,
      BUTTONS: __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */],
      OPERATIONS: __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */],
      VALUES: __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */]
    };
  },

  watch: {
    'tradeOperationAndValue': function tradeOperationAndValue(v) {
      if (this.contract.contractId !== this.tradeOptions.contractId) return;
      var type = v.type,
          value = v.value;

      if (type && value) {
        this.activeButton = value === __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES ? __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES.id : __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_NO.id;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isTradingEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['status']), {
    chartOptions: function chartOptions() {
      return {
        include24hr: true,
        include7day: true,
        include30day: true,
        include90day: true,
        includeCandle: true,
        includeLine: true,
        includeLegend: false,
        contractIds: [this.tradeOptions.contractId]
      };
    },
    mainClassName: function mainClassName() {
      return 'purchase-offer-desktop-sushi-common-betslip';
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--maintenance', !this.isTradingEnabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--yes', this.tradeOptions.operationValue === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--no', this.tradeOptions.operationValue === 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--' + this.$router.currentRoute.name, true), _ref;
    },
    leftButtonText: function leftButtonText() {
      return this.activeButton === __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES.id ? 'Trade YES' : 'YES';
    },
    rightButtonText: function rightButtonText() {
      return this.activeButton === __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_NO.id ? 'Trade NO' : 'NO';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    isButtonActive: function isButtonActive(index) {
      var isOn = this.activeButton === index;
      var isButtonActive = this.tradeOptions.contractId === this.contract.contractId;

      return {
        'purchase-offer-desktop-sushi-common-betslip__button-single--active': isButtonActive,
        'purchase-offer-desktop-sushi-common-betslip__button-single--on': isOn,
        'purchase-offer-desktop-sushi-common-betslip__button-single--off': !isOn,
        'purchase-offer-desktop-sushi-common-betslip__button-single--off-yes': this.tradeOptions.operationValue === __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES,
        'purchase-offer-desktop-sushi-common-betslip__button-single--off-no': this.tradeOptions.operationValue === __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      if (this.isWaiting) {
        return;
      }

      this.isWaiting = false;
      if (this.forCmsWidget) {
        this.$emit('contractClicked', { contractId: contractId });
        return;
      }
      if (this.isMarketSettled) return;
      if (this.isMarketDisabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["w" /* contractOwnershipNum */])(this.contractModel) === 0) return;
      this.pushSessionHistoryContract({
        value: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.contract, {
          marketName: this.market.marketShortName || this.market.marketName
        })
      });
      this.setTradeOptions({
        contractId: contractId,
        operationType: operationType,
        operationValue: operationValue !== null ? operationValue : this.contractModel.mode || __WEBPACK_IMPORTED_MODULE_8__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES
      });
    }
  })
});

/***/ }),

/***/ "Tnlz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contracts-history",class:_vm.classModifiers},[(_vm.showLoader)?_c('table-rows-loader',{attrs:{"num":_vm.loaderNum}}):_vm._e(),_vm._v(" "),(_vm.showHeader && _vm.isComponentReady)?_c('div',{class:_vm.headModifiers},[_c('div',{staticClass:"contracts-history__contract"},[_vm._v("\n      Contract\n    ")]),_vm._v(" "),_c('div',{staticClass:"contracts-history__profit"},[(_vm.desktopColumns)?[_c('div',{staticClass:"contracts-history__profit-desk"},[_vm._v("\n          Profit/Loss\n        ")]),_vm._v(" "),_c('div',{staticClass:"contracts-history__profit-fees"},[_vm._v("\n          (Fees)\n        ")])]:[_vm._v("\n        Net P/L\n      ")]],2),_vm._v(" "),_c('div',{staticClass:"contracts-history__risk"},[_vm._v("\n      Risk Adj.\n    ")]),_vm._v(" "),_c('div',{staticClass:"contracts-history__cash"},[_c('plus-minus-sign',{staticClass:"contracts-history__plus-minus"}),_vm._v(" Cash\n    ")],1)]):_vm._e(),_vm._v(" "),(!_vm.showHeader)?_c('div',{staticClass:"contracts-history__line"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contracts-history__list"},[(_vm.compactMode && _vm.contracts.length === 0)?_c('div',{staticClass:"contracts-history__list-message"},[_vm._v("\n      You have no trades in the past 30 days\n    ")]):_vm._l((_vm.contracts),function(item,index){return _c('contract-tile',{key:index,staticClass:"contracts-history__item",attrs:{"showMarketName":_vm.showMarketNames,"data":item,"compactMode":_vm.compactMode,"desktop":_vm.desktopColumns}})}),_vm._v(" "),(_vm.marketId)?_c('div',{staticClass:"contracts-history__more"},[_c('div',{staticClass:"contracts-history__see"},[_vm._v("\n        For detailed information, see your "),(_vm.contracts.length > 0)?_c('router-link',{staticClass:"contracts-history__account-link",attrs:{"to":{ name: 'account-history', params: { marketId: _vm.marketId } }}},[_vm._v("Account History")]):[_vm._v("Account History")]],2)]):_vm._e(),_vm._v(" "),(_vm.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"contracts-history__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e(),_vm._v(" "),(!_vm.canLoadMore && !_vm.marketId)?_c('div',{staticClass:"contracts-history__loaded-info",domProps:{"innerHTML":_vm._s(_vm.loadedInfo)}}):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tp6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_desktop_header_js__ = __webpack_require__("lZ3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403fe3ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_desktop_header_vue__ = __webpack_require__("nPGV");
function injectStyle (ssrContext) {
  __webpack_require__("fFIe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_desktop_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403fe3ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_desktop_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tr7g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TtE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_discussion_js__ = __webpack_require__("vWyF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c89a599_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_discussion_vue__ = __webpack_require__("N9YZ");
function injectStyle (ssrContext) {
  __webpack_require__("n9Uc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_discussion_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c89a599_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_discussion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ttr+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TuQe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ty/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classModifiers,attrs:{"to":{name: 'market-details', params: {marketId: _vm.market.marketId, marketUrl: _vm.market.marketUrl}}}},[_c('div',{staticClass:"market-list-item-v2__container",on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_c('div',{staticClass:"market-list-item-v2__container-bg1",style:(_vm.styleModifiers)}),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__container-bg2"}),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__main-section"},[_c('div',{staticClass:"market-list-item-v2__main-section-container"},[_c('h3',{staticClass:"market-list-item-v2__title"},[_vm._v("\n            "+_vm._s(_vm.market.marketName)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__contracts"},_vm._l((_vm.contracts),function(item){return _c('market-contract',{key:_vm.contractKey(item),attrs:{"market":_vm.market,"contract":item}})}),1),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__shares"},[(!_vm.showVolume)?_c('span',{staticClass:"market-list-item-v2__shares-new"},[_vm._v("\n              NEW\n            ")]):[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(_vm.totalSharesTraded),expression:"totalSharesTraded"}]}),_vm._v(" Share"),(_vm.totalSharesTraded !== 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(" Traded\n            ")]],2)])]),_vm._v(" "),(_vm.watchIcon)?_c('div',{staticClass:"market-list-item-v2__right"},[_c('div',{staticClass:"market-list-item-v2__watch",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('watchToggle')}}},[_c('div',{staticClass:"market-list-item-v2__watch-icon"})])]):_vm._e(),_vm._v(" "),(_vm.showSharesOwnedNotification)?[_c('div',{staticClass:"market-list-item-v2__shares-owned"})]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tzaz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-map"},[(_vm.type === 'electoral')?_c('div',{staticClass:"overview-map__header"},[(_vm.isLayoutMobile)?[_vm._v("\n      Who will win the presidential election?\n    ")]:[_vm._v("\n      Presidential Election Winner?\n    ")]],2):_c('div',{staticClass:"overview-map__header"},[_vm._v("\n    Control of the Senate\n  ")]),_vm._v(" "),_c('div',{staticClass:"overview-map__content"},[(!_vm.isComponentReady)?[_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"content-loader-item"},[_c('overview-map-loader')],1)}),0)]:_vm._l((_vm.items),function(item){return _c('overview-map-contract',{key:item.contractId,staticClass:"overview-map__content-contract",attrs:{"type":_vm.type,"item":item}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U+El":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "U/rp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U23d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"page-dashboard-sushi__container"},[_c('div',{staticClass:"page-dashboard-sushi__main"},[_c('div',{staticClass:"page-dashboard-sushi__title"},[_vm._v("\n        Dashboard\n      ")]),_vm._v(" "),_c('div',{staticClass:"page-dashboard-sushi__toolbar"},[_c('div',{staticClass:"page-dashboard-sushi__toolbar-tabs"},[_c('tabs',{attrs:{"items":_vm.navigationTabs,"theme":"dashboard-nav","activeTab":_vm.activeNavigationTab},on:{"tabChange":_vm.navigationTabChange}})],1),_vm._v(" "),(_vm.portfolioValueReady)?_c('div',{staticClass:"page-dashboard-sushi__toolbar-info"},[_c('div',{staticClass:"page-dashboard-sushi__portfolio"},[_c('div',{staticClass:"page-dashboard-sushi__portfolio-value"},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.fixedflex",value:(_vm.portfolioValueDecimal),expression:"portfolioValueDecimal",modifiers:{"fixedflex":true}}]})]),_vm._v(" "),_c('div',{staticClass:"page-dashboard-sushi__portfolio-label"},[_vm._v("Portfolio Value")])]),_vm._v(" "),_c('div',{class:_vm.gainLossClassModifiers},[_c('div',{staticClass:"page-dashboard-sushi__gain-loss-value"},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.fixedflex",value:(Math.abs(_vm.mySharesTotalGainLoss)),expression:"Math.abs(mySharesTotalGainLoss)",modifiers:{"fixedflex":true}}]})]),_vm._v(" "),_c('div',{staticClass:"page-dashboard-sushi__gain-loss-label"},[_vm._v("Gain/Loss")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"page-dashboard-sushi__content"},[_c('router-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U2mR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U7Hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getValidationMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__ = __webpack_require__("FGdP");



function errorMessage(data) {
  var msg = __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__["a" /* default */][data.type];
  if (typeof msg === 'undefined') return '';
  if (data.type === 'minValue' || data.type === 'minValueDeposit' || data.type === 'greaterThan') {
    var value = data.min < 1 ? data.min.toFixed(2) : data.min;
    return msg.replace(/%v/g, value);
  }
  if (data.type === 'maxValueDeposit') return msg.replace(/%v/g, data.max);
  if (data.type === 'minLength' || data.type === 'minLengthDigit') return msg.replace(/%v/g, data.min);
  if (data.type === 'maxLength' || data.type === 'maxLengthDigit') return msg.replace(/%v/g, data.max);
  if (data.type === 'between') return msg.replace(/%v1/g, data.min.toFixed(2)).replace(/%v2/g, data.max.toFixed(2));
  if (data.type === 'exactLength') return msg.replace(/%v/g, data.target);
  return msg;
}

function getValidationMessage(field) {
  if (field.$invalid) {
    if (field.required === false) {
      return __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__["a" /* default */].required;
    }
    if (field.errorMessage) {
      return field.errorMessage;
    }
    var erMsg = '';
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(field.$params).some(function (obj) {
      if (!field[obj.type]) {
        erMsg = errorMessage(obj);
        return true;
      }
      return false;
    });
    return erMsg;
  }
  return '';
}

/***/ }),

/***/ "U7LV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "U8Te":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U91k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_filters_market_filters_desktop_grid_market_filters_desktop_grid_vue__ = __webpack_require__("vxYz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketFiltersDesktopGrid: __WEBPACK_IMPORTED_MODULE_1__components_market_market_filters_market_filters_desktop_grid_market_filters_desktop_grid_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true,
      default: 0
    },
    layout: {
      type: String,
      default: 'grid'
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentLayout: this.layout
    };
  },

  methods: {
    switchLayoutClicked: function switchLayoutClicked(layout) {
      this.currentLayout = layout;
      this.$emit('toggle', layout);
    },
    classModifier: function classModifier(layout) {
      var _ref;

      return _ref = {
        'market-list-desktop-header__switch-button': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-list-desktop-header__switch-button--' + layout, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-list-desktop-header__switch-button--active', this.currentLayout === layout), _ref;
    }
  }
});

/***/ }),

/***/ "U9Lo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    buyQuantity: {
      type: Number,
      default: 0
    },
    sellQuantity: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: 'yes'
    }
  },
  computed: {
    hasOffers: function hasOffers() {
      return this.buyQuantity > 0 || this.sellQuantity > 0;
    },
    buyQuantityFormatted: function buyQuantityFormatted() {
      return this.buyQuantity.toLocaleString('en-US');
    },
    sellQuantityFormatted: function sellQuantityFormatted() {
      return this.sellQuantity.toLocaleString('en-US');
    },
    buyQuantityDisplay: function buyQuantityDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["u" /* largeNumberDisplay */])(this.buyQuantity);
    },
    sellQuantityDisplay: function sellQuantityDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["u" /* largeNumberDisplay */])(this.sellQuantity);
    },
    buyValueClass: function buyValueClass() {
      return ['market-contract-horizontal-sushi-orders__value', 'market-contract-horizontal-sushi-orders__value--buy-' + (this.mode || 'yes'), 'market-contract-horizontal-sushi-orders__tooltip'];
    },
    sellValueClass: function sellValueClass() {
      return ['market-contract-horizontal-sushi-orders__value', 'market-contract-horizontal-sushi-orders__value--sell-' + (this.mode || 'yes'), 'market-contract-horizontal-sushi-orders__tooltip'];
    }
  }
});

/***/ }),

/***/ "UBij":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UEti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_disqus__ = __webpack_require__("oeb2");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_disqus__["a" /* default */]],
  props: {
    market: {
      type: Object,
      required: true
    },
    showInfoOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['isDiscussionPinned'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['toggleDiscussionPin']))
});

/***/ }),

/***/ "UGnQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coinbase-withdraw"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"withdraw"}}):[(!_vm.showConfirmation)?_c('div',[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending}}):[(!_vm.hasErrorMessage)?[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n          Withdrawing funds may cause some or all of your open orders to be cancelled.\n        ")]),_vm._v(" "),_c('form',{staticClass:"form ach__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('available-balance',{attrs:{"restricted":_vm.restrictedFunds,"balance":_vm.availableBalance}}),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.amount,"theme":"amount","name":"amount","disabled":_vm.isAmountFieldDisabled,"autocomplete":"","placeholder":"Withdrawal Amount (Minimum $1 USD)"},on:{"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1)]),_vm._v(" "),_c('h4',{staticClass:"coinbase-withdraw__section-title"},[_vm._v("\n            Email\n          ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"coinbase-withdraw__address"},[_vm._v("\n                "+_vm._s(_vm.withdrawCoinbase.email)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Review Request"}})],1)])],1)]:_vm._e(),_vm._v(" "),(_vm.hasErrorMessage)?_c('alert-box',{attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.hasErrorMessage)?[_c('div',{staticClass:"coinbase-withdraw__disclaimer",domProps:{"innerHTML":_vm._s(_vm.withdrawCoinbase.disclaimer)}})]:_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.showConfirmation)?_c('withdraw-confirm',{staticClass:"withdraw-confirm--with-margin",attrs:{"kind":"coinbase-withdraw","amendAvailable":true,"amount":Number(_vm.fields.amount),"fee":Number(_vm.fields.amount) * Number(_vm.withdrawCoinbase.feePercent),"recipient":_vm.withdrawCoinbase.email},on:{"edit":_vm.onEdit,"success":_vm.onSuccess}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UIPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_portfolio_my_markets_js__ = __webpack_require__("vV6Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aea34be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_portfolio_my_markets_vue__ = __webpack_require__("N1G7");
function injectStyle (ssrContext) {
  __webpack_require__("PmrE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_portfolio_my_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aea34be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_portfolio_my_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UKGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true,
      isOn: this.showPassword
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'show-password--on': this.isOn,
        'show-password--off': !this.isOn
      };
    },
    title: function title() {
      return this.isOn ? 'Hide password' : 'Show password';
    }
  },
  methods: {
    onPasswordToggle: function onPasswordToggle() {
      var _this = this;

      this.$emit('showPassword');
      this.show = false;
      this.isOn = !this.isOn;
      setTimeout(function () {
        _this.show = true;
      }, 0);
    }
  }
});

/***/ }),

/***/ "UKic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_accountVerify__ = __webpack_require__("yZQa");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_accountVerify__["a" /* default */]],
  methods: {
    onGoToWallet: function onGoToWallet() {
      if (this.isUserVerified) {
        this.$router.push({ name: 'wallet' });
      } else {
        this.$router.push({ name: 'account-details' });
      }
    }
  }
});

/***/ }),

/***/ "ULMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("sPnT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac999fea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("Cwec");
function injectStyle (ssrContext) {
  __webpack_require__("4Ny/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac999fea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UPFk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tax-info-notification"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[(_vm.statement)?_c('p',{staticClass:"tax-info-notification__disclaimer"},[_vm._v("\n          "+_vm._s(_vm.statement)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.mandatoryStatement)?_c('p',{staticClass:"tax-info-notification__disclaimer tax-info-notification__disclaimer--statement"},[_vm._v("\n          "+_vm._s(_vm.mandatoryStatement)+"\n        ")]):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.name,"disabled":_vm.isFormDisabled,"name":"name","type":"text","required":true,"autocomplete":"name","placeholder":"Name"},on:{"input":_vm.$v.fields.name.$touch},model:{value:(_vm.fields.name),callback:function ($$v) {_vm.$set(_vm.fields, "name", $$v)},expression:"fields.name"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.address,"disabled":_vm.isFormDisabled,"name":"address","type":"text","required":true,"autocomplete":"address","placeholder":"Address"},on:{"input":_vm.$v.fields.address.$touch},model:{value:(_vm.fields.address),callback:function ($$v) {_vm.$set(_vm.fields, "address", $$v)},expression:"fields.address"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.city,"disabled":_vm.isFormDisabled,"name":"city","type":"text","required":true,"autocomplete":"city","placeholder":"City"},on:{"input":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.stateCode,"disabled":_vm.isFormDisabled,"name":"stateCode","type":"text","required":true,"autocomplete":"state-code","placeholder":"State Code"},on:{"input":_vm.$v.fields.stateCode.$touch},model:{value:(_vm.fields.stateCode),callback:function ($$v) {_vm.$set(_vm.fields, "stateCode", $$v)},expression:"fields.stateCode"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.zipCode,"disabled":_vm.isFormDisabled,"name":"zipCode","type":"text","required":true,"autocomplete":"postal-code","placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.taxId,"disabled":_vm.isFormDisabled,"name":"taxId","type":"text","required":true,"autocomplete":"taxId","placeholder":"Social Security number or ITIN"},on:{"input":_vm.$v.fields.taxId.$touch},model:{value:(_vm.fields.taxId),callback:function ($$v) {_vm.$set(_vm.fields, "taxId", $$v)},expression:"fields.taxId"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"tax-info-notification__disclaimer"},[_vm._v("\n          If you cannot complete this form for any reason, please contact "),_c('a',{attrs:{"href":("mailto:" + (_vm.systemEmails.support))}},[_vm._v(_vm._s(_vm.systemEmails.support))])])]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Submit"}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tax-info-notification__disclaimer"},[_c('span',{staticClass:"tax-info-notification__title"},[_vm._v("Please provide or confirm the following information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('p',{staticClass:"tax-info-notification__disclaimer"},[_c('span',{staticClass:"tax-info-notification__title"},[_vm._v("Please provide your Social Security number or ITIN")]),_vm._v(" "),_c('br'),_vm._v("\n          Note that this number is only used for tax reporting purposes and will be encrypted to ensure proper security.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tax-info-notification__disclaimer"},[_c('span',{staticClass:"tax-info-notification__title"},[_vm._v("By submitting this form, I certify that:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"tax-info-notification__list"},[_c('li',[_vm._v("The number shown on this form is my correct Social Security number or individual taxpayer identification number, and")]),_vm._v(" "),_c('li',[_vm._v("I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding and")]),_vm._v(" "),_c('li',[_vm._v("I am a U.S Person (a US Citizen living anywhere in the world or a Resident Alien)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UTL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLayoutDesktop)?_c('div',{class:_vm.classModifiers},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__content"},[((_vm.theme === 'currently' || _vm.theme === 'comments'))?[_c('div',{staticClass:"market-widget-loader__avatarised"},[_vm._m(1),_vm._v(" "),(_vm.theme === 'currently')?_c('div',{staticClass:"market-widget-loader__avatarised-item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text market-widget-loader__avatarised-text--short"})]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.theme === 'money')?[_vm._m(3)]:_vm._e(),_vm._v(" "),(_vm.theme === 'stats')?[_vm._m(4)]:_vm._e()],2)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__header"},[_c('div',{staticClass:"market-widget-loader__header-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__avatarised-item"},[_c('div',{staticClass:"market-widget-loader__avatarised-head"},[_c('div',{staticClass:"market-widget-loader__avatarised-avatar"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-title"})]),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text market-widget-loader__avatarised-text--short"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__avatarised-head"},[_c('div',{staticClass:"market-widget-loader__avatarised-avatar"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-title"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__stats"},[_c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})]),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UV+D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-item-simple"},[_c('div',{staticClass:"notification-item-simple__container"},[_c('div',{staticClass:"notification-item-simple__icon"},[(_vm.icon === 'pending')?_c('img',{attrs:{"src":__webpack_require__("U+El")}}):_vm._e(),_vm._v(" "),(_vm.icon === 'cancel')?_c('img',{attrs:{"src":__webpack_require__("VM/5")}}):_vm._e()]),_vm._v(" "),(_vm.title)?_c('h4',{staticClass:"notification-item-simple__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.showAutoCloseLoader)?_c('div',{staticClass:"notification-item-simple__loader",style:({ '--close-timeout': (_vm.closeTimeout + "ms") })},[_c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32"}},[_c('circle',{staticClass:"notification-item-simple__loader-ring",attrs:{"cx":"16","cy":"16","r":"13"}})])]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-simple__close",on:{"click":_vm.onClose}})]),_vm._v(" "),_c('div',{staticClass:"notification-item-simple__container notification-item-simple__container--simple"},[_c('div',{staticClass:"notification-item-simple__text"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UWOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classModifiers,attrs:{"href":_vm.marketDetailUrl}},[(_vm.isLayoutMobile)?[_c('div',{staticClass:"overview-map-contract__image-wrapper"},[_c('div',{staticClass:"overview-map-contract__image",style:(_vm.imageStyleModifiers)}),_vm._v(" "),(false)?_c('div',{staticClass:"overview-map-contract__indicator",style:(_vm.bgColorStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info"},[_c('span',{staticClass:"overview-map-contract__current-price"},[(_vm.contractModel.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.contractModel.lastTradePriceAsCents}})]:[_vm._v("\n              -\n            ")]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1)]),_vm._v(" "),_c('span',{staticClass:"overview-map-contract__title",style:(_vm.bgColorStyleModifiers)},[_vm._v("\n      "+_vm._s(_vm.item.shortName)+"\n    ")])]:[_c('div',{staticClass:"overview-map-contract__image-wrapper"},[_c('div',{staticClass:"overview-map-contract__image",style:(_vm.imageStyleModifiers)}),_vm._v(" "),(false)?_c('div',{staticClass:"overview-map-contract__indicator",style:(_vm.bgColorStyleModifiers)}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info-wrapper"},[_c('span',{staticClass:"overview-map-contract__title",style:(_vm.bgColorStyleModifiers)},[_vm._v("\n        "+_vm._s(_vm.item.shortName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info"},[_c('span',{staticClass:"overview-map-contract__current-price"},[(_vm.contractModel.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.contractModel.lastTradePriceAsCents}})]:[_vm._v("\n              -\n            ")]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1)])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UWaV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UWgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_js__ = __webpack_require__("V00F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4283b276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__("OMZ0");
function injectStyle (ssrContext) {
  __webpack_require__("N8e0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4283b276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UXtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_compact_js__ = __webpack_require__("TYUd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b42fe910_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_compact_vue__ = __webpack_require__("poL5");
function injectStyle (ssrContext) {
  __webpack_require__("ApBL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_compact_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b42fe910_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_compact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ucvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ach_js__ = __webpack_require__("5g2X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2565370c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ach_vue__ = __webpack_require__("br/H");
function injectStyle (ssrContext) {
  __webpack_require__("+MUC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ach_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2565370c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ach_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uepp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-info-loader"},[_c('div',{staticClass:"leaderboards-info-loader__text"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-info-loader__position"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ufge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    chartOptions: {
      type: Object,
      default: null
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['chartTimeline', 'chartType', 'market']), {
    showDownload: function showDownload() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeDownload', true);
    }
  }),
  methods: {
    onDownload: function onDownload() {
      var url = "/Resource/DownloadMarketChartData" + '?marketid=' + this.market.marketId + '&timespan=' + this.chartTimeline;
      window.open(url, '_blank');
    }
  }
});

/***/ }),

/***/ "Ug2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");







var DEFAULT_AVATAR = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["C" /* getAssetPath */])('/images/Avatars/default.png');

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData']), {
    avatar: function avatar() {
      if (this.userData && this.userData.avatarImage) {
        return this.userData.avatarImage;
      }
      return '';
    },
    showRemoveOption: function showRemoveOption() {
      return this.avatar && this.avatar !== DEFAULT_AVATAR;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['uploadUserImage', 'resetUserImage', 'getAccountDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    fileToBase64: function fileToBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result.replace(/^data:image\/(png|jpg|jpeg);base64,/, ''));
        };
        reader.onerror = function (error) {
          reject(error);
        };
      });
    },
    onUpload: function onUpload() {
      this.$refs.fileinput.click();
    },
    onRemove: function onRemove() {
      var _this = this;

      this.resetUserImage().then(function () {
        setTimeout(function () {
          _this.setCurrentSmallPopup();
        }, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT);
        _this.setSuccessSideNotification('Your profile photo has been removed');
      }).then(this.getAccountDetail).catch(function () {});
    },
    onChange: function onChange() {
      var _this2 = this;

      this.loaderAdd();
      var formData = new FormData();
      formData.append('files', this.$refs.fileinput.files[0]);

      this.uploadUserImage(formData).then(function () {
        _this2.loaderRemove();
        setTimeout(function () {
          _this2.setCurrentSmallPopup();
        }, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT);
        _this2.setSuccessSideNotification('Your profile image has been submitted for review');
      }).then(this.getAccountDetail).catch(function (e) {
        var message = e.response.data && e.response.data.message ? e.response.data.message : 'An error has occurred.';
        _this2.setErrorSideNotification(message);
        _this2.loaderRemove();
      });
    }
  })
});

/***/ }),

/***/ "UgWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.items.length === 0)?_c('div',{staticClass:"session-history-sushi__note"},[_c('market-empty-state',{attrs:{"icon":"session-history"}},[_vm._v("\n      Session history is empty.\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.type === 'widget' || _vm.isLayoutMobile)?_vm._l((_vm.items),function(item,index){return _c('div',{key:("session-history-" + index + "-" + (item.marketId)),staticClass:"market-contract-info-v2__widget-item"},[_c('market-contract-info-v2',{attrs:{"image":item.image,"link":_vm.itemLink(item),"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n            "+_vm._s(item.marketName)+"\n          ")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__value-light"},[_vm._v(_vm._s(item.contractName))]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[(item.price)?_c('market-change-price',{attrs:{"price":item.price,"lastClosePrice":item.lastClosePrice}}):_vm._e(),_vm._v(" "),(item.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":item.priceAsCents}})]:[_vm._v("\n                  NEW\n                ")]],2)])]},proxy:true}],null,true)})],1)}):_vm._l((_vm.items),function(item,index){return _c('div',{key:("session-history-" + index + "-" + (item.marketId)),staticClass:"market-contract-info-v2__widget-item market-contract-info-v2__widget-item--border-bottom"},[_c('market-contract-info-v2',{staticClass:"market-contract-info-v2--center market-contract-info-v2--center-detailed",attrs:{"image":item.image,"link":_vm.itemLink(item),"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row-h100"},[_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wsessionhistory"},[_c('div',{staticClass:"market-contract-info-v2__market-name"},[_vm._v("\n                  "+_vm._s(item.marketName)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wsessionhhistorymain"},[_c('div',{staticClass:"market-contract-info-v2__col"},_vm._l((item.contracts),function(contract,index){return _c('div',{key:("session-history-" + index + "-" + (contract.contractId)),staticClass:"market-contract-info-v2__contract-row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__contract-row-name"},[_vm._v("\n                        "+_vm._s(contract.contractName)+"\n                    ")]),_vm._v(" "),_c('div',[(contract.changePriceAsCents)?_c('market-change-price',{attrs:{"price":contract.changePriceAsCents,"lastClosePrice":contract.lastClosePrice}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-contract-info-v2--mono market-contract-info-v2__contract-row-price"},[(contract.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":contract.lastTradePriceAsCents}})]:[_vm._v("\n                          NEW\n                        ")]],2)],1)])}),0)])])]},proxy:true}],null,true)})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UhjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UqqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_js__ = __webpack_require__("eb91");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a0a58ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_vue__ = __webpack_require__("aIx/");
function injectStyle (ssrContext) {
  __webpack_require__("sIXq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a0a58ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UtW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters_consts__ = __webpack_require__("OJH0");










/* eslint-disable arrow-body-style, max-len, comma-dangle */







var KEY_SHOULD_SHOW_TIMESPAN = 'watchlist-should-show-timespan';
var KEY_SELECTED_ORDER = 'watchlist-selected-order';
var KEY_SELECTED_TIMESPAN = 'watchlist-selected-timespan';

var DEFAULT_WATCHLIST = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    orders: __WEBPACK_IMPORTED_MODULE_13__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_13__filters_consts__["b" /* TIMESPANS */],
    watchlist: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_WATCHLIST),
    selectedOrder: __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_ORDER, __WEBPACK_IMPORTED_MODULE_13__filters_consts__["a" /* ORDERS */][0]),
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_TIMESPAN, __WEBPACK_IMPORTED_MODULE_13__filters_consts__["c" /* AVAILABLE_TIMESPANS */].ALL),
    shouldShowTimespanFilter: __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get(KEY_SHOULD_SHOW_TIMESPAN, true)
  },
  mutations: {
    updateWatchlistFromNotification: function updateWatchlistFromNotification(state, data) {
      if (state.watchlist.data) {
        state.watchlist = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.watchlist, {
          data: state.watchlist.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateWatchlistContractFromNotification: function updateWatchlistContractFromNotification(state, data) {
      if (state.watchlist.data) {
        state.watchlist = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.watchlist, {
          data: state.watchlist.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    selectOrder: function selectOrder(state, sort) {
      var selectedOrder = __WEBPACK_IMPORTED_MODULE_9_lodash_find___default()(state.orders, { sort: sort });
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_13__filters_consts__["d" /* DEFAULT_TIMESPANS */][sort] || __WEBPACK_IMPORTED_MODULE_13__filters_consts__["c" /* AVAILABLE_TIMESPANS */].EMPTY;
      var shouldShowTimespan = __WEBPACK_IMPORTED_MODULE_13__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(selectedOrder.sort) !== -1;
      state.selectedOrder = selectedOrder;
      state.selectedTimespan = selectedTimespan;
      state.shouldShowTimespanFilter = shouldShowTimespan;
      __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
      __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(KEY_SHOULD_SHOW_TIMESPAN, shouldShowTimespan);
      __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_ORDER, selectedOrder);
    },
    selectTimespan: function selectTimespan(state, parameter) {
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_9_lodash_find___default()(state.timespans, { parameter: parameter });
      state.selectedTimespan = selectedTimespan;
      __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
    },
    updateWatchList: function updateWatchList(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(state.watchlist.data));
      var data = __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default()(sourceData.concat(payload.data.markets || []), 'marketId');
      var page = payload.data.page;
      var totalCount = payload.data.totalMarkets;
      var canLoadMore = totalCount > data.length;

      state.watchlist = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.watchlist, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setWatchlistData: function setWatchlistData(state, payload) {
      state.watchlist = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.watchlist, {
        data: payload.data,
        page: payload.page,
        totalCount: payload.totalCount,
        canLoadMore: payload.totalCount > payload.data.length
      });
    },
    resetWatchlist: function resetWatchlist(state) {
      state.watchlist = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_WATCHLIST);
    }
  },
  actions: {
    reloadWatchlist: function reloadWatchlist(_ref) {
      var _this = this;

      var state = _ref.state,
          commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var totalPages, results, allMarkets, data, lastResult, totalMarkets;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                totalPages = state.watchlist.page;

                if (!(totalPages === 0)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()({ length: totalPages }, function (_, i) {
                  return i + 1;
                }).map(function (page) {
                  return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getMarketWatch(state.selectedOrder.sort, state.selectedTimespan.parameter, page);
                }));

              case 5:
                results = _context.sent;
                allMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(results.map(function (r) {
                  return r.data.markets || [];
                }));
                data = __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default()(allMarkets, 'marketId');
                lastResult = results[results.length - 1].data;
                totalMarkets = lastResult.totalMarkets || state.watchlist.totalCount;


                commit('setWatchlistData', {
                  data: data,
                  page: totalPages,
                  totalCount: totalMarkets
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    resetWatchlist: function resetWatchlist(_ref2) {
      var commit = _ref2.commit;

      commit('resetWatchlist');
    },
    getWatchList: function getWatchList(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.watchlist.canLoadMore) {
        var page = state.watchlist.page + 1;
        return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getMarketWatch(state.selectedOrder.sort, state.selectedTimespan.parameter, page).then(function (response) {
          commit('updateWatchList', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    selectOrder: function selectOrder(_ref4, sort) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      commit('selectOrder', sort);
    },
    selectTimespan: function selectTimespan(_ref5, timespan) {
      var state = _ref5.state,
          dispatch = _ref5.dispatch,
          commit = _ref5.commit;

      commit('selectTimespan', timespan);
    },
    updateWatchlistFromNotification: function updateWatchlistFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateWatchlistFromNotification', payload);
    },
    updateWatchlistContractFromNotification: function updateWatchlistContractFromNotification(_ref7, payload) {
      var commit = _ref7.commit;

      commit('updateWatchlistContractFromNotification', payload);
    }
  }
});

/***/ }),

/***/ "UuoC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UwQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_watchlist_js__ = __webpack_require__("exX2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd33354_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_watchlist_vue__ = __webpack_require__("xR86");
function injectStyle (ssrContext) {
  __webpack_require__("TuQe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_watchlist_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd33354_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_watchlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V+2w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.ready && _vm.historyContracts.length === 0)?_c('div',{staticClass:"trade-history-sushi__note trade-history-sushi__note--margin-top"},[_c('market-empty-state',{attrs:{"icon":"trade-history"}},[_vm._v("\n      You have no trades in the past 30 days.\n    ")])],1):(_vm.ready)?_c('div',[(!_vm.isLayoutMobile)?[_c('div',{staticClass:"trade-history-sushi__header-wrap"},[_c('div',{staticClass:"trade-history-sushi__header-subtitle"},[_vm._v("\n          Last 30 Days\n        ")]),_vm._v(" "),_c('div',{staticClass:"trade-history-sushi__header"},[_c('div',{staticClass:"trade-history-sushi__header-1"},[_vm._v("Net P/L "),_c('div',{staticClass:"trade-history-sushi__icon",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showNetPLInfo($event)}}})]),_vm._v(" "),_c('div',{staticClass:"trade-history-sushi__header-2"},[_vm._v("Risk Adj.")]),_vm._v(" "),_c('div',{staticClass:"trade-history-sushi__header-3"},[_c('plus-minus-sign'),_vm._v(" Cash")],1),_vm._v(" "),_c('div',{staticClass:"trade-history-sushi__header-4"},[_vm._v("Date")])])]),_vm._v(" "),_vm._l((_vm.historyContracts),function(item,index){return _c('div',{key:item.id,staticClass:"market-contract-info-v2__widget-item",class:{'market-contract-info-v2__widget-item--border-bottom': index != _vm.historyContracts.length - 1}},[_c('market-contract-info-v2',{attrs:{"marketId":item.marketId,"contractId":item.contractId,"image":item.contractImageSmallUrl,"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row-h100"},[_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wtradehistorymain",class:{
                'market-contract-info-v2__col--no-image': !item.contractImageSmallUrl
              }},[_c('div',{staticClass:"market-contract-info-v2__contract-name"},[_vm._v("\n                  "+_vm._s(item.contractName || _vm.contractName(item))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__action"},[_vm._v("\n                  "+_vm._s(_vm.typeToString(item))+" "),_c('span',{staticClass:"market-contract-info-v2--mono"},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "+_vm._s(_vm.tradeActionToString(item))+" at "),_c('span',{staticClass:"market-contract-info-v2--mono"},[_c('animated-number',{attrs:{"value":_vm.itemPriceInCents(item)}})],1)])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wtradehistory"},[_c('div',{staticClass:"market-contract-info-v2__contract-value market-contract-info-v2--mono"},[_vm._v("\n                  "+_vm._s(item.netProfitLossString)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wtradehistory"},[_c('div',{staticClass:"market-contract-info-v2__contract-value market-contract-info-v2--mono"},[_vm._v("\n                  "+_vm._s(item.riskChangeString)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wtradehistory"},[_c('div',{staticClass:"market-contract-info-v2__contract-value market-contract-info-v2--mono"},[_vm._v("\n                  "+_vm._s(item.tradeValueString)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col"},[_c('div',{staticClass:"market-contract-info-v2__contract-value market-contract-info-v2--mono"},[_vm._v(_vm._s(_vm.itemMainDate(item)))]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__action"},[_vm._v(_vm._s(_vm.itemSecondaryDate(item)))])])])]},proxy:true}],null,true)})],1)})]:[_vm._m(0),_vm._v(" "),_vm._l((_vm.historyContracts),function(item){return _c('div',{key:item.id,staticClass:"market-contract-info-v2__widget-item"},[_c('market-contract-info-v2',{attrs:{"marketId":item.marketId,"contractId":item.contractId,"image":item.contractImageSmallUrl,"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n            "+_vm._s(item.contractName || _vm.contractName(item))+"\n          ")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row"},[_c('div',{staticClass:"market-contract-info-v2__value-light"},[_vm._v("Action")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[_vm._v("\n                  "+_vm._s(_vm.typeToString(item))+" "+_vm._s(item.quantity)+" "+_vm._s(_vm.tradeActionToString(item).toUpperCase())+" at "),_c('animated-number',{attrs:{"value":_vm.itemPriceInCents(item)}})],1)]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__row"},[_c('div',{staticClass:"market-contract-info-v2__value-light"},[_vm._v("Net P/L "),_c('div',{staticClass:"trade-history-sushi__icon",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showNetPLInfo($event)}}})]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[_vm._v(_vm._s(_vm.reformatStringValue(item.netProfitLossString)))])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__row"},[_c('div',{staticClass:"market-contract-info-v2__value-light"},[_vm._v("Risk Adj.")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[_vm._v(_vm._s(_vm.reformatStringValue(item.riskChangeString)))])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__row"},[_c('div',{staticClass:"market-contract-info-v2__value-light"},[_c('plus-minus-sign'),_vm._v(" Cash")],1),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[_vm._v(_vm._s(_vm.reformatStringValue(item.tradeValueString)))])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__row"},[_c('div',{staticClass:"market-contract-info-v2__value-light"},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[_vm._v(_vm._s(_vm.dateToString(item.dateExecuted)))])])]},proxy:true}],null,true)})],1)})],_vm._v(" "),(_vm.historyContracts.length < _vm.MAX_CONTRACTS_NUM)?_c('div',{staticClass:"trade-history-sushi__note trade-history-sushi__note--light"},[_vm._v("\n      You have no other trades in the last 30 days.\n    ")]):_vm._e(),_vm._v(" "),(_vm.history.totalCount > _vm.MAX_CONTRACTS_NUM)?_c('router-link',{staticClass:"trade-history-sushi__history-link",attrs:{"to":{ name: 'account-history', params: { marketId: _vm.market.marketId }, query: { tabId: 'trades' } }}},[_vm._v("\n      See more\n    ")]):_vm._e()],2):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trade-history-sushi__header-wrap"},[_c('div',{staticClass:"trade-history-sushi__header-subtitle"},[_vm._v("\n          Last 30 Days\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V/Y1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_debug_js__ = __webpack_require__("sA4S");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78964f96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_debug_vue__ = __webpack_require__("RMkq");
function injectStyle (ssrContext) {
  __webpack_require__("9IBX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_debug_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78964f96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_debug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "V00F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__ = __webpack_require__("GZXJ");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'text'
    },
    autocomplete: {
      type: String,
      required: false
    },
    disabled: Boolean,
    name: {
      type: String,
      required: true
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    max: Number,
    min: Number,
    value: [String, Number],
    // new stuff
    validation: Object,
    theme: {
      type: String,
      default: ''
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: ''
    },
    hideIconOnValue: {
      type: Boolean,
      default: true
    },
    showValidationWithin: {
      type: Boolean,
      default: true
    },
    masked: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    inputStyleModifiers: function inputStyleModifiers() {
      if (this.masked) {
        return {
          'text-security': 'disc',
          '-webkit-text-security': 'disc',
          '-moz-text-security': 'disc'
        };
      }
      return {};
    },
    inputModifiers: function inputModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'input--no-placeholder': !this.placeholder,
        'input--has-value': this.value,
        'input--is-focused': this.focus,
        'input--is-disabled': this.disabled,
        'input--hide-icon': this.hideIconOnValue
      }, 'input--' + this.theme, this.theme);
    },
    errorMessage: function errorMessage() {
      return this.validation ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_getValidationMessage__["a" /* default */])(this.validation) : '';
    },
    error: function error() {
      return this.validation ? this.validation.$error : false;
    },
    successTick: function successTick() {
      // if (this.validation) {
      //   if (this.validation.required === undefined && this.value === '') {
      //     return false;
      //   }
      //   return this.validation.$dirty && !this.validation.$invalid;
      // }
      return false;
    },
    hasIcon: function hasIcon() {
      return !!this.$slots.icon;
    },
    gtmObject: function gtmObject() {
      var _gtm$split = this.gtm.split(','),
          _gtm$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_gtm$split, 2),
          category = _gtm$split2[0],
          label = _gtm$split2[1];

      return {
        event: 'eventTrackerTrigger',
        category: category,
        action: 'fill',
        label: label
      };
    }
  },
  methods: {
    handleBlur: function handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
      if (this.gtm && this.value) {
        this.$gtm.trackEvent(this.gtmObject);
      }
    },
    handleFocus: function handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);

      if (this.isWrapperApp) {
        e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    updateValue: function updateValue(e) {
      this.$emit('input', e.target.value);
    }
  }
});

/***/ }),

/***/ "V3zd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_login_js__ = __webpack_require__("+poj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53d5b67f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_login_vue__ = __webpack_require__("fvWR");
function injectStyle (ssrContext) {
  __webpack_require__("LdRG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53d5b67f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VJVd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showMenu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['watchedUserDetails', 'userData']), {
    showMenuToggle: function showMenuToggle() {
      return this.isLoggedIn && this.userData.userName !== this.watchedUserDetails.userName;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onMenuToggle: function onMenuToggle() {
      this.showMenu = !this.showMenu;
    },
    onReportUser: function onReportUser() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_REPORT_USER);
    }
  })
});

/***/ }),

/***/ "VM/5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MyIgaGVpZ2h0PSI0MyIgdmlld0JveD0iMCAwIDQzIDQzIj4KICAgIDxkZWZzPgogICAgICAgIDxmaWx0ZXIgaWQ9ImEiIHdpZHRoPSIxMDMuNyUiIGhlaWdodD0iMTIyLjIlIiB4PSItMS45JSIgeT0iLTcuOSUiIGZpbHRlclVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgICAgICAgIDxmZU9mZnNldCBkeT0iMiIgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSIvPgogICAgICAgICAgICA8ZmVHYXVzc2lhbkJsdXIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIiBzdGREZXZpYXRpb249IjIiLz4KICAgICAgICAgICAgPGZlQ29sb3JNYXRyaXggaW49InNoYWRvd0JsdXJPdXRlcjEiIHJlc3VsdD0ic2hhZG93TWF0cml4T3V0ZXIxIiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMiAwIi8+CiAgICAgICAgICAgIDxmZU1lcmdlPgogICAgICAgICAgICAgICAgPGZlTWVyZ2VOb2RlIGluPSJzaGFkb3dNYXRyaXhPdXRlcjEiLz4KICAgICAgICAgICAgICAgIDxmZU1lcmdlTm9kZSBpbj0iU291cmNlR3JhcGhpYyIvPgogICAgICAgICAgICA8L2ZlTWVyZ2U+CiAgICAgICAgPC9maWx0ZXI+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbHRlcj0idXJsKCNhKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1IC0xMikiPgogICAgICAgIDxwYXRoIGZpbGw9IiNkOTUzNGYiIHN0cm9rZT0iI2Q5NTM0ZiIgZD0iTTIwIDMxLjVDMjAgNDAuNjEyIDI3LjM4NiA0OCAzNi41IDQ4IDQ1LjYxMiA0OCA1MyA0MC42MTIgNTMgMzEuNVM0NS42MTIgMTUgMzYuNSAxNUMyNy4zODYgMTUgMjAgMjIuMzg4IDIwIDMxLjV6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTM5LjE5OSAzNy4wOGwtMi42OTQtMi42OTItMi43MDQgMi43YTIuMDQyIDIuMDQyIDAgMSAxLTIuODktMi44ODdsMi43MDMtMi43MDItMi43MDItMi43Yy0uOC0uNzk5LS44LTIuMDkxIDAtMi44ODhhMi4wNDIgMi4wNDIgMCAwIDEgMi44OSAwbDIuNzAzIDIuN0wzOS4yIDI1LjkyYTIuMDQyIDIuMDQyIDAgMSAxIDIuODkgMi44ODdsLTIuNjk0IDIuNjk0IDIuNjkzIDIuNjkyYy44Ljc5Ni44IDIuMDkgMCAyLjg4N2EyLjA0NiAyLjA0NiAwIDAgMS0yLjg5IDB6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "VQsM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-invite-widget"},[_c('div',{staticClass:"share-invite-widget__title"},[_c('span',{staticClass:"share-invite-widget__title-text"},[_vm._v("Invite Your Friends")]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__title-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__content"},[(_vm.successEmail)?_c('div',{staticClass:"share-invite-widget__success"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__success-message"},[_vm._v("\n        An invitation has been sent to "+_vm._s(_vm.successEmail)+".\n        "),_c('br'),_c('br'),_vm._v("Invite more friends below.\n      ")])]):_c('div',{staticClass:"share-invite-widget__label"},[_vm._v("\n      Enter an Email Address\n    ")]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__form"},[_c('div',{staticClass:"share-invite-widget__input"},[_c('form-input',{attrs:{"placeholder":" ","theme":"invite","validation":_vm.$v.fields.email,"name":"email","type":"text","required":false,"autocomplete":"email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"button button--primary share-invite-widget__button",attrs:{"disabled":_vm.invalidOrDisabled},on:{"click":_vm.onSend}},[_vm._v("\n            SEND\n          ")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__subtitle"},[_vm._v("\n      Share on Social Media\n    ")]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__icons"},[_c('div',{staticClass:"share-invite-widget__icon share-invite-widget__icon--facebook",on:{"click":_vm.onFacebookShare}}),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__icon share-invite-widget__icon--twitter",on:{"click":_vm.onTwitterShare}},[_c('img',{attrs:{"src":__webpack_require__("SdQH")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-invite-widget__success-icon-wrapper"},[_c('div',{staticClass:"share-invite-widget__success-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-invite-widget__line"},[_c('div',{staticClass:"share-invite-widget__line-part"}),_vm._v(" "),_c('div',[_vm._v("or")]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__line-part"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VYD9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VYlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-history"},[(_vm.isLoggedIn)?[_vm._m(0),_vm._v(" "),_c('trade-history-sushi',{ref:"tradeHistory"})]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-history__title sushi-market-history__title--no-padding"},[_c('div',{staticClass:"sushi-market-history__title-text"},[_vm._v("Trade History")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VYq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_switch_switch_vue__ = __webpack_require__("iOeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");



 /* eslint-disable no-restricted-syntax */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    switchModal: __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_switch_switch_vue__["a" /* default */]
  },
  props: {
    items: {},
    price: {
      type: Number,
      required: true
    },
    operationType: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    title: function title() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["B" /* capitalizeFirstLetter */])(this.operationType) + ' Orders at ' + this.price + '\xA2';
    },
    hasBeforeMeOffers: function hasBeforeMeOffers() {
      return this.groupedRecords.length > 1 && !this.groupedRecords[0][0].isMine;
    },
    hasAfterMeOffers: function hasAfterMeOffers() {
      return this.groupedRecords.length > 1 && !this.groupedRecords[this.groupedRecords.length - 1][0].isMine;
    },
    groupedRecords: function groupedRecords() {
      if (this.items.length === 0) return [];

      var results = [];
      var temp = [];
      var previousFlag = null;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (previousFlag !== null && item.isMine !== previousFlag) {
            results.push([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(temp)));
            temp = [];
          }

          temp.push(item);
          previousFlag = item.isMine;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      results.push([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(temp)));

      return results;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isFirstGroupedIndex: function isFirstGroupedIndex(index) {
      return index === 0;
    },
    isLastGroupedIndex: function isLastGroupedIndex(index) {
      return index === this.groupedRecords.length - 1;
    },
    areMine: function areMine(records) {
      return records[0].isMine;
    },
    rowClassModifiers: function rowClassModifiers(records) {
      return {
        'offers-indicator--highlight': this.areMine(records)
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('overlay', {
    hideOverlay: 'hide'
  }), {
    displayRecords: function displayRecords(records) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default()(records, function (i) {
        return i.quantity;
      }).toLocaleString('en-US');
    },
    close: function close() {
      this.$emit('modalClose');
    }
  })
});

/***/ }),

/***/ "Vgd5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vgn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_settings_settings__ = __webpack_require__("8p/V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'small-modal': function smallModal() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "+CQ6"));
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['settingShowOdds', 'settingOrderbookCollapsed', 'settingColorPalette', 'settingMobileLayout']), {
    settingsModalOptions: function settingsModalOptions() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3__components_account_settings_settings__["c" /* UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING */].filter(function (setting) {
        return _this.isLayoutMobile || setting.key !== __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingShowOdds', 'setSettingOrderbookCollapsed', 'setSettingColorPalette', 'setSettingMobileLayout']), {
    close: function close() {
      this.$emit('input', false);
    },
    isOptionDisabled: function isOptionDisabled(option) {
      return !!option.disabled;
    },
    onSettingOptionClick: function onSettingOptionClick(category, option) {
      if (this.isOptionDisabled(option) || this.isSelected(category, option.key)) {
        return;
      }
      this.setSettingValue(category, option.key);
    },
    setSettingValue: function setSettingValue(category, key) {
      var _this2 = this;

      if (category === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
        this.loaderAdd(document.body);
        this.setSettingShowOdds(key === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS).then(function () {
          return _this2.loaderRemove(document.body);
        }).catch(function () {
          return _this2.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS) {
        this.loaderAdd(document.body);
        this.setSettingOrderbookCollapsed(key === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED).then(function () {
          return _this2.loaderRemove(document.body);
        }).catch(function () {
          return _this2.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
        this.loaderAdd(document.body);
        this.setSettingColorPalette(key).then(function () {
          return _this2.loaderRemove(document.body);
        }).catch(function () {
          return _this2.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
        this.loaderAdd(document.body);
        this.setSettingMobileLayout(key).then(function () {
          return _this2.loaderRemove(document.body);
        }).catch(function () {
          return _this2.loaderRemove(document.body);
        });
      }
    },
    isSelected: function isSelected(category, key) {
      switch (category) {
        case __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay:
          return this.settingShowOdds === (key === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS);
        case __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS:
          return this.settingOrderbookCollapsed === (key === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED);
        case __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme:
          return this.settingColorPalette === key;
        case __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout:
          return this.settingMobileLayout === key;
        default:
          return false;
      }
    }
  })
});

/***/ }),

/***/ "Vngw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vnj/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_state_tooltip_js__ = __webpack_require__("CAq+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66e6d570_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_state_tooltip_vue__ = __webpack_require__("fZS5");
function injectStyle (ssrContext) {
  __webpack_require__("oLs4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_state_tooltip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66e6d570_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_state_tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VqOw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "VsU5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-search-input",class:_vm.hasValueModifier},[_c('label',{staticClass:"faq-search-input__label",attrs:{"for":_vm.name},on:{"click":_vm.focusInput}},[_vm._v(_vm._s(_vm.placeholder))]),_vm._v(" "),_c('input',{ref:"input",staticClass:"faq-search-input__input",attrs:{"type":"text","name":_vm.name},domProps:{"value":_vm.value},on:{"input":_vm.updateSearch}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W3K2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-set-password"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{staticClass:"account-set-password form  content-header__section-group",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPassword,"name":"newPassword","type":"password","validator":"password","required":true,"autocomplete":"new-password","placeholder":"Password"},on:{"input":_vm.$v.fields.newPassword.$touch},model:{value:(_vm.fields.newPassword),callback:function ($$v) {_vm.$set(_vm.fields, "newPassword", $$v)},expression:"fields.newPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPasswordConfirmation,"name":"newPasswordConfirmation","type":"password","validator":"password","required":true,"autocomplete":"new-password","placeholder":"Confirm Password"},on:{"input":_vm.$v.fields.newPasswordConfirmation.$touch},model:{value:(_vm.fields.newPasswordConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "newPasswordConfirmation", $$v)},expression:"fields.newPasswordConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('password-requirements',{attrs:{"validation":_vm.$v.fields.newPassword}})],1)]),_vm._v(" "),_c('div',{staticClass:"account-set-password__buttons"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Save Password"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W4YR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W6JW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_value_sushi_js__ = __webpack_require__("v/bO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064c840c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_value_sushi_vue__ = __webpack_require__("Czyq");
function injectStyle (ssrContext) {
  __webpack_require__("1gXZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_value_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064c840c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_value_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W82P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'click'
  },
  props: {
    checked: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    black: Boolean
  },
  watch: {
    checked: function checked(val) {
      this.isChecked = val;
    }
  },
  data: function data() {
    return {
      isChecked: this.checked
    };
  },

  computed: {
    isOnModifier: function isOnModifier() {
      return {
        'switch-button--on': this.isChecked,
        'switch-button--disabled': this.disabled,
        'switch-button--black': this.black
      };
    }
  },
  methods: {
    toggle: function toggle() {
      if (!this.disabled) {
        this.isChecked = !this.isChecked;
        this.$emit('toggle', this.isChecked);
      }
    }
  }
});

/***/ }),

/***/ "W9Re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketSharesItemLoader_vue__ = __webpack_require__("L6pp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c1c5fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketSharesItemLoader_vue__ = __webpack_require__("ib9I");
function injectStyle (ssrContext) {
  __webpack_require__("IW6G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketSharesItemLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c1c5fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketSharesItemLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WDNh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WDky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WF/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    theme: String
  },
  methods: {
    onToggle: function onToggle() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    }
  }
});

/***/ }),

/***/ "WHJu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WLny":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WMwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-methodology"},[_vm._v("\n  sushi-market-methodology\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WOmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"election-map-toolbar"},[_c('div',{staticClass:"election-map-toolbar__legend"},[_c('div',{staticClass:"election-map-toolbar__label",style:(_vm.democratLabelStyleModifiers)},[_vm._v("\n      Democratic "+_vm._s(_vm.democraticCounters.total + _vm.democraticCounters.predefinedReal)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__label",style:(_vm.republicanLabelStyleModifiers)},[_vm._v("\n      "+_vm._s(_vm.republicanCounters.total + _vm.republicanCounters.predefinedReal)+" Republican\n    ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar",style:(_vm.barStyleModifiers)},[_c('div',{staticClass:"election-map-toolbar__line"},[_c('div',{staticClass:"election-map-toolbar__line-content"},[_c('div',{staticClass:"election-map-toolbar__line-label election-map-toolbar__line-label--center"},[_vm._v("\n          "+_vm._s(_vm.majorityText)+"\n        ")])])]),_vm._v(" "),(_vm.isSenate)?_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic-stripped",style:(_vm.democraticPredefinedBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.predefinedReal}},[(_vm.showDemocraticPredefinedText)?_c('span',[_vm._v("\n        34 + 2 "),_c('div',{staticClass:"election-map-toolbar__bar-section-label election-map-toolbar__bar-section-label--right"},[_vm._v("No election")])]):_c('span',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticHighBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.high}},[(_vm.showDemocraticHighText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.democraticCounters.high)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticMediumBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.medium}},[(_vm.showDemocraticMediumText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.democraticCounters.medium)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticLowBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.low}},[(_vm.showDemocraticLowText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.democraticCounters.low)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanLowBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.low}},[(_vm.showRepublicanLowText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.republicanCounters.low)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanMediumBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.medium}},[(_vm.showRepublicanMediumText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.republicanCounters.medium)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanHighBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.high}},[(_vm.showRepublicanHighText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.republicanCounters.high)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),(_vm.isSenate)?_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican-stripped",style:(_vm.republicanPredefinedBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.predefinedReal}},[(_vm.showRepublicanPredefinedText)?_c('span',[_c('div',{staticClass:"election-map-toolbar__bar-section-label election-map-toolbar__bar-section-label--left"},[_vm._v("No election")]),_vm._v(" "+_vm._s(_vm.republicanCounters.predefinedReal)+"\n      ")]):_c('span',[_vm._v(" ")])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WRh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_small_js__ = __webpack_require__("b+hr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ee8cf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_small_vue__ = __webpack_require__("/xcM");
function injectStyle (ssrContext) {
  __webpack_require__("h6O+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_small_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ee8cf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SETTING_SHOW_ODDS */
/* unused harmony export SETTING_COLOR_PALETTE_KEY */
/* unused harmony export SETTING_MOBILE_LAYOUT_KEY */
/* unused harmony export SETTING_ORDERBOOK_COLLAPSED_KEY */
/* unused harmony export SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY */
/* unused harmony export SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY */
/* unused harmony export SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_COLOR_PALETTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_MOBILE_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return APP_PRICE_DISPLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return APP_MOBILE_ORDERBOOK_DISPLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UX_CATEGORY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__ = __webpack_require__("63Fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_header_notification_app_header_notification_vue__ = __webpack_require__("dMVO");

/* eslint-disable */






var LAYOUT_MOBILE = 'mobile';
var LAYOUT_DESKTOP = 'desktop';
var LAYOUT_SWITCH_BREAKPOINT = 910;

function getDefaultLayout() {
  var width = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
  return width >= LAYOUT_SWITCH_BREAKPOINT ? LAYOUT_DESKTOP : LAYOUT_MOBILE;
}

var SETTING_SHOW_ODDS = 'settings-odds-key';
var SETTING_COLOR_PALETTE_KEY = 'settings-color-palette-key';
var SETTING_MOBILE_LAYOUT_KEY = 'settings-mobile-layout-key';
var SETTING_ORDERBOOK_COLLAPSED_KEY = 'settings-orderbook-collapsed-key';
var SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY = 'guest-setting-color-palette-dirty';
var SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY = 'guest-setting-price-display-dirty';
var SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY = 'guest-setting-mobile-layout-dirty';

var APP_COLOR_PALETTE = {
  BLUE_GREY: 2,
  GREEN_RED: 1
};

var APP_MOBILE_LAYOUT = {
  STANDARD: 1,
  SIMPLIFIED: 2,
  CONDENSED: 3
};

var APP_PRICE_DISPLAY = {
  TRADE_PRICES: 1,
  ODDS: 2 // settingShowOdds true
};

var APP_MOBILE_ORDERBOOK_DISPLAY = {
  COLLAPSED: 0, // settingOrderbookCollapsed true
  EXPANDED: 1
};

var UX_CATEGORY = {
  UXSettingBuyColorScheme: 'UXSettingBuyColorScheme',
  UXSettingMobileContractLayout: 'UXSettingMobileContractLayout',
  UXSettingPriceDisplay: 'UXSettingPriceDisplay',
  UXSettingIsOBCollapsedOnOS: 'UXSettingIsOBCollapsedOnOS',
  UXSettingAnnouncementCurState: 'UXSettingAnnouncementCurState'
};

/* harmony default export */ __webpack_exports__["f"] = ({
  namespaced: true,
  state: {
    previousRoute: null,
    initialVersion: null,
    serverVersion: null,
    skipAttachToHomeNotification: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get('skipAttachToHomeNotification', false),
    skipBanner: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get('skipBanner', false),
    hasServerErrorOccurred: false,
    layout: getDefaultLayout(),
    isTaxNotificationMandatory: false,
    hiddenMaintenanceMessage: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4__components_app_app_header_notification_app_header_notification_vue__["a" /* LS_MAINTENANCE_MESSAGE_KEY */]),
    maintenance: {
      isMaintenanceEnabled: false,
      isTradingEnabled: true,
      maintenanceMessage: '',
      suspendedMessage: '',
      systemMessage: ''
    },
    mobileMenuOpened: false,
    isTabActive: !document.hidden,
    liveUpdatesDisabled: false,
    firebaseInitialized: false,
    signalrInitialized: false,
    systemEmails: {
      support: "support@predictit.org",
      press: "press@predictit.org",
      markets: "markets@predictit.org"
    },
    newLoaderCounter: 0,
    settingShowOdds: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(SETTING_SHOW_ODDS, true),
    settingOrderbookCollapsed: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(SETTING_ORDERBOOK_COLLAPSED_KEY, false),
    settingColorPalette: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(SETTING_COLOR_PALETTE_KEY, APP_COLOR_PALETTE.GREEN_RED),
    settingMobileLayout: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(SETTING_MOBILE_LAYOUT_KEY, APP_MOBILE_LAYOUT.SIMPLIFIED),
    guestSettingColorPaletteDirty: __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].get(SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY, false),
    guestSettingPriceDisplayDirty: __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].get(SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY, false),
    guestSettingMobileLayoutDirty: __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].get(SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY, false)
  },
  mutations: {
    setLiveUpdatesDisabled: function setLiveUpdatesDisabled(state, flag) {
      state.liveUpdatesDisabled = flag;
    },
    setIsTabActive: function setIsTabActive(state, data) {
      state.isTabActive = data;
    },
    setPreviousRoute: function setPreviousRoute(state, data) {
      state.previousRoute = data;
    },
    setInitialVersion: function setInitialVersion(state, version) {
      state.initialVersion = version;
    },
    setServerVersion: function setServerVersion(state, version) {
      state.serverVersion = version;
    },
    setLayout: function setLayout(state, layout) {
      state.layout = layout;
    },
    setServerError: function setServerError(state, hasOccurred) {
      state.hasServerErrorOccurred = hasOccurred;
    },
    setFirebaseInitialized: function setFirebaseInitialized(state, flag) {
      state.firebaseInitialized = flag;
    },
    setSignalrInitialized: function setSignalrInitialized(state, flag) {
      state.signalrInitialized = flag;
    },
    setMaintenance: function setMaintenance(state, data) {
      state.maintenance = data;
    },
    setMandatoryTaxNotification: function setMandatoryTaxNotification(state, flag) {
      state.isTaxNotificationMandatory = flag;
    },
    dontShowAttachToHomeNotification: function dontShowAttachToHomeNotification(state) {
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set('skipAttachToHomeNotification', true, expiresAt);
      state.skipAttachToHomeNotification = true;
    },
    dontShowBanner: function dontShowBanner(state) {
      state.skipBanner = true;
    },
    toggleMobileMenu: function toggleMobileMenu(state) {
      state.mobileMenuOpened = !state.mobileMenuOpened;
    },
    closeMobileMenu: function closeMobileMenu(state) {
      state.mobileMenuOpened = false;
    },
    setHiddenMaintenanceMessage: function setHiddenMaintenanceMessage(state, value) {
      state.hiddenMaintenanceMessage = value;
    },
    incrNewLoaderCounter: function incrNewLoaderCounter(state) {
      state.newLoaderCounter = state.newLoaderCounter + 1;
    },
    decrNewLoaderCounter: function decrNewLoaderCounter(state) {
      state.newLoaderCounter = state.newLoaderCounter - 1;
      if (state.newLoaderCounter < 0) {
        state.newLoaderCounter = 0;
      }
    },
    resetLoaderCounter: function resetLoaderCounter(state) {
      state.newLoaderCounter = 0;
    },
    setSettingShowOdds: function setSettingShowOdds(state, flag) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set(SETTING_SHOW_ODDS, flag);
      state.settingShowOdds = flag;
    },
    setSettingOrderbookCollapsed: function setSettingOrderbookCollapsed(state, flag) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set(SETTING_ORDERBOOK_COLLAPSED_KEY, flag);
      state.settingOrderbookCollapsed = flag;
    },
    setSettingColorPalette: function setSettingColorPalette(state, value) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set(SETTING_COLOR_PALETTE_KEY, value);
      state.settingColorPalette = value;
    },
    setSettingMobileLayout: function setSettingMobileLayout(state, value) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set(SETTING_MOBILE_LAYOUT_KEY, value);
      state.settingMobileLayout = value;
    },
    setGuestSettingColorPaletteDirty: function setGuestSettingColorPaletteDirty(state, value) {
      if (value) {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].set(SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY, true);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del(SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY);
      }
      state.guestSettingColorPaletteDirty = value;
    },
    setGuestSettingPriceDisplayDirty: function setGuestSettingPriceDisplayDirty(state, value) {
      if (value) {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].set(SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY, true);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del(SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY);
      }
      state.guestSettingPriceDisplayDirty = value;
    },
    setGuestSettingMobileLayoutDirty: function setGuestSettingMobileLayoutDirty(state, value) {
      if (value) {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].set(SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY, true);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del(SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY);
      }
      state.guestSettingMobileLayoutDirty = value;
    }
  },
  getters: {
    isLayoutMobile: function isLayoutMobile(state) {
      return state.layout === LAYOUT_MOBILE;
    },
    isLayoutDesktop: function isLayoutDesktop(state) {
      return state.layout === LAYOUT_DESKTOP;
    },
    isShutdownModeOn: function isShutdownModeOn(state) {
      return !!false;
    },
    isPinningEnabled: function isPinningEnabled(state) {
      return !!false;
    },
    leaderboardsEnabled: function leaderboardsEnabled(state) {
      return !!false;
    },
    hasMaintenanceMessage: function hasMaintenanceMessage(state) {
      if (state.maintenance.maintenanceMessage) return true;
      var maintenanceMessage = state.maintenance.suspendedMessage || state.maintenance.systemMessage;
      // check if message was hidden by user;
      return maintenanceMessage && maintenanceMessage !== state.hiddenMaintenanceMessage;
    },
    hasMaintenance: function hasMaintenance(state) {
      return state.maintenance.maintenanceMessage || state.maintenance.suspendedMessage;
    },
    hasMaintenanceSuspended: function hasMaintenanceSuspended(state) {
      return !!state.maintenance.suspendedMessage;
    },
    hasBanner: function hasBanner(state, getters, rootState, rootGetters) {
      return false && !state.skipBanner && rootGetters['user/isLoggedIn'];
    },
    isAfterHours: function isAfterHours(state) {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 2;
      return false;
    },
    isRegularMaintenance: function isRegularMaintenance(state) {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 3;
      return false;
    },
    isExtendedMaintenance: function isExtendedMaintenance(state) {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 4;
      return false;
    },
    isFullMaintenance: function isFullMaintenance(state) {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 5;
      return false;
    },
    isTradingEnabled: function isTradingEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isCancelOrdersEnabled: function isCancelOrdersEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isDepositEnabled: function isDepositEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isWithdrawEnabled: function isWithdrawEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isCommentEnabled: function isCommentEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isLoginEnabled: function isLoginEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isSignUpEnabled: function isSignUpEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    newLoaderIsLoading: function newLoaderIsLoading(state) {
      return state.newLoaderCounter > 0;
    },
    currentPriceSymbol: function currentPriceSymbol(state) {
      return state.settingShowOdds ? '%' : '&cent;';
    }
  },
  actions: {
    setHiddenMaintenanceMessage: function setHiddenMaintenanceMessage(_ref, value) {
      var commit = _ref.commit;

      commit('setHiddenMaintenanceMessage', value);
    },
    setInitialVersion: function setInitialVersion(_ref2, data) {
      var commit = _ref2.commit;

      commit('setInitialVersion', data);
    },
    setServerVersion: function setServerVersion(_ref3, data) {
      var commit = _ref3.commit;

      commit('setServerVersion', data);
    },
    setLayoutWidth: function setLayoutWidth(_ref4, width) {
      var commit = _ref4.commit;

      if (width >= LAYOUT_SWITCH_BREAKPOINT) {
        commit('setLayout', LAYOUT_DESKTOP);
      } else {
        commit('setLayout', LAYOUT_MOBILE);
      }
    },
    setServerError: function setServerError(_ref5, hasOccurred) {
      var commit = _ref5.commit;

      commit('setServerError', hasOccurred);
    },
    setMaintenance: function setMaintenance(_ref6, data) {
      var commit = _ref6.commit;

      commit('setMaintenance', data);
    },
    setMandatoryTaxNotification: function setMandatoryTaxNotification(_ref7, flag) {
      var commit = _ref7.commit;

      commit('setMandatoryTaxNotification', flag);
    },
    dontShowAttachToHomeNotification: function dontShowAttachToHomeNotification(_ref8) {
      var commit = _ref8.commit;

      commit('dontShowAttachToHomeNotification');
    },
    dontShowBanner: function dontShowBanner(_ref9) {
      var commit = _ref9.commit;

      commit('dontShowBanner');
    },
    setPreviousRoute: function setPreviousRoute(_ref10, data) {
      var commit = _ref10.commit;

      commit('setPreviousRoute', data);
    },
    toggleMobileMenu: function toggleMobileMenu(_ref11) {
      var commit = _ref11.commit;

      commit('toggleMobileMenu');
    },
    closeMobileMenu: function closeMobileMenu(_ref12) {
      var commit = _ref12.commit;

      commit('closeMobileMenu');
    },
    setIsTabActive: function setIsTabActive(_ref13, flag) {
      var commit = _ref13.commit;

      commit('setIsTabActive', flag);
    },
    setLiveUpdatesDisabled: function setLiveUpdatesDisabled(_ref14, flag) {
      var commit = _ref14.commit;

      commit('setLiveUpdatesDisabled', flag);
    },
    setFirebaseInitialized: function setFirebaseInitialized(_ref15, flag) {
      var commit = _ref15.commit;

      commit('setFirebaseInitialized', flag);
    },
    setSignalrInitialized: function setSignalrInitialized(_ref16, flag) {
      var commit = _ref16.commit;

      commit('setSignalrInitialized', flag);
    },
    incrNewLoaderCounter: function incrNewLoaderCounter(_ref17) {
      var commit = _ref17.commit;

      commit('incrNewLoaderCounter');
    },
    decrNewLoaderCounter: function decrNewLoaderCounter(_ref18) {
      var commit = _ref18.commit;

      commit('decrNewLoaderCounter');
    },
    resetLoaderCounter: function resetLoaderCounter(_ref19) {
      var commit = _ref19.commit;

      commit('resetLoaderCounter');
    },
    setSettingShowOdds: function setSettingShowOdds(_ref20, flag) {
      var commit = _ref20.commit,
          rootGetters = _ref20.rootGetters;

      commit('setSettingShowOdds', flag);
      if (rootGetters['user/isLoggedIn']) {
        commit('setGuestSettingPriceDisplayDirty', false);
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingPriceDisplay, flag ? APP_PRICE_DISPLAY.ODDS : APP_PRICE_DISPLAY.TRADE_PRICES);
      }
      commit('setGuestSettingPriceDisplayDirty', true);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setSettingOrderbookCollapsed: function setSettingOrderbookCollapsed(_ref21, flag) {
      var commit = _ref21.commit,
          rootGetters = _ref21.rootGetters;

      commit('setSettingOrderbookCollapsed', flag);
      if (rootGetters['user/isLoggedIn']) {
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingIsOBCollapsedOnOS, flag ? APP_MOBILE_ORDERBOOK_DISPLAY.COLLAPSED : APP_MOBILE_ORDERBOOK_DISPLAY.EXPANDED);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setSettingColorPalette: function setSettingColorPalette(_ref22, value) {
      var commit = _ref22.commit,
          rootGetters = _ref22.rootGetters;

      commit('setSettingColorPalette', value);
      if (rootGetters['user/isLoggedIn']) {
        commit('setGuestSettingColorPaletteDirty', false);
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingBuyColorScheme, value);
      }
      commit('setGuestSettingColorPaletteDirty', true);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setSettingMobileLayout: function setSettingMobileLayout(_ref23, value) {
      var commit = _ref23.commit,
          rootGetters = _ref23.rootGetters;

      commit('setSettingMobileLayout', value);
      if (rootGetters['user/isLoggedIn']) {
        commit('setGuestSettingMobileLayoutDirty', false);
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingMobileContractLayout, value);
      }
      commit('setGuestSettingMobileLayoutDirty', true);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setSettingsAnnouncementCurState: function setSettingsAnnouncementCurState(_ref24, value) {
      var commit = _ref24.commit;

      return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingAnnouncementCurState, value);
    },
    applySettingShowOdds: function applySettingShowOdds(_ref25, flag) {
      var commit = _ref25.commit;

      commit('setSettingShowOdds', flag);
    },
    applySettingOrderbookCollapsed: function applySettingOrderbookCollapsed(_ref26, flag) {
      var commit = _ref26.commit;

      commit('setSettingOrderbookCollapsed', flag);
    },
    applySettingColorPalette: function applySettingColorPalette(_ref27, value) {
      var commit = _ref27.commit;

      commit('setSettingColorPalette', value);
    },
    applySettingMobileLayout: function applySettingMobileLayout(_ref28, value) {
      var commit = _ref28.commit;

      commit('setSettingMobileLayout', value);
    },
    setGuestSettingDirty: function setGuestSettingDirty(_ref29, _ref30) {
      var commit = _ref29.commit;
      var keyName = _ref30.keyName,
          value = _ref30.value;

      if (keyName === UX_CATEGORY.UXSettingBuyColorScheme) {
        commit('setGuestSettingColorPaletteDirty', value);
      } else if (keyName === UX_CATEGORY.UXSettingPriceDisplay) {
        commit('setGuestSettingPriceDisplayDirty', value);
      } else if (keyName === UX_CATEGORY.UXSettingMobileContractLayout) {
        commit('setGuestSettingMobileLayoutDirty', value);
      }
    }
  }
});

/***/ }),

/***/ "WTcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-daily-markets-details",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WXHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposited_js__ = __webpack_require__("Mq7P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1503a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposited_vue__ = __webpack_require__("2HMZ");
function injectStyle (ssrContext) {
  __webpack_require__("A3QY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposited_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1503a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposited_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WYZc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_history_trades_refine_history_refine_history_vue__ = __webpack_require__("t3+b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_history_trades_button_with_info_button_with_info_vue__ = __webpack_require__("II89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: Object,
    markets: Array,
    recent: Boolean,
    isOpen: Boolean
  },
  components: {
    refineHistory: __WEBPACK_IMPORTED_MODULE_2__components_account_history_trades_refine_history_refine_history_vue__["a" /* default */],
    buttonWithInfo: __WEBPACK_IMPORTED_MODULE_3__components_account_history_trades_button_with_info_button_with_info_vue__["a" /* default */]
  },
  computed: {
    openModifier: function openModifier() {
      return {
        'history-filters--open': this.isOpen
      };
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onRecent: function onRecent() {
      this.$emit('input', null);
      if (!this.value) {
        this.$router.push({ name: 'account-history', params: {}, query: { tabId: 'trades' } });
      } else {
        this.$router.push({ name: 'account-history', params: { marketId: 'all' }, query: { tabId: 'trades' } });
      }
    },
    onMarkets: function onMarkets() {
      this.$router.push({ name: 'account-history', params: { marketId: 'all' }, query: { tabId: 'trades' } });
    },
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_TRADE_INFO);
    },
    onRefineHistoryInput: function onRefineHistoryInput(e) {
      this.$emit('input', e);
      this.$router.push({ name: 'account-history', params: { marketId: e.marketId }, query: { tabId: 'trades' } });
    }
  })
});

/***/ }),

/***/ "WcTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.tableModifiers},[(_vm.showHeader)?_c('div',{staticClass:"order-book-sushi__header order-book-sushi__header--striped"},[_c('div',{staticClass:"order-book-sushi__side order-book-my-orders-sushi__side"},[_c('div',{class:_vm.buyHeaderModifiers},[_vm._v("\n          Buy Orders\n        ")])]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__side order-book-my-orders-sushi__side"},[_c('div',{class:_vm.sellHeaderModifiers},[_vm._v("\n          Sell Orders\n        ")])])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.bodyModifiers},[_vm._l((_vm.displayRows),function(row,index){return _c('div',{key:("order-book-my-orders-" + index),staticClass:"order-book-sushi__row order-book-sushi__row--striped"},[_c('div',{staticClass:"order-book-sushi__side order-book-my-orders-sushi__side"},[(row.buy)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--highlight order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--price"},[_vm._v("\n              "+_vm._s(row.buy.pricePerShare)),_c('span',[_vm._v("¢")])]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--quantity"},[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(row.buy.remainingQuantity),expression:"row.buy.remainingQuantity"}]})]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--action"},[_c('button',{staticClass:"order-book-my-orders-sushi__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.cancelClicked(row.buy.offerId)}}},[_c('span',{staticClass:"order-book-my-orders-sushi__button-icon"})])])]:(row.showBuyEmpty)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--full"},[_vm._v("\n              "+_vm._s(_vm.emptyStateText)+"\n            ")])]:[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--price"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--quantity"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--action"},[_vm._v(" ")])]],2),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__side order-book-my-orders-sushi__side"},[(row.sell)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--highlight order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--price"},[_vm._v("\n              "+_vm._s(row.sell.pricePerShare)),_c('span',[_vm._v("¢")])]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--quantity"},[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(row.sell.remainingQuantity),expression:"row.sell.remainingQuantity"}]})]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--action"},[_c('button',{staticClass:"order-book-my-orders-sushi__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.cancelClicked(row.sell.offerId)}}},[_c('span',{staticClass:"order-book-my-orders-sushi__button-icon"})])])]:(row.showSellEmpty)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--full"},[_vm._v("\n              "+_vm._s(_vm.emptyStateText)+"\n            ")])]:[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--price"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--quantity"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-my-orders-sushi__cell order-book-my-orders-sushi__cell--action"},[_vm._v(" ")])]],2)])}),_vm._v(" "),(_vm.isEmpty)?_c('div',{staticClass:"order-book-my-orders-sushi__empty-message"},[(_vm.isLoggedIn)?[_vm._v("\n          "+_vm._s(_vm.emptyOrdersText)+"\n        ")]:[_c('button',{staticClass:"order-book-sushi__empty-card-link",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.loginClicked($event)}}},[_vm._v("Login")]),_vm._v(" to see your orders.\n        ")]],2):_vm._e()],2)]),_vm._v(" "),(_vm.showProcessedNotice)?_c('div',{staticClass:"order-book-sushi__footer order-book-my-orders-sushi__footer"},[_c('div',{staticClass:"order-book-sushi__footer-cell order-book-sushi__footer-cell--price-links order-book-my-orders-sushi__processed-notice"},[_vm._v("\n      * Order is currently in process.\n    ")])]):_vm._e(),_vm._v(" "),(_vm.showCancelModal)?_c('small-modal',{on:{"modalClose":_vm.closeCancelModal},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("\n      Confirm Cancel Order\n    ")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-content"},[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-title"},[_vm._v("\n          Are you sure you want to cancel the following order?\n        ")]),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers"},[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-contract-info"},[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-contract-image",style:(_vm.contractImageStyleModifiers)}),_vm._v(" "),(_vm.isMarketSingle)?[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-contract"},[_vm._v("\n                "+_vm._s(_vm.market.marketShortName || _vm.market.marketName)+"\n              ")])]:[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-contract"},[_vm._v("\n                "+_vm._s(_vm.contract.contractName)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offers-market"},[_vm._v("\n                "+_vm._s(_vm.market.marketShortName || _vm.market.marketName)+"\n              ")])]],2),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offer"},[_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offer-info",domProps:{"innerHTML":_vm._s(_vm.offerFullInfoDisplay(_vm.selectedOffer))}}),_vm._v(" "),_c('div',{staticClass:"order-book-offers-sushi__cancel-modal-offer-date"},[_vm._v(_vm._s(_vm.getDateFull(_vm.selectedOffer)))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"button button--large button--black button--full-width",attrs:{"disabled":_vm.isCancelling},on:{"click":_vm.confirmCancelClicked}},[_vm._v("\n          Cancel Order\n        ")])])]},proxy:true}],null,false,2739998718)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WeRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_autosuggest__ = __webpack_require__("aatO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");

 /* eslint-disable */






var OTHER_ID = -1;
var LIMIT = 10;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      showExplanation: false,
      isSearching: false,
      suggestions: [{ data: [] }],
      current: [],
      currentIds: [],
      fields: {
        query: '',
        agreed: ''
      }
    };
  },

  components: {
    VueAutosuggest: __WEBPACK_IMPORTED_MODULE_3_vue_autosuggest__["a" /* VueAutosuggest */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['status']), {
    universities: function universities() {
      return this.current;
    },
    isConfirmDisabled: function isConfirmDisabled() {
      var isOneOfFieldsEmpty = __WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(this.current, function (x) {
        return !x.name;
      });
      return !this.isFormEnabled || !this.fields.agreed || isOneOfFieldsEmpty;
    },
    showOtherSchoolNote: function showOtherSchoolNote() {
      return this.currentIds.includes(OTHER_ID);
    },
    buttonText: function buttonText() {
      return this.status.isUCAffilSet === null ? 'Continue' : 'Confirm';
    }
  }),
  watch: {
    'fields.agreed': function fieldsAgreed(value) {
      if (value === 'no') {
        this.fields.query = '';
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getUserAffiliations', 'setUserAffiliations', 'getAffiliations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getStatus']), {
    onClick: function onClick(suggestion) {
      if (this.isLayoutMobile) return;
      this.onSelected(suggestion);
    },
    onMouseDown: function onMouseDown(suggestion) {
      if (!this.isLayoutMobile) return;
      this.onSelected(suggestion);
    },
    onRemove: function onRemove(value) {
      this.current = this.current.filter(function (i) {
        return i.id !== value.id;
      });
      this.currentIds = this.currentIds.filter(function (i) {
        return i !== value.id;
      });
    },
    getKey: function getKey() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    onSelected: function onSelected(value) {
      var _this = this;

      if (!value || !value.item || this.currentIds.length === LIMIT) {
        return;
      }
      var item = value.item;
      if (item && (item.id === OTHER_ID || !this.currentIds.includes(item.id))) {
        this.currentIds.push(item.id);
        this.current.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item));
        // this.fields.query = item.name;
      }

      if (item && item.id === OTHER_ID) {
        this.$nextTick(function () {
          var elements = _this.$el.querySelectorAll('.input__value');
          if (elements.length > 0) {
            elements[elements.length - 1].focus();
          }
        });
      }

      // this.$nextTick(() => {
      //   this.fields.query = '';
      //   if (this.$refs.autosuggest) {
      //     this.$refs.autosuggest.searchInputClose();
      //   }
      // });
      // this.suggestions[0].data = [];
    },
    onInputChange: function onInputChange(text) {
      var _this2 = this;

      if (this.isSearching) return;

      if (this.fields.query && this.fields.query.length >= 2) {
        this.isSearching = true;
        setTimeout(function () {
          _this2.getAffiliations(_this2.fields.query).then(function (data) {
            _this2.suggestions[0].data = (data.affiliateEntities || []).map(function (i) {
              return {
                id: i.affiliateEntityId,
                isHidden: false,
                name: i.name,
                key: _this2.getKey()
              };
            });
            _this2.isSearching = false;
          }).catch(function () {
            _this2.isSearching = false;
          });
        }, 500);
      }
    },
    getSuggestionValue: function getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.formDisable();
      this.loaderAdd(document.body);

      var affiliations = [];

      if (this.fields.agreed === 'yes') {
        this.universities.forEach(function (i) {
          var item = {
            id: i.id,
            name: i.id === -1 ? i.name : '',
            isPublic: !i.isHidden
          };
          affiliations.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item));
        });
      } else {
        affiliations = [];
      }
      var payload = {
        isUCAffiliated: this.fields.agreed === 'yes',
        userAffiliations: affiliations
      };

      this.setUserAffiliations(payload).then(function () {
        return _this3.getStatus();
      }).then(function () {
        return _this3.getUserAffiliations();
      }).then(function () {
        // Emit event for parent to handle (allows registration flow interception)
        _this3.$emit('affiliationsSubmitted');
      }).then(function () {
        _this3.loaderRemove(document.body);
        _this3.formEnable();
      }).catch(function () {
        _this3.loaderRemove(document.body);
        _this3.formEnable();
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.loaderAdd();
    this.getUserAffiliations().then(function (data) {
      (data.affiliateEntities || []).forEach(function (i) {
        _this4.currentIds.push(i.affiliateEntityId);
        var item = {
          id: i.affiliateEntityId,
          isHidden: !i.isPublic,
          name: i.name,
          key: _this4.getKey()
        };
        _this4.current.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item));
      });
      if (_this4.status.isUCAffilSet === true) {
        _this4.fields.agreed = 'yes';
      } else if (_this4.status.isUCAffilSet === false) {
        _this4.fields.agreed = 'no';
      }
      _this4.loaderRemove();
    }).catch(function () {
      return _this4.loaderRemove();
    });
  }
});

/***/ }),

/***/ "WhZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    markets: {
      type: Array,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    dataNumColumnsDesktop: {
      type: Number,
      default: 3
    },
    renderStyle: {
      type: Number,
      default: 1 // 1 = Tiles (default), 2 = Vertical List
    }
  },
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_0__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  },
  computed: {
    isVerticalList: function isVerticalList() {
      return this.renderStyle === 2;
    },
    gridStyleModifiers: function gridStyleModifiers() {
      var n = this.dataNumColumnsDesktop;
      var gapTotal = (n - 1) * 20;
      return {
        'grid-template-columns': 'repeat(auto-fit, minmax(max(300px, calc((100% - ' + gapTotal + 'px) / ' + n + ')), 1fr))'
      };
    }
  }
});

/***/ }),

/***/ "Wspo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TAB_INDEX_CREDIT */
/* unused harmony export TAB_INDEX_PAY_NEAR_ME */
/* unused harmony export TAB_INDEX_COINBASE */
/* unused harmony export TAB_INDEX_ONLINE_BANKING */
/* unused harmony export TAB_INDEX_PENDING */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_card_add_funds_card_vue__ = __webpack_require__("a3Wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_cash_add_funds_cash_vue__ = __webpack_require__("4OEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__ = __webpack_require__("ircP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_list_deposit_pending_requests_list_deposit_vue__ = __webpack_require__("9rb4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");










var TAB_INDEX_CREDIT = 0;
var TAB_INDEX_PAY_NEAR_ME = 1;
var TAB_INDEX_COINBASE = 2;
var TAB_INDEX_ONLINE_BANKING = 3;
var TAB_INDEX_PENDING = 4;

var GTM_PAGE_NAME = 'deposit';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    addFundsCard: __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_card_add_funds_card_vue__["a" /* default */],
    addFundsCash: __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_cash_add_funds_cash_vue__["a" /* default */],
    addFundsCoinbase: __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__["a" /* default */],
    addFundsBankTransfer: __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["c" /* default */],
    pendingRequests: __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_list_deposit_pending_requests_list_deposit_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showTabs: false,
      tabIndexOrder: [],
      isCashAvailable: false,
      isCryptoAvailable: false,
      isCreditCardAvailable: false,
      isOnlineBankingAvailable: false,
      cryptoDescription: '',
      activeTab: null,
      cardDepositAttempt: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    showBankingTab: function showBankingTab() {
      return this.activeTab === TAB_INDEX_ONLINE_BANKING;
    },
    showCreditCardTab: function showCreditCardTab() {
      return this.activeTab === TAB_INDEX_CREDIT;
    },
    showCashTab: function showCashTab() {
      return this.activeTab === TAB_INDEX_PAY_NEAR_ME;
    },
    showCoinBaseTab: function showCoinBaseTab() {
      return this.activeTab === TAB_INDEX_COINBASE;
    },
    showPendingTab: function showPendingTab() {
      return this.activeTab === TAB_INDEX_PENDING;
    },
    tabs: function tabs() {
      var _this = this;

      var results = [];
      this.tabIndexOrder.forEach(function (v) {
        if (_this.isOnlineBankingAvailable && v === TAB_INDEX_ONLINE_BANKING) {
          results.push({
            name: TAB_INDEX_ONLINE_BANKING,
            title: _this.isLayoutMobile ? 'Online Banking' : 'Online Banking'
          });
        }
        if (_this.isCreditCardAvailable && v === TAB_INDEX_CREDIT) {
          results.push({
            name: TAB_INDEX_CREDIT,
            title: _this.isLayoutMobile ? 'Credit Card' : 'Credit Card'
          });
        }
        if (_this.isCashAvailable && v === TAB_INDEX_PAY_NEAR_ME) {
          results.push({
            name: TAB_INDEX_PAY_NEAR_ME,
            title: 'Cash'
          });
        }
        if (_this.isCryptoAvailable && v === TAB_INDEX_COINBASE) {
          results.push({
            name: TAB_INDEX_COINBASE,
            title: _this.cryptoDesctiption
          });
        }
      });
      results.push({
        name: TAB_INDEX_PENDING,
        title: 'Pending'
      });
      return results;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getDepositMethods']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: this.$route.path + '/' + GTM_PAGE_NAME + '/' + name,
          virtualPageTitle: this.$route.name + ' - ' + GTM_PAGE_NAME + ' - ' + name
        });
      }
    },
    onAddFundsCardSuccess: function onAddFundsCardSuccess() {
      this.cardDepositAttempt += 1;
    }
  }),
  created: function created() {
    var _this2 = this;

    this.loaderAdd(document.body);
    this.getDepositMethods().then(function (data) {
      _this2.showTabs = true;
      _this2.tabIndexOrder = data.tabIndexOrder;
      _this2.isCashAvailable = data.isCashAvailable;
      _this2.isCryptoAvailable = data.isCryptoAvailable;
      _this2.isCreditCardAvailable = data.isCreditCardAvailable;
      _this2.isOnlineBankingAvailable = data.isOnlineBankingAvailable;
      _this2.cryptoDesctiption = data.cryptoDescription || 'USDC';
      _this2.loaderRemove(document.body);
    }).catch(function () {
      return _this2.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "Wva1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__ = __webpack_require__("dDJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  props: {
    contractId: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      default: null
    }
  },
  components: {
    marketContractInfoV2: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["b" /* MARKET_CONTRACT_INFO_VALUES_LAYOUT */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['relatedContracts']), {
    items: function items() {
      var contracts = this.relatedContracts.map(function (i) {
        var instance = new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](i);
        return {
          id: i.contractId,
          marketName: i.marketShortName || i.marketName,
          marketId: i.marketId,
          marketType: i.marketType,
          contractName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* isMarketSingle */])(i) ? 'YES' : i.contractShortName || i.contractName,
          image: i.contractImageSmallUrl || i.contractImageUrl,
          price: instance.changePriceAsCents,
          priceAsCents: instance.lastTradePriceAsCents,
          lastClosePrice: instance.lastClosePrice,
          contracts: [i]
        };
      });
      return this.max !== null ? (contracts || []).slice(0, this.max) : contracts || [];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['getRelatedContracts', 'clearRelatedContracts']), {
    itemLink: function itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      };
    },
    loadContracts: function loadContracts() {
      var _this = this;

      this.getRelatedContracts(this.contractId).then(function () {
        _this.isComponentReady = true;
      }).catch(function () {
        _this.isComponentReady = true;
      });
    },
    titleLink: function titleLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId }
      };
    }
  }),
  watch: {
    contractId: {
      handler: function handler() {
        this.loadContracts();
      },

      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearRelatedContracts();
  }
});

/***/ }),

/***/ "Wx+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-currently-predicting"},[_c('div',{staticClass:"market-currently-predicting__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),(!!_vm.widget)?_c('div',{staticClass:"market-currently-predicting__content"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.traders),function(pred,index){return _c('swiper-slide',{key:index},[_c('div',{staticClass:"market-currently-predicting__element"},[_c('div',{staticClass:"market-currently-predicting__user-area",on:{"click":function($event){$event.stopPropagation();return _vm.showUserDetails(pred)}}},[_c('div',{staticClass:"market-currently-predicting__avatar"},[_c('account-social-avatar',{attrs:{"avatar":pred.avatarImage,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.getLevelByPredictions(pred.profitablePredictions).currentColor,"showEdit":false,"theme":"markets"}})],1),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__name"},[_vm._v(_vm._s(pred.userName))]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__info"},[_c('div',{staticClass:"market-currently-predicting__active"},[_vm._v("\n                 "+_vm._s(_vm.traderLevelDisplay(pred))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__market",on:{"click":function($event){$event.stopPropagation();return _vm.onClick(pred)}}},[_vm._v(_vm._s(pred.marketName))]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__footer"},[_c('div',{staticClass:"market-currently-predicting__wrap"},[_c('div',{staticClass:"market-currently-predicting__what"},[_vm._v(_vm._s(_vm.boughtSold(pred.tradeType)))]),_vm._v(" "),_c('div',{class:_vm.classModifier(pred.tradeType)},[_vm._v(_vm._s(_vm.yesNo(pred.tradeType)))]),_vm._v(" "),(!_vm.isMarketSingle(pred))?_c('div',{staticClass:"market-currently-predicting__contract"},[_c('span',[_vm._v("in")]),_vm._v(" "+_vm._s(pred.contractName)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.priceClassModifiers(pred)},[(pred.pricePerShare)?_c('animated-number',{attrs:{"value":Number(pred.pricePerShare)}}):_c('span',[_vm._v(" ")])],1)])])])])}),1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WxRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-map-loader"},[_c('div',{staticClass:"overview-map-loader__avatar"},[_c('div',{staticClass:"overview-map-loader__avatar-circle"})]),_vm._v(" "),_c('div',{staticClass:"overview-map-loader__content"},[_c('div',{staticClass:"overview-map-loader__text-1"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X/Fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    visible: false
  },
  mutations: {
    show: function show(state) {
      state.visible = true;
    },
    hide: function hide(state) {
      state.visible = false;
    }
  },
  actions: {
    show: function show(_ref) {
      var commit = _ref.commit;

      commit('show');
    },
    hide: function hide(_ref2) {
      var commit = _ref2.commit;

      commit('hide');
    }
  }
});

/***/ }),

/***/ "X/wz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X0hB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-stats-popup"},[_c('switch-modal',{staticClass:"modal-switch--contracts-stats",attrs:{"showSwitchButton":false},on:{"modalClose":_vm.close}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Trading Statistics")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{class:_vm.classModifiers},[_c('market-contracts-stats',{attrs:{"isFixed":_vm.isFixed,"stats":_vm.stats}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X4WA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export thousandDisplay */
/* unused harmony export TITLE_LATEST_PRICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPERATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTONS; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getActiveButtonAfterSwitch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_button_direction_market_button_direction_vue__ = __webpack_require__("jtVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mutex__ = __webpack_require__("EOu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__ = __webpack_require__("tRmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__ = __webpack_require__("azKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_shares_ownership_market_shares_ownership_vue__ = __webpack_require__("tyTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_market_market_contract_horizontal_sushi_orders_market_contract_horizontal_sushi_orders_vue__ = __webpack_require__("G/7i");



/* eslint-disable */
















var thousandDisplay = function thousandDisplay(value) {
  if (value >= 1.0e+4) {
    return Math.round(value / 1.0e+3) + 'K';
  }
  return value >= 1.0e+3 ? Math.floor(10 * value / 1.0e+3) / 10 + 'K' : value;
};

var TITLE_LATEST_PRICE = 'Latest Price';
var firstNonEmptyString = function firstNonEmptyString() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value === 'string' && value.trim() !== '';
  });
};
var OPERATIONS = {
  BUY: 'buy',
  SELL: 'sell'
};
var VALUES = {
  YES: 'yes',
  NO: 'no'
};
var BUTTONS = {
  BUY_NO: {
    id: 'buy-no',
    type: OPERATIONS.BUY,
    value: VALUES.NO
  },
  BUY_YES: {
    id: 'buy-yes',
    type: OPERATIONS.BUY,
    value: VALUES.YES
  },
  SELL_NO: {
    id: 'sell-no',
    type: OPERATIONS.SELL,
    value: VALUES.NO
  },
  SELL_YES: {
    id: 'sell-yes',
    type: OPERATIONS.SELL,
    value: VALUES.YES
  }
};

function getActiveButtonAfterSwitch(contractModel, switchTo) {
  var button = null;

  if (switchTo === 'left') {
    button = BUTTONS.BUY_YES;;
  } else if (switchTo === 'right') {
    button = BUTTONS.BUY_NO;
  }

  return button;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__["a" /* default */]],
  components: {
    marketButtonDirection: __WEBPACK_IMPORTED_MODULE_8__components_market_market_button_direction_market_button_direction_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_7__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */],
    marketDisabledOutcomeV2: __WEBPACK_IMPORTED_MODULE_13__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__["a" /* default */],
    marketTradingUnavailableV2: __WEBPACK_IMPORTED_MODULE_14__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__["a" /* default */],
    marketSharesOwnership: __WEBPACK_IMPORTED_MODULE_15__components_market_market_shares_ownership_market_shares_ownership_vue__["a" /* default */],
    marketContractHorizontalSushiOrders: __WEBPACK_IMPORTED_MODULE_16__components_market_market_contract_horizontal_sushi_orders_market_contract_horizontal_sushi_orders_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    },
    forceMobileLayout: {
      type: Boolean,
      default: false
    },
    dashboardMode: {
      type: Boolean,
      default: false
    },
    showSharesOwnedIconOnImage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      BUTTONS: BUTTONS,
      OPERATIONS: OPERATIONS,
      VALUES: VALUES,
      isWaiting: false,
      activeButton: null,
      chart: null
    };
  },
  mounted: function mounted() {
    this.initializePurchaseButtons();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isTradingEnabled', 'currentPriceSymbol']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['settingShowOdds']), {
    useMobileLayout: function useMobileLayout() {
      return this.forceMobileLayout || this.isLayoutMobile;
    },
    useDesktopLayout: function useDesktopLayout() {
      return !this.useMobileLayout;
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    isMarketJourneyDisabled: function isMarketJourneyDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["y" /* isMarketJourneyDisabled */])(this.market);
    },
    singleMarketTitle: function singleMarketTitle() {
      return firstNonEmptyString(this.market && this.market.marketShortName, this.market && this.market.marketName, this.contractModel.marketName, this.contractModel.contractName) || TITLE_LATEST_PRICE;
    },
    cmsWidgetTitle: function cmsWidgetTitle() {
      return firstNonEmptyString(this.contract && this.contract.contractName) || TITLE_LATEST_PRICE;
    },
    title: function title() {
      if (this.forCmsWidget) {
        return this.cmsWidgetTitle;
      }

      return this.isMarketSingle ? this.singleMarketTitle : firstNonEmptyString(this.contractModel.contractName, this.contractModel.name);
    },
    classModifiers: function classModifiers() {
      return {
        'market-contract-horizontal-sushi': true,
        'market-contract-horizontal-sushi--show-shares-owned-on-image': this.showSharesOwnedIconOnImage,
        'market-contract-horizontal-sushi--dashboard': this.dashboardMode,
        'market-contract-horizontal-sushi--hovered': this.hovered,
        'market-contract-horizontal-sushi--forced-mobile': this.forceMobileLayout,
        'market-contract-horizontal-sushi--no-shares-or-offers': !this.showOffersOrShares,
        'market-contract-horizontal-sushi--settled-yes': this.isMarketSettled && this.isPayoutTypeYes,
        'market-contract-horizontal-sushi--settled-no': this.isMarketSettled && this.isPayoutTypeNo,
        'market-contract-horizontal-sushi--should-close': this.shouldClosePurchaseJourney,
        'market-contract-horizontal-sushi--cms-widget': this.forCmsWidget
      };
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    showOpenOffers: function showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar: function showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    sharesOwnedStyleModifiers: function sharesOwnedStyleModifiers() {
      return {
        'market-contract-horizontal-sushi__image-shares-owned': true,
        'market-contract-horizontal-sushi__image-shares-owned--no': this.contractModel.mode === 'no'
      };
    },
    showOffersOrShares: function showOffersOrShares() {
      return this.showSharesBar || this.showOpenOffers;
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    isPayoutTypeYes: function isPayoutTypeYes() {
      return this.contract.payoutType === 1;
    },
    isPayoutTypeNo: function isPayoutTypeNo() {
      return this.isMarketSingle && this.contract.payoutType === 0;
    },
    shouldClosePurchaseJourney: function shouldClosePurchaseJourney() {
      return this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId;
    },
    currentPrice: function currentPrice() {
      return this.contractModel.lastTradePriceAsCents;
    },
    currentPriceDashboard: function currentPriceDashboard() {
      if (!this.contractModel.hasLastTradePrice) {
        return 0;
      }

      if (this.contractModel.mode === 'no') {
        return 100 - this.contractModel.lastTradePriceAsCents;
      }
      return this.contractModel.lastTradePriceAsCents;
    },
    volumeDisplay: function volumeDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["u" /* largeNumberDisplay */])(this.contractModel.userQuantity);
    },
    buyOrdersDisplay: function buyOrdersDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["u" /* largeNumberDisplay */])(this.contractModel.userOpenOrdersBuyQuantity);
    },
    sellOrdersDisplay: function sellOrdersDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["u" /* largeNumberDisplay */])(this.contractModel.userOpenOrdersSellQuantity);
    },
    buyOrdersTooltip: function buyOrdersTooltip() {
      return 'Buy: ' + this.contractModel.userOpenOrdersBuyQuantity.toLocaleString('en-US');
    },
    sellOrdersTooltip: function sellOrdersTooltip() {
      return 'Sell: ' + this.contractModel.userOpenOrdersSellQuantity.toLocaleString('en-US');
    }
  }),
  watch: {
    // opposite side of order book was clicked -- switching sides
    tradeOperationToggle: function tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      var button = getActiveButtonAfterSwitch(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, button.id);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    findActiveButton: function findActiveButton() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(BUTTONS).find(function (i) {
        return i.id === _this.activeButton;
      });
    },
    getTypeAndValueIfButtonActiveOrDefaults: function getTypeAndValueIfButtonActiveOrDefaults() {
      var type = this.tradeOptions.operationType;
      var value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        var button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type: type, value: value };
    },
    onClickSharesBar: function onClickSharesBar() {
      var _getTypeAndValueIfBut = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut.type,
          value = _getTypeAndValueIfBut.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    onClickOpenOffers: function onClickOpenOffers() {
      var tab = 'sell-offers';
      var operationType = this.tradeOptions.operationType || '';
      if (operationType === '' && this.contractModel.userOpenOrdersBuyQuantity || operationType === OPERATIONS.BUY && this.contractModel.userOpenOrdersBuyQuantity) {
        tab = 'buy-offers';
      }

      var _getTypeAndValueIfBut2 = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut2.type,
          value = _getTypeAndValueIfBut2.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    initializePurchaseButtons: function initializePurchaseButtons() {
      var button = BUTTONS.BUY_YES;
      if (this.contractModel.mode === VALUES.NO) {
        button = this.contract.contractId === this.tradeOptions.contractId && this.tradeOptions.operationValue === 'no' ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
      } else if (this.contractModel.mode === VALUES.YES) {
        button = BUTTONS.BUY_YES;
      }
      this.activeButton = button.id;

      if ((!this.isMarketSingle || this.useMobileLayout) && this.tradeOptions && this.contract.contractId === this.tradeOptions.contractId && (button.type !== this.tradeOptions.operationType || button.value !== this.tradeOptions.operationValue)) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
      }
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    },
    onContractClick: function onContractClick() {
      if (this.shouldClosePurchaseJourney) {
        this.setTradeOptions(null);
        return;
      }
      if (this.activeButton) {
        var button = BUTTONS.BUY_YES;
        if (this.contractModel.mode) {
          button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        }
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, button.id);

        // const $el = this.$refs[this.activeButton];
        // if (!$el) return;
        // const ev = new MouseEvent('click');
        // $el.dispatchEvent(ev);
      } else {
        var _button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        this.openPurchaseJourney(this.contractModel.contractId, _button.type, _button.value);
      }
    },
    isButtonActive: function isButtonActive(index) {
      var isOn = this.activeButton === index;
      var isButtonActive = this.tradeOptions.contractId === this.contract.contractId;

      return {
        'market-contract-horizontal-sushi__button-single--active': isButtonActive,
        'market-contract-horizontal-sushi__button-single--on': isOn,
        'market-contract-horizontal-sushi__button-single--off': !isOn,
        'market-contract-horizontal-sushi__button-single--off-yes': this.tradeOptions.operationValue === VALUES.YES,
        'market-contract-horizontal-sushi__button-single--off-no': this.tradeOptions.operationValue === VALUES.NO
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var _this2 = this;

      var activateButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (this.isWaiting) {
        return;
      }

      this.isWaiting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["a" /* waitForFirebaseInitialized */])().then(function () {
        if (_this2.isLoggedIn) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["b" /* waitForStatusReady */])();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }).then(function () {
        _this2.isWaiting = false;
        // contract does not modify tradeOptions, is simply used as a widget somewhere
        if (_this2.forCmsWidget) {
          _this2.$emit('contractClicked', { contractId: contractId, operationValue: operationValue });
          return;
        }

        if (_this2.isMarketJourneyDisabled || _this2.isMarketDisabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["w" /* contractOwnershipNum */])(_this2.contractModel) === 0) return;
        if (activateButton) {
          _this2.activeButton = activateButton;
        }
        _this2.pushSessionHistoryContract({
          value: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.contract, {
            marketName: _this2.market.marketShortName || _this2.market.marketName
          })
        });
        _this2.setTradeOptions({
          contractId: contractId,
          operationType: operationType,
          operationValue: operationValue !== null ? operationValue : _this2.contractModel.mode || VALUES.YES
        });
      });
    }
  })
});

/***/ }),

/***/ "X543":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_link_tile_link_tile_vue__ = __webpack_require__("SHkF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_support_faq_faq_vue__ = __webpack_require__("ZIhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_support_book_svg__ = __webpack_require__("jDBh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_support_book_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_icons_support_book_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_support_faq_svg__ = __webpack_require__("B8JL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_support_faq_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_icons_support_faq_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_branding_logo5_png__ = __webpack_require__("qzFn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_branding_logo5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_branding_logo5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_support_tutorial_svg__ = __webpack_require__("C5mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_support_tutorial_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_icons_support_tutorial_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_support__ = __webpack_require__("33FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_brand_name_brand_name_js__ = __webpack_require__("9IfM");



/* eslint-disable arrow-body-style */
















var TICKET_SEND_MESSAGE = 'Message received!';
// const FILE_PROCESSING_ERROR = 'An error occured while processing your file';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Help and Support'
    }
  },
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_16__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    linkTile: __WEBPACK_IMPORTED_MODULE_4__components_generics_link_tile_link_tile_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_5__components_generics_content_header_content_header_vue__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_6__components_support_faq_faq_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_support__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      announcements: [],
      fields: {
        email: '',
        subject: null,
        message: ''
      },
      files: []
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['userData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('support', ['ticketTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['systemEmails']), {
    allowedExtensions: function allowedExtensions() {
      return ['bmp', 'gif', 'jpeg', 'jpg', 'pdf', 'png'];
    },
    acceptAllowedExtensions: function acceptAllowedExtensions() {
      return this.allowedExtensions.map(function (ext) {
        return '.' + ext;
      }).join(', ');
    },
    isAnyFileInvalid: function isAnyFileInvalid() {
      var _this = this;

      return this.files.some(function (i) {
        return !_this.allowedExtensions.some(function (s) {
          return i.name.endsWith(s);
        });
      });
    },
    items: function items() {
      var items = [{
        href: '/support/what-is-predictit',
        icon: __WEBPACK_IMPORTED_MODULE_9__assets_branding_logo5_png___default.a,
        title: 'What is ' + __WEBPACK_IMPORTED_MODULE_17__components_brand_name_brand_name_js__["a" /* BRAND */] + '?',
        subtitle: ''
      }, {
        href: '/support/how-to-trade-on-predictit',
        icon: __WEBPACK_IMPORTED_MODULE_7__assets_icons_support_book_svg___default.a,
        title: 'How to Trade',
        subtitle: ''
      }, {
        href: '/support/faq',
        icon: __WEBPACK_IMPORTED_MODULE_8__assets_icons_support_faq_svg___default.a,
        title: 'FAQs'
      }];

      if (!this.showVideos) {
        items.push({
          href: '/support/videos',
          icon: __WEBPACK_IMPORTED_MODULE_10__assets_icons_support_tutorial_svg___default.a,
          title: 'Videos',
          subtitle: ''
        });
      }

      return items;
    },
    subjectOptions: function subjectOptions() {
      return this.ticketTypes === null ? [] : this.ticketTypes;
    },
    isUploadEnabled: function isUploadEnabled() {
      // return !(this.isIos && this.isStandalone);
      return true;
    },
    messagePlaceholder: function messagePlaceholder() {
      return this.fields.message ? '' : 'Message';
    },
    messageRequired: function messageRequired() {
      return !this.fields.message;
    }
  }),
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["a" /* validators */].email,
      subject: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["a" /* validators */].required,
      message: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["a" /* validators */].message
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('support', ['getTicketsTypes', 'postTicket', 'getAnnouncements']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    userDataHandler: function userDataHandler(value) {
      if (value && value.email) {
        this.fields.email = value.email;
      }
    },
    showAnnouncement: function showAnnouncement(announcement) {
      if (!announcement.body) return;

      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_ANNOUNCEMENT);
      this.setCurrentPopupOptions({ announcement: announcement });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd(document.body);
        var formData = new FormData();
        formData.append('email', this.fields.email);
        formData.append('subject', this.fields.subject.value);
        formData.append('description', this.fields.message);

        this.files.forEach(function (file) {
          formData.append('uploadedImage', file);
        });

        this.postTicket(formData).then(function () {
          _this2.loaderRemove(document.body);
          _this2.setSuccessSideNotification(TICKET_SEND_MESSAGE);
          _this2.files = [];
          _this2.fields.message = '';
          _this2.fields.subject = null;
          _this2.formEnable();
        }).catch(function (error) {
          _this2.loaderRemove(document.body);
          _this2.formHandleErrors(error);
        });
      }
    },
    onUpload: function onUpload() {
      this.$refs.fileinput.click();
    },
    fileToBase64: function fileToBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve({
            name: file.name,
            file: reader.result
          });
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    onChange: function onChange() {
      var files = this.$refs.fileinput.files;
      if (files.length) {
        this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files));
      }
    },
    fileRemove: function fileRemove(index) {
      this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(0, index)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(index + 1)));
    }
  }),
  watch: {
    userData: {
      handler: 'userDataHandler',
      immediate: true
    }
  },
  created: function created() {
    var _this3 = this;

    this.loaderAdd(document.body);
    this.getTicketsTypes().then(function () {
      return _this3.getAnnouncements().then(function (data) {
        _this3.announcements = data || [];
      }).then(function () {
        return _this3.loaderRemove(document.body);
      });
    }).catch(function () {
      _this3.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "X6LQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"account-ssn-info-upload__note"},[_vm._v("\n    In order to process a credit card deposit, we need to verify your identity. This will be quick. Please click the button below.\n  ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick($event)}}},[_vm._v("\n    Verify Identity\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-ssn-info-upload__icon"},[_c('img',{attrs:{"src":__webpack_require__("xgaP")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XFAz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XLAI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"main-nav"},[_c('div',{staticClass:"main-nav__menu"},_vm._l((_vm.enabledLinks),function(item){return _c('div',{staticClass:"main-nav__item",on:{"click":function($event){return _vm.onLinkClick(item.href)}}},[_c('router-link',{class:_vm.classModifier(item.name),attrs:{"id":("nav-" + (item.name)),"to":item.href}},[_vm._v("\n          "+_vm._s(item.title.toString())+"\n      ")])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XLkl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XMP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableRowsLoader_vue__ = __webpack_require__("QWrq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aca848_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableRowsLoader_vue__ = __webpack_require__("T6JC");
function injectStyle (ssrContext) {
  __webpack_require__("iaga")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableRowsLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aca848_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableRowsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XO3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"purchase-extended-betslip"},[_c('div',{staticClass:"purchase-extended-betslip__contract",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('contractInfoClick')}}},[_c('purchase-extended-betslip-contract-info',{attrs:{"market":_vm.market,"contract":_vm.contract,"hideSharesBar":_vm.showOwnershipAndOrdersSummary}})],1),_vm._v(" "),(_vm.showOwnershipAndOrdersSummary)?_c('market-ownership-and-orders-bar',{staticClass:"purchase-extended-betslip__ownership-and-orders",attrs:{"theme":"orderslip","contract":_vm.contract,"symbol":_vm.currentPriceSymbol,"hideOrdersLabel":true}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"purchase-extended-betslip__forms-shares-value",class:{'purchase-extended-betslip__forms-shares-value--with-ownership-and-orders': _vm.showOwnershipAndOrdersSummary}},[(_vm.showOrderSlip)?_c('order-book-sushi',{key:_vm.extendedOrderBookKey,staticClass:"purchase-extended-betslip__orderslip",attrs:{"displayMode":_vm.ORDER_BOOK_DISPLAY_MODES.MOBILE,"contract":_vm.contract,"market":_vm.market,"operationType":_vm.tradeOptions.operationType,"operationValue":_vm.tradeOptions.operationValue},on:{"updatePriceAndQuantity":_vm.onUpdatePriceAndQuantity}}):_vm._e(),_vm._v(" "),(!_vm.isTradingEnabled)?[_c('market-trading-unavailable-v2',{attrs:{"theme":_vm.tradingUnavailableTheme},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v("\n          "+_vm._s(_vm.tradingUnavailableText)+"\n        ")]},proxy:true}],null,false,3819882065)})]:[_c('purchase-trade-type-switcher-sushi',{attrs:{"contract":_vm.contract}}),_vm._v(" "),(!_vm.isAvailableForTrade)?_c('div',{staticClass:"purchase-extended-betslip__warning"},[_vm._v("\n        You will need to liquidate your "+_vm._s(_vm.contractModel.mode.toUpperCase())+" holdings and cancel your unfilled orders before you are able to take a "+_vm._s(_vm.tradeOptions.operationValue.toUpperCase())+" position in this contract.\n      ")]):(_vm.showSellWarning)?_c('div',{staticClass:"purchase-extended-betslip__warning"},[_vm._v("\n        You don't have any shares to sell. After you buy shares, if the price rises you can sell to lock in your gains, or hold until settlement. Correct outcomes pay $1 per share.\n      ")]):[_c('purchase-quantity-picker-mobile-sushi',{staticClass:"purchase-extended-betslip__quantity",attrs:{"userQuantity":_vm.contractModel.userQuantity,"operationType":_vm.tradeOptions.operationType,"minValue":_vm.minQuantityValue,"maxValue":_vm.maxQuantityValue,"minimumOwnership":_vm.minimumOwnership,"selected":_vm.inputSelected === 'quantity'},on:{"blur":_vm.onQuantityInputBlur,"focus":function($event){_vm.inputSelected = 'quantity'}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v("\n              Quantity "+_vm._s(_vm.yesNoText)+"\n            ")]},proxy:true}]),model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}}),_vm._v(" "),(_vm.quantityErrorText)?_c('div',{staticClass:"purchase-extended-betslip__offer-quantity-error"},[_vm._v("\n            "+_vm._s(_vm.quantityErrorText)+"\n          ")]):_vm._e(),_vm._v(" "),_c('purchase-offer-value-picker-mobile-sushi',{staticClass:"purchase-extended-betslip__price",attrs:{"selected":_vm.inputSelected === 'value'},on:{"blur":_vm.onPriceInputBlur,"focus":function($event){_vm.inputSelected = 'value'}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v("\n              "+_vm._s(_vm.pricePerShareSuffixFull)+" "+_vm._s(_vm.tradeTypeText)+" Price\n            ")]},proxy:true}]),model:{value:(_vm.pricePerShare),callback:function ($$v) {_vm.pricePerShare=$$v},expression:"pricePerShare"}}),_vm._v(" "),(_vm.showThresholdInfo)?_c('div',{staticClass:"purchase-extended-betslip__ownership-link",on:{"click":_vm.openThresholdInfoPopup}},[_vm._v("\n            Minimum Ownership Requirement: "+_vm._s(_vm.minimumOwnership)+" Share"),(_vm.minimumOwnership > 1)?[_vm._v("s")]:_vm._e()],2):_vm._e()],_vm._v(" "),(_vm.isAvailableForTrade)?[_c('button',{class:_vm.nextButtonClassModifiers,attrs:{"disabled":_vm.nextButtonDisabledExtended},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClickNext($event)}}},[(_vm.showSellWarning)?[_vm._v("\n            Sell Shares\n          ")]:(_vm.tradeOptions.operationType === 'sell')?[(_vm.quantity && _vm.pricePerShare)?[_vm._v("\n              "+_vm._s(_vm.tradeTypeText)+" "+_vm._s(_vm.quantity)+" "+_vm._s(_vm.yesNoText)+"  "),_c('span',{staticClass:"purchase-extended-betslip__button-outline"},[_vm._v("at "+_vm._s(_vm.pricePerShare)+"¢ Min")])]:[_vm._v("\n              "+_vm._s(_vm.tradeTypeText)+"\n            ")]]:[(_vm.quantity && _vm.pricePerShare && _vm.dontShowMultiples)?[_vm._v("\n              "+_vm._s(_vm.tradeTypeText)+" "+_vm._s(_vm.quantity)+" "+_vm._s(_vm.yesNoText)+"  "),_c('span',{staticClass:"purchase-extended-betslip__button-outline"},[_vm._v("at "+_vm._s(_vm.pricePerShare)+"¢ Max")])]:(_vm.quantity && _vm.pricePerShare)?[_vm._v("\n              "+_vm._s(_vm.tradeTypeText)+" $"+_vm._s(_vm.buyPrice)+" "+_vm._s(_vm.yesNoText)+"  "),_c('span',{staticClass:"purchase-extended-betslip__button-outline"},[_vm._v("Win "+_vm._s(_vm.multiple)+"X")])]:[_vm._v("\n              "+_vm._s(_vm.tradeTypeText)+"\n            ")]]],2),_vm._v(" "),_c('div',{staticClass:"purchase-extended-betslip__rules"},[_c('div',{staticClass:"purchase-extended-betslip__skip-confirmation"},[_c('div',{class:_vm.skipConfirmationToggleClassModifiers,on:{"click":function($event){_vm.skipConfirmation = !_vm.skipConfirmation}}}),_vm._v(" "),_c('span',{staticClass:"purchase-extended-betslip__skip-confirmation-label"},[_vm._v("Skip Confirmation")])]),_vm._v(" "),_c('div',{staticClass:"purchase-extended-betslip__payout-container"},[(_vm.tradeOptions.operationType !== 'sell')?[_c('div',{staticClass:"purchase-extended-betslip__payout-amount-label",class:{'purchase-extended-betslip__payout-amount-label--clickable': _vm.tradeOptions.operationType === 'sell'},on:{"click":_vm.payoutClick}},[_vm._v("Payout:")]),_vm._v(" "),_c('div',{staticClass:"purchase-extended-betslip__payout-amount-value",class:{'purchase-extended-betslip__payout-amount-value--clickable': _vm.tradeOptions.operationType === 'sell'},attrs:{"title":_vm.payoutDisplayTitle},on:{"click":_vm.payoutClick}},[_vm._v(_vm._s(_vm.payoutDisplay))])]:_vm._e(),_vm._v(" "),_vm._t("right-side-footer")],2)])]:_vm._e()]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XObm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XWIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_notifications_proxy__ = __webpack_require__("a0yF");








var BALANCE_DEFAULT = {
  accountBalance: '$0.00',
  accountBalanceDecimal: 0,
  portfolioBalance: '$0.00',
  portfolioBalanceDecimal: 0,
  shareValueDelta: '$0.00',
  shareValueDeltaDecimal: 0,
  isDefault: true
};

var DEFAULT_WIRE_SEARCH = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    ach: {},
    check: {},
    wire: {},
    withdrawCoinbase: {},
    depositMethods: {},
    balance: BALANCE_DEFAULT,
    wireSearchResults: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_WIRE_SEARCH),
    pendingRequests: [],
    pendingDepositsRequests: [],
    currentDeposit: {},
    firstDepositDone: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('firstDepositDone', false),
    bankTransferStep: {}
  },
  getters: {
    portfolioValueDecimal: function portfolioValueDecimal(state, getters, rotState, rootGetters) {
      var totalValue = state.balance.accountBalanceDecimal + state.balance.portfolioBalanceDecimal + rootGetters['dashboard/mySharesTotalGainLoss'];
      return Math.floor(totalValue * 100) / 100;
    },
    portfolioValue: function portfolioValue(state, getters) {
      var value = getters.portfolioValueDecimal.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + value;
    }
  },
  mutations: {
    setBalance: function setBalance(state, payload) {
      state.balance = payload;
    },
    setCurrentDeposit: function setCurrentDeposit(state, payload) {
      state.currentDeposit = payload;
    },
    setWire: function setWire(state, data) {
      state.wire = data;
    },
    setAch: function setAch(state, data) {
      state.ach = data;
    },
    setCheck: function setCheck(state, data) {
      state.check = data;
    },
    setWithdrawCoinbase: function setWithdrawCoinbase(state, data) {
      state.withdrawCoinbase = data;
    },
    setPendingRequests: function setPendingRequests(state, data) {
      state.pendingRequests = data;
    },
    setPendingDepositsRequests: function setPendingDepositsRequests(state, data) {
      state.pendingDepositsRequests = data;
    },
    updateBalanceFromNotification: function updateBalanceFromNotification(state, data) {
      state.balance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["R" /* updateObjectValues */])(state.balance, data, __WEBPACK_IMPORTED_MODULE_6__services_notifications_proxy__["o" /* ACCOUNT_FUNDS_MAP */]);
    },
    markFirstDepositDone: function markFirstDepositDone(state) {
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set('firstDepositDone', true, expiresAt);
      state.firstDepositDone = true;
    },
    setDepositMethods: function setDepositMethods(state, value) {
      state.depositMethods = value;
    },
    resetWireSearchResults: function resetWireSearchResults(state) {
      state.wireSearchResults = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_WIRE_SEARCH);
    },
    setWireSearchResults: function setWireSearchResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.wireSearchResults.data));
      var data = sourceData.concat(payload.data.results || []);
      var page = payload.data.page;
      var totalCount = payload.data.totalResults;
      var canLoadMore = totalCount > data.length;

      state.wireSearchResults = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.wireSearchResults, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setBankTransferStep: function setBankTransferStep(state, data) {
      state.bankTransferStep = data;
    }
  },
  actions: {
    clearBalance: function clearBalance(_ref) {
      var commit = _ref.commit;

      commit('setBalance', BALANCE_DEFAULT);
    },
    getBalance: function getBalance(_ref2) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getBalance().then(function (response) {
        commit('setBalance', response.data);
        return response.data;
      });
    },
    getDepositCard: function getDepositCard() {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getDepositCard().then(function (response) {
        return response.data;
      });
    },
    confirmDepositCard: function confirmDepositCard(_ref3, payload) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postConfirmDepositCard(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositCard: function submitDepositCard(_ref4, payload) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postSubmitDepositCard(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositUSDCoin: function submitDepositUSDCoin(_ref5, payload) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postSubmitDepositUSDCoin(payload).then(function (response) {
        return response.data;
      });
    },
    setCurrentDeposit: function setCurrentDeposit(_ref6, value) {
      var commit = _ref6.commit;

      commit('setCurrentDeposit', value);
    },
    getPayNearMe: function getPayNearMe(_ref7, page) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getPayNearMe(page).then(function (response) {
        return response.data;
      });
    },
    getDepositUSDCoin: function getDepositUSDCoin() {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getDepositUSDCoin().then(function (response) {
        return response.data;
      });
    },
    resetWireSearchResults: function resetWireSearchResults(_ref8) {
      var commit = _ref8.commit;

      commit('resetWireSearchResults');
    },
    getWithdrawWireBankSearch: function getWithdrawWireBankSearch(_ref9, _ref10) {
      var state = _ref9.state,
          commit = _ref9.commit;
      var _ref10$query = _ref10.query,
          query = _ref10$query === undefined ? '' : _ref10$query;

      if (state.wireSearchResults.canLoadMore) {
        var page = state.wireSearchResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawWireBankSearch(page, query).then(function (response) {
          commit('setWireSearchResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    getWithdrawWire: function getWithdrawWire(_ref11) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawWire().then(function (response) {
        commit('setWire', response.data);
        return response.data;
      });
    },
    getWithdrawAch: function getWithdrawAch(_ref12) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawAch().then(function (response) {
        commit('setAch', response.data);
        return response.data;
      });
    },
    getWithdrawCheck: function getWithdrawCheck(_ref13) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawCheck().then(function (response) {
        commit('setCheck', response.data);
        return response.data;
      });
    },
    getWithdrawCoinbase: function getWithdrawCoinbase(_ref14) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawUSDC().then(function (response) {
        commit('setWithdrawCoinbase', response.data);
        return response.data;
      });
    },
    postWithdrawAch: function postWithdrawAch(_ref15, payload) {
      var dispatch = _ref15.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawAch(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawCheck: function postWithdrawCheck(_ref16, payload) {
      var dispatch = _ref16.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawCheck(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawCoinbase: function postWithdrawCoinbase(_ref17, payload) {
      var dispatch = _ref17.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawUSDC(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawWireBankInfo: function postWithdrawWireBankInfo(_ref18, payload) {
      var dispatch = _ref18.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawWireBankInfo(payload).then(function (response) {
        return response.data;
      });
    },
    postWithdrawWireConfirm: function postWithdrawWireConfirm(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawWireConfirm(payload).then(function (response) {
        return response.data;
      });
    },
    postWithdrawWireSubmit: function postWithdrawWireSubmit(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawWireSubmit(payload).then(function (response) {
        return response.data;
      });
    },
    getPendingWithdrawals: function getPendingWithdrawals(_ref19) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getPendingWithdrawals().then(function (response) {
        commit('setPendingRequests', response.data);
        return response.data;
      });
    },
    getPendingDeposits: function getPendingDeposits(_ref20) {
      var commit = _ref20.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getPendingDeposits().then(function (response) {
        commit('setPendingDepositsRequests', response.data);
        return response.data;
      });
    },
    cancelWithdrawal: function cancelWithdrawal(_ref21, payload) {
      var dispatch = _ref21.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postCancelWithdrawal(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    updateBalanceFromNotification: function updateBalanceFromNotification(_ref22, payload) {
      var commit = _ref22.commit;

      commit('updateBalanceFromNotification', payload);
    },
    getDepositMethods: function getDepositMethods(_ref23) {
      var commit = _ref23.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getDepositMethods().then(function (response) {
        var data = response.data;
        commit('setDepositMethods', data);
        return data;
      });
    },
    getWithdrawalMethods: function getWithdrawalMethods() {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawalMethods().then(function (response) {
        return response.data;
      });
    },
    markFirstDepositDone: function markFirstDepositDone(_ref24) {
      var commit = _ref24.commit;

      commit('markFirstDepositDone');
    },
    getDepositPWMB: function getDepositPWMB(_) {
      var _ref25 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref25$authorizationI = _ref25.authorizationId,
          authorizationId = _ref25$authorizationI === undefined ? '' : _ref25$authorizationI,
          _ref25$returnUrl = _ref25.returnUrl,
          returnUrl = _ref25$returnUrl === undefined ? '' : _ref25$returnUrl,
          _ref25$cancelUrl = _ref25.cancelUrl,
          cancelUrl = _ref25$cancelUrl === undefined ? '' : _ref25$cancelUrl;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getDepositPWMB({ authorizationId: authorizationId, returnUrl: returnUrl, cancelUrl: cancelUrl }).then(function (response) {
        return response.data;
      });
    },
    deletePWMBAccount: function deletePWMBAccount(_, authorizationId) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.deletePWMBAuthorization(authorizationId).then(function (response) {
        return response.data;
      });
    },
    confirmDepositPWMB: function confirmDepositPWMB(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postConfirmDepositPWMB(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositPWMB: function submitDepositPWMB(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postSubmitDepositPWMB(payload).then(function (response) {
        return response.data;
      });
    },
    getPWMBAuthorization: function getPWMBAuthorization() {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getPWMBAuthorization().then(function (response) {
        return response.data;
      });
    },
    setBankTransferStep: function setBankTransferStep(_ref26, data) {
      var commit = _ref26.commit;

      commit('setBankTransferStep', data);
    },
    submitInstantCredit: function submitInstantCredit(_, promoCodeText) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postInstantCredit({ promoCodeText: promoCodeText }).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "XaR5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XcjC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin__ = __webpack_require__("Q9xH");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']))
});

/***/ }),

/***/ "XiJB":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "Xkgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_trade_history_sushi_js__ = __webpack_require__("IQKx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007b32f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trade_history_sushi_vue__ = __webpack_require__("V+2w");
function injectStyle (ssrContext) {
  __webpack_require__("pNYZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_trade_history_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007b32f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trade_history_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xo/C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XqpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_js__ = __webpack_require__("HzXs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7b9b4be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_vue__ = __webpack_require__("qAAu");
function injectStyle (ssrContext) {
  __webpack_require__("XObm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7b9b4be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XrgL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "XyfZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XzHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  data: function data() {
    return {
      statement: '',
      mandatoryStatement: '',
      fields: {
        taxId: '',
        zipCode: '',
        stateCode: '',
        city: '',
        address: '',
        name: ''
      }
    };
  },

  validations: {
    fields: {
      taxId: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].taxId,
      zipCode: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      stateCode: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      city: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      address: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      name: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['systemEmails'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getTaxInfo', 'postTaxInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setMandatoryTaxNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          taxId: this.fields.taxId,
          zipCode: this.fields.zipCode,
          stateCode: this.fields.stateCode,
          city: this.fields.city,
          address1: this.fields.address,
          name: this.fields.name
        };
        this.postTaxInfo(payload).then(function (data) {
          _this.setCurrentPopup();
          _this.setSuccessSideNotification(data.message);
        }).catch(function (error) {
          return _this.formHandleErrors(error);
        });
      }
    }
  }),
  created: function created() {
    var _this2 = this;

    var reasonCode = this.$route.query.reason || '';
    this.getTaxInfo({ reasonCode: reasonCode }).then(function (data) {
      _this2.setMandatoryTaxNotification(data.isMandatory);
      _this2.fields.address = data.address1;
      _this2.fields.city = data.city;
      _this2.fields.name = data.name;
      _this2.fields.zipCode = data.zipCode;
      _this2.fields.stateCode = data.stateCode;
      _this2.mandatoryStatement = data.mandatoryStatement;
      _this2.statement = data.statement;
    });
  }
});

/***/ }),

/***/ "XzS6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y+KT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    bodyClass: {
      type: String,
      default: ''
    },
    headerClass: {
      type: String,
      default: ''
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    clickOutsideEnabled: {
      type: Boolean,
      default: false
    },
    gtm: [String, Object],
    fullScreen: {
      type: Boolean,
      default: false
    },
    overlayTheme: {
      type: String,
      default: 'default'
    },
    hideHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasHeader: function hasHeader() {
      return !!this.$slots.header && !this.hideHeader;
    },
    hasFooter: function hasFooter() {
      return !!this.$slots.footer;
    },
    overlayClassModifiers: function overlayClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        modal__overlay: true
      }, 'modal__overlay--' + this.overlayTheme, this.overlayTheme);
    },
    classModifier: function classModifier() {
      return {
        'modal__content--full': this.fullScreen,
        'modal__content--with-footer': this.hasFooter,
        'modal__content--no-padding': this.noPadding
      };
    }
  },
  methods: {
    close: function close() {
      if (this.gtm && this.gtm.closing) {
        this.$gtm.trackEvent(this.gtm.closing);
      }
      this.$emit('modalClose');
    },
    onClickOutside: function onClickOutside() {
      if (this.clickOutsideEnabled) this.close();
    },
    afterEnter: function afterEnter() {}
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["l" /* lockModal */])();
    if (this.gtm) {
      var name = this.gtm.virtualPage || (typeof this.gtm === 'string' ? this.gtm : this.gtm.name);
      var virtualPage = this.gtm.virtualPage ? name : this.$route.path + '/' + name;

      if (virtualPage) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: virtualPage,
          virtualPageTitle: 'modal/' + name
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.gtm && this.$route && this.$route.fullPath) {
      this.$gtm.trackEvent({
        event: 'pageviewTrackerEvent',
        virtualPage: this.$route.fullPath,
        virtualPageTitle: this.$route.name,
        closing: this.gtm
      });
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["m" /* unLockModal */])();
  }
});

/***/ }),

/***/ "Y/OY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y/q+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_js__ = __webpack_require__("ZllZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530978a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_vue__ = __webpack_require__("kjig");
function injectStyle (ssrContext) {
  __webpack_require__("2/KR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530978a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y2Na":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showMenu: false,
      selectedType: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    typesBuy: function typesBuy() {
      return 'buy';
    },
    typesSell: function typesSell() {
      return 'sell';
    },
    types: function types() {
      return [this.typesBuy, this.typesSell];
    },
    showOptionToggle: function showOptionToggle() {
      return this.contractModel.mode && this.contractModel.mode === this.tradeOptions.operationValue;
    },
    tradeType: function tradeType() {
      switch (this.tradeOptions.operationType + '_' + this.tradeOptions.operationValue) {
        case 'buy_no':
          return 0;
        case 'buy_yes':
          return 1;
        case 'sell_no':
          return 2;
        case 'sell_yes':
          return 3;
        default:
          return -1;
      }
    },
    isYesType: function isYesType() {
      return this.tradeType === 1 || this.tradeType === 3;
    },
    yesNoText: function yesNoText() {
      return this.isYesType ? 'YES' : 'NO';
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](this.contract);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['addSimple']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    switchOperation: function switchOperation(value) {
      if (value === this.selectedType) {
        return;
      }

      if (!this.showOptionToggle && !this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
        return;
      }

      this.setTradeOptions({
        contractId: this.contract.contractId,
        operationType: value,
        operationValue: this.tradeOptions.operationValue
      });
      this.showMenu = false;
    },
    switchDirection: function switchDirection(direction) {
      if (direction === this.yesNoText.toLowerCase()) return;
      if (direction === 'yes') {
        this.toggleTradeOperation('left');
      } else {
        this.toggleTradeOperation('right');
      }
    },
    onMenuToggle: function onMenuToggle() {
      this.showMenu = !this.showMenu;
    },
    directionClassModifiers: function directionClassModifiers(direction) {
      return {
        'purchase-trade-type-switcher-sushi__direction': true,
        'purchase-trade-type-switcher-sushi__direction--selected': direction === this.yesNoText.toLowerCase(),
        'purchase-trade-type-switcher-sushi__direction--no': this.yesNoText.toLowerCase() === 'no'
      };
    },
    operationClassModifiers: function operationClassModifiers(operation) {
      return {
        'purchase-trade-type-switcher-sushi__operation': true,
        // 'purchase-trade-type-switcher-sushi__operation--not-available': !this.showOptionToggle && this.isLoggedIn,
        'purchase-trade-type-switcher-sushi__operation--selected': operation === this.selectedType.toLowerCase()
      };
    },
    tradeOptionsHandler: function tradeOptionsHandler(value) {
      this.selectedType = value.operationType;
    },
    onClickOutside: function onClickOutside() {
      this.showMenu = false;
    }
  }),
  watch: {
    tradeOptions: {
      handler: 'tradeOptionsHandler',
      immediate: true
    }
  }
});

/***/ }),

/***/ "Y4EP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    href: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    isDark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    darkModifier: function darkModifier() {
      return {
        'link-tile--dark': this.isDark
      };
    },
    titleModifier: function titleModifier() {
      return {
        'link-tile__content-title--big': !this.subtitle
      };
    }
  }
});

/***/ }),

/***/ "Y4M0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_what_is_new_flow_version_1_js__ = __webpack_require__("/BTu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_606edf70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_new_flow_version_1_vue__ = __webpack_require__("sQLb");
function injectStyle (ssrContext) {
  __webpack_require__("M6K4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_what_is_new_flow_version_1_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_606edf70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_new_flow_version_1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y6Bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_enable_classic_predictit_js__ = __webpack_require__("mskH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_060928cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_enable_classic_predictit_vue__ = __webpack_require__("u/mk");
function injectStyle (ssrContext) {
  __webpack_require__("u1Yt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_enable_classic_predictit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_060928cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_enable_classic_predictit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y8LD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YCiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_js__ = __webpack_require__("oo9H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78516850_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__("iK+6");
function injectStyle (ssrContext) {
  __webpack_require__("jthy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78516850_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YEM7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YF1h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YGiH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-login"},[_c('div',{staticClass:"page-login__content"},[_c('div',{staticClass:"page-login__title"},[_vm._v("\n      Login\n    ")]),_vm._v(" "),_c('div',{staticClass:"page-login__content-wrap"},[_c('account-login',{attrs:{"mode":"page"}}),_vm._v(" "),_c('account-login-footer',{attrs:{"mode":"page"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YHd0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_contract_js__ = __webpack_require__("E5wa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05561034_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_contract_vue__ = __webpack_require__("UWOG");
function injectStyle (ssrContext) {
  __webpack_require__("Qo/9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_contract_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05561034_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_contract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YQaP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-forgotten-password"},[_c('div',{staticClass:"page-forgotten-password__content"},[_c('div',{staticClass:"page-forgotten-password__title"},[_vm._v("\n      Forgotten Password\n    ")]),_vm._v(" "),_c('div',{staticClass:"page-forgotten-password__content-wrap"},[_c('account-forgotten')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YWtT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YZ+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");




/* eslint-disable no-mixed-operators */


var Contract = function () {
  function Contract(params) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Contract);

    var getters = ['hasLastTradePrice', 'lastTradePriceAsCents', 'lastClosePriceAsCents', 'changePriceAsCents', 'userAveragePricePerShareAsCents', 'userChangePriceAsCents', 'buyYesCostAsCents', 'buyNoCostAsCents', 'sellYesCostAsCents', 'sellNoCostAsCents', 'userOpenOrders', 'totalSharesTradedDisplay', 'mode', 'lastTradePriceAsCentsWithZeroBypass'];
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      if (getters.indexOf(key) < 0) {
        // to avoid setter exception
        _this[key] = params[key];
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Contract, [{
    key: 'hasLastTradePrice',
    get: function get() {
      return this.lastTradePriceAsCents > 0;
    }
  }, {
    key: 'lastTradePriceAsCents',
    get: function get() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(this.lastTradePrice);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) ? value : 0;
    }
  }, {
    key: 'lastTradePriceAsCentsWithZeroBypass',
    get: function get() {
      return this.hasLastTradePrice ? this.lastTradePriceAsCents : 0;
    }
  }, {
    key: 'lastClosePriceAsCents',
    get: function get() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(this.lastClosePrice);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) ? value : 0;
    }
  }, {
    key: 'changePriceAsCents',
    get: function get() {
      if (!this.hasLastTradePrice) {
        return 0;
      }

      return this.lastTradePriceAsCents - this.lastClosePriceAsCents;
    }
  }, {
    key: 'userAveragePricePerShareAsCents',
    get: function get() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(this.userAveragePricePerShare);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) ? value : 0;
    }
  }, {
    key: 'userChangePriceAsCents',
    get: function get() {
      if (!this.hasLastTradePrice) {
        return 0;
      }

      var roundedAverage = Math.round(this.userAveragePricePerShare * 100) / 100;
      if (this.mode === 'no') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(1 - this.lastTradePrice - roundedAverage);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(this.lastTradePrice - roundedAverage);
    }
  }, {
    key: 'buyYesCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["i" /* correctPrice */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(this.bestYesPrice || this.bestYesCost));
    }
  }, {
    key: 'buyNoCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["i" /* correctPrice */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(this.bestNoPrice || this.bestNoCost));
    }
  }, {
    key: 'sellYesCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["i" /* correctPrice */])(100 - this.buyNoCostAsCents);
    }
  }, {
    key: 'sellNoCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["i" /* correctPrice */])(100 - this.buyYesCostAsCents);
    }
  }, {
    key: 'userOpenOrders',
    get: function get() {
      return this.userOpenOrdersBuyQuantity + this.userOpenOrdersSellQuantity;
    }
  }, {
    key: 'mode',
    get: function get() {
      if (this.userQuantity === 0 && this.userOpenOrders === 0) return '';
      if (this.userPrediction === 0) return 'no';
      if (this.userPrediction === 1) return 'yes';
      return '';
    }
  }, {
    key: 'totalSharesTradedNumber',
    get: function get() {
      return this.totalSharesTraded || this.totalTrades || 0;
    }
  }, {
    key: 'totalSharesTradedDisplay',
    get: function get() {
      var value = this.totalSharesTradedNumber;
      return value.toLocaleString();
    }
  }]);

  return Contract;
}();

/* harmony default export */ __webpack_exports__["a"] = (Contract);

/***/ }),

/***/ "YZhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_prices_sushi_js__ = __webpack_require__("NQZ3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95e11d68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_prices_sushi_vue__ = __webpack_require__("mmUa");
function injectStyle (ssrContext) {
  __webpack_require__("a/JI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_prices_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95e11d68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_prices_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");

 /* eslint-disable arrow-body-style, max-len */










var DISABLE_RESTRICTED_ACCESS_ROUTES = ['disqus-auth', 'social-auth', 'home'];

var DISABLE_CHECK_CLASSICS_ACCESS_ROUTES = ['terms-and-conditions'];

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var RouterInstance = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  base: "/",
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(to, 'params.dontReload', false)) {
      return null;
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },

  routes: __WEBPACK_IMPORTED_MODULE_5__router_routes__["a" /* default */]
});

RouterInstance.beforeEach(function (to, from, next) {
  if (from && from.name && from.fullPath) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setPreviousRoute', from.fullPath);
  }
  if (__WEBPACK_IMPORTED_MODULE_7__mixins_userAgent__["g" /* isStandalone */] && from.name && to.name && to.fullPath) {
    var expiresAt = 31536000;
    __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('currentRoutePath', to.fullPath, expiresAt);
  }

  var shouldCheckAccess = function shouldCheckAccess() {
    return false && !DISABLE_RESTRICTED_ACCESS_ROUTES.includes(to.name) || to.matched.some(function (record) {
      return record.meta.requiresAuth;
    });
  };

  var shouldCheckAnonymous = function shouldCheckAnonymous() {
    return to.matched.some(function (record) {
      return record.meta.requiresAnonymous;
    });
  };

  var shouldCheckClassicsEnabled = function shouldCheckClassicsEnabled() {
    return !DISABLE_CHECK_CLASSICS_ACCESS_ROUTES.includes(to.name);
  };

  var serverApiVersion = parseInt(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.app.serverVersion || 0, 10);
  var initialApiVersion = parseInt(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.app.initialVersion || 0, 10);

  if (serverApiVersion && initialApiVersion && serverApiVersion > initialApiVersion) {
    window.location.reload();
  }

  var hasClassicsNotEnabled = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user.status.isClassicEnabled === false;

  if (shouldCheckAccess()) {
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn'] === false) {
      next({
        name: 'home',
        query: { redirect: to.fullPath }
      });
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    } else if (hasClassicsNotEnabled) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC).then(function () {
        return next();
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup').then(function () {
        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup');
      }).then(function () {
        return next();
      });
    }
  } else if (shouldCheckAnonymous()) {
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn'] === true) {
      next({ name: 'home', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to.query) });
    } else {
      next();
    }
  } else if (shouldCheckClassicsEnabled()) {
    if (hasClassicsNotEnabled) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC).then(function () {
        return next();
      });
    } else {
      next();
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup').then(function () {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup');
    }).then(function () {
      return next();
    });
  }
});

RouterInstance.afterEach(function (to) {
  __WEBPACK_IMPORTED_MODULE_8__helpers_sessionVars__["a" /* default */].check(to);
  window.dataLayer = window.dataLayer || [];
  if (to && to.fullPath) {
    window.dataLayer.push({
      event: 'pageviewTrackerEvent',
      virtualPage: to.fullPath,
      virtualPageTitle: to.name
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterInstance);

/***/ }),

/***/ "YfBz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xMS4zMzQgNy0zLjE3NyAzLjI2NmEuMjIyLjIyMiAwIDAgMS0uMTU3LjA2Ny4yMTYuMjE2IDAgMCAxLS4xNTctLjA2N0w0LjY2NyA3IiBzdHJva2U9IiMwQzBDMEMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "YfnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_toolbar_js__ = __webpack_require__("Qe7J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_479c8e50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_toolbar_vue__ = __webpack_require__("xTJs");
function injectStyle (ssrContext) {
  __webpack_require__("xIGH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_toolbar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_479c8e50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YjXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-story-detail"},[_c('div',{staticClass:"page-story-detail__content"},[_c('div',{staticClass:"page-story-detail__story"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.storyContent)}}),_vm._v(" "),(_vm.detailData && _vm.detailData.ctaText)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.detailData.ctaText)}}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ykf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_daily_markets_details_js__ = __webpack_require__("KfAn");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_daily_markets_details_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6aedb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_daily_markets_details_vue__ = __webpack_require__("WTcQ");
function injectStyle (ssrContext) {
  __webpack_require__("UhjY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_daily_markets_details_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6aedb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_daily_markets_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["b"] = (Component.exports);


/***/ }),

/***/ "Ynfl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yszk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2"},[_c('section',{staticClass:"index2__banner"},[_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-8 index2__hero-container"},[_c('hero-unit-slider'),_vm._v(" "),_c('div',{staticClass:"index2__quotes"},[_c('quotes')],1)],1),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4"},[_c('div',{staticClass:"index2__sign-up"},[_c('div',{staticClass:"index2__modal__header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register',{attrs:{"mode":"page"}})],1)])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"index2__properties"},[_c('div',{staticClass:" "},[_c('div',{staticClass:"index2__properties-container"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/4300778c-1f81-48dd-bc0f-34c7b1390ac8.png"),expression:"`/images/4300778c-1f81-48dd-bc0f-34c7b1390ac8.png`"}]})]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/010db909-3592-4dd7-8fe9-53d40fba2b8f.png"),expression:"`/images/010db909-3592-4dd7-8fe9-53d40fba2b8f.png`"}]})]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/33cc985e-910b-41a6-93b8-bdad5cd60908.png"),expression:"`/images/33cc985e-910b-41a6-93b8-bdad5cd60908.png`"}]})]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/262950df-75d5-4d67-ae63-eb12878c3a0a.png"),expression:"`/images/262950df-75d5-4d67-ae63-eb12878c3a0a.png`"}]})]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/ce63ef48-3790-471d-88cd-dec2880845c1.png"),expression:"`/images/ce63ef48-3790-471d-88cd-dec2880845c1.png`"}]})]),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"})])])]),_vm._v(" "),_vm._m(8)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index2__prediction"},[_c('div',{staticClass:"row row-x "},[_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8100/Will-Congress-confirm-a-Supreme-Court-justice-in-2025","target":"_blank"}},[_c('div',{staticClass:"index2__prediction-img index2__prediction-img--left"},[_c('p',{staticClass:"index2__prediction--prediction-text"},[_vm._v("New justice "),_c('br'),_vm._v(" confirmed?")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8142/How-many-vetoes-will-Trump-issue-in-2025","target":"_blank"}},[_c('div',{staticClass:"index2__prediction-img index2__prediction-img--middle"},[_c('p',{staticClass:"index2__prediction--prediction-text"},[_vm._v("Number of "),_c('br'),_vm._v(" vetoes?")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8099/Which-party-will-win-the-2025-gubernatorial-election-in-Virginia","target":"_blank"}},[_c('div',{staticClass:"index2__prediction-img index2__prediction-img--right"},[_c('p',{staticClass:"index2__prediction--prediction-text"},[_vm._v("Next Virginia "),_c('br'),_vm._v(" Governor?")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index2__video"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"index2__video--video-container"},[_c('div',{staticClass:"column small-12 index2__video--videowrapper"},[_c('iframe',{attrs:{"height":"608","width":"100%","src":"https://www.youtube.com/embed/XxHBRkqT5YQ?rel=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12 large-12"},[_c('div',{staticClass:"index2__process-heading"},[_c('h2',[_vm._v("Start Now")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Shares priced 1¢ - 99¢. Winning shares pay $1.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Think your shares hit the roof? Sell them to other buyers.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Safe and Secure: Operated by the Prediction Market Research Consortium.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Trade on over 300 political futures markets.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Join the prediction market for politics.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index2__work"},[_c('div',{staticClass:"row row-x index2__work-container "},[_c('div',{staticClass:"col-sm-12 index2__process-heading"},[_c('h2',[_vm._v("How Does It Work")])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index2__work--work-info"},[_c('div',{staticClass:"index2__work--work-icon"},[_vm._v("\n\t\t\t\t\t1\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index2__process-text"},[_c('h3',[_vm._v("Browse Markets")]),_vm._v(" "),_c('p',[_vm._v("Look for opportunities on market prices.")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index2__work--work-info"},[_c('div',{staticClass:"index2__work--work-icon"},[_vm._v("\n\t\t\t\t\t2\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index2__process-text"},[_c('h3',[_vm._v("Make a Prediction")]),_vm._v(" "),_c('p',[_vm._v("Think everyone's got it wrong? Buy shares for or against an event taking place. ")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index2__work--work-info"},[_c('div',{staticClass:"index2__work--work-icon"},[_vm._v("\n\t\t\t\t\t3\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index2__process-text"},[_c('h3',[_vm._v("Trade your shares")]),_vm._v(" "),_c('p',[_vm._v("Buy your shares low and sell them high once the crowd figures out you were right.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z+l7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.items.length === 0 && !_vm.isLoading)?_c('div',{staticClass:"watchlist-sushi__note"},[_c('market-empty-state',{attrs:{"icon":"watchlist-history","small":_vm.type !== 'widget'}},[_vm._v("\n      Watchlist is empty.\n    ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.marketId,class:_vm.itemClassModifiers},[(_vm.type === 'widget' || _vm.isLayoutMobile)?[_c('market-contract-info-v2',{attrs:{"market":item,"link":_vm.itemLink(item),"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY}})]:[_c('market-contract-info-v2',{staticClass:"market-contract-info-v2--center market-contract-info-v2--center-detailed",attrs:{"image":item.marketImageUrl,"link":_vm.itemLink(item),"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row-h100"},[_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wwatchlist"},[_c('div',{staticClass:"market-contract-info-v2__market-name"},[_vm._v("\n                  "+_vm._s(item.marketName)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wwatchlistmain"},[_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--multi"},_vm._l((_vm.getContracts(item)),function(contract){return _c('router-link',{key:contract.contractId,staticClass:"market-contract-info-v2__contract-row",attrs:{"to":_vm.itemLink(item, contract.contractId)}},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__contract-row-name"},[_vm._v("\n                        "+_vm._s(contract.contractName)+"\n                    ")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"market-contract-info-v2__contract-row-price market-contract-info-v2--mono"},[(contract.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":contract.lastTradePriceAsCents}})]:[_vm._v("\n                          NEW\n                        ")]],2),_vm._v(" "),(contract.changePriceAsCents)?_c('market-change-price',{attrs:{"price":contract.changePriceAsCents,"lastClosePrice":contract.lastClosePrice}}):_vm._e()],1)])}),1),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--right"},[_c('div',{staticClass:"market-contract-info-v2__contract-value market-contract-info-v2--mono"},[_vm._v("\n                    "+_vm._s(item.totalSharesTraded.toLocaleString())+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__action"},[_vm._v("\n                    Shares Traded\n                  ")])])])])]},proxy:true}],null,true)})]],2)}),_vm._v(" "),(!_vm.isLoading && _vm.items.length > 0)?_c('router-link',{staticClass:"watchlist-sushi__link",attrs:{"to":{ name: 'market-watchlist' }}},[_vm._v("\n    Open Watchlist\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z+nZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_notifications_js__ = __webpack_require__("FaNS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b832195e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_notifications_vue__ = __webpack_require__("zzjx");
function injectStyle (ssrContext) {
  __webpack_require__("nzeb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_notifications_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b832195e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z/tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("SqSL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_354f1cc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("ZiY/");
function injectStyle (ssrContext) {
  __webpack_require__("Xo/C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_354f1cc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z05w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_how_it_works_js__ = __webpack_require__("8KbT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e19be50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_how_it_works_vue__ = __webpack_require__("IS7d");
function injectStyle (ssrContext) {
  __webpack_require__("Vgd5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_how_it_works_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e19be50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_how_it_works_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z4oj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE5IDE3Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTEuMTYgNi44NjNoMy4xMzl2Ni42MDFIMS4xNnpNMTQuNjkxIDEwLjI3NGgzLjEzOXYzLjE5MWgtMy4xMzl6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iIzY3OTk5RiIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTguNDEgMTUuODE0SC41OGMtLjMyIDAtLjU4LjI2NC0uNTguNTkgMCAuMzI1LjI2LjU4OS41OC41ODloMTcuODNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5IDAtLjMyNS0uMjYtLjU5LS41OC0uNTl6TTE4LjQxIDkuMDk1aC00LjNjLS4zMiAwLS41OC4yNjQtLjU4LjU5djQuMzdjMCAuMzI1LjI2LjU4OS41OC41ODloNC4zYy4zMiAwIC41OC0uMjY0LjU4LS41OXYtNC4zN2MwLS4zMjUtLjI2LS41OS0uNTgtLjU5em0tLjU4IDQuMzdoLTMuMTR2LTMuMTkxaDMuMTR2My4xOXpNLjU4IDE0LjY0NGg0LjNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5di03Ljc4YzAtLjMyNi0uMjYtLjU5LS41OC0uNTlILjU4Yy0uMzIgMC0uNTguMjY0LS41OC41OXY3Ljc4YzAgLjMyNi4yNi41OS41OC41OXptLjU4LTcuNzhINC4zdjYuNkgxLjE2di02LjZ6TTcuMzQ1IDE0LjY0NGg0LjNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5Vi42MzZjMC0uMzI1LS4yNi0uNTktLjU4LS41OWgtNC4zYy0uMzIgMC0uNTguMjY1LS41OC41OXYxMy40MThjMCAuMzI2LjI2LjU5LjU4LjU5em0uNTgtMTMuNDE4aDMuMTR2MTIuMjM5aC0zLjE0VjEuMjI1eiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "ZB+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-ownership-conflict-modal"},[_c('div',{staticClass:"market-ownership-conflict-modal__info",domProps:{"innerHTML":_vm._s(_vm.restrictionPreamble)}}),_vm._v(" "),(_vm.restrictions.length > 0)?_c('div',{staticClass:"market-ownership-conflict-modal__restrictions"},_vm._l((_vm.restrictions),function(restriction,index){return _c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],key:("restriction-" + index),staticClass:"market-ownership-conflict-modal__restriction",attrs:{"href":restriction.marketLink}},[_c('div',{staticClass:"market-ownership-conflict-modal__restriction-content"},[_c('div',{staticClass:"market-ownership-conflict-modal__restriction-market-name"},[_vm._v(_vm._s(restriction.marketName))]),_vm._v(" "),_c('div',{staticClass:"market-ownership-conflict-modal__restriction-exchange"},[_vm._v("PredictIt Exchange")])]),_vm._v(" "),_c('div',{staticClass:"market-ownership-conflict-modal__restriction-arrow"})])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZBib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZC+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiggestGainsLoader_vue__ = __webpack_require__("tV9q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9907168e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiggestGainsLoader_vue__ = __webpack_require__("LQ9G");
function injectStyle (ssrContext) {
  __webpack_require__("hBIN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiggestGainsLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9907168e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiggestGainsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZFw9":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "ZIhC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_js__ = __webpack_require__("4RI/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71762b3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__ = __webpack_require__("KkzE");
function injectStyle (ssrContext) {
  __webpack_require__("Qbbn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71762b3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZJN1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZJhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_table_js__ = __webpack_require__("Oz+7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b31201_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__("gj0Q");
function injectStyle (ssrContext) {
  __webpack_require__("q+s1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_table_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b31201_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZKEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']))
});

/***/ }),

/***/ "ZKfp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZMD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_export_history_state_button_state_button_vue__ = __webpack_require__("JOj2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__("XILU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);







var DATE_FORMAT = 'MM/DD/YYYY';
var DATE_FORMAT_API = 'MM-DD-YYYY';
var KIND_TRADE = 'trade';
var KIND_TRANSACTION = 'transaction';

function dateFormatter(date) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format(DATE_FORMAT);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    stateButton: __WEBPACK_IMPORTED_MODULE_4__components_export_history_state_button_state_button_vue__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a
  },
  props: {
    kind: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      dateFormatter: dateFormatter,
      disabled: {
        from: null
      },
      selected: {
        l30d: false,
        l3m: false,
        ytd: false
      },
      dates: {},
      dateFrom: {
        date: null
      },
      dateTo: {
        date: null
      },
      openCalendar: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['market']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlay', ['visible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['token']), {
    formAction: function formAction() {
      switch (this.kind) {
        case KIND_TRANSACTION:
          return "/Resource/DownloadWalletHistory";
        case KIND_TRADE:
          return "/Resource/DownloadTradeHistory";
        default:
          return '';
      }
    },
    marketId: function marketId() {
      if (this.$route.params.marketId && this.$route.params.marketId !== 'all') {
        return this.$route.params.marketId;
      }
      return null;
    },
    contractId: function contractId() {
      if (this.$route.query) {
        return this.$route.query.contractId;
      }
      return null;
    },
    contractName: function contractName() {
      var _this = this;

      if (this.contractId) {
        var contract = this.market.contracts.find(function (i) {
          return i.contractId === _this.contractId;
        });
        return (contract || {}).contractName;
      }
      return null;
    }
  }),
  watch: {
    'dateFrom.date': 'watchDateChange',
    'dateTo.date': 'watchDateChange',
    visible: function visible() {
      if (!this.openCalendar && !this.visible) {
        this.setCurrentPopup();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('overlay', {
    hideOverlay: 'hide',
    showOverlay: 'show'
  }), {
    watchDateChange: function watchDateChange() {
      var preset = this.isPreset(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateFrom.date).format(DATE_FORMAT), __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateTo.date).format(DATE_FORMAT), this.dates);
      this.setButton(preset);
    },
    onButtonClick: function onButtonClick(btn) {
      this.dateFrom = {
        date: new Date(Date.parse(this.dates[btn.name]))
      };
      this.dateTo = {
        date: new Date(Date.parse(this.dates.today))
      };
    },
    onExport: function onExport() {
      var StartDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateFrom.date).format(DATE_FORMAT_API);
      var EndDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateTo.date).format(DATE_FORMAT_API);

      this.$refs.StartDate.value = StartDate;
      this.$refs.EndDate.value = EndDate;
      // this.$refs.bearer.value = this.token; because API wants this as get
      this.$refs.staticForm.action = this.formAction + '?bearer=' + this.token;
      this.$refs.staticForm.submit();
      this.setCurrentPopup();
      this.hideOverlay();
    },
    setButton: function setButton(btn) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected).forEach(function (a) {
        _this2.selected[a] = btn === a;
      });
    },
    setAllDates: function setAllDates() {
      var dates = this.dates;
      var now = new Date();
      dates.today = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).format(DATE_FORMAT);
      dates.l30d = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(30, 'days').format(DATE_FORMAT);
      dates.l3m = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(3, 'months').format(DATE_FORMAT);
      dates.ytd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(1, 'years').format(DATE_FORMAT);
    },
    isPreset: function isPreset(start, end, dates) {
      if (end !== dates.today) {
        return false;
      }
      switch (start) {
        case dates.l30d:
          return 'l30d';
        case dates.l3m:
          return 'l3m';
        case dates.ytd:
          return 'ytd';
        default:
      }
      return false;
    },
    opened: function opened() {
      // show component overlay
      this.openCalendar = true;
      // hide app overlay
      this.hideOverlay();
    },
    closed: function closed() {
      // hide component overlay
      this.openCalendar = false;
      // show app overlay
      this.showOverlay();
    },
    overlayClick: function overlayClick() {
      // hide component overlay
      this.openCalendar = false;
    },
    fromClick: function fromClick() {
      // datepicker has no refs nor showMethod
      var input = this.$refs.fromDatepicker.$el.querySelector('input');
      input.click();
    },
    toClick: function toClick() {
      // datepicker has no refs
      var input = this.$refs.toDatepicker.$el.querySelector('input');
      input.click();
    }
  }),
  mounted: function mounted() {
    this.setAllDates();
    this.onButtonClick({ name: 'ytd' });
    this.disabled.from = new Date();
  }
});

/***/ }),

/***/ "ZNt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-forgotten"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('p',{staticClass:"account-forgotten__notification"},[_vm._v("\n      Enter your email address to receive a link to reset your password. If you don’t hear from us within 15 minutes, check your spam folder and adjust your filtering to allow emails from PredictIt.\n    ")]),_vm._v(" "),_c('p',{staticClass:"account-forgotten__notification account-forgotten__notification--bottom"},[_vm._v("\n      If you need further assistance, our Support department is here to help you. Please contact us at "),_c('a',{attrs:{"href":("mailto:" + (_vm.systemEmails.support))}},[_vm._v(_vm._s(_vm.systemEmails.support))]),_vm._v(".\n    ")]),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('div',{staticClass:"row-y"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.email,"name":"username","type":"email","placeholder":"Email","autocomplete":"off"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form__section account-forgotten__submit"},[_c('form-submit',{attrs:{"disabled":_vm.resetButtonDisabled,"loading":_vm.isFormDisabled,"label":"Reset my Password"}}),_vm._v(" "),_vm._m(0)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recaptcha-terms"},[_vm._v("\n        Protected by reCAPTCHA ·\n        "),_c('a',{attrs:{"href":"https://policies.google.com/privacy","target":"_blank"}},[_vm._v("Privacy")]),_vm._v("\n        ·\n        "),_c('a',{attrs:{"href":"https://policies.google.com/terms","target":"_blank"}},[_vm._v("Terms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQ/I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZSKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-user-status"},[_c('br'),_vm._v("\n  Window size: "+_vm._s(_vm.getWindowSize())),_c('br'),_vm._v("\n  orientation: "+_vm._s(_vm.getOrientation())),_c('br'),_vm._v("\n  standalone: "+_vm._s(_vm.isStandalone)),_c('br'),_vm._v("\n  iosWrapper: "+_vm._s(_vm.iOSWrapper)),_c('br'),_vm._v("\n  androidWrapper: "+_vm._s(_vm.androidWrapper)),_c('br'),_vm._v("\n  wrapperApp: "+_vm._s(_vm.isWrapperApp)),_c('br'),_vm._v("\n  ios: "+_vm._s(_vm.isIos)),_c('br'),_vm._v("\n  ie: "+_vm._s(_vm.isIE)),_c('br'),_vm._v("\n  edge: "+_vm._s(_vm.isEdge)),_c('br'),_vm._v("\n  tablet: "+_vm._s(_vm.isTablet)),_c('br'),_vm._v("\n  Version: "+_vm._s(_vm.version)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZWR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TAB_INDEX_CREDIT; });
/* unused harmony export TAB_INDEX_PAY_NEAR_ME */
/* unused harmony export TAB_INDEX_COINBASE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TAB_INDEX_ONLINE_BANKING; });
/* unused harmony export TAB_INDEX_PENDING */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_card_add_funds_card_vue__ = __webpack_require__("a3Wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_cash_add_funds_cash_vue__ = __webpack_require__("4OEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__ = __webpack_require__("ircP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_list_deposit_pending_requests_list_deposit_vue__ = __webpack_require__("9rb4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");










var TAB_INDEX_CREDIT = 0;
var TAB_INDEX_PAY_NEAR_ME = 1;
var TAB_INDEX_COINBASE = 2;
var TAB_INDEX_ONLINE_BANKING = 3;
var TAB_INDEX_PENDING = 4;

var GTM_PAGE_NAME = 'deposit';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    addFundsCard: __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_card_add_funds_card_vue__["a" /* default */],
    addFundsCash: __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_cash_add_funds_cash_vue__["a" /* default */],
    addFundsCoinbase: __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__["a" /* default */],
    addFundsBankTransfer: __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["c" /* default */],
    pendingRequests: __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_list_deposit_pending_requests_list_deposit_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showTabs: false,
      tabIndexOrder: [],
      isCashAvailable: false,
      isCryptoAvailable: false,
      isCreditCardAvailable: false,
      isOnlineBankingAvailable: false,
      cryptoDescription: '',
      activeTab: null,
      cardDepositAttempt: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    showBankingTab: function showBankingTab() {
      return this.activeTab === TAB_INDEX_ONLINE_BANKING;
    },
    showCreditCardTab: function showCreditCardTab() {
      return this.activeTab === TAB_INDEX_CREDIT;
    },
    showCashTab: function showCashTab() {
      return this.activeTab === TAB_INDEX_PAY_NEAR_ME;
    },
    showCoinBaseTab: function showCoinBaseTab() {
      return this.activeTab === TAB_INDEX_COINBASE;
    },
    showPendingTab: function showPendingTab() {
      return this.activeTab === TAB_INDEX_PENDING;
    },
    tabs: function tabs() {
      var _this = this;

      var results = [];
      this.tabIndexOrder.forEach(function (v) {
        if (_this.isOnlineBankingAvailable && v === TAB_INDEX_ONLINE_BANKING) {
          results.push({
            name: TAB_INDEX_ONLINE_BANKING,
            title: _this.isLayoutMobile ? 'Online Banking' : 'Online Banking'
          });
        }
        if (_this.isCreditCardAvailable && v === TAB_INDEX_CREDIT) {
          results.push({
            name: TAB_INDEX_CREDIT,
            title: _this.isLayoutMobile ? 'Credit Card' : 'Credit Card'
          });
        }
        if (_this.isCashAvailable && v === TAB_INDEX_PAY_NEAR_ME) {
          results.push({
            name: TAB_INDEX_PAY_NEAR_ME,
            title: 'Cash'
          });
        }
        if (_this.isCryptoAvailable && v === TAB_INDEX_COINBASE) {
          results.push({
            name: TAB_INDEX_COINBASE,
            title: _this.cryptoDesctiption
          });
        }
      });
      results.push({
        name: TAB_INDEX_PENDING,
        title: 'Pending'
      });
      return results;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getDepositMethods']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: this.$route.path + '/' + GTM_PAGE_NAME + '/' + name,
          virtualPageTitle: this.$route.name + ' - ' + GTM_PAGE_NAME + ' - ' + name
        });
      }
    },
    onAddFundsCardSuccess: function onAddFundsCardSuccess() {
      this.cardDepositAttempt += 1;
    }
  }),
  created: function created() {
    var _this2 = this;

    this.loaderAdd(document.body);
    this.getDepositMethods().then(function (data) {
      _this2.showTabs = true;
      _this2.tabIndexOrder = data.tabIndexOrder;
      _this2.isCashAvailable = data.isCashAvailable;
      _this2.isCryptoAvailable = data.isCryptoAvailable;
      _this2.isCreditCardAvailable = data.isCreditCardAvailable;
      _this2.isOnlineBankingAvailable = data.isOnlineBankingAvailable;
      _this2.cryptoDesctiption = data.cryptoDescription || 'USDC';
      _this2.loaderRemove(document.body);
    }).catch(function () {
      return _this2.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "ZdYx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zdfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Zdl7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_static_page_header_js__ = __webpack_require__("+i1c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2a95cb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_static_page_header_vue__ = __webpack_require__("NEEm");
function injectStyle (ssrContext) {
  __webpack_require__("Ynfl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_static_page_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2a95cb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_static_page_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zdym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_account_details_update_account_address_update_vue__ = __webpack_require__("jVeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_account_details_update_account_details_update_vue__ = __webpack_require__("a/AT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_update_password_account_update_password_vue__ = __webpack_require__("mx5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_account_set_password_account_set_password_vue__ = __webpack_require__("s06T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");



var _VERIFICATION_STATUS_;















var ROUTE_DETAILS = 'account-details';
var ROUTE_DETAILS_UPDATE = 'details-update';
var ROUTE_ADDRESS_UPDATE = 'address-update';
var ROUTE_PASS_UPDATE = 'password-update';
var ROUTE_PASS_SET = 'password-set';

var STATUS_NOT_VERIFIED = 0;
var STATUS_BASIC = 1;
var STATUS_IN_PROCESS = 2;
var STATUS_ENHANCED = 3;
var UPLOAD_LINK_SOURCE = 3;

var VERIFICATION_STATUS_MAP = (_VERIFICATION_STATUS_ = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_VERIFICATION_STATUS_, STATUS_NOT_VERIFIED, 'Not Verified'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_VERIFICATION_STATUS_, STATUS_BASIC, 'Basic'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_VERIFICATION_STATUS_, STATUS_IN_PROCESS, 'In Process'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_VERIFICATION_STATUS_, STATUS_ENHANCED, 'Enhanced'), _VERIFICATION_STATUS_);

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_loader__["a" /* default */]],
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_14__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    accountAddressUpdate: __WEBPACK_IMPORTED_MODULE_3__components_account_account_details_update_account_address_update_vue__["a" /* default */],
    accountDetailsUpdate: __WEBPACK_IMPORTED_MODULE_4__components_account_account_details_update_account_details_update_vue__["a" /* default */],
    accountUpdatePassword: __WEBPACK_IMPORTED_MODULE_5__components_account_account_update_password_account_update_password_vue__["a" /* default */],
    accountSetPassword: __WEBPACK_IMPORTED_MODULE_6__components_account_account_set_password_account_set_password_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_7__components_generics_content_header_content_header_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_8__components_account_profile_profile_vue__["a" /* default */],
    notificationIcon: __WEBPACK_IMPORTED_MODULE_11__components_notification_icon_notification_icon_vue__["a" /* default */]
  },
  data: function data() {
    return {
      hasLocalPassword: false,
      documentUploadLink: '',
      STATUS_NOT_VERIFIED: STATUS_NOT_VERIFIED,
      STATUS_BASIC: STATUS_BASIC,
      STATUS_IN_PROCESS: STATUS_IN_PROCESS,
      STATUS_ENHANCED: STATUS_ENHANCED
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Account Details'
    };
  },

  watch: {
    $route: function $route(v) {
      this.triggerPopup(this.isLayoutMobile, v.name);
    },
    isLayoutMobile: function isLayoutMobile() {
      this.triggerPopup(this.isLayoutMobile, this.$route.name);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['userAffiliations', 'isUCAffilSet']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData', 'status']), {
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    },
    isDetailsShown: function isDetailsShown() {
      return !this.isLayoutMobile || this.$route.name === ROUTE_DETAILS;
    },
    isMobileAddressUpdate: function isMobileAddressUpdate() {
      return this.isLayoutMobile && this.$route.name === ROUTE_ADDRESS_UPDATE;
    },
    isMobileDetailsUpdate: function isMobileDetailsUpdate() {
      return this.isLayoutMobile && this.$route.name === ROUTE_DETAILS_UPDATE;
    },
    isMobilePasswordChange: function isMobilePasswordChange() {
      return this.isLayoutMobile && this.$route.name === ROUTE_PASS_UPDATE;
    },
    isMobilePasswordSet: function isMobilePasswordSet() {
      return this.isLayoutMobile && this.$route.name === ROUTE_PASS_SET;
    },
    isUpdateAddressDisabled: function isUpdateAddressDisabled() {
      var idVerified = this.userData.idVerified;
      return typeof idVerified !== 'undefined' ? !idVerified : false;
    },
    title: function title() {
      if (this.isMobilePasswordChange) return 'Change Password';
      if (this.isMobilePasswordSet) return 'Set Password';
      if (this.isMobileAddressUpdate) return 'Change Address';
      if (this.isMobileDetailsUpdate) return 'Change Username';
      return 'Account Details';
    },
    verificationStatusDisplay: function verificationStatusDisplay() {
      var currentStatus = this.userData.verificationStatus;
      return VERIFICATION_STATUS_MAP[currentStatus];
    },
    showVerificationStatusInfo: function showVerificationStatusInfo() {
      var currentStatus = this.userData.verificationStatus;
      return currentStatus !== STATUS_ENHANCED;
    },
    contentHeaderButtonSectionModifiers: function contentHeaderButtonSectionModifiers() {
      return {
        'content-header__section-alt--right': true,
        'content-header__section-alt--right--large-pad': !this.verificationStatusIs(STATUS_ENHANCED) && !this.verificationStatusIs(STATUS_IN_PROCESS)
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getUserAffiliations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getAccountDetail', 'getManageInfo', 'getDocumentUploadLink']), {
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PUBLIC_PROFILE_INFO);
    },
    verificationStatusIs: function verificationStatusIs(target) {
      return this.userData.verificationStatus === target;
    },
    onVerifyIdentity: function onVerifyIdentity() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.showAccountVerifyPopup();
    },
    triggerPopup: function triggerPopup(mobile, $route) {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      if (!mobile) {
        if ($route === ROUTE_ADDRESS_UPDATE) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ADDRESS_UPDATE);
        } else if ($route === ROUTE_DETAILS_UPDATE) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_DETAIL_UPDATE);
        } else if ($route === ROUTE_PASS_UPDATE) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_DETAIL_PASSWORD);
        } else if ($route === ROUTE_PASS_SET) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_DETAIL_PASSWORD_SET);
        } else {
          this.setCurrentPopup();
        }
      } else {
        this.setCurrentPopup();
      }
    },
    onShowVerificationInfo: function onShowVerificationInfo() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_VERIFICATION_INFO);
      this.setCurrentPopupOptions({ verificationStatus: this.userData.verificationStatus });
    },
    onUploadDocuments: function onUploadDocuments() {
      this.getDocumentUploadLink(UPLOAD_LINK_SOURCE).then(function (link) {
        window.location.href = link;
      });
    },
    showAffiliationsPopup: function showAffiliationsPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
      this.setCurrentPopupOptions({ allowClose: true });
    },
    showPhoneUpdatePopup: function showPhoneUpdatePopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PHONE_UPDATE);
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getAccountDetail().then(this.getUserAffiliations).then(this.getManageInfo).then(function (data) {
      _this.loaderRemove(document.body);
      _this.hasLocalPassword = data.hasLocalPassword;
      _this.isComponentReady = true;
    }).catch(function () {
      _this.loaderRemove(document.body);
      _this.isComponentReady = true;
    });

    this.triggerPopup(this.isLayoutMobile, this.$route.name);
  }
});

/***/ }),

/***/ "ZgfQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending-request-deposit"},[_c('div',{staticClass:"pending-request-deposit__card"},[_c('div',{staticClass:"pending-request-deposit__section-title"},[_vm._v("\n      "+_vm._s(_vm.requestTitle)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-deposit__sections"},[_c('div',{staticClass:"pending-request-deposit__section"},[_c('div',{staticClass:"pending-request-deposit__section--left"},[_vm._v("\n          Payment Method\n        ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-deposit__section--right"},[_vm._v("\n          "+_vm._s(_vm.paymentMethod)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"pending-request-deposit__section"},[_c('div',{staticClass:"pending-request-deposit__section--left"},[_vm._v("\n          Deposit Amount\n        ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-deposit__section--right pending-request-deposit__section--right-strong"},[_vm._v("\n          "+_vm._s(_vm.formattedAmount)+"\n        ")])]),_vm._v(" "),(_vm.showAmountReceived)?_c('div',{staticClass:"pending-request-deposit__section"},[_c('div',{staticClass:"pending-request-deposit__section--left"},[_vm._v("\n          Amount Received\n        ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-deposit__section--right"},[_vm._v("\n          "+_vm._s(_vm.formattedAmountReceived)+"\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pending-request-deposit__section"},[_c('div',{staticClass:"pending-request-deposit__section--left"},[_vm._v("\n          Date Created\n        ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-deposit__section--right"},[_vm._v("\n          "+_vm._s(_vm.formattedDate)+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zi8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  props: {
    isNewArrival: {
      type: Boolean,
      default: false
    },
    isTopTrending: {
      type: Boolean,
      default: false
    },
    num: {
      type: Number,
      default: 3
    }
  },
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    var _this = this;

    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        loop: true,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('browse', ['mostPredictedMarkets', 'newArrivalMarkets', 'trendingMarkets']), {
    dummyComponents: function dummyComponents() {
      if (this.isLayoutMobile) return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, 1);
      return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, this.num);
    },
    items: function items() {
      if (this.isNewArrival) {
        return this.newArrivalMarkets;
      }
      if (this.isTopTrending) {
        return this.trendingMarkets;
      }
      return this.mostPredictedMarkets;
    },
    title: function title() {
      if (this.isNewArrival) {
        return 'New Arrivals';
      }
      if (this.isTopTrending) {
        return 'Top Trending';
      }
      return 'Most Predicted';
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === this.num - 1;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--left': true
        // 'most-predicted-list__header-arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--right': true
        // 'most-predicted-list__header-arrow--disabled': this.isNextArrowDisabled,
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getMostPredictedMarkets', 'getNewArrivalMarkets', 'getTrendingMarkets']), {
    prevSlide: function prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      limit: this.num
    };
    var promise = this.getMostPredictedMarkets;

    if (this.isNewArrival) {
      promise = this.getNewArrivalMarkets;
    }

    if (this.isTopTrending) {
      promise = this.getTrendingMarkets;
    }

    this.loaderAdd();

    promise(payload).then(function () {
      _this2.loaderRemove();
      _this2.isComponentReady = true;
    }).catch(function () {
      return _this2.loaderRemove();
    });
  }
});

/***/ }),

/***/ "ZiY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-already-exists-footer"},[_c('h4',{staticClass:"account-already-exists-footer__title"},[_vm._v("\n        Don't have an account?\n      ")]),_vm._v(" "),_c('a',{staticClass:"account-already-exists-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onCreateAccount($event)}}},[_vm._v("\n        Create an Account\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zk72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAVIGATION_TABS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_disqus_disqus_vue__ = __webpack_require__("4EoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_payout_sushi_market_payout_sushi_vue__ = __webpack_require__("12bX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_headerTags__ = __webpack_require__("cgm0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_headerHeight__ = __webpack_require__("GHbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_mutex__ = __webpack_require__("EOu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_sushi_market_discussion_widget_sushi_market_discussion_widget_vue__ = __webpack_require__("LrHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_sushi_market_links_widget_sushi_market_links_widget_vue__ = __webpack_require__("wQqh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_market_market_watch_market_watch_vue__ = __webpack_require__("lkXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_brand_name_brand_name_js__ = __webpack_require__("9IfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_page_market_detail_sushi_pages_sushi_market_charts_sushi_market_charts_vue__ = __webpack_require__("kOSc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pages_page_market_detail_sushi_pages_sushi_market_discussion_sushi_market_discussion_vue__ = __webpack_require__("TtE0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_page_market_detail_sushi_pages_sushi_market_history_sushi_market_history_vue__ = __webpack_require__("5WGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_page_market_detail_sushi_pages_sushi_market_rules_sushi_market_rules_vue__ = __webpack_require__("wFR7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_page_market_detail_sushi_pages_sushi_market_contracts_sushi_market_contracts_vue__ = __webpack_require__("vSY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_pages_page_market_detail_sushi_pages_sushi_market_links_sushi_market_links_vue__ = __webpack_require__("uf7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_pages_page_market_detail_sushi_pages_sushi_market_research_sushi_market_research_vue__ = __webpack_require__("uAZ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pages_page_market_detail_sushi_pages_sushi_market_methodology_sushi_market_methodology_vue__ = __webpack_require__("NHsJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_market_v2_market_alert_v2_market_alert_v2_vue__ = __webpack_require__("eLZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_market_v2_market_site_alert_v2_market_site_alert_v2_vue__ = __webpack_require__("G+2P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__ = __webpack_require__("X4WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_purchase_sushi_purchase_offer_sushi_mobile_bar_purchase_offer_sushi_mobile_bar_vue__ = __webpack_require__("otBS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__store_modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__store__ = __webpack_require__("IcnI");






/* eslint-disable */






































var DEFAULT_PAGE_TITLE = __WEBPACK_IMPORTED_MODULE_21__components_brand_name_brand_name_js__["a" /* BRAND */];

var NAVIGATION_TABS = {
  CONTRACTS: 'contracts',
  RESEARCH: 'research',
  METHODOLOGY: 'methodology',
  RULES: 'rules',
  CHARTS: 'charts',
  HISTORY: 'history',
  DISCUSSION: 'discussion',
  LINKS: 'links'
};

var ROUTE_DRIVEN_TABS = [NAVIGATION_TABS.CONTRACTS, NAVIGATION_TABS.RESEARCH, NAVIGATION_TABS.METHODOLOGY, NAVIGATION_TABS.RULES, NAVIGATION_TABS.CHARTS, NAVIGATION_TABS.HISTORY, NAVIGATION_TABS.DISCUSSION, NAVIGATION_TABS.LINKS];

var AUTH_REQUIRING_TABS = [NAVIGATION_TABS.HISTORY, NAVIGATION_TABS.LINKS];

function resolveActiveTab(tab) {
  if (!ROUTE_DRIVEN_TABS.includes(tab)) {
    return NAVIGATION_TABS.CONTRACTS;
  }
  if (AUTH_REQUIRING_TABS.includes(tab) && !__WEBPACK_IMPORTED_MODULE_41__store__["a" /* default */].getters['user/isLoggedIn']) {
    return NAVIGATION_TABS.CONTRACTS;
  }
  return ROUTE_DRIVEN_TABS.includes(tab) ? tab : NAVIGATION_TABS.CONTRACTS;
}

function buildDiscussionQuery(query) {
  var commentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var commentThreadId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var nextQuery = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, query, {
    tab: NAVIGATION_TABS.DISCUSSION
  });

  if (Number(commentThreadId) > 0) {
    nextQuery.commentThreadId = Number(commentThreadId);
  } else {
    delete nextQuery.commentThreadId;
  }

  if (commentId) {
    nextQuery.commentId = commentId;
  } else {
    delete nextQuery.commentId;
  }

  return nextQuery;
}

function buildTabQuery(query, tab) {
  var nextQuery = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, query);

  delete nextQuery.commentThreadId;
  delete nextQuery.commentId;

  if (tab && tab !== NAVIGATION_TABS.CONTRACTS) {
    nextQuery.tab = tab;
  } else {
    delete nextQuery.tab;
  }

  return nextQuery;
}

function buildCommentHash() {
  var commentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return commentId ? '#comment-' + commentId : '';
}

function normalizeCommentThreadId(commentThreadId) {
  var normalized = Number(commentThreadId);

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite___default()(normalized) && normalized > 0 ? normalized : 0;
}

function resolveRouteMarketId(route) {
  return Number(route && route.params ? route.params.marketId : 0);
}

function resolveDiscussionCommentId(route) {
  if (route && route.query && route.query.commentId) {
    return route.query.commentId;
  }

  if (route && route.hash && route.hash.indexOf('#comment-') === 0) {
    return route.hash.replace('#comment-', '');
  }

  return '';
}

function getCurrentLocationQuery() {
  var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["I" /* parseQuery */])(window.location.search || '');

  delete query[''];

  return query;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_headerTags__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_headerHeight__["a" /* default */], __WEBPACK_IMPORTED_MODULE_32__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_33__mixins_contentLoader__["a" /* default */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_9__components_generics_alert_box_alert_box_vue__["a" /* default */],
    disqus: __WEBPACK_IMPORTED_MODULE_7__components_disqus_disqus_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__["a" /* default */],
    sushiMarketDiscussionWidget: __WEBPACK_IMPORTED_MODULE_17__components_sushi_market_discussion_widget_sushi_market_discussion_widget_vue__["a" /* default */],
    sushiMarketLinksWidget: __WEBPACK_IMPORTED_MODULE_18__components_sushi_market_links_widget_sushi_market_links_widget_vue__["a" /* default */],
    marketPayoutSushi: __WEBPACK_IMPORTED_MODULE_8__components_market_market_payout_sushi_market_payout_sushi_vue__["a" /* default */],
    marketWatch: __WEBPACK_IMPORTED_MODULE_19__components_market_market_watch_market_watch_vue__["a" /* default */],
    pageSushiMarketCharts: __WEBPACK_IMPORTED_MODULE_22__components_pages_page_market_detail_sushi_pages_sushi_market_charts_sushi_market_charts_vue__["a" /* default */],
    pageSushiMarketDiscussion: __WEBPACK_IMPORTED_MODULE_23__components_pages_page_market_detail_sushi_pages_sushi_market_discussion_sushi_market_discussion_vue__["a" /* default */],
    pageSushiMarketHistory: __WEBPACK_IMPORTED_MODULE_24__components_pages_page_market_detail_sushi_pages_sushi_market_history_sushi_market_history_vue__["a" /* default */],
    pageSushiMarketRules: __WEBPACK_IMPORTED_MODULE_25__components_pages_page_market_detail_sushi_pages_sushi_market_rules_sushi_market_rules_vue__["a" /* default */],
    pageSushiMarketContracts: __WEBPACK_IMPORTED_MODULE_26__components_pages_page_market_detail_sushi_pages_sushi_market_contracts_sushi_market_contracts_vue__["a" /* default */],
    pageSushiMarketLinks: __WEBPACK_IMPORTED_MODULE_27__components_pages_page_market_detail_sushi_pages_sushi_market_links_sushi_market_links_vue__["a" /* default */],
    pageSushiMarketResearch: __WEBPACK_IMPORTED_MODULE_28__components_pages_page_market_detail_sushi_pages_sushi_market_research_sushi_market_research_vue__["a" /* default */],
    pageSushiMarketMethodology: __WEBPACK_IMPORTED_MODULE_29__components_pages_page_market_detail_sushi_pages_sushi_market_methodology_sushi_market_methodology_vue__["a" /* default */],
    marketAlertV2: __WEBPACK_IMPORTED_MODULE_30__components_market_v2_market_alert_v2_market_alert_v2_vue__["a" /* default */],
    marketSiteAlertV2: __WEBPACK_IMPORTED_MODULE_31__components_market_v2_market_site_alert_v2_market_site_alert_v2_vue__["a" /* default */],
    marketCharts: __WEBPACK_IMPORTED_MODULE_34__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */],
    purchaseOfferSushiMobileBar: __WEBPACK_IMPORTED_MODULE_38__components_purchase_sushi_purchase_offer_sushi_mobile_bar_purchase_offer_sushi_mobile_bar_vue__["a" /* default */]
  },
  props: {
    showRules: {
      type: Boolean,
      default: false
    },
    marketId: {
      type: Number,
      required: true
    },
    prerendered: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      NAVIGATION_TABS: NAVIGATION_TABS,
      titleHovered: false,
      stickyObserver: null,
      onScroll: null,
      stickyScrollAnimationFrame: null,
      contentResizeObserver: null,
      desktopStickyTitleHeight: 0,
      desktopContentMinHeight: 0,
      mobileContentMinHeight: 0,
      mobileContentHeightReleaseTimer: null,
      mobileContentHeightReleaseAnimationFrame: null,
      discussionWidgetRouteSwap: 1,
      isResetting: false,
      showAllContracts: false,
      activeTab: resolveActiveTab(this.$route.query.tab),
      requestedDiscussionCommentId: resolveDiscussionCommentId(this.$route),
      requestedDiscussionCommentThreadId: normalizeCommentThreadId(this.$route.query.commentThreadId),
      showHistory: false,
      toolbarTabsCanScrollLeft: false,
      toolbarTabsCanScrollRight: false,
      toolbarTabsResizeObserver: null,
      hideMainChart: false,
      isTitleSticky: false,
      initialised: false,
      reloading: false,
      tabScrollPositions: {}
    };
  },
  metaInfo: function metaInfo() {
    if (this.market && this.market.marketId) {
      return {
        title: this.market.seoTitle,
        link: [{ rel: 'canonical', href: '' + window.location.href }],
        meta: [{ name: 'description', content: this.market.seoDescription }, { itemprop: 'name', content: this.market.seoTitle }, { itemprop: 'description', content: this.market.seoDescription }, { itemprop: 'image', content: this.market.imageName }, { property: 'og:title', content: this.market.seoTitle }, { property: 'og:type', content: 'article' }, { property: 'og:image', content: this.market.imageName }, { property: 'og:description', content: this.market.seoDescription }, { property: 'og:site_name', content: __WEBPACK_IMPORTED_MODULE_21__components_brand_name_brand_name_js__["a" /* BRAND */] }, { property: 'og:url', content: '' + window.location.href }]
      };
    }
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'isCommentEnabled', 'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance', 'isPinningEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['previousRoute', 'settingShowOdds']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('market', ['market', 'contracts', 'marketLoadError', 'marketIsEngineBusy', 'marketIsEngineBusyMessage', 'isDiscussionPinned']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'bottomBetslipExtended', 'bottomWidgetFooterMode', 'bottomWidgetFooterModeContractsSection', 'hasStoredBottomWidgetFooterModePreference']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('notifications', ['lastConfirmedContractData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('user', ['status']), {
    isShortcutWidgetVisible: function isShortcutWidgetVisible() {
      return this.market !== null && !!this.market.marketId && !this.isMarketDisabled && this.initialised && !this.isResetting && this.isLayoutMobile && this.activeTab !== NAVIGATION_TABS.CONTRACTS;
    },
    displayedMarketName: function displayedMarketName() {
      if (!this.market) {
        return '';
      }

      return this.isTitleSticky ? this.pinnedMarketName : this.market.marketName;
    },
    pinnedMarketName: function pinnedMarketName() {
      if (!this.market) {
        return '';
      }

      return this.market.marketShortName || this.market.marketName;
    },
    desktopStickyTitleOffset: function desktopStickyTitleOffset() {
      if (!this.isLayoutDesktop || !this.isTitleSticky) {
        return 0;
      }

      // Desktop stacks the sticky short title above the tabs, so the toolbar
      // always needs the final rendered title height and not just the header.
      if (this.desktopStickyTitleHeight > 0) {
        return this.desktopStickyTitleHeight;
      }

      var $stickyTitle = document.querySelector('.page-market-detail-sushi__title--is-sticky');

      return $stickyTitle ? $stickyTitle.offsetHeight : 0;
    },
    toolbarStyleModifiers: function toolbarStyleModifiers() {
      return {
        top: this.headerHeight + this.desktopStickyTitleOffset + 'px'
      };
    },
    contentStyleModifiers: function contentStyleModifiers() {
      var contentMinHeight = this.isLayoutDesktop ? this.desktopContentMinHeight : this.mobileContentMinHeight;

      if (!contentMinHeight) {
        return {};
      }

      return {
        minHeight: contentMinHeight + 'px'
      };
    },
    titleStyleModifiers: function titleStyleModifiers() {
      if (this.isLayoutMobile && !this.isMarketDisabled) {
        return {
          top: this.headerHeight + 'px'
        };
      }

      if (!this.isTitleSticky) {
        return {};
      }
      return {
        top: this.headerHeight + 'px'
      };
    },
    showStickyTitleSummary: function showStickyTitleSummary() {
      return this.isTitleSticky && this.isPayoutAvailable;
    },
    isExpandedMobileBetslipActive: function isExpandedMobileBetslipActive() {
      return this.isLayoutMobile && this.bottomWidgetFooterMode === __WEBPACK_IMPORTED_MODULE_39__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP && this.bottomBetslipExtended;
    },
    stickyUserGainLoss: function stickyUserGainLoss() {
      if (!this.market) {
        return 0;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["J" /* marketUserGainLoss */])(this.market);
    },
    stickyUserGainLossNormalized: function stickyUserGainLossNormalized() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["h" /* roundToTwo */])(this.stickyUserGainLoss) === 0 ? 0 : this.stickyUserGainLoss;
    },
    stickyUserGainLossLabel: function stickyUserGainLossLabel() {
      if (this.stickyUserGainLossNormalized > 0) {
        return 'Gain';
      }

      return this.stickyUserGainLossNormalized < 0 ? 'Loss' : 'Gain/Loss';
    },
    showDesktopTitlePayout: function showDesktopTitlePayout() {
      return this.isPayoutAvailable && this.isLayoutDesktop && !this.isTitleSticky;
    },
    showDesktopTitleWatch: function showDesktopTitleWatch() {
      return this.isLayoutDesktop && this.watchIconVisible;
    },
    showMobileTitleWatch: function showMobileTitleWatch() {
      return this.isLayoutMobile && this.watchIconVisible;
    },
    newMarketBarDescription: function newMarketBarDescription() {
      return this.isLayoutDesktop ? 'Orderbooks and features may be limited.' : 'Features may be limited.';
    },
    watchIconVisible: function watchIconVisible() {
      var statuses = [__WEBPACK_IMPORTED_MODULE_20__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* default */].MARKET_SETTLED];
      return this.isLoggedIn && !statuses.includes(this.market.status);
    },
    discussionWidgetKey: function discussionWidgetKey() {
      return 'market--' + this.discussionWidgetRouteSwap.toString();
    },
    navigationTabs: function navigationTabs() {
      var results = [{
        name: NAVIGATION_TABS.CONTRACTS,
        title: 'Contracts'
      }];

      // results = [
      //   ...results,
      //   {
      //     name: NAVIGATION_TABS.CHARTS,
      //     title: 'Charts',
      //   },
      // ]

      results = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(results), [{
        name: NAVIGATION_TABS.DISCUSSION,
        title: 'Discussion'
      }, {
        name: NAVIGATION_TABS.RULES,
        title: 'Rules',
        meta: {
          numRuleComments: this.market ? this.market.numRuleComments : 0
        }
      }]);

      if (this.isLoggedIn) {
        results = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(results), [{
          name: NAVIGATION_TABS.HISTORY,
          title: 'History'
        }, {
          name: NAVIGATION_TABS.LINKS,
          title: 'Lists'
        }]);
      }

      return results;
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    isPayoutAvailable: function isPayoutAvailable() {
      return this.isLoggedIn && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["K" /* hasMarketPayout */])(this.market) && !this.isMarketSettled;
    },
    isAllPayoutsAvailable: function isAllPayoutsAvailable() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    title: function title() {
      return 'Market details for ' + this.market.symbol + '--' + this.market.marketId;
    },
    showEngineBusyNotification: function showEngineBusyNotification() {
      return this.market.isEngineBusy && this.market.isEngineBusyMessage || this.marketIsEngineBusy && this.marketIsEngineBusyMessage;
    },
    engineBusyNotificationContent: function engineBusyNotificationContent() {
      return this.market.isEngineBusyMessage || this.marketIsEngineBusyMessage;
    },
    ogImageSrc: function ogImageSrc() {
      return this.prerendered !== '' && this.market && this.market.imageName;
    },
    showEconomicIndicator: function showEconomicIndicator() {
      return [2, 3, 4].includes(this.market.econIndicatorTradeStatus);
    },
    showDiscussionWidget: function showDiscussionWidget() {
      return this.isPinningEnabled && this.isLoggedIn && this.isDiscussionPinned && this.isCommentEnabled;
    },
    showMarketLinksWidget: function showMarketLinksWidget() {
      return this.isPinningEnabled && this.isLoggedIn;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('insight', ['getMarketFeeds']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('market', ['getMarket', 'clearMarket', 'clearMarketEngineBusyMessage', 'getMarketContractsStats']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setTradePopup', 'setGenericPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'setTradePrice', 'setTradeQuantity', 'clearOrderBook', 'setBottomBetSlipExtendedMode', 'toggleHidePurchaseForContractId', 'setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection']), {
    isMarketDetailPath: function isMarketDetailPath() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return typeof path === 'string' && path.indexOf('/markets/detail/') === 0;
    },
    shouldPreserveMobileFooterMode: function shouldPreserveMobileFooterMode() {
      var fromRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (fromRoute && fromRoute.name === 'market-details') {
        return true;
      }

      return this.isMarketDetailPath(this.previousRoute);
    },
    applyDefaultMobileFooterMode: function applyDefaultMobileFooterMode() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$fromRoute = _ref.fromRoute,
          fromRoute = _ref$fromRoute === undefined ? null : _ref$fromRoute;

      if (!this.isLayoutMobile) {
        return;
      }

      this.setBottomBetSlipExtendedMode(false);

      if (!this.hasStoredBottomWidgetFooterModePreference && !this.shouldPreserveMobileFooterMode(fromRoute)) {
        this.setBottomWidgetFooterModeContractsSection(__WEBPACK_IMPORTED_MODULE_39__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH);
      }

      if (this.activeTab === NAVIGATION_TABS.CONTRACTS) {
        this.setBottomWidgetFooterMode(this.bottomWidgetFooterModeContractsSection);
        return;
      }

      this.setBottomWidgetFooterMode(__WEBPACK_IMPORTED_MODULE_39__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH);
    },
    destroyStickyTracking: function destroyStickyTracking() {
      if (this.stickyObserver) {
        this.stickyObserver.disconnect();
        this.stickyObserver = null;
      }

      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        this.onScroll = null;
      }

      if (this.stickyScrollAnimationFrame && window.cancelAnimationFrame) {
        window.cancelAnimationFrame(this.stickyScrollAnimationFrame);
        this.stickyScrollAnimationFrame = null;
      }

      this.desktopStickyTitleHeight = 0;
    },
    destroyDesktopContentHeightTracking: function destroyDesktopContentHeightTracking() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$resetHeight = _ref2.resetHeight,
          resetHeight = _ref2$resetHeight === undefined ? false : _ref2$resetHeight;

      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }

      if (resetHeight) {
        this.desktopContentMinHeight = 0;
      }
    },
    cancelMobileContentHeightRelease: function cancelMobileContentHeightRelease() {
      if (this.mobileContentHeightReleaseTimer) {
        window.clearTimeout(this.mobileContentHeightReleaseTimer);
        this.mobileContentHeightReleaseTimer = null;
      }

      if (this.mobileContentHeightReleaseAnimationFrame) {
        window.cancelAnimationFrame(this.mobileContentHeightReleaseAnimationFrame);
        this.mobileContentHeightReleaseAnimationFrame = null;
      }
    },
    destroyMobileContentHeightLock: function destroyMobileContentHeightLock() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$resetHeight = _ref3.resetHeight,
          resetHeight = _ref3$resetHeight === undefined ? false : _ref3$resetHeight;

      this.cancelMobileContentHeightRelease();

      if (resetHeight) {
        this.mobileContentMinHeight = 0;
      }
    },
    getToolbarTabsScroller: function getToolbarTabsScroller() {
      if (!this.$refs.toolbarTabs) {
        return null;
      }

      return this.$refs.toolbarTabs.querySelector('.tabs');
    },
    initToolbarTabsScrollTracking: function initToolbarTabsScrollTracking() {
      var _this = this;

      this.destroyToolbarTabsScrollTracking();
      this.$nextTick(function () {
        var $tabs = _this.getToolbarTabsScroller();

        if (!$tabs) {
          _this.refreshToolbarTabsScrollState();
          return;
        }

        $tabs.addEventListener('scroll', _this.refreshToolbarTabsScrollState, { passive: true });

        if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
          _this.toolbarTabsResizeObserver = new ResizeObserver(_this.refreshToolbarTabsScrollState);
          _this.toolbarTabsResizeObserver.observe($tabs);
        }

        _this.refreshToolbarTabsScrollState();
        _this.scheduleToolbarTabIntoView(_this.activeTab);
      });
    },
    destroyToolbarTabsScrollTracking: function destroyToolbarTabsScrollTracking() {
      var $tabs = this.getToolbarTabsScroller();

      if ($tabs) {
        $tabs.removeEventListener('scroll', this.refreshToolbarTabsScrollState);
      }

      if (this.toolbarTabsResizeObserver) {
        this.toolbarTabsResizeObserver.disconnect();
        this.toolbarTabsResizeObserver = null;
      }
    },
    refreshToolbarTabsScrollState: function refreshToolbarTabsScrollState() {
      var $tabs = this.getToolbarTabsScroller();

      if (!this.isLayoutMobile || !$tabs) {
        this.toolbarTabsCanScrollLeft = false;
        this.toolbarTabsCanScrollRight = false;
        return;
      }

      var maxScrollLeft = Math.max(0, $tabs.scrollWidth - $tabs.clientWidth);
      var $firstTab = $tabs.querySelector('.tabs__item:first-child');
      var $lastTab = $tabs.querySelector('.tabs__item:last-of-type');
      var tabsRect = $tabs.getBoundingClientRect();
      var firstTabRect = $firstTab ? $firstTab.getBoundingClientRect() : null;
      var lastTabRect = $lastTab ? $lastTab.getBoundingClientRect() : null;

      this.toolbarTabsCanScrollLeft = maxScrollLeft > 1 && firstTabRect && firstTabRect.left < tabsRect.left - 1;
      this.toolbarTabsCanScrollRight = maxScrollLeft > 1 && lastTabRect && lastTabRect.right > tabsRect.right + 1;
    },
    scrollToolbarTabs: function scrollToolbarTabs(direction) {
      var $tabs = this.getToolbarTabsScroller();

      if (!$tabs) {
        return;
      }

      var distance = Math.max(120, Math.floor($tabs.clientWidth * 0.8));
      var left = $tabs.scrollLeft + distance * direction;

      if (typeof $tabs.scrollTo === 'function') {
        $tabs.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        $tabs.scrollLeft = left;
      }

      window.setTimeout(this.refreshToolbarTabsScrollState, 250);
    },
    scheduleToolbarTabIntoView: function scheduleToolbarTabIntoView() {
      var _this2 = this;

      var tabName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.activeTab;

      if (!this.isLayoutMobile || !tabName) {
        return;
      }

      this.$nextTick(function () {
        _this2.scrollToolbarTabIntoView(tabName);

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            _this2.scrollToolbarTabIntoView(tabName);
          });
        }

        window.setTimeout(function () {
          _this2.scrollToolbarTabIntoView(tabName);
        }, 150);
      });
    },
    scrollToolbarTabIntoView: function scrollToolbarTabIntoView(tabName) {
      if (!this.isLayoutMobile || !tabName) {
        return;
      }

      var $tabs = this.getToolbarTabsScroller();

      if (!$tabs) {
        return;
      }

      var $tab = $tabs.querySelector('.tabs__link-name-' + tabName);

      if (!$tab) {
        return;
      }

      var tabsRect = $tabs.getBoundingClientRect();
      var tabRect = $tab.getBoundingClientRect();
      var maxScrollLeft = Math.max(0, $tabs.scrollWidth - $tabs.clientWidth);
      var scrollButtonWidth = 28;
      var scrollButtonBuffer = 8;
      var overlaySafeWidth = scrollButtonWidth + scrollButtonBuffer;
      var visibleLeft = tabsRect.left + ($tabs.scrollLeft > 1 ? overlaySafeWidth : 0);
      var visibleRight = tabsRect.right - ($tabs.scrollLeft < maxScrollLeft - 1 ? overlaySafeWidth : 0);
      var leftOverflow = tabRect.left - visibleLeft;
      var rightOverflow = tabRect.right - visibleRight;
      var nextScrollLeft = $tabs.scrollLeft;

      if (leftOverflow < 0) {
        nextScrollLeft += leftOverflow;
      } else if (rightOverflow > 0) {
        nextScrollLeft += rightOverflow;
      } else {
        this.refreshToolbarTabsScrollState();
        return;
      }

      nextScrollLeft = Math.max(0, Math.min(nextScrollLeft, maxScrollLeft));

      if (typeof $tabs.scrollTo === 'function') {
        $tabs.scrollTo({ left: nextScrollLeft, behavior: 'smooth' });
      } else {
        $tabs.scrollLeft = nextScrollLeft;
      }

      window.setTimeout(this.refreshToolbarTabsScrollState, 250);
    },
    captureDesktopContentHeight: function captureDesktopContentHeight() {
      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      this.desktopContentMinHeight = this.$refs.marketContent.offsetHeight;
    },
    captureMobileContentHeight: function captureMobileContentHeight() {
      if (!this.isLayoutMobile || !this.$refs.marketContent) {
        return;
      }

      this.cancelMobileContentHeightRelease();

      var currentHeight = this.$refs.marketContent.offsetHeight;
      var minHeightToPreventClamp = this.resolveContentMinHeight();

      this.mobileContentMinHeight = Math.ceil(Math.max(currentHeight, minHeightToPreventClamp));
    },
    getNaturalContentHeight: function getNaturalContentHeight() {
      if (!this.$refs.marketContent || !this.$refs.marketContentInner) {
        return 0;
      }

      var styles = window.getComputedStyle(this.$refs.marketContent);
      var verticalChrome = parseFloat(styles.paddingTop || 0) + parseFloat(styles.paddingBottom || 0) + parseFloat(styles.borderTopWidth || 0) + parseFloat(styles.borderBottomWidth || 0);

      return Math.ceil(this.$refs.marketContentInner.offsetHeight + verticalChrome);
    },
    resolveContentMinHeight: function resolveContentMinHeight() {
      if (!this.$refs.marketContent) {
        return 0;
      }

      var naturalHeight = this.getNaturalContentHeight();
      var scrollTop = window.pageYOffset || window.scrollY || 0;
      var contentTop = this.$refs.marketContent.getBoundingClientRect().top + scrollTop;
      var currentHeight = this.$refs.marketContent.offsetHeight;
      var documentHeight = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
      var chromeBelowContent = Math.max(0, documentHeight - contentTop - currentHeight);
      var viewportBottom = scrollTop + window.innerHeight;
      // The page shell needs this temporary min-height so tab swaps do not clamp the document
      // while the next panel is mounting and the scroll position is being restored.
      var minHeightToPreventClamp = Math.max(0, viewportBottom - contentTop - chromeBelowContent);

      return Math.ceil(Math.max(naturalHeight, minHeightToPreventClamp));
    },
    syncDesktopContentMinHeight: function syncDesktopContentMinHeight() {
      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      var nextHeight = this.resolveContentMinHeight();

      if (nextHeight > 0 && nextHeight !== this.desktopContentMinHeight) {
        this.desktopContentMinHeight = nextHeight;
      }
    },
    refreshDesktopContentHeightTracking: function refreshDesktopContentHeightTracking() {
      var _this3 = this;

      if (this.isResetting) {
        return;
      }

      this.$nextTick(function () {
        if (!_this3.isLayoutDesktop || !_this3.$refs.marketContent || !_this3.$refs.marketContentInner) {
          _this3.destroyDesktopContentHeightTracking({ resetHeight: true });
          return;
        }

        _this3.syncDesktopContentMinHeight();

        if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
          _this3.destroyDesktopContentHeightTracking();
          _this3.contentResizeObserver = new ResizeObserver(function () {
            _this3.syncDesktopContentMinHeight();
          });
          _this3.contentResizeObserver.observe(_this3.$refs.marketContentInner);
        }

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            _this3.syncDesktopContentMinHeight();
          });
        }
      });
    },
    isDesktopToolbarPinned: function isDesktopToolbarPinned() {
      if (!this.isLayoutDesktop) {
        return false;
      }

      var $toolbar = this.$el ? this.$el.querySelector('.page-market-detail-sushi__toolbar') : null;
      if (!$toolbar) {
        return false;
      }

      var stickyTop = this.headerHeight + this.desktopStickyTitleOffset;
      var toolbarTop = $toolbar.getBoundingClientRect().top;

      return toolbarTop <= stickyTop + 1;
    },
    resetDesktopTabContentScroll: function resetDesktopTabContentScroll() {
      var _this4 = this;

      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      var $toolbar = this.$el ? this.$el.querySelector('.page-market-detail-sushi__toolbar') : null;
      if (!$toolbar) {
        return;
      }

      var toolbarBottom = $toolbar.getBoundingClientRect().bottom;
      var scrollTop = window.pageYOffset || window.scrollY || 0;
      var contentTop = this.$refs.marketContent.getBoundingClientRect().top + scrollTop;
      var nextScrollTop = Math.max(0, Math.ceil(contentTop - toolbarBottom));

      // Once the desktop tabs are pinned, reset the new tab back to its own top instead of inheriting a deep scroll from the last tab.
      window.scrollTo(0, nextScrollTop);

      if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
        window.requestAnimationFrame(function () {
          _this4.syncDesktopContentMinHeight();
        });
        return;
      }

      this.syncDesktopContentMinHeight();
    },
    isMobileToolbarVisible: function isMobileToolbarVisible() {
      if (!this.isLayoutMobile || !this.$el) {
        return false;
      }

      var $toolbar = this.$el.querySelector('.page-market-detail-sushi__toolbar');
      if (!$toolbar) {
        return false;
      }

      var toolbarRect = $toolbar.getBoundingClientRect();

      return toolbarRect.bottom > this.headerHeight && toolbarRect.top < window.innerHeight;
    },
    scheduleMobileContentHeightRelease: function scheduleMobileContentHeightRelease() {
      var _this5 = this;

      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$delay = _ref4.delay,
          delay = _ref4$delay === undefined ? 0 : _ref4$delay;

      var release = function release() {
        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          _this5.mobileContentHeightReleaseAnimationFrame = window.requestAnimationFrame(function () {
            _this5.mobileContentHeightReleaseAnimationFrame = window.requestAnimationFrame(function () {
              _this5.mobileContentHeightReleaseAnimationFrame = null;
              _this5.mobileContentMinHeight = 0;
            });
          });
          return;
        }

        _this5.mobileContentMinHeight = 0;
      };

      this.cancelMobileContentHeightRelease();

      if (delay > 0) {
        this.mobileContentHeightReleaseTimer = window.setTimeout(function () {
          _this5.mobileContentHeightReleaseTimer = null;
          release();
        }, delay);
        return;
      }

      release();
    },
    restoreMobileTabContentScroll: function restoreMobileTabContentScroll(tab) {
      var _this6 = this;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$preserveToolbar = _ref5.preserveToolbarPosition,
          preserveToolbarPosition = _ref5$preserveToolbar === undefined ? false : _ref5$preserveToolbar;

      if (!this.isLayoutMobile || !this.$refs.marketContent) {
        this.destroyMobileContentHeightLock({ resetHeight: true });
        return;
      }

      if (preserveToolbarPosition) {
        this.scheduleMobileContentHeightRelease({ delay: 400 });
        return;
      }

      var topOffset = this.headerHeight;

      if (this.$refs.marketTitle) {
        topOffset += this.$refs.marketTitle.offsetHeight;
      }

      if (this.tabScrollPositions[tab] !== undefined) {
        __WEBPACK_IMPORTED_MODULE_40__logger__["a" /* default */].info('Scrolling to last position for ' + tab);
        window.scrollTo(0, this.tabScrollPositions[tab]);
        this.scheduleMobileContentHeightRelease();
        return;
      }

      this.scheduleMobileContentHeightRelease({ delay: 400 });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_scrollTo__["a" /* default */])(this.$refs.marketContent, 250, 'linear', null, topOffset, function () {
        _this6.scheduleMobileContentHeightRelease();
      });
    },
    syncDesktopStickyTitleHeight: function syncDesktopStickyTitleHeight() {
      if (!this.isLayoutDesktop || !this.isTitleSticky || !this.$refs.marketTitle) {
        this.desktopStickyTitleHeight = 0;
        return;
      }

      this.desktopStickyTitleHeight = this.$refs.marketTitle.offsetHeight;
    },
    getPageScrollTop: function getPageScrollTop() {
      var scrollTop = window.pageYOffset || window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

      if (this.isLayoutMobile && this.bottomBetslipExtended && document.body.style.position === 'fixed' && document.body.style.top) {
        var lockedScrollTop = parseInt(document.body.style.top, 10);

        if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(lockedScrollTop)) {
          scrollTop = Math.abs(lockedScrollTop);
        }
      }

      return scrollTop;
    },
    isAtPageTop: function isAtPageTop() {
      var scrollTop = this.getPageScrollTop();

      return scrollTop <= 1;
    },
    scheduleStickyTitleStateUpdate: function scheduleStickyTitleStateUpdate() {
      var _this7 = this;

      this.$nextTick(function () {
        var update = function update() {
          _this7.updateTitleStickyState();
        };

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(update);
          return;
        }

        update();
      });
    },
    updateTitleStickyState: function updateTitleStickyState() {
      var stickySentinelTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.isLayoutMobile && this.isAtPageTop()) {
        this.isTitleSticky = false;
        return;
      }

      if (stickySentinelTop === null) {
        if (!this.$refs.stickySentinel) {
          this.isTitleSticky = false;
          return;
        }

        stickySentinelTop = this.$refs.stickySentinel.getBoundingClientRect().top;
      }

      this.isTitleSticky = !this.isMarketDisabled && stickySentinelTop <= this.headerHeight;
    },
    refreshStickyObserver: function refreshStickyObserver() {
      var _this8 = this;

      if (this.isResetting) {
        return;
      }

      this.$nextTick(function () {
        _this8.initStickyObserver();
      });
    },
    initStickyObserver: function initStickyObserver() {
      var _this9 = this;

      this.destroyStickyTracking();

      if (!this.$refs.stickySentinel) {
        this.isTitleSticky = false;
        return;
      }

      var useScrollFallback = this.isLayoutMobile || !('IntersectionObserver' in window);
      if (useScrollFallback) {
        this.initScrollFallback();
      }

      if (!('IntersectionObserver' in window)) {
        this.updateTitleStickyState();
        return;
      }

      this.stickyObserver = new IntersectionObserver(function (_ref6) {
        var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref6, 1),
            entry = _ref7[0];

        _this9.updateTitleStickyState(entry.boundingClientRect.top);
      }, {
        rootMargin: '-' + this.headerHeight + 'px 0px 0px 0px',
        threshold: [0]
      });

      this.stickyObserver.observe(this.$refs.stickySentinel);
      this.updateTitleStickyState();
    },
    initScrollFallback: function initScrollFallback() {
      var _this10 = this;

      this.onScroll = function () {
        if (_this10.stickyScrollAnimationFrame) {
          return;
        }

        if (!window.requestAnimationFrame) {
          _this10.updateTitleStickyState();
          return;
        }

        _this10.stickyScrollAnimationFrame = window.requestAnimationFrame(function () {
          _this10.stickyScrollAnimationFrame = null;
          _this10.updateTitleStickyState();
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
    },
    onWatchToggle: function onWatchToggle() {
      this.retrieveMarketData({ marketId: this.marketId, clearOrderBook: false, clearMarket: true, loader: false });
    },
    onTitleMouseOver: function onTitleMouseOver() {
      this.titleHovered = true;
    },
    onTitleMouseLeave: function onTitleMouseLeave() {
      this.titleHovered = false;
    },
    openNewMarketStats: function openNewMarketStats() {
      var _this11 = this;

      this.loaderAdd(document.body);
      this.getMarketContractsStats(this.market.marketId).then(function (data) {
        _this11.loaderRemove(document.body);
        if (!data) {
          return;
        }
        _this11.setGenericPopup({
          name: __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].MARKET_CONTRACT_STATS,
          options: {
            stats: data,
            isFixed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["q" /* hasMarketHiddenContracts */])(_this11.market)
          }
        });
      }).catch(function () {
        return _this11.loaderRemove(document.body);
      });
    },
    openPotentialPayouts: function openPotentialPayouts() {
      this.setGenericPopup({
        name: __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].POTENTIAL_PAYOUTS,
        options: {
          market: this.market
        }
      });
    },
    syncDiscussionLocation: function syncDiscussionLocation() {
      var commentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var commentThreadId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var currentQuery = getCurrentLocationQuery();
      var resolvedRoute = this.$router.resolve({
        name: this.$route.name,
        params: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.$route.params, {
          dontReload: true
        }),
        query: buildDiscussionQuery(currentQuery, commentId, commentThreadId),
        hash: buildCommentHash(commentId)
      });

      // Keep Disqus-only state out of Vue Router so the routed page shell does not remount.
      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
    },
    syncTabLocation: function syncTabLocation(tab) {
      var currentQuery = getCurrentLocationQuery();
      var resolvedRoute = this.$router.resolve({
        name: this.$route.name,
        params: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.$route.params, {
          dontReload: true
        }),
        query: buildTabQuery(currentQuery, tab),
        hash: ''
      });

      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
    },
    resolveActiveTabForCurrentUser: function resolveActiveTabForCurrentUser(tab) {
      if (!ROUTE_DRIVEN_TABS.includes(tab)) {
        return NAVIGATION_TABS.CONTRACTS;
      }

      if (AUTH_REQUIRING_TABS.includes(tab) && !this.isLoggedIn) {
        return NAVIGATION_TABS.CONTRACTS;
      }

      return tab;
    },
    syncActiveTabFromRoute: function syncActiveTabFromRoute() {
      var currentQuery = getCurrentLocationQuery();
      var activeTab = this.resolveActiveTabForCurrentUser(this.$route.query.tab || currentQuery.tab);

      if (activeTab !== this.activeTab) {
        this.activeTab = activeTab;
      }

      this.scheduleToolbarTabIntoView(activeTab);
    },
    updateDiscussionRequest: function updateDiscussionRequest() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$commentId = _ref8.commentId,
          commentId = _ref8$commentId === undefined ? '' : _ref8$commentId,
          _ref8$commentThreadId = _ref8.commentThreadId,
          commentThreadId = _ref8$commentThreadId === undefined ? 0 : _ref8$commentThreadId;

      this.requestedDiscussionCommentId = commentId;
      this.requestedDiscussionCommentThreadId = normalizeCommentThreadId(commentThreadId);
      this.syncDiscussionLocation(this.requestedDiscussionCommentId, this.requestedDiscussionCommentThreadId);
    },
    onOpenDiscussion: function onOpenDiscussion() {
      this.activeTab = NAVIGATION_TABS.DISCUSSION;
      this.updateDiscussionRequest();
    },
    onOpenDiscussionComment: function onOpenDiscussionComment(comment) {
      var commentId = comment && comment.commentId ? comment.commentId : '';
      var commentThreadId = comment && comment.commentThreadId ? Number(comment.commentThreadId) : 0;

      this.activeTab = NAVIGATION_TABS.DISCUSSION;
      this.updateDiscussionRequest({
        commentId: commentId,
        commentThreadId: commentThreadId
      });
    },
    onDiscussionRequestChange: function onDiscussionRequestChange() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.updateDiscussionRequest(payload);
    },
    navigationTabChange: function navigationTabChange(name) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_40__logger__["a" /* default */].info('[TABS] Change to: ' + name + ' from ' + this.activeTab);
      var isTheSameTab = this.activeTab === name;

      if (isTheSameTab) {
        return;
      }

      if (this.activeTab === NAVIGATION_TABS.DISCUSSION) {
        this.discussionWidgetRouteSwap += 1;
      }

      // Only do the desktop reset when the tabs are already pinned, otherwise we bring the old toolbar jump back in the non-sticky state.
      var shouldResetDesktopTabContentScroll = this.isLayoutDesktop && this.isDesktopToolbarPinned();
      var shouldPreserveMobileToolbarPosition = this.isLayoutMobile && this.isMobileToolbarVisible();

      if (this.isLayoutDesktop) {
        this.captureDesktopContentHeight();
      } else {
        // Mobile needs the outgoing panel height held through the swap so the page does not
        // shrink and yank the midpage tabs around before the new panel finishes mounting.
        this.captureMobileContentHeight();
        this.tabScrollPositions[this.activeTab] = window.scrollY || window.pageYOffset;
      }

      this.activeTab = name;
      if (this.activeTab === NAVIGATION_TABS.DISCUSSION) {
        this.updateDiscussionRequest();
      } else {
        this.requestedDiscussionCommentId = '';
        this.requestedDiscussionCommentThreadId = 0;
        this.syncTabLocation(this.activeTab);
      }
      if (this.activeTab === NAVIGATION_TABS.CONTRACTS) {
        this.setBottomWidgetFooterMode(this.bottomWidgetFooterModeContractsSection);
      }
      this.$nextTick(function () {
        _this12.scheduleToolbarTabIntoView(name);

        if (_this12.isLayoutDesktop) {
          _this12.refreshDesktopContentHeightTracking();

          if (shouldResetDesktopTabContentScroll) {
            if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
              window.requestAnimationFrame(function () {
                _this12.resetDesktopTabContentScroll();
              });
            } else {
              _this12.resetDesktopTabContentScroll();
            }
          }
          return;
        }

        _this12.restoreMobileTabContentScroll(name, { preserveToolbarPosition: shouldPreserveMobileToolbarPosition });
      });
    },
    retrieveMarketData: function retrieveMarketData(_ref9) {
      var _this13 = this;

      var marketId = _ref9.marketId,
          _ref9$clearMarket = _ref9.clearMarket,
          clearMarket = _ref9$clearMarket === undefined ? true : _ref9$clearMarket,
          _ref9$clearOrderBook = _ref9.clearOrderBook,
          clearOrderBook = _ref9$clearOrderBook === undefined ? true : _ref9$clearOrderBook,
          _ref9$loader = _ref9.loader,
          loader = _ref9$loader === undefined ? true : _ref9$loader;

      if (clearOrderBook) {
        this.clearOrderBook();
      }
      if (marketId) {
        if (loader) {
          this.loaderAdd(document.body);
        }
        var commentThreadId = this.$route.query.commentThreadId;
        return this.getMarket({ marketId: marketId, commentThreadId: commentThreadId, skipCache: clearMarket }).then(function (data) {
          if (loader) {
            _this13.loaderRemove(document.body);
          }
          if (data.econIndicatorTradeStatus === 3) {
            _this13.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
          }
        }).catch(function () {
          if (loader) {
            _this13.loaderRemove(document.body);
          }
          _this13.$router.push({ name: 'not-found' });
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
    },
    addBoxLoading: function addBoxLoading() {
      var $el = document.querySelector('.purchase-offer-desktop-sushi-common-betslip__box');
      if ($el) {
        $el.classList.add('purchase-offer-desktop-sushi-common-betslip__box--loading');
      }

      var $el2 = document.querySelector('.purchase-offer-sushi-mobile-bar');
      if ($el2) {
        $el2.classList.add('purchase-offer-sushi-mobile-bar--loading');
      }
    },
    removeBoxLoading: function removeBoxLoading() {
      var $el = document.querySelector('.purchase-offer-desktop-sushi-common-betslip__box');
      if ($el) {
        $el.classList.remove('purchase-offer-desktop-sushi-common-betslip__box--loading');
      }

      var $el2 = document.querySelector('.purchase-offer-sushi-mobile-bar');
      if ($el2) {
        $el2.classList.remove('purchase-offer-sushi-mobile-bar--loading');
      }
    },
    loadHandler: function loadHandler(value) {
      var _this14 = this;

      if (!this.initialised) {
        this.applyDefaultMobileFooterMode();
        this.startPageSetup();
      }

      this.addBoxLoading();
      this.reloading = true;

      if (value) {
        this.retrieveMarketData({
          marketId: this.marketId, clearOrderBook: false, clearMarket: true
        }).then(__WEBPACK_IMPORTED_MODULE_16__utils_mutex__["b" /* waitForStatusReady */]).then(function () {
          if (!_this14.initialised) {
            _this14.setupPage();
          } else {
            _this14.switchContractSideIfNecessaryBecauseOfOwnership();
          }
          _this14.syncActiveTabFromRoute();
          _this14.removeBoxLoading();
          _this14.initialised = true;
          _this14.reloading = false;
        });
      } else {
        this.retrieveMarketData({
          marketId: this.marketId, clearOrderBook: true, clearMarket: true
        }).then(function () {
          if (!_this14.initialised) {
            _this14.setupPage();
          }
          _this14.syncActiveTabFromRoute();
          _this14.removeBoxLoading();
          _this14.initialised = true;
          _this14.reloading = false;
        });
      }
    },
    switchContractSideIfNecessaryBecauseOfOwnership: function switchContractSideIfNecessaryBecauseOfOwnership() {
      var _this15 = this;

      if (this.isMarketDisabled) {
        return;
      }

      if (!this.tradeOptions.contractId) {
        return;
      }

      var contract = this.contracts.find(function (c) {
        return c.contractId === _this15.tradeOptions.contractId;
      });
      if (!contract) {
        return;
      }

      var contractModel = new __WEBPACK_IMPORTED_MODULE_36__models_contract__["a" /* default */](contract);
      if (!contractModel.mode || contractModel.mode === this.tradeOptions.operationValue) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_40__logger__["a" /* default */].info('[PURCHASE] switching sides after signin');
      this.setTradeOptions({
        contractId: contract.contractId,
        operationType: __WEBPACK_IMPORTED_MODULE_37__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__["b" /* OPERATIONS */].BUY,
        operationValue: contractModel.mode
      });
      this.setTradePrice(contractModel.mode === __WEBPACK_IMPORTED_MODULE_37__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__["c" /* VALUES */].YES ? contractModel.buyYesCostAsCents : contractModel.buyNoCostAsCents);
    },
    startPageSetup: function startPageSetup() {
      this.isResetting = true;
      this.isTitleSticky = false;
      this.hideMainChart = false;
      this.destroyStickyTracking();
      this.destroyDesktopContentHeightTracking({ resetHeight: true });
      this.destroyMobileContentHeightLock({ resetHeight: true });
    },
    setupPage: function setupPage() {
      this.isResetting = false;
      this.reorganizeTags();
      this.refreshStickyObserver();
      this.refreshDesktopContentHeightTracking();
      this.initToolbarTabsScrollTracking();
    }
  }),
  watch: {
    lastConfirmedContractData: function lastConfirmedContractData(data) {
      var contractIds = (this.contracts || []).map(function (i) {
        return i.contractId;
      });
      if (data && data.matched && contractIds.includes(data.id)) {
        this.showHistory = true;
      }
    },

    isLoggedIn: {
      handler: 'loadHandler',
      immediate: true
    },
    headerHeight: function headerHeight(value, oldValue) {
      if (!value || value === oldValue) {
        return;
      }

      this.syncDesktopStickyTitleHeight();
      this.refreshStickyObserver();
    },
    isLayoutMobile: function isLayoutMobile(value, oldValue) {
      if (value === oldValue) {
        return;
      }

      this.destroyMobileContentHeightLock({ resetHeight: true });
      this.initToolbarTabsScrollTracking();

      if (value) {
        this.destroyDesktopContentHeightTracking({ resetHeight: true });
      } else {
        this.refreshDesktopContentHeightTracking();
      }

      this.syncDesktopStickyTitleHeight();
      this.refreshStickyObserver();
    },
    bottomBetslipExtended: function bottomBetslipExtended(value, oldValue) {
      if (value === oldValue || !this.isLayoutMobile) {
        return;
      }

      this.scheduleStickyTitleStateUpdate();
    },
    isTitleSticky: function isTitleSticky(value, oldValue) {
      var _this16 = this;

      if (value === oldValue) {
        return;
      }

      this.$nextTick(function () {
        _this16.syncDesktopStickyTitleHeight();

        if (value && typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            _this16.syncDesktopStickyTitleHeight();
          });
        }
      });
    },
    showStickyTitleSummary: function showStickyTitleSummary(value, oldValue) {
      var _this17 = this;

      if (value === oldValue) {
        return;
      }

      this.$nextTick(function () {
        _this17.syncDesktopStickyTitleHeight();

        if (_this17.isLayoutDesktop && typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            _this17.syncDesktopStickyTitleHeight();
          });
        }
      });
    },
    $route: function $route(to, from) {
      var _this18 = this;

      if (from && to) {
        this.activeTab = this.resolveActiveTabForCurrentUser(to.query.tab);
        this.requestedDiscussionCommentId = resolveDiscussionCommentId(to);
        this.requestedDiscussionCommentThreadId = normalizeCommentThreadId(to.query.commentThreadId);
        this.scheduleToolbarTabIntoView(this.activeTab);

        if (resolveRouteMarketId(to) === resolveRouteMarketId(from)) {
          return;
        }

        this.applyDefaultMobileFooterMode({ fromRoute: from });
        this.setBottomBetSlipExtendedMode(false);
        this.startPageSetup();
        this.retrieveMarketData({
          marketId: to.params.marketId,
          clearOrderBook: true,
          clearMarket: true
        }).then(function () {
          _this18.setupPage();
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyStickyTracking();
    this.destroyDesktopContentHeightTracking({ resetHeight: true });
    this.destroyMobileContentHeightLock({ resetHeight: true });
    this.destroyToolbarTabsScrollTracking();
    this.clearMarketEngineBusyMessage();
    this.setTradeOptions(null);
    this.toggleHidePurchaseForContractId(null);
    this.clearMarket();
    this.clearOrderBook();
    this.setBottomBetSlipExtendedMode(false);
    document.title = DEFAULT_PAGE_TITLE;
  }
});

/***/ }),

/***/ "ZllZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    stats: {
      type: Array,
      required: true
    },
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sortParam: 'totalSharesTraded',
      sortOrder: 'desc'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['market']), {
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    sortedItems: function sortedItems() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default()(this.stats, [this.sortParam], [this.sortOrder]);
    },
    isSortable: function isSortable() {
      return this.stats.length > 1;
    },
    secondColumnModifiers: function secondColumnModifiers() {
      return {
        'market-contracts-stats--middle': this.isSortable && !this.isMarketSettled,
        'market-contracts-stats--last-volume': this.isSortable && this.isMarketSettled
      };
    },
    thirdColumnModifiers: function thirdColumnModifiers() {
      return {
        'market-contracts-stats--middle': this.isLayoutDesktop,
        'market-contracts-stats--last': !this.isLayoutDesktop
      };
    },
    totalSharesTradedSum: function totalSharesTradedSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.totalSharesTraded;
      }).toLocaleString();
    },
    todaysVolumeSum: function todaysVolumeSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.todaysVolume;
      }).toLocaleString();
    },
    openInterestSum: function openInterestSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.openInterest;
      }).toLocaleString();
    }
  }),
  methods: {
    headerSortByModifiers: function headerSortByModifiers(name) {
      if (!this.isSortable) return {};

      return {
        'market-contracts-stats--sort-by': this.sortParam === name,
        'market-contracts-stats--asc': this.sortParam === name && this.sortOrder === 'asc',
        'market-contracts-stats--desc': this.sortParam === name && this.sortOrder === 'desc'
      };
    },
    sortBy: function sortBy(name) {
      if (this.sortParam === name) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder = 'desc';
        this.sortParam = name;
      }
    }
  }
});

/***/ }),

/***/ "Zn+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-money-widget__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),(!!_vm.widget)?_c('div',{staticClass:"market-money-widget__content",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('div',{staticClass:"market-money-widget__percent-container"},[_c('div',{staticClass:"market-money-widget__percent"},[_vm._v(_vm._s(_vm.percent))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__percent-title"},[_c('div',{staticClass:"market-money-widget__percent-vertical"},[_vm._v(_vm._s(_vm.obj.percentTitle))])])]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__market"},[_vm._v(_vm._s(_vm.obj.marketName))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__contract"},[_c('div',{staticClass:"market-money-widget__contract-title"},[_vm._v(_vm._s(_vm.contractName))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__contract-section"},[_c('span',{staticClass:"market-money-widget__contract-price"},[(_vm.hasPrice)?[_c('animated-number',{attrs:{"value":_vm.price}})]:[_vm._v("\n            -"),_c('span',{domProps:{"innerHTML":_vm._s('&cent;')}})]],2),_vm._v(" "),_c('market-change-price',{staticClass:"market-money-widget__contract-delta",attrs:{"price":_vm.delta}}),_vm._v(" "),(_vm.hasPrice)?_c('span',{class:_vm.iconModifiers}):_vm._e()],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZqrY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_section_header_js__ = __webpack_require__("mXqA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8883f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_section_header_vue__ = __webpack_require__("zGja");
function injectStyle (ssrContext) {
  __webpack_require__("Eckv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_section_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8883f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_section_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZqyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-journey-sushi"},[(_vm.showPurchaseOfferDesktop)?_c('purchase-offer-desktop-sushi',{attrs:{"market":_vm.market,"contract":_vm.contract,"showContractCharts":_vm.showContractCharts,"showRelatedContracts":_vm.showRelatedContracts,"showOrderSlip":_vm.showOrderSlip,"disablePurchaseOfferWatchers":_vm.disablePurchaseOfferWatchers},on:{"submit":_vm.onClickNext}}):(_vm.showPurchaseOfferMobile)?_c('purchase-offer-sushi',{attrs:{"market":_vm.market,"contract":_vm.contract,"showContractCharts":_vm.showContractCharts,"showRelatedContracts":_vm.showRelatedContracts,"showOrderSlip":_vm.showOrderSlip,"disablePurchaseOfferWatchers":_vm.disablePurchaseOfferWatchers},on:{"submit":_vm.onClickNext}}):(_vm.showPurchaseOfferDesktopWidget)?_c('purchase-offer-desktop-sushi-common-betslip',{attrs:{"market":_vm.market,"contract":_vm.contract,"showContractCharts":_vm.showContractCharts,"showRelatedContracts":_vm.showRelatedContracts,"showOrderSlip":_vm.showOrderSlip,"disablePurchaseOfferWatchers":_vm.disablePurchaseOfferWatchers},on:{"submit":_vm.onClickNext}}):(_vm.showPurchaseOfferMobileWidget)?_c('purchase-offer-sushi-mobile-bar',{attrs:{"market":_vm.market,"contract":_vm.contract,"showOwnershipAndOrdersBar":_vm.showOwnershipAndOrdersBar,"disablePurchaseOfferWatchers":_vm.disablePurchaseOfferWatchers},on:{"submit":_vm.onClickNext,"submit-no-skip":_vm.onClickSubmitWithoutSkipConfirmationHandling}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZrIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZvSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_search_input_js__ = __webpack_require__("zX9S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb62f5b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_search_input_vue__ = __webpack_require__("VsU5");
function injectStyle (ssrContext) {
  __webpack_require__("RZj3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_search_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb62f5b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_search_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZyPi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a+EO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.isYoutube)?[_c('youtube',{ref:"youtubePlayer",staticClass:"video-view__youtube",attrs:{"player-width":_vm.playerWidth,"player-height":_vm.playerHeight,"video-id":_vm.youtubeVideoId,"mute":_vm.mute,"player-vars":_vm.youtubePlayerVars},on:{"ended":_vm.youtubeEnded}})]:(_vm.isVimeo)?[_c('vimeo-player',{staticClass:"video-view__vimeo",attrs:{"video-id":_vm.vimeoVideoId,"autoplay":_vm.autoPlay,"loop":_vm.loop,"options":_vm.vimeoPlayerVars,"player-width":_vm.playerWidth,"player-height":_vm.playerHeight}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a/AT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_update_js__ = __webpack_require__("H2eu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1734a70b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_update_vue__ = __webpack_require__("pfv0");
function injectStyle (ssrContext) {
  __webpack_require__("9sg1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_update_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1734a70b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_update_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a/JI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a0yF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NOTIFICATION_TRADE_CONFIRMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTIFICATION_SIMPLE; });
/* unused harmony export NOTIFICATION_ACCOUNT_FUNDS */
/* unused harmony export NOTIFICATION_MARKET */
/* unused harmony export NOTIFICATION_MARKET_STATUS */
/* unused harmony export NOTIFICATION_CONTRACT */
/* unused harmony export NOTIFICATION_MARKET_OWNERSHIP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATION_CONTRACT_OWNERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NOTIFICATION_SHARES_TRADED; });
/* unused harmony export NOTIFICATION_SITE_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NOTIFICATION_TRADER_LEVEL_CHANGED; });
/* unused harmony export NOTIFICATION_PWMB_DEPOSIT_FINISHED */
/* unused harmony export NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION */
/* unused harmony export NOTIFICATION_PWMB_SHOW_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ALLOWED_NOTIFICATION_TYPES; });
/* unused harmony export IGNORE_TIMESTAMP_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NOTIFICATION_MATCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NOTIFICATION_SETTLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NOTIFICATION_PRICE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NOTIFICATION_LEVEL; });
/* unused harmony export NOTIFICATIONS_ONLINE_BANKING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NOTIFICATION_TRADE_CONFIRMED_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION_SHARES_TRADED_CLOSE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MARKET_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MY_SHARES_MARKET_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CONTRACT_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ACCOUNT_FUNDS_MAP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_camelCase__ = __webpack_require__("NRb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__ = __webpack_require__("ENdH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");



/* eslint-disable no-console, arrow-body-style, no-case-declarations */







// import ss from '@/helpers/sessionStorage';



/*
  List of notification types that come from an signalr.
 */
var NOTIFICATION_TRADE_CONFIRMED = 'tradeConfirmed_data';
var NOTIFICATION_SIMPLE = 'simple';
var NOTIFICATION_ACCOUNT_FUNDS = 'accountfunds_data';
var NOTIFICATION_MARKET = 'market_data';
var NOTIFICATION_MARKET_STATUS = 'market_status';
var NOTIFICATION_CONTRACT = 'contract_data';
var NOTIFICATION_MARKET_OWNERSHIP = 'marketOwnershipUpdate_data';
var NOTIFICATION_CONTRACT_OWNERSHIP = 'contractOwnershipUpdate_data';
var NOTIFICATION_SHARES_TRADED = 'notification_shares_traded';
var NOTIFICATION_SITE_STATUS = 'site_status';
var NOTIFICATION_TRADER_LEVEL_CHANGED = 'notification_trade_level_changed';
var NOTIFICATION_PWMB_DEPOSIT_FINISHED = 'notification_pwmb_deposit_finished';
var NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION = 'notification_pwmb_deposit_show_confirmation';
var NOTIFICATION_PWMB_SHOW_ERROR = 'notification_pwmb_show_error';

/*
  List of notification types that *should* display in top right corner of the app.
 */
var ALLOWED_NOTIFICATION_TYPES = [NOTIFICATION_SIMPLE, NOTIFICATION_TRADE_CONFIRMED, NOTIFICATION_SHARES_TRADED, NOTIFICATION_TRADER_LEVEL_CHANGED];

var IGNORE_TIMESTAMP_TYPES = [NOTIFICATION_TRADE_CONFIRMED, NOTIFICATION_SHARES_TRADED, NOTIFICATION_MARKET_STATUS];
/*
  Generic notification types that come from API (backend).
  The reason for separate list is determined by other typing mechanism used by
  API as opposed to signalr notifications.
  For now NOTIFICATION_SHARES_TRADED maps to NOTIFICATION_MATCHED.
  and NOTIFICATION_TRADER_LEVEL_CHANGED to NOTIFICATION_LEVEL
 */
var NOTIFICATION_MATCHED = 1;
var NOTIFICATION_SETTLED = 2;
var NOTIFICATION_PRICE_CHANGE = 3;
var NOTIFICATION_LEVEL = 12;
var NOTIFICATIONS_ONLINE_BANKING = [13, 14];
/*
  Number of milliseconds to delay confirmations so they do not appear instantly after submit click
  because simple notification should display first.
 */
var NOTIFICATION_TRADE_CONFIRMED_DELAY = 1250;
var NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY = 10000;
var NOTIFICATION_SHARES_TRADED_CLOSE_DELAY = 5000;

var MARKET_DATA_MAP = {
  TotalSharesTraded: 'totalSharesTraded',
  UserGainLoss: 'userGainLoss',
  UserInvestment: 'userInvestment',
  UserMaxPayout: 'userMaxPayout',
  Status: 'status',
  IsOpen: 'isOpen',
  IsActive: 'isActive',
  IsProcessed: 'isProcessed',
  UserHasOwnership: 'userHasOwnership'
};

// additional map because of TotalSharesTraded different mapping
var MY_SHARES_MARKET_DATA_MAP = {
  TotalSharesTraded: 'marketSharesTraded',
  UserGainLoss: 'userGainLoss',
  UserInvestment: 'userInvestment',
  UserMaxPayout: 'userMaxPayout',
  Status: 'status',
  IsOpen: 'isOpen',
  IsActive: 'isActive',
  IsProcessed: 'isProcessed',
  IsOpenStatusMessage: 'isOpenStatusMessage',
  UserHasOwnership: 'userHasOwnership'
};

var CONTRACT_DATA_MAP = {
  TimeStamp: 'timestamp',
  BestNoPrice: 'bestNoPrice',
  BestNoCost: 'bestNoPrice',
  BestYesPrice: 'bestYesPrice',
  BestYesCost: 'bestYesPrice',
  LastClosePrice: 'lastClosePrice',
  LastTradePrice: 'lastTradePrice',
  UserAveragePricePerShare: 'userAveragePricePerShare',
  UserQuantity: 'userQuantity',
  UserOpenOrdersBuyQuantity: 'userOpenOrdersBuyQuantity',
  UserOpenOrdersSellQuantity: 'userOpenOrdersSellQuantity',
  UserPrediction: 'userPrediction'
};

var ACCOUNT_FUNDS_MAP = {
  AccountBalance: 'accountBalance',
  AccountBalanceDecimal: 'accountBalanceDecimal',
  PortfolioBalance: 'portfolioBalance',
  PortfolioBalanceDecimal: 'portfolioBalanceDecimal',
  ShareValueDelta: 'shareValueDelta',
  ShareValueDeltaDecimal: 'shareValueDeltaDecimal',
  ProfitablePredictions: 'profitablePredictions'
};

var pageLoad = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
var processedGuids = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();

var updateOrResetCounters = function updateOrResetCounters() {
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/toggleNotifications');

  if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.notifications.showNotificationsWidget) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('user/increaseUserUnreadNotificationsCount');
  } else {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('user/setUserUnreadNotificationsCount', 0);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/markNotificationsAsRead');
  }
};

var addToStore = function addToStore(method, updateType, data) {
  if (!data) return;

  if (data && data.TimeStamp && !IGNORE_TIMESTAMP_TYPES.includes(updateType)) {
    if (__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(data.TimeStamp).diff(pageLoad, 'seconds') < 0) {
      return;
    }
  }

  if (data.Guid) {
    if (processedGuids.has(data.Guid)) return;
    processedGuids.add(data.Guid);
  }

  data.UpdateType = updateType;
  switch (updateType) {
    case NOTIFICATION_ACCOUNT_FUNDS:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/updateBalanceFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('profile/updateProfileFromNotification', data);
      break;
    case NOTIFICATION_MARKET:
    case NOTIFICATION_MARKET_OWNERSHIP:
    case NOTIFICATION_MARKET_STATUS:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateRelatedMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateMarketFromNotification', data);
      // store.dispatch('browse/updateStoryMapFromMarketNotification', data);
      // store.dispatch('browse/updateGainsLossMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updatePredictedTrendingMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/updateMySharesFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('search/updateMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('watchlist/updateWatchlistFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/updateTradePopupOptionsMarketFromNotification', data);
      break;
    case NOTIFICATION_CONTRACT:
    case NOTIFICATION_CONTRACT_OWNERSHIP:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateRelatedContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateGainsLossContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updatePredictedTrendingContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateMarketWidgetsContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/updateMySharesContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('search/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('watchlist/updateWatchlistContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/updateTradePopupOptionsContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMapOverviewDataFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMapOverviewDataSenateFromNotification', data);
      // store.dispatch('browse/updateStoryMapFromContractNotification', data);
      break;
    case NOTIFICATION_SITE_STATUS:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('app/setServerError', false);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('app/setMaintenance', {
        isMaintenanceEnabled: data.IsMaintenance,
        isTradingEnabled: !data.IsTradingSuspended,
        maintenanceMessage: data.MaintenanceMessage,
        suspendedMessage: data.TradingSuspendedMessage,
        systemMessage: data.SystemMessage
      });
      break;
    case NOTIFICATION_SHARES_TRADED:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', {
        method: method,
        type: updateType,
        data: {
          contentJson: data,
          notificationType: NOTIFICATION_MATCHED
        }
      });
      updateOrResetCounters();
      break;
    case NOTIFICATION_TRADER_LEVEL_CHANGED:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', {
        method: method,
        type: updateType,
        data: {
          contentJson: data,
          notificationType: NOTIFICATION_LEVEL
        }
      });
      updateOrResetCounters();
      break;
    case NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
        step: data.PrefilledAmountToDeposit ? __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].CONFIRM : __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].AMOUNT_CONFIRM,
        stepData: __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default()(data, function (result, value, key) {
          result[__WEBPACK_IMPORTED_MODULE_1_lodash_camelCase___default()(key)] = value;
          return result;
        }, {})
      });
      break;
    case NOTIFICATION_PWMB_SHOW_ERROR:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
        step: __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].FINISHED_FAILED,
        stepData: {
          error: data.MessageForUser
        }
      });
      break;
    case NOTIFICATION_PWMB_DEPOSIT_FINISHED:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/getBalance').then(function () {
        return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setCurrentDeposit', {
          amount: data.TotalAmountDeposited,
          matched: data.AmountMatched,
          messageForUser: data.MessageForUser,
          confirmationNumber: data.PWMBCaptureId,
          type: 'bank-transfer',
          account: {
            accountStatus: 1,
            bankInfo: {
              bankIconUrl: data.BankIconURL,
              bankAccountDisplayName: data.BankAccountDisplayName,
              bankDisplayName: data.BankDisplayName
            }
          }
        });
      }).then(function () {
        if (data.Status === __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["b" /* FINISHED_STATUS */].SUCCESS) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].FINISHED_SUCCESS,
            stepData: {}
          });
        } else if (data.Status === __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["b" /* FINISHED_STATUS */].FAILED) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].FINISHED_FAILED,
            stepData: {
              error: data.MessageForUser
            }
          });
        } else if (data.Status === __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["b" /* FINISHED_STATUS */].EXPIRED) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].FINISHED_EXPIRED,
            stepData: {
              pwmbAuthorizationId: data.PWMBAuthorizationId,
              error: data.MessageForUser
            }
          });
        }
      });
      break;
    case NOTIFICATION_TRADE_CONFIRMED:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/incrReloadHistoryToggle');
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', {
        method: method,
        type: updateType,
        data: data
      });
      break;
    default:
      {
        var payload = {
          method: method,
          type: updateType,
          data: data
        };
        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', payload);
      }
  }
};

var KEY_MESSAGING_STATE = 'messagingState';
var MESSAGING_STATES = {
  OPT_IN: 'opt-in',
  OPT_OUT: 'opt-out',
  NO_DECISION: 'no-decision'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  initialisedFirebaseAnonymous: false,
  initialisedFirebase: false,
  initialisedSignalr: false,
  latestApiToken: null,
  init: function init() {
    this.initFirebase();
    this.initSignalr();
  },
  initFirebase: function initFirebase() {
    var apiToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__["a" /* connect */](apiToken, { onUpdate: addToStore });

    if (apiToken) {
      this.initialisedFirebase = true;
    } else {
      this.initialisedFirebaseAnonymous = true;
    }
  },
  initSignalr: function initSignalr() {
    var apiToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (!apiToken && !false) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["a" /* createConnection */]({ apiToken: apiToken, onUpdate: addToStore });
    this.initialisedSignalr = true;
  },
  authorize: function authorize(apiToken) {
    // reinitialise if it was switched off for anonymous users
    if (!this.initialisedFirebase) {
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('firebase::', 'authorize::', 'init::');
      this.initFirebase(apiToken);
    }
    if (!this.initialisedSignalr) {
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('socket::', 'authorize::', 'init::');
      this.initSignalr(apiToken);
      this.latestApiToken = apiToken;
    } else if (this.latestApiToken !== apiToken) {
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('socket::', 'authorize::', 'reinitializetoken::');
      __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["b" /* forceReconnect */]({ apiToken: apiToken, onUpdate: addToStore });
      this.latestApiToken = apiToken;
    } else {
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('socket::', 'authorize::', 'stale::');
    }
  },
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["c" /* forceDisconnect */]();
    if (window.firebase.apps.length > 0) {
      window.firebase.app().delete().then(function () {});
    }
  },
  setupMessaging: function setupMessaging() {
    __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__["b" /* setupMessaging */]();
  },
  forceDisconnect: function forceDisconnect() {
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["c" /* forceDisconnect */]();
  },
  shouldSetupMessaging: function shouldSetupMessaging() {
    if (!__webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).PUSH_NOTIFICATIONS_JOURNEY_ENABLED) return true;

    var state = __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_MESSAGING_STATE, MESSAGING_STATES.NO_DECISION);
    return state === MESSAGING_STATES.OPT_IN;
  },
  showMessagingJourney: function showMessagingJourney(isBuyTradeType) {
    if (!__webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true}).PUSH_NOTIFICATIONS_JOURNEY_ENABLED || !isBuyTradeType) return;

    var state = __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_MESSAGING_STATE, MESSAGING_STATES.NO_DECISION);
    if (state !== MESSAGING_STATES.NO_DECISION) return;

    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup', __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MESSAGING_JOURNEY);
    }, 4000);
  },
  optOutMessaging: function optOutMessaging() {
    __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_MESSAGING_STATE, MESSAGING_STATES.OPT_OUT);
  },
  optInMessaging: function optInMessaging() {
    __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_MESSAGING_STATE, MESSAGING_STATES.OPT_IN);
  }
});

/***/ }),

/***/ "a3Wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_card_js__ = __webpack_require__("Jjcr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a5b46d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_card_vue__ = __webpack_require__("SngK");
function injectStyle (ssrContext) {
  __webpack_require__("RqM3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_card_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a5b46d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a7S9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_rules_content_js__ = __webpack_require__("ybIt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d9891b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_rules_content_vue__ = __webpack_require__("0W9C");
function injectStyle (ssrContext) {
  __webpack_require__("aYZE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_rules_content_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d9891b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_rules_content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a8vN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: String,
    checked: Boolean,
    small: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classIsChecked: function classIsChecked() {
      return this.checked ? 'checkbox__tick--checked' : '';
    },
    checkboxModifiers: function checkboxModifiers() {
      return {
        'checkbox--small': this.small
      };
    }
  },
  methods: {
    onChange: function onChange(e) {
      this.$emit('change', e.target.checked);
    }
  }
});

/***/ }),

/***/ "aAxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-combined"},[(_vm.showTabs && !_vm.hideTabs)?_c('div',{staticClass:"add-funds-combined__tabs"},[_c('tabs',{attrs:{"items":_vm.tabs},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),(!_vm.showTabs)?_c('div',{staticClass:"add-funds-combined__content add-funds-combined__content--loading"}):_c('div',{staticClass:"add-funds-combined__content"},[(_vm.showBankingTab)?_c('add-funds-bank-transfer',{attrs:{"instantCreditData":_vm.instantCreditData,"isPopup":true},on:{"step":_vm.onBankTransferStep}}):_vm._e(),_vm._v(" "),(_vm.showCardTab)?_c('add-funds-card',{attrs:{"instantCreditData":_vm.instantCreditData}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aDe5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_captcha_js__ = __webpack_require__("EGLE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_724f2549_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captcha_vue__ = __webpack_require__("/gt+");
function injectStyle (ssrContext) {
  __webpack_require__("3kQE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_captcha_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_724f2549_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captcha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aFCK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aGiD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aHny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_js__ = __webpack_require__("2+il");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d40979d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_vue__ = __webpack_require__("Bmi9");
function injectStyle (ssrContext) {
  __webpack_require__("n9uA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d40979d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aIVs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refine-link",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aIx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"most-predicted"},[_c('div',{staticClass:"most-predicted__header"},[_c('div',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"most-predicted__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row most-predicted__content"},[(_vm.isLayoutMobile)?_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(item){return _c('swiper-slide',{key:item.marketId},[_c('market-list-item',{staticClass:"most-predicted__swiper-slide",attrs:{"market":item,"theme":"home"}})],1)}),1):_c('div',{staticClass:"row"},_vm._l((_vm.items),function(market){return _c('div',{key:market.marketId,staticClass:"large-4 column most-predicted__swiper-column"},[_c('market-list-item',{key:market.marketId,attrs:{"market":market,"theme":"home"}})],1)}),0)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aK6m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_accessibility_statement_js__ = __webpack_require__("9ewn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8c5b944_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_accessibility_statement_vue__ = __webpack_require__("tBC5");
function injectStyle (ssrContext) {
  __webpack_require__("NN0H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_accessibility_statement_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8c5b944_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_accessibility_statement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aLRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-price-change-chart"},[_c('div',{ref:"chart",staticClass:"market-price-change-chart__chart"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aNYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_history_trades_refine_link_refine_link_vue__ = __webpack_require__("gFdO");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: Array
  },
  components: {
    refineLink: __WEBPACK_IMPORTED_MODULE_0__components_account_history_trades_refine_link_refine_link_vue__["a" /* default */]
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('input', e);
    }
  }
});

/***/ }),

/***/ "aTrv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_balance_history_js__ = __webpack_require__("5MMF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4eb3bb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_balance_history_vue__ = __webpack_require__("keem");
function injectStyle (ssrContext) {
  __webpack_require__("PFd9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_balance_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4eb3bb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_balance_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aUi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_two_factor_prompt_js__ = __webpack_require__("MptW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2597ff88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_two_factor_prompt_vue__ = __webpack_require__("xoS/");
function injectStyle (ssrContext) {
  __webpack_require__("ynxK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_two_factor_prompt_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2597ff88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_two_factor_prompt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aYZE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aaFU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aeoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


var DEFAULT_TIMELINE = 7;

/* harmony default export */ __webpack_exports__["a"] = ({
  getProfileDetail: function getProfileDetail() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Detail');
  },
  getMyShares: function getMyShares(sort, sortPar) {
    var sorting = sort ? '?sort=' + sort : '';
    var sortParameter = sorting && sortPar ? '&sortParameter=' + sortPar : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Shares' + sorting + sortParameter);
  },
  getTradeHistory: function getTradeHistory(itemsPerPage, page, marketId) {
    var contractId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var tradeType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Trade/History?itemsPerPage=' + itemsPerPage + '&page=' + page + '&marketId=' + marketId + '&contractId=' + contractId + '&tradeType=' + tradeType);
  },
  getTransactionHistory: function getTransactionHistory(itemsPerPage, page) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ALL';
    var year = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var url = 'api/User/Wallet/History?itemsPerPage=' + itemsPerPage + '&page=' + page + '&type=' + type;
    var restOfQueryString = year ? '&year=' + year : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url.concat(restOfQueryString));
  },
  getMarketPayouts: function getMarketPayouts(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Market/' + marketId + '/Payouts');
  },
  getContractOffers: function getContractOffers(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/contract/' + contractId + '/Offers');
  },
  getContractShares: function getContractShares(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/contract/' + contractId + '/Shares');
  },
  getTradeHistoryMarkets: function getTradeHistoryMarkets() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Trade/History/Markets');
  },
  getMarketWatch: function getMarketWatch(sort, sortPar) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var itemsPerPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;

    var sorting = sort ? '?sort=' + sort : '';
    var sortParameter = sorting && sortPar ? '&sortParameter=' + sortPar : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/MarketWatch' + sorting + sortParameter + '&itemsPerPage=' + itemsPerPage + '&page=' + page);
  },
  putMarketWatch: function putMarketWatch(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/MarketWatch/' + marketId);
  },
  deleteMarketWatch: function deleteMarketWatch(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].delete('api/Profile/MarketWatch/' + marketId);
  },
  getPortfolioChart: function getPortfolioChart() {
    var timespan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIMELINE;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Profile/Portfolio?timespan=' + timespan);
  },
  putSettings: function putSettings(category, key, value) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Settings/Categories/' + category + '/Keys/' + key + '/' + value);
  },
  getAllSettings: function getAllSettings(categories) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Profile/Settings/Categories?categories=' + categories);
  },
  getNotifications: function getNotifications() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var itemsPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Notifications?itemsPerPage=' + itemsPerPage + '&page=' + page);
  },
  putNotification: function putNotification(notificationId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Notifications/' + notificationId + '/read');
  },
  putNotifications: function putNotifications() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Notifications/markRead');
  },
  postSendInviteEmail: function postSendInviteEmail(email) {
    var payload = {
      email: email
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Profile/invite/email', payload);
  },
  getUnreadNotificationsCount: function getUnreadNotificationsCount() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/UnreadNotificationsCount');
  },
  getUserAffiliations: function getUserAffiliations() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Affiliations');
  },
  setUserAffiliations: function setUserAffiliations(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Affiliations', payload);
  },
  removeUserAffiliations: function removeUserAffiliations(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].delete('api/Profile/Affiliations', payload);
  },
  getAffiliations: function getAffiliations(search) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Affiliations/Search/' + search);
  }
});

/***/ }),

/***/ "al65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_price_js__ = __webpack_require__("1lzi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1d8cab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_price_vue__ = __webpack_require__("tUhF");
function injectStyle (ssrContext) {
  __webpack_require__("SfXH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_price_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1d8cab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_price_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aoNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_history_filters_js__ = __webpack_require__("WYZc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e946bf02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_filters_vue__ = __webpack_require__("H4Kq");
function injectStyle (ssrContext) {
  __webpack_require__("/afu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_history_filters_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e946bf02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_filters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "asvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-the-news-old"},[_c('h2',{staticClass:"in-the-news-old__title"},[_vm._v("PredictIt in the News")]),_vm._v(" "),_c('div',{staticClass:"in-the-news-old__title--border"}),_vm._v(" "),_c('div',{staticClass:"in-the-news-old__wrapper"},[(_vm.isLayoutMobile)?_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.itemsPaged),function(page){return _c('swiper-slide',{key:page.key,staticClass:"in-the-news__slide"},_vm._l((page.items),function(logo){return _c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":logo.href}},[_c('img',{class:_vm.getImgModifiers(logo),attrs:{"src":logo.src,"alt":logo.alt}})])}),0)}),_vm._v(" "),_c('div',{staticClass:"in-the-news-old__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_c('div',_vm._l((_vm.items),function(logo){return _c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":logo.href}},[_c('img',{class:_vm.getImgModifiers(logo),attrs:{"src":logo.src,"alt":logo.alt}})])}),0)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ayND":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "azKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_trading_unavailable_v2_js__ = __webpack_require__("sS6v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282d136a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_trading_unavailable_v2_vue__ = __webpack_require__("yOrf");
function injectStyle (ssrContext) {
  __webpack_require__("xLyB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_trading_unavailable_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282d136a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_trading_unavailable_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b+hr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopupOptions']), {
    classModifiers: function classModifiers() {
      return {
        'popup-generic-small': true,
        'popup-generic-small--icon': this.currentPopupOptions && this.currentPopupOptions.icon
      };
    }
  })
});

/***/ }),

/***/ "b2pe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_index1_js__ = __webpack_require__("j3lF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c332136_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index1_vue__ = __webpack_require__("9H7b");
function injectStyle (ssrContext) {
  __webpack_require__("uDCm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_index1_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c332136_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b34n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b47U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__ = __webpack_require__("9xQS");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  props: {
    depositPayload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      fields: {
        agreed: false
      }
    };
  },

  computed: {
    amountDisplay: function amountDisplay() {
      return Number(this.depositPayload.amount).toFixed(2);
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return !this.isFormEnabled || !this.fields.agreed;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['submitDepositUSDCoin']), {
    onSubmit: function onSubmit() {
      var _this = this;

      this.formDisable();
      this.loaderAdd(document.body);
      this.submitDepositUSDCoin(this.depositPayload).then(function (data) {
        _this.loaderRemove(document.body);
        if (_this.checkDocumentUploadFlags(data)) return;
        _this.formEnable();
        window.location.href = data.url;
      }).catch(function (error) {
        _this.loaderRemove(document.body);
        if (_this.checkDocumentUploadFlags(error.response.data)) return;
        _this.formEnable();
      });
    }
  })
});

/***/ }),

/***/ "b4Ty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__ = __webpack_require__("S9O8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_overlay_overlay_vue__ = __webpack_require__("RuD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__ = __webpack_require__("gjXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_app_modals_vue__ = __webpack_require__("PUuo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_app_app_privacy_statement_app_privacy_statement_vue__ = __webpack_require__("z/nA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_instant_credit__ = __webpack_require__("zAJv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_app_app_loader_app_loader_vue__ = __webpack_require__("EIVR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_what_is_new_popup_helpers__ = __webpack_require__("AyQu");


/* eslint-disable consistent-return, no-void */





















var RESIZE_HANDLER_TIMEOUT = 500;
var SOCIAL_AUTH_ROUTES = ['disqus-auth', 'social-auth'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__mixins_userAgent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      appFlowDisabled: false,
      appInitialPopupShown: false,
      initialised: false,
      disconnectTimeout: null,
      connectTimeout: null,
      connectTimeoutAnonymous: null,
      touchStartTop: 0
    };
  },

  components: {
    overlay: __WEBPACK_IMPORTED_MODULE_7__components_generics_overlay_overlay_vue__["a" /* default */],
    appPrivacyStatement: __WEBPACK_IMPORTED_MODULE_14__components_app_app_privacy_statement_app_privacy_statement_vue__["a" /* default */],
    appLayoutOld: __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__["a" /* default */],
    appModals: __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_app_modals_vue__["a" /* default */],
    appLoader: __WEBPACK_IMPORTED_MODULE_17__components_app_app_loader_app_loader_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['skipAttachToHomeNotification', 'isTabActive', 'newLoaderCounter', 'settingColorPalette']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['token']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['activeCategory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('profile', ['profileStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['loginWithDisqus', 'isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['hasMaintenance', 'isLayoutMobile', 'isShutdownModeOn', 'newLoaderIsLoading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['navigatingToTwoFactorSetup']), {
    layoutComponent: function layoutComponent() {
      return __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__["a" /* default */];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('app', ['setLayoutWidth', 'setIsTabActive', 'setLiveUpdatesDisabled', 'setSettingShowOdds', 'setSettingsAnnouncementCurState']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('browse', ['getHeaders']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('user', ['getStatus', 'getAccountDetail', 'getUserInfo', 'login', 'logout', 'clearAuthSession', 'setBareToken', 'setUserUnreadNotificationsCount', 'checkAndCacheTwoFactorStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('profile', ['getProfileDetail', 'getAllSettings', 'setProfileStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getBalance', 'clearBalance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getBiggestGains']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), {
    getUserDetailedInformation: function getUserDetailedInformation() {
      var _this = this;

      this.getAccountDetail().then(function (data) {
        _this.setUserUnreadNotificationsCount(data.userUnreadNotificationsCount);
        if (data.idVerified) {
          return _this.getBalance();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }).then(this.getAllSettings).then(this.getStatus).then(function (data) {
        _this.appInitialPopupShown = false;
        var skipRoutes = ['terms-and-conditions', 'password-set'];
        var showVerifyPopup = !skipRoutes.includes(_this.$route.name) && !_this.hasMaintenance && !_this.checkDataIfUserIsVerified(_this.userData);

        if (showVerifyPopup && !_this.appInitialPopupShown) {
          _this.showAccountVerifyPopup();
          // Stop here - let modal close handler continue the flow
          return;
        } else if (!_this.appInitialPopupShown) {
          _this.showAttachToHomeNotification();
        }
        // Cache 2FA status for modal chain decisions (must complete before modals show)
        return _this.checkAndCacheTwoFactorStatus().then(function () {
          // Guard: skip ADD_FUNDS if navigating to 2FA setup or already on settings page
          var skipAddFunds = _this.navigatingToTwoFactorSetup || _this.$route.name === 'account-settings';

          if (_this.userData.idVerified) {
            if (
            // Fallback: if no ADD_FUNDS shown, check if we should show 2FA prompt directly
            !_this.appInitialPopupShown && !_this.currentPopup && _this.$store.state.user.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
              // Verified user with positive balance and no 2FA - show prompt directly
              _this.appInitialPopupShown = true;
              _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].TWO_FACTOR_PROMPT);
            } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__components_what_is_new_popup_helpers__["a" /* shouldShowWhatsIsNewPopup */])()) {
              _this.appInitialPopupShown = true;
              _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].CUSTOMIZE_YOUR_PREDICTIT);
            }
            _this.routeQueryHandler();
          } else if (data.isUCAffilSet === null && !_this.appInitialPopupShown) {
            _this.appInitialPopupShown = true;
            _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
          }
          return { skipAddFunds: skipAddFunds }; // Pass to next .then() for use in instant credit checks
        });
      }).then(this.getProfileDetail).then(function (data) {
        if (_this.appFlowDisabled) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }
        if (__WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('registeredExternal', false)) {
          __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].del('registeredExternal');
          _this.$gtm.trackEvent({
            event: 'SignUp',
            gtmUserID: data.userGuid,
            otmUserID: data.otmUserId,
            email: _this.userData.email
          });
          // uncomment when we want frontend to migrate setting
          // return this.setSettingsAnnouncementCurState(VERSION_TO_MIGRATE_TO);
        } else if (_this.profileStatus.event && _this.profileStatus.event === 'registered') {
          _this.$gtm.trackEvent({
            event: 'SignUp',
            gtmUserID: data.userGuid,
            otmUserID: data.otmUserId,
            email: _this.userData.email
          });
          _this.setProfileStatus({});
          // uncomment when we want frontend to migrate setting
          // return this.setSettingsAnnouncementCurState(VERSION_TO_MIGRATE_TO);
        } else if (_this.profileStatus.event && _this.profileStatus.event === 'login') {
          _this.$gtm.trackEvent({ event: 'Login' });
          _this.setProfileStatus({});
          // Guard: skip ADD_FUNDS if navigating to 2FA setup
          var skipAddFunds = _this.navigatingToTwoFactorSetup || _this.$route.name === 'account-settings';
          if (__WEBPACK_IMPORTED_MODULE_16__services_instant_credit__["a" /* default */].checkIfCanRunAfterLogin() && !skipAddFunds) {
            // Firing quick deposit with instant credit check
            _this.appInitialPopupShown = true;
            _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
            _this.setCurrentPopupOptions({
              checkInstantCredit: true
            });
          }
        } else if (__WEBPACK_IMPORTED_MODULE_16__services_instant_credit__["a" /* default */].checkIfCanRunAfterLogin()) {
          // Guard: skip ADD_FUNDS if navigating to 2FA setup
          var _skipAddFunds = _this.navigatingToTwoFactorSetup || _this.$route.name === 'account-settings';
          if (!_skipAddFunds) {
            // Firing quick deposit with instant credit check
            _this.appInitialPopupShown = true;
            _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
            _this.setCurrentPopupOptions({
              checkInstantCredit: true
            });
          }
        }
      });
    },
    getUserData: function getUserData() {
      var _this2 = this;

      if (!this.token) return;

      if (SOCIAL_AUTH_ROUTES.includes(this.$route.name)) {
        this.getUserInfo().then(function (response) {
          if (response.data.hasRegistered) {
            _this2.getUserDetailedInformation();
          }
        });
      } else {
        this.getUserDetailedInformation();
      }
    },
    storageHandler: function storageHandler() {
      var storageToken = __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('token', null);
      // token removed from localstorage (user logged out in other tab/window)
      if (this.token && !storageToken) {
        this.logout();
        // token added to localstorage and it's different --> update app state
      } else if (this.token && this.token !== storageToken) {
        this.setBareToken(storageToken);
      }
    },
    resizeHandler: function resizeHandler() {
      var _this3 = this;

      setTimeout(function () {
        var width = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        _this3.setLayoutWidth(width);
      }, RESIZE_HANDLER_TIMEOUT);
    },
    orientationChangeHandler: function orientationChangeHandler() {
      var _this4 = this;

      setTimeout(function () {
        if (_this4.isLayoutMobile && _this4.getOrientation() === 'landscape' && !_this4.isTablet) {
          _this4.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].ORIENTATION);
        } else if (_this4.currentPopup === __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].ORIENTATION) {
          _this4.setCurrentPopup();
        }
      }, 10);
    },
    touchStartHandler: function touchStartHandler(event) {
      if (!this.isIos) return;
      if (event.touches && event.touches[0]) {
        this.touchStartTop = event.touches[0].pageY;
      }
    },
    touchMoveHandler: function touchMoveHandler(event) {
      if (!this.isIos) return;
      if (!event.touches || !event.touches[0]) return;

      var currentY = event.touches[0].pageY;
      var diffY = currentY - this.touchStartTop;

      if (window.pageYOffset === 0 && diffY > 30) {
        // Trigger a tiny scroll to force Safari to re-evaluate the viewport
        void document.body.offsetHeight;
        window.scrollBy(0, 1);
        window.scrollBy(0, -1);
      }
    },
    refreshAccessToken: function refreshAccessToken() {
      var _this5 = this;

      if (!this.token) return;
      var expiresAt = __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('tokenExpires', null);
      var threshold = -parseInt("60", 10);
      var hasExpired = expiresAt === null || __WEBPACK_IMPORTED_MODULE_2_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(expiresAt), 'seconds') > threshold;
      // no expires at or expires in less than a minute
      if (hasExpired) {
        var payload = {
          grant_type: 'refresh_token',
          refresh_token: __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('refreshToken')
        };
        this.login(payload).catch(function () {
          return _this5.clearAuthSession();
        });
      }
    },
    accessTokenRenewal: function accessTokenRenewal() {
      var _this6 = this;

      clearInterval(this.tokenInterval);
      this.tokenInterval = setInterval(function () {
        _this6.refreshAccessToken();
      }, parseInt("60", 10) * 1000);
    },
    showAttachToHomeNotification: function showAttachToHomeNotification() {
      // if (
      //   !this.token ||
      //   this.skipAttachToHomeNotification ||
      //   !this.isIos ||
      //   this.isStandalone ||
      //   this.currentPopup ||
      //   this.iOSWrapper ||
      //   !process.env.ATTACH_TO_HOME_POPUP_ENABLED ||
      //   !this.isLayoutMobile
      // ) return;
      // setTimeout(
      //   () => this.setCurrentPopup(MODALS.ATTACH_TO_HOME),
      //   constants.DEFAULT_SMALL_POPUP_TIMEOUT);
    },
    setupUI: function setupUI() {
      document.body.classList.remove('splash');
      if (this.isStandalone) document.body.classList.add('standalone');
      if (this.isIos) {
        document.documentElement.classList.add('ios');
        document.body.classList.add('ios');
      }
      if (this.isIE) {
        document.body.classList.add('ie');
      }
      if (this.isEdge) {
        document.body.classList.add('edge');
      }
      if (this.isWrapperApp) {
        document.body.classList.add('wrapper');
      }
      if (this.isShutdownModeOn) {
        document.body.classList.add('shutdown');
      }
    },
    pwaRedirect: function pwaRedirect() {
      var routePath = __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('currentRoutePath', null);
      if (this.isStandalone && routePath && routePath !== '/') {
        this.$router.push(routePath);
      } else if (this.isStandalone && routePath === null) {
        this.$router.push({ name: 'home' });
      }
    },
    routeQueryHandler: function routeQueryHandler() {
      if (this.$route.query.coinbase === 'success') {
        this.$router.push({ name: 'market-list' });
      }
      if (this.popupShown) {
        return;
      }

      var hasQuickDeposit = this.$route.query.quickdeposit && this.$route.query.quickdeposit === 'true' || this.$route.query.quick_deposit && this.$route.query.quick_deposit === 'true' || this.$route.query.quickDeposit && this.$route.query.quickDeposit === 'true';

      if (this.$route.name !== 'wallet' && hasQuickDeposit && this.isDepositEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
        this.popupShown = true;
      }

      var hasSignUp = this.$route.query.signupModal && this.$route.query.signupModal === 'true';
      var hasLogin = this.$route.query.loginModal && this.$route.query.loginModal === 'true';

      if (hasSignUp && !this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
        this.popupShown = true;
      } else if (hasLogin && !this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
        this.popupShown = true;
      }
    },
    initializeUserData: function initializeUserData() {
      // when user comes from social login we need to fetch data manually
      // because he doesnt have refreshToken witch causes
      // token watch to trigger
      if (__WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('refreshToken', null) && !SOCIAL_AUTH_ROUTES.includes(this.$route.name)) {
        this.refreshAccessToken();
      }
    },
    tokenHandler: function tokenHandler(newToken) {
      var _this7 = this;

      var secondsToDelay = parseInt("3", 10);

      if (this.initialised && !newToken) {
        clearTimeout(this.connectTimeout);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_api_http__["a" /* authorizeApi */])(null);
        var routeRequiresAuth = this.$route && this.$route.matched ? this.$route.matched.some(function (record) {
          return record.meta.requiresAuth;
        }) : true;
        __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__["a" /* default */].userLoggedOut();
        __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].logout();
        if (this.isWrapperApp) {
          this.loaderRemove(document.body);
          this.$router.push({ name: 'home' });
        } else {
          if (routeRequiresAuth) {
            window.location.href = "/";
          } else {
            this.routeQueryHandler();
          }
        }
      } else if (newToken) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_api_http__["a" /* authorizeApi */])(newToken);
        this.getUserData();
        __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__["a" /* default */].userLoggedIn(newToken);
        this.connectTimeout = setTimeout(function () {
          clearTimeout(_this7.connectTimeoutAnonymous);
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].init();
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].authorize(newToken);
          if (__WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].shouldSetupMessaging()) {
            __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[MESSAGING] User is opted in. Setting up messaging');
            __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].setupMessaging();
          } else {
            __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[MESSAGING] User is opted out or hasnt made messaging decision');
          }
        }, secondsToDelay * 1000);
        // this.accessTokenRenewal();
      } else {
        this.routeQueryHandler();
        this.connectTimeoutAnonymous = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].init();
        }, secondsToDelay * 1000);
      }
      this.initialised = true;
    },
    windowOnFocusHandler: function windowOnFocusHandler() {
      this.setIsTabActive(true);
    },
    windowOnBlurHandler: function windowOnBlurHandler() {
      this.setIsTabActive(false);
    },
    isTabActiveHandler: function isTabActiveHandler(value) {
      var _this8 = this;

      var secondsToDelay = parseInt("0", 10);
      if (!secondsToDelay) return;
      // no need to do that on mobile as browser closes tabs there
      if (this.isLayoutMobile) return;
      if (!this.isLoggedIn && !false) return;

      if (value) {
        clearTimeout(this.disconnectTimeout);
      } else {
        this.disconnectTimeout = setTimeout(function () {
          _this8.setLiveUpdatesDisabled(true);
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].forceDisconnect();
        }, secondsToDelay * 1000);
      }
    }
  }),
  watch: {
    settingColorPalette: {
      immediate: true,
      handler: function handler(palette) {
        var name = palette === __WEBPACK_IMPORTED_MODULE_20__store_modules_app__["a" /* APP_COLOR_PALETTE */].GREEN_RED ? 'green-red' : 'blue-grey';
        document.body.setAttribute('data-color-palette', name);
      }
    },
    token: {
      handler: 'tokenHandler',
      immediate: true
    },
    isTabActive: {
      handler: 'isTabActiveHandler',
      immediate: true
    }
  },
  created: function created() {
    this.setupUI();
    this.pwaRedirect();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_api_http__["a" /* authorizeApi */])(this.token);
    this.getHeaders();
    window.onfocus = this.windowOnFocusHandler;
    window.onblur = this.windowOnBlurHandler;
    window.addEventListener('orientationchange', this.orientationChangeHandler);
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('storage', this.storageHandler);
    window.addEventListener('touchstart', this.touchStartHandler, { passive: true });
    window.addEventListener('touchmove', this.touchMoveHandler, { passive: true });
    this.resizeHandler();
    this.initializeUserData();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.orientationChangeHandler);
    window.removeEventListener('resize', this.resizeHandler);
    window.removeEventListener('storage', this.storageHandler);
    window.removeEventListener('touchstart', this.touchStartHandler);
    window.removeEventListener('touchmove', this.touchMoveHandler);
  }
});

/***/ }),

/***/ "b8Ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_two_factor_verify_js__ = __webpack_require__("H1pb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400a71c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_two_factor_verify_vue__ = __webpack_require__("m7Pp");
function injectStyle (ssrContext) {
  __webpack_require__("tDB6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_two_factor_verify_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400a71c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_two_factor_verify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bAqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"market-contracts-list-header-sushi__item-2"},[_c('div',{staticClass:"market-contracts-list-header-sushi__item-2-text",class:{ 'market-contracts-list-header-sushi__item-2-text--clickable': !_vm.forCmsWidget },on:{"click":_vm.onMenuToggle}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('transition',{attrs:{"name":"market-contracts-list-header-sushi"}},[(_vm.showMenu)?_c('div',{staticClass:"market-contracts-list-header-sushi__menu"},[_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner"},[_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-item",on:{"click":function($event){return _vm.setOddsMode(true)}}},[_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-icon",class:{ 'market-contracts-list-header-sushi__menu-inner-icon--empty': !_vm.settingShowOdds }}),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-item-operation",class:{ 'market-contracts-list-header-sushi__menu-inner-item-operation--selected': _vm.settingShowOdds }},[_vm._v("\n            Odds\n          ")])]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-item",on:{"click":function($event){return _vm.setOddsMode(false)}}},[_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-icon",class:{ 'market-contracts-list-header-sushi__menu-inner-icon--empty': _vm.settingShowOdds }}),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-item-operation",class:{ 'market-contracts-list-header-sushi__menu-inner-item-operation--selected': !_vm.settingShowOdds }},[_vm._v("\n            Trade Prices\n          ")])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bBr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader"},[(_vm.theme === 'details')?[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]:_vm._e(),_vm._v(" "),(_vm.theme === 'withdraw')?[_c('div',{staticClass:"account-form-loader__alert"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__balance"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__input"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__line"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__button"})]:_vm._e(),_vm._v(" "),(_vm.theme === 'deposit')?[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bFAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_top_comment_js__ = __webpack_require__("xTWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00300fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_comment_vue__ = __webpack_require__("6WA/");
function injectStyle (ssrContext) {
  __webpack_require__("AzCe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_top_comment_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00300fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bFdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-mobile__menu-order"},[_c('menu-button',{attrs:{"type":_vm.selectedOrder.sort,"theme":_vm.theme,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-mobile__menu-timespans"},[_c('menu-button',{attrs:{"type":"timespan","theme":_vm.theme,"name":_vm.selectedTimespan.name,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-filters-mobile__menu-filters"},[_c('menu-button',{attrs:{"type":"filters","theme":_vm.theme,"name":_vm.filterMenuName,"active":_vm.filtersOpen,"arrow":true},on:{"click":_vm.toggleFilters}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.ordersOpen)?_c('div',{staticClass:"market-filters-mobile__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"theme":_vm.theme,"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort)},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.filtersOpen)?_c('div',{staticClass:"market-filters-mobile__filters"},[_c('a',{staticClass:"market-filters-mobile__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-mobile__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"theme":_vm.theme,"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.timespansOpen)?_c('div',{staticClass:"market-filters-mobile__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"theme":_vm.theme,"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_instant_credit__ = __webpack_require__("zAJv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("oiih");




/* eslint-disable max-len */









var TOKEN_EXPIRES_IN_MINUTES = 28;
var TOKEN_EXPIRES_DATE_FMT = 'YYYY-MM-DD HH:mm:s';

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  getters: {
    isLoggedIn: function isLoggedIn(state) {
      return !!state.token;
    },
    loginWithDisqus: function loginWithDisqus(state) {
      return state.disqusLogin && state.status.useDisqus;
    },
    isUserRestricted: function isUserRestricted(state, getters) {
      return false && !getters.isLoggedIn;
    }
  },
  state: {
    userUnreadNotificationsCount: 0,
    userData: {},
    userInfo: {},
    loginIsBeingCalled: false,
    ssnInfoVerified: false,
    token: __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('token'),
    refreshToken: __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('refreshToken'),
    status: {},
    disqusLogin: __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('disqusLogin', true),
    marketDisplay: 'grid',
    usernameTries: 0,
    watchedUserDetails: {},
    // marketDisplay: ls.get('marketDisplay', 'grid'),

    // Two-Factor Authentication
    twoFactorRequired: false,
    twoFactorToken: null,
    twoFactorMethods: [],
    twoFactorEmailHint: '',
    twoFactorPhoneHint: '',
    twoFactorSecondsUntilExpiry: 0,
    showTwoFactorPrompt: false,
    pendingLoginPayload: null,

    // Registration flow tracking - used to ensure 2FA prompt appears after signup flow
    registrationFlowActive: false,

    // Cached 2FA enabled status (fetched at login to avoid modal race conditions)
    twoFactorEnabled: null,
    // Flag to suppress ADD_FUNDS when navigating to 2FA setup
    navigatingToTwoFactorSetup: false
  },
  mutations: {
    login: function login(state, user) {
      state.token = user.access_token;
      state.refreshToken = user.refresh_token;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('token', user.access_token);
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('tokenExpires', __WEBPACK_IMPORTED_MODULE_4_moment___default()(user['.expires']).format(TOKEN_EXPIRES_DATE_FMT));
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('refreshToken', user.refresh_token);
    },
    logout: function logout(state) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      state.token = data;
      state.refreshToken = data;
      state.userData = {};
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('tokenExpires');
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('currentRoutePath');
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('token');
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('refreshToken');
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('disqusLogin');
      __WEBPACK_IMPORTED_MODULE_7__helpers_sessionVars__["a" /* default */].clear();
      __WEBPACK_IMPORTED_MODULE_8__services_instant_credit__["a" /* default */].clear();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_notifications_firebase__["e" /* cleanupMessaging */])();
    },
    clearRefreshToken: function clearRefreshToken(state) {
      state.refreshToken = null;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('refreshToken');
    },
    setStatus: function setStatus(state, status) {
      state.status = status;
    },
    setUserData: function setUserData(state, data) {
      state.userData = data;
    },
    increaseUserUnreadNotificationsCount: function increaseUserUnreadNotificationsCount(state) {
      state.userUnreadNotificationsCount += 1;
    },
    setUserUnreadNotificationsCount: function setUserUnreadNotificationsCount(state, count) {
      state.userUnreadNotificationsCount = count;
    },
    setUserInfo: function setUserInfo(state, data) {
      state.userInfo = data;
    },
    setBareToken: function setBareToken(state, data) {
      state.token = data;
    },
    setToken: function setToken(state, data) {
      var expires = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(TOKEN_EXPIRES_IN_MINUTES, 'minutes').format(TOKEN_EXPIRES_DATE_FMT);
      state.token = data;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('token', data);
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('tokenExpires', expires);
    },
    setRefreshToken: function setRefreshToken(state, data) {
      state.refreshToken = data;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('refreshToken', data);
    },
    updateMarketDisplay: function updateMarketDisplay(state, payload) {
      state.marketDisplay = payload;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('marketDisplay', payload, "31536000");
    },
    setUseDisqus: function setUseDisqus(state, payload) {
      if (payload) {
        state.disqusLogin = true;
        __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('disqusLogin', payload, "31536000");
      } else {
        state.disqusLogin = false;
        __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('disqusLogin');
      }
    },
    setUsernameTries: function setUsernameTries(state, count) {
      state.usernameTries = count;
    },
    setLoginIsBeingCalled: function setLoginIsBeingCalled(state, value) {
      state.loginIsBeingCalled = value;
    },
    setWatchedUserDetails: function setWatchedUserDetails(state, trader) {
      state.watchedUserDetails = trader;
    },
    setSsnInfoVerified: function setSsnInfoVerified(state) {
      state.ssnInfoVerified = true;
    },


    // Two-Factor Authentication
    setTwoFactorChallenge: function setTwoFactorChallenge(state, data) {
      state.twoFactorRequired = true;
      state.twoFactorToken = data.two_factor_token;
      state.twoFactorMethods = data.available_methods || [];
      state.twoFactorEmailHint = data.email_hint || '';
      state.twoFactorPhoneHint = data.phone_hint || '';
      state.twoFactorSecondsUntilExpiry = data.seconds_until_expiry || 300;
    },
    clearTwoFactorChallenge: function clearTwoFactorChallenge(state) {
      state.twoFactorRequired = false;
      state.twoFactorToken = null;
      state.twoFactorMethods = [];
      state.twoFactorEmailHint = '';
      state.twoFactorPhoneHint = '';
      state.twoFactorSecondsUntilExpiry = 0;
      state.pendingLoginPayload = null;
    },
    setShowTwoFactorPrompt: function setShowTwoFactorPrompt(state, value) {
      state.showTwoFactorPrompt = value;
    },
    setPendingLoginPayload: function setPendingLoginPayload(state, payload) {
      state.pendingLoginPayload = payload;
    },


    // Registration flow
    setRegistrationFlowActive: function setRegistrationFlowActive(state) {
      state.registrationFlowActive = true;
    },
    clearRegistrationFlowActive: function clearRegistrationFlowActive(state) {
      state.registrationFlowActive = false;
    },
    setTwoFactorEnabled: function setTwoFactorEnabled(state, value) {
      state.twoFactorEnabled = value;
    },
    setNavigatingToTwoFactorSetup: function setNavigatingToTwoFactorSetup(state, value) {
      state.navigatingToTwoFactorSetup = value;
    }
  },
  actions: {
    loginDisqus: function loginDisqus() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getDisqusLogin().then(function (response) {
        return response.data;
      });
    },
    logoutDisqus: function logoutDisqus() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getDisqusLogout().then(function (response) {
        return response.data;
      });
    },
    getDisqusUserAuth: function getDisqusUserAuth() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getDisqusUserAuth().then(function (response) {
        return response.data;
      });
    },
    login: function login(_ref) {
      var commit = _ref.commit,
          state = _ref.state;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (state.loginIsBeingCalled) return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve({});

      commit('setLoginIsBeingCalled', true);
      commit('setPendingLoginPayload', payload);

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postToken(payload).then(function (response) {
        commit('setLoginIsBeingCalled', false);
        commit('login', response.data);

        // Check if 2FA prompt should be shown for non-2FA users
        if (response.data.showTwoFactorPrompt === 'true') {
          commit('setShowTwoFactorPrompt', true);
        }

        return response.data;
      }).catch(function (error) {
        commit('setLoginIsBeingCalled', false);

        // Check for 2FA challenge response
        if (error.response && error.response.data && error.response.data.error === 'two_factor_required') {
          try {
            var twoFactorData = JSON.parse(error.response.data.error_description);
            commit('setTwoFactorChallenge', twoFactorData);
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ requiresTwoFactor: true }, twoFactorData);
          } catch (parseError) {
            // If parsing fails, throw original error
            throw error;
          }
        }

        throw error;
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postLogout().then(function () {
        commit('logout', data);
      }).catch(function () {
        commit('logout', data);
      });
    },
    clearAuthSession: function clearAuthSession(_ref3) {
      var commit = _ref3.commit;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      commit('logout', data);
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
    },
    register: function register(_ref4, payload) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postRegister(payload);
    },
    registerExternal: function registerExternal(_ref5, payload) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postRegisterExternal(payload);
    },
    getExternalLogins: function getExternalLogins(_ref6, _ref7) {
      var commit = _ref6.commit;
      var _ref7$pathname = _ref7.pathname,
          pathname = _ref7$pathname === undefined ? window.location.pathname : _ref7$pathname,
          _ref7$type = _ref7.type,
          type = _ref7$type === undefined ? __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* default */].SOCIAL_LOGIN_OR_REGISTER : _ref7$type;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getExternalLogins(pathname, type);
    },
    addExternal: function addExternal(_ref8, payload) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postAddExternalLogin(payload).then(function (response) {
        return response.data;
      });
    },
    removeExternal: function removeExternal(_ref9, payload) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postRemoveLogin(payload).then(function (response) {
        return response.data;
      });
    },
    getUserInfo: function getUserInfo(_ref10) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getUserInfo().then(function (response) {
        commit('setUserInfo', response.data);
        return response;
      });
    },
    getManageInfo: function getManageInfo() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getManageInfo().then(function (response) {
        return response.data;
      });
    },
    getAccountDetail: function getAccountDetail(_ref11) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getAccountDetail().then(function (response) {
        commit('setUserData', response.data);
        return response.data;
      });
    },
    getVerifyID: function getVerifyID() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getVerifyID().then(function (response) {
        return response;
      });
    },
    verifyID: function verifyID(_ref12, payload) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postVerifyID(payload).then(function (response) {
        return response.data;
      });
    },
    getStatus: function getStatus(_ref13) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getStatus().then(function (response) {
        commit('setStatus', response.data);
        return response.data;
      });
    },
    resetPassword: function resetPassword(_ref14, payload) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postResetPassword(payload);
    },
    forgotPassword: function forgotPassword(_ref15, payload) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postForgotPassword(payload).then(function (response) {
        return response.data;
      });
    },
    changePassword: function changePassword(_ref16, payload) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postChangePassword(payload);
    },
    setPassword: function setPassword(_ref17, payload) {
      var commit = _ref17.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postSetPassword(payload);
    },
    uploadUserImage: function uploadUserImage(_ref18, payload) {
      var commit = _ref18.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postUploadUserImage(payload);
    },
    resetUserImage: function resetUserImage() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.putResetUserImage();
    },
    getCommunicationPreferences: function getCommunicationPreferences() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getCommunicationPreferences().then(function (response) {
        return response.data;
      });
    },
    setCommunicationPreferences: function setCommunicationPreferences(_ref19, payload) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postCommunicationPreferences(payload).then(function (response) {
        return response.data;
      });
    },
    setBareToken: function setBareToken(_ref20, payload) {
      var commit = _ref20.commit;

      commit('setBareToken', payload);
    },
    setToken: function setToken(_ref21, payload) {
      var commit = _ref21.commit;

      commit('setToken', payload);
    },
    setRefreshToken: function setRefreshToken(_ref22, payload) {
      var commit = _ref22.commit;

      commit('setRefreshToken', payload);
    },
    getCaptchaSiteKey: function getCaptchaSiteKey() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getCaptchaSiteKey().then(function (response) {
        return response.data;
      });
    },
    setUseDisqus: function setUseDisqus(_ref23) {
      var commit = _ref23.commit;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('setUseDisqus', payload);
        resolve();
      });
    },
    getIdUploadUrl: function getIdUploadUrl() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getIdUploadUrl().then(function (response) {
        return response.data;
      });
    },
    getTaxInfo: function getTaxInfo(_ref24, _ref25) {
      var commit = _ref24.commit;
      var _ref25$reasonCode = _ref25.reasonCode,
          reasonCode = _ref25$reasonCode === undefined ? '' : _ref25$reasonCode;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getTaxInfo({ reasonCode: reasonCode }).then(function (response) {
        return response.data;
      });
    },
    postTaxInfo: function postTaxInfo(_ref26, payload) {
      var commit = _ref26.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTaxInfo(payload).then(function (response) {
        return response.data;
      });
    },
    updateMarketDisplay: function updateMarketDisplay(_ref27, payload) {
      var commit = _ref27.commit;

      return commit('updateMarketDisplay', payload);
    },
    clearRefreshToken: function clearRefreshToken(_ref28) {
      var commit = _ref28.commit;

      commit('clearRefreshToken');
    },
    setUserUnreadNotificationsCount: function setUserUnreadNotificationsCount(_ref29, count) {
      var commit = _ref29.commit;

      commit('setUserUnreadNotificationsCount', count);
    },
    increaseUserUnreadNotificationsCount: function increaseUserUnreadNotificationsCount(_ref30) {
      var commit = _ref30.commit;

      commit('increaseUserUnreadNotificationsCount');
    },
    getUserNameTries: function getUserNameTries(_ref31) {
      var commit = _ref31.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getChangeUsername().then(function (response) {
        commit('setUsernameTries', response.data);
        return response.data;
      });
    },
    changeUserName: function changeUserName(_ref32, username) {
      var commit = _ref32.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postChangeUsername(username).then(function (response) {
        return response.data;
      });
    },
    getDocumentUploadLink: function getDocumentUploadLink(_ref33, source) {
      var commit = _ref33.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getDocumentUploadLink(source).then(function (response) {
        return response.data;
      });
    },
    setWatchedUserDetails: function setWatchedUserDetails(_ref34, trader) {
      var commit = _ref34.commit;

      commit('setWatchedUserDetails', trader);
    },
    agreeToTerms: function agreeToTerms(_ref35, payload) {
      var commit = _ref35.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.putAgreedToTerms(payload).then(function (response) {
        return response.data;
      });
    },
    setSsnInfoVerified: function setSsnInfoVerified(_ref36) {
      var commit = _ref36.commit;

      commit('setSsnInfoVerified');
    },


    // Two-Factor Authentication actions
    twoFactorSendCode: function twoFactorSendCode(_ref37, _ref38) {
      var state = _ref37.state;
      var method = _ref38.method;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSendCode({
        twoFactorToken: state.twoFactorToken,
        method: method
      }).then(function (response) {
        return response.data;
      });
    },
    twoFactorVerify: function twoFactorVerify(_ref39, _ref40) {
      var commit = _ref39.commit,
          state = _ref39.state;
      var method = _ref40.method,
          code = _ref40.code;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorVerify({
        twoFactorToken: state.twoFactorToken,
        method: method,
        code: code
      }).then(function (response) {
        commit('clearTwoFactorChallenge');
        commit('login', response.data);
        return response.data;
      });
    },
    getTwoFactorStatus: function getTwoFactorStatus() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getTwoFactorStatus().then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupEmailSendCode: function twoFactorSetupEmailSendCode() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupEmailSendCode().then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupEmailVerify: function twoFactorSetupEmailVerify(_ref41, _ref42) {
      var commit = _ref41.commit;
      var code = _ref42.code;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupEmailVerify({ code: code }).then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupPhoneSendCode: function twoFactorSetupPhoneSendCode() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupPhoneSendCode().then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupPhoneVerify: function twoFactorSetupPhoneVerify(_ref43, _ref44) {
      var commit = _ref43.commit;
      var code = _ref44.code;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupPhoneVerify({ code: code }).then(function (response) {
        return response.data;
      });
    },
    getTwoFactorSetupAuthenticator: function getTwoFactorSetupAuthenticator() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getTwoFactorSetupAuthenticator().then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupAuthenticatorVerify: function twoFactorSetupAuthenticatorVerify(_ref45, _ref46) {
      var commit = _ref45.commit;
      var code = _ref46.code,
          encryptedSecret = _ref46.encryptedSecret;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupAuthenticatorVerify({ code: code, encryptedSecret: encryptedSecret }).then(function (response) {
        return response.data;
      });
    },
    twoFactorEnable: function twoFactorEnable(_ref47) {
      var commit = _ref47.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorEnable().then(function (response) {
        // Update cached state so modal handlers know 2FA is now enabled
        commit('setTwoFactorEnabled', true);
        return response.data;
      });
    },
    twoFactorDisable: function twoFactorDisable(_ref48) {
      var commit = _ref48.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorDisable().then(function (response) {
        // Update cached state so modal handlers know 2FA is now disabled
        commit('setTwoFactorEnabled', false);
        return response.data;
      });
    },


    // Phone Management actions
    getPhone: function getPhone() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getPhone().then(function (response) {
        return response.data;
      });
    },
    phoneUpdate: function phoneUpdate(_, _ref49) {
      var phoneNumber = _ref49.phoneNumber;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postPhoneUpdate({ phoneNumber: phoneNumber }).then(function (response) {
        return response.data;
      });
    },
    phoneVerify: function phoneVerify(_, _ref50) {
      var phoneNumber = _ref50.phoneNumber,
          code = _ref50.code;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postPhoneVerify({ phoneNumber: phoneNumber, code: code }).then(function (response) {
        return response.data;
      });
    },
    dismissTwoFactorPrompt: function dismissTwoFactorPrompt(_ref51) {
      var commit = _ref51.commit;

      commit('setShowTwoFactorPrompt', false);
    },
    clearTwoFactorChallenge: function clearTwoFactorChallenge(_ref52) {
      var commit = _ref52.commit;

      commit('clearTwoFactorChallenge');
    },


    // Registration flow actions
    startRegistrationFlow: function startRegistrationFlow(_ref53) {
      var commit = _ref53.commit;

      commit('setRegistrationFlowActive');
    },
    endRegistrationFlow: function endRegistrationFlow(_ref54) {
      var commit = _ref54.commit;

      commit('clearRegistrationFlowActive');
    },


    // 2FA status caching for modal flow decisions
    checkAndCacheTwoFactorStatus: function checkAndCacheTwoFactorStatus(_ref55) {
      var _this = this;

      var commit = _ref55.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, status;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getTwoFactorStatus();

              case 3:
                response = _context.sent;
                status = response.data;

                commit('setTwoFactorEnabled', status.is_two_factor_enabled);
                return _context.abrupt('return', status.is_two_factor_enabled);

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                // On error, assume 2FA not enabled (safe default, will show prompt)
                commit('setTwoFactorEnabled', false);
                return _context.abrupt('return', false);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    setNavigatingToTwoFactorSetup: function setNavigatingToTwoFactorSetup(_ref56, value) {
      var commit = _ref56.commit;

      commit('setNavigatingToTwoFactorSetup', value);
    }
  }
});

/***/ }),

/***/ "bTYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [],
      swiperOptions: {
        loop: false,
        autoplay: 5000,
        direction: 'horizontal',
        pagination: '.hero-unit-slider__pagination',
        paginationClickable: true
      }
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getCarousel']), {
    onNavigate: function onNavigate(banner) {
      if (banner.carouselData.carouselItemButton.url) {
        window.location.href = banner.carouselData.carouselItemButton.url;
      } else if (banner.carouselData.marketId) {
        this.$router.push({ name: 'market-details', params: { marketId: banner.carouselData.marketId } });
      }
    },
    bannerImageStyleModifiers: function bannerImageStyleModifiers(url) {
      if (!url) return {};
      return {
        'background-image': 'url(\'' + url + '\')'
      };
    },
    buttonStyleModifiers: function buttonStyleModifiers(button) {
      var styles = {};
      if (button.backgroundColor) {
        styles.backgroundColor = button.backgroundColor;
        styles.borderColor = button.backgroundColor;
      }
      return styles;
    }
  }),
  created: function created() {
    var _this = this;

    this.getCarousel().then(function (data) {
      _this.items = data;
    });
  }
});

/***/ }),

/***/ "bUan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__ = __webpack_require__("P71F");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__["a" /* default */]],
  metaInfo: function metaInfo() {
    return {
      title: 'News'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull']), {
    installCategoryNav: function installCategoryNav() {
      var categoryNav = this.$el.querySelector('#g-newshubpage .g_newshubpage_cls_category-nav');
      var categoryNavButtons = categoryNav ? categoryNav.querySelectorAll('button') : [];
      var newsItems = this.$el.querySelectorAll('#g-newshubpage .g_newshubpage_cls_js-news-item');

      categoryNavButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          categoryNavButtons.forEach(function (btn) {
            return btn.classList.remove('g_newshubpage_cls_active');
          });
          e.currentTarget.classList.add('g_newshubpage_cls_active');

          var category = e.currentTarget.textContent.trim();
          newsItems.forEach(function (item) {
            var itemCategory = item.getAttribute('data-category') || '';
            var show = category === 'All' || itemCategory === category;
            item.style.display = show ? '' : 'none';
          });
        });
      });
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* STATIC_PAGES */].NEWS).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
      _this.$nextTick(function () {
        _this.installCategoryNav();
      });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).catch(function () {
      _this.isComponentReady = true;
      _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "bWBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bXjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"market-watch"}},[(_vm.show)?_c('button',{staticClass:"market-watch",class:_vm.classModifiers,attrs:{"title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.onWatchToggle($event)}}},[_vm._v("\n     \n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bXzy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bYWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_main_nav_app_main_nav_vue__ = __webpack_require__("3cKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_unreadNotification__ = __webpack_require__("BL43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notifications_widget_notifications_widget_vue__ = __webpack_require__("oY3V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_hamburger_icon_hamburger_icon_vue__ = __webpack_require__("MRVZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_headerNav__ = __webpack_require__("drLe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_header_header_search_header_search_vue__ = __webpack_require__("h41O");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_headerNav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_unreadNotification__["a" /* default */]],
  components: {
    appMainNav: __WEBPACK_IMPORTED_MODULE_2__components_app_app_main_nav_app_main_nav_vue__["a" /* default */],
    hamburgerIcon: __WEBPACK_IMPORTED_MODULE_5__components_hamburger_icon_hamburger_icon_vue__["a" /* default */],
    notificationsWidget: __WEBPACK_IMPORTED_MODULE_4__components_notifications_widget_notifications_widget_vue__["a" /* default */],
    headerSearch: __WEBPACK_IMPORTED_MODULE_7__components_app_app_header_header_search_header_search_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['mobileMenuOpened']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['showNotificationsWidget']), {
    isNotificationsWidgetDisabled: function isNotificationsWidgetDisabled() {
      return this.$route && this.$route.name === 'dashboard-notifications' || this.mobileMenuOpened;
    },
    isNotificationIconActive: function isNotificationIconActive() {
      return this.$route.name === 'notifications' || this.showNotificationsWidget;
    },
    showUnreadNotificationCount: function showUnreadNotificationCount() {
      return !this.isNotificationIconActive && this.userUnreadNotificationsCountHeader > 0;
    },
    notificationsIconModifiers: function notificationsIconModifiers() {
      return {
        'app-header__notifications': true,
        'app-header__notifications--disabled': this.isNotificationsWidgetDisabled,
        'app-header__notifications--unread': this.showUnreadNotificationCount,
        'app-header__notifications--active': this.isNotificationIconActive
      };
    },
    depositClassModifiers: function depositClassModifiers() {
      var disabled = this.$route.name === 'wallet';
      return {
        'app-header__menu-item': true,
        'app-header__menu-item--deposit': true,
        'app-header__menu-item--disabled': disabled
      };
    }
  }),
  watch: {
    $route: function $route() {
      this.closeNotificationsWidget();
    },
    showNotificationsWidget: function showNotificationsWidget(value) {
      if (!value) {
        this.clearAllNotifications();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['toggleNotificationsWidget', 'closeNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar', 'closeSearchBar']), {
    onNotificationsClick: function onNotificationsClick() {
      if (!this.isNotificationsWidgetDisabled) {
        this.toggleNotificationsWidget();
        this.closeSearchBar();
      }
    }
  })
});

/***/ }),

/***/ "bbNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: String,
    text: String,
    url: String,
    styleVariant: {
      type: String,
      default: ''
    }
  },
  computed: {
    isLink: function isLink() {
      return this.type === 'link';
    },
    isButton: function isButton() {
      return this.type === 'button';
    },
    isStoryFooterCta: function isStoryFooterCta() {
      return this.styleVariant === 'story-footer-cta';
    },
    linkClass: function linkClass() {
      return {
        link: true,
        'link--regular': this.isLink,
        'link--story-footer-cta': this.isLink && this.isStoryFooterCta
      };
    },
    displayText: function displayText() {
      if (!this.isStoryFooterCta) {
        return this.text;
      }

      return (this.text || '').replace(/\s*→\s*$/, '').trim();
    }
  }
});

/***/ }),

/***/ "bfFv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bkfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_footer_js__ = __webpack_require__("NGyh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f4022ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__ = __webpack_require__("2KqR");
function injectStyle (ssrContext) {
  __webpack_require__("kyMZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f4022ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "blr7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refine-history"},[_c('div',{staticClass:"refine-history__header"},[_vm._v("Market")]),_vm._v(" "),(_vm.list.length === 0)?_c('div',{staticClass:"refine-history__loaded-info"},[_vm._v("\n    No trades in the past 30 days\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item){return (_vm.list.length > 0)?_c('refine-link',{key:item.marketId,staticClass:"refine-history__item",attrs:{"name":item.marketTitle,"data":item},on:{"click":_vm.onClick}}):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "br/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ach"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"withdraw"}}):[(!_vm.showConfirmation)?_c('div',[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending}}):[(!_vm.hasErrorMessage)?[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n          Withdrawing funds may cause some or all of your open orders to be cancelled.\n        ")]),_vm._v(" "),_c('form',{staticClass:"form ach__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('available-balance',{attrs:{"restricted":_vm.restrictedFunds,"balance":_vm.availableBalance}}),_vm._v(" "),(_vm.newAccountMode)?_c('div',[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"theme":"amount","name":"amount","validation":_vm.$v.fields.amount,"disabled":_vm.isAmountFieldDisabled,"autocomplete":"","placeholder":"Withdrawal Amount (Minimum $1 USD)"},on:{"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.routingNumber,"name":"routingNumber","type":"text","required":true,"disabled":_vm.hasErrorMessage,"autocomplete":"","placeholder":"Routing Number"},on:{"input":_vm.$v.fields.routingNumber.$touch},model:{value:(_vm.fields.routingNumber),callback:function ($$v) {_vm.$set(_vm.fields, "routingNumber", $$v)},expression:"fields.routingNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.accountNumber,"name":"accountNumber","type":"text","required":true,"disabled":_vm.hasErrorMessage,"autocomplete":"","placeholder":"Account Number"},on:{"input":_vm.$v.fields.accountNumber.$touch},model:{value:(_vm.fields.accountNumber),callback:function ($$v) {_vm.$set(_vm.fields, "accountNumber", $$v)},expression:"fields.accountNumber"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('notification-icon',{attrs:{"text":"Where can I find this information?"},on:{"showPopup":_vm.showRoutingNumberModal}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("Account Type")])])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},_vm._l((_vm.accountTypes),function(item){return _c('form-radio',{key:item.index,staticClass:"ach__radio",attrs:{"name":"accountType","label":item.label,"value":item.index,"required":true,"disabled":_vm.hasErrorMessage},model:{value:(_vm.fields.accountType),callback:function ($$v) {_vm.$set(_vm.fields, "accountType", $$v)},expression:"fields.accountType"}})}),1)])]):_c('div',[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"theme":"amount","validation":_vm.$v.fields.amount,"disabled":_vm.isAmountFieldDisabled,"name":"amount","autocomplete":"","placeholder":"Withdrawal Amount (Minimum $1 USD)"},on:{"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-7"},[_c('div',{staticClass:"ach__account-note"},[_vm._v("\n                  Your withdrawal will be sent to your bank account ending in\n                  "),_c('strong',[_vm._v("*******"+_vm._s(_vm.ach.achAccountNumberLastFour))])])]),_vm._v(" "),_c('div',{staticClass:"column small-5"},[_c('span',{staticClass:"ach__change",on:{"click":function($event){$event.preventDefault();return _vm.onChangeAccount($event)}}},[_vm._v("\n                  Change\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Review Request"}})],1)])],1)]:_vm._e(),_vm._v(" "),(_vm.hasErrorMessage)?_c('alert-box',{attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.hasErrorMessage)?[_c('p',{staticClass:"ach__disclaimer"},[_vm._v("\n          Your banking information will be saved in a secure environment.\n          PredictIt can store information on only one bank account at a time.\n        ")]),_vm._v(" "),_c('p',{staticClass:"ach__disclaimer"},[_vm._v("\n          We remit funds via ACH only to verified account holders with US bank accounts. Withdrawals are subject to a 5% fee and are typically processed twice per week. If authorized, funds should be deposited to your bank account within five business days.\n        ")])]:_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.showConfirmation)?_c('withdraw-confirm',{staticClass:"withdraw-confirm--with-margin",attrs:{"kind":"ach","amendAvailable":true,"amount":Number(_vm.fields.amount),"fee":Number(_vm.fields.amount) * Number(_vm.ach.feePercent),"accountDetails":_vm.accountDetails},on:{"edit":_vm.onEdit,"success":_vm.onSuccess}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "btoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[(_vm.showDetails)?_c('small-modal',{on:{"modalClose":function($event){_vm.showDetails = false}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.isMarketSettled(_vm.market))?[_vm._v("\n        The market is settled."),_c('br'),_vm._v(" "+_vm._s(_vm.settledOutcome)+"\n      ")]:(_vm.isMarketExpired(_vm.market))?[_vm._v("\n       Trading has closed while settlement is pending.\n      ")]:(_vm.isMarketSuspended(_vm.market))?[_vm._v("\n        Trading is temporarily suspended for this market.\n      ")]:(_vm.isMarketStatusClosed(_vm.market))?[_vm._v("\n        This market has closed."),_c('br'),_c('br'),_vm._v(" Visit our "),_c('router-link',{attrs:{"to":{ name: 'market-list' }}},[_vm._v("Markets Page")]),_vm._v(" to find active markets.\n      ")]:_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-alert-v2__title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-alert-v2__text"},[(_vm.isLayoutMobile)?[(_vm.isMarketSettled(_vm.market))?[_vm._v("\n          The market is settled.\n        ")]:(_vm.isMarketSuspended(_vm.market))?[_vm._v("\n          Trading is suspended.\n        ")]:_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-alert-v2__details-link",on:{"click":function($event){_vm.showDetails = true}}},[_vm._v("\n          View Details\n        ")])]:(_vm.isMarketSettled(_vm.market))?[_vm._v("\n        The market is settled. "+_vm._s(_vm.settledOutcome)+"\n      ")]:(_vm.isMarketExpired(_vm.market))?[_vm._v("\n       Trading has closed while settlement is pending.\n      ")]:(_vm.isMarketSuspended(_vm.market))?[_vm._v("\n        Trading is temporarily suspended for this market.\n      ")]:(_vm.isMarketStatusClosed(_vm.market))?[_vm._v("\n        This market has closed."),_c('br'),_c('br'),_vm._v(" Visit our "),_c('router-link',{attrs:{"to":{ name: 'market-list' }}},[_vm._v("Markets Page")]),_vm._v(" to find active markets.\n      ")]:_vm._e()],2)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bvK5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  created: function created() {
    if (this.activeTab) {
      this.onChange(this.activeTab, true);
    } else if (this.items.length > 0) {
      this.onChange(this.items[0].name);
    }
  },
  data: function data() {
    return {
      currentTab: this.activeTab
    };
  },

  watch: {
    activeTab: function activeTab(tab) {
      if (tab !== this.currentTab) {
        this.onChange(tab);
      }
    }
  },
  methods: {
    tabLinkModifiers: function tabLinkModifiers(item) {
      var _ref;

      return _ref = {
        tabs__link: true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link-name-' + item.name, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--with-icon', item.icon), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--' + this.theme + '-' + item.name, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--stats', item.kind && item.kind === 'stats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--active', item.name === this.currentTab), _ref;
    },
    tabItemModifiers: function tabItemModifiers(item) {
      return {
        tabs__item: true,
        'tabs__item--stats': item.kind && item.kind === 'stats'
      };
    },
    tabIconModifiers: function tabIconModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        tabs__icon: true
      }, 'tabs__icon--' + item.icon, item.icon);
    },
    onChange: function onChange(name) {
      var startedWithActiveTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (name !== this.currentTab) {
        this.currentTab = name;
        this.$emit('tabChange', name);
      } else if (startedWithActiveTab) {
        this.$emit('tabChange', this.currentTab);
      }
    }
  }
});

/***/ }),

/***/ "bwq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__("H/Zg");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    mostPopular: null,
    analysis: null,
    news: []
  },
  mutations: {
    updateMostPopular: function updateMostPopular(state, payload) {
      state.mostPopular = payload;
    },
    updateAnalysis: function updateAnalysis(state, payload) {
      state.analysis = payload;
    },
    updateNews: function updateNews(state, payload) {
      state.news = payload;
    }
  },
  actions: {
    getMostPopular: function getMostPopular(_ref, payload) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getMostPopular(payload.interval, payload.count).then(function (response) {
        commit('updateMostPopular', response.data);
        return response.data;
      });
    },
    getAnalysis: function getAnalysis(_ref2, _ref3) {
      var commit = _ref2.commit;
      var _ref3$limit = _ref3.limit,
          limit = _ref3$limit === undefined ? 4 : _ref3$limit,
          _ref3$offset = _ref3.offset,
          offset = _ref3$offset === undefined ? 0 : _ref3$offset;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getAnalysis(limit, offset).then(function (response) {
        commit('updateAnalysis', response.data);
        return response.data;
      });
    },
    getFeeds: function getFeeds() {
      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getFeeds().then(function (response) {
        return response.data;
      });
    },
    getMarketFeeds: function getMarketFeeds(_ref4, marketId) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getMarketFeeds(marketId).then(function (response) {
        return response.data;
      });
    },
    getNews: function getNews(_ref5) {
      var commit = _ref5.commit;

      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$limit = _ref6.limit,
          limit = _ref6$limit === undefined ? 4 : _ref6$limit,
          _ref6$offset = _ref6.offset,
          offset = _ref6$offset === undefined ? 0 : _ref6$offset;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getNews(limit, offset).then(function (response) {
        commit('updateNews', response.data);
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "bynG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_rules_js__ = __webpack_require__("1FJm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2f909f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_rules_vue__ = __webpack_require__("qZUk");
function injectStyle (ssrContext) {
  __webpack_require__("6vwd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_rules_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2f909f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_rules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bzSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return capitalizeFirstLetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRedirectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DEFAULT_DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return dateToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return priceDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return updateObjectValues; });
/* unused harmony export capitalize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toCents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return correctPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return isNumber; });
/* unused harmony export hasLastTradePrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getLeadingTradedContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isMarketSingle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return contractOwnershipNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isMarketSettled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return isMarketExpired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return isMarketSuspended; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return isMarketMaintenance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return isMarketStatusClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return isMarketClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isMarketDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return isMarketJourneyDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return hasMarketPayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasMarketHiddenContracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return isContractOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isHighChartsReady; });
/* harmony export (immutable) */ __webpack_exports__["u"] = largeNumberDisplay;
/* unused harmony export elementOffset */
/* harmony export (immutable) */ __webpack_exports__["F"] = lockScroll;
/* harmony export (immutable) */ __webpack_exports__["E"] = unlockScroll;
/* harmony export (immutable) */ __webpack_exports__["l"] = lockModal;
/* harmony export (immutable) */ __webpack_exports__["m"] = unLockModal;
/* harmony export (immutable) */ __webpack_exports__["J"] = marketUserGainLoss;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasNoPositionInAMarketBesidesLoadedContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return smartbtoa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return smartatob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return groupByKeepOrder; });
/* harmony export (immutable) */ __webpack_exports__["h"] = roundToTwo;
/* harmony export (immutable) */ __webpack_exports__["G"] = roundDown;
/* unused harmony export roundTop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCardTypeForNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getOrdinalSuffix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return parseQuery; });
/* unused harmony export checkIfKeyExist */
/* unused harmony export loginUrl */
/* unused harmony export signUpUrl */
/* unused harmony export editAccountDetailsUrl */
/* unused harmony export verifyDetailsUrl */
/* unused harmony export logoutUrl */
/* unused harmony export changeAvatarImageUrl */
/* unused harmony export registerPersonalDetailsUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getAssetPath; });
/* unused harmony export isVisibleInViewport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return stripTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isEmptyHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return uuidv4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_maxBy__ = __webpack_require__("K1hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_sessionVars__ = __webpack_require__("DECz");







/* global Highcharts:false */
/* eslint-disable */








var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
var getRedirectUrl = function getRedirectUrl(path) {
  var rootPath = "/".slice(0, -1);
  return window.location.protocol + '//' + window.location.host + rootPath + path;
};
var DEFAULT_DATE_FORMAT = 'MM/DD/YYYY hh:mm a';

var dateToString = function dateToString(string) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  return __WEBPACK_IMPORTED_MODULE_7_moment___default()(string).format(fmt) + ' (ET)';
};
var priceDisplay = function priceDisplay(num) {
  return num.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
var updateObjectValues = function updateObjectValues(obj, data) {
  var map = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var setTimestampFor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [__WEBPACK_IMPORTED_MODULE_9__services_notifications_proxy__["b" /* NOTIFICATION_CONTRACT_OWNERSHIP */]];

  var result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, obj);
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    var timestampKey = 'timestamp';
    var objKey = typeof map[key] !== 'undefined' ? map[key] : key;
    if (typeof result[objKey] !== 'undefined' && objKey !== timestampKey || setTimestampFor.includes(data.UpdateType) && objKey === timestampKey) {
      // timestamp prop is updated only for certain notifications
      result[objKey] = data[key];
    }
  });

  return result;
};
var capitalize = function capitalize(input) {
  return input.charAt(0).toUpperCase() + input.slice(1);
};
var toCents = function toCents(input) {
  return Math.round(100 * input);
};
var correctPrice = function correctPrice(input) {
  return !isNaN(input) && input < 100 ? input : 0;
};
var isNumber = function isNumber(input) {
  return !isNaN(parseFloat(input)) && isFinite(input);
};
var hasLastTradePrice = function hasLastTradePrice(contract) {
  var value = Number(contract && contract.lastTradePrice);
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(value) && Math.round(100 * value) > 0;
};
var getLeadingTradedContract = function getLeadingTradedContract() {
  var contracts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var results = (contracts || []).filter(hasLastTradePrice);
  return results.length > 0 ? __WEBPACK_IMPORTED_MODULE_5_lodash_maxBy___default()(results, function (i) {
    return i.lastTradePrice;
  }) : null;
};
var isMarketSingle = function isMarketSingle(market) {
  return market && (market.type === 'Single' || market.marketType === 0 || market.MarketType === 0);
};
var contractOwnershipNum = function contractOwnershipNum(contract) {
  return contract.userQuantity + contract.userOpenOrdersBuyQuantity + contract.userOpenOrdersSellQuantity;
};
var isMarketSettled = function isMarketSettled(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_SETTLED;
};
var isMarketExpired = function isMarketExpired(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_EXPIRED;
};
var isMarketSuspended = function isMarketSuspended(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_SUSPENDED;
};
var isMarketMaintenance = function isMarketMaintenance(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_MAINTENANCE;
};
var isMarketStatusClosed = function isMarketStatusClosed(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_CLOSED;
};
var isMarketClosed = function isMarketClosed(market) {
  return market && !market.isOpen;
};
var isMarketDisabled = function isMarketDisabled(market) {
  return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['app/hasMaintenance'] || isMarketSettled(market) || isMarketExpired(market) || isMarketSuspended(market) || isMarketMaintenance(market) || isMarketStatusClosed(market);
};
var isMarketJourneyDisabled = function isMarketJourneyDisabled(market) {
  return isMarketSettled(market);
};
var hasMarketPayout = function hasMarketPayout(market) {
  return market && (market.userInvestment !== 0 || market.userMaxPayout !== 0);
};
var hasMarketHiddenContracts = function hasMarketHiddenContracts(market) {
  var contracts = market.contracts || market.marketContracts || [];
  return typeof contracts.find(function (i) {
    return i.hiddenByDefault;
  }) !== 'undefined';
};
var isContractOpen = function isContractOpen(contract) {
  return typeof contract.isOpen !== 'undefined' && contract.isOpen || typeof contract.contractIsOpen !== 'undefined' && contract.contractIsOpen;
};

var isHighChartsReady = function isHighChartsReady() {
  return typeof Highcharts !== 'undefined';
};


/* unused harmony default export */ var _unused_webpack_default_export = ({});

function largeNumberDisplay(x) {
  var largeThousands = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var value = x;
  if (value >= 1.0e+6) {
    if ((value / 1.0e+6).toFixed(1).endsWith('.0')) {
      value = (value / 1.0e+6).toFixed(0) + 'M';
    } else {
      value = (value / 1.0e+6).toFixed(1) + 'M';
    }
  } else if (largeThousands && value >= 1.0e+5) {
    value = (value / 1.0e+3).toFixed(0) + 'K';
  } else if (!largeThousands && value >= 1.0e+3) {
    if ((value / 1.0e+3).toFixed(1).endsWith('.0')) {
      value = (value / 1.0e+3).toFixed(0) + 'K';
    } else {
      value = (value / 1.0e+3).toFixed(1) + 'K';
    }
  } else {
    value = value.toLocaleString('en-US');
  }
  return value;
}

function elementOffset(el) {
  var rect = el.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

var scrollPosition = 0;
var lockCount = 0;
var lockedWithFixedBody = false;

function lockScroll() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$modal = _ref.modal,
      modal = _ref$modal === undefined ? false : _ref$modal,
      _ref$forceFixed = _ref.forceFixed,
      forceFixed = _ref$forceFixed === undefined ? false : _ref$forceFixed,
      _ref$fixedOffset = _ref.fixedOffset,
      fixedOffset = _ref$fixedOffset === undefined ? 0 : _ref$fixedOffset;

  if (lockCount === 0) {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    var isDesktop = !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["b" /* isIos */] && !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["c" /* isAndroid */] && !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["d" /* isTablet */];
    lockedWithFixedBody = __WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["b" /* isIos */] || forceFixed;

    if (lockedWithFixedBody) {
      __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('lockScroll ON ' + (__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["b" /* isIos */] ? 'iOS' : 'Desktop'));
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + Math.max(0, scrollPosition - fixedOffset) + 'px';
      document.body.style.width = '100%';
    }

    if (isDesktop) {
      document.body.style.height = 'auto';
    }
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

function unlockScroll() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$modal = _ref2.modal,
      modal = _ref2$modal === undefined ? false : _ref2$modal;

  if (lockCount <= 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('lockScroll OFF');
    var isDesktop = !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["b" /* isIos */] && !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["c" /* isAndroid */] && !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["d" /* isTablet */];
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    if (lockedWithFixedBody) {
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      lockedWithFixedBody = false;
    }

    if (isDesktop) {
      document.body.style.removeProperty('height');
    }

    window.requestAnimationFrame(function () {
      window.scrollTo({
        top: scrollPosition,
        behavior: 'instant'
      });
    });

    void document.body.offsetHeight;
  }
}

function lockModal() {
  lockScroll({ modal: true });
}

function unLockModal() {
  unlockScroll({ modal: true });
}

function marketUserGainLoss(market) {
  var contracts = market.contracts || market.marketContracts || [];
  return __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy___default()(contracts, function (c) {
    var gainLoss = 0;
    if (c.userPrediction === 0 && c.userOpenOrders !== 0) {
      gainLoss = (1 - c.lastTradePrice - c.userAveragePricePerShare) * c.userQuantity;
    } else {
      gainLoss = (c.lastTradePrice - c.userAveragePricePerShare) * c.userQuantity;
    }
    return gainLoss;
  });
}

var hasNoPositionInAMarketBesidesLoadedContract = function hasNoPositionInAMarketBesidesLoadedContract(_ref3) {
  var market = _ref3.market,
      contract = _ref3.contract;

  if (!market || !contract) return false;
  var contracts = market.contracts || market.marketContracts || [];
  var contractsWithout = contracts.filter(function (c) {
    return c.contractId !== contract.contractId;
  });
  if (contractsWithout.length === 0) return false;

  return contractsWithout.some(function (c) {
    return c.userPrediction === 0 && c.userQuantity > 0;
  });
};

var smartbtoa = function smartbtoa(input) {
  return btoa(unescape(encodeURIComponent(input)));
};
var smartatob = function smartatob(input) {
  return decodeURIComponent(escape(atob(input)));
};

var groupByKeepOrder = function groupByKeepOrder(arr, prop) {
  var newArr = [];
  var wrapObj = {};

  arr.forEach(function (item) {
    var propName = item[prop];
    if (propName) {
      propName = propName.toString();
      if (!wrapObj[propName]) {
        wrapObj[propName] = [];
        newArr.push(wrapObj[propName]);
      }
      wrapObj[propName].push(item);
    }
  });

  return newArr;
};

function roundToTwo(value) {
  return Math.round(value * 100) / 100;
}

function roundDown(value) {
  return Math.floor(value * 100) / 100;
}

function roundTop(value) {
  return Math.ceil(value * 100) / 100;
}

var getCardTypeForNumber = function getCardTypeForNumber(value) {
  if (/^(?:4\d{12}(?:\d{3})?)$/.test(value)) return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.VISA;
  if (/^(?:3[47]\d{13})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.AMERICAN_EXPRESS;
  if (/^6(?:011\d{12,15}|5\d{14,17}|4[4-9]\d{13,16}|22(?:1(?:2[6-9]|[3-9]\d)|[2-8]\d{2}|9(?:[01]\d|2[0-5]))\d{10,13})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.DISCOVER;
  if (/^(?:5[1-5]\d{14})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.MASTERCARD;
  return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.BLANK;
};

var getOrdinalSuffix = function getOrdinalSuffix(value) {
  var symbols = ['th', 'st', 'nd', 'rd'];
  var v = value % 100;
  return symbols[(v - 20) % 10] || symbols[v] || symbols[0];
};

var loadedScripts = {};
var loadScript = function loadScript(url, windowVariable) {
  if (!loadedScripts[url]) {
    loadedScripts[url] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.addEventListener('load', function () {
        return resolve(windowVariable ? __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(window, windowVariable) : undefined);
      }, false);
      script.addEventListener('error', function (e) {
        return reject(e);
      }, false);
      document.body.appendChild(script);
    });
  }
  return loadedScripts[url];
};

var parseQuery = function parseQuery(queryString) {
  var query = {};
  var a = (queryString[0] === '?' || queryString[0] === '#' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < a.length; i += 1) {
    var b = a[i].split('=');
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
  }
  return query;
};
var checkIfKeyExist = function checkIfKeyExist(objectName, keyName) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(objectName).some(function (key) {
    return key === keyName;
  });
};

function getExtendedUrlWithSessionVarsInQuery(url) {
  var data = __WEBPACK_IMPORTED_MODULE_13__helpers_sessionVars__["a" /* default */].params();
  var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data);
  if (keys.length === 0) {
    return encodeURIComponent(url);
  }

  try {
    var urlObject = new URL(url);
    keys.forEach(function (key) {
      var value = data[key];
      if (value !== undefined && value !== null) {
        urlObject.searchParams.set(key, String(value));
      }
    });
    return encodeURIComponent(urlObject.toString());
  } catch (e) {
    return encodeURIComponent(url);
  }
}

var loginUrl = function loginUrl() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$returnTo = _ref4.returnTo,
      returnTo = _ref4$returnTo === undefined ? null : _ref4$returnTo;

  var url = returnTo || window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/login?returnUrl=' + returnUrl;
};
var signUpUrl = function signUpUrl() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$returnTo = _ref5.returnTo,
      returnTo = _ref5$returnTo === undefined ? null : _ref5$returnTo;

  var url = returnTo || window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/register?returnUrl=' + returnUrl;
};

var editAccountDetailsUrl = function editAccountDetailsUrl() {
  var url = window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/manage?returnUrl=' + returnUrl;
};

var verifyDetailsUrl = function verifyDetailsUrl() {
  var url = window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/profile?returnUrl=' + returnUrl;
};

var logoutUrl = function logoutUrl() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$routeRequiresAu = _ref6.routeRequiresAuth,
      routeRequiresAuth = _ref6$routeRequiresAu === undefined ? true : _ref6$routeRequiresAu;

  var url = routeRequiresAuth ? '/' : window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/logout?returnUrl=' + returnUrl;
};

var changeAvatarImageUrl = function changeAvatarImageUrl() {
  var url = window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/avatar?returnUrl=' + returnUrl;
};

var registerPersonalDetailsUrl = function registerPersonalDetailsUrl() {
  var url = window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/registration?returnUrl=' + returnUrl;
};

var getAssetPath = function getAssetPath(path) {
  return '' + "https://cdn1.predictit.org" + path;
};

var isVisibleInViewport = function isVisibleInViewport(element) {
  var elementStyle = window.getComputedStyle(element);
  //Particular cases when the element is not visible at all
  if (elementStyle.height == '0px' || elementStyle.display == 'none' || elementStyle.opacity == '0' || elementStyle.visibility == 'hidden' || elementStyle.clipPath == 'circle(0px at 50% 50%)' || elementStyle.transform == 'scale(0)' || element.hasAttribute('hidden')) {
    return false;
  }

  var rect = element.getBoundingClientRect();

  //Overlapping strict check
  var baseElementLeft = rect.left;
  var baseElementTop = rect.top;

  var elementFromStartingPoint = document.elementFromPoint(baseElementLeft, baseElementTop);

  if (elementFromStartingPoint != null && !element.isSameNode(elementFromStartingPoint)) {
    var elementZIndex = elementStyle.zIndex;
    var elementOverlappingZIndex = window.getComputedStyle(elementFromStartingPoint).zIndex;
    if (Number(elementZIndex) < Number(elementOverlappingZIndex)) {
      return false;
    }

    if (elementZIndex === '' && elementOverlappingZIndex === '') {
      /**
           		If two positioned elements overlap without a z-index specified, the element
      positioned last in the HTML code will be shown on top
           		**/
      if (element.compareDocumentPosition(elementFromStartingPoint) & Node.DOCUMENT_POSITION_FOLLOWING) {
        return false;
      }
    }
  }

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var stripTags = function stripTags(string) {
  return (string || "").replace(/(<([^>]+)>)/gi, "");
};

var isEmptyHtml = function isEmptyHtml(html) {
  if (!html) return true;
  var stripped = html.replace(/<[^>]*>?/gm, '').trim();
  return stripped.length === 0;
};
var uuidv4 = function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (c) {
    return (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16);
  });
};

/***/ }),

/***/ "cBKw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cEur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_auth_js__ = __webpack_require__("I4ul");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff37a56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_auth_vue__ = __webpack_require__("OmlY");
function injectStyle (ssrContext) {
  __webpack_require__("6QL+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_auth_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff37a56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cFI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy__ = __webpack_require__("to0n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_switch_switch_vue__ = __webpack_require__("iOeH");

 /* eslint-disable quotes */




var csvPrefix = 'data:text/csv;charset=utf-8,';
var csvHeader = 'Market Outcome,Type,Shares,Avg Price,Share Value,If Yes,If No,Risk,Payout';
var csvInfoOne = '"Your Risk in any contract is the sum of your profits and losses, across all contracts, should that contract resolve to \'Yes\'."';
var csvInfoTwo = '"Your Investment in the market as a whole is equal to your greatest Risk in any one contract. This is the amount PredictIt debits from your account to cover your position."';
var csvInfoThree = '"Your Potential Payout is the amount you will be credited if the contract resolves to \'Yes\'. It is the difference between your total Investment (greatest Risk in any contract) and the Risk in the winning contract."';
var csvInfoFour = '"Share Value corresponds to the face value of your position in each contract (shares multiplied by average purchase price)."';

function predictionTypeToString(type) {
  return type === 0 || type === 2 ? 'No' : 'Yes';
}
function formatData(o) {
  return o < 0 ? '($' + Math.abs(o).toFixed(3) + ')' : '$' + o.toFixed(3);
}
var COLUMNS = ['averagePrice', 'investment', 'profitYes', 'profitNo', 'riskAmount', 'payoutAmount'];
var COLUMNS_LAST = COLUMNS.slice(1);
function csvObjectToString(o, i, c) {
  if (i + 1 === c.length) {
    var _formatedData = COLUMNS_LAST.map(function (prop) {
      return formatData(o[prop]);
    });
    return o.contractName + ',,,,' + _formatedData.join(',');
  }
  var type = predictionTypeToString(o.predictionType);
  var formatedData = COLUMNS.map(function (prop) {
    return formatData(o[prop]);
  });
  return o.contractName + ',' + type + ',' + o.sharesOwned + ',' + formatedData.join(',');
}

function toCsv(contractsArray, filename, link) {
  var arr = contractsArray.map(csvObjectToString);

  if (window.navigator.msSaveBlob) {
    var IE = new Blob([csvHeader + '\n' + arr.join('\n') + '\n\n\n' + csvInfoOne + '\n' + csvInfoTwo + '\n' + csvInfoThree + '\n' + csvInfoFour], { type: 'text/csv;charset=utf-8' });
    window.navigator.msSaveBlob(IE, filename);
  } else {
    var data = void 0;
    if (window.Blob) {
      var csvNoPrefix = csvHeader + '\n' + arr.join('\n') + '\n\n\n' + csvInfoOne + '\n' + csvInfoTwo + '\n' + csvInfoThree + '\n' + csvInfoFour;
      var blob = new Blob([csvNoPrefix], { type: 'text/csv;charset=utf-8' });
      data = window.URL.createObjectURL(blob);
    } else {
      var csv = '' + csvPrefix + csvHeader + '\n' + arr.join('\n') + '\n\n\n' + csvInfoOne + '\n' + csvInfoTwo + '\n' + csvInfoThree + '\n' + csvInfoFour;
      data = encodeURI(csv);
    }
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    switchModal: __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_switch_switch_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      toggleIndex: 1,
      faqlink: {
        name: 'Faq',
        params: { faqid: 666 }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['marketPayouts']), {
    itemWithGreatestRisk: function itemWithGreatestRisk() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default()(this.payouts, function (x) {
        return x.riskAmount;
      });
    },
    payouts: function payouts() {
      return this.marketPayouts === null ? [] : this.marketPayouts.contracts;
    },
    showSpinner: function showSpinner() {
      return this.payouts.length === 0;
    },
    classModifier: function classModifier() {
      return {
        'potential-payouts__content--long': this.payouts.length > 5
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('overlay', { hideOverlay: 'hide' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getMarketPayouts', 'clearMarketPayouts']), {
    isNo: function isNo(item) {
      return item.predictionType === 0 || item.predictionType === 2;
    },
    yourOwnText: function yourOwnText(item) {
      return predictionTypeToString(item.predictionType);
    },
    yourOwnModifiers: function yourOwnModifiers(item) {
      var isNo = this.isNo(item);
      return {
        'potential-payouts--bar': true,
        'potential-payouts--no': isNo,
        'potential-payouts--yes': !isNo
      };
    },
    isWithGreatestRisk: function isWithGreatestRisk(item) {
      if (!this.itemWithGreatestRisk) return false;
      return item.riskAmount === this.itemWithGreatestRisk.riskAmount;
    },
    toggle: function toggle() {
      this.toggleIndex += 1;
    },
    close: function close() {
      this.$emit('modalClose');
    },
    whileRouting: function whileRouting() {
      this.$emit('modalClose');
      this.hideOverlay();
    },
    onExport: function onExport() {
      toCsv(this.marketPayouts.contracts, 'Potential Payouts-' + this.market.marketId + '.csv', this.$refs.export);
    }
  }),
  mounted: function mounted() {
    this.getMarketPayouts(this.market.marketId);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearMarketPayouts();
  }
});

/***/ }),

/***/ "cLlV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WITHDRAW_CANCEL_STEPS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_processing_transaction_processing_transaction_vue__ = __webpack_require__("J1hJ");


/* eslint-disable max-len */






var TYPE_CHECK = 1;
var TYPE_TRANSFER = 2;
var TYPE_COINBASE = 4;
var TYPE_BANK_TRANSFER = 5;

var DATE_DISPLAY_FORMAT = 'MM/DD/YYYY hh:mm A';
var TITLE_DATE_FORMAT = 'ddd MMM Do, YYYY';
var EMPTY_DISPLAY = '-';

var hasValue = function hasValue(value) {
  return value !== null && typeof value !== 'undefined' && value !== '';
};
var hasNumber = function hasNumber(value) {
  return hasValue(value) && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(Number(value));
};
var formatCurrency = function formatCurrency(value) {
  if (!hasNumber(value)) return EMPTY_DISPLAY;

  var amount = Number(value);
  return '$' + amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

var WITHDRAW_CANCEL_STEPS = {
  INITIAL: 1,
  PROCESSING: 2,
  FINISHED_SUCCESS: 3,
  FINISHED_FAILED: 4
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  props: {
    request: {
      type: Object,
      required: true
    },
    isDeposit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    processingWithdrawalCancelTransaction: __WEBPACK_IMPORTED_MODULE_6__components_processing_transaction_processing_transaction_vue__["a" /* default */]
  },
  data: function data() {
    return {
      hasFailed: false,
      WITHDRAW_CANCEL_STEPS: WITHDRAW_CANCEL_STEPS,
      currentStep: WITHDRAW_CANCEL_STEPS.INITIAL,
      currentStepData: {}
    };
  },

  watch: {
    withdrawalCancelStep: function withdrawalCancelStep(value) {
      if (this.currentStep === WITHDRAW_CANCEL_STEPS.PROCESSING && value.step === WITHDRAW_CANCEL_STEPS.FINISHED_SUCCESS) {
        this.setSuccessSideNotification('Your withdrawal has been cancelled.');
        this.$emit('complete');
      }
      if (this.currentStep === WITHDRAW_CANCEL_STEPS.PROCESSING && value.step === WITHDRAW_CANCEL_STEPS.FINISHED_FAILED) {
        this.setErrorSideNotification('Unfortunately, we could not process your request.');
        this.$emit('complete');
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('wallet', ['withdrawalCancelStep']), {
    isTransfer: function isTransfer() {
      return this.request.type === TYPE_TRANSFER;
    },
    isCheck: function isCheck() {
      return this.request.type === TYPE_CHECK;
    },
    isCoinbase: function isCoinbase() {
      return this.request.type === TYPE_COINBASE;
    },
    isBankTransfer: function isBankTransfer() {
      return this.request.type === TYPE_BANK_TRANSFER;
    },
    requestDateValue: function requestDateValue() {
      if (!this.request) return null;

      return this.request.date || this.request.dateCreated || null;
    },
    requestTypeLabel: function requestTypeLabel() {
      if (!this.request) return 'Pending Withdrawal';

      if (this.request.typeName && this.request.typeName !== 'Withdrawal') {
        return this.request.typeName;
      }

      if (this.paymentMethod !== EMPTY_DISPLAY) {
        return this.paymentMethod + ' Withdrawal';
      }

      return 'Pending Withdrawal';
    },
    requestTitle: function requestTitle() {
      if (!this.requestDateValue || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.requestDateValue).isValid()) {
        return this.requestTypeLabel;
      }

      return this.requestTypeLabel + ' on ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.requestDateValue).format(TITLE_DATE_FORMAT);
    },
    paymentMethod: function paymentMethod() {
      if (!this.request) return EMPTY_DISPLAY;

      switch (this.request.type) {
        case TYPE_TRANSFER:
          return 'ACH';
        case TYPE_CHECK:
          return 'Check';
        case TYPE_COINBASE:
          return 'USD Coin';
        case TYPE_BANK_TRANSFER:
          return 'Bank Transfer';
        default:
          return EMPTY_DISPLAY;
      }
    },
    formattedAmount: function formattedAmount() {
      return formatCurrency(this.request && this.request.amount);
    },
    formattedFee: function formattedFee() {
      return formatCurrency(this.request && this.request.fee);
    },
    formattedNet: function formattedNet() {
      return formatCurrency(this.request && this.request.net);
    },
    formattedDate: function formattedDate() {
      if (!this.requestDateValue || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.requestDateValue).isValid()) return EMPTY_DISPLAY;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["k" /* dateToString */])(this.requestDateValue, DATE_DISPLAY_FORMAT);
    },
    confirmationNumber: function confirmationNumber() {
      return this.request && this.request.confirmationNumber ? this.request.confirmationNumber : EMPTY_DISPLAY;
    },
    detailRows: function detailRows() {
      if (!this.request) return [];

      if (this.isTransfer) {
        return [{
          label: 'Account Type',
          value: this.request.accountType || EMPTY_DISPLAY
        }, {
          label: 'Routing Number',
          value: this.request.routingNumber || EMPTY_DISPLAY
        }, {
          label: 'Account Number',
          value: hasValue(this.request.accountNumberLastFour) ? '********' + this.request.accountNumberLastFour : EMPTY_DISPLAY
        }];
      }

      if (this.isCheck) {
        var locationParts = [this.request.city, this.request.stateCode].filter(hasValue);
        var location = locationParts.join(', ');
        var cityLineParts = [location, this.request.postalCode].filter(hasValue);
        var lines = [this.request.payeeName, this.request.address, cityLineParts.join(' ')].filter(hasValue);

        if (hasValue(this.request.countryCode)) {
          lines.push(this.request.countryCode);
        }

        return [{
          label: 'Check Payable To',
          lines: lines.length > 0 ? lines : [EMPTY_DISPLAY],
          isStacked: true
        }];
      }

      if (this.isCoinbase) {
        return [{
          label: 'Recipient',
          value: hasValue(this.request.email) ? this.request.email : EMPTY_DISPLAY
        }];
      }

      return [];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['cancelWithdrawal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    isStep: function isStep(name) {
      return this.currentStep === name;
    },
    onCancel: function onCancel() {
      var _this = this;

      var payload = {
        withdrawalId: this.request.withdrawalId
      };
      // this.currentStep = WITHDRAW_CANCEL_STEPS.PROCESSING;
      this.loaderAdd();
      this.cancelWithdrawal(payload).then(function () {
        _this.loaderRemove();
        _this.setSuccessSideNotification('Your withdrawal has been cancelled.');
        _this.$emit('complete');
      }).catch(function () {
        _this.loaderRemove();
        _this.setErrorSideNotification('Unfortunately, we could not process your request.');
      });
    }
  })
});

/***/ }),

/***/ "cRkn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-timeline"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsPeriod.length > 0 && !_vm.isLayoutMobile),expression:"tabsPeriod.length > 0 && !isLayoutMobile"}],staticClass:"charts-timeline__tabs-period",class:{'charts-timeline__tabs-period--disabled': _vm.isChartLoading},style:(_vm.tabsPeriodStyleModifiers)},[_c('tabs',{attrs:{"activeTab":_vm.activeTabPeriod,"items":_vm.tabsPeriod,"theme":"timeline-sushi"},on:{"tabChange":_vm.tabChangePeriod}})],1),_vm._v(" "),(!_vm.isForStory)?_c('div',{staticClass:"charts-timeline__menu-control-stats",attrs:{"title":"View trading statistics"},on:{"click":_vm.onOpenStats}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-control-settings",on:{"click":_vm.onOpenSettings}}),_vm._v(" "),_c('div',{staticClass:"charts-timeline__logo"}),_vm._v(" "),(_vm.showMenu)?_c('small-modal',{on:{"modalClose":function($event){_vm.showMenu = false}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("\n      Chart Settings\n    ")]},proxy:true},{key:"content",fn:function(){return [(_vm.showMenu)?_c('div',{staticClass:"charts-timeline__menu"},[_c('div',{staticClass:"charts-timeline__menu-content"},[(_vm.tabsPeriod.length > 0 && _vm.isLayoutMobile)?[_c('div',{staticClass:"charts-timeline__menu-label"},[_vm._v("\n              Chart Timeline\n            ")]),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-inner"},[_c('div',{staticClass:"charts-timeline__menu-inner-items",class:{'charts-timeline__menu-inner-items--disabled': _vm.isChartLoading}},_vm._l((_vm.tabsPeriod),function(tab){return _c('div',{key:tab.name,staticClass:"charts-timeline__menu-inner-item",class:{
                       'charts-timeline__menu-inner-item--selected': tab.name === _vm.activeTabPeriod,
                       'charts-timeline__menu-inner-item--disabled': _vm.isChartLoading
                     },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.tabChangePeriod(tab.name)}}},[_vm._v("\n                  "+_vm._s(tab.title)+"\n                ")])}),0)]),_vm._v(" "),_c('hr')]:_vm._e(),_vm._v(" "),(_vm.tabsType.length > 1)?[_c('div',{staticClass:"charts-timeline__menu-label"},[_vm._v("\n              Chart Type\n            ")]),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-inner"},[_c('div',{staticClass:"charts-timeline__menu-inner-items",class:{'charts-timeline__menu-inner-items--disabled': _vm.isChartLoading}},_vm._l((_vm.tabsType),function(tab){return _c('div',{key:tab.name,staticClass:"charts-timeline__menu-inner-item",class:{
                       'charts-timeline__menu-inner-item--selected': tab.name === _vm.activeTabType,
                       'charts-timeline__menu-inner-item--disabled': _vm.isChartLoading
                     },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.tabChangeType(tab.name)}}},[_vm._v("\n                  "+_vm._s(tab.title)+"\n                ")])}),0)]),_vm._v(" "),_c('hr')]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-label"},[_vm._v("\n            Chart Settings\n          ")]),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-inner"},[_c('div',{staticClass:"charts-timeline__toggle",class:{'charts-timeline__toggle--disabled': _vm.isChartLoading}},[_c('div',{staticClass:"charts-timeline__toggle-control",class:{
                  'charts-timeline__toggle-control--active': _vm.showVolumeChart,
                  'charts-timeline__toggle-control--disabled': _vm.isChartLoading
                },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onVolumeChartToggle($event)}}}),_vm._v(" "),_c('div',{staticClass:"charts-timeline__toggle-control-label"},[_vm._v("\n                Show Volume\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-inner"},[_c('div',{staticClass:"charts-timeline__toggle",class:{'charts-timeline__toggle--disabled': _vm.isChartLoading}},[_c('div',{staticClass:"charts-timeline__toggle-control",class:{
                  'charts-timeline__toggle-control--active': _vm.showPriceAxisZoomValue,
                  'charts-timeline__toggle-control--disabled': _vm.isChartLoading
                },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onPriceAxisZoomToggle($event)}}}),_vm._v(" "),_c('div',{staticClass:"charts-timeline__toggle-control-label"},[_vm._v("\n                Price Axis Zoom\n              ")])])]),_vm._v(" "),(!_vm.isForStory)?[_c('hr'),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-stats",class:{'charts-timeline__menu-stats--disabled': _vm.isChartLoading},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onOpenStats($event)}}},[_vm._v("\n              Open Stats\n            ")])]:_vm._e(),_vm._v(" "),(_vm.isChartLoading)?_c('div',{staticClass:"charts-timeline__menu-loading"},[_c('div',{staticClass:"charts-timeline__menu-loading-spinner"})]):_vm._e()],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"button button--large button--black button--full-width",on:{"click":function($event){_vm.showMenu = false}}},[_vm._v("\n          Close\n        ")])]):_vm._e()]},proxy:true}],null,false,826266073)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cT9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_panel_insight_panel_vue__ = __webpack_require__("QgOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_link_insight_link_vue__ = __webpack_require__("DXdo");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    insightPanel: __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_panel_insight_panel_vue__["a" /* default */],
    insightLink: __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_link_insight_link_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('insight', ['analysis']), {
    allArticlesAway: function allArticlesAway() {
      return !this.isLayoutMobile;
    },
    allArticlesLink: function allArticlesLink() {
      if (!this.isLayoutMobile) {
        return 'https://analysis.predictit.org/';
      }
      return {
        path: '/insight/' + btoa(encodeURI('//analysis.predictit.org/'))
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('insight', ['getAnalysis']), {
    createLink: function createLink(url) {
      return {
        path: '/insight/' + btoa(encodeURI(url))
      };
    },
    createDate: function createDate(date) {
      if (date) {
        var dt = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date.split(' ')[0]);
        var diff = __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(dt, 'days');
        var map = {
          0: 'Today',
          1: 'Yesterday',
          2: dt.format('dddd'),
          3: dt.format('dddd'),
          4: dt.format('dddd'),
          5: dt.format('dddd'),
          6: dt.format('dddd')
        };
        return map[diff] || dt.format('MMM. D');
      }
      return '';
    }
  }),
  mounted: function mounted() {
    this.getAnalysis({});
  }
});

/***/ }),

/***/ "cU06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-panel-simple",class:_vm.isOpenModifier},[_c('h3',{staticClass:"collapsible-panel-simple__header",on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isOpenState)?_c('div',{staticClass:"collapsible-panel-simple__content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cVuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("0O9D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b161a9d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("n71m");
function injectStyle (ssrContext) {
  __webpack_require__("wQrL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b161a9d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cW54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* eslint-disable max-len */






/* harmony default export */ __webpack_exports__["a"] = ({
  getManageInfo: function getManageInfo() {
    var returnUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var generateState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'false';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/ManageInfo?returnUrl=' + returnUrl + '&generateState=' + generateState);
  },
  postToken: function postToken() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/token', payload);
  },
  getUserInfo: function getUserInfo() {
    var options = {};
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/UserInfo', options);
  },
  getAccountDetail: function getAccountDetail() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/Detail');
  },
  postLogout: function postLogout() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var options = {
      withCredentials: true
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/Logout', payload, options);
  },
  getStatus: function getStatus() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/Status');
  },
  postRegister: function postRegister(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].payload(payload, 'PIReferral', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/Register', marketingPayload);
  },
  postRegisterExternal: function postRegisterExternal(payload) {
    var options = {};
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].payload(payload, 'PIReferral', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/RegisterExternal', marketingPayload, options);
  },
  postResetPassword: function postResetPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ResetPassword', payload);
  },
  postForgotPassword: function postForgotPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ForgotPassword', payload);
  },
  postChangePassword: function postChangePassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ChangePassword', payload);
  },
  postSetPassword: function postSetPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/SetPassword', payload);
  },
  postRemoveLogin: function postRemoveLogin(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/RemoveLogin', payload);
  },
  postAddExternalLogin: function postAddExternalLogin(payload) {
    var options = {
      withCredentials: true
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/AddExternalLogin', payload, options);
  },
  getExternalLogins: function getExternalLogins() {
    var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].SOCIAL_LOGIN_OR_REGISTER;

    var redirect = pathname.replace("/", '/');
    var accessToken = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('token');

    if (accessToken !== null || redirect.includes('account/login') || redirect.includes('account/sign-up')) {
      redirect = '/';
    }

    var options = {
      params: {
        returnUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["a" /* getRedirectUrl */])('/account/social/auth/?redirect=' + redirect + '&type=' + type),
        generateState: true
      }
    };
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Account/ExternalLogins', options);
  },
  getVerifyID: function getVerifyID() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/VerifyID');
  },
  postVerifyID: function postVerifyID(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/VerifyID', payload);
  },
  postUploadUserImage: function postUploadUserImage(payload) {
    var options = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/UploadUserImage', payload, options);
  },
  putResetUserImage: function putResetUserImage() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/ResetUserImage');
  },
  getCommunicationPreferences: function getCommunicationPreferences() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/CommunicationPreferences');
  },
  postCommunicationPreferences: function postCommunicationPreferences(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/CommunicationPreferences', payload);
  },
  getCaptchaSiteKey: function getCaptchaSiteKey() {
    // Public endpoint - must not send Authorization header (may have stale token)
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/CaptchaSiteKey', {
      transformRequest: [function (data, headers) {
        delete headers.Authorization;
        return data;
      }]
    });
  },
  getCaptchaSiteKeyV3: function getCaptchaSiteKeyV3() {
    // Public endpoint - must not send Authorization header (may have stale token)
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/CaptchaSiteKeyV3', {
      transformRequest: [function (data, headers) {
        delete headers.Authorization;
        return data;
      }]
    });
  },
  getDisqusLogin: function getDisqusLogin() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusLogin');
  },
  getDisqusLogout: function getDisqusLogout() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusLogout');
  },
  getDisqusUserAuth: function getDisqusUserAuth() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusUserAuth');
  },
  getIdUploadUrl: function getIdUploadUrl() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/IdUploadUrl');
  },
  getTaxInfo: function getTaxInfo(_ref) {
    var _ref$reasonCode = _ref.reasonCode,
        reasonCode = _ref$reasonCode === undefined ? '' : _ref$reasonCode;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TaxInfo?reasonCode=' + reasonCode);
  },
  postTaxInfo: function postTaxInfo(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TaxInfo', payload);
  },
  putMessagingToken: function putMessagingToken(token) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/MessagingToken?token=' + token);
  },
  getChangeUsername: function getChangeUsername() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/ChangeUsername');
  },
  postChangeUsername: function postChangeUsername(username) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ChangeUsername?username=' + username);
  },
  getDocumentUploadLink: function getDocumentUploadLink(source) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DocumentUploadLink?source=' + source);
  },
  putAgreedToTerms: function putAgreedToTerms(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/UpdateAgreedToTerms', payload);
  },


  // --- Two-Factor Authentication ---

  // Login flow (anonymous - uses encrypted 2FA token)
  postTwoFactorSendCode: function postTwoFactorSendCode(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/SendCode', payload);
  },
  postTwoFactorVerify: function postTwoFactorVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Verify', payload);
  },


  // User management (authenticated)
  getTwoFactorStatus: function getTwoFactorStatus() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TwoFactor/Status');
  },
  postTwoFactorSetupEmailSendCode: function postTwoFactorSetupEmailSendCode() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Email/SendCode');
  },
  postTwoFactorSetupEmailVerify: function postTwoFactorSetupEmailVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Email/Verify', payload);
  },
  postTwoFactorSetupPhoneSendCode: function postTwoFactorSetupPhoneSendCode() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Phone/SendCode');
  },
  postTwoFactorSetupPhoneVerify: function postTwoFactorSetupPhoneVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Phone/Verify', payload);
  },
  getTwoFactorSetupAuthenticator: function getTwoFactorSetupAuthenticator() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TwoFactor/Setup/Authenticator');
  },
  postTwoFactorSetupAuthenticatorVerify: function postTwoFactorSetupAuthenticatorVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Authenticator/Verify', payload);
  },
  postTwoFactorEnable: function postTwoFactorEnable() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Enable');
  },
  postTwoFactorDisable: function postTwoFactorDisable() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Disable');
  },


  // --- Phone Management ---
  getPhone: function getPhone() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TwoFactor/Phone');
  },
  postPhoneUpdate: function postPhoneUpdate(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Phone/Update', payload);
  },
  postPhoneVerify: function postPhoneVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Phone/Verify', payload);
  }
});

/***/ }),

/***/ "cbPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    predictionType: Number,
    tradeType: Number,
    quantity: Number,
    price: Number
  },
  computed: {
    typeToString: function typeToString() {
      switch (this.tradeType) {
        case 0: // Buy No
        case 1:
          // Buy Yes
          return 'Bought';
        case 2: // Sell No
        case 3:
          // Sell Yes
          return 'Sold';
        default:
          return 'Closed'; // 4 - Closed
      }
    },
    closedText: function closedText() {
      if (this.tradeType === 4) {
        var price = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["g" /* toCents */])(this.price);
        var yesNo = this.predictionType === 0 ? '<span class="sold-bought-at__quantity sold-bought-at--negative">' + this.quantity + '</span>' : '<span class="sold-bought-at__quantity">' + this.quantity + '</span>';

        if (price === 0) {
          return yesNo + ' pays $0';
        }
        var pays = price === 100 ? '$1' : this.priceToString;
        return yesNo + ' pays ' + pays;
      }
      return null;
    },
    priceToString: function priceToString() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["g" /* toCents */])(this.price) + '\xA2';
    },
    negativeModifier: function negativeModifier() {
      return {
        'sold-bought-at--negative': this.tradeType === 0 || this.tradeType === 2
      };
    }
  }
});

/***/ }),

/***/ "ceFQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_cmsContent__ = __webpack_require__("tQfv");



var CONTENT_COLLAPSED_HEIGHT = 475;
var CONTENT_OVERFLOW_TOLERANCE = 12;
var EXPANDED_HEIGHT_BUFFER = 8;
var EXPANDED_HEIGHT_MEASURE_DELAYS = [0, 150, 500, 1200];
var PODCAST_RESIZE_EVENT = 'cms:podcast-resize';
var PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';
var LAST_STORY_ROW_CLASS = 'preview-carousel__story-row--last';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_cmsContent__["a" /* default */]],
  props: {
    storySection: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    previewMode: {
      type: String,
      default: 'desktop'
    }
  },
  data: function data() {
    return {
      storyHtml: '',
      isExpanded: false,
      isContentOverflowing: false,
      expandedContentHeight: null,
      contentMeasureTimeouts: [],
      contentResizeObserver: null
    };
  },

  computed: {
    contentClassModifiers: function contentClassModifiers() {
      return {
        'preview-carousel__content': true,
        'preview-carousel__content--collapsed': !this.isExpanded,
        'preview-carousel__content--overflowing': this.isContentOverflowing && !this.isExpanded,
        'preview-carousel__content--with-guide': true
      };
    },
    contentStyleModifiers: function contentStyleModifiers() {
      var minHeightPx = CONTENT_COLLAPSED_HEIGHT;
      if (this.isExpanded && this.expandedContentHeight) {
        return {
          '--story-preview-cutoff-height': CONTENT_COLLAPSED_HEIGHT + 'px',
          minHeight: Math.max(minHeightPx, this.expandedContentHeight) + 'px'
        };
      }
      return {
        '--story-preview-cutoff-height': CONTENT_COLLAPSED_HEIGHT + 'px',
        minHeight: minHeightPx + 'px'
      };
    },
    expandClassModifiers: function expandClassModifiers() {
      return {
        'preview-carousel__expand': true,
        'preview-carousel__expand--floating': !this.isExpanded
      };
    },
    showExpandControl: function showExpandControl() {
      return this.isContentOverflowing && !!this.storyHtml;
    }
  },
  methods: {
    getCmsForcedLayoutMode: function getCmsForcedLayoutMode() {
      if (this.previewMode === 'mobile') {
        return 'mobile';
      }
      if (this.previewMode === 'desktop') {
        return 'desktop';
      }
      return '';
    },
    clearPendingExpandedMeasurements: function clearPendingExpandedMeasurements() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.contentMeasureTimeouts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeoutId = _step.value;

          clearTimeout(timeoutId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.contentMeasureTimeouts = [];
    },
    teardownContentResizeObserver: function teardownContentResizeObserver() {
      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }
    },
    setupContentResizeObserver: function setupContentResizeObserver() {
      var _this = this;

      this.teardownContentResizeObserver();
      if (typeof ResizeObserver === 'undefined') {
        return;
      }

      var target = this.getActiveStoryElement() || this.$refs.content;
      if (!target) {
        return;
      }

      this.contentResizeObserver = new ResizeObserver(function () {
        if (_this.isExpanded) {
          _this.scheduleExpandedHeightRefresh();
        } else {
          _this.checkContentOverflow();
        }
        _this.emitPodcastLayoutRefresh();
      });
      this.contentResizeObserver.observe(target);
    },
    getActiveStoryElement: function getActiveStoryElement() {
      var content = this.$refs.content;
      if (!content) {
        return null;
      }
      return content.querySelector('.preview-carousel__story');
    },
    isVisibleElement: function isVisibleElement(node) {
      var styles = window.getComputedStyle(node);
      if (styles.display === 'none' || styles.visibility === 'hidden') {
        return false;
      }
      var rect = node.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 || node.scrollHeight > 0;
    },
    getLastVisibleStoryRow: function getLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return null;
      }

      var rows = activeStory.querySelectorAll('.browse-story-content-region__items');
      for (var index = rows.length - 1; index >= 0; index -= 1) {
        var row = rows[index];
        if (this.isVisibleElement(row)) {
          return row;
        }
      }

      return null;
    },
    updateLastVisibleStoryRow: function updateLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return;
      }

      var markedRows = activeStory.querySelectorAll('.' + LAST_STORY_ROW_CLASS);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(markedRows), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var row = _step2.value;

          row.classList.remove(LAST_STORY_ROW_CLASS);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var lastVisibleRow = this.getLastVisibleStoryRow(activeStory);
      if (lastVisibleRow) {
        lastVisibleRow.classList.add(LAST_STORY_ROW_CLASS);
      }
    },
    measureStoryHeight: function measureStoryHeight() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$includeBuffer = _ref.includeBuffer,
          includeBuffer = _ref$includeBuffer === undefined ? false : _ref$includeBuffer;

      var activeStory = this.getActiveStoryElement();
      if (!activeStory) {
        return null;
      }

      this.updateLastVisibleStoryRow(activeStory);

      var activeRect = activeStory.getBoundingClientRect();
      var measuredHeight = Math.max(activeStory.scrollHeight || 0, activeStory.offsetHeight || 0);
      var descendants = activeStory.querySelectorAll('*');

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(descendants), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var node = _step3.value;

          var styles = window.getComputedStyle(node);
          if (styles.display === 'none' || styles.visibility === 'hidden') {
            continue;
          }
          var rect = node.getBoundingClientRect();
          if (rect.width === 0 && rect.height === 0) {
            continue;
          }
          var nodeBottom = rect.bottom - activeRect.top;
          if (nodeBottom > measuredHeight) {
            measuredHeight = nodeBottom;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (measuredHeight <= 0) {
        return null;
      }

      return Math.ceil(measuredHeight + (includeBuffer ? EXPANDED_HEIGHT_BUFFER : 0));
    },
    measureExpandedContentHeight: function measureExpandedContentHeight() {
      return this.measureStoryHeight({ includeBuffer: true });
    },
    measureCollapsedContentHeight: function measureCollapsedContentHeight() {
      return this.measureStoryHeight();
    },
    scheduleExpandedHeightRefresh: function scheduleExpandedHeightRefresh() {
      var _this2 = this;

      if (!this.isExpanded) {
        return;
      }
      this.clearPendingExpandedMeasurements();
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(EXPANDED_HEIGHT_MEASURE_DELAYS), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var delay = _step4.value;

          var timeoutId = setTimeout(function () {
            if (!_this2.isExpanded) {
              return;
            }
            var measuredHeight = _this2.measureExpandedContentHeight();
            if (measuredHeight) {
              _this2.expandedContentHeight = measuredHeight;
            }
          }, delay);
          this.contentMeasureTimeouts.push(timeoutId);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    checkContentOverflow: function checkContentOverflow() {
      var content = this.$refs.content;
      if (!content) {
        this.isContentOverflowing = false;
        return;
      }
      var collapsedContentHeight = this.measureCollapsedContentHeight() || content.scrollHeight || 0;
      this.isContentOverflowing = collapsedContentHeight > CONTENT_COLLAPSED_HEIGHT + CONTENT_OVERFLOW_TOLERANCE;
      if (this.isExpanded) {
        var expandedContentHeight = this.measureExpandedContentHeight();
        if (expandedContentHeight) {
          this.expandedContentHeight = expandedContentHeight;
        }
      }
    },
    emitPodcastLayoutRefresh: function emitPodcastLayoutRefresh() {
      window.dispatchEvent(new Event(PODCAST_LAYOUT_REFRESH_EVENT));
    },
    handleWindowResize: function handleWindowResize() {
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.checkContentOverflow();
      }
      this.emitPodcastLayoutRefresh();
    },
    handleEmbeddedResizeEvent: function handleEmbeddedResizeEvent() {
      var _this3 = this;

      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.$nextTick(function () {
          _this3.checkContentOverflow();
        });
      }
    },
    toggleExpand: function toggleExpand() {
      var _this4 = this;

      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.$nextTick(function () {
        _this4.emitPodcastLayoutRefresh();
      });
    },
    refreshSurface: function refreshSurface() {
      var _this5 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$resetExpansion = _ref2.resetExpansion,
          resetExpansion = _ref2$resetExpansion === undefined ? true : _ref2$resetExpansion;

      var section = this.storySection || {};
      var html = section.html || '';
      var css = section.css || '';
      var cmsContent = section.cmsContent || {};

      if (resetExpansion) {
        this.isExpanded = false;
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }

      this.storyHtml = '' + css + html;

      this.$nextTick(function () {
        _this5.installDynamicControls({
          data: {
            cmsContentObject: cmsContent
          }
        });
        _this5.$nextTick(function () {
          _this5.setupContentResizeObserver();
          _this5.checkContentOverflow();
          _this5.emitPodcastLayoutRefresh();
          setTimeout(function () {
            return _this5.emitPodcastLayoutRefresh();
          }, 200);
        });
      });
    }
  },
  watch: {
    storySection: {
      handler: function handler() {
        this.refreshSurface({ resetExpansion: true });
      },

      deep: true
    },
    previewMode: function previewMode() {
      this.refreshSurface({ resetExpansion: true });
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);
    this.refreshSurface({ resetExpansion: true });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearPendingExpandedMeasurements();
    this.teardownContentResizeObserver();
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);
  }
});

/***/ }),

/***/ "cgm0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global $:false */
/*
  Mixin used to move some meta tags used for SEO just after
  header's title node. Supposedly it affects prerender.io.
 */
var headerTagsMixin = {
  methods: {
    reorganizeTags: function reorganizeTags() {
      setTimeout(function () {
        if (!window.$) return;
        $('meta[name="description"]').detach().insertAfter('title');
        $('meta[itemprop]').detach().insertAfter('title');
        $('meta[property]').detach().insertAfter('title');
      }, 0);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (headerTagsMixin);

/***/ }),

/***/ "cgtd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_export_history_js__ = __webpack_require__("ZMD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22a56cf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_export_history_vue__ = __webpack_require__("kP05");
function injectStyle (ssrContext) {
  __webpack_require__("hviY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_export_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22a56cf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_export_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "chIw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ci9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"announcement"},[_c('div',{staticClass:"announcement__icon"}),_vm._v(" "),_c('div',{staticClass:"announcement__title",domProps:{"innerHTML":_vm._s(_vm.announcement.title)}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"announcement__content",domProps:{"innerHTML":_vm._s(_vm.announcement.body)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ckGe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cole":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-modal"},[_c('div',{staticClass:"insight-modal__inner"},[_c('content-header',{attrs:{"title":_vm.title,"returnRoute":"home","returnRouteGoTo":"insight-widget"}}),_vm._v(" "),_c('div',{staticClass:"insight-modal__content"},[_c('iframe',{staticClass:"insight-modal__iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cwNw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cwmf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lp-6.031e5f1.png";

/***/ }),

/***/ "cz2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");








var disConfig = {
  api_key: "kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf",
  sso: {
    name: "PredictIt",
    button: "https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png",
    icon: "https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png",
    url: "/Account/DisqusLogin",
    logout: "/Account/DisqusLogout",
    width: "800",
    height: "600"
  }
};

function disqusConfig() {
  this.page.identifier = disConfig.identifier;
  this.page.url = disConfig.url;
  this.page.title = disConfig.title;
  this.page.api_key = disConfig.api_key;
  this.sso = disConfig.sso;

  this.page.remote_auth_s3 = disConfig.remote_auth_s3 ? disConfig.remote_auth_s3 : '';
}

function buildDisqusUrl(url) {
  var commentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var baseUrl = (url || '' + window.location.href).split('#')[0];

  if (!commentId) {
    return baseUrl;
  }

  return baseUrl + '#comment-' + commentId;
}

function normalizeCommentThreadId(commentThreadId) {
  var normalized = Number(commentThreadId);

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(normalized) && normalized > 0 ? normalized : 0;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    disqusId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    auth: String,
    url: String,
    marketId: {
      default: null
    },
    previous: {
      default: null
    },
    next: {
      default: null
    },
    total: {
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    focusCommentId: {
      type: String,
      default: ''
    },
    requestedCommentThreadId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      currentThread: 0,
      currentTitle: this.title,
      previousThread: this.previous,
      nextThread: this.next,
      totalComments: this.total,
      currentDisqusId: this.disqusId,
      currentDisqusUrl: this.url,
      currentDisqusTitle: this.title,
      appliedFocusCommentId: this.focusCommentId,
      isReconcilingRequest: false,
      showExplanation: false
    };
  },

  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_6__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isCommentEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn'])),
  mounted: function mounted() {
    if (this.auth && this.isLoggedIn) {
      this.enableDisqus(this.auth, this.focusCommentId);
    } else {
      this.enableDisqus(null, this.focusCommentId);
    }

    this.reconcileRequestedState();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getCommentThread']), {
    applyThreadData: function applyThreadData(data, threadId) {
      this.currentThread = normalizeCommentThreadId(threadId);
      this.currentTitle = data.disqus_ThreadName;
      this.nextThread = data.disqus_NextThreadID;
      this.previousThread = data.disqus_PrevThreadID;
      this.totalComments = data.disqus_ArchivedCommentsTotal;
      this.currentDisqusId = data.disqus_Identifier;
      this.currentDisqusUrl = data.disqus_Url;
      this.currentDisqusTitle = data.disqus_ThreadName;
    },
    emitDiscussionRequestChange: function emitDiscussionRequestChange() {
      var commentThreadId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var commentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      this.$emit('discussion-request-change', {
        commentId: commentId,
        commentThreadId: normalizeCommentThreadId(commentThreadId)
      });
    },
    reload: function reload(payload) {
      var _this = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$syncState = _ref.syncState,
          syncState = _ref$syncState === undefined ? true : _ref$syncState;

      var threadId = normalizeCommentThreadId(payload.threadId);
      var commentId = payload.commentId || '';

      this.isReconcilingRequest = true;

      if (syncState) {
        this.emitDiscussionRequestChange(threadId, commentId);
      }

      return this.getCommentThread(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
        threadId: threadId
      })).then(function (data) {
        _this.applyThreadData(data, threadId);

        if (_this.auth && _this.isLoggedIn) {
          _this.enableDisqus(_this.auth, commentId);
        } else {
          _this.enableDisqus(null, commentId);
        }
      }).finally(function () {
        _this.isReconcilingRequest = false;
        _this.$nextTick(function () {
          _this.reconcileRequestedState();
        });
      });
    },
    reconcileRequestedState: function reconcileRequestedState() {
      if (!this.isActive || this.isReconcilingRequest) {
        return;
      }

      var requestedThreadId = normalizeCommentThreadId(this.requestedCommentThreadId);
      var requestedCommentId = this.focusCommentId || '';

      if (requestedThreadId !== this.currentThread) {
        // Reconcile same-market thread changes inside Disqus so the rest of the page stays mounted.
        this.reload({
          threadId: requestedThreadId,
          marketId: this.marketId,
          commentId: requestedCommentId
        }, {
          syncState: false
        });
        return;
      }

      if (requestedCommentId === this.appliedFocusCommentId) {
        return;
      }

      this.isReconcilingRequest = true;

      if (this.auth && this.isLoggedIn) {
        this.enableDisqus(this.auth, requestedCommentId);
      } else {
        this.enableDisqus(null, requestedCommentId);
      }

      this.isReconcilingRequest = false;
    },
    onCurrent: function onCurrent(commentThreadId) {
      this.reload({
        threadId: commentThreadId,
        marketId: this.marketId
      });
    },
    onPrevious: function onPrevious() {
      this.reload({
        threadId: this.previousThread,
        marketId: this.marketId
      });
    },
    onNext: function onNext() {
      this.reload({
        threadId: this.nextThread,
        marketId: this.marketId
      });
    },
    enableDisqus: function enableDisqus(auth) {
      var commentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var shortname = "PredictIt";
      var resolvedAuth = this.$router.resolve({
        name: 'disqus-auth'
      });
      var resolvedLogout = this.$router.resolve({
        name: 'disqus-logout',
        params: {
          routeName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["H" /* smartbtoa */])(this.$route.name),
          routeParams: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["H" /* smartbtoa */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.params))
        }
      });

      disConfig.identifier = this.currentDisqusId || this.disqusId;
      disConfig.url = buildDisqusUrl(this.currentDisqusUrl || this.url, commentId);
      disConfig.title = this.currentDisqusTitle || this.title;
      disConfig.sso.width = this.isLayoutMobile ? 320 : 800;
      disConfig.sso.url = '' + window.location.origin + resolvedAuth.href;
      disConfig.sso.logout = '' + window.location.origin + resolvedLogout.href;
      // Note: SSO payloads expire after 2 hours. - now storing in ls
      disConfig.remote_auth_s3 = auth || '';
      this.appliedFocusCommentId = commentId;

      if (window.DISQUS) {
        window.DISQUS.reset({
          reload: true,
          config: disqusConfig
        });
      } else {
        window.disqus_config = disqusConfig;
        var existingScript = document.querySelector('[data-disqus-embed="true"]');

        if (!existingScript) {
          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = '//' + shortname + '.disqus.com/embed.js';
          script.setAttribute('data-disqus-embed', 'true');
          document.body.appendChild(script);
        }
      }
    }
  }),
  watch: {
    isActive: function isActive() {
      this.reconcileRequestedState();
    },
    focusCommentId: function focusCommentId() {
      this.reconcileRequestedState();
    },
    requestedCommentThreadId: function requestedCommentThreadId() {
      this.reconcileRequestedState();
    }
  }
});

/***/ }),

/***/ "czMQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d/V8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export thousandDisplay */
/* unused harmony export TITLE_LATEST_PRICE */
/* unused harmony export OPERATIONS */
/* unused harmony export VALUES */
/* unused harmony export BUTTONS */
/* unused harmony export getActiveButtonAfterSwitch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_button_direction_market_button_direction_vue__ = __webpack_require__("jtVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mutex__ = __webpack_require__("EOu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__ = __webpack_require__("tRmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__ = __webpack_require__("azKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_shares_ownership_market_shares_ownership_vue__ = __webpack_require__("tyTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_market_market_contract_horizontal_sushi_orders_market_contract_horizontal_sushi_orders_vue__ = __webpack_require__("G/7i");



/* eslint-disable */
















var thousandDisplay = function thousandDisplay(value) {
  if (value >= 1.0e+4) {
    return Math.round(value / 1.0e+3) + 'K';
  }
  return value >= 1.0e+3 ? Math.floor(10 * value / 1.0e+3) / 10 + 'K' : value;
};

var TITLE_LATEST_PRICE = 'Latest Price';
var firstNonEmptyString = function firstNonEmptyString() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value === 'string' && value.trim() !== '';
  });
};
var OPERATIONS = {
  BUY: 'buy',
  SELL: 'sell'
};
var VALUES = {
  YES: 'yes',
  NO: 'no'
};
var BUTTONS = {
  BUY_NO: {
    id: 'buy-no',
    type: OPERATIONS.BUY,
    value: VALUES.NO
  },
  BUY_YES: {
    id: 'buy-yes',
    type: OPERATIONS.BUY,
    value: VALUES.YES
  },
  SELL_NO: {
    id: 'sell-no',
    type: OPERATIONS.SELL,
    value: VALUES.NO
  },
  SELL_YES: {
    id: 'sell-yes',
    type: OPERATIONS.SELL,
    value: VALUES.YES
  }
};

function getActiveButtonAfterSwitch(contractModel, switchTo) {
  var button = null;

  if (switchTo === 'left') {
    button = BUTTONS.BUY_YES;;
  } else if (switchTo === 'right') {
    button = BUTTONS.BUY_NO;
  }

  return button;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__["a" /* default */]],
  components: {
    marketButtonDirection: __WEBPACK_IMPORTED_MODULE_8__components_market_market_button_direction_market_button_direction_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_7__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */],
    marketDisabledOutcomeV2: __WEBPACK_IMPORTED_MODULE_13__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__["a" /* default */],
    marketTradingUnavailableV2: __WEBPACK_IMPORTED_MODULE_14__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__["a" /* default */],
    marketSharesOwnership: __WEBPACK_IMPORTED_MODULE_15__components_market_market_shares_ownership_market_shares_ownership_vue__["a" /* default */],
    marketContractHorizontalSushiOrders: __WEBPACK_IMPORTED_MODULE_16__components_market_market_contract_horizontal_sushi_orders_market_contract_horizontal_sushi_orders_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    },
    forceMobileLayout: {
      type: Boolean,
      default: false
    },
    dashboardMode: {
      type: Boolean,
      default: false
    },
    showSharesOwnedIconOnImage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      BUTTONS: BUTTONS,
      OPERATIONS: OPERATIONS,
      VALUES: VALUES,
      isWaiting: false,
      activeButton: null,
      chart: null
    };
  },
  mounted: function mounted() {
    this.initializePurchaseButtons();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isTradingEnabled', 'currentPriceSymbol']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['settingShowOdds']), {
    useMobileLayout: function useMobileLayout() {
      return this.forceMobileLayout || this.isLayoutMobile;
    },
    useDesktopLayout: function useDesktopLayout() {
      return !this.useMobileLayout;
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    isMarketJourneyDisabled: function isMarketJourneyDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["y" /* isMarketJourneyDisabled */])(this.market);
    },
    singleMarketTitle: function singleMarketTitle() {
      return firstNonEmptyString(this.market && this.market.marketShortName, this.market && this.market.marketName, this.contractModel.marketName, this.contractModel.contractName) || TITLE_LATEST_PRICE;
    },
    cmsWidgetTitle: function cmsWidgetTitle() {
      return firstNonEmptyString(this.contract && this.contract.contractName) || TITLE_LATEST_PRICE;
    },
    title: function title() {
      if (this.forCmsWidget) {
        return this.cmsWidgetTitle;
      }

      return this.isMarketSingle ? this.singleMarketTitle : firstNonEmptyString(this.contractModel.contractName, this.contractModel.name);
    },
    classModifiers: function classModifiers() {
      return {
        'market-contract-horizontal-sushi': true,
        'market-contract-horizontal-sushi--show-shares-owned-on-image': this.showSharesOwnedIconOnImage,
        'market-contract-horizontal-sushi--dashboard': this.dashboardMode,
        'market-contract-horizontal-sushi--hovered': this.hovered,
        'market-contract-horizontal-sushi--forced-mobile': this.forceMobileLayout,
        'market-contract-horizontal-sushi--no-shares-or-offers': !this.showOffersOrShares,
        'market-contract-horizontal-sushi--settled-yes': this.isMarketSettled && this.isPayoutTypeYes,
        'market-contract-horizontal-sushi--settled-no': this.isMarketSettled && this.isPayoutTypeNo,
        'market-contract-horizontal-sushi--should-close': this.shouldClosePurchaseJourney,
        'market-contract-horizontal-sushi--cms-widget': this.forCmsWidget
      };
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    showOpenOffers: function showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar: function showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    sharesOwnedStyleModifiers: function sharesOwnedStyleModifiers() {
      return {
        'market-contract-horizontal-sushi__image-shares-owned': true,
        'market-contract-horizontal-sushi__image-shares-owned--no': this.contractModel.mode === 'no'
      };
    },
    showOffersOrShares: function showOffersOrShares() {
      return this.showSharesBar || this.showOpenOffers;
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["n" /* isMarketSettled */])(this.market);
    },
    isPayoutTypeYes: function isPayoutTypeYes() {
      return this.contract.payoutType === 1;
    },
    isPayoutTypeNo: function isPayoutTypeNo() {
      return this.isMarketSingle && this.contract.payoutType === 0;
    },
    shouldClosePurchaseJourney: function shouldClosePurchaseJourney() {
      return this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId;
    },
    currentPrice: function currentPrice() {
      return this.contractModel.lastTradePriceAsCents;
    },
    currentPriceDashboard: function currentPriceDashboard() {
      if (!this.contractModel.hasLastTradePrice) {
        return 0;
      }

      if (this.contractModel.mode === 'no') {
        return 100 - this.contractModel.lastTradePriceAsCents;
      }
      return this.contractModel.lastTradePriceAsCents;
    },
    volumeDisplay: function volumeDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["u" /* largeNumberDisplay */])(this.contractModel.userQuantity);
    },
    buyOrdersDisplay: function buyOrdersDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["u" /* largeNumberDisplay */])(this.contractModel.userOpenOrdersBuyQuantity);
    },
    sellOrdersDisplay: function sellOrdersDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["u" /* largeNumberDisplay */])(this.contractModel.userOpenOrdersSellQuantity);
    },
    buyOrdersTooltip: function buyOrdersTooltip() {
      return 'Buy: ' + this.contractModel.userOpenOrdersBuyQuantity.toLocaleString('en-US');
    },
    sellOrdersTooltip: function sellOrdersTooltip() {
      return 'Sell: ' + this.contractModel.userOpenOrdersSellQuantity.toLocaleString('en-US');
    }
  }),
  watch: {
    // opposite side of order book was clicked -- switching sides
    tradeOperationToggle: function tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      var button = getActiveButtonAfterSwitch(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, button.id);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    findActiveButton: function findActiveButton() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(BUTTONS).find(function (i) {
        return i.id === _this.activeButton;
      });
    },
    getTypeAndValueIfButtonActiveOrDefaults: function getTypeAndValueIfButtonActiveOrDefaults() {
      var type = this.tradeOptions.operationType;
      var value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        var button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type: type, value: value };
    },
    onClickSharesBar: function onClickSharesBar() {
      var _getTypeAndValueIfBut = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut.type,
          value = _getTypeAndValueIfBut.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    onClickOpenOffers: function onClickOpenOffers() {
      var tab = 'sell-offers';
      var operationType = this.tradeOptions.operationType || '';
      if (operationType === '' && this.contractModel.userOpenOrdersBuyQuantity || operationType === OPERATIONS.BUY && this.contractModel.userOpenOrdersBuyQuantity) {
        tab = 'buy-offers';
      }

      var _getTypeAndValueIfBut2 = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut2.type,
          value = _getTypeAndValueIfBut2.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    initializePurchaseButtons: function initializePurchaseButtons() {
      var button = BUTTONS.BUY_YES;
      if (this.contractModel.mode === VALUES.NO) {
        button = this.contract.contractId === this.tradeOptions.contractId && this.tradeOptions.operationValue === 'no' ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
      } else if (this.contractModel.mode === VALUES.YES) {
        button = BUTTONS.BUY_YES;
      }
      this.activeButton = button.id;

      if ((!this.isMarketSingle || this.useMobileLayout) && this.tradeOptions && this.contract.contractId === this.tradeOptions.contractId && (button.type !== this.tradeOptions.operationType || button.value !== this.tradeOptions.operationValue)) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
      }
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    },
    onContractClick: function onContractClick() {
      if (this.shouldClosePurchaseJourney) {
        this.setTradeOptions(null);
        return;
      }
      if (this.activeButton) {
        var button = BUTTONS.BUY_YES;
        if (this.contractModel.mode) {
          button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        }
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, button.id);

        // const $el = this.$refs[this.activeButton];
        // if (!$el) return;
        // const ev = new MouseEvent('click');
        // $el.dispatchEvent(ev);
      } else {
        var _button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        this.openPurchaseJourney(this.contractModel.contractId, _button.type, _button.value);
      }
    },
    isButtonActive: function isButtonActive(index) {
      var isOn = this.activeButton === index;
      var isButtonActive = this.tradeOptions.contractId === this.contract.contractId;

      return {
        'market-contract-horizontal-sushi__button-single--active': isButtonActive,
        'market-contract-horizontal-sushi__button-single--on': isOn,
        'market-contract-horizontal-sushi__button-single--off': !isOn,
        'market-contract-horizontal-sushi__button-single--off-yes': this.tradeOptions.operationValue === VALUES.YES,
        'market-contract-horizontal-sushi__button-single--off-no': this.tradeOptions.operationValue === VALUES.NO
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var _this2 = this;

      var activateButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (this.isWaiting) {
        return;
      }

      this.isWaiting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["a" /* waitForFirebaseInitialized */])().then(function () {
        if (_this2.isLoggedIn) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["b" /* waitForStatusReady */])();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }).then(function () {
        _this2.isWaiting = false;
        // contract does not modify tradeOptions, is simply used as a widget somewhere
        if (_this2.forCmsWidget) {
          _this2.$emit('contractClicked', { contractId: contractId, operationValue: operationValue });
          return;
        }

        if (_this2.isMarketJourneyDisabled || _this2.isMarketDisabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["w" /* contractOwnershipNum */])(_this2.contractModel) === 0) return;
        if (activateButton) {
          _this2.activeButton = activateButton;
        }
        _this2.pushSessionHistoryContract({
          value: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.contract, {
            marketName: _this2.market.marketShortName || _this2.market.marketName
          })
        });
        _this2.setTradeOptions({
          contractId: contractId,
          operationType: operationType,
          operationValue: operationValue !== null ? operationValue : _this2.contractModel.mode || VALUES.YES
        });
      });
    }
  })
});

/***/ }),

/***/ "d2fJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountWithdrawalLoader_vue__ = __webpack_require__("6iuM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d73298_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountWithdrawalLoader_vue__ = __webpack_require__("5v01");
function injectStyle (ssrContext) {
  __webpack_require__("9poZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountWithdrawalLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d73298_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountWithdrawalLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d3y4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMarket: function getMarket(marketId) {
    var commentThreadId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (commentThreadId) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '?commentThreadId=' + commentThreadId);
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId);
  },
  getCommentThread: function getCommentThread(_ref) {
    var marketId = _ref.marketId,
        threadId = _ref.threadId;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/CommentThread/' + threadId);
  },
  getMarketTopComments: function getMarketTopComments(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/TopComments');
  },
  getMarketRules: function getMarketRules(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Rule');
  },
  getContract: function getContract(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/Contract/' + contractId);
  },
  getRelatedContracts: function getRelatedContracts(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + contractId + '/RelatedContracts');
  },
  getMarketContracts: function getMarketContracts(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Contracts');
  },
  getMarketContractsStats: function getMarketContractsStats(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Contracts/Stats');
  },
  getMarketRelated: function getMarketRelated(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Related');
  },
  getMarketRelatedProducts: function getMarketRelatedProducts(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Market/' + marketId + '/RelatedProducts');
  }
});

/***/ }),

/***/ "d76Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__ = __webpack_require__("P71F");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__["a" /* default */]],
  metaInfo: function metaInfo() {
    return {
      title: 'News'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* STATIC_PAGES */].NEWS_ARCHIVE).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).catch(function () {
      _this.isComponentReady = true;
      _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "dB88":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dCA5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dDJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_info_v2_js__ = __webpack_require__("v01n");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_info_v2_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09cb4d47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_info_v2_vue__ = __webpack_require__("CRil");
function injectStyle (ssrContext) {
  __webpack_require__("T5QV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_info_v2_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09cb4d47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_info_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dDcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_share_invite_widget_js__ = __webpack_require__("dNf9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaa75f00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_invite_widget_vue__ = __webpack_require__("VQsM");
function injectStyle (ssrContext) {
  __webpack_require__("63o8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_share_invite_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaa75f00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_invite_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dEOY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dI8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_notifications__ = __webpack_require__("tjp7");





/* eslint-disable max-len */





var DEFAULT_SEARCH = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    searchBarVisible: false,
    hasSearched: false,
    searchQuery: '',
    searchResults: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_SEARCH)
  },
  mutations: {
    toggleSearchBar: function toggleSearchBar(state) {
      state.searchBarVisible = !state.searchBarVisible;
    },
    closeSearchBar: function closeSearchBar(state) {
      state.searchBarVisible = false;
    },
    resetSearchResults: function resetSearchResults(state) {
      state.searchResults = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_SEARCH);
    },
    setSearchResults: function setSearchResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.searchResults.data));
      var data = __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default()(sourceData.concat(payload.data.markets || []), 'marketId');
      var page = payload.data.page;
      var totalCount = payload.data.totalMarkets;
      var canLoadMore = totalCount > data.length;

      state.searchResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.searchResults, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setHasSearched: function setHasSearched(state, flag) {
      state.hasSearched = flag;
    },
    setSearchQuery: function setSearchQuery(state, query) {
      state.searchQuery = query;
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      if (state.searchResults.data) {
        state.searchResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.searchResults, {
          data: state.searchResults.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.searchResults.data) {
        state.searchResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.searchResults, {
          data: state.searchResults.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    }
  },
  actions: {
    toggleSearchBar: function toggleSearchBar(_ref) {
      var commit = _ref.commit;

      commit('toggleSearchBar');
    },
    closeSearchBar: function closeSearchBar(_ref2) {
      var commit = _ref2.commit;

      commit('closeSearchBar');
    },
    getSearch: function getSearch(_ref3, query) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.searchResults.canLoadMore) {
        var page = state.searchResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].browse.getSearch(query, page).then(function (response) {
          commit('setHasSearched', true);
          commit('setSearchResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({ TotalMarkets: 0 });
    },
    resetSearchResults: function resetSearchResults(_ref4, query) {
      var commit = _ref4.commit;

      commit('resetSearchResults');
      commit('setSearchQuery', query);
      if (!query) {
        commit('setHasSearched', false);
      }
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref5, payload) {
      var commit = _ref5.commit;

      commit('updateMarketFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateContractFromNotification', payload);
    }
  }
});

/***/ }),

/***/ "dK2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__ = __webpack_require__("GZXJ");


/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    if (!__WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__["g" /* isStandalone */]) {
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener noreferrer');
    }
  }
});

/***/ }),

/***/ "dLt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { staticPageHeader: __WEBPACK_IMPORTED_MODULE_6__components_static_page_header_static_page_header_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__["a" /* default */]],
  metaInfo: function metaInfo() {
    return {
      title: 'Platform Announcements'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* STATIC_PAGES */].PLATFORM_ANNOUNCEMENTS).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).catch(function () {
      _this.isComponentReady = true;
      _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "dMVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__ = __webpack_require__("qidN");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcbe727_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_notification_vue__ = __webpack_require__("7P8z");
function injectStyle (ssrContext) {
  __webpack_require__("YF1h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcbe727_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["b"] = (Component.exports);


/***/ }),

/***/ "dNf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].multipleEmails
    }
  },
  data: function data() {
    return {
      fields: {
        email: ''
      },
      successEmail: ''
    };
  },

  watch: {
    'fields.email': function fieldsEmail(value) {
      if (value) {
        this.successEmail = '';
      }
    }
  },
  computed: {
    shareUrl: function shareUrl() {
      return window.location.origin;
    },
    shareText: function shareText() {
      return 'Hey, I\'m playing @PredictIt and I think you should, too. You can make some money and have some fun picking political futures like election results and world events. Don\u2019t miss out!';
    },
    facebookShareUrl: function facebookShareUrl() {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl);
    },
    twitterShareUrl: function twitterShareUrl() {
      return 'http://twitter.com/share?url=' + encodeURIComponent(this.shareUrl) + '&text=' + encodeURIComponent(this.shareText);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['sendInviteEmail']), {
    onSend: function onSend() {
      var _this = this;

      this.loaderAdd();
      this.sendInviteEmail(this.fields.email).then(function () {
        _this.loaderRemove();
        _this.successEmail = _this.fields.email.split(';').map(function (i) {
          return i.replace(' ', '');
        }).join(', ');
        _this.fields.email = '';
        _this.$nextTick(function () {
          _this.$v.$reset();
        });
      }).catch(function () {
        return _this.loaderRemove();
      });
    },
    openShareDialog: function openShareDialog(url) {
      window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
    },
    onFacebookShare: function onFacebookShare() {
      this.openShareDialog(this.facebookShareUrl);
    },
    onTwitterShare: function onTwitterShare() {
      this.openShareDialog(this.twitterShareUrl);
    },
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_SHARE_INVITE_INFO);
    }
  })
});

/***/ }),

/***/ "dOsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__["a" /* default */]],
  props: {
    avatar: {},
    theme: {
      type: String,
      default: ''
    },
    radius: {
      type: Number,
      default: 58
    },
    percentage: {
      type: Number,
      default: 5
    },
    progressStrokeColor: {
      type: String,
      default: ''
    },
    backgroundStrokeColor: {
      type: String,
      default: '#e6e6e6'
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    notificationsCount: {
      type: Number,
      required: false,
      default: -1
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['hasBanner', 'hasMaintenanceMessage', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred']), {
    isRouteActive: function isRouteActive() {
      return this.$route.name === 'portfolio';
    },
    strokeWidth: function strokeWidth() {
      if (this.isRouteActive && this.theme === 'nav-top') return 7;
      return 5;
    },
    size: function size() {
      if (this.theme === 'profile') return this.isLayoutMobile ? 90 : 140;
      if (this.theme === 'markets') return 45;
      if (this.theme === 'nav-top') return 32;
      if (this.theme === 'nav-bottom' && !this.isRouteActive) return 30;
      if (this.theme === 'nav-bottom' && this.isRouteActive) return 30;
      if (this.theme === 'large') return 100;
      if (this.theme === 'leaderboards') return 32;
      if (this.theme === 'mobile-menu') return 32;
      if (this.theme === 'user-profile') return 100;
      return 84;
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'account-social-avatar': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account-social-avatar--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account-social-avatar--active', this.isRouteActive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account-social-avatar--server-error', this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner), _ref;
    },
    imageClassModifiers: function imageClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-social-avatar__oval': true
      }, 'account-social-avatar__oval--' + this.theme, this.theme);
    },
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'background-image': 'url(\'' + this.avatar + '\')',
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    labelClassModifiers: function labelClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-social-avatar__label': true
      }, 'account-social-avatar__label--' + this.theme, this.theme);
    },
    circReference: function circReference() {
      return 2 * Math.PI * this.radius;
    },
    styleModifiers: function styleModifiers() {
      return {
        strokeDashoffset: this.circReference * (1 - this.percentage / 100),
        strokeDasharray: this.circReference,
        stroke: this.progressStrokeColor
      };
    },
    isEditEnabled: function isEditEnabled() {
      // return this.showEdit && !(this.isIos && this.isStandalone);
      return this.showEdit;
    },
    showNotificationsCount: function showNotificationsCount() {
      return this.avatar && this.notificationsCount > 0;
    },
    hasLabel: function hasLabel() {
      return !!this.$slots.label;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onShowEditPopup: function onShowEditPopup() {
      if (this.isEditEnabled) this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_EDIT_IMAGE);
    }
  })
});

/***/ }),

/***/ "dQUH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lp-2.f0a8811.png";

/***/ }),

/***/ "dSDn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header"},[_c('div',{staticClass:"app-header__content"},[_c('div',{staticClass:"app-header__logo"},[_c('router-link',{attrs:{"to":{name: 'home'},"id":"pl-logo"}},[_c('img',{attrs:{"src":__webpack_require__("Kcew")}})])],1),_vm._v(" "),_c('div',{staticClass:"app-header__nav"},[_c('app-main-nav')],1),_vm._v(" "),_c('div',{staticClass:"app-header__side"},[(_vm.isLoggedIn)?_c('div',{class:_vm.notificationsIconModifiers,on:{"click":function($event){$event.stopPropagation();return _vm.onNotificationsClick($event)}}},[(_vm.showUnreadNotificationCount)?_c('div',{staticClass:"app-header__notifications-count"},[_vm._v("\n          "+_vm._s(_vm.userUnreadNotificationsCountHeader)+"\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"app-header__notifications-widget"}},[(_vm.showNotificationsWidget)?_c('div',{staticClass:"app-header__notifications-widget"},[_c('notifications-widget')],1):_vm._e()]),_vm._v(" "),(_vm.isLayoutMobile)?_c('hamburger-icon',{staticClass:"app-header__burger"}):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{staticClass:"app-header__menu"},[(_vm.isLoggedIn && _vm.showBalanceHeader)?[_c('router-link',{staticClass:"app-header__menu-item app-header__menu-item--investment app-header__menu-item--border-right",attrs:{"id":"investment","tag":"div","to":{ name: 'portfolio' }}},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixedflex",value:(_vm.balance.portfolioBalanceDecimal),expression:"balance.portfolioBalanceDecimal",modifiers:{"floor":true,"fixedflex":true}}],staticClass:"app-header__menu-item-value"}),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item-text"},[_vm._v("Investment")])]),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item app-header__menu-item--cash app-header__menu-item--border-right",attrs:{"id":"cash"},on:{"click":function($event){$event.preventDefault();return _vm.onCashClick($event)}}},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixedflex",value:(_vm.balance.accountBalanceDecimal),expression:"balance.accountBalanceDecimal",modifiers:{"floor":true,"fixedflex":true}}],staticClass:"app-header__menu-item-value"}),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item-text"},[_vm._v("Cash")])]),_vm._v(" "),_c('div',{class:_vm.depositClassModifiers,attrs:{"id":"nav-deposit"},on:{"click":function($event){$event.preventDefault();return _vm.openDepositPopup($event)}}},[_c('div',{staticClass:"app-header__menu-item-icon app-header__menu-item-icon--deposit app-header__menu-item--border-right"}),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item-text"},[_vm._v("Deposit")])])]:(!_vm.isLoggedIn)?[_c('header-search'),_vm._v(" "),(!_vm.isUserRestricted)?_c('div',{staticClass:"app-header__menu-item app-header__menu-item--register app-header__menu-item--border-right",attrs:{"id":"signup"},on:{"click":_vm.onSignUp}},[_c('div',[_vm._v("SIGN UP")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item app-header__menu-item--login",attrs:{"id":"login"},on:{"click":_vm.onLogin}},[_c('div',[_vm._v("LOGIN")])])]:_vm._e(),_vm._v(" "),(!_vm.isUserRestricted && _vm.isLoggedIn)?_c('div',{staticClass:"app-header__menu-item app-header__menu-item--search",attrs:{"id":"search"},on:{"click":_vm.toggleSearchBar}},[_c('div',{staticClass:"app-header__menu-item-icon app-header__menu-item-icon--search"}),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item-text"},[_vm._v("Search")])]):_vm._e()],2):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dSN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dSZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");



 /**
                                * reCAPTCHA v3 + v2 Fallback Service
                                *
                                * Primary: Uses invisible reCAPTCHA v3 (no user interaction)
                                * Fallback: When v3 score fails, allows v2 challenge modal
                                */




var v3SiteKey = null;
var v2SiteKey = null;
var grecaptchaInstance = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Initialize the v3 reCAPTCHA script
   * @returns {Promise<object>} The grecaptcha instance
   */
  initV3: function initV3() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var scriptUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(grecaptchaInstance && v3SiteKey)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', grecaptchaInstance);

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].account.getCaptchaSiteKeyV3().then(function (r) {
                return r.data;
              });

            case 4:
              v3SiteKey = _context.sent;
              scriptUrl = 'https://www.google.com/recaptcha/api.js?render=' + v3SiteKey;
              _context.next = 8;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["b" /* loadScript */])(scriptUrl, 'grecaptcha');

            case 8:
              grecaptchaInstance = _context.sent;
              return _context.abrupt('return', grecaptchaInstance);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  /**
   * Execute invisible v3 reCAPTCHA and get token
   * @param {string} action - The action name for scoring (e.g., 'login', 'register')
   * @returns {Promise<string>} The reCAPTCHA token
   */
  executeV3: function executeV3(action) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var grecaptcha;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.initV3();

            case 2:
              grecaptcha = _context2.sent;
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                grecaptcha.ready(function () {
                  grecaptcha.execute(v3SiteKey, { action: action }).then(resolve);
                });
              }));

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },


  /**
   * Get the v2 site key for fallback challenge modal
   * @returns {Promise<string>} The v2 site key
   */
  getV2SiteKey: function getV2SiteKey() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (v2SiteKey) {
                _context3.next = 4;
                break;
              }

              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].account.getCaptchaSiteKey().then(function (r) {
                return r.data;
              });

            case 3:
              v2SiteKey = _context3.sent;

            case 4:
              return _context3.abrupt('return', v2SiteKey);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },


  /**
   * Check if an error response indicates v3 score failed and v2 challenge is needed
   * @param {object} error - Axios error object
   * @returns {boolean} True if v2 challenge is required
   */
  isV3ScoreFailure: function isV3ScoreFailure(error) {
    // Check for OAuth token endpoint error format
    var oauthError = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(error, 'response.data.error');
    if (oauthError === 'recaptcha_challenge_required') {
      return true;
    }
    // Check for standard API error format
    var data = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(error, 'response.data', []);
    if (Array.isArray(data)) {
      return data.some(function (e) {
        return e.code === 'recaptcha_challenge_required';
      });
    }
    return false;
  }
});

/***/ }),

/***/ "dVCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_watchlist_js__ = __webpack_require__("MH7L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e066ffcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_watchlist_vue__ = __webpack_require__("zRJs");
function injectStyle (ssrContext) {
  __webpack_require__("Sa5U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_watchlist_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e066ffcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_watchlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dcEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_overview_map_overview_map_contract_overview_map_contract_vue__ = __webpack_require__("YHd0");








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  components: {
    overviewMapContract: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_overview_map_overview_map_contract_overview_map_contract_vue__["a" /* default */]
  },
  props: {
    mapOverviewData: {},
    type: {
      type: String,
      default: 'electoral'
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), {
    num: function num() {
      return 2;
    },
    dummyComponents: function dummyComponents() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, this.num);
    },
    items: function items() {
      return this.mapOverviewData.slice(0, this.num);
    }
  }),
  methods: {
    mapOverviewDataHandler: function mapOverviewDataHandler(value) {
      if (value.length > 0) {
        this.isComponentReady = true;
      }
    }
  },
  watch: {
    mapOverviewData: {
      handler: 'mapOverviewDataHandler',
      immediate: true
    }
  }
});

/***/ }),

/***/ "dh9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('browse', ['userBrowseHeaders']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('browse', ['showNavBrowseOverlay'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['toggleNavBrowseCategoriesOverlay']), {
    closeOverlay: function closeOverlay() {
      this.toggleNavBrowseCategoriesOverlay();
    }
  }),
  watch: {
    showNavBrowseOverlay: function showNavBrowseOverlay(value) {
      if (value) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["l" /* lockModal */])();
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["m" /* unLockModal */])();
      }
    }
  }
});

/***/ }),

/***/ "dimc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_errors_js__ = __webpack_require__("zNKi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed38a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_errors_vue__ = __webpack_require__("JD5z");
function injectStyle (ssrContext) {
  __webpack_require__("f9W8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_errors_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed38a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_errors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dlHv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_public_profile_widget_js__ = __webpack_require__("3wpX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c17a5f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_public_profile_widget_vue__ = __webpack_require__("+8hI");
function injectStyle (ssrContext) {
  __webpack_require__("FQlF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_public_profile_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c17a5f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_public_profile_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "drLe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");






var BALANCE_THRESHOLD = 0;
var DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES = ['account-page-login', 'account-page-register', 'account-password-forgotten', 'index1', 'index2'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn', 'isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    showLoginAndSignUpButtons: function showLoginAndSignUpButtons() {
      return !DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES.includes(this.$route.name);
    },
    showBalanceHeader: function showBalanceHeader() {
      return this.settings.display ? this.settings.display.ShowBalanceHeader : true;
    },
    notifyOnLowBalance: function notifyOnLowBalance() {
      return this.balance.accountBalanceDecimal <= BALANCE_THRESHOLD;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['closeMobileMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSideNotification', 'toggleNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar', 'closeSearchBar']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCashClick: function onCashClick() {
      this.closeMobileMenu();
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      } else if (!this.isUserVerified) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
        return;
      }
      this.$router.push({ name: 'wallet' });
    },
    onInvestmentClick: function onInvestmentClick() {
      this.closeMobileMenu();
      this.$router.push({ name: 'portfolio' });
    },
    onSignUp: function onSignUp() {
      this.closeMobileMenu();
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
    },
    onLogin: function onLogin() {
      this.closeMobileMenu();
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    },
    openDepositPopup: function openDepositPopup() {
      if (!this.hasUserClassicEnabled) {
        this.closeMobileMenu();
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
      } else if (this.isUserVerified) {
        if (this.$route.name !== 'wallet') {
          this.closeMobileMenu();
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
        }
      } else {
        this.closeMobileMenu();
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
      }
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    }
  })
});

/***/ }),

/***/ "drbC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "drjh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");

/* eslint-disable */







var refreshSubscribers = [];
var isRefreshing = false;

function tokenRefreshSubscribe(cb) {
  refreshSubscribers.push(cb);
}

function tokenRefreshComplete(token) {
  refreshSubscribers.map(function (cb) {
    return cb(token);
  });
  refreshSubscribers = [];
}

var skipFromInterceptor = ['api/Account/UploadUserImage', 'api/Support/Ticket', 'api/Profile/SetUserAffiliations', 'api/Profile/RemoveUserAffiliations', "/" + 'api/Account/UploadUserImage', "/" + 'api/Support/Ticket', "/" + 'api/Profile/SetUserAffiliations', "/" + 'api/Profile/RemoveUserAffiliations'];

function checkRequest(request) {
  return request.method === 'post' && skipFromInterceptor.indexOf(request.url) === -1;
}

/* harmony default export */ __webpack_exports__["a"] = (function (request) {
  if (checkRequest(request)) {
    request.data = __WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify(request.data);
  }
  if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn']) return request;

  var expiresAt = __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('tokenExpires', null);
  var threshold = -60;
  var expiresOrIsAboutToExpires = expiresAt === null || __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(expiresAt), 'seconds') > threshold;

  if (expiresOrIsAboutToExpires && !isRefreshing) {
    isRefreshing = true;
    var payload = {
      grant_type: 'refresh_token',
      refresh_token: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('refreshToken')
    };
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/login', payload).then(function () {
      isRefreshing = false;
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] REFRESHED');
      tokenRefreshComplete(__WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('token'));
    }).catch(function () {
      isRefreshing = false;
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] CANNOT REFRESH');
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/clearAuthSession');
      tokenRefreshComplete(null);
    });

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      tokenRefreshSubscribe(function (token) {
        if (token) {
          request.headers.Authorization = 'Bearer ' + token;
        } else if (request.headers) {
          delete request.headers.Authorization;
          if (request.headers.common) {
            delete request.headers.common.Authorization;
          }
        }
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] Retry');
        resolve(request);
      });
    });
  }

  return request;
});

/***/ }),

/***/ "dstN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_ach_ach_vue__ = __webpack_require__("Ucvo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_check_check_vue__ = __webpack_require__("ep7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_bank_transfer_bank_transfer_vue__ = __webpack_require__("3mSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_coinbase_withdraw_coinbase_withdraw_vue__ = __webpack_require__("1ri1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_list_withdrawal_pending_requests_list_withdrawal_vue__ = __webpack_require__("88wj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");










var TAB_ACH = 'ach';
var TAB_CHECK = 'check';
var TAB_COIN_BASE = 'coinbase';
var TAB_PENDING_REQUESTS = 'pending';
var TAB_BANK_TRANSFER = 'bank-transfer';
var GTM_PAGE_NAME = 'withdraw';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    ach: __WEBPACK_IMPORTED_MODULE_3__components_wallet_ach_ach_vue__["a" /* default */],
    check: __WEBPACK_IMPORTED_MODULE_4__components_wallet_check_check_vue__["a" /* default */],
    bankTransfer: __WEBPACK_IMPORTED_MODULE_5__components_wallet_bank_transfer_bank_transfer_vue__["a" /* default */],
    coinbaseWithdraw: __WEBPACK_IMPORTED_MODULE_6__components_wallet_coinbase_withdraw_coinbase_withdraw_vue__["a" /* default */],
    pendingRequests: __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_list_withdrawal_pending_requests_list_withdrawal_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      cryptoDesctiption: '',
      showTabs: false,
      activeTab: null,
      isCryptoAvailable: false,
      isCheckAvailable: false,
      isAchAvailable: false,
      isWireTransferAvailable: false
    };
  },

  computed: {
    showAchTab: function showAchTab() {
      return this.activeTab === TAB_ACH;
    },
    showCheckTab: function showCheckTab() {
      return this.activeTab === TAB_CHECK;
    },
    showPendingTab: function showPendingTab() {
      return this.activeTab === TAB_PENDING_REQUESTS;
    },
    showCryptoTab: function showCryptoTab() {
      return this.activeTab === TAB_COIN_BASE;
    },
    showBankTransferTab: function showBankTransferTab() {
      return this.activeTab === TAB_BANK_TRANSFER;
    },
    tabs: function tabs() {
      var results = [];
      if (this.isAchAvailable) {
        results.push({
          name: TAB_ACH,
          title: 'ACH'
        });
      }
      if (this.isCheckAvailable) {
        results.push({
          name: TAB_CHECK,
          title: 'Check'
        });
      }
      if (this.isCryptoAvailable) {
        results.push({
          name: TAB_COIN_BASE,
          title: this.cryptoDesctiption
        });
      }
      if (this.isWireTransferAvailable) {
        results.push({
          name: TAB_BANK_TRANSFER,
          title: 'Wire Transfer'
        });
      }
      results.push({ name: TAB_PENDING_REQUESTS, title: 'Pending' });
      return results;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getWithdrawalMethods']), {
    onSuccessWithdraw: function onSuccessWithdraw() {
      this.activeTab = TAB_PENDING_REQUESTS;
    },
    tabChange: function tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: this.$route.path + '/' + GTM_PAGE_NAME + '/' + name,
          virtualPageTitle: this.$route.name + ' - ' + GTM_PAGE_NAME + ' - ' + name
        });
      }
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getWithdrawalMethods().then(function (data) {
      _this.showTabs = true;
      _this.isCheckAvailable = data.isCheckAvailable;
      _this.isAchAvailable = data.isAchAvailable;
      _this.isWireTransferAvailable = data.isWireTransferAvailable;
      _this.isCryptoAvailable = data.isCryptoAvailable;
      _this.cryptoDesctiption = data.cryptoDescription || 'USDC';
      _this.loaderRemove(document.body);
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "dxV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_js__ = __webpack_require__("bbNg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e09f9a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_vue__ = __webpack_require__("svCT");
function injectStyle (ssrContext) {
  __webpack_require__("naY1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e09f9a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dywA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_trends_js__ = __webpack_require__("mka8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a0a44f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trends_vue__ = __webpack_require__("LnM6");
function injectStyle (ssrContext) {
  __webpack_require__("gZZf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_trends_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a0a44f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trends_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e/7H":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "e0++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_to_review_js__ = __webpack_require__("o3i4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43091980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_to_review_vue__ = __webpack_require__("MI6U");
function injectStyle (ssrContext) {
  __webpack_require__("q3Wh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_to_review_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43091980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_to_review_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e1V1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e69X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e7+2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e76B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.toggleMobileMenu}},[_c('div',{staticClass:"hamburger-icon__icon"}),_vm._v(" "),_c('div',{staticClass:"hamburger-icon__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e8xD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip"},[(_vm.isLayoutMobile)?[_c('div',{class:_vm.mobileBarClassModifiers},[_c('market-settings-button',{attrs:{"theme":"details"},model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}}),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__mobile-title"},[_vm._v("\n        "+_vm._s(_vm.titleSecondMobile)+"\n      ")])],1)]:[_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__item-1"},[_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"market-contracts-list-header-sushi-common-betslip__item-2",class:{
      'market-contracts-list-header-sushi-common-betslip__item-2--disabled-desktop': _vm.isMarketDisabled && _vm.isLayoutDesktop
         }},[_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__item-2-text market-contracts-list-header-sushi-common-betslip__item-2-text--clickable",on:{"click":_vm.onMenuToggle}},[_vm._v("\n        "+_vm._s(_vm.titleSecond)+"\n      ")]),_vm._v(" "),(false)?_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__item-2-toggle",on:{"click":_vm.onMenuToggle}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"market-contracts-list-header-sushi-common-betslip"}},[(_vm.showMenu)?_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__menu"},[_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__menu-inner"},[_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__menu-inner-item",on:{"click":function($event){return _vm.setOddsMode(true)}}},[_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__menu-inner-icon",class:{ 'market-contracts-list-header-sushi-common-betslip__menu-inner-icon--empty': !_vm.settingShowOdds }}),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__menu-inner-item-operation",class:{ 'market-contracts-list-header-sushi-common-betslip__menu-inner-item-operation--selected': _vm.settingShowOdds }},[_vm._v("\n                Odds\n              ")])]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__menu-inner-item",on:{"click":function($event){return _vm.setOddsMode(false)}}},[_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__menu-inner-icon",class:{ 'market-contracts-list-header-sushi-common-betslip__menu-inner-icon--empty': _vm.settingShowOdds }}),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__menu-inner-item-operation",class:{ 'market-contracts-list-header-sushi-common-betslip__menu-inner-item-operation--selected': !_vm.settingShowOdds }},[_vm._v("\n                Trade Prices\n              ")])])])]):_vm._e()])],1),_vm._v(" "),(_vm.isMarketDisabled)?[_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__item-3"},[_vm._v("\n        "+_vm._s(_vm.titleThird)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi-common-betslip__item-4"},[_vm._v("\n        "+_vm._s(_vm.titleFourth)+"\n      ")])]:_vm._e(),_vm._v(" "),(!_vm.isLayoutMobile && !_vm.isMarketDisabled)?_c('market-settings-button',{model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}}):_vm._e()],_vm._v(" "),_c('market-settings-modal',{model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e9Yj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_cmsContent__ = __webpack_require__("tQfv");


var PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_cmsContent__["a" /* default */]],
  props: {
    detailData: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      storyContent: '',
      resizeObserver: null
    };
  },

  methods: {
    emitPodcastLayoutRefresh: function emitPodcastLayoutRefresh() {
      window.dispatchEvent(new Event(PODCAST_LAYOUT_REFRESH_EVENT));
    },
    setupResizeObserver: function setupResizeObserver() {
      var _this = this;

      if (typeof ResizeObserver === 'undefined' || !this.$el) {
        return;
      }
      this.teardownResizeObserver();
      this.resizeObserver = new ResizeObserver(function () {
        _this.emitPodcastLayoutRefresh();
      });
      this.resizeObserver.observe(this.$el);
    },
    teardownResizeObserver: function teardownResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    },
    refreshSurface: function refreshSurface() {
      var _this2 = this;

      var data = this.detailData || {};
      var cmsContentObject = data.cmsContentObject || {};
      this.storyContent = '' + (data.bodyCSS || '') + (data.bodyHTML || '');
      this.$nextTick(function () {
        _this2.installDynamicControls({
          data: {
            cmsContentObject: cmsContentObject
          }
        });
        _this2.$nextTick(function () {
          _this2.setupResizeObserver();
          _this2.emitPodcastLayoutRefresh();
          setTimeout(function () {
            return _this2.emitPodcastLayoutRefresh();
          }, 200);
        });
      });
    }
  },
  watch: {
    detailData: {
      handler: function handler() {
        this.refreshSurface();
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.refreshSurface();
  },
  beforeDestroy: function beforeDestroy() {
    this.teardownResizeObserver();
  }
});

/***/ }),

/***/ "eFDh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eFE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_modal_switch_switch_vue__ = __webpack_require__("iOeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_contracts_stats_market_contracts_stats_vue__ = __webpack_require__("Y/q+");
/* eslint-disable no-restricted-syntax */




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketContractsStats: __WEBPACK_IMPORTED_MODULE_1__components_market_market_contracts_stats_market_contracts_stats_vue__["a" /* default */],
    switchModal: __WEBPACK_IMPORTED_MODULE_0__components_generics_modal_switch_switch_vue__["a" /* default */]
  },
  props: {
    stats: {
      type: Array,
      required: true
    },
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return {
        'market-contracts-stats-popup__content': true,
        'market-contracts-stats-popup__content--long': this.stats.length > 5
      };
    }
  },
  methods: {
    close: function close() {
      this.$emit('modalClose');
    }
  }
});

/***/ }),

/***/ "eFwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showMenu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['settingShowOdds'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingShowOdds']), {
    onMenuToggle: function onMenuToggle() {
      if (this.forCmsWidget) return;
      this.showMenu = !this.showMenu;
    },
    onClickOutside: function onClickOutside() {
      this.showMenu = false;
    },
    setOddsMode: function setOddsMode(value) {
      this.setSettingShowOdds(value);
      this.showMenu = false;
    }
  })
});

/***/ }),

/***/ "eGtO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_processing_transaction_js__ = __webpack_require__("vJHd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038c8f8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processing_transaction_vue__ = __webpack_require__("+j07");
function injectStyle (ssrContext) {
  __webpack_require__("F06B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_processing_transaction_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038c8f8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processing_transaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eHZI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "eInO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: String,
    data: Object
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click', this.data);
    }
  }
});

/***/ }),

/***/ "eKbQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-reset-password"},[_c('form',{staticClass:"account-reset-password__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"validation":_vm.$v.fields.email,"autocomplete":"off","gtm":"Reset Password,Email","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"name":"newPassword","type":"password","disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPassword,"autocomplete":"off","placeholder":"New Password"},on:{"input":_vm.$v.fields.newPassword.$touch},model:{value:(_vm.fields.newPassword),callback:function ($$v) {_vm.$set(_vm.fields, "newPassword", $$v)},expression:"fields.newPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"name":"newPasswordConfirmation","type":"password","disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPasswordConfirmation,"autocomplete":"off","placeholder":"Confirm New Password"},on:{"input":_vm.$v.fields.newPasswordConfirmation.$touch},model:{value:(_vm.fields.newPasswordConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "newPasswordConfirmation", $$v)},expression:"fields.newPasswordConfirmation"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form__section account-reset-password__submit"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Reset Password"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eLZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_alert_v2_js__ = __webpack_require__("LiRf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b49ada2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_alert_v2_vue__ = __webpack_require__("btoj");
function injectStyle (ssrContext) {
  __webpack_require__("aFCK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_alert_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b49ada2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_alert_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eLuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__ = __webpack_require__("bTYh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fec102c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__ = __webpack_require__("Q6AZ");
function injectStyle (ssrContext) {
  __webpack_require__("GB5W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fec102c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eMds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_transactions_js__ = __webpack_require__("QA2/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58740d2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transactions_vue__ = __webpack_require__("I7u4");
function injectStyle (ssrContext) {
  __webpack_require__("/sbu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_transactions_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58740d2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eNmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_js__ = __webpack_require__("E2Y7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1fb362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_vue__ = __webpack_require__("283W");
function injectStyle (ssrContext) {
  __webpack_require__("ub3M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1fb362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eWdu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_withdraw_confirm_withdraw_confirm_vue__ = __webpack_require__("waMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_available_balance_available_balance_vue__ = __webpack_require__("3PvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__("c/9r");












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* formMixin */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__["a" /* default */],
    availableBalance: __WEBPACK_IMPORTED_MODULE_5__components_wallet_available_balance_available_balance_vue__["a" /* default */],
    withdrawConfirm: __WEBPACK_IMPORTED_MODULE_3__components_wallet_withdraw_confirm_withdraw_confirm_vue__["a" /* default */]
  },
  validations: function validations() {
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].depositAmountCoinbase(this.minWithdrawal, this.maxWithdrawal)
      }
    };
  },
  created: function created() {
    this.checkWithdrawCoinbase();
  },
  data: function data() {
    return {
      countries: [],
      error: '',
      showConfirmation: false,
      fields: {
        amount: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['withdrawCoinbase']), {
    availableBalance: function availableBalance() {
      return this.withdrawCoinbase && this.withdrawCoinbase.availableFundsString ? this.withdrawCoinbase.availableFundsString : '$0.00';
    },
    restrictedFunds: function restrictedFunds() {
      return this.withdrawCoinbase && this.withdrawCoinbase.restrictedFundsString ? this.withdrawCoinbase.restrictedFundsString : '';
    },
    minWithdrawal: function minWithdrawal() {
      return this.maxWithdrawal > 0 ? 0.1 : 0;
    },
    maxWithdrawal: function maxWithdrawal() {
      return this.withdrawCoinbase ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["G" /* roundDown */])(this.withdrawCoinbase.availableFunds) : 0;
    },
    isWithdrawalDisabled: function isWithdrawalDisabled() {
      return Number(this.fields.amount || 0) === 0;
    },
    isAmountFieldDisabled: function isAmountFieldDisabled() {
      return this.minWithdrawal < 0.1 || this.maxWithdrawal < 1;
    },
    errorMessage: function errorMessage() {
      return this.error || this.withdrawCoinbase.errorMessage;
    },
    hasErrorMessage: function hasErrorMessage() {
      return this.error || !!this.withdrawCoinbase.errorMessage;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getVerifyID']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getWithdrawCoinbase']), {
    onSubmit: function onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess: function onSuccess() {
      this.fields.amount = '';
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawCoinbase();
      this.$emit('success');
    },
    onEdit: function onEdit() {
      this.showConfirmation = false;
    },
    checkWithdrawCoinbase: function checkWithdrawCoinbase() {
      var _this = this;

      this.getWithdrawCoinbase().then(function (data) {
        _this.checkDocumentUploadFlags(data);
        _this.isComponentReady = true;
      }).catch(function (error) {
        _this.isComponentReady = true;
        _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '');
      });
    }
  })
});

/***/ }),

/***/ "eb91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  props: {
    num: {
      type: Number,
      default: 3
    }
  },
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    var _this = this;

    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('browse', ['newArrivalMarkets']), {
    title: function title() {
      return 'New Arrivals';
    },
    items: function items() {
      return this.newArrivalMarkets;
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === this.num - 1;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--left': true,
        'most-predicted__header-arrow--disabled': this.isPrevArrowDisabled
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--right': true,
        'most-predicted__header-arrow--disabled': this.isNextArrowDisabled
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getNewArrivalMarkets']), {
    prevSlide: function prevSlide() {
      if (!this.isPrevArrowDisabled) this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      if (!this.isNextArrowDisabled) this.$refs.swiper.swiper.slideNext();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      limit: this.num
    };

    this.loaderAdd();

    this.getNewArrivalMarkets(payload).then(function () {
      _this2.loaderRemove();
      _this2.isComponentReady = true;
    }).catch(function () {
      return _this2.loaderRemove();
    });
  }
});

/***/ }),

/***/ "ed4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_button_js__ = __webpack_require__("W82P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb742ad8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_button_vue__ = __webpack_require__("f/U3");
function injectStyle (ssrContext) {
  __webpack_require__("dCA5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb742ad8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "edJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('preview-carousel-loader'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}],class:_vm.tabsClassModifiers},[(_vm.showNavigationArrows)?_c('button',{staticClass:"preview-carousel__arrow preview-carousel__arrow--left",attrs:{"disabled":!_vm.canScrollLeft,"aria-label":"Scroll left"},on:{"click":_vm.scrollLeft}}):_vm._e(),_vm._v(" "),_c('div',{ref:"tabsList",staticClass:"preview-carousel__nav-container"},[_c('tabs',{attrs:{"items":_vm.navigationTabs,"theme":"carousel","activeTab":_vm.activeTab},on:{"tabChange":_vm.navigationTabChange},nativeOn:{"click":function($event){return _vm.tabsClicked($event)}}})],1),_vm._v(" "),(_vm.showNavigationArrows)?_c('button',{staticClass:"preview-carousel__arrow preview-carousel__arrow--right",attrs:{"disabled":!_vm.canScrollRight,"aria-label":"Scroll right"},on:{"click":_vm.scrollRight}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isComponentReady),expression:"isComponentReady"}],ref:"content",class:_vm.contentClassModifiers,style:(_vm.contentStyleModifiers)},_vm._l((_vm.storyMap),function(data,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(parseInt(index, 10) === _vm.currentStoryIndex),expression:"parseInt(index, 10) === currentStoryIndex"}],key:(_vm.refreshIndex + "-" + index),staticClass:"preview-carousel__story"},[_c('div',{staticClass:"preview-carousel__story-html",domProps:{"innerHTML":_vm._s(_vm.storyContentMap[index])}})])}),0),_vm._v(" "),(_vm.showExpandControl)?_c('div',{class:_vm.expandClassModifiers,on:{"click":_vm.toggleExpand}},[(!_vm.isExpanded)?_c('span',[_vm._v("Read More ▾")]):_c('span',[_vm._v("Show Less ▴")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "egIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-info-loader"},[_c('div',{staticClass:"contract-info-loader__image"}),_vm._v(" "),_c('div',{staticClass:"contract-info-loader__content"},[_c('div',{staticClass:"contract-info-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"contract-info-loader__text-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ei5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select",class:_vm.selectModifiers},[(_vm.disabled)?_c('div',{staticClass:"select__disabled"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"select__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('multiselect',{attrs:{"adjust":_vm.adjust,"value":_vm.value,"show-no-results":_vm.showNoResults,"options":_vm.options,"track-by":_vm.trackBy,"label":_vm.label,"placeholder":"","show-labels":false,"searchable":_vm.searchable,"allow-empty":false,"max-height":_vm.maxHeight,"custom-label":_vm.customLabel,"tabindex":_vm.tabindex},on:{"close":function (e) { return _vm.$emit('close', e); },"select":function (e) { return _vm.$emit('select', e); },"input":_vm.updateValue}},[_c('div',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("No elements found.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "emeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header"},[(_vm.isLayoutDesktop)?_c('div',{staticClass:"charts-header--clear"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"charts-header--right"},[(_vm.showDownload)?_c('div',{staticClass:"charts-header__download",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onDownload($event)}}},[_c('div',{staticClass:"charts-header__download-icon"})]):_vm._e()])]):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"charts-header--clear"},[_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header--left"},[_c('div',{staticClass:"charts-header__logo"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header--left"},[_vm._v("\n      Volume "),_c('img',{attrs:{"src":__webpack_require__("Z4oj")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header--right"},[_c('img',{attrs:{"src":__webpack_require__("7wmZ")}}),_vm._v(" Price\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ep7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_js__ = __webpack_require__("mcLx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b555e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_vue__ = __webpack_require__("MSkT");
function injectStyle (ssrContext) {
  __webpack_require__("opDZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b555e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "erdd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eufm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eveM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-disqus"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "exX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_filters_market_filters_desktop_grid_watchlist_market_filters_desktop_grid_watchlist_vue__ = __webpack_require__("dVCa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_filters_market_filters_mobile_watchlist_market_filters_mobile_watchlist_vue__ = __webpack_require__("SMhf");










var NO_ITEMS_MESSAGE = 'There are no markets in your Watchlist';
var NO_MORE_ITEMS_MESSAGE = 'No more markets to display';
var SCROLL_FOR_MORE = 'Scroll down for more markets';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */]],
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    marketFiltersDesktopGrid: __WEBPACK_IMPORTED_MODULE_7__components_market_market_filters_market_filters_desktop_grid_watchlist_market_filters_desktop_grid_watchlist_vue__["a" /* default */],
    marketFiltersMobile: __WEBPACK_IMPORTED_MODULE_8__components_market_market_filters_market_filters_mobile_watchlist_market_filters_mobile_watchlist_vue__["a" /* default */],
    marketListItem: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Watchlist'
    };
  },
  data: function data() {
    return {
      loadedInfo: SCROLL_FOR_MORE,
      infiniteLoader: null,
      stickyOptions: __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile,
      watchersDisabled: false,
      watchersRemoved: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['selectedOrder', 'selectedTimespan']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['watchlist']), {
    items: function items() {
      return this.watchlist.data === null ? [] : this.watchlist.data;
    },
    showNoMarketsMessage: function showNoMarketsMessage() {
      return !this.isLoading && this.items.length === 0;
    },
    filtering: function filtering() {
      return this.selectedOrder.name + this.selectedTimespan.name;
    },
    infiniteLoadingKey: function infiniteLoadingKey() {
      return 'watchlist-' + this.selectedOrder.sort + '-' + this.selectedTimespan.parameter + '-' + this.watchersRemoved;
    }
  }),
  watch: {
    filtering: 'filteringChanged',
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.watchlist.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }

      if (!this.watchlist.canLoadMore) {
        this.loadedInfo = this.items.length > 0 ? NO_MORE_ITEMS_MESSAGE : NO_ITEMS_MESSAGE;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['clearOrder', 'clearTimespan']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('watchlist', ['resetWatchlist', 'getWatchList', 'reloadWatchlist']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['removeMarketFromWatchList']), {
    filteringChanged: function filteringChanged() {
      if (this.watchersDisabled) return;

      this.$router.push({
        name: 'market-watchlist',
        query: {
          sort: this.selectedOrder.sort,
          sortParameter: this.selectedTimespan.parameter
        }
      });
      this.resetWatchlist();
    },
    onRemoveMarketFromWatchList: function onRemoveMarketFromWatchList(item) {
      var _this = this;

      this.loaderAddLegacy(document.body);
      this.removeMarketFromWatchList(item.marketId).then(function () {
        return _this.reloadWatchlist();
      }).then(function () {
        return _this.loaderRemoveLegacy(document.body);
      }).catch(function () {
        _this.loaderRemoveLegacy(document.body);
      });
    },
    goInfinite: function goInfinite(infi) {
      var _this2 = this;

      this.infiniteLoader = infi;

      if (this.watchlist.canLoadMore) {
        this.isLoading = true;
        this.getWatchList().then(function () {
          _this2.isLoading = false;
        }).catch(function () {
          _this2.isLoading = false;
        });
      }
    }
  }),
  mounted: function mounted() {
    this.resetWatchlist();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // browse.selectedOrder etc i shared by watchlist and markets page
    this.watchersDisabled = true;
    this.clearTimespan().then(this.clearOrder()).then(function () {
      return next();
    });
  }
});

/***/ }),

/***/ "f+P6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('small-modal',{on:{"modalClose":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("\n    Trade Experience Settings\n  ")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"market-settings-modal__menu"},[_vm._l((_vm.settingsModalOptions),function(setting){return _c('div',{key:setting.key,staticClass:"market-settings-modal__option"},[_c('div',{staticClass:"market-settings-modal__label"},[_vm._v("\n          "+_vm._s(setting.info)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-settings-modal__inner"},[_c('div',{staticClass:"market-settings-modal__inner-items"},_vm._l((setting.options),function(option){return _c('div',{key:option.key,staticClass:"market-settings-modal__inner-item",class:{
                'market-settings-modal__inner-item--selected': _vm.isSelected(setting.key, option.key),
                'market-settings-modal__inner-item--disabled': _vm.isOptionDisabled(option)
              },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onSettingOptionClick(setting.key, option)}}},[_vm._v("\n              "+_vm._s(option.info)+"\n            ")])}),0)])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"button button--large button--black button--full-width",on:{"click":_vm.close}},[_vm._v("\n        Close\n      ")])],2)]},proxy:true}],null,false,2646511922)}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f/U3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button",class:_vm.isOnModifier,on:{"click":_vm.toggle}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button__inner"},[_c('div',{staticClass:"switch-button__toggle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f084":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-popup"},[_c(_vm.currentFlow,{tag:"component"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f1Rs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f9IU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f9W8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fFIe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fFb1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fHHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.classModifiers},[_c('div',{staticClass:"app-bottom-nav__menu"},_vm._l((_vm.enabledLinks),function(item){return _c('div',{class:_vm.itemClassModifier(item),on:{"click":function($event){return _vm.onLinkClick(item.href)}}},[(_vm.showRegularItem(item))?_c('router-link',{class:_vm.linkClassModifiers(item.name),attrs:{"id":("nav-" + (item.name)),"to":item.href}},[_vm._v("\n          "+_vm._s(item.title.toString())+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.showSocialAvatarOnMobile(item))?_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onAvatarClick($event)}}},[_vm._v("\n         \n        "),_c('account-social-avatar',{attrs:{"theme":"nav-bottom","avatar":_vm.userAvatar,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.levelColorWithRespectToNav,"showEdit":false}},[_c('span',{attrs:{"slot":"label"},on:{"click":function($event){$event.stopPropagation();return _vm.onAvatarClick($event)}},slot:"label"},[_vm._v("Dashboard")])])],1):_vm._e()],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fI94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-combined-footer"},[_c('h4',{staticClass:"add-funds-combined-footer__title"},[_vm._v("\n    Looking for Additional Deposit Methods?\n  ")]),_vm._v(" "),_c('span',{staticClass:"add-funds-combined-footer__link",on:{"click":function($event){$event.preventDefault();return _vm.onGoToWallet($event)}}},[_vm._v("\n    Open Your Wallet\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fVgO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"purchase-offer-sushi__order-book"},[_c('order-book-sushi',{key:_vm.orderBookKey,attrs:{"contract":_vm.contract,"market":_vm.market,"operationType":_vm.tradeOptions.operationType,"operationValue":_vm.tradeOptions.operationValue,"defaultMinimumRows":5,"compactCards":true,"showTitle":true},on:{"updatePriceAndQuantity":_vm.onUpdatePriceAndQuantity}})],1),_vm._v(" "),(_vm.showContractCharts)?_c('div',{staticClass:"purchase-offer-sushi__charts"},[_c('market-charts',{attrs:{"market":_vm.market,"chartOptions":_vm.chartOptions,"cache":true}})],1):_vm._e(),_vm._v(" "),(_vm.showRelatedContracts)?_c('div',{staticClass:"purchase-offer-sushi__related-contracts"},[_c('div',{staticClass:"purchase-offer-sushi__related-contracts-title"},[_vm._v("\n      Related Contracts\n    ")]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-sushi__related-contracts-content"},[_c('related-contracts-sushi',{attrs:{"contractId":_vm.contract.contractId,"max":2}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fZS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,style:(_vm.styleModifiers),on:{"click":_vm.onTooltipClick}},[_c('div',{class:_vm.titleClassModifiers,style:(_vm.titleStyleModifiers)},[_vm._v("\n    "+_vm._s(_vm.stateName)+" "),(!_vm.isSenate)?[_vm._v("("+_vm._s(_vm.marketData.stateVotes)),(_vm.showNote)?_c('span',[_vm._v(" STATEWIDE")]):_vm._e(),_vm._v(")")]:(_vm.isSenate && _vm.stateCode === 'GA')?[_vm._v("(REGULAR)")]:(_vm.isSenate && _vm.stateCode === 'GA2')?[_vm._v("(SPECIAL)")]:_vm._e()],2),_vm._v(" "),(_vm.winnerMode)?[_c('div',{staticClass:"market-state-tooltip__winner"},[_c('div',{staticClass:"market-state-tooltip__winner-title"},[_vm._v("\n        "+_vm._s(_vm.targetContract.contractName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__winner-image",style:(_vm.imageStyleModifiers(_vm.targetContract))}),_vm._v(" "),(_vm.showNote)?_c('div',{staticClass:"market-state-tooltip__winner-name",style:(_vm.winnerBgColorStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__winner-price"},[_c('span',{staticClass:"market-state-tooltip__winner-current-price"},[(_vm.targetContractInstance.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.targetContractInstance.lastTradePriceAsCents}})]:[_vm._v("\n            -\n          ")]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.targetContractInstance.changePriceAsCents,"lastClosePrice":_vm.targetContractInstance.lastClosePrice,"theme":"chart"}})],1)])]:_vm._l((_vm.contracts),function(contract,index){return _c('div',{key:contract.contractId,class:_vm.contractClassModifiers(contract, index)},[_c('div',{staticClass:"market-state-tooltip__contract-image",style:(_vm.imageStyleModifiers(contract))}),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__contract-info"},[_c('div',{staticClass:"market-state-tooltip__contract-name"},[_vm._v("\n          "+_vm._s(_vm.getNameDisplay(contract))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__contract-price"},[_c('span',{staticClass:"market-state-tooltip__contract-current-price"},[(contract.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":contract.lastTradePriceAsCents}})]:[_vm._v("\n              -\n            ")]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":contract.changePriceAsCents,"lastClosePrice":contract.lastClosePrice,"theme":"chart"}})],1)])])}),_vm._v(" "),(_vm.showNote)?_c('div',{staticClass:"market-state-tooltip__note"},[_vm._v("\n    See separate markets for individual "),_c('br'),_vm._v("congressional districts in "+_vm._s(_vm.capitalizeFirstLetter(_vm.stateName.toLowerCase()))+".\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fftE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.showMarketName)?_c('router-link',{staticClass:"contract-tile__market",attrs:{"to":{ name: 'market-details', params: { marketId: _vm.data.marketId } }}},[_vm._v(_vm._s(_vm.market))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-tile__wrap"},[(_vm.isMarketSingle)?[_c('span',{staticClass:"contract-tile__name contract-tile__name--long"},[_vm._v(_vm._s(_vm.contractName))])]:[_c('router-link',{staticClass:"contract-tile__name contract-tile__name--long contract-tile__name--clickable",attrs:{"to":_vm.accountHistoryRoute}},[_vm._v(_vm._s(_vm.contractName))])],_vm._v(" "),_c('div',{staticClass:"contract-tile__profit contract-tile__profit--short"},[(_vm.desktop)?[_c('div',{class:_vm.profitClass},[_vm._v("\n          "+_vm._s(_vm.profitDesk)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"contract-tile__fees"},[_vm._v("\n          "+_vm._s(_vm.fee)+"\n        ")])]:[_vm._v(_vm._s(_vm.data.netProfitLossString))]],2),_vm._v(" "),_c('div',{staticClass:"contract-tile__risk"},[_vm._v("\n      "+_vm._s(_vm.data.riskChangeString)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"contract-tile__cash"},[_vm._v("\n      "+_vm._s(_vm.data.tradeValueString)+"\n    ")])],2),_vm._v(" "),_c('div',{staticClass:"contract-tile__bottom"},[_c('div',{staticClass:"contract-tile__per-share"},[_c('sold-bought-at',{attrs:{"tradeType":_vm.data.tradeType,"predictionType":_vm.data.predictionType,"quantity":_vm.data.quantity,"price":_vm.data.pricePerShare}})],1),_vm._v(" "),_c('div',{staticClass:"contract-tile__date"},[_vm._v("\n      "+_vm._s(_vm.date)+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "flEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_id_js__ = __webpack_require__("LyDt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3008b852_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_id_vue__ = __webpack_require__("KaRd");
function injectStyle (ssrContext) {
  __webpack_require__("8RtG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_id_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3008b852_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_id_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fmhl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_ORDER_BOOK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOTTOM_WIDGET_FOOTER_MODES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");






// import constants from '@/constants';

var DEFAULT_ORDER_BOOK = {
  noOrders: 0,
  yesOrders: 0
};

function makeTradeOptions() {
  return {
    contractId: null,
    operationType: 'buy', // buy | sell
    operationValue: 'yes', // yes | no
    pricePerShare: null,
    skipConfirmation: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('skipConfirmation', false),
    quantity: null
  };
}

function getPricePerShare(value) {
  var min = 1;
  var max = 99;
  var price = parseInt(value, 10);

  if (price < min) {
    price = min;
  }
  if (price > max) {
    price = max;
  }
  return price;
}

var KEY_BOTTOM_WIDGET_FOOTER_MODE = 'bottom-widget-footer-mode';
var BOTTOM_WIDGET_FOOTER_MODES = {
  BETSLIP: 'betslip',
  PINNED: 'pinned',
  TOGGlE: 'toggle',
  QUICK_SWITCH: 'quick-switch'
};
var BOTTOM_WIDGET_DEFAULT_MODE = BOTTOM_WIDGET_FOOTER_MODES.BETSLIP;
var BOTTOM_WIDGET_KEYS_TO_STORE_IN_LS = [BOTTOM_WIDGET_FOOTER_MODES.BETSLIP, BOTTOM_WIDGET_FOOTER_MODES.PINNED, BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH];

function getStoredBottomWidgetFooterMode() {
  var storedMode = __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get(KEY_BOTTOM_WIDGET_FOOTER_MODE, null);

  if (BOTTOM_WIDGET_KEYS_TO_STORE_IN_LS.includes(storedMode)) {
    return storedMode;
  }

  return null;
}

var STORED_BOTTOM_WIDGET_FOOTER_MODE = getStoredBottomWidgetFooterMode();
var INITIAL_BOTTOM_WIDGET_FOOTER_MODE = STORED_BOTTOM_WIDGET_FOOTER_MODE || BOTTOM_WIDGET_DEFAULT_MODE;

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  state: {
    orderBook: null,
    hidePurchaseForContractId: null,
    contractShares: [],
    contractOffers: [],
    tradeOptions: makeTradeOptions(),
    masterTradeOptions: {},
    tradeSuccess: false,
    keyboardDoubleSelected: false,
    cancelToggle: false,
    tradeOperationToggle: null,
    isInConfirmationMode: false,
    confirmationDoneData: null,
    confirmationData: null,
    bottomBetslipExtended: false,
    bottomWidgetFooterMode: INITIAL_BOTTOM_WIDGET_FOOTER_MODE,
    bottomWidgetFooterModeContractsSection: INITIAL_BOTTOM_WIDGET_FOOTER_MODE,
    previousBottomWidgetFooterMode: INITIAL_BOTTOM_WIDGET_FOOTER_MODE,
    hasStoredBottomWidgetFooterModePreference: STORED_BOTTOM_WIDGET_FOOTER_MODE !== null
  },
  mutations: {
    toggleHidePurchaseForContractId: function toggleHidePurchaseForContractId(state, contractId) {
      if (state.hidePurchaseForContractId === null) {
        state.hidePurchaseForContractId = contractId;
      } else {
        state.hidePurchaseForContractId = null;
      }
    },
    setOrderBook: function setOrderBook(state, payload) {
      state.orderBook = payload;
    },
    clearOrderBook: function clearOrderBook(state) {
      state.orderBook = null;
    },
    setContractShares: function setContractShares(state, payload) {
      state.contractShares = payload;
    },
    setContractOffers: function setContractOffers(state, payload) {
      state.contractOffers = payload;
    },
    setTradeOptions: function setTradeOptions(state, payload) {
      if (state.tradeOptions !== null && payload !== null && state.tradeOptions.contractId === payload.contractId && state.tradeOptions.operationType === payload.operationType && state.tradeOptions.operationValue === payload.operationValue) {
        state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, payload);
      } else {
        var defaults = makeTradeOptions();
        var pricePerShare = defaults.pricePerShare;
        var skipConfirmation = defaults.skipConfirmation;
        if (payload && state.tradeOptions.contractId === payload.contractId) {
          pricePerShare = state.tradeOptions.pricePerShare;
          skipConfirmation = state.tradeOptions.skipConfirmation || false;
        }
        state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaults, payload, {
          pricePerShare: pricePerShare,
          skipConfirmation: skipConfirmation
        });
      }

      if (state.tradeOptions && state.tradeOptions.contractId) {
        state.hidePurchaseForContractId = null;
      }
    },
    setTradeSuccess: function setTradeSuccess(state, flag) {
      state.tradeSuccess = flag;
    },
    setTradeSkipConfirmation: function setTradeSkipConfirmation(state, skipConfirmation) {
      var value = !!skipConfirmation;
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set('skipConfirmation', value, expiresAt);
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { skipConfirmation: value });
    },
    updateKeyboardDoubleSelected: function updateKeyboardDoubleSelected(state, selected) {
      state.keyboardDoubleSelected = selected;
    },
    setCancelToggle: function setCancelToggle(state, flag) {
      state.cancelToggle = flag;
    },
    setIsInConfirmationMode: function setIsInConfirmationMode(state, flag) {
      state.isInConfirmationMode = flag;
    },
    setConfirmationData: function setConfirmationData(state, data) {
      state.confirmationData = data;
    },
    setConfirmationDoneData: function setConfirmationDoneData(state, data) {
      state.confirmationDoneData = data;
    },
    toggleTradeOperation: function toggleTradeOperation(state, side) {
      state.tradeOperationToggle = side;
    },
    setBottomWidgetFooterMode: function setBottomWidgetFooterMode(state, value) {
      state.previousBottomWidgetFooterMode = state.bottomWidgetFooterMode;
      state.bottomWidgetFooterMode = value;
    },
    toggleBottomBetslipMode: function toggleBottomBetslipMode(state) {
      state.bottomBetslipExtended = !state.bottomBetslipExtended;
    },
    setBottomWidgetFooterModeContractsSection: function setBottomWidgetFooterModeContractsSection(state, value) {
      if (BOTTOM_WIDGET_KEYS_TO_STORE_IN_LS.includes(value)) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set(KEY_BOTTOM_WIDGET_FOOTER_MODE, value);
        state.hasStoredBottomWidgetFooterModePreference = true;
      }
      state.bottomWidgetFooterModeContractsSection = value;
    },
    setTradeQuantity: function setTradeQuantity(state, quantity) {
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { quantity: parseInt(quantity, 10) || null });
    },
    setTradePrice: function setTradePrice(state, pricePerShare) {
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { pricePerShare: pricePerShare });
    },
    setMasterTradeOptions: function setMasterTradeOptions(state, data) {
      state.masterTradeOptions = data;
    },
    setBottomBetSlipExtendedMode: function setBottomBetSlipExtendedMode(state, extended) {
      state.bottomBetslipExtended = extended;
    }
  },
  actions: {
    confirmTrade: function confirmTrade(_ref, payload) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.postConfirmTrade(payload);
    },
    submitTrade: function submitTrade(_ref2, payload) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.postSubmitTrade(payload);
    },
    getOrderBook: function getOrderBook(_ref3, contractId) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.getOrderBook(contractId).then(function (response) {
        commit('setOrderBook', response.data);
        return response.data;
      });
    },
    updateOrderBookPeriodically: function updateOrderBookPeriodically(_ref4, contractId) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_3__services_notifications_firebase__["c" /* addOrderBookListener */](contractId, function (data) {
        commit('setOrderBook', data);
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(DEFAULT_ORDER_BOOK));
    },
    clearOrderBookUpdates: function clearOrderBookUpdates(_ref5, contractId) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_3__services_notifications_firebase__["d" /* clearOrderBookListeners */](contractId);
    },
    clearOrderBook: function clearOrderBook(_ref6) {
      var commit = _ref6.commit;

      commit('clearOrderBook');
    },
    getContractShares: function getContractShares(_ref7, contractId) {
      var commit = _ref7.commit;

      if (contractId === null) {
        commit('setContractShares', []);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].profile.getContractShares(contractId).then(function (response) {
        commit('setContractShares', response.data.shares);
        return response.data.shares;
      });
    },
    getContractOffers: function getContractOffers(_ref8, contractId) {
      var commit = _ref8.commit;

      if (contractId === null) {
        commit('setContractOffers', []);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].profile.getContractOffers(contractId).then(function (response) {
        commit('setContractOffers', response.data.offers);
        return response.data.offers;
      });
    },
    cancelAllOffers: function cancelAllOffers(_ref9, payload) {
      var commit = _ref9.commit;

      var contractId = payload.contractId;
      delete payload.contractId;
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.postCancelAllOffers(contractId, payload).then(function (response) {
        commit('setCancelToggle', true);
        return response.data;
      });
    },
    cancelOffer: function cancelOffer(_ref10, offerId) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.postCancelOffer(offerId).then(function (response) {
        commit('setCancelToggle', true);
        return response.data;
      });
    },
    setCancelToggle: function setCancelToggle(_ref11, flag) {
      var commit = _ref11.commit;

      commit('setCancelToggle', flag);
    },
    setIsInConfirmationMode: function setIsInConfirmationMode(_ref12, flag) {
      var commit = _ref12.commit;

      commit('setIsInConfirmationMode', flag);
    },
    setConfirmationData: function setConfirmationData(_ref13, data) {
      var commit = _ref13.commit;

      commit('setConfirmationData', data);
    },
    setConfirmationDoneData: function setConfirmationDoneData(_ref14, data) {
      var commit = _ref14.commit;

      commit('setConfirmationDoneData', data);
    },
    setTradeOptions: function setTradeOptions(_ref15, payload) {
      var commit = _ref15.commit;

      if (payload === null) {
        commit('setConfirmationData', null);
        commit('setConfirmationDoneData', null);
      }
      commit('setTradeOptions', payload);
    },
    setTradeQuantity: function setTradeQuantity(_ref16, quantity) {
      var commit = _ref16.commit,
          state = _ref16.state;

      commit('setTradeQuantity', quantity);
      commit('setMasterTradeOptions', {
        quantity: quantity,
        pricePerShare: state.tradeOptions.pricePerShare
      });
    },
    setTradePrice: function setTradePrice(_ref17, pricePerShare) {
      var commit = _ref17.commit,
          state = _ref17.state;

      var standardValue = getPricePerShare(pricePerShare);
      commit('setMasterTradeOptions', {
        pricePerShare: standardValue,
        quantity: state.tradeOptions.quantity
      });
      commit('setTradePrice', standardValue);
    },
    setMasterTradeOptions: function setMasterTradeOptions(_ref18, _ref19) {
      var commit = _ref18.commit;
      var quantity = _ref19.quantity,
          pricePerShare = _ref19.pricePerShare;

      commit('setMasterTradeOptions', { quantity: quantity, pricePerShare: pricePerShare });
    },
    setTradeSuccess: function setTradeSuccess(_ref20, flag) {
      var commit = _ref20.commit;

      commit('setTradeSuccess', flag);
    },
    setTradeSkipConfirmation: function setTradeSkipConfirmation(_ref21, skipConfirmation) {
      var commit = _ref21.commit;

      commit('setTradeSkipConfirmation', skipConfirmation);
    },
    toggleTradeOperation: function toggleTradeOperation(_ref22, side) {
      var commit = _ref22.commit;

      commit('toggleTradeOperation', side);
    },
    updateKeyboardDoubleSelected: function updateKeyboardDoubleSelected(_ref23, selected) {
      var commit = _ref23.commit;

      commit('updateKeyboardDoubleSelected', selected);
    },
    getOrderBookTradeInfo: function getOrderBookTradeInfo(_ref24, _ref25) {
      var commit = _ref24.commit;
      var contractId = _ref25.contractId,
          tradeType = _ref25.tradeType,
          price = _ref25.price;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.getOrderBookTradeInfo(contractId, tradeType, price).then(function (response) {
        return response.data;
      });
    },
    setBottomWidgetFooterMode: function setBottomWidgetFooterMode(_ref26, value) {
      var commit = _ref26.commit;

      commit('setBottomWidgetFooterMode', value);
    },
    toggleHidePurchaseForContractId: function toggleHidePurchaseForContractId(_ref27, contractId) {
      var commit = _ref27.commit;

      commit('toggleHidePurchaseForContractId', contractId);
    },
    toggleBottomBetslipMode: function toggleBottomBetslipMode(_ref28) {
      var commit = _ref28.commit;

      commit('toggleBottomBetslipMode');
    },
    setBottomBetSlipExtendedMode: function setBottomBetSlipExtendedMode(_ref29, value) {
      var commit = _ref29.commit;

      commit('setBottomBetSlipExtendedMode', value);
    },
    setBottomWidgetFooterModeContractsSection: function setBottomWidgetFooterModeContractsSection(_ref30, value) {
      var commit = _ref30.commit;

      commit('setBottomWidgetFooterModeContractsSection', value);
    }
  }
});

/***/ }),

/***/ "fpwF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "fr0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-quantity-picker-mobile-sushi"},[_c('div',{staticClass:"purchase-quantity-picker-mobile-sushi__box"},[_c('div',{staticClass:"purchase-quantity-picker-mobile-sushi__label",on:{"click":_vm.onFocus}},[(!_vm.$slots.label)?[_vm._v("\n          Quantity\n        ")]:_vm._t("label")],2),_vm._v(" "),_c('div',[_c('div',{staticClass:"purchase-quantity-picker-mobile-sushi__input-wrap",on:{"click":_vm.onFocus}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"input",staticClass:"purchase-quantity-picker-mobile-sushi__input",attrs:{"tabindex":_vm.tabindex,"inputmode":"numeric","pattern":"[0-9]*","type":"text","maxlength":"4","placeholder":""},domProps:{"value":(_vm.val)},on:{"click":_vm.onFocus,"focus":_vm.onFocus,"blur":_vm.onBlur,"input":function($event){if($event.target.composing){ return; }_vm.val=$event.target.value}}})])])]),_vm._v(" "),(_vm.selected)?_c('div',{staticClass:"purchase-quantity-picker-mobile-sushi__options"},_vm._l((_vm.options),function(option){return _c('div',{key:option,staticClass:"purchase-quantity-picker-mobile-sushi__option",on:{"pointerdown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onSelectOption(option)},"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onSelectOption(option)}}},[_vm._v("\n        "+_vm._s(option > 0 ? '+' + option : option)+"\n      ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fvWR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-login"},[_c('div',{staticClass:"account-login__socials"},[_c('form-socials',{attrs:{"title":"Login with"}})],1),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.email,"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"autocomplete":"off","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"hideIconOnValue":false,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.password,"name":"password","type":_vm.fieldTypePassword,"required":true,"autocomplete":"off","placeholder":"Password"},on:{"input":_vm.$v.fields.password.$touch},model:{value:(_vm.fields.password),callback:function ($$v) {_vm.$set(_vm.fields, "password", $$v)},expression:"fields.password"}},[(!_vm.isIE)?_c('show-password-icon',{attrs:{"slot":"icon"},on:{"showPassword":_vm.showPassword},slot:"icon"}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"column small-12 account-login__forgotten-column"},[_c('div',{staticClass:"column small-6"},[_c('form-checkbox',{attrs:{"name":"rememberMe","label":"Keep Me Logged In"},model:{value:(_vm.fields.rememberMe),callback:function ($$v) {_vm.$set(_vm.fields, "rememberMe", $$v)},expression:"fields.rememberMe"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"account-login__forgotten-password"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onForgotten($event)}}},[_vm._v("Forgot Password?")])])])])]),_vm._v(" "),_c('form-submit',{attrs:{"disabled":_vm.loginButtonDisabled,"loading":_vm.isFormDisabled,"label":"Login"}}),_vm._v(" "),_vm._m(1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v("\n          Login using your email\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recaptcha-terms"},[_vm._v("\n          Protected by reCAPTCHA ·\n          "),_c('a',{attrs:{"href":"https://policies.google.com/privacy","target":"_blank"}},[_vm._v("Privacy")]),_vm._v("\n          ·\n          "),_c('a',{attrs:{"href":"https://policies.google.com/terms","target":"_blank"}},[_vm._v("Terms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fzCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketLoader_vue__ = __webpack_require__("HPJt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee7f171_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketLoader_vue__ = __webpack_require__("0syx");
function injectStyle (ssrContext) {
  __webpack_require__("pM6l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee7f171_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g1ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_details_update_account_address_update_vue__ = __webpack_require__("jVeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_account_details_update_account_details_update_vue__ = __webpack_require__("a/AT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_account_update_password_account_update_password_vue__ = __webpack_require__("mx5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_set_password_account_set_password_vue__ = __webpack_require__("s06T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_modal_modal_vue__ = __webpack_require__("CAzF");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    what: String
  },
  components: {
    accountAddressUpdate: __WEBPACK_IMPORTED_MODULE_2__components_account_account_details_update_account_address_update_vue__["a" /* default */],
    accountDetailsUpdate: __WEBPACK_IMPORTED_MODULE_3__components_account_account_details_update_account_details_update_vue__["a" /* default */],
    accountUpdatePassword: __WEBPACK_IMPORTED_MODULE_4__components_account_account_update_password_account_update_password_vue__["a" /* default */],
    accountSetPassword: __WEBPACK_IMPORTED_MODULE_5__components_account_account_set_password_account_set_password_vue__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_6__components_generics_modal_modal_vue__["a" /* default */]
  },
  methods: {
    closeModal: function closeModal() {
      this.$router.go(-1);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    noPadding: function noPadding() {
      return this.isLayoutMobile;
    },
    header: function header() {
      switch (this.what) {
        case 'account-detail-password-set':
          return 'Set Password';
        case 'account-detail-password':
          return 'Change Password';
        case 'account-detail-update':
          return 'Change Username';
        default:
          return 'Change Address';
      }
    }
  })
});

/***/ }),

/***/ "g2Bo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flows_what_is_new_flow_version_1_what_is_new_flow_version_1_vue__ = __webpack_require__("Y4M0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__("AyQu");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    whatIsNewFlowVersion1: __WEBPACK_IMPORTED_MODULE_2__flows_what_is_new_flow_version_1_what_is_new_flow_version_1_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    currentFlow: function currentFlow() {
      if (__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* VERSION_TO_MIGRATE_TO */] === 1) {
        return 'whatIsNewFlowVersion1';
      }
      return null;
    }
  })
});

/***/ }),

/***/ "gCuu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    amount: {
      type: Number,
      required: false
    },
    fee: {
      type: Number,
      required: false
    },
    total: {
      type: Number,
      required: false
    },
    isBankTransfer: {
      type: Boolean,
      default: false
    },
    isDeposit: {
      type: Boolean,
      default: false
    },
    flatFeeAmount: {
      type: Number,
      required: false
    },
    percentageFeeAmount: {
      type: Number,
      required: false
    },
    plaidAccount: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    flatFeeAmountRounded: function flatFeeAmountRounded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["h" /* roundToTwo */])(this.flatFeeAmount);
    },
    percentageFeeAmountRounded: function percentageFeeAmountRounded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["h" /* roundToTwo */])(this.percentageFeeAmount);
    },
    feeRounded: function feeRounded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["h" /* roundToTwo */])(this.fee || 0);
    },
    totalRounded: function totalRounded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["h" /* roundToTwo */])(this.total);
    }
  }
});

/***/ }),

/***/ "gFdO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_refine_link_js__ = __webpack_require__("eInO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab57839c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refine_link_vue__ = __webpack_require__("aIVs");
function injectStyle (ssrContext) {
  __webpack_require__("NMmg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_refine_link_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab57839c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refine_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gJ7L":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "gL3B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"product-history-sushi-active__header-wrap"},[_c('div',{staticClass:"product-history-sushi__subtitle"},[_vm._v("\n      Active\n    ")]),_vm._v(" "),(_vm.relatedProducts.active.length > 0 && _vm.type !== 'widget')?_c('div',{staticClass:"product-history-sushi-active__header"},[_c('div',{staticClass:"product-history-sushi-active__header-1"},[_vm._v("Top Contracts")]),_vm._v(" "),_c('div',{staticClass:"product-history-sushi-active__header-2"},[_vm._v("Volume")])]):_vm._e()]),_vm._v(" "),(_vm.ready && _vm.relatedProducts.active.length === 0)?_c('div',{staticClass:"product-history-sushi__note"},[_vm._v("\n    No active markets to display.\n  ")]):_vm._e(),_vm._v(" "),(_vm.type === 'widget' || _vm.isLayoutMobile)?_vm._l((_vm.relatedProducts.active),function(item){return _c('div',{key:item.id,staticClass:"market-contract-info-v2__widget-item"},[_c('market-contract-info-v2',{attrs:{"market":item,"addFakeContracts":false,"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY}})],1)}):_vm._l((_vm.relatedProducts.active),function(item,index){return _c('div',{key:item.id,staticClass:"market-contract-info-v2__widget-item",class:{'market-contract-info-v2__widget-item--border-bottom': index !== _vm.relatedProducts.closed.length - 1}},[_c('market-contract-info-v2',{staticClass:"market-contract-info-v2--center market-contract-info-v2--center-detailed",attrs:{"image":item.marketImageUrl,"link":_vm.itemLink(item),"addFakeContracts":false,"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row-h100"},[_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wproducthistoryactive"},[_c('div',{staticClass:"market-contract-info-v2__market-name"},[_vm._v("\n                  "+_vm._s(item.marketName)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wproducthistoryactivemain"},[_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--multi"},_vm._l((_vm.getContracts(item)),function(contract){return _c('div',{key:contract.contractId,staticClass:"market-contract-info-v2__contract-row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__contract-value"},[_vm._v("\n                        "+_vm._s(contract.contractName)+"\n                    ")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"market-contract-info-v2__action market-contract-info-v2--mono"},[(contract.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":contract.lastTradePriceAsCents}})]:[_vm._v("\n                          NEW\n                        ")]],2),_vm._v(" "),(contract.changePriceAsCents)?_c('market-change-price',{attrs:{"price":contract.changePriceAsCents,"lastClosePrice":contract.lastClosePrice}}):_vm._e()],1)])}),0),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--right"},[_c('div',{staticClass:"market-contract-info-v2__contract-value market-contract-info-v2--mono"},[_vm._v("\n                    "+_vm._s(item.totalSharesTraded.toLocaleString())+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__action"},[_vm._v("\n                    Shares Traded\n                  ")])])])])]},proxy:true}],null,true)})],1)}),_vm._v(" "),_c('div',{staticClass:"product-history-sushi-settled__header-wrap"},[_c('div',{staticClass:"product-history-sushi__subtitle"},[_vm._v("\n      Settled\n    ")]),_vm._v(" "),(_vm.relatedProducts.closed.length > 0 && _vm.type !== 'widget')?_c('div',{staticClass:"product-history-sushi-settled__header"},[_c('div',{staticClass:"product-history-sushi-settled__header-1"},[_vm._v("Outcome")]),_vm._v(" "),_c('div',{staticClass:"product-history-sushi-settled__header-2"},[_vm._v("Volume")])]):_vm._e()]),_vm._v(" "),(_vm.ready && _vm.relatedProducts.closed.length === 0)?_c('div',{staticClass:"product-history-sushi__note"},[_vm._v("\n    No settled markets to display.\n  ")]):_vm._e(),_vm._v(" "),(_vm.type === 'widget' || _vm.isLayoutMobile)?_vm._l((_vm.relatedProducts.closed),function(item){return _c('div',{key:item.id,staticClass:"market-contract-info-v2__widget-item"},[_c('market-contract-info-v2',{attrs:{"addFakeContracts":false,"image":item.marketImageUrl,"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n            "+_vm._s(item.marketName)+"\n          ")]},proxy:true},{key:"content",fn:function(){return _vm._l((_vm.getContracts(item)),function(contract){return _c('div',{key:contract.contractId,staticClass:"market-contract-info-v2__row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__value-light"},[_vm._v(_vm._s(contract.contractName))]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[(item.contractWinner && item.contractWinner.contractName === contract.contractName)?[_c('market-winner-v2')]:[(contract.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":contract.lastTradePriceAsCents}})]:[_vm._v("\n                    NEW\n                  ")],_vm._v(" "),(contract.changePriceAsCents)?_c('market-change-price',{attrs:{"price":contract.changePriceAsCents,"lastClosePrice":contract.lastClosePrice}}):_vm._e()]],2)])})},proxy:true}],null,true)})],1)}):_vm._l((_vm.relatedProducts.closed),function(item,index){return _c('div',{key:item.id,staticClass:"market-contract-info-v2__widget-item",class:{'market-contract-info-v2__widget-item--border-bottom': index !== _vm.relatedProducts.closed.length - 1}},[_c('market-contract-info-v2',{staticClass:"market-contract-info-v2--center",attrs:{"image":item.marketImageUrl,"link":_vm.itemLink(item),"addFakeContracts":false,"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row-h100"},[_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wproducthistorysettled"},[_c('div',{staticClass:"market-contract-info-v2__market-name"},[_vm._v("\n                  "+_vm._s(item.marketName)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--wproducthistorysettledmain"},[_c('div',{staticClass:"market-contract-info-v2__col"},_vm._l((_vm.getContracts(item)),function(contract){return _c('div',{key:contract.contractId,staticClass:"market-contract-info-v2__contract-row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__contract-value"},[_vm._v("\n                        "+_vm._s(contract.contractName)+"\n                    ")]),_vm._v(" "),_c('div',[(item.contractWinner && item.contractWinner.contractName === contract.contractName)?[_c('market-winner-v2')]:[_c('span',{staticClass:"market-contract-info-v2__action market-contract-info-v2--mono"},[(contract.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":contract.lastTradePriceAsCents}})]:[_vm._v("\n                            NEW\n                          ")]],2),_vm._v(" "),(contract.changePriceAsCents)?_c('market-change-price',{attrs:{"price":contract.changePriceAsCents,"lastClosePrice":contract.lastClosePrice}}):_vm._e()]],2)])}),0),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__col market-contract-info-v2__col--right"},[_c('div',{staticClass:"market-contract-info-v2__contract-value"},[_vm._v("\n                    "+_vm._s(item.totalSharesTraded.toLocaleString())+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__action"},[_vm._v("\n                    Shares Traded\n                  ")])])])])]},proxy:true}],null,true)})],1)})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gQ0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_landing_pages_index1_index1_vue__ = __webpack_require__("b2pe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landing_pages_index2_index2_vue__ = __webpack_require__("gSES");



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/index1',
  name: 'index1',
  component: __WEBPACK_IMPORTED_MODULE_0__components_landing_pages_index1_index1_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/index2',
  name: 'index2',
  component: __WEBPACK_IMPORTED_MODULE_1__components_landing_pages_index2_index2_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}]);

/***/ }),

/***/ "gSES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_index2_js__ = __webpack_require__("9eDo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ade43f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index2_vue__ = __webpack_require__("Yszk");
function injectStyle (ssrContext) {
  __webpack_require__("L0UG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_index2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ade43f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gSSJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gTKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onClickNumber($event)}}},[_c('span',{staticClass:"market-shares-ownership__number"},[_vm._v(_vm._s(_vm.numberDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-shares-ownership__mode"},[_vm._v(_vm._s(_vm.mode))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gTQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_potential_payouts_js__ = __webpack_require__("cFI2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a70431e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_potential_payouts_vue__ = __webpack_require__("ApH/");
function injectStyle (ssrContext) {
  __webpack_require__("KyYK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_potential_payouts_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a70431e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_potential_payouts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gVgM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_register_js__ = __webpack_require__("klsN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018aecc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_register_vue__ = __webpack_require__("n8oX");
function injectStyle (ssrContext) {
  __webpack_require__("/yMG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_register_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018aecc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gXIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_market_detail_sushi_page_market_detail_sushi__ = __webpack_require__("KA7l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    navigatedFromContractsSection: {
      type: Boolean,
      default: false
    },
    selectedSection: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      BOTTOM_WIDGET_FOOTER_MODES: __WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */],
      NAVIGATION_TABS: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_market_detail_sushi_page_market_detail_sushi__["a" /* NAVIGATION_TABS */],
      options: [{ mode: __WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH, title: 'QuickSwitch' }, { mode: __WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].PINNED, title: 'Shortcuts' }, { mode: __WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP, title: 'Order Slip' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['bottomWidgetFooterMode', 'previousBottomWidgetFooterMode', 'bottomWidgetFooterModeContractsSection']), {
    showMarketShortcuts: function showMarketShortcuts() {
      return this.$route.name !== 'portfolio';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    isPersistentFooterMode: function isPersistentFooterMode(footerMode) {
      return [__WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP, __WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].PINNED, __WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH].includes(footerMode);
    },
    showContractsOnlyWarning: function showContractsOnlyWarning(name) {
      var contractsOnlyModes = [__WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].PINNED, __WEBPACK_IMPORTED_MODULE_3__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP];
      return this.navigatedFromContractsSection && contractsOnlyModes.includes(name);
    },
    switchTo: function switchTo(footerMode) {
      if (this.showContractsOnlyWarning(footerMode)) return;
      this.setBottomWidgetFooterMode(footerMode);
      if (!this.navigatedFromContractsSection && this.isPersistentFooterMode(footerMode)) {
        this.setBottomWidgetFooterModeContractsSection(footerMode);
      }
    },
    optionClassModifiers: function optionClassModifiers(option) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'bottom-market-links-overlay__option': true,
        'bottom-market-links-overlay__option--selected': option.mode === this.previousBottomWidgetFooterMode
      }, 'bottom-market-links-overlay__option--' + option.mode, option.mode);
    },
    closeOverlay: function closeOverlay() {
      this.switchTo(this.previousBottomWidgetFooterMode);
    },
    goToDeposit: function goToDeposit() {
      this.closeOverlay();
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
    },
    goToLogin: function goToLogin() {
      this.closeOverlay();
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    },
    goToSignUp: function goToSignUp() {
      this.closeOverlay();
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
    },
    goToDashboard: function goToDashboard() {
      this.closeOverlay();
      this.$router.push({ name: 'portfolio' });
    },
    goToMarketTab: function goToMarketTab(name) {
      var el = document.querySelector('.tabs__link-name-' + name);
      if (el !== null) {
        this.closeOverlay();
        el.click();
      }
    }
  }),
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["l" /* lockModal */])();
  },
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["m" /* unLockModal */])();
  }
});

/***/ }),

/***/ "gXJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.titleClassModifiers,on:{"click":_vm.toggleItem}},[_c('div',{class:_vm.toggleClassModifiers}),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable-sushi__title-image",style:(_vm.marketImageStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable-sushi__title-content"},[_c('div',{staticClass:"market-list-item-expandable-sushi__header"},[_c('div',{staticClass:"market-list-item-expandable-sushi__header-text"},[_vm._v("\n          "+_vm._s(_vm.market.marketShortName)+"\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"market-list-item-expandable-sushi__header-link",attrs:{"to":{ name: 'market-details', params: { marketId: _vm.market.marketId, marketUrl: _vm.market.marketUrl } }},nativeOn:{"click":function($event){return $event.stopPropagation()}}},[_vm._v("View Market")])],1),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable-sushi__payout"},[(_vm.isPayoutAvailable)?_c('market-payout-sushi',{attrs:{"theme":"dashboard","showMarketLink":false,"market":_vm.market}}):_c('div',{staticClass:"market-list-item-expandable-sushi__payout-note"},[_vm._v("\n          No Ownership - "+_vm._s(_vm.openOffers)+" Open Order"),(_vm.openOffers !== 1)?[_vm._v("s")]:_vm._e()],2)],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"market-list-item-expandable-sushi"}},[(_vm.expanded)?_c('div',{staticClass:"market-list-item-expandable-sushi__content"},[_c('div',{staticClass:"market-list-item-expandable-sushi__line"}),_vm._v(" "),_c('market-contracts-list-header-sushi',{attrs:{"market":_vm.market,"dashboardMode":true}}),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable-sushi__contracts"},[_vm._l((_vm.contractsToShow),function(item){return [_c('div',{staticClass:"market-list-item-expandable-sushi__contract-wrapper",class:{'market-list-item-expandable-sushi__contract-wrapper--padding-top': !_vm.isPurchaseInlineMode(item.contractId)}},[(_vm.isLayoutDesktop)?_c('market-contract-horizontal-sushi',{key:_vm.contractKey('market-contract', item),attrs:{"market":_vm.market,"contract":item,"dashboardMode":true,"data-contract-id":item.contractId,"showSharesOwnedIconOnImage":true}}):_c('market-contract-horizontal-sushi-mobile',{key:_vm.contractKey('market-contract', item),attrs:{"market":_vm.market,"contract":item,"dashboardMode":true,"data-contract-id":item.contractId,"showOwnershipAndOrdersBar":true}})],1),_vm._v(" "),(_vm.isPurchaseActive(item.contractId))?_c('div',{staticClass:"market-list-item-expandable-sushi__purchase-wrapper"},[(_vm.isPurchaseInlineMode(item.contractId))?_c('purchase-inline-sushi',{key:_vm.contractKey('purchase-inline', item),attrs:{"market":_vm.market,"showCloseButton":false,"closeJourneyAfterSuccess":false,"showRelatedContracts":_vm.isLayoutMobile,"layoutKind":_vm.isLayoutMobile ? 'mobile' : 'desktop'}}):_vm._e(),_vm._v(" "),(_vm.showMobileWidgetPurchase(item.contractId))?_c('purchase-inline-sushi',{key:_vm.tradeOptions.contractId,attrs:{"market":_vm.market,"layoutKind":"mobile-widget","closeJourneyAfterSuccess":false,"showRelatedContracts":false,"showOwnershipAndOrdersBar":true}}):_vm._e()],1):_vm._e()]}),_vm._v(" "),(_vm.shouldShowToggleMoreButton)?_c('div',{class:_vm.toggleMoreModifiers,on:{"click":_vm.onToggleMore}},[(!_vm.showAllContracts)?[_vm._v("\n            "+_vm._s(_vm.leftContractsToShow.length)+" More Contract"),(_vm.leftContractsToShow.length > 1)?[_vm._v("s")]:_vm._e()]:[_vm._v("\n            Show Fewer\n          ")]],2):_vm._e()],2)],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gYkw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_simple_js__ = __webpack_require__("M0+2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc600f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_simple_vue__ = __webpack_require__("cU06");
function injectStyle (ssrContext) {
  __webpack_require__("74Z8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_simple_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc600f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_simple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gZZf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gatU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMostPopular: function getMostPopular() {
    var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '12h';
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

    // from disqus api
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/MostPopular/' + interval + '?count=' + count);
  },
  getAnalysis: function getAnalysis() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    // from tumblr api
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Analysis?limit=' + limit + '&offset=' + offset);
  },
  getFeeds: function getFeeds() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Feeds');
  },
  getMarketFeeds: function getMarketFeeds(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Feeds/Markets/' + marketId);
  },
  getNews: function getNews() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/News?limit=' + limit + '&offset=' + offset);
  }
});

/***/ }),

/***/ "gdGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_badge_js__ = __webpack_require__("3yfD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9392fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_badge_vue__ = __webpack_require__("PBe4");
function injectStyle (ssrContext) {
  __webpack_require__("Dz7g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_badge_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9392fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_badge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gj0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-table"},[_c('div',{staticClass:"charts-table__wrapper",class:{ 'charts-table__wrapper--scrollable': _vm.showNavigationArrows }},[(_vm.showNavigationArrows)?_c('button',{staticClass:"charts-table__arrow charts-table__arrow--left",attrs:{"disabled":!_vm.canScrollLeft},on:{"click":_vm.scrollLeft}}):_vm._e(),_vm._v(" "),_c('swiper',{ref:"swiper",staticClass:"charts-table__row",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.contracts),function(item){return _c('swiper-slide',{key:item.contractId,staticClass:"charts-table__row-item"},[_c('form-checkbox',{attrs:{"color":_vm.checkboxColor(item),"name":_vm.contractName(item)},on:{"change":function($event){return _vm.onChange(item, $event)}},model:{value:(item.checked),callback:function ($$v) {_vm.$set(item, "checked", $$v)},expression:"item.checked"}},[_c('div',{staticClass:"charts-table__item"},[(_vm.showImage)?_c('div',{staticClass:"charts-table__item-image",style:(_vm.imageStyleModifiers(item))}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"charts-table__item-label"},[_vm._v("\n              "+_vm._s(item.contractName)+"\n            ")])])])],1)}),1),_vm._v(" "),(_vm.showNavigationArrows)?_c('button',{staticClass:"charts-table__arrow charts-table__arrow--right",attrs:{"disabled":!_vm.canScrollRight},on:{"click":_vm.scrollRight}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gjXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_layout_js__ = __webpack_require__("EyLR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0781ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_layout_vue__ = __webpack_require__("xFU0");
function injectStyle (ssrContext) {
  __webpack_require__("KXaR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_layout_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0781ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gnYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  desktop: { zIndex: 3, stickyTop: 90 },
  mobile: { zIndex: 3, stickyTop: 90 }
  // TODO change back
  // desktop: { zIndex: 3, stickyTop: 109 },
  // mobile: { zIndex: 3, stickyTop: 109 },
});

/***/ }),

/***/ "gwUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_v2_market_contract_v2_market_contract_v2_vue__ = __webpack_require__("D5rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);








var MAX_CONTRACTS_TO_DISPLAY = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketContract: __WEBPACK_IMPORTED_MODULE_5__components_market_v2_market_contract_v2_market_contract_v2_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'grid'
    },
    theme: {
      type: String
    },
    watchIcon: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      showMarketImages: this.showImage && this.market.marketImageUrl
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    totalSharesTraded: function totalSharesTraded() {
      return Number(this.market.totalSharesTraded) || 0;
    },
    showVolume: function showVolume() {
      var fallbackStartDate = this.market.contracts && this.market.contracts.length > 0 ? this.market.contracts[0].startDate : null;
      var openedDate = this.market.dateOpened || fallbackStartDate;
      var daysOld = openedDate && __WEBPACK_IMPORTED_MODULE_6_moment___default()(openedDate).isValid() ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_6_moment___default()(openedDate), 'days') : 7;
      var isNewMarket = daysOld < 7 && this.totalSharesTraded <= 100;

      return !isNewMarket;
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
        'market-list-item-v2': true,
        'market-list-item-v2--large': true,
        'market-list-item-v2--hovered': this.hovered,
        'market-list-item-v2--not-logged': !this.isLoggedIn
      }, 'market-list-item-v2--' + this.layout, true);
    },
    styleModifiers: function styleModifiers() {
      return {
        '--bg-url': 'url(' + this.market.marketImageUrl + ')'
      };
    },
    contracts: function contracts() {
      var results = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.market.contracts) || [];
      if (!results) return [];

      /* Add fake copy of a contract that represents NO contracts */
      if (results.length === 1) {
        var noContract = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ noContract: true }, results[0]);
        results.push(noContract);
      }

      return results.slice(0, MAX_CONTRACTS_TO_DISPLAY);
    },
    showSharesOwnedNotification: function showSharesOwnedNotification() {
      return this.market.userHasOwnership;
    },
    onClick: function onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl
        }
      });
    }
  }),
  methods: {
    contractKey: function contractKey(contract) {
      var suffix = contract.noContract ? 'no' : 'yes';
      return contract.contractId + '-' + suffix;
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    }
  }
});

/***/ }),

/***/ "gzFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"community-forums"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":"Forum","silent":true},on:{"close":_vm.onClose}}):_c('div',{staticClass:"community-forums__desktop-header"},[_c('router-link',{staticClass:"community-forums__back",attrs:{"to":{name: 'HelpAndSupport'},"tag":"span"}},[_vm._v("\n      Help and Support\n    ")])],1),_vm._v(" "),(_vm.url)?_c('div',{staticClass:"community-forums__content"},[_c('iframe',{staticClass:"community-forums__iframe",attrs:{"src":_vm.url,"frameborder":"0"}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h/F2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    account: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: true
    },
    selectable: {
      type: Boolean,
      default: true
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showStatusMessage: function showStatusMessage() {
      return this.showMessage && typeof this.account.accountStatus !== 'undefined' && this.account.accountStatus !== 1;
    },
    classModifiers: function classModifiers() {
      return {
        'bank-account': true,
        'bank-account--selectable': this.selectable
      };
    }
  }
});

/***/ }),

/***/ "h1Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-form-loader': true
      }, 'account-form-loader--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "h21F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disqus-panel"},[(!_vm.isCommentEnabled)?[_c('alert-box',{staticClass:"disqus-panel__warning",attrs:{"level":"warning"}},[_vm._v("\n      Comments are disabled at the moment.\n    ")])]:[(_vm.showTitle)?_c('div',{staticClass:"disqus-panel__title"},[_vm._v("\n      Comments "),(_vm.total)?_c('span',[_vm._v("("+_vm._s(_vm.total.toLocaleString())+" Archived)")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"disqus-panel__content"},[(_vm.currentTitle)?_c('div',{staticClass:"disqus-panel__subtitle"},[_vm._v("\n        "+_vm._s(_vm.currentTitle)+"\n      ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"disqus-panel__note"},[_c('strong',[_vm._v("DISCLAIMER:")]),_vm._v("\n        The Disqus comment section below is for informational purposes only. "),_c('a',{staticClass:"disqus-panel__link",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.showExplanation = !_vm.showExplanation}}},[_vm._v("What does this mean?")]),_vm._v(" "),_c('transition',{attrs:{"name":"disqus-panel"}},[(_vm.showExplanation)?_c('div',[_c('brand-name'),_vm._v(" does not monitor or assess the accuracy of comments. Traders should seek out independent information before making any investment decision. "),_c('brand-name'),_vm._v(" removes comments and may ban users that violate the terms of service (such as those containing inappropriate or offensive language or content) if we become aware of them. See also the "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://help.disqus.com/en/articles/1717116-basic-rules-for-disqus"}},[_vm._v("Basic Rules for Disqus")]),_vm._v(" and "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://help.disqus.com/en/articles/1717227-how-to-report-abuse"}},[_vm._v("How to Report Abuse on Disqus")]),_vm._v(".\n            ")],1):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"disqus",attrs:{"id":"disqus_thread"}}),_vm._v(" "),((_vm.previousThread !== null) || (_vm.nextThread !== null))?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"disqus-panel__navigation"},[(_vm.previousThread !== null)?_c('div',{staticClass:"disqus-panel__navigation-link disqus-panel__navigation-link--left",on:{"click":_vm.onPrevious}},[_vm._v("\n            < OLDER COMMENTS\n          ")]):_vm._e(),_vm._v(" "),(_vm.nextThread !== null)?_c('div',{staticClass:"disqus-panel__navigation-link disqus-panel__navigation-link--right",on:{"click":_vm.onNext}},[_vm._v("\n            NEWER COMMENTS >\n          ")]):_vm._e()])]):_vm._e()])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"disqus-panel__note"},[_c('strong',[_vm._v("ARCHIVED COMMENTS:")]),_vm._v("\n          Every so often we need to archive the comments on a page. If that happens we still make the archived comments accessible by clicking the Older Comments link.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h41O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_search_js__ = __webpack_require__("vm2L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8628820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_search_vue__ = __webpack_require__("G3f5");
function injectStyle (ssrContext) {
  __webpack_require__("aaFU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_search_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8628820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h6O+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hBIN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hE3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewCarouselLoader_vue__ = __webpack_require__("ZKEq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d6492c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewCarouselLoader_vue__ = __webpack_require__("hqzU");
function injectStyle (ssrContext) {
  __webpack_require__("WLny")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewCarouselLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d6492c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewCarouselLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hECP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hKjy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hPGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_header_search_bar_search_bar_vue__ = __webpack_require__("OL8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_headerNav__ = __webpack_require__("drLe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_headerNav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_accountVerify__["a" /* default */]],
  components: {
    searchBar: __WEBPACK_IMPORTED_MODULE_3__components_app_app_header_search_bar_search_bar_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['mobileMenuOpened']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['leaderboardsEnabled']), {
    enabledLinks: function enabledLinks() {
      return this.links.filter(function (i) {
        return i.enabled;
      });
    },
    links: function links() {
      if (this.isLoggedIn) {
        return [{
          title: 'Markets',
          name: 'markets',
          href: '/markets',
          nested: false,
          enabled: true
        }, {
          title: 'News',
          name: 'news',
          href: '/news',
          nested: false,
          enabled: true
        }, {
          title: 'Trends',
          name: 'trends',
          href: '/trends',
          nested: false,
          enabled: false
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard',
          nested: false,
          enabled: true
        }, {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          enabled: this.leaderboardsEnabled,
          nested: false
        }, {
          title: 'Account',
          name: 'account',
          href: '/account',
          nested: false,
          enabled: true
        }, {
          title: 'Learn',
          name: 'help',
          href: '/support',
          nested: true,
          enabled: true
        }, {
          title: 'Wallet',
          name: 'wallet',
          href: '/account/wallet',
          nested: true,
          enabled: this.isUserVerified
        }];
      }

      return [{
        title: 'Markets',
        name: 'markets',
        href: '/markets',
        nested: false,
        enabled: true
      }, {
        title: 'News',
        name: 'news',
        href: '/news',
        nested: false,
        enabled: true
      }, {
        title: 'Learn',
        name: 'help',
        href: '/support',
        nested: false,
        enabled: true
      }, {
        title: 'Insights',
        name: 'insight',
        href: '/insight',
        nested: false,
        enabled: false
      }, {
        title: 'Leaderboards',
        name: 'leaderboards',
        href: '/leaderboards',
        enabled: this.leaderboardsEnabled,
        nested: false
      }];
    }
  }),
  watch: {
    mobileMenuOpened: function mobileMenuOpened(value) {
      if (value) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["l" /* lockModal */])();
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["m" /* unLockModal */])();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('app', ['closeMobileMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onLinkClick: function onLinkClick(href) {
      if (this.$route && this.$route.path === href && this.mobileMenuOpened) {
        window.scrollTo(0, 0);
        this.closeMobileMenu();
      }
    },
    itemClassModifiers: function itemClassModifiers(item) {
      return {
        'app-mobile-menu__nav-item': true,
        'app-mobile-menu__nav-item--nested': item.nested,
        'app-mobile-menu__nav-item--active': this.$route.path.includes(item.href)
      };
    },
    itemIconClassModifiers: function itemIconClassModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'app-mobile-menu__nav-item-icon': true
      }, 'app-mobile-menu__nav-item-icon--' + item.name, item.name);
    },
    logoutButton: function logoutButton() {
      this.loaderAdd(document.body);
      this.logout();
      this.$gtm.trackEvent({ event: 'Logout' });
    },
    showLeavingPopup: function showLeavingPopup() {
      if (this.mobileMenuOpened) {
        window.scrollTo(0, 0);
        this.closeMobileMenu();
      }
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_app_modals__["a" /* MODALS */].LEAVING_POPUP);
    }
  }),
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["m" /* unLockModal */])();
  }
});

/***/ }),

/***/ "hQNd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hQjR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_table_js__ = __webpack_require__("AxKI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bdc609c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_table_vue__ = __webpack_require__("1Qpe");
function injectStyle (ssrContext) {
  __webpack_require__("NKIR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_table_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bdc609c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hUJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"noPadding":_vm.noPadding,"bodyClass":"modal__body--slim modal__body--show-ready"},on:{"modalClose":_vm.closeModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),(_vm.what === 'account-address-update')?_c('account-address-update',{attrs:{"slot":"content"},slot:"content"}):_vm._e(),_vm._v(" "),(_vm.what === 'account-detail-update')?_c('account-details-update',{attrs:{"slot":"content"},slot:"content"}):_vm._e(),_vm._v(" "),(_vm.what === 'account-detail-password')?_c('account-update-password',{attrs:{"slot":"content"},slot:"content"}):_vm._e(),_vm._v(" "),(_vm.what === 'account-detail-password-set')?_c('account-set-password',{attrs:{"slot":"content"},slot:"content"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hbUY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hk1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticPageLoader_vue__ = __webpack_require__("paCg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b535a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticPageLoader_vue__ = __webpack_require__("4DPA");
function injectStyle (ssrContext) {
  __webpack_require__("JqZZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticPageLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b535a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticPageLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hkT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-profile-overview-header"},[(_vm.showMenuToggle)?_c('div',{staticClass:"user-profile-overview-header__toggle",on:{"click":_vm.onMenuToggle}},[_vm._v("•••")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"user-profile-overview-header"}},[(_vm.showMenu)?_c('div',{staticClass:"user-profile-overview-header__menu"},[_c('div',{staticClass:"user-profile-overview-header__menu-inner",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onReportUser($event)}}},[_vm._v("\n        Report user\n      ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"user-profile-overview-header__text"},[_vm._v("\n    User Profile\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hmLA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hmLK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"election-map-special__label"},[_vm._v("\n    GA Special:\n  ")]),_vm._v(" "),_c('transition',{attrs:{"name":"election-map-special"}},[(_vm.showTooltip && _vm.isLayoutDesktop)?_c('div',{staticClass:"election-map-special__tooltip"},[_c('market-state-tooltip',{attrs:{"stateCode":"GA2","stateName":"Georgia","marketData":_vm.ga2MarketData,"type":"senate"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"election-map-special__legend",style:(_vm.legendStyleModifiers),on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"click":_vm.onClick}},[(_vm.targetContractInstance.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.targetContractInstance.lastTradePriceAsCents}})]:[_vm._v("\n      -\n    ")]],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hpVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-contracts"},[_c('div',{staticClass:"sushi-market-contracts__main"},[_c('market-contracts-list-header-sushi',{attrs:{"market":_vm.market}}),_vm._v(" "),_c('div',{staticClass:"sushi-market-contracts__items"},_vm._l((_vm.visibleContracts),function(item){return _c('div',{key:item.contractId,staticClass:"sushi-market-contracts__item"},[_c('market-contract-horizontal-sushi',{attrs:{"data-contract-id":item.contractId,"market":_vm.market,"contract":item,"showOwnershipAndOrdersBar":true,"mobileLayout":_vm.marketDetailMobileLayout}}),_vm._v(" "),_c('transition',{attrs:{"name":"sushi-market-contracts-purchase","mode":"out-in"}},[(_vm.showInlinePurchase(item.contractId))?_c('purchase-inline-sushi',{attrs:{"market":_vm.market,"closeJourneyAfterSuccess":false,"disablePurchaseOfferWatchers":true,"showRelatedContracts":false,"showOrderSlip":_vm.isLayoutMobile,"showOwnershipAndOrdersBar":true,"layoutKind":_vm.isLayoutMobile ? 'mobile' : 'desktop'}}):_vm._e()],1),_vm._v(" "),(_vm.visibleContracts.length > 1)?_c('div',{staticClass:"sushi-market-contracts__contract-line",class:{
            'sushi-market-contracts__contract-line--disabled': _vm.isMarketDisabled,
            'sushi-market-contracts__contract-line--with-purchase': _vm.showInlinePurchase(item.contractId)
          }}):_vm._e()],1)}),0),_vm._v(" "),(_vm.shouldShowToggleMoreButton)?_c('div',{class:_vm.toggleMoreModifiers,on:{"click":_vm.onToggleMore}},[_c('div',{staticClass:"sushi-market-contracts__toggle-text"},[(!_vm.showAllContracts)?[_vm._v("\n          Load More Contracts\n        ")]:[_vm._v("\n          Show Fewer\n        ")]],2),_vm._v(" "),_c('div',{staticClass:"sushi-market-contracts__toggle-icon"})]):_vm._e(),_vm._v(" "),(_vm.showRelatedContractsMobile)?_c('div',{staticClass:"sushi-market-contracts__related-contracts"},[_c('div',{staticClass:"sushi-market-contracts__related-contracts-title"},[_vm._v("\n        Related Contracts\n      ")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-contracts__related-contracts-content"},[_c('related-contracts-sushi',{key:_vm.relatedContractsMobileContractId,attrs:{"contractId":_vm.relatedContractsMobileContractId,"max":3}})],1)]):_vm._e(),_vm._v(" "),_c('sushi-market-top-comments',{attrs:{"isActive":_vm.isActive,"market":_vm.market,"hasDesktopRightRail":_vm.isLayoutDesktop && !_vm.isMarketDisabled},on:{"open-discussion":_vm.onOpenDiscussion,"open-comment":_vm.onOpenComment}})],1),_vm._v(" "),(_vm.isLayoutDesktop && !_vm.isMarketDisabled)?_c('div',{staticClass:"sushi-market-contracts__betslip",style:(_vm.betslipStyleModifiers)},[_c('purchase-inline-sushi',{key:_vm.tradeOptions.contractId,attrs:{"market":_vm.market,"layoutKind":"desktop-widget","closeJourneyAfterSuccess":false,"showRelatedContracts":false,"showOwnershipAndOrdersBar":true}})],1):_vm._e(),_vm._v(" "),(_vm.isLayoutMobile && !_vm.isMarketDisabled)?_c('purchase-inline-sushi',{key:_vm.tradeOptions.contractId,attrs:{"market":_vm.market,"layoutKind":"mobile-widget","closeJourneyAfterSuccess":false,"showRelatedContracts":false,"showOwnershipAndOrdersBar":true}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hqzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__content"},[_c('div',{staticClass:"preview-carousel-loader__story"},[_c('div',{staticClass:"preview-carousel-loader__title"}),_vm._v(" "),(_vm.isLayoutMobile)?[_c('div',{staticClass:"preview-carousel-loader__media"}),_vm._v(" "),_vm._m(1)]:_c('div',{staticClass:"preview-carousel-loader__main"},[_vm._m(2),_vm._v(" "),_vm._m(3)])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader__nav"},[_c('div',{staticClass:"preview-carousel-loader__nav-item preview-carousel-loader__nav-item--active"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__nav-item"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__nav-item"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__nav-item"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__nav-item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader__copy"},[_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--wide"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader__media-column"},[_c('div',{staticClass:"preview-carousel-loader__media"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader__copy-column"},[_c('div',{staticClass:"preview-carousel-loader__copy"},[_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--wide"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"})]),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-secondary"},[_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "htEh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "htHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['market']))
});

/***/ }),

/***/ "hviY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hy1J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-already-exists"},[_c('p',[_vm._v("\n    Your account '"+_vm._s(_vm.email)+"' already exists. Click Next to sign in with that account.\n  ")]),_vm._v(" "),_c('div',{staticClass:"account-already-exists__button"},[_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":_vm.onLogin}},[_vm._v("\n        Next\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i3z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_filters_market_filters_mobile_market_filters_mobile_vue__ = __webpack_require__("EvOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_section_header_market_section_header_vue__ = __webpack_require__("ZqrY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_list_desktop_header_market_list_desktop_header_vue__ = __webpack_require__("/v52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_headerTags__ = __webpack_require__("cgm0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_brand_name_brand_name__ = __webpack_require__("9IfM");


















var HOMEPAGE_FONT_LOAD_FALLBACK_MS = 1200;
var MARKET_DESCRIPTION_FALLBACK = 'PredictIt is a real-money political prediction market, where you can buy and sell shares in the outcome of elections and other political events.';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_headerTags__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_userAgent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_loader__["a" /* default */]],
  components: {
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading___default.a,
    marketFiltersMobile: __WEBPACK_IMPORTED_MODULE_6__components_market_market_filters_market_filters_mobile_market_filters_mobile_vue__["a" /* default */],
    marketSectionHeader: __WEBPACK_IMPORTED_MODULE_7__components_market_market_section_header_market_section_header_vue__["a" /* default */],
    marketListDesktopHeader: __WEBPACK_IMPORTED_MODULE_8__components_market_market_list_desktop_header_market_list_desktop_header_vue__["a" /* default */],
    marketListItem: __WEBPACK_IMPORTED_MODULE_9__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  },
  props: {
    notificationText: {
      type: String,
      required: false
    },
    notificationLevel: {
      type: String,
      required: false
    },
    headerId: Number,
    headerUrl: String,
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: true,
      isFiltering: false,
      infiniteLoader: null,
      stickyOptions: __WEBPACK_IMPORTED_MODULE_5__helpers_stickyConstants__["a" /* default */].mobile,
      watchersDisabled: false,
      isInfiniteLoading: false,
      embeddedInitialFontsReady: false
    };
  },
  metaInfo: function metaInfo() {
    if (this.embedded) return {};
    if (this.currentHeader !== null) {
      return {
        title: this.currentHeader.seoTitle || 'Markets',
        link: [{ rel: 'canonical', href: '' + window.location.href }],
        meta: [{ name: 'description', content: this.currentHeader.seoDescription }, { itemprop: 'name', content: this.currentHeader.seoTitle }, { itemprop: 'description', content: this.currentHeader.seoDescription }, { property: 'og:title', content: this.currentHeader.seoTitle }, { property: 'og:type', content: 'website' }, { property: 'og:description', content: this.currentHeader.seoDescription }, { property: 'og:site_name', content: __WEBPACK_IMPORTED_MODULE_16__components_brand_name_brand_name__["a" /* BRAND */] }, { property: 'og:url', content: '' + window.location.href }]
      };
    }
    return {
      title: 'Markets',
      link: [{ rel: 'canonical', href: '' + window.location.href }],
      meta: [{ name: 'description', content: MARKET_DESCRIPTION_FALLBACK }, { itemprop: 'name', content: 'Markets' }, { itemprop: 'description', content: MARKET_DESCRIPTION_FALLBACK }, { property: 'og:title', content: 'Markets' }, { property: 'og:type', content: 'website' }, { property: 'og:description', content: MARKET_DESCRIPTION_FALLBACK }, { property: 'og:site_name', content: __WEBPACK_IMPORTED_MODULE_16__components_brand_name_brand_name__["a" /* BRAND */] }, { property: 'og:url', content: '' + window.location.href }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('browse', ['selectedFilters', 'selectedOrder', 'selectedTimespan', 'filteredMarkets', 'headers', 'latestHeaderId', 'marketsPageInitialLoadDone']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('user', ['marketDisplay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['previousRoute']), {
    items: function items() {
      var markets = this.filteredMarkets.data === null ? [] : this.filteredMarkets.data;
      var statuses = [__WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].MARKET_SETTLED, __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].MARKET_SUSPENDED];
      return markets.filter(function (m) {
        return !statuses.includes(m.status);
      });
    },
    showNoMarketsMessage: function showNoMarketsMessage() {
      return !this.showInitialSpinner && !this.isLoading && !this.isInfiniteLoading && this.items.length === 0;
    },
    currentHeader: function currentHeader() {
      var _this = this;

      var header = this.headers ? this.headers.find(function (h) {
        return h.headerId === _this.headerId;
      }) : null;
      return header || null;
    },
    currentHeaderName: function currentHeaderName() {
      var header = this.currentHeader;
      if (header) {
        return header.name;
      }
      return this.selectedFilters.length ? 'Filtered Markets' : 'All Markets';
    },
    filtering: function filtering() {
      return this.selectedFilters.toString() + this.selectedOrder.name + this.selectedTimespan.name;
    },
    showSpinner: function showSpinner() {
      return !this.embedded || this.embedded && this.marketsPageInitialLoadDone;
    },
    showInitialSpinner: function showInitialSpinner() {
      return this.embedded ? !this.embeddedInitialFontsReady && !this.marketsPageInitialLoadDone : !this.marketsPageInitialLoadDone;
    },
    marketSkeletonCount: function marketSkeletonCount() {
      return this.isLayoutDesktop ? 9 : 6;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('browse', ['clearFilters', 'clearTimespan', 'clearOrder', 'getFilters', 'getFilteredMarkets', 'setLatestHeaderId', 'resetFilteredMarkets', 'setMarketsPageInitialLoadDone']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['updateMarketDisplay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('notifications', ['setSideNotification']), {
    fetchData: function fetchData() {
      var _this2 = this;

      this.isLoading = true;
      this.infiniteLoader = null;
      if (this.embedded) {
        this.embeddedInitialFontsReady = false;
      }
      if (this.isFiltering) return;
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(this.headerId)) {
        this.notifyEmbeddedInitialLoadState(true);
        __WEBPACK_IMPORTED_MODULE_15__logger__["a" /* default */].info('[MARKETS] Fetching Data');
        this.isFiltering = true;
        this.reorganizeTags();
        this.getFilters(this.headerId).then(function () {
          _this2.getMarkets(true).then(function () {
            _this2.isFiltering = false;
            _this2.isLoading = false;
            _this2.setMarketsPageInitialLoadDone(true);
            _this2.waitForEmbeddedInitialFonts().then(function () {
              _this2.notifyEmbeddedInitialLoadState(false);
            });
          }).catch(function () {
            _this2.isLoading = false;
            _this2.isFiltering = false;
            _this2.setMarketsPageInitialLoadDone(true);
            _this2.waitForEmbeddedInitialFonts().then(function () {
              _this2.notifyEmbeddedInitialLoadState(false);
            });
          });
        }).catch(function () {
          _this2.isFiltering = false;
          _this2.isLoading = false;
          _this2.setMarketsPageInitialLoadDone(true);
          _this2.waitForEmbeddedInitialFonts().then(function () {
            _this2.notifyEmbeddedInitialLoadState(false);
          });
        });
      }
    },
    getMarkets: function getMarkets() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return this.getFilteredMarkets({
        headerId: this.headerId || 0,
        reset: reset
      });
    },
    onLayoutToggle: function onLayoutToggle(layout) {
      this.updateMarketDisplay(layout);
    },
    notifyEmbeddedInitialLoadState: function notifyEmbeddedInitialLoadState(isLoading) {
      if (this.embedded) {
        this.$emit('embeddedInitialLoadStateChange', isLoading);
      }
    },
    waitForEmbeddedInitialFonts: function waitForEmbeddedInitialFonts() {
      var _this3 = this;

      if (!this.embedded || this.embeddedInitialFontsReady) {
        this.embeddedInitialFontsReady = true;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }

      if (typeof document === 'undefined' || !document.fonts || typeof document.fonts.load !== 'function') {
        this.embeddedInitialFontsReady = true;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }

      var requiredFontFaces = ['500 14px Roboto', '300 12px Roboto', '300 24px "Roboto Mono"'];

      if (requiredFontFaces.every(function (fontFace) {
        return document.fonts.check(fontFace);
      })) {
        this.embeddedInitialFontsReady = true;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.race([__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(requiredFontFaces.map(function (fontFace) {
        return document.fonts.load(fontFace);
      })))), new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(resolve, HOMEPAGE_FONT_LOAD_FALLBACK_MS);
      })]).catch(function () {}).then(function () {
        _this3.embeddedInitialFontsReady = true;
      });
    },
    filteringChanged: function filteringChanged() {
      if (this.watchersDisabled) return;

      __WEBPACK_IMPORTED_MODULE_15__logger__["a" /* default */].info('[MARKETS] Filtering. Is in Progress: ' + this.isFiltering.toString());
      if (this.isFiltering) return;
      if (this.embedded) {
        this.fetchData();
      } else {
        this.$router.push({
          name: 'market-list',
          params: {
            headerId: this.headerId,
            headerUrl: this.headerUrl
          },
          query: {
            filterIds: this.selectedFilters.join(','),
            sort: this.selectedOrder.sort,
            sortParameter: this.selectedTimespan.parameter
          }
        });
        this.fetchData();
      }
    },
    headerIdChanged: function headerIdChanged(newValue) {
      if (this.embedded) {
        this.resetFilteredMarkets();
        this.setLatestHeaderId(newValue);
        this.clearFilters();
        this.clearOrder();
        this.clearTimespan();
        this.fetchData();
      } else {
        this.fetchData();
      }
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.filteredMarkets.canLoadMore) {
        this.isInfiniteLoading = true;
        __WEBPACK_IMPORTED_MODULE_15__logger__["a" /* default */].info('[MARKETS] go infinite, initialLoadDone=' + this.marketsPageInitialLoadDone);
        this.getMarkets(false);
      }
    }
  }),
  watch: {
    headerId: {
      handler: 'headerIdChanged',
      immediate: true
    },
    filtering: 'filteringChanged',
    isLoggedIn: 'fetchData',
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        this.isInfiniteLoading = false;
        if (!this.filteredMarkets.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    }
  },
  created: function created() {
    if (this.notificationText && this.notificationLevel) {
      this.setSideNotification({
        text: this.notificationText,
        level: this.notificationLevel
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.embedded) {
      this.watchersDisabled = true;
      this.resetFilteredMarkets();
      this.clearFilters();
      this.clearOrder();
      this.clearTimespan();
    }
  }
});

/***/ }),

/***/ "i8vA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_js__ = __webpack_require__("/Tgi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303d5461_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_vue__ = __webpack_require__("Rl7k");
function injectStyle (ssrContext) {
  __webpack_require__("+8GN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303d5461_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iHgG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iHjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_research_research_vue__ = __webpack_require__("eNmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support_videos_videos_vue__ = __webpack_require__("HSd1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    research: __WEBPACK_IMPORTED_MODULE_3__components_research_research_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_5__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    videos: __WEBPACK_IMPORTED_MODULE_4__components_support_videos_videos_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Research'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']))
});

/***/ }),

/***/ "iJBb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iK+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":"Settings","returnRoute":"profile"}}):_vm._e(),_vm._v(" "),(_vm.settingsReady)?[_c('div',{class:_vm.gridRowModifier},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 account-settings__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[(!_vm.isLayoutMobile)?_c('account-desktop-header',{attrs:{"title":"Settings"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-settings__content"},[_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Security")]),_vm._v(" "),_c('div',{staticClass:"account-settings__container"},[_c('security-settings')],1),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Privacy")]),_vm._v(" "),_c('div',{ref:"general",staticClass:"account-settings__container"},_vm._l((_vm.sectionPrivacy),function(item){return (_vm.hasPrivacy)?_c('div',{staticClass:"account-settings__section"},[_c('settings-option',{key:item.key,attrs:{"category":_vm.categories.privacy,"obj":item},on:{"toggle":function($event){return _vm.onToggleSetting(item, $event)},"error":_vm.doError}},[_vm._v(_vm._s(item.info)+"\n              ")])],1):_vm._e()}),0),_vm._v(" "),(_vm.hasUX)?[_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("User Experience")]),_vm._v(" "),_c('div',{ref:"ux",staticClass:"account-settings__container"},_vm._l((_vm.sectionUX),function(item){return _c('div',{key:item.key,staticClass:"account-settings__section"},[_c('settings-option-switch',{key:item.key,attrs:{"category":_vm.categories.ux,"obj":item},on:{"error":_vm.doError}})],1)}),0)]:_vm._e(),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("In-app Notifications")]),_vm._v(" "),_c('div',{staticClass:"account-settings__container"},[_c('div',[_c('div',{staticClass:"account-settings__push-section"},[_c('div',{staticClass:"account-settings__push-section-wrap"},[_c('div',{staticClass:"account-settings__push-section-inner"},_vm._l((_vm.sectionNotifications),function(item){return _c('check-option',{key:item.key,attrs:{"category":_vm.categories.inApp,"obj":item},on:{"error":_vm.doError}})}),1)])])])]),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Push Notifications")]),_vm._v(" "),_c('div',{ref:"push",staticClass:"account-settings__container"},[(_vm.hasPush)?_c('div',[_c('div',{staticClass:"account-settings__section"},[_c('settings-option',{staticClass:"account-settings__no-margin",attrs:{"category":_vm.categories.push,"obj":_vm.optionPush},on:{"error":_vm.doError,"toggle":_vm.togglePush}},[_vm._v("Allow Notifications\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"account-settings__push-section"},[_c('div',{staticClass:"account-settings__push-section-wrap"},[_c('div',{staticClass:"account-settings__push-section-inner"},_vm._l((_vm.sectionNotifications),function(item){return _c('check-option',{key:item.key,attrs:{"category":_vm.categories.push,"obj":item,"disabled":_vm.isPushDisabled},on:{"error":_vm.doError}})}),1),_vm._v(" "),(_vm.isPushDisabled)?_c('div',{staticClass:"account-settings__push-section--disabled"}):_vm._e()])])]):_vm._e()]),_vm._v(" "),(_vm.hasLocalPassword)?[_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Social Logins")]),_vm._v(" "),_c('div',{staticClass:"account-settings__section"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"account-settings__section--right"},[_c('switch-button',{key:_vm.hasFacebook,attrs:{"black":"","checked":_vm.hasFacebook,"disabled":_vm.isFacebookDisabled},on:{"toggle":function($event){return _vm.onToggleProvider('Facebook', $event)}}})],1)]),_vm._v(" "),(_vm.googleLink)?_c('div',{staticClass:"account-settings__section"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"account-settings__section--right"},[_c('switch-button',{key:_vm.hasGoogle,attrs:{"black":"","checked":_vm.hasGoogle,"disabled":_vm.isGoogleDisabled},on:{"toggle":function($event){return _vm.onToggleProvider('Google', $event)}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-settings__section"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"account-settings__section--right"},[_c('switch-button',{key:_vm.hasTwitter,attrs:{"black":"","checked":_vm.hasTwitter,"disabled":_vm.isTwitterDisabled},on:{"toggle":function($event){return _vm.onToggleProvider('Twitter', $event)}}})],1)])]:_vm._e(),_vm._v(" "),(_vm.manageInfoLoaded && !_vm.hasLocalPassword)?[_c('div',{staticClass:"account-settings__section account-settings__section--clickable",on:{"click":function($event){$event.preventDefault();return _vm.onSetPassword($event)}}},[_c('alert-box',{attrs:{"level":"danger"}},[_vm._v("\n                You must create a password for your account before you can manage your External Logins.\n              ")])],1)]:_vm._e()],2)],1)])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings__section--left account-settings__section--facebook"},[_c('img',{staticClass:"account-settings__section-img",attrs:{"src":__webpack_require__("ntlj"),"alt":""}}),_vm._v(" Facebook\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings__section--left account-settings__section--google"},[_c('img',{staticClass:"account-settings__section-img",attrs:{"src":__webpack_require__("/zTd"),"alt":""}}),_vm._v(" Google\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings__section--left account-settings__section--x"},[_c('img',{staticClass:"account-settings__section-img",attrs:{"src":__webpack_require__("Rutn"),"alt":""}}),_vm._v(" X.com\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iNbR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iOdY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iOeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_js__ = __webpack_require__("/gy2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f3a5260_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_vue__ = __webpack_require__("ubfr");
function injectStyle (ssrContext) {
  __webpack_require__("G8ry")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f3a5260_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iPBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-trade-type-switcher-sushi"},[_c('div',{staticClass:"purchase-trade-type-switcher-sushi__main"},[_c('span',{class:_vm.operationClassModifiers('buy'),on:{"pointerdown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.switchOperation('buy')}}},[_vm._v("Buy")]),_vm._v(" "),_c('span',{staticClass:"purchase-trade-type-switcher-sushi__operation--margin-left",class:_vm.operationClassModifiers('sell'),on:{"pointerdown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.switchOperation('sell')}}},[_vm._v("Sell")]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"purchase-trade-type-switcher-sushi__type-container"},[_c('span',{staticClass:"purchase-trade-type-switcher-sushi__type"},[_vm._v("Limit Order")]),_vm._v(" "),(false)?_c('div',{staticClass:"purchase-trade-type-switcher-sushi__type-toggle",on:{"click":_vm.onMenuToggle}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"purchase-trade-type-switcher-sushi"}},[(_vm.showMenu)?_c('div',{staticClass:"purchase-trade-type-switcher-sushi__menu"},[_c('div',{staticClass:"purchase-trade-type-switcher-sushi__menu-inner"},[_c('div',{staticClass:"purchase-trade-type-switcher-sushi__menu-inner-item"},[_c('div',{staticClass:"purchase-trade-type-switcher-sushi__menu-inner-icon"}),_vm._v(" "),_c('div',{staticClass:"purchase-trade-type-switcher-sushi__menu-inner-item-operation purchase-trade-type-switcher-sushi__menu-inner-item-operation--selected"},[_vm._v("\n                Limit Order\n              ")])]),_vm._v(" "),_c('div',{staticClass:"purchase-trade-type-switcher-sushi__menu-inner-item"},[_c('div',{staticClass:"purchase-trade-type-switcher-sushi__menu-inner-icon purchase-trade-type-switcher-sushi__menu-inner-icon--empty"}),_vm._v(" "),_c('div',{staticClass:"purchase-trade-type-switcher-sushi__menu-inner-item-operation purchase-trade-type-switcher-sushi__menu-inner-item-operation--not-available"},[_vm._v("\n                Market Order (Coming Soon)\n              ")])])])]):_vm._e()])],1)]),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"purchase-trade-type-switcher-sushi__secondary"},[_c('span',{staticClass:"purchase-trade-type-switcher-sushi__direction-label"},[_vm._v("Direction")]),_vm._v(" "),_c('div',{staticClass:"purchase-trade-type-switcher-sushi__direction-container"},[_c('span',{class:_vm.directionClassModifiers('yes'),on:{"pointerdown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.switchDirection('yes')}}},[_vm._v("Yes")]),_vm._v(" "),_c('span',{class:_vm.directionClassModifiers('no'),on:{"pointerdown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.switchDirection('no')}}},[_vm._v("No")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iSNB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials"},[_c('h5',{staticClass:"socials__title"},[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.availableSocials))]),_vm._v(" "),(!_vm.isComponentReady)?_c('socials-loader'):_c('div',{staticClass:"socials__items"},[(_vm.facebookLink)?_c('div',{staticClass:"socials__item"},[_c('a',{staticClass:"socials__button socials__button--facebook",attrs:{"href":_vm.facebookLink},on:{"click":function($event){return _vm.registrationTrack('Facebook')}}})]):_vm._e(),_vm._v(" "),(_vm.googleLink)?_c('div',{staticClass:"socials__item"},[_c('a',{staticClass:"socials__button socials__button--google",attrs:{"href":_vm.googleLink},on:{"click":function($event){return _vm.registrationTrack('Google')}}})]):_vm._e(),_vm._v(" "),(_vm.twitterLink)?_c('div',{staticClass:"socials__item"},[_c('a',{staticClass:"socials__button socials__button--twitter",attrs:{"href":_vm.twitterLink},on:{"click":function($event){return _vm.registrationTrack('Twitter')}}})]):_vm._e()]),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials__line"},[_c('div',{staticClass:"socials__line-border"}),_vm._v(" "),_c('div',{staticClass:"socials__line-label"},[_vm._v("OR")]),_vm._v(" "),_c('div',{staticClass:"socials__line-border"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iWSG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iYpn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    title: function title() {
      if (!this.isMarketSingle) return this.contractModel.contractName || this.contractModel.name;
      return this.contract.noContract ? 'No' : 'Yes';
    },
    hasLastTradePrice: function hasLastTradePrice() {
      return this.contractModel.hasLastTradePrice;
    },
    price: function price() {
      var lastPrice = this.contractModel.lastTradePriceAsCents;
      if (!this.hasLastTradePrice) return 0;
      if (!this.isMarketSingle) return lastPrice;
      if (this.contract.noContract) {
        return 100 - lastPrice;
      }
      return lastPrice;
    },
    changePrice: function changePrice() {
      if (!this.hasLastTradePrice) return 0;
      var price = this.contractModel.changePriceAsCents;
      return this.contract.noContract ? -price : price;
    },
    classModifiers: function classModifiers() {
      return {
        'market-contract-v2': true
      };
    },
    isDisabled: function isDisabled() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["A" /* isContractOpen */])(this.contractModel);
    },
    contractRoute: function contractRoute() {
      var query = { contractId: this.contract.contractId };
      if (this.contract.noContract) {
        query.no = 'true';
      }
      return {
        name: 'market-details',
        params: { marketId: this.market.marketId },
        query: query
      };
    }
  })
});

/***/ }),

/***/ "iaga":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ib9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-shares-item-loader"},[_c('div',{staticClass:"market-shares-item-loader__image"}),_vm._v(" "),_c('div',{staticClass:"market-shares-item-loader__content"},[_c('div',{staticClass:"market-shares-item-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"market-shares-item-loader__text-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ibDk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "id0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"most-predicted-list"},[_c('div',{staticClass:"most-predicted-list__header"},[_c('div',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"most-predicted-list__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()]),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"content-loader-item"},[_c('market-loader')],1)}),0):_c('div',{staticClass:"most-predicted-list__content"},[(_vm.isLayoutDesktop)?_vm._l((_vm.items),function(market){return _c('market-list-item',{key:market.marketId,staticClass:"most-predicted-list__item",attrs:{"market":market,"theme":"home"}})}):_vm._e(),_vm._v(" "),(_vm.isLayoutMobile)?[_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(item){return _c('swiper-slide',{key:item.marketId},[_c('market-list-item',{staticClass:"most-predicted-list__item",attrs:{"market":item,"theme":"home"}})],1)}),1)]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ifvC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xMiAxNC4yM2MxLjM0OSAwIDIuNDM5LTEuMDM1IDIuNDM5LTIuMzE0IDAtMS4yOC0xLjA5Mi0yLjMxNi0yLjQzOC0yLjMxNi0xLjM2NyAwLTIuNDQgMS4wNTctMi40MzggMi4zMTUuMDAzIDEuMjgyIDEuMDg5IDIuMzE1IDIuNDM4IDIuMzE1em0zLjE0MS0uMTE0Yy0uNzQ2LjkyMi0xLjcyOCAxLjQzLTIuOTUxIDEuNDk5LS43MTcuMDQxLTEuNDMyLS4xMTUtMi4wNjYtLjQ1Mi0uNjMzLS4zMjItMS4xNjItLjgxOC0xLjUyMi0xLjQzLS41MDctLjg2My0uNjI3LTEuNzgtLjM3OC0yLjc0MmgtMS4xdjUuMDU2YzAgLjAyNSAwIC4wNS4wMDMuMDc1LjAxLjA5My4wNDYuMTgxLjEwNi4yNTMuMDYuMDcyLjE0LjEyNC4yMy4xNS4wNjMuMDE2LjEyNy4wMjQuMTkxLjAyMmg4LjY5N2MuMDQ2LjAwMS4wOTItLjAwMy4xMzctLjAxLjEwOC0uMDE4LjIwNy0uMDczLjI3OC0uMTU3LjA3LS4wODMuMTEtLjE4OC4xMS0uMjk4di01LjA4OUgxNS43OGMuMjggMS4xMzMuMDczIDIuMTc1LS42MzkgMy4xMjN6TTIyLjU5MSAwSDEuNDFDMS4wMzcuMDAxLjY4LjE1LjQxNC40MTUuMTUuNjc5LjAwMSAxLjAzOCAwIDEuNDEyVjIyLjU5Yy4wMDIuMzc0LjE1LjczMi40MTUuOTk2LjI2NC4yNjQuNjIyLjQxMy45OTYuNDE0aDIxLjE4Yy4zNzMtLjAwMi43My0uMTUuOTk0LS40MTUuMjY0LS4yNjQuNDEzLS42MjEuNDE1LS45OTVWMS40MTJjLS4wMDEtLjM3NC0uMTUtLjczMi0uNDE0LS45OTctLjI2NC0uMjY0LS42MjItLjQxNC0uOTk2LS40MTV6bS00LjUyNCAxNS43NjRjMCAxLjE4LS45OSAyLjE0NC0yLjIgMi4xNDRIOC4xMzVjLTEuMjEyIDAtMi4yLS45NjQtMi4yLTIuMTQ0VjguMjM4YzAtMS4xNzkuOTktMi4xNDQgMi4yLTIuMTQ0aDcuNzMyYzEuMjExIDAgMi4yLjk2NCAyLjIgMi4xNDR2Ny41Mjd6bS0xLjY4NS04LjQ4MWgtMS40NDRjLS4yODMgMC0uNDk3LjIwMi0uNDk4LjQ3djEuMzgxYzAgLjAyMi4wMDIuMDQ0LjAwNS4wNjUuMDIuMTE1LjA4LjIxOS4xNy4yOTMuMDkuMDc0LjIwMy4xMTMuMzIuMTEuMjQtLjAwMy40ODEgMCAuNzIyIDBoLjcyM2MuMDMxLjAwMS4wNjMgMCAuMDkzLS4wMDUuMTEyLS4wMTUuMjE1LS4wNy4yOS0uMTU0LjA3NC0uMDg1LjExNS0uMTk0LjExNS0uMzA3VjcuNzU0YzAtLjAyNS0uMDAxLS4wNS0uMDA1LS4wNzUtLjAyLS4xMTQtLjA4MS0uMjE3LS4xNzEtLjI5LS4wOS0uMDcyLS4yMDQtLjExLS4zMi0uMTA1di0uMDAxeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "ihRI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MiIgaGVpZ2h0PSI4MiIgdmlld0JveD0iMCAwIDgyIDgyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAuNSIgc3Ryb2tlPSIjNDJDRjI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzQyQ0YyNiIgZD0iTTYwLjY0MiAzMS4yNDJsLTIxLjkyNCAyMi45NGEzLjQ5NSAzLjQ5NSAwIDAgMS01LjEwNiAwbC05LjE1OC05LjU3OWMtMS40MDgtMS40NzctMS40MDgtMy44NjkgMC01LjM0NmEzLjUwMSAzLjUwMSAwIDAgMSA1LjEwNiAwbDYuNjA1IDYuOTFMNTUuNTM1IDI1LjlhMy40OTUgMy40OTUgMCAwIDEgNS4xMDcgMGMxLjQxMiAxLjQ3NCAxLjQxMiAzLjg2NiAwIDUuMzQzIi8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "iit4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_keyboard_numeric_input_sushi_keyboard_numeric_input_sushi_vue__ = __webpack_require__("JLAi");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    keyboardNumericInputSushi: __WEBPACK_IMPORTED_MODULE_1__components_keyboard_numeric_input_sushi_keyboard_numeric_input_sushi_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: 'Minimum Sell Price'
    },
    value: {
      type: Number,
      default: 50
    },
    kind: {
      type: String,
      default: 'modal'
    },
    selected: Boolean,
    userQuantity: {},
    threshold: {
      type: Number,
      default: 25
    },
    operationType: {
      type: String,
      default: 'buy'
    },
    tabindex: Number,
    minimumOwnership: {
      type: Number,
      default: 1
    },
    minValue: {
      type: Number,
      default: 1
    },
    maxValue: {
      type: Number,
      default: 9999
    }
  },
  data: function data() {
    return {
      updated: false,
      val: this.value !== null ? parseInt(this.value, 10) : null
    };
  },

  computed: {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {
        'purchase-quantity-value-sushi': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'purchase-quantity-value-sushi--' + this.kind, this.kind), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'purchase-quantity-value-sushi--selected', this.selected), _ref;
    }
  },
  watch: {
    val: 'updateOffer',
    value: function value(_value) {
      this.val = _value !== null ? parseInt(_value, 10) : null;
    }
  },
  methods: {
    add: function add() {
      if (isNaN(this.val) || this.val === null || this.val === 1) {
        this.val = 0;
      }
      var newValue = this.val + this.threshold;
      if (this.userQuantity && this.operationType === 'sell' && this.val <= this.userQuantity && newValue > this.userQuantity) {
        newValue = this.userQuantity;
      }
      this.val = Math.min(newValue, this.maxValue);
    },
    subtract: function subtract() {
      if (isNaN(this.val) || this.val === null || this.val < this.threshold + 1) {
        this.val = this.threshold + 1;
      }
      var newValue = this.val - this.threshold;
      this.val = Math.max(newValue, this.minValue);
    },
    updateOffer: function updateOffer() {
      this.updated = true;
      this.val = parseInt(this.val, 10);
      if (isNaN(this.val) || this.val < 1) this.val = null;

      if (this.val !== null) {
        this.$emit('input', Number(this.val));
      } else {
        this.$emit('input', this.val);
      }
    },
    click: function click() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "ikte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.iconClassModifiers}),_vm._v(" "),_c('div',{staticClass:"market-disabled-outcome-v2__text"},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "imzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_learn_the_basics_js__ = __webpack_require__("nHRj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7510bc1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_learn_the_basics_vue__ = __webpack_require__("DJ46");
function injectStyle (ssrContext) {
  __webpack_require__("maUT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_learn_the_basics_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7510bc1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_learn_the_basics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iocs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-list-v2-embed",class:{ 'market-contract-list-v2-embed--narrow': _vm.isNarrowContainer }},[_c('market-contracts-list-header-sushi',{attrs:{"market":_vm.market,"forCmsWidget":true,"force-mobile-layout":_vm.isNarrowContainer}}),_vm._v(" "),_c('div',{staticClass:"market-contract-list-v2-embed__contracts",attrs:{"data-newtab":_vm.openNewTab.toString()}},_vm._l((_vm.market.contracts),function(contract,index){return _c('div',{key:contract.contractId,staticClass:"market-contract-list-v2-embed__contract",class:{ 'market-contract-list-v2-embed__contract--last': index === _vm.market.contracts.length - 1 }},[(_vm.isLayoutDesktop && !_vm.isNarrowContainer)?_c('market-contract-horizontal-sushi',{attrs:{"data-contract-id":contract.contractId,"market":_vm.market,"contract":contract,"forCmsWidget":true},on:{"contractClicked":_vm.onContractClick}}):_c('market-contract-horizontal-sushi-mobile',{attrs:{"data-contract-id":contract.contractId,"market":_vm.market,"contract":contract,"forCmsWidget":true},on:{"contractClicked":_vm.onContractClick}}),_vm._v(" "),(index !== _vm.market.contracts.length - 1)?_c('div',{staticClass:"market-contract-list-v2-embed__contract-line"}):_vm._e()],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "irZi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ircP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_coinbase_js__ = __webpack_require__("/JWN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0818b7de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_coinbase_vue__ = __webpack_require__("xnYV");
function injectStyle (ssrContext) {
  __webpack_require__("THQS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_coinbase_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0818b7de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_coinbase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "itDa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iuvl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-key-stats-element",on:{"click":_vm.onClick}},[_c('div',{staticClass:"market-key-stats-element__title"},[_vm._v("\n    "+_vm._s(_vm.obj.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__wrap market-key-stats-element__wrap--left"},[_c('div',{staticClass:"market-key-stats-element__center"},[_c('div',{staticClass:"market-key-stats-element__percent"},[_vm._v(_vm._s(Number(_vm.obj.valueA).toFixed(1))),_c('span',{staticClass:"market-key-stats-element__sign"},[_vm._v("%")])]),_vm._v(" "),(_vm.obj.valueAHasTrend)?_c('div',{staticClass:"market-key-stats-element__delta"},[_c('market-change-price',{attrs:{"price":_vm.obj.valueATrendPercentage,"percent":true}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__sub-title"},[_vm._v(_vm._s(_vm.obj.valueASubtitle))])]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__wrap market-key-stats-element__wrap--right"},[_c('div',{staticClass:"market-key-stats-element__center"},[_c('div',{staticClass:"market-key-stats-element__percent"},[_vm._v(_vm._s(Number(_vm.obj.valueB).toFixed(1))),_c('span',{staticClass:"market-key-stats-element__sign"},[_vm._v("%")])]),_vm._v(" "),(_vm.obj.valueBHasTrend)?_c('div',{staticClass:"market-key-stats-element__delta"},[_c('market-change-price',{attrs:{"price":_vm.obj.valueBTrendPercentage,"percent":true}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__sub-title"},[_vm._v(_vm._s(_vm.obj.valueBSubtitle))])]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__footer"},[(_vm.obj.urlData)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":_vm.obj.urlData},on:{"click":function($event){return $event.stopPropagation()}}},[_vm._v("\n      "+_vm._s(_vm.obj.source)+"\n    ")]):_c('a',{attrs:{"href":"#"}},[_vm._v("\n      "+_vm._s(_vm.obj.source)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iwZ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j0az":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j3lF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountRegister: __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "j7O+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-betslip-shortcut-widget",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClick($event)}}},[_c('div',{staticClass:"bottom-betslip-shortcut-widget__icon"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jDBh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMwN2EwYmIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIzIDE2Ljg3NVYxLjEyNUMyMyAuNTAyIDIyLjQ5OCAwIDIxLjg3NSAwSDYuNUE0LjUwMSA0LjUwMSAwIDAgMCAyIDQuNXYxNUMyIDIxLjk4NCA0LjAxNiAyNCA2LjUgMjRoMTUuMzc1Yy42MjMgMCAxLjEyNS0uNTAyIDEuMTI1LTEuMTI1di0uNzVjMC0uMzUyLS4xNjQtLjY3LS40MTctLjg3Ny0uMTk3LS43MjEtLjE5Ny0yLjc4IDAtMy41MDEuMjUzLS4yMDIuNDE3LS41Mi40MTctLjg3MnpNOCA2LjI4MUM4IDYuMTI3IDguMTI3IDYgOC4yODEgNmg5LjkzOGMuMTU0IDAgLjI4MS4xMjcuMjgxLjI4MXYuOTM4YS4yODIuMjgyIDAgMCAxLS4yODEuMjgxSDguMjhBLjI4Mi4yODIgMCAwIDEgOCA3LjIxOVY2LjI4em0wIDNDOCA5LjEyNyA4LjEyNyA5IDguMjgxIDloOS45MzhjLjE1NCAwIC4yODEuMTI3LjI4MS4yODF2LjkzOGEuMjgyLjI4MiAwIDAgMS0uMjgxLjI4MUg4LjI4QS4yODIuMjgyIDAgMCAxIDggMTAuMjE5VjkuMjh6TTE5Ljg3OCAyMUg2LjVjLS44MyAwLTEuNS0uNjctMS41LTEuNSAwLS44MjUuNjc1LTEuNSAxLjUtMS41aDEzLjM3OGMtLjA4OS44MDItLjA4OSAyLjE5OCAwIDN6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "jHoo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jI1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_affiliations_popup_js__ = __webpack_require__("WeRi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5711ba6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_affiliations_popup_vue__ = __webpack_require__("OZE0");
function injectStyle (ssrContext) {
  __webpack_require__("I+d5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_affiliations_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5711ba6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_affiliations_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jLJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__("gsqX");
  __webpack_require__("v2ns");
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "jPoG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return regularContractPrice; });
/* unused harmony export noContractPrice */
function regularContractPrice(contractData) {
  if (contractData.closeSharePrice === null) return null;
  return Number((100 * contractData.closeSharePrice).toFixed(2));
}

function noContractPrice(contractData) {
  if (contractData.closeSharePrice === null) return null;
  return Number((100 - contractData.closeSharePrice * 100).toFixed(2));
}



/***/ }),

/***/ "jSv/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jVeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_address_update_js__ = __webpack_require__("kwj7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2732ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_address_update_vue__ = __webpack_require__("qjJq");
function injectStyle (ssrContext) {
  __webpack_require__("D3WX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_address_update_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2732ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_address_update_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jWsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-winner-v2"},[_c('div',{staticClass:"market-winner-v2__title"},[_vm._v("\n    Winner\n  ")]),_vm._v(" "),_c('div',{staticClass:"market-winner-v2__icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jcOa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jcwD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_news_archive_stories_js__ = __webpack_require__("d76Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6234da0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_news_archive_stories_vue__ = __webpack_require__("8HXy");
function injectStyle (ssrContext) {
  __webpack_require__("xqHD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_news_archive_stories_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6234da0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_news_archive_stories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jeTY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "joAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    checked: {
      type: String
    },
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('change', this.value);
    },
    onChange: function onChange(e) {
      this.$emit('change', e.target.value);
    }
  }
});

/***/ }),

/***/ "jqqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_news_stories_js__ = __webpack_require__("bUan");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb7cb11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_news_stories_vue__ = __webpack_require__("xdho");
function injectStyle (ssrContext) {
  __webpack_require__("cBKw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_news_stories_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb7cb11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_news_stories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jtVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_button_direction_js__ = __webpack_require__("GSOF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ee3226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_button_direction_vue__ = __webpack_require__("utJg");
function injectStyle (ssrContext) {
  __webpack_require__("dSN9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_button_direction_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ee3226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_button_direction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jtWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['setWatchedUserDetails']), {
    showUserDetails: function showUserDetails(item) {
      var profitablePredictions = (typeof item.totalProfitablePredictions !== 'undefined' ? item.totalProfitablePredictions : item.profitablePredictions) || 0;
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_USER_PROFILE);
      var trader = {
        userName: item.userName,
        avatarImage: item.avatarImage,
        traderLevel: item.traderLevel || null,
        profitablePredictions: profitablePredictions
      };
      this.setWatchedUserDetails(trader);
    }
  })
});

/***/ }),

/***/ "jthy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k0c/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNyIgc3Ryb2tlPSIjOTQ5NDk0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "kFFz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kGUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('div',{staticClass:"hero-unit-slider__loader"}):_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(banner){return _c('swiper-slide',{key:banner.carouselId,staticClass:"hero-unit-slider__slide"},[_c('div',{staticClass:"hero-unit-slider__image",style:(_vm.bannerImageStyleModifiers(banner.carouselData.image))}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__content"},[(banner.carouselData.carouselItemHeader.secondLine)?_c('p',{staticClass:"hero-unit-slider__para",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.secondLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemHeader.firstLine)?_c('h2',{staticClass:"hero-unit-slider__headline",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.firstLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemButton)?[(_vm.isUrlExternal(banner))?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"button button--medium button--submit hero-unit-slider__button",style:(_vm.buttonStyleModifiers(banner.carouselData.carouselItemButton)),attrs:{"href":_vm.getBannerUrl(banner)},domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemButton.text)}}):_c('router-link',{staticClass:"button button--medium button--submit hero-unit-slider__button",style:(_vm.buttonStyleModifiers(banner.carouselData.carouselItemButton)),attrs:{"to":_vm.getBannerUrl(banner)},domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemButton.text)}})]:_vm._e()],2)])}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kGlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_filters_filter_button_filter_button_vue__ = __webpack_require__("3GDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_filters_menu_button_menu_button_vue__ = __webpack_require__("Q/ey");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    filterButton: __WEBPACK_IMPORTED_MODULE_4__components_market_market_filters_filter_button_filter_button_vue__["a" /* default */],
    menuButton: __WEBPACK_IMPORTED_MODULE_5__components_market_market_filters_menu_button_menu_button_vue__["a" /* default */]
  },
  props: {
    theme: {
      type: String,
      default: 'sushi'
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ordersOpen: false,
      filtersOpen: false,
      timespansOpen: false,
      isDashboardOpen: false,
      isWatchlistOpen: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('browse', ['filters', 'orders', 'timespans', 'selectedFilters', 'selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    mainClassName: function mainClassName() {
      return 'market-filters';
    },
    filterMenuName: function filterMenuName() {
      var prefix = 'Keywords';
      if (this.selectedFilters && this.selectedFilters.length > 0) {
        return prefix + ' (' + this.selectedFilters.length + ')';
      }
      return prefix;
    },
    orderMenuName: function orderMenuName() {
      return 'Sort By';
    },
    classModifier: function classModifier() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--embedded', this.embedded), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open', this.filtersOpen || this.ordersOpen || this.timespansOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-order', this.ordersOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-filters', this.filtersOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-timespans', this.timespansOpen), _ref;
    },
    availableTimespanOptions: function availableTimespanOptions() {
      if (this.selectedOrder && this.selectedOrder.sort === 'movers') {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.timespans)).filter(function (i) {
          return i.parameter !== 'ALL';
        });
      }
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.timespans)).filter(function (i) {
        return i.parameter !== '3DAY';
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('browse', ['addFilter', 'removeFilter', 'selectOrder', 'selectTimespan', 'clearFilters']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('overlay', {
    hideOverlay: 'hide',
    showOverlay: 'show'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('dashboard', {
    dashSelectOrder: 'selectOrder',
    dashSelectTimespan: 'selectTimespan'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('watchlist', {
    watchSelectOrder: 'selectOrder',
    watchSelectTimespan: 'selectTimespan'
  }), {
    orderList: function orderList(kind) {
      var marketsDisabledSorts = ['gain', 'loss', 'investment'];

      return kind === 'markets' ? this.orders.filter(function (i) {
        return !marketsDisabledSorts.includes(i.sort);
      }) : this.orders;
    },
    onAddFilter: function onAddFilter(filterId) {
      this.addFilter(filterId);
      if (this.embedded) {
        this.closeFilters();
      }
    },
    onRemoveFilter: function onRemoveFilter(filterId) {
      this.removeFilter(filterId);
      if (this.embedded) {
        this.closeFilters();
      }
    },
    onClearFilters: function onClearFilters() {
      this.clearFilters();
      if (this.embedded) {
        this.closeFilters();
      }
    },
    toggleFilters: function toggleFilters() {
      this.filtersOpen = !this.filtersOpen;
      this.ordersOpen = false;
      this.timespansOpen = false;
    },
    toggleOrder: function toggleOrder() {
      this.ordersOpen = !this.ordersOpen;
      this.filtersOpen = false;
      this.timespansOpen = false;
    },
    toggleTimespans: function toggleTimespans() {
      this.timespansOpen = !this.timespansOpen;
      this.filtersOpen = false;
      this.ordersOpen = false;
    },
    selectOrderAndClose: function selectOrderAndClose(sort) {
      if (this.isWatchlistOpen) {
        this.watchSelectOrder(sort);
      } else if (this.isDashboardOpen) {
        this.dashSelectOrder(sort);
      } else {
        this.selectOrder(sort);
      }
      this.toggleOrder();
    },
    selectTimespanAndClose: function selectTimespanAndClose(timespan) {
      if (this.isWatchlistOpen) {
        this.watchSelectTimespan(timespan);
      } else if (this.isDashboardOpen) {
        this.dashSelectTimespan(timespan);
      } else {
        this.selectTimespan(timespan);
      }
      this.toggleTimespans();
    },
    selectTimespanOnly: function selectTimespanOnly(timespan) {
      this.selectTimespan(timespan);
    },
    filterSelected: function filterSelected(filterId) {
      return this.selectedFilters.includes(filterId);
    },
    orderSelected: function orderSelected(sort) {
      return this.selectedOrder.sort === sort;
    },
    closeFilters: function closeFilters() {
      this.filtersOpen = false;
      this.ordersOpen = false;
      this.timespansOpen = false;
    },
    filterKey: function filterKey(filter) {
      return filter.filterId.toString() + this.filterSelected(filter.filterId).toString();
    }
  })
});

/***/ }),

/***/ "kHwo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iOSIgZmlsbD0iIzJBODg1NiIvPgo8cGF0aCBkPSJNMTEuODM1NyA2LjE0OTMxQzExLjY3IDUuNTQxNTcgMTAuODY3OCA0LjMyNjExIDguOTg0OTEgNC4zMjYxMUM4LjA3ODgzIDQuMzA0MDEgNi4yNjY2OCA0LjY1NzQ2IDYuMTY3MjMgNi41NDY5MUM2LjA3MzAxIDguMzM3MDIgOC4xODkzMyA4Ljc2ODA4IDguOTg0OTEgOS4wNjY0MkM5LjkzNTE5IDkuMjQzMTggMTEuODM1NyA5Ljk3NDU5IDExLjgzNTcgMTEuNDg2MkMxMS44MzU3IDEzLjM3NTcgOS40ODIxNSAxMy43NzM1IDguOTg0OTEgMTMuNzczNUM4LjQ4NzY3IDEzLjc3MzUgNi40NjU1OCAxMy42MDc3IDYuMTY3MjMgMTEuOTgzNE04Ljk4NDkxIDNMOC45ODQ5MSAxNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "kIHN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kIgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_sushi_js__ = __webpack_require__("NOsI");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_sushi_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a49db7a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_sushi_vue__ = __webpack_require__("3po1");
function injectStyle (ssrContext) {
  __webpack_require__("swXC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_sushi_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a49db7a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kNWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_history_js__ = __webpack_require__("HOak");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f46608f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__ = __webpack_require__("vSKX");
function injectStyle (ssrContext) {
  __webpack_require__("ExM7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f46608f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kOSc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_charts_js__ = __webpack_require__("kqQR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e76c5910_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_charts_vue__ = __webpack_require__("xb6r");
function injectStyle (ssrContext) {
  __webpack_require__("TZdP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_charts_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e76c5910_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kP05":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export-history row-xy"},[(_vm.openCalendar)?_c('div',{staticClass:"export-history__transparent-overlay",on:{"click":_vm.overlayClick}}):_vm._e(),_vm._v(" "),(_vm.contractName)?_c('div',{staticClass:"column small-12"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"export-history__market"},[_vm._v("\n      "+_vm._s(_vm.contractName)+"\n    ")])]):(_vm.marketId)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"export-history__market"},[_vm._v("\n      "+_vm._s(_vm.market.marketName)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('state-button',{ref:"l30d",staticClass:"export-history__button",attrs:{"selected":_vm.selected.l30d,"name":"l30d"},on:{"click":_vm.onButtonClick}},[_vm._v("Past Month")])],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('state-button',{ref:"l3m",staticClass:"export-history__button",attrs:{"selected":_vm.selected.l3m,"name":"l3m"},on:{"click":_vm.onButtonClick}},[_vm._v("Past 3 Months")])],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('state-button',{ref:"ytd",staticClass:"export-history__button",attrs:{"selected":_vm.selected.ytd,"name":"ytd"},on:{"click":_vm.onButtonClick}},[_vm._v("Past Year")])],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"export-history__date",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.fromClick($event)}}},[_c('label',{staticClass:"export-history__label",attrs:{"for":"fromDatepicker"}},[_vm._v("From")]),_vm._v(" "),_c('datepicker',{ref:"fromDatepicker",attrs:{"format":_vm.dateFormatter,"disabled":_vm.disabled,"maximum-view":"month","input-class":"export-history__input","wrapper-class":"export-history__wrap","calendar-class":"export-history__calendar","id":"fromDatepicker","name":"fromDatepicker"},on:{"opened":_vm.opened,"closed":_vm.closed},model:{value:(_vm.dateFrom.date),callback:function ($$v) {_vm.$set(_vm.dateFrom, "date", $$v)},expression:"dateFrom.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"export-history__date",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.toClick($event)}}},[_c('label',{staticClass:"export-history__label",attrs:{"for":"toDatepicker"}},[_vm._v("To")]),_vm._v(" "),_c('datepicker',{ref:"toDatepicker",attrs:{"format":_vm.dateFormatter,"disabled":_vm.disabled,"maximum-view":"month","input-class":"export-history__input","wrapper-class":"export-history__wrap","calendar-class":"export-history__calendar","id":"toDatepicker","name":"toDatepicker"},on:{"opened":_vm.opened,"closed":_vm.closed},model:{value:(_vm.dateTo.date),callback:function ($$v) {_vm.$set(_vm.dateTo, "date", $$v)},expression:"dateTo.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--full-width button--primary",on:{"click":function($event){$event.preventDefault();return _vm.onExport($event)}}},[_vm._v("Export")]),_vm._v(" "),_c('form',{ref:"staticForm",attrs:{"action":_vm.formAction,"method":"post"}},[(_vm.contractId)?_c('input',{attrs:{"type":"hidden","name":"ContractIdForExport"},domProps:{"value":_vm.contractId}}):(_vm.marketId)?_c('input',{attrs:{"type":"hidden","name":"MarketIdForExport"},domProps:{"value":_vm.marketId}}):_vm._e(),_vm._v(" "),_c('input',{ref:"StartDate",attrs:{"type":"hidden","name":"StartDate","value":""}}),_vm._v(" "),_c('input',{ref:"EndDate",attrs:{"type":"hidden","name":"EndDate","value":""}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kQhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kdgD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "keem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance-history"},[(!_vm.isComponentReady)?_c('table-rows-loader',{attrs:{"num":_vm.loaderNum}}):_vm._e(),_vm._v(" "),(_vm.isComponentReady)?_c('div',{staticClass:"balance-history__head"},[_c('div',{staticClass:"row"},[_c('div',{class:_vm.typeColumnModifiers},[_vm._v("\n        Type\n      ")]),_vm._v(" "),_c('div',{class:_vm.amountColumnModifiers},[_vm._v("\n        Amount\n      ")]),_vm._v(" "),(_vm.showAdditionalColumns)?[_c('div',{staticClass:"column small-2"},[_c('div',{staticClass:"balance-history__fee"},[_c('div',[_vm._v("\n              Fee\n            ")]),_vm._v(" "),_c('div',{staticClass:"balance-history__fee-icon",on:{"click":_vm.onFeeInfoClick}})])]),_vm._v(" "),_c('div',{staticClass:"column small-2 text-center"},[_vm._v("\n          Net\n        ")])]:_vm._e(),_vm._v(" "),_c('div',{class:_vm.statusColumnModifiers},[_vm._v("\n        Status\n      ")])],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"balance-history__list"},[_vm._l((_vm.items),function(item){return _c('balance-history-item',{key:item.confirmationNumber + item.date,attrs:{"type":_vm.type,"item":item},on:{"itemCancelled":function($event){return _vm.$emit('itemCancelled')}}})}),_vm._v(" "),(_vm.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"balance-history__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e(),_vm._v(" "),(!_vm.canLoadMore)?_c('div',{staticClass:"balance-history__loaded-info"},[_vm._v("\n      "+_vm._s(_vm.loadedInfo)+"\n    ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "khSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_desktop_sushi_js__ = __webpack_require__("PCac");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbf9928_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_desktop_sushi_vue__ = __webpack_require__("vMHG");
function injectStyle (ssrContext) {
  __webpack_require__("m7mD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_desktop_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbf9928_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_desktop_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kiaR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kjig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-stats"},[(_vm.isLayoutDesktop)?_c('div',{staticClass:"market-contracts-stats__market-name"},[_vm._v(_vm._s(_vm.market.marketName))]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"market-contracts-stats__table"},[_c('thead',{staticClass:"market-contracts-stats__thead"},[(_vm.isSortable)?_c('th',{staticClass:"market-contracts-stats__table-name",on:{"click":function($event){return _vm.sortBy('displayOrder')}}},[_c('span',{class:_vm.headerSortByModifiers('displayOrder')},[_vm._v("\n          Contract\n        ")])]):_vm._e(),_vm._v(" "),_c('th',{class:_vm.secondColumnModifiers,on:{"click":function($event){return _vm.sortBy('totalSharesTraded')}}},[_c('span',{class:_vm.headerSortByModifiers('totalSharesTraded')},[_vm._v("\n          Total Volume\n        ")])]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('th',{class:_vm.thirdColumnModifiers,on:{"click":function($event){return _vm.sortBy('todaysVolume')}}},[_c('span',{class:_vm.headerSortByModifiers('todaysVolume')},[_vm._v("\n            Today's Volume\n          ")])]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"market-contracts-stats--last",on:{"click":function($event){return _vm.sortBy('openInterest')}}},[_c('span',{class:_vm.headerSortByModifiers('openInterest')},[_vm._v("\n            Active Shares\n          ")])]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.sortedItems),function(item,index){return _c('tr',{key:index},[(_vm.isSortable)?_c('td',{staticClass:"market-contracts-stats__table-name"},[_vm._v("\n          "+_vm._s(item.contractName)+"\n        ")]):_vm._e(),_vm._v(" "),_c('td',{class:_vm.secondColumnModifiers},[_vm._v("\n          "+_vm._s(item.totalSharesTraded.toLocaleString())+"\n        ")]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('td',{class:_vm.thirdColumnModifiers},[_vm._v("\n            "+_vm._s(item.todaysVolume.toLocaleString())+"\n          ")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"market-contracts-stats--last"},[_vm._v("\n            "+_vm._s(item.openInterest.toLocaleString())+"\n          ")]):_vm._e()]:_vm._e()],2)}),_vm._v(" "),(_vm.isSortable)?_c('tr',[_c('td',{staticClass:"market-contracts-stats__table-name market-contracts-stats__table-name--bold market-contracts-stats__table-summary"},[_vm._v("\n          Total\n        ")]),_vm._v(" "),_c('td',{staticClass:"market-contracts-stats__table-summary",class:_vm.secondColumnModifiers},[_vm._v("\n          "+_vm._s(_vm.totalSharesTradedSum)+"\n        ")]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('td',{staticClass:"market-contracts-stats__table-summary",class:_vm.thirdColumnModifiers},[_vm._v("\n            "+_vm._s(_vm.todaysVolumeSum)+"\n          ")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"market-contracts-stats__table-summary market-contracts-stats--last"},[_vm._v("\n            "+_vm._s(_vm.openInterestSum)+"\n          ")]):_vm._e()]:_vm._e()],2):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "klpy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "klsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountRegister: __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "koWp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("laM4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36590486_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("mtKO");
function injectStyle (ssrContext) {
  __webpack_require__("vBva")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36590486_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kqQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketCharts: __WEBPACK_IMPORTED_MODULE_2__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['market']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']))
});

/***/ }),

/***/ "kwj7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("oiih");


/* eslint-disable object-shorthand */






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["b" /* formMixin */]],
  validations: {
    fields: {
      address: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      city: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      zipCode: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateUSZipCode('country'),
      country: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required
    }
  },
  watch: {
    userData: function userData(value) {
      if (value) {
        this.assignFields(value);
      }
    },
    'fields.address': function fieldsAddress(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.city': function fieldsCity(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.zipCode': function fieldsZipCode(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.country': function fieldsCountry(newValue, oldValue) {
      if (oldValue && newValue.value !== oldValue.value) {
        this.dataUpdated = true;
      }
    }
  },
  data: function data() {
    return {
      dataUpdated: false,
      countries: [],
      fields: {
        country: '',
        address: '',
        city: '',
        zipCode: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData']), {
    isNotUnitedStates: function isNotUnitedStates() {
      return this.fields.country && this.fields.country.value && this.fields.country.value !== 'US';
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      return !this.dataUpdated || this.invalidOrDisabled;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotificationWithTimeoutCallback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['verifyID', 'getAccountDetail', 'getVerifyID']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          address1: this.fields.address,
          city: this.fields.city,
          postalCode: this.fields.zipCode,
          countryID: this.fields.country.value,
          formType: __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* FORM_TYPE_IDV */].CHANGE_ADDRESS
        };
        if (!this.isNotUnitedStates) {
          payload.nscbStatus = -1;
        }
        this.verifyID(payload).then(function (data) {
          if (_this.isNotUnitedStates) {
            window.location.href = data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('');
          }
          _this.dataUpdated = false;
          return _this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Account Address Updated.',
            callback: function callback() {
              return _this.$router.go(-1);
            }
          });
        }).then(this.formEnable).then(this.getAccountDetail).catch(function (e) {
          _this.formHandleErrors(e);
        });
      }
    },
    assignFields: function assignFields(value) {
      this.fields.address = value.address;
      this.fields.city = value.city;
      this.fields.zipCode = value.postalCode;

      if (value.countryCode) {
        this.fields.country = this.countries.find(function (i) {
          return i.value === value.countryCode;
        }) || '';
      }
    }
  }),
  created: function created() {
    var _this2 = this;

    this.getVerifyID().then(function (response) {
      var data = response.data;
      _this2.countries = data.countryList.map(function (el) {
        return {
          required: el.validatePostalCode,
          label: el.countryName,
          value: el.countryCode
        };
      });

      _this2.fields.country = _this2.countries.find(function (i) {
        return i.value === data.countryID;
      }) || '';
      if (_this2.userData) _this2.assignFields(_this2.userData);
    });
  }
});

/***/ }),

/***/ "kyMZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l+Fm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_leaderboard_info_js__ = __webpack_require__("lXxb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bdadadf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_leaderboard_info_vue__ = __webpack_require__("nnNw");
function injectStyle (ssrContext) {
  __webpack_require__("ZyPi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_leaderboard_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bdadadf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_leaderboard_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l8Or":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_code_input_js__ = __webpack_require__("KNAh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008705de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_code_input_vue__ = __webpack_require__("rpWg");
function injectStyle (ssrContext) {
  __webpack_require__("RZEf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_code_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008705de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_code_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l9wN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_combined_js__ = __webpack_require__("oaFs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19fa31a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_combined_vue__ = __webpack_require__("aAxP");
function injectStyle (ssrContext) {
  __webpack_require__("CTE/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_combined_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19fa31a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_combined_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lBfC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lFoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountLogin: __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "lLL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{staticClass:"account-update-password form content-header__section-group",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('p',{staticClass:"account-update-password__disclaimer"},[_vm._v("\n      You will need to enter your current password in order to create a new one.\n    ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.currentPassword,"name":"currentPassword","type":"password","validator":"password","required":true,"autocomplete":"off","placeholder":"Current Password"},on:{"input":_vm.$v.fields.currentPassword.$touch},model:{value:(_vm.fields.currentPassword),callback:function ($$v) {_vm.$set(_vm.fields, "currentPassword", $$v)},expression:"fields.currentPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPassword,"name":"newPassword","type":"password","validator":"password","required":true,"autocomplete":"off","placeholder":"New Password"},on:{"input":_vm.$v.fields.newPassword.$touch},model:{value:(_vm.fields.newPassword),callback:function ($$v) {_vm.$set(_vm.fields, "newPassword", $$v)},expression:"fields.newPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPasswordConfirmation,"name":"newPasswordConfirmation","type":"password","validator":"password","required":true,"autocomplete":"off","placeholder":"Confirm New Password"},on:{"input":_vm.$v.fields.newPasswordConfirmation.$touch},model:{value:(_vm.fields.newPasswordConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "newPasswordConfirmation", $$v)},expression:"fields.newPasswordConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('password-requirements',{attrs:{"validation":_vm.$v.fields.newPassword}})],1)]),_vm._v(" "),_c('div',{staticClass:"account-update-password__buttons"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Save New Password"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lMNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: {
      type: Object,
      required: true
    }
  }
});

/***/ }),

/***/ "lPAh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lXxb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_leaderboards_leaderboards_info_leaderboards_info_vue__ = __webpack_require__("HkCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profile_public_profile_widget_public_profile_widget_vue__ = __webpack_require__("dlHv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */]],
  components: {
    leaderboardsInfo: __WEBPACK_IMPORTED_MODULE_2__components_leaderboards_leaderboards_info_leaderboards_info_vue__["a" /* default */],
    publicProfileWidget: __WEBPACK_IMPORTED_MODULE_3__components_profile_public_profile_widget_public_profile_widget_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['userAffiliations', 'isUCAffilSet'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['getUserAffiliations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopup', 'setCurrentPopupOptions']), {
    showAffiliationsPopup: function showAffiliationsPopup() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
      this.setCurrentPopupOptions({ allowClose: true });
    },
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PUBLIC_PROFILE_INFO);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getUserAffiliations().then(function () {
      return _this.loaderRemove(document.body);
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "lZ3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    showExport: {
      type: Boolean,
      default: false
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  methods: {
    onExport: function onExport() {
      this.$emit('export', this.activeTab);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['transactionHistory', 'tradeHistory']), {
    isExportAvailable: function isExportAvailable() {
      var hasItems = this.activeTab === 'trades' ? true : this.transactionHistory && this.transactionHistory.data && this.transactionHistory.data.length > 0;

      return this.showExport && hasItems;
    }
  })
});

/***/ }),

/***/ "laM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCancel: function onCancel() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    }
  })
});

/***/ }),

/***/ "lb8p":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMS4zMyAxNC4zNzZhLjg5Ljg5IDAgMCAwIDEuMzQxIDBsMy4yNDEtNC4zNWEuNDQ1LjQ0NSAwIDAgMC0uMzU3LS43MDloLTcuMTFhLjQ0NC40NDQgMCAwIDAtLjM1Ni43MWwzLjI0IDQuMzQ5eiIgZmlsbD0iIzBDMEMwQyIvPgo8L3N2Zz4K"

/***/ }),

/***/ "ldoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sections.length > 0)?_c('div',{staticClass:"sushi-market-links-widget"},[_c('div',{staticClass:"sushi-market-links-widget__title"},[_c('div',{staticClass:"sushi-market-links-widget__title-text"},[_vm._v("Market Lists")]),_vm._v(" "),_c('sushi-market-links-toggle')],1),_vm._v(" "),_c('div',{staticClass:"sushi-market-links-widget__sections"},_vm._l((_vm.sections),function(section){return _c('div',{key:section.name},[_c('div',{class:_vm.sectionClassModifiers(section),on:{"click":function($event){return _vm.toggleOpenPinSection(section.name)}}},[_c('div',{staticClass:"sushi-market-links-widget__section-title"},[_vm._v("\n            "+_vm._s(section.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-links-widget__section-icon"})]),_vm._v(" "),(_vm.isSectionOpen(section) && section.name === _vm.SECTIONS.PRODUCT_HISTORY)?_c('div',{staticClass:"sushi-market-links-widget__section-content"}):_vm._e(),_vm._v(" "),(_vm.isSectionOpen(section) && section.name === _vm.SECTIONS.SESSION_HISTORY)?_c('div',{staticClass:"sushi-market-links-widget__section-content"},[_c('session-history-sushi',{attrs:{"type":"widget"}})],1):_vm._e(),_vm._v(" "),(_vm.isSectionOpen(section) && section.name === _vm.SECTIONS.WATCHLIST)?_c('div',{staticClass:"sushi-market-links-widget__section-content"},[_c('watchlist-sushi',{attrs:{"type":"widget"}})],1):_vm._e()])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lkXP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_watch_js__ = __webpack_require__("32Fy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5727127f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_watch_vue__ = __webpack_require__("bXjM");
function injectStyle (ssrContext) {
  __webpack_require__("/gSw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_watch_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5727127f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_watch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lmGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_js__ = __webpack_require__("y8UT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b632c34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__("Ivan");
function injectStyle (ssrContext) {
  __webpack_require__("CP5y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b632c34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lp3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"currency-input"},[_c('input',{ref:"input",domProps:{"value":_vm.valueWithCent},on:{"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.onBlur,"focus":_vm.onFocus,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onBlur($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lq1j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"notifications-widget"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"notifications-widget__content"},[_c('notifications-list',{attrs:{"limit":5,"theme":"widget"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-widget__title"},[_c('div',{staticClass:"notifications-widget__title-text"},[_vm._v("\n      Notifications\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Number,
      default: 50
    },
    userQuantity: {},
    operationType: {
      type: String,
      default: 'buy'
    },
    tabindex: Number,
    minimumOwnership: {
      type: Number,
      default: 1
    },
    minValue: {
      type: Number,
      default: 1
    },
    maxValue: {
      type: Number,
      default: 9999
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      updated: false,
      val: this.value !== null ? parseInt(this.value, 10) : null,
      options: [-10, -1, 1, 10]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile'])),
  watch: {
    val: 'updateOffer',
    value: function value(_value) {
      this.val = _value !== null ? parseInt(_value, 10) : null;
    }
  },
  methods: {
    onSelectOption: function onSelectOption(option) {
      this.add(option);
    },
    add: function add(value) {
      if (isNaN(this.val) || this.val === null) {
        this.val = 0;
      }
      var newValue = this.val + value;
      if (this.userQuantity && this.operationType === 'sell' && this.val <= this.userQuantity && newValue > this.userQuantity) {
        newValue = this.userQuantity;
      }
      this.val = Math.max(Math.min(newValue, this.maxValue), this.minValue);
    },
    updateOffer: function updateOffer() {
      this.updated = true;
      this.val = parseInt(this.val, 10);
      if (isNaN(this.val) || this.val < 1) this.val = null;

      if (this.val !== null) {
        this.$emit('input', Number(this.val));
      } else {
        this.$emit('input', this.val);
      }
    },
    onFocus: function onFocus() {
      var _this = this;

      if (this.isLayoutMobile) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["F" /* lockScroll */])();
      }
      this.$emit('focus');
      var focusAndSelect = function focusAndSelect() {
        var el = _this.$refs && _this.$refs.input;
        if (el && typeof el.select === 'function') {
          el.focus();
          el.select();
          el.setSelectionRange(0, 9999);
        }
      };
      this.$nextTick(focusAndSelect);
      setTimeout(focusAndSelect, 50);
    },
    onBlur: function onBlur() {
      this.$emit('blur', this.val);
      if (this.isLayoutMobile) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["E" /* unlockScroll */])();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isLayoutMobile) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["E" /* unlockScroll */])();
    }
  }
});

/***/ }),

/***/ "lyr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_security_settings_js__ = __webpack_require__("Ellf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229560a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_security_settings_vue__ = __webpack_require__("KfPg");
function injectStyle (ssrContext) {
  __webpack_require__("bWBf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_security_settings_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229560a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_security_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lzus":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_sushi_js__ = __webpack_require__("QaeY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6902a5e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_sushi_vue__ = __webpack_require__("fVgO");
function injectStyle (ssrContext) {
  __webpack_require__("y9s0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6902a5e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m/0L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videos"},[_c('div',{staticClass:"row"},[(!_vm.asWidget)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"videos__static-page-header"},[_c('static-page-header',{attrs:{"back":{ name: 'HelpAndSupport' }}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Help and Support")])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-12"},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"videos__header"},[_vm._v("Videos")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"videos__content"},_vm._l((_vm.videos),function(item){return _c('div',{attrs:{"id":item.id}},[_c('collapsible-panel',{key:item.title,attrs:{"isOpen":_vm.expanded,"title":item.title,"accordion":_vm.accordion,"id":item.id},on:{"open":_vm.accordionOpen}},[_c('youtube',{staticClass:"videos__player",attrs:{"player-width":"100%","player-height":220,"video-id":_vm.getYoutubeIdFromUrl(item.video)}})],1)],1)}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m1D1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_keyboard_numeric_sushi_js__ = __webpack_require__("1MKN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe213e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_numeric_sushi_vue__ = __webpack_require__("GeN7");
function injectStyle (ssrContext) {
  __webpack_require__("no4l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_keyboard_numeric_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe213e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_numeric_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m7Pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-two-factor-verify"},[_c('div',{staticClass:"two-factor-verify__header"},[(!_vm.selectedMethod)?_c('p',{staticClass:"two-factor-verify__subtitle"},[_vm._v("\n      Choose how you want to verify your login.\n    ")]):_vm._e(),_vm._v(" "),(_vm.secondsUntilExpiry > 0)?_c('p',{staticClass:"two-factor-verify__expiry"},[_vm._v("\n      Session expires in: "),_c('strong',[_vm._v(_vm._s(_vm.formattedExpiryTime))])]):_vm._e()]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"two-factor-verify__error"},[_c('span',{staticClass:"two-factor-verify__error-icon"},[_vm._v("⚠")]),_vm._v(" "),_c('span',{staticClass:"two-factor-verify__error-text"},[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),(!_vm.selectedMethod)?_c('div',{staticClass:"two-factor-verify__methods"},[(_vm.hasEmail)?_c('button',{staticClass:"two-factor-verify__method-btn",on:{"click":function($event){return _vm.selectMethod('email')}}},[_c('span',{staticClass:"two-factor-verify__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"}}),_vm._v(" "),_c('polyline',{attrs:{"points":"22,6 12,13 2,6"}})])]),_vm._v(" "),_c('span',{staticClass:"two-factor-verify__method-text"},[_vm._v("\n        Email\n        "),_c('small',[_vm._v(_vm._s(_vm.twoFactorEmailHint))])]),_vm._v(" "),_c('span',{staticClass:"two-factor-verify__method-chevron"},[_vm._v("›")])]):_vm._e(),_vm._v(" "),(_vm.hasPhone)?_c('button',{staticClass:"two-factor-verify__method-btn",on:{"click":function($event){return _vm.selectMethod('phone')}}},[_c('span',{staticClass:"two-factor-verify__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"5","y":"2","width":"14","height":"20","rx":"2","ry":"2"}}),_vm._v(" "),_c('line',{attrs:{"x1":"12","y1":"18","x2":"12.01","y2":"18"}})])]),_vm._v(" "),_c('span',{staticClass:"two-factor-verify__method-text"},[_vm._v("\n        Phone (SMS)\n        "),_c('small',[_vm._v(_vm._s(_vm.twoFactorPhoneHint))])]),_vm._v(" "),_c('span',{staticClass:"two-factor-verify__method-chevron"},[_vm._v("›")])]):_vm._e(),_vm._v(" "),(_vm.hasAuthenticator)?_c('button',{staticClass:"two-factor-verify__method-btn",on:{"click":function($event){return _vm.selectMethod('authenticator')}}},[_c('span',{staticClass:"two-factor-verify__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 12l2 2 4-4"}})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticClass:"two-factor-verify__method-chevron"},[_vm._v("›")])]):_vm._e()]):_c('div',{staticClass:"two-factor-verify__code-entry"},[_c('div',{staticClass:"two-factor-verify__selected-method"},[_c('p',{staticClass:"two-factor-verify__method-info",class:{ 'is-sending': _vm.isSendingCode }},[_vm._v("\n        "+_vm._s(_vm.getMethodLabelDescriptive(_vm.selectedMethod))+"\n      ")]),_vm._v(" "),(_vm.twoFactorMethods.length > 1)?_c('button',{staticClass:"two-factor-verify__change-method-btn",on:{"click":function($event){_vm.selectedMethod = null}}},[_vm._v("\n        Change method\n      ")]):_vm._e()]),_vm._v(" "),(_vm.codeSent || _vm.isSendingCode)?_c('div',{staticClass:"two-factor-verify__input-group"},[_c('label',{staticClass:"two-factor-verify__label"},[_vm._v("\n        "+_vm._s(_vm.getCodeInputLabel())+"\n      ")]),_vm._v(" "),_c('code-input',{ref:"codeInput",attrs:{"error":_vm.hasCodeError,"disabled":_vm.isVerifying || _vm.isSendingCode,"loading":_vm.isVerifying || _vm.isSendingCode},on:{"complete":_vm.onCodeComplete,"submit":_vm.verifyCode},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_vm._v(" "),(_vm.methodRequiresSendCode)?_c('div',{staticClass:"two-factor-verify__resend"},[_c('button',{staticClass:"two-factor-verify__resend-btn",attrs:{"disabled":!_vm.canSendCode},on:{"click":_vm.sendCode}},[(_vm.isSendingCode)?[_c('span',{staticClass:"two-factor-verify__resend-icon"},[_vm._v("⧗")]),_vm._v("\n            Waiting...\n          ")]:(_vm.secondsUntilResend > 0)?[_c('span',{staticClass:"two-factor-verify__resend-icon"},[_vm._v("⏱")]),_vm._v("\n            Resend in "+_vm._s(_vm.secondsUntilResend)+"s\n          ")]:[_vm._v(" Resend code ")]],2)]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"two-factor-verify__footer"},[_c('button',{staticClass:"two-factor-verify__cancel-btn",on:{"click":_vm.onCancel}},[_vm._v("\n      Cancel\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"two-factor-verify__method-text"},[_vm._v("\n        Authenticator App\n        "),_c('small',[_vm._v("Use your authenticator app")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m7mD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mBiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    lastClosePrice: {},
    price: {
      type: Number,
      default: 0
    },
    fixed: {
      type: Boolean,
      default: false
    },
    percent: {
      type: Boolean,
      default: false
    },
    plainStyle: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: '&cent;'
    }
  },
  computed: {
    isPriceEqual: function isPriceEqual() {
      // lastClosePrice === null must be checked so
      // new contracts does show price gain on day 1
      // null must be checked in case parameter is not passed (undefined)
      return this.price === 0 || this.lastClosePrice === null;
    },
    priceDisplay: function priceDisplay() {
      return this.fixed ? Math.abs(this.price).toFixed(2) : '' + Math.abs(this.price);
    },
    changeValue: function changeValue() {
      var symbol = this.percent ? '%' : this.symbol;
      if (this.fixed) {
        return !this.isPriceEqual ? '$' + this.priceDisplay : 'N/C';
      }
      return !this.isPriceEqual ? '' + this.priceDisplay + symbol : 'N/C';
    },
    objClass: function objClass() {
      var _ref;

      return _ref = {
        'market-change-price': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--plain', this.plainStyle), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--up', !this.isPriceEqual && this.price > 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--down', !this.isPriceEqual && this.price < 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--equal', this.isPriceEqual), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--wide', this.theme === 'page-market' && this.priceDisplay.length === 1), _ref;
    }
  }
});

/***/ }),

/***/ "mDCk":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "mHXl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_what_is_new_popup_footer_vue__ = __webpack_require__("PzFO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dd4063e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_new_popup_footer_vue__ = __webpack_require__("tGjv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_what_is_new_popup_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dd4063e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_new_popup_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mI5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-quotes"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(quote){return _c('swiper-slide',{key:quote.id,staticClass:"main-quotes__slide"},[_c('div',{staticClass:"main-quotes__image"}),_vm._v(" "),_c('div',{staticClass:"main-quotes__content"},[_c('p',{staticClass:"main-quotes__item--text"},[_vm._v(_vm._s(quote.text))]),_vm._v(" "),_c('p',{staticClass:"main-quotes__item--author"},[_vm._v(_vm._s(quote.author))])])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mQlD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Community Forums'
    }
  },
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */]
  },
  data: function data() {
    return {
      url: ''
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Learn'
    };
  },
  created: function created() {
    this.loadForum();
  },

  watch: {
    isLoggedIn: function isLoggedIn() {
      this.loadForum();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('support', ['getForumUrl']), {
    loadForum: function loadForum() {
      var _this = this;

      this.getForumUrl().then(function (data) {
        _this.url = data;
      });
    },
    onClose: function onClose() {
      this.$router.push({
        name: 'HelpAndSupport'
      });
    }
  })
});

/***/ }),

/***/ "mRGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_tile_view_js__ = __webpack_require__("7trC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc68f0c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_tile_view_vue__ = __webpack_require__("F+2w");
function injectStyle (ssrContext) {
  __webpack_require__("ibDk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_tile_view_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc68f0c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_tile_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mThu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    obj: Object,
    category: String
  },
  components: {
    switchButton: __WEBPACK_IMPORTED_MODULE_2__components_generics_switch_button_switch_button_vue__["a" /* default */]
  },
  data: function data() {
    return {
      checked: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    classObject: function classObject() {
      return {
        'settings-option': true,
        'settings-option--disabled': this.disabled
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['updateSettings']), {
    toggle: function toggle(e) {
      var _this = this;

      this.loaderAddLegacy();
      this.checked = e;
      this.updateSettings({
        category: this.category,
        key: this.obj.key,
        value: e
      }).then(function () {
        return _this.loaderRemoveLegacy();
      }).catch(function () {
        _this.loaderRemoveLegacy();
        _this.checked = !e;
        _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
      });
      this.$emit('toggle', e);
    }
  }),
  created: function created() {
    var k = this.settings[this.category][this.obj.key];
    this.checked = k !== undefined ? k : false;
  }
});

/***/ }),

/***/ "mTzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-bar"}},[(_vm.show)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"search-bar__inner"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('label',{staticClass:"search-bar__control",attrs:{"for":"search-query"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"searchInput",class:_vm.inputClassModifiers,attrs:{"id":"search-query","type":"text","placeholder":"Search Markets"},domProps:{"value":(_vm.searchQuery)},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur,"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-bar__submit",attrs:{"type":"submit"}})])]),_vm._v(" "),_c('div',{staticClass:"search-bar__close",on:{"click":_vm.onClose}},[_c('div',{staticClass:"search-bar__close-icon"}),_vm._v(" "),_c('div',{staticClass:"search-bar__close-text"},[_vm._v("Close")])])]),_vm._v(" "),(false)?_c('div',{class:_vm.summaryClassModifiers},[(_vm.searchTotal > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 text-left"},[_c('strong',[_vm._v("Search Results")]),_vm._v(": "+_vm._s(_vm.searchFor)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[_vm._v("\n          "+_vm._s(_vm.searchTotal)+" Market"),(_vm.searchTotal !== 1)?_c('span',[_vm._v("s")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.searchTotal === 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-8 text-left"},[_c('strong',[_vm._v("No Search Results")]),_vm._v(": "+_vm._s(_vm.searchFor)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column small-4 text-right"},[_vm._v("\n          0 Markets\n        ")])]):_vm._e()]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mXH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLayoutMobile)?_c('router-link',{staticClass:"insight-link__link",attrs:{"to":_vm.href}},[_c('div',{staticClass:"insight-link__content"},[_vm._v("\n      "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"insight-link__date"},[_vm._v(_vm._s(_vm.date))])])]):_c('a',{staticClass:"insight-link__link",attrs:{"href":_vm.url,"target":"_blank"}},[_c('div',{staticClass:"insight-link__content"},[_vm._v("\n      "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"insight-link__date"},[_vm._v(_vm._s(_vm.date))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mXqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true,
      default: 0
    }
  }
});

/***/ }),

/***/ "maUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mbJS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "mcLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_withdraw_confirm_withdraw_confirm_vue__ = __webpack_require__("waMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_available_balance_available_balance_vue__ = __webpack_require__("3PvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__("c/9r");












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* formMixin */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__["a" /* default */],
    availableBalance: __WEBPACK_IMPORTED_MODULE_5__components_wallet_available_balance_available_balance_vue__["a" /* default */],
    withdrawConfirm: __WEBPACK_IMPORTED_MODULE_3__components_wallet_withdraw_confirm_withdraw_confirm_vue__["a" /* default */]
  },
  validations: function validations() {
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].withdrawalAmount(this.minWithdrawal, this.maxWithdrawal)
      }
    };
  },
  created: function created() {
    this.checkWithdrawCheck();
  },
  data: function data() {
    return {
      countries: [],
      error: '',
      showConfirmation: false,
      fields: {
        street: '',
        city: '',
        zipCode: '',
        amount: '',
        country: ''
      }
    };
  },

  watch: {
    check: function check(value) {
      this.fields.country = value.countryCode;
      this.fields.street = value.address1;
      this.fields.city = value.city;
      this.fields.zipCode = value.postalCode;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['check']), {
    availableBalance: function availableBalance() {
      return this.check && this.check.availableFundsString ? this.check.availableFundsString : '$0.00';
    },
    restrictedFunds: function restrictedFunds() {
      return this.check && this.check.restrictedFundsString ? this.check.restrictedFundsString : '';
    },
    minWithdrawal: function minWithdrawal() {
      return this.maxWithdrawal > 0 ? 1 : 0;
    },
    maxWithdrawal: function maxWithdrawal() {
      return this.check ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["G" /* roundDown */])(this.check.availableFunds) : 0;
    },
    isWithdrawalDisabled: function isWithdrawalDisabled() {
      return Number(this.fields.amount || 0) === 0;
    },
    isAmountFieldDisabled: function isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    errorMessage: function errorMessage() {
      return this.error || this.check.errorMessage;
    },
    hasErrorMessage: function hasErrorMessage() {
      return this.error || !!this.check.errorMessage;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getVerifyID']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getWithdrawCheck']), {
    onSubmit: function onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess: function onSuccess() {
      this.fields.amount = '';
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawCheck();
      this.$emit('success');
    },
    onEdit: function onEdit() {
      this.showConfirmation = false;
    },
    checkWithdrawCheck: function checkWithdrawCheck() {
      var _this = this;

      this.getWithdrawCheck().then(function (data) {
        _this.checkDocumentUploadFlags(data);
        _this.isComponentReady = true;
      }).catch(function (error) {
        _this.isComponentReady = true;
        _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '');
      });
    }
  })
});

/***/ }),

/***/ "mgKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_trophy_pyramid_js__ = __webpack_require__("7Ez+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20718362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_trophy_pyramid_vue__ = __webpack_require__("2evg");
function injectStyle (ssrContext) {
  __webpack_require__("MvkI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_trophy_pyramid_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20718362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_trophy_pyramid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mjGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_close_button_js__ = __webpack_require__("0OLA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d77be4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_button_vue__ = __webpack_require__("6X+t");
function injectStyle (ssrContext) {
  __webpack_require__("uEEg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_close_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d77be4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mka8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_home_old_hero_unit_slider_hero_unit_slider_vue__ = __webpack_require__("RQ5D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_home_old_quotes_quotes_vue__ = __webpack_require__("PElc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_home_old_how_it_works_how_it_works_vue__ = __webpack_require__("Z05w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_home_old_most_predicted_most_predicted_vue__ = __webpack_require__("UqqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_home_old_most_predicted_list_most_predicted_list_vue__ = __webpack_require__("4p0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_home_old_podcasts_podcasts_vue__ = __webpack_require__("QrTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_research_widget_research_widget_vue__ = __webpack_require__("/yTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_home_home_old_in_the_news_in_the_news_vue__ = __webpack_require__("y1jZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_home_home_old_news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_insight_insight_widget_insight_widget_vue__ = __webpack_require__("w0Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_market_biggest_gains_market_biggest_gains_vue__ = __webpack_require__("XqpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_money_widget_market_money_widget_vue__ = __webpack_require__("JVxM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_market_market_currently_predicting_market_currently_predicting_vue__ = __webpack_require__("Dksu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_market_market_key_stats_market_key_stats_vue__ = __webpack_require__("aHny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_market_market_top_comments_market_top_comments_vue__ = __webpack_require__("KvDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_disqus__ = __webpack_require__("oeb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_home_home_old_home_videos__ = __webpack_require__("CPvM");
























var REFRSEH_ENABLED = true;
var REFRESH_INTERVAL = 10 * 60 * 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_19__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__mixins_disqus__["a" /* default */]],
  components: {
    heroUnitSlider: __WEBPACK_IMPORTED_MODULE_3__components_home_home_old_hero_unit_slider_hero_unit_slider_vue__["a" /* default */],
    quotes: __WEBPACK_IMPORTED_MODULE_4__components_home_home_old_quotes_quotes_vue__["a" /* default */],
    howItWorks: __WEBPACK_IMPORTED_MODULE_5__components_home_home_old_how_it_works_how_it_works_vue__["a" /* default */],
    mostPredicted: __WEBPACK_IMPORTED_MODULE_6__components_home_home_old_most_predicted_most_predicted_vue__["a" /* default */],
    podcasts: __WEBPACK_IMPORTED_MODULE_8__components_home_home_old_podcasts_podcasts_vue__["a" /* default */],
    researchWidget: __WEBPACK_IMPORTED_MODULE_9__components_research_widget_research_widget_vue__["a" /* default */],
    inTheNews: __WEBPACK_IMPORTED_MODULE_10__components_home_home_old_in_the_news_in_the_news_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_11__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    newsFeed: __WEBPACK_IMPORTED_MODULE_12__components_home_home_old_news_feed_news_feed_vue__["a" /* default */],
    mostPredictedList: __WEBPACK_IMPORTED_MODULE_7__components_home_home_old_most_predicted_list_most_predicted_list_vue__["a" /* default */],
    insightWidget: __WEBPACK_IMPORTED_MODULE_13__components_insight_insight_widget_insight_widget_vue__["a" /* default */],
    marketBiggestGains: __WEBPACK_IMPORTED_MODULE_14__components_market_market_biggest_gains_market_biggest_gains_vue__["a" /* default */],
    marketMoneyWidget: __WEBPACK_IMPORTED_MODULE_15__components_market_market_money_widget_market_money_widget_vue__["a" /* default */],
    marketCurrentlyPredicting: __WEBPACK_IMPORTED_MODULE_16__components_market_market_currently_predicting_market_currently_predicting_vue__["a" /* default */],
    marketKeyStats: __WEBPACK_IMPORTED_MODULE_17__components_market_market_key_stats_market_key_stats_vue__["a" /* default */],
    marketTopComments: __WEBPACK_IMPORTED_MODULE_18__components_market_market_top_comments_market_top_comments_vue__["a" /* default */],
    homeVideos: __WEBPACK_IMPORTED_MODULE_21__components_home_home_old_home_videos__["a" /* default */]
  },
  data: function data() {
    return {
      interval: null
    };
  },
  metaInfo: function metaInfo() {
    var title = this.$route.name === 'trends' ? 'Trends' : 'PredictIt';
    return {
      title: title
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isUserRestricted', 'isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('browse', ['widgets']), {
    shouldShowKeyStatsWidgets: function shouldShowKeyStatsWidgets() {
      return (__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.widgets, 'key.widgetKeyStats', []) || []).length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getWidgets']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    fetchWidgetsData: function fetchWidgetsData() {
      var _this = this;

      this.getWidgets().then(function () {
        _this.isComponentReady = true;
      });
      if (REFRSEH_ENABLED) {
        if (this.interval) clearInterval(this.interval);
        this.interval = setInterval(function () {
          _this.getWidgets();
        }, REFRESH_INTERVAL);
      }
    }
  }),
  mounted: function mounted() {
    this.setupDisqus();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  created: function created() {
    this.fetchWidgetsData();
  }
});

/***/ }),

/***/ "mmUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.tableModifiers},[(_vm.usesStructuredRows)?[(_vm.showHeader)?_c('div',{staticClass:"order-book-sushi__header order-book-sushi__header--striped "},[_c('div',{staticClass:"order-book-sushi__side",class:{'order-book-sushi__side--active': _vm.sideActive === 'left', 'order-book-sushi__side--inactive': _vm.sideActive !== 'left'}},[_c('div',{class:_vm.leftSideHeaderModifiers},[_vm._v(_vm._s(_vm.operationTypeLeftText)+" "+_vm._s(_vm.operationValueText.toUpperCase())+" "),_c('span',{staticClass:"order-book-sushi__header-matches"},[_vm._v("Matches")])])]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__side",class:{'order-book-sushi__side--active': _vm.sideActive === 'right', 'order-book-sushi__side--inactive': _vm.sideActive !== 'right'}},[_c('div',{class:_vm.rightSideHeaderModifiers},[_vm._v(_vm._s(_vm.operationTypeRightText)+" "+_vm._s(_vm.operationValueRightText.toUpperCase())+" "),_c('span',{staticClass:"order-book-sushi__header-matches"},[_vm._v("Matches")])])])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.bodyModifiers},[_vm._l((_vm.displayRows),function(item,index){return _c('div',{key:("order-book-prices-" + index),staticClass:"order-book-sushi__row order-book-sushi__row--striped"},[_c('div',{class:_vm.sideClassModifiers('left')},[(!_vm.leftPricesUnavailable || item.buyPrice)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--highlight order-book-sushi__body-cell--price",class:_vm.hoverPriceClassModifier(item.buyOwned, index, 'left'),on:{"mouseover":function($event){return _vm.onMouseOver(index, 'left')},"mouseleave":function($event){return _vm.onMouseLeave('left')},"click":function($event){return _vm.onClick(item, item.buyOwned, 'left')}}},[_vm._v(_vm._s(item.buyPrice)),(item.buyPrice)?_c('span',[_vm._v("¢")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell",class:_vm.hoverQuantityClassModifier(item.buyOwned, index, 'left'),attrs:{"data-tooltip":_vm.ownedTooltipText(item.buyOwned)},on:{"mouseover":function($event){return _vm.onMouseOver(index, 'left')},"mouseleave":function($event){return _vm.onMouseLeave('left')},"click":function($event){return _vm.onClick(item, item.buyOwned, 'left')}}},[(item.buyQuantity)?[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(item.buyQuantity),expression:"item.buyQuantity"}]}),(_vm.showOwnedIndicators && item.buyOwned)?_c('span',{staticClass:"order-book-prices-sushi__owned-asterisk"},[_vm._v("*")]):_vm._e()]:[_vm._v(" ")]],2)]:(_vm.shouldShowEmptyState(item, 'left', index))?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable order-book-sushi__body-cell--full"},[_vm._v("\n                (No Orders)\n              ")])]:[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-sushi__body-cell--price"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder"},[_vm._v(" ")])]],2),_vm._v(" "),_c('div',{class:_vm.sideClassModifiers('right')},[(!_vm.rightPricesUnavailable || item.sellPrice)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--highlight order-book-sushi__body-cell--price",class:_vm.hoverPriceClassModifier(item.sellOwned, index, 'right'),on:{"mouseover":function($event){return _vm.onMouseOver(index, 'right')},"mouseleave":function($event){return _vm.onMouseLeave('right')},"click":function($event){return _vm.onClick(item, item.sellOwned, 'right')}}},[_vm._v(_vm._s(item.sellPrice)),(item.sellPrice)?_c('span',[_vm._v("¢")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell",class:_vm.hoverQuantityClassModifier(item.sellOwned, index, 'right'),attrs:{"data-tooltip":_vm.ownedTooltipText(item.sellOwned)},on:{"mouseover":function($event){return _vm.onMouseOver(index, 'right')},"mouseleave":function($event){return _vm.onMouseLeave('right')},"click":function($event){return _vm.onClick(item, item.sellOwned, 'right')}}},[(item.sellQuantity)?[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(item.sellQuantity),expression:"item.sellQuantity"}]}),(_vm.showOwnedIndicators && item.sellOwned)?_c('span',{staticClass:"order-book-prices-sushi__owned-asterisk"},[_vm._v("*")]):_vm._e()]:[_vm._v(" ")]],2)]:(_vm.shouldShowEmptyState(item, 'right', index))?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable order-book-sushi__body-cell--full"},[_vm._v("\n                (No Orders)\n              ")])]:[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-sushi__body-cell--price"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder"},[_vm._v(" ")])]],2)])}),_vm._v(" "),(_vm.showOwnedTrayNotice)?_c('div',{staticClass:"order-book-prices-sushi__owned-notice"},[_vm._v("\n          Tap price links for order priority\n        ")]):_vm._e()],2)]:[(_vm.showHeader)?_c('div',{staticClass:"order-book-sushi__header order-book-sushi__header--striped "},[_c('div',{class:_vm.leftSideHeaderModifiers},[_vm._v(_vm._s(_vm.operationTypeLeftText)+" "+_vm._s(_vm.operationValueText.toUpperCase())+" "),_c('span',{staticClass:"order-book-sushi__header-matches"},[_vm._v("Matches")])]),_vm._v(" "),_c('div',{class:_vm.rightSideHeaderModifiers},[_vm._v(_vm._s(_vm.operationTypeRightText)+" "+_vm._s(_vm.operationValueRightText.toUpperCase())+" "),_c('span',{staticClass:"order-book-sushi__header-matches"},[_vm._v("Matches")])])]):_vm._e(),_vm._v(" "),(!_vm.showInlineUnavailableSides && (_vm.leftPricesUnavailable || _vm.rightPricesUnavailable))?_c('div',{staticClass:"order-book-sushi__row"},[(_vm.leftPricesUnavailable)?[(_vm.pricesGrouped.length === 0)?_c('div',{staticClass:"order-book-sushi__header-cell order-book-sushi__header-cell--unavailable"}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.leftSideNoOffersModifiers},[_vm._v("(No Orders)")])]:_vm._e(),_vm._v(" "),(_vm.rightPricesUnavailable)?[(_vm.pricesGrouped.length === 0)?_c('div',{staticClass:"order-book-sushi__header-cell order-book-sushi__header-cell--unavailable"}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.rightSideNoOffersModifiers},[_vm._v("(No Orders)")])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body"},_vm._l((_vm.defaultDisplayRows),function(item,index){return _c('div',{key:("order-book-prices-default-" + index),staticClass:"order-book-sushi__row order-book-sushi__row--striped"},[_c('div',{staticClass:"order-book-sushi__side"},[(!_vm.leftPricesUnavailable)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--highlight order-book-sushi__body-cell--price",class:_vm.hoverPriceClassModifier(item.buyOwned, index, 'left'),on:{"mouseover":function($event){return _vm.onMouseOver(index, 'left')},"mouseleave":function($event){return _vm.onMouseLeave('left')},"click":function($event){return _vm.onClick(item, item.buyOwned, 'left')}}},[_vm._v(_vm._s(item.buyPrice)),(item.buyPrice)?_c('span',[_vm._v("¢")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell",class:_vm.hoverQuantityClassModifier(item.buyOwned, index, 'left'),attrs:{"data-tooltip":_vm.ownedTooltipText(item.buyOwned)},on:{"mouseover":function($event){return _vm.onMouseOver(index, 'left')},"mouseleave":function($event){return _vm.onMouseLeave('left')},"click":function($event){return _vm.onClick(item, item.buyOwned, 'left')}}},[(item.buyQuantity)?[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(item.buyQuantity),expression:"item.buyQuantity"}]}),(_vm.showOwnedIndicators && item.buyOwned)?_c('span',{staticClass:"order-book-prices-sushi__owned-asterisk"},[_vm._v("*")]):_vm._e()]:[_vm._v(" ")]],2)]:(_vm.shouldShowDefaultUnavailableState('left', index))?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable order-book-sushi__body-cell--full"},[_vm._v("\n                (No Orders)\n              ")])]:[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-sushi__body-cell--price"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder"},[_vm._v(" ")])]],2),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__side"},[(!_vm.rightPricesUnavailable)?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--highlight order-book-sushi__body-cell--price",class:_vm.hoverPriceClassModifier(item.sellOwned, index, 'right'),on:{"mouseover":function($event){return _vm.onMouseOver(index, 'right')},"mouseleave":function($event){return _vm.onMouseLeave('right')},"click":function($event){return _vm.onClick(item, item.sellOwned, 'right')}}},[_vm._v(_vm._s(item.sellPrice)),(item.sellPrice)?_c('span',[_vm._v("¢")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell",class:_vm.hoverQuantityClassModifier(item.sellOwned, index, 'right'),attrs:{"data-tooltip":_vm.ownedTooltipText(item.sellOwned)},on:{"mouseover":function($event){return _vm.onMouseOver(index, 'right')},"mouseleave":function($event){return _vm.onMouseLeave('right')},"click":function($event){return _vm.onClick(item, item.sellOwned, 'right')}}},[(item.sellQuantity)?[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(item.sellQuantity),expression:"item.sellQuantity"}]}),(_vm.showOwnedIndicators && item.sellOwned)?_c('span',{staticClass:"order-book-prices-sushi__owned-asterisk"},[_vm._v("*")]):_vm._e()]:[_vm._v(" ")]],2)]:(_vm.shouldShowDefaultUnavailableState('right', index))?[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--unavailable order-book-sushi__body-cell--full"},[_vm._v("\n                (No Orders)\n              ")])]:[_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder order-book-sushi__body-cell--price"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"order-book-sushi__body-cell order-book-sushi__body-cell--placeholder"},[_vm._v(" ")])]],2)])}),0)]],2),_vm._v(" "),(_vm.showAllItemsNotice || _vm.showPriceLinksNotice)?_c('div',{staticClass:"order-book-sushi__footer"},[(_vm.showPriceLinksNotice)?_c('div',{staticClass:"order-book-sushi__footer-cell order-book-sushi__footer-cell--price-links"},[_vm._v("\n      Tap price links for order priority\n    ")]):_vm._e(),_vm._v(" "),(_vm.showAllItemsNotice)?_c('div',{staticClass:"order-book-sushi__footer-cell order-book-sushi__footer-cell--show-all-prices",on:{"click":_vm.toggleShowAll}},[(!_vm.showAll)?[_vm._v("Show All")]:[_vm._v("Show Less")]],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isCardEmpty || _vm.isScrollableEmpty)?_c('div',{staticClass:"order-book-prices-sushi__empty-card-message"},[_vm._v("\n    "+_vm._s(_vm.emptyOverlayText)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mnsD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learn-the-basics"},[_c('div',{class:_vm.mainRowModifiers},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"learn-the-basics__static-page-header"},[_c('static-page-header',{attrs:{"back":{ name: 'HelpAndSupport' }}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n              Help and Support\n            ")])])],1)]),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{class:_vm.mainColumnModifiers},[_c('div',{staticClass:"what-is-predictit__content"},[_c('static-page-loader')],1)]):_c('div',{class:_vm.mainColumnModifiers},[_vm._l((_vm.topics),function(item){return [_c('div',{staticClass:"learn-the-basics__header"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),(item.text)?_c('div',{staticClass:"learn-the-basics__desc"},[_vm._v(_vm._s(item.text))]):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"what-is-predictit__content",domProps:{"innerHTML":_vm._s(_vm.content)}})],2),_vm._v(" "),(_vm.showVideos)?_c('div',{staticClass:"column large-4"},[_c('videos',{attrs:{"asWidget":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "moY3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAuMzg0IiBoZWlnaHQ9IjQyLjU0MSIgdmlld0JveD0iMCAwIDMwLjM4NCA0Mi41NDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUuMTkyIDM4LjU0MVY0TTMuNSAxNS42OTJMMTUuMTkyIDRMMjYuODg0IDE1LjY5MiIgc3Ryb2tlPSIjMDA5MTY1IiBzdHJva2Utd2lkdGg9IjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "mskH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['agreeToTerms', 'getStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formDisable()) {
        this.loaderAdd(document.body);
        var payload = {
          isNALTermsAgreedTo: true
        };
        this.agreeToTerms(payload).then(function () {
          return _this.getStatus();
        }).then(function () {
          _this.loaderRemove(document.body);
          _this.setCurrentPopup();
        }).catch(function (e) {
          _this.loaderRemove(document.body);
          _this.formEnable();
          _this.formHandleErrors(e);
        });
      }
    }
  })
});

/***/ }),

/***/ "mt5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-ownership-and-orders-bar__ownership",class:_vm.ownershipClassModifiers},[(_vm.hasOwnership)?[(_vm.showOwnershipIcon)?_c('span',{staticClass:"market-ownership-and-orders-bar__icon"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__quantity"},[_vm._v(_vm._s(_vm.ownershipQuantityDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__mode"},[_vm._v(_vm._s(_vm.ownershipModeDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__average"},[_vm._v("\n        ("),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.ownershipAverage),expression:"ownershipAverage",modifiers:{"cents":true}}]}),_vm._v(" avg)\n      ")]),_vm._v(" "),(_vm.ownershipDifference)?_c('market-change-price',{staticClass:"market-ownership-and-orders-bar__change",attrs:{"price":_vm.ownershipDifference}}):_vm._e()]:[_c('span',{staticClass:"market-ownership-and-orders-bar__ownership-empty"},[_vm._v("No ownership")])]],2),_vm._v(" "),(_vm.showOrdersSummary)?_c('div',{staticClass:"market-ownership-and-orders-bar__orders"},[(_vm.hasOrders)?[(!_vm.hideOrdersLabel)?_c('span',{staticClass:"market-ownership-and-orders-bar__orders-label"},[_vm._v("Orders:")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-count market-ownership-and-orders-bar__orders-count--buy"},[_vm._v(_vm._s(_vm.buyOrdersDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-text"},[_vm._v("Buy")]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-separator"},[_vm._v("/")]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-count market-ownership-and-orders-bar__orders-count--sell"},[_vm._v(_vm._s(_vm.sellOrdersDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-text"},[_vm._v("Sell")])]:_c('span',{staticClass:"market-ownership-and-orders-bar__orders-empty"},[_vm._v("No orders")])],2):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mtKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-forgotten-footer"},[_c('span',{staticClass:"account-forgotten-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onCancel($event)}}},[_vm._v("\n    Cancel\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mx5S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_update_password_js__ = __webpack_require__("TZdm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2210d2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_update_password_vue__ = __webpack_require__("lLL5");
function injectStyle (ssrContext) {
  __webpack_require__("q5rS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_update_password_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2210d2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_update_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n/Ch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_notifications_proxy__ = __webpack_require__("a0yF");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onOptIn: function onOptIn() {
      __WEBPACK_IMPORTED_MODULE_2__services_notifications_proxy__["a" /* default */].optInMessaging();
      __WEBPACK_IMPORTED_MODULE_2__services_notifications_proxy__["a" /* default */].setupMessaging();
      this.setCurrentSmallPopup();
    },
    onOptOut: function onOptOut() {
      __WEBPACK_IMPORTED_MODULE_2__services_notifications_proxy__["a" /* default */].optOutMessaging();
      this.setCurrentSmallPopup();
    }
  })
});

/***/ }),

/***/ "n0gu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    obj: Object,
    category: String,
    disabled: Boolean
  },
  data: function data() {
    return {
      modelValue: null,
      oldValue: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['settings']), {
    classObject: function classObject() {
      return {
        'settings-option-switch': true,
        'settings-option-switch--disabled': this.disabled
      };
    },
    isDisabled: function isDisabled() {
      return this.disabled;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['updateSettings']), {
    isOptionDisabled: function isOptionDisabled(option) {
      return this.isDisabled || !!option.disabled;
    },
    change: function change(value) {
      var _this = this;

      this.loaderAddLegacy();
      this.modelValue = value;
      this.updateSettings({
        category: this.category,
        key: this.obj.key,
        value: value
      }).then(function () {
        _this.oldValue = _this.modelValue;
        _this.loaderRemoveLegacy();
      }).catch(function () {
        _this.loaderRemoveLegacy();
        _this.modelValue = _this.oldValue;
        _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
      });
      this.$emit('change', value);
    }
  }),
  created: function created() {
    var value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.settings, [this.category, this.obj.key]);
    this.modelValue = value !== undefined ? value : this.obj.defaultValue;
    this.oldValue = this.modelValue;
  }
});

/***/ }),

/***/ "n2FT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_close_button_close_button_vue__ = __webpack_require__("mjGX");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: false
    },
    silent: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    returnRoute: {
      type: String
    },
    returnRouteGoTo: {
      type: String
    },
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    closeButton: __WEBPACK_IMPORTED_MODULE_1__components_generics_close_button_close_button_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'content-header': true,
        'content-header--closable': this.showCloseButton
      }, 'content-header--' + this.theme, this.theme);
    }
  },
  methods: {
    closeTitle: function closeTitle() {
      if (!this.showCloseButton) return;
      this.close();
    },
    close: function close() {
      this.$emit('close');
      if (this.silent) return;
      if (this.returnRoute) {
        var routeObj = { name: this.returnRoute };
        if (this.returnRouteGoTo) {
          routeObj.query = { el: this.returnRouteGoTo };
        }
        this.$router.push(routeObj);
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),

/***/ "n3iy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n4JO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_settings_settings__ = __webpack_require__("8p/V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loader__ = __webpack_require__("39kf");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_loader__["a" /* default */]],
  props: {
    market: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      showMenu: false,
      showSettings: false,
      showSettingsModal: false
    };
  },

  components: {
    'small-modal': function smallModal() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "+CQ6"));
    },
    'market-settings-button': function marketSettingsButton() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "4eDX"));
    },
    'market-settings-modal': function marketSettingsModal() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "5n65"));
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isTradingEnabled', 'isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['settingShowOdds', 'settingOrderbookCollapsed', 'settingColorPalette', 'settingMobileLayout']), {
    hasOwnership: function hasOwnership() {
      if (this.market === null || !this.isLoggedIn) return false;
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.market.contracts, function (i) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["w" /* contractOwnershipNum */])(i);
      }) > 0;
    },
    isMarketDisabled: function isMarketDisabled() {
      return this.market !== null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    pricesTitle: function pricesTitle() {
      return this.isLayoutMobile ? 'Trade Prices' : 'Last Trade Price';
    },
    titleSecond: function titleSecond() {
      return this.settingShowOdds ? 'Odds' : this.pricesTitle;
    },
    titleThird: function titleThird() {
      return '';
    },
    titleFourth: function titleFourth() {
      return 'Outcome';
    },
    titleSecondMobile: function titleSecondMobile() {
      if (this.isMarketDisabled) {
        return 'Outcome';
      }
      return this.settingShowOdds ? 'Odds' : this.pricesTitle;
    },
    isCondensedMobileLayout: function isCondensedMobileLayout() {
      return this.settingMobileLayout === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED;
    },
    mobileBarClassModifiers: function mobileBarClassModifiers() {
      return {
        'market-contracts-list-header-sushi-common-betslip__mobile-bar': true,
        'market-contracts-list-header-sushi-common-betslip__mobile-bar--condensed': this.isCondensedMobileLayout,
        'market-contracts-list-header-sushi-common-betslip__mobile-bar--condensed-disabled': this.isCondensedMobileLayout && this.isMarketDisabled
      };
    },
    settingsModalOptions: function settingsModalOptions() {
      return __WEBPACK_IMPORTED_MODULE_5__components_account_settings_settings__["c" /* UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING */];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('app', ['setSettingShowOdds', 'setSettingOrderbookCollapsed', 'setSettingColorPalette', 'setSettingMobileLayout']), {
    onMenuToggle: function onMenuToggle() {
      this.showMenu = !this.showMenu;
      this.showSettings = false;
    },
    onSettingsToggle: function onSettingsToggle() {
      this.showSettings = !this.showSettings;
      this.showMenu = false;
    },
    onClickOutside: function onClickOutside() {
      this.showMenu = false;
    },
    isOptionDisabled: function isOptionDisabled(option) {
      return !!option.disabled;
    },
    setOddsMode: function setOddsMode(value) {
      this.setSettingShowOdds(value);
      this.showMenu = false;
      this.showSettings = false;
    },
    onSettingOptionClick: function onSettingOptionClick(category, option) {
      if (this.isOptionDisabled(option) || this.isSelected(category, option.key)) {
        return;
      }

      this.setSettingValue(category, option.key);
    },
    setSettingValue: function setSettingValue(category, key) {
      var _this = this;

      if (category === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
        this.loaderAdd(document.body);
        this.setSettingShowOdds(key === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS).then(function () {
          return _this.loaderRemove(document.body);
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS) {
        this.loaderAdd(document.body);
        this.setSettingOrderbookCollapsed(key === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED).then(function () {
          return _this.loaderRemove(document.body);
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
        this.loaderAdd(document.body);
        this.setSettingColorPalette(key).then(function () {
          return _this.loaderRemove(document.body);
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
        this.loaderAdd(document.body);
        this.setSettingMobileLayout(key).then(function () {
          return _this.loaderRemove(document.body);
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      }
    },
    isSelected: function isSelected(category, key) {
      switch (category) {
        case __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay:
          return this.settingShowOdds === (key === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS);
        case __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS:
          return this.settingOrderbookCollapsed === (key === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED);
        case __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme:
          return this.settingColorPalette === key;
        case __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout:
          return this.settingMobileLayout === key;
        default:
          return false;
      }
    }
  })
});

/***/ }),

/***/ "n58p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_static_preview_js__ = __webpack_require__("1/XJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e4ddbab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_static_preview_vue__ = __webpack_require__("SA4y");
function injectStyle (ssrContext) {
  __webpack_require__("WDNh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_static_preview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e4ddbab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_static_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n5Uq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-box",class:_vm.levelModifier},[(!!_vm.$slots.title)?_c('div',{staticClass:"alert-box__title"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"alert-box__content"},[(_vm.iconSrc)?_c('img',{staticClass:"alert-box__content-icon",attrs:{"src":_vm.iconSrc}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"alert-box__content-text"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n5nq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "n71m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register-footer"},[_c('div',{staticClass:"account-register-footer__title"},[_vm._v("\n        Already have an account?\n      ")]),_vm._v(" "),_c('span',{staticClass:"account-register-footer__link",on:{"click":function($event){$event.preventDefault();return _vm.onLogin($event)}}},[_vm._v("\n        Login to My Account\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n8WA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "n8oX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-register"},[_c('div',{staticClass:"page-register__content"},[_c('div',{staticClass:"page-register__title"},[_vm._v("\n      Create an Account\n    ")]),_vm._v(" "),_c('div',{staticClass:"page-register__content-wrap"},[_c('account-register',{attrs:{"mode":"page"}}),_vm._v(" "),_c('account-register-footer',{attrs:{"mode":"page"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n9Uc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n9uA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nBFw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nBxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("9cGE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b6487f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("Dthr");
function injectStyle (ssrContext) {
  __webpack_require__("Y/OY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b6487f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nE9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tax_info_notification_tax_info_notification_vue__ = __webpack_require__("wQDz");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    taxInfoNotification: __WEBPACK_IMPORTED_MODULE_0__components_tax_info_notification_tax_info_notification_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "nEDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_ownership_conflict_modal_js__ = __webpack_require__("0FJH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b630a28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_ownership_conflict_modal_vue__ = __webpack_require__("ZB+R");
function injectStyle (ssrContext) {
  __webpack_require__("tG+e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_ownership_conflict_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b630a28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_ownership_conflict_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nGgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__ = __webpack_require__("Ykf8");


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ link: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.id, title: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.title }, { link: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.id, title: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.title }]
    };
  },

  methods: {
    dailyMarketPageLink: function dailyMarketPageLink(item) {
      return { name: item.link };
    }
  }
});

/***/ }),

/***/ "nHRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_catchHtmlClickMixin__ = __webpack_require__("xO2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__ = __webpack_require__("ZIhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_support__ = __webpack_require__("33FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_brand_name_brand_name_js__ = __webpack_require__("9IfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_contentLoader__ = __webpack_require__("P71F");













var DEFAULT_TITLE = 'How to Trade on ' + __WEBPACK_IMPORTED_MODULE_9__components_brand_name_brand_name_js__["a" /* BRAND */];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_catchHtmlClickMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_support__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_contentLoader__["a" /* default */]],
  props: {
    title: {
      type: String,
      default: DEFAULT_TITLE
    }
  },
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__["a" /* default */],
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_8__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* STATIC_PAGES */].HOW_TO_TRADE).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "nHn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__ = __webpack_require__("o+KH");



var COOKIE_ACCEPTED = 'accepted';
var COOKIE_NAME = 'PrivacyStatement';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hidden: false
    };
  },

  computed: {
    show: function show() {
      return false && __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__["a" /* default */].get(COOKIE_NAME) === null && !this.hidden;
    }
  },
  methods: {
    onAgree: function onAgree() {
      __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__["a" /* default */].setForever(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, COOKIE_NAME, COOKIE_ACCEPTED));
      this.onHide();
    },
    onHide: function onHide() {
      this.hidden = true;
    }
  }
});

/***/ }),

/***/ "nJds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"home-old__preview-carousel"},[_c('preview-carousel')],1),_vm._v(" "),_c('div',{staticClass:"home-old__markets"},[_c('page-markets',{attrs:{"headerId":0,"embedded":true},on:{"embeddedInitialLoadStateChange":_vm.onEmbeddedInitialLoadStateChange}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nLQ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nNeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_profile_overview_header_js__ = __webpack_require__("VJVd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8a113c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_profile_overview_header_vue__ = __webpack_require__("hkT+");
function injectStyle (ssrContext) {
  __webpack_require__("T+Fj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_profile_overview_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8a113c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_profile_overview_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nPGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-desktop-header"},[_c('div',{staticClass:"account-desktop-header__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isExportAvailable)?_c('button',{staticClass:"account-desktop-header__button account-desktop-header__button--export",on:{"click":_vm.onExport}},[_vm._v("Export")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nPqm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_0__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  data: function data() {
    return {
      promoCodeDetail: {},
      instantCreditDetail: {}
    };
  },

  computed: {
    showInstantCreditNotification: function showInstantCreditNotification() {
      return this.instantCreditDetail && typeof this.instantCreditDetail.success !== 'undefined';
    },
    instantCreditBoxLevel: function instantCreditBoxLevel() {
      return this.instantCreditDetail.success ? 'success' : 'warning';
    },
    instantCreditBoxMessage: function instantCreditBoxMessage() {
      return this.instantCreditDetail.success ? this.instantCreditDetail.friendlyDescription : this.instantCreditDetail.errorMessage;
    },
    showPromoNotification: function showPromoNotification() {
      return this.promoCodeDetail && this.promoCodeDetail.showPromoCodeBox;
    },
    showPromoCode: function showPromoCode() {
      return this.promoCodeDetail && this.promoCodeDetail.promoCodeText;
    }
  }
});

/***/ }),

/***/ "nYw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__ = __webpack_require__("CAth");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b435be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_vue__ = __webpack_require__("JNgs");
function injectStyle (ssrContext) {
  __webpack_require__("sJOz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["c" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b435be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["f"] = (Component.exports);


/***/ }),

/***/ "na9c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "naY1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "neXN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nfG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      required: true
    }
  },
  computed: {
    numberDisplay: function numberDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["u" /* largeNumberDisplay */])(this.number);
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'market-shares-ownership': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-ownership--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-ownership--yes', this.mode === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-ownership--no', this.mode === 'no'), _ref;
    }
  },
  methods: {
    onClickNumber: function onClickNumber() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "nfMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state-button",class:_vm.selectedModifier,on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "niuH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "nlkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountLogin: __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "nnNw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-leaderboard-info"},[_c('div',{staticClass:"sushi-leaderboard-info__content"},[_c('div',{staticClass:"sushi-leaderboard-info__user"},[_c('account-social-avatar',{attrs:{"avatar":_vm.userAvatar,"showProgress":false,"percentage":_vm.progressPercentage,"progressStrokeColor":_vm.progressColor,"backgroundStrokeColor":_vm.levelColor,"theme":"profile"}}),_vm._v(" "),_c('div',{staticClass:"sushi-leaderboard-info__username"},[_vm._v("\n        "+_vm._s(_vm.userData.userName)+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"sushi-leaderboard-info__affiliations"},[_c('div',{staticClass:"sushi-leaderboard-info__item"},[_c('div',{staticClass:"sushi-leaderboard-info__item-title"},[_vm._v("\n          College Affiliation\n        ")]),_vm._v(" "),(_vm.isUCAffilSet === false)?_c('div',{staticClass:"sushi-leaderboard-info__item-subtitle"},[_vm._v("\n          Not Affiliated\n        ")]):(_vm.userAffiliations.length === 0)?_c('div',{staticClass:"sushi-leaderboard-info__item-subtitle"},[_vm._v("\n          No Affiliations Specified\n        ")]):(_vm.userAffiliations.length > 0)?_c('div',{staticClass:"sushi-leaderboard-info__items"},_vm._l((_vm.userAffiliations),function(item){return _c('div',[_vm._v("\n            "+_vm._s(item.name)),(item.isPendingApproval)?_c('span',[_vm._v(" (Pending)")]):_vm._e(),(!item.isPublic)?_c('span',[_vm._v(" *")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('span',{staticClass:"sushi-leaderboard-info__link",on:{"click":_vm.showAffiliationsPopup}},[_vm._v("Edit")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "no4l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ntlj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjM0I1OTk4IiByeD0iMiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEyLjU3NCAxMC4wNjJoLTEuNjZ2Ni4wODVIOC4zOTZ2LTYuMDg1SDcuMlY3LjkyM2gxLjE5N1Y2LjU0YzAtLjk5LjQ3LTIuNTM5IDIuNTM5LTIuNTM5bDEuODY0LjAwOHYyLjA3NmgtMS4zNTNjLS4yMjEgMC0uNTMzLjExLS41MzMuNTgzdjEuMjU4aDEuODhsLS4yMiAyLjEzN3oiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "nygi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_image_js__ = __webpack_require__("J+13");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dcf159c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_image_vue__ = __webpack_require__("0Jvk");
function injectStyle (ssrContext) {
  __webpack_require__("uZm2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_image_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dcf159c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nzeb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o+KH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EXPIRY_TIME */
/* unused harmony export EXPIRY_FOREVER */
/* unused harmony export extractHostname */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn__ = __webpack_require__("AVgl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forOwn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie__ = __webpack_require__("sp77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cookie__);




var EXPIRY_TIME = 5;
var EXPIRY_FOREVER = 'Fri, 31 Dec 9999 23:59:59 GMT';

var extractHostname = function extractHostname() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$delimiter = options.delimiter,
      delimiter = _options$delimiter === undefined ? '.' : _options$delimiter,
      _options$deep = options.deep,
      deep = _options$deep === undefined ? 2 : _options$deep;
  var hostname = window.location.hostname;

  var parts = hostname.split(delimiter);
  return parts.slice(-deep).join(delimiter);
};

var set = function set(data, expires) {
  var date = new Date();
  date.setMinutes(date.getMinutes() + EXPIRY_TIME);
  __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn___default()(data, function (value, key) {
    document.cookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_cookie__["serialize"])(key, value, {
      expires: expires || date,
      domain: extractHostname()
    });
  });
};

var setForever = function setForever(data) {
  return set(data, new Date(EXPIRY_FOREVER));
};

var get = function get(key) {
  var cookie = document.cookie ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_cookie__["parse"])(document.cookie) : {};
  return cookie[key] || null;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  set: set,
  setForever: setForever
});

/***/ }),

/***/ "o/Tx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_request_deposit_js__ = __webpack_require__("Ld4z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a15167f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_request_deposit_vue__ = __webpack_require__("ZgfQ");
function injectStyle (ssrContext) {
  __webpack_require__("Iuoh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_request_deposit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a15167f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_request_deposit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o302":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMwN2EwYmIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjk5MyA1LjE4NWMtLjAwMi0uMTI3LS4wMDQtLjIzNi0uMDA0LS4zMjhIMTguMzhjLjA3LTEuNTQ1LjAyMy0yLjg1Ny4wMjMtMi44NTdIMTIuMDRhLjQzNi40MzYgMCAwIDAtLjA0NS4wMDJBLjQzNC40MzQgMCAwIDAgMTEuOTUgMkg1LjU3cy0uMDQ3IDEuMzEyLjAyMyAyLjg1N0gydjEuNDI5aC4wMDdjLjAzNiAxLjE2NS4yMjMgMi43MjMuOTk3IDQuMzE4YTguOTUgOC45NSAwIDAgMCAyLjgxMiAzLjM2NCA5Ljc1IDkuNzUgMCAwIDAgMy40MDIgMS41NjZjLjcyNi43NzUgMS40NDIgMS4yMDMgMi4wNjcgMS4zNzR2MS41OWMtLjA4OS40NzMtLjYzIDIuMDczLTQuNDA5IDIuMDczaC0uNTl2MS40MjhoMTEuNDI4di0xLjQyOGgtLjU4OWMtNC40MzIgMC00LjQxMS0yLjIwMy00LjQxMS0yLjIwM3YtMS40NmMuNjI1LS4xNzEgMS4zMjctLjU5NyAyLjA1LTEuMzY4YTkuNzM1IDkuNzM1IDAgMCAwIDMuNDItMS41NzIgOC45NSA4Ljk1IDAgMCAwIDIuODEyLTMuMzY0YzEuMDU3LTIuMTc3IDEuMDE4LTQuMjg2Ljk5Ny01LjQyek00LjI4OCA5Ljk3OWMtLjY0NS0xLjMyOS0uODE0LTIuNjY3LS44NTEtMy42OTNINS42OWMuMDM4LjM5OC4wODcuNzkuMTUgMS4xNi4zOCAyLjI2My45MDIgNC4yNjIgMS44OSA2LjAyNkE3LjU5IDcuNTkgMCAwIDEgNC4yODggOS45OHptMTUuNDIzIDBhNy41OTEgNy41OTEgMCAwIDEtMy40NyAzLjUwN2MuOTkyLTEuNzY3IDEuNTEtMy43NzEgMS44OS02LjA0LjA2My0uMzcuMTEyLS43NjIuMTUtMS4xNmgyLjI4MWMtLjAzNyAxLjAyNi0uMjA2IDIuMzY0LS44NTEgMy42OTN6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "o3i4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    num: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    link: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    markOpened: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      opened: false
    };
  },

  computed: {
    hasSlotSuffix: function hasSlotSuffix() {
      return !!this.$slots.suffix;
    },
    classModifiers: function classModifiers() {
      return {
        'document-to-review': true,
        'document-to-review--opened': this.markOpened && this.opened
      };
    },
    symbolClassModifiers: function symbolClassModifiers() {
      return {
        'document-to-review__symbol': true,
        'document-to-review__symbol--pdf': this.link && this.link.endsWith('pdf')
      };
    }
  },
  methods: {
    onOpen: function onOpen() {
      this.opened = true;
      this.$emit('change', true);
    }
  }
});

/***/ }),

/***/ "o4Wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bottom_market_links_overlay_js__ = __webpack_require__("gXIn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8ff43bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_market_links_overlay_vue__ = __webpack_require__("ECMi");
function injectStyle (ssrContext) {
  __webpack_require__("BSVH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bottom_market_links_overlay_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8ff43bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_market_links_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o5X3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o68p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o6F4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgOCAxNCI+CiAgICA8cGF0aCBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0uOTAyLjMzM2wtLjYwNC42NzNBMS4yMjQgMS4yMjQgMCAwIDAgMCAxLjgyNGMwIC4zMTguMS41ODcuMjk4LjgwOUw0LjIxMiA3IC4yOTggMTEuMzY3YTEuMTY5IDEuMTY5IDAgMCAwLS4yOTguODA5YzAgLjMxMS4xLjU4NC4yOTguODE4bC42MDQuNjY1YS45NTEuOTUxIDAgMCAwIC43MzMuMzQxYy4yOSAwIC41MzItLjExNC43MjUtLjM0MWw1LjI0My01Ljg1Yy4yMDQtLjIxNi4zMDYtLjQ4NS4zMDYtLjgwOSAwLS4zMTgtLjEwMi0uNTktLjMwNi0uODE4TDIuMzYuMzMyQS45MzguOTM4IDAgMCAwIDEuNjM1IDBjLS4yOCAwLS41MjMuMTEtLjczMy4zMzN6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "o9eX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oFp3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_page_market_detail_sushi_page_market_detail_sushi__ = __webpack_require__("KA7l");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('toggle');
    },
    goToMarketTab: function goToMarketTab(name) {
      var el = document.querySelector('.tabs__link-name-' + name);
      if (el !== null) {
        el.click();
      }
    }
  }
});

/***/ }),

/***/ "oKYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-underscore-dangle: ["error", { "allow": ["__vueClickOutside__"] }] */

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var bubble = binding.modifiers.bubble;
    var handler = function handler(e) {
      if (bubble || !el.contains(e.target) && el !== e.target) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;
    document.addEventListener('click', handler);
  },
  unbind: function unbind(el) {
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
});

/***/ }),

/***/ "oLs4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oTR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_deposit_deposit_vue__ = __webpack_require__("NVO6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_withdraw_withdraw_vue__ = __webpack_require__("rdUu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__("c/9r");












var TAB_DEPOSIT = 'deposit';
var TAB_WITHDRAW = 'withdraw';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__["a" /* default */]],
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_2__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    alertBox: __WEBPACK_IMPORTED_MODULE_9__components_generics_alert_box_alert_box_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    deposit: __WEBPACK_IMPORTED_MODULE_4__components_wallet_deposit_deposit_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_6__components_generics_tabs_tabs_vue__["a" /* default */],
    withdraw: __WEBPACK_IMPORTED_MODULE_7__components_wallet_withdraw_withdraw_vue__["a" /* default */]
  },
  data: function data() {
    return {
      capitalizeFirstLetter: __WEBPACK_IMPORTED_MODULE_10__utils_helpers__["B" /* capitalizeFirstLetter */],
      ready: false,
      activeTab: '',
      tabs: [{ name: TAB_DEPOSIT, title: 'Deposit' }, { name: TAB_WITHDRAW, title: 'Withdraw' }]
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Wallet'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'hasMaintenance', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData']), {
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    },
    showDepositTab: function showDepositTab() {
      return this.activeTab === TAB_DEPOSIT;
    },
    showWithdrawTab: function showWithdrawTab() {
      return this.activeTab === TAB_WITHDRAW;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;
      if (this.isLayoutDesktop) {
        this.$router.push({
          name: 'wallet',
          query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            tabId: this.activeTab
          })
        });
      }
    }
  }),
  watch: {
    '$route.query': function $routeQuery(value) {
      if (value.tabId && value.tabId !== this.activeTab) {
        this.activeTab = value.tabId;
      }
    }
  },
  created: function created() {
    if (!this.isUserVerified) this.showAccountVerifyPopup();
    if (this.$route.query.tabId) {
      this.activeTab = this.$route.query.tabId;
    } else {
      this.activeTab = TAB_DEPOSIT;
      this.$router.push({
        name: 'wallet',
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          tabId: this.activeTab
        })
      });
    }
    this.ready = true;
  }
});

/***/ }),

/***/ "oV6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__("c/9r");








/* eslint-disable no-restricted-syntax */








var STORY_SWITCH_INTERVAL = 8 * 1000;
var CONTENT_COLLAPSED_HEIGHT = 475;
var CONTENT_OVERFLOW_TOLERANCE = 12;
var EXPANDED_HEIGHT_BUFFER = 8;
var EXPANDED_HEIGHT_MEASURE_DELAYS = [0, 150, 500, 1200];
var PODCAST_RESIZE_EVENT = 'cms:podcast-resize';
var PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';
var LAST_STORY_ROW_CLASS = 'preview-carousel__story-row--last';
var interval = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      stripTags: __WEBPACK_IMPORTED_MODULE_13__utils_helpers__["o" /* stripTags */],
      isLoading: false,
      selected: {},
      selectedManually: false,
      isTransitioning: false,
      storyContentMap: {},
      activeTab: null,
      showNavigationArrows: false,
      canScrollLeft: false,
      canScrollRight: false,
      isExpanded: false,
      isContentOverflowing: false,
      expandedContentHeight: null,
      contentMeasureTimeouts: [],
      contentResizeObserver: null,
      refreshIndex: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('browse', ['storiesNav', 'storyMap', 'currentStoryIndex']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup']), {
    showNav: function showNav() {
      return this.storiesNav.length > 0 && !this.isLoading && this.isComponentReady;
    },
    navigationTabs: function navigationTabs() {
      return this.storiesNav.map(function (item) {
        return {
          name: 'story-' + item.index,
          title: item.navTitle || 'Story #' + (item.index + 1)
        };
      });
    },
    classModifiers: function classModifiers() {
      return {
        'preview-carousel': true
      };
    },
    contentClassModifiers: function contentClassModifiers() {
      return {
        'preview-carousel__content': true,
        'preview-carousel__content--collapsed': !this.isExpanded,
        'preview-carousel__content--overflowing': this.isContentOverflowing && !this.isExpanded
      };
    },
    contentStyleModifiers: function contentStyleModifiers() {
      var minHeightPx = CONTENT_COLLAPSED_HEIGHT;
      if (this.isExpanded && this.expandedContentHeight) {
        return {
          minHeight: Math.max(minHeightPx, this.expandedContentHeight) + 'px'
        };
      }
      return {
        minHeight: minHeightPx + 'px'
      };
    },
    expandClassModifiers: function expandClassModifiers() {
      return {
        'preview-carousel__expand': true,
        'preview-carousel__expand--floating': !this.isExpanded
      };
    },
    showExpandControl: function showExpandControl() {
      return this.isContentOverflowing && this.isComponentReady;
    },
    tabsClassModifiers: function tabsClassModifiers() {
      return {
        'preview-carousel__tabs': true,
        'preview-carousel__tabs--arrows': this.showNavigationArrows
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('browse', ['getStoriesNav', 'getStory', 'getStoriesList', 'updateStoryMapFromContractNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    getStoryContentForLayout: function getStoryContentForLayout(data) {
      return this.isLayoutDesktop ? data.desktopContent : data.mobileContent;
    },
    clearPendingExpandedMeasurements: function clearPendingExpandedMeasurements() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.contentMeasureTimeouts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeoutId = _step.value;

          clearTimeout(timeoutId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.contentMeasureTimeouts = [];
    },
    teardownContentResizeObserver: function teardownContentResizeObserver() {
      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }
    },
    setupContentResizeObserver: function setupContentResizeObserver() {
      var _this = this;

      this.teardownContentResizeObserver();
      if (typeof ResizeObserver === 'undefined') {
        return;
      }

      var target = this.getActiveStoryElement() || this.$refs.content;
      if (!target) {
        return;
      }

      this.contentResizeObserver = new ResizeObserver(function () {
        if (_this.isExpanded) {
          _this.scheduleExpandedHeightRefresh();
        } else {
          _this.checkContentOverflow();
        }
      });
      this.contentResizeObserver.observe(target);
    },
    getActiveStoryElement: function getActiveStoryElement() {
      var content = this.$refs.content;
      if (!content) {
        return null;
      }
      var stories = content.querySelectorAll('.preview-carousel__story');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(stories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var story = _step2.value;

          if (window.getComputedStyle(story).display !== 'none') {
            return story;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    },
    isVisibleElement: function isVisibleElement(node) {
      var styles = window.getComputedStyle(node);
      if (styles.display === 'none' || styles.visibility === 'hidden') {
        return false;
      }
      var rect = node.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 || node.scrollHeight > 0;
    },
    getLastVisibleStoryRow: function getLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return null;
      }

      var rows = activeStory.querySelectorAll('.browse-story-content-region__items');
      for (var index = rows.length - 1; index >= 0; index -= 1) {
        var row = rows[index];
        if (this.isVisibleElement(row)) {
          return row;
        }
      }

      return null;
    },
    updateLastVisibleStoryRow: function updateLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return;
      }

      var markedRows = activeStory.querySelectorAll('.' + LAST_STORY_ROW_CLASS);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(markedRows), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var row = _step3.value;

          row.classList.remove(LAST_STORY_ROW_CLASS);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var lastVisibleRow = this.getLastVisibleStoryRow(activeStory);
      if (lastVisibleRow) {
        lastVisibleRow.classList.add(LAST_STORY_ROW_CLASS);
      }
    },
    measureStoryHeight: function measureStoryHeight() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$includeBuffer = _ref.includeBuffer,
          includeBuffer = _ref$includeBuffer === undefined ? false : _ref$includeBuffer;

      var activeStory = this.getActiveStoryElement();
      if (!activeStory) {
        return null;
      }

      this.updateLastVisibleStoryRow(activeStory);

      var activeRect = activeStory.getBoundingClientRect();
      var measuredHeight = Math.max(activeStory.scrollHeight || 0, activeStory.offsetHeight || 0);
      var descendants = activeStory.querySelectorAll('*');

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(descendants), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var node = _step4.value;

          var styles = window.getComputedStyle(node);
          if (styles.display === 'none' || styles.visibility === 'hidden') {
            continue;
          }
          var rect = node.getBoundingClientRect();
          if (rect.width === 0 && rect.height === 0) {
            continue;
          }
          var nodeBottom = rect.bottom - activeRect.top;
          if (nodeBottom > measuredHeight) {
            measuredHeight = nodeBottom;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (measuredHeight <= 0) {
        return null;
      }

      return Math.ceil(measuredHeight + (includeBuffer ? EXPANDED_HEIGHT_BUFFER : 0));
    },
    measureExpandedContentHeight: function measureExpandedContentHeight() {
      return this.measureStoryHeight({ includeBuffer: true });
    },
    measureCollapsedContentHeight: function measureCollapsedContentHeight() {
      return this.measureStoryHeight();
    },
    scheduleExpandedHeightRefresh: function scheduleExpandedHeightRefresh() {
      var _this2 = this;

      if (!this.isExpanded) {
        return;
      }
      this.clearPendingExpandedMeasurements();
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(EXPANDED_HEIGHT_MEASURE_DELAYS), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var delay = _step5.value;

          var timeoutId = setTimeout(function () {
            if (!_this2.isExpanded) {
              return;
            }
            var measuredHeight = _this2.measureExpandedContentHeight();
            if (measuredHeight) {
              _this2.expandedContentHeight = measuredHeight;
            }
          }, delay);
          this.contentMeasureTimeouts.push(timeoutId);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    handleWindowResize: function handleWindowResize() {
      this.checkOverflow();
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.checkContentOverflow();
      }
    },
    handleEmbeddedResizeEvent: function handleEmbeddedResizeEvent() {
      var _this3 = this;

      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.$nextTick(function () {
          _this3.checkContentOverflow();
        });
      }
    },
    emitPodcastLayoutRefresh: function emitPodcastLayoutRefresh() {
      window.dispatchEvent(new Event(PODCAST_LAYOUT_REFRESH_EVENT));
    },
    tabsClicked: function tabsClicked() {
      this.stopNavRotation();
      this.selectedManually = true;
    },
    navigationTabChange: function navigationTabChange(name) {
      this.activeTab = name;
      var index = parseInt(name.replace('story-', ''), 10);
      this.onSelect({ item: this.storiesNav.find(function (i) {
          return i.index === index;
        }), stop: false });
    },
    installActiveStoryCharts: function installActiveStoryCharts() {
      var activeStoryElement = this.getActiveStoryElement();
      if (!activeStoryElement) {
        return;
      }
      this.installMarketCharts(activeStoryElement, { suppressGlobalLoader: true });
    },
    setupContent: function setupContent() {
      var _this4 = this;

      var totalCmsContent = [];
      this.storyContentMap = {};

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.storyMap)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref2 = _step6.value;

          var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

          var index = _ref3[0];
          var data = _ref3[1];

          var storyContent = this.getStoryContentForLayout(data);
          totalCmsContent.push(storyContent.cmsContent || {});
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(this.storyContentMap, index, '' + (storyContent.css || '') + (storyContent.html || ''));
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var accordionContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.accordionContentObjects || [];
      }));
      var podcastItemContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.podcastItemContentObjects || [];
      }));
      var contractListMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.contractListMarkets || [];
      }));
      var marketTileMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.marketTileMarkets || [];
      }));
      var chartWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.chartWidgetObjects || [];
      }));
      var docsWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.docsWidgetObjects || [];
      }));
      var videoWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.videoWidgetObjects || [];
      }));
      this.isComponentReady = true;

      setTimeout(function () {
        _this4.installDynamicControls({
          data: {
            cmsContentObject: {
              accordionContentObjects: accordionContentObjects,
              podcastItemContentObjects: podcastItemContentObjects,
              contractListMarkets: contractListMarkets,
              marketTileMarkets: marketTileMarkets,
              chartWidgetObjects: chartWidgetObjects,
              docsWidgetObjects: docsWidgetObjects,
              videoWidgetObjects: videoWidgetObjects
            }
          },
          skipMarketCharts: true
        });
        _this4.$nextTick(function () {
          _this4.installActiveStoryCharts();
          _this4.setupContentResizeObserver();
          _this4.checkContentOverflow();
          _this4.emitPodcastLayoutRefresh();
        });
      }, 0);
    },
    refreshLayoutContent: function refreshLayoutContent() {
      var _this5 = this;

      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$clearExpanded = _ref4.clearExpanded,
          clearExpanded = _ref4$clearExpanded === undefined ? true : _ref4$clearExpanded;

      if (!this.isComponentReady || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.storyMap).length === 0) {
        return;
      }
      if (clearExpanded) {
        this.isExpanded = false;
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.refreshIndex += 1;
      this.$nextTick(function () {
        _this5.setupContent();
        _this5.$nextTick(function () {
          _this5.setupContentResizeObserver();
          _this5.checkOverflow();
          _this5.emitPodcastLayoutRefresh();
        });
      });
    },
    onSelect: function onSelect(_ref5) {
      var _this6 = this;

      var item = _ref5.item,
          _ref5$stop = _ref5.stop,
          stop = _ref5$stop === undefined ? false : _ref5$stop;

      if (typeof item === 'undefined') return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      var disableNavBarAutomaticProgression = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(item, 'disableNavBarAutomaticProgression', false);
      if (stop || disableNavBarAutomaticProgression) {
        this.stopNavRotation();
        this.selectedManually = true;
      }

      this.isTransitioning = true;
      return this.getStory({ index: item.index }).then(function (data) {
        var timeout = 0;
        if (stop) {
          window.scrollTo(0, 0);
        }
        _this6.selected = item;
        setTimeout(function () {
          _this6.isTransitioning = false;
        }, timeout);
      });
    },
    stopNavRotation: function stopNavRotation() {
      if (interval !== null) {
        clearInterval(interval);
      }
    },
    startNavRotation: function startNavRotation() {
      var _this7 = this;

      this.stopNavRotation();
      interval = setInterval(function () {
        var currentIndex = _this7.selected.index;
        var nextIndex = currentIndex === _this7.storiesNav.length - 1 ? 0 : currentIndex + 1;
        _this7.onSelect({ item: _this7.storiesNav[nextIndex] });
      }, STORY_SWITCH_INTERVAL);
    },
    resolveInitialStoryItem: function resolveInitialStoryItem(data) {
      if (this.$route.query.story) {
        var indexToSelect = parseInt(this.$route.query.story, 10);
        var selectedItem = data[indexToSelect - 1];

        if (selectedItem) {
          this.activeTab = 'story-' + selectedItem.index;
          return selectedItem;
        }
      }

      var defaultItem = data[0];
      if (defaultItem) {
        this.activeTab = 'story-' + defaultItem.index;
      }

      return defaultItem;
    },
    start: function start() {
      var _this8 = this;

      this.stopNavRotation();
      this.isLoading = true;
      this.isComponentReady = false;
      this.getStoriesNav().then(function (data) {
        if (data.length === 0) {
          _this8.isLoading = false;
          _this8.isComponentReady = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }

        var item = _this8.resolveInitialStoryItem(data);
        if (!item) {
          _this8.isLoading = false;
          _this8.isComponentReady = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }

        return _this8.getStoriesList({ indexes: data.map(function (i) {
            return i.index;
          }), cache: true }).then(function () {
          return _this8.onSelect({ item: item }).then(function () {
            _this8.isLoading = false;
            _this8.setupContent();

            setTimeout(function () {
              _this8.checkOverflow();
            }, 0);

            var disableNavBarAutomaticProgression = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(item || {}, 'disableNavBarAutomaticProgression', false);
            if (!_this8.currentPopup && !disableNavBarAutomaticProgression) {
              _this8.startNavRotation();
            }
          });
        });
      }).catch(function (e) {
        console.error(e);
        _this8.isLoading = false;
        _this8.isComponentReady = true;
      });
    },
    checkScrollButtons: function checkScrollButtons() {
      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        var tolerance = 25;
        this.canScrollLeft = tabsList.scrollLeft > tolerance;
        this.canScrollRight = tabsList.scrollLeft < tabsList.scrollWidth - tabsList.clientWidth - tolerance;
      }
    },
    checkOverflow: function checkOverflow() {
      var _this9 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.showNavigationArrows = tabsList.scrollWidth > tabsList.clientWidth;
        setTimeout(function () {
          _this9.checkScrollButtons();
        }, 250);
      }
    },
    scrollLeft: function scrollLeft() {
      var _this10 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: -150, // Scroll left by 150px
          behavior: 'smooth'
        });
        setTimeout(function () {
          _this10.checkScrollButtons();
        }, 250);
      }
    },
    scrollRight: function scrollRight() {
      var _this11 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: 150, // Scroll right by 150px
          behavior: 'smooth'
        });
        setTimeout(function () {
          _this11.checkScrollButtons();
        }, 250);
      }
    },
    toggleExpand: function toggleExpand() {
      var _this12 = this;

      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.stopNavRotation();
      this.selectedManually = true;
      this.$nextTick(function () {
        _this12.emitPodcastLayoutRefresh();
      });
    },
    checkContentOverflow: function checkContentOverflow() {
      var content = this.$refs.content;
      if (content) {
        var collapsedContentHeight = this.measureCollapsedContentHeight() || content.scrollHeight || 0;
        this.isContentOverflowing = collapsedContentHeight > CONTENT_COLLAPSED_HEIGHT + CONTENT_OVERFLOW_TOLERANCE;
        if (this.isExpanded) {
          var expandedContentHeight = this.measureExpandedContentHeight();
          if (expandedContentHeight) {
            this.expandedContentHeight = expandedContentHeight;
          }
        }
      }
    }
  }),
  created: function created() {
    this.start();
  },

  watch: {
    currentStoryIndex: function currentStoryIndex(val) {
      var _this13 = this;

      this.isExpanded = false;
      this.expandedContentHeight = null;
      this.clearPendingExpandedMeasurements();
      this.$nextTick(function () {
        _this13.installActiveStoryCharts();
        _this13.setupContentResizeObserver();
        _this13.checkContentOverflow();
        _this13.emitPodcastLayoutRefresh();
        setTimeout(function () {
          return _this13.emitPodcastLayoutRefresh();
        }, 200);
      });
      var activeTab = 'story-' + val;
      if (activeTab !== this.activeTab) {
        this.activeTab = activeTab;
      }
    },
    isLayoutDesktop: function isLayoutDesktop(value, oldValue) {
      var _this14 = this;

      if (value === oldValue) {
        return;
      }
      this.$nextTick(function () {
        _this14.refreshLayoutContent({ clearExpanded: true });
      });
    },
    currentPopup: function currentPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    },
    currentSmallPopup: function currentSmallPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopNavRotation();
    this.clearPendingExpandedMeasurements();
    this.teardownContentResizeObserver();
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);
  }
});

/***/ }),

/***/ "oY3V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_widget_js__ = __webpack_require__("ORlq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e019a0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_widget_vue__ = __webpack_require__("lq1j");
function injectStyle (ssrContext) {
  __webpack_require__("2gZh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e019a0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oaFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_card_add_funds_card_vue__ = __webpack_require__("a3Wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__ = __webpack_require__("ZWR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_instant_credit__ = __webpack_require__("zAJv");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_accountVerify__["a" /* default */]],
  components: {
    addFundsBankTransfer: __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["c" /* default */],
    addFundsCard: __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_card_add_funds_card_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  props: {
    checkInstantCredit: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showTabs: false,
      hideTabs: false,
      activeTab: null,
      tabIndexOrder: [],
      isCreditCardAvailable: false,
      isOnlineBankingAvailable: false,
      instantCreditData: {}
    };
  },

  computed: {
    tabs: function tabs() {
      var _this = this;

      var results = [];
      this.tabIndexOrder.forEach(function (v) {
        if (_this.isOnlineBankingAvailable && v === __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["a" /* TAB_INDEX_ONLINE_BANKING */]) {
          results.push({
            name: __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["a" /* TAB_INDEX_ONLINE_BANKING */],
            title: 'Online Banking'
          });
        }
        if (_this.isCreditCardAvailable && v === __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["b" /* TAB_INDEX_CREDIT */]) {
          results.push({
            name: __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["b" /* TAB_INDEX_CREDIT */],
            title: 'Credit Card'
          });
        }
      });
      return results;
    },
    showCardTab: function showCardTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["b" /* TAB_INDEX_CREDIT */];
    },
    showBankingTab: function showBankingTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["a" /* TAB_INDEX_ONLINE_BANKING */];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getDepositMethods']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;
      // upon initial tab change if there is one tab hide options
      if (this.tabs.length === 1) {
        this.hideTabs = true;
      }
    },
    onBankTransferStep: function onBankTransferStep(step) {
      if (step === 3) {
        this.hideTabs = true;
      } else if (step === 1 || step === 2) {
        this.hideTabs = false;
      }
    }
  }),
  created: function created() {
    var _this2 = this;

    this.getDepositMethods().then(function (data) {
      _this2.tabIndexOrder = data.tabIndexOrder;
      _this2.isCreditCardAvailable = data.isCreditCardAvailable;
      _this2.isOnlineBankingAvailable = data.isOnlineBankingAvailable;
      var shouldGoToWalletPage = !data.isCreditCardAvailable && !data.isOnlineBankingAvailable && _this2.isUserVerifiedFully;

      if (shouldGoToWalletPage) {
        if (_this2.$route.name === 'wallet') {
          _this2.setCurrentPopup();
        } else {
          _this2.$router.push({ name: 'wallet' });
        }
      } else if (_this2.checkInstantCredit) {
        __WEBPACK_IMPORTED_MODULE_7__services_instant_credit__["a" /* default */].run().then(function (instantCreditData) {
          _this2.instantCreditData = instantCreditData;
          _this2.showTabs = true;

          if (_this2.instantCreditData.success) {
            _this2.getStatus();
          }
        });
      } else {
        _this2.showTabs = true;
      }
    });
  }
});

/***/ }),

/***/ "oeb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_disqus_disqus_vue__ = __webpack_require__("4EoQ");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    disqus: __WEBPACK_IMPORTED_MODULE_2__components_disqus_disqus_vue__["a" /* default */]
  },
  data: function data() {
    return {
      disqusReady: false,
      disqusAuth: ''
    };
  },

  computed: {
    disqusId: function disqusId() {
      return this.$route.name;
    },
    disqusTitle: function disqusTitle() {
      return document.title;
    },
    disqusUrl: function disqusUrl() {
      return window.location.href;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getDisqusUserAuth']), {
    setupDisqus: function setupDisqus() {
      var _this = this;

      this.getDisqusUserAuth().then(function (data) {
        _this.disqusReady = true;
        _this.disqusAuth = data;
      });
    }
  })
});

/***/ }),

/***/ "of0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_dashboard_js__ = __webpack_require__("T9qA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535868f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_dashboard_vue__ = __webpack_require__("/x/V");
function injectStyle (ssrContext) {
  __webpack_require__("shWj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_dashboard_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535868f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ohdr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-badges-list"},[_c('div',{staticClass:"account-badges-list__title"},[_vm._v("\n    You earned "+_vm._s(_vm.earned.length)+" badge"),(_vm.earned.length !== 1)?[_vm._v("s")]:_vm._e(),_vm._v(" today\n  ")],2),_vm._v(" "),_c('div',{staticClass:"account-badges-list__content"},_vm._l((_vm.earned),function(badge,index){return _c('div',{key:index,staticClass:"account-badges-list__badge"},[_c('div',{staticClass:"account-badges-list__badge-icon"}),_vm._v(" "),_c('div',{staticClass:"account-badges-list__badge-title"},[_vm._v(_vm._s(badge.title))])])}),0),_vm._v(" "),_c('div',{staticClass:"account-badges-list__title"},[_vm._v("\n    You now have "+_vm._s(_vm.current.length)+" badge"),(_vm.current.length !== 1)?[_vm._v("s")]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"account-badges-list__content"},_vm._l((_vm.current),function(badge,index){return _c('div',{key:index,staticClass:"account-badges-list__badge"},[_c('div',{staticClass:"account-badges-list__badge-icon"}),_vm._v(" "),_c('div',{staticClass:"account-badges-list__badge-title"},[_vm._v(_vm._s(badge.title))])])}),0),_vm._v(" "),_c('div',{staticClass:"account-badges-list__title"},[_vm._v("\n    Still to discover\n  ")]),_vm._v(" "),_c('div',{staticClass:"account-badges-list__content"},_vm._l((_vm.toDiscover),function(badge,index){return _c('div',{key:index,staticClass:"account-badges-list__badge"},[_c('div',{staticClass:"account-badges-list__badge-icon account-badges-list__badge-icon--locked"}),_vm._v(" "),_c('div',{staticClass:"account-badges-list__badge-title"},[_vm._v(_vm._s(badge.title))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oiU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oibH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_vm._v("\n  "+_vm._s(_vm.transformedStatus)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oiih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATIC_PAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FORM_TYPE_IDV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FORM_TYPE_TRIGGERS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/* eslint-disable */

var DEFAULT_SMALL_POPUP_TIMEOUT = 3500;
var DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT = 3500;
var DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
var DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT = 250;
var MARKET_OPEN = 'Open';
var MARKET_SUSPENDED = 'Suspended';
var MARKET_EXPIRED = 'Expired';
var MARKET_SETTLED = 'Settled';
var MARKET_CLOSED = 'Closed';
var MARKET_MAINTENANCE = 'Maintenance';
var SOCIAL_LOGIN_OR_REGISTER = 'login-register';
var SOCIAL_LOGIN_ADD = 'add';

// set to false to show 'setup 2FA' prompt on login and at end of registration flows
var DISABLE_TWO_FACTOR_PROMPT = true !== null && true !== undefined ? true : true;

var CARDS = {
  VISA: 'visa',
  AMERICAN_EXPRESS: 'americanexpress',
  DISCOVER: 'discover',
  MASTERCARD: 'mastercard',
  BLANK: 'blank'
};

function getDay(index) {
  var value = index + 1;
  return {
    label: value < 10 ? '0' + value.toString() : value.toString(),
    value: value
  };
}

function getMonth(index) {
  var value = index + 1;
  return {
    label: value < 10 ? '0' + value.toString() : value.toString(),
    value: value
  };
}

function getYear(index) {
  var year = new Date().getFullYear();
  var value = year - index;

  return {
    label: value.toString(),
    value: value
  };
}

function getExpiryYear(index) {
  var year = new Date().getFullYear();
  var value = year + index;

  return {
    label: value.toString(),
    value: value
  };
}

function getBirthYear(index) {
  var year = new Date().getFullYear() - 18;
  var value = year - index;

  return {
    label: value.toString(),
    value: value
  };
}

var days = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(31))).map(function (el, index) {
  return getDay(index);
});
var months = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(12))).map(function (el, index) {
  return getMonth(index);
});
var years = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(100))).map(function (el, index) {
  return getYear(index);
});
var expiryYears = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(13))).map(function (el, index) {
  return getExpiryYear(index);
});
var birthYears = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(101))).map(function (el, index) {
  return getBirthYear(index);
});

var statesCodeToNameMap = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming"
};

var statesCodeToElectoralVotesMap = {
  "NE03": 1,
  "NE02": 1,
  "NE01": 1,
  "NE-03": 1,
  "NE-02": 1,
  "NE-01": 1,
  "WA": 12,
  "DE": 3,
  "DC": 3,
  "WI": 10,
  "WV": 5,
  "HI": 4,
  "FL": 29,
  "WY": 3,
  "NH": 4,
  "NJ": 14,
  "NM": 5,
  "TX": 38,
  "LA": 8,
  "NC": 15,
  "ND": 3,
  "NE": 2, // 5
  "TN": 11,
  "NY": 29,
  "PA": 20,
  "CA": 55,
  "NV": 6,
  "VA": 13,
  "CO": 9,
  "AK": 3,
  "AL": 9,
  "AR": 6,
  "VT": 3,
  "IL": 20,
  "GA": 16,
  "IN": 11,
  "IA": 6,
  "OK": 7,
  "AZ": 11,
  "ID": 4,
  "CT": 7,
  "ME": 2, // 4
  "MD": 10,
  "MA": 11,
  "OH": 18,
  "UT": 6,
  "MO": 10,
  "MN": 10,
  "MI": 16,
  "RI": 4,
  "KS": 6,
  "MT": 3,
  "ME02": 1,
  "MS": 6,
  "ME01": 1,
  "ME-01": 1,
  "ME-02": 1,
  "SC": 9,
  "KY": 8,
  "OR": 7,
  "SD": 3
};

var SMALL_STATE_CODES = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];

var STATIC_PAGES = {
  TERMS: 'TandC',
  RESEARCH: 'ResearchPage',
  PRIVACY: 'PrivacyPolicy',
  WHAT_IS: 'WhatIsPredictIt',
  HOW_TO_TRADE: 'HowToTradeOnPredictIt',
  PLATFORM_ANNOUNCEMENTS: 'PlatformAnnouncements',
  DEPOSIT_WARNING: 'DepositWarning',
  NEWS: 'News',
  NEWS_ARCHIVE: 'NewsArchive'
};

var FORM_TYPE_IDV = {
  INITIAL: 1,
  CHANGE_ADDRESS: 2,
  SSN4IDV: 3
};

var FORM_TYPE_TRIGGERS = {
  MODAL: 'modal',
  STANDALONE: 'standalone'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  FORM_TYPE_IDV: FORM_TYPE_IDV,
  FORM_TYPE_TRIGGERS: FORM_TYPE_TRIGGERS,
  CARDS: CARDS,
  DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT: DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT: DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT,
  DEFAULT_SMALL_POPUP_TIMEOUT: DEFAULT_SMALL_POPUP_TIMEOUT,
  MARKET_OPEN: MARKET_OPEN,
  MARKET_SUSPENDED: MARKET_SUSPENDED,
  MARKET_EXPIRED: MARKET_EXPIRED,
  MARKET_SETTLED: MARKET_SETTLED,
  MARKET_CLOSED: MARKET_CLOSED,
  MARKET_MAINTENANCE: MARKET_MAINTENANCE,
  DISABLE_TWO_FACTOR_PROMPT: DISABLE_TWO_FACTOR_PROMPT,
  SOCIAL_LOGIN_ADD: SOCIAL_LOGIN_ADD,
  SOCIAL_LOGIN_OR_REGISTER: SOCIAL_LOGIN_OR_REGISTER,
  SMALL_STATE_CODES: SMALL_STATE_CODES,
  birthYears: birthYears,
  expiryYears: expiryYears,
  years: years,
  months: months,
  days: days,
  statesCodeToNameMap: statesCodeToNameMap,
  statesCodeToElectoralVotesMap: statesCodeToElectoralVotesMap,
  STATIC_PAGES: STATIC_PAGES
});

/***/ }),

/***/ "oo9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UX_OPTIONS_BUTTON_COLOR_SCHEME */
/* unused harmony export UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT */
/* unused harmony export UX_OPTIONS_PRICE_DISPLAY */
/* unused harmony export UX_OPTIONS_MOBILE_ORDERBOOK_DISPLAY */
/* unused harmony export UX_OPTIONS */
/* unused harmony export UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__settings_option_settings_option_vue__ = __webpack_require__("7DQ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__settings_option_switch_settings_option_switch_vue__ = __webpack_require__("OdBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__check_option_check_option_vue__ = __webpack_require__("9zdy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__security_settings_security_settings_vue__ = __webpack_require__("lyr+");


/* eslint-disable no-console */


















var PROVIDER_FACEBOOK = 'Facebook';
var PROVIDER_TWITTER = 'Twitter';
var PROVIDER_GOOGLE = 'Google';

var optionPush = {
  key: 'AllowPushNotifications',
  info: 'Push Notifications'
};

var sectionNotifications = [{
  key: 'OpenOfferMatched',
  info: 'One of my orders has been matched'
}, {
  key: 'MarketClosed',
  info: 'One of my markets has closed'
}];

if (false) {
  sectionNotifications.push({
    key: 'ContractPriceChange',
    info: 'One of my contracts changes in price by:',
    withValue: 'ContractPriceChangeAmount',
    validate: function validate(x) {
      return x >= 5 && x < 100;
    },
    currencyInitial: 5
  });
}

var sectionGeneral = [
  // {
  //   key: 'ShowBalanceHeader',
  //   info: 'Show my available balances in header',
  // },
];

var UX_OPTIONS_BUTTON_COLOR_SCHEME = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme,
  info: 'Buy Button Color Scheme',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["a" /* APP_COLOR_PALETTE */].GREEN_RED,
    info: 'Green/Red'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["a" /* APP_COLOR_PALETTE */].BLUE_GREY,
    info: 'Blue/Grey'
  }]
};

var UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout,
  info: 'Mobile Contract Layout',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].STANDARD,
    info: 'Tile'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].SIMPLIFIED,
    info: 'Simplified'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED,
    info: 'Condensed'
  }]
};

var UX_OPTIONS_PRICE_DISPLAY = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay,
  info: 'Price Display',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["d" /* APP_PRICE_DISPLAY */].TRADE_PRICES,
    info: 'Trade Prices'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS,
    info: 'Odds'
  }]
};

var UX_OPTIONS_MOBILE_ORDERBOOK_DISPLAY = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS,
  info: 'Orderbook Layout (Mobile Only)',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED,
    info: 'Collapsed'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].EXPANDED,
    info: 'Expanded'
  }]
};

var UX_OPTIONS = [UX_OPTIONS_BUTTON_COLOR_SCHEME, UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT, UX_OPTIONS_PRICE_DISPLAY];

var UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(UX_OPTIONS.filter(function (option) {
  return option.key !== __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS;
})));

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_12__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    alertBox: __WEBPACK_IMPORTED_MODULE_7__components_generics_alert_box_alert_box_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    formCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_forms_checkbox_checkbox_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__["a" /* default */],
    switchButton: __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__["a" /* default */],
    settingsOption: __WEBPACK_IMPORTED_MODULE_15__settings_option_settings_option_vue__["a" /* default */],
    checkOption: __WEBPACK_IMPORTED_MODULE_17__check_option_check_option_vue__["a" /* default */],
    securitySettings: __WEBPACK_IMPORTED_MODULE_18__security_settings_security_settings_vue__["a" /* default */],
    settingsOptionSwitch: __WEBPACK_IMPORTED_MODULE_16__settings_option_switch_settings_option_switch_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_externalLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      manageInfoLoaded: false,
      correspondence: false,
      logins: [],
      hasLocalPassword: false,
      sectionGeneral: sectionGeneral,
      sectionNotifications: sectionNotifications,
      optionPush: optionPush,
      sectionPushEnabled: false,
      categories: {
        privacy: 'privacy',
        general: 'display',
        push: 'PushNotifications',
        inApp: 'InAppNotifications',
        ux: 'ux'
      },
      sectionUX: UX_OPTIONS
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Settings'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'leaderboardsEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('profile', ['settingsReady']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['settings']), {
    sectionPrivacy: function sectionPrivacy() {
      var results = [{
        key: 'ShowTradeHistory',
        info: "Show my trade activity in 'Currently Predicting'"
      }];
      if (this.leaderboardsEnabled) {
        results.push({
          key: 'AllowLeaderboard',
          info: 'Show my ranking in the Leaderboards'
        });
      }
      return results;
    },
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    },
    isFacebookDisabled: function isFacebookDisabled() {
      return !this.hasLocalPassword;
    },
    isTwitterDisabled: function isTwitterDisabled() {
      return !this.hasLocalPassword;
    },
    isGoogleDisabled: function isGoogleDisabled() {
      return !this.hasLocalPassword;
    },
    hasFacebook: function hasFacebook() {
      return this.checkLogin(PROVIDER_FACEBOOK);
    },
    hasTwitter: function hasTwitter() {
      return this.checkLogin(PROVIDER_TWITTER);
    },
    hasGoogle: function hasGoogle() {
      return this.checkLogin(PROVIDER_GOOGLE);
    },
    hasGeneral: function hasGeneral() {
      if (this.settings.display && typeof this.settings.display.ShowBalanceHeader !== 'undefined') {
        return true;
      }
      return false;
    },
    hasPrivacy: function hasPrivacy() {
      if (this.settings.privacy && typeof this.settings.privacy.ShowTradeHistory !== 'undefined' && typeof this.settings.privacy.AllowLeaderboard !== 'undefined') {
        return true;
      }
      return false;
    },
    hasUX: function hasUX() {
      return this.settings.ux && typeof this.settings.ux.UXSettingBuyColorScheme !== 'undefined' && typeof this.settings.ux.UXSettingMobileContractLayout !== 'undefined' && typeof this.settings.ux.UXSettingPriceDisplay !== 'undefined';
    },
    hasPush: function hasPush() {
      if (this.settings.PushNotifications && typeof this.settings.PushNotifications.AllowPushNotifications !== 'undefined') {
        this.sectionPushEnabled = this.settings.PushNotifications.AllowPushNotifications;
        return true;
      }
      return false;
    },
    isPushDisabled: function isPushDisabled() {
      return !this.sectionPushEnabled;
    },
    haveSettingsLoaded: function haveSettingsLoaded() {
      return this.hasGeneral || this.hasPrivacy || this.hasPush;
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.clearSettings();
    this.getAllSettings().then(this.checkManageInfo).then(function () {
      _this.manageInfoLoaded = true;
    }).then(function () {
      return _this.getExternalLogins({
        type: __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* default */].SOCIAL_LOGIN_ADD
      });
    }).then(function (response) {
      _this.links = response.data;
    }).then(function () {
      _this.loaderRemove(document.body);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getManageInfo', 'removeExternal', 'logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getAllSettings', 'clearSettings']), {
    checkProvider: function checkProvider(x, target) {
      return x.loginProvider.toLowerCase() === target.toLowerCase();
    },
    checkLogin: function checkLogin(target) {
      var _this2 = this;

      return this.logins && this.logins.length > 0 && this.logins.filter(function (x) {
        return _this2.checkProvider(x, target);
      }).length === 1;
    },
    getProviderKey: function getProviderKey(target) {
      var _this3 = this;

      if (this.logins && this.logins.length > 0) {
        var login = this.logins.filter(function (x) {
          return _this3.checkProvider(x, target);
        })[0];
        return login ? login.providerKey : {};
      }
      return {};
    },
    checkManageInfo: function checkManageInfo() {
      var _this4 = this;

      return this.getManageInfo().then(function (data) {
        _this4.hasLocalPassword = data.hasLocalPassword;
        _this4.logins = data.logins;
      });
    },
    onToggleProvider: function onToggleProvider(provider, value) {
      var _this5 = this;

      if (value) {
        if (!this.isWrapperApp) {
          this.loaderAdd(document.body);
        }
        try {
          if (provider === PROVIDER_FACEBOOK) this.facebookLinkClick();
          if (provider === PROVIDER_TWITTER) this.twitterLinkClick();
          if (provider === PROVIDER_GOOGLE) this.googleLinkClick();
        } catch (err) {
          this.loaderRemove(document.body);
          console.error(err);
        }
      } else {
        var payload = {
          loginProvider: provider,
          providerKey: this.getProviderKey(provider)
        };
        this.removeExternal(payload).then(function () {
          return _this5.setSuccessSideNotification('Settings updated successfully.');
        }).then(this.getAllSettings).then(this.checkManageInfo).catch(function () {
          return _this5.setErrorSideNotification('Error has occured.');
        });
      }
    },
    onToggleSetting: function onToggleSetting(item) {
      if (item.key === 'AllowLeaderboard') {
        this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_LEADERBOARDS_UPDATE_INFO);
      }
    },
    onSetPassword: function onSetPassword() {
      this.$router.push({ name: 'password-set' });
    },
    doError: function doError(e) {
      this.setErrorSideNotification(e);
    },
    togglePush: function togglePush(e) {
      this.sectionPushEnabled = e;
    }
  })
});

/***/ }),

/***/ "ooVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FINISHED_STATUS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNumber__ = __webpack_require__("J009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__("q16o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy__ = __webpack_require__("uN7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_wallet_deposited_deposited_vue__ = __webpack_require__("WXHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_bank_account_bank_account_vue__ = __webpack_require__("5r1F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_processing_transaction_processing_transaction_vue__ = __webpack_require__("eGtO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_depositWarningMixin__ = __webpack_require__("Scap");





/* global PayWithMyBank */
/* eslint-disable */















var AMOUNT_STEP_ONE = 10;
var AMOUNT_STEP_THREE = 50;
var AMOUNT_STEP_FOUR = 100;

var CLOSE_PAYMENT_SUCCESS_TIMEOUT = 1500;

var ERROR_MESSAGE_GENERIC = 'Unable to remove the authorization, please try again later.';

var randomNumber = function randomNumber() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;
  return Math.floor(Math.random() * (max - min + 1) + min);
};

var STEPS = {
  INITIAL: 1,
  AMOUNT_CONFIRM: 2,
  CONFIRM: 3,
  PROCESSING: 4,
  FINISHED_SUCCESS: 5,
  FINISHED_FAILED: 6,
  FINISHED_EXPIRED: 7
};

var FINISHED_STATUS = {
  SUCCESS: 1,
  FAILED: 2,
  EXPIRED: 3
};

/* harmony default export */ __webpack_exports__["c"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_vuelidate__["validationMixin"], __WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_depositWarningMixin__["a" /* default */]],
  components: {
    bankAccount: __WEBPACK_IMPORTED_MODULE_15__components_bank_account_bank_account_vue__["a" /* default */],
    processingTransaction: __WEBPACK_IMPORTED_MODULE_16__components_processing_transaction_processing_transaction_vue__["a" /* default */],
    deposited: __WEBPACK_IMPORTED_MODULE_13__components_wallet_deposited_deposited_vue__["a" /* default */]
  },
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    instantCreditData: {}
  },
  data: function data() {
    return {
      errors: [],
      fields: {},
      isFormEnabled: true,
      timeout: null,
      amount: 0,
      disclaimer: '',
      payWithMyBankId: 'paywithmybank-' + randomNumber(),
      canDeposit: false,
      smallPopupShown: false,
      depositAmounts: [AMOUNT_STEP_ONE, AMOUNT_STEP_THREE, AMOUNT_STEP_FOUR],
      currentStep: STEPS.INITIAL,
      currentStepData: {},
      requestSignature: '',
      authorizationId: null,
      errorMessage: '',
      refreshDataObject: {},
      existingAccounts: [],
      account: null,
      STEPS: STEPS,
      instantCreditDetail: this.instantCreditData
    };
  },
  validations: function validations() {
    return {
      amount: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["a" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('wallet', ['depositMethods', 'bankTransferStep']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('user', ['status']), {
    accountUploadDocumentTheme: function accountUploadDocumentTheme() {
      return this.isPopup ? '' : 'page-padded';
    },
    classModifiers: function classModifiers() {
      return {
        'add-funds-bank-transfer': true,
        'add-funds-bank-transfer--popup': this.isPopup,
        'add-funds-bank-transfer--regular': !this.isPopup
      };
    },
    alertBoxPromoModifiers: function alertBoxPromoModifiers() {
      return {
        'add-funds-bank-transfer__alert-box': true,
        'add-funds-bank-transfer__alert-box--promo-popup': this.isPopup
      };
    },
    infoAmount: function infoAmount() {
      var number = Number(this.amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + number;
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    },
    amountHasError: function amountHasError() {
      return this.$v.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_getValidationMessage__["a" /* default */])(this.$v.amount);
    },
    minimumDepositAmount: function minimumDepositAmount() {
      return this.depositMethods.minimumDepositAmount || 10.0;
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    isFormDisabled: function isFormDisabled() {
      return this.isFormEnabled === false;
    },
    invalidOrDisabled: function invalidOrDisabled() {
      return this.$v.$invalid || !this.isFormEnabled;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions', 'setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('wallet', ['getDepositPWMB', 'deletePWMBAccount', 'confirmDepositPWMB', 'submitDepositPWMB']), {
    formIsValid: function formIsValid() {
      return !this.$v.$invalid;
    },
    formEnable: function formEnable() {
      this.isFormEnabled = true;
    },
    formDisable: function formDisable() {
      this.formReset();
      this.isFormEnabled = false;
      return true;
    },
    formReset: function formReset() {
      this.errors = [];
    },
    onSuccess: function onSuccess() {
      if (this.isPopup) {
        this.setCurrentPopup();
      } else {
        this.onLoadInitial();
      }
    },
    isStep: function isStep(name) {
      return this.currentStep === name;
    },
    cleanup: function cleanup() {
      if (typeof PayWithMyBank !== 'undefined') {
        PayWithMyBank.destroy();
      }
    },
    handleAmountBlur: function handleAmountBlur() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      });
    },
    handleDepositFail: function handleDepositFail(error) {
      this.currentStepData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentStepData, {
        error: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '')
      });
      this.currentStep = STEPS.FINISHED_FAILED;
    },
    onRemove: function onRemove(account) {
      var _this = this;

      this.errorMessage = '';
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PWMB_ACCOUNT_CONFIRM_DELETE);
      this.smallPopupShown = true;
      this.setCurrentPopupOptions({
        onConfirm: function onConfirm() {
          _this.loaderAdd();
          _this.deletePWMBAccount(account.authorizationId).then(function (data) {
            if (data) {
              _this.setup({ loadWidget: false });
            } else {
              _this.errorMessage = ERROR_MESSAGE_GENERIC;
            }
            _this.loaderRemove();
            _this.smallPopupShown = false;
            _this.setCurrentSmallPopup();
          }).catch(function () {
            _this.errorMessage = ERROR_MESSAGE_GENERIC;
            _this.loaderRemove();
            _this.smallPopupShown = false;
            _this.setCurrentSmallPopup();
          });
        }
      });
    },
    onSelect: function onSelect(account) {
      if (account.accountStatus === 2) {
        this.authorizationId = account.authorizationId;
        this.account = account;
        this.setup({ authorizationId: account.authorizationId });
      } else {
        this.authorizationId = account.authorizationId;
        this.account = account;
        this.cleanup();
        this.currentStep = STEPS.AMOUNT_CONFIRM;
      }
    },
    onLoadInitial: function onLoadInitial() {
      this.currentStep = STEPS.INITIAL;
      this.setup();
    },
    onCancelConfirm: function onCancelConfirm() {
      this.currentStep = STEPS.AMOUNT_CONFIRM;
    },
    onReviewAndConfirm: function onReviewAndConfirm() {
      var _this2 = this;

      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'submit',
        label: 'Submit Deposit'
      });
      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd();
        var payload = {
          amount: this.amount
        };
        this.confirmDepositPWMB(payload).then(function (data) {
          _this2.loaderRemove();
          _this2.formEnable();
          if (_this2.checkDocumentUploadFlags(data)) return;
          _this2.currentStep = STEPS.CONFIRM;
        }).catch(function (error) {
          _this2.loaderRemove();
          if (_this2.checkDocumentUploadFlags(error.response.data)) return;
          _this2.formEnable();
          _this2.handleDepositFail(error);
        });
      }
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.formDisable();
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      });
      this.loaderAdd();
      var payload = {
        amount: this.amount,
        pwmbAuthorizationId: this.authorizationId
      };
      this.submitDepositPWMB(payload).then(function (data) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(data)) return;
        _this3.$gtm.trackEvent({ event: _this3.status.hasBeenFunded ? 'MultiDeposit' : 'Deposit' });
        if (data.isBankReauthorizationRequired) {
          _this3.currentStep = STEPS.FINISHED_EXPIRED;
          _this3.setupReauthorization();
        } else if (data.waitForResponseEvent) {
          _this3.currentStep = STEPS.PROCESSING;
        } else {
          setTimeout(function () {
            _this3.setCurrentPopup();
          }, CLOSE_PAYMENT_SUCCESS_TIMEOUT);
        }
        _this3.formEnable();
      }).then(this.getBalance).catch(function (error) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(error.response.data)) return;
        _this3.formEnable();
        _this3.handleDepositFail(error);
      });
    },
    setup: function setup() {
      var _this4 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$loadWidget = _ref.loadWidget,
          loadWidget = _ref$loadWidget === undefined ? true : _ref$loadWidget,
          _ref$authorizationId = _ref.authorizationId,
          authorizationId = _ref$authorizationId === undefined ? '' : _ref$authorizationId;

      var url = window.location.origin + window.location.pathname;
      var payload = {
        returnUrl: url + '?pwmbDeposit=success',
        cancelUrl: url + '?pwmbDeposit=cancel',
        authorizationId: authorizationId
      };
      this.loaderAdd();
      return this.getDepositPWMB(payload).then(function (data) {
        _this4.loaderRemove();
        _this4.checkDocumentUploadFlags(data);
        _this4.errorMessage = data.errorMessage;
        _this4.promoCodeDetail = data.promoCodeDetail || {};
        _this4.disclaimer = data.disclaimer;
        _this4.canDeposit = data.canDeposit;
        _this4.existingAccounts = data.existingAccounts || [];
        if (loadWidget && data.refreshDataObject && _this4.$refs.paywithmybank) {
          _this4.loadWidget(data);
        }
        return data;
      }).catch(function (error) {
        _this4.loaderRemove();
        _this4.errorMessage = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
      });
    },
    loadWidget: function loadWidget(apiData) {
      var _this5 = this;

      this.refreshDataObject = apiData.refreshDataObject;
      this.amount = apiData.refreshDataObject.amount;
      this.requestSignature = apiData.pwmbRequestSignature;
      var url = apiData.refreshDataObject.pwmbSDKUrl;
      if (this.$refs.paywithmybank) {
        this.loaderAdd(this.$refs.paywithmybank.parentElement, 'is-loading', false);
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["b" /* loadScript */])(url, 'PayWithMyBank').then(function () {
        setTimeout(function () {
          if (_this5.$refs.paywithmybank) {
            _this5.loaderRemove(_this5.$refs.paywithmybank.parentElement, 'is-loading', false);
          }
        }, 2000);
        var options = {
          closeButton: false,
          dragAndDrop: true,
          widgetContainerId: _this5.payWithMyBankId
        };
        var data = __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, apiData.refreshDataObject, {
          requestSignature: apiData.pwmbRequestSignature
        }), __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a);

        PayWithMyBank.addPanelListener(function (command, obj) {
          switch (command) {
            case 'event':
              switch (obj.type) {
                case 'close':
                  if (_this5.currentStep === STEPS.FINISHED_EXPIRED) {
                    _this5.onLoadInitial();
                  }
                  break;
                case 'new_location':
                  obj.preventDefault();
                  break;
                default:
                  break;
              }
              break;
            default:
              break;
          }
        });
        if (apiData.refreshDataObject.authToken) {
          PayWithMyBank.establish(data, options);
        } else {
          PayWithMyBank.selectBankWidget(data, options);
        }
      });
    },
    onUpdateAmount: function onUpdateAmount(value) {
      if (this.amount === '' || Number(this.amount) === 0.0) {
        this.amount = value;
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNumber___default()(this.amount)) {
        this.amount = Number(this.amount) + value;
      } else {
        this.amount = Number(this.amount) + value;
      }
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + value + ' Button'
      });
    },
    setupReauthorization: function setupReauthorization() {
      var _this6 = this;

      this.timeout = window.setTimeout(function () {
        _this6.setup({
          authorizationId: _this6.account.authorizationId
        });
      }, 3500);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13 && this.smallPopupShown) {
        this.smallPopupShown = false;
        this.setCurrentSmallPopup();
      }
    },
    currentStepHandler: function currentStepHandler(value) {
      this.$emit('step', value);
    }
  }),
  watch: {
    bankTransferStep: function bankTransferStep(value) {
      var _this7 = this;

      this.currentStep = value.step;
      this.currentStepData = value.stepData;
      if (value.step === STEPS.AMOUNT_CONFIRM) {
        this.cleanup();
        this.setup({ loadWidget: false }).then(function (data) {
          _this7.authorizationId = _this7.currentStepData.pwmbAuthorizationId;
          _this7.account = data.existingAccounts.find(function (i) {
            return i.authorizationId === _this7.authorizationId;
          });
        });
      } else if (value.step === STEPS.FINISHED_EXPIRED) {
        this.cleanup();
        this.setup({ loadWidget: false }).then(function (data) {
          _this7.authorizationId = _this7.currentStepData.pwmbAuthorizationId;
          _this7.account = data.existingAccounts.find(function (i) {
            return i.authorizationId === _this7.authorizationId;
          });
        }).then(function () {
          return _this7.setupReauthorization();
        });
      } else if (value.step === STEPS.CONFIRM) {
        this.amount = Number(this.currentStepData.prefilledAmountToDeposit);
      }
    },

    currentStep: {
      handler: 'currentStepHandler',
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
    window.removeEventListener('keyup', this.onKeyDown);
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
  },
  mounted: function mounted() {
    this.setup();
    window.addEventListener('keyup', this.onKeyDown);
  }
});

/***/ }),

/***/ "opDZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "otBS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_sushi_mobile_bar_js__ = __webpack_require__("x6Bg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5036d036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_sushi_mobile_bar_vue__ = __webpack_require__("J8fB");
function injectStyle (ssrContext) {
  __webpack_require__("+11a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_sushi_mobile_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5036d036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_sushi_mobile_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "owqz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAt1BMVEUAAACzxsa5xsa3xcX///+5xce4xca7zMy4xca4xcW4xca5xce3xMa5xMe4xca7xMS4xca4w8O5w8i4xca4xca4xca3xca4xcW/v7+5xcW5xcW5xcWqqqq3w8e3xsa5udG4xcW4xce4xMS4xcW5xce3xsa4xcaxxMS4xca4xce4xMa3xcW4xsa4xsa5xcW5xsa4xMS4xca4xca4xsa3xMa2yMi5xce4xMa4xcW4xca5xca4xcYAAACBS8jKAAAAO3RSTlMAG0xYAW3mD7yf8pVjSdQe/C8z/tPXq6gMPlQsA0BRC13QK3PHQ+ENwoy7avS/FpxB6PmBixyRocbs4TuKakIAAAABYktHRACIBR1IAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4gwECBkTzGfTAQAAASpJREFUWMPtlnlPwkAQxRe2HC1XoYWCyqECHqAihwLv+38vuxuI2hLSnSGBkL5/Nt12ftl5M+mOEKlSXY4yWWmsbGYfbeXyICmfs1R8oUgLVyoWQoANOKWyeQrlkgPYQlSAao3mXK0KVMIDuHWq9w0vPIIPn169ZhjsokUHtOAKINg9tTtS3tzeHfrQ6kYc7PX1fgD8AgaOrsz9wwHAY6yAwxhg5O1ejZ9ogGd4L1IOXoEJLYUp3tTyDnwkN/EvILqeFjD7jFgwX5ilsIyZODYzcfUV/Nf3zKyMSTw42kiJAMdaORmAoKsBrM1/qHutNYCnUwA29BQ2GrClm7i9FgDbxPP3AbOV2ZerjyYdoK53G16DGq8HDPaIwx6y+GMee9BU4o26qVJdgH4ANBK/Pw4bXI4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMTItMDRUMDg6MjU6MTkrMDE6MDADEIs/AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTEyLTA0VDA4OjI1OjE5KzAxOjAwck0zgwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),

/***/ "p+/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_story_detail_js__ = __webpack_require__("xVgH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47be75e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_story_detail_vue__ = __webpack_require__("NP+F");
function injectStyle (ssrContext) {
  __webpack_require__("kFFz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_story_detail_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47be75e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_story_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p1CT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authorizeApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_interceptors_request__ = __webpack_require__("drjh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_interceptors_responseSuccess__ = __webpack_require__("rxGt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_interceptors_responseError__ = __webpack_require__("P3oX");





var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "/"
});

http.interceptors.request.use(__WEBPACK_IMPORTED_MODULE_1__services_interceptors_request__["a" /* default */]);
http.interceptors.response.use(__WEBPACK_IMPORTED_MODULE_2__services_interceptors_responseSuccess__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__services_interceptors_responseError__["a" /* default */]);

function authorizeApi(token) {
  if (token) {
    http.defaults.headers.common.Authorization = 'Bearer ' + token;
  } else {
    delete http.defaults.headers.common.Authorization;
  }
}

/* harmony default export */ __webpack_exports__["b"] = (http);


/***/ }),

/***/ "p8N8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p8bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_avatar_account_social_avatar_vue__ = __webpack_require__("ROsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  components: {
    accountSocialAvatar: __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_avatar_account_social_avatar_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['watchedUserDetails']), {
    userLevel: function userLevel() {
      if (this.watchedUserDetails.traderLevel) {
        return this.getLevelByNumber(this.watchedUserDetails.traderLevel);
      }
      return this.getLevelByPredictions(this.watchedUserDetails.profitablePredictions);
    }
  })
});

/***/ }),

/***/ "pM6l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pMeB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pNYZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pPYv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pSXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-research"},[_vm._v("\n  sushi-market-research\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "paCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "pbJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      dontShowAgain: false,
      swiperOptions: {
        direction: 'horizontal',
        pagination: '.attach-to-home__pagination',
        paginationClickable: true
      },
      items: [{
        textTop: 'Follow these quick steps to a place a PredictIt icon on your iPhone.',
        image: 'step1',
        textBottom: 'First, hit the share button in the footer at the bottom of the screen (available in Safari only).'
      }, {
        textTop: 'Scroll left and tap the icon in the image below.',
        image: 'step2',
        textBottom: ''
      }, {
        textTop: "Choose a simple title, hit 'Add' and you are set to go!",
        image: 'step3',
        textBottom: ''
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['dontShowAttachToHomeNotification'])),
  beforeDestroy: function beforeDestroy() {
    if (this.dontShowAgain) this.dontShowAttachToHomeNotification();
  }
});

/***/ }),

/***/ "pfo7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pfv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialised)?_c('div',[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{staticClass:"account-details-update form content-header__section-group",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[(_vm.usernameTries === 3)?_c('p',{staticClass:"account-details-update__disclaimer"},[_vm._v("You can change your username up to three times only.")]):(_vm.usernameTries === 2)?_c('p',{staticClass:"account-details-update__disclaimer"},[_vm._v("You have changed your username once already. You can change it twice more only.")]):(_vm.usernameTries === 1)?_c('p',{staticClass:"account-details-update__disclaimer"},[_vm._v("You have changed your username twice already. You can change it once more only.")]):_c('p',{staticClass:"account-details-update__disclaimer"},[_vm._v("You have changed your username three times already. You cannot change it further.")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{staticClass:"account-details-update__current-username",attrs:{"disabled":true,"name":"nickname","type":"text","autocomplete":"off","placeholder":"Current Username"},model:{value:(_vm.fields.username),callback:function ($$v) {_vm.$set(_vm.fields, "username", $$v)},expression:"fields.username"}})],1),_vm._v(" "),(_vm.usernameTries > 0)?_c('div',{staticClass:"small-12 column"},[_c('form-input',{ref:"newUsername",attrs:{"validation":_vm.$v.fields.newUserName,"disabled":_vm.isUsernameInputDisabled,"name":"nickname","type":"text","autocomplete":"off","gtm":"Registration,User Name","placeholder":"New Username"},on:{"input":_vm.$v.fields.newUserName.$touch},model:{value:(_vm.fields.newUserName),callback:function ($$v) {_vm.$set(_vm.fields, "newUserName", $$v)},expression:"fields.newUserName"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"account-details-update__buttons"},[(_vm.usernameTries > 0)?_c('form-submit',{attrs:{"disabled":_vm.isSubmitButtonDisabled,"label":"Confirm"}}):_vm._e()],1)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pgVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String,
      required: true
    },
    infoOnLeft: {
      type: Boolean,
      default: true
    },
    selected: Boolean
  },
  data: function data() {
    return {};
  },

  computed: {
    selectedModifier: function selectedModifier() {
      return {
        'button-with-info--selected': this.selected
      };
    },
    iconModifier: function iconModifier() {
      return {
        'button-with-info__icon--right': !this.infoOnLeft
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    },
    onInfoClick: function onInfoClick() {
      this.$emit('infoClick');
    }
  }
});

/***/ }),

/***/ "poL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-list-v2-embed-compact"},[_c('div',{staticClass:"market-contract-list-v2-embed-compact__title"},[_vm._v(_vm._s(_vm.items[0].marketName))]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('div',{key:("market-contract-list-v2-embed-compact-" + index + "-" + (item.marketId)),staticClass:"market-contract-info-v2__widget-item"},[_c('market-contract-info-v2',{attrs:{"image":item.image,"link":_vm.itemLink(item),"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__value-light market-contract-list-v2-embed-compact__contract-name"},[_vm._v(_vm._s(item.contractName))]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-light-darker market-contract-info-v2--mono"},[_c('market-change-price',{attrs:{"price":item.price,"lastClosePrice":item.lastClosePrice}}),_vm._v(" "),(item.hasLastTradePrice)?[_c('animated-number',{staticClass:"market-contract-list-v2-embed-compact__item-price-box",attrs:{"value":item.priceAsCents}})]:[_c('span',{staticClass:"market-contract-list-v2-embed-compact__item-price-box"},[_vm._v("NEW")])]],2)])]},proxy:true}],null,true)})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "poum":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "pqmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { contentHeader: __WEBPACK_IMPORTED_MODULE_0__components_generics_content_header_content_header_vue__["a" /* default */] },
  computed: {
    title: function title() {
      return this.url.includes('news.predictit') ? "What's New?" : 'Analysis';
    },
    url: function url() {
      // because atob errors on slug === undefined
      return this.$route.params.slug ? atob(decodeURI(this.$route.params.slug)) : '';
    }
  }
});

/***/ }),

/***/ "ptZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_price_change_chart_js__ = __webpack_require__("1Lmp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eac342e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_price_change_chart_vue__ = __webpack_require__("aLRO");
function injectStyle (ssrContext) {
  __webpack_require__("iOdY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_price_change_chart_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eac342e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_price_change_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q+s1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q/wu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q1K7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_winner_v2_js__ = __webpack_require__("4v/L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1da946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_winner_v2_vue__ = __webpack_require__("jWsT");
function injectStyle (ssrContext) {
  __webpack_require__("s8MB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_winner_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1da946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_winner_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q3Wh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q5rS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qAAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.shouldShowDesktopList || _vm.shouldShowMobileSlider)?_c('div',{staticClass:"market-biggest-gains__swiper-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e(),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"content-loader-item"},[_c('biggest-gains-loader')],1)}),0):[(_vm.shouldShowMobileSlider)?_c('div',[_c('swiper',{ref:"market-biggest-gains-slider",staticClass:"market-biggest-gains__slider",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(promo){return _c('swiper-slide',{key:promo.id,staticClass:"market-biggest-gains__slide"},[_c('market-biggest-gains-element',{attrs:{"promo":promo[0]}}),_vm._v(" "),_c('market-biggest-gains-element',{attrs:{"promo":promo[1],"header":false}})],1)}),1)],1):_vm._e(),_vm._v(" "),(_vm.shouldShowDesktopList)?_c('div',{staticClass:"row"},_vm._l((_vm.items),function(promo){return _c('div',{key:promo.id,staticClass:"market-biggest-gains__slide"},[_c('market-biggest-gains-element',{attrs:{"promo":promo}})],1)}),0):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qIn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_icon_js__ = __webpack_require__("4/Ye");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_601e8d5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_icon_vue__ = __webpack_require__("tjGv");
function injectStyle (ssrContext) {
  __webpack_require__("7vAe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_601e8d5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qUrc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"related-contracts-sushi"},[(!_vm.isComponentReady)?_vm._l((_vm.loaderItems(4)),function(item){return _c('div',{staticClass:"content-loader-item"},[_c('contract-info-loader')],1)}):[(_vm.relatedContracts.length === 0)?_c('div',{staticClass:"related-contracts-sushi__note"},[_vm._v("\n      No contracts to display.\n    ")]):_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"market-contract-info-v2__widget-item"},[_c('market-contract-info-v2',{attrs:{"market":item,"image":item.image,"link":_vm.itemLink(item),"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY,"useCurrentPriceSymbol":true}})],1)})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qXT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






function getPriceOrZero(target) {
  // value may be empty or can come as fraction like 0.99 or 99
  if (isNaN(target)) return 0;
  return target < 1 ? Math.round(100 * target) : Math.round(target);
}

function _hasPrice(target) {
  return getPriceOrZero(target) > 0;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    widget: Object,
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'market-money-widget': true
      }, 'market-money-widget--' + this.theme, this.theme);
    },
    iconModifiers: function iconModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'market-money-widget__icon': true
      }, 'market-money-widget__icon--' + this.iconTargetClass, this.iconTargetClass);
    },
    iconTargetClass: function iconTargetClass() {
      return this.delta ? 'price-up' : 'price-down';
    },
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    hasPrice: function hasPrice() {
      return _hasPrice(this.obj.lastTradePrice);
    },
    price: function price() {
      return getPriceOrZero(this.obj.lastTradePrice);
    },
    delta: function delta() {
      if (!this.hasPrice) {
        return 0;
      }
      return getPriceOrZero(this.obj.lastTradePrice) - getPriceOrZero(this.obj.lastClosePrice);
    },
    percent: function percent() {
      var value = (this.obj.percentValue || '0').toString();
      if (value.endsWith('%')) {
        return value;
      }
      var parsed = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(value, 10);
      return isNaN(parsed) ? '0%' : parsed + '%';
    },
    contractName: function contractName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* isMarketSingle */])(this.obj) ? 'Latest Price' : this.obj.contractName;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.obj.marketId,
          marketUrl: this.obj.marketUrl
        }
      });
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "qYhg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_dollar_sign_round_green_svg__ = __webpack_require__("kHwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_dollar_sign_round_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_icons_dollar_sign_round_green_svg__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    level: {
      type: String,
      default: 'success'
    },
    icon: {
      type: String,
      default: null
    }
  },
  computed: {
    iconSrc: function iconSrc() {
      if (this.icon === 'dollar') {
        return __WEBPACK_IMPORTED_MODULE_0__assets_icons_dollar_sign_round_green_svg___default.a;
      }
      return null;
    },
    levelModifier: function levelModifier() {
      return 'alert-box--' + this.level;
    }
  }
});

/***/ }),

/***/ "qZUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-rules"},[_c('div',{attrs:{"id":"market-rules"}}),_vm._v(" "),_c('div',{class:_vm.marginBoxClass},[_c('div',{ref:"wrap",class:_vm.wrapperClass},[_c('market-rules-content',{ref:"content",attrs:{"market":_vm.market}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qg25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PROCESSING_TRANSACTION_TIMEOUT = 60;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      timeout: null,
      showTimeout: false
    };
  },

  methods: {
    openWithdrawalHistory: function openWithdrawalHistory() {
      this.getBalance();
      this.setCurrentPopup();
      this.$router.push({ name: 'account-history', query: { tabId: 'deposit-withdrawals' } });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.timeout = setTimeout(function () {
      _this.showTimeout = true;
    }, PROCESSING_TRANSACTION_TIMEOUT * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
});

/***/ }),

/***/ "qidN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LS_MAINTENANCE_MESSAGE_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__ = __webpack_require__("Moaq");




var LS_MAINTENANCE_MESSAGE_KEY = 'maintenanceMessageHidden';

/* harmony default export */ __webpack_exports__["b"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasBanner']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred', 'maintenance', 'liveUpdatesDisabled', 'hiddenMaintenanceMessage']), {
    classModifiers: function classModifiers() {
      return {
        'app-header-notification__wrapper': true
      };
    },
    maintenanceMessageText: function maintenanceMessageText() {
      return this.maintenance.suspendedMessage || this.maintenance.systemMessage;
    },
    hasServerMessage: function hasServerMessage() {
      return !!this.maintenanceMessageText && this.maintenanceMessageText !== this.hiddenMaintenanceMessage;
    },
    showErrorNotification: function showErrorNotification() {
      return !this.hasServerMessage && this.hasServerErrorOccurred;
    },
    showBannerNotification: function showBannerNotification() {
      return !this.hasServerMessage && this.hasBanner && !this.hasServerErrorOccurred;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['dontShowBanner', 'setServerError', 'setHiddenMaintenanceMessage']), {
    onCloseMaintenanceMessage: function onCloseMaintenanceMessage() {
      var expiresAt = 86400 * 3; // 3 days
      __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].set(LS_MAINTENANCE_MESSAGE_KEY, this.maintenanceMessageText, expiresAt);
      this.setHiddenMaintenanceMessage(this.maintenanceMessageText);
    },
    onErrorClick: function onErrorClick() {
      this.setServerError(false);
      var dt = new Date();
      this.$router.go({
        path: this.$router.path,
        query: {
          t: +dt
        }
      });
    },
    onBannerClick: function onBannerClick() {
      this.dontShowBanner();
    },
    onSystemMessageClick: function onSystemMessageClick() {
      this.$router.push({ name: 'platform-announcements' });
    }
  })
});

/***/ }),

/***/ "qjJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{staticClass:"account-address-update form content-header__section-group",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[(_vm.countries.length > 1)?_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.country,"placeholder":"Country","options":_vm.countries,"track-by":"value","label":"label","required":true},on:{"input":_vm.$v.fields.country.$touch},model:{value:(_vm.fields.country),callback:function ($$v) {_vm.$set(_vm.fields, "country", $$v)},expression:"fields.country"}}):_c('form-input',{attrs:{"tabindex":8,"name":"country","placeholder":"Country","track-by":"value","label":"label","gtm":"ID Verification,Country","disabled":true},model:{value:(_vm.fields.country.label),callback:function ($$v) {_vm.$set(_vm.fields.country, "label", $$v)},expression:"fields.country.label"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.address,"name":"street","type":"text","required":true,"autocomplete":"street-address","placeholder":"House/Number/Street name"},on:{"input":_vm.$v.fields.address.$touch},model:{value:(_vm.fields.address),callback:function ($$v) {_vm.$set(_vm.fields, "address", $$v)},expression:"fields.address"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-6 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.city,"name":"city","type":"text","required":true,"autocomplete":"address-line1","placeholder":"Town/City"},on:{"input":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.zipCode,"name":"zipCode","type":"text","required":_vm.fields.country.required,"autocomplete":"postal-code","placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"account-address-update__buttons"},[_c('form-submit',{attrs:{"disabled":_vm.isSubmitButtonDisabled,"label":"Next"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qrpg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");





var appNotificationMixin = {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: true
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    index: {
      type: Number,
      required: true
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      timeout: null,
      interacted: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['remove']), {
    onClose: function onClose() {
      this.remove(this.index);
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  computed: {
    isDebug: function isDebug() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__logger__["b" /* isDebugOn */])();
    },
    showAutoCloseLoader: function showAutoCloseLoader() {
      return this.autoClose && this.closeTimeout > 0 && !this.interacted && !this.isDebug;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !this.isDebug) {
      this.timeout = setTimeout(function () {
        if (!_this.interacted) _this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.onClose();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (appNotificationMixin);

/***/ }),

/***/ "qvFU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_levels_js__ = __webpack_require__("z++8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9f61f96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_levels_vue__ = __webpack_require__("IQRz");
function injectStyle (ssrContext) {
  __webpack_require__("czMQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_levels_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9f61f96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_levels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qyl+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_contract_horizontal_sushi_common_betslip_market_contract_horizontal_sushi_common_betslip_vue__ = __webpack_require__("M+zr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_contracts_list_header_sushi_common_betslip_market_contracts_list_header_sushi_common_betslip_vue__ = __webpack_require__("G1f8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_purchase_inline_sushi_purchase_inline_sushi_vue__ = __webpack_require__("T8v5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_related_contracts_sushi_related_contracts_sushi_vue__ = __webpack_require__("P4uE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_page_market_detail_sushi_pages_sushi_market_contracts_components_sushi_market_top_comments_sushi_market_top_comments_vue__ = __webpack_require__("DkRA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_headerHeight__ = __webpack_require__("GHbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__ = __webpack_require__("X4WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_modules_app__ = __webpack_require__("WSTi");




















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_headerHeight__["a" /* default */]],
  components: {
    marketContractHorizontalSushi: __WEBPACK_IMPORTED_MODULE_5__components_market_market_contract_horizontal_sushi_common_betslip_market_contract_horizontal_sushi_common_betslip_vue__["a" /* default */],
    marketContractsListHeaderSushi: __WEBPACK_IMPORTED_MODULE_6__components_market_market_contracts_list_header_sushi_common_betslip_market_contracts_list_header_sushi_common_betslip_vue__["a" /* default */],
    purchaseInlineSushi: __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_purchase_inline_sushi_purchase_inline_sushi_vue__["a" /* default */],
    relatedContractsSushi: __WEBPACK_IMPORTED_MODULE_8__components_related_contracts_sushi_related_contracts_sushi_vue__["a" /* default */],
    sushiMarketTopComments: __WEBPACK_IMPORTED_MODULE_10__components_pages_page_market_detail_sushi_pages_sushi_market_contracts_components_sushi_market_top_comments_sushi_market_top_comments_vue__["a" /* default */]
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isPageTitleSticky: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      oddsReinit: false,
      oddsTimeout: null,
      shownOnInit: false,
      showAllContracts: false
    };
  },
  created: function created() {
    this.debouncedPurchaseJourneyOpened = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(this.purchaseJourneyOpened, 300);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['settingMobileLayout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('market', ['market', 'contracts']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'hidePurchaseForContractId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('user', ['status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    isStandardMobileLayout: function isStandardMobileLayout() {
      return this.isLayoutMobile && this.settingMobileLayout === __WEBPACK_IMPORTED_MODULE_17__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].STANDARD;
    },
    isSimplifiedMobileLayout: function isSimplifiedMobileLayout() {
      return this.isLayoutMobile && this.settingMobileLayout === __WEBPACK_IMPORTED_MODULE_17__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].SIMPLIFIED;
    },
    isCondensedMobileLayout: function isCondensedMobileLayout() {
      return this.isLayoutMobile && this.settingMobileLayout === __WEBPACK_IMPORTED_MODULE_17__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED;
    },
    marketDetailMobileLayout: function marketDetailMobileLayout() {
      return this.isLayoutMobile ? this.settingMobileLayout : null;
    },
    isSingleContractMarket: function isSingleContractMarket() {
      return this.isMarketSingle && this.contracts.length === 1;
    },
    singleContractId: function singleContractId() {
      return this.isSingleContractMarket ? this.contracts[0].contractId : null;
    },
    showRelatedContractsMobile: function showRelatedContractsMobile() {
      return this.isLayoutMobile && !this.isMarketDisabled && this.singleContractId !== null;
    },
    relatedContractsMobileContractId: function relatedContractsMobileContractId() {
      return this.showRelatedContractsMobile ? this.singleContractId : null;
    },
    betslipStyleModifiers: function betslipStyleModifiers() {
      var $toolbar = document.querySelector('.page-market-detail-sushi__toolbar');
      var $stickyTitle = document.querySelector('.page-market-detail-sushi__title--is-sticky');
      var toolbarHeight = $toolbar ? $toolbar.offsetHeight : 43;
      var stickyTitleHeight = this.isPageTitleSticky && $stickyTitle ? $stickyTitle.offsetHeight : 0;

      return {
        // Keep the old desktop breathing room above the order slip, then layer in
        // the sticky short-title height when that extra pinned row is active.
        top: this.headerHeight + 20 + stickyTitleHeight + toolbarHeight + 'px'
      };
    },
    visibleContracts: function visibleContracts() {
      return this.showAllContracts ? this.contracts : this.notHiddenContracts;
    },
    notHiddenContracts: function notHiddenContracts() {
      return this.contracts.filter(function (i) {
        return !i.hiddenByDefault;
      });
    },
    hiddenContracts: function hiddenContracts() {
      return this.contracts.filter(function (i) {
        return i.hiddenByDefault;
      });
    },
    shouldShowToggleMoreButton: function shouldShowToggleMoreButton() {
      return this.hiddenContracts.length > 0;
    },
    shouldInitializePurchaseOnInit: function shouldInitializePurchaseOnInit() {
      var _this = this;

      var isTradeOptionsValid = this.tradeOptions && this.tradeOptions.contractId;
      var isContractInMarket = isTradeOptionsValid && this.contracts.some(function (c) {
        return c.contractId === _this.tradeOptions.contractId;
      });

      if (isTradeOptionsValid && isContractInMarket) {
        return false;
      }

      return this.contracts.length > 0 && !this.isMarketDisabled && !this.shownOnInit;
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    hiddenContractsOffersOrSharesCount: function hiddenContractsOffersOrSharesCount() {
      if (this.hiddenContracts.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default()(this.hiddenContracts, __WEBPACK_IMPORTED_MODULE_12__utils_helpers__["w" /* contractOwnershipNum */]);
      }
      return 0;
    },
    toggleMoreModifiers: function toggleMoreModifiers() {
      return {
        'sushi-market-contracts__toggle': true,
        'sushi-market-contracts__toggle--offers-or-shares': this.hiddenContractsOffersOrSharesCount > 0,
        'sushi-market-contracts__toggle--active': this.showAllContracts
      };
    },
    routeContractId: function routeContractId() {
      return parseInt(this.$route.query.contractId || '0', 10);
    },
    routeContractForceNoSide: function routeContractForceNoSide() {
      return (this.$route.query.no || '').toLowerCase() === 'true';
    },
    tradeOptionsAndHidePurchaseForContractId: function tradeOptionsAndHidePurchaseForContractId() {
      return {
        tradeOptions: this.tradeOptions,
        hidePurchaseForContractId: this.hidePurchaseForContractId,
        contractId: this.tradeOptions.contractId,
        wasActive: this.showInlinePurchase(this.tradeOptions.contractId)
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'setTradePrice', 'toggleHidePurchaseForContractId', 'setBottomWidgetFooterMode', 'setBottomBetSlipExtendedMode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    resetContractsViewForMarketChange: function resetContractsViewForMarketChange() {
      this.shownOnInit = false;
      this.showAllContracts = false;
    },
    shouldInitializePurchaseOnInitHandler: function shouldInitializePurchaseOnInitHandler(value) {
      var _this2 = this;

      if (value && this.visibleContracts.length > 0 && !this.shownOnInit) {
        this.shownOnInit = true;
        setTimeout(function () {
          if (_this2.routeContractId) {
            var inContracts = _this2.contracts.map(function (i) {
              return i.contractId;
            }).includes(_this2.routeContractId);
            var inHiddenContracts = _this2.hiddenContracts.map(function (i) {
              return i.contractId;
            }).includes(_this2.routeContractId);

            if (inContracts) {
              if (inHiddenContracts) {
                _this2.showAllContracts = true;
              }
              _this2.$nextTick(function () {
                _this2.openContract({ contractId: _this2.routeContractId, forceNoSide: _this2.routeContractForceNoSide });
              });
              return;
            }
          }
          _this2.openFirstContract();
        }, 250);
      }
    },
    hidePurchaseForDefaultPick: function hidePurchaseForDefaultPick(contractId) {
      var _this3 = this;

      if (!this.isLayoutMobile) return;

      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_14__logger__["a" /* default */].info('[PURCHASE] hiding for ' + contractId);
        _this3.toggleHidePurchaseForContractId(contractId);
      });
    },
    getDefaultButtonForContract: function getDefaultButtonForContract(contract) {
      var forceNoSide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (forceNoSide) {
        return __WEBPACK_IMPORTED_MODULE_15__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__["a" /* BUTTONS */].BUY_NO;
      }

      var contractModel = new __WEBPACK_IMPORTED_MODULE_9__models_contract__["a" /* default */](contract);
      return contractModel.mode === __WEBPACK_IMPORTED_MODULE_15__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__["c" /* VALUES */].NO ? __WEBPACK_IMPORTED_MODULE_15__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__["a" /* BUTTONS */].BUY_NO : __WEBPACK_IMPORTED_MODULE_15__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi__["a" /* BUTTONS */].BUY_YES;
    },
    selectDefaultContract: function selectDefaultContract(_ref) {
      var contractId = _ref.contractId,
          _ref$forceNoSide = _ref.forceNoSide,
          forceNoSide = _ref$forceNoSide === undefined ? false : _ref$forceNoSide;

      var contract = this.contracts.find(function (c) {
        return c.contractId === contractId;
      });
      if (!contract) {
        __WEBPACK_IMPORTED_MODULE_14__logger__["a" /* default */].info('[PURCHASE] no contract to open');
        return;
      }

      var button = this.getDefaultButtonForContract(contract, forceNoSide);
      __WEBPACK_IMPORTED_MODULE_14__logger__["a" /* default */].info('[PURCHASE] selecting default contract', contractId);

      this.setTradeOptions({
        contractId: contract.contractId,
        operationType: button.type,
        operationValue: button.value
      });
      this.pushSessionHistoryContract({
        value: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, contract, {
          marketName: this.market.marketShortName || this.market.marketName
        })
      });
      this.hidePurchaseForDefaultPick(contract.contractId);
      if (this.isLayoutMobile) {
        this.setBottomBetSlipExtendedMode(false);
      }
    },
    openContract: function openContract(_ref2) {
      var _this4 = this;

      var contractId = _ref2.contractId,
          _ref2$forceNoSide = _ref2.forceNoSide,
          forceNoSide = _ref2$forceNoSide === undefined ? false : _ref2$forceNoSide;

      setTimeout(function () {
        _this4.selectDefaultContract({ contractId: contractId, forceNoSide: forceNoSide });
      }, 250);
    },
    openFirstContract: function openFirstContract() {
      if (this.visibleContracts.length > 0) {
        var contractId = this.visibleContracts[0].contractId;
        this.selectDefaultContract({ contractId: contractId });
      }
    },
    purchaseJourneyOpened: function purchaseJourneyOpened(contractId) {
      var _this5 = this;

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_14__logger__["a" /* default */].info('[PURCHASE] journey opened', contractId);
        var $el = document.querySelector('[data-contract-id="' + contractId + '"]');
        if (!$el) {
          __WEBPACK_IMPORTED_MODULE_14__logger__["a" /* default */].info('[PURCHASE] journey opened cannot find contract');
          return;
        }
        var topOffset = _this5.headerHeight;

        if (_this5.isLayoutDesktop) {
          var $toolbar = document.querySelector('.page-market-detail-sushi__toolbar');
          if ($toolbar) {
            topOffset += $toolbar.offsetHeight;
          }
        } else {
          var $title = document.querySelector('.page-market-detail-sushi__title');
          if ($title) {
            topOffset += $title.offsetHeight;
          }
        }

        // Disabled atm
        if (!_this5.oddsReinit && _this5.isLayoutMobile && false) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_scrollTo__["a" /* default */])($el, 250, 'linear', null, topOffset);
        }
      }, 250);
    },
    onToggleMore: function onToggleMore() {
      this.showAllContracts = !this.showAllContracts;
    },
    onOpenDiscussion: function onOpenDiscussion() {
      this.$emit('open-discussion');
    },
    onOpenComment: function onOpenComment(comment) {
      this.$emit('open-comment', comment);
    },
    showInlinePurchase: function showInlinePurchase(contractId) {
      if (this.isCondensedMobileLayout) {
        return false;
      }
      if (this.tradeOptions && this.tradeOptions.contractId === contractId && this.hidePurchaseForContractId === contractId) {
        return false;
      }
      return this.tradeOptions && this.tradeOptions.contractId === contractId;
    }
  }),
  beforeDestroy: function beforeDestroy() {
    if (this.debouncedPurchaseJourneyOpened) {
      this.debouncedPurchaseJourneyOpened.cancel();
    }
    if (this.oddsTimeout) {
      clearTimeout(this.oddsTimeout);
    }
  },

  watch: {
    'tradeOptions.contractId': {
      handler: function handler(newId, oldId) {
        // clear show all for order book
        if (newId !== oldId && oldId) {
          __WEBPACK_IMPORTED_MODULE_16__helpers_localStorage__["a" /* default */].del('order_book_prices_show_all_' + oldId);
          __WEBPACK_IMPORTED_MODULE_16__helpers_localStorage__["a" /* default */].del('order_book_shares_show_all_' + oldId);
          __WEBPACK_IMPORTED_MODULE_16__helpers_localStorage__["a" /* default */].del('order_book_all_offers_show_all_' + oldId);
        }
      }
    },
    'market.marketId': function marketMarketId(value, oldValue) {
      if (!value || !oldValue || value === oldValue) {
        return;
      }

      this.resetContractsViewForMarketChange();
    },
    tradeOptionsAndHidePurchaseForContractId: function tradeOptionsAndHidePurchaseForContractId(newVal, oldVal) {
      // TODO: possible rmove for improve when switching tradeOptions and initializing scroll
      var newTradeOptions = newVal.tradeOptions;
      var newUpdateMarker = {
        tradeOptions: newVal.tradeOptions,
        hidePurchaseForContractId: newVal.hidePurchaseForContractId
      };
      var oldUpdateMarker = {
        tradeOptions: oldVal.tradeOptions,
        hidePurchaseForContractId: oldVal.hidePurchaseForContractId
      };

      var isNonEmpty = newTradeOptions && newTradeOptions.contractId;
      var updateTrigger = !__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(newUpdateMarker, oldUpdateMarker);
      var activeTrigger = newVal.wasActive !== oldVal.wasActive || newVal.contractId !== oldVal.contractId;
      var shouldDisplayJourney = newTradeOptions && (newTradeOptions.contractId || this.isMarketSingle) && this.showInlinePurchase(newTradeOptions.contractId);
      var shouldTriggerOpen = isNonEmpty && updateTrigger && activeTrigger && shouldDisplayJourney;

      if (shouldTriggerOpen) {
        this.debouncedPurchaseJourneyOpened(newTradeOptions.contractId);
      }
    },

    shouldInitializePurchaseOnInit: {
      handler: 'shouldInitializePurchaseOnInitHandler',
      immediate: true
    }
  }
});

/***/ }),

/***/ "qzFn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "r/18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r5bH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "r6f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_attach_to_home_js__ = __webpack_require__("pbJv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_970c6b88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attach_to_home_vue__ = __webpack_require__("MFJf");
function injectStyle (ssrContext) {
  __webpack_require__("XLkl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_attach_to_home_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_970c6b88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attach_to_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r78W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_community_forums_js__ = __webpack_require__("mQlD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_374c1a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_community_forums_vue__ = __webpack_require__("gzFh");
function injectStyle (ssrContext) {
  __webpack_require__("eFDh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_community_forums_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_374c1a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_community_forums_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r7L0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "rEDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_items_js__ = __webpack_require__("EcaT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8786f2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_items_vue__ = __webpack_require__("ypi2");
function injectStyle (ssrContext) {
  __webpack_require__("KJ3Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_items_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8786f2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_items_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rF1e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rJdw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_review_and_confirm_sushi_js__ = __webpack_require__("RbF8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a16640_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_review_and_confirm_sushi_vue__ = __webpack_require__("t8b7");
function injectStyle (ssrContext) {
  __webpack_require__("OSiv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_review_and_confirm_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a16640_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_review_and_confirm_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rW2y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classModifier,on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rZUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-with-info",class:_vm.selectedModifier,on:{"click":_vm.onClick}},[_c('span',{staticClass:"button-with-info__text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.selected)?_c('div',{staticClass:"button-with-info__icon",class:_vm.iconModifier,on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rdUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_withdraw_js__ = __webpack_require__("dstN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308cf884_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdraw_vue__ = __webpack_require__("6JQ3");
function injectStyle (ssrContext) {
  __webpack_require__("KVSF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_withdraw_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308cf884_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rgkE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rhA/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rjLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_market_detail_sushi_js__ = __webpack_require__("Zk72");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d1b0741_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_market_detail_sushi_vue__ = __webpack_require__("PeCr");
function injectStyle (ssrContext) {
  __webpack_require__("j0az")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_market_detail_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d1b0741_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_market_detail_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rjQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_news_js__ = __webpack_require__("cT9C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d9a742_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_news_vue__ = __webpack_require__("N4a4");
function injectStyle (ssrContext) {
  __webpack_require__("rutz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_news_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d9a742_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rm4l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_empty_state_market_empty_state_vue__ = __webpack_require__("tGGA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__ = __webpack_require__("dDJX");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketContractInfoV2: __WEBPACK_IMPORTED_MODULE_6__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["a" /* default */],
    marketEmptyState: __WEBPACK_IMPORTED_MODULE_4__components_market_market_empty_state_market_empty_state_vue__["a" /* default */]
  },
  props: {
    type: {
      type: String,
      default: 'standalone'
    }
  },
  data: function data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: __WEBPACK_IMPORTED_MODULE_6__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["b" /* MARKET_CONTRACT_INFO_VALUES_LAYOUT */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['sessionHistory']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'session-history-sushi': true
      }, 'session-history-sushi--' + this.type, this.type);
    },
    items: function items() {
      return this.sessionHistory.map(function (i) {
        var instance = new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](i);
        return {
          id: i.contractId,
          marketName: i.marketName,
          marketId: i.marketId,
          contractName: i.contractName,
          image: i.contractImageSmallUrl || i.contractImageUrl,
          price: instance.changePriceAsCents,
          priceAsCents: instance.lastTradePriceAsCents,
          hasLastTradePrice: instance.hasLastTradePrice,
          lastClosePrice: instance.lastClosePrice,
          contracts: [instance]
        };
      });
    }
  }),
  methods: {
    itemLink: function itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      };
    }
  }
});

/***/ }),

/***/ "rpWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-input",class:{
    'code-input--complete': _vm.isComplete,
    'code-input--error': _vm.error,
    'code-input--disabled': _vm.disabled,
    'code-input--loading': _vm.loading,
  }},_vm._l((_vm.digits),function(digit,index){return _c('input',{key:index,ref:"inputs",refInFor:true,staticClass:"code-input__digit",style:({ '--index': index }),attrs:{"type":"text","inputmode":"numeric","autocomplete":"one-time-code","maxlength":_vm.length,"disabled":_vm.disabled},domProps:{"value":digit},on:{"input":function($event){return _vm.handleInput($event, index)},"keydown":function($event){return _vm.handleKeydown($event, index)},"paste":_vm.handlePaste,"focus":_vm.handleFocus}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rpmV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rrO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("G/BR");

/* eslint-disable */


var currentAnimationFrame = null;
var currentInterruptionListeners = null;

var cancelCurrentScroll = function cancelCurrentScroll() {
  if (currentAnimationFrame) {
    cancelAnimationFrame(currentAnimationFrame);
    currentAnimationFrame = null;
  }
  if (currentInterruptionListeners) {
    var _currentInterruptionL = currentInterruptionListeners,
        container = _currentInterruptionL.container,
        listeners = _currentInterruptionL.listeners,
        windowListeners = _currentInterruptionL.windowListeners;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(listeners).forEach(function (event) {
      container.removeEventListener(event, listeners[event], { passive: true });
    });
    if (windowListeners) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(windowListeners).forEach(function (event) {
        window.removeEventListener(event, windowListeners[event], { passive: true });
      });
    }
    currentInterruptionListeners = null;
  }
};

function scrollTo(destination) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
  var container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var topOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var callback = arguments[5];

  if (typeof container === 'function') {
    callback = container;
    container = null;
    topOffset = 0;
  }

  if (typeof topOffset === 'function') {
    callback = topOffset;
    topOffset = 0;
  }

  cancelCurrentScroll();

  var getScrollParent = function getScrollParent(node) {
    if (node === null || node === undefined || node === document.body || node === document.documentElement) {
      return window;
    }

    if (node.scrollHeight > node.clientHeight) {
      var style = window.getComputedStyle(node);
      var overflowY = style.overflowY;
      if (overflowY !== 'visible' && overflowY !== 'hidden') {
        return node;
      }
    }

    return getScrollParent(node.parentNode);
  };

  var easings = {
    linear: function linear(t) {
      return t;
    },
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad: function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic: function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart: function easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
  };

  var actualContainer = container;
  if (!actualContainer && typeof destination !== 'number' && destination.nodeType) {
    actualContainer = getScrollParent(destination.parentNode);
  }
  if (!actualContainer) {
    actualContainer = window;
  }

  var isWindow = actualContainer === window;

  var getScrollPos = function getScrollPos() {
    if (isWindow) {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }
    return actualContainer.scrollTop;
  };

  var start = getScrollPos();
  var prevScrollPos = start;
  var scrollCheckCount = 20;
  var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  var destinationOffset = void 0;
  if (typeof destination === 'number') {
    destinationOffset = destination;
  } else if (isWindow) {
    destinationOffset = Math.round(destination.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) - topOffset);
  } else {
    destinationOffset = destination.offsetTop - topOffset;
  }

  var maxScroll = void 0;
  var viewportHeight = void 0;
  if (isWindow) {
    maxScroll = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
    viewportHeight = window.innerHeight;
  } else {
    maxScroll = actualContainer.scrollHeight - actualContainer.clientHeight;
    viewportHeight = actualContainer.clientHeight;
  }

  var destinationOffsetToScroll = Math.max(0, Math.min(destinationOffset, maxScroll));

  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Starting scroll to:', destination, {
    duration: duration,
    easing: easing,
    container: actualContainer,
    isWindow: isWindow,
    topOffset: topOffset,
    start: start,
    destinationOffset: destinationOffset,
    maxScroll: maxScroll,
    destinationOffsetToScroll: destinationOffsetToScroll
  });

  var performScroll = function performScroll(pos) {
    if (isWindow) {
      window.scroll(0, pos);
    } else {
      actualContainer.scrollTop = pos;
    }
  };

  if ('requestAnimationFrame' in window === false) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] requestAnimationFrame not supported, jumping to position');
    performScroll(destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  var interruptionEvents = ['wheel', 'touchstart', 'mousedown', 'keydown', 'MSPointerDown', 'pointerdown', 'touchmove'];
  var interruptionTarget = isWindow ? window : actualContainer;

  var onUserInterruption = function onUserInterruption() {
    var now = 'now' in window.performance ? performance.now() : new Date().getTime();
    if (now - startTime < 150) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Ignoring interruption during first 150ms');
      return;
    }

    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] User interrupted scroll');
    cancelCurrentScroll();
  };

  var setupListeners = function setupListeners(target, listenersMap) {
    interruptionEvents.forEach(function (event) {
      listenersMap[event] = onUserInterruption;
      target.addEventListener(event, onUserInterruption, { passive: true });
    });
  };

  var containerListeners = {};
  setupListeners(interruptionTarget, containerListeners);
  var windowListeners = null;
  if (!isWindow) {
    windowListeners = {};
    setupListeners(window, windowListeners);
  }

  currentInterruptionListeners = {
    container: interruptionTarget,
    listeners: containerListeners,
    windowListeners: windowListeners
  };

  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Starting animation');

  function scroll() {
    var now = 'now' in window.performance ? performance.now() : new Date().getTime();
    var time = Math.min(1, (now - startTime) / duration);
    var timeFunction = easings[easing](time);
    var nextPos = Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start);

    performScroll(nextPos);

    var currentScrollPos = getScrollPos();

    // Check if scroll is stuck (position not updating as expected)
    // Only if we're not already at the destination and expecting to move
    var hasPositionChanged = Math.abs(prevScrollPos - currentScrollPos) >= 1;
    var shouldHaveMoved = Math.abs(nextPos - prevScrollPos) > 1;

    if (!hasPositionChanged && shouldHaveMoved) {
      scrollCheckCount--;
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Scroll might be stuck:', {
        prevScrollPos: prevScrollPos,
        currentScrollPos: currentScrollPos,
        nextPos: nextPos,
        scrollCheckCount: scrollCheckCount
      });
    }

    if (Math.abs(currentScrollPos - destinationOffsetToScroll) <= 1 || scrollCheckCount < 0) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Scroll finished at:', currentScrollPos, {
        reason: Math.abs(currentScrollPos - destinationOffsetToScroll) <= 1 ? 'reached destination' : 'scroll stuck (scrollCheckCount < 0)'
      });
      cancelCurrentScroll();
      if (callback) {
        callback();
      }
      return;
    }

    prevScrollPos = currentScrollPos;
    currentAnimationFrame = requestAnimationFrame(scroll);
  }

  // wait a bit for initialisation to avoid premature interruption from touch events
  setTimeout(function () {
    currentAnimationFrame = requestAnimationFrame(scroll);
  }, 50);
}

/***/ }),

/***/ "rreX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rutz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rxGt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("8/3H");



/* harmony default export */ __webpack_exports__["a"] = (function (response) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* checkResponseForMaintenance */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* checkResponseForTaxInfo */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* checkResponseForDocumentUpload */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* checkResponseVersion */])(response);
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('API - SUCCESS', response.status, response.config.method, response.config.url, response);
  return response;
});

/***/ }),

/***/ "s06T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_set_password_js__ = __webpack_require__("+8fj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77ab062c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_set_password_vue__ = __webpack_require__("W3K2");
function injectStyle (ssrContext) {
  __webpack_require__("qrpg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_set_password_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77ab062c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_set_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s6Yu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s8MB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sA4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toggled: false,
      value: 10,
      updateValue: 22
    };
  },

  methods: {
    onClick: function onClick() {
      this.value = this.updateValue;
    }
  }
});

/***/ }),

/***/ "sBpB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_wallet_js__ = __webpack_require__("oTR+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4ba17d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wallet_vue__ = __webpack_require__("62Q9");
function injectStyle (ssrContext) {
  __webpack_require__("67/Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_wallet_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4ba17d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sCGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "sFos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__logger__ = __webpack_require__("G/BR");








/* eslint-disable no-restricted-syntax */









var STORY_SWITCH_INTERVAL = 8 * 1000;
var CONTENT_COLLAPSED_HEIGHT = 475;
var CONTENT_OVERFLOW_TOLERANCE = 12;
var EXPANDED_HEIGHT_BUFFER = 8;
var EXPANDED_HEIGHT_MEASURE_DELAYS = [0, 150, 500, 1200];
var PODCAST_RESIZE_EVENT = 'cms:podcast-resize';
var PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';
var LAST_STORY_ROW_CLASS = 'preview-carousel-embed__story-row--last';
var interval = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  props: {
    indexes: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      stripTags: __WEBPACK_IMPORTED_MODULE_13__utils_helpers__["o" /* stripTags */],
      isLoading: false,
      selected: {},
      selectedManually: false,
      isTransitioning: false,
      storyContentMap: {},
      activeTab: null,
      showNavigationArrows: false,
      canScrollLeft: false,
      canScrollRight: false,
      isExpanded: false,
      isContentOverflowing: false,
      expandedContentHeight: null,
      contentMeasureTimeouts: [],
      contentResizeObserver: null,
      refreshIndex: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('browse', ['storiesNav', 'storyMap', 'currentStoryIndex']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup']), {
    localStoriesNav: function localStoriesNav() {
      var _this = this;

      if (this.indexes.length === 0) {
        return this.storiesNav;
      }
      return this.storiesNav.filter(function (i) {
        return _this.indexes.includes(String(i.index));
      });
    },
    showNav: function showNav() {
      return this.navigationTabs.length > 1 && !this.isLoading && this.isComponentReady;
    },
    navigationTabs: function navigationTabs() {
      return this.localStoriesNav.map(function (item) {
        return {
          name: 'story-' + item.index,
          title: item.navTitle || 'Story #' + (item.index + 1)
        };
      });
    },
    classModifiers: function classModifiers() {
      return {
        'preview-carousel-embed': true
      };
    },
    contentClassModifiers: function contentClassModifiers() {
      return {
        'preview-carousel-embed__content': true,
        'preview-carousel-embed__content--collapsed': !this.isExpanded,
        'preview-carousel-embed__content--overflowing': this.isContentOverflowing && !this.isExpanded
      };
    },
    contentStyleModifiers: function contentStyleModifiers() {
      var minHeightPx = CONTENT_COLLAPSED_HEIGHT;
      if (this.isExpanded && this.expandedContentHeight) {
        return {
          minHeight: Math.max(minHeightPx, this.expandedContentHeight) + 'px'
        };
      }
      return {
        minHeight: minHeightPx + 'px'
      };
    },
    expandClassModifiers: function expandClassModifiers() {
      return {
        'preview-carousel-embed__expand': true,
        'preview-carousel-embed__expand--floating': !this.isExpanded
      };
    },
    showExpandControl: function showExpandControl() {
      return this.isContentOverflowing && this.isComponentReady;
    },
    tabsClassModifiers: function tabsClassModifiers() {
      return {
        'preview-carousel-embed__tabs': true,
        'preview-carousel-embed__tabs--arrows': this.showNavigationArrows
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('browse', ['getStoriesNav', 'getStory', 'getStoriesList', 'updateStoryMapFromContractNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    getStoryContentForLayout: function getStoryContentForLayout(data) {
      return this.isLayoutDesktop ? data.desktopContent : data.mobileContent;
    },
    clearPendingExpandedMeasurements: function clearPendingExpandedMeasurements() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.contentMeasureTimeouts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeoutId = _step.value;

          clearTimeout(timeoutId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.contentMeasureTimeouts = [];
    },
    teardownContentResizeObserver: function teardownContentResizeObserver() {
      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }
    },
    setupContentResizeObserver: function setupContentResizeObserver() {
      var _this2 = this;

      this.teardownContentResizeObserver();
      if (typeof ResizeObserver === 'undefined') {
        return;
      }

      var target = this.getActiveStoryElement() || this.$refs.content;
      if (!target) {
        return;
      }

      // eslint-disable-next-line no-undef
      this.contentResizeObserver = new ResizeObserver(function () {
        if (_this2.isExpanded) {
          _this2.scheduleExpandedHeightRefresh();
        } else {
          _this2.checkContentOverflow();
        }
      });
      this.contentResizeObserver.observe(target);
    },
    getActiveStoryElement: function getActiveStoryElement() {
      var content = this.$refs.content;
      if (!content) {
        return null;
      }
      var stories = content.querySelectorAll('.preview-carousel-embed__story');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(stories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var story = _step2.value;

          if (window.getComputedStyle(story).display !== 'none') {
            return story;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    },
    isVisibleElement: function isVisibleElement(node) {
      var styles = window.getComputedStyle(node);
      if (styles.display === 'none' || styles.visibility === 'hidden') {
        return false;
      }
      var rect = node.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 || node.scrollHeight > 0;
    },
    getLastVisibleStoryRow: function getLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return null;
      }

      var rows = activeStory.querySelectorAll('.browse-story-content-region__items');
      for (var index = rows.length - 1; index >= 0; index -= 1) {
        var row = rows[index];
        if (this.isVisibleElement(row)) {
          return row;
        }
      }

      return null;
    },
    updateLastVisibleStoryRow: function updateLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return;
      }

      var markedRows = activeStory.querySelectorAll('.' + LAST_STORY_ROW_CLASS);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(markedRows), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var row = _step3.value;

          row.classList.remove(LAST_STORY_ROW_CLASS);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var lastVisibleRow = this.getLastVisibleStoryRow(activeStory);
      if (lastVisibleRow) {
        lastVisibleRow.classList.add(LAST_STORY_ROW_CLASS);
      }
    },
    measureStoryHeight: function measureStoryHeight() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$includeBuffer = _ref.includeBuffer,
          includeBuffer = _ref$includeBuffer === undefined ? false : _ref$includeBuffer;

      var activeStory = this.getActiveStoryElement();
      if (!activeStory) {
        return null;
      }

      this.updateLastVisibleStoryRow(activeStory);

      var activeRect = activeStory.getBoundingClientRect();
      var measuredHeight = Math.max(activeStory.scrollHeight || 0, activeStory.offsetHeight || 0);
      var descendants = activeStory.querySelectorAll('*');

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(descendants), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var node = _step4.value;

          var styles = window.getComputedStyle(node);
          if (styles.display !== 'none' && styles.visibility !== 'hidden') {
            var rect = node.getBoundingClientRect();
            if (rect.width !== 0 || rect.height !== 0) {
              var nodeBottom = rect.bottom - activeRect.top;
              if (nodeBottom > measuredHeight) {
                measuredHeight = nodeBottom;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (measuredHeight <= 0) {
        return null;
      }

      return Math.ceil(measuredHeight + (includeBuffer ? EXPANDED_HEIGHT_BUFFER : 0));
    },
    measureExpandedContentHeight: function measureExpandedContentHeight() {
      return this.measureStoryHeight({ includeBuffer: true });
    },
    measureCollapsedContentHeight: function measureCollapsedContentHeight() {
      return this.measureStoryHeight();
    },
    scheduleExpandedHeightRefresh: function scheduleExpandedHeightRefresh() {
      var _this3 = this;

      if (!this.isExpanded) {
        return;
      }
      this.clearPendingExpandedMeasurements();
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(EXPANDED_HEIGHT_MEASURE_DELAYS), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var delay = _step5.value;

          var timeoutId = setTimeout(function () {
            if (!_this3.isExpanded) {
              return;
            }
            var measuredHeight = _this3.measureExpandedContentHeight();
            if (measuredHeight) {
              _this3.expandedContentHeight = measuredHeight;
            }
          }, delay);
          this.contentMeasureTimeouts.push(timeoutId);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    handleWindowResize: function handleWindowResize() {
      this.checkOverflow();
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.checkContentOverflow();
      }
    },
    handleEmbeddedResizeEvent: function handleEmbeddedResizeEvent() {
      var _this4 = this;

      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.$nextTick(function () {
          _this4.checkContentOverflow();
        });
      }
    },
    emitPodcastLayoutRefresh: function emitPodcastLayoutRefresh() {
      window.dispatchEvent(new Event(PODCAST_LAYOUT_REFRESH_EVENT));
    },
    tabsClicked: function tabsClicked() {
      this.stopNavRotation();
      this.selectedManually = true;
    },
    navigationTabChange: function navigationTabChange(name) {
      this.activeTab = name;
      var index = parseInt(name.replace('story-', ''), 10);
      this.onSelect({ item: this.localStoriesNav.find(function (i) {
          return i.index === index;
        }), stop: false });
    },
    installActiveStoryCharts: function installActiveStoryCharts() {
      var activeStoryElement = this.getActiveStoryElement();
      if (!activeStoryElement) {
        return;
      }
      this.installMarketCharts(activeStoryElement, { suppressGlobalLoader: true });
    },
    setupContent: function setupContent() {
      var _this5 = this;

      var totalCmsContent = [];
      this.storyContentMap = {};

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.storyMap)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref2 = _step6.value;

          var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

          var index = _ref3[0];
          var data = _ref3[1];

          var storyContent = this.getStoryContentForLayout(data);
          totalCmsContent.push(storyContent.cmsContent || {});
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(this.storyContentMap, index, '' + (storyContent.css || '') + (storyContent.html || ''));
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var accordionContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.accordionContentObjects || [];
      }));
      var podcastItemContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.podcastItemContentObjects || [];
      }));
      var contractListMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.contractListMarkets || [];
      }));
      var marketTileMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.marketTileMarkets || [];
      }));
      var chartWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.chartWidgetObjects || [];
      }));
      var docsWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.docsWidgetObjects || [];
      }));
      var videoWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.videoWidgetObjects || [];
      }));
      this.isComponentReady = true;

      setTimeout(function () {
        _this5.installDynamicControls({
          data: {
            cmsContentObject: {
              accordionContentObjects: accordionContentObjects,
              podcastItemContentObjects: podcastItemContentObjects,
              contractListMarkets: contractListMarkets,
              marketTileMarkets: marketTileMarkets,
              chartWidgetObjects: chartWidgetObjects,
              docsWidgetObjects: docsWidgetObjects,
              videoWidgetObjects: videoWidgetObjects
            }
          },
          skipMarketCharts: true,
          skipCarousel: true
        });
        _this5.$nextTick(function () {
          _this5.installActiveStoryCharts();
          _this5.setupContentResizeObserver();
          _this5.checkContentOverflow();
          _this5.emitPodcastLayoutRefresh();
        });
      }, 0);
    },
    refreshLayoutContent: function refreshLayoutContent() {
      var _this6 = this;

      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$clearExpanded = _ref4.clearExpanded,
          clearExpanded = _ref4$clearExpanded === undefined ? true : _ref4$clearExpanded;

      if (!this.isComponentReady || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.storyMap).length === 0) {
        return;
      }
      if (clearExpanded) {
        this.isExpanded = false;
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.refreshIndex += 1;
      this.$nextTick(function () {
        _this6.setupContent();
        _this6.$nextTick(function () {
          _this6.setupContentResizeObserver();
          _this6.checkOverflow();
          _this6.emitPodcastLayoutRefresh();
        });
      });
    },
    onSelect: function onSelect(_ref5) {
      var _this7 = this;

      var item = _ref5.item,
          _ref5$stop = _ref5.stop,
          stop = _ref5$stop === undefined ? false : _ref5$stop;

      if (typeof item === 'undefined') return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      var disableNavBarAutomaticProgression = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(item, 'disableNavBarAutomaticProgression', false);
      if (stop || disableNavBarAutomaticProgression) {
        this.stopNavRotation();
        this.selectedManually = true;
      }

      this.isTransitioning = true;
      return this.getStory({ index: item.index }).then(function () {
        var timeout = 0;
        if (stop) {
          window.scrollTo(0, 0);
        }
        _this7.selected = item;
        setTimeout(function () {
          _this7.isTransitioning = false;
        }, timeout);
      });
    },
    stopNavRotation: function stopNavRotation() {
      if (interval !== null) {
        clearInterval(interval);
        interval = null;
      }
    },
    startNavRotation: function startNavRotation() {
      var _this8 = this;

      this.stopNavRotation();
      interval = setInterval(function () {
        var nav = _this8.localStoriesNav;
        if (nav.length === 0) {
          return;
        }
        var currentPosition = nav.findIndex(function (i) {
          return i.index === _this8.selected.index;
        });
        var nextPosition = currentPosition === -1 || currentPosition === nav.length - 1 ? 0 : currentPosition + 1;
        _this8.onSelect({ item: nav[nextPosition] });
      }, STORY_SWITCH_INTERVAL);
    },
    resolveInitialStoryItem: function resolveInitialStoryItem(data) {
      if (this.$route.query.story) {
        var indexToSelect = parseInt(this.$route.query.story, 10);
        var selectedItem = data[indexToSelect - 1];

        if (selectedItem) {
          this.activeTab = 'story-' + selectedItem.index;
          return selectedItem;
        }
      }

      var defaultItem = data[0];
      if (defaultItem) {
        this.activeTab = 'story-' + defaultItem.index;
      }

      return defaultItem;
    },
    start: function start() {
      var _this9 = this;

      this.stopNavRotation();
      this.isLoading = true;
      this.isComponentReady = false;

      this.getStoriesNav({ indexes: this.indexes }).then(function (data) {
        if (data.length === 0) {
          _this9.isLoading = false;
          _this9.isComponentReady = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }

        var item = _this9.resolveInitialStoryItem(data);
        if (!item) {
          _this9.isLoading = false;
          _this9.isComponentReady = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }

        return _this9.getStoriesList({ indexes: _this9.indexes, cache: true }).then(function () {
          return _this9.onSelect({ item: item }).then(function () {
            _this9.isLoading = false;
            _this9.setupContent();

            setTimeout(function () {
              _this9.checkOverflow();
            }, 0);

            var disableNavBarAutomaticProgression = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(item || {}, 'disableNavBarAutomaticProgression', false);
            if (!_this9.currentPopup && !disableNavBarAutomaticProgression) {
              _this9.startNavRotation();
            }
          });
        });
      }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_14__logger__["a" /* default */].error(e);
        _this9.isLoading = false;
        _this9.isComponentReady = true;
      });
    },
    checkScrollButtons: function checkScrollButtons() {
      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        var tolerance = 25;
        this.canScrollLeft = tabsList.scrollLeft > tolerance;
        this.canScrollRight = tabsList.scrollLeft < tabsList.scrollWidth - tabsList.clientWidth - tolerance;
      }
    },
    checkOverflow: function checkOverflow() {
      var _this10 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.showNavigationArrows = tabsList.scrollWidth > tabsList.clientWidth;
        setTimeout(function () {
          _this10.checkScrollButtons();
        }, 250);
      }
    },
    scrollLeft: function scrollLeft() {
      var _this11 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: -150, // Scroll left by 150px
          behavior: 'smooth'
        });
        setTimeout(function () {
          _this11.checkScrollButtons();
        }, 250);
      }
    },
    scrollRight: function scrollRight() {
      var _this12 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: 150, // Scroll right by 150px
          behavior: 'smooth'
        });
        setTimeout(function () {
          _this12.checkScrollButtons();
        }, 250);
      }
    },
    toggleExpand: function toggleExpand() {
      var _this13 = this;

      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.stopNavRotation();
      this.selectedManually = true;
      this.$nextTick(function () {
        _this13.emitPodcastLayoutRefresh();
      });
    },
    checkContentOverflow: function checkContentOverflow() {
      var content = this.$refs.content;
      if (content) {
        var collapsedContentHeight = this.measureCollapsedContentHeight() || content.scrollHeight || 0;
        this.isContentOverflowing = collapsedContentHeight > CONTENT_COLLAPSED_HEIGHT + CONTENT_OVERFLOW_TOLERANCE;
        if (this.isExpanded) {
          var expandedContentHeight = this.measureExpandedContentHeight();
          if (expandedContentHeight) {
            this.expandedContentHeight = expandedContentHeight;
          }
        }
      }
    }
  }),
  created: function created() {
    this.start();
  },

  watch: {
    currentStoryIndex: function currentStoryIndex(val) {
      var _this14 = this;

      this.isExpanded = false;
      this.expandedContentHeight = null;
      this.clearPendingExpandedMeasurements();
      this.$nextTick(function () {
        _this14.installActiveStoryCharts();
        _this14.setupContentResizeObserver();
        _this14.checkContentOverflow();
        _this14.emitPodcastLayoutRefresh();
        setTimeout(function () {
          return _this14.emitPodcastLayoutRefresh();
        }, 200);
      });
      var activeTab = 'story-' + val;
      if (activeTab !== this.activeTab) {
        this.activeTab = activeTab;
      }
    },
    isLayoutDesktop: function isLayoutDesktop(value, oldValue) {
      var _this15 = this;

      if (value === oldValue) {
        return;
      }
      this.$nextTick(function () {
        _this15.refreshLayoutContent({ clearExpanded: true });
      });
    },
    currentPopup: function currentPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    },
    currentSmallPopup: function currentSmallPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopNavRotation();
    this.clearPendingExpandedMeasurements();
    this.teardownContentResizeObserver();
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);
  }
});

/***/ }),

/***/ "sILV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs",class:("tabs--" + _vm.theme)},_vm._l((_vm.items),function(item){return _c('li',{class:_vm.tabItemModifiers(item),on:{"click":function($event){$event.preventDefault();return _vm.onChange(item.name)}}},[_c('a',{class:_vm.tabLinkModifiers(item),attrs:{"href":"#"}},[(item.icon)?[_c('span',{class:_vm.tabIconModifiers(item)})]:[_vm._v("\n        "+_vm._s(item.title)+"\n        "),(item.meta && item.meta.numRuleComments > 0)?_c('div',{staticClass:"tabs__rule-comments-count"},[_vm._v("\n          "+_vm._s(item.meta.numRuleComments)+"\n        ")]):_vm._e()]],2)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sIXq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sIse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_messaging_journey_info_js__ = __webpack_require__("n/Ch");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71bc59fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messaging_journey_info_vue__ = __webpack_require__("6Aew");
function injectStyle (ssrContext) {
  __webpack_require__("N9iO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_messaging_journey_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71bc59fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messaging_journey_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sJOz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sJdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tabs_js__ = __webpack_require__("bvK5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a48efb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__ = __webpack_require__("sILV");
function injectStyle (ssrContext) {
  __webpack_require__("eufm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tabs_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a48efb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sLBT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


/* eslint-disable no-restricted-syntax */
function stringifyQuery(obj) {
  var res = obj ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
    var value = obj[key];

    if (value === undefined) {
      return '';
    }

    if (value === null) {
      return encodeURIComponent(key);
    }

    if (Array.isArray(value)) {
      var result = [];
      value.forEach(function (el) {
        if (el === undefined) {
          return;
        }
        if (el === null) {
          result.push(encodeURIComponent(key));
        } else {
          result.push(encodeURIComponent(key) + '=' + encodeURIComponent(el));
        }
      });
      return result.join('&');
    }

    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : null;
  return res ? '?' + res : '';
}

function unserializeQuery(url) {
  var searchParams = url.split('?')[1];
  var result = {};
  if (searchParams !== undefined) {
    var paramParts = searchParams.split('&');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(paramParts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var part = _step.value;

        var paramValuePair = part.split('=');
        if (paramValuePair.length === 2) {
          result[paramValuePair[0]] = decodeURIComponent(paramValuePair[1]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  stringifyQuery: stringifyQuery,
  unserializeQuery: unserializeQuery
});

/***/ }),

/***/ "sNPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-mobile-watchlist__menu-order"},[_c('menu-button',{attrs:{"theme":_vm.theme,"type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-mobile-watchlist__menu-timespans"},[_c('menu-button',{attrs:{"type":"timespan","theme":_vm.theme,"name":_vm.selectedTimespan.name,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e()]),_vm._v(" "),(_vm.ordersOpen)?_c('div',{staticClass:"market-filters-mobile-watchlist__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"theme":_vm.theme,"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort)},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e(),_vm._v(" "),(_vm.filtersOpen)?_c('div',{staticClass:"market-filters-mobile-watchlist__filters"},[_c('a',{staticClass:"market-filters-mobile-watchlist__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-mobile-watchlist__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"theme":_vm.theme,"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e(),_vm._v(" "),(_vm.timespansOpen)?_c('div',{staticClass:"market-filters-mobile-watchlist__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"theme":_vm.theme,"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sOc5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sPnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCreateAccount: function onCreateAccount() {
      if (this.isPage) {
        this.$router.push({ name: 'account-page-register' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
      }
    }
  })
});

/***/ }),

/***/ "sQLb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1"},[_c('div',{staticClass:"what-is-new-flow-version-1__step"},[(_vm.currentStepIndexFlow1 === _vm.STEPS.FIRST)?[_c('div',{staticClass:"what-is-new-flow-version-1__step-1-image"}),_vm._v(" "),_vm._m(0)]:_vm._e(),_vm._v(" "),(_vm.currentStepIndexFlow1 === _vm.STEPS.SECOND)?[_c('div',{staticClass:"what-is-new-flow-version-1__step-title"},[_vm._v("Buy Button Color Scheme")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-options"},_vm._l((_vm.optionsSecondStep),function(option){return _c('div',{key:option.key,staticClass:"what-is-new-flow-version-1__step-option",class:{'what-is-new-flow-version-1__step-option--selected': option.key === _vm.optionSecondStepSelectedFlow1},on:{"click":function($event){return _vm.selectOptionSecondStepFlow1(option.key)}}},[_c('div',{staticClass:"what-is-new-flow-version-1__step-option-image",class:("what-is-new-flow-version-1__step-option-image--2-" + (option.key))}),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-option-title"},[_vm._v("\n              "+_vm._s(option.info)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-option-toggle"})])}),0),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-help"},[_vm._v("What color scheme do you want for your Buy buttons?")]),_vm._v(" "),_vm._m(1)]:_vm._e(),_vm._v(" "),(_vm.currentStepIndexFlow1 === _vm.STEPS.THIRD)?[_c('div',{staticClass:"what-is-new-flow-version-1__step-title"},[_vm._v("Mobile Trade Interface Style")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-options what-is-new-flow-version-1__step-options--overflow"},_vm._l((_vm.optionsThirdStep),function(option){return _c('div',{key:option.key,staticClass:"what-is-new-flow-version-1__step-option",class:{'what-is-new-flow-version-1__step-option--selected': option.key === _vm.optionThirdStepSelectedFlow1},on:{"click":function($event){return _vm.selectOptionThirdStepFlow1(option.key)}}},[_c('div',{staticClass:"what-is-new-flow-version-1__step-option-image",class:("what-is-new-flow-version-1__step-option-image--3-" + (option.key))}),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-option-title"},[_vm._v("\n              "+_vm._s(option.info)+"\n              "),(option.info === 'Condensed' && !_vm.isLayoutMobile)?[_vm._v("\n                (Legacy)\n              ")]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-option-toggle"})])}),0),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-help"},[_vm._v("What trade interface layout do you want to use on mobile?")]),_vm._v(" "),_vm._m(2)]:_vm._e(),_vm._v(" "),(_vm.currentStepIndexFlow1 === _vm.STEPS.FOURTH)?[_c('div',{staticClass:"what-is-new-flow-version-1__step-title"},[_vm._v("Other Key Improvements")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7)]:_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1__step-1-header"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-1-header-title"},[_vm._v("\n            We’ve listened and brought back the most requested features.\n          ")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-1-header-subtitle"},[_vm._v("\n            Whether you prefer new or old, your trading experience is personal. Take a minute to configure your PredictIt and learn what’s new.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1__step-hint"},[_vm._v("Hint: Use the settings button "),_c('span',{staticClass:"what-is-new-flow-version-1__step-hint-icon"}),_vm._v("  to change it at any time.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1__step-hint"},[_vm._v("Hint: Use the settings button "),_c('span',{staticClass:"what-is-new-flow-version-1__step-hint-icon"}),_vm._v("  to change it at any time.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1__step-4-section what-is-new-flow-version-1__step-4-section--left"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-image what-is-new-flow-version-1__step-4-section-image--1"}),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-text"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-title"},[_vm._v("\n              Buy/Sell Buttons\n            ")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-description"},[_vm._v("\nWe made it so that when you own a contract the Sell button is visible, making it faster to exit a position.            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1__step-4-section what-is-new-flow-version-1__step-4-section--right"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-image what-is-new-flow-version-1__step-4-section-image--2"}),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-text"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-title"},[_vm._v("\n              Orderbook In Mobile Order Slip\n            ")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-description"},[_vm._v("\nWe have added a collapsible orderbook in the mobile order slip so that you can build your orders with more information.            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1__step-4-section what-is-new-flow-version-1__step-4-section--left"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-image what-is-new-flow-version-1__step-4-section-image--3"}),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-text"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-title"},[_vm._v("\n              Dashboard\n            ")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-description"},[_vm._v("\nWe updated the Dashboard to use a column layout, making it easier to scan and trade.\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1__step-4-section what-is-new-flow-version-1__step-4-section--right"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-image what-is-new-flow-version-1__step-4-section-image--4"}),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-text"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-title"},[_vm._v("\n              Positions Bar\n            ")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-description"},[_vm._v("\nWe added a new Positions Bar to see your current ownership and unfilled orders at a glance.            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-flow-version-1__step-4-section what-is-new-flow-version-1__step-4-section--left"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-image what-is-new-flow-version-1__step-4-section-image--5"}),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-text"},[_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-title"},[_vm._v("\n              Cleaner Typography\n            ")]),_vm._v(" "),_c('div',{staticClass:"what-is-new-flow-version-1__step-4-section-description"},[_vm._v("\nWe have updated our text and typography for easier reading on desktop and mobile.             ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-trading-unavailable-v2': true
      }, 'market-trading-unavailable-v2--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "shWj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sl5T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "smaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__news_feed_item_news_feed_item_vue__ = __webpack_require__("RU3U");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_5__components_collapsible_panel_collapsible_panel_vue__["a" /* default */],
    newsFeedItem: __WEBPACK_IMPORTED_MODULE_6__news_feed_item_news_feed_item_vue__["a" /* default */]
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    inOverlay: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    numArticles: {
      type: Number,
      default: 3
    },
    marketId: {
      type: Number,
      default: null
    },
    source: {
      type: Array,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAllArticles: this.inOverlay,
      feeds: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    classModifiers: function classModifiers() {
      return {
        'news-feed': true,
        'news-feed--collapsible': this.collapsible
      };
    },
    contentClassModifiers: function contentClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'news-feed__content': true,
        'news-feed__content--no-more': !this.showMoreButton
      }, 'news-feed__content--' + this.theme, this.theme);
    },
    articles: function articles() {
      try {
        var articles = __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default()(this.feeds.map(function (feed) {
          return feed.items;
        }));
        var articlesWithoutDuplicates = __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(articles, 'id');
        return articlesWithoutDuplicates.sort(function (a, b) {
          return parseInt(b.published, 10) - parseInt(a.published, 10);
        });
      } catch (exc) {
        return [];
      }
    },
    items: function items() {
      return this.showAllArticles ? this.articles : this.articles.slice(0, this.numArticles);
    },
    showMoreButton: function showMoreButton() {
      return !this.showAllArticles && this.numArticles <= this.articles.length;
    },
    showNewsFeed: function showNewsFeed() {
      return this.marketId ? this.items.length > 0 : true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setGenericPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('insight', ['getFeeds', 'getMarketFeeds']), {
    setupFeeds: function setupFeeds() {
      var _this = this;

      /* if source is passed then feed is not loaded via api calls */
      if (this.source) {
        this.feeds = this.source;
      } else if (this.marketId) {
        this.getMarketFeeds(this.marketId).then(function (data) {
          _this.feeds = data;
        });
      } else {
        this.getFeeds().then(function (data) {
          _this.feeds = data;
        });
      }
    },
    loadMore: function loadMore(e) {
      e.stopPropagation();
      if (this.isLayoutDesktop) {
        this.setGenericPopup({
          name: 'news-feed',
          options: {
            marketId: this.marketId
          }
        });
      } else {
        this.showAllArticles = true;
      }
    }
  }),
  created: function created() {
    this.setupFeeds();
  }
});

/***/ }),

/***/ "sof5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_contentLoader__ = __webpack_require__("P71F");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_contentLoader__["a" /* default */]],
  metaInfo: function metaInfo() {
    return {
      title: 'Site Map'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('about', ['sitemap']), {
    enabledGroups: function enabledGroups() {
      var disabledGroupForSimplifiedDemoSite = [];
      return this.sitemap.groups.filter(function (item) {
        if (disabledGroupForSimplifiedDemoSite.includes(item.name.toLowerCase())) {
          return false;
        }
        return true;
      });
    }
  }),
  components: {
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_2__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('about', ['getSitemap']), {
    enabledGroupItems: function enabledGroupItems(items) {
      return items.filter(function (item) {
        if (item.name.toLowerCase() === 'research') {
          return false;
        }
        return true;
      });
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getSitemap().then(function () {
      _this.isComponentReady = true;
      _this.loaderRemove(document.body);
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "srEx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_shares_sushi_js__ = __webpack_require__("BC2b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c4f0fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_shares_sushi_vue__ = __webpack_require__("53+i");
function injectStyle (ssrContext) {
  __webpack_require__("UuoC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_shares_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c4f0fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_shares_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "srjS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDEzIDE1Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTYuNDEzIDUuMjY0TDIuMzYuNzQyYS45MzguOTM4IDAgMCAwLS43MjUtLjMzM2MtLjI4IDAtLjUyMy4xMS0uNzMzLjMzM2wtLjYwNC42NzNBMS4yMjQgMS4yMjQgMCAwIDAgMCAyLjIzM2MwIC4zMTguMS41ODcuMjk4LjgwOWwzLjkxNCA0LjM2Ny0zLjkxNCA0LjM2N2ExLjE2OSAxLjE2OSAwIDAgMC0uMjk4LjgwOWMwIC4zMTEuMS41ODQuMjk4LjgxOGwuNjA0LjY2NWEuOTUxLjk1MSAwIDAgMCAuNzMzLjM0MWMuMjkgMCAuNTMyLS4xMTQuNzI1LS4zNDFsNC4wNDUtNC41MTQgNC4wNTMgNC41MjJjLjE5OS4yMjIuNDQuMzMzLjcyNS4zMzMuMjggMCAuNTI0LS4xMS43MzMtLjMzM2wuNjA0LS42NzNjLjE5OS0uMjM0LjI5OC0uNTA3LjI5OC0uODE4IDAtLjMxOC0uMS0uNTg3LS4yOTgtLjgwOUw4LjYwNiA3LjQxbDMuOTE0LTQuMzY3Yy4xOTktLjIyMi4yOTgtLjQ5MS4yOTgtLjgwOSAwLS4zMTEtLjEtLjU4NC0uMjk4LS44MThMMTEuOTE2Ljc1YS45NTEuOTUxIDAgMCAwLS43MzMtLjM0MS45MTIuOTEyIDAgMCAwLS43MjUuMzQxTDYuNDEzIDUuMjY0eiIvPgo8L3N2Zz4="

/***/ }),

/***/ "svCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLink)?_c('a',{class:_vm.linkClass,attrs:{"href":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.displayText)),(_vm.isStoryFooterCta)?_c('span',[_vm._v(" →")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isButton)?_c('a',{staticClass:"link link--button",attrs:{"href":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "swXC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t3+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_refine_history_js__ = __webpack_require__("aNYI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c40d350_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refine_history_vue__ = __webpack_require__("blr7");
function injectStyle (ssrContext) {
  __webpack_require__("5QOt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_refine_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c40d350_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refine_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t3/+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t45u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isOfferMatched;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");

/* eslint-disable */



function isOfferMatched(data) {
  return data.History !== null && data.History.length > 0 && data.Offer.RemainingQuantity === 0;
}

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  state: {
    notificationList: [],
    sideNotificationLevel: '',
    sideNotificationText: '',
    sideNotificationOnCloseCallback: null,
    lastConfirmedContractData: {},
    showNotificationsWidget: false
  },
  mutations: {
    add: function add(state, notification) {
      notification.index = new Date().getTime() + Math.floor(Math.random() * 10000);
      state.notificationList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.notificationList), [notification]);
    },
    remove: function remove(state, index) {
      var target = state.notificationList.find(function (i) {
        return i.index === index;
      });
      var indexToSlice = state.notificationList.indexOf(target);
      if (indexToSlice === -1) return;
      var firstSlice = state.notificationList.slice(0, indexToSlice);
      var secondSlice = state.notificationList.slice(indexToSlice + 1);
      state.notificationList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(firstSlice), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(secondSlice));
    },
    clear: function clear(state) {
      state.notificationList = [];
    },
    setSideNotification: function setSideNotification(state, _ref) {
      var text = _ref.text,
          level = _ref.level,
          onCloseCallback = _ref.onCloseCallback;

      state.sideNotificationLevel = level;
      state.sideNotificationText = text;
      state.sideNotificationOnCloseCallback = onCloseCallback;
    },
    clearSideNotification: function clearSideNotification(state) {
      state.sideNotificationLevel = '';
      state.sideNotificationText = '';
      state.sideNotificationOnCloseCallback = null;
    },
    setLastConfirmedContractData: function setLastConfirmedContractData(state, payload) {
      state.lastConfirmedContractData = payload;
    },
    toggleNotificationsWidget: function toggleNotificationsWidget(state) {
      state.showNotificationsWidget = !state.showNotificationsWidget;
    },
    closeNotificationsWidget: function closeNotificationsWidget(state) {
      state.showNotificationsWidget = false;
    }
  },
  actions: {
    add: function add(_ref2, notification) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (notification.type === __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["f" /* NOTIFICATION_TRADE_CONFIRMED */]) {
        setTimeout(function () {
          commit('add', notification);
          commit('setLastConfirmedContractData', {
            id: notification.data.ContractId,
            matched: isOfferMatched(notification.data)
          });
          if (notification.data && notification.data.Offer && notification.data.Offer.OfferId) {
            var associatedNotification = state.notificationList.filter(function (i) {
              return i.type === 'simple';
            }).find(function (i) {
              return i.externalId === notification.data.Offer.OfferId;
            });

            if (!associatedNotification) return;
            commit('remove', associatedNotification.index);
          }
        }, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["i" /* NOTIFICATION_TRADE_CONFIRMED_DELAY */]);
      } else if (notification.type === __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["g" /* NOTIFICATION_SHARES_TRADED */]) {
        commit('setLastConfirmedContractData', {
          id: notification.data.contentJson.ContractId,
          matched: true
        });
        commit('add', notification);
      } else if (__WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["j" /* ALLOWED_NOTIFICATION_TYPES */].includes(notification.type)) {
        commit('add', notification);
      }
    },
    remove: function remove(_ref3, notificationIndex) {
      var commit = _ref3.commit;

      commit('remove', notificationIndex);
    },
    clear: function clear(_ref4) {
      var commit = _ref4.commit;

      commit('clear');
    },
    addSimple: function addSimple(_ref5, _ref6) {
      var commit = _ref5.commit;
      var icon = _ref6.icon,
          text = _ref6.text,
          _ref6$externalId = _ref6.externalId,
          externalId = _ref6$externalId === undefined ? null : _ref6$externalId,
          _ref6$closeTimeout = _ref6.closeTimeout,
          closeTimeout = _ref6$closeTimeout === undefined ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT : _ref6$closeTimeout,
          _ref6$title = _ref6.title,
          title = _ref6$title === undefined ? '' : _ref6$title;

      var notification = {
        method: null,
        type: 'simple',
        externalId: externalId,
        data: {
          title: title,
          icon: icon,
          text: text,
          closeTimeout: closeTimeout
        }
      };
      commit('add', notification);
    },
    setSideNotification: function setSideNotification(_ref7, _ref8) {
      var commit = _ref7.commit;
      var text = _ref8.text,
          level = _ref8.level;

      commit('setSideNotification', { text: text, level: level });
    },
    setSuccessSideNotification: function setSuccessSideNotification(_ref9, text) {
      var commit = _ref9.commit;

      commit('setSideNotification', { text: text, level: 'success' });
    },
    setSuccessSideNotificationWithTimeoutCallback: function setSuccessSideNotificationWithTimeoutCallback(_ref10, _ref11) {
      var _this = this;

      var commit = _ref10.commit;
      var text = _ref11.text,
          _ref11$callback = _ref11.callback,
          callback = _ref11$callback === undefined ? function () {} : _ref11$callback;

      var callBackApplied = false;
      var timeout = setTimeout(function () {
        callBackApplied = true;
        callback.apply(_this);
      }, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT);
      commit('setSideNotification', {
        text: text,
        level: 'success',
        onCloseCallback: function onCloseCallback() {
          if (!callBackApplied) {
            clearTimeout(timeout);
            callback.apply(_this);
          }
        }
      });
    },
    setErrorSideNotification: function setErrorSideNotification(_ref12, text) {
      var commit = _ref12.commit;

      commit('setSideNotification', { text: text, level: 'danger' });
    },
    clearSideNotification: function clearSideNotification(_ref13) {
      var commit = _ref13.commit;

      commit('clearSideNotification');
    },
    toggleNotificationsWidget: function toggleNotificationsWidget(_ref14) {
      var commit = _ref14.commit;

      commit('toggleNotificationsWidget');
    },
    closeNotificationsWidget: function closeNotificationsWidget(_ref15) {
      var commit = _ref15.commit;

      commit('closeNotificationsWidget');
    }
  }
});

/***/ }),

/***/ "t71M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__ = __webpack_require__("ooVM");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eda1c81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_bank_transfer_vue__ = __webpack_require__("tWD/");
function injectStyle (ssrContext) {
  __webpack_require__("f9IU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__["c" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eda1c81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_bank_transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["c"] = (Component.exports);


/***/ }),

/***/ "t8b7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__contract"},[_c('purchase-extended-betslip-contract-info',{attrs:{"market":_vm.market,"contract":_vm.contract}})],1),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__line"}),_vm._v(" "),(_vm.confirmationData.isTradeWarningMessage)?_c('alert-box',{staticClass:"purchase-review-and-confirm-sushi__alert-box",attrs:{"level":_vm.confirmationData.isTradeWarningMessageLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.confirmationData.isTradeWarningMessage)}})]):_vm._e(),_vm._v(" "),(_vm.outsideOfPriceBoundsWarningText && (!_vm.confirmationData.isTradeWarningMessage || _vm.confirmationData.isTradeWarningMessageLevel === 'info'))?_c('alert-box',{staticClass:"purchase-review-and-confirm-sushi__alert-box",attrs:{"level":"info"}},[_vm._v("\n    "+_vm._s(_vm.outsideOfPriceBoundsWarningText)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.confirmationData.showTradeData)?[_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary"},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row"},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-label"},[_vm._v("\n          Summary\n        ")]),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-value purchase-review-and-confirm-sushi__summary-row-value--bold"},[_vm._v("\n          "+_vm._s(_vm.tradeTypeText)+" "+_vm._s(_vm.confirmationData.quantity.toLocaleString())+" "+_vm._s(_vm.yesNoText)+" at "+_vm._s(_vm.pricePerSharePrefix)+" "+_vm._s(_vm.pricePerShareDisplay)+"\n        ")])]),_vm._v(" "),(_vm.riskAdjustment)?_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row"},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-label"},[_vm._v("\n          Risk Adjustment\n        ")]),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-value"},[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.riskAdjustment),expression:"riskAdjustment",modifiers:{"fixed3":true}}]})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row"},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-label"},[_vm._v("\n          Cash\n        ")]),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-value"},[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.orderTotal),expression:"orderTotal",modifiers:{"fixed3":true}}]})])]),_vm._v(" "),(_vm.tradeOptions.operationType !== 'sell')?_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row"},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-label"},[_vm._v("\n          Payout\n        ")]),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-value"},[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.tradeOptions.quantity),expression:"tradeOptions.quantity",modifiers:{"fixed3":true}}]})])]):_vm._e(),_vm._v(" "),(_vm.showProfitOrLoss)?_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row"},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-label"},[_vm._v("\n          Profit\n        ")]),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-value"},[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.profits),expression:"profits",modifiers:{"fixed3":true}}]})])]):_vm._e(),_vm._v(" "),(_vm.fees)?_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row"},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-label"},[_vm._v("\n          Fees\n        ")]),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__summary-row-value"},[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.fees),expression:"fees",modifiers:{"fixed3":true}}]})])]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.confirmationData.showTradeData)?[_c('div',{staticClass:"purchase-review-and-confirm-sushi__line"}),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__information"},[_c('div',{staticClass:"purchase-review-and-confirm-sushi__information-title"},[_vm._v("Order Mechanics and Legal Disclaimers")]),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__information-content",class:{ 'purchase-review-and-confirm-sushi__information-content--expanded': _vm.isExpanded }},[_c('p',[_vm._v("\n          Calculations offered for profit or loss, fees, risk adjustment and changes to your cash balance assume that all orders above are matched at the price shown.\n          Actual figures will differ in the event that some orders cannot be matched or are matched at more favorable prices.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Open orders in any contract that you are unable to cover as a result of this transaction will be cancelled.\n        ")])]),_vm._v(" "),_c('span',{staticClass:"purchase-review-and-confirm-sushi__information-more",on:{"click":function($event){_vm.isExpanded = !_vm.isExpanded}}},[_vm._v("\n        "+_vm._s(_vm.isExpanded ? 'Read less' : 'Read more')+"\n      ")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__line"}),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__footer"},[_c('button',{class:_vm.nextButtonClassModifiers,attrs:{"disabled":_vm.nextButtonDisabled},on:{"click":_vm.onClickSubmit}},[(_vm.tradeOptions.operationType === 'sell')?[(_vm.tradeOptions.quantity && _vm.pricePerShare)?[_vm._v("\n                "+_vm._s(_vm.tradeTypeText)+" "+_vm._s(_vm.tradeOptions.quantity)+" "+_vm._s(_vm.yesNoText)+"  "),_c('span',{staticClass:"purchase-review-and-confirm-sushi__footer-next-button-outline"},[_vm._v("at "+_vm._s(_vm.pricePerShare)+"¢ Min")])]:[_vm._v("\n                "+_vm._s(_vm.tradeTypeText)+"\n              ")]]:[(_vm.tradeOptions.quantity && _vm.pricePerShare && _vm.dontShowMultiples)?[_vm._v("\n              "+_vm._s(_vm.tradeTypeText)+" "+_vm._s(_vm.tradeOptions.quantity)+" "+_vm._s(_vm.yesNoText)+"  "),_c('span',{staticClass:"purchase-review-and-confirm-sushi__footer-next-button-outline"},[_vm._v("at "+_vm._s(_vm.pricePerShare)+"¢ Max")])]:(_vm.tradeOptions.quantity && _vm.pricePerShare)?[_vm._v("\n                "+_vm._s(_vm.tradeTypeText)+" $"+_vm._s(_vm.buyPrice)+" "+_vm._s(_vm.yesNoText)+"  "),_c('span',{staticClass:"purchase-review-and-confirm-sushi__footer-next-button-outline"},[_vm._v("Win "+_vm._s(_vm.multiple)+"X")])]:[_vm._v("\n                "+_vm._s(_vm.tradeTypeText)+"\n              ")]]],2),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm-sushi__footer-rules"},[_vm._v("\n        By placing your order, you agree to the\n        "),_c('br'),_vm._v(" "),_c('a',{staticClass:"purchase-review-and-confirm-sushi__footer-rules-link",on:{"click":function($event){$event.preventDefault();return _vm.onReadRules($event)}}},[_vm._v("\n          Contract Rules\n        ")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tBC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-accessibility-statement"},[_c('h2',{staticClass:"page-accessibility-statement__headline"},[_vm._v("\n     Accessibility Statement\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    PredictIt is committed to making our website's content accessible and user friendly to everyone. If you are having difficulty viewing or navigating the content on this website, or notice any content, feature, or functionality that you believe is not fully accessible to people with disabilities, please email our Support team at "),_c('a',{attrs:{"href":"mailto:support@predictit.org"}},[_vm._v("support@predictit.org")]),_vm._v(" with “Disabled Access” in the subject line and provide a description of the specific feature you feel is not fully accessible or a suggestion for improvement.  We take your feedback seriously and will consider it as we evaluate ways to accommodate all of our customers and our overall accessibility policies.  Additionally, while we do not control such vendors, we strongly encourage vendors of third-party digital content to provide content that is accessible and user friendly.\n\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tDB6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tE+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: {
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.name;
    },
    mainClassName: function mainClassName() {
      return 'market-filters-mobile';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-mobile__menu': true,
        'market-filters-mobile__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    }
  }
});

/***/ }),

/***/ "tFv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi_vue__ = __webpack_require__("lzus");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_offer_desktop_sushi_purchase_offer_desktop_sushi_vue__ = __webpack_require__("khSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_purchase_sushi_purchase_offer_desktop_sushi_common_betslip_purchase_offer_desktop_sushi_common_betslip_vue__ = __webpack_require__("9QTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_purchase_offer_sushi_mobile_bar_purchase_offer_sushi_mobile_bar_vue__ = __webpack_require__("otBS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__ = __webpack_require__("X4WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__logger__ = __webpack_require__("G/BR");
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  components: {
    purchaseOfferSushi: __WEBPACK_IMPORTED_MODULE_3__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi_vue__["a" /* default */],
    purchaseOfferSushiMobileBar: __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_purchase_offer_sushi_mobile_bar_purchase_offer_sushi_mobile_bar_vue__["a" /* default */],
    purchaseOfferDesktopSushi: __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_offer_desktop_sushi_purchase_offer_desktop_sushi_vue__["a" /* default */],
    purchaseOfferDesktopSushiCommonBetslip: __WEBPACK_IMPORTED_MODULE_5__components_purchase_sushi_purchase_offer_desktop_sushi_common_betslip_purchase_offer_desktop_sushi_common_betslip_vue__["a" /* default */]
  },
  props: {
    market: {},
    kind: {
      type: String,
      default: 'modal'
    },
    closeJourneyAfterSuccess: {
      type: Boolean,
      default: true
    },
    showRelatedContracts: {
      type: Boolean,
      default: false
    },
    showContractCharts: {
      type: Boolean,
      default: false
    },
    showOrderSlip: {
      type: Boolean,
      default: true
    },
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false
    },
    disablePurchaseOfferWatchers: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeSuccess', 'confirmationData', 'confirmationDoneData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['status']), {
    showPurchaseOfferDesktop: function showPurchaseOfferDesktop() {
      return this.kind === 'desktop' && !!this.contract;
    },
    showPurchaseOfferMobile: function showPurchaseOfferMobile() {
      return this.kind === 'mobile' && !!this.contract;
    },
    showPurchaseOfferDesktopWidget: function showPurchaseOfferDesktopWidget() {
      return this.kind === 'desktop-widget' && !!this.contract;
    },
    showPurchaseOfferMobileWidget: function showPurchaseOfferMobileWidget() {
      return this.kind === 'mobile-widget' && !!this.contract;
    },
    minimumOwnership: function minimumOwnership() {
      return Math.max(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.contract, 'minimumClipSize', 1), 1);
    },
    contract: function contract() {
      var _this = this;

      if (!this.tradeOptions.contractId) return null;
      var contracts = this.market.contracts || this.market.marketContracts;
      return contracts.find(function (c) {
        return c.contractId === _this.tradeOptions.contractId;
      });
    },
    payload: function payload() {
      return {
        quantity: this.tradeOptions.quantity,
        pricePerShare: this.tradeOptions.pricePerShare,
        contractId: this.tradeOptions.contractId,
        tradeType: this.tradeType
      };
    },
    tradeType: function tradeType() {
      switch (this.tradeOptions.operationType + '_' + this.tradeOptions.operationValue) {
        case 'buy_no':
          return 0;
        case 'buy_yes':
          return 1;
        case 'sell_no':
          return 2;
        case 'sell_yes':
          return 3;
        default:
          return -1;
      }
    }
  }),
  data: function data() {
    return {
      hasInitialised: false
    };
  },

  watch: {
    tradeOptions: {
      handler: 'tradeOptionsHandler',
      immediate: true
    },
    tradeSuccess: function tradeSuccess(value) {
      var _this2 = this;

      if (value) {
        var completedTradeOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.tradeOptions);
        this.setCurrentPopup();
        // desktop exclusive
        if (this.closeJourneyAfterSuccess) {
          this.setTradeOptions(null);
        }

        this.getMarketContracts(this.market.marketId).then(function () {
          __WEBPACK_IMPORTED_MODULE_13__logger__["a" /* default */].info('[PURCHASE] successful');
          _this2.setTradeSuccess(false);
          if (!_this2.contract) {
            return;
          }
          var contractModel = new __WEBPACK_IMPORTED_MODULE_11__models_contract__["a" /* default */](_this2.contract);
          if (_this2.isLayoutMobile && completedTradeOptions.operationType === __WEBPACK_IMPORTED_MODULE_12__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */].BUY && completedTradeOptions.operationValue === __WEBPACK_IMPORTED_MODULE_12__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO) {
            _this2.setTradeOptions({
              contractId: _this2.contract.contractId,
              operationType: __WEBPACK_IMPORTED_MODULE_12__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */].BUY,
              operationValue: __WEBPACK_IMPORTED_MODULE_12__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO
            });
            return;
          }
          // switch to buy yes, user got rid of ownership
          if (completedTradeOptions.operationType === __WEBPACK_IMPORTED_MODULE_12__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */].SELL && !contractModel.mode) {
            __WEBPACK_IMPORTED_MODULE_13__logger__["a" /* default */].info('[PURCHASE] user lost ownership after selling');
            _this2.setTradeOptions({
              contractId: _this2.contract.contractId,
              operationType: __WEBPACK_IMPORTED_MODULE_12__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */].BUY,
              operationValue: __WEBPACK_IMPORTED_MODULE_12__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES
            });
          }
        });
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['clearTradedMarkets']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getContract', 'setMarketEngineBusyMessage', 'getMarketContracts']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['submitTrade', 'confirmTrade', 'setTradeOptions', 'setTradeQuantity', 'setTradeSuccess', 'setIsInConfirmationMode', 'setConfirmationData', 'setConfirmationDoneData', 'setBottomBetSlipExtendedMode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['addSimple']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setTradePopup', 'setCurrentPopupOptions']), {
    getErrorFromResponse: function getErrorFromResponse(response) {
      if (!response) return '';
      if (typeof response.data === 'string') {
        return response.data;
      }
      return response.data ? response.data.message : '';
    },
    tradeOptionsHandler: function tradeOptionsHandler(tradeOptions) {
      var oldOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (oldOptions.contractId !== tradeOptions.contractId) {
        this.setConfirmationData(null);
        this.setConfirmationDoneData(null);
      }
      if (oldOptions.operationValue !== tradeOptions.operationValue || oldOptions.operationType !== tradeOptions.operationType) {
        this.setConfirmationData(null);
        this.setConfirmationDoneData(null);
      }
    },
    onClickSubmitWithoutSkipConfirmationHandling: function onClickSubmitWithoutSkipConfirmationHandling() {
      this.processTrade({ canSkip: false });
    },
    onClickNext: function onClickNext() {
      this.processTrade({ canSkip: true });
    },
    processTrade: function processTrade() {
      var _this3 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$canSkip = _ref.canSkip,
          canSkip = _ref$canSkip === undefined ? true : _ref$canSkip;

      if (this.isLoading) {
        return;
      }

      if (!this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
        return;
      }

      if (!this.isUserVerified) {
        this.showAccountVerifyPopup();
        return;
      }

      if (!this.status.hasBeenFunded) {
        this.showAddFundsPopup({ delay: false });
        return;
      }

      if (canSkip && this.tradeOptions.skipConfirmation) {
        this.submitTradeAction();
      } else {
        this.loaderAdd(document.body);
        this.confirmTrade(this.payload).then(function (response) {
          _this3.loaderRemove(document.body);
          // when quantity is reduced it has to be set
          if (response.data.quantity && response.data.quantity >= _this3.minimumOwnership) {
            _this3.setTradeQuantity(response.data.quantity);
          }
          if (_this3.isLayoutDesktop && _this3.currentPopup !== __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE) {
            _this3.setTradePopup({
              name: __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE_SUSHI_REVIEW,
              options: {
                market: _this3.market
              }
            });
          }
          if (_this3.isLayoutMobile && _this3.currentPopup !== __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE) {
            _this3.setTradePopup({
              name: __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE_SUSHI_REVIEW,
              options: {
                market: _this3.market
              }
            });
          }
          _this3.setConfirmationData(response.data);
          _this3.setConfirmationDoneData(null);
          _this3.setIsInConfirmationMode(true);
        }).catch(function (error) {
          _this3.inspectErrorForRestrictions(error);
          _this3.loaderRemove(document.body);
          var message = _this3.getErrorFromResponse(error.response);
          if (message) {
            _this3.addSimple({
              title: 'Error Occurred',
              icon: 'cancel',
              text: message
            });
          }
        });
      }
    },
    submitTradeAction: function submitTradeAction() {
      var _this4 = this;

      this.loaderAdd(document.body);
      this.submitTrade(this.payload).then(function (response) {
        var data = response.data;
        _this4.$gtm.trackEvent({ event: 'Trade' });
        _this4.loaderRemove(document.body);
        _this4.setConfirmationData(null);
        _this4.setConfirmationDoneData(data);
        _this4.addSimple({
          externalId: data.offer ? data.offer.offerId : null,
          closeTimeout: 3500,
          icon: 'pending',
          text: 'You will be notified when processing is complete.',
          title: 'Order Received'
        });
        _this4.setMarketEngineBusyMessage({
          isEngineBusy: data.isEngineBusy,
          isEngineBusyMessage: data.isEngineBusyMessage
        });
        _this4.setTradeSuccess(true);
        _this4.setBottomBetSlipExtendedMode(false);
        _this4.clearTradedMarkets();
        var isBuyTradeType = [0, 1].includes(_this4.tradeType);
        __WEBPACK_IMPORTED_MODULE_9__services_notifications_proxy__["a" /* default */].showMessagingJourney(isBuyTradeType);
      }).catch(function (error) {
        _this4.inspectErrorForRestrictions(error);
        _this4.setTradeSuccess(false);
        _this4.loaderRemove(document.body);
        var message = _this4.getErrorFromResponse(error.response);
        if (message) {
          _this4.addSimple({
            title: 'Error Occurred',
            icon: 'cancel',
            text: message
          });
        }
      });
    },
    onClickSubmit: function onClickSubmit() {
      this.submitTradeAction();
    },
    onClickAmend: function onClickAmend() {
      this.setConfirmationData(null);
      this.setConfirmationDoneData(null);
      this.setIsInConfirmationMode(false);
    },
    inspectErrorForRestrictions: function inspectErrorForRestrictions(error) {
      var restrictionPreamble = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.restrictionPreamble', null);
      var restrictions = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.restrictions', null);
      if (restrictionPreamble && restrictions) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].MARKET_OWNERSHIP_CONFLICT);
        this.setCurrentPopupOptions({
          restrictions: restrictions,
          restrictionPreamble: restrictionPreamble
        });
      }
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.setIsInConfirmationMode(false);
  }
});

/***/ }),

/***/ "tG+e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_empty_state_js__ = __webpack_require__("KmT2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e2bcbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_empty_state_vue__ = __webpack_require__("FBuH");
function injectStyle (ssrContext) {
  __webpack_require__("FmzU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_empty_state_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e2bcbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_empty_state_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tGWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_4__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_2__components_account_profile_profile_vue__["a" /* default */],
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_5__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    showHeader: function showHeader() {
      return this.$route.name === 'HelpAndSupport';
    },
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    }
  })
});

/***/ }),

/***/ "tGjv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-is-new-popup-footer"},[_c(_vm.currentFlow,{tag:"component"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLet":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tLhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classModifiers,attrs:{"to":_vm.contractRoute}},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-v2__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"market-contract-v2__current-price"},[(_vm.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.price}})]:[_vm._v("\n      -"),_c('span',{domProps:{"innerHTML":_vm._s('&cent;')}})]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.changePrice,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tPuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_js__ = __webpack_require__("gwUB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_594cc512_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_vue__ = __webpack_require__("Ty/y");
function injectStyle (ssrContext) {
  __webpack_require__("rhA/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_594cc512_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tQ/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.name;
    },
    mainClassName: function mainClassName() {
      return 'market-filters-mobile-watchlist';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-mobile-watchlist__menu': true,
        'market-filters-mobile-watchlist__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    }
  }),
  created: function created() {
    this.isWatchlistOpen = true;
  }
});

/***/ }),

/***/ "tQfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_shuffle__ = __webpack_require__("yG5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_twitter_twitter__ = __webpack_require__("tWDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_onboarding_consts__ = __webpack_require__("yUpF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_cms_account_combined_login_account_combined_login_vue__ = __webpack_require__("7GI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_cms_market_list_item_v2_embed_market_list_item_v2_embed_vue__ = __webpack_require__("JSpR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_cms_market_contract_list_v2_embed_market_contract_list_v2_embed_vue__ = __webpack_require__("KsCZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_cms_market_contract_list_v2_embed_compact_market_contract_list_v2_embed_compact_vue__ = __webpack_require__("UXtE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_cms_document_table_view_document_table_view_vue__ = __webpack_require__("BiGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_cms_document_tile_view_document_tile_view_vue__ = __webpack_require__("mRGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_generics_link_link_vue__ = __webpack_require__("dxV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_home_home_old_podcasts_podcasts_vue__ = __webpack_require__("QrTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_cms_video_view_video_view_vue__ = __webpack_require__("5jEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__router_index__ = __webpack_require__("YaEn");






 /* eslint-disable */





















var LoginComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_13__components_cms_account_combined_login_account_combined_login_vue__["a" /* default */]);
var CollapsiblePanelComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_9__components_collapsible_panel_collapsible_panel_vue__["a" /* default */]);
var MarketListItemEmbedComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_14__components_cms_market_list_item_v2_embed_market_list_item_v2_embed_vue__["a" /* default */]);
var MarketContractListEmbedComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_15__components_cms_market_contract_list_v2_embed_market_contract_list_v2_embed_vue__["a" /* default */]);
var MarketContractListEmbedCompactComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_16__components_cms_market_contract_list_v2_embed_compact_market_contract_list_v2_embed_compact_vue__["a" /* default */]);
var LinkComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_19__components_generics_link_link_vue__["a" /* default */]);
var PodcastsComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_21__components_home_home_old_podcasts_podcasts_vue__["a" /* default */]);
var MarketChartsComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_20__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */]);
var DocumentTableViewComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_17__components_cms_document_table_view_document_table_view_vue__["a" /* default */]);
var DocumentTileViewComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_18__components_cms_document_tile_view_document_tile_view_vue__["a" /* default */]);
var VideoViewComponents = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_22__components_cms_video_view_video_view_vue__["a" /* default */]);

var PreviewCarouselEmbedComponent = null;
var getPreviewCarouselEmbedComponent = function getPreviewCarouselEmbedComponent() {
  if (PreviewCarouselEmbedComponent) {
    return PreviewCarouselEmbedComponent;
  }
  var module = __webpack_require__("TA6E");
  PreviewCarouselEmbedComponent = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].extend(module.default || module);
  return PreviewCarouselEmbedComponent;
};

var dateGoDisplay = function dateGoDisplay(dt) {
  var daysDiff = __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(dt, 'days');
  var hoursDiff = __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(dt, 'hours');
  if (daysDiff > 365) {
    var years = Math.floor(daysDiff / 365);
    return years === 1 ? '1 year ago' : years + ' years ago';
  } else if (daysDiff > 30) {
    var months = Math.floor(daysDiff / 30);
    return months === 1 ? '1 month ago' : months + ' months ago';
  } else if (hoursDiff > 24) {
    return daysDiff === 1 ? '1 day ago' : daysDiff + ' days ago';
  } else if (hoursDiff >= 1) {
    return hoursDiff === 1 ? '1 hour ago' : Math.floor(hoursDiff) + ' hours ago';
  }
  return 'Within the last hour';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_24__mixins_accountVerify__["a" /* default */]],
  data: function data() {
    return {
      content: '',
      marketTileMarkets: [],
      contractListMarkets: [],
      cmsAccordionContentObjects: [],
      podcastItemContentObjects: [],
      chartWidgetObjects: [],
      docsWidgetObjects: [],
      videoWidgetObjects: [],
      cmsChartMarketCache: new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    installCarousels: function installCarousels() {
      var carousels = this.$el.querySelectorAll('.predictit__carousel');
      var PreviewCarouselComponent = getPreviewCarouselEmbedComponent();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(carousels), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          var indicesString = el.getAttribute('data-carousel_indices');
          var indexes = indicesString ? indicesString.split(',').map(function (i) {
            return i.trim();
          }) : [];

          var instance = new PreviewCarouselComponent({
            parent: this,
            propsData: {
              indexes: indexes
            }
          });
          instance.$mount(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    installAccordions: function installAccordions() {
      var _this = this;

      var accordionHeaders = this.$el.querySelectorAll('.predictit__accordion');

      var _loop = function _loop(el) {
        var uuid = el.getAttribute('data-accordionuuid');
        var title = el.getAttribute('data-accordiontitle');
        var accordionObj = _this.cmsAccordionContentObjects.find(function (i) {
          return i.regionUUID === uuid;
        });

        if (accordionObj) {
          var content = accordionObj.content || '';
          var instance = new CollapsiblePanelComponent({
            parent: _this,
            propsData: {
              title: title,
              content: content,
              isOpen: accordionObj.isOpenByDefault
            }
          });
          instance.$mount(el);
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(accordionHeaders), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var el = _step2.value;

          _loop(el);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    installTweets: function installTweets() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
        var twitterWidgets = _this2.$el.querySelectorAll('.predictit__twitter');
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(twitterWidgets), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var widget = _step3.value;

            var tweetId = widget.getAttribute('data-tweetid');
            twt.widgets.createTweet(tweetId, widget, {
              theme: 'light'
            });
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
    },
    installDateElapsed: function installDateElapsed() {
      var dateEls = this.$el.querySelectorAll('.predictit__elapsedtime');
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(dateEls), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var el = _step4.value;

          var date = __WEBPACK_IMPORTED_MODULE_7_moment___default()(el.getAttribute('data-publishdate'));
          el.innerHTML = dateGoDisplay(date);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    installWelcomePopupControls: function installWelcomePopupControls() {
      var buttons = this.$el.querySelectorAll('.predictit-leaving-button');
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(buttons), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var button = _step5.value;

          button.addEventListener('click', function () {
            __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].LEAVING_POPUP);
          });
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    installLoginAndSignUpControls: function installLoginAndSignUpControls() {
      var loginButtons = this.$el.querySelectorAll('.predictit-login-button');
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(loginButtons), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var button = _step6.value;

          button.addEventListener('click', function () {
            if (__WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].getters['user/isLoggedIn']) {
              __WEBPACK_IMPORTED_MODULE_25__router_index__["a" /* default */].push({ name: 'market-list' });
            } else {
              __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
            }
          });
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var loginControls = this.$el.querySelectorAll('.predictit-login-control');
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(loginControls), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _button = _step7.value;

          if (__WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].getters['user/isLoggedIn']) {
            __WEBPACK_IMPORTED_MODULE_25__router_index__["a" /* default */].push({ name: 'market-list' });
          } else {
            var instance = new LoginComponent({
              parent: this,
              propsData: {}
            });
            instance.$mount(_button);
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var signUpButtons = this.$el.querySelectorAll('.predictit-signup-button');
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(signUpButtons), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _button2 = _step8.value;

          _button2.addEventListener('click', function () {
            if (__WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].getters['user/isLoggedIn']) {
              __WEBPACK_IMPORTED_MODULE_25__router_index__["a" /* default */].push({ name: 'market-list' });
            } else {
              __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
            }
          });
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    },
    installMarketLists: function installMarketLists() {
      var _this3 = this;

      var marketListEls = this.$el.querySelectorAll('.predictit__markettilelist');

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(marketListEls), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var el = _step9.value;

          var marketIds = el.getAttribute('data-marketids').replace(' ', '').split(',').map(function (i) {
            return parseInt(i, 10);
          });
          var markets = marketIds.map(function (marketId) {
            return _this3.marketTileMarkets.find(function (i) {
              return i.marketId === marketId;
            });
          }).filter(function (i) {
            return !!i;
          });
          var dataNumColumns = parseInt(el.getAttribute('data-num-columns') || 3, 10);
          var renderStyle = parseInt(el.getAttribute('data-render-style') || 1, 10);

          if (markets.length > 0) {
            var instance = new MarketListItemEmbedComponent({
              parent: this,
              propsData: {
                markets: markets,
                dataNumColumnsDesktop: dataNumColumns,
                renderStyle: renderStyle
              }
            });
            instance.$mount(el);
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    installMarketContracts: function installMarketContracts() {
      var _this4 = this;

      var marketContractsEl = this.$el.querySelectorAll('.predictit__marketpreview');

      var _loop2 = function _loop2(el) {
        var marketId = parseInt(el.getAttribute('data-marketid'), 10);
        var market = _this4.contractListMarkets.find(function (i) {
          return i.marketId === marketId;
        });
        if (!market) {
          return 'continue';
        }
        var contractIds = el.getAttribute('data-contractids').replace(' ', '').split(',').map(function (i) {
          return parseInt(i, 10);
        });
        var contracts = market.contracts.filter(function (i) {
          return contractIds.includes(i.contractId);
        });
        var compactViewMode = (el.getAttribute('data-compactview') || '').toLowerCase() === 'true';
        var openNewTab = (el.getAttribute('data-opennewtab') || '').toLowerCase() === 'true';
        if (compactViewMode) {
          var instance = new MarketContractListEmbedCompactComponent({
            parent: _this4,
            propsData: {
              openNewTab: openNewTab,
              contracts: contracts.map(function (i) {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, i, {
                  marketName: market.marketName,
                  marketId: market.marketId
                });
              })
            }
          });
          instance.$mount(el);
        } else {
          var _instance = new MarketContractListEmbedComponent({
            parent: _this4,
            propsData: {
              openNewTab: openNewTab,
              market: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, market, {
                contracts: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(contracts))
              })
            }
          });
          _instance.$mount(el);
        }
      };

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(marketContractsEl), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var el = _step10.value;

          var _ret2 = _loop2(el);

          if (_ret2 === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    },
    installButtonsAndLinks: function installButtonsAndLinks() {
      var links = this.$el.querySelectorAll('[data-buttontype="Link"]');
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(links), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var el = _step11.value;

          var url = el.getAttribute('data-detailpath');
          var isStoryFooterCta = (el.getAttribute('data-story-footer-cta') || '').toLowerCase() === 'true';
          var instance = new LinkComponent({
            parent: this,
            propsData: {
              type: 'link',
              text: el.innerHTML,
              url: url,
              styleVariant: isStoryFooterCta ? 'story-footer-cta' : ''
            }
          });
          instance.$mount(el);
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      var buttons = this.$el.querySelectorAll('[data-buttontype="Button"]');
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(buttons), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var _el = _step12.value;

          var url = _el.getAttribute('data-detailpath');
          var instance = new LinkComponent({
            parent: this,
            propsData: {
              type: 'button',
              text: _el.innerHTML,
              url: url
            }
          });
          instance.$mount(_el);
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }
    },
    installPodcasts: function installPodcasts() {
      var _this5 = this;

      var podcastSliders = this.$el.querySelectorAll('.predictit__podcastslider');
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(podcastSliders), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var el = _step13.value;

          var podcastUuids = (el.getAttribute('data-podcastuuids') || '').split(',').map(function (i) {
            return i.trim();
          }).filter(function (i) {
            return i.length > 0;
          });
          var podcasts = podcastUuids.map(function (index) {
            return _this5.podcastItemContentObjects.find(function (podcast) {
              return podcast.regionUUID === index;
            });
          }).filter(function (i) {
            return !!i;
          });
          var _title = el.getAttribute('data-podcasttitle');
          var isRandomized = (el.getAttribute('data-podcastisrandomized') || '').toLowerCase() === 'true';

          var items = podcasts.map(function (i) {
            var chunks = (i.podcastUrl || '').split('/').filter(function (chunk) {
              return chunk && chunk.length > 0;
            });
            return {
              id: chunks[chunks.length - 1] || '',
              type: __WEBPACK_IMPORTED_MODULE_21__components_home_home_old_podcasts_podcasts_vue__["b" /* PODCAST */].APPLE
            };
          }).filter(function (i) {
            return i.id.length > 0;
          });

          if (isRandomized) {
            items = __WEBPACK_IMPORTED_MODULE_5_lodash_shuffle___default()(items);
          }
          var forceLayoutMode = typeof this.getCmsForcedLayoutMode === 'function' ? this.getCmsForcedLayoutMode() : '';
          var instance = new PodcastsComponent({
            parent: this,
            propsData: {
              theme: 'story',
              title: _title,
              items: items,
              forceLayoutMode: forceLayoutMode
            }
          });
          instance.$mount(el);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }
    },
    resolveChartMarket: function resolveChartMarket(marketId) {
      var _this6 = this;

      var normalizedMarketId = parseInt(marketId, 10);
      if (isNaN(normalizedMarketId)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Invalid market id: ' + marketId));
      }

      if (this.cmsChartMarketCache.has(normalizedMarketId)) {
        return this.cmsChartMarketCache.get(normalizedMarketId);
      }

      var request = __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('market/getMarket', { marketId: normalizedMarketId, modifyState: false }).then(function (market) {
        if (!market) {
          throw new Error('Market data not found for marketId=' + normalizedMarketId);
        }
        return market;
      }).catch(function (error) {
        _this6.cmsChartMarketCache.delete(normalizedMarketId);
        throw error;
      });

      this.cmsChartMarketCache.set(normalizedMarketId, request);
      return request;
    },
    installMarketCharts: function installMarketCharts() {
      var _this7 = this;

      var rootEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$suppressGlobalLo = _ref.suppressGlobalLoader,
          suppressGlobalLoader = _ref$suppressGlobalLo === undefined ? false : _ref$suppressGlobalLo;

      var root = rootEl || this.$el;
      if (!root) {
        return;
      }
      var marketChartsEl = root.querySelectorAll('.predictit__datachart');

      var _loop3 = function _loop3(el) {
        var mountState = el.getAttribute('data-cms-chart-mounted');
        if (mountState === 'pending' || mountState === 'true') {
          return 'continue';
        }

        var uuid = el.getAttribute('data-chartuuid');
        var versionId = el.getAttribute('data-chartstoryversionid');
        var storyId = el.getAttribute('data-chartstoryid');
        var maxHeight = el.getAttribute('data-max-height');

        var chartObj = _this7.chartWidgetObjects.find(function (i) {
          return i.regionUUID === uuid;
        });
        if (typeof chartObj === 'undefined') {
          return 'continue';
        }

        el.setAttribute('data-cms-chart-mounted', 'pending');
        _this7.resolveChartMarket(chartObj.marketId).then(function (market) {
          var result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, market);
          if (chartObj.contractIds && result && result.contracts) {
            result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, result, {
              contracts: result.contracts.filter(function (i) {
                return chartObj.contractIds.includes(i.contractId);
              })
            });
          }
          var instance = new MarketChartsComponent({
            parent: _this7,
            propsData: {
              market: result,
              chartOptions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, chartObj, {
                cmsStoryId: storyId,
                cmsVersionId: versionId,
                includeDownload: false,
                maxHeight: maxHeight
                // showContractImagesOnLegend: true,
                // showContractImagesOnChart: true,
              }),
              suppressGlobalLoader: suppressGlobalLoader
            }
          });
          instance.$mount(el);
          el.setAttribute('data-cms-chart-mounted', 'true');
        }).catch(function () {
          el.removeAttribute('data-cms-chart-mounted');
        });
      };

      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(marketChartsEl), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var el = _step14.value;

          var _ret3 = _loop3(el);

          if (_ret3 === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }
    },
    installVideoWidgets: function installVideoWidgets() {
      var _this8 = this;

      var videoEls = this.$el.querySelectorAll('.predictit__videowidget');

      var _loop4 = function _loop4(el) {
        var url = el.getAttribute('data-videourl');
        var maxHeight = el.getAttribute('data-max-height');
        var videoData = _this8.videoWidgetObjects.find(function (i) {
          return i.videoUrl === url;
        });
        var instance = new VideoViewComponents({
          parent: _this8,
          propsData: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, videoData, {
            maxHeight: maxHeight
          })
        });
        instance.$mount(el);
      };

      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(videoEls), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var el = _step15.value;

          _loop4(el);
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }
    },
    installDocumentsWidgets: function installDocumentsWidgets() {
      var _this9 = this;

      var documentsEls = this.$el.querySelectorAll('.predictit__docswidget');

      var _loop5 = function _loop5(el) {
        var uuid = el.getAttribute('data-docsuuid');
        var viewType = parseInt(el.getAttribute('data-docsviewtype'), 10);
        var documentData = _this9.docsWidgetObjects.find(function (i) {
          return i.regionUUID === uuid;
        });
        if (documentData) {
          var componentClassMap = {
            1: DocumentTileViewComponent,
            2: DocumentTableViewComponent
          };
          var ComponentClass = componentClassMap[viewType] || DocumentTileViewComponent;
          var instance = new ComponentClass({
            parent: _this9,
            propsData: {
              documentData: documentData
            }
          });
          instance.$mount(el);
        }
      };

      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(documentsEls), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var el = _step16.value;

          _loop5(el);
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },
    installDynamicControls: function installDynamicControls() {
      var _this10 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$data = _ref2.data,
          data = _ref2$data === undefined ? {} : _ref2$data,
          _ref2$marketChartsRoo = _ref2.marketChartsRootEl,
          marketChartsRootEl = _ref2$marketChartsRoo === undefined ? null : _ref2$marketChartsRoo,
          _ref2$suppressMarketC = _ref2.suppressMarketChartsGlobalLoader,
          suppressMarketChartsGlobalLoader = _ref2$suppressMarketC === undefined ? false : _ref2$suppressMarketC,
          _ref2$skipMarketChart = _ref2.skipMarketCharts,
          skipMarketCharts = _ref2$skipMarketChart === undefined ? false : _ref2$skipMarketChart,
          _ref2$skipCarousel = _ref2.skipCarousel,
          skipCarousel = _ref2$skipCarousel === undefined ? false : _ref2$skipCarousel;

      this.css = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'renderedCSS', '') || '';
      this.content = '' + this.css + __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'renderedHTML', '');
      this.cmsAccordionContentObjects = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'cmsContentObject.accordionContentObjects', []);
      this.podcastItemContentObjects = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'cmsContentObject.podcastItemContentObjects', []);
      this.contractListMarkets = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'cmsContentObject.contractListMarkets', []);
      this.marketTileMarkets = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'cmsContentObject.marketTileMarkets', []);
      this.chartWidgetObjects = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'cmsContentObject.chartWidgetObjects', []);
      this.docsWidgetObjects = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'cmsContentObject.docsWidgetObjects', []);
      this.videoWidgetObjects = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'cmsContentObject.videoWidgetObjects', []);

      this.$nextTick(function () {
        _this10.installAccordions();
        _this10.installTweets();
        _this10.installDateElapsed();
        _this10.installLoginAndSignUpControls();
        _this10.installWelcomePopupControls();
        _this10.installMarketLists();
        _this10.installMarketContracts();
        _this10.installButtonsAndLinks();
        _this10.installPodcasts();
        if (!skipMarketCharts) {
          _this10.installMarketCharts(marketChartsRootEl, { suppressGlobalLoader: suppressMarketChartsGlobalLoader });
        }
        _this10.installDocumentsWidgets();
        _this10.installVideoWidgets();
        if (!skipCarousel) {
          _this10.installCarousels();
        }
      });
    }
  }
});

/***/ }),

/***/ "tRmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_disabled_outcome_v2_js__ = __webpack_require__("2A6V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4536ead8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_disabled_outcome_v2_vue__ = __webpack_require__("ikte");
function injectStyle (ssrContext) {
  __webpack_require__("sOc5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_disabled_outcome_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4536ead8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_disabled_outcome_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tUhF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[(_vm.layout === 'inline')?[_c('span',{staticClass:"button-price__text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])]:[_c('span',{staticClass:"button-price__text"},[_vm._v("\n      "+_vm._s(_vm.text)+" "),(_vm.price > 0)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.price),expression:"price",modifiers:{"cents":true}}],staticClass:"button-price__text--bold"}):_vm._e()]),_vm._v(" "),(_vm.showWinOrSell)?[_c('transition',{attrs:{"name":"button-price"}},[(_vm.hovered || _vm.active)?_c('span',{staticClass:"button-price__price"},[(_vm.isSell)?_c('span',{staticClass:"button-price__price-alt"},[_vm._v("\n            Sell: "+_vm._s(_vm.sell)+"¢\n          ")]):(_vm.isWin && _vm.price > 0)?_c('span',{staticClass:"button-price__price-alt"},[_vm._v("\n            Win: "+_vm._s(_vm.multiple)+"X\n          ")]):(_vm.isWin && _vm.price === 0)?_c('span',{staticClass:"button-price__price-alt"},[_vm._v("\n            Set the Market\n          ")]):_vm._e()]):_vm._e()])]:_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tV9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "tWD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":_vm.accountUploadDocumentTheme}}):(_vm.isStep(_vm.STEPS.INITIAL))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[(_vm.showPromoNotification)?_c('alert-box',{class:_vm.alertBoxPromoModifiers,attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification)?_c('alert-box',{class:_vm.alertBoxPromoModifiers,attrs:{"level":_vm.instantCreditBoxLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instantCreditBoxMessage)}})]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('alert-box',{staticClass:"add-funds-bank-transfer__alert-box add-funds-bank-transfer__alert-box--error",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):[(_vm.existingAccounts.length > 0)?_c('div',{staticClass:"add-funds-bank-transfer__accounts"},[_c('div',{staticClass:"add-funds-bank-transfer__title"},[_vm._v("\n          Use an Existing Account\n        ")]),_vm._v(" "),_vm._l((_vm.existingAccounts),function(account){return _c('bank-account',{key:account.authorizationId,staticClass:"add-funds-bank-transfer__account",attrs:{"account":account},on:{"select":function($event){return _vm.onSelect(account)},"remove":function($event){return _vm.onRemove(account)}}})})],2):_vm._e(),_vm._v(" "),_c('div',[_c('div',{ref:"paywithmybank",staticClass:"add-funds-bank-transfer__paywithmybank",attrs:{"id":_vm.payWithMyBankId}})]),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds-bank-transfer__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e()]],2):(_vm.isStep(_vm.STEPS.AMOUNT_CONFIRM))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[(_vm.showPromoNotification)?_c('alert-box',{class:_vm.alertBoxPromoModifiers,attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification)?_c('alert-box',{class:_vm.alertBoxPromoModifiers,attrs:{"level":_vm.instantCreditBoxLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instantCreditBoxMessage)}})]):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"add-funds-bank-transfer__cancel-title"},[_c('span',{staticClass:"add-funds-bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onLoadInitial($event)}}},[_vm._v("\n        Cancel\n      ")])]),_vm._v(" "),(_vm.account !== null)?_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"removable":false,"showMessage":false,"account":_vm.account},on:{"select":_vm.onLoadInitial}}):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Deposit Amount ($"+_vm._s(_vm.minimumDepositAmount.toFixed(2))+" Minimum)")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[(_vm.amountHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds-bank-transfer__error"},[_vm._v("\n          "+_vm._s(_vm.amountValidationMessage)+"\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"input-group input-group--large"},[_c('span',{staticClass:"input-group__addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"input-group__input",attrs:{"tabindex":"1","validation":_vm.$v.amount},domProps:{"value":(_vm.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value},_vm.$v.amount.$touch],"blur":_vm.handleAmountBlur}})])]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},_vm._l((_vm.depositAmounts),function(value){return _c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"button button--primary add-funds-bank-transfer__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onUpdateAmount(value)}}},[_c('span',{staticClass:"add-funds-bank-transfer__button-plus"},[_vm._v("+")]),_vm._v(" $"+_vm._s(value)+"\n              ")])])}),0)])]),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__confirm",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":_vm.onReviewAndConfirm}},[_c('span',[_vm._v("\n        Review And Confirm\n      ")])]),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds-bank-transfer__note add-funds-bank-transfer__note--large-padding"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e()],1):(_vm.isStep(_vm.STEPS.CONFIRM))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('h4',{staticClass:"add-funds-bank-transfer__cancel-title"},[_c('span',{staticClass:"add-funds-bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onCancelConfirm($event)}}},[_vm._v("\n        Cancel\n      ")])]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__info"},[_c('p',{staticClass:"add-funds-bank-transfer__info-large-para"},[_vm._v("\n        Are you sure you want to deposit\n      ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-bank-transfer__info-amount"},[_vm._v("\n        "+_vm._s(_vm.infoAmount)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-bank-transfer__info-large-para"},[_vm._v("\n        using Online Banking?\n      ")]),_vm._v(" "),_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"account":_vm.account,"preview":true}}),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":_vm.onSubmit}},[_c('span',[_vm._v("\n          Confirm And Deposit\n        ")])]),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds-bank-transfer__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e()],1)]):(_vm.isStep(_vm.STEPS.PROCESSING))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('processing-transaction')],1):(_vm.isStep(_vm.STEPS.FINISHED_SUCCESS))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_c('div',{staticClass:"add-funds-bank-transfer__icon"},[_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}})]),_vm._v(" "),_c('h5',{staticClass:"add-funds-bank-transfer__icon-title add-funds-bank-transfer__icon-title--success"},[_vm._v("\n        Success!\n      ")]),_vm._v(" "),_c('deposited'),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",on:{"click":_vm.onSuccess}},[_c('span',[_vm._v("\n          Done\n        ")])])],1)]):(_vm.isStep(_vm.STEPS.FINISHED_FAILED))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_c('div',{staticClass:"add-funds-bank-transfer__icon"},[_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}})]),_vm._v(" "),_c('div',[(_vm.currentStepData && _vm.currentStepData.error)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentStepData.error)}}):_c('span',[_vm._v("Unfortunately, we could not process your payment.")])])]),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",on:{"click":_vm.onLoadInitial}},[_c('span',[_vm._v("\n        Done\n      ")])])]):(_vm.isStep(_vm.STEPS.FINISHED_EXPIRED))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_c('h5',{staticClass:"add-funds-bank-transfer__title add-funds-bank-transfer__title--warn"},[_vm._v("\n        Bank Reauthorization Required\n      ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__expired-account"},[_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"account":_vm.account,"preview":true}})],1),_vm._v(" "),_c('div',[(_vm.currentStepData && _vm.currentStepData.error)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentStepData.error)}}):_c('p',[_vm._v("Unfortunately, we could not process your payment.")])]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__loader"}),_vm._v(" "),_c('div',[_c('div',{ref:"paywithmybank",staticClass:"add-funds-bank-transfer__paywithmybank add-funds-bank-transfer__paywithmybank--no-min-height",attrs:{"id":_vm.payWithMyBankId}})])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tWDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-underscore-dangle: ["error", { "allow": ["_e"] }] */
var init = false;

function twitter() {
  if (init) {
    return window.twttr;
  }

  window.twttr = function (d, s, id) {
    var fjs = d.getElementsByTagName(s)[0];
    var t = {};
    var js = d.createElement(s);
    js.id = id;
    js.src = 'https://platform.twitter.com/widgets.js';
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function (f) {
      t._e.push(f);
    };
    return t;
  }(document, 'script', 'twitter-wjs');

  init = true;
  return window.twttr;
}

/* harmony default export */ __webpack_exports__["a"] = (twitter);

/***/ }),

/***/ "tdTh":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tdTh";

/***/ }),

/***/ "teEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-platform-announcements"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-platform-announcements__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-platform-announcements__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tel1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialsLoader_vue__ = __webpack_require__("H1Lz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6621e2b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialsLoader_vue__ = __webpack_require__("5XgW");
function injectStyle (ssrContext) {
  __webpack_require__("2LR/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialsLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6621e2b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "thf6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-balance"},[_c('div',{staticClass:"available-balance__amount",domProps:{"innerHTML":_vm._s(_vm.balance)}}),_vm._v(" "),_c('div',{staticClass:"available-balance__title"},[_vm._v("Available Balance")]),_vm._v(" "),(_vm.restricted)?_c('div',{staticClass:"available-balance__restricted"},[_c('div',[_vm._v("\n      Restricted Balance "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.restricted)}})]),_vm._v(" "),_c('div',{staticClass:"available-balance__restricted-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tjGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-icon"},[(!_vm.reversed)?_c('div',[_c('img',{staticClass:"notification-icon__img",attrs:{"src":__webpack_require__("EoBZ")},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}}),_vm._v(" "),_c('span',{staticClass:"notification-icon__text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_vm._v(" "),(_vm.reversed)?_c('div',[_c('span',{staticClass:"notification-icon__text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('img',{staticClass:"notification-icon__img",attrs:{"src":__webpack_require__("EoBZ")},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tjXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tjp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateMarketContracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateMySharesMarket; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__ = __webpack_require__("a0yF");



var updateMarket = function updateMarket(market, data) {
  if (market.marketId === data.MarketId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["R" /* updateObjectValues */])(market, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["p" /* MARKET_DATA_MAP */]);
  }
  return market;
};

var updateContract = function updateContract(contract, data) {
  if (contract.contractId === data.ContractId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["R" /* updateObjectValues */])(contract, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["q" /* CONTRACT_DATA_MAP */]);
  }
  return contract;
};

var updateMarketContracts = function updateMarketContracts(market, data) {
  if (market.contracts) {
    market.contracts = market.contracts.map(function (contract) {
      return updateContract(contract, data);
    });
  }
  if (market.marketContracts) {
    market.marketContracts = market.marketContracts.map(function (contract) {
      return updateContract(contract, data);
    });
  }
  return market;
};

var updateMySharesMarket = function updateMySharesMarket(market, data) {
  if (market.marketId === data.MarketId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["R" /* updateObjectValues */])(market, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["r" /* MY_SHARES_MARKET_DATA_MAP */]);
  }
  return market;
};

/***/ }),

/***/ "tmS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var upperCaseOptions = ['yes', 'no'];

function setContractName(el) {
  var text = el.textContent.trim();
  if (upperCaseOptions.includes(text.toLowerCase())) {
    el.textContent = text.toUpperCase();
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    setContractName(el);
  },
  update: function update(el) {
    setContractName(el);
  }
});

/***/ }),

/***/ "tp7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-update-image"},[_c('div',{staticClass:"account-update-image__note"},[_vm._v("\n   Profile images are reviewed before publication. Your new image will be visible after this review.\n  ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width account-update-image__button",on:{"click":_vm.onUpload}},[_vm._v("\n    Upload Photo\n  ")]),_vm._v(" "),_c('input',{ref:"fileinput",staticClass:"account-update-image__input",attrs:{"type":"file"},on:{"change":_vm.onChange}}),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width account-update-image__button",attrs:{"disabled":!_vm.showRemoveOption},on:{"click":_vm.onRemove}},[_vm._v("\n    Remove Current Photo\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ttZ6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "tumW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__ = __webpack_require__("tWDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






function styleTwitterTimeline($content) {
  if ($content) {
    var style = document.createElement('style');
    style.innerHTML += 'a {color:#67999f;}';
    style.innerHTML += '.timeline-Widget {padding:19px 13px;}';
    style.innerHTML += '.timeline-Header {margin-bottom:9px;padding:0;}';
    style.innerHTML += '.timeline-Header-title {color:#263b3f;font-size:26px;line-height:17px;letter-spacing:0.03em;font-weight:500;}';
    style.innerHTML += '.timeline-Header-byline {color:#263b3f;}';
    style.innerHTML += '.SandboxRoot.env-bp-430 .timeline-Tweet-text {font-size:14px;line-height:18px;font-weight:500;color:#263b3f;}';
    style.innerHTML += '.timeline-TweetList-tweet {border-top:1px solid #b8c5c6;}';
    style.innerHTML += '.timeline-Body {border-top:1px solid #b8c5c6;border-bottom:1px solid #b8c5c6;}';
    var head = $content.getElementsByTagName('head');

    if (head && head.length > 0) {
      head[0].appendChild(style);
    }
  }
}

function createTimeline(twt, el) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;

  var options = {
    chrome: 'nofooter'
  };

  if (width <= 320) {
    options.width = 300;
  }

  if (limit !== -1) options.tweetLimit = limit;
  twt.widgets.createTimeline({
    sourceType: 'profile',
    screenName: "PredictIt"
  }, el, options).then(function (iframeEl) {
    if (!iframeEl) return;
    // const $content = iframeEl.contentDocument;
    // styleTwitterTimeline($content);

    if (callback !== null && typeof callback === 'function') {
      callback();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    inOverlay: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    numTweets: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      identifier: +new Date(),
      loading: false,
      ready: false,
      hideFooter: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isShutdownModeOn']), {
    getMoreTweetsLabel: function getMoreTweetsLabel() {
      return this.isLayoutDesktop ? 'More Tweets' : 'Load more';
    },
    classModifiers: function classModifiers() {
      return {
        twittertimeline: true,
        'twittertimeline--loading': this.loading
      };
    },
    initClassModifiers: function initClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'twittertimeline__iframe-wrapper': true
      }, 'twittertimeline__iframe-wrapper--' + this.identifier, this.identifier);
    },
    contentClassModifiers: function contentClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        twittertimeline__content: true,
        'twittertimeline__content--shutdown': this.isShutdownModeOn
      }, 'twittertimeline__content--' + this.theme, this.theme);
    },
    showFooter: function showFooter() {
      return !this.inOverlay && !this.hideFooter;
    },
    tweetLimit: function tweetLimit() {
      return !this.inOverlay ? this.numTweets : undefined;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onFooterMoreButtonClick: function onFooterMoreButtonClick(e) {
      var _this = this;

      e.stopPropagation();
      if (this.isLayoutDesktop) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].TWITTER);
      } else {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
          return createTimeline(twt, _this.$refs.more, undefined, function () {
            _this.loading = false;
            _this.hideFooter = true;
            _this.$refs.init.remove();
          });
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.loading = true;
    setTimeout(function () {
      _this2.loading = false;
    }, 5000);
    this.$nextTick(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
        twt.events.bind('loaded', function () {
          _this2.loading = false;
          _this2.ready = true;
        });
        createTimeline(twt, _this2.$refs.init, _this2.tweetLimit, function () {
          _this2.loading = false;
        });
      });
    });
  }
});

/***/ }),

/***/ "tvM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-detail-page-loader"},[_c('div',{staticClass:"market-detail-page-loader__content"},[_c('div',{staticClass:"market-detail-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"market-detail-page-loader__text-2"}),_vm._v(" "),_c('div',{staticClass:"market-detail-page-loader__text-3"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tyTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_ownership_js__ = __webpack_require__("nfG2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2ab5582_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_ownership_vue__ = __webpack_require__("gTKa");
function injectStyle (ssrContext) {
  __webpack_require__("tLet")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_ownership_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2ab5582_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_ownership_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u/mk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-enable-classic-predictit"},[_c('form-errors',{staticClass:"account-enable-classic-predictit__errors",attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('p',{staticClass:"account-enable-classic-predictit__first"},[_vm._v("\n      Your PredictIt account gives you access to all PredictIt products. Since each product has different terms you must enable each product individually.\n    ")]),_vm._v(" "),_c('p',{staticClass:"account-enable-classic-predictit__second"},[_vm._v("\n      By clicking \"Enable PredictIt Classic\", you confirm that you are at least 18 years of age and have read the "),_c('router-link',{staticClass:"account-enable-classic-predictit__link",attrs:{"to":{ name: 'terms-and-conditions', params: { noPopup: true } },"target":"_blank"}},[_vm._v("\n          Terms and Conditions\n        ")]),_vm._v(". One account per person.\n    ")],1),_vm._v(" "),_c('div',{staticClass:"account-enable-classic-predictit__button"},[_c('form-submit',{attrs:{"disabled":!_vm.isFormEnabled,"label":"Enable PredictIt Classic"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u0d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_support_support_support_vue__ = __webpack_require__("0fv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_support_help_and_support_help_and_support_vue__ = __webpack_require__("wv8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_support_learn_the_basics_learn_the_basics_vue__ = __webpack_require__("imzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_support_community_forums_community_forums_vue__ = __webpack_require__("r78W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__ = __webpack_require__("ZIhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_support_what_is_predictit_what_is_predictit_vue__ = __webpack_require__("CCA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_support_videos_videos_vue__ = __webpack_require__("HSd1");








/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/support',
  component: __WEBPACK_IMPORTED_MODULE_0__components_support_support_support_vue__["a" /* default */],
  props: true,
  children: [{
    path: '',
    name: 'HelpAndSupport',
    component: __WEBPACK_IMPORTED_MODULE_1__components_support_help_and_support_help_and_support_vue__["a" /* default */],
    props: true
  }, {
    path: 'what-is-predictit',
    name: 'WhatIsPredictIt',
    component: __WEBPACK_IMPORTED_MODULE_5__components_support_what_is_predictit_what_is_predictit_vue__["a" /* default */],
    props: true
  }, {
    path: 'how-to-trade-on-predictit',
    name: 'LearnTheBasics',
    component: __WEBPACK_IMPORTED_MODULE_2__components_support_learn_the_basics_learn_the_basics_vue__["a" /* default */],
    props: true
  }, {
    path: 'community-forums',
    name: 'ComunityForums',
    component: __WEBPACK_IMPORTED_MODULE_3__components_support_community_forums_community_forums_vue__["a" /* default */],
    props: true
  }, {
    path: 'faq',
    name: 'Faq',
    component: __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__["a" /* default */],
    props: true
  }, {
    path: 'videos',
    name: 'Videos',
    component: __WEBPACK_IMPORTED_MODULE_6__components_support_videos_videos_vue__["a" /* default */],
    props: true
  }]
}]);

/***/ }),

/***/ "u1Yt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u9HT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userDetails__ = __webpack_require__("jtWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_userDetails__["a" /* default */]],
  props: {
    widget: Object
  },
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: 5000,
        slidesPerGroup: 2,
        slidesPerView: 2,
        slidesPerColumn: 1,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerGroup: 1,
            slidesPerView: 1,
            slidesPerColumn: 2
          }
        }
      }
    };
  },

  computed: {
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    traderCount: function traderCount() {
      return this.widget ? this.widget.activeTraderCount.toLocaleString('en-US') : '';
    },
    traders: function traders() {
      return this.obj.traders;
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  methods: {
    traderLevelDisplay: function traderLevelDisplay(item) {
      var level = this.getLevelByPredictions(item.profitablePredictions);
      return 'Level ' + level.num + ' (' + level.text + ')';
    },
    priceClassModifiers: function priceClassModifiers() {
      return {
        'market-currently-predicting__price': true
        // 'market-currently-predicting__price--multiple': !this.isMarketSingle(market),
        // 'market-currently-predicting__price--single': this.isMarketSingle(market),
      };
    },
    isMarketSingle: function isMarketSingle(market) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* isMarketSingle */])(market);
    },
    boughtSold: function boughtSold(type) {
      return type < 2 ? 'Bought' : 'Sold';
    },
    yesNo: function yesNo(type) {
      return type % 2 === 0 ? 'No' : 'Yes';
    },
    classModifier: function classModifier(type) {
      return {
        'market-currently-predicting__type': true,
        'market-currently-predicting__type--no': type % 2 === 0
      };
    },
    onClick: function onClick(pred) {
      if (pred.marketId) {
        this.$router.push({
          name: 'market-details',
          params: { marketId: pred.marketId, marketUrl: pred.marketUrl }
        });
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "uAZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_research_js__ = __webpack_require__("htHi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a43aaa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_research_vue__ = __webpack_require__("pSXB");
function injectStyle (ssrContext) {
  __webpack_require__("85+t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_research_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a43aaa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_research_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uCH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_pending_request_withdrawal_pending_request_withdrawal_vue__ = __webpack_require__("94vp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__["a" /* default */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__["a" /* default */],
    pendingRequest: __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_pending_request_withdrawal_pending_request_withdrawal_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.getPendingWithdrawals().then(function () {
      _this.isComponentReady = true;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['pendingRequests'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getPendingWithdrawals']), {
    onComplete: function onComplete() {
      this.getPendingWithdrawals();
    }
  })
});

/***/ }),

/***/ "uDCm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDSN":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgdmlld0JveD0iMCAwIDM1IDM1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTYuNSIgY3k9IjE2LjUiIHI9IjE3IiBzdHJva2U9IiM4M0M1NjgiIGZpbGw9IiM4M0M1NjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjUuMjYgMTMuNTUzbC04LjkxIDkuMTI1YTEuNDQyIDEuNDQyIDAgMCAxLTIuMDc1IDBsLTMuNzIyLTMuODFhMS41MzIgMS41MzIgMCAwIDEgMC0yLjEyNyAxLjQ0NCAxLjQ0NCAwIDAgMSAyLjA3NSAwbDIuNjg1IDIuNzUgNy44NzItOC4wNjNhMS40NDIgMS40NDIgMCAwIDEgMi4wNzYgMCAxLjUyNyAxLjUyNyAwIDAgMSAwIDIuMTI1Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "uEEg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uN8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_js__ = __webpack_require__("zyjZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53208cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_vue__ = __webpack_require__("zTpV");
function injectStyle (ssrContext) {
  __webpack_require__("I4Gm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53208cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uTAh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-and-support"},[_c('div',{class:_vm.mainRowModifiers},[_c('div',{class:_vm.mainColumnModifiers},[_c('div',{staticClass:"help-and-support__content"},[_vm._l((_vm.items),function(item){return _c('link-tile',{key:item.title,staticClass:"help-and-support__tile",attrs:{"href":item.href,"title":item.title,"icon":item.icon,"subtitle":item.subtitle}})}),_vm._v(" "),_c('router-view')],2),_vm._v(" "),(_vm.announcements.length > 0)?[_c('p',{staticClass:"help-and-support__contact-us"},[_vm._v("Announcements")]),_vm._v(" "),_c('div',{staticClass:"help-and-support__announcements-content"},[_c('ul',{staticClass:"help-and-support__announcements-list"},_vm._l((_vm.announcements),function(announcement){return _c('li',{key:announcement.announcementId,staticClass:"help-and-support__announcement"},[_c('div',{domProps:{"innerHTML":_vm._s(announcement.title)}}),_vm._v(" "),(!!announcement.body)?_c('div',{staticClass:"help-and-support__announcements-link",on:{"click":function($event){return _vm.showAnnouncement(announcement)}}},[_vm._v("(Details)")]):_vm._e()])}),0)])]:_vm._e(),_vm._v(" "),_c('p',{staticClass:"help-and-support__contact-us"},[_vm._v("Contact Us")]),_vm._v(" "),_c('div',{staticClass:"help-and-support__form-box"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{ref:"fileuploadform",attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form-input',{staticClass:"help-and-support__email",attrs:{"disabled":_vm.isFormDisabled,"required":true,"validation":_vm.$v.fields.email,"autocomplete":"off","name":"help-input","placeholder":"Email","type":"email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}}),_vm._v(" "),_c('form-select',{staticClass:"help-and-support__subject",attrs:{"searchable":false,"maxHeight":300,"adjust":false,"disabled":_vm.isFormDisabled,"options":_vm.subjectOptions,"required":true,"label":"label","placeholder":"Subject","track-by":"value"},on:{"input":_vm.$v.fields.subject.$touch},model:{value:(_vm.fields.subject),callback:function ($$v) {_vm.$set(_vm.fields, "subject", $$v)},expression:"fields.subject"}}),_vm._v(" "),_c('form-textarea',{staticClass:"help-and-support__message",attrs:{"required":_vm.messageRequired,"name":"help-message","placeholder":_vm.messagePlaceholder},model:{value:(_vm.fields.message),callback:function ($$v) {_vm.$set(_vm.fields, "message", $$v)},expression:"fields.message"}}),_vm._v(" "),_c('input',{ref:"fileinput",staticClass:"help-and-support__file",attrs:{"type":"file","multiple":"multiple","accept":_vm.acceptAllowedExtensions},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"help-and-support__footer"},[(_vm.isUploadEnabled)?_c('button',{staticClass:"help-and-support__button help-and-support__upload",attrs:{"disabled":_vm.isFormDisabled,"name":"upload-button","type":"button"},on:{"click":_vm.onUpload}},[_vm._v("\n              Upload\n            ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"help-and-support__press"},[_vm._v("For market suggestions, please email:"),_c('br'),_vm._v(" "),_c('a',{staticClass:"help-and-support__press-link",attrs:{"href":("mailto:" + (_vm.systemEmails.support))}},[_vm._v(_vm._s(_vm.systemEmails.support))])])]),_vm._v(" "),(_vm.files.length > 0)?_c('ul',{staticClass:"help-and-support__files"},[_vm._l((_vm.files),function(file,index){return [_c('li',[_vm._v(_vm._s(file.name)+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.fileRemove(index)}}},[_vm._v("(Remove)")])])]})],2):_vm._e(),_vm._v(" "),(_vm.isAnyFileInvalid)?_c('div',{staticClass:"help-and-support__error"},[_vm._v("\n            One of the files has invalid format. Valid file formats: "+_vm._s(_vm.acceptAllowedExtensions)+".\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"help-and-support__footer"},[_c('button',{staticClass:"help-and-support__button help-and-support__submit",attrs:{"type":"submit","disabled":_vm.invalidOrDisabled || _vm.isAnyFileInvalid,"name":"help-button"}},[_vm._v("Send")]),_vm._v(" "),_c('p',{staticClass:"help-and-support__press"},[_vm._v("For press inquiries, please contact:"),_c('br'),_vm._v(" "),_c('a',{staticClass:"help-and-support__press-link",attrs:{"href":("mailto:" + (_vm.systemEmails.press))}},[_vm._v(_vm._s(_vm.systemEmails.press))])])])],1)],1)],2),_vm._v(" "),(_vm.showVideos)?_c('div',{staticClass:"column large-4"},[_c('videos',{staticClass:"help-and-support__videos",attrs:{"asWidget":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uVqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_trade_confirmed_js__ = __webpack_require__("BmES");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410b68a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_trade_confirmed_vue__ = __webpack_require__("3VsP");
function injectStyle (ssrContext) {
  __webpack_require__("EeD/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_trade_confirmed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410b68a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_trade_confirmed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uY0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_extended_betslip_contract_info_js__ = __webpack_require__("RGPW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2207a67b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_extended_betslip_contract_info_vue__ = __webpack_require__("NNk1");
function injectStyle (ssrContext) {
  __webpack_require__("iwZ2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_extended_betslip_contract_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2207a67b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_extended_betslip_contract_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uZm2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uath":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_contracts_history_js__ = __webpack_require__("1/Lc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4fcdc74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contracts_history_vue__ = __webpack_require__("Tnlz");
function injectStyle (ssrContext) {
  __webpack_require__("FV5o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_contracts_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4fcdc74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contracts_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ub3M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ubfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-switch__overlay"},[_c('div',{staticClass:"modal-switch__wrapper",class:_vm.isAltViewModifier},[_c('div',{staticClass:"modal-switch__header"},[(_vm.showSwitchButton)?_c('button',{staticClass:"modal-switch__info",on:{"click":_vm.toggle}}):_vm._e(),_vm._v(" "),(!_vm.altModeOn)?_vm._t("header"):_vm._e(),_vm._v(" "),(_vm.altModeOn)?_vm._t("altheader"):_vm._e(),_vm._v(" "),_c('button',{staticClass:"modal-switch__close",on:{"click":_vm.close}})],2),_vm._v(" "),_c('div',{staticClass:"modal-switch__content"},[(!_vm.altModeOn)?_vm._t("content"):_vm._e(),_vm._v(" "),(_vm.altModeOn)?_vm._t("altcontent"):_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ucfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketWidgetLoader_vue__ = __webpack_require__("7Ymm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e23c9c30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketWidgetLoader_vue__ = __webpack_require__("UTL5");
function injectStyle (ssrContext) {
  __webpack_require__("DIeW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketWidgetLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e23c9c30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketWidgetLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ucfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TAB_SEVEN_DAYS; });
/* unused harmony export TAB_THIRTY_DAYS */
/* unused harmony export TAB_NINETY_DAYS */
/* unused harmony export TAB_TWENTY_FOUR_HOURS */
/* unused harmony export TAB_RANGE */
/* unused harmony export TAB_STATS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");












var MARKET_OPEN_DAYS_TWENTY_HOUR_CHART = 2;
var TAB_SEVEN_DAYS = '7d';
var TAB_THIRTY_DAYS = '30d';
var TAB_NINETY_DAYS = '90d';
var TAB_TWENTY_FOUR_HOURS = '24h';
var TAB_RANGE = '0';
var TAB_STATS = 'stats';

var TAB_LINE = 'line';
var TAB_CANDLE = 'candle';

var LS_SHOW_VOLUME_CHART = 'showVolumeChart';
var LS_SHOW_PRICE_AXIS_ZOOM = 'showPriceAxisZoom';

var UNIT_OF_TIME_MAP = {
  1: 'h',
  2: 'd'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_loader__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__["a" /* default */],
    smallModal: __WEBPACK_IMPORTED_MODULE_9__components_generics_modal_small_small_vue__["default"]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      default: null
    },
    showVolume: {
      type: Boolean,
      default: false
    },
    showPriceAxisZoom: {
      type: Boolean,
      default: true
    },
    isChartLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showVolumeChart: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get(LS_SHOW_VOLUME_CHART, this.showVolume),
      showPriceAxisZoomValue: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get(LS_SHOW_PRICE_AXIS_ZOOM, this.showPriceAxisZoom),
      showMenu: false,
      activeTabPeriod: null,
      activeTabType: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    isForStory: function isForStory() {
      return !!__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'cmsStoryId', null);
    },
    tabsPeriodStyleModifiers: function tabsPeriodStyleModifiers() {
      return {};
    },

    /*
    *  Determines which timeframe mode to use. A chart can show a timeframe
    *  in one of two ways:
    *    1) Date Range - data between a start date and end date
    *    2) To Date: data from the last X days/hours to the current date
    */
    useDateRange: function useDateRange() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'useDateRange', false);
    },

    /*
    * "To Date" is a timeframe that shows the last X days/hours of data and is
    * used if not using the "Date Range" timeframe. Each option is formatted
    * {
    *   unit: Number (1 for hour, 2 for days)
    *   quantity: Number (integer representing how many days/hours)
    *   isDefault: Boolean (whether this option should be the default option)
    * }
    * These options will become the period tabs.
    */
    toDateOptions: function toDateOptions() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'toDateAvailableOptions');
    },
    dateRangeUnit: function dateRangeUnit() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'dateRangeUnit');
    },
    showDateRangeTab: function showDateRangeTab() {
      return this.useDateRange && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'startDate', null) !== null && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'endDate', null) !== null;
    },
    showToDateTab: function showToDateTab() {
      return !this.useDateRange && this.toDateOptions && this.toDateOptions.length > 0;
    },
    defaultRangeTab: function defaultRangeTab() {
      var suffix = this.dateRangeUnit ? UNIT_OF_TIME_MAP[this.dateRangeUnit] : 'd';
      return { name: '' + TAB_RANGE + suffix, title: null, icon: 'calendar' };
    },
    defaultToDateTab: function defaultToDateTab() {
      var defaultToDateOption = this.showToDateTab ? this.toDateOptions.find(function (option) {
        return option.isDefault;
      }) || this.toDateOptions[0] : null;
      return this.tabFromToDateOption(defaultToDateOption);
    },
    tabsPeriod: function tabsPeriod() {
      var _this = this;

      var items = [];

      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include24hr', false)) {
        items.push({ name: TAB_TWENTY_FOUR_HOURS, title: '24h' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include7day', false)) {
        items.push({ name: TAB_SEVEN_DAYS, title: '7d' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include30day', false)) {
        items.push({ name: TAB_THIRTY_DAYS, title: '30d' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include90day', false)) {
        items.push({ name: TAB_NINETY_DAYS, title: '90d' });
      }

      if (this.showDateRangeTab) {
        items.push(this.defaultRangeTab);
      } else if (this.showToDateTab) {
        this.toDateOptions.forEach(function (option) {
          return items.push(_this.tabFromToDateOption(option));
        });
      }
      return items;
    },
    tabsType: function tabsType() {
      var items = [];
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeCandle', false)) {
        items.push({ name: TAB_CANDLE, title: 'Candle' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeLine', false)) {
        items.push({ name: TAB_LINE, title: 'Line' });
      }
      return items;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['setChartTimeline', 'getMarketContractsStats', 'setChartType']), {
    onOpenSettings: function onOpenSettings() {
      this.showMenu = !this.showMenu;
    },
    onClickOutside: function onClickOutside() {
      this.showMenu = false;
    },
    onOpenStats: function onOpenStats() {
      var _this2 = this;

      if (this.isChartLoading) {
        return;
      }
      this.loaderAdd(document.body);
      this.showMenu = false;
      this.getMarketContractsStats(this.market.marketId).then(function (data) {
        _this2.loaderRemove(document.body);
        _this2.setGenericPopup({
          name: 'market-contracts-stats',
          options: {
            stats: data,
            isFixed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["q" /* hasMarketHiddenContracts */])(_this2.market)
          }
        });
      }).catch(function () {
        return _this2.loaderRemove(document.body);
      });
    },
    tabChangePeriod: function tabChangePeriod(name) {
      if (this.isChartLoading) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('[CHART][TIMELINE] tabChangePeriod to ' + name + ' for ' + this.market.marketId);
      this.activeTabPeriod = name;
      this.setChartTimeline(name);
      this.$emit('timelineChange', this.activeTabPeriod);
    },
    tabChangeType: function tabChangeType(name) {
      if (this.isChartLoading) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('[CHART][TIMELINE] tabChangeType to ' + name + ' for ' + this.market.marketId);
      this.activeTabType = name;
      this.setChartType(name);
      this.$emit('typeChange', this.activeTabType);
    },
    tabsPeriodHandler: function tabsPeriodHandler(items) {
      var dateOpenedDayDiff = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.market.dateOpened), 'days');
      var activeTabPeriod = dateOpenedDayDiff < MARKET_OPEN_DAYS_TWENTY_HOUR_CHART ? TAB_TWENTY_FOUR_HOURS : TAB_SEVEN_DAYS;
      if (this.showDateRangeTab) {
        activeTabPeriod = this.defaultRangeTab.name;
      } else if (this.showToDateTab) {
        activeTabPeriod = this.defaultToDateTab.name;
      }

      var activeTab = items.find(function (tab) {
        return tab.name === activeTabPeriod;
      });
      if (activeTab) {
        this.activeTabPeriod = activeTabPeriod;
      } else if (items.length > 0) {
        this.activeTabPeriod = items[0].name;
      }
    },
    tabsTypeHandler: function tabsTypeHandler(value) {
      if (!value || value.length === 0) return;
      if (value.find(function (i) {
        return i.name === TAB_LINE;
      })) {
        this.activeTabType = TAB_LINE;
      } else {
        this.activeTabType = value[0].name;
      }
    },
    tabFromToDateOption: function tabFromToDateOption(toDateOption) {
      if (toDateOption) {
        var name = '' + toDateOption.quantity + UNIT_OF_TIME_MAP[toDateOption.unit];
        var title = name;
        return { name: name, title: title };
      }
      return {};
    },
    onVolumeChartToggle: function onVolumeChartToggle() {
      if (this.isChartLoading) {
        return;
      }
      this.showVolumeChart = !this.showVolumeChart;
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set(LS_SHOW_VOLUME_CHART, this.showVolumeChart);
      this.$emit('volumeChartToggle', this.showVolumeChart);
    },
    onPriceAxisZoomToggle: function onPriceAxisZoomToggle() {
      if (this.isChartLoading) {
        return;
      }
      this.showPriceAxisZoomValue = !this.showPriceAxisZoomValue;
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set(LS_SHOW_PRICE_AXIS_ZOOM, this.showPriceAxisZoomValue);
      this.$emit('priceAxisZoomToggle', this.showPriceAxisZoomValue);
    }
  }),
  watch: {
    tabsPeriod: {
      handler: 'tabsPeriodHandler',
      immediate: true
    },
    tabsType: {
      handler: 'tabsTypeHandler',
      immediate: true
    }
  },
  mounted: function mounted() {
    this.$emit('volumeChartToggle', this.showVolumeChart);
    this.$emit('priceAxisZoomToggle', this.showPriceAxisZoomValue);
    __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('[CHART][TIMELINE] got ' + this.tabsPeriod.length + ' period tabs and ' + this.tabsType.length + ' type tabs for ' + this.market.marketId);
  }
});

/***/ }),

/***/ "uf7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_links_js__ = __webpack_require__("680R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5284c5fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_links_vue__ = __webpack_require__("5zJi");
function injectStyle (ssrContext) {
  __webpack_require__("WHJu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_links_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5284c5fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "umUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");










var toRoute = '';
var restore = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__["a" /* default */]],
  components: {
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_8__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Privacy Policy'
    };
  },
  data: function data() {
    return {
      content: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* STATIC_PAGES */].PRIVACY).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  },

  // beforeDestroy() {
  //   // firest after router loop
  //   if (restore) {
  //     store.dispatch('popup/restorePopup', toRoute);
  //   }
  // },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var popup = to.params.noPopup ? null : __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('popup/rememberPopup', {
      route: from.name,
      popup: popup
    });
    next();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'terms-and-conditions';
    toRoute = to.name;
    next();
  }
});

/***/ }),

/***/ "uo5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  props: {
    showIcons: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    classModifiers: function classModifiers() {
      return {
        'app-bottom-nav': true,
        'app-bottom-nav--logged-in': this.isLoggedIn
      };
    },
    enabledLinks: function enabledLinks() {
      return this.links.filter(function (i) {
        return i.enabled;
      });
    },
    links: function links() {
      if (this.isLoggedIn) {
        return [{
          title: 'Markets',
          name: 'markets',
          href: '/markets',
          enabled: true
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard',
          enabled: true
        }, {
          title: 'Account',
          name: 'account',
          href: this.accountLink,
          enabled: true
        }];
      }

      return [{
        title: 'Markets',
        name: 'markets',
        href: '/markets',
        enabled: true
      }, {
        title: 'News',
        name: 'news',
        href: '/news',
        enabled: true
      }, {
        title: 'Learn',
        name: 'help',
        href: '/support',
        enabled: true
      }];
    }
  }),
  methods: {
    itemClassModifier: function itemClassModifier(item) {
      return {
        'app-bottom-nav__item': true,
        'app-bottom-nav__item--active': this.$route.path.includes(item.href),
        'app-bottom-nav__item--logged-in': this.isLoggedIn
      };
    },
    linkClassModifiers: function linkClassModifiers(name) {
      var _ref;

      var routes = ['market-details'];
      var dontHighlight = routes.includes(this.$route.name);
      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'app-bottom-nav__link-with-icon app-bottom-nav__link-with-icon--' + name, this.showIcons), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'app-bottom-nav__link--no-highlight', dontHighlight), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'app-bottom-nav__link', true), _ref;
    },
    showSocialAvatarOnMobile: function showSocialAvatarOnMobile(item) {
      return this.isLayoutMobile && item.name === 'dashboard' && this.isLoggedIn;
    },
    showRegularItem: function showRegularItem(item) {
      return this.isLayoutMobile ? item.name !== 'dashboard' : true;
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLinkClick: function onLinkClick(href) {
      // scroll page to top if link is clicked again
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
    }
  }
});

/***/ }),

/***/ "urbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_0__components_static_page_header_static_page_header_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "utJg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,attrs:{"data-tooltip":_vm.saleDisabled ? _vm.disabledTooltip : null},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('button-price',{key:_vm.price,staticClass:"market-button-direction__price",attrs:{"price":_vm.price,"text":_vm.text,"win":_vm.win,"sell":_vm.sell,"active":_vm.isActive}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uvRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-privacy-policy"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-privacy-policy__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-privacy-policy__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uvwz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_state_icon_js__ = __webpack_require__("0HU1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21929832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_state_icon_vue__ = __webpack_require__("oibH");
function injectStyle (ssrContext) {
  __webpack_require__("r/18")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_state_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21929832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_state_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v+Mv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_terms_and_conditions_js__ = __webpack_require__("xqHz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ec6584_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_terms_and_conditions_vue__ = __webpack_require__("SWC/");
function injectStyle (ssrContext) {
  __webpack_require__("pMeB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_terms_and_conditions_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ec6584_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_terms_and_conditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v/bO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_keyboard_numeric_input_sushi_keyboard_numeric_input_sushi_vue__ = __webpack_require__("JLAi");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    keyboardNumericInputSushi: __WEBPACK_IMPORTED_MODULE_3__components_keyboard_numeric_input_sushi_keyboard_numeric_input_sushi_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: 'Minimum Sell Price'
    },
    value: {
      type: Number,
      default: 50
    },
    kind: {
      type: String,
      default: 'modal'
    },
    selected: Boolean,
    tabindex: Number
  },
  data: function data() {
    return {
      cents: this.value !== null ? parseInt(this.value, 10) : 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    minimumCentValue: function minimumCentValue() {
      return 1;
    },
    classModifier: function classModifier() {
      var _ref;

      return _ref = {
        'purchase-offer-value-sushi': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'purchase-offer-value-sushi--' + this.kind, this.kind), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'purchase-offer-value-sushi--selected', this.selected), _ref;
    }
  }),
  watch: {
    cents: 'updateOffer',
    value: function value(_value) {
      this.cents = _value !== null ? parseInt(_value, 10) : 0;
    }
  },
  methods: {
    add: function add() {
      if (isNaN(this.cents) || this.cents === null) this.cents = this.minimumCentValue;
      this.cents += 1;
    },
    subtract: function subtract() {
      if (isNaN(this.cents) || this.cents === null) this.cents = this.minimumCentValue;
      if (this.cents === this.minimumCentValue) return;
      this.cents -= 1;
    },
    updateOffer: function updateOffer() {
      this.cents = parseInt(this.cents, 10);
      if (isNaN(this.cents) || this.cents < 1) this.cents = null;else if (this.cents > 99) this.cents = 99;

      if (this.cents !== null) {
        this.$emit('input', Number(this.cents));
      } else {
        this.$emit('input', this.cents);
      }
    },
    click: function click() {
      this.$emit('click');
    },
    onBoxClick: function onBoxClick() {
      if (this.isLayoutDesktop) {
        this.$refs.input.focus();
      }
    }
  }
});

/***/ }),

/***/ "v01n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MARKET_CONTRACT_INFO_VALUES_LAYOUT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_winner_v2_market_winner_v2_vue__ = __webpack_require__("q1K7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");









var MARKET_CONTRACT_INFO_VALUES_LAYOUT = {
  BLANK: 'blank',
  BLANK_DETAILED: 'blank-detailed',
  CONTRACTS_SUMMARY: 'contracts-summary'
};

/* harmony default export */ __webpack_exports__["b"] = ({
  props: {
    market: {
      type: Object,
      required: false,
      default: null
    },
    contract: {
      type: Object,
      required: false,
      default: null
    },
    image: {
      type: String,
      required: false,
      default: null
    },
    link: {
      required: false,
      default: null
    },
    layout: {
      type: String,
      default: MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK
    },
    addFakeContracts: {
      type: Boolean,
      default: true
    },
    marketId: {},
    contractId: {},
    useCurrentPriceSymbol: {
      type: Boolean,
      default: false // set to true when we want layout to use current price symbol, false by default as its not necesaryy everywhere
    }
  },
  components: {
    marketWinnerV2: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_winner_v2_market_winner_v2_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: MARKET_CONTRACT_INFO_VALUES_LAYOUT
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['currentPriceSymbol']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    isCompactLayout: function isCompactLayout() {
      var layouts = [MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK, MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY];
      return layouts.includes(this.layout);
    },
    isDetailedLayout: function isDetailedLayout() {
      var layouts = [MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED];
      return layouts.includes(this.layout);
    },
    marketContracts: function marketContracts() {
      if (!this.market || !this.market.contracts) return [];
      var results = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.market.contracts || []);
      if (!results) return [];

      /* Add fake copy of a contract that represents NO contracts */
      var names = ['Yes', 'No'];
      if (this.addFakeContracts && results.length === 1 && names.includes(this.getContractName(results[0]))) {
        var noContract = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ noContract: true }, results[0]);
        results.push(noContract);
      }

      return results;
    },
    imageUrl: function imageUrl() {
      if (this.image !== null) {
        return this.image;
      }
      if (this.contract !== null) {
        return this.contract.contractImageUrl;
      }

      if (this.market !== null) {
        return this.market.marketImageUrl;
      }
      return null;
    },
    imageStyleModifiers: function imageStyleModifiers() {
      if (this.imageUrl !== null) {
        return {
          'background-image': 'url(\'' + this.imageUrl + '\')'
        };
      }
      return {};
    },
    title: function title() {
      if (this.contract !== null) {
        return this.contract;
      }

      if (this.market !== null) {
        return this.market.marketName;
      }

      return '';
    },
    isMarketSingle: function isMarketSingle() {
      return this.market !== null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    detailsLink: function detailsLink() {
      if (this.link) return this.link;
      if (this.market !== null) {
        return {
          name: 'market-details',
          params: { marketId: this.market.marketId }
        };
      }
      if (this.marketId !== null) {
        var query = {};
        if (this.contractId !== null) {
          query.contractId = this.contractId;
        }
        return {
          name: 'market-details',
          params: { marketId: this.marketId },
          query: query
        };
      }
      return '';
    },
    priceSymbol: function priceSymbol() {
      return this.useCurrentPriceSymbol ? this.currentPriceSymbol : undefined;
    }
  }),
  methods: {
    getContactInstance: function getContactInstance(data) {
      return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](data);
    },
    getContractName: function getContractName(data) {
      return data.contractShortName || data.contractName || data.name;
    },
    contractTitle: function contractTitle(data) {
      if (!this.isMarketSingle) {
        return this.getContractName(data);
      }
      return data.noContract ? 'No' : 'Yes';
    },
    contractPrice: function contractPrice(data) {
      var instance = this.getContactInstance(data);
      var lastPrice = instance.lastTradePriceAsCents;
      if (!instance.hasLastTradePrice) {
        return 0;
      }
      if (data.noContract) {
        return 100 - lastPrice;
      }
      return lastPrice;
    },
    contractHasLastTradePrice: function contractHasLastTradePrice(data) {
      var instance = this.getContactInstance(data);
      return instance.hasLastTradePrice;
    },
    contractChanePrice: function contractChanePrice(data) {
      var instance = this.getContactInstance(data);
      if (!instance.hasLastTradePrice) {
        return 0;
      }
      var price = instance.changePriceAsCents;
      return data.noContract ? -price : price;
    },
    contractLastClosePrice: function contractLastClosePrice(data) {
      var instance = this.getContactInstance(data);
      return instance.lastClosePrice;
    },
    contractKey: function contractKey(contract) {
      var suffix = contract.noContract ? 'no' : 'yes';
      return contract.contractId + '-' + suffix;
    }
  }
});

/***/ }),

/***/ "v0Cj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_orientation_info_js__ = __webpack_require__("XrgL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca07128_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orientation_info_vue__ = __webpack_require__("A7mH");
function injectStyle (ssrContext) {
  __webpack_require__("hQNd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_orientation_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca07128_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orientation_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v0IF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-transfer"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"withdraw"}}):[(!_vm.showConfirmation)?_c('div',[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending}}):[(!_vm.hasErrorMessage)?[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n            Withdrawing funds may cause some or all of your open orders to be cancelled.\n          ")]),_vm._v(" "),_c('div',{staticClass:"form bank-transfer__form"},[_c('available-balance',{attrs:{"restricted":_vm.restrictedFunds,"balance":_vm.availableBalance}}),_vm._v(" "),(_vm.showBankInfoForm)?[(_vm.hasSavedAccount)?_c('h4',{staticClass:"bank-transfer__cancel-title"},[_c('span',{staticClass:"bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onCancel($event)}}},[_vm._v("\n                  Cancel\n                ")])]):_vm._e(),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('h4',{staticClass:"bank-transfer__section-title"},[_vm._v("\n                Account\n              ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[(_vm.showIbanValidationInfo)?_c('div',{staticClass:"column small-12"},[_c('alert-box',{attrs:{"level":"success"}},[_vm._v("\n                    Your IBAN has been validated. Please identify additional details to locate your specific bank branch.\n                  ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.beneficiaryFieldsJustFirst),function(field){return _c('div',{key:field.id,staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fieldsBankInfoForm[field.id],"showValidationWithin":false,"name":field.id,"type":"text","required":field.isRequired,"disabled":_vm.hasErrorMessage,"autocomplete":"","placeholder":field.name},on:{"input":function($event){return _vm.onFieldInput(field.id, $event)}},model:{value:(_vm.fieldsBankInfoForm[field.id]),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, field.id, $$v)},expression:"fieldsBankInfoForm[field.id]"}},[(field.id === 'swiftBicCode')?_c('notification-icon',{attrs:{"slot":"icon","reversed":true},on:{"showPopup":_vm.showSwiftModal},slot:"icon"}):_vm._e()],1)],1)}),_vm._v(" "),_vm._l((_vm.beneficiaryFieldsWithoutFirst),function(field){return _c('div',{key:field.id,class:_vm.customFieldsClassModifiers(field)},[(field.hasValueList)?_c('form-select',{attrs:{"options":Object.values(field.valueList),"label":"","required":field.isRequired,"placeholder":field.name,"trackBy":""},model:{value:(_vm.fieldsBankInfoForm[field.id]),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, field.id, $$v)},expression:"fieldsBankInfoForm[field.id]"}}):_c('form-input',{attrs:{"validation":_vm.$v.fieldsBankInfoForm[field.id],"showValidationWithin":false,"name":field.id,"type":"text","required":field.isRequired,"disabled":_vm.hasErrorMessage,"autocomplete":"","placeholder":field.name},on:{"input":function($event){return _vm.onFieldInput(field.id, $event)}},model:{value:(_vm.fieldsBankInfoForm[field.id]),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, field.id, $$v)},expression:"fieldsBankInfoForm[field.id]"}},[(field.id === 'swiftBicCode')?_c('notification-icon',{attrs:{"slot":"icon","reversed":true},on:{"showPopup":_vm.showSwiftModal},slot:"icon"}):_vm._e()],1)],1)})],2),_vm._v(" "),(_vm.showIbanValidationForm)?[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"submit","disabled":_vm.hasErrorMessage || _vm.invalidOrDisabled},on:{"click":_vm.confirmAccountInfo}},[_vm._v("\n                  Confirm Account Information\n                ")])]:[_c('h4',{staticClass:"bank-transfer__section-title"},[_vm._v("\n                  Bank Branch Lookup\n                ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"type":"text","required":false,"disabled":_vm.hasErrorMessage,"autocomplete":"","name":"search-bank","placeholder":"Bank Name"},model:{value:(_vm.fieldsBankInfoForm.searchBankName),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, "searchBankName", $$v)},expression:"fieldsBankInfoForm.searchBankName"}}),_vm._v(" "),(false)?_c('div',{staticClass:"bank-transfer__explanation"},[_vm._v("\n                      You may enter one or more values, separated by spaces, to locate your specific bank.\n                      Example values to search: Swift/BIC number, bank routing number, bank city\n                    ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"type":"text","required":false,"disabled":_vm.hasErrorMessage,"autocomplete":"","name":"search-city","placeholder":"City"},model:{value:(_vm.fieldsBankInfoForm.searchCity),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, "searchCity", $$v)},expression:"fieldsBankInfoForm.searchCity"}})],1),_vm._v(" "),(_vm.showAddressSearch)?_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"type":"text","required":false,"disabled":_vm.hasErrorMessage,"autocomplete":"","name":"search-address","placeholder":"Address"},model:{value:(_vm.fieldsBankInfoForm.searchAddress),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, "searchAddress", $$v)},expression:"fieldsBankInfoForm.searchAddress"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"submit"},on:{"click":_vm.onSearch}},[_vm._v("\n                      Search For Matching Banks\n                    ")])]),_vm._v(" "),(_vm.isSearching)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"bank-transfer__spinner"})]):_vm._e(),_vm._v(" "),(_vm.hasSearched)?[(_vm.suggestionsTotal === 0)?_c('div',{staticClass:"column small-12"},[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n                         A matching bank could not be located in "+_vm._s(_vm.userData.countryName)+". Please try again.\n                      ")])],1):(_vm.suggestionsTotal > _vm.TOO_MANY_RESULTS)?_c('div',{staticClass:"column small-12"},[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n                        Your search returned too many results. Please provide additional details such as bank address or city.\n                      ")])],1):_vm._e(),_vm._v(" "),(_vm.suggestionsTotal <= 50)?_c('div',{staticClass:"column small-12"},[_vm._l((_vm.suggestions),function(suggestion){return _c('div',{key:suggestion.id,class:_vm.suggestionClassModifiers(suggestion),on:{"click":function($event){return _vm.onSuggestionPick(suggestion)}}},[_vm._v("\n                        "+_vm._s(suggestion.name)+"\n                        "),_c('div',{staticClass:"bank-transfer__suggestion-description"},[_c('strong',[_vm._v("City")]),_vm._v(": "+_vm._s(suggestion.city)+" | "),_c('strong',[_vm._v("Swift")]),_vm._v(": "+_vm._s(suggestion.swiftCode)+" "),(suggestion.routingCode)?[_vm._v("| "),_c('strong',[_vm._v("Routing")]),_vm._v(": "+_vm._s(suggestion.routingCode))]:_vm._e()],2),_vm._v(" "),(suggestion.address1)?_c('div',[_c('strong',[_vm._v("Address")]),_vm._v(": "+_vm._s(suggestion.address1)+"\n                        ")]):_vm._e(),_vm._v(" "),(!suggestion.isValid)?_c('div',{staticClass:"bank-transfer__suggestion-message"},[_vm._v("\n                          This branch can't be selected\n                        ")]):_vm._e()])}),_vm._v(" "),(_vm.wireSearchResults.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"bank-transfer__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()],2):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.pickedSuggestion !== null)?[_c('div',{staticClass:"column small-12"},[_c('h4',{staticClass:"bank-transfer__section-title bank-transfer__section-title--no-margin-bottom"},[_vm._v("\n                        Your Banking Information\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bank-transfer__section-group content-header__section-group"},[_vm._l((_vm.beneficiaryFieldsJustFirst),function(field){return _c('div',{key:((field.id) + "-edit"),staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            "+_vm._s(field.name)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm[field.id])+"\n                          ")])])}),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            Bank Name\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm.bankName)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            Street Address\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm.streetAddress)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            City\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm.city)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            Postal Code\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm.zipCode)+"\n                          ")])])],2)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"submit","disabled":_vm.hasErrorMessage || _vm.invalidOrDisabled},on:{"click":_vm.confirmBankInfo}},[_vm._v("\n                        Confirm Banking Information\n                      ")])])]:_vm._e()],2)],_vm._v(" "),_c('p',{staticClass:"bank-transfer__disclaimer",domProps:{"innerHTML":_vm._s(_vm.disclaimer)}},[_vm._v("\n                Your banking information will be saved in a secure environment.\n                PredictIt can store information on only one bank account at a time.\n              ")]),_vm._v(" "),_c('p',{staticClass:"bank-transfer__disclaimer"},[_vm._v("\n                If you wish to change your address before proceeding with this withdrawal, you can do so on the "),_c('router-link',{attrs:{"to":{ name: 'address-update' }}},[_vm._v("Account Details")]),_vm._v(" page.\n              ")],1)]:(_vm.showWithdrawalAmountForm)?[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"theme":"amount","name":"amount","validation":_vm.$v.fieldsWithdrawalAmountForm.amount,"disabled":_vm.isAmountFieldDisabled,"showValidationWithin":false,"autocomplete":"","placeholder":_vm.amountPlaceholder},on:{"input":_vm.$v.fieldsWithdrawalAmountForm.amount.$touch},model:{value:(_vm.fieldsWithdrawalAmountForm.amount),callback:function ($$v) {_vm.$set(_vm.fieldsWithdrawalAmountForm, "amount", $$v)},expression:"fieldsWithdrawalAmountForm.amount"}})],1)]),_vm._v(" "),_c('h4',{staticClass:"bank-transfer__section-title"},[_vm._v("\n                Your Name & Address\n              ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"name":"name","type":"text","disabled":true,"autocomplete":"","placeholder":"Name"},model:{value:(_vm.beneficiaryInfo.accountName),callback:function ($$v) {_vm.$set(_vm.beneficiaryInfo, "accountName", $$v)},expression:"beneficiaryInfo.accountName"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"name":"street","type":"text","disabled":true,"autocomplete":"","placeholder":"Street Address"},model:{value:(_vm.beneficiaryInfo.accountAddress),callback:function ($$v) {_vm.$set(_vm.beneficiaryInfo, "accountAddress", $$v)},expression:"beneficiaryInfo.accountAddress"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"name":"city","type":"text","disabled":true,"autocomplete":"","placeholder":"City"},model:{value:(_vm.beneficiaryInfo.accountCity),callback:function ($$v) {_vm.$set(_vm.beneficiaryInfo, "accountCity", $$v)},expression:"beneficiaryInfo.accountCity"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"name":"zipCode","type":"text","disabled":true,"autocomplete":"postal-code","placeholder":"Postal Code"},model:{value:(_vm.beneficiaryInfo.accountPostal),callback:function ($$v) {_vm.$set(_vm.beneficiaryInfo, "accountPostal", $$v)},expression:"beneficiaryInfo.accountPostal"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('h4',{staticClass:"bank-transfer__section-title bank-transfer__section-title--no-margin-bottom"},[_vm._v("\n                    Your bank transfer will be sent to\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"column small-7"},[_c('div',{staticClass:"bank-transfer__info"},[_vm._v("\n                    "+_vm._s(_vm.beneficiaryInfo.bankName)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"bank-transfer__info"},[_vm._v("\n                    Account ending in: "+_vm._s(_vm.beneficiaryInfo.accountNumberLastFour)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"column small-5"},[_c('h4',{staticClass:"bank-transfer__cancel-title"},[_c('span',{staticClass:"bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.changeBankInformation($event)}}},[_vm._v("\n                      Change\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.hasErrorMessage || _vm.invalidOrDisabled},on:{"click":_vm.reviewRequest}},[_vm._v("\n                    Review Request\n                  ")])])]),_vm._v(" "),_c('p',{staticClass:"bank-transfer__disclaimer"},[_vm._v("\n                Your banking information will be saved in a secure environment. PredictIt can store information on only one bank account at a time.\n              ")]),_vm._v(" "),_c('p',{staticClass:"bank-transfer__disclaimer",domProps:{"innerHTML":_vm._s(_vm.disclaimer)}},[_vm._v("\n                Your banking information will be saved in a secure environment.\n                PredictIt can store information on only one bank account at a time.\n              ")])]:_vm._e()],2)]:_vm._e(),_vm._v(" "),(_vm.hasErrorMessage)?_c('alert-box',{attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.showConfirmation)?_c('withdraw-confirm',{staticClass:"withdraw-confirm--with-margin",attrs:{"kind":"bank-transfer","amendAvailable":true,"beneficiaryInfo":_vm.beneficiaryInfo,"bankWithdrawAmounts":_vm.bankWithdrawAmounts,"amount":Number(_vm.fieldsWithdrawalAmountForm.amount)},on:{"edit":_vm.onEdit,"success":_vm.onSuccess}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v5l1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_quantity_picker_mobile_sushi_js__ = __webpack_require__("lqHp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9974dfc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_quantity_picker_mobile_sushi_vue__ = __webpack_require__("fr0J");
function injectStyle (ssrContext) {
  __webpack_require__("73/K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_quantity_picker_mobile_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9974dfc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_quantity_picker_mobile_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v6Dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offers-indicator"},[_c('switch-modal',{staticClass:"modal-switch--offers-indicator",attrs:{"showSwitchButton":false},on:{"modalClose":_vm.close}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Order Sequence")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.groupedRecords.length > 0)?[_c('div',{staticClass:"offers-indicator__title"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"offers-indicator__subtitle"},[(_vm.operationType === 'buy')?[_vm._v("\n            Your Sell Orders appear as Buy Orders to other traders.\n          ")]:[_vm._v("\n            Your Buy Orders appear as Sell Orders to other traders.\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"offers-indicator__table-container"},[_c('table',{staticClass:"offers-indicator__table"},[_c('tbody',_vm._l((_vm.groupedRecords),function(records,index){return _c('tr',{class:_vm.rowClassModifiers(records)},[_c('td',{staticClass:"offers-indicator__label"},[(_vm.isFirstGroupedIndex(index) && _vm.hasBeforeMeOffers)?[_vm._v("\n                    Orders before You\n                  ")]:(_vm.isLastGroupedIndex(index) && _vm.hasAfterMeOffers)?[_vm._v("\n                    Orders after You\n                  ")]:(_vm.areMine(records))?[_vm._v("\n                    Your Orders\n                  ")]:[_vm._v("\n                    Subsequent Orders\n                  ")]],2),_vm._v(" "),_c('td',{staticClass:"offers-indicator__num"},[_vm._v("\n                  "+_vm._s(_vm.displayRecords(records))+"\n                ")])])}),0)])])]:_c('div',{staticClass:"offers-indicator__no-data"},[_vm._v("\n        No data to display.\n      ")])],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v8Uc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzc1IiBoZWlnaHQ9IjMyMSIgdmlld0JveD0iMCAwIDM3NSAzMjEiPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJiIiB4MT0iMTAwJSIgeDI9IjMuMzY4JSIgeTE9IjEwMCUiIHkyPSI1LjE2JSI+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiMwN2EwYmIiLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSI1OS4xNSUiIHN0b3AtY29sb3I9IiMxODgwOTMiLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjMUU1QTc1Ii8+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgzNzV2MzIxSDB6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxtYXNrIGlkPSJjIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGZpbGw9InVybCgjYikiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjEiIGhlaWdodD0iMjIwIiB4PSIzNzMuNTkiIHk9Ii01LjQxNCIgZmlsbD0iI0ZGRiIgbWFzaz0idXJsKCNjKSIgb3BhY2l0eT0iLjIiIHJ4PSIuNSIgc3R5bGU9Im1peC1ibGVuZC1tb2RlOnNvZnQtbGlnaHQiIHRyYW5zZm9ybT0icm90YXRlKDQwIDM3NC4wOSAxMDQuNTg2KSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjIyMCIgeD0iLTIzLjQxIiB5PSIyNDcuNTg2IiBmaWxsPSIjRkZGIiBtYXNrPSJ1cmwoI2MpIiBvcGFjaXR5PSIuMiIgcng9Ii41IiBzdHlsZT0ibWl4LWJsZW5kLW1vZGU6c29mdC1saWdodCIgdHJhbnNmb3JtPSJyb3RhdGUoNDAgLTIyLjkxIDM1Ny41ODYpIi8+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjEiIGhlaWdodD0iMjIwIiB4PSIxMDQuMzU2IiB5PSItMjEuNzcxIiBmaWxsPSIjMDdhMGJiIiBtYXNrPSJ1cmwoI2MpIiBvcGFjaXR5PSIuMiIgcng9Ii41IiB0cmFuc2Zvcm09InJvdGF0ZSg0MCAxMDQuODU2IDg4LjIzKSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSI5MyIgaGVpZ2h0PSIyNzMiIHg9IjIzNS44NjIiIHk9Ii0yOS4wNDUiIGZpbGw9IiMwN2EwYmIiIG1hc2s9InVybCgjYykiIG9wYWNpdHk9Ii4xIiByeD0iNDYuNSIgc3R5bGU9Im1peC1ibGVuZC1tb2RlOmxpZ2h0ZW4iIHRyYW5zZm9ybT0icm90YXRlKDQwIDI4Mi4zNjIgMTA3LjQ1NSkiLz4KICAgICAgICA8cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iOTAiIHg9IjI3Mi45MDciIHk9IjI2My43NTYiIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjYykiIG9wYWNpdHk9Ii4yIiByeD0iMzAiIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTpzb2Z0LWxpZ2h0IiB0cmFuc2Zvcm09InJvdGF0ZSg0MCAzMDIuOTA3IDMwOC43NTYpIi8+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjI5LjYxNSIgaGVpZ2h0PSIyNzMiIHg9Ii01MC43MjQiIHk9IjE1MC41ODMiIGZpbGw9IiMwN2EwYmIiIG1hc2s9InVybCgjYykiIG9wYWNpdHk9Ii41IiByeD0iMTQuODA3IiBzdHlsZT0ibWl4LWJsZW5kLW1vZGU6c29mdC1saWdodCIgdHJhbnNmb3JtPSJyb3RhdGUoNDAgLTM1LjkxNiAyODcuMDgzKSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSIyNzMiIHg9IjIxOS4yNzYiIHk9Ii02MS40MTciIGZpbGw9IiMwN2EwYmIiIG1hc2s9InVybCgjYykiIG9wYWNpdHk9Ii41IiByeD0iMjAiIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTpzb2Z0LWxpZ2h0IiB0cmFuc2Zvcm09InJvdGF0ZSg0MCAyMzkuMjc2IDc1LjA4MykiLz4KICAgICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMzAiIHg9IjcwLjYzIiB5PSIyNTguMjUyIiBmaWxsPSIjRkZGIiBtYXNrPSJ1cmwoI2MpIiBvcGFjaXR5PSIuMiIgcng9IjEwIiBzdHlsZT0ibWl4LWJsZW5kLW1vZGU6c29mdC1saWdodCIgdHJhbnNmb3JtPSJyb3RhdGUoNDAgODAuNjMgMjczLjI1MikiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "vBva":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vEia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"nav-browse-categories-overlay"}},[(_vm.showNavBrowseOverlay)?_c('div',{staticClass:"nav-browse-categories-overlay"},[_c('div',{staticClass:"nav-browse-categories-overlay__content",on:{"click":_vm.closeOverlay}},[_c('div',{staticClass:"nav-browse-categories-overlay__title"},[_vm._v("\n        Market Categories\n      ")]),_vm._v(" "),_c('div',{staticClass:"nav-browse-categories-overlay__items"},[_c('router-link',{staticClass:"nav-browse-categories-overlay__item",attrs:{"to":{name: 'market-list', params: {headerId: 'all'}}},on:{"click":_vm.closeOverlay}},[_vm._v("\n              All\n            ")]),_vm._v(" "),_vm._l((_vm.userBrowseHeaders),function(item){return [(item.external)?[(item.name)?_c('router-link',{key:("overlay-" + (item.headerId)),staticClass:"nav-browse-categories-overlay__item",attrs:{"to":{name: item.name}},on:{"click":_vm.closeOverlay}},[_vm._v("\n              "+_vm._s(item.title)+"\n            ")]):(item.href)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],key:("overlay-" + (item.headerId)),staticClass:"nav-browse-categories-overlay__item",attrs:{"href":item.href},on:{"click":_vm.closeOverlay}},[_vm._v("\n               "+_vm._s(item.title)+"\n            ")]):_vm._e()]:_c('router-link',{key:("overlay-" + (item.headerId)),staticClass:"nav-browse-categories-overlay__item",attrs:{"to":{name: 'market-list', params: {headerId: item.headerId, headerUrl: item.headerUrl}}},on:{"click":_vm.closeOverlay}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])]})],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vJHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var PROCESSING_TRANSACTION_TIMEOUT = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      timeout: null,
      showTimeout: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getBalance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    openDepositHistory: function openDepositHistory() {
      this.getBalance();
      this.setCurrentPopup();
      this.$router.push({ name: 'account-history', query: { tabId: 'deposit-withdrawals' } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.timeout = setTimeout(function () {
      _this.showTimeout = true;
    }, PROCESSING_TRANSACTION_TIMEOUT * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
});

/***/ }),

/***/ "vJzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_captcha_captcha_vue__ = __webpack_require__("aDe5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_errors_errors_vue__ = __webpack_require__("dimc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_input_input_vue__ = __webpack_require__("UWgA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_radio_radio_vue__ = __webpack_require__("K2ud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_select_select_vue__ = __webpack_require__("x+uv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_socials_socials_vue__ = __webpack_require__("NqVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_submit_submit_vue__ = __webpack_require__("GgQs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms_textarea_textarea_vue__ = __webpack_require__("3ggI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_forms_password_requirements_password_requirements_vue__ = __webpack_require__("EjHU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_show_password_icon_show_password_icon_vue__ = __webpack_require__("OIiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_validators__ = __webpack_require__("SVQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__helpers_validators__["a"]; });















var ERROR_GENERIC = 'There was an error processing your request. Please try again.';
var ERROR_UNAUTHORIZED = '401 Unauthorized';
var ERROR_UNAUTHORIZED_MESSAGE = 'This account has been closed.';

var formMixin = {
  components: {
    formCaptcha: __WEBPACK_IMPORTED_MODULE_1__components_forms_captcha_captcha_vue__["a" /* default */],
    formCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_forms_checkbox_checkbox_vue__["a" /* default */],
    formErrors: __WEBPACK_IMPORTED_MODULE_3__components_forms_errors_errors_vue__["a" /* default */],
    formInput: __WEBPACK_IMPORTED_MODULE_4__components_forms_input_input_vue__["a" /* default */],
    formRadio: __WEBPACK_IMPORTED_MODULE_5__components_forms_radio_radio_vue__["a" /* default */],
    formSelect: __WEBPACK_IMPORTED_MODULE_6__components_forms_select_select_vue__["a" /* default */],
    formSocials: __WEBPACK_IMPORTED_MODULE_7__components_forms_socials_socials_vue__["a" /* default */],
    formSubmit: __WEBPACK_IMPORTED_MODULE_8__components_forms_submit_submit_vue__["a" /* default */],
    formTextarea: __WEBPACK_IMPORTED_MODULE_9__components_forms_textarea_textarea_vue__["a" /* default */],
    passwordRequirements: __WEBPACK_IMPORTED_MODULE_10__components_forms_password_requirements_password_requirements_vue__["a" /* default */],
    showPasswordIcon: __WEBPACK_IMPORTED_MODULE_11__components_show_password_icon_show_password_icon_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      errors: [],
      fields: {},
      isFormEnabled: true
    };
  },

  computed: {
    isFormDisabled: function isFormDisabled() {
      return this.isFormEnabled === false;
    },
    invalidOrDisabled: function invalidOrDisabled() {
      return this.$v.$invalid || !this.isFormEnabled;
    }
  },
  methods: {
    formIsValid: function formIsValid() {
      return !this.$v.$invalid;
    },
    formEnable: function formEnable() {
      this.isFormEnabled = true;
    },
    formDisable: function formDisable() {
      this.formReset();
      this.isFormEnabled = false;
      return true;
    },
    formReset: function formReset() {
      this.errors = [];
    },
    formHandleErrors: function formHandleErrors(error) {
      var _this = this;

      this.formEnable();
      try {
        if (error && error.response && error.response.data) {
          if (error.response.data instanceof Array) {
            error.response.data.forEach(function (e) {
              return _this.errors.push(e.message);
            });
          } else if (error.response.data.error_description) {
            var description = error.response.data.error_description;
            if (typeof description === 'string') {
              description = JSON.parse(description);
            }
            description.forEach(function (e) {
              return _this.errors.push(e.Message);
            });
          } else if (error.response.data.message) {
            this.errors.push(error.response.data.message);
          } else if (error.response.data.error) {
            if (error.response.data.error === ERROR_UNAUTHORIZED) {
              this.errors.push(ERROR_UNAUTHORIZED_MESSAGE);
            } else {
              this.errors.push(error.response.data.error);
            }
          }
        }
      } catch (e) {
        this.errors.push(ERROR_GENERIC);
      }

      if (__WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["b" /* isIos */]) {
        this.$el.scrollIntoView(true);
      }
    },
    tabTo: function tabTo(e, next) {
      if (e) {
        if (!this.$refs[next]) return;
        var input = this.$refs[next].$el.getElementsByTagName('input')[0];
        if (input) {
          input.focus();
        }
      }
    }
  }
};


/* unused harmony default export */ var _unused_webpack_default_export = (formMixin);

/***/ }),

/***/ "vKYG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI2LjUiIHN0cm9rZT0iIzcyNzI3MiIvPgogICAgPGNpcmNsZSBjeD0iNyIgY3k9IjQiIHI9IjEiIGZpbGw9IiM3MjcyNzIiLz4KICAgIDxyZWN0IHg9IjcuNzUiIHk9IjYuNSIgd2lkdGg9IjUiIGhlaWdodD0iMS41IiByeD0iMC43NSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNy43NSA2LjUpIiBmaWxsPSIjNzI3MjcyIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "vMHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"purchase-offer-desktop-sushi__left",class:{'purchase-offer-desktop-sushi__left--full': !_vm.showOrderSlip}},[_c('div',{staticClass:"purchase-offer-desktop-sushi__order-book"},[_c('order-book-sushi',{key:_vm.orderBookKey,attrs:{"contract":_vm.contract,"market":_vm.market,"operationType":_vm.tradeOptions.operationType,"operationValue":_vm.tradeOptions.operationValue,"defaultMinimumRows":5,"showTitle":false},on:{"updatePriceAndQuantity":_vm.onUpdatePriceAndQuantity}})],1),_vm._v(" "),(_vm.showContractCharts)?_c('div',{staticClass:"purchase-offer-desktop-sushi__charts"},[_c('market-charts',{attrs:{"market":_vm.market,"chartOptions":_vm.chartOptions,"cache":true}})],1):_vm._e()]),_vm._v(" "),(_vm.showOrderSlip)?_c('div',{staticClass:"purchase-offer-desktop-sushi__right"},[(!_vm.isMarketDisabled)?_c('div',{staticClass:"purchase-offer-desktop-sushi__right-box"},[_c('purchase-extended-betslip',{attrs:{"market":_vm.market,"contract":_vm.contract,"showOrderSlip":false},on:{"submit":function($event){return _vm.$emit('submit')}}})],1):_vm._e(),_vm._v(" "),(_vm.showRelatedContracts)?_c('div',{staticClass:"purchase-offer-desktop-sushi__related-contracts"},[_c('div',{staticClass:"purchase-offer-desktop-sushi__related-contracts-title"},[_vm._v("\n        Related Contracts\n      ")]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-desktop-sushi__related-contracts-content"},[_c('related-contracts-sushi',{attrs:{"contractId":_vm.contract.contractId,"max":3}})],1)]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vRZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance-history-item",class:_vm.classModifier},[_c('div',{staticClass:"row balance-history-item__main-row"},[_c('div',{class:_vm.typeColumnModifiers},[_c('div',{staticClass:"balance-history-item__type text-left"},[_vm._v("\n        "+_vm._s(_vm.item.typeName)+" "),(_vm.item.providerId)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"balance-history-item__provider-order",attrs:{"href":("https://commerce.coinbase.com/receipts/" + (_vm.item.providerId))}},[(_vm.isLayoutDesktop)?_c('span',[_vm._v("("+_vm._s(_vm.item.providerId)+")")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{class:_vm.amountColumnModifiers},[_c('div',{staticClass:"balance-history-item__amount text-center"},[(_vm.item.requested)?_c('span',[_vm._v(_vm._s(_vm.item.requested))]):_c('span',[_vm._v(_vm._s(_vm.item.amount))])])]),_vm._v(" "),(_vm.showAdditionalColumns)?[_c('div',{staticClass:"column small-2"},[_c('div',{staticClass:"balance-history-item__fee text-center"},[(_vm.item.fee)?_c('span',[_vm._v(_vm._s(_vm.item.fee))]):_c('span',[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"column small-2"},[_c('div',{staticClass:"balance-history-item__fee text-center"},[(_vm.item.requested)?_c('span',[_vm._v(_vm._s(_vm.item.amount))]):_c('span',[_vm._v("-")])])])]:_vm._e(),_vm._v(" "),_c('div',{class:_vm.statusColumnModifiers},[_c('div',{staticClass:"balance-history-item__status"},[_c('state-icon',{attrs:{"state":_vm.item.status,"theme":"transaction"}})],1)])],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"balance-history-item__date text-left"},[_vm._v("\n        "+_vm._s(_vm.itemDate)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[_c('div',{staticClass:"balance-history-item__confirmation-number"},[_vm._v("\n        "+_vm._s(_vm.item.confirmationNumber)+"\n      ")]),_vm._v(" "),(_vm.showCancelRequestButton(_vm.item))?_c('div',{staticClass:"balance-history-item__cancel",on:{"click":function($event){return _vm.onCancelRequest(_vm.item)}}},[_vm._v("\n        Cancel Request\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vSKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-history"},[(_vm.isLayoutMobile)?_c('content-header',{staticClass:"content-header--account",attrs:{"title":"History","returnRoute":"profile"}}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.gridRowModifier},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 account-history__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[(!_vm.isLayoutMobile)?_c('account-desktop-header',{attrs:{"title":"History","showExport":true,"activeTab":_vm.activeTab},on:{"export":_vm.onExport}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-history__content"},[(_vm.showTradesTab)?_c('trades',{key:_vm.tradesKey,attrs:{"showExport":_vm.isLayoutMobile},on:{"export":_vm.onExport}}):_vm._e(),_vm._v(" "),(_vm.showTransactionsTab)?_c('transactions',{key:_vm.transactionsKey,attrs:{"showExport":_vm.isLayoutMobile},on:{"export":_vm.onExport}}):_vm._e()],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vSY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_contracts_js__ = __webpack_require__("qyl+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0032042e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_contracts_vue__ = __webpack_require__("hpVO");
function injectStyle (ssrContext) {
  __webpack_require__("YEM7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_contracts_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0032042e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_contracts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vUBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw-confirm"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('div',{staticClass:"withdraw-confirm__section-title"},[_c('div',{staticClass:"withdraw-confirm__section-title-text"},[_vm._v("\n      Withdrawal Confirmation\n    ")]),_vm._v(" "),(_vm.amendAvailable)?_c('div',{staticClass:"withdraw-confirm__section-title-cancel",on:{"click":function($event){$event.preventDefault();return _vm.onEdit($event)}}},[_c('div',{staticClass:"withdraw-confirm__section-title-cancel-text"},[_vm._v("\n        "+_vm._s(_vm.backText)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"withdraw-confirm__section-title-cancel-icon"})]):_vm._e()]),_vm._v(" "),(!_vm.isBankTransfer)?_c('amount-info',{attrs:{"amount":_vm.amount,"fee":_vm.fee,"total":_vm.netTotal}}):_c('amount-info',{attrs:{"isBankTransfer":true,"amount":_vm.bankWithdrawAmounts.grossWithdrawalAmount,"flatFeeAmount":_vm.bankWithdrawAmounts.flatFeeAmount,"percentageFeeAmount":_vm.bankWithdrawAmounts.percentageFeeAmount,"total":_vm.bankWithdrawAmounts.netWithdrawalAmount}}),_vm._v(" "),(_vm.isCoinbase)?_c('div',[_c('h4',{staticClass:"withdraw-confirm__section-title withdraw-confirm__section-title--spaced"},[_vm._v("\n      Payment Details\n    ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Email\n        ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n          "+_vm._s(_vm.recipient)+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"withdraw-confirm__disclaimer"},[_vm._v("\n      Withdrawals are subject to a 5% processing fee and are typically processed twice per week. Once authorized, funds should be deposited within one business day of processing.\n    ")])]):_vm._e(),_vm._v(" "),(_vm.isBankTransfer)?_c('div',[_c('h4',{staticClass:"withdraw-confirm__section-title withdraw-confirm__section-title--spaced"},[_vm._v("\n      Payment Details\n    ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Bank Name\n        ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n          "+_vm._s(_vm.beneficiaryInfo.bankName)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Account Number\n        ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n          ********"+_vm._s(_vm.beneficiaryInfo.accountNumberLastFour)+"\n        ")])])])]):_vm._e(),_vm._v(" "),(_vm.isAch)?_c('div',[_c('h4',{staticClass:"withdraw-confirm__section-title withdraw-confirm__section-title--spaced"},[_vm._v("\n      Payment Details\n    ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[(!_vm.accountDetails.accountId)?[_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n            Account Type\n          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n            "+_vm._s(_vm.accountDetails.accountTypeLabel)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n            Routing Number\n          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n            "+_vm._s(_vm.accountDetails.routingNumber)+"\n          ")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Account Number\n        ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[(_vm.accountDetails.accountId)?_c('span',[_vm._v("********"+_vm._s(_vm.accountDetails.accountLastFourDigits))]):_vm._e(),_vm._v(" "),(!_vm.accountDetails.accountId)?_c('span',[_vm._v(_vm._s(_vm.accountDetails.accountNumber))]):_vm._e()])])],2),_vm._v(" "),_c('p',{staticClass:"withdraw-confirm__disclaimer"},[_vm._v("\n      We remit funds via ACH only to verified account holders with US bank accounts. Withdrawals are subject to a 5% fee and are typically processed twice per week. If authorized, funds should be deposited to your bank account within five business days.\n    ")])]):_vm._e(),_vm._v(" "),(_vm.isCheck)?_c('div',{staticClass:"withdraw-confirm__check"},[_c('h4',{staticClass:"withdraw-confirm__section-title withdraw-confirm__section-title--spaced"},[_vm._v("\n      Recipient\n    ")]),_vm._v(" "),_c('div',{staticClass:"withdraw-confirm__address"},[_vm._v("\n      "+_vm._s(_vm.recipient)+"\n      "),_c('br'),_vm._v("\n      "+_vm._s(_vm.addressLine1)+"\n      "),_c('br'),_vm._v("\n      "+_vm._s(_vm.addressLine2)+", "+_vm._s(_vm.addressLine3)+"\n      "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"withdraw-confirm__review-amount-note"},[_vm._v("\n        Our standard processing time for check withdrawals is 7-10 business days.\n      ")]),_vm._v(" "),_c('br')])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.hasFailed},on:{"click":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_vm._v("\n    Confirm Request\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vV6Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_list_item_expandable_sushi_market_list_item_expandable_sushi_vue__ = __webpack_require__("9ozv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* eslint-disable arrow-body-style */










var MY_SHARES_INITIAL = 0.0;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    marketListItemExpandableSushi: __WEBPACK_IMPORTED_MODULE_5__components_market_market_list_item_expandable_sushi_market_list_item_expandable_sushi_vue__["a" /* default */]
  },
  props: {
    sushi: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isLoading: true,
      toggledItems: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('dashboard', ['myShares', 'marketsToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    marketsNumber: function marketsNumber() {
      return this.myShares ? this.myShares.markets.length : 0;
    },
    marketsShares: function marketsShares() {
      var markets = this.myShares && this.myShares.markets ? this.myShares.markets : [];
      return markets.reduce(function (previous, current) {
        var userQuantity = __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy___default()(current.marketContracts, function (i) {
          return i.userQuantity;
        });
        return previous + userQuantity;
      }, MY_SHARES_INITIAL);
    },
    filteredMarkets: function filteredMarkets() {
      var markets = this.myShares && this.myShares.markets ? this.myShares.markets : [];
      var statuses = [__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_SETTLED];
      return markets.filter(function (m) {
        return !statuses.includes(m.status);
      }).filter(function (m) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy___default()(m.marketContracts, function (i) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["w" /* contractOwnershipNum */])(i);
        }) > 0;
      });
    },
    filteredMarketsContractsIds: function filteredMarketsContractsIds() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default()(this.filteredMarkets.map(function (market) {
        return market.marketContracts;
      })).filter(function (i) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["w" /* contractOwnershipNum */])(i) > 0;
      }).map(function (i) {
        return i.contractId;
      });
    },
    showMarketsList: function showMarketsList() {
      return this.marketsNumber > 0;
    },
    showNoSharesPlaceholder: function showNoSharesPlaceholder() {
      return this.marketsNumber === 0 && !this.isLoading;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('dashboard', ['getMyShares', 'setDashboardOpen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'setBottomBetSlipExtendedMode']), {
    isItemExpanded: function isItemExpanded(marketId) {
      var item = this.toggledItems.find(function (i) {
        return i.marketId === marketId;
      });
      return !!item;
    },
    isExpandingAllTriggered: function isExpandingAllTriggered(marketId) {
      var item = this.toggledItems.find(function (i) {
        return i.marketId === marketId;
      }) || {};
      return item.expandAll;
    },
    onMarketListItemToggle: function onMarketListItemToggle(data) {
      if (data.expanded) {
        this.toggledItems.push({
          marketId: data.market.marketId,
          expandAll: false
        });
      } else {
        this.toggledItems = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.toggledItems.filter(function (i) {
          return i.marketId !== data.market.marketId;
        })));
      }
    },
    scrollToMarketsSection: function scrollToMarketsSection() {
      var _this = this;

      setTimeout(function () {
        var elOffset = _this.$refs.myshares.offsetTop;
        var offset = _this.isLayoutMobile ? elOffset - 45 : elOffset - 95;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_scrollTo__["a" /* default */])(offset, 500);
      }, __WEBPACK_IMPORTED_MODULE_5__components_market_market_list_item_expandable_sushi_market_list_item_expandable_sushi_vue__["b" /* OFFSET_CHECK_TIMEOUT */]);
    }
  }),
  watch: {
    marketsToggle: function marketsToggle(value) {
      if (value) {
        this.toggledItems = this.filteredMarkets.map(function (i) {
          return {
            marketId: i.marketId,
            expandAll: true
          };
        });
        // this.scrollToMarketsSection();
      } else {
        this.toggledItems = [];
      }
    },
    filteredMarketsContractsIds: function filteredMarketsContractsIds() {
      if (this.currentPopup === __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE && this.tradeOptions && this.tradeOptions.contractId && !this.filteredMarketsContractsIds.includes(this.tradeOptions.contractId)) {
        this.setCurrentPopup();
        this.setTradeOptions(null);
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.loaderAdd(document.body);
    this.getMyShares().then(function () {
      _this2.loaderRemove(document.body);
      _this2.isLoading = false;
      _this2.isComponentReady = true;
    }).catch(function () {
      _this2.loaderRemove(document.body);
      _this2.isLoading = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.setTradeOptions(null);
    this.setBottomBetSlipExtendedMode(false);
  }
});

/***/ }),

/***/ "vWyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_disqus__ = __webpack_require__("oeb2");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_disqus__["a" /* default */]],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    focusCommentId: {
      type: String,
      default: ''
    },
    requestedCommentThreadId: {
      type: Number,
      default: 0
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isPinningEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['market', 'isDiscussionPinned'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['toggleDiscussionPin']))
});

/***/ }),

/***/ "vXhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__ = __webpack_require__("a8vN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b643906_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("9Z8S");
function injectStyle (ssrContext) {
  __webpack_require__("W4YR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b643906_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vfWA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vm2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: ''
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var q = this.query.trim();
      if (!q) return;
      this.$router.push({ path: '/markets/search', query: { query: q } });
    }
  }
});

/***/ }),

/***/ "vuRz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vxYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_js__ = __webpack_require__("D+Yn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279bb822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_vue__ = __webpack_require__("NXsH");
function injectStyle (ssrContext) {
  __webpack_require__("zZwI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279bb822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w009":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_change_price_js__ = __webpack_require__("mBiY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94ebb4ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_change_price_vue__ = __webpack_require__("LMIZ");
function injectStyle (ssrContext) {
  __webpack_require__("Bo+i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_change_price_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94ebb4ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_change_price_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w0Aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_widget_js__ = __webpack_require__("Efhk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9b3c90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_widget_vue__ = __webpack_require__("CRTj");
function injectStyle (ssrContext) {
  __webpack_require__("lBfC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9b3c90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w1pb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_youtube_embed__ = __webpack_require__("5/be");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    getYoutubeUrl: function getYoutubeUrl() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_youtube_embed__["b" /* getIdFromURL */])('https://www.youtube.com/watch?v=NfWU0Wiixuo');
    }
  }
});

/***/ }),

/***/ "w4vL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_categories_overlay_js__ = __webpack_require__("dh9S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_865af4c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_categories_overlay_vue__ = __webpack_require__("vEia");
function injectStyle (ssrContext) {
  __webpack_require__("kdgD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_categories_overlay_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_865af4c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_categories_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w70/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    href: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    date: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']))
});

/***/ }),

/***/ "wFR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_rules_js__ = __webpack_require__("yjAn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92f088e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_rules_vue__ = __webpack_require__("RIFu");
function injectStyle (ssrContext) {
  __webpack_require__("klpy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_rules_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92f088e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_rules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wLE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.preview)?_c('div',[_c('div',{staticClass:"bank-account bank-account--preview"},[_c('div',{staticClass:"bank-account__icon"},[_c('img',{attrs:{"src":_vm.account.bankInfo.bankIconUrl}})]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank-title bank-account__bank-title--summary"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankDisplayName)+"\n      ")]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankAccountDisplayName)+"\n      ")])])]):_c('div',{class:_vm.classModifiers,on:{"click":function($event){return _vm.$emit('select')}}},[_c('div',{staticClass:"bank-account__icon"},[_c('img',{attrs:{"src":_vm.account.bankInfo.bankIconUrl}})]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank"},[_c('div',{staticClass:"bank-account__bank-title"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankDisplayName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank-account"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankAccountDisplayName)+"\n      ")])]),_vm._v(" "),(_vm.removable)?_c('div',{staticClass:"bank-account__remove-wrapper",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove', _vm.account)}}},[_c('div',{staticClass:"bank-account__remove"})]):_vm._e(),_vm._v(" "),(_vm.showStatusMessage)?_c('div',{staticClass:"bank-account__message"},[_vm._v("\n      "+_vm._s(_vm.account.accountStatusMessage)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wQDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tax_info_notification_js__ = __webpack_require__("XzHq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99dd460a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tax_info_notification_vue__ = __webpack_require__("UPFk");
function injectStyle (ssrContext) {
  __webpack_require__("LT3w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tax_info_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99dd460a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tax_info_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wQqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_links_widget_js__ = __webpack_require__("yG4g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041ad0c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_links_widget_vue__ = __webpack_require__("ldoT");
function injectStyle (ssrContext) {
  __webpack_require__("7Q1h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sushi_market_links_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041ad0c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sushi_market_links_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wQrL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wU6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "wWzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_query__ = __webpack_require__("sLBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    widget: Object
  },
  computed: {
    obj: function obj() {
      return this.widget ? this.widget : {};
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['addFilter', 'setTimespanFromQuery', 'setOrderFromQuery']), {
    onClick: function onClick() {
      var _this = this;

      if (this.obj.marketUrl) {
        var queryObj = __WEBPACK_IMPORTED_MODULE_3__helpers_query__["a" /* default */].unserializeQuery(this.obj.marketUrl);
        var storeModified = false;
        if (queryObj.filterIds) {
          queryObj.filterIds.split(',').forEach(function (i) {
            var filterId = parseInt(i, 10);
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[MARKETS] filterId passed: ' + filterId);
            if (filterId) {
              storeModified = true;
              _this.addFilter(filterId);
            }
          });
        }
        if (queryObj.sortParameter) {
          storeModified = true;
          this.setTimespanFromQuery(queryObj.sortParameter);
        }
        if (queryObj.sort) {
          storeModified = true;
          this.setOrderFromQuery(queryObj.sort);
        }
        var url = storeModified ? this.obj.marketUrl + '&widget' : this.obj.marketUrl;
        this.$router.push(url);
      }
    }
  })
});

/***/ }),

/***/ "waMS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_withdraw_confirm_js__ = __webpack_require__("8I/4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8104f330_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdraw_confirm_vue__ = __webpack_require__("vUBl");
function injectStyle (ssrContext) {
  __webpack_require__("EbKL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_withdraw_confirm_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8104f330_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdraw_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wfyV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_forgotten_account_forgotten_vue__ = __webpack_require__("8TeC");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountForgotten: __WEBPACK_IMPORTED_MODULE_0__components_account_account_forgotten_account_forgotten_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "wuuS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wv8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_help_and_support_js__ = __webpack_require__("X543");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ae0bf26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_and_support_vue__ = __webpack_require__("uTAh");
function injectStyle (ssrContext) {
  __webpack_require__("XFAz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_help_and_support_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ae0bf26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_and_support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+uv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_select_js__ = __webpack_require__("x3ff");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6100fcc9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__ = __webpack_require__("ei5i");
function injectStyle (ssrContext) {
  __webpack_require__("neXN")
  __webpack_require__("vfWA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_select_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6100fcc9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x0s9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "x3ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multiselect_vue__ = __webpack_require__("Q334");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    multiselect: __WEBPACK_IMPORTED_MODULE_1__multiselect_vue__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    required: Boolean,
    placeholder: String,
    label: {
      type: String,
      required: true
    },
    trackBy: {
      type: String,
      required: true
    },
    value: [String, Object],
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 200
    },
    customLabel: {
      type: Function
    },
    searchable: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: false
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: ''
    },
    adjust: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectModifiers: function selectModifiers() {
      return {
        'select--has-value': this.value,
        'select--small': this.small
      };
    },
    gtmObject: function gtmObject() {
      var _gtm$split = this.gtm.split(','),
          _gtm$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_gtm$split, 2),
          category = _gtm$split2[0],
          label = _gtm$split2[1];

      return {
        event: 'eventTrackerTrigger',
        category: category,
        action: 'select',
        label: label
      };
    }
  },
  methods: {
    updateValue: function updateValue(e) {
      this.$emit('input', e);
      if (this.gtm && this.value) {
        this.$gtm.trackEvent(this.gtmObject);
      }
    }
  }
});

/***/ }),

/***/ "x6Bg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi__ = __webpack_require__("HC9X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__ = __webpack_require__("yzoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_v2_button_price_button_price_vue__ = __webpack_require__("al65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__ = __webpack_require__("tRmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_purchase_extended_betslip_purchase_extended_betslip_vue__ = __webpack_require__("Nqth");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_purchase_sushi_bottom_market_links_widget_bottom_market_links_widget_vue__ = __webpack_require__("2iQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_bottom_market_links_overlay_bottom_market_links_overlay_vue__ = __webpack_require__("o4Wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_purchase_sushi_bottom_betslip_shortcut_widget_bottom_betslip_shortcut_widget_vue__ = __webpack_require__("ySQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_page_market_detail_sushi_page_market_detail_sushi__ = __webpack_require__("KA7l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__("c/9r");















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_purchase_sushi_purchase_offer_sushi_purchase_offer_sushi__["a" /* default */]],
  props: {
    navigatedFromContractsSection: {
      type: Boolean,
      default: false
    },
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false
    },
    selectedSection: {
      type: String,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_12__components_pages_page_market_detail_sushi_page_market_detail_sushi__["a" /* NAVIGATION_TABS */].CONTRACTS
    }
  },
  data: function data() {
    return {
      BOTTOM_WIDGET_FOOTER_MODES: __WEBPACK_IMPORTED_MODULE_11__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */],
      visible: false,
      isAtBottom: false
    };
  },

  components: {
    marketDisabledOutcomeV2: __WEBPACK_IMPORTED_MODULE_6__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__["a" /* default */],
    buttonPrice: __WEBPACK_IMPORTED_MODULE_5__components_market_v2_button_price_button_price_vue__["a" /* default */],
    marketCharts: __WEBPACK_IMPORTED_MODULE_3__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */],
    purchaseTradeTypeSwitcherSushi: __WEBPACK_IMPORTED_MODULE_4__components_purchase_sushi_purchase_trade_type_switcher_sushi_purchase_trade_type_switcher_sushi_vue__["a" /* default */],
    purchaseExtendedBetslip: __WEBPACK_IMPORTED_MODULE_7__components_purchase_sushi_purchase_extended_betslip_purchase_extended_betslip_vue__["a" /* default */],
    bottomMarketLinksWidget: __WEBPACK_IMPORTED_MODULE_8__components_purchase_sushi_bottom_market_links_widget_bottom_market_links_widget_vue__["a" /* default */],
    bottomMarketLinksOverlay: __WEBPACK_IMPORTED_MODULE_9__components_purchase_sushi_bottom_market_links_overlay_bottom_market_links_overlay_vue__["a" /* default */],
    bottomBetslipShortcutWidget: __WEBPACK_IMPORTED_MODULE_10__components_purchase_sushi_bottom_betslip_shortcut_widget_bottom_betslip_shortcut_widget_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isTradingEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode', 'bottomBetslipExtended', 'bottomWidgetFooterMode', 'bottomWidgetFooterModeContractsSection']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['status']), {
    isHidden: function isHidden() {
      var dontHide = [__WEBPACK_IMPORTED_MODULE_11__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH, __WEBPACK_IMPORTED_MODULE_11__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].TOGGlE];
      var isAtTheBottom = this.isAtBottom && !dontHide.includes(this.bottomWidgetFooterMode);
      return isAtTheBottom || !this.visible;
    },
    nextButtonTitle: function nextButtonTitle() {
      return this.tradeTypeText;
    },
    nextButtonClassModifiers: function nextButtonClassModifiers() {
      return {
        'purchase-offer-sushi-mobile-bar__preview-button': true,
        'purchase-offer-sushi-mobile-bar__preview-button--yes': this.isYesType && !this.nextButtonDisabled,
        'purchase-offer-sushi-mobile-bar__preview-button--no': !this.isYesType && !this.nextButtonDisabled,
        'purchase-offer-sushi-mobile-bar__preview-button--disabled': this.nextButtonDisabled
      };
    },
    isExpandedBetslipActive: function isExpandedBetslipActive() {
      return this.bottomWidgetFooterMode === __WEBPACK_IMPORTED_MODULE_11__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP && this.bottomBetslipExtended;
    }
  }),
  watch: {
    isExpandedBetslipActive: function isExpandedBetslipActive() {
      this.updateExpandedBetslipScrollLock();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this._scrollTarget = this.getScrollParent(this.$el) || window;

    if ('IntersectionObserver' in window) {
      this.initIntersectionObserver();
    } else {
      var target = this._scrollTarget === document ? window : this._scrollTarget;
      if (target && target.addEventListener) {
        target.addEventListener('scroll', this.handleScroll, { passive: true });
      }
      window.addEventListener('resize', this.handleScroll);
      window.addEventListener('orientationchange', this.handleScroll);
    }

    this.$nextTick(function () {
      _this.handleScroll();
      _this.updateExpandedBetslipScrollLock();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.releaseExpandedBetslipScrollLock();
    if (this._observer) {
      this._observer.disconnect();
    }
    var target = this._scrollTarget === document ? window : this._scrollTarget;
    if (target && target.removeEventListener) {
      target.removeEventListener('scroll', this.handleScroll);
    }
    window.removeEventListener('resize', this.handleScroll);
    window.removeEventListener('orientationchange', this.handleScroll);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation', 'toggleBottomBetslipMode', 'setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    isPersistentFooterMode: function isPersistentFooterMode(footerMode) {
      return [__WEBPACK_IMPORTED_MODULE_11__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP, __WEBPACK_IMPORTED_MODULE_11__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].PINNED, __WEBPACK_IMPORTED_MODULE_11__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH].includes(footerMode);
    },
    getExpandedBetslipFixedOffset: function getExpandedBetslipFixedOffset() {
      var stickyTitle = document.querySelector('.page-market-detail-sushi__title');

      if (!stickyTitle || window.pageYOffset <= 1) {
        return 0;
      }

      var stickyTitleRect = stickyTitle.getBoundingClientRect();
      var stickyTitleStyle = window.getComputedStyle(stickyTitle);
      var isStickyTitleVisible = stickyTitleRect.height > 0 && stickyTitleRect.bottom > stickyTitleRect.top;
      var isStickyTitlePinned = stickyTitle.classList.contains('page-market-detail-sushi__title--is-sticky') || stickyTitleStyle.position === 'sticky' || stickyTitleStyle.position === '-webkit-sticky' || stickyTitleStyle.position === 'fixed';

      return isStickyTitleVisible && isStickyTitlePinned ? Math.round(stickyTitleRect.height) : 0;
    },
    switchTo: function switchTo(footerMode) {
      this.setBottomWidgetFooterMode(footerMode);
      if (!this.navigatedFromContractsSection && this.isPersistentFooterMode(footerMode)) {
        this.setBottomWidgetFooterModeContractsSection(footerMode);
      }
    },
    updateExpandedBetslipScrollLock: function updateExpandedBetslipScrollLock() {
      if (this.isExpandedBetslipActive && !this._expandedBetslipScrollLocked) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["F" /* lockScroll */])({ forceFixed: true, fixedOffset: this.getExpandedBetslipFixedOffset() });
        this._expandedBetslipScrollLocked = true;
      } else if (!this.isExpandedBetslipActive) {
        this.releaseExpandedBetslipScrollLock();
      }
    },
    releaseExpandedBetslipScrollLock: function releaseExpandedBetslipScrollLock() {
      if (!this._expandedBetslipScrollLocked) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["E" /* unlockScroll */])();
      this._expandedBetslipScrollLocked = false;
    },
    initIntersectionObserver: function initIntersectionObserver() {
      var _this2 = this;

      var sentinel = document.querySelector('.footer__bottom');

      if (!sentinel) {
        // Fallback to scroll listener if sentinel not found in DOM yet
        setTimeout(function () {
          var retrySentinel = document.querySelector('.footer__bottom');
          if (retrySentinel) {
            _this2.setupObserver(retrySentinel);
          } else {
            var target = _this2._scrollTarget === document ? window : _this2._scrollTarget;
            target.addEventListener('scroll', _this2.handleScroll, { passive: true });
          }
        }, 1000);
        return;
      }

      this.setupObserver(sentinel);
    },
    setupObserver: function setupObserver(element) {
      var _this3 = this;

      this._observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          _this3.isAtBottom = entry.isIntersecting;
        });
      }, {
        root: null,
        rootMargin: '0px 0px 50px 0px',
        threshold: 0
      });

      this._observer.observe(element);
    },
    getScrollParent: function getScrollParent(el) {
      if (!el) return document.scrollingElement || document.documentElement || document.body;
      var node = el;
      while (node && node !== document.body) {
        var style = window.getComputedStyle(node);
        var overflowY = style.overflowY;
        var canScroll = (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight + 1;
        if (canScroll) return node;
        node = node.parentElement;
      }
      return document.scrollingElement || document.documentElement || document.body;
    },
    handleScroll: function handleScroll() {
      var target = this._scrollTarget || window;

      if (target === window || target === document || target === document.body || target === document.documentElement) {
        var doc = document.documentElement;
        var body = document.body;
        var scrollTop = (typeof window.pageYOffset === 'number' ? window.pageYOffset : 0) || doc && doc.scrollTop || body && body.scrollTop || 0;
        var clientHeight = (typeof window.innerHeight === 'number' ? window.innerHeight : 0) || doc && doc.clientHeight || 0;
        var scrollHeight = Math.max(doc && doc.scrollHeight || 0, body && body.scrollHeight || 0, doc && doc.offsetHeight || 0, body && body.offsetHeight || 0);
        this.isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      } else {
        var el = target;
        var _scrollTop = el.scrollTop;
        var _clientHeight = el.clientHeight;
        var _scrollHeight = el.scrollHeight;
        this.isAtBottom = _scrollTop + _clientHeight >= _scrollHeight - 5;
      }
    }
  }),
  created: function created() {
    var _this4 = this;

    if (this.navigatedFromContractsSection) {
      var contractsSectionMode = this.isPersistentFooterMode(this.bottomWidgetFooterMode) ? this.bottomWidgetFooterMode : this.bottomWidgetFooterModeContractsSection;

      this.setBottomWidgetFooterModeContractsSection(contractsSectionMode);
      this.setBottomWidgetFooterMode(__WEBPACK_IMPORTED_MODULE_11__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].QUICK_SWITCH);
      this.$nextTick(function () {
        _this4.visible = true;
      });
    } else {
      this.visible = true;
    }
  }
});

/***/ }),

/***/ "xCnb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNyIgc3Ryb2tlPSIjOTQ5NDk0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSIzLjUiIGZpbGw9IiM5NDk0OTQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "xFU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appModifiers},[(!_vm.isSimpleLayout)?[_c('maintenance-notification'),_vm._v(" "),(_vm.searchBarVisible)?_c('div',{staticClass:"app-layout__search-overlay"}):_vm._e(),_vm._v(" "),_c('search-bar'),_vm._v(" "),_c('transition',{attrs:{"name":"app-layout-side-notification"}},[(_vm.sideNotificationShouldDisplay)?_c('side-notification',{attrs:{"level":_vm.sideNotificationLevel,"text":_vm.sideNotificationText,"sideNotificationOnCloseCallback":_vm.sideNotificationOnCloseCallback}}):_vm._e()],1),_vm._v(" "),_c('div',{class:_vm.headerModifiers},[(!_vm.mobileMenuOpened && !_vm.isStandalone)?_c('app-header-notification'):_vm._e(),_vm._v(" "),_c('app-header'),_vm._v(" "),_c('app-secondary-nav')],1)]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"app-layout","mode":"out-in"},on:{"before-leave":_vm.onBeforeLeave,"after-enter":_vm.onAfterEnter}},[_c('div',{key:_vm.$route.fullPath,class:_vm.contentModifiers},[_c('app-mobile-menu'),_vm._v(" "),_c('notification-items'),_vm._v(" "),_c('router-view')],1)]),_vm._v(" "),(!_vm.isSimpleLayout)?_c('div',{staticClass:"app-layout__footer"},[_c('app-footer')],1):_vm._e(),_vm._v(" "),(!_vm.isSimpleLayout && false)?_c('div',{staticClass:"app-layout__bottom-nav"},[_c('app-bottom-nav',{key:_vm.$router.currentRoute.path,attrs:{"showIcons":true}})],1):_vm._e(),_vm._v(" "),_c('nav-browse-categories-overlay')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xIGH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJ4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_js__ = __webpack_require__("smaH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631127d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_vue__ = __webpack_require__("4Iyt");
function injectStyle (ssrContext) {
  __webpack_require__("rpmV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631127d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xLyB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xMYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_currency_input_js__ = __webpack_require__("MGrt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4907a2c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currency_input_vue__ = __webpack_require__("lp3Y");
function injectStyle (ssrContext) {
  __webpack_require__("O4q7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_currency_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4907a2c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currency_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xO2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // because if content loaded vie v-html that has links
    // router will not kick in, and app state is lost and app reloads
    catchHtmlClick: function catchHtmlClick(e) {
      var href = e.srcElement.href;
      if (href && href.indexOf(window.location.origin) === 0) {
        e.preventDefault();
        var path = href.substr(window.location.origin.length);
        this.$router.push({ path: path });
      }
    }
  }
});

/***/ }),

/***/ "xOSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending-request-withdrawal"},[(_vm.isStep(_vm.WITHDRAW_CANCEL_STEPS.INITIAL))?[_c('div',{staticClass:"pending-request-withdrawal__card"},[_c('div',{staticClass:"pending-request-withdrawal__section-title"},[_c('div',{staticClass:"pending-request-withdrawal__section-title-text"},[_vm._v("\n          "+_vm._s(_vm.requestTitle)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section-title-cancel",on:{"click":function($event){$event.preventDefault();return _vm.onCancel($event)}}},[_c('div',{staticClass:"pending-request-withdrawal__section-title-cancel-text"},[_vm._v("\n            Cancel\n          ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section-title-cancel-icon"})])]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__sections"},[_c('div',{staticClass:"pending-request-withdrawal__section"},[_c('div',{staticClass:"pending-request-withdrawal__section--left"},[_vm._v("\n            Payment Method\n          ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section--right"},[_vm._v("\n            "+_vm._s(_vm.paymentMethod)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section"},[_c('div',{staticClass:"pending-request-withdrawal__section--left"},[_vm._v("\n            Requested Amount\n          ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section--right pending-request-withdrawal__section--right-strong"},[_vm._v("\n            "+_vm._s(_vm.formattedAmount)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section"},[_c('div',{staticClass:"pending-request-withdrawal__section--left"},[_vm._v("\n            Fees\n          ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section--right"},[_vm._v("\n            "+_vm._s(_vm.formattedFee)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section"},[_c('div',{staticClass:"pending-request-withdrawal__section--left"},[_vm._v("\n            Net Withdrawal\n          ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section--right pending-request-withdrawal__section--right-strong"},[_vm._v("\n            "+_vm._s(_vm.formattedNet)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section"},[_c('div',{staticClass:"pending-request-withdrawal__section--left"},[_vm._v("\n            Date Created\n          ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section--right"},[_vm._v("\n            "+_vm._s(_vm.formattedDate)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section"},[_c('div',{staticClass:"pending-request-withdrawal__section--left"},[_vm._v("\n            Confirmation Number\n          ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__section--right pending-request-withdrawal__section--right-break"},[_vm._v("\n            "+_vm._s(_vm.confirmationNumber)+"\n          ")])])]),_vm._v(" "),(_vm.detailRows.length > 0)?_c('div',{staticClass:"pending-request-withdrawal__detail-group"},[_c('div',{staticClass:"pending-request-withdrawal__detail-title"},[_vm._v("\n          Payment Details\n        ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__details"},_vm._l((_vm.detailRows),function(detail){return _c('div',{key:detail.label,staticClass:"pending-request-withdrawal__detail-row",class:{ 'pending-request-withdrawal__detail-row--stacked': detail.isStacked }},[_c('div',{staticClass:"pending-request-withdrawal__detail-label"},[_vm._v("\n              "+_vm._s(detail.label)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"pending-request-withdrawal__detail-value"},[(detail.lines)?_vm._l((detail.lines),function(line,index){return _c('div',{key:((detail.label) + "-" + index),staticClass:"pending-request-withdrawal__detail-line"},[_vm._v("\n                  "+_vm._s(line)+"\n                ")])}):[_vm._v("\n                "+_vm._s(detail.value)+"\n              ")]],2)])}),0)]):_vm._e()])]:(_vm.isStep(_vm.WITHDRAW_CANCEL_STEPS.PROCESSING))?[_c('processing-withdrawal-cancel-transaction')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xPXF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xQ7R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xR86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-watchlist"},[(_vm.isLayoutMobile)?_c('div',{staticClass:"page-watchlist__mobile-header-wrapper"},[_c('div',{staticClass:"page-watchlist__mobile-header-container"},[_vm._m(0),_vm._v(" "),_c('market-filters-mobile')],1)]):[_c('div',{staticClass:"page-watchlist__title"},[_c('div',{staticClass:"page-watchlist__title-text"},[_vm._v("\n        Watchlist\n      ")]),_vm._v(" "),_c('div',{staticClass:"page-watchlist__title-filters"},[_c('market-filters-desktop-grid')],1)])],_vm._v(" "),(_vm.items)?_c('div',{staticClass:"page-watchlist__grid"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"page-watchlist__grid-item"},[_c('market-list-item',{key:item.marketId,attrs:{"market":item,"watchIcon":true},on:{"watchToggle":function($event){return _vm.onRemoveMarketFromWatchList(item)}}})],1)}),0):_vm._e(),_vm._v(" "),(_vm.watchlist.canLoadMore)?_c('infinite-loading',{key:_vm.infiniteLoadingKey,on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"page-watchlist__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e(),_vm._v(" "),(_vm.showNoMarketsMessage)?_c('div',{staticClass:"page-watchlist__no-markets-found"},[_vm._v("\n    There are no markets in your Watchlist.\n  ")]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-watchlist__title"},[_c('div',{staticClass:"page-watchlist__title-text"},[_vm._v("\n          Watchlist\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xTJs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-toolbar"},[(_vm.isLayoutMobile)?_c('div',{staticClass:"leaderboards-toolbar__title"},[(_vm.backButton)?_c('div',{staticClass:"leaderboards-toolbar__back",on:{"click":function($event){return _vm.$emit('back')}}}):_vm._e(),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm._f("pluralize")(_vm.title))+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"leaderboards-toolbar__form"},[(false)?_c('form-select',{staticClass:"leaderboards-toolbar__form-item",attrs:{"searchable":false,"placeholder":"Type","options":_vm.typeOptions,"track-by":"value","label":"label"},model:{value:(_vm.filter.type),callback:function ($$v) {_vm.$set(_vm.filter, "type", $$v)},expression:"filter.type"}}):_vm._e(),_vm._v(" "),_c('form-select',{staticClass:"leaderboards-toolbar__form-item",attrs:{"small":_vm.isLayoutMobile,"searchable":false,"options":_vm.timeOptions,"track-by":"value","label":"label"},model:{value:(_vm.filter.time),callback:function ($$v) {_vm.$set(_vm.filter, "time", $$v)},expression:"filter.time"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xTWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_userDetails__ = __webpack_require__("jtWA");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_userDetails__["a" /* default */]],
  props: {
    comment: Object
  },
  methods: {
    traderLevelDisplay: function traderLevelDisplay(item) {
      var level = this.getLevelByPredictions(item.profitablePredictions);
      return 'Level ' + level.num + ' (' + level.text + ')';
    },
    ellipsizeTextBox: function ellipsizeTextBox(el) {
      var wordArray = el.innerHTML.split(' ');
      while (el.scrollHeight > el.offsetHeight) {
        wordArray.pop();
        el.innerHTML = wordArray.join(' ') + '...';
      }
    },
    onClick: function onClick() {
      if (this.comment && this.comment.commentUrl && !__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["g" /* isStandalone */]) {
        window.location.href = this.comment.commentUrl;
      }
    }
  },
  mounted: function mounted() {
    // this.ellipsizeTextBox(this.$refs.text);
  }
});

/***/ }),

/***/ "xVgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_disqus__ = __webpack_require__("oeb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_scrollTo__ = __webpack_require__("rrO7");

/* eslint-disable no-restricted-syntax */






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_disqus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  props: {
    storyId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      storyContent: '',
      refreshIndex: 0
    };
  },
  metaInfo: function metaInfo() {
    if (this.currentStoryDetail !== null) {
      return {
        title: this.currentStoryDetail.seoTitle
      };
    }
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('browse', ['currentStoryDetail'])),
  watch: {
    currentStoryDetail: {
      deep: true,
      handler: function handler(newVal) {
        var _this = this;

        if (newVal) {
          this.refreshIndex += 1;
          this.storyContent = '' + (newVal.bodyCSS || '') + (newVal.bodyHTML || '');
          this.$nextTick(function () {
            _this.installDynamicControls({
              data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newVal)
            });
          });
        }
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStoryDetail', 'clearCurrentStoryDetail']), {
    getCanonicalStoryUrl: function getCanonicalStoryUrl() {
      if (!this.currentStoryDetail) {
        return '';
      }
      return (this.currentStoryDetail.storyUrl || '').trim();
    },
    syncCanonicalStoryUrl: function syncCanonicalStoryUrl() {
      var canonicalStoryUrl = this.getCanonicalStoryUrl();
      var currentStoryUrl = ((this.$route.params || {}).storyUrl || '').trim();

      if (currentStoryUrl === canonicalStoryUrl) {
        return;
      }

      var params = {
        storyId: this.storyId
      };
      if (canonicalStoryUrl.length > 0) {
        params.storyUrl = canonicalStoryUrl;
      }

      this.$router.replace({
        name: 'story-details',
        params: params,
        query: this.$route.query,
        hash: this.$route.hash
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.loaderAdd(document.body);
    this.getStoryDetail({ index: this.storyId }).then(function () {
      _this2.syncCanonicalStoryUrl();
      _this2.loaderRemove(document.body);

      if (!window.location.hash) return;

      _this2.$nextTick(function () {
        var elementId = window.location.hash.replace('#', '');
        var element = window.document.getElementById(elementId);
        if (element !== null) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_scrollTo__["a" /* default */])(element);
        }
      });
    }).catch(function () {
      return _this2.loaderRemove(document.body);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearCurrentStoryDetail();
  }
});

/***/ }),

/***/ "xYxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-details-verify"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),(!_vm.ready)?_c('div',{staticClass:"account-details-verify__loader"}):_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[(_vm.isSsn4)?_c('p',{staticClass:"account-details-verify__ssn-info"},[_vm._v("\n      Please verify your information to continue\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row-xy"},[(!_vm.isSsn4)?[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":1,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.firstName,"name":"firstName","autocomplete":"given-name","required":true,"gtm":"ID Verification,First Name","placeholder":"First Name"},on:{"input":_vm.$v.fields.firstName.$touch,"blur":_vm.$v.fields.firstName.$touch},model:{value:(_vm.fields.firstName),callback:function ($$v) {_vm.$set(_vm.fields, "firstName", $$v)},expression:"fields.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":2,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.lastName,"name":"lastName","autocomplete":"family-name","required":true,"gtm":"ID Verification,Last Name","placeholder":"Last Name"},on:{"input":_vm.$v.fields.lastName.$touch,"blur":_vm.$v.fields.lastName.$touch},model:{value:(_vm.fields.lastName),callback:function ($$v) {_vm.$set(_vm.fields, "lastName", $$v)},expression:"fields.lastName"}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":3,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.dateOfBirthMonth,"autocomplete":"bday-month","placeholder":"MM","options":_vm.months,"track-by":"value","label":"label","gtm":"ID Verification,DOB-Month","required":true},on:{"input":_vm.$v.fields.dateOfBirthMonth.$touch,"select":function (e) { return _vm.tabTo(e, 'day'); }},model:{value:(_vm.fields.dateOfBirthMonth),callback:function ($$v) {_vm.$set(_vm.fields, "dateOfBirthMonth", $$v)},expression:"fields.dateOfBirthMonth"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('form-select',{ref:"day",attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":4,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.dateOfBirthDay,"autocomplete":"bday-day","placeholder":"DD","options":_vm.days,"track-by":"value","label":"label","gtm":"ID Verification,DOB-Day","required":true},on:{"input":_vm.$v.fields.dateOfBirthDay.$touch,"select":function (e) { return _vm.tabTo(e, 'year'); }},model:{value:(_vm.fields.dateOfBirthDay),callback:function ($$v) {_vm.$set(_vm.fields, "dateOfBirthDay", $$v)},expression:"fields.dateOfBirthDay"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('form-select',{ref:"year",attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":5,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.dateOfBirthYear,"autocomplete":"bday-year","placeholder":"YYYY","options":_vm.years,"track-by":"value","label":"label","gtm":"ID Verification,DOB-Year","required":true},on:{"input":_vm.$v.fields.dateOfBirthYear.$touch,"select":function (e) { return _vm.tabTo(e, 'street'); }},model:{value:(_vm.fields.dateOfBirthYear),callback:function ($$v) {_vm.$set(_vm.fields, "dateOfBirthYear", $$v)},expression:"fields.dateOfBirthYear"}})],1),_vm._v(" "),(_vm.errorNotAdult)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"account-details-verify__error"},[_vm._v("\n            "+_vm._s(_vm.errorNotAdult)+"\n          ")])]):_vm._e()]:_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{ref:"street",attrs:{"tabindex":6,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.street,"name":"street","autocomplete":"street","type":"text","required":true,"gtm":"ID Verification,Home Address","placeholder":"Street Address"},on:{"input":_vm.$v.fields.street.$touch,"blur":_vm.$v.fields.street.$touch},model:{value:(_vm.fields.street),callback:function ($$v) {_vm.$set(_vm.fields, "street", $$v)},expression:"fields.street"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":7,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.city,"name":"city","autocomplete":"city","type":"text","required":true,"gtm":"ID Verification,City","placeholder":"City"},on:{"input":_vm.$v.fields.city.$touch,"blur":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),(_vm.countries.length > 0)?_c('div',{class:_vm.countriesModifier},[(_vm.countries.length > 1)?_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":8,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.country,"placeholder":"Country","options":_vm.countries,"track-by":"value","label":"label","gtm":"ID Verification,Country","required":true},on:{"input":_vm.$v.fields.country.$touch,"close":function (e) { return _vm.tabTo(e, 'zipcode'); }},model:{value:(_vm.fields.country),callback:function ($$v) {_vm.$set(_vm.fields, "country", $$v)},expression:"fields.country"}}):_c('form-input',{attrs:{"tabindex":8,"name":"country","placeholder":"Country","track-by":"value","label":"label","gtm":"ID Verification,Country","disabled":true},model:{value:(_vm.fields.country.label),callback:function ($$v) {_vm.$set(_vm.fields.country, "label", $$v)},expression:"fields.country.label"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.zipCodeModifier},[_c('form-input',{ref:"zipcode",attrs:{"tabindex":9,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.zipCode,"name":"zipCode","autocomplete":"postal-code","type":"text","gtm":"ID Verification,Postal Code","required":_vm.fields.country.required,"placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch,"blur":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1),_vm._v(" "),(!_vm.isNotUnitedStates)?[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{ref:"taxId",attrs:{"tabindex":10,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.taxId,"name":"taxId","autocomplete":"off","type":"text","gtm":"taxId","required":_vm.fields.taxId.required,"placeholder":"SSN (Last 4 Digits)","masked":true},on:{"input":_vm.$v.fields.taxId.$touch,"blur":_vm.$v.fields.taxId.$touch},model:{value:(_vm.fields.taxId),callback:function ($$v) {_vm.$set(_vm.fields, "taxId", $$v)},expression:"fields.taxId"}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.showNoSolicitingNotice)?_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"column small-1"},[_c('form-checkbox',{staticClass:"checkbox--no-margin",attrs:{"name":"rememberMe","label":""},model:{value:(_vm.fields.nscbStatus),callback:function ($$v) {_vm.$set(_vm.fields, "nscbStatus", $$v)},expression:"fields.nscbStatus"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-11"},[_c('div',{staticClass:"account-details-verify__non-us-info"},[_vm._v("\n          Please check this box to confirm that you are a "),_c('router-link',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"to":{ name: 'terms-and-conditions', query: { section: 'us-person' } }}},[_vm._v("U.S. Person")]),_vm._v(" (a U.S. Citizen living anywhere in the world or a Resident Alien), that were not solicited by PredictIt or any PredictIt employee and that you have a valid U.S. Social Security Number (SSN) or Individual Tax Identification Number (ITIN). If you believe you were personally solicited by PredictIt or do not have the required identification do not check this box.\n        ")],1),_vm._v(" "),_c('div',{staticClass:"account-details-verify__non-us-link",on:{"click":function($event){_vm.showNscbStatusExplanation = !_vm.showNscbStatusExplanation}}},[_vm._v("\n          What does this mean?\n        ")]),_vm._v(" "),_c('transition',{attrs:{"name":"account-details-verify"}},[(_vm.showNscbStatusExplanation)?_c('div',{staticClass:"account-details-verify__non-us-info account-details-verify__non-us-info--margin"},[_vm._v("\n            Predictit accepts applications from "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://www.irs.gov/individuals/international-taxpayers/classification-of-taxpayers-for-us-tax-purposes"}},[_vm._v("U.S. Persons")]),_vm._v(" in numerous countries; however, PredictIt is a U.S. platform and does not solicit or market outside the United States. Check this box to certify that you have a valid U.S. SSN or ITIN, and that you have not been solicited by PredictIt or a PredictIt employee or representative about applying for, opening, or trading in a Predictit account. If you do not have a valid U.S. SSN or ITIN, or if you believe you were solicited by Predictit, do not check this box.\n          ")]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-details-verify__submit"},[_c('form-submit',{attrs:{"disabled":_vm.isSubmitButtonDisabled,"label":_vm.submitLabel}})],1),_vm._v(" "),_c('p',{staticClass:"account-details-verify__disclaimer",domProps:{"innerHTML":_vm._s(_vm.disclaimer)},on:{"!click":function($event){return _vm.catchHtmlClick($event)}}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("Date Of Birth")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("Home Address")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("Tax Info")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xb6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-charts"},[_c('div',{staticClass:"sushi-market-charts__title"},[_vm._v("\n    Charts\n  ")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-charts__content"},[_c('market-charts',{key:("chart-extra-" + (_vm.isLayoutDesktop.toString())),attrs:{"market":_vm.market}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xdho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-news-stories"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-news-stories__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-news-stories__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xgaP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "xnYV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"add-funds-coinbase"},[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":"page-padded"}}):(_vm.collectSsnInfo)?_c('account-ssn-info-upload',{attrs:{"isPopup":_vm.isPopup,"theme":_vm.accountUploadDocumentTheme}}):[(_vm.showPromoNotification)?_c('alert-box',{staticClass:"add-funds-coinbase__alert-box",attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.error)?_c('alert-box',{staticClass:"add-funds-coinbase__alert-box",attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.error)}})]):[_c('p',{staticClass:"add-funds-coinbase__note add-funds-coinbase__note--bold"},[_vm._v("\n        You can deposit funds into your PredictIt account using a "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://www.coinbase.com/usdc"}},[_vm._v("USD Coin")]),_vm._v(" wallet. After clicking on the Confirm button below, you will be taken to Coinbase to complete your transaction.\n      ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-coinbase__note add-funds-coinbase__note--bold"},[_vm._v("\n        Please note that "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://www.coinbase.com"}},[_vm._v("Coinbase")]),_vm._v(" charges a network fee to transfer funds. You should expect a delay between the time you transfer funds from your wallet and the time you receive a credit in your PredictIt account.\n      ")]),_vm._v(" "),_c('form',{staticClass:"add-funds-coinbase__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Deposit Amount ($"+_vm._s(_vm.minimumDepositAmount.toFixed(2))+" Minimum)")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[(_vm.amountHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds-coinbase__error"},[_vm._v("\n              "+_vm._s(_vm.amountValidationMessage)+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"input-group input-group--large"},[_c('span',{staticClass:"input-group__addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fields.amount),expression:"fields.amount"}],staticClass:"input-group__input",attrs:{"tabindex":"1","validation":_vm.$v.fields.amount},domProps:{"value":(_vm.fields.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.fields, "amount", $event.target.value)},_vm.$v.fields.amount.$touch],"blur":_vm.handleAmountBlur}})])]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},_vm._l((_vm.depositAmounts),function(amount){return _c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"button button--primary add-funds-coinbase__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onUpdateAmount(amount)}}},[_c('span',{staticClass:"add-funds-coinbase__button-plus"},[_vm._v("+")]),_vm._v(" $"+_vm._s(amount)+"\n                  ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"add-funds-coinbase__submit"},[_c('form-submit',{attrs:{"label":"Confirm","disabled":_vm.isConfirmDisabled}})],1)]),_vm._v(" "),(_vm.disclaimer)?[_c('br'),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds-coinbase__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e(),_vm._v(" "),(false)?_c('p',{staticClass:"add-funds-coinbase__note"},[_vm._v("\n          Due to anti-money laundering and anti-terrorism laws we have a "),_c('strong',[_vm._v("$10K daily deposit limit")]),_vm._v(". If your daily deposit(s) total more $10k on any given day you will automatically trigger a $500 processing fee and your account will be suspended for 7 days for processing.\n        ")]):_vm._e()]:_vm._e()]]],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xoS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-two-factor-prompt"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"two-factor-prompt__title"},[_vm._v("Secure Your Account")]),_vm._v(" "),_c('p',{staticClass:"two-factor-prompt__description"},[_vm._v("\n    Add an extra layer of security to your PredictIt account with two-factor authentication. \n    This helps protect your account even if your password is compromised.\n  ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"two-factor-prompt__actions"},[_c('button',{staticClass:"button button--primary button--full-width",on:{"click":_vm.onSetupNow}},[_vm._v("\n      Set Up Now\n    ")]),_vm._v(" "),_c('button',{staticClass:"two-factor-prompt__skip-btn",on:{"click":_vm.onNotNow}},[_vm._v("\n      Not Now\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"two-factor-prompt__icon"},[_c('span',{staticClass:"icon-shield"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"two-factor-prompt__benefits"},[_c('li',[_vm._v("Protect your funds and trading activity")]),_vm._v(" "),_c('li',[_vm._v("Choose from email, SMS, or authenticator app")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xpMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"app-loader"},[_c('div',{staticClass:"app-loader__overlay"}),_vm._v(" "),_c('div',{staticClass:"app-loader__progress-bar"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xqHD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xqHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");












var toRoute = '';
var restore = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_contentLoader__["a" /* default */]],
  components: {
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_10__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Terms and Conditions'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* STATIC_PAGES */].TERMS).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).then(function () {
      var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["I" /* parseQuery */])(window.location.search);
      if (query && query.section) {
        _this.$nextTick(function () {
          var toWhere = document.getElementById(query.section);
          if (!toWhere) {
            return;
          }
          var topOffset = 16; // add some padding
          var header = document.querySelector('.app-layout__header');
          if (header) {
            topOffset += header.offsetHeight;
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scrollTo__["a" /* default */])(toWhere, 0, 'linear', null, topOffset);
        });
      }
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  },

  // beforeDestroy() {
  //   // firest after router loop
  //   if (restore) {
  //     store.dispatch('popup/restorePopup', toRoute);
  //   }
  // },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var popup = to.params.noPopup ? null : null;
    __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('popup/rememberPopup', {
      route: from.name,
      popup: popup
    });
    next();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'privacy-policy';
    toRoute = to.name;
    next();
  }
});

/***/ }),

/***/ "xth1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_tax_detail_js__ = __webpack_require__("nE9/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45db617a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_tax_detail_vue__ = __webpack_require__("4Hqt");
function injectStyle (ssrContext) {
  __webpack_require__("G/gM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_tax_detail_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45db617a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_tax_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xw4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    smallModal: __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_small_small_vue__["default"]
  },
  props: {
    scrollable: {
      type: Boolean,
      default: false
    },
    minimumRows: {
      type: Number,
      default: 3
    },
    contract: {
      type: Object,
      required: true
    },
    market: {
      type: Object,
      required: true
    },
    buyOffers: {
      type: Array,
      required: true,
      default: []
    },
    sellOffers: {
      type: Array,
      required: true,
      default: []
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    operationType: {
      type: String,
      default: 'buy',
      validator: function validator(value) {
        return ['buy', 'sell'].indexOf(value) >= 0;
      }
    }
  },
  data: function data() {
    return {
      deleteOfferId: null,
      isCancelling: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isCancelOrdersEnabled']), {
    classModifiers: function classModifiers() {
      return {
        'order-book-my-orders-sushi': true,
        'order-book-my-orders-sushi--empty': this.isEmpty
      };
    },
    tableModifiers: function tableModifiers() {
      return {
        'order-book-sushi__table': true,
        'order-book-sushi__table--scrollable': this.scrollable
      };
    },
    bodyModifiers: function bodyModifiers() {
      return {
        'order-book-sushi__body': true,
        'order-book-sushi__body--scrollable': this.scrollable,
        'order-book-my-orders-sushi__body--empty': this.isEmpty
      };
    },
    emptyStateText: function emptyStateText() {
      return this.isLoggedIn ? '(No Orders)' : '(Not Logged In)';
    },
    activeOrderSide: function activeOrderSide() {
      return this.operationType === 'sell' ? 'sell' : 'buy';
    },
    emptyOrdersText: function emptyOrdersText() {
      return 'You have no ' + this.activeOrderSide + ' orders.';
    },
    buyHeaderModifiers: function buyHeaderModifiers() {
      return {
        'order-book-sushi__header-cell': true,
        'order-book-sushi__header-cell--with-avail-matches': true,
        'order-book-sushi__header-cell--active': this.activeOrderSide === 'buy'
      };
    },
    sellHeaderModifiers: function sellHeaderModifiers() {
      return {
        'order-book-sushi__header-cell': true,
        'order-book-sushi__header-cell--with-avail-matches': true,
        'order-book-sushi__header-cell--active': this.activeOrderSide === 'sell'
      };
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    imageUrl: function imageUrl() {
      return this.contract.contractImageSmallUrl || this.contract.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    buyOffersMapped: function buyOffersMapped() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.buyOffers)).map(function (offer) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, offer, {
          pricePerShare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(offer.pricePerShare)
        });
      }).sort(function (prev, next) {
        return next.pricePerShare - prev.pricePerShare;
      });
    },
    sellOffersMapped: function sellOffersMapped() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.sellOffers)).map(function (offer) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, offer, {
          pricePerShare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* toCents */])(offer.pricePerShare)
        });
      }).sort(function (prev, next) {
        return prev.pricePerShare - next.pricePerShare;
      });
    },
    displayRows: function displayRows() {
      var _this = this;

      var rowCount = Math.max(this.buyOffersMapped.length, this.sellOffersMapped.length, this.scrollable ? this.minimumRows : 0);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: rowCount }, function (item, index) {
        return {
          buy: _this.buyOffersMapped[index] || null,
          sell: _this.sellOffersMapped[index] || null,
          showBuyEmpty: !_this.isEmpty && _this.buyOffersMapped.length === 0 && index === 0,
          showSellEmpty: !_this.isEmpty && _this.sellOffersMapped.length === 0 && index === 0
        };
      });
    },
    isEmpty: function isEmpty() {
      return this.buyOffersMapped.length === 0 && this.sellOffersMapped.length === 0;
    },
    selectedOffer: function selectedOffer() {
      var _this2 = this;

      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.buyOffersMapped), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.sellOffersMapped)).find(function (offer) {
        return offer.offerId === _this2.deleteOfferId;
      }) || null;
    },
    showCancelModal: function showCancelModal() {
      return !!this.selectedOffer;
    },
    showProcessedNotice: function showProcessedNotice() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.buyOffersMapped), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.sellOffersMapped)).some(function (offer) {
        return !offer.isProcessed;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['cancelOffer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('app', ['setCurrentPopup']), {
    loginClicked: function loginClicked() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    },
    getDateFull: function getDateFull(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["k" /* dateToString */])(item.dateCreated);
    },
    offerFullInfoDisplay: function offerFullInfoDisplay(item) {
      var quantity = item.remainingQuantity.toLocaleString();
      var price = item.pricePerShare + '&cent;';
      switch (item.tradeType) {
        case 0:
          return 'Buy ' + quantity + ' NO at Max ' + price;
        case 1:
          return 'Buy ' + quantity + ' YES at Max ' + price;
        case 2:
          return 'Sell ' + quantity + ' NO at Min ' + price;
        case 3:
          return 'Sell ' + quantity + ' YES at Min ' + price;
        default:
          return '';
      }
    },
    cancelClicked: function cancelClicked(offerId) {
      this.deleteOfferId = offerId;
    },
    closeCancelModal: function closeCancelModal() {
      this.deleteOfferId = null;
      this.isCancelling = false;
    },
    confirmCancelClicked: function confirmCancelClicked() {
      var _this3 = this;

      if (!this.selectedOffer || this.isCancelling) {
        return;
      }

      if (!this.isCancelOrdersEnabled) {
        this.setErrorSideNotification('The site is in Maintenance so we are unable to cancel your order at this time. Please try again later.');
        this.closeCancelModal();
        return;
      }

      this.isCancelling = true;
      this.cancelOffer(this.selectedOffer.offerId).then(function () {
        _this3.setSuccessSideNotification('Your order has been removed.');
        _this3.closeCancelModal();
        _this3.$emit('offerCanceled');
      }).catch(function () {
        _this3.closeCancelModal();
        _this3.setErrorSideNotification('Unable to cancel your order right now.');
      });
    }
  })
});

/***/ }),

/***/ "xyij":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "y1jZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_in_the_news_js__ = __webpack_require__("6b0c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67380c1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_in_the_news_vue__ = __webpack_require__("asvG");
function injectStyle (ssrContext) {
  __webpack_require__("tjXz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_in_the_news_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67380c1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_in_the_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y8UT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_badge_account_social_badge_vue__ = __webpack_require__("gdGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_userAgent__ = __webpack_require__("GZXJ");

/* eslint-disable no-unused-vars */







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_userAgent__["a" /* default */]],
  components: {
    accountSocialBadge: __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_badge_account_social_badge_vue__["a" /* default */]
  },
  data: function data() {
    return {
      name: null,
      accountBalance: null,
      portfolioBalance: null,
      currency: null
    };
  },
  metaInfo: function metaInfo() {
    if (this.isLayoutMobile) {
      return {
        title: 'Account'
      };
    }
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasMaintenanceMessage', 'isLayoutMobile']), {
    enabledLinks: function enabledLinks() {
      return this.links.filter(function (i) {
        return i.enabled;
      });
    },
    links: function links() {
      var route = this.$route;
      var query = this.$route.query;

      return [{
        type: 'header',
        name: 'Wallet',
        enabled: true
      }, {
        name: 'Deposit',
        type: 'link',
        inner: true,
        to: { name: 'wallet', query: { tabId: 'deposit' } },
        active: route.name === 'wallet' && query.tabId === 'deposit',
        enabled: true
      }, {
        name: 'Withdraw',
        type: 'link',
        inner: true,
        to: { name: 'wallet', query: { tabId: 'withdraw' } },
        active: route.name === 'wallet' && query.tabId === 'withdraw',
        enabled: true
      }, {
        type: 'line',
        name: 'Line1',
        enabled: true
      }, {
        type: 'header',
        name: 'History',
        enabled: true
      }, {
        name: 'Trades',
        type: 'link',
        inner: true,
        to: { name: 'account-history', query: { tabId: 'trades' } },
        active: route.name === 'account-history' && (query.tabId === 'trades' || route.params.marketId),
        enabled: true
      }, {
        name: 'Deposits / Withdrawals',
        type: 'link',
        inner: true,
        to: { name: 'account-history', query: { tabId: 'deposit-withdrawals' } },
        active: route.name === 'account-history' && query.tabId === 'deposit-withdrawals',
        enabled: true
      }, {
        type: 'line',
        name: 'Line2',
        enabled: true
      }, {
        name: 'Account Details',
        type: 'link',
        to: { name: 'account-details' },
        active: route.name === 'account-details',
        enabled: true
      }, {
        name: 'Settings',
        type: 'link',
        to: { name: 'account-settings' },
        active: route.name === 'account-settings',
        enabled: true
      }, {
        name: 'Help and Support',
        type: 'link',
        to: { name: 'HelpAndSupport' },
        active: ['HelpAndSupport', 'WhatIsPredictIt', 'LearnTheBasics', 'ComunityForums', 'Faq', 'Videos'].includes(route.name),
        enabled: true
      }, {
        type: 'line',
        name: 'Line3',
        enabled: true
      }, {
        type: 'logout',
        name: 'LOGOUT',
        enabled: true
      }];
    },
    cash: function cash() {
      return (Math.floor(this.balance.accountBalanceDecimal * 100) / 100).toFixed(2);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout']), {
    profileButtonClass: function profileButtonClass(link) {
      return {
        profile__button: true,
        'profile__button--inner': link.inner,
        'profile__button--active': link.active
      };
    },
    logoutButton: function logoutButton() {
      this.loaderAdd(document.body);
      this.logout();
      this.$gtm.trackEvent({ event: 'Logout' });
    },
    isLinkAvailable: function isLinkAvailable(link) {
      var walletCheckNames = ['Deposit', 'Withdraw', 'Wallet', 'Line1'];
      if (walletCheckNames.includes(link.name)) {
        return this.isWalletEnabled;
      }
      return true;
    }
  })
});

/***/ }),

/***/ "y9s0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yCD8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgOCAxNCI+CiAgICA8cGF0aCBmaWxsPSIjMjYzQjNGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0uOTAyLjMzM2wtLjYwNC42NzNBMS4yMjQgMS4yMjQgMCAwIDAgMCAxLjgyNGMwIC4zMTguMS41ODcuMjk4LjgwOUw0LjIxMiA3IC4yOTggMTEuMzY3YTEuMTY5IDEuMTY5IDAgMCAwLS4yOTguODA5YzAgLjMxMS4xLjU4NC4yOTguODE4bC42MDQuNjY1YS45NTEuOTUxIDAgMCAwIC43MzMuMzQxYy4yOSAwIC41MzItLjExNC43MjUtLjM0MWw1LjI0My01Ljg1Yy4yMDQtLjIxNi4zMDYtLjQ4NS4zMDYtLjgwOSAwLS4zMTgtLjEwMi0uNTktLjMwNi0uODE4TDIuMzYuMzMyQS45MzguOTM4IDAgMCAwIDEuNjM1IDBjLS4yOCAwLS41MjMuMTEtLjczMy4zMzN6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "yG4g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_session_history_sushi_session_history_sushi_vue__ = __webpack_require__("84WW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_history_sushi_product_history_sushi_vue__ = __webpack_require__("4gzO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_watchlist_sushi_watchlist_sushi_vue__ = __webpack_require__("62Vb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sushi_market_links_toggle_sushi_market_links_toggle_vue__ = __webpack_require__("S77G");








var SECTIONS = {
  WATCHLIST: 'watchlist',
  SESSION_HISTORY: 'session-history',
  PRODUCT_HISTORY: 'product-history'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      opened: [],
      SECTIONS: SECTIONS
    };
  },

  components: {
    sessionHistorySushi: __WEBPACK_IMPORTED_MODULE_3__components_session_history_sushi_session_history_sushi_vue__["a" /* default */],
    productHistorySushi: __WEBPACK_IMPORTED_MODULE_4__components_product_history_sushi_product_history_sushi_vue__["a" /* default */],
    watchlistSushi: __WEBPACK_IMPORTED_MODULE_5__components_watchlist_sushi_watchlist_sushi_vue__["a" /* default */],
    sushiMarketLinksToggle: __WEBPACK_IMPORTED_MODULE_6__sushi_market_links_toggle_sushi_market_links_toggle_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['market', 'isMarketHistoryPinned', 'isWatchlistPinned', 'isSessionHistoryPinned', 'pinnedOpened']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('market', ['historyData']), {
    sections: function sections() {
      var results = [];
      if (this.isWatchlistPinned) {
        results.push({ name: SECTIONS.WATCHLIST, title: 'Watchlist' });
      }

      if (this.isSessionHistoryPinned) {
        results.push({ name: SECTIONS.SESSION_HISTORY, title: 'Session List' });
      }

      // if (this.isMarketHistoryPinned) {
      //   results.push({ name: SECTIONS.PRODUCT_HISTORY, title: 'Product History' });
      // }

      return results;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['toggleOpenPinSection']), {
    sectionClassModifiers: function sectionClassModifiers(section) {
      return {
        'sushi-market-links-widget__section': true,
        'sushi-market-links-widget__section--opened': this.isSectionOpen(section)
      };
    },
    isSectionOpen: function isSectionOpen(section) {
      return this.pinnedOpened.includes(section.name);
    }
  })
});

/***/ }),

/***/ "yMVe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-details"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":_vm.title,"returnRoute":"profile"}}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.gridRowModifier},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 account-details__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[(!_vm.isLayoutMobile)?_c('account-desktop-header',{attrs:{"title":"Account Details"}}):_vm._e(),_vm._v(" "),(_vm.isMobileAddressUpdate)?_c('account-address-update'):_vm._e(),_vm._v(" "),(_vm.isMobileDetailsUpdate)?_c('account-details-update'):_vm._e(),_vm._v(" "),(_vm.isMobilePasswordChange)?_c('account-update-password'):_vm._e(),_vm._v(" "),(_vm.isMobilePasswordSet)?_c('account-set-password'):_vm._e(),_vm._v(" "),(_vm.isDetailsShown)?_c('div',{staticClass:"account-details__content"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"details"}}):[_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Personal Details")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                First Name\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                "+_vm._s(_vm.userData.firstName)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                Last Name\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                "+_vm._s(_vm.userData.lastName)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                Username\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_c('div',[_vm._v(_vm._s(_vm.userData.userName))]),_vm._v(" "),_c('router-link',{staticClass:"content-header__section-alt-link",attrs:{"to":{name: 'details-update'}}},[_vm._v("\n                  Edit\n                 ")])],1)]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                Email\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                "+_vm._s(_vm.userData.email)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                Phone\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_c('div',[_vm._v(_vm._s(_vm.userData.phone || "Not Set"))]),_vm._v(" "),_c('a',{staticClass:"content-header__section-alt-link",on:{"click":_vm.showPhoneUpdatePopup}},[_vm._v("\n                     "+_vm._s(_vm.userData.phone ? "Edit" : "Add")+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                Password\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_c('div',[_vm._v("*********")]),_vm._v(" "),(_vm.hasLocalPassword)?_c('router-link',{staticClass:"content-header__section-alt-link content-header__section-alt-link--small-margin",attrs:{"to":{name: 'password-update'}}},[_vm._v("\n                  Edit\n                 ")]):_vm._e(),_vm._v(" "),(!_vm.hasLocalPassword)?_c('router-link',{staticClass:"content-header__section-alt-link content-header__section-alt-link--small-margin",attrs:{"to":{name: 'password-set'}}},[_vm._v("\n                  Set\n                ")]):_vm._e()],1)])]),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Identity Verification")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_c('div',{staticClass:"content-header__section-text"},[_vm._v("Verification Status")]),_vm._v(" "),(_vm.showVerificationStatusInfo)?_c('notification-icon',{staticClass:"content-header__section-icon",on:{"showPopup":_vm.onShowVerificationInfo}}):_vm._e()],1),_vm._v(" "),_c('div',{class:_vm.contentHeaderButtonSectionModifiers},[_c('div',[_vm._v(_vm._s(_vm.verificationStatusDisplay))]),_vm._v(" "),(!_vm.verificationStatusIs(_vm.STATUS_ENHANCED))?[(_vm.verificationStatusIs(_vm.STATUS_NOT_VERIFIED))?_c('button',{staticClass:"content-header__section-alt-button",on:{"click":_vm.onVerifyIdentity}},[_c('div',[_vm._v("Verify")])]):_vm._e(),_vm._v(" "),(_vm.verificationStatusIs(_vm.STATUS_BASIC))?_c('button',{staticClass:"content-header__section-alt-button",on:{"click":_vm.onUploadDocuments}},[_c('div',[_vm._v("Upgrade")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt-button-icon"})]):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Contact Details")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section-alt content-header__section-alt--full-height"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                Address\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right text-right"},[_c('div',[_vm._v("\n                  "+_vm._s(_vm.userData.address)),_c('br'),_vm._v("\n                  "+_vm._s(_vm.userData.city)),_c('br'),_vm._v("\n                  "+_vm._s(_vm.userData.postalCode)+"\n                ")]),_vm._v(" "),(!_vm.isUpdateAddressDisabled)?_c('router-link',{staticClass:"content-header__section-alt-link",attrs:{"to":{name: 'address-update'}}},[_vm._v("\n                  Edit\n                 ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                Country\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                "+_vm._s(_vm.userData.countryName)+"\n              ")])])]),_vm._v(" "),_c('h4',{staticClass:"account-details__profile-title"},[_c('span',{staticClass:"account-details__profile-title-text"},[_vm._v("Profile")]),_vm._v(" "),_c('div',{staticClass:"account-details__profile-title-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section-alt content-header__section-alt--full-height content-header__section-alt--no-border"},[_c('div',{staticClass:"content-header__section-alt--left-short"},[_c('div',[_vm._v("\n                  College Affiliation\n                ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right text-right"},[(_vm.isUCAffilSet === false)?_c('div',[_vm._v("\n                  Not Affiliated\n                ")]):(_vm.userAffiliations.length === 0)?_c('div',[_vm._v("\n                  No Affiliations Specified\n                ")]):(_vm.userAffiliations.length > 0)?_c('div',_vm._l((_vm.userAffiliations),function(item,index){return _c('div',{key:index},[_vm._v("\n                    "+_vm._s(item.name)),(item.isPendingApproval)?_c('span',[_vm._v(" (Pending)")]):_vm._e(),(!item.isPublic)?_c('span',[_vm._v(" *")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('a',{staticClass:"content-header__section-alt-link",on:{"click":_vm.showAffiliationsPopup}},[_vm._v("\n                  Edit\n                 ")])])])])]],2):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yOrf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-trading-unavailable-v2__icon"}),_vm._v(" "),_c('div',{staticClass:"market-trading-unavailable-v2__text"},[_vm._t("text")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ySQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bottom_betslip_shortcut_widget_js__ = __webpack_require__("oFp3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3f5458_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_betslip_shortcut_widget_vue__ = __webpack_require__("j7O+");
function injectStyle (ssrContext) {
  __webpack_require__("drbC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bottom_betslip_shortcut_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3f5458_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottom_betslip_shortcut_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yUpF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ONBOARDING_STEPS_WITH_PROGRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ONBOARDING_STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ONBOARDING_STEP_CODE_NAME_MAP; });
/* unused harmony export ONBOARDING_STEP_CODES_USER_VERIFIED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ONBOARDING_STEP_NAME_CODE_MAP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);



var _ONBOARDING_STEP_CODE;

/* eslint-disable */

var ONBOARDING_STEPS_WITH_PROGRESS = {
  // CONFIRM_EMAIL: 'confirm-email',
  PERSONAL_DETAILS: 'personal-details',
  COMPLIANCE: 'compliance',
  QUESTIONNAIRE: 'questionnaire',
  PENDING_APPROVAL: 'pending-approval',
  QUICK_DEPOSIT: 'quick-deposit'
};
var ONBOARDING_STEPS = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, ONBOARDING_STEPS_WITH_PROGRESS, {
  REGISTER: 'register',
  LOGIN: 'login',
  FORGOTTEN: 'forgotten'
});

var ONBOARDING_STEP_CODE_NAME_MAP = (_ONBOARDING_STEP_CODE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ONBOARDING_STEP_CODE, 'ConfigureProfileAndIDV', ONBOARDING_STEPS.PERSONAL_DETAILS), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ONBOARDING_STEP_CODE, 'ComplianceDocumentReview', ONBOARDING_STEPS.COMPLIANCE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ONBOARDING_STEP_CODE, 'ComplianceQuestionReview', ONBOARDING_STEPS.QUESTIONNAIRE), _ONBOARDING_STEP_CODE);

var ONBOARDING_STEP_CODES_USER_VERIFIED = ['SignupComplete', 'ComplianceFinalization'];

var ONBOARDING_STEP_NAME_CODE_MAP = {
  PERSONAL_DETAILS: 'ConfigureProfileAndIDV',
  COMPLIANCE: 'ComplianceDocumentReview',
  QUESTIONNAIRE: 'ComplianceQuestionReview',
  ADD_FUNDS_OR_PENDING: 'RequestDeposit',
  SIGNUP_COMPLETE: 'SignupComplete',
  COMPLIANCE_FINALIZATION: 'ComplianceFinalization'
};

/***/ }),

/***/ "yZQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




var STATUS_PENDING = 2;

var accountVerifyMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData', 'status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), {
    accountLink: function accountLink() {
      if (this.isLayoutMobile) return '/account';
      if (this.isWalletEnabled) return '/account/wallet';
      return '/account/details';
    },
    hasUserClassicEnabled: function hasUserClassicEnabled() {
      return !this.isLoggedIn || this.isLoggedIn && this.status.isClassicEnabled !== false;
    },
    isUserVerified: function isUserVerified() {
      var idVerified = this.userData.idVerified;
      var verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified || verificationStatus === STATUS_PENDING : false;
    },
    isUserVerifiedFully: function isUserVerifiedFully() {
      var idVerified = this.userData.idVerified;
      var verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified && verificationStatus !== STATUS_PENDING : false;
    },
    isWalletEnabled: function isWalletEnabled() {
      var idVerified = this.userData.idVerified;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified : false;
    },
    isUserBalanceEmpty: function isUserBalanceEmpty() {
      return this.balance && this.balance.accountBalanceDecimal === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    checkDataIfUserIsVerified: function checkDataIfUserIsVerified(data) {
      if (!this.isLoggedIn) return true;
      return data && (data.idVerified === true || data.verificationStatus === STATUS_PENDING);
    },
    showAccountVerifyPopup: function showAccountVerifyPopup() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
    },
    showAddFundsPopup: function showAddFundsPopup() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (accountVerifyMixin);

/***/ }),

/***/ "ybBz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showMenu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['market', 'isMarketHistoryPinned', 'isWatchlistPinned', 'isSessionHistoryPinned']), {
    itemWatchlistModifiers: function itemWatchlistModifiers() {
      return {
        'sushi-market-links-toggle__menu-inner-item': true,
        'sushi-market-links-toggle__menu-inner-item--active': this.isWatchlistPinned
      };
    },
    itemSessionHistoryModifiers: function itemSessionHistoryModifiers() {
      return {
        'sushi-market-links-toggle__menu-inner-item': true,
        'sushi-market-links-toggle__menu-inner-item--active': this.isSessionHistoryPinned
      };
    },
    itemMarketHistoryModifiers: function itemMarketHistoryModifiers() {
      return {
        'sushi-market-links-toggle__menu-inner-item': true,
        'sushi-market-links-toggle__menu-inner-item--active': this.isMarketHistoryPinned
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['toggleWatchlistPin', 'toggleMarketHistoryPin', 'toggleSessionHistoryPin']))
});

/***/ }),

/***/ "ybIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_v2_rules_criteria_svg__ = __webpack_require__("n5nq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_v2_rules_criteria_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_icons_v2_rules_criteria_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_v2_rules_dates_svg__ = __webpack_require__("LnAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_v2_rules_dates_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_v2_rules_dates_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_v2_rules_market_type_svg__ = __webpack_require__("zx9v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_v2_rules_market_type_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_v2_rules_market_type_svg__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      criteriaIcon: __WEBPACK_IMPORTED_MODULE_1__assets_icons_v2_rules_criteria_svg___default.a,
      datesIcon: __WEBPACK_IMPORTED_MODULE_2__assets_icons_v2_rules_dates_svg___default.a,
      marketTypeIcon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_v2_rules_market_type_svg___default.a
    };
  },

  props: {
    market: {
      type: Object,
      required: true
    }
  },
  computed: {
    rulesModel: function rulesModel() {
      return this.market && this.market.rulesModel || {};
    },
    startDate: function startDate() {
      return this.rulesModel.dateStart ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["k" /* dateToString */])(this.rulesModel.dateStart) : null;
    },
    endDate: function endDate() {
      var text = this.rulesModel.dateEndText;

      if (text && text.toUpperCase() === 'NA') {
        return null;
      }

      if (!text || text.trim() === '') {
        return this.rulesModel.dateEnd ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["k" /* dateToString */])(this.rulesModel.dateEnd) : null;
      }

      return text.trim();
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* isMarketSingle */])(this.market);
    },
    clarificationDisclaimer: function clarificationDisclaimer() {
      return (this.rulesModel.ruleClarifications || []).find(function (clarification) {
        return clarification.isHighlighted;
      });
    },
    clarificationsSection: function clarificationsSection() {
      return this.rulesModel.ruleClarifications || [];
    }
  },
  methods: {
    dateToString: __WEBPACK_IMPORTED_MODULE_0__utils_helpers__["k" /* dateToString */]
  }
});

/***/ }),

/***/ "yeq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_badges_list_js__ = __webpack_require__("LWRS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8808b94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_badges_list_vue__ = __webpack_require__("ohdr");
function injectStyle (ssrContext) {
  __webpack_require__("H7Lx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_badges_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8808b94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_badges_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ygM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

/* eslint-disable no-useless-escape */


function isValidUrl(input) {
  var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  return regex.test(input);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      imageLoadError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    showSubtitle: function showSubtitle() {
      return this.data && this.data.origin && this.data.origin.title;
    },
    shouldShowImage: function shouldShowImage() {
      return !this.imageLoadError;
    },
    containerModifier: function containerModifier() {
      return {
        'news-feed-item--no-image': this.imageLoadError
      };
    },
    contentModifier: function contentModifier() {
      return {
        'small-8': !this.imageLoadError,
        'small-12': this.imageLoadError
      };
    },
    url: function url() {
      return this.data.originId;
    },
    target: function target() {
      return isValidUrl(this.url) && this.isLayoutDesktop ? '_blank' : '_self';
    }
  }),
  methods: {
    getItemImage: function getItemImage(item) {
      if (item.visual && item.visual.url) {
        return item.visual.url;
      }

      this.imageLoadError = true;
      return null;
    },
    onImageLoadError: function onImageLoadError() {
      this.imageLoadError = true;
    }
  }
});

/***/ }),

/***/ "yhSh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_toolbar_js__ = __webpack_require__("RJiU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41157d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_toolbar_vue__ = __webpack_require__("WOmE");
function injectStyle (ssrContext) {
  __webpack_require__("t3/+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_toolbar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41157d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yjAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_rules_market_rules_vue__ = __webpack_require__("bynG");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketRules: __WEBPACK_IMPORTED_MODULE_2__components_market_market_rules_market_rules_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['market']))
});

/***/ }),

/***/ "ynxK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yoSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"animated-number"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('span',{key:_vm.value,staticClass:"animated-number__value"},[_vm._v(_vm._s(_vm.value)),_c('span',{domProps:{"innerHTML":_vm._s(_vm.symbol)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ypi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-notification-items"}},[(_vm.shouldDisplayNotifications)?_c('div',{staticClass:"notification-items"},[_c('div',{staticClass:"notification-items__container"},[_c('transition-group',{attrs:{"name":"slide-notification","tag":"div"}},[_vm._l((_vm.notificationsToDisplay),function(notification){return [(_vm.shouldDisplayNotificationSimple(notification))?_c('notification-item-simple',{key:notification.index,attrs:{"autoClose":true,"text":notification.data.text,"icon":notification.data.icon,"title":notification.data.title,"closeTimeout":notification.data.closeTimeout,"index":notification.index}}):_vm._e(),_vm._v(" "),(_vm.shouldDisplayNotificationTradeConfirmed(notification))?_c('notification-item-trade-confirmed',{key:notification.index,attrs:{"autoClose":true,"closeTimeout":_vm.NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY,"index":notification.index,"data":notification.data}}):_vm._e(),_vm._v(" "),(_vm.shouldDisplayDashboardNotification(notification))?_c('notification-item-dashboard',{key:notification.index,attrs:{"autoClose":true,"closeButton":true,"closeTimeout":_vm.NOTIFICATION_SHARES_TRADED_CLOSE_DELAY,"theme":"notifications","index":notification.index,"data":notification.data}}):_vm._e()]})],2)],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ys9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");

 /* eslint-disable */




var externalLinksMixin = {
  data: function data() {
    return {
      links: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getExternalLogins']), {
    registrationTrack: function registrationTrack(label) {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: label
      });
    },
    twitterLinkClick: function twitterLinkClick() {
      this.registrationTrack('Twitter');
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('TWITTER LINK CLICKED', this.twitterLink);
      window.location.href = this.twitterLink;
    },
    facebookLinkClick: function facebookLinkClick() {
      this.registrationTrack('Facebook');
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('FACEBOOK LINK CLICKED', this.facebookLink);
      window.location.href = this.facebookLink;
    },
    googleLinkClick: function googleLinkClick() {
      this.registrationTrack('Google');
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('GOOGLE LINK CLICKED', this.googleLink);
      window.location.href = this.googleLink;
    }
  }),
  computed: {
    twitterLink: function twitterLink() {
      var data = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.links, function (l) {
        return l.name === 'Twitter';
      });
      return data ? '' + "" + data.url : null;
    },
    facebookLink: function facebookLink() {
      var data = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.links, function (l) {
        return l.name === 'Facebook';
      });
      return data ? '' + "" + data.url : null;
    },
    googleLink: function googleLink() {
      var data = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.links, function (l) {
        return l.name === 'Google';
      });
      return data ? '' + "" + data.url : null;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (externalLinksMixin);

/***/ }),

/***/ "yzoE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_trade_type_switcher_sushi_js__ = __webpack_require__("Y2Na");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2802b874_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_trade_type_switcher_sushi_vue__ = __webpack_require__("iPBj");
function injectStyle (ssrContext) {
  __webpack_require__("BPuv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_trade_type_switcher_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2802b874_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_trade_type_switcher_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z++8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__ = __webpack_require__("P71F");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('leaderboards', ['selectedLeaderboard']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('leaderboards', ['leaderboards', 'selectedLeaderboardId'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('leaderboards', ['setSelectedLeaderboardId', 'getLeaderboards']), {
    itemClassModifiers: function itemClassModifiers(item) {
      return {
        'leaderboards-levels__item': true,
        'leaderboards-levels__item--active': item.leaderBoardId === this.selectedLeaderboardId
      };
    },
    onItemClick: function onItemClick(item) {
      if (item.leaderBoardId !== this.selectedLeaderboardId) {
        this.setSelectedLeaderboardId(item.leaderBoardId);
      }
    }
  }),
  created: function created() {
    var _this = this;

    this.getLeaderboards().then(function (data) {
      _this.isComponentReady = true;
      var shouldSetFirstLeaderboardAsDefault = !_this.selectedLeaderboardId && (data || []).length > 0 && _this.isLayoutDesktop;

      if (shouldSetFirstLeaderboardAsDefault) {
        _this.setSelectedLeaderboardId(data[0].leaderBoardId);
      }
    });
  }
});

/***/ }),

/***/ "z/nA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_privacy_statement_js__ = __webpack_require__("nHn7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c03ab7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_privacy_statement_vue__ = __webpack_require__("MYxc");
function injectStyle (ssrContext) {
  __webpack_require__("bfFv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_privacy_statement_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c03ab7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_privacy_statement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z/s/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z6fO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MiIgaGVpZ2h0PSI4MiIgdmlld0JveD0iMCAwIDgyIDgyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjZDk1MzRmIiBkPSJNMSA0MWMwIDIyLjA5IDE3LjkwNSA0MCA0MCA0MCAyMi4wOSAwIDQwLTE3LjkxIDQwLTQwUzYzLjA5IDEgNDEgMUMxOC45MDUgMSAxIDE4LjkxIDEgNDF6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI2Q5NTM0ZiIgZD0iTTQ3LjU0MyA1NC41MjhsLTYuNTMtNi41MjYtNi41NTYgNi41NDZhNC45NSA0Ljk1IDAgMCAxLTcuMDA0IDAgNC45NDIgNC45NDIgMCAwIDEgMC03bDYuNTUtNi41NS02LjU1LTYuNTQ2YTQuOTQyIDQuOTQyIDAgMCAxIDAtNyA0Ljk1IDQuOTUgMCAwIDEgNy4wMDQgMGw2LjU1NSA2LjU0NiA2LjUzLTYuNTI2YTQuOTUxIDQuOTUxIDAgMSAxIDcuMDA0IDdsLTYuNTI5IDYuNTMgNi41MyA2LjUyNmE0Ljk0MiA0Ljk0MiAwIDAgMSAwIDcgNC45NiA0Ljk2IDAgMCAxLTcuMDA0IDB6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "z8T8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OFFSET_CHECK_TIMEOUT; });
/* unused harmony export MARKET_CONTRACTS_SHOW_MORE_NUM */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_vue__ = __webpack_require__("PUmN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_contract_horizontal_sushi_common_betslip_market_contract_horizontal_sushi_common_betslip_vue__ = __webpack_require__("M+zr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_contracts_list_header_sushi_market_contracts_list_header_sushi_vue__ = __webpack_require__("uN8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_purchase_inline_sushi_purchase_inline_sushi_vue__ = __webpack_require__("T8v5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_payout_sushi_market_payout_sushi_vue__ = __webpack_require__("12bX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");













// import scrollTo from '@/utils/scrollTo';

// transition time + buffer
var OFFSET_CHECK_TIMEOUT = 300 + 150;
var MARKET_CONTRACTS_SHOW_MORE_NUM = 3;

/* harmony default export */ __webpack_exports__["b"] = ({
  props: {
    market: {
      type: Object,
      required: true
    },
    expandingAll: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAllContracts: false,
      isExpandingAll: this.expandingAll,
      togglePositionTop: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    marketContractHorizontalSushi: __WEBPACK_IMPORTED_MODULE_3__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_vue__["a" /* default */],
    marketContractHorizontalSushiMobile: __WEBPACK_IMPORTED_MODULE_4__components_market_market_contract_horizontal_sushi_common_betslip_market_contract_horizontal_sushi_common_betslip_vue__["a" /* default */],
    marketContractsListHeaderSushi: __WEBPACK_IMPORTED_MODULE_5__components_market_market_contracts_list_header_sushi_market_contracts_list_header_sushi_vue__["a" /* default */],
    marketPayoutSushi: __WEBPACK_IMPORTED_MODULE_7__components_market_market_payout_sushi_market_payout_sushi_vue__["a" /* default */],
    purchaseInlineSushi: __WEBPACK_IMPORTED_MODULE_6__components_purchase_sushi_purchase_inline_sushi_purchase_inline_sushi_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['settingMobileLayout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'hidePurchaseForContractId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['currentPopup']), {
    contractsToShow: function contractsToShow() {
      return !this.showAllContracts && this.shouldShowToggleMoreButton ? this.filteredContracts.slice(0, MARKET_CONTRACTS_SHOW_MORE_NUM) : this.filteredContracts;
    },
    leftContractsToShow: function leftContractsToShow() {
      return this.showAllContracts ? [] : this.filteredContracts.slice(MARKET_CONTRACTS_SHOW_MORE_NUM, this.filteredContracts.length);
    },
    shouldShowToggleMoreButton: function shouldShowToggleMoreButton() {
      return this.expandingAll && this.filteredContracts.length > MARKET_CONTRACTS_SHOW_MORE_NUM;
    },
    classModifiers: function classModifiers() {
      return {
        'market-list-item-expandable-sushi': true,
        'market-list-item-expandable-sushi--expanded': this.expanded
      };
    },
    toggleMoreModifiers: function toggleMoreModifiers() {
      return {
        'market-list-item-expandable-sushi__contracts-toggle-more': true,
        'market-list-item-expandable-sushi__contracts-toggle-more--active': this.showAllContracts
      };
    },
    titleClassModifiers: function titleClassModifiers() {
      return {
        'market-list-item-expandable-sushi__title': true,
        'market-list-item-expandable-sushi__title--has-open-offers': this.showOpenOffersIndicator
      };
    },
    toggleClassModifiers: function toggleClassModifiers() {
      return {
        'market-list-item-expandable-sushi__toggle': true,
        'market-list-item-expandable-sushi__toggle--expanded': this.expanded
      };
    },
    marketImageStyleModifiers: function marketImageStyleModifiers() {
      var baseGradient = 'linear-gradient(to right, rgba(78, 109, 115, 0.12), rgba(78, 109, 115, 0.16))';
      return {
        'background-image': baseGradient + ', url(' + this.market.marketImageUrl + ')'
      };
    },
    filteredContracts: function filteredContracts() {
      return this.market && this.market.marketContracts ? this.market.marketContracts.filter(function (i) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["w" /* contractOwnershipNum */])(i) > 0;
      }) : [];
    },
    isPayoutAvailable: function isPayoutAvailable() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["K" /* hasMarketPayout */])(this.market);
    },
    openOffers: function openOffers() {
      if (!this.market.isOpen) return 0;
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.filteredContracts, function (i) {
        return i.userOpenOrdersBuyQuantity + i.userOpenOrdersSellQuantity;
      });
    },
    showOpenOffersIndicator: function showOpenOffersIndicator() {
      return this.isLayoutDesktop && this.openOffers > 0;
    },
    isCondensedMobileLayout: function isCondensedMobileLayout() {
      return this.isLayoutMobile && this.settingMobileLayout === __WEBPACK_IMPORTED_MODULE_11__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED;
    },
    marketKey: function marketKey() {
      var loggedIn = this.isLoggedIn ? 'logged-in' : 'logged-out';
      return this.market ? 'dashboard-' + this.market.marketId + '-' + loggedIn : null;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getMarket']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setTradePopup']), {
    onToggleMore: function onToggleMore() {
      this.showAllContracts = !this.showAllContracts;
      if (!this.showAllContracts) {
        window.scrollTo(0, this.$el.offsetTop);
      }
    },
    onViewMarket: function onViewMarket(market) {
      this.$router.push({
        name: 'market-details',
        params: { marketId: market.marketId, marketUrl: market.marketUrl }
      });
    },
    toggleItem: function toggleItem() {
      this.togglePositionTop = this.$el.offsetTop;
      this.$emit('toggle', {
        expanded: !this.expanded,
        market: this.market
      });
    },
    contractKey: function contractKey(prefix, data) {
      var contract = new __WEBPACK_IMPORTED_MODULE_9__models_contract__["a" /* default */](data);
      return prefix + '-' + this.marketKey + '-' + contract.contractId + '-' + contract.mode;
    },
    isPurchaseInlineMode: function isPurchaseInlineMode(contractId) {
      return this.isPurchaseActive(contractId) && !this.isCondensedMobileLayout;
    },
    isPurchaseActive: function isPurchaseActive(contractId) {
      return this.tradeOptions && this.tradeOptions.contractId === contractId;
    },
    showMobileWidgetPurchase: function showMobileWidgetPurchase(contractId) {
      return this.isLayoutMobile && this.isPurchaseActive(contractId);
    },
    initializePurchase: function initializePurchase() {
      var contracts = this.market.contracts || this.market.marketContracts;
      var contractIds = contracts.map(function (i) {
        return i.contractId;
      });
      if (this.isLayoutMobile && this.tradeOptions !== null && this.tradeOptions.contractId !== null && contractIds.includes(this.tradeOptions.contractId) && this.currentPopup !== __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE_SUSHI && false) {
        this.setTradePopup({
          name: __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE_SUSHI,
          options: {
            market: this.market
          }
        });
      }
    }
  }),
  watch: {
    tradeOptions: function tradeOptions() {
      this.initializePurchase();
    }
  }
});

/***/ }),

/***/ "zAJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__ = __webpack_require__("63Fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* eslint-disable */



var STATUS_PENDING = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  checkIfCanRunAfterVerification: function checkIfCanRunAfterVerification() {
    var lastInstantCredit = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('lastInstantCredit', null);
    var instantCredit = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('instant_credit', null);
    if (instantCredit && lastInstantCredit === instantCredit) {
      return false;
    }

    return instantCredit !== null;
  },
  checkIfCanRunAfterLogin: function checkIfCanRunAfterLogin() {
    var checkIfCanRunAfterVerification = this.checkIfCanRunAfterVerification();
    var userData = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.userData;
    var verificationStatus = userData.verificationStatus;
    var idVerified = userData.idVerified;
    var isUserVerified = typeof idVerified !== 'undefined' ? idVerified || verificationStatus === STATUS_PENDING : true;
    return checkIfCanRunAfterVerification && isUserVerified;
  },
  run: function run() {
    var code = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('instant_credit', null);

    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('wallet/submitInstantCredit', code).then(function (data) {
      __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].set('lastInstantCredit', code);
      return data;
    });
  },
  clear: function clear() {
    __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].del('lastInstantCredit');
    __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].del('instant_credit');
  }
});

/***/ }),

/***/ "zBTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"purchase-offer-desktop-sushi-common-betslip__box",class:{'purchase-offer-desktop-sushi-common-betslip__box--full': _vm.isMarketDisabled}},[_c('div',{staticClass:"purchase-offer-desktop-sushi-common-betslip__buttons"},[_c('div',{staticClass:"purchase-offer-desktop-sushi-common-betslip__buttons--left"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{ref:_vm.BUTTONS.BUY_YES.id,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-single purchase-offer-desktop-sushi-common-betslip__button-single--buy-yes",class:_vm.isButtonActive(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value)}}},[_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-price",attrs:{"price":0,"layout":"inline","text":_vm.leftButtonText}})],1)]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{ref:_vm.BUTTONS.BUY_YES.id,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-single purchase-offer-desktop-sushi-common-betslip__button-single--sell-yes",class:_vm.isButtonActive(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value)}}},[_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-price",attrs:{"price":0,"layout":"inline","text":_vm.leftButtonText}})],1)]:[_c('button',{ref:_vm.BUTTONS.BUY_YES.id,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-single purchase-offer-desktop-sushi-common-betslip__button-single--buy-yes",class:_vm.isButtonActive(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value)}}},[_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-price",attrs:{"price":0,"layout":"inline","text":_vm.leftButtonText}})],1)]],2),_vm._v(" "),_c('div',{staticClass:"purchase-offer-desktop-sushi-common-betslip__buttons--right"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{ref:_vm.BUTTONS.BUY_NO.id,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-single purchase-offer-desktop-sushi-common-betslip__button-single--sell-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value)}}},[_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-price",attrs:{"price":0,"layout":"inline","text":_vm.rightButtonText}})],1)]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{ref:_vm.BUTTONS.BUY_NO.id,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-single purchase-offer-desktop-sushi-common-betslip__button-single--buy-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value)}}},[_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-price",attrs:{"price":0,"layout":"inline","text":_vm.rightButtonText}})],1)]:[_c('button',{ref:_vm.BUTTONS.BUY_NO.id,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-single purchase-offer-desktop-sushi-common-betslip__button-single--buy-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value)}}},[_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"purchase-offer-desktop-sushi-common-betslip__button-price",attrs:{"price":0,"layout":"inline","text":_vm.rightButtonText}})],1)]],2)]),_vm._v(" "),_c('div',{class:{ 'purchase-offer-desktop-sushi-common-betslip__box-inner': !_vm.isMarketDisabled
    }},[_c('purchase-extended-betslip',{attrs:{"market":_vm.market,"contract":_vm.contract,"showOrderSlip":false},on:{"submit":function($event){return _vm.$emit('submit')}}})],1)]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-desktop-sushi-common-betslip__related-contracts"},[_c('div',{staticClass:"purchase-offer-desktop-sushi-common-betslip__related-contracts-title"},[_vm._v("\n      Related Contracts\n    ")]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-desktop-sushi-common-betslip__related-contracts-content"},[_c('related-contracts-sushi',{attrs:{"contractId":_vm.contract.contractId,"max":3}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zGja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-section-header"},[_c('div',{staticClass:"market-section-header__title"},[_c('div',{staticClass:"market-section-header__text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-section-header__counter"},[(_vm.count === 1)?[_vm._v("\n        1 Market\n      ")]:[_vm._v("\n        "+_vm._s(_vm.count)+" Markets\n      ")]],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zKe2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zNKi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    errors: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ "zRJs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-desktop-grid-watchlist__menu-timespan"},[_c('menu-button',{attrs:{"theme":"sushi-pill","type":"timespan","name":_vm.selectedTimespan.name,"active":_vm.timespansOpen},on:{"click":_vm.toggleTimespans}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-filters-desktop-grid-watchlist__menu-order"},[_c('menu-button',{attrs:{"theme":"sushi-pill","type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),_c('div',{staticClass:"market-filters-desktop-grid-watchlist__menu-title"},[_vm._v("\n      Sort By:\n    ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.ordersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid-watchlist__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"theme":_vm.theme,"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort)},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.filtersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid-watchlist__filters"},[_c('a',{staticClass:"market-filters-desktop-grid-watchlist__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-desktop-grid-watchlist__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"theme":_vm.theme,"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.timespansOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid-watchlist__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"theme":_vm.theme,"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTpV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-list-header-sushi",class:{ 'market-contracts-list-header-sushi--forced-mobile': _vm.forceMobileLayout, 'market-contracts-list-header-sushi--cms-widget': _vm.forCmsWidget, 'market-contracts-list-header-sushi--dashboard': _vm.dashboardMode && !_vm.forCmsWidget }},[(_vm.useMobileLayout)?[(_vm.forCmsWidget)?_c('div',{staticClass:"market-contracts-list-header-sushi--cms-mobile"},[_c('div',{staticClass:"market-contracts-list-header-sushi__item-1"},[_vm._v("\n        "+_vm._s(_vm.titleFirst)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-2"},[_c('div',{staticClass:"market-contracts-list-header-sushi__item-2-text"},[_vm._v("\n          "+_vm._s(_vm.titleSecond)+"\n        ")])])]):_c('div',{class:_vm.mobileBarClassModifiers},[_c('market-settings-button',{attrs:{"theme":"details"},model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}}),_vm._v(" "),(!_vm.isMarketDisabled)?_c('div',{staticClass:"market-contracts-list-header-sushi__mobile-title"},[_vm._v("\n        "+_vm._s(_vm.titleSecond)+"\n      ")]):_vm._e()],1)]:[_c('div',{staticClass:"market-contracts-list-header-sushi__item-1"},[_vm._v("\n      "+_vm._s(_vm.titleFirst)+"\n    ")]),_vm._v(" "),(_vm.dashboardMode)?_c('div',{staticClass:"market-contracts-list-header-sushi__middle-columns"},[(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contracts-list-header-sushi__item-type"},[_vm._v(_vm._s(_vm.titleType))])]:_vm._e(),_vm._v(" "),_c('market-contracts-list-header-sushi-item2',{attrs:{"title":_vm.titleSecond,"for-cms-widget":_vm.forCmsWidget}}),_vm._v(" "),(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contracts-list-header-sushi__item-3"},[_vm._v(_vm._s(_vm.titleThird))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-4"},[_vm._v(_vm._s(_vm.titleFourth))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-buy-orders"},[_vm._v(_vm._s(_vm.titleBuyOrders))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-sell-orders"},[_vm._v(_vm._s(_vm.titleSellOrders))])]:_vm._e()],2):[_c('market-contracts-list-header-sushi-item2',{attrs:{"title":_vm.titleSecond,"for-cms-widget":_vm.forCmsWidget}}),_vm._v(" "),(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contracts-list-header-sushi__item-3"},[_vm._v(_vm._s(_vm.titleThird))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-4"},[_vm._v(_vm._s(_vm.titleFourth))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-5"},[_vm._v(_vm._s(_vm.titleFifth))])]:_vm._e()],_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-6"},[(!_vm.forCmsWidget)?_c('market-settings-button',{model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}}):_vm._e()],1)],_vm._v(" "),(!_vm.forCmsWidget)?_c('market-settings-modal',{model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zUFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-info-popup"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"share-info-popup__row"},[_c('div',[_vm._v(_vm._s(_vm.item.dateExecuted))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.item.pricePerShare)+"¢")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.item.sharesOwned))]),_vm._v(" "),_c('div',[(_vm.item.isNo)?[_vm._v("NO")]:[_vm._v("YES")]],2)]),_vm._v(" "),_c('div',{staticClass:"share-info-popup__info"},[_vm._v("\n    Your position is sold in the order of purchase\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-info-popup__header"},[_c('div',[_vm._v("Date")]),_vm._v(" "),_c('div',[_vm._v("Price")]),_vm._v(" "),_c('div',[_vm._v("Quantity")]),_vm._v(" "),_c('div',[_vm._v("Type")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zV2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_browse_nav_browse_vue__ = __webpack_require__("i8vA");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    navBrowse: __WEBPACK_IMPORTED_MODULE_2__nav_browse_nav_browse_vue__["a" /* default */]
  },
  data: function data() {
    return {
      rerender: false,
      rotationIndex: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    showNavBrowser: function showNavBrowser() {
      return !this.rerender;
    },
    classModifier: function classModifier() {
      return {
        'page-secondary-nav': true,
        'page-secondary-nav--browser': this.showNavBrowser
      };
    }
  }),
  methods: {
    handleOrientationChange: function handleOrientationChange() {
      var _this = this;

      this.rerender = true;
      setTimeout(function () {
        _this.rerender = false;
        _this.rotationIndex += 1;
      }, 300);
    }
  },
  created: function created() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.handleOrientationChange();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
  }
});

/***/ }),

/***/ "zX9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: 'faq-search-input'
    },
    placeholder: {
      type: String,
      default: 'Search FAQs'
    },
    initial: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      value: this.initial
    };
  },

  computed: {
    hasValueModifier: function hasValueModifier() {
      return this.value ? 'faq-search-input--has-value' : '';
    }
  },
  methods: {
    updateSearch: function updateSearch(e) {
      var value = e.target.value;
      this.value = value;
      this.$emit('search', value);
    },
    focusInput: function focusInput() {
      this.$refs.input.focus();
    }
  },
  mounted: function mounted() {
    if (this.initial) {
      this.$emit('init', this.initial);
    }
  }
});

/***/ }),

/***/ "zZwI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zbfY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE4IDIyIj4KICAgIDxnIGZpbGw9IiMwN2EwYmIiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTTE0LjU4IDIuMTk4YS43NDQuNzQ0IDAgMCAwLTEuMDE2LjI3MWwtLjc0MyAxLjI3OSAyLjU3NCAxLjQ3OC43NDMtMS4yNzlhLjczOC43MzggMCAwIDAtLjI3Mi0xLjAxbC0xLjI4Ni0uNzM5ek0zLjMzMiAyLjE5OGwtMS4yODUuNzM5YS43MzguNzM4IDAgMCAwLS4yNzMgMS4wMWwuNzQzIDEuMjc5TDUuMDkgMy43NDhsLS43NDMtMS4yNzlhLjc0NC43NDQgMCAwIDAtMS4wMTYtLjI3MXpNOSAzLjMyN2MuNDcgMCAuOTI5LjA0NiAxLjM4My4xMVYyLjI0MmwuOTUtLjAwOFYuNjg4YzAtLjM4LS4zMS0uNjg4LS42OTEtLjY4OEg3LjM2NmEuNjg5LjY4OSAwIDAgMC0uNjkyLjY4OHYxLjU0NmwuOTQzLjAwOHYxLjE5NmMuNDU0LS4wNjUuOTEzLS4xMSAxLjM4My0uMTF6TTkgNy4zMTVjLTMuMTkxIDAtNS43NzkgMi41NzMtNS43NzkgNS43NDcgMCAzLjE3NSAyLjU4NyA1Ljc0OCA1Ljc3OSA1Ljc0OCAzLjE5MiAwIDUuNzc5LTIuNTczIDUuNzc5LTUuNzQ3IDAtMy4xNzUtMi41ODgtNS43NDgtNS43NzktNS43NDh6bS44MyA2LjhjLS4zMzQuMzA0LTEuMDAyLjExNy0xLjQ5MS0uNDE3LS40OS0uNTM1LS42MTYtMS4yMTQtLjI4Mi0xLjUxNy4zMzQtLjMwMyAzLjMyNi0xLjk0MyA0LjI0LTIuMDc0LS4yMTUuODk0LTIuMTMyIDMuNzA1LTIuNDY2IDQuMDA5eiIvPgogICAgICAgIDxwYXRoIGQ9Ik05IDQuMTI1Yy00Ljk2MyAwLTguOTg2IDQuMDAxLTguOTg2IDguOTM4Qy4wMTQgMTcuOTk4IDQuMDM3IDIyIDkgMjJjNC45NjMgMCA4Ljk4Ni00LjAwMSA4Ljk4Ni04LjkzOCAwLTQuOTM2LTQuMDIzLTguOTM3LTguOTg2LTguOTM3em0wIDE2LjE5Yy00LjAyNyAwLTcuMjkxLTMuMjQ3LTcuMjkxLTcuMjUzIDAtNC4wMDUgMy4yNjQtNy4yNTEgNy4yOTEtNy4yNTEgNC4wMjcgMCA3LjI5MiAzLjI0NiA3LjI5MiA3LjI1MiAwIDQuMDA1LTMuMjY1IDcuMjUxLTcuMjkyIDcuMjUxeiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "zckU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SESSION_HISTORY_EXPIRES_AT */
/* unused harmony export SESSION_HISTORY_SIZE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SESSION_HISTORY_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__ = __webpack_require__("Moaq");





var SESSION_HISTORY_EXPIRES_AT = 86400; // 1 day

var SESSION_HISTORY_SIZE = 10;
var SESSION_HISTORY_KEY = 'session-history';

var getContractsHistory = function getContractsHistory() {
  return __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].get(SESSION_HISTORY_KEY, []);
};
var pushContract = function pushContract(_ref) {
  var value = _ref.value;

  try {
    var history = getContractsHistory();

    /* append value at the beginning of the list and make sure its unique */
    var newHistory = __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()([value].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(history)), function (el) {
      return el.contractId;
    });
    var result = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newHistory.slice(0, SESSION_HISTORY_SIZE)));
    __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].set(SESSION_HISTORY_KEY, result, SESSION_HISTORY_EXPIRES_AT);
    return result;
  } catch (e) {
    return [];
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  pushContract: pushContract,
  getContractsHistory: getContractsHistory
});

/***/ }),

/***/ "zeud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zhst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-top-comments"},[_c('div',{staticClass:"market-top-comments__header"},[_c('div',{staticClass:"market-top-comments__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('div',{staticClass:"market-top-comments__arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})])]),_vm._v(" "),_c('div',{staticClass:"row market-top-comments__content"},[(!!_vm.obj)?_c('swiper',{ref:"swiper",staticClass:"market-top-comments__slider",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(comment,index){return _c('swiper-slide',{key:index,staticClass:"market-top-comments__slide"},[_c('top-comment',{attrs:{"comment":comment}})],1)}),1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ziKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_value_picker_mobile_sushi_js__ = __webpack_require__("IXeU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908e3744_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_value_picker_mobile_sushi_vue__ = __webpack_require__("K2V5");
function injectStyle (ssrContext) {
  __webpack_require__("P9Cr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_value_picker_mobile_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908e3744_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_value_picker_mobile_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zkja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_markets_toggle_js__ = __webpack_require__("54E+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_666bb8a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_markets_toggle_vue__ = __webpack_require__("KRSH");
function injectStyle (ssrContext) {
  __webpack_require__("FBEZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_markets_toggle_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_666bb8a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_markets_toggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zx9v":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "zyXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_journey_sushi_js__ = __webpack_require__("tFv8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f261a43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_journey_sushi_vue__ = __webpack_require__("ZqyY");
function injectStyle (ssrContext) {
  __webpack_require__("BCWs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_journey_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f261a43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_journey_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zyjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__market_settings_button_market_settings_button_vue__ = __webpack_require__("4eDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__market_settings_modal_market_settings_modal_vue__ = __webpack_require__("5n65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__market_contracts_list_header_sushi_item2_market_contracts_list_header_sushi_item2_vue__ = __webpack_require__("J2kF");











var firstNonEmptyString = function firstNonEmptyString() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value === 'string' && value.trim() !== '';
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketSettingsButton: __WEBPACK_IMPORTED_MODULE_5__market_settings_button_market_settings_button_vue__["default"],
    marketSettingsModal: __WEBPACK_IMPORTED_MODULE_6__market_settings_modal_market_settings_modal_vue__["default"],
    marketContractsListHeaderSushiItem2: __WEBPACK_IMPORTED_MODULE_7__market_contracts_list_header_sushi_item2_market_contracts_list_header_sushi_item2_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    },
    dashboardMode: {
      type: Boolean,
      default: false
    },
    forceMobileLayout: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showSettingsModal: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isTradingEnabled', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['settingShowOdds', 'settingMobileLayout']), {
    useMobileLayout: function useMobileLayout() {
      return this.forceMobileLayout || this.isLayoutMobile;
    },
    isCondensedMobileLayout: function isCondensedMobileLayout() {
      return this.settingMobileLayout === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED;
    },
    mobileBarClassModifiers: function mobileBarClassModifiers() {
      return {
        'market-contracts-list-header-sushi__mobile-bar': true,
        'market-contracts-list-header-sushi__mobile-bar--condensed': this.isCondensedMobileLayout
      };
    },
    hasOwnership: function hasOwnership() {
      if (this.market === null || !this.isLoggedIn) return false;
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.market.contracts, function (i) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["w" /* contractOwnershipNum */])(i);
      }) > 0;
    },
    isMarketDisabled: function isMarketDisabled() {
      return this.market !== null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["x" /* isMarketDisabled */])(this.market);
    },
    pricesTitle: function pricesTitle() {
      return this.isLayoutMobile ? 'Trade Prices' : 'Last Trade Price';
    },
    titleSecond: function titleSecond() {
      if (this.forCmsWidget) {
        return this.settingShowOdds ? 'Odds' : this.pricesTitle;
      }
      if (this.dashboardMode) {
        return this.settingShowOdds ? 'Last Odds' : 'Last Price';
      }
      return 'Latest';
    },
    titleType: function titleType() {
      return 'Type';
    },
    titleFirst: function titleFirst() {
      if (!this.forCmsWidget) {
        return 'Contract';
      }

      return firstNonEmptyString(this.market && this.market.marketShortName, this.market && this.market.marketName) || 'Contract';
    },
    titleThird: function titleThird() {
      return this.forCmsWidget ? 'Volume' : 'Ownership';
    },
    titleFourth: function titleFourth() {
      return 'Avg. Paid';
    },
    titleFifth: function titleFifth() {
      return 'Orders (Buy/Sell)';
    },
    titleBuyOrders: function titleBuyOrders() {
      return 'Buy Orders';
    },
    titleSellOrders: function titleSellOrders() {
      return 'Sell Orders';
    },
    titleSixth: function titleSixth() {
      return 'Trade';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']))
});

/***/ }),

/***/ "zyut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_offers_indicator_popup_js__ = __webpack_require__("VYq2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b071eeae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offers_indicator_popup_vue__ = __webpack_require__("v6Dd");
function injectStyle (ssrContext) {
  __webpack_require__("QVL1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_offers_indicator_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b071eeae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offers_indicator_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zzjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-notifications"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('notifications-list')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e4bc8089ce1287522655.js